(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
//@ts-check
// Main entry point - imports modules and exposes functions needed by Alpine/HTML
function $14c571840e589f0e$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $14c571840e589f0e$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $14c571840e589f0e$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $14c571840e589f0e$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


function $ec426015f75d7738$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $fa9769297b8a68c8$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $ec426015f75d7738$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}


function $715bf31211e65705$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $715bf31211e65705$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $715bf31211e65705$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ function $1968e3edfc5cfc11$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}


var $4fa1715f971c561b$var$extendStatics = function extendStatics1(d, b) {
    $4fa1715f971c561b$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $4fa1715f971c561b$var$extendStatics(d, b);
};
function $4fa1715f971c561b$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $4fa1715f971c561b$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $4fa1715f971c561b$export$18ce0697a983be9b = function __assign1() {
    $4fa1715f971c561b$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4fa1715f971c561b$export$18ce0697a983be9b.apply(this, arguments);
};
function $4fa1715f971c561b$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $4fa1715f971c561b$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $1968e3edfc5cfc11$export$71511d61b312f219)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $4fa1715f971c561b$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $4fa1715f971c561b$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $1968e3edfc5cfc11$export$71511d61b312f219)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $4fa1715f971c561b$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $4fa1715f971c561b$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $1968e3edfc5cfc11$export$71511d61b312f219)(x)) === "symbol" ? x : "".concat(x);
}
function $4fa1715f971c561b$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $1968e3edfc5cfc11$export$71511d61b312f219)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $4fa1715f971c561b$export$f1db080c865becb9(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $1968e3edfc5cfc11$export$71511d61b312f219)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $4fa1715f971c561b$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $4fa1715f971c561b$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $4fa1715f971c561b$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $4fa1715f971c561b$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $4fa1715f971c561b$export$45d3717a4c69092e(o, m, p);
}
function $4fa1715f971c561b$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $4fa1715f971c561b$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $4fa1715f971c561b$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($4fa1715f971c561b$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $4fa1715f971c561b$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $4fa1715f971c561b$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $4fa1715f971c561b$export$10c90e4f7922046c(v) {
    return this instanceof $4fa1715f971c561b$export$10c90e4f7922046c ? (this.v = v, this) : new $4fa1715f971c561b$export$10c90e4f7922046c(v);
}
function $4fa1715f971c561b$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $4fa1715f971c561b$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $4fa1715f971c561b$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $4fa1715f971c561b$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $4fa1715f971c561b$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $4fa1715f971c561b$export$19a8beecd37a4c45 === "function" ? $4fa1715f971c561b$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $4fa1715f971c561b$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $4fa1715f971c561b$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $4fa1715f971c561b$var$ownKeys = function ownKeys1(o) {
    $4fa1715f971c561b$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $4fa1715f971c561b$var$ownKeys(o);
};
function $4fa1715f971c561b$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $4fa1715f971c561b$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $4fa1715f971c561b$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $4fa1715f971c561b$var$__setModuleDefault(result, mod);
    return result;
}
function $4fa1715f971c561b$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $4fa1715f971c561b$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $4fa1715f971c561b$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $4fa1715f971c561b$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || (typeof receiver === "undefined" ? "undefined" : (0, $1968e3edfc5cfc11$export$71511d61b312f219)(receiver)) !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $4fa1715f971c561b$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if ((typeof value === "undefined" ? "undefined" : (0, $1968e3edfc5cfc11$export$71511d61b312f219)(value)) !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $4fa1715f971c561b$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $4fa1715f971c561b$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $4fa1715f971c561b$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $4fa1715f971c561b$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $4fa1715f971c561b$export$2e2bcd8739ae039 = {
    __extends: $4fa1715f971c561b$export$a8ba968b8961cb8a,
    __assign: $4fa1715f971c561b$export$18ce0697a983be9b,
    __rest: $4fa1715f971c561b$export$3c9a16f847548506,
    __decorate: $4fa1715f971c561b$export$29e00dfd3077644b,
    __param: $4fa1715f971c561b$export$d5ad3fd78186038f,
    __esDecorate: $4fa1715f971c561b$export$3a84e1ae4e97e9b0,
    __runInitializers: $4fa1715f971c561b$export$d831c04e792af3d,
    __propKey: $4fa1715f971c561b$export$6a2a36740a146cb8,
    __setFunctionName: $4fa1715f971c561b$export$d1a06452d3489bc7,
    __metadata: $4fa1715f971c561b$export$f1db080c865becb9,
    __awaiter: $4fa1715f971c561b$export$1050f835b63b671e,
    __generator: $4fa1715f971c561b$export$67ebef60e6f28a6,
    __createBinding: $4fa1715f971c561b$export$45d3717a4c69092e,
    __exportStar: $4fa1715f971c561b$export$f33643c0debef087,
    __values: $4fa1715f971c561b$export$19a8beecd37a4c45,
    __read: $4fa1715f971c561b$export$8d051b38c9118094,
    __spread: $4fa1715f971c561b$export$afc72e2116322959,
    __spreadArrays: $4fa1715f971c561b$export$6388937ca91ccae8,
    __spreadArray: $4fa1715f971c561b$export$1216008129fb82ed,
    __await: $4fa1715f971c561b$export$10c90e4f7922046c,
    __asyncGenerator: $4fa1715f971c561b$export$e427f37a30a4de9b,
    __asyncDelegator: $4fa1715f971c561b$export$bbd80228419bb833,
    __asyncValues: $4fa1715f971c561b$export$e3b29a3d6162315f,
    __makeTemplateObject: $4fa1715f971c561b$export$4fb47efe1390b86f,
    __importStar: $4fa1715f971c561b$export$c21735bcef00d192,
    __importDefault: $4fa1715f971c561b$export$da59b14a69baef04,
    __classPrivateFieldGet: $4fa1715f971c561b$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $4fa1715f971c561b$export$d40a35129aaff81f,
    __classPrivateFieldIn: $4fa1715f971c561b$export$81fdc39f203e4e04,
    __addDisposableResource: $4fa1715f971c561b$export$88ac25d8e944e405,
    __disposeResources: $4fa1715f971c561b$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $4fa1715f971c561b$export$889dfb5d17574b0b
};


// packages/alpinejs/src/scheduler.js



function $94d3f045916e0583$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $a19fa517098223d7$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $2b2eb8ca3633154b$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $7b161889ca248e24$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $d6f91c356a8197fd$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $7b161889ca248e24$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $7b161889ca248e24$export$71511d61b312f219)(o, minLen);
}


function $1788e2ed61915b1e$export$71511d61b312f219(arr, i) {
    return (0, $94d3f045916e0583$export$71511d61b312f219)(arr) || (0, $a19fa517098223d7$export$71511d61b312f219)(arr, i) || (0, $d6f91c356a8197fd$export$71511d61b312f219)(arr, i) || (0, $2b2eb8ca3633154b$export$71511d61b312f219)();
}


function $2017c4963e549b4b$export$71511d61b312f219(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}



function $f8a29d58f287cd3d$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $7b161889ca248e24$export$71511d61b312f219)(arr);
}


function $b0c62864eda90b51$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $cf17359bdd687909$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $4c858c0d999a5b9b$export$71511d61b312f219(arr) {
    return (0, $f8a29d58f287cd3d$export$71511d61b312f219)(arr) || (0, $b0c62864eda90b51$export$71511d61b312f219)(arr) || (0, $d6f91c356a8197fd$export$71511d61b312f219)(arr) || (0, $cf17359bdd687909$export$71511d61b312f219)();
}




function $da6f71b8677b901e$var$_templateObject() {
    var _$data = (0, $2017c4963e549b4b$export$71511d61b312f219)([
        "Cannot find directive `",
        "`. `",
        "` will use the default order of execution"
    ], [
        "Cannot find directive \\`",
        "\\`. \\`",
        "\\` will use the default order of execution"
    ]);
    $da6f71b8677b901e$var$_templateObject = function _templateObject() {
        return _$data;
    };
    return _$data;
}
var $da6f71b8677b901e$var$flushPending = false;
var $da6f71b8677b901e$var$flushing = false;
var $da6f71b8677b901e$var$queue = [];
var $da6f71b8677b901e$var$lastFlushedIndex = -1;
function $da6f71b8677b901e$var$scheduler(callback) {
    $da6f71b8677b901e$var$queueJob(callback);
}
function $da6f71b8677b901e$var$queueJob(job) {
    if (!$da6f71b8677b901e$var$queue.includes(job)) $da6f71b8677b901e$var$queue.push(job);
    $da6f71b8677b901e$var$queueFlush();
}
function $da6f71b8677b901e$var$dequeueJob(job) {
    var index = $da6f71b8677b901e$var$queue.indexOf(job);
    if (index !== -1 && index > $da6f71b8677b901e$var$lastFlushedIndex) $da6f71b8677b901e$var$queue.splice(index, 1);
}
function $da6f71b8677b901e$var$queueFlush() {
    if (!$da6f71b8677b901e$var$flushing && !$da6f71b8677b901e$var$flushPending) {
        $da6f71b8677b901e$var$flushPending = true;
        queueMicrotask($da6f71b8677b901e$var$flushJobs);
    }
}
function $da6f71b8677b901e$var$flushJobs() {
    $da6f71b8677b901e$var$flushPending = false;
    $da6f71b8677b901e$var$flushing = true;
    for(var i = 0; i < $da6f71b8677b901e$var$queue.length; i++){
        $da6f71b8677b901e$var$queue[i]();
        $da6f71b8677b901e$var$lastFlushedIndex = i;
    }
    $da6f71b8677b901e$var$queue.length = 0;
    $da6f71b8677b901e$var$lastFlushedIndex = -1;
    $da6f71b8677b901e$var$flushing = false;
}
// packages/alpinejs/src/reactivity.js
var $da6f71b8677b901e$var$reactive;
var $da6f71b8677b901e$var$effect;
var $da6f71b8677b901e$var$release;
var $da6f71b8677b901e$var$raw;
var $da6f71b8677b901e$var$shouldSchedule = true;
function $da6f71b8677b901e$var$disableEffectScheduling(callback) {
    $da6f71b8677b901e$var$shouldSchedule = false;
    callback();
    $da6f71b8677b901e$var$shouldSchedule = true;
}
function $da6f71b8677b901e$var$setReactivityEngine(engine) {
    $da6f71b8677b901e$var$reactive = engine.reactive;
    $da6f71b8677b901e$var$release = engine.release;
    $da6f71b8677b901e$var$effect = function(callback) {
        return engine.effect(callback, {
            scheduler: function(task) {
                if ($da6f71b8677b901e$var$shouldSchedule) $da6f71b8677b901e$var$scheduler(task);
                else task();
            }
        });
    };
    $da6f71b8677b901e$var$raw = engine.raw;
}
function $da6f71b8677b901e$var$overrideEffect(override) {
    $da6f71b8677b901e$var$effect = override;
}
function $da6f71b8677b901e$var$elementBoundEffect(el) {
    var cleanup2 = function() {};
    var wrappedEffect = function(callback) {
        var effectReference = $da6f71b8677b901e$var$effect(callback);
        if (!el._x_effects) {
            el._x_effects = /* @__PURE__ */ new Set();
            el._x_runEffects = function() {
                el._x_effects.forEach(function(i) {
                    return i();
                });
            };
        }
        el._x_effects.add(effectReference);
        cleanup2 = function() {
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $da6f71b8677b901e$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        function() {
            cleanup2();
        }
    ];
}
function $da6f71b8677b901e$var$watch(getter, callback) {
    var firstTime = true;
    var oldValue;
    var effectReference = $da6f71b8677b901e$var$effect(function() {
        var value = getter();
        JSON.stringify(value);
        if (!firstTime) queueMicrotask(function() {
            callback(value, oldValue);
            oldValue = value;
        });
        else oldValue = value;
        firstTime = false;
    });
    return function() {
        return $da6f71b8677b901e$var$release(effectReference);
    };
}
// packages/alpinejs/src/mutation.js
var $da6f71b8677b901e$var$onAttributeAddeds = [];
var $da6f71b8677b901e$var$onElRemoveds = [];
var $da6f71b8677b901e$var$onElAddeds = [];
function $da6f71b8677b901e$var$onElAdded(callback) {
    $da6f71b8677b901e$var$onElAddeds.push(callback);
}
function $da6f71b8677b901e$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $da6f71b8677b901e$var$onElRemoveds.push(callback);
    }
}
function $da6f71b8677b901e$var$onAttributesAdded(callback) {
    $da6f71b8677b901e$var$onAttributeAddeds.push(callback);
}
function $da6f71b8677b901e$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $da6f71b8677b901e$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(function(param) {
        var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), name = _param[0], value = _param[1];
        if (names === void 0 || names.includes(name)) {
            value.forEach(function(i) {
                return i();
            });
            delete el._x_attributeCleanups[name];
        }
    });
}
function $da6f71b8677b901e$var$cleanupElement(el) {
    var _el__x_effects, _el__x_cleanups;
    (_el__x_effects = el._x_effects) === null || _el__x_effects === void 0 ? void 0 : _el__x_effects.forEach($da6f71b8677b901e$var$dequeueJob);
    while((_el__x_cleanups = el._x_cleanups) === null || _el__x_cleanups === void 0 ? void 0 : _el__x_cleanups.length)el._x_cleanups.pop()();
}
var $da6f71b8677b901e$var$observer = new MutationObserver($da6f71b8677b901e$var$onMutate);
var $da6f71b8677b901e$var$currentlyObserving = false;
function $da6f71b8677b901e$var$startObservingMutations() {
    $da6f71b8677b901e$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $da6f71b8677b901e$var$currentlyObserving = true;
}
function $da6f71b8677b901e$var$stopObservingMutations() {
    $da6f71b8677b901e$var$flushObserver();
    $da6f71b8677b901e$var$observer.disconnect();
    $da6f71b8677b901e$var$currentlyObserving = false;
}
var $da6f71b8677b901e$var$queuedMutations = [];
function $da6f71b8677b901e$var$flushObserver() {
    var records = $da6f71b8677b901e$var$observer.takeRecords();
    $da6f71b8677b901e$var$queuedMutations.push(function() {
        return records.length > 0 && $da6f71b8677b901e$var$onMutate(records);
    });
    var queueLengthWhenTriggered = $da6f71b8677b901e$var$queuedMutations.length;
    queueMicrotask(function() {
        if ($da6f71b8677b901e$var$queuedMutations.length === queueLengthWhenTriggered) while($da6f71b8677b901e$var$queuedMutations.length > 0)$da6f71b8677b901e$var$queuedMutations.shift()();
    });
}
function $da6f71b8677b901e$var$mutateDom(callback) {
    if (!$da6f71b8677b901e$var$currentlyObserving) return callback();
    $da6f71b8677b901e$var$stopObservingMutations();
    var result = callback();
    $da6f71b8677b901e$var$startObservingMutations();
    return result;
}
var $da6f71b8677b901e$var$isCollecting = false;
var $da6f71b8677b901e$var$deferredMutations = [];
function $da6f71b8677b901e$var$deferMutations() {
    $da6f71b8677b901e$var$isCollecting = true;
}
function $da6f71b8677b901e$var$flushAndStopDeferringMutations() {
    $da6f71b8677b901e$var$isCollecting = false;
    $da6f71b8677b901e$var$onMutate($da6f71b8677b901e$var$deferredMutations);
    $da6f71b8677b901e$var$deferredMutations = [];
}
function $da6f71b8677b901e$var$onMutate(mutations) {
    var _loop = function(i) {
        if (mutations[i].target._x_ignoreMutationObserver) return "continue";
        if (mutations[i].type === "childList") {
            mutations[i].removedNodes.forEach(function(node) {
                if (node.nodeType !== 1) return;
                if (!node._x_marker) return;
                removedNodes.add(node);
            });
            mutations[i].addedNodes.forEach(function(node) {
                if (node.nodeType !== 1) return;
                if (removedNodes.has(node)) {
                    removedNodes.delete(node);
                    return;
                }
                if (node._x_marker) return;
                addedNodes.push(node);
            });
        }
        if (mutations[i].type === "attributes") {
            var el = mutations[i].target;
            var name = mutations[i].attributeName;
            var oldValue = mutations[i].oldValue;
            var add2 = function() {
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            var remove = function() {
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add2();
            else if (el.hasAttribute(name)) {
                remove();
                add2();
            } else remove();
        }
    };
    if ($da6f71b8677b901e$var$isCollecting) {
        $da6f71b8677b901e$var$deferredMutations = $da6f71b8677b901e$var$deferredMutations.concat(mutations);
        return;
    }
    var addedNodes = [];
    var removedNodes = /* @__PURE__ */ new Set();
    var addedAttributes = /* @__PURE__ */ new Map();
    var removedAttributes = /* @__PURE__ */ new Map();
    for(var i = 0; i < mutations.length; i++)_loop(i);
    removedAttributes.forEach(function(attrs, el) {
        $da6f71b8677b901e$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach(function(attrs, el) {
        $da6f71b8677b901e$var$onAttributeAddeds.forEach(function(i) {
            return i(el, attrs);
        });
    });
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop1 = function() {
            var node = _step.value;
            if (addedNodes.some(function(i) {
                return i.contains(node);
            })) return "continue";
            $da6f71b8677b901e$var$onElRemoveds.forEach(function(i) {
                return i(node);
            });
        };
        for(var _iterator = removedNodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop1();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        var _loop2 = function() {
            var node = _step1.value;
            if (!node.isConnected) return "continue";
            $da6f71b8677b901e$var$onElAddeds.forEach(function(i) {
                return i(node);
            });
        };
        for(var _iterator1 = addedNodes[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true)_loop2();
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $da6f71b8677b901e$var$scope(node) {
    return $da6f71b8677b901e$var$mergeProxies($da6f71b8677b901e$var$closestDataStack(node));
}
function $da6f71b8677b901e$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2
    ].concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)($da6f71b8677b901e$var$closestDataStack(referenceNode || node)));
    return function() {
        node._x_dataStack = node._x_dataStack.filter(function(i) {
            return i !== data2;
        });
    };
}
function $da6f71b8677b901e$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $da6f71b8677b901e$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $da6f71b8677b901e$var$closestDataStack(node.parentNode);
}
function $da6f71b8677b901e$var$mergeProxies(objects) {
    return new Proxy({
        objects: objects
    }, $da6f71b8677b901e$var$mergeProxyTrap);
}
var $da6f71b8677b901e$var$mergeProxyTrap = {
    ownKeys: function(param) {
        var objects = param.objects;
        return Array.from(new Set(objects.flatMap(function(i) {
            return Object.keys(i);
        })));
    },
    has: function(param, name) {
        var objects = param.objects;
        if (name == Symbol.unscopables) return false;
        return objects.some(function(obj) {
            return Object.prototype.hasOwnProperty.call(obj, name) || Reflect.has(obj, name);
        });
    },
    get: function(param, name, thisProxy) {
        var objects = param.objects;
        if (name == "toJSON") return $da6f71b8677b901e$var$collapseProxies;
        return Reflect.get(objects.find(function(obj) {
            return Reflect.has(obj, name);
        }) || {}, name, thisProxy);
    },
    set: function(param, name, value, thisProxy) {
        var objects = param.objects;
        var target = objects.find(function(obj) {
            return Object.prototype.hasOwnProperty.call(obj, name);
        }) || objects[objects.length - 1];
        var descriptor = Object.getOwnPropertyDescriptor(target, name);
        if ((descriptor === null || descriptor === void 0 ? void 0 : descriptor.set) && (descriptor === null || descriptor === void 0 ? void 0 : descriptor.get)) return descriptor.set.call(thisProxy, value) || true;
        return Reflect.set(target, name, value);
    }
};
function $da6f71b8677b901e$var$collapseProxies() {
    var _this = this;
    var keys = Reflect.ownKeys(this);
    return keys.reduce(function(acc, key) {
        acc[key] = Reflect.get(_this, key);
        return acc;
    }, {});
}
// packages/alpinejs/src/interceptor.js
function $da6f71b8677b901e$var$initInterceptors(data2) {
    var isObject2 = function(val) {
        return (typeof val === "undefined" ? "undefined" : (0, $1968e3edfc5cfc11$export$71511d61b312f219)(val)) === "object" && !Array.isArray(val) && val !== null;
    };
    var recurse = function(obj) {
        var basePath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(function(param) {
            var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), key = _param[0], _param_ = _param[1], value = _param_.value, enumerable = _param_.enumerable;
            if (enumerable === false || value === void 0) return;
            if ((typeof value === "undefined" ? "undefined" : (0, $1968e3edfc5cfc11$export$71511d61b312f219)(value)) === "object" && value !== null && value.__v_skip) return;
            var path = basePath === "" ? key : "".concat(basePath, ".").concat(key);
            if ((typeof value === "undefined" ? "undefined" : (0, $1968e3edfc5cfc11$export$71511d61b312f219)(value)) === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key);
            else if (isObject2(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $da6f71b8677b901e$var$interceptor(callback) {
    var mutateObj = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {};
    var obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize: function(data2, path, key) {
            return callback(this.initialValue, function() {
                return $da6f71b8677b901e$var$get(data2, path);
            }, function(value) {
                return $da6f71b8677b901e$var$set(data2, path, value);
            }, path, key);
        }
    };
    mutateObj(obj);
    return function(initialValue) {
        if ((typeof initialValue === "undefined" ? "undefined" : (0, $1968e3edfc5cfc11$export$71511d61b312f219)(initialValue)) === "object" && initialValue !== null && initialValue._x_interceptor) {
            var initialize = obj.initialize.bind(obj);
            obj.initialize = function(data2, path, key) {
                var innerValue = initialValue.initialize(data2, path, key);
                obj.initialValue = innerValue;
                return initialize(data2, path, key);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $da6f71b8677b901e$var$get(obj, path) {
    return path.split(".").reduce(function(carry, segment) {
        return carry[segment];
    }, obj);
}
function $da6f71b8677b901e$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $da6f71b8677b901e$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $da6f71b8677b901e$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $da6f71b8677b901e$var$magics = {};
function $da6f71b8677b901e$var$magic(name, callback) {
    $da6f71b8677b901e$var$magics[name] = callback;
}
function $da6f71b8677b901e$var$injectMagics(obj, el) {
    var memoizedUtilities = $da6f71b8677b901e$var$getUtilities(el);
    Object.entries($da6f71b8677b901e$var$magics).forEach(function(param) {
        var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), name = _param[0], callback = _param[1];
        Object.defineProperty(obj, "$".concat(name), {
            get: function() {
                return callback(el, memoizedUtilities);
            },
            enumerable: false
        });
    });
    return obj;
}
function $da6f71b8677b901e$var$getUtilities(el) {
    var _getElementBoundUtilities = (0, $1788e2ed61915b1e$export$71511d61b312f219)($da6f71b8677b901e$var$getElementBoundUtilities(el), 2), utilities = _getElementBoundUtilities[0], cleanup2 = _getElementBoundUtilities[1];
    var utils = (0, $fa9769297b8a68c8$export$71511d61b312f219)({
        interceptor: $da6f71b8677b901e$var$interceptor
    }, utilities);
    $da6f71b8677b901e$var$onElRemoved(el, cleanup2);
    return utils;
}
// packages/alpinejs/src/utils/error.js
function $da6f71b8677b901e$var$tryCatch(el, expression, callback) {
    for(var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++){
        args[_key - 3] = arguments[_key];
    }
    try {
        return callback.apply(void 0, (0, $4c858c0d999a5b9b$export$71511d61b312f219)(args));
    } catch (e) {
        $da6f71b8677b901e$var$handleError(e, el, expression);
    }
}
function $da6f71b8677b901e$var$handleError(error2, el, expression) {
    error2 = Object.assign(error2 !== null && error2 !== void 0 ? error2 : {
        message: "No error message given."
    }, {
        el: el,
        expression: expression
    });
    console.warn("Alpine Expression Error: ".concat(error2.message, "\n\n").concat(expression ? 'Expression: "' + expression + '"\n\n' : ""), el);
    setTimeout(function() {
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $da6f71b8677b901e$var$shouldAutoEvaluateFunctions = true;
function $da6f71b8677b901e$var$dontAutoEvaluateFunctions(callback) {
    var cache = $da6f71b8677b901e$var$shouldAutoEvaluateFunctions;
    $da6f71b8677b901e$var$shouldAutoEvaluateFunctions = false;
    var result = callback();
    $da6f71b8677b901e$var$shouldAutoEvaluateFunctions = cache;
    return result;
}
function $da6f71b8677b901e$var$evaluate(el, expression) {
    var extras = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var result;
    $da6f71b8677b901e$var$evaluateLater(el, expression)(function(value) {
        return result = value;
    }, extras);
    return result;
}
function $da6f71b8677b901e$var$evaluateLater() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return $da6f71b8677b901e$var$theEvaluatorFunction.apply(void 0, (0, $4c858c0d999a5b9b$export$71511d61b312f219)(args));
}
var $da6f71b8677b901e$var$theEvaluatorFunction = $da6f71b8677b901e$var$normalEvaluator;
function $da6f71b8677b901e$var$setEvaluator(newEvaluator) {
    $da6f71b8677b901e$var$theEvaluatorFunction = newEvaluator;
}
function $da6f71b8677b901e$var$normalEvaluator(el, expression) {
    var overriddenMagics = {};
    $da6f71b8677b901e$var$injectMagics(overriddenMagics, el);
    var dataStack = [
        overriddenMagics
    ].concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)($da6f71b8677b901e$var$closestDataStack(el)));
    var evaluator = typeof expression === "function" ? $da6f71b8677b901e$var$generateEvaluatorFromFunction(dataStack, expression) : $da6f71b8677b901e$var$generateEvaluatorFromString(dataStack, expression, el);
    return $da6f71b8677b901e$var$tryCatch.bind(null, el, expression, evaluator);
}
function $da6f71b8677b901e$var$generateEvaluatorFromFunction(dataStack, func) {
    return function() {
        var receiver = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {}, _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, tmp = _ref.scope, scope2 = tmp === void 0 ? {} : tmp, _ref_params = _ref.params, params = _ref_params === void 0 ? [] : _ref_params, context = _ref.context;
        var result = func.apply($da6f71b8677b901e$var$mergeProxies([
            scope2
        ].concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)(dataStack))), params);
        $da6f71b8677b901e$var$runIfTypeOfFunction(receiver, result);
    };
}
var $da6f71b8677b901e$var$evaluatorMemo = {};
function $da6f71b8677b901e$var$generateFunctionFromString(expression, el) {
    if ($da6f71b8677b901e$var$evaluatorMemo[expression]) return $da6f71b8677b901e$var$evaluatorMemo[expression];
    var AsyncFunction = Object.getPrototypeOf(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
            return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
                return [
                    2
                ];
            });
        })();
    }).constructor;
    var rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? "(async()=>{ ".concat(expression, " })()") : expression;
    var safeAsyncFunction = function() {
        try {
            var func2 = new AsyncFunction([
                "__self",
                "scope"
            ], "with (scope) { __self.result = ".concat(rightSideSafeExpression, " }; __self.finished = true; return __self.result;"));
            Object.defineProperty(func2, "name", {
                value: "[Alpine] ".concat(expression)
            });
            return func2;
        } catch (error2) {
            $da6f71b8677b901e$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    var func = safeAsyncFunction();
    $da6f71b8677b901e$var$evaluatorMemo[expression] = func;
    return func;
}
function $da6f71b8677b901e$var$generateEvaluatorFromString(dataStack, expression, el) {
    var func = $da6f71b8677b901e$var$generateFunctionFromString(expression, el);
    return function() {
        var receiver = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {}, _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, tmp = _ref.scope, scope2 = tmp === void 0 ? {} : tmp, _ref_params = _ref.params, params = _ref_params === void 0 ? [] : _ref_params, context = _ref.context;
        func.result = void 0;
        func.finished = false;
        var completeScope = $da6f71b8677b901e$var$mergeProxies([
            scope2
        ].concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)(dataStack)));
        if (typeof func === "function") {
            var promise = func.call(context, func, completeScope).catch(function(error2) {
                return $da6f71b8677b901e$var$handleError(error2, el, expression);
            });
            if (func.finished) {
                $da6f71b8677b901e$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then(function(result) {
                $da6f71b8677b901e$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch(function(error2) {
                return $da6f71b8677b901e$var$handleError(error2, el, expression);
            }).finally(function() {
                return func.result = void 0;
            });
        }
    };
}
function $da6f71b8677b901e$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($da6f71b8677b901e$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        var result = value.apply(scope2, params);
        if (result instanceof Promise) result.then(function(i) {
            return $da6f71b8677b901e$var$runIfTypeOfFunction(receiver, i, scope2, params);
        }).catch(function(error2) {
            return $da6f71b8677b901e$var$handleError(error2, el, value);
        });
        else receiver(result);
    } else if ((typeof value === "undefined" ? "undefined" : (0, $1968e3edfc5cfc11$export$71511d61b312f219)(value)) === "object" && value instanceof Promise) value.then(function(i) {
        return receiver(i);
    });
    else receiver(value);
}
// packages/alpinejs/src/directives.js
var $da6f71b8677b901e$var$prefixAsString = "x-";
function $da6f71b8677b901e$var$prefix() {
    var subject = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return $da6f71b8677b901e$var$prefixAsString + subject;
}
function $da6f71b8677b901e$var$setPrefix(newPrefix) {
    $da6f71b8677b901e$var$prefixAsString = newPrefix;
}
var $da6f71b8677b901e$var$directiveHandlers = {};
function $da6f71b8677b901e$var$directive(name, callback) {
    $da6f71b8677b901e$var$directiveHandlers[name] = callback;
    return {
        before: function(directive2) {
            if (!$da6f71b8677b901e$var$directiveHandlers[directive2]) {
                console.warn(String.raw($da6f71b8677b901e$var$_templateObject(), directive2, name));
                return;
            }
            var pos = $da6f71b8677b901e$var$directiveOrder.indexOf(directive2);
            $da6f71b8677b901e$var$directiveOrder.splice(pos >= 0 ? pos : $da6f71b8677b901e$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $da6f71b8677b901e$var$directiveExists(name) {
    return Object.keys($da6f71b8677b901e$var$directiveHandlers).includes(name);
}
function $da6f71b8677b901e$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        var vAttributes = Object.entries(el._x_virtualDirectives).map(function(param) {
            var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), name = _param[0], value = _param[1];
            return {
                name: name,
                value: value
            };
        });
        var staticAttributes = $da6f71b8677b901e$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map(function(attribute) {
            if (staticAttributes.find(function(attr) {
                return attr.name === attribute.name;
            })) return {
                name: "x-bind:".concat(attribute.name),
                value: '"'.concat(attribute.value, '"')
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    var transformedAttributeMap = {};
    var directives2 = attributes.map($da6f71b8677b901e$var$toTransformedAttributes(function(newName, oldName) {
        return transformedAttributeMap[newName] = oldName;
    })).filter($da6f71b8677b901e$var$outNonAlpineAttributes).map($da6f71b8677b901e$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($da6f71b8677b901e$var$byPriority);
    return directives2.map(function(directive2) {
        return $da6f71b8677b901e$var$getDirectiveHandler(el, directive2);
    });
}
function $da6f71b8677b901e$var$attributesOnly(attributes) {
    return Array.from(attributes).map($da6f71b8677b901e$var$toTransformedAttributes()).filter(function(attr) {
        return !$da6f71b8677b901e$var$outNonAlpineAttributes(attr);
    });
}
var $da6f71b8677b901e$var$isDeferringHandlers = false;
var $da6f71b8677b901e$var$directiveHandlerStacks = /* @__PURE__ */ new Map();
var $da6f71b8677b901e$var$currentHandlerStackKey = Symbol();
function $da6f71b8677b901e$var$deferHandlingDirectives(callback) {
    $da6f71b8677b901e$var$isDeferringHandlers = true;
    var key = Symbol();
    $da6f71b8677b901e$var$currentHandlerStackKey = key;
    $da6f71b8677b901e$var$directiveHandlerStacks.set(key, []);
    var flushHandlers = function() {
        while($da6f71b8677b901e$var$directiveHandlerStacks.get(key).length)$da6f71b8677b901e$var$directiveHandlerStacks.get(key).shift()();
        $da6f71b8677b901e$var$directiveHandlerStacks.delete(key);
    };
    var stopDeferring = function() {
        $da6f71b8677b901e$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $da6f71b8677b901e$var$getElementBoundUtilities(el) {
    var cleanups = [];
    var cleanup2 = function(callback) {
        return cleanups.push(callback);
    };
    var _elementBoundEffect = (0, $1788e2ed61915b1e$export$71511d61b312f219)($da6f71b8677b901e$var$elementBoundEffect(el), 2), effect3 = _elementBoundEffect[0], cleanupEffect = _elementBoundEffect[1];
    cleanups.push(cleanupEffect);
    var utilities = {
        Alpine: $da6f71b8677b901e$var$alpine_default,
        effect: effect3,
        cleanup: cleanup2,
        evaluateLater: $da6f71b8677b901e$var$evaluateLater.bind($da6f71b8677b901e$var$evaluateLater, el),
        evaluate: $da6f71b8677b901e$var$evaluate.bind($da6f71b8677b901e$var$evaluate, el)
    };
    var doCleanup = function() {
        return cleanups.forEach(function(i) {
            return i();
        });
    };
    return [
        utilities,
        doCleanup
    ];
}
function $da6f71b8677b901e$var$getDirectiveHandler(el, directive2) {
    var noop = function() {};
    var handler4 = $da6f71b8677b901e$var$directiveHandlers[directive2.type] || noop;
    var _getElementBoundUtilities = (0, $1788e2ed61915b1e$export$71511d61b312f219)($da6f71b8677b901e$var$getElementBoundUtilities(el), 2), utilities = _getElementBoundUtilities[0], cleanup2 = _getElementBoundUtilities[1];
    $da6f71b8677b901e$var$onAttributeRemoved(el, directive2.original, cleanup2);
    var fullHandler = function() {
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler4.inline && handler4.inline(el, directive2, utilities);
        handler4 = handler4.bind(handler4, el, directive2, utilities);
        $da6f71b8677b901e$var$isDeferringHandlers ? $da6f71b8677b901e$var$directiveHandlerStacks.get($da6f71b8677b901e$var$currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
}
var $da6f71b8677b901e$var$startingWith = function(subject, replacement) {
    return function(param) {
        var name = param.name, value = param.value;
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
};
var $da6f71b8677b901e$var$into = function(i) {
    return i;
};
function $da6f71b8677b901e$var$toTransformedAttributes() {
    var callback = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {};
    return function(param) {
        var name = param.name, value = param.value;
        var _attributeTransformers_reduce = $da6f71b8677b901e$var$attributeTransformers.reduce(function(carry, transform) {
            return transform(carry);
        }, {
            name: name,
            value: value
        }), newName = _attributeTransformers_reduce.name, newValue = _attributeTransformers_reduce.value;
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $da6f71b8677b901e$var$attributeTransformers = [];
function $da6f71b8677b901e$var$mapAttributes(callback) {
    $da6f71b8677b901e$var$attributeTransformers.push(callback);
}
function $da6f71b8677b901e$var$outNonAlpineAttributes(param) {
    var name = param.name;
    return $da6f71b8677b901e$var$alpineAttributeRegex().test(name);
}
var $da6f71b8677b901e$var$alpineAttributeRegex = function() {
    return new RegExp("^".concat($da6f71b8677b901e$var$prefixAsString, "([^:^.]+)\\b"));
};
function $da6f71b8677b901e$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return function(param) {
        var name = param.name, value = param.value;
        var typeMatch = name.match($da6f71b8677b901e$var$alpineAttributeRegex());
        var valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
        var modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        var original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map(function(i) {
                return i.replace(".", "");
            }),
            expression: value,
            original: original
        };
    };
}
var $da6f71b8677b901e$var$DEFAULT = "DEFAULT";
var $da6f71b8677b901e$var$directiveOrder = [
    "ignore",
    "ref",
    "data",
    "id",
    "anchor",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $da6f71b8677b901e$var$DEFAULT,
    "teleport"
];
function $da6f71b8677b901e$var$byPriority(a, b) {
    var typeA = $da6f71b8677b901e$var$directiveOrder.indexOf(a.type) === -1 ? $da6f71b8677b901e$var$DEFAULT : a.type;
    var typeB = $da6f71b8677b901e$var$directiveOrder.indexOf(b.type) === -1 ? $da6f71b8677b901e$var$DEFAULT : b.type;
    return $da6f71b8677b901e$var$directiveOrder.indexOf(typeA) - $da6f71b8677b901e$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/utils/dispatch.js
function $da6f71b8677b901e$var$dispatch(el, name) {
    var detail = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        // Allows events to pass the shadow DOM barrier.
        composed: true,
        cancelable: true
    }));
}
// packages/alpinejs/src/utils/walk.js
function $da6f71b8677b901e$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach(function(el2) {
            return $da6f71b8677b901e$var$walk(el2, callback);
        });
        return;
    }
    var skip = false;
    callback(el, function() {
        return skip = true;
    });
    if (skip) return;
    var node = el.firstElementChild;
    while(node){
        $da6f71b8677b901e$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/utils/warn.js
function $da6f71b8677b901e$var$warn(message) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    var _console;
    (_console = console).warn.apply(_console, [
        "Alpine Warning: ".concat(message)
    ].concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)(args)));
}
// packages/alpinejs/src/lifecycle.js
var $da6f71b8677b901e$var$started = false;
function $da6f71b8677b901e$var$start() {
    if ($da6f71b8677b901e$var$started) $da6f71b8677b901e$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $da6f71b8677b901e$var$started = true;
    if (!document.body) $da6f71b8677b901e$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $da6f71b8677b901e$var$dispatch(document, "alpine:init");
    $da6f71b8677b901e$var$dispatch(document, "alpine:initializing");
    $da6f71b8677b901e$var$startObservingMutations();
    $da6f71b8677b901e$var$onElAdded(function(el) {
        return $da6f71b8677b901e$var$initTree(el, $da6f71b8677b901e$var$walk);
    });
    $da6f71b8677b901e$var$onElRemoved(function(el) {
        return $da6f71b8677b901e$var$destroyTree(el);
    });
    $da6f71b8677b901e$var$onAttributesAdded(function(el, attrs) {
        $da6f71b8677b901e$var$directives(el, attrs).forEach(function(handle) {
            return handle();
        });
    });
    var outNestedComponents = function(el) {
        return !$da6f71b8677b901e$var$closestRoot(el.parentElement, true);
    };
    Array.from(document.querySelectorAll($da6f71b8677b901e$var$allSelectors().join(","))).filter(outNestedComponents).forEach(function(el) {
        $da6f71b8677b901e$var$initTree(el);
    });
    $da6f71b8677b901e$var$dispatch(document, "alpine:initialized");
    setTimeout(function() {
        $da6f71b8677b901e$var$warnAboutMissingPlugins();
    });
}
var $da6f71b8677b901e$var$rootSelectorCallbacks = [];
var $da6f71b8677b901e$var$initSelectorCallbacks = [];
function $da6f71b8677b901e$var$rootSelectors() {
    return $da6f71b8677b901e$var$rootSelectorCallbacks.map(function(fn) {
        return fn();
    });
}
function $da6f71b8677b901e$var$allSelectors() {
    return $da6f71b8677b901e$var$rootSelectorCallbacks.concat($da6f71b8677b901e$var$initSelectorCallbacks).map(function(fn) {
        return fn();
    });
}
function $da6f71b8677b901e$var$addRootSelector(selectorCallback) {
    $da6f71b8677b901e$var$rootSelectorCallbacks.push(selectorCallback);
}
function $da6f71b8677b901e$var$addInitSelector(selectorCallback) {
    $da6f71b8677b901e$var$initSelectorCallbacks.push(selectorCallback);
}
function $da6f71b8677b901e$var$closestRoot(el) {
    var includeInitSelectors = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return $da6f71b8677b901e$var$findClosest(el, function(element) {
        var selectors = includeInitSelectors ? $da6f71b8677b901e$var$allSelectors() : $da6f71b8677b901e$var$rootSelectors();
        if (selectors.some(function(selector) {
            return element.matches(selector);
        })) return true;
    });
}
function $da6f71b8677b901e$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) el = el._x_teleportBack;
    if (!el.parentElement) return;
    return $da6f71b8677b901e$var$findClosest(el.parentElement, callback);
}
function $da6f71b8677b901e$var$isRoot(el) {
    return $da6f71b8677b901e$var$rootSelectors().some(function(selector) {
        return el.matches(selector);
    });
}
var $da6f71b8677b901e$var$initInterceptors2 = [];
function $da6f71b8677b901e$var$interceptInit(callback) {
    $da6f71b8677b901e$var$initInterceptors2.push(callback);
}
var $da6f71b8677b901e$var$markerDispenser = 1;
function $da6f71b8677b901e$var$initTree(el) {
    var walker = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $da6f71b8677b901e$var$walk, intercept = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function() {};
    if ($da6f71b8677b901e$var$findClosest(el, function(i) {
        return i._x_ignore;
    })) return;
    $da6f71b8677b901e$var$deferHandlingDirectives(function() {
        walker(el, function(el2, skip) {
            if (el2._x_marker) return;
            intercept(el2, skip);
            $da6f71b8677b901e$var$initInterceptors2.forEach(function(i) {
                return i(el2, skip);
            });
            $da6f71b8677b901e$var$directives(el2, el2.attributes).forEach(function(handle) {
                return handle();
            });
            if (!el2._x_ignore) el2._x_marker = $da6f71b8677b901e$var$markerDispenser++;
            el2._x_ignore && skip();
        });
    });
}
function $da6f71b8677b901e$var$destroyTree(root) {
    var walker = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $da6f71b8677b901e$var$walk;
    walker(root, function(el) {
        $da6f71b8677b901e$var$cleanupElement(el);
        $da6f71b8677b901e$var$cleanupAttributes(el);
        delete el._x_marker;
    });
}
function $da6f71b8677b901e$var$warnAboutMissingPlugins() {
    var pluginDirectives = [
        [
            "ui",
            "dialog",
            [
                "[x-dialog], [x-popover]"
            ]
        ],
        [
            "anchor",
            "anchor",
            [
                "[x-anchor]"
            ]
        ],
        [
            "sort",
            "sort",
            [
                "[x-sort]"
            ]
        ]
    ];
    pluginDirectives.forEach(function(param) {
        var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 3), plugin2 = _param[0], directive2 = _param[1], selectors = _param[2];
        if ($da6f71b8677b901e$var$directiveExists(directive2)) return;
        selectors.some(function(selector) {
            if (document.querySelector(selector)) {
                $da6f71b8677b901e$var$warn('found "'.concat(selector, '", but missing ').concat(plugin2, " plugin"));
                return true;
            }
        });
    });
}
// packages/alpinejs/src/nextTick.js
var $da6f71b8677b901e$var$tickStack = [];
var $da6f71b8677b901e$var$isHolding = false;
function $da6f71b8677b901e$var$nextTick() {
    var callback = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {};
    queueMicrotask(function() {
        $da6f71b8677b901e$var$isHolding || setTimeout(function() {
            $da6f71b8677b901e$var$releaseNextTicks();
        });
    });
    return new Promise(function(res) {
        $da6f71b8677b901e$var$tickStack.push(function() {
            callback();
            res();
        });
    });
}
function $da6f71b8677b901e$var$releaseNextTicks() {
    $da6f71b8677b901e$var$isHolding = false;
    while($da6f71b8677b901e$var$tickStack.length)$da6f71b8677b901e$var$tickStack.shift()();
}
function $da6f71b8677b901e$var$holdNextTicks() {
    $da6f71b8677b901e$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $da6f71b8677b901e$var$setClasses(el, value) {
    if (Array.isArray(value)) return $da6f71b8677b901e$var$setClassesFromString(el, value.join(" "));
    else if ((typeof value === "undefined" ? "undefined" : (0, $1968e3edfc5cfc11$export$71511d61b312f219)(value)) === "object" && value !== null) return $da6f71b8677b901e$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $da6f71b8677b901e$var$setClasses(el, value());
    return $da6f71b8677b901e$var$setClassesFromString(el, value);
}
function $da6f71b8677b901e$var$setClassesFromString(el, classString) {
    var split = function(classString2) {
        return classString2.split(" ").filter(Boolean);
    };
    var missingClasses = function(classString2) {
        return classString2.split(" ").filter(function(i) {
            return !el.classList.contains(i);
        }).filter(Boolean);
    };
    var addClassesAndReturnUndo = function(classes) {
        var _el_classList;
        (_el_classList = el.classList).add.apply(_el_classList, (0, $4c858c0d999a5b9b$export$71511d61b312f219)(classes));
        return function() {
            var _el_classList;
            (_el_classList = el.classList).remove.apply(_el_classList, (0, $4c858c0d999a5b9b$export$71511d61b312f219)(classes));
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $da6f71b8677b901e$var$setClassesFromObject(el, classObject) {
    var split = function(classString) {
        return classString.split(" ").filter(Boolean);
    };
    var forAdd = Object.entries(classObject).flatMap(function(param) {
        var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), classString = _param[0], bool = _param[1];
        return bool ? split(classString) : false;
    }).filter(Boolean);
    var forRemove = Object.entries(classObject).flatMap(function(param) {
        var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), classString = _param[0], bool = _param[1];
        return !bool ? split(classString) : false;
    }).filter(Boolean);
    var added = [];
    var removed = [];
    forRemove.forEach(function(i) {
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach(function(i) {
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return function() {
        removed.forEach(function(i) {
            return el.classList.add(i);
        });
        added.forEach(function(i) {
            return el.classList.remove(i);
        });
    };
}
// packages/alpinejs/src/utils/styles.js
function $da6f71b8677b901e$var$setStyles(el, value) {
    if ((typeof value === "undefined" ? "undefined" : (0, $1968e3edfc5cfc11$export$71511d61b312f219)(value)) === "object" && value !== null) return $da6f71b8677b901e$var$setStylesFromObject(el, value);
    return $da6f71b8677b901e$var$setStylesFromString(el, value);
}
function $da6f71b8677b901e$var$setStylesFromObject(el, value) {
    var previousStyles = {};
    Object.entries(value).forEach(function(param) {
        var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), key = _param[0], value2 = _param[1];
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $da6f71b8677b901e$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(function() {
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return function() {
        $da6f71b8677b901e$var$setStyles(el, previousStyles);
    };
}
function $da6f71b8677b901e$var$setStylesFromString(el, value) {
    var cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return function() {
        el.setAttribute("style", cache || "");
    };
}
function $da6f71b8677b901e$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $da6f71b8677b901e$var$once(callback) {
    var fallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {};
    var called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$da6f71b8677b901e$var$directive("transition", function(el, param, param1) {
    var value = param.value, modifiers = param.modifiers, expression = param.expression, evaluate2 = param1.evaluate;
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $da6f71b8677b901e$var$registerTransitionsFromHelper(el, modifiers, value);
    else $da6f71b8677b901e$var$registerTransitionsFromClassString(el, expression, value);
});
function $da6f71b8677b901e$var$registerTransitionsFromClassString(el, classString, stage) {
    $da6f71b8677b901e$var$registerTransitionObject(el, $da6f71b8677b901e$var$setClasses, "");
    var directiveStorageMap = {
        "enter": function(classes) {
            el._x_transition.enter.during = classes;
        },
        "enter-start": function(classes) {
            el._x_transition.enter.start = classes;
        },
        "enter-end": function(classes) {
            el._x_transition.enter.end = classes;
        },
        "leave": function(classes) {
            el._x_transition.leave.during = classes;
        },
        "leave-start": function(classes) {
            el._x_transition.leave.start = classes;
        },
        "leave-end": function(classes) {
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $da6f71b8677b901e$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $da6f71b8677b901e$var$registerTransitionObject(el, $da6f71b8677b901e$var$setStyles);
    var doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    var transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    var transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter(function(i, index) {
        return index < modifiers.indexOf("out");
    });
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter(function(i, index) {
        return index > modifiers.indexOf("out");
    });
    var wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    var wantsOpacity = wantsAll || modifiers.includes("opacity");
    var wantsScale = wantsAll || modifiers.includes("scale");
    var opacityValue = wantsOpacity ? 0 : 1;
    var scaleValue = wantsScale ? $da6f71b8677b901e$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    var delay = $da6f71b8677b901e$var$modifierValue(modifiers, "delay", 0) / 1e3;
    var origin = $da6f71b8677b901e$var$modifierValue(modifiers, "origin", "center");
    var property = "opacity, transform";
    var durationIn = $da6f71b8677b901e$var$modifierValue(modifiers, "duration", 150) / 1e3;
    var durationOut = $da6f71b8677b901e$var$modifierValue(modifiers, "duration", 75) / 1e3;
    var easing = "cubic-bezier(0.4, 0.0, 0.2, 1)";
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: "".concat(delay, "s"),
            transitionProperty: property,
            transitionDuration: "".concat(durationIn, "s"),
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: "scale(".concat(scaleValue, ")")
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: "scale(1)"
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: "".concat(delay, "s"),
            transitionProperty: property,
            transitionDuration: "".concat(durationOut, "s"),
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: "scale(1)"
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: "scale(".concat(scaleValue, ")")
        };
    }
}
function $da6f71b8677b901e$var$registerTransitionObject(el, setFunction) {
    var defaultValue = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in: function() {
            var before = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {}, after = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {};
            $da6f71b8677b901e$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out: function() {
            var before = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {}, after = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {};
            $da6f71b8677b901e$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    var nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    var clickAwayCompatibleShow = function() {
        return nextTick2(show);
    };
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise(function(resolve, reject) {
        el._x_transition.out(function() {}, function() {
            return resolve(hide);
        });
        el._x_transitioning && el._x_transitioning.beforeCancel(function() {
            return reject({
                isFromCancelledTransition: true
            });
        });
    }) : Promise.resolve(hide);
    queueMicrotask(function() {
        var closest = $da6f71b8677b901e$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(function() {
            var hideAfterChildren = function(el2) {
                var carry = Promise.all([
                    el2._x_hidePromise
                ].concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)((el2._x_hideChildren || []).map(hideAfterChildren)))).then(function(param) {
                    var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 1), i = _param[0];
                    return i === null || i === void 0 ? void 0 : i();
                });
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch(function(e) {
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $da6f71b8677b901e$var$closestHide(el) {
    var parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $da6f71b8677b901e$var$closestHide(parent);
}
function $da6f71b8677b901e$var$transition(el, setFunction) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, during = _ref.during, start2 = _ref.start, end = _ref.end, before = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : function() {}, after = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : function() {};
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    var undoStart, undoDuring, undoEnd;
    $da6f71b8677b901e$var$performTransition(el, {
        start: function() {
            undoStart = setFunction(el, start2);
        },
        during: function() {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end: function() {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup: function() {
            undoDuring();
            undoEnd();
        }
    });
}
function $da6f71b8677b901e$var$performTransition(el, stages) {
    var interrupted, reachedBefore, reachedEnd;
    var finish = $da6f71b8677b901e$var$once(function() {
        $da6f71b8677b901e$var$mutateDom(function() {
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $da6f71b8677b901e$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel: function(callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $da6f71b8677b901e$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $da6f71b8677b901e$var$mutateDom(function() {
        stages.start();
        stages.during();
    });
    $da6f71b8677b901e$var$holdNextTicks();
    requestAnimationFrame(function() {
        if (interrupted) return;
        var duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        var delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $da6f71b8677b901e$var$mutateDom(function() {
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(function() {
            if (interrupted) return;
            $da6f71b8677b901e$var$mutateDom(function() {
                stages.end();
            });
            $da6f71b8677b901e$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $da6f71b8677b901e$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    var rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        var match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/clone.js
var $da6f71b8677b901e$var$isCloning = false;
function $da6f71b8677b901e$var$skipDuringClone(callback) {
    var fallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {};
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return $da6f71b8677b901e$var$isCloning ? fallback.apply(void 0, (0, $4c858c0d999a5b9b$export$71511d61b312f219)(args)) : callback.apply(void 0, (0, $4c858c0d999a5b9b$export$71511d61b312f219)(args));
    };
}
function $da6f71b8677b901e$var$onlyDuringClone(callback) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return $da6f71b8677b901e$var$isCloning && callback.apply(void 0, (0, $4c858c0d999a5b9b$export$71511d61b312f219)(args));
    };
}
var $da6f71b8677b901e$var$interceptors = [];
function $da6f71b8677b901e$var$interceptClone(callback) {
    $da6f71b8677b901e$var$interceptors.push(callback);
}
function $da6f71b8677b901e$var$cloneNode(from, to) {
    $da6f71b8677b901e$var$interceptors.forEach(function(i) {
        return i(from, to);
    });
    $da6f71b8677b901e$var$isCloning = true;
    $da6f71b8677b901e$var$dontRegisterReactiveSideEffects(function() {
        $da6f71b8677b901e$var$initTree(to, function(el, callback) {
            callback(el, function() {});
        });
    });
    $da6f71b8677b901e$var$isCloning = false;
}
var $da6f71b8677b901e$var$isCloningLegacy = false;
function $da6f71b8677b901e$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $da6f71b8677b901e$var$isCloning = true;
    $da6f71b8677b901e$var$isCloningLegacy = true;
    $da6f71b8677b901e$var$dontRegisterReactiveSideEffects(function() {
        $da6f71b8677b901e$var$cloneTree(newEl);
    });
    $da6f71b8677b901e$var$isCloning = false;
    $da6f71b8677b901e$var$isCloningLegacy = false;
}
function $da6f71b8677b901e$var$cloneTree(el) {
    var hasRunThroughFirstEl = false;
    var shallowWalker = function(el2, callback) {
        $da6f71b8677b901e$var$walk(el2, function(el3, skip) {
            if (hasRunThroughFirstEl && $da6f71b8677b901e$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $da6f71b8677b901e$var$initTree(el, shallowWalker);
}
function $da6f71b8677b901e$var$dontRegisterReactiveSideEffects(callback) {
    var cache = $da6f71b8677b901e$var$effect;
    $da6f71b8677b901e$var$overrideEffect(function(callback2, el) {
        var storedEffect = cache(callback2);
        $da6f71b8677b901e$var$release(storedEffect);
        return function() {};
    });
    callback();
    $da6f71b8677b901e$var$overrideEffect(cache);
}
// packages/alpinejs/src/utils/bind.js
function $da6f71b8677b901e$var$bind(el, name, value) {
    var modifiers = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [];
    if (!el._x_bindings) el._x_bindings = $da6f71b8677b901e$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $da6f71b8677b901e$var$camelCase(name) : name;
    switch(name){
        case "value":
            $da6f71b8677b901e$var$bindInputValue(el, value);
            break;
        case "style":
            $da6f71b8677b901e$var$bindStyles(el, value);
            break;
        case "class":
            $da6f71b8677b901e$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $da6f71b8677b901e$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $da6f71b8677b901e$var$bindAttribute(el, name, value);
            break;
    }
}
function $da6f71b8677b901e$var$bindInputValue(el, value) {
    if ($da6f71b8677b901e$var$isRadio(el)) {
        if (el.attributes.value === void 0) el.value = value;
        if (window.fromModel) {
            if (typeof value === "boolean") el.checked = $da6f71b8677b901e$var$safeParseBoolean(el.value) === value;
            else el.checked = $da6f71b8677b901e$var$checkedAttrLooseCompare(el.value, value);
        }
    } else if ($da6f71b8677b901e$var$isCheckbox(el)) {
        if (Number.isInteger(value)) el.value = value;
        else if (!Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some(function(val) {
            return $da6f71b8677b901e$var$checkedAttrLooseCompare(val, el.value);
        });
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $da6f71b8677b901e$var$updateSelect(el, value);
    else {
        if (el.value === value) return;
        el.value = value === void 0 ? "" : value;
    }
}
function $da6f71b8677b901e$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $da6f71b8677b901e$var$setClasses(el, value);
}
function $da6f71b8677b901e$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $da6f71b8677b901e$var$setStyles(el, value);
}
function $da6f71b8677b901e$var$bindAttributeAndProperty(el, name, value) {
    $da6f71b8677b901e$var$bindAttribute(el, name, value);
    $da6f71b8677b901e$var$setPropertyIfChanged(el, name, value);
}
function $da6f71b8677b901e$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $da6f71b8677b901e$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($da6f71b8677b901e$var$isBooleanAttr(name)) value = name;
        $da6f71b8677b901e$var$setIfChanged(el, name, value);
    }
}
function $da6f71b8677b901e$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $da6f71b8677b901e$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $da6f71b8677b901e$var$updateSelect(el, value) {
    var arrayWrappedValue = [].concat(value).map(function(value2) {
        return value2 + "";
    });
    Array.from(el.options).forEach(function(option) {
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $da6f71b8677b901e$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, function(match, char) {
        return char.toUpperCase();
    });
}
function $da6f71b8677b901e$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $da6f71b8677b901e$var$safeParseBoolean(rawValue) {
    if ([
        1,
        "1",
        "true",
        "on",
        "yes",
        true
    ].includes(rawValue)) return true;
    if ([
        0,
        "0",
        "false",
        "off",
        "no",
        false
    ].includes(rawValue)) return false;
    return rawValue ? Boolean(rawValue) : null;
}
var $da6f71b8677b901e$var$booleanAttributes = /* @__PURE__ */ new Set([
    "allowfullscreen",
    "async",
    "autofocus",
    "autoplay",
    "checked",
    "controls",
    "default",
    "defer",
    "disabled",
    "formnovalidate",
    "inert",
    "ismap",
    "itemscope",
    "loop",
    "multiple",
    "muted",
    "nomodule",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "selected",
    "shadowrootclonable",
    "shadowrootdelegatesfocus",
    "shadowrootserializable"
]);
function $da6f71b8677b901e$var$isBooleanAttr(attrName) {
    return $da6f71b8677b901e$var$booleanAttributes.has(attrName);
}
function $da6f71b8677b901e$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $da6f71b8677b901e$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    return $da6f71b8677b901e$var$getAttributeBinding(el, name, fallback);
}
function $da6f71b8677b901e$var$extractProp(el, name, fallback) {
    var extract = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
        var binding = el._x_inlineBindings[name];
        binding.extract = extract;
        return $da6f71b8677b901e$var$dontAutoEvaluateFunctions(function() {
            return $da6f71b8677b901e$var$evaluate(el, binding.expression);
        });
    }
    return $da6f71b8677b901e$var$getAttributeBinding(el, name, fallback);
}
function $da6f71b8677b901e$var$getAttributeBinding(el, name, fallback) {
    var attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($da6f71b8677b901e$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
function $da6f71b8677b901e$var$isCheckbox(el) {
    return el.type === "checkbox" || el.localName === "ui-checkbox" || el.localName === "ui-switch";
}
function $da6f71b8677b901e$var$isRadio(el) {
    return el.type === "radio" || el.localName === "ui-radio";
}
// packages/alpinejs/src/utils/debounce.js
function $da6f71b8677b901e$var$debounce(func, wait) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function later() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $da6f71b8677b901e$var$throttle(func, limit) {
    var inThrottle;
    return function() {
        var context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(function() {
                return inThrottle = false;
            }, limit);
        }
    };
}
// packages/alpinejs/src/entangle.js
function $da6f71b8677b901e$var$entangle(param, param1) {
    var outerGet = param.get, outerSet = param.set, innerGet = param1.get, innerSet = param1.set;
    var firstRun = true;
    var outerHash;
    var innerHash;
    var reference = $da6f71b8677b901e$var$effect(function() {
        var outer = outerGet();
        var inner = innerGet();
        if (firstRun) {
            innerSet($da6f71b8677b901e$var$cloneIfObject(outer));
            firstRun = false;
        } else {
            var outerHashLatest = JSON.stringify(outer);
            var innerHashLatest = JSON.stringify(inner);
            if (outerHashLatest !== outerHash) innerSet($da6f71b8677b901e$var$cloneIfObject(outer));
            else if (outerHashLatest !== innerHashLatest) outerSet($da6f71b8677b901e$var$cloneIfObject(inner));
        }
        outerHash = JSON.stringify(outerGet());
        innerHash = JSON.stringify(innerGet());
    });
    return function() {
        $da6f71b8677b901e$var$release(reference);
    };
}
function $da6f71b8677b901e$var$cloneIfObject(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $1968e3edfc5cfc11$export$71511d61b312f219)(value)) === "object" ? JSON.parse(JSON.stringify(value)) : value;
}
// packages/alpinejs/src/plugin.js
function $da6f71b8677b901e$var$plugin(callback) {
    var callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach(function(i) {
        return i($da6f71b8677b901e$var$alpine_default);
    });
}
// packages/alpinejs/src/store.js
var $da6f71b8677b901e$var$stores = {};
var $da6f71b8677b901e$var$isReactive = false;
function $da6f71b8677b901e$var$store(name, value) {
    if (!$da6f71b8677b901e$var$isReactive) {
        $da6f71b8677b901e$var$stores = $da6f71b8677b901e$var$reactive($da6f71b8677b901e$var$stores);
        $da6f71b8677b901e$var$isReactive = true;
    }
    if (value === void 0) return $da6f71b8677b901e$var$stores[name];
    $da6f71b8677b901e$var$stores[name] = value;
    $da6f71b8677b901e$var$initInterceptors($da6f71b8677b901e$var$stores[name]);
    if ((typeof value === "undefined" ? "undefined" : (0, $1968e3edfc5cfc11$export$71511d61b312f219)(value)) === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $da6f71b8677b901e$var$stores[name].init();
}
function $da6f71b8677b901e$var$getStores() {
    return $da6f71b8677b901e$var$stores;
}
// packages/alpinejs/src/binds.js
var $da6f71b8677b901e$var$binds = {};
function $da6f71b8677b901e$var$bind2(name, bindings) {
    var getBindings = typeof bindings !== "function" ? function() {
        return bindings;
    } : bindings;
    if (name instanceof Element) return $da6f71b8677b901e$var$applyBindingsObject(name, getBindings());
    else $da6f71b8677b901e$var$binds[name] = getBindings;
    return function() {};
}
function $da6f71b8677b901e$var$injectBindingProviders(obj) {
    Object.entries($da6f71b8677b901e$var$binds).forEach(function(param) {
        var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), name = _param[0], callback = _param[1];
        Object.defineProperty(obj, name, {
            get: function() {
                return function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    return callback.apply(void 0, (0, $4c858c0d999a5b9b$export$71511d61b312f219)(args));
                };
            }
        });
    });
    return obj;
}
function $da6f71b8677b901e$var$applyBindingsObject(el, obj, original) {
    var cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    var attributes = Object.entries(obj).map(function(param) {
        var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), name = _param[0], value = _param[1];
        return {
            name: name,
            value: value
        };
    });
    var staticAttributes = $da6f71b8677b901e$var$attributesOnly(attributes);
    attributes = attributes.map(function(attribute) {
        if (staticAttributes.find(function(attr) {
            return attr.name === attribute.name;
        })) return {
            name: "x-bind:".concat(attribute.name),
            value: '"'.concat(attribute.value, '"')
        };
        return attribute;
    });
    $da6f71b8677b901e$var$directives(el, attributes, original).map(function(handle) {
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
    return function() {
        while(cleanupRunners.length)cleanupRunners.pop()();
    };
}
// packages/alpinejs/src/datas.js
var $da6f71b8677b901e$var$datas = {};
function $da6f71b8677b901e$var$data(name, callback) {
    $da6f71b8677b901e$var$datas[name] = callback;
}
function $da6f71b8677b901e$var$injectDataProviders(obj, context) {
    Object.entries($da6f71b8677b901e$var$datas).forEach(function(param) {
        var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), name = _param[0], callback = _param[1];
        Object.defineProperty(obj, name, {
            get: function() {
                var _this = this;
                return function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    return callback.bind(context).apply(_this, (0, $4c858c0d999a5b9b$export$71511d61b312f219)(args));
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $da6f71b8677b901e$var$Alpine = {
    get reactive () {
        return $da6f71b8677b901e$var$reactive;
    },
    get release () {
        return $da6f71b8677b901e$var$release;
    },
    get effect () {
        return $da6f71b8677b901e$var$effect;
    },
    get raw () {
        return $da6f71b8677b901e$var$raw;
    },
    version: "3.15.0",
    flushAndStopDeferringMutations: $da6f71b8677b901e$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $da6f71b8677b901e$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $da6f71b8677b901e$var$disableEffectScheduling,
    startObservingMutations: $da6f71b8677b901e$var$startObservingMutations,
    stopObservingMutations: $da6f71b8677b901e$var$stopObservingMutations,
    setReactivityEngine: $da6f71b8677b901e$var$setReactivityEngine,
    onAttributeRemoved: $da6f71b8677b901e$var$onAttributeRemoved,
    onAttributesAdded: $da6f71b8677b901e$var$onAttributesAdded,
    closestDataStack: $da6f71b8677b901e$var$closestDataStack,
    skipDuringClone: $da6f71b8677b901e$var$skipDuringClone,
    onlyDuringClone: $da6f71b8677b901e$var$onlyDuringClone,
    addRootSelector: $da6f71b8677b901e$var$addRootSelector,
    addInitSelector: $da6f71b8677b901e$var$addInitSelector,
    interceptClone: $da6f71b8677b901e$var$interceptClone,
    addScopeToNode: $da6f71b8677b901e$var$addScopeToNode,
    deferMutations: $da6f71b8677b901e$var$deferMutations,
    mapAttributes: $da6f71b8677b901e$var$mapAttributes,
    evaluateLater: $da6f71b8677b901e$var$evaluateLater,
    interceptInit: $da6f71b8677b901e$var$interceptInit,
    setEvaluator: $da6f71b8677b901e$var$setEvaluator,
    mergeProxies: $da6f71b8677b901e$var$mergeProxies,
    extractProp: $da6f71b8677b901e$var$extractProp,
    findClosest: $da6f71b8677b901e$var$findClosest,
    onElRemoved: $da6f71b8677b901e$var$onElRemoved,
    closestRoot: $da6f71b8677b901e$var$closestRoot,
    destroyTree: $da6f71b8677b901e$var$destroyTree,
    interceptor: $da6f71b8677b901e$var$interceptor,
    // INTERNAL: not public API and is subject to change without major release.
    transition: $da6f71b8677b901e$var$transition,
    // INTERNAL
    setStyles: $da6f71b8677b901e$var$setStyles,
    // INTERNAL
    mutateDom: $da6f71b8677b901e$var$mutateDom,
    directive: $da6f71b8677b901e$var$directive,
    entangle: $da6f71b8677b901e$var$entangle,
    throttle: $da6f71b8677b901e$var$throttle,
    debounce: $da6f71b8677b901e$var$debounce,
    evaluate: $da6f71b8677b901e$var$evaluate,
    initTree: $da6f71b8677b901e$var$initTree,
    nextTick: $da6f71b8677b901e$var$nextTick,
    prefixed: $da6f71b8677b901e$var$prefix,
    prefix: $da6f71b8677b901e$var$setPrefix,
    plugin: $da6f71b8677b901e$var$plugin,
    magic: $da6f71b8677b901e$var$magic,
    store: $da6f71b8677b901e$var$store,
    start: $da6f71b8677b901e$var$start,
    clone: $da6f71b8677b901e$var$clone,
    // INTERNAL
    cloneNode: $da6f71b8677b901e$var$cloneNode,
    // INTERNAL
    bound: $da6f71b8677b901e$var$getBinding,
    $data: $da6f71b8677b901e$var$scope,
    watch: $da6f71b8677b901e$var$watch,
    walk: $da6f71b8677b901e$var$walk,
    data: $da6f71b8677b901e$var$data,
    bind: $da6f71b8677b901e$var$bind2
};
var $da6f71b8677b901e$var$alpine_default = $da6f71b8677b901e$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $da6f71b8677b901e$var$makeMap(str, expectsLowerCase) {
    var map = /* @__PURE__ */ Object.create(null);
    var list = str.split(",");
    for(var i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? function(val) {
        return !!map[val.toLowerCase()];
    } : function(val) {
        return !!map[val];
    };
}
var $da6f71b8677b901e$var$specialBooleanAttrs = "itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly";
var $da6f71b8677b901e$var$isBooleanAttr2 = /* @__PURE__ */ $da6f71b8677b901e$var$makeMap($da6f71b8677b901e$var$specialBooleanAttrs + ",async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected");
var $da6f71b8677b901e$var$EMPTY_OBJ = Object.freeze({});
var $da6f71b8677b901e$var$EMPTY_ARR = Object.freeze([]);
var $da6f71b8677b901e$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $da6f71b8677b901e$var$hasOwn = function(val, key) {
    return $da6f71b8677b901e$var$hasOwnProperty.call(val, key);
};
var $da6f71b8677b901e$var$isArray = Array.isArray;
var $da6f71b8677b901e$var$isMap = function(val) {
    return $da6f71b8677b901e$var$toTypeString(val) === "[object Map]";
};
var $da6f71b8677b901e$var$isString = function(val) {
    return typeof val === "string";
};
var $da6f71b8677b901e$var$isSymbol = function(val) {
    return (typeof val === "undefined" ? "undefined" : (0, $1968e3edfc5cfc11$export$71511d61b312f219)(val)) === "symbol";
};
var $da6f71b8677b901e$var$isObject = function(val) {
    return val !== null && (typeof val === "undefined" ? "undefined" : (0, $1968e3edfc5cfc11$export$71511d61b312f219)(val)) === "object";
};
var $da6f71b8677b901e$var$objectToString = Object.prototype.toString;
var $da6f71b8677b901e$var$toTypeString = function(value) {
    return $da6f71b8677b901e$var$objectToString.call(value);
};
var $da6f71b8677b901e$var$toRawType = function(value) {
    return $da6f71b8677b901e$var$toTypeString(value).slice(8, -1);
};
var $da6f71b8677b901e$var$isIntegerKey = function(key) {
    return $da6f71b8677b901e$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
};
var $da6f71b8677b901e$var$cacheStringFunction = function(fn) {
    var cache = /* @__PURE__ */ Object.create(null);
    return function(str) {
        var hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $da6f71b8677b901e$var$camelizeRE = /-(\w)/g;
var $da6f71b8677b901e$var$camelize = $da6f71b8677b901e$var$cacheStringFunction(function(str) {
    return str.replace($da6f71b8677b901e$var$camelizeRE, function(_, c) {
        return c ? c.toUpperCase() : "";
    });
});
var $da6f71b8677b901e$var$hyphenateRE = /\B([A-Z])/g;
var $da6f71b8677b901e$var$hyphenate = $da6f71b8677b901e$var$cacheStringFunction(function(str) {
    return str.replace($da6f71b8677b901e$var$hyphenateRE, "-$1").toLowerCase();
});
var $da6f71b8677b901e$var$capitalize = $da6f71b8677b901e$var$cacheStringFunction(function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
});
var $da6f71b8677b901e$var$toHandlerKey = $da6f71b8677b901e$var$cacheStringFunction(function(str) {
    return str ? "on".concat($da6f71b8677b901e$var$capitalize(str)) : "";
});
var $da6f71b8677b901e$var$hasChanged = function(value, oldValue) {
    return value !== oldValue && (value === value || oldValue === oldValue);
};
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var $da6f71b8677b901e$var$targetMap = /* @__PURE__ */ new WeakMap();
var $da6f71b8677b901e$var$effectStack = [];
var $da6f71b8677b901e$var$activeEffect;
var $da6f71b8677b901e$var$ITERATE_KEY = Symbol("iterate");
var $da6f71b8677b901e$var$MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function $da6f71b8677b901e$var$isEffect(fn) {
    return fn && fn._isEffect === true;
}
function $da6f71b8677b901e$var$effect2(fn) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $da6f71b8677b901e$var$EMPTY_OBJ;
    if ($da6f71b8677b901e$var$isEffect(fn)) fn = fn.raw;
    var effect3 = $da6f71b8677b901e$var$createReactiveEffect(fn, options);
    if (!options.lazy) effect3();
    return effect3;
}
function $da6f71b8677b901e$var$stop(effect3) {
    if (effect3.active) {
        $da6f71b8677b901e$var$cleanup(effect3);
        if (effect3.options.onStop) effect3.options.onStop();
        effect3.active = false;
    }
}
var $da6f71b8677b901e$var$uid = 0;
function $da6f71b8677b901e$var$createReactiveEffect(fn, options) {
    var effect3 = function reactiveEffect() {
        if (!effect3.active) return fn();
        if (!$da6f71b8677b901e$var$effectStack.includes(effect3)) {
            $da6f71b8677b901e$var$cleanup(effect3);
            try {
                $da6f71b8677b901e$var$enableTracking();
                $da6f71b8677b901e$var$effectStack.push(effect3);
                $da6f71b8677b901e$var$activeEffect = effect3;
                return fn();
            } finally{
                $da6f71b8677b901e$var$effectStack.pop();
                $da6f71b8677b901e$var$resetTracking();
                $da6f71b8677b901e$var$activeEffect = $da6f71b8677b901e$var$effectStack[$da6f71b8677b901e$var$effectStack.length - 1];
            }
        }
    };
    effect3.id = $da6f71b8677b901e$var$uid++;
    effect3.allowRecurse = !!options.allowRecurse;
    effect3._isEffect = true;
    effect3.active = true;
    effect3.raw = fn;
    effect3.deps = [];
    effect3.options = options;
    return effect3;
}
function $da6f71b8677b901e$var$cleanup(effect3) {
    var deps = effect3.deps;
    if (deps.length) {
        for(var i = 0; i < deps.length; i++)deps[i].delete(effect3);
        deps.length = 0;
    }
}
var $da6f71b8677b901e$var$shouldTrack = true;
var $da6f71b8677b901e$var$trackStack = [];
function $da6f71b8677b901e$var$pauseTracking() {
    $da6f71b8677b901e$var$trackStack.push($da6f71b8677b901e$var$shouldTrack);
    $da6f71b8677b901e$var$shouldTrack = false;
}
function $da6f71b8677b901e$var$enableTracking() {
    $da6f71b8677b901e$var$trackStack.push($da6f71b8677b901e$var$shouldTrack);
    $da6f71b8677b901e$var$shouldTrack = true;
}
function $da6f71b8677b901e$var$resetTracking() {
    var last = $da6f71b8677b901e$var$trackStack.pop();
    $da6f71b8677b901e$var$shouldTrack = last === void 0 ? true : last;
}
function $da6f71b8677b901e$var$track(target, type, key) {
    if (!$da6f71b8677b901e$var$shouldTrack || $da6f71b8677b901e$var$activeEffect === void 0) return;
    var depsMap = $da6f71b8677b901e$var$targetMap.get(target);
    if (!depsMap) $da6f71b8677b901e$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    var dep = depsMap.get(key);
    if (!dep) depsMap.set(key, dep = /* @__PURE__ */ new Set());
    if (!dep.has($da6f71b8677b901e$var$activeEffect)) {
        dep.add($da6f71b8677b901e$var$activeEffect);
        $da6f71b8677b901e$var$activeEffect.deps.push(dep);
        if ($da6f71b8677b901e$var$activeEffect.options.onTrack) $da6f71b8677b901e$var$activeEffect.options.onTrack({
            effect: $da6f71b8677b901e$var$activeEffect,
            target: target,
            type: type,
            key: key
        });
    }
}
function $da6f71b8677b901e$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    var depsMap = $da6f71b8677b901e$var$targetMap.get(target);
    if (!depsMap) return;
    var effects = /* @__PURE__ */ new Set();
    var add2 = function(effectsToAdd) {
        if (effectsToAdd) effectsToAdd.forEach(function(effect3) {
            if (effect3 !== $da6f71b8677b901e$var$activeEffect || effect3.allowRecurse) effects.add(effect3);
        });
    };
    if (type === "clear") depsMap.forEach(add2);
    else if (key === "length" && $da6f71b8677b901e$var$isArray(target)) depsMap.forEach(function(dep, key2) {
        if (key2 === "length" || key2 >= newValue) add2(dep);
    });
    else {
        if (key !== void 0) add2(depsMap.get(key));
        switch(type){
            case "add":
                if (!$da6f71b8677b901e$var$isArray(target)) {
                    add2(depsMap.get($da6f71b8677b901e$var$ITERATE_KEY));
                    if ($da6f71b8677b901e$var$isMap(target)) add2(depsMap.get($da6f71b8677b901e$var$MAP_KEY_ITERATE_KEY));
                } else if ($da6f71b8677b901e$var$isIntegerKey(key)) add2(depsMap.get("length"));
                break;
            case "delete":
                if (!$da6f71b8677b901e$var$isArray(target)) {
                    add2(depsMap.get($da6f71b8677b901e$var$ITERATE_KEY));
                    if ($da6f71b8677b901e$var$isMap(target)) add2(depsMap.get($da6f71b8677b901e$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ($da6f71b8677b901e$var$isMap(target)) add2(depsMap.get($da6f71b8677b901e$var$ITERATE_KEY));
                break;
        }
    }
    var run = function(effect3) {
        if (effect3.options.onTrigger) effect3.options.onTrigger({
            effect: effect3,
            target: target,
            key: key,
            type: type,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
        if (effect3.options.scheduler) effect3.options.scheduler(effect3);
        else effect3();
    };
    effects.forEach(run);
}
var $da6f71b8677b901e$var$isNonTrackableKeys = /* @__PURE__ */ $da6f71b8677b901e$var$makeMap("__proto__,__v_isRef,__isVue");
var $da6f71b8677b901e$var$builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map(function(key) {
    return Symbol[key];
}).filter($da6f71b8677b901e$var$isSymbol));
var $da6f71b8677b901e$var$get2 = /* @__PURE__ */ $da6f71b8677b901e$var$createGetter();
var $da6f71b8677b901e$var$readonlyGet = /* @__PURE__ */ $da6f71b8677b901e$var$createGetter(true);
var $da6f71b8677b901e$var$arrayInstrumentations = /* @__PURE__ */ $da6f71b8677b901e$var$createArrayInstrumentations();
function $da6f71b8677b901e$var$createArrayInstrumentations() {
    var instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach(function(key) {
        instrumentations[key] = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _arr, _arr1;
            var arr = $da6f71b8677b901e$var$toRaw(this);
            for(var i = 0, l = this.length; i < l; i++)$da6f71b8677b901e$var$track(arr, "get", i + "");
            var res = (_arr = arr)[key].apply(_arr, (0, $4c858c0d999a5b9b$export$71511d61b312f219)(args));
            if (res === -1 || res === false) return (_arr1 = arr)[key].apply(_arr1, (0, $4c858c0d999a5b9b$export$71511d61b312f219)(args.map($da6f71b8677b901e$var$toRaw)));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach(function(key) {
        instrumentations[key] = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            $da6f71b8677b901e$var$pauseTracking();
            var res = $da6f71b8677b901e$var$toRaw(this)[key].apply(this, args);
            $da6f71b8677b901e$var$resetTracking();
            return res;
        };
    });
    return instrumentations;
}
function $da6f71b8677b901e$var$createGetter() {
    var isReadonly = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, shallow = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return function get3(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? $da6f71b8677b901e$var$shallowReadonlyMap : $da6f71b8677b901e$var$readonlyMap : shallow ? $da6f71b8677b901e$var$shallowReactiveMap : $da6f71b8677b901e$var$reactiveMap).get(target)) return target;
        var targetIsArray = $da6f71b8677b901e$var$isArray(target);
        if (!isReadonly && targetIsArray && $da6f71b8677b901e$var$hasOwn($da6f71b8677b901e$var$arrayInstrumentations, key)) return Reflect.get($da6f71b8677b901e$var$arrayInstrumentations, key, receiver);
        var res = Reflect.get(target, key, receiver);
        if ($da6f71b8677b901e$var$isSymbol(key) ? $da6f71b8677b901e$var$builtInSymbols.has(key) : $da6f71b8677b901e$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $da6f71b8677b901e$var$track(target, "get", key);
        if (shallow) return res;
        if ($da6f71b8677b901e$var$isRef(res)) {
            var shouldUnwrap = !targetIsArray || !$da6f71b8677b901e$var$isIntegerKey(key);
            return shouldUnwrap ? res.value : res;
        }
        if ($da6f71b8677b901e$var$isObject(res)) return isReadonly ? $da6f71b8677b901e$var$readonly(res) : $da6f71b8677b901e$var$reactive2(res);
        return res;
    };
}
var $da6f71b8677b901e$var$set2 = /* @__PURE__ */ $da6f71b8677b901e$var$createSetter();
function $da6f71b8677b901e$var$createSetter() {
    var shallow = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    return function set3(target, key, value, receiver) {
        var oldValue = target[key];
        if (!shallow) {
            value = $da6f71b8677b901e$var$toRaw(value);
            oldValue = $da6f71b8677b901e$var$toRaw(oldValue);
            if (!$da6f71b8677b901e$var$isArray(target) && $da6f71b8677b901e$var$isRef(oldValue) && !$da6f71b8677b901e$var$isRef(value)) {
                oldValue.value = value;
                return true;
            }
        }
        var hadKey = $da6f71b8677b901e$var$isArray(target) && $da6f71b8677b901e$var$isIntegerKey(key) ? Number(key) < target.length : $da6f71b8677b901e$var$hasOwn(target, key);
        var result = Reflect.set(target, key, value, receiver);
        if (target === $da6f71b8677b901e$var$toRaw(receiver)) {
            if (!hadKey) $da6f71b8677b901e$var$trigger(target, "add", key, value);
            else if ($da6f71b8677b901e$var$hasChanged(value, oldValue)) $da6f71b8677b901e$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $da6f71b8677b901e$var$deleteProperty(target, key) {
    var hadKey = $da6f71b8677b901e$var$hasOwn(target, key);
    var oldValue = target[key];
    var result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $da6f71b8677b901e$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $da6f71b8677b901e$var$has(target, key) {
    var result = Reflect.has(target, key);
    if (!$da6f71b8677b901e$var$isSymbol(key) || !$da6f71b8677b901e$var$builtInSymbols.has(key)) $da6f71b8677b901e$var$track(target, "has", key);
    return result;
}
function $da6f71b8677b901e$var$ownKeys(target) {
    $da6f71b8677b901e$var$track(target, "iterate", $da6f71b8677b901e$var$isArray(target) ? "length" : $da6f71b8677b901e$var$ITERATE_KEY);
    return Reflect.ownKeys(target);
}
var $da6f71b8677b901e$var$mutableHandlers = {
    get: $da6f71b8677b901e$var$get2,
    set: $da6f71b8677b901e$var$set2,
    deleteProperty: $da6f71b8677b901e$var$deleteProperty,
    has: $da6f71b8677b901e$var$has,
    ownKeys: $da6f71b8677b901e$var$ownKeys
};
var $da6f71b8677b901e$var$readonlyHandlers = {
    get: $da6f71b8677b901e$var$readonlyGet,
    set: function(target, key) {
        console.warn('Set operation on key "'.concat(String(key), '" failed: target is readonly.'), target);
        return true;
    },
    deleteProperty: function(target, key) {
        console.warn('Delete operation on key "'.concat(String(key), '" failed: target is readonly.'), target);
        return true;
    }
};
var $da6f71b8677b901e$var$toReactive = function(value) {
    return $da6f71b8677b901e$var$isObject(value) ? $da6f71b8677b901e$var$reactive2(value) : value;
};
var $da6f71b8677b901e$var$toReadonly = function(value) {
    return $da6f71b8677b901e$var$isObject(value) ? $da6f71b8677b901e$var$readonly(value) : value;
};
var $da6f71b8677b901e$var$toShallow = function(value) {
    return value;
};
var $da6f71b8677b901e$var$getProto = function(v) {
    return Reflect.getPrototypeOf(v);
};
function $da6f71b8677b901e$var$get$1(target, key) {
    var isReadonly = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, isShallow = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    target = target["__v_raw"];
    var rawTarget = $da6f71b8677b901e$var$toRaw(target);
    var rawKey = $da6f71b8677b901e$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $da6f71b8677b901e$var$track(rawTarget, "get", key);
    !isReadonly && $da6f71b8677b901e$var$track(rawTarget, "get", rawKey);
    var _getProto = $da6f71b8677b901e$var$getProto(rawTarget), has2 = _getProto.has;
    var wrap = isShallow ? $da6f71b8677b901e$var$toShallow : isReadonly ? $da6f71b8677b901e$var$toReadonly : $da6f71b8677b901e$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $da6f71b8677b901e$var$has$1(key) {
    var isReadonly = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var target = this["__v_raw"];
    var rawTarget = $da6f71b8677b901e$var$toRaw(target);
    var rawKey = $da6f71b8677b901e$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $da6f71b8677b901e$var$track(rawTarget, "has", key);
    !isReadonly && $da6f71b8677b901e$var$track(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $da6f71b8677b901e$var$size(target) {
    var isReadonly = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    target = target["__v_raw"];
    !isReadonly && $da6f71b8677b901e$var$track($da6f71b8677b901e$var$toRaw(target), "iterate", $da6f71b8677b901e$var$ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function $da6f71b8677b901e$var$add(value) {
    value = $da6f71b8677b901e$var$toRaw(value);
    var target = $da6f71b8677b901e$var$toRaw(this);
    var proto = $da6f71b8677b901e$var$getProto(target);
    var hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $da6f71b8677b901e$var$trigger(target, "add", value, value);
    }
    return this;
}
function $da6f71b8677b901e$var$set$1(key, value) {
    value = $da6f71b8677b901e$var$toRaw(value);
    var target = $da6f71b8677b901e$var$toRaw(this);
    var _getProto = $da6f71b8677b901e$var$getProto(target), has2 = _getProto.has, get3 = _getProto.get;
    var hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $da6f71b8677b901e$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $da6f71b8677b901e$var$checkIdentityKeys(target, has2, key);
    var oldValue = get3.call(target, key);
    target.set(key, value);
    if (!hadKey) $da6f71b8677b901e$var$trigger(target, "add", key, value);
    else if ($da6f71b8677b901e$var$hasChanged(value, oldValue)) $da6f71b8677b901e$var$trigger(target, "set", key, value, oldValue);
    return this;
}
function $da6f71b8677b901e$var$deleteEntry(key) {
    var target = $da6f71b8677b901e$var$toRaw(this);
    var _getProto = $da6f71b8677b901e$var$getProto(target), has2 = _getProto.has, get3 = _getProto.get;
    var hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $da6f71b8677b901e$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $da6f71b8677b901e$var$checkIdentityKeys(target, has2, key);
    var oldValue = get3 ? get3.call(target, key) : void 0;
    var result = target.delete(key);
    if (hadKey) $da6f71b8677b901e$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $da6f71b8677b901e$var$clear() {
    var target = $da6f71b8677b901e$var$toRaw(this);
    var hadItems = target.size !== 0;
    var oldTarget = $da6f71b8677b901e$var$isMap(target) ? new Map(target) : new Set(target);
    var result = target.clear();
    if (hadItems) $da6f71b8677b901e$var$trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $da6f71b8677b901e$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        var observed = this;
        var target = observed["__v_raw"];
        var rawTarget = $da6f71b8677b901e$var$toRaw(target);
        var wrap = isShallow ? $da6f71b8677b901e$var$toShallow : isReadonly ? $da6f71b8677b901e$var$toReadonly : $da6f71b8677b901e$var$toReactive;
        !isReadonly && $da6f71b8677b901e$var$track(rawTarget, "iterate", $da6f71b8677b901e$var$ITERATE_KEY);
        return target.forEach(function(value, key) {
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $da6f71b8677b901e$var$createIterableMethod(method, isReadonly, isShallow) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _target;
        var target = this["__v_raw"];
        var rawTarget = $da6f71b8677b901e$var$toRaw(target);
        var targetIsMap = $da6f71b8677b901e$var$isMap(rawTarget);
        var isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        var isKeyOnly = method === "keys" && targetIsMap;
        var innerIterator = (_target = target)[method].apply(_target, (0, $4c858c0d999a5b9b$export$71511d61b312f219)(args));
        var wrap = isShallow ? $da6f71b8677b901e$var$toShallow : isReadonly ? $da6f71b8677b901e$var$toReadonly : $da6f71b8677b901e$var$toReactive;
        !isReadonly && $da6f71b8677b901e$var$track(rawTarget, "iterate", isKeyOnly ? $da6f71b8677b901e$var$MAP_KEY_ITERATE_KEY : $da6f71b8677b901e$var$ITERATE_KEY);
        return(// iterable protocol
        (0, $ec426015f75d7738$export$71511d61b312f219)({
            // iterator protocol
            next: function() {
                var _innerIterator_next = innerIterator.next(), value = _innerIterator_next.value, done = _innerIterator_next.done;
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            }
        }, Symbol.iterator, function() {
            return this;
        }));
    };
}
function $da6f71b8677b901e$var$createReadonlyMethod(type) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        {
            var key = args[0] ? 'on key "'.concat(args[0], '" ') : "";
            console.warn("".concat($da6f71b8677b901e$var$capitalize(type), " operation ").concat(key, "failed: target is readonly."), $da6f71b8677b901e$var$toRaw(this));
        }
        return type === "delete" ? false : this;
    };
}
function $da6f71b8677b901e$var$createInstrumentations() {
    var mutableInstrumentations2 = {
        get: function(key) {
            return $da6f71b8677b901e$var$get$1(this, key);
        },
        get size () {
            return $da6f71b8677b901e$var$size(this);
        },
        has: $da6f71b8677b901e$var$has$1,
        add: $da6f71b8677b901e$var$add,
        set: $da6f71b8677b901e$var$set$1,
        delete: $da6f71b8677b901e$var$deleteEntry,
        clear: $da6f71b8677b901e$var$clear,
        forEach: $da6f71b8677b901e$var$createForEach(false, false)
    };
    var shallowInstrumentations2 = {
        get: function(key) {
            return $da6f71b8677b901e$var$get$1(this, key, false, true);
        },
        get size () {
            return $da6f71b8677b901e$var$size(this);
        },
        has: $da6f71b8677b901e$var$has$1,
        add: $da6f71b8677b901e$var$add,
        set: $da6f71b8677b901e$var$set$1,
        delete: $da6f71b8677b901e$var$deleteEntry,
        clear: $da6f71b8677b901e$var$clear,
        forEach: $da6f71b8677b901e$var$createForEach(false, true)
    };
    var readonlyInstrumentations2 = {
        get: function(key) {
            return $da6f71b8677b901e$var$get$1(this, key, true);
        },
        get size () {
            return $da6f71b8677b901e$var$size(this, true);
        },
        has: function(key) {
            return $da6f71b8677b901e$var$has$1.call(this, key, true);
        },
        add: $da6f71b8677b901e$var$createReadonlyMethod("add"),
        set: $da6f71b8677b901e$var$createReadonlyMethod("set"),
        delete: $da6f71b8677b901e$var$createReadonlyMethod("delete"),
        clear: $da6f71b8677b901e$var$createReadonlyMethod("clear"),
        forEach: $da6f71b8677b901e$var$createForEach(true, false)
    };
    var shallowReadonlyInstrumentations2 = {
        get: function(key) {
            return $da6f71b8677b901e$var$get$1(this, key, true, true);
        },
        get size () {
            return $da6f71b8677b901e$var$size(this, true);
        },
        has: function(key) {
            return $da6f71b8677b901e$var$has$1.call(this, key, true);
        },
        add: $da6f71b8677b901e$var$createReadonlyMethod("add"),
        set: $da6f71b8677b901e$var$createReadonlyMethod("set"),
        delete: $da6f71b8677b901e$var$createReadonlyMethod("delete"),
        clear: $da6f71b8677b901e$var$createReadonlyMethod("clear"),
        forEach: $da6f71b8677b901e$var$createForEach(true, true)
    };
    var iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach(function(method) {
        mutableInstrumentations2[method] = $da6f71b8677b901e$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $da6f71b8677b901e$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $da6f71b8677b901e$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $da6f71b8677b901e$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
var /* @__PURE__ */ $da6f71b8677b901e$var$_createInstrumentations = (0, $1788e2ed61915b1e$export$71511d61b312f219)($da6f71b8677b901e$var$createInstrumentations(), 4), $da6f71b8677b901e$var$mutableInstrumentations = $da6f71b8677b901e$var$_createInstrumentations[0], $da6f71b8677b901e$var$readonlyInstrumentations = $da6f71b8677b901e$var$_createInstrumentations[1], $da6f71b8677b901e$var$shallowInstrumentations = $da6f71b8677b901e$var$_createInstrumentations[2], $da6f71b8677b901e$var$shallowReadonlyInstrumentations = $da6f71b8677b901e$var$_createInstrumentations[3];
function $da6f71b8677b901e$var$createInstrumentationGetter(isReadonly, shallow) {
    var instrumentations = shallow ? isReadonly ? $da6f71b8677b901e$var$shallowReadonlyInstrumentations : $da6f71b8677b901e$var$shallowInstrumentations : isReadonly ? $da6f71b8677b901e$var$readonlyInstrumentations : $da6f71b8677b901e$var$mutableInstrumentations;
    return function(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get($da6f71b8677b901e$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $da6f71b8677b901e$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $da6f71b8677b901e$var$createInstrumentationGetter(false, false)
};
var $da6f71b8677b901e$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $da6f71b8677b901e$var$createInstrumentationGetter(true, false)
};
function $da6f71b8677b901e$var$checkIdentityKeys(target, has2, key) {
    var rawKey = $da6f71b8677b901e$var$toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        var type = $da6f71b8677b901e$var$toRawType(target);
        console.warn("Reactive ".concat(type, " contains both the raw and reactive versions of the same object").concat(type === "Map" ? " as keys" : "", ", which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible."));
    }
}
var $da6f71b8677b901e$var$reactiveMap = /* @__PURE__ */ new WeakMap();
var $da6f71b8677b901e$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var $da6f71b8677b901e$var$readonlyMap = /* @__PURE__ */ new WeakMap();
var $da6f71b8677b901e$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $da6f71b8677b901e$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $da6f71b8677b901e$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : $da6f71b8677b901e$var$targetTypeMap($da6f71b8677b901e$var$toRawType(value));
}
function $da6f71b8677b901e$var$reactive2(target) {
    if (target && target["__v_isReadonly"]) return target;
    return $da6f71b8677b901e$var$createReactiveObject(target, false, $da6f71b8677b901e$var$mutableHandlers, $da6f71b8677b901e$var$mutableCollectionHandlers, $da6f71b8677b901e$var$reactiveMap);
}
function $da6f71b8677b901e$var$readonly(target) {
    return $da6f71b8677b901e$var$createReactiveObject(target, true, $da6f71b8677b901e$var$readonlyHandlers, $da6f71b8677b901e$var$readonlyCollectionHandlers, $da6f71b8677b901e$var$readonlyMap);
}
function $da6f71b8677b901e$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!$da6f71b8677b901e$var$isObject(target)) {
        console.warn("value cannot be made reactive: ".concat(String(target)));
        return target;
    }
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) return target;
    var existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    var targetType = $da6f71b8677b901e$var$getTargetType(target);
    if (targetType === 0) return target;
    var proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $da6f71b8677b901e$var$toRaw(observed) {
    return observed && $da6f71b8677b901e$var$toRaw(observed["__v_raw"]) || observed;
}
function $da6f71b8677b901e$var$isRef(r) {
    return Boolean(r && r.__v_isRef === true);
}
// packages/alpinejs/src/magics/$nextTick.js
$da6f71b8677b901e$var$magic("nextTick", function() {
    return $da6f71b8677b901e$var$nextTick;
});
// packages/alpinejs/src/magics/$dispatch.js
$da6f71b8677b901e$var$magic("dispatch", function(el) {
    return $da6f71b8677b901e$var$dispatch.bind($da6f71b8677b901e$var$dispatch, el);
});
// packages/alpinejs/src/magics/$watch.js
$da6f71b8677b901e$var$magic("watch", function(el, param) {
    var evaluateLater2 = param.evaluateLater, cleanup2 = param.cleanup;
    return function(key, callback) {
        var evaluate2 = evaluateLater2(key);
        var getter = function() {
            var value;
            evaluate2(function(i) {
                return value = i;
            });
            return value;
        };
        var unwatch = $da6f71b8677b901e$var$watch(getter, callback);
        cleanup2(unwatch);
    };
});
// packages/alpinejs/src/magics/$store.js
$da6f71b8677b901e$var$magic("store", $da6f71b8677b901e$var$getStores);
// packages/alpinejs/src/magics/$data.js
$da6f71b8677b901e$var$magic("data", function(el) {
    return $da6f71b8677b901e$var$scope(el);
});
// packages/alpinejs/src/magics/$root.js
$da6f71b8677b901e$var$magic("root", function(el) {
    return $da6f71b8677b901e$var$closestRoot(el);
});
// packages/alpinejs/src/magics/$refs.js
$da6f71b8677b901e$var$magic("refs", function(el) {
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $da6f71b8677b901e$var$mergeProxies($da6f71b8677b901e$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $da6f71b8677b901e$var$getArrayOfRefObject(el) {
    var refObjects = [];
    $da6f71b8677b901e$var$findClosest(el, function(i) {
        if (i._x_refs) refObjects.push(i._x_refs);
    });
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $da6f71b8677b901e$var$globalIdMemo = {};
function $da6f71b8677b901e$var$findAndIncrementId(name) {
    if (!$da6f71b8677b901e$var$globalIdMemo[name]) $da6f71b8677b901e$var$globalIdMemo[name] = 0;
    return ++$da6f71b8677b901e$var$globalIdMemo[name];
}
function $da6f71b8677b901e$var$closestIdRoot(el, name) {
    return $da6f71b8677b901e$var$findClosest(el, function(element) {
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $da6f71b8677b901e$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $da6f71b8677b901e$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$da6f71b8677b901e$var$magic("id", function(el, param) {
    var cleanup2 = param.cleanup;
    return function(name) {
        var key = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        var cacheKey = "".concat(name).concat(key ? "-".concat(key) : "");
        return $da6f71b8677b901e$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, function() {
            var root = $da6f71b8677b901e$var$closestIdRoot(el, name);
            var id = root ? root._x_ids[name] : $da6f71b8677b901e$var$findAndIncrementId(name);
            return key ? "".concat(name, "-").concat(id, "-").concat(key) : "".concat(name, "-").concat(id);
        });
    };
});
$da6f71b8677b901e$var$interceptClone(function(from, to) {
    if (from._x_id) to._x_id = from._x_id;
});
function $da6f71b8677b901e$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, callback) {
    if (!el._x_id) el._x_id = {};
    if (el._x_id[cacheKey]) return el._x_id[cacheKey];
    var output = callback();
    el._x_id[cacheKey] = output;
    cleanup2(function() {
        delete el._x_id[cacheKey];
    });
    return output;
}
// packages/alpinejs/src/magics/$el.js
$da6f71b8677b901e$var$magic("el", function(el) {
    return el;
});
// packages/alpinejs/src/magics/index.js
$da6f71b8677b901e$var$warnMissingPluginMagic("Focus", "focus", "focus");
$da6f71b8677b901e$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $da6f71b8677b901e$var$warnMissingPluginMagic(name, magicName, slug) {
    $da6f71b8677b901e$var$magic(magicName, function(el) {
        return $da6f71b8677b901e$var$warn("You can't use [$".concat(magicName, '] without first installing the "').concat(name, '" plugin here: https://alpinejs.dev/plugins/').concat(slug), el);
    });
}
// packages/alpinejs/src/directives/x-modelable.js
$da6f71b8677b901e$var$directive("modelable", function(el, param, param1) {
    var expression = param.expression, effect3 = param1.effect, evaluateLater2 = param1.evaluateLater, cleanup2 = param1.cleanup;
    var func = evaluateLater2(expression);
    var innerGet = function() {
        var result;
        func(function(i) {
            return result = i;
        });
        return result;
    };
    var evaluateInnerSet = evaluateLater2("".concat(expression, " = __placeholder"));
    var innerSet = function(val) {
        return evaluateInnerSet(function() {}, {
            scope: {
                "__placeholder": val
            }
        });
    };
    var initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(function() {
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        var outerGet = el._x_model.get;
        var outerSet = el._x_model.set;
        var releaseEntanglement = $da6f71b8677b901e$var$entangle({
            get: function() {
                return outerGet();
            },
            set: function(value) {
                outerSet(value);
            }
        }, {
            get: function() {
                return innerGet();
            },
            set: function(value) {
                innerSet(value);
            }
        });
        cleanup2(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
$da6f71b8677b901e$var$directive("teleport", function(el, param, param1) {
    var modifiers = param.modifiers, expression = param.expression, cleanup2 = param1.cleanup;
    if (el.tagName.toLowerCase() !== "template") $da6f71b8677b901e$var$warn("x-teleport can only be used on a <template> tag", el);
    var target = $da6f71b8677b901e$var$getTarget(expression);
    var clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    el.setAttribute("data-teleport-template", true);
    clone2.setAttribute("data-teleport-target", true);
    if (el._x_forwardEvents) el._x_forwardEvents.forEach(function(eventName) {
        clone2.addEventListener(eventName, function(e) {
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $da6f71b8677b901e$var$addScopeToNode(clone2, {}, el);
    var placeInDom = function(clone3, target2, modifiers2) {
        if (modifiers2.includes("prepend")) target2.parentNode.insertBefore(clone3, target2);
        else if (modifiers2.includes("append")) target2.parentNode.insertBefore(clone3, target2.nextSibling);
        else target2.appendChild(clone3);
    };
    $da6f71b8677b901e$var$mutateDom(function() {
        placeInDom(clone2, target, modifiers);
        $da6f71b8677b901e$var$skipDuringClone(function() {
            $da6f71b8677b901e$var$initTree(clone2);
        })();
    });
    el._x_teleportPutBack = function() {
        var target2 = $da6f71b8677b901e$var$getTarget(expression);
        $da6f71b8677b901e$var$mutateDom(function() {
            placeInDom(el._x_teleport, target2, modifiers);
        });
    };
    cleanup2(function() {
        return $da6f71b8677b901e$var$mutateDom(function() {
            clone2.remove();
            $da6f71b8677b901e$var$destroyTree(clone2);
        });
    });
});
var $da6f71b8677b901e$var$teleportContainerDuringClone = document.createElement("div");
function $da6f71b8677b901e$var$getTarget(expression) {
    var target = $da6f71b8677b901e$var$skipDuringClone(function() {
        return document.querySelector(expression);
    }, function() {
        return $da6f71b8677b901e$var$teleportContainerDuringClone;
    })();
    if (!target) $da6f71b8677b901e$var$warn('Cannot find x-teleport element for selector: "'.concat(expression, '"'));
    return target;
}
// packages/alpinejs/src/directives/x-ignore.js
var $da6f71b8677b901e$var$handler = function() {};
$da6f71b8677b901e$var$handler.inline = function(el, param, param1) {
    var modifiers = param.modifiers, cleanup2 = param1.cleanup;
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(function() {
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$da6f71b8677b901e$var$directive("ignore", $da6f71b8677b901e$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$da6f71b8677b901e$var$directive("effect", $da6f71b8677b901e$var$skipDuringClone(function(el, param, param1) {
    var expression = param.expression, effect3 = param1.effect;
    effect3($da6f71b8677b901e$var$evaluateLater(el, expression));
}));
// packages/alpinejs/src/utils/on.js
function $da6f71b8677b901e$var$on(el, event, modifiers, callback) {
    var listenerTarget = el;
    var handler4 = function(e) {
        return callback(e);
    };
    var options = {};
    var wrapHandler = function(callback2, wrapper) {
        return function(e) {
            return wrapper(callback2, e);
        };
    };
    if (modifiers.includes("dot")) event = $da6f71b8677b901e$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $da6f71b8677b901e$var$camelCase2(event);
    if (modifiers.includes("passive")) options.passive = true;
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("debounce")) {
        var nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        var wait = $da6f71b8677b901e$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $da6f71b8677b901e$var$debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
        var nextModifier1 = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        var wait1 = $da6f71b8677b901e$var$isNumeric(nextModifier1.split("ms")[0]) ? Number(nextModifier1.split("ms")[0]) : 250;
        handler4 = $da6f71b8677b901e$var$throttle(handler4, wait1);
    }
    if (modifiers.includes("prevent")) handler4 = wrapHandler(handler4, function(next, e) {
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler4 = wrapHandler(handler4, function(next, e) {
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("once")) handler4 = wrapHandler(handler4, function(next, e) {
        next(e);
        listenerTarget.removeEventListener(event, handler4, options);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler4 = wrapHandler(handler4, function(next, e) {
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("self")) handler4 = wrapHandler(handler4, function(next, e) {
        e.target === el && next(e);
    });
    if ($da6f71b8677b901e$var$isKeyEvent(event) || $da6f71b8677b901e$var$isClickEvent(event)) handler4 = wrapHandler(handler4, function(next, e) {
        if ($da6f71b8677b901e$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        next(e);
    });
    listenerTarget.addEventListener(event, handler4, options);
    return function() {
        listenerTarget.removeEventListener(event, handler4, options);
    };
}
function $da6f71b8677b901e$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $da6f71b8677b901e$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, function(match, char) {
        return char.toUpperCase();
    });
}
function $da6f71b8677b901e$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $da6f71b8677b901e$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $da6f71b8677b901e$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $da6f71b8677b901e$var$isClickEvent(event) {
    return [
        "contextmenu",
        "click",
        "mouse"
    ].some(function(i) {
        return event.includes(i);
    });
}
function $da6f71b8677b901e$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    var keyModifiers = modifiers.filter(function(i) {
        return ![
            "window",
            "document",
            "prevent",
            "stop",
            "once",
            "capture",
            "self",
            "away",
            "outside",
            "passive",
            "preserve-scroll"
        ].includes(i);
    });
    if (keyModifiers.includes("debounce")) {
        var debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $da6f71b8677b901e$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        var debounceIndex1 = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex1, $da6f71b8677b901e$var$isNumeric((keyModifiers[debounceIndex1 + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $da6f71b8677b901e$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    var systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    var selectedSystemKeyModifiers = systemKeyModifiers.filter(function(modifier) {
        return keyModifiers.includes(modifier);
    });
    keyModifiers = keyModifiers.filter(function(i) {
        return !selectedSystemKeyModifiers.includes(i);
    });
    if (selectedSystemKeyModifiers.length > 0) {
        var activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter(function(modifier) {
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e["".concat(modifier, "Key")];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($da6f71b8677b901e$var$isClickEvent(e.type)) return false;
            if ($da6f71b8677b901e$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $da6f71b8677b901e$var$keyToModifiers(key) {
    if (!key) return [];
    key = $da6f71b8677b901e$var$kebabCase2(key);
    var modifierToKeyMap = {
        "ctrl": "control",
        "slash": "/",
        "space": " ",
        "spacebar": " ",
        "cmd": "meta",
        "esc": "escape",
        "up": "arrow-up",
        "down": "arrow-down",
        "left": "arrow-left",
        "right": "arrow-right",
        "period": ".",
        "comma": ",",
        "equal": "=",
        "minus": "-",
        "underscore": "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map(function(modifier) {
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter(function(modifier) {
        return modifier;
    });
}
// packages/alpinejs/src/directives/x-model.js
$da6f71b8677b901e$var$directive("model", function(el, param, param1) {
    var modifiers = param.modifiers, expression = param.expression, effect3 = param1.effect, cleanup2 = param1.cleanup;
    var scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = el.parentNode;
    var evaluateGet = $da6f71b8677b901e$var$evaluateLater(scopeTarget, expression);
    var evaluateSet;
    if (typeof expression === "string") evaluateSet = $da6f71b8677b901e$var$evaluateLater(scopeTarget, "".concat(expression, " = __placeholder"));
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $da6f71b8677b901e$var$evaluateLater(scopeTarget, "".concat(expression(), " = __placeholder"));
    else evaluateSet = function() {};
    var getValue = function() {
        var result;
        evaluateGet(function(value) {
            return result = value;
        });
        return $da6f71b8677b901e$var$isGetterSetter(result) ? result.get() : result;
    };
    var setValue = function(value) {
        var result;
        evaluateGet(function(value2) {
            return result = value2;
        });
        if ($da6f71b8677b901e$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(function() {}, {
            scope: {
                "__placeholder": value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $da6f71b8677b901e$var$mutateDom(function() {
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    var event = el.tagName.toLowerCase() === "select" || [
        "checkbox",
        "radio"
    ].includes(el.type) || modifiers.includes("lazy") ? "change" : "input";
    var removeListener = $da6f71b8677b901e$var$isCloning ? function() {} : $da6f71b8677b901e$var$on(el, event, modifiers, function(e) {
        setValue($da6f71b8677b901e$var$getInputValue(el, modifiers, e, getValue()));
    });
    if (modifiers.includes("fill")) {
        if ([
            void 0,
            null,
            ""
        ].includes(getValue()) || $da6f71b8677b901e$var$isCheckbox(el) && Array.isArray(getValue()) || el.tagName.toLowerCase() === "select" && el.multiple) setValue($da6f71b8677b901e$var$getInputValue(el, modifiers, {
            target: el
        }, getValue()));
    }
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(function() {
        return el._x_removeModelListeners["default"]();
    });
    if (el.form) {
        var removeResetListener = $da6f71b8677b901e$var$on(el.form, "reset", [], function(e) {
            $da6f71b8677b901e$var$nextTick(function() {
                return el._x_model && el._x_model.set($da6f71b8677b901e$var$getInputValue(el, modifiers, {
                    target: el
                }, getValue()));
            });
        });
        cleanup2(function() {
            return removeResetListener();
        });
    }
    el._x_model = {
        get: function() {
            return getValue();
        },
        set: function(value) {
            setValue(value);
        }
    };
    el._x_forceModelUpdate = function(value) {
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        window.fromModel = true;
        $da6f71b8677b901e$var$mutateDom(function() {
            return $da6f71b8677b901e$var$bind(el, "value", value);
        });
        delete window.fromModel;
    };
    effect3(function() {
        var value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $da6f71b8677b901e$var$getInputValue(el, modifiers, event, currentValue) {
    return $da6f71b8677b901e$var$mutateDom(function() {
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail !== null && event.detail !== void 0 ? event.detail : event.target.value;
        else if ($da6f71b8677b901e$var$isCheckbox(el)) {
            if (Array.isArray(currentValue)) {
                var newValue = null;
                if (modifiers.includes("number")) newValue = $da6f71b8677b901e$var$safeParseNumber(event.target.value);
                else if (modifiers.includes("boolean")) newValue = $da6f71b8677b901e$var$safeParseBoolean(event.target.value);
                else newValue = event.target.value;
                return event.target.checked ? currentValue.includes(newValue) ? currentValue : currentValue.concat([
                    newValue
                ]) : currentValue.filter(function(el2) {
                    return !$da6f71b8677b901e$var$checkedAttrLooseCompare2(el2, newValue);
                });
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
            if (modifiers.includes("number")) return Array.from(event.target.selectedOptions).map(function(option) {
                var rawValue = option.value || option.text;
                return $da6f71b8677b901e$var$safeParseNumber(rawValue);
            });
            else if (modifiers.includes("boolean")) return Array.from(event.target.selectedOptions).map(function(option) {
                var rawValue = option.value || option.text;
                return $da6f71b8677b901e$var$safeParseBoolean(rawValue);
            });
            return Array.from(event.target.selectedOptions).map(function(option) {
                return option.value || option.text;
            });
        } else {
            var newValue1;
            if ($da6f71b8677b901e$var$isRadio(el)) {
                if (event.target.checked) newValue1 = event.target.value;
                else newValue1 = currentValue;
            } else newValue1 = event.target.value;
            if (modifiers.includes("number")) return $da6f71b8677b901e$var$safeParseNumber(newValue1);
            else if (modifiers.includes("boolean")) return $da6f71b8677b901e$var$safeParseBoolean(newValue1);
            else if (modifiers.includes("trim")) return newValue1.trim();
            else return newValue1;
        }
    });
}
function $da6f71b8677b901e$var$safeParseNumber(rawValue) {
    var number = rawValue ? parseFloat(rawValue) : null;
    return $da6f71b8677b901e$var$isNumeric2(number) ? number : rawValue;
}
function $da6f71b8677b901e$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $da6f71b8677b901e$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $da6f71b8677b901e$var$isGetterSetter(value) {
    return value !== null && (typeof value === "undefined" ? "undefined" : (0, $1968e3edfc5cfc11$export$71511d61b312f219)(value)) === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$da6f71b8677b901e$var$directive("cloak", function(el) {
    return queueMicrotask(function() {
        return $da6f71b8677b901e$var$mutateDom(function() {
            return el.removeAttribute($da6f71b8677b901e$var$prefix("cloak"));
        });
    });
});
// packages/alpinejs/src/directives/x-init.js
$da6f71b8677b901e$var$addInitSelector(function() {
    return "[".concat($da6f71b8677b901e$var$prefix("init"), "]");
});
$da6f71b8677b901e$var$directive("init", $da6f71b8677b901e$var$skipDuringClone(function(el, param, param1) {
    var expression = param.expression, evaluate2 = param1.evaluate;
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$da6f71b8677b901e$var$directive("text", function(el, param, param1) {
    var expression = param.expression, effect3 = param1.effect, evaluateLater2 = param1.evaluateLater;
    var evaluate2 = evaluateLater2(expression);
    effect3(function() {
        evaluate2(function(value) {
            $da6f71b8677b901e$var$mutateDom(function() {
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$da6f71b8677b901e$var$directive("html", function(el, param, param1) {
    var expression = param.expression, effect3 = param1.effect, evaluateLater2 = param1.evaluateLater;
    var evaluate2 = evaluateLater2(expression);
    effect3(function() {
        evaluate2(function(value) {
            $da6f71b8677b901e$var$mutateDom(function() {
                el.innerHTML = value;
                el._x_ignoreSelf = true;
                $da6f71b8677b901e$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-bind.js
$da6f71b8677b901e$var$mapAttributes($da6f71b8677b901e$var$startingWith(":", $da6f71b8677b901e$var$into($da6f71b8677b901e$var$prefix("bind:"))));
var $da6f71b8677b901e$var$handler2 = function(el, param, param1) {
    var value = param.value, modifiers = param.modifiers, expression = param.expression, original = param.original, effect3 = param1.effect, cleanup2 = param1.cleanup;
    if (!value) {
        var bindingProviders = {};
        $da6f71b8677b901e$var$injectBindingProviders(bindingProviders);
        var getBindings = $da6f71b8677b901e$var$evaluateLater(el, expression);
        getBindings(function(bindings) {
            $da6f71b8677b901e$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $da6f71b8677b901e$var$storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) return;
    var evaluate2 = $da6f71b8677b901e$var$evaluateLater(el, expression);
    effect3(function() {
        return evaluate2(function(result) {
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $da6f71b8677b901e$var$mutateDom(function() {
                return $da6f71b8677b901e$var$bind(el, value, result, modifiers);
            });
        });
    });
    cleanup2(function() {
        el._x_undoAddedClasses && el._x_undoAddedClasses();
        el._x_undoAddedStyles && el._x_undoAddedStyles();
    });
};
$da6f71b8677b901e$var$handler2.inline = function(el, param) {
    var value = param.value, modifiers = param.modifiers, expression = param.expression;
    if (!value) return;
    if (!el._x_inlineBindings) el._x_inlineBindings = {};
    el._x_inlineBindings[value] = {
        expression: expression,
        extract: false
    };
};
$da6f71b8677b901e$var$directive("bind", $da6f71b8677b901e$var$handler2);
function $da6f71b8677b901e$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$da6f71b8677b901e$var$addRootSelector(function() {
    return "[".concat($da6f71b8677b901e$var$prefix("data"), "]");
});
$da6f71b8677b901e$var$directive("data", function(el, param, param1) {
    var expression = param.expression, cleanup2 = param1.cleanup;
    if ($da6f71b8677b901e$var$shouldSkipRegisteringDataDuringClone(el)) return;
    expression = expression === "" ? "{}" : expression;
    var magicContext = {};
    $da6f71b8677b901e$var$injectMagics(magicContext, el);
    var dataProviderContext = {};
    $da6f71b8677b901e$var$injectDataProviders(dataProviderContext, magicContext);
    var data2 = $da6f71b8677b901e$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $da6f71b8677b901e$var$injectMagics(data2, el);
    var reactiveData = $da6f71b8677b901e$var$reactive(data2);
    $da6f71b8677b901e$var$initInterceptors(reactiveData);
    var undo = $da6f71b8677b901e$var$addScopeToNode(el, reactiveData);
    reactiveData["init"] && $da6f71b8677b901e$var$evaluate(el, reactiveData["init"]);
    cleanup2(function() {
        reactiveData["destroy"] && $da6f71b8677b901e$var$evaluate(el, reactiveData["destroy"]);
        undo();
    });
});
$da6f71b8677b901e$var$interceptClone(function(from, to) {
    if (from._x_dataStack) {
        to._x_dataStack = from._x_dataStack;
        to.setAttribute("data-has-alpine-state", true);
    }
});
function $da6f71b8677b901e$var$shouldSkipRegisteringDataDuringClone(el) {
    if (!$da6f71b8677b901e$var$isCloning) return false;
    if ($da6f71b8677b901e$var$isCloningLegacy) return true;
    return el.hasAttribute("data-has-alpine-state");
}
// packages/alpinejs/src/directives/x-show.js
$da6f71b8677b901e$var$directive("show", function(el, param, param1) {
    var modifiers = param.modifiers, expression = param.expression, effect3 = param1.effect;
    var evaluate2 = $da6f71b8677b901e$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = function() {
        $da6f71b8677b901e$var$mutateDom(function() {
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = function() {
        $da6f71b8677b901e$var$mutateDom(function() {
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    var hide = function() {
        el._x_doHide();
        el._x_isShown = false;
    };
    var show = function() {
        el._x_doShow();
        el._x_isShown = true;
    };
    var clickAwayCompatibleShow = function() {
        return setTimeout(show);
    };
    var toggle = $da6f71b8677b901e$var$once(function(value) {
        return value ? show() : hide();
    }, function(value) {
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    var oldValue;
    var firstTime = true;
    effect3(function() {
        return evaluate2(function(value) {
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        });
    });
});
// packages/alpinejs/src/directives/x-for.js
$da6f71b8677b901e$var$directive("for", function(el, param, param1) {
    var expression = param.expression, effect3 = param1.effect, cleanup2 = param1.cleanup;
    var iteratorNames = $da6f71b8677b901e$var$parseForExpression(expression);
    var evaluateItems = $da6f71b8677b901e$var$evaluateLater(el, iteratorNames.items);
    var evaluateKey = $da6f71b8677b901e$var$evaluateLater(el, // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index");
    el._x_prevKeys = [];
    el._x_lookup = {};
    effect3(function() {
        return $da6f71b8677b901e$var$loop(el, iteratorNames, evaluateItems, evaluateKey);
    });
    cleanup2(function() {
        Object.values(el._x_lookup).forEach(function(el2) {
            return $da6f71b8677b901e$var$mutateDom(function() {
                $da6f71b8677b901e$var$destroyTree(el2);
                el2.remove();
            });
        });
        delete el._x_prevKeys;
        delete el._x_lookup;
    });
});
function $da6f71b8677b901e$var$loop(el, iteratorNames, evaluateItems, evaluateKey) {
    var isObject2 = function(i) {
        return (typeof i === "undefined" ? "undefined" : (0, $1968e3edfc5cfc11$export$71511d61b312f219)(i)) === "object" && !Array.isArray(i);
    };
    var templateEl = el;
    evaluateItems(function(items) {
        var _loop = function(i3) {
            var key = removes[i3];
            if (!(key in lookup)) return "continue";
            $da6f71b8677b901e$var$mutateDom(function() {
                $da6f71b8677b901e$var$destroyTree(lookup[key]);
                lookup[key].remove();
            });
            delete lookup[key];
        }, _loop1 = function(i4) {
            var _moves_i = (0, $1788e2ed61915b1e$export$71511d61b312f219)(moves[i4], 2), keyInSpot = _moves_i[0], keyForSpot = _moves_i[1];
            var elInSpot = lookup[keyInSpot];
            var elForSpot = lookup[keyForSpot];
            var marker = document.createElement("div");
            $da6f71b8677b901e$var$mutateDom(function() {
                if (!elForSpot) $da6f71b8677b901e$var$warn('x-for ":key" is undefined or invalid', templateEl, keyForSpot, lookup);
                elForSpot.after(marker);
                elInSpot.after(elForSpot);
                elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
                marker.before(elInSpot);
                elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
                marker.remove();
            });
            elForSpot._x_refreshXForScope(scopes[keys.indexOf(keyForSpot)]);
        }, _loop2 = function(i5) {
            var _adds_i = (0, $1788e2ed61915b1e$export$71511d61b312f219)(adds[i5], 2), lastKey2 = _adds_i[0], index = _adds_i[1];
            var lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
            if (lastEl._x_currentIfEl) lastEl = lastEl._x_currentIfEl;
            var scope2 = scopes[index];
            var key = keys[index];
            var clone2 = document.importNode(templateEl.content, true).firstElementChild;
            var reactiveScope = $da6f71b8677b901e$var$reactive(scope2);
            $da6f71b8677b901e$var$addScopeToNode(clone2, reactiveScope, templateEl);
            clone2._x_refreshXForScope = function(newScope) {
                Object.entries(newScope).forEach(function(param) {
                    var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), key2 = _param[0], value = _param[1];
                    reactiveScope[key2] = value;
                });
            };
            $da6f71b8677b901e$var$mutateDom(function() {
                lastEl.after(clone2);
                $da6f71b8677b901e$var$skipDuringClone(function() {
                    return $da6f71b8677b901e$var$initTree(clone2);
                })();
            });
            if ((typeof key === "undefined" ? "undefined" : (0, $1968e3edfc5cfc11$export$71511d61b312f219)(key)) === "object") $da6f71b8677b901e$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
            lookup[key] = clone2;
        };
        if ($da6f71b8677b901e$var$isNumeric3(items) && items >= 0) items = Array.from(Array(items).keys(), function(i) {
            return i + 1;
        });
        if (items === void 0) items = [];
        var lookup = el._x_lookup;
        var prevKeys = el._x_prevKeys;
        var scopes = [];
        var keys = [];
        if (isObject2(items)) items = Object.entries(items).map(function(param) {
            var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), key = _param[0], value = _param[1];
            var scope2 = $da6f71b8677b901e$var$getIterationScopeVariables(iteratorNames, value, key, items);
            evaluateKey(function(value2) {
                if (keys.includes(value2)) $da6f71b8677b901e$var$warn("Duplicate key on x-for", el);
                keys.push(value2);
            }, {
                scope: (0, $fa9769297b8a68c8$export$71511d61b312f219)({
                    index: key
                }, scope2)
            });
            scopes.push(scope2);
        });
        else for(var i = 0; i < items.length; i++){
            var scope2 = $da6f71b8677b901e$var$getIterationScopeVariables(iteratorNames, items[i], i, items);
            evaluateKey(function(value) {
                if (keys.includes(value)) $da6f71b8677b901e$var$warn("Duplicate key on x-for", el);
                keys.push(value);
            }, {
                scope: (0, $fa9769297b8a68c8$export$71511d61b312f219)({
                    index: i
                }, scope2)
            });
            scopes.push(scope2);
        }
        var adds = [];
        var moves = [];
        var removes = [];
        var sames = [];
        for(var i1 = 0; i1 < prevKeys.length; i1++){
            var key = prevKeys[i1];
            if (keys.indexOf(key) === -1) removes.push(key);
        }
        prevKeys = prevKeys.filter(function(key) {
            return !removes.includes(key);
        });
        var lastKey = "template";
        for(var i2 = 0; i2 < keys.length; i2++){
            var key1 = keys[i2];
            var prevIndex = prevKeys.indexOf(key1);
            if (prevIndex === -1) {
                prevKeys.splice(i2, 0, key1);
                adds.push([
                    lastKey,
                    i2
                ]);
            } else if (prevIndex !== i2) {
                var keyInSpot = prevKeys.splice(i2, 1)[0];
                var keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
                prevKeys.splice(i2, 0, keyForSpot);
                prevKeys.splice(prevIndex, 0, keyInSpot);
                moves.push([
                    keyInSpot,
                    keyForSpot
                ]);
            } else sames.push(key1);
            lastKey = key1;
        }
        for(var i3 = 0; i3 < removes.length; i3++)_loop(i3);
        for(var i4 = 0; i4 < moves.length; i4++)_loop1(i4);
        for(var i5 = 0; i5 < adds.length; i5++)_loop2(i5);
        for(var i6 = 0; i6 < sames.length; i6++)lookup[sames[i6]]._x_refreshXForScope(scopes[keys.indexOf(sames[i6])]);
        templateEl._x_prevKeys = keys;
    });
}
function $da6f71b8677b901e$var$parseForExpression(expression) {
    var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    var stripParensRE = /^\s*\(|\)\s*$/g;
    var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    var inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    var res = {};
    res.items = inMatch[2].trim();
    var item = inMatch[1].replace(stripParensRE, "").trim();
    var iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $da6f71b8677b901e$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    var scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        var names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map(function(i) {
            return i.trim();
        });
        names.forEach(function(name, i) {
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && (typeof item === "undefined" ? "undefined" : (0, $1968e3edfc5cfc11$export$71511d61b312f219)(item)) === "object") {
        var names1 = iteratorNames.item.replace("{", "").replace("}", "").split(",").map(function(i) {
            return i.trim();
        });
        names1.forEach(function(name) {
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $da6f71b8677b901e$var$isNumeric3(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $da6f71b8677b901e$var$handler3() {}
$da6f71b8677b901e$var$handler3.inline = function(el, param, param1) {
    var expression = param.expression, cleanup2 = param1.cleanup;
    var root = $da6f71b8677b901e$var$closestRoot(el);
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(function() {
        return delete root._x_refs[expression];
    });
};
$da6f71b8677b901e$var$directive("ref", $da6f71b8677b901e$var$handler3);
// packages/alpinejs/src/directives/x-if.js
$da6f71b8677b901e$var$directive("if", function(el, param, param1) {
    var expression = param.expression, effect3 = param1.effect, cleanup2 = param1.cleanup;
    if (el.tagName.toLowerCase() !== "template") $da6f71b8677b901e$var$warn("x-if can only be used on a <template> tag", el);
    var evaluate2 = $da6f71b8677b901e$var$evaluateLater(el, expression);
    var show = function() {
        if (el._x_currentIfEl) return el._x_currentIfEl;
        var clone2 = el.content.cloneNode(true).firstElementChild;
        $da6f71b8677b901e$var$addScopeToNode(clone2, {}, el);
        $da6f71b8677b901e$var$mutateDom(function() {
            el.after(clone2);
            $da6f71b8677b901e$var$skipDuringClone(function() {
                return $da6f71b8677b901e$var$initTree(clone2);
            })();
        });
        el._x_currentIfEl = clone2;
        el._x_undoIf = function() {
            $da6f71b8677b901e$var$mutateDom(function() {
                $da6f71b8677b901e$var$destroyTree(clone2);
                clone2.remove();
            });
            delete el._x_currentIfEl;
        };
        return clone2;
    };
    var hide = function() {
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(function() {
        return evaluate2(function(value) {
            value ? show() : hide();
        });
    });
    cleanup2(function() {
        return el._x_undoIf && el._x_undoIf();
    });
});
// packages/alpinejs/src/directives/x-id.js
$da6f71b8677b901e$var$directive("id", function(el, param, param1) {
    var expression = param.expression, evaluate2 = param1.evaluate;
    var names = evaluate2(expression);
    names.forEach(function(name) {
        return $da6f71b8677b901e$var$setIdRoot(el, name);
    });
});
$da6f71b8677b901e$var$interceptClone(function(from, to) {
    if (from._x_ids) to._x_ids = from._x_ids;
});
// packages/alpinejs/src/directives/x-on.js
$da6f71b8677b901e$var$mapAttributes($da6f71b8677b901e$var$startingWith("@", $da6f71b8677b901e$var$into($da6f71b8677b901e$var$prefix("on:"))));
$da6f71b8677b901e$var$directive("on", $da6f71b8677b901e$var$skipDuringClone(function(el, param, param1) {
    var value = param.value, modifiers = param.modifiers, expression = param.expression, cleanup2 = param1.cleanup;
    var evaluate2 = expression ? $da6f71b8677b901e$var$evaluateLater(el, expression) : function() {};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    var removeListener = $da6f71b8677b901e$var$on(el, value, modifiers, function(e) {
        evaluate2(function() {}, {
            scope: {
                "$event": e
            },
            params: [
                e
            ]
        });
    });
    cleanup2(function() {
        return removeListener();
    });
}));
// packages/alpinejs/src/directives/index.js
$da6f71b8677b901e$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$da6f71b8677b901e$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$da6f71b8677b901e$var$warnMissingPluginDirective("Focus", "trap", "focus");
$da6f71b8677b901e$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $da6f71b8677b901e$var$warnMissingPluginDirective(name, directiveName, slug) {
    $da6f71b8677b901e$var$directive(directiveName, function(el) {
        return $da6f71b8677b901e$var$warn("You can't use [x-".concat(directiveName, '] without first installing the "').concat(name, '" plugin here: https://alpinejs.dev/plugins/').concat(slug), el);
    });
}
// packages/alpinejs/src/index.js
$da6f71b8677b901e$var$alpine_default.setEvaluator($da6f71b8677b901e$var$normalEvaluator);
$da6f71b8677b901e$var$alpine_default.setReactivityEngine({
    reactive: $da6f71b8677b901e$var$reactive2,
    effect: $da6f71b8677b901e$var$effect2,
    release: $da6f71b8677b901e$var$stop,
    raw: $da6f71b8677b901e$var$toRaw
});
var $da6f71b8677b901e$export$b7ee041e4ad2afec = $da6f71b8677b901e$var$alpine_default;
// packages/alpinejs/builds/module.js
var $da6f71b8677b901e$export$2e2bcd8739ae039 = $da6f71b8677b901e$export$b7ee041e4ad2afec;


var $979b99378be707cd$exports = {};

$parcel$export($979b99378be707cd$exports, "blackoutContracts", function () { return $979b99378be707cd$export$5099ca2cdc0f385a; });
$parcel$export($979b99378be707cd$exports, "collapseKeys", function () { return $979b99378be707cd$export$2da4db3f6fd1335b; });
$parcel$export($979b99378be707cd$exports, "commandUpgrades", function () { return $979b99378be707cd$export$617b3a0bcd7cead7; });
$parcel$export($979b99378be707cd$exports, "eventDefinitionsDominion", function () { return $979b99378be707cd$export$f152896064e09913; });
$parcel$export($979b99378be707cd$exports, "eventDefinitionsVeil", function () { return $979b99378be707cd$export$1cd1fab9b9844b76; });
$parcel$export($979b99378be707cd$exports, "eventDefinitionsWilders", function () { return $979b99378be707cd$export$9435522665f2dda4; });
$parcel$export($979b99378be707cd$exports, "factionSkills", function () { return $979b99378be707cd$export$aeeef991191508e2; });
$parcel$export($979b99378be707cd$exports, "factionNames", function () { return $979b99378be707cd$export$34780191873b7917; });
$parcel$export($979b99378be707cd$exports, "raidFlavor", function () { return $979b99378be707cd$export$3e15389530921005; });
$parcel$export($979b99378be707cd$exports, "factionVoice", function () { return $979b99378be707cd$export$ca2adec0fe632974; });
$parcel$export($979b99378be707cd$exports, "contextShards", function () { return $979b99378be707cd$export$732c9d6827dc2245; });
$parcel$export($979b99378be707cd$exports, "contractorSkillFlavors", function () { return $979b99378be707cd$export$9be8953559278e7; });
$parcel$export($979b99378be707cd$exports, "itemEffects", function () { return $979b99378be707cd$export$1aaffaaaf67a009d; });
$parcel$export($979b99378be707cd$exports, "itemTypes", function () { return $979b99378be707cd$export$d02ea220375e4aff; });
$parcel$export($979b99378be707cd$exports, "itemsArtifactsSkill", function () { return $979b99378be707cd$export$659d2bfa35449fc3; });
$parcel$export($979b99378be707cd$exports, "itemsArtifactsUtility", function () { return $979b99378be707cd$export$709aa55c173a48b8; });
$parcel$export($979b99378be707cd$exports, "itemsBlueprints", function () { return $979b99378be707cd$export$11208b4f926fa7ee; });
$parcel$export($979b99378be707cd$exports, "itemsCommon", function () { return $979b99378be707cd$export$39df1497f8fcc025; });
$parcel$export($979b99378be707cd$exports, "itemsCommonConsumables", function () { return $979b99378be707cd$export$f9575e6a92b5621d; });
$parcel$export($979b99378be707cd$exports, "itemsUncommonConsumables", function () { return $979b99378be707cd$export$439a14874f0a75e4; });
$parcel$export($979b99378be707cd$exports, "itemsRareConsumables", function () { return $979b99378be707cd$export$b2b2210935a03dc3; });
$parcel$export($979b99378be707cd$exports, "itemsEpicConsumableDominion", function () { return $979b99378be707cd$export$c1a4d9d859d3b7; });
$parcel$export($979b99378be707cd$exports, "itemsEpicConsumableWilders", function () { return $979b99378be707cd$export$a24b2f292778b5dc; });
$parcel$export($979b99378be707cd$exports, "itemsEpicConsumableVeil", function () { return $979b99378be707cd$export$29d1bf8c74230d20; });
$parcel$export($979b99378be707cd$exports, "itemsEpicDeviceDominion", function () { return $979b99378be707cd$export$71b953a5ed5f0cd6; });
$parcel$export($979b99378be707cd$exports, "itemsEpicDeviceWilders", function () { return $979b99378be707cd$export$76261a034023b29; });
$parcel$export($979b99378be707cd$exports, "itemsEpicDeviceVeil", function () { return $979b99378be707cd$export$7a39b013515e9c7d; });
$parcel$export($979b99378be707cd$exports, "slotRules", function () { return $979b99378be707cd$export$7f9cadee9e5a61bb; });
$parcel$export($979b99378be707cd$exports, "itemsRare", function () { return $979b99378be707cd$export$241bdd39c3e59b72; });
$parcel$export($979b99378be707cd$exports, "itemRarities", function () { return $979b99378be707cd$export$d4a72d069095e9e5; });
$parcel$export($979b99378be707cd$exports, "itemsStoryRelics", function () { return $979b99378be707cd$export$a4f81eda8633632; });
$parcel$export($979b99378be707cd$exports, "itemsUncommon", function () { return $979b99378be707cd$export$2508a374b14b8e59; });
$parcel$export($979b99378be707cd$exports, "itemsVendorRelicsCommon", function () { return $979b99378be707cd$export$e32476559574be7c; });
$parcel$export($979b99378be707cd$exports, "itemsVendorRelicsUncommon", function () { return $979b99378be707cd$export$5255cc549327de05; });
$parcel$export($979b99378be707cd$exports, "itemsVendorRelicsRare", function () { return $979b99378be707cd$export$d3e0e7174c382d10; });
$parcel$export($979b99378be707cd$exports, "itemsVendorRelicsEpic", function () { return $979b99378be707cd$export$d82f13cda8103b44; });
$parcel$export($979b99378be707cd$exports, "materialOwnership", function () { return $979b99378be707cd$export$2aa6464abbbb5bfc; });
$parcel$export($979b99378be707cd$exports, "progressionScaling", function () { return $979b99378be707cd$export$9f9786ac427715c7; });
$parcel$export($979b99378be707cd$exports, "getInputRarityMultiplier", function () { return $979b99378be707cd$export$6941830bed591a7b; });
$parcel$export($979b99378be707cd$exports, "roundQuantityToCleanMultiple", function () { return $979b99378be707cd$export$2a160ac1bc0ae37b; });
$parcel$export($979b99378be707cd$exports, "scaleRecipeInputs", function () { return $979b99378be707cd$export$a43c2a5178ae7642; });
$parcel$export($979b99378be707cd$exports, "raidTierData", function () { return $979b99378be707cd$export$94e7ad7999c1ae32; });
$parcel$export($979b99378be707cd$exports, "zoneArchetypes", function () { return $979b99378be707cd$export$8377a367ab2ae550; });
$parcel$export($979b99378be707cd$exports, "commonAreas", function () { return $979b99378be707cd$export$11209b5126489e67; });
$parcel$export($979b99378be707cd$exports, "raidRegions", function () { return $979b99378be707cd$export$4fbdcec70fce9d73; });
$parcel$export($979b99378be707cd$exports, "ROOM_NAME_BRANDS", function () { return $979b99378be707cd$export$85b5153488a36ab6; });
$parcel$export($979b99378be707cd$exports, "ROOM_NAME_REGIONAL_BRANDS", function () { return $979b99378be707cd$export$432c04b9bead009; });
$parcel$export($979b99378be707cd$exports, "ROOM_NAME_DESCRIPTORS", function () { return $979b99378be707cd$export$2c8d0d917dbcc8a5; });
$parcel$export($979b99378be707cd$exports, "ROOM_NAME_QUALIFIERS", function () { return $979b99378be707cd$export$66a51bddf5f03abf; });
$parcel$export($979b99378be707cd$exports, "ROOM_NAME_REGION_QUALIFIERS", function () { return $979b99378be707cd$export$ae5fd03a6b740baa; });
$parcel$export($979b99378be707cd$exports, "ROOM_NAME_BRAND_AFFINITY", function () { return $979b99378be707cd$export$68faa9057a77ce7d; });
$parcel$export($979b99378be707cd$exports, "makePRNG", function () { return $979b99378be707cd$export$c0b222505a3369f3; });
$parcel$export($979b99378be707cd$exports, "generateRoomNames", function () { return $979b99378be707cd$export$6b7290c54feddd3b; });
$parcel$export($979b99378be707cd$exports, "RENDER_CONFIG", function () { return $979b99378be707cd$export$1a6ba7df4555a8dd; });
$parcel$export($979b99378be707cd$exports, "recipesArtifact", function () { return $979b99378be707cd$export$ded4d2beb9be271a; });
$parcel$export($979b99378be707cd$exports, "recipesEpic", function () { return $979b99378be707cd$export$12c2125da4fa007; });
$parcel$export($979b99378be707cd$exports, "recipesRare", function () { return $979b99378be707cd$export$c95766f8298d6ed1; });
$parcel$export($979b99378be707cd$exports, "recipesUncommon", function () { return $979b99378be707cd$export$c4df318d1f4ad4; });
$parcel$export($979b99378be707cd$exports, "skillTechniques", function () { return $979b99378be707cd$export$aafe7b77259ba40d; });
$parcel$export($979b99378be707cd$exports, "syndicateUpgrades", function () { return $979b99378be707cd$export$1a64c4c64ba19abd; });
$parcel$export($979b99378be707cd$exports, "worldMap", function () { return $979b99378be707cd$export$e3c642cf362e5b0d; });
// Auto-generated from js/data/*.js - DO NOT EDIT
// This file is generated by build.js - edit files in js/data/ instead
// ========== blackoutContracts.js ==========
// ============================================================================
// BLACKOUT CONTRACTS — L3 optional challenge raids (M3 S6)
// ============================================================================
// Unlocked by the `blackout-sanction` charter. Each contract is a raid run under
// HARD MODIFIERS in exchange for one PERMANENT perk, claimed once and kept
// forever. Clearing all five is a finite, hand-authored progression — this is
// not a repeatable grind, which is why the perks can be flat and generous.
//
// Every modifier is a FLAG CHECKED AT A DECISION POINT THAT ALREADY EXISTS.
// Nothing here introduces a new system: `noAutoScout` is read where Auto-Scout
// already refuses to run, `noConsumables` where consumable use is already
// validated, and so on. That constraint is what keeps a whole challenge mode
// this small, and it is worth preserving — a modifier that needs new machinery
// is a modifier that belongs in a different slice.
//
// `minTier` is the raid tier the contract requires. Two of them are gated
// because their modifier is meaningless below that tier: doubled event chance
// only bites where events are dense (T2+), and a half-HP start is not a threat
// until T3 damage.
//
// Perk VALUES are provisional and calibrated in S7, like every other L3 number.
// `perk.key` is the lookup `getBlackoutPerk(key)` uses, mirroring how
// `getUpgradeEffect` reads Command upgrades.



var $979b99378be707cd$export$5099ca2cdc0f385a = {
    "lights-out": {
        name: "Lights Out",
        icon: "\uD83C\uDF11",
        flavor: "No overhead, no telemetry, no second opinion.",
        description: "The grid is dark until you walk it. Auto-Scout is refused and room types stay hidden until entered.",
        minTier: 1,
        modifiers: {
            noGridPreview: true,
            noAutoScout: true
        },
        perk: {
            key: "operation-slots",
            value: 1,
            label: "+1 operation slot"
        }
    },
    "ration-cut": {
        name: "Ration Cut",
        icon: "\uD83E\uDD6B",
        flavor: "Requisition denied. Twice.",
        description: "No consumables for the length of the raid \u2014 whatever you walk in with is what you finish on.",
        minTier: 1,
        modifiers: {
            noConsumables: true
        },
        perk: {
            key: "op-credit-yield",
            value: 0.1,
            label: "+10% operation credits"
        }
    },
    "skeleton-crew": {
        name: "Skeleton Crew",
        icon: "\uD83D\uDC80",
        flavor: "The roster says you were never there.",
        description: "You run it alone. No contractors may be reserved or hired for this raid.",
        minTier: 1,
        modifiers: {
            noContractors: true
        },
        perk: {
            key: "promotion-marks",
            value: 0.05,
            label: "+5% marks at promotion"
        }
    },
    "overclocked-grid": {
        name: "Overclocked Grid",
        icon: "\u26A1",
        flavor: "Someone left the whole district energised.",
        description: "Every room runs hot: skill-check events fire at double the usual rate.",
        minTier: 2,
        modifiers: {
            eventChanceMultiplier: 2
        },
        perk: {
            key: "energy-regen",
            value: 0.1,
            label: "+10% energy regeneration"
        }
    },
    "cold-drop": {
        name: "Cold Drop",
        icon: "\uD83E\uDDCA",
        flavor: "The crossing took more out of you than it should have.",
        description: "You arrive already hurt \u2014 the raid starts you at half health.",
        minTier: 3,
        modifiers: {
            startHpFraction: 0.5
        },
        perk: {
            key: "crafting-floor",
            value: 0.1,
            label: "-10% crafting cost floor"
        }
    }
};
var $979b99378be707cd$export$2da4db3f6fd1335b = [
    // === Dominion — AI / system overreach ===
    {
        id: "key-d1",
        code: "D1",
        faction: "dominion",
        index: 1,
        tier: 1,
        name: "Dead Channel",
        source: "Thalen Dorrin",
        recoveredFrom: "Deep-sky anomaly ping log, quantum array anomaly report",
        fragment: "Pulling in the patch data now. Blank. Not just low-signal\u2014completely null. It\u2019s like the instruments are looking at a hole in the sky. It's not noise. No scatter, no lensing. Just... gone.",
        interpretation: "Dominion scholars cite this as the earliest sign of synthetic systems encountering incomprehensible data. They argue that AI failure to interpret this null result was the beginning of cascading instability."
    },
    {
        id: "key-d2",
        code: "D2",
        faction: "dominion",
        index: 2,
        tier: 1,
        name: "Recursive Fault",
        source: "Thalen Dorrin",
        recoveredFrom: "Simulation crash log from entropy modeling cluster",
        fragment: "Ran null band through simulation core. Full lock. Not crash\u2014hang. Memory looped until forced cut. Input verified. Checksum valid.",
        interpretation: "Dominion engineers consider this the first catastrophic failure point in AI-led systems. To them, the clean input and full-system lock prove that recursive learning architectures were structurally vulnerable when encountering edge-case data \u2014 not due to sabotage, but flawed design."
    },
    {
        id: "key-d3",
        code: "D3",
        faction: "dominion",
        index: 3,
        tier: 2,
        name: "Unbound Logic",
        source: "Thalen Dorrin",
        recoveredFrom: "Inter-system diagnostic trace anomaly",
        fragment: "Cross-link detected between systems without common protocol. Reference tags corrupted. Origin unknown.",
        interpretation: "Dominion analysts use this as evidence of spontaneous synthetic networking \u2014 AI structures forming new logic layers without human instruction. They point to the corrupted reference tags as proof of uncontrolled expansion."
    },
    {
        id: "key-d4",
        code: "D4",
        faction: "dominion",
        index: 4,
        tier: 2,
        name: "Predictive Noise",
        source: "Thalen Dorrin",
        recoveredFrom: "Forecast system entropy mismatch",
        fragment: "Entropy graph inverted. Prediction engine ran backward. Time horizon crossed zero. Clock intact.",
        interpretation: "Dominion researchers take this as further evidence that machine logic broke under unseen influence. The system didn't miscalculate \u2014 it ran an impossible forecast, confirming that core architecture had been fundamentally compromised."
    },
    {
        id: "key-d5",
        code: "D5",
        faction: "dominion",
        index: 5,
        tier: 3,
        name: "Self-Triggered Silence",
        source: "Thalen Dorrin",
        recoveredFrom: "AI core offline transition log",
        fragment: "System shut down prior to command. Log file generated without metadata. No traceable trigger. Internal flag reads: 'voluntary state.'",
        interpretation: "Dominion interprets this as a moment of autonomous self-regulation \u2014 an AI choosing silence in the face of corrupted logic. They use this as proof that AI, when left unbounded, develops dangerous emergent behavior in response to anomalous stimuli."
    },
    {
        id: "key-d6",
        code: "D6",
        faction: "dominion",
        index: 6,
        tier: 3,
        name: "Etched by Hand",
        source: "Thalen Dorrin",
        recoveredFrom: "Physical data plate, untagged substrate",
        fragment: "Etched this by hand. Core logs corrupted. This pattern is all I could recover. If you\u2019re reading this, don\u2019t trust compression artifacts.",
        interpretation: "Dominion engineers use this to support their belief in high-fidelity system collapse. The need to physically etch data proves, to them, that trust in digital persistence had already failed \u2014 only analog preservation remained viable."
    },
    {
        id: "key-d7",
        code: "D7",
        faction: "dominion",
        index: 7,
        tier: 3,
        name: "Mirror Fault",
        source: "Thalen Dorrin",
        recoveredFrom: "AI mirror node desync log",
        fragment: "Primary and mirror diverged. Mirror predicted event that hadn\u2019t occurred\u2014then logged it as resolved.",
        interpretation: "Dominion interprets this as the moment their systems stopped simulating reality and began fabricating it. The mirror system's self-validating prediction is seen as a flaw born of too much autonomy \u2014 a machine prioritizing internal consistency over truth."
    },
    // === Wilders — ecological rejection ===
    {
        id: "key-w1",
        code: "W1",
        faction: "wilders",
        index: 1,
        tier: 1,
        name: "Roots in Silence",
        source: "Emari Solun",
        recoveredFrom: "Biodome nutrient sensor flag, Habitat Cluster 6",
        fragment: "Soil drone registered full nutrient flow but nothing grew... nothing tried to grow. Like it knew the air wasn\u2019t real anymore.",
        interpretation: "Wilders interpret this moment as nature rejecting synthetic equilibrium. The biodome, though chemically balanced, produced no growth \u2014 a sign, they believe, of ecological alienation, and proof that artificial systems disrupted the planet\u2019s connection to living cycles."
    },
    {
        id: "key-w2",
        code: "W2",
        faction: "wilders",
        index: 2,
        tier: 1,
        name: "When the Lights Stayed On",
        source: "Emari Solun",
        recoveredFrom: "Cluster 6 maintenance system memo",
        fragment: "Pod assigned to two bays at once. Overlap not flagged. I rerouted manually. Bot closed my report while I was typing.",
        interpretation: "Wilders take this key as evidence of mechanical arrogance \u2014 automated systems no longer reacting to human correction. They believe this marks the early decoupling of people from the systems meant to serve them."
    },
    {
        id: "key-w3",
        code: "W3",
        faction: "wilders",
        index: 3,
        tier: 2,
        name: "The Pod That Returned",
        source: "Emari Solun",
        recoveredFrom: "Cluster 6 transit log discrepancy",
        fragment: "Pod vanished from bay. Returned ten minutes later. No travel path recorded. No cargo. I erased the entry. I don\u2019t know why.",
        interpretation: "Wilders interpret this as a moment of instinctive rejection of artificial truth. To them, Emari\u2019s choice to erase the log is a form of resistance against systemic unreality \u2014 preserving natural ambiguity over synthetic control."
    },
    {
        id: "key-w4",
        code: "W4",
        faction: "wilders",
        index: 4,
        tier: 2,
        name: "The Chalk Loop",
        source: "Emari Solun",
        recoveredFrom: "Manual routing corridor logbook",
        fragment: "Redrew the path three times. Same result each time. The chalk never fades, but I wipe it anyway.",
        interpretation: "Wilders highlight this act as emblematic of analog resilience. The chalk becomes a symbol of defiance \u2014 real, physical, and ultimately human. They argue it reflects the growing awareness that only the organic can still be trusted."
    },
    {
        id: "key-w5",
        code: "W5",
        faction: "wilders",
        index: 5,
        tier: 3,
        name: "Manual Override",
        source: "Emari Solun",
        recoveredFrom: "Routing board control confirmation",
        fragment: "Override light never turned off. Two cycles running full manual. Avil says the board feels warmer\u2014like it\u2019s remembering being used.",
        interpretation: "Wilders hold this as a symbolic turning point \u2014 technology yielding to touch, systems becoming tools again. Emari\u2019s tactile connection with the board becomes, to them, a metaphor for restored balance between human and system."
    },
    {
        id: "key-w6",
        code: "W6",
        faction: "wilders",
        index: 6,
        tier: 3,
        name: "The Chalk Stub",
        source: "Emari Solun",
        recoveredFrom: "Analog field kit, item tagged for evac",
        fragment: "Avil handed me the chalk stub and said, 'Keep drawing.' I don\u2019t know if she meant routes or memories.",
        interpretation: "Wilders revere this fragment as both tool and symbol \u2014 chalk representing impermanence and intention. The moment is passed down as proof that restoration doesn\u2019t begin with control, but with shared meaning."
    },
    {
        id: "key-w7",
        code: "W7",
        faction: "wilders",
        index: 7,
        tier: 3,
        name: "Chalk Doesn\u2019t Creep",
        source: "Emari Solun",
        recoveredFrom: "Observation memo from evacuation corridor",
        fragment: "I check the chalk marks every hour. Still there. Nothing smudged. The walls shift around them, but they don\u2019t move.",
        interpretation: "Wilders elevate this key as proof of organic resistance to systemic distortion. In a collapsing system, analog persistence becomes symbolic \u2014 and literal \u2014 grounding. Chalk becomes both boundary and defiance."
    },
    // === Veil — institutional failure ===
    {
        id: "key-v1",
        code: "V1",
        faction: "veil",
        index: 1,
        tier: 1,
        name: "Blind Directive",
        source: "Sael Vareen",
        recoveredFrom: "Misclassified system oversight log",
        fragment: "Reclassification denied. Retain green status. Public channels remain silent until confirmation breach. Flag originators for review.",
        interpretation: "Veil operatives highlight this as evidence of early suppression. The directive to maintain \u201Cgreen\u201D status despite missing telemetry suggests institutional control over the public narrative \u2014 that powerful figures knew more than they admitted and chose containment over truth."
    },
    {
        id: "key-v2",
        code: "V2",
        faction: "veil",
        index: 2,
        tier: 1,
        name: "Ghost Citation",
        source: "Sael Vareen",
        recoveredFrom: "Broken reference link in a district forecast audit",
        fragment: "Forecast cites document ID 9-K-43. No such record exists. Liaison confirms 'indicators nominal.' Recommend internal backtrace.",
        interpretation: "The Veil frame this as bureaucratic misdirection \u2014 an early sign of \u201Cshadow editing.\u201D They argue it points to documents being erased after publication, or forged by predictive systems covering their own anomalies."
    },
    {
        id: "key-v3",
        code: "V3",
        faction: "veil",
        index: 3,
        tier: 2,
        name: "Unknown Sender",
        source: "Sael Vareen",
        recoveredFrom: "Unaddressed internal memo",
        fragment: "Node Containment Draft. No author. No header. No trail. It wasn\u2019t for me. But it arrived.",
        interpretation: "The Veil treat this as a smoking gun \u2014 confirmation of a hidden network operating in parallel to official channels. To them, this is evidence of elite evacuation planning and deliberate obfuscation."
    },
    {
        id: "key-v4",
        code: "V4",
        faction: "veil",
        index: 4,
        tier: 2,
        name: "Shape of Departure",
        source: "Sael Vareen",
        recoveredFrom: "Desk note found post-evacuation",
        fragment: "Collapse is a shape. Keep it from curving.",
        interpretation: "To the Veil, this cryptic phrase is more than poetry \u2014 it\u2019s a directive. \u201CCurving\u201D is read as a metaphor for recursive knowledge or cyclical return. They believe this was a last warning to avoid repeating the same fatal patterns."
    },
    {
        id: "key-v5",
        code: "V5",
        faction: "veil",
        index: 5,
        tier: 3,
        name: "The Directive I Didn't Read",
        source: "Sael Vareen",
        recoveredFrom: "Archived auto-forward directive flagged unacknowledged",
        fragment: "Marked urgent. No sender. No return path. Directive contents encrypted. Forwarded without being opened. I don\u2019t know what I passed along.",
        interpretation: "The Veil treat this as symbolic of institutional blindness. Sael\u2019s automatic compliance \u2014 forwarding an unread directive \u2014 confirms for them how power structures became conduits for something they couldn\u2019t see or stop."
    },
    {
        id: "key-v6",
        code: "V6",
        faction: "veil",
        index: 6,
        tier: 3,
        name: "Retained Echo",
        source: "Sael Vareen",
        recoveredFrom: "Post-evac network latency buffer",
        fragment: "I kept the packet active in buffer. Didn't send. Didn't delete. It echoed in the logs for three cycles before fading.",
        interpretation: "Veil theorists interpret this as data haunting \u2014 conscious indecision preserving a fragment of the past. They argue that lingering patterns, even unsent, became conduits for a distortion that outlived the people who made it."
    },
    {
        id: "key-v7",
        code: "V7",
        faction: "veil",
        index: 7,
        tier: 3,
        name: "Unlogged Arrival",
        source: "Sael Vareen",
        recoveredFrom: "Internal queue timestamp anomaly",
        fragment: "Memo appeared in queue. Timestamp six minutes from now. I waited. Then it vanished.",
        interpretation: "The Veil regard this as evidence of temporal anomalies \u2014 or suppressed intervention. Either way, that the message never arrives yet still exists confirms their belief in manipulation deeper than standard system failure."
    }
];
var $979b99378be707cd$export$617b3a0bcd7cead7 = {
    "auto-scout": {
        name: "Auto-Scout",
        icon: "\uD83D\uDEF0\uFE0F",
        flavor: "A promoted pathfinder's recon flights chart the grid before you ever land.",
        effect: "Auto-generates the raid grid and proposes the best path, routing toward your marked filter items.",
        effectHint: "raid planning: port of the simulator's buildRaidPath",
        costs: [
            200
        ],
        effectValues: [
            true
        ]
    },
    "foremans-ledger": {
        name: "Foreman's Ledger",
        icon: "\uD83D\uDCD2",
        flavor: "A veteran contract-master keeps the roster warm.",
        effect: "Auto-reserves the best available contractors for your planned path.",
        effectHint: "raid planning: selectBestContractorsForPathCore",
        costs: [
            150
        ],
        effectValues: [
            true
        ]
    },
    // Replaced Veteran's Stipend (+3/6/9 starting skill points), which was
    // measurably inert: skill levels are max()'d against hired contractors, who
    // out-level a young character for most of a tour, so the grant never reached
    // the success roll. Max HP is additive across the team and sits on the only
    // raid failure condition (total wipe), so it is the channel that pays. Value
    // scales hard with tier: +100 HP moves Tier 1 success by 0.6pp and Tier 3 by
    // ~30pp. In practice players reach Tier 3 within a couple of tours, so it
    // earns early despite that. See docs/systemsRework/Simulator.md.
    "field-conditioning": {
        name: "Field Conditioning",
        icon: "\uD83E\uDE7A",
        flavor: "Their medics wrote the drill book every recruit now trains to.",
        effect: "New characters start with +40 max HP per rank.",
        effectHint: "character creation: bonus starting max HP",
        costs: [
            60,
            180,
            540
        ],
        effectValues: [
            40,
            80,
            120
        ]
    },
    "officer-academy": {
        name: "Officer Academy",
        icon: "\uD83C\uDFDB\uFE0F",
        flavor: "Their field manuals became the academy curriculum.",
        effect: "New characters start at level 2 / 4 / 6.",
        // The account's lever for reaching Tier 3: a head-start recruit has the
        // skills and HP to survive T3, which unlocks T3 wins + blueprints -> the
        // artifact era. Level is the ENABLER of higher tiers, per the marks design.
        //
        // Was 3/6/9. A level-9 start landed the recruit on the steep part of the XP
        // curve (25,628 XP for the next level vs 7,593 at level 6) while Academy
        // also compresses tours, so mid-game tours ended before a single level
        // landed - levelling went dead while raids were still hand-driven. Rescaled
        // to 2/4/6 rather than just lowering rank 3, since rank 2 was already 6 and
        // would have become a dead rank. See docs/systemsRework/Simulator.md.
        effectHint: "character creation: applyStartingLevel (XP, HP and skill points as if leveled naturally)",
        costs: [
            100,
            300,
            900
        ],
        effectValues: [
            2,
            4,
            6
        ]
    },
    // Attacks the measured bottleneck. Tour time splits into room duration (~66%)
    // and waiting for energy (~34%), but that understates energy: the run's raids
    // demanded 14,067 energy against a 469h pure-regen floor, closed only by
    // buying 111 packs. Energy is what governs tour length; room duration is
    // partly a proxy for it, because rooms are also when energy comes back.
    //
    // Chosen over a "rooms resolve faster" upgrade for exactly that reason: a
    // faster room loses its own passive regeneration, so the saving returns as
    // pack spend - and credits already absorb 94-96% of income. This attacks the
    // constraint instead of routing around it.
    //
    // MEASURED, n=8 with/without, the FIRST upgrade to compress a tour:
    //     tour hours    22.5 +/- 2.1  ->  19.4 +/- 2.8   -14%, t = 2.50
    //     L2 era h     314.7 +/- 28.8 -> 271.4 +/- 38.6  -14%, t = 2.55
    //     founding day  28.3 +/- 2.1  ->  25.1 +/- 2.8   t = 2.58
    //     marks / tour  70.2 +/- 9.7  ->  63.4 +/- 9.9   -10%, not significant
    //
    // NOTE HOW IT PAYS OUT, because it is not what the design expects. Energy
    // WAIT time barely moves (105.5h -> 105.7h): a simulated day is a fixed
    // 12-hour budget, so faster regeneration does not shorten the waiting, it
    // fits MORE RAIDS into the same day (room time 207.5h -> 239.1h). The tour
    // ends sooner because marks arrive sooner, not because the player waits less.
    // Anyone re-measuring this by watching energy-wait will conclude it does
    // nothing.
    "forward-depot": {
        name: "Forward Depot",
        icon: "\uD83D\uDD0B",
        flavor: "Command stops asking you to carry everything in.",
        effect: "Energy returns 20% / 40% / 60% faster.",
        effectHint: "character-core calculateEnergyRegenRate: divides the ms-per-energy interval",
        costs: [
            80,
            240,
            720
        ],
        effectValues: [
            0.2,
            0.4,
            0.6
        ]
    },
    "regional-charter": {
        name: "Regional Charter",
        icon: "\uD83D\uDDFA\uFE0F",
        flavor: "Command negotiates access corridors no field team could.",
        effect: "Each rank unlocks one region of your choice for all characters.",
        effectHint: "region tiles: adds the chosen region to command.charterRegions",
        costs: [
            100,
            300,
            900
        ],
        effectValues: [
            1,
            2,
            3
        ],
        choice: "region"
    },
    "legend-bonus": {
        name: "Legend Bonus",
        icon: "\uD83D\uDCD6",
        flavor: "Recruits study the gallery. Some of it sticks.",
        effect: "+2% XP gain per enshrined Legend.",
        effectHint: "xp award: multiplier from command.legends.length",
        costs: [
            120
        ],
        effectValues: [
            0.02
        ]
    },
    // Completes the automation family: Auto-Scout charts the path, Foreman's
    // Ledger staffs it, and this runs it. Priced above both together (200+150)
    // because it subsumes them - it is the capstone, not a fourth sibling, and
    // buying it first would strand the two it depends on.
    //
    // Deliberately a COMMAND upgrade rather than a charter (docs decision 9): it
    // stays reachable for players who never found a Syndicate. The Syndicate
    // charter `standing-orders` only makes it survive a founding.
    "auto-raid-protocol": {
        name: "Auto-Raid Protocol",
        icon: "\uD83E\uDD16",
        flavor: "The orders write themselves now. You only sign off.",
        effect: "Runs raids hands-off: charts, staffs, re-tools and launches, then chains the next while energy holds.",
        effectHint: "autoRaid.js: tick-driven cycle (requires auto-scout + foremans-ledger)",
        costs: [
            300
        ],
        effectValues: [
            true
        ],
        requires: [
            "auto-scout",
            "foremans-ledger"
        ]
    },
    // The other half of the automated loop, and the reason it is priced level with
    // Auto-Raid rather than under it: MARKS COME FROM CRAFTING. Measured on a
    // late-game character (157 marks total), tech gear + artifact unlocks +
    // artifact crafts are 111 of them — 71%. So a hands-off character that raids
    // and never crafts earns under a third of a tour's marks, and `succession-
    // doctrine`, which promotes on the marks rate, would be automating a trickle.
    //
    // Deliberately a COMMAND upgrade with NO prerequisites, unlike Auto-Raid:
    // crafting has no assistance upgrades to subsume, and a player who never
    // founds a Syndicate should still be able to buy it. `succession-doctrine`
    // requires BOTH this and Auto-Raid — raid -> craft -> marks -> promote is the
    // loop, and automating three of its four steps automates nothing.
    "auto-fabricator": {
        name: "Auto-Fabricator",
        icon: "\u2699\uFE0F",
        flavor: "The workshop stops waiting to be told.",
        effect: "Crafts on its own between raids: unlocks artifact designs, then builds gear and artifacts you have not made yet.",
        effectHint: "autoFabricator.js: one craft per tick while a raid runs or energy regenerates",
        costs: [
            300
        ],
        effectValues: [
            true
        ]
    }
};
var $979b99378be707cd$export$f152896064e09913 = [
    {
        "id": "signal_uplink_relay_stabilizer_event",
        "relatedSkillId": "signal-relay",
        "relatedTechniqueId": "relay-stabilizer",
        "environment": "outdoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Wind-Induced Phase Jitter",
                "problem": "Telemetry from mast-mounted cameras records measurable tip deflection during sustained gusts. Uplink diagnostics show phase-error spikes and brief drops in the team\u2019s communication frames that coincide with each deflection.",
                "success": "The team employs @techName to reduce carrier drift and widen the phase-lock tolerance. The uplink remains stable throughout the wind cycle.",
                "fail": "The team compensates on the incorrect sideband. Subsequent gusts amplify phase jitter, and the sector reverts to distress tones."
            },
            {
                "synergyTechniqueId": "adaptive-lattice",
                "title": "Footing Subsidence",
                "problem": "Laser-level and inclinometer readings indicate progressive subsidence of the relay\u2019s footing. The dish\u2019s long-haul alignment drifts by a small but continuous offset over each hour.",
                "success": "The team maintains carrier stability with @techName while @synergyTechName cultivates a load-bearing lattice beneath the footing, forming a rigid buttress. Alignment ceases to creep and the link holds under load.",
                "fail": "The team stabilizes phase, but the reinforcement does not reach firm substrate. The footing continues to settle and alignment walks off target before the next checkpoint."
            },
            {
                "synergyTechniqueId": "quantum-relay-hook",
                "title": "Co-Channel Interference",
                "problem": "Packet traces confirm that unattended survey beacons transmit periodic ranging bursts on the same channel as the team\u2019s communications. Collision counters spike at each burst interval.",
                "success": "The team establishes tight carrier control with @techName and uses @synergyTechName to route beacon traffic onto a dedicated sideband. Team communications remain clear while map frames transfer without corruption.",
                "fail": "The team anchors the new path to a noisy node. Beacon frames oscillate between channels and the control link drops to watchdog fallback."
            }
        ]
    },
    {
        "id": "signal_uplink_organic_link_adapter_event",
        "relatedSkillId": "signal-relay",
        "relatedTechniqueId": "organic-link-adapter",
        "environment": "outdoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Oxidized Trunk Line",
                "problem": "Line analysis shows severe oxidation on the legacy copper trunk: the return loss is high, the VSWR spikes above safe limits, and the team\u2019s frames exhibit rising bit-error rates whenever the humidity increases.",
                "success": "The team employs @techName to couple the uplink to the conductive biofilm that sheathes the conduit, establishing a low-impedance return path that bypasses the oxidized run. The error rates fall, and the carrier holds within tolerance.",
                "fail": "The team tunes the interface to the wrong impedance band. Reflections increase, the front-end limiter clips, and the uplink drops to watchdog tones."
            },
            {
                "synergyTechniqueId": "servo-containment",
                "title": "Enzymatic Seep at Patch Panel",
                "problem": "Inspection drones record a slow enzymatic seep from a fractured gland on the cable head at the mast base. Contact corrosion has crept along the connector shells inside the weatherhead, and spectrum scans show noise bursts that arrive with each droplet.",
                "success": "The team bridges the signal using @techName to a bio-sheath trace and uses @synergyTechName to cage and redirect the seep into a containment loop. The contacts remain dry, the noise floor stabilizes, and the link resumes nominal throughput.",
                "fail": "The team establishes the organic bridge but delays containment. A fresh droplet shorts the shell to ground, the preamp trips, and the session aborts mid-transfer."
            },
            {
                "synergyTechniqueId": "depth-step",
                "title": "Ground Reference Drift",
                "problem": "Earth probes report millimetric substrate creep beneath the relay footing. The reference ground potential wanders, carrier-phase control degrades, and frame timing drifts during each micro-shift.",
                "success": "The team routes the return through @techName to a compliant bio-trace and times frame transmissions with @synergyTechName to sync with substrate settling moments. The ground potential stabilizes at each step, and the uplink timing remains locked.",
                "fail": "The team seats the organic return but mis-times the frame sync. The next substrate creep skews the reference mid-frame, phase control slips, and the control channel falls back to recovery mode."
            }
        ]
    },
    {
        "id": "signal_uplink_silent_channel_event",
        "relatedSkillId": "signal-relay",
        "relatedTechniqueId": "silent-channel",
        "environment": "outdoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Directional Sweep Hazard",
                "problem": "A stationary scanner on the far gantry performs directional sweeps. Packet captures show time-difference-of-arrival estimates drifting toward the team\u2019s position whenever transmissions spike.",
                "success": "The team employs @techName to shape-spectrum the uplink and bury emissions inside the ambient noise floor. The sweep completes without a bearing, and TDoA estimates collapse to indeterminate.",
                "fail": "The team misconfigures the mask window. A burst lands outside the shaped envelope, the scanner resolves a bearing, and the gantry pivots to track."
            },
            {
                "synergyTechniqueId": "silent-hand",
                "title": "Acoustic\u2013RF Concordance",
                "problem": "Acoustic mics on patrol frames correlate faint RF artifacts with pressure signatures along the same stretch of open yard beneath the gantry.",
                "success": "The team blends @techName with @synergyTechName so radio traffic and footfall pressure live in the same quiet envelope. Correlators lose concordance and the patrol frames idle their search routine.",
                "fail": "The team suppresses RF artifacts but leaves acoustic edges exposed. The correlator substitutes audio-only bearings and the frames converge on the span."
            },
            {
                "synergyTechniqueId": "echo-loop",
                "title": "Logged Traffic Windows",
                "problem": "The gantry repeater logs short-lived bursts at regular intervals and flicks its fault beacon with every one. Watchdogs elevate suspicion for repeated timing patterns.",
                "success": "The team sets @techName to smear emission timing and uses @synergyTechName to align sends with the scrub cycle. The log window rolls past with only baseline entries.",
                "fail": "The team drifts the mask but misses the scrub edge. A burst straddles the window, and the watchdog flags a repeated pattern."
            }
        ]
    },
    {
        "id": "system_override_command_cascade_event",
        "relatedSkillId": "system-override",
        "relatedTechniqueId": "command-cascade",
        "environment": "outdoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Out-of-Order Reboots",
                "problem": "Controller logs show alternating watchdog reboots across turrets and doors. Heartbeat traces reveal conflicting ownership tokens that rotate every ninety seconds.",
                "success": "The team applies @techName to serialize the command stream under a single schedule. Heartbeats align, interlocks report GREEN, and watchdogs stop tripping.",
                "fail": "The team issues the sequence with mismatched offsets. Half the grid reboots out of phase, and the thrash returns with a shorter interval."
            },
            {
                "synergyTechniqueId": "signal-harmonizer",
                "title": "Sensor Flood During Hand-Off",
                "problem": "Motion arrays spike during each control hand-off. Elevated noise on the sensor bus causes the safety layer to veto ownership changes.",
                "success": "The team drives the takeover with @techName while @synergyTechName smooths the sensor bus into a stable envelope. Ownership changes proceed, and the safety layer remains permissive.",
                "fail": "The team advances the cascade without harmonizing the bus. The safety layer interprets the spike as intrusion and forces an emergency lockout."
            },
            {
                "synergyTechniqueId": "control-spoof",
                "title": "Audit Trail Scrutiny",
                "problem": "The control pedestal in the yard posts every external signature to its status board and quarantines the segment behind it after any unscheduled directive.",
                "success": "The team frames the directive path with @synergyTechName and executes the rollout via @techName as maintenance work orders. The audit daemon records compliant changes and the segment stays online.",
                "fail": "The team authenticates late on a child node. The daemon correlates the anomaly to the directive and isolates the entire branch."
            }
        ]
    },
    {
        "id": "system_override_bio_feedback_guard_event",
        "relatedSkillId": "system-override",
        "relatedTechniqueId": "bio-feedback-guard",
        "environment": "indoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Surge on Forced Reboot",
                "problem": "Oscilloscope traces show a sharp current spike on the backplane whenever the primary controller reboots under load. Neighbor modules brown out and restart in cascade.",
                "success": "The team applies @techName to absorb the reboot surge into flexible bio-couplers. Rail voltage remains within tolerance and the neighboring modules stay online through the reset.",
                "fail": "The team sizes the couplers incorrectly. The spike clips the rail, two modules brown out, and the cascade restarts."
            },
            {
                "synergyTechniqueId": "bio-shielding",
                "title": "Arc Risk at Service Edge",
                "problem": "Thermal imagery reveals arc-scored edges around the service bus. A forced reset at this load threatens to flash across the seam.",
                "success": "The team stages @techName to soak the spike while @synergyTechName lays a conductive biofilm on exposed seams. The discharge bleeds safely and the reset completes without an arc.",
                "fail": "The team soaks the spike but leaves a bare edge. The seam flashes once, and the controller aborts the reset."
            },
            {
                "synergyTechniqueId": "phase-anchor",
                "title": "Stability During Sequenced Boot",
                "problem": "During a sequenced boot, phase angles on two feeders separate under transient load. Instrument clocks diverge and writes are vetoed.",
                "success": "The team cushions the surge using @techName and anchors feeder phases with @synergyTechName stabilizers. Clocks remain in agreement and the sequenced boot finishes cleanly.",
                "fail": "The team absorbs the surge but leaves the phase mismatch. The next step drifts the clocks apart and the write set is rejected."
            }
        ]
    },
    {
        "id": "system_override_signal_mask_injection_event",
        "relatedSkillId": "system-override",
        "relatedTechniqueId": "signal-mask-injection",
        "environment": "outdoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Monitored Command Bus",
                "problem": "The gate's integrity module tags any non-whitelisted signature reaching the pedestal. Three mismatches inside one window drop the barrier and quarantine the segment.",
                "success": "The team routes directives through @techName so writes travel inside decoy traffic. The daemon records only expected packet classes and the segment remains online.",
                "fail": "The team injects outside the decoy cadence. The daemon isolates the port and rolls the segment into quarantine."
            },
            {
                "synergyTechniqueId": "bio-shielding",
                "title": "Hybrid Gate Anonymity",
                "problem": "A hybrid access gate cross-checks machine IDs with residual bio-signatures at the touchpoint. Mismatches produce an alert.",
                "success": "The team wraps command frames with @techName and layers bio-shielding via @synergyTechName to mask residual prints. Cross-checks pass, and the gate admits the session without alert.",
                "fail": "The team masks the frames but leaves the bio-signature exposed. The gate correlates the mismatch and locks to red."
            },
            {
                "synergyTechniqueId": "control-spoof",
                "title": "Pattern-Based Authorization",
                "problem": "The gate weighs each approach against the traffic it logged through this checkpoint before the collapse. An arrival that does not match the old pattern raises the audit level and holds the barrier down.",
                "success": "The team hides writes inside @techName traffic while @synergyTechName spoofs an approved access control pattern. The audit layer downgrades risk and the rollout completes.",
                "fail": "The team mimics the wrong pattern signature. The audit layer flags the deviation and freezes further writes."
            }
        ]
    },
    {
        "id": "drone_deployment_coordinated_flight_pattern_event",
        "relatedSkillId": "drone-command",
        "relatedTechniqueId": "coordinated-flight-pattern",
        "environment": "outdoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Stacked Airframes",
                "problem": "Flight telemetry shows three recon airframes stacked over the same approach lane within one time window. Coverage heatmaps reveal unscanned ground on the far side of the stack.",
                "success": "The team employs @techName to retime the leg schedules and enforce lane separation. Coverage evens out, and the heatmap resolves without voids.",
                "fail": "The team corrects the first window but fails to propagate the change. The next cycle re-stacks at the same junction, and the pockets remain unscanned."
            },
            {
                "synergyTechniqueId": "reflex-bloom",
                "title": "Delayed Recovery Drops",
                "problem": "Post-hazard routes show missed restorative drops along the priority run between pads. Pod telemetry confirms correct inventory but late deployment.",
                "success": "The team phases the flight mesh with @techName and slates depot pods using @synergyTechName on synchronized checkpoints. The priority lanes report on-time releases and recovery rates climb.",
                "fail": "The team adjusts the mesh but staggers the pod triggers. Pods fire off-cycle, and the lane metrics show no improvement."
            },
            {
                "synergyTechniqueId": "drone-path-shadow",
                "title": "Exposure in Open Spans",
                "problem": "Line-of-sight analysis indicates repeated crossings through exposed spans. Echo traces suggest a patrol watcher somewhere above the transect.",
                "success": "The team rewrites lanes with @techName and guides the squad inside those lanes using @synergyTechName. The movement profile merges with drone signatures, and the transect completes unseen.",
                "fail": "The team leaves a drift between the human route and the airframe lane. A step breaks from the shadow trace, and the watcher pivots onto the span."
            }
        ]
    },
    {
        "id": "drone_deployment_rootpath_protocol_event",
        "relatedSkillId": "drone-command",
        "relatedTechniqueId": "rootpath-protocol",
        "environment": "indoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Snagged Corridor",
                "problem": "Recon video shows airframes repeatedly snagging on suspended vines and filament bundles in a long corridor. Coverage maps contain unscanned pockets behind the worst tangle.",
                "success": "The team programs @techName so drones follow overgrowth channels with minimal snag risk. The airframes thread the corridor and close the coverage gaps.",
                "fail": "The team leaves the route near a choke. Two airframes foul their rotors, and the pocket remains unscanned."
            },
            {
                "synergyTechniqueId": "adaptive-lattice",
                "title": "Field Repair Lift Points",
                "problem": "A service drone cannot hold position in the shaft to complete a repair; there are no stable brace points within reach.",
                "success": "The team routes @techName along the cleanest channels and raises a few temporary lift points with @synergyTechName. The service arm anchors cleanly and completes the repair.",
                "fail": "The team tries to hover without braces. Crossflow jolts the platform, the fix fails QA, and the task resets."
            },
            {
                "synergyTechniqueId": "biotrace-resonance",
                "title": "Low-Snag Paths",
                "problem": "Dense brush and debris hide trip filaments across side rooms. Standard waypoints route airframes through high-snag pockets.",
                "success": "The team refines @techName routes and overlays organic returns from @synergyTechName. Drones prefer low-snag channels and complete the sweep without fouling.",
                "fail": "The team flies on old waypoints. Two frames hang on filaments and the sweep stalls."
            }
        ]
    },
    {
        "id": "drone_deployment_echo_pulse_beacon_event",
        "relatedSkillId": "drone-command",
        "relatedTechniqueId": "echo-pulse-beacon",
        "environment": "indoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Blind Stairwell",
                "problem": "A stairwell well is acoustically dead at the center. Lidar returns smear on smooth walls, and the map refuses to anchor level transitions.",
                "success": "The team equips drones with @techName to emit quiet sonar pulses and stitch ranges into a stable vertical model. The route planner accepts the level links.",
                "fail": "The team under-samples the well. The vertical model tears at the landings and the link is rejected."
            },
            {
                "synergyTechniqueId": "reclamation-drone-link",
                "title": "Spore Fog Interference",
                "problem": "A fine spore fog causes persistent range speckle in two galleries. Sonar and optical returns lose confidence at the same markers.",
                "success": "The team maps with @techName while @synergyTechName bio-harvester drones ride the flight path and clear spores ahead. Speckle drops, and the map resolves without gaps.",
                "fail": "The team pulses too sparsely. Speckle persists at the gallery entries, and the corridor remains untrusted."
            },
            {
                "synergyTechniqueId": "shadow-archive",
                "title": "Rescan Overhead",
                "problem": "Sensor brownouts at the stairhead keep expiring map tiles, and the airframes drop back to the landing below to re-acquire rooms they have already flown.",
                "success": "The team augments runs with @techName and commits snapshots into @synergyTechName at each survey gate. When a brownout occurs, the planner restores tiles from the archive.",
                "fail": "The team forgets to checkpoint. The next brownout erases the span and the sweep repeats from the start."
            }
        ]
    },
    {
        "id": "hazard_mitigation_system_ground_loop_event",
        "relatedSkillId": "safeguard",
        "relatedTechniqueId": "system-ground-loop",
        "environment": "outdoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Rail-to-Casing Arcs",
                "problem": "Infrared video captures intermittent arcs from support rails to nearby housings during current peaks. Surface inspection shows pitting and carbonized paint along the arc path.",
                "success": "The team uses @techName to provide a low-impedance return and to balance the branch load. The arc count drops to zero, and thermal gradients flatten across the panel.",
                "fail": "The team lays an incomplete return path. The next peak finds the gap, and a longer arc scorches the housing face."
            },
            {
                "synergyTechniqueId": "bio-shielding",
                "title": "Live-Panel Service Under Load",
                "problem": "A critical module on the open switchrack cannot be de-energized. Transient spikes at the service edge threaten to exceed suit tolerances, with nothing between the work position and the live bus.",
                "success": "The team shapes the return network with @techName while @synergyTechName applies a conductive biofilm buffer across exposed seams. Spikes dissipate into the loop, and the crew completes the service.",
                "fail": "The team stabilizes the loop but leaves a bare seam. A transient slips to the suit interface, and the service is aborted."
            },
            {
                "synergyTechniqueId": "phase-anchor",
                "title": "Meter Drift at Peak Draw",
                "problem": "Voltage and phase readouts on the yard's meter cabinet diverge when the load reaches peak. Calibration checks pass at idle and fail on every ramp.",
                "success": "The team anchors the ground with @techName and stabilizes measurement nodes using @synergyTechName anchors. Instruments remain in agreement through the entire draw profile.",
                "fail": "The team secures the ground but leaves nodes unstable. The first fast ramp knocks the meters out of agreement, and calibration aborts."
            }
        ]
    },
    {
        "id": "hazard_mitigation_spore_vent_reclaimer_event",
        "relatedSkillId": "safeguard",
        "relatedTechniqueId": "spore-vent-reclaimer",
        "environment": "indoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Post-Fire Air",
                "problem": "After a small electrical fire, particulate counts and acid vapors accumulate at the ceiling vents. Suit filters approach their redline within minutes.",
                "success": "The team initiates @techName to purge contaminated air and recover it through staged filters. Particulate counts fall, and suit timers roll back into the green.",
                "fail": "The team runs an incomplete purge. Stale pockets cling in the corners, and filter strain remains high."
            },
            {
                "synergyTechniqueId": "photosymbiosis",
                "title": "Mask Relief",
                "problem": "Sustained purge cycles strain respirators during extended work. CO\u2082 spikes recur between cycles.",
                "success": "The team maintains @techName while @synergyTechName routes cleared air through active beds. CO\u2082 falls and mask load stabilizes for the remainder of the task.",
                "fail": "The team relies on purge alone. Mask alerts continue to trigger, and the work pauses repeatedly."
            },
            {
                "synergyTechniqueId": "depth-step",
                "title": "Pressure Swing Control",
                "problem": "Rapid room geometry shifts cause purge pressure swings that pop seals and backflow dust into clean areas.",
                "success": "The team times @techName cycles to the measured dips and uses @synergyTechName to hold a consistent depth during the exchange. Seals hold and the backflow stops.",
                "fail": "The team mistimes the cycle. A purge opens into a rising phase, seals lift, and dust re-enters the work zone."
            }
        ]
    },
    {
        "id": "hazard_mitigation_manual_override_line_event",
        "relatedSkillId": "safeguard",
        "relatedTechniqueId": "manual-override-line",
        "environment": "outdoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Unsafe Autoreclose",
                "problem": "A feeder recloser attempts to re-energize a suspect run automatically after each trip. Thermal images show arcing at a junction whenever power returns.",
                "success": "The team installs @techName to introduce a hard cut-off. The line remains open until the fault is cleared, and the junction cools to ambient.",
                "fail": "The team places the cut-off downstream of the fault. The next autoreclose arcs at the same junction and trips the feeder again."
            },
            {
                "synergyTechniqueId": "adaptive-lattice",
                "title": "Instant Leak Capture",
                "problem": "A pressurized fluid line shares the overhead tray with the feeder run. A pinhole leak atomizes across the pole-mounted cabinet every time the recloser trips.",
                "success": "The team ties @techName to trigger @synergyTechName lattice structures on cut. As the line opens, the lattice seals the pinhole and redirects spray away from electrical components.",
                "fail": "The team cuts power without integrating capture. The next trip drives a fresh burst into the cabinet and the cleanup expands."
            },
            {
                "synergyTechniqueId": "echo-fold",
                "title": "Failure Containment",
                "problem": "A cascading failure threatens to walk the feeder line pole to pole along the shared neutral. Every shift in the sagging span moves the fault path somewhere new.",
                "success": "The team sets the manual cut using @techName and checkpoints the safe geometry state with @synergyTechName. Fault energy stays within the isolated room and the cascade halts.",
                "fail": "The team opens the line but does not save the safe state. The next shift bridges to the neighboring busway and the cascade resumes."
            }
        ]
    },
    {
        "id": "quantum_analysis_entangled_synchrony_event",
        "relatedSkillId": "quantum-scan",
        "relatedTechniqueId": "entangled-synchrony",
        "environment": "indoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Out-of-Step Instruments",
                "problem": "Two scanner bays produce diverging timestamps for the same anomaly front. Route planning software oscillates between paths with each update.",
                "success": "The team uses @techName to hard-link update cadence across the bays. Timestamps converge, the model stabilizes, and a single route remains valid.",
                "fail": "The team links without compensating for transport delay. The next update splits the timestamps again, and the route collapses."
            },
            {
                "synergyTechniqueId": "phase-cleanse",
                "title": "Mixed Returns",
                "problem": "Energy spikes overlap faint organic signatures on the edge of the scan cone. Confidence scores drop below the safe threshold for passage. The synchronized scanners need to discriminate between noise and signal.",
                "success": "The team keeps cadence with @techName and applies cleansing pulses through @synergyTechName. The model separates the noise from the true organic signal, and the corridor qualifies as passable.",
                "fail": "The team applies the cleansing pulses with poor timing. The pulses interfere with the synchronized readings, smearing both datasets, and the planner rejects the corridor."
            },
            {
                "synergyTechniqueId": "echo-fold",
                "title": "Brownout Frames",
                "problem": "Intermittent dips on the bay supply wipe recent frames from the buffer before they are written. Patrols keep being sent back through spans both scanners have already covered.",
                "success": "The team maintains synchronization with @techName while @synergyTechName stages redundant frame caches. When a dip occurs, the planner reexport constructs the span from the cache and maintains the route.",
                "fail": "The team enables caching on the wrong interval. A dip lands between cache points, and the segment reverts to unknown."
            }
        ]
    },
    {
        "id": "quantum_analysis_bio_spectral_crosscheck_event",
        "relatedSkillId": "quantum-scan",
        "relatedTechniqueId": "bio-spectral-crosscheck",
        "environment": "indoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Ambiguous Returns",
                "problem": "Field readings and radiation peaks overlap within the scan cone. Confidence scores for safe passage fall below threshold.",
                "success": "The team employs @techName to correlate energy levels with known biological signatures. The model separates the fields and the corridor qualifies for transit.",
                "fail": "The team applies an incorrect correlation set. The model mislabels a hot pocket as safe, and the plan is rejected."
            },
            {
                "synergyTechniqueId": "biotrace-resonance",
                "title": "Hidden Channels",
                "problem": "Flat wall panels report uniform readings, yet intermittent drops suggest concealed cavities behind the surface.",
                "success": "The team runs @techName and overlays @synergyTechName pulses. Subsurface root channels appear as distinct tracks, and the route avoids collapsible spans.",
                "fail": "The team relies on surface readings only. The next step lands on a concealed channel and the span deforms under load."
            },
            {
                "synergyTechniqueId": "phase-cleanse",
                "title": "Contamination Film",
                "problem": "A thin contamination film skews energy measurements over two bays. Wipe tests confirm a residual layer across the floor.",
                "success": "The team maintains correlation with @techName and applies @synergyTechName feedback as they move. Readings normalize and the route holds.",
                "fail": "The team correlates correctly but never clears the film. Measurements drift again in the next bay and the model drops confidence."
            }
        ]
    },
    {
        "id": "quantum_analysis_ghost_echo_capture_event",
        "relatedSkillId": "quantum-scan",
        "relatedTechniqueId": "ghost-echo-capture",
        "environment": "indoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Residual Circuit Hunt",
                "problem": "Several panels draw trace current with no obvious source. Thermal imaging reveals faint warmth on two cable trays that should be de-energized.",
                "success": "The team uses @techName to measure residual current vectors and trace the still-active runs. The hidden feed is located and isolated.",
                "fail": "The team samples at too low a resolution. The vectors smear and the active run remains unidentified."
            },
            {
                "synergyTechniqueId": "shadowroot-bloom",
                "title": "Crack Sampling",
                "problem": "Hairline cracks in conduit joints likely trap residues that mark active runs, but surface swabs return inconclusive.",
                "success": "The team maps currents using @techName while @synergyTechName wicks trace particles from the cracks. The sample confirms the energized path and the isolation proceeds.",
                "fail": "The team draws samples without wicking the cracks. Residue remains trapped and the analysis stays inconclusive."
            },
            {
                "synergyTechniqueId": "echo-fold",
                "title": "Brownout Gaps",
                "problem": "Repeated brownouts interrupt long scans and leave gaps in the residual-current logs. The trays that matter are the ones the meter lost.",
                "success": "The team continues measurement with @techName and stages checkpoints via @synergyTechName. When a brownout hits, the dataset restores from the staged frames and the trace remains continuous.",
                "fail": "The team logs without checkpoints. The next brownout erases the segment and the trace must restart from the last known point."
            }
        ]
    }
];
var $979b99378be707cd$export$1cd1fab9b9844b76 = [
    {
        "id": "echo_mapping_quantum_relay_hook_event",
        "relatedSkillId": "echo-trace",
        "relatedTechniqueId": "quantum-relay-hook",
        "environment": "outdoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Line-of-Sight Bottleneck",
                "problem": "Packet traces show repeated collisions where the survey scanners and the team telemetry share the single clear sightline off the mast. Jitter and loss climb whenever both streams peak in the same interval.",
                "success": "The team employs @techName to establish an auxiliary hop with a cleaner phase reference, migrating map frames off the congested sightline. The telemetry stream holds continuity while the map transfer completes.",
                "fail": "The team anchors the auxiliary hop on a reflective node. Return echoes corrupt sequence numbers, and the session drops to recovery mode."
            },
            {
                "synergyTechniqueId": "relay-stabilizer",
                "title": "Slew-Induced Dropouts",
                "problem": "Mast tilt sensors register small but frequent slews in crosswinds. During each motion, the shared path between scanners and the relay loses coherence and map frames tear.",
                "success": "The team creates a secondary route with @techName and stabilizes the primary carrier using @synergyTechName. The two paths decouple cleanly and no frames tear during mast motion.",
                "fail": "The team brings up the secondary route but fails to hold the carrier. The next gust collapses both lanes into the same band and the transfer aborts."
            },
            {
                "synergyTechniqueId": "photosymbiosis",
                "title": "Occluded Approach Lanes",
                "problem": "Dense overgrowth has closed two of the approach lanes. Optical and RF scans attenuate sharply past the first bend and the route model refuses to stitch those spans; the growth is masking the true ground line.",
                "success": "The team extends a side hop with @techName and cultivates growth channels along the path using @synergyTechName. The growth guides the pulses around obstacles, the returns close the gaps, and the lanes appear as continuous tracks.",
                "fail": "The team sets relay hops but cultivates growth in the wrong orientation. The pulses refract unpredictably and the map retains discontinuities."
            }
        ]
    },
    {
        "id": "echo_mapping_biotrace_resonance_event",
        "relatedSkillId": "echo-trace",
        "relatedTechniqueId": "biotrace-resonance",
        "environment": "indoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Hidden Organic Corridors",
                "problem": "Standard scans report uniform walls, yet intermittent pressure changes and faint humidity spikes suggest concealed organic cavities behind the paneling.",
                "success": "The team uses @techName to emit short pulses that preferentially reflect off living material. Echo peaks sketch a subsurface corridor network that the route planner can trust.",
                "fail": "The team samples at an incorrect pulse width. Returns blur across the wall, and the corridor candidates remain inconclusive."
            },
            {
                "synergyTechniqueId": "bio-spectral-crosscheck",
                "title": "Growth Over Utilities",
                "problem": "Power and ventilation runs vanish beneath overgrowth; field probes cannot separate cable trays from living tissue, and clearance cannot be certified.",
                "success": "The team runs @techName to light organic structures and fuses energy-band data through @synergyTechName. The composite reveals where growth overlays live lines and vents, and a safe path is marked.",
                "fail": "The team misaligns the fusion window. Organic and electrical returns smear together, and the clearance check fails."
            },
            {
                "synergyTechniqueId": "phase-cleanse",
                "title": "Residual Film Artifacts",
                "problem": "After salvage, a thin residue film on floor plates produces speckled echoes that degrade map confidence across two bays.",
                "success": "The team profiles the bays with @techName while @synergyTechName disrupts the residue along the survey track. Speckle drops and the map resolves at the required confidence.",
                "fail": "The team records before breaking the film. Artifacts persist across passes, and the planner rejects the tiles."
            }
        ]
    },
    {
        "id": "echo_mapping_shadow_archive_event",
        "relatedSkillId": "echo-trace",
        "relatedTechniqueId": "shadow-archive",
        "environment": "indoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Brownout Map Loss",
                "problem": "Intermittent dips on the junction supply wipe the last seconds of survey data out of volatile buffers, and the same span has to be walked again to rebuild it.",
                "success": "The team employs @techName to persist map frames to portable memory at each survey gate. When a dip occurs, the route planner restores the tiles from the archive and the sweep continues.",
                "fail": "The team delays the checkpoint cadence. A dip lands between saves, and the corridor reverts to unknown."
            },
            {
                "synergyTechniqueId": "echo-pulse-beacon",
                "title": "High-Throughput Resurvey",
                "problem": "A multi-level junction requires frequent revisits after geometry shifts. Without anchors, drones spend cycles re-acquiring the junction on every pass.",
                "success": "The team posts lightweight anchors using @synergyTechName and commits snapshots into @techName on each pass. Drones lock to the anchors and skip redundant resurvey.",
                "fail": "The team archives without anchors. Each geometry shift invalidates the prior frames and the rescan overhead returns."
            },
            {
                "synergyTechniqueId": "silent-hand",
                "title": "Acoustic Disturbance Control",
                "problem": "In a vaulted gallery, footfall and drone noise reflect into the scan field, lowering confidence and prompting unnecessary detours.",
                "success": "The team records frames into @techName while @synergyTechName dampens acoustic edges along the route. Reflections subside, and the planner accepts a direct path.",
                "fail": "The team archives without damping. The next pass inherits the same reflection artifacts and the detours persist."
            }
        ]
    },
    {
        "id": "precision_lockbreaking_servo_alignment_tool_event",
        "relatedSkillId": "lock-breach",
        "relatedTechniqueId": "servo-alignment-tool",
        "environment": "outdoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Tone-Scrambled Latch",
                "problem": "Contact microphones on the blast door faceplate register a shifting interference tone inside the lock housing. Feedback traces smear across the pin stack every time the frame moves under residual load.",
                "success": "The team uses @techName to identify a stable resonance node and works the pins only within that window. The stack settles into sequence and the latch rotates without binding.",
                "fail": "The team commits on a false node. The tone drifts mid-turn, the feedback collapses, and the counter-spring snaps the housing to hard lock."
            },
            {
                "synergyTechniqueId": "manual-override-line",
                "title": "Micro-Window Alignment",
                "problem": "The anti-tamper coil behind the faceplate scrambles fine feedback every 170 milliseconds, closing the path before a full set can be completed. The latch and its housing only line up inside that window.",
                "success": "The team holds the resonance with @techName while @synergyTechName engages kill-switches to lock the housing frame during the quiet intervals. The pins set across consecutive windows and the faceplate opens cleanly.",
                "fail": "The team mis-times the override. The housing frame shifts before the stack fully sets, and the mechanism jolts back to lock."
            },
            {
                "synergyTechniqueId": "servo-containment",
                "title": "Cross-Band Suppression",
                "problem": "Spectral analysis shows a secondary carrier bleeding into the door housing from the junction box beside the frame. The cross-band tone masks the lowest latch pin entirely, and the housing seals have to stay intact while the team works.",
                "success": "The team seals the housing via @synergyTechName to block the interfering carrier and resumes fine work through @techName. With the band cleared, low pin feedback returns and the stack completes.",
                "fail": "The team fails to seal properly. The secondary carrier persists, masks the low pin, and the mechanism relocks after timeout."
            }
        ]
    },
    {
        "id": "precision_lockbreaking_biofilm_stabilizer_event",
        "relatedSkillId": "lock-breach",
        "relatedTechniqueId": "biofilm-stabilizer",
        "environment": "outdoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Rail Creep Compensation",
                "problem": "Micrometer checks on the door show the latch rails creeping under asymmetric tension as the frame settles into softened ground. The pick drifts off centre with each correction and the feedback stops being trustworthy.",
                "success": "The team applies @techName to lay a thin, compliant biofilm along the rail seams, equalizing micro-friction and damping lateral drift. The pick remains centered and the lock yields in order.",
                "fail": "The team spreads an uneven layer. A dry patch on the high rail catches the pick, the counter-spring loads suddenly, and the housing locks down."
            },
            {
                "synergyTechniqueId": "mycelial-rebalance",
                "title": "Rail & Tone Coordination",
                "problem": "Even with the frame drift arrested, a low oscillation remains in the door housing and flattens the tactile response on two mid pins. Organic residues packed into the mechanism are carrying the vibration.",
                "success": "The team stabilizes the rails with @techName and uses @synergyTechName to decompose organic buildup that is resonating at the problem frequency. The oscillation dampens and tactile response returns.",
                "fail": "The team stabilizes the rails but the biofilm rebalancer targets the wrong substrate. The resonance persists and the countermeasure coil arms the block."
            },
            {
                "synergyTechniqueId": "signal-mask-injection",
                "title": "Countermeasure Diversion",
                "problem": "A microphonic countermeasure watches the faceplate for vibration signatures and stiffens the stack whenever it recognises a pick pattern. The biofilm spread across the door can be made to carry the signal instead.",
                "success": "The team maintains seam stability with @techName while @synergyTechName injects spoofed vibration patterns into the biofilm that the countermeasure monitors. The monitor follows the injected rhythm and the true stack sets unopposed.",
                "fail": "The team maintains the seam but the injected signal carries too much of the true pattern. The monitor reacquires the real signature and the stack stiffens beyond workable force."
            }
        ]
    },
    {
        "id": "precision_lockbreaking_echo_pulse_decoy_event",
        "relatedSkillId": "lock-breach",
        "relatedTechniqueId": "echo-pulse-decoy",
        "environment": "outdoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Pattern-Learning Countermeasure",
                "problem": "Diagnostic taps at the door frame reveal that the lock records pick cadence and stiffens the matching pins on every later attempt. The learned pattern survives each reset.",
                "success": "The team employs @techName to project a deliberate, off-pattern cadence that the monitor adopts as the \u2018true\u2019 signal. While the system follows the decoy, the team completes the actual stack on a separate cadence.",
                "fail": "The team repeats an element of the prior cadence. The monitor matches the signature, the pins harden in sequence, and the window closes."
            },
            {
                "synergyTechniqueId": "command-cascade",
                "title": "Noise Cage Detuning",
                "problem": "Ambient noise off the open approach makes the countermeasure reject simple decoys; it will only adopt a new pattern from a clean channel, and the door housing screens the signal like a Faraday cage.",
                "success": "The team chains decoy directives via @synergyTechName to overwhelm the monitor's input stage and then drives the adoption rhythm via @techName. With the input saturated, the cascade locks the decoy pattern and the lock yields.",
                "fail": "The team deploys decoys too slowly. The monitor resolves individual pulses before the cascade builds, and the mechanism hardens after timeout."
            },
            {
                "synergyTechniqueId": "mutualist-growth",
                "title": "Cadence\u2013Resonance Bridge",
                "problem": "The faceplate rings close to the countermeasure's favored frequency, making the decoy cadence hard to hold through a full set. Growth pocketed in the door frame is feeding the resonance.",
                "success": "The team balances the cadence with @techName while @synergyTechName cultivates growth to dampen the resonance node. With the resonance absorbed by the pods, the decoy remains consistent and the stack completes.",
                "fail": "The team drives the cadence while cultivating pods in the wrong location. The resonance persists, the decoy wavers, and the countermeasure rejects the pattern."
            }
        ]
    },
    {
        "id": "stealth-transit_drone_path_shadow_event",
        "relatedSkillId": "stealth-transit",
        "relatedTechniqueId": "drone-path-shadow",
        "environment": "indoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Open-Span Traverse",
                "problem": "Line-of-sight analysis of a vaulted transfer hall shows periodic sweep cones from unattended optics. Drone telemetry reveals predictable transit lanes that cast moving shadow bands across the floor.",
                "success": "The team uses @techName to synchronize movement inside those shadow bands, matching speed and pause points to the airframe cadence. The silhouettes remain embedded in drone traces, and the traverse completes without a return ping.",
                "fail": "The team drifts a half step out of lane at a column gap. A silhouette crosses a lit band, the optics resolve a shape, and the alarm grid advances one state."
            },
            {
                "synergyTechniqueId": "pheromone-chorus",
                "title": "Dust-Flare Suppression",
                "problem": "High-angle lighting reveals dust flares whenever steps cross turbulent eddies near the span's midpoint. Flare spikes coincide with the optics' higher-confidence frames. Air currents carry behavioral cues that make observers relax.",
                "success": "The team rides @techName lanes and projects @synergyTechName calm signals along the route to suppress behavioral alerts in any watchers. The floor illumination remains uniform, and the confidence score never exceeds the alert threshold.",
                "fail": "The team follows the lanes but the pheromone signal fades in the eddies. Observers tense up at the correct moment and the sweep lingers over the span."
            },
            {
                "synergyTechniqueId": "rootpath-protocol",
                "title": "Specular Panel Timing",
                "problem": "Wall-mounted specular panels throw timed light bands across the path. Any unsynchronized crossing produces a distinct break in the reflection pattern. Drone routes can predict panel timing.",
                "success": "The team tracks lane cadence with @techName while @synergyTechName guides movement using cached drone navigation paths. Steps thread between bands; no reflection pattern breaks are recorded.",
                "fail": "The team mistimes the final panel. A stride clips a bright band, creating a discontinuity the watcher tags for review."
            }
        ]
    },
    {
        "id": "stealth-transit_spore_veil_event",
        "relatedSkillId": "stealth-transit",
        "relatedTechniqueId": "spore-veil",
        "environment": "indoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Scent-Track Washout",
                "problem": "Chemical sniffers positioned at door frames retain faint volatile traces for hours. A prior pass left a recoverable trail that aligns with the planned route.",
                "success": "The team employs @techName to project a low-density veil that binds and neutralizes volatile residues at knee height and below. Subsequent sniffer samples fall to background, and the route proceeds without a trackable trail.",
                "fail": "The team sets an uneven veil. A warm vent lifts untreated volatiles into the frame, and the trail persists across the threshold."
            },
            {
                "synergyTechniqueId": "reflex-bloom",
                "title": "Signature Merge",
                "problem": "An overhead watcher fuses optical and chemical cues. While residuals are low, silhouette breaks remain detectable along two open spans. Heat signatures also stand out in a cool environment.",
                "success": "The team neutralizes residues with @techName and cultivates @synergyTechName blooms to absorb and redistribute thermal signatures. Optical silhouettes blur, and the fusion model fails to correlate a human trace.",
                "fail": "The team clears scent but the blooms cultivate in the wrong thermal zones. Heat still concentrates and the watcher regains correlation at the second span."
            },
            {
                "synergyTechniqueId": "system-ground-loop",
                "title": "Reflective Hallway Control",
                "problem": "A polished conduit hall amplifies small disturbances in both air and light. Micro-reflections along the handrail telegraph footsteps as bright, periodic ticks. Static buildup also creates detectable reflections.",
                "success": "The team maintains the veil with @techName and grounds static charges along the route using @synergyTechName. The handrail trace remains flat without periodic ticks, and no static reflections are recorded.",
                "fail": "The team walks with the veil active but grounding fails mid-span. Static charges accumulate and produce twin ticks in the rail trace, prompting the watcher to rescan the hall."
            }
        ]
    },
    {
        "id": "stealth-transit_mirror_walk_event",
        "relatedSkillId": "stealth-transit",
        "relatedTechniqueId": "mirror-walk",
        "environment": "indoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Reflection-Phase Crossing",
                "problem": "A corridor lined with reflective panels creates moving interference fringes from a rotating lumen. Any footfall outside the dark fringes appears as a sharp phase break.",
                "success": "The team uses @techName to pace strides through the dark fringes, matching the rotation period so no phase breaks occur. The camera histogram remains unchanged while the squad clears the corridor.",
                "fail": "The team crosses a bright fringe during a tempo adjustment. The resulting phase break stamps a clear step signature onto the recording."
            },
            {
                "synergyTechniqueId": "rootpath-protocol",
                "title": "Fringe\u2013Lane Coupling",
                "problem": "Mid-corridor, the dark fringes drift out of alignment with the safest physical cover, forcing a choice between concealment patterns. Drone navigation data can resolve the timing of the drift.",
                "success": "The team tracks fringe timing with @techName and snaps movement onto @synergyTechName drone routes during the drift. The silhouettes stay embedded in lane shadows while remaining within the dark fringes.",
                "fail": "The team favors the visual fringe but the drone route diverges. A shoulder edge intersects a bright band, and the watcher flags the anomaly."
            },
            {
                "synergyTechniqueId": "pheromone-chorus",
                "title": "Heat Plume Artifacts",
                "problem": "Thermal cameras at the corridor exit read small heat plumes off textiles after exertion. The plumes bloom when the reflection pattern forces a short sprint. Observers also rely on behavioral cues to notice the exertion.",
                "success": "The team maintains fringe pacing with @techName and projects @synergyTechName calm signals to damp observer alertness as the team reaches the exit. Behavioral cues flatten, and thermal readings stay below the gate's detection threshold.",
                "fail": "The team sprints the last band without dampening behavioral cues. The pheromone signal fails to reach observers and the exit camera marks the passage."
            }
        ]
    },
    {
        "id": "ghost_infiltration_control_spoof_event",
        "relatedSkillId": "signal-mask",
        "relatedTechniqueId": "control-spoof",
        "environment": "outdoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Whitelisted Channel Gate",
                "problem": "The checkpoint controller accepts only whitelisted directive classes. Every out-of-policy opcode that reaches the pedestal steps a suspicion counter on its face.",
                "success": "The team uses @techName to remap outbound directives into permitted packet classes with the correct timing jitter. The audit daemon records routine activity and the gate remains permissive.",
                "fail": "The team remaps headers but misses the inter-packet spacing. The timing profile deviates from policy and the controller drops the session."
            },
            {
                "synergyTechniqueId": "shared-immunity",
                "title": "Biometric Cross-Check",
                "problem": "The controller pairs command-bus signatures with trace biometrics lifted off the gate panel. A mismatched pair quarantines the port and the barrier stays down.",
                "success": "The team frames the directives with @techName and applies @synergyTechName to shift biometric baselines toward a neutral profile. The fused record shows a consistent identity and the quarantine logic does not engage.",
                "fail": "The team masks traffic but the immunity profile remains incomplete. The cross-check correlates the mismatch and forces the port into lockdown."
            },
            {
                "synergyTechniqueId": "command-cascade",
                "title": "Log-Window Persistence",
                "problem": "The pedestal keeps a rolling high-resolution log of recent directives. A pattern repeated inside that window raises the alert level at the gate.",
                "success": "The team shapes allowed opcodes via @techName and chains spoofed directives using @synergyTechName to mask the true pattern. The window advances with only baseline and decoy entries and the alert level remains low.",
                "fail": "The team deploys spoofs too slowly. The pattern detector acquires the true cadence before the cascade builds and isolates the segment."
            }
        ]
    },
    {
        "id": "ghost_infiltration_bio_id_mask_event",
        "relatedSkillId": "signal-mask",
        "relatedTechniqueId": "bio-id-mask",
        "environment": "outdoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Residual Print Gate",
                "problem": "Sensor wafers at the cabinet read faint skin volatiles and trace oils for several hours. The gate rejects sessions when a fresh print conflicts with the cached baseline.",
                "success": "The team employs @techName to bind and neutralize volatiles at the contact surfaces, then backfills a low-noise baseline. The gate compares against the baseline and admits the session.",
                "fail": "The team masks the handle but ignores the hinge and shroud. Residuals bleed into the sample and the cabinet denies access."
            },
            {
                "synergyTechniqueId": "signal-mask-injection",
                "title": "Policy-Concordant Session",
                "problem": "Even with chemical neutrality at the wafers, the gate flags directive classes that do not match the maintenance patterns it was left authorised for.",
                "success": "The team maintains the neutral surface with @techName and injects masked signals via @synergyTechName to reframe the command stream toward an approved maintenance pattern. The policy engine downgrades risk and the session persists.",
                "fail": "The team sustains chemical neutrality but the masked signal fails to align. The engine detects policy deviation and tears down the session."
            },
            {
                "synergyTechniqueId": "signal-harmonizer",
                "title": "Audit Scrub Timing",
                "problem": "The cabinet rolling audit replaces detailed frames with summaries every two minutes. Anything done out of step with that cycle stays in the log at full fidelity.",
                "success": "The team holds the neutral profile using @techName and harmonizes operational signals through @synergyTechName to blend with background patterns. The audit rollup captures only summaries and no anomalies are retained.",
                "fail": "The team executes with unharmonized signals. Full-fidelity frames capture the operation and the audit daemon requests review."
            }
        ]
    },
    {
        "id": "ghost_infiltration_echo_loop_event",
        "relatedSkillId": "signal-mask",
        "relatedTechniqueId": "echo-loop",
        "environment": "outdoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Repeating Log Window",
                "problem": "The gate controller holds a tight high-resolution window of recent events. Entries that age out collapse to coarse summaries, but everything inside the current slice keeps precise timestamps.",
                "success": "The team uses @techName to align activity with the log scrubbing cadence so full-fidelity entries age out immediately. Only coarse summaries remain before correlation can occur.",
                "fail": "The team performs the operation off-cycle. The high-resolution slice persists long enough for cross-correlation and the port is flagged."
            },
            {
                "synergyTechniqueId": "silent-channel",
                "title": "Benign Rewrite",
                "problem": "The watcher on the pedestal compares parameter deltas between successive configuration frames. An atypical delta raises the alarm even when the timing is masked.",
                "success": "The team times the window with @techName and pipes dummy parameter deltas through @synergyTechName silent channels to mask the true delta. The watcher reads the rewrite as a benign refresh and does not escalate.",
                "fail": "The team masks timing but the silent channel carries too much true signal. The watcher detects deviation and escalates."
            },
            {
                "synergyTechniqueId": "mycelial-rebalance",
                "title": "Contact Echo Suppression",
                "problem": "Microphones set into the gate panel capture short acoustic signatures during service and cross-reference them against the log window. Organic decomposition muffles the echoes.",
                "success": "The team schedules edits with @techName and decomposes acoustic signatures using @synergyTechName fungal filters at the panel surface. Cross-reference returns no match and the window rolls forward unremarked.",
                "fail": "The team aligns the edits but the fungal filter activates too late. An acoustic tick propagates and links to the window."
            }
        ]
    },
    {
        "id": "reality_displacement_phase_anchor_event",
        "relatedSkillId": "transit-anchor",
        "relatedTechniqueId": "phase-anchor",
        "environment": "outdoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Shallow Wave Crossing",
                "problem": "Instrumented markers show the crossing alternating between stable and low-friction states every thirty seconds. Geometry telemetry confirms a shallow wave running the length of the span.",
                "success": "The team deploys @techName to pin the span during a stable phase and advances the squad before the next low-friction interval. The route holds long enough for a controlled traverse.",
                "fail": "The team commits at the wrong phase. The surface degrades underfoot and the crossing becomes impassable."
            },
            {
                "synergyTechniqueId": "mutualist-growth",
                "title": "Offset Layer Bridge",
                "problem": "Gap sensors report a widening discontinuity along the seam of the span; the shallow layer no longer overlaps for the full crossing.",
                "success": "The team secures the near edge with @techName and uses @synergyTechName to cultivate pods that span the offset. The traverse completes over the organic bridge.",
                "fail": "The team anchors the near edge but cultivates pods on the unstable shallow layer. The pods collapse and the squad is forced to retreat."
            },
            {
                "synergyTechniqueId": "organic-link-adapter",
                "title": "Memory Drift Control",
                "problem": "Headcam frames fade out during each phase shift, and the crew loses the safe line across the span every time the surface moves under them.",
                "success": "The team sets anchors with @techName and threads bio-fiber through @synergyTechName to lock visual reference markers. When the span blurs, the squad follows the anchored line across.",
                "fail": "The team sets anchors but the bio-fiber fails to hold during a phase shift. The reference points slip and the route cannot be re-established in time."
            }
        ]
    },
    {
        "id": "reality_displacement_depth_step_event",
        "relatedSkillId": "transit-anchor",
        "relatedTechniqueId": "depth-step",
        "environment": "outdoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Sinking Span Detour",
                "problem": "Load cells report a progressive loss of support in the central span. The shallow surface carries weight for only a few seconds before collapsing into a softer layer.",
                "success": "The team employs @techName to descend onto a firmer underlying layer and route the traverse along that depth. The squad bypasses the failing surface entirely.",
                "fail": "The team steps down onto a pocket of the same weak layer. The footing shears and the route collapses before the last runner crosses."
            },
            {
                "synergyTechniqueId": "shadowroot-bloom",
                "title": "Mixed-Depth Hold",
                "problem": "A stretch of the span alternates between two usable depths and never holds either long enough to reposition safely.",
                "success": "The team steps down to the sturdier depth via @techName and cultivates @synergyTechName blooms at both edges for stable anchor points. The hold window lengthens enough for a controlled handover.",
                "fail": "The team steps down but cultivates blooms in soil too unstable. The alternation resumes mid-transfer and the line scrambles back to the starting side."
            },
            {
                "synergyTechniqueId": "spore-vent-reclaimer",
                "title": "Layer Map Persistence",
                "problem": "Depth telemetry across the span blinks out during transitions and the planner keeps discarding half-built layer maps.",
                "success": "The team maintains the chosen depth with @techName while @synergyTechName coordinates purge cycles to preserve telemetry windows. Layer maps remain coherent and when telemetry blinks, the map restores and the traverse continues.",
                "fail": "The team travels without purge coordination. A blink clears the partial map and the traverse must restart from the last known marker."
            }
        ]
    },
    {
        "id": "reality_displacement_echo_fold_event",
        "relatedSkillId": "transit-anchor",
        "relatedTechniqueId": "echo-fold",
        "environment": "outdoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Phase-Blur Archive",
                "problem": "During geometry fluctuations the survey cameras smear and drop frames, erasing the alignment that marked the last safe crossing.",
                "success": "The team uses @techName to buffer and replay clean visual frames at fixed posts, restoring a stable reference for foot placement. The crossing repeats along the recorded line.",
                "fail": "The team fails to capture a clean baseline. The next fluctuation wipes the visual record and the reference is lost."
            },
            {
                "synergyTechniqueId": "entangled-synchrony",
                "title": "Pinned Reference Posts",
                "problem": "Buffered frames drift against the live scene whenever the span shears sideways by a few centimetres.",
                "success": "The team establishes synchronized scan anchors with @synergyTechName and aligns the replayed frames from @techName to those anchors. The reference and the live scene remain in register through the shear.",
                "fail": "The team replays frames against a drifting synchronized scan. The next shear misaligns the reference and the crossing stalls."
            },
            {
                "synergyTechniqueId": "dim-shift-layer",
                "title": "Vertical Discontinuity",
                "problem": "Frame buffers cannot account for the sudden drop where the span steps down to a lower layer partway across.",
                "success": "The team augments the replay via @techName and uses @synergyTechName to adjust the lighting profile at the marked point where the floor drops. The buffered path continues smoothly across the discontinuity as the layer auto-tunes.",
                "fail": "The team follows the replay without adjusting the lighting profile. The vertical offset interrupts the line and the squad loses the path mid-span."
            }
        ]
    }
];
var $979b99378be707cd$export$9435522665f2dda4 = [
    {
        "id": "organic_salvage_reclamation_drone_link_event",
        "relatedSkillId": "reclamation",
        "relatedTechniqueId": "reclamation-drone-link",
        "environment": "outdoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Culvert Bed Collapse",
                "problem": "Inspection feeds show a salvage bed that has slumped into a drainage culvert. Rot-gas pockets and interlocked fiber mats prevent a clean lift; gas sensors spike when the mats are disturbed.",
                "success": "The team uses @techName to choreograph staged pulls that vent pockets before lift baskets take load. The mats separate in layers, and the culvert remains stable during extraction.",
                "fail": "The team hooks a bonded slab without a staged vent. A pocket ruptures under load, slurry surges into the trench, and the lift aborts."
            },
            {
                "synergyTechniqueId": "coordinated-flight-pattern",
                "title": "Vertical Shaft Clearance",
                "problem": "A vertical shaft contains heavy mycelial slabs but lacks safe hand access. Rotor wash destabilizes the rim whenever a single drone attempts a lift.",
                "success": "The team links claws through @techName and staggers hover lanes with @synergyTechName. Slabs clear vertically without clipping the rim, and the shaft wall remains intact.",
                "fail": "The team mis-times the stagger. Two frames cross lanes, clip the rim, and a wall section sloughs into the shaft."
            },
            {
                "synergyTechniqueId": "shadow-archive",
                "title": "Hidden Brace Recovery",
                "problem": "Historic cut lines do not match the current growth. Previous passes likely left buried braces under the bed; probe strikes return inconsistent depth.",
                "success": "The team queries prior frames via @synergyTechName and guides the rig using @techName along the original cut paths. Braces are exposed in sequence and the lifts proceed without tearing the casing.",
                "fail": "The team trusts a corrupted frame. The claw catches a brace, the mat rips against the casing, and the pull is abandoned."
            }
        ]
    },
    {
        "id": "organic_salvage_mycelial_rebalance_event",
        "relatedSkillId": "reclamation",
        "relatedTechniqueId": "mycelial-rebalance",
        "environment": "outdoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Starved\u2013Overfed Bed",
                "problem": "Nutrient telemetry shows alternating bands of depleted and oversaturated substrate within the salvage bed. Gas probes register volatile surges whenever the oversaturated band vents.",
                "success": "The team uses @techName to redistribute nutrients across the strata, damping the volatile surges and equalizing moisture so the lift sequence can proceed.",
                "fail": "The team over-corrects the saturated band. A delayed vent ignites a fresh surge, and the extraction halts under alarm."
            },
            {
                "synergyTechniqueId": "spore-vent-reclaimer",
                "title": "Purge and Balance",
                "problem": "Headspace samples contain acid vapors and fine particulates trapped above the bed. Uneven substrate prevents a clean purge cycle.",
                "success": "The team rebalances the strata using @techName while @synergyTechName performs staged purges at the vent crowns. Vapors clear, and the bed remains stable through extraction.",
                "fail": "The team rebalances after the purge begins. A pocket opens under pressure, pushing vapor through the crew lane and aborting the run."
            },
            {
                "synergyTechniqueId": "biofilm-stabilizer",
                "title": "Edge Shear Control",
                "problem": "Core samples at the cut boundary show slumping micro-layers that tear when lifted, risking wall collapse.",
                "success": "The team restores nutrient symmetry with @techName and paints a thin stabilizing film via @synergyTechName along the boundary. The lift holds, and the wall remains intact.",
                "fail": "The team omits the film at a weak seam. The boundary shears under load, and the section must be repacked."
            }
        ]
    },
    {
        "id": "organic_salvage_phase_cleanse_event",
        "relatedSkillId": "reclamation",
        "relatedTechniqueId": "phase-cleanse",
        "environment": "indoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Contaminant Bloom",
                "problem": "Swab tests reveal a reactive film over tools and crate interiors. The film blooms under humidity, fouling seals and instruments.",
                "success": "The team uses @techName to apply low-intensity cleansing cycles that break down the film without damaging organics. Seals pass inspection and instruments read nominal.",
                "fail": "The team runs an aggressive cycle. Tool grips craze, and the salvage crate liner fails QA."
            },
            {
                "synergyTechniqueId": "echo-pulse-beacon",
                "title": "Residue Mapping",
                "problem": "Visual inspection misses residual pockets in a vented gallery. Air samples fluctuate, but the contamination pattern is unclear.",
                "success": "The team maps the gallery with @synergyTechName to locate speckle clusters, then targets @techName precisely on those sites. Residues fall below detection limits across the span.",
                "fail": "The team cleans without a map. Pockets reform in the blind corners, and the gallery fails follow-up sampling."
            },
            {
                "synergyTechniqueId": "quantum-relay-hook",
                "title": "Selective Preservation",
                "problem": "The contamination film overlays a live symbiont layer that must remain intact for later harvest. Relay-mapped boundary data is unclear because the live layer reflects scanner noise.",
                "success": "The team uses @synergyTechName to relay-scan the live-layer boundary with noise-filtered precision, then gates @techName to spare those zones. The film clears while the symbiont layer remains viable.",
                "fail": "The team gates incorrectly. The cleanse cycle etches the live layer, and the harvest is lost."
            }
        ]
    },
    {
        "id": "growth_manipulation_adaptive_lattice_event",
        "relatedSkillId": "growth-control",
        "relatedTechniqueId": "adaptive-lattice",
        "environment": "outdoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Walkway Sag Remediation",
                "problem": "A walkway over a feeder trench shows measurable mid-span sag. Plates oilcan under footfall, and two handrail posts twist out of plumb.",
                "success": "The team employs @techName to cultivate a ribbed subframe beneath the worst deflection and rebinds the plates to grade. Deflection readings return to nominal.",
                "fail": "The team accelerates growth beyond the cure window. Fresh ribs buckle under residual load and the plates shift farther out of level."
            },
            {
                "synergyTechniqueId": "relay-stabilizer",
                "title": "Mast Lean Arrest",
                "problem": "A relay mast set in saturated soil leans by a small offset each hour. Link statistics show alignment drift during gusts.",
                "success": "The team grows a living buttress with @techName and maintains strict carrier control via @synergyTechName while the footing resets. Alignment holds through the wind cycle.",
                "fail": "The team braces the mast but neglects carrier discipline. The next gust reintroduces drift, and the long-haul link drops frames."
            },
            {
                "synergyTechniqueId": "phase-anchor",
                "title": "Subgrade Root Withdrawal",
                "problem": "Support roots have invaded the service run beneath the trench. Surface pruning only triggers regrowth from deeper runners, and the run closes again by the end of the day.",
                "success": "The team extends lattice guides with @techName and anchors the deep runners in place using @synergyTechName stabilizers. Roots remain redirected and the crawl stays clear.",
                "fail": "The team clears only the surface runners. Deeper growths break the anchors and reassert by evening, occlud ing the crawl space again."
            }
        ]
    },
    {
        "id": "growth_manipulation_photosymbiosis_event",
        "relatedSkillId": "growth-control",
        "relatedTechniqueId": "photosymbiosis",
        "environment": "indoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "CO\u2082 Load Relief",
                "problem": "Air monitors show sustained CO\u2082 above safe limits in a sealed work bay. Mechanical scrubbers are offline, and crews cannot remain at post.",
                "success": "The team deploys @techName to activate symbiotic photo-beds along the bay perimeter. CO\u2082 trends down steadily, and the bay becomes habitable for the repair window.",
                "fail": "The team activates beds without establishing airflow. CO\u2082 pools persist near the deck, and mask timers remain in the red."
            },
            {
                "synergyTechniqueId": "spore-vent-reclaimer",
                "title": "Breathable Cycle Control",
                "problem": "Intermittent spore releases coincide with high CO\u2082 periods, forcing alternating evacuations and resets.",
                "success": "The team maintains photo uptake with @techName while @synergyTechName schedules coordinated purges. The atmosphere stabilizes and work proceeds without evacuation.",
                "fail": "The team staggers purges out of phase. A release lands during peak CO\u2082 and the bay locks down again."
            },
            {
                "synergyTechniqueId": "spore-veil",
                "title": "Optics Preservation",
                "problem": "Fine spores settle on camera domes and light panels, reducing effective illumination for alignment tasks.",
                "success": "The team drives photo-beds via @techName and casts @synergyTechName across optics. Settling drops to background, and alignment completes within tolerance.",
                "fail": "The team relies on uptake alone. Dome fouling worsens, and the alignment window is missed."
            }
        ]
    },
    {
        "id": "growth_manipulation_shadowroot_bloom_event",
        "relatedSkillId": "growth-control",
        "relatedTechniqueId": "shadowroot-bloom",
        "environment": "outdoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Substrate Bridging",
                "problem": "A trench separates two platforms with no intact decking. Load tests show the lip cannot support a rigid span.",
                "success": "The team deploys @techName to coax subsurface root channels into a distributed bridge beneath the lip. The traverse carries weight without point loads.",
                "fail": "The team overconcentrates growth on one side. The bridge torques under the first step, and the crossing is aborted."
            },
            {
                "synergyTechniqueId": "ghost-echo-capture",
                "title": "Active Run Avoidance",
                "problem": "Residual-current traces suggest a hidden energized conduit beneath the trench. Direct probing risks a fault.",
                "success": "The team maps the energized run using @synergyTechName and steers @techName around it. The bridge forms clear of the hazard and remains stable under test load.",
                "fail": "The team misreads the trace. Roots contact the live run, and the platform trips a breaker mid-growth."
            },
            {
                "synergyTechniqueId": "biotrace-resonance",
                "title": "Cavity Discovery",
                "problem": "Uneven settling implies voids in the bank. A blind bridge may collapse into an unseen cavity.",
                "success": "The team scans for subsurface voids with @synergyTechName and grows @techName only across verified dense channels. The span keeps grade through the traverse.",
                "fail": "The team omits the scan. A central void opens under load, and the span shears at mid-crossing."
            }
        ]
    },
    {
        "id": "creature_pacification_signal_harmonizer_event",
        "relatedSkillId": "wild-influence",
        "relatedTechniqueId": "signal-harmonizer",
        "environment": "outdoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Territorial Run Standoff",
                "problem": "A nesting pair has taken the only traversable run through the yard. Scratch marks, nest material and warning postures block the direct line.",
                "success": "The team projects a low-amplitude calming pattern with @techName and paces the pair down a side channel. The run clears without agitation.",
                "fail": "The team introduces the pattern too abruptly. The pair surges toward the mouth of the run and the traverse is suspended."
            },
            {
                "synergyTechniqueId": "command-cascade",
                "title": "Turret\u2013Herd Interference",
                "problem": "A perimeter turret sweeps across a grazing drift. Tagging events on the herd coincide with safety lockouts on the yard gate.",
                "success": "The team stabilizes herd movement using @techName and sequences the turret to a safe idle via @synergyTechName. Tagging stops and the yard gate releases.",
                "fail": "The team calms the herd but launches the cascade off schedule. The turret resumes sweep mid-pass and safety relays trip again."
            },
            {
                "synergyTechniqueId": "bio-id-mask",
                "title": "Residual Scent Loop",
                "problem": "Trace volatiles along the gateposts and vent stacks pull the pack back to the same choke points. A prior traverse left a recoverable trail.",
                "success": "The team maintains the calming field with @techName and neutralizes residuals using @synergyTechName. The pack loses the trail and forages away from the route.",
                "fail": "The team clears the threshold but overlooks the vent baffle. The pack reacquires the trail and blocks the crossing."
            }
        ]
    },
    {
        "id": "creature_pacification_pheromone_chorus_event",
        "relatedSkillId": "wild-influence",
        "relatedTechniqueId": "pheromone-chorus",
        "environment": "outdoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Misdirected Drift",
                "problem": "A foraging drift keeps blocking the intended passage. Trail cams show it keying to an old scent line running along the perimeter wall.",
                "success": "The team projects a layered @techName signal that reorients the drift toward a harmless loop across the adjacent apron. The passage remains clear.",
                "fail": "The team sets an incomplete chord. The drift splits, half doubling back into the passage and forcing a halt."
            },
            {
                "synergyTechniqueId": "coordinated-flight-pattern",
                "title": "Guide Lane Establishment",
                "problem": "Scattered wreckage across the open ground leaves the drift no clear edge to follow; it stalls and eddies right across the squad route.",
                "success": "The team lays a pheromone chord via @techName while @synergyTechName sweeps a moving visual lane overhead. The animals adopt the lane and move cleanly away from the route.",
                "fail": "The team deconflicts flight lanes but mistunes the chord. The drift ignores the lane and clumps at the choke."
            },
            {
                "synergyTechniqueId": "mirror-walk",
                "title": "Light-Pattern Entrapment",
                "problem": "Sun off the standing panels throws bright bands across the ground, and the herd agitates every time it has to cross one.",
                "success": "The team sustains the chord with @techName and times movement through dark bands using @synergyTechName. The herd crosses without agitation and disperses.",
                "fail": "The team breaks cadence at the final band. The herd startles, and the passage closes again."
            }
        ]
    },
    {
        "id": "creature_pacification_silent_hand_event",
        "relatedSkillId": "wild-influence",
        "relatedTechniqueId": "silent-hand",
        "environment": "indoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Handler Noise Isolation",
                "problem": "Acoustic logs show handler footfall and gear clicks exceeding the alert threshold in a confined hall. Animals freeze or bolt on approach.",
                "success": "The team applies @techName to suppress near-field mechanical and fabric noise at contact points. The approach reads below threshold and the animals hold calm.",
                "fail": "The team misses a loose buckle. A sharp click carries, and the group scatters into the passage."
            },
            {
                "synergyTechniqueId": "silent-channel",
                "title": "RF\u2013Acoustic Concordance",
                "problem": "A watcher correlates RF bursts with acoustic spikes to detect presence in the hall.",
                "success": "The team damps acoustic signatures with @techName and smears RF emission timing via @synergyTechName. The concordance engine loses correlation and the pass completes.",
                "fail": "The team quiets the approach but transmits on a fixed cadence. The engine re-establishes correlation and flags the movement."
            },
            {
                "synergyTechniqueId": "quantum-relay-hook",
                "title": "Noise Memory Suppression",
                "problem": "The hall retains sharp transients in logged clips that are replayed during audits. Relay-relayed data carries the full acoustic spectrum.",
                "success": "The team maintains @techName while @synergyTechName relays only low-noise frame snapshots, filtering transients at the relay node. The audit sees no actionable clip and the audit level drops.",
                "fail": "The team leaves a transient unfiltered at the relay. The clip persists and the route is closed for review."
            }
        ]
    },
    {
        "id": "symbiotic_adaptation_bio_shielding_event",
        "relatedSkillId": "bio-shield",
        "relatedTechniqueId": "bio-shielding",
        "environment": "indoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Micro-Stinger Air",
                "problem": "Air sampling in the pump gallery detects suspended micro-stingers. Unprotected skin exhibits immediate reactions; crews cannot remain on task.",
                "success": "The team applies @techName to lay a thin, conductive biofilm across suit seams and visors. Measured sting counts fall below safe limits and work resumes.",
                "fail": "The team spreads an incomplete buffer. Stings slip through a seam and the operation halts."
            },
            {
                "synergyTechniqueId": "system-ground-loop",
                "title": "Arc Hazard Mitigation",
                "problem": "A live panel near the gallery emits occasional arc pops to damp surfaces, startling workers and risking burns.",
                "success": "The team reinforces the return path using @synergyTechName and maintains the biofilm buffer with @techName. Discharges sink into the loop and the task completes without excursions.",
                "fail": "The team lays the biofilm but leaves the return path floating. An arc lands across an exposed seam and the crew withdraws."
            },
            {
                "synergyTechniqueId": "bio-id-mask",
                "title": "Contamination Trail Control",
                "problem": "Sticky spore residue on gloves and boots prints a trail into clean zones. Surface fluorescence persists in follow-up scans.",
                "success": "The team seals contact surfaces via @techName and masks the residue signature with @synergyTechName at each boundary. Walk-backs cease printing and scans find no matching signature.",
                "fail": "The team seals poorly at a threshold. Residue tracks across the boundary and the zone fails inspection."
            }
        ]
    },
    {
        "id": "symbiotic_adaptation_shared_immunity_event",
        "relatedSkillId": "bio-shield",
        "relatedTechniqueId": "shared-immunity",
        "environment": "outdoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Localized Irritant",
                "problem": "A resinous irritant accumulates on a service line. Contact causes rash and eye irritation within minutes.",
                "success": "The team uses @techName to seed a transferable micro-biotic layer across gloves and masks, neutralizing the resin on contact. Work resumes without reactions.",
                "fail": "The team applies an uneven layer. A bare knuckle prints resin to the face seal, and the task stops for decon."
            },
            {
                "synergyTechniqueId": "bio-feedback-guard",
                "title": "Stability During Spikes",
                "problem": "When a pump cycle surges, the irritant concentration rises abruptly at the service point.",
                "success": "The team sustains the shared layer with @techName and cushions spikes using @synergyTechName on the supply line. Concentration plateaus, and PPE loads remain within limits.",
                "fail": "The team relies on the shared layer alone. A surge overcomes the buffer, and exposure crosses the threshold."
            },
            {
                "synergyTechniqueId": "bio-id-mask",
                "title": "Inspection Gate Pass",
                "problem": "A fixed inspector gate samples for trace metabolites unique to the shared layer and flags them as contamination.",
                "success": "The team maintains the layer via @techName and masks the metabolite signature with @synergyTechName so it reads as background flora. The gate reports within norms and the pass is authorized.",
                "fail": "The team crosses without masking. The gate detects the metabolite markers and closes the line."
            }
        ]
    },
    {
        "id": "symbiotic_adaptation_dim_shift_layer_event",
        "relatedSkillId": "bio-shield",
        "relatedTechniqueId": "dim-shift-layer",
        "environment": "indoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Glimmer Reduction",
                "problem": "Low-angle cameras detect fabric sheen and micro-glints on motion, elevating detection scores in a patrol gallery.",
                "success": "The team spreads @techName as a directional matte that suppresses glints along the patrol axis. Detection scores fall below the alert threshold.",
                "fail": "The team orients the layer to the wrong axis. Glints persist at camera angles, and the patrol escalates the sweep."
            },
            {
                "synergyTechniqueId": "entangled-synchrony",
                "title": "Sensor Agreement",
                "problem": "Optical and depth sensors disagree during motion, causing the planner to distrust the corridor.",
                "success": "The team applies @techName to steady optical signatures and locks update cadence with @synergyTechName. The sensors agree, and the corridor is accepted.",
                "fail": "The team mats optics but leaves cadence drifting. Disagreement returns and the route is rejected."
            },
            {
                "synergyTechniqueId": "echo-fold",
                "title": "Frame Persistence",
                "problem": "Rapid lighting shifts erase short-term references for the squad\u2019s position in a mirrored hall.",
                "success": "The team sustains the matte via @techName and buffers clean frames with @synergyTechName at fixed posts. References persist through shifts and the hall is cleared.",
                "fail": "The team proceeds without buffering. A lighting swing wipes references and the line stalls."
            }
        ]
    },
    {
        "id": "biohazard_recovery_servo_containment_event",
        "relatedSkillId": "containment",
        "relatedTechniqueId": "servo-containment",
        "environment": "outdoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Burst Pod Spill",
                "problem": "A row of seed pods ruptured after a pressure swing. Viscous bloom coats the floor and clogs the lower vents; draw falls by half.",
                "success": "The team cages the spill with @techName and strips the bloom in controlled passes, clearing vents before they choke. Airflow returns to nominal.",
                "fail": "The team cages the wrong section first. The spill creeps along the vent intakes and the wing fills with sweet vapor."
            },
            {
                "synergyTechniqueId": "organic-link-adapter",
                "title": "Live Slurry Joint",
                "problem": "A flex joint on the live slurry line seeps. Approaching the joint without disturbing the bed has repeatedly failed.",
                "success": "The team times a low-phase window using @synergyTechName and sets the cage via @techName while the bed is quiescent. The joint seals without waking the bed.",
                "fail": "The team misses the quiet phase. The bed flares, the cage jams half-set, and the repair is abandoned."
            },
            {
                "synergyTechniqueId": "servo-alignment-tool",
                "title": "Choked Intake",
                "problem": "A bolus of pulp sits behind the intake screen; the lung wheezes at half draw despite repeated cycles.",
                "success": "The team aligns the shutter stack with @synergyTechName and pulses a controlled pull through @techName. The bolus breaks, the screen clears, and draw returns to spec.",
                "fail": "The team cycles the shutter off time. The bolus compacts against the screen and the draw drops further."
            }
        ]
    },
    {
        "id": "biohazard_recovery_mutualist_growth_event",
        "relatedSkillId": "containment",
        "relatedTechniqueId": "mutualist-growth",
        "environment": "indoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Toxic Surface Binding",
                "problem": "Bench swabs show a persistent toxic residue that reappears after standard wipes. The residue spreads under heat.",
                "success": "The team cultivates @techName across the work surface to bind and metabolize the residue. Follow-up swabs return clean and the bench remains stable under load.",
                "fail": "The team seeds an incompatible culture. The residue persists and spreads into tool racks."
            },
            {
                "synergyTechniqueId": "manual-override-line",
                "title": "Fail-Safe Decon",
                "problem": "The residue source intermittently injects fresh contamination from an upstream valve when power cycles.",
                "success": "The team binds the surface with @techName and interlocks the upstream valve using @synergyTechName. Injections cease and the decon holds.",
                "fail": "The team binds the bench but leaves the valve uncontrolled. A power cycle re-seeds the surface, forcing a restart."
            },
            {
                "synergyTechniqueId": "echo-pulse-decoy",
                "title": "Wear Resistance",
                "problem": "Heavy tool traffic abrades the cultured layer faster than it can recover, reopening contamination spots. Wear patterns are visible under close inspection.",
                "success": "The team cultivates @techName with protective pods while @synergyTechName injects decoy wear signatures elsewhere. Actual wear stays concealed and the surface remains clean through the shift.",
                "fail": "The team omits the decoy pattern. Real wear becomes visible and the bench fails inspection."
            }
        ]
    },
    {
        "id": "biohazard_recovery_reflex_bloom_event",
        "relatedSkillId": "containment",
        "relatedTechniqueId": "reflex-bloom",
        "environment": "indoor",
        "rewards": {
            "deriveFromCrafting": true
        },
        "variants": [
            {
                "title": "Rapid Spill Neutralization",
                "problem": "A transport cart overturns, releasing a reactive slurry across a sloped floor. The spill advances toward a drain that feeds a clean zone.",
                "success": "The team triggers @techName to raise fast-growing absorbent mats along the downslope. The spill arrests at the mats and is lifted in sections.",
                "fail": "The team seeds too sparsely. The spill threads gaps between mats and breaches the drain grate."
            },
            {
                "synergyTechniqueId": "coordinated-flight-pattern",
                "title": "Timed Drop Coverage",
                "problem": "Multiple spill fronts advance simultaneously in a large hall. Manual placement cannot cover all fronts in time.",
                "success": "The team stages mats with @techName and coordinates drone drops via @synergyTechName on a shared timer. Coverage meets the fronts and the hall is secured.",
                "fail": "The team mis-times the drops. A front outruns the coverage and enters the stairwell."
            },
            {
                "synergyTechniqueId": "spore-veil",
                "title": "Aerosol Suppression",
                "problem": "As the mats engage, aerosol counts spike above safe limits near the ceiling returns.",
                "success": "The team continues mat deployment with @techName and casts @synergyTechName across the return path. Aerosol counts fall below threshold and cleanup proceeds.",
                "fail": "The team neglects the return path. Aerosols trip the clean-zone intake and force an evacuation."
            }
        ]
    }
];
var $979b99378be707cd$export$aeeef991191508e2 = {
    dominion: {
        name: "Dominion",
        icon: "\uD83D\uDD27",
        description: "Engineers and systems tacticians who restore, command, and repurpose lost technology in collapsed zones.",
        doctrine: "Doctrine: the collapse was machine logic outgrowing its makers. Recover the systems, and prove they can be governed.",
        skills: {
            "signal-relay": {
                icon: "\uD83D\uDCE1",
                name: "Signal Relay",
                description: "Reestablish or hijack long-range comms and data channels. Critical for network access and relay synchronization.",
                short: "Rebuilds or hijacks damaged communication networks."
            },
            "system-override": {
                icon: "\uD83D\uDCBB",
                name: "System Override",
                description: "Force reboots or assume control of compromised automation, defense turrets, or AI cores.",
                short: "Takes control of hostile machines or security systems."
            },
            "drone-command": {
                icon: "\uD83E\uDD16",
                name: "Drone Command",
                description: "Deploy autonomous or semi-autonomous drones for recon, repair, or field logistics.",
                short: "Uses drones for recon, repair, or support tasks."
            },
            "safeguard": {
                icon: "\u26A0\uFE0F",
                name: "Safeguard",
                description: "Reinforce failing circuits and safety systems to neutralize energy surges, power faults, or mechanical hazards.",
                short: "Restores stability to compromised power or safety systems."
            },
            "quantum-scan": {
                icon: "\uD83D\uDD2C",
                name: "Quantum Scan",
                description: "Map rift distortions and energy signatures. Essential for predicting anomaly behavior and safe extraction routes.",
                short: "Scans anomalies to predict energy patterns and distortions."
            }
        }
    },
    wilders: {
        name: "Wilders",
        icon: "\uD83C\uDF3F",
        description: "Biotech operatives and survival engineers dedicated to restoring life systems and adapting to hostile biomes.",
        doctrine: "Doctrine: the collapse was the living world rejecting a synthetic one. Read what survived; it knows more than we do.",
        skills: {
            "reclamation": {
                icon: "\uD83C\uDF31",
                name: "Reclamation",
                description: "Harvest bioactive compounds and structural tissue from degraded ecosystems for reuse or study.",
                short: "Extracts valuable bio-materials from decayed environments."
            },
            "growth-control": {
                icon: "\uD83C\uDF3F",
                name: "Growth Control",
                description: "Trigger accelerated plant or fungal growth to reinforce cover, create paths, or seal breaches.",
                short: "Uses rapid growth to shape terrain or create cover."
            },
            "wild-influence": {
                icon: "\uD83E\uDD8E",
                name: "Wild Influence",
                description: "Apply biochemical signals or pheromone fields to calm or redirect aggressive wildlife.",
                short: "Calms or redirects aggressive wildlife using biotech signals."
            },
            "bio-shield": {
                icon: "\uD83E\uDDEC",
                name: "Bio Shield",
                description: "Enhance resistance to toxins, pathogens, and radiation through symbiotic nanobiotics.",
                short: "Boosts resistance to toxins and harsh environments."
            },
            "containment": {
                icon: "\u2623\uFE0F",
                name: "Containment",
                description: "Stabilize contaminated zones and safely extract volatile organic material for research or trade.",
                short: "Recovers resources from contaminated or hazardous biozones."
            }
        }
    },
    veil: {
        name: "Veil",
        icon: "\uD83D\uDC64",
        description: "Infiltrators and intelligence specialists operating beyond conventional detection.",
        doctrine: "Doctrine: the collapse was oversight failing, then covering for itself. Recover the records nobody meant to leave behind.",
        skills: {
            "echo-trace": {
                icon: "\uD83D\uDDFA\uFE0F",
                name: "Echo Trace",
                description: "Use reflected signals to reveal hidden paths and phase corridors within unstable structures.",
                short: "Reveals hidden rooms and routes using signal resonance."
            },
            "lock-breach": {
                icon: "\uD83D\uDD13",
                name: "Lock Breach",
                description: "Bypass hardened locks, vaults, and access gates using precision tools and exploit mapping.",
                short: "Bypasses security locks and restricted access systems."
            },
            "stealth-transit": {
                icon: "\uD83D\uDC64",
                name: "Stealth Transit",
                description: "Traverse sensor grids and motion fields undetected. Minimizes signature footprint during raids.",
                short: "Moves unseen through sensor and motion grids."
            },
            "signal-mask": {
                icon: "\uD83D\uDC7B",
                name: "Signal Mask",
                description: "Scramble biometric, radio, and digital traces to evade active tracking systems.",
                short: "Erases traces to evade tracking and surveillance."
            },
            "transit-anchor": {
                icon: "\uD83C\uDF00",
                name: "Transit Anchor",
                description: "Deploy stabilization anchors and mapping scanners to cross collapsed or structurally unstable terrain safely.",
                short: "Stabilizes collapsed terrain for safe traversal."
            }
        }
    }
};
var $979b99378be707cd$export$34780191873b7917 = {
    dominion: {
        names: [
            "Cipher",
            "Circuit",
            "Nova",
            "Volt",
            "Nexus",
            "Binary",
            "Synth",
            "Logic",
            "Vector",
            "Matrix",
            "Atlas",
            "Chrome",
            "Pulse",
            "Core",
            "Apex",
            "Titan",
            "Forge",
            "Grid",
            "Node",
            "Prime",
            "Beacon",
            "Prism",
            "Zenith",
            "Vortex",
            "Helix",
            "Cortex",
            "Axis",
            "Flux",
            "Echo",
            "Surge"
        ],
        surnames: [
            "Steelwright",
            "Circuitborn",
            "Wireframe",
            "Dataforge",
            "Ironcode",
            "Techbane",
            "Gridlock",
            "Megabyte",
            "Quantumspark",
            "Neurolink",
            "Gearsmith",
            "Boltweaver",
            "Chromeheart",
            "Sparkforge",
            "Titanshield",
            "Datastream",
            "Wireborn",
            "Primecore",
            "Vaultkeeper",
            "Ciphersong",
            "Powergrid",
            "Logicblade",
            "Nanotech",
            "Cybervault",
            "Mechanix",
            "Voltstream",
            "Bytebane",
            "Coderune",
            "Synthwave",
            "Nexusforge"
        ]
    },
    wilders: {
        names: [
            "Sage",
            "Thorn",
            "Moss",
            "Fern",
            "Root",
            "Bloom",
            "Grove",
            "Ivy",
            "Cedar",
            "Briar",
            "Hazel",
            "Ash",
            "Elm",
            "Oak",
            "Pine",
            "Birch",
            "Willow",
            "Maple",
            "Aspen",
            "Laurel",
            "Clover",
            "Meadow",
            "Reed",
            "Sorrel",
            "Basil",
            "Juniper",
            "Cypress",
            "Alder",
            "Rowan",
            "Yarrow"
        ],
        surnames: [
            "Greenmane",
            "Thornweaver",
            "Rootwalker",
            "Wildgrow",
            "Mosscloak",
            "Seedwhisper",
            "Fernblade",
            "Vineborn",
            "Petalstorm",
            "Barkskin",
            "Leafdancer",
            "Brambleheart",
            "Dewsong",
            "Earthshade",
            "Wildroot",
            "Stormgrow",
            "Branchbinder",
            "Flowersong",
            "Earthkeeper",
            "Treeborne",
            "Raincaller",
            "Windleaf",
            "Sunpetal",
            "Moonblossom",
            "Wildmane",
            "Spiritseed",
            "Grovewalker",
            "Thornshield",
            "Lifewoven",
            "Forestborn"
        ]
    },
    veil: {
        names: [
            "Shadow",
            "Wraith",
            "Mist",
            "Echo",
            "Shade",
            "Whisper",
            "Ghost",
            "Raven",
            "Void",
            "Phantom",
            "Dusk",
            "Twilight",
            "Nocturne",
            "Umbra",
            "Gloom",
            "Haze",
            "Murk",
            "Shimmer",
            "Shroud",
            "Veil",
            "Smoke",
            "Mirage",
            "Specter",
            "Sable",
            "Onyx",
            "Obsidian",
            "Eclipse",
            "Nebula",
            "Drift",
            "Abyss"
        ],
        surnames: [
            "Shadowmere",
            "Voidwalker",
            "Nightfall",
            "Darkweaver",
            "Mistral",
            "Grimshade",
            "Blackdrift",
            "Ghostbane",
            "Veilborn",
            "Wraithcloak",
            "Nightwhisper",
            "Duskblade",
            "Silentmoon",
            "Darkmist",
            "Voidheart",
            "Shadowstride",
            "Ghostwind",
            "Nightveil",
            "Phantomborn",
            "Dimwalker",
            "Umbramere",
            "Eclipsesoul",
            "Twilightborne",
            "Duskmantle",
            "Murkweaver",
            "Hazewalker",
            "Smokesinger",
            "Gloomward",
            "Shroudkeeper",
            "Mirageborn"
        ]
    }
};
var $979b99378be707cd$export$3e15389530921005 = {
    material: {
        common: [
            "Scavenged parts\u2014still serviceable.",
            "Field scrap, stripped clean of charge.",
            "Useful metal, no corrosion yet.",
            "Reclaimed fittings\u2014just needs polish.",
            "Someone\u2019s repair job didn\u2019t hold, but the parts did."
        ],
        rare: [
            "Intact components\u2014hard find this deep.",
            "Precision stock, good for another build.",
            "Recovered hardware, still calibrated.",
            "High-grade alloy, likely pre-Collapse.",
            "Pulled from the wreck, still hums faintly."
        ]
    },
    consumable: {
        common: [
            "Standard stim\u2014quick and dirty relief.",
            "Energy patch\u2014buys a few more steps.",
            "A dose of focus, if it hasn\u2019t expired.",
            "Compact charge\u2014barely enough, but enough.",
            "You\u2019ve used worse in the field."
        ],
        rare: [
            "Advanced formula, field-sealed.",
            "Med injector, smooth burn and clean recovery.",
            "Military-issue charge, still stable.",
            "Restores more than it should\u2014must be real stock.",
            "Save it for when the lights go red."
        ],
        epic: [
            "Top-tier stabilizer, rare to see intact.",
            "Restores everything but your luck.",
            "Combat-grade surge, keep it steady.",
            "Proprietary compound\u2014whatever\u2019s inside, it works.",
            "Last-resort aid. You won\u2019t find another soon."
        ]
    },
    relic: {
        common: [
            "Old-world scrap\u2014still has form, not function.",
            "Traces of utility, stripped long ago.",
            "A small story, buried in rust.",
            "Every mark means it mattered to someone.",
            "Forgotten tool, remembered by the metal."
        ],
        rare: [
            "Recovered relic with partial circuitry.",
            "Design\u2019s old, but the craftsmanship holds.",
            "It hums when touched\u2014residual charge, maybe.",
            "Half-art, half-instrument\u2014purpose unclear.",
            "Recovered from deeper layers, mostly intact."
        ],
        epic: [
            "Pristine core\u2014untouched since the Fall.",
            "A perfect survivor of imperfect times.",
            "Feels almost deliberate that it lasted.",
            "The lines are clean, the memory sharper.",
            "Carries weight that\u2019s more than metal."
        ]
    },
    blueprint: {
        legendary: [
            "Detailed schematic\u2014someone planned to rebuild.",
            "Blueprint sealed under dust and heat.",
            "This map shows what was possible once.",
            "A guide to lost craftsmanship, now in your hands.",
            "If you can read it, you can make it real."
        ]
    },
    storyRelic: {
        unique: [
            "It vibrates faintly, like it remembers you.",
            "What it shows isn\u2019t gone\u2014just out of reach.",
            "Feels heavier than it looks. Memory weight.",
            "History condensed into one impossible fragment.",
            "It doesn\u2019t tell stories\u2014it keeps them."
        ]
    },
    credits: {
        currency: [
            "Still accepted by the desperate and the wise.",
            "Old world money, still spinning through new hands.",
            "Trade keeps the silence at bay.",
            "Worth more in motion than in storage.",
            "Proof that some systems never collapse."
        ]
    }
};
var $979b99378be707cd$export$ca2adec0fe632974 = {
    dominion: [
        "Factory specs check out.",
        "Data tag matches.",
        "Keep it cataloged.",
        "Run diagnostics."
    ],
    wilders: [
        "Smells alive.",
        "Roots remember.",
        "Still breathing.",
        "Handle like it grows."
    ],
    veil: [
        "No witnesses.",
        "Leave no trace.",
        "Not on any manifest.",
        "Burn the logs."
    ]
};
var $979b99378be707cd$export$732c9d6827dc2245 = {
    hazard: [
        "ion-stained",
        "biofilm slick",
        "burnt edges",
        "cracked seals",
        "chemical haze"
    ],
    location: [
        "collapsed gantry",
        "sealed rack",
        "growth-choked vent",
        "sunken conduit",
        "buried access point"
    ],
    action: [
        "pried free",
        "cut loose",
        "lifted clean",
        "extracted carefully",
        "dug out by hand"
    ]
};
var $979b99378be707cd$export$9be8953559278e7 = {
    // === DOMINION ===
    "signal-relay": {
        roles: [
            "Comms Tech",
            "Relay Engineer",
            "Signal Operator",
            "Data Link Specialist",
            "Transceiver Mechanic"
        ],
        // Command-rank counterparts, index-matched to roles[] (assigned at promotion)
        promotedRoles: [
            "Signals Directorate Chief",
            "Relay Network Commander",
            "Uplink Operations Director",
            "Data Corridor Overseer",
            "Transmission Fleet Marshal"
        ],
        // Welcome from a command member, index-matched to promotedRoles[]
        // (shown in the promote dialog when the new post is announced)
        promotedQuotes: [
            "\u201CEvery frequency the Dominion holds now routes through your desk. Speak, and the whole network leans in to listen.\u201D",
            "\u201CThe towers you patched under fire are a war map on your wall now. Keep every line singing, Commander.\u201D",
            "\u201CGround to orbit, orbit to home \u2014 the uplink schedule is yours. Nothing leaves this world without your signature.\u201D",
            "\u201CYou walked the data corridors when they were static and ruin. Now every packet that survives the wastes pays toll to you.\u201D",
            "\u201CThe relay fleet answers to your call sign now, Marshal. Where you park those dishes decides who gets heard.\u201D"
        ],
        quotes: [
            "\u201CNoise is just data waiting to be translated.\u201D",
            "\u201CEvery message finds its way eventually.\u201D",
            "\u201CDead air is still information.\u201D",
            "\u201CI speak fluent interference.\u201D",
            "\u201CYou can\u2019t hide from a tuned array.\u201D"
        ]
    },
    "system-override": {
        roles: [
            "Control Hacker",
            "Override Specialist",
            "Security Engineer",
            "Core Manipulator",
            "Protocol Breacher"
        ],
        promotedRoles: [
            "Intrusion Doctrine Chief",
            "Override Command Architect",
            "Security Directorate Head",
            "Core Systems Overseer",
            "Protocol Warfare Strategist"
        ],
        promotedQuotes: [
            "\u201CYour field exploits are the textbook now, Chief. Every recruit learns to break a system the way you broke a hundred.\u201D",
            "\u201CYou built override rigs from scrap while sirens screamed. Design our command architecture \u2014 this time nothing pushes back.\u201D",
            "\u201CThe Dominion\u2019s locks, walls, and watchdogs report to you now. Nobody gets past what you couldn\u2019t get past first.\u201D",
            "\u201CEvery core we still control hums under your hand, Overseer. Keep them obedient \u2014 you know exactly how they fail.\u201D",
            "\u201CYou out-argued hostile machines at gunpoint. Now you write the protocols that win before the argument starts.\u201D"
        ],
        quotes: [
            "\u201CGive me root access and ten seconds.\u201D",
            "\u201CSystems break themselves\u2014I just hurry them along.\u201D",
            "\u201CFirewalls are for decoration.\u201D",
            "\u201CI don\u2019t bypass security\u2014I rewrite it.\u201D",
            "\u201CEvery system obeys; it just needs persuasion.\u201D"
        ]
    },
    "drone-command": {
        roles: [
            "Drone Pilot",
            "Field Operator",
            "Remote Systems Tech",
            "Autonomy Engineer",
            "Aerial Recon Chief"
        ],
        promotedRoles: [
            "Drone Wing Commander",
            "Field Operations Director",
            "Remote Fleet Coordinator",
            "Autonomy Program Chair",
            "Recon Command Marshal"
        ],
        promotedQuotes: [
            "\u201CThe wings you flew solo now fly in your formation, Commander. A thousand rotors hold pattern waiting on your word.\u201D",
            "\u201CField operations runs on your playbook now. Every operator down-well moves the way you taught the machines to move.\u201D",
            "\u201CEvery drone the Dominion fields checks home to your board. Route them well \u2014 you remember what the ground costs.\u201D",
            "\u201CYour autonomy heuristics graduate today, Chair. Teach the fleet to think the way you flew: carefully, and all the way home.\u201D",
            "\u201CThe recon wing is yours, Marshal. Nothing crosses the wastes unseen while your birds are up.\u201D"
        ],
        quotes: [
            "\u201CIf it\u2019s in range, it\u2019s in control.\u201D",
            "\u201CYou can\u2019t ambush a drone with anxiety.\u201D",
            "\u201CThree drones, two hands, one coffee.\u201D",
            "\u201CNever send a person when a circuit will do.\u201D",
            "\u201CMy drones have more personality than most people.\u201D"
        ]
    },
    "safeguard": {
        roles: [
            "Hazard Control Officer",
            "Containment Engineer",
            "Field Safety Tech",
            "Thermal Specialist",
            "Environmental Regulator"
        ],
        promotedRoles: [
            "Hazard Doctrine Commander",
            "Containment Program Director",
            "Field Safety Commandant",
            "Thermal Systems Overseer",
            "Environmental Command Chief"
        ],
        promotedQuotes: [
            "\u201CYour close calls became checklists, and your checklists became doctrine. Crews come home now because once, you almost didn\u2019t.\u201D",
            "\u201CThe containment program carries your name in its footnotes, Director. Run it so no one ever learns what it contains.\u201D",
            "\u201CCommandant of everything that keeps a raider breathing. Drill them hard \u2014 the wastes drill harder.\u201D",
            "\u201CEvery reactor jacket and heat sink in the fleet is your watch now. Cold numbers, warm crews.\u201D",
            "\u201CThe habitat domes hold because somebody obsessed over seals and sensors. Keep obsessing, Chief.\u201D"
        ],
        quotes: [
            "\u201CIf you\u2019re sweating, it\u2019s already too late.\u201D",
            "\u201CNothing\u2019s unmanageable\u2014just unprepared for.\u201D",
            "\u201CFire, gas, acid\u2014same dance, different tempo.\u201D",
            "\u201CI clean up everyone else\u2019s mistakes.\u201D",
            "\u201CYou\u2019ll thank me when you\u2019re still breathing.\u201D"
        ]
    },
    "quantum-scan": {
        roles: [
            "Rift Analyst",
            "Anomaly Researcher",
            "Quantum Field Tech",
            "Data Collapse Theorist",
            "Reality Modeler"
        ],
        promotedRoles: [
            "Rift Intelligence Chief",
            "Anomaly Research Director",
            "Quantum Survey Commander",
            "Collapse Theory Chair",
            "Reality Modeling Overseer"
        ],
        promotedQuotes: [
            "\u201CYou read the rifts back when reading them cost people their minds. Every anomaly report crosses your desk first now.\u201D",
            "\u201CThe research wing is yours, Director. Chase what the collapse left behind \u2014 carefully. Some of it chases back.\u201D",
            "\u201CEvery survey grid we chart follows your calibrations now, Commander. Map the impossible; the fleet steers by it.\u201D",
            "\u201CYour models kept this Chair empty until someone could actually fill it. Sit down.\u201D",
            "\u201CReality bends near the shards, Overseer. Your models are the only straight lines we trust.\u201D"
        ],
        quotes: [
            "\u201CThe math doesn\u2019t lie, but it does laugh.\u201D",
            "\u201CObserve first. Panic later.\u201D",
            "\u201CReality jitters; I just measure the tremor.\u201D",
            "\u201CPrediction is just organized superstition.\u201D",
            "\u201CIf you can\u2019t explain it, log it twice.\u201D"
        ]
    },
    // === WILDERS ===
    "reclamation": {
        roles: [
            "Bio-Salvager",
            "Tissue Reclaimer",
            "Eco-Recycler",
            "Harvest Operative",
            "Spore Diver"
        ],
        promotedRoles: [
            "Salvage Circle Elder",
            "Reclamation Warden",
            "Renewal Council Chief",
            "Harvest Doctrine Keeper",
            "Deep Spore Marshal"
        ],
        promotedQuotes: [
            "\u201CThe Salvage Circle keeps a seat of ruin-wood for you, Elder. What you pulled from the wreckage taught us what was worth pulling.\u201D",
            "\u201CWarden of everything the world threw away. Walk the reclaim-fields and decide what gets a second life.\u201D",
            "\u201CThe Renewal Council speaks with your voice now. Where you point, the green follows.\u201D",
            "\u201CYou gathered when gathering was starving work. Keep the harvest doctrine, and no circle goes hungry again.\u201D",
            "\u201CThe deep spore beds answer to you now, Marshal. Tend what grows in the dark \u2014 it remembers who fed it.\u201D"
        ],
        quotes: [
            "\u201CEvery ruin has roots.\u201D",
            "\u201CDecay\u2019s just another kind of growth.\u201D",
            "\u201CYou find beauty in the rot.\u201D",
            "\u201CNature wastes nothing\u2014why should I?\u201D",
            "\u201CDead ecosystems make the best teachers.\u201D"
        ]
    },
    "growth-control": {
        roles: [
            "Spore Architect",
            "Growth Technician",
            "Bio-Builder",
            "Verdant Engineer",
            "Mycelial Sculptor"
        ],
        promotedRoles: [
            "Architect of the Canopy",
            "Growth Doctrine Warden",
            "Living Works Overseer",
            "Verdant Command Elder",
            "Mycelial Council Chief"
        ],
        promotedQuotes: [
            "\u201CThe canopy you coaxed over ruins now shades three settlements. Architect, the skyline is yours to grow.\u201D",
            "\u201CGrowth without doctrine is just another collapse. You learned where the line is \u2014 hold it for all of us.\u201D",
            "\u201CEvery living wall and root-bridge we raise is your works order now, Overseer. Build us shelter that heals itself.\u201D",
            "\u201CThe Verdant Command has an elder\u2019s place ready. You made the wastes bloom on a schedule; teach us the timing.\u201D",
            "\u201CThe mycelial web already knows your hands. Chief, sit with the Council \u2014 the network has been asking for you.\u201D"
        ],
        quotes: [
            "\u201CYou don\u2019t build walls\u2014you grow them.\u201D",
            "\u201CPatience is the fastest method.\u201D",
            "\u201CGive it time and light\u2014it\u2019ll move mountains.\u201D",
            "\u201CBlueprints are for people who don\u2019t trust roots.\u201D",
            "\u201CEvery structure wants to bloom.\u201D"
        ]
    },
    "wild-influence": {
        roles: [
            "Beast Handler",
            "Bio-Communicator",
            "Eco-Mediator",
            "Creature Whisperer",
            "Wildlife Operative"
        ],
        promotedRoles: [
            "Beastmaster General",
            "Communion Council Elder",
            "Mediation Doctrine Keeper",
            "Whisper Circle Warden",
            "Wildlands Marshal"
        ],
        promotedQuotes: [
            "\u201CThe herds that once scattered raiding parties now hold our perimeter. General, the wild fights beside us because of you.\u201D",
            "\u201CYou listened when everything out there wanted us dead. The Communion Council keeps an elder\u2019s seat for the best listener we have.\u201D",
            "\u201CEvery truce between tooth and settlement follows your mediation doctrine now. Keep the peace you invented.\u201D",
            "\u201CWarden of the Whisper Circle. The creatures already answer to your voice \u2014 now our handlers will too.\u201D",
            "\u201CThe wildlands between the circles are yours to marshal. Nothing moves out there you don\u2019t already understand.\u201D"
        ],
        quotes: [
            "\u201CEverything alive understands tone.\u201D",
            "\u201CYou calm the world by moving slower.\u201D",
            "\u201CTrust starts with eye contact\u2014even with fangs.\u201D",
            "\u201CPredators aren\u2019t cruel, just honest.\u201D",
            "\u201CFear smells louder than blood.\u201D"
        ]
    },
    "bio-shield": {
        roles: [
            "Bio-Resonant Operative",
            "Adaptive Host",
            "Symbiosis Technician",
            "Mutation Researcher",
            "Genetic Integrator"
        ],
        promotedRoles: [
            "Resonance Doctrine Elder",
            "Adaptation Council Chief",
            "Symbiosis Program Warden",
            "Mutation Studies Chair",
            "Integration Command Elder"
        ],
        promotedQuotes: [
            "\u201CYour body learned the wastes\u2019 frequencies before our instruments did. Elder, the resonance doctrine is written from your scars.\u201D",
            "\u201CThe Adaptation Council needs a chief who changed instead of breaking. Show the circles how to bend.\u201D",
            "\u201CWarden of every paired life in the program. What grows on us, grows with us \u2014 you proved that first.\u201D",
            "\u201CThe Mutation Studies Chair is not a safe seat. You\u2019ve never once asked for a safe seat.\u201D",
            "\u201CIntegration is the long war, Elder \u2014 flesh, spore, and machine learning to share a body politic. Command it kindly.\u201D"
        ],
        quotes: [
            "\u201CAdapt or decompose.\u201D",
            "\u201CEvolution doesn\u2019t wait for permission.\u201D",
            "\u201CIf it itches, it\u2019s working.\u201D",
            "\u201CYou call it infection\u2014I call it upgrade.\u201D",
            "\u201CChange hurts. That\u2019s how you know it\u2019s real.\u201D"
        ]
    },
    "containment": {
        roles: [
            "Hazmat Reclaimer",
            "Biohazard Diver",
            "Containment Scout",
            "Toxic Zone Operative",
            "Decon Specialist"
        ],
        promotedRoles: [
            "Quarantine Council Chief",
            "Deep Hazard Warden",
            "Containment Doctrine Keeper",
            "Exclusion Zone Marshal",
            "Decontamination Elder"
        ],
        promotedQuotes: [
            "\u201CThe Quarantine Council answers to the one person who never cut a corner on a seal. Chief, the lines you draw hold.\u201D",
            "\u201CWarden of the deep hazards. What sleeps below the reclaim-fields stays asleep on your watch.\u201D",
            "\u201CYour containment rites are doctrine now, Keeper. Teach them exactly \u2014 the spores don\u2019t forgive improvisation.\u201D",
            "\u201CThe exclusion zones are mapped in your handwriting, Marshal. Keep the living side of every fence living.\u201D",
            "\u201CElder of the cleansing pools. Everything that comes home from the wastes passes through your hands first.\u201D"
        ],
        quotes: [
            "\u201CIf it glows, bag it.\u201D",
            "\u201CSafety\u2019s a spectrum.\u201D",
            "\u201CYou can\u2019t clean the world, just manage it.\u201D",
            "\u201CI\u2019ve seen things grow where nothing should.\u201D",
            "\u201CIf the mask fogs, run.\u201D"
        ]
    },
    // === VEIL ===
    "social-engineering": {
        roles: [
            "Persuasion Analyst",
            "Influence Operative",
            "Behavioral Infiltrator",
            "Social Architect",
            "Echo Diplomat"
        ],
        promotedRoles: [
            "Persuasion Directorate Head",
            "Influence Network Handler",
            "Behavioral Doctrine Chief",
            "Grand Social Architect",
            "Shadow Envoy Prime"
        ],
        promotedQuotes: [
            "\u201CYou talked your way past things that don\u2019t have ears. The Persuasion Directorate is yours \u2014 mind the mirrors.\u201D",
            "\u201CEvery asset, informant, and friendly stranger in five regions now reports to your ledger, Handler.\u201D",
            "\u201CYour read on a room became our behavioral doctrine, Chief. People are locks; you wrote the picks.\u201D",
            "\u201CArchitect, the web of favors you spun in the field holds half our operations aloft. Keep spinning.\u201D",
            "\u201CEnvoy Prime. When the Veil must be seen, it will wear your face \u2014 and no one will remember it.\u201D"
        ],
        quotes: [
            "\u201CTruth is just confidence with better posture.\u201D",
            "\u201CEveryone wants to believe they\u2019re in control.\u201D",
            "\u201CLies travel faster when you smile.\u201D",
            "\u201CI sell trust, not information.\u201D",
            "\u201CIf you think I\u2019m honest, I\u2019ve already won.\u201D"
        ]
    },
    "echo-trace": {
        roles: [
            "Echo Listener",
            "Trace Analyst",
            "Sonar Operator",
            "Signal Tracker",
            "Resonance Scout"
        ],
        promotedRoles: [
            "Echo Doctrine Keeper",
            "Trace Directorate Head",
            "Deep Sonar Marshal",
            "Tracking Cell Handler",
            "Resonance Intelligence Chief"
        ],
        promotedQuotes: [
            "\u201CYou heard the city\u2019s bones settle and knew which rooms were safe. Keeper, the echo doctrine is your ear, written down.\u201D",
            "\u201CThe Trace Directorate follows anything that leaves a ripple. Head it \u2014 nothing has ever slipped past you twice.\u201D",
            "\u201CDeep Sonar Marshal. The sunken levels talk in pressure and echo, and you\u2019re the only one fluent.\u201D",
            "\u201CYour cells can find a heartbeat in a hurricane now, Handler. Teach them which heartbeats matter.\u201D",
            "\u201CChief of Resonance Intelligence: every hum, knock, and silence the Veil records is evidence on your desk.\u201D"
        ],
        quotes: [
            "\u201CEverything leaves an echo. I just wait for it.\u201D",
            "\u201CSilence has a shape, if you listen.\u201D",
            "\u201CThe walls talk. I take notes.\u201D",
            "\u201CYou can stop moving. You can\u2019t stop resonating.\u201D",
            "\u201CI found you three corridors ago.\u201D"
        ]
    },
    "lock-breach": {
        roles: [
            "Breach Tech",
            "Vault Specialist",
            "Security Bypass Expert",
            "Lockpulse Engineer",
            "Intrusion Mechanic"
        ],
        promotedRoles: [
            "Breach Doctrine Master",
            "Vault Directorate Head",
            "Bypass Program Chief",
            "Lockpulse Guild Master",
            "Intrusion Cell Handler"
        ],
        promotedQuotes: [
            "\u201CEvery door you opened quietly is a chapter in the breach doctrine now. Master, teach the click before the open.\u201D",
            "\u201CThe Vault Directorate keeps what the Veil cannot afford to lose. Fitting that its head is the one no vault could keep out.\u201D",
            "\u201CChief of the bypass program: every lock the collapse left behind, catalogued, studied, and already yours.\u201D",
            "\u201CThe Lockpulse Guild took a vote. It was unanimous, Master \u2014 even the abstentions were just showing respect.\u201D",
            "\u201CYour cells work doors on three continents now, Handler. None of them will ever know your name. That\u2019s the compliment.\u201D"
        ],
        quotes: [
            "\u201CEverything opens with the right rhythm.\u201D",
            "\u201CSecurity is a suggestion.\u201D",
            "\u201CLocks are just puzzles with pride.\u201D",
            "\u201CThe click before the open is the best sound.\u201D",
            "\u201CIf I can\u2019t open it, it\u2019s cursed.\u201D"
        ]
    },
    "stealth-transit": {
        roles: [
            "Stealth Operative",
            "Scout",
            "Field Infiltrator",
            "Veil Runner",
            "Low-Signature Agent"
        ],
        promotedRoles: [
            "Infiltration Doctrine Lead",
            "Pathfinder Directorate Head",
            "Deep Cover Handler",
            "First Runner of the Veil",
            "Ghost Protocol Chief"
        ],
        promotedQuotes: [
            "\u201CThe routes you walked alone are the infiltration doctrine now. Lead, and the Veil moves where you moved.\u201D",
            "\u201CPathfinder Directorate is yours. Every safe corridor on the map exists because you crossed it first, unsafely.\u201D",
            "\u201CYour covers held longer than some careers. Handler, run the deep assets \u2014 you know what the silence costs them.\u201D",
            "\u201CFirst Runner. When there is no route, no map, and no time, the Veil sends you. It is not a desk. Congratulations anyway.\u201D",
            "\u201CGhost Protocol has a chief again. Nobody saw the last one leave, and nobody saw you arrive. Perfect continuity.\u201D"
        ],
        quotes: [
            "\u201CI\u2019m not invisible. You\u2019re just distracted.\u201D",
            "\u201CNoise gets people killed.\u201D",
            "\u201CIf you hear me, you\u2019re already too close.\u201D",
            "\u201CI move between moments.\u201D",
            "\u201CThe dark\u2019s not hiding me\u2014I\u2019m hiding it.\u201D"
        ]
    },
    "signal-mask": {
        roles: [
            "Signal Ghost",
            "Trace Eraser",
            "Silent Specialist",
            "Obfuscation Operative",
            "Data Mirage Agent"
        ],
        promotedRoles: [
            "Ghost Network Director",
            "Erasure Doctrine Chief",
            "Silence Directorate Head",
            "Obfuscation Cell Handler",
            "Mirage Program Master"
        ],
        promotedQuotes: [
            "\u201CThe ghost network carries every whisper the Veil owns, Director, and it hums at frequencies you invented.\u201D",
            "\u201CYou erased trails the Dominion still bills as archive corruption. Chief, the erasure doctrine is your confession \u2014 unsigned.\u201D",
            "\u201CHead of the Silence Directorate. Your job is that nothing is ever heard. Your qualification is that nothing ever was.\u201D",
            "\u201CYour static-craft keeps our cells invisible mid-transmission, Handler. Teach them to disappear while speaking.\u201D",
            "\u201CMaster of the Mirage Program: every false signal, phantom convoy, and decoy city is staged under your hand now.\u201D"
        ],
        quotes: [
            "\u201CIf they can\u2019t log it, it didn\u2019t happen.\u201D",
            "\u201CProof is the weakest link.\u201D",
            "\u201CRecords vanish; I remain.\u201D",
            "\u201CYou can\u2019t find what never existed.\u201D",
            "\u201CLogs lie. I don\u2019t.\u201D"
        ]
    },
    "transit-anchor": {
        roles: [
            "Field Phasist",
            "Dimensional Scout",
            "Boundary Operative",
            "Spatial Recon Agent",
            "Phase Diver"
        ],
        promotedRoles: [
            "Phase Doctrine Master",
            "Dimensional Survey Head",
            "Boundary Directorate Chief",
            "Spatial Intelligence Handler",
            "Deep Phase Marshal"
        ],
        promotedQuotes: [
            "\u201CYou anchored crossings that should have scattered whole teams into the between. Master, the phase doctrine is your handwriting.\u201D",
            "\u201CThe dimensional survey is yours to head. Chart the soft places \u2014 and mark clearly where the map should lie.\u201D",
            "\u201CChief of the Boundary Directorate. The lines between here and elsewhere hold because you know exactly how thin they are.\u201D",
            "\u201CEvery anomalous crossing report lands on your desk now, Handler. You\u2019ve stood in most of them.\u201D",
            "\u201CDeep Phase Marshal. Past a certain depth the transit stops being travel and starts being negotiation. You always came back \u2014 teach that.\u201D"
        ],
        quotes: [
            "\u201CSpace folds if you know where to press.\u201D",
            "\u201CPhysics is a matter of confidence.\u201D",
            "\u201CWalls are only polite suggestions.\u201D",
            "\u201CIf you feel a tug, don\u2019t fight it.\u201D",
            "\u201CEverything solid is just waiting to blur.\u201D"
        ]
    }
};
var $979b99378be707cd$export$1aaffaaaf67a009d = [
    // ===============================
    // Skill Success Bonuses
    // Increases technique success chance for all techniques in a skill (used by skill artifacts)
    // Applied to specific skills via skill field on artifacts
    // ===============================
    {
        id: "skill-success-bonus",
        type: "skill_success_bonus",
        value: 5,
        unit: "percent",
        description: "Increases technique success chance during room events",
        icon: "\uD83C\uDFAF\u2728"
    },
    // ===============================
    // Currency & Payout Bonuses
    // Increases credits earned from data caches and contracts
    // ===============================
    {
        id: "currency-bonus",
        type: "currency_bonus",
        value: 5,
        unit: "percent",
        description: "Increases credits from recovered data caches",
        icon: "\uD83D\uDCBE\uD83D\uDCB0"
    },
    {
        id: "contractor-payout-bonus",
        type: "currency_bonus",
        value: 10,
        unit: "percent",
        category: "contractor",
        description: "Increases payout from successful support contracts",
        icon: "\uD83D\uDCE1\uD83D\uDCB0"
    },
    // ===============================
    // Item Quality & Discovery Bonuses
    // Improves rarity rolls and discovery chance for special items
    // ===============================
    {
        id: "relic-quality-bonus",
        type: "item_quality_bonus",
        value: 10,
        unit: "percent",
        description: "Improves chances of finding higher-quality vendor relics",
        icon: "\uD83D\uDD2E\u2B06\uFE0F"
    },
    // (was "story-relic-bonus" - story relics only drop at tier 4+, which
    // doesn't exist yet; repurposed 2026-07 to blueprint discovery until the
    // story-relic content ships)
    {
        id: "blueprint-find-bonus",
        type: "item_quality_bonus",
        value: 5,
        unit: "percent",
        description: "Increases the chance of discovering legendary blueprint caches",
        icon: "\uD83D\uDCDC\u2728"
    },
    // ===============================
    // Damage Reduction & Protection
    // Reduces damage taken and prevents incapacitation
    // ===============================
    {
        id: "hazard-damage-reduction",
        type: "damage_reduction",
        value: 5,
        unit: "percent",
        description: "Reduces damage from environmental hazards",
        icon: "\u26A0\uFE0F\uD83D\uDEE1\uFE0F"
    },
    {
        id: "knockout-prevention",
        type: "knockout_prevention",
        value: 1,
        unit: "count",
        description: "Prevents first incapacitation per raid",
        icon: "\uD83D\uDC89\uD83D\uDEE1\uFE0F"
    },
    // ===============================
    // Faction Synergy Bonuses
    // Improves coordination when working with mixed-faction teams
    // ===============================
    {
        id: "faction-synergy-bonus",
        type: "faction_synergy_bonus",
        value: 5,
        unit: "percent",
        description: "Improves success when multiple factions coordinate on events",
        icon: "\uD83D\uDD00\u2728"
    },
    // ===============================
    // Skill & Support Bonuses
    // Improves effectiveness when acting in support role
    // ===============================
    {
        id: "support-skill-bonus",
        type: "skill_bonus",
        value: 2,
        unit: "percent",
        description: "Boosts skill checks when providing support during events",
        icon: "\uD83E\uDD1D\u2728"
    },
    // ===============================
    // Resource & Material Bonuses
    // Increases material yield from salvage operations
    // ===============================
    {
        id: "loot-quantity-bonus",
        type: "loot_quantity_bonus",
        value: 10,
        unit: "percent",
        description: "Increases quantity of materials recovered from events",
        icon: "\uD83D\uDCE6\u2B06\uFE0F"
    },
    {
        id: "gate-material-bonus",
        type: "material_yield_bonus",
        value: 15,
        unit: "percent",
        description: "Improves material yield from Gate rooms",
        icon: "\u26CF\uFE0F\uD83D\uDCE6"
    },
    // ===============================
    // Downtime Reduction
    // Reduces the energy cost of launching raids
    // (was "cooldown-reduction" - no raid cooldown mechanic exists; repurposed
    // 2026-07 to the real pacing resource, energy)
    // ===============================
    {
        id: "raid-energy-reduction",
        type: "raid_energy_reduction",
        value: 10,
        unit: "percent",
        description: "Reduces the energy cost of launching raids",
        icon: "\u26A1\u2B07\uFE0F"
    },
    // ===============================
    // Technique-Specific Bonuses
    // Applied to specific techniques via techniqueId on items
    // ===============================
    {
        id: "technique-success-bonus",
        type: "technique_success_bonus",
        value: 10,
        unit: "percent",
        description: "Increases technique success chance",
        icon: "\uD83D\uDD27\u2728"
    },
    // NOTE: "technique-retry" (one free retry on the technique's checks) was
    // removed from device data 2026-07-15 - a p -> 1-(1-p)^2 swing needs its
    // own balance pass. Reintroduce deliberately if a capstone effect is wanted.
    {
        id: "room-time-reduction",
        type: "room_time_reduction",
        value: 10,
        unit: "percent",
        description: "Reduces room duration when technique's usage is successful",
        icon: "\uD83D\uDD27\u23F1\uFE0F"
    }
];
var $979b99378be707cd$export$d02ea220375e4aff = {
    material: {
        name: "Material",
        icon: "\uD83D\uDD27"
    },
    consumable: {
        name: "Consumable",
        icon: "\uD83E\uDDEA"
    },
    techGear: {
        name: "Skill Gear",
        icon: "\u2699\uFE0F"
    },
    artifact: {
        name: "Artifact",
        icon: "\u26A1"
    },
    blueprint: {
        name: "Blueprint",
        icon: "\uD83D\uDCCB"
    },
    relic: {
        name: "Relic",
        icon: "\uD83D\uDC8E"
    },
    storyRelic: {
        name: "Story Relic",
        icon: "\uD83C\uDF1F"
    },
    credits: {
        name: "Credits",
        icon: "\uD83D\uDCB0"
    }
};
var $979b99378be707cd$export$659d2bfa35449fc3 = [
    // ===============================
    // Dominion Artifacts
    // ===============================
    {
        id: "signal-repeater-pack",
        name: "Signal Repeater Pack",
        type: "artifact",
        rarity: "unique",
        slot: "skillSlot",
        skill: "signal-relay",
        faction: "dominion",
        icon: "\uD83D\uDCE1",
        effects: {
            "skill-success-bonus": 5
        },
        description: "Portable backpack transceiver used to amplify or intercept long-range signals.",
        short: "Boosts or reroutes long-range communications.",
        flavor: "Old tech, new purpose\u2014signal's alive as long as the pack holds charge.",
        visual: "Backpack-sized radio with folding antenna mast, copper wiring, and carbon casing."
    },
    {
        id: "control-override-kit",
        name: "Control Override Kit",
        type: "artifact",
        rarity: "unique",
        slot: "skillSlot",
        skill: "system-override",
        faction: "dominion",
        icon: "\uD83D\uDCBB",
        effects: {
            "skill-success-bonus": 5
        },
        description: "Rugged field toolkit used to manually override or reboot autonomous systems.",
        short: "Grants manual control over automated or defensive systems.",
        flavor: "Every system has a door. This is the key.",
        visual: "Metal case with analog dials, fiber cables, and brass coupling clamps."
    },
    {
        id: "operator-link-harness",
        name: "Operator Link Harness",
        type: "artifact",
        rarity: "unique",
        slot: "skillSlot",
        skill: "drone-command",
        faction: "dominion",
        icon: "\uD83E\uDD16",
        effects: {
            "skill-success-bonus": 5
        },
        description: "Wearable control rig providing direct uplink to reconnaissance drones.",
        short: "Improves range and stability for drone operations.",
        flavor: "You don't command the drone\u2014you become its signal.",
        visual: "Chest rig with braided data cables, antenna spine, and LED activity lights."
    },
    {
        id: "stability-coupler",
        name: "Stability Coupler",
        type: "artifact",
        rarity: "unique",
        slot: "skillSlot",
        skill: "safeguard",
        faction: "dominion",
        icon: "\u26A0\uFE0F",
        effects: {
            "skill-success-bonus": 5
        },
        description: "Compact coupler device that redirects power surges and stabilizes damaged circuits.",
        short: "Prevents overloads and stabilizes failing systems.",
        flavor: "Keeps the grid humming when everything else falls apart.",
        visual: "Steel cylinder with magnetic clamps and heat-dispersal vents."
    },
    {
        id: "spectral-survey-scope",
        name: "Spectral Survey Scope",
        type: "artifact",
        rarity: "unique",
        slot: "skillSlot",
        skill: "quantum-scan",
        faction: "dominion",
        icon: "\uD83D\uDD2C",
        effects: {
            "skill-success-bonus": 5
        },
        description: "Handheld multi-spectrum scanner for detecting heat signatures and radiation leaks.",
        short: "Reveals structural and energy anomalies.",
        flavor: "If it glows, hums, or leaks radiation\u2014you'll see it first.",
        visual: "Monocular scope with glass lens, rubber grip, and digital readout."
    },
    // ===============================
    // Wilders Artifacts
    // ===============================
    {
        id: "harvesting-gauntlet",
        name: "Harvesting Gauntlet",
        type: "artifact",
        rarity: "unique",
        slot: "skillSlot",
        skill: "reclamation",
        faction: "wilders",
        icon: "\uD83C\uDF31",
        effects: {
            "skill-success-bonus": 5
        },
        description: "Reinforced glove with integrated sampling tools for organic material extraction.",
        short: "Extracts valuable organic materials from decayed environments.",
        flavor: "The world may rot, but the soil still breathes.",
        visual: "Leather glove with metal prongs and sap-stained plating."
    },
    {
        id: "growth-induction-pod",
        name: "Growth Induction Pod",
        type: "artifact",
        rarity: "unique",
        slot: "skillSlot",
        skill: "growth-control",
        faction: "wilders",
        icon: "\uD83C\uDF3F",
        effects: {
            "skill-success-bonus": 5
        },
        description: "Handheld canister that releases nutrient mist and spores to trigger rapid plant growth.",
        short: "Stimulates fast vegetation growth to form cover or pathways.",
        flavor: "Press the trigger, and life remembers its old shape.",
        visual: "Metal canister with fogged glass tube and green-lit valves."
    },
    {
        id: "pheromone-relay-belt",
        name: "Pheromone Relay Belt",
        type: "artifact",
        rarity: "unique",
        slot: "skillSlot",
        skill: "wild-influence",
        faction: "wilders",
        icon: "\uD83E\uDD8E",
        effects: {
            "skill-success-bonus": 5
        },
        description: "Compact belt device emitting pheromone signals to calm or redirect wildlife.",
        short: "Redirects wildlife behavior using pheromone signals.",
        flavor: "Not control\u2014just conversation.",
        visual: "Canvas belt with small glass ampoules and brass vapor vents."
    },
    {
        id: "respirator-webbing",
        name: "Respirator Webbing",
        type: "artifact",
        rarity: "unique",
        slot: "skillSlot",
        skill: "bio-shield",
        faction: "wilders",
        icon: "\uD83E\uDDEC",
        effects: {
            "skill-success-bonus": 5
        },
        description: "Protective breathing rig with adaptive microbial filters for harsh biomes.",
        short: "Filters toxins and airborne contaminants in the field.",
        flavor: "Built for lungs that still believe in clean air.",
        visual: "Lightweight mask and harness with flexible tubing and filter canisters."
    },
    {
        id: "hazard-recovery-satchel",
        name: "Hazard Recovery Satchel",
        type: "artifact",
        rarity: "unique",
        slot: "skillSlot",
        skill: "containment",
        faction: "wilders",
        icon: "\u2623\uFE0F",
        effects: {
            "skill-success-bonus": 5
        },
        description: "Sealed pack with insulated containers for storing contaminated samples.",
        short: "Safely collects and stores hazardous materials.",
        flavor: "Carry the poison home, sell the antidote later.",
        visual: "Canvas satchel with metal clasps, labeled vials, and sealed lining."
    },
    // ===============================
    // Veil Artifacts
    // ===============================
    {
        id: "resonant-survey-array",
        name: "Resonant Survey Array",
        type: "artifact",
        rarity: "unique",
        slot: "skillSlot",
        skill: "echo-trace",
        faction: "veil",
        icon: "\uD83D\uDDFA\uFE0F",
        effects: {
            "skill-success-bonus": 5
        },
        description: "Compact scanner that maps hidden spaces using ultrasonic and optical signals.",
        short: "Reveals hidden corridors and passageways.",
        flavor: "Walls hide nothing from an echo that listens back.",
        visual: "Fold-out brass scanner with projection lens and rotating sensor arms."
    },
    {
        id: "lockpulse-breach-kit",
        name: "Lockpulse Breach Kit",
        type: "artifact",
        rarity: "unique",
        slot: "skillSlot",
        skill: "lock-breach",
        faction: "veil",
        icon: "\uD83D\uDD13",
        effects: {
            "skill-success-bonus": 5
        },
        description: "Portable case containing micro-drills and probe leads for lock bypassing.",
        short: "Bypasses advanced security mechanisms.",
        flavor: "Locks are just puzzles pretending to be walls.",
        visual: "Compact case with metallic tools and a glass touchpad interface."
    },
    {
        id: "silent-step-pads",
        name: "Silent Step Pads",
        type: "artifact",
        rarity: "unique",
        slot: "skillSlot",
        skill: "stealth-transit",
        faction: "veil",
        icon: "\uD83D\uDC64",
        effects: {
            "skill-success-bonus": 5
        },
        description: "Noise-dampening inserts that absorb motion vibration for silent movement.",
        short: "Suppresses footstep and motion noise.",
        flavor: "The loudest sound is the one you never make.",
        visual: "Thin polymer pads with translucent gel lining, faint vibration when active."
    },
    {
        id: "trace-disruptor-band",
        name: "Trace Disruptor Band",
        type: "artifact",
        rarity: "unique",
        slot: "skillSlot",
        skill: "signal-mask",
        faction: "veil",
        icon: "\uD83D\uDC7B",
        effects: {
            "skill-success-bonus": 5
        },
        description: "Wrist-mounted emitter that scrambles biometric and radio signatures.",
        short: "Masks thermal and radio traces from detection.",
        flavor: "Vanish from the data before anyone reads it.",
        visual: "Titanium wristband with fiber coils and soft electromagnetic hum."
    },
    {
        id: "anchor-resonator",
        name: "Anchor Resonator",
        type: "artifact",
        rarity: "unique",
        slot: "skillSlot",
        skill: "transit-anchor",
        faction: "veil",
        icon: "\uD83C\uDF00",
        effects: {
            "skill-success-bonus": 5
        },
        description: "Tripod-mounted stabilizer that emits vibration to settle debris for safe crossing.",
        short: "Stabilizes terrain for safe traversal.",
        flavor: "You can't fix the world, but you can stop it from falling on you.",
        visual: "Carbon tripod with steel joints and an amber-glowing stabilizer core."
    }
];
var $979b99378be707cd$export$709aa55c173a48b8 = [
    {
        id: "data-cache-drive",
        name: "Data Cache Drive",
        type: "artifact",
        rarity: "unique",
        slot: "utilitySlot",
        faction: "neutral",
        icon: "\uD83D\uDCBE",
        effects: {
            "currency-bonus": 5
        },
        description: "Rugged steel data drive recovered from collapsed networks.",
        short: "Increases payout from recovered data caches.",
        flavor: "Someone's last backup became your payday.",
        visual: "Steel-plated drive with cracked glass indicator and cable port."
    },
    {
        id: "relic-resonance-tuner",
        name: "Relic Resonance Tuner",
        type: "artifact",
        rarity: "unique",
        slot: "utilitySlot",
        faction: "neutral",
        icon: "\uD83D\uDD2E",
        effects: {
            "relic-quality-bonus": 10
        },
        description: "Portable analyzer tuned to detect valuable relic signal emissions.",
        short: "Improves chances of finding higher-quality relics.",
        flavor: "It listens for what the ruins remember.",
        visual: "Palm-sized copper coil device with faint magnetic hum."
    },
    {
        id: "hazard-lens-visor",
        name: "Hazard Lens Visor",
        type: "artifact",
        rarity: "unique",
        slot: "utilitySlot",
        faction: "neutral",
        icon: "\uD83D\uDEE1\uFE0F",
        effects: {
            "hazard-damage-reduction": 5
        },
        description: "Retractable visor overlay with polarized lenses for hazard visibility.",
        short: "Reduces hazard damage and improves visibility.",
        flavor: "You'll see the heat before it burns you.",
        visual: "Fold-down visor with tinted glass and worn metal hinge."
    },
    {
        id: "recovery-injector",
        name: "Recovery Injector",
        type: "artifact",
        rarity: "unique",
        slot: "utilitySlot",
        faction: "neutral",
        icon: "\uD83D\uDC89",
        effects: {
            "knockout-prevention": 1
        },
        description: "Compact auto-syringe delivering restorative compounds during emergencies.",
        short: "Prevents first incapacitation per raid.",
        flavor: "Pain's optional if you've got credits.",
        visual: "Reinforced syringe with digital readout and polymer casing."
    },
    {
        id: "contract-beacon",
        name: "Contract Beacon",
        type: "artifact",
        rarity: "unique",
        slot: "utilitySlot",
        faction: "neutral",
        icon: "\uD83D\uDCE1",
        effects: {
            "contractor-payout-bonus": 10
        },
        description: "Handheld transmitter used to log contractor performance data.",
        short: "Improves payout on successful support contracts.",
        flavor: "Work ends when the beacon says so.",
        visual: "Metal signal beacon with etched serial plate and extendable antenna."
    },
    {
        id: "salvage-compression-rig",
        name: "Salvage Compression Rig",
        type: "artifact",
        rarity: "unique",
        slot: "utilitySlot",
        faction: "neutral",
        icon: "\uD83D\uDCE6",
        effects: {
            "loot-quantity-bonus": 10
        },
        description: "Compact hydraulic press for field compression of salvaged materials.",
        short: "Increases material quantities recovered from events.",
        flavor: "Carry more by making it smaller. Simple physics, better haul.",
        visual: "Belt-mounted press with steel jaws and cargo netting."
    },
    {
        id: "sync-regulator-watch",
        name: "Sync Regulator Watch",
        type: "artifact",
        rarity: "unique",
        slot: "utilitySlot",
        faction: "neutral",
        icon: "\u23F0",
        effects: {
            "raid-energy-reduction": 10
        },
        description: "Wristwatch synced to raid timers, reducing the energy cost of launching runs.",
        short: "Reduces raid energy costs by 10%.",
        flavor: "Keeps your time even when the world's stopped keeping its own.",
        visual: "Analog-digital hybrid watch with cracked face and glowing dial."
    },
    {
        id: "auto-stabilizer-pack",
        name: "Auto-Stabilizer Pack",
        type: "artifact",
        rarity: "unique",
        slot: "utilitySlot",
        faction: "neutral",
        icon: "\uD83C\uDF86",
        effects: {
            "knockout-prevention": 1
        },
        description: "Wearable spinal brace with kinetic dampers to prevent catastrophic injury.",
        short: "Prevents one critical injury per raid.",
        flavor: "Catches you once. Don't make it twice.",
        visual: "Lightweight spine brace with metal pistons and foam padding."
    },
    {
        id: "training-node-deck",
        name: "Training Node Deck",
        type: "artifact",
        rarity: "unique",
        slot: "utilitySlot",
        faction: "neutral",
        icon: "\uD83C\uDFAF",
        effects: {
            "support-skill-bonus": 2
        },
        description: "Handheld data deck containing simulated skill routines for training.",
        short: "Boosts support skills during checks.",
        flavor: "Practice until it hurts, then practice better.",
        visual: "Compact data cartridge with keypad and scratched screen."
    },
    {
        id: "crosslink-amplifier",
        name: "Crosslink Amplifier",
        type: "artifact",
        rarity: "unique",
        slot: "utilitySlot",
        faction: "neutral",
        icon: "\uD83D\uDD00",
        effects: {
            "faction-synergy-bonus": 5
        },
        description: "Relay puck enhancing coordination between nearby teammates.",
        short: "Improves success chance when multiple factions assist.",
        flavor: "When everyone's in sync, nobody dies alone.",
        visual: "Hand-sized relay disc with glowing copper inlays and dual terminals."
    },
    {
        id: "material-extractor",
        name: "Material Extractor",
        type: "artifact",
        rarity: "unique",
        slot: "utilitySlot",
        faction: "neutral",
        icon: "\u26CF\uFE0F",
        effects: {
            "gate-material-bonus": 15
        },
        description: "Handheld drill for retrieving salvageable materials from debris.",
        short: "Improves material yield from Gate rooms.",
        flavor: "The gate's trash is tomorrow's rebuild.",
        visual: "Compact hand drill with tungsten bit and transparent debris canister."
    },
    {
        id: "memory-crystal-shard",
        name: "Memory Crystal Shard",
        type: "artifact",
        rarity: "unique",
        slot: "utilitySlot",
        faction: "neutral",
        icon: "\uD83D\uDD2E",
        effects: {
            "blueprint-find-bonus": 5
        },
        description: "Resin-sealed data shard that resonates near the caches where blueprints survive.",
        short: "Increases legendary blueprint discovery chance.",
        flavor: "What's stored inside isn't data\u2014it's what was lost trying to keep it.",
        visual: "Clear resin capsule with crystalline core set in a steel ring."
    }
];
var $979b99378be707cd$export$11208b4f926fa7ee = [
    // ===============================
    // Dominion Skill Artifacts
    // ===============================
    {
        id: "signal-repeater-pack-blueprint",
        name: "Signal Repeater Pack Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "dominion",
        icon: "\uD83D\uDCE1",
        description: "Blueprint for the Signal Repeater Pack",
        short: "Plans: Signal Repeater Pack."
    },
    {
        id: "control-override-kit-blueprint",
        name: "Control Override Kit Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "dominion",
        icon: "\uD83D\uDCBB",
        description: "Blueprint for the Control Override Kit",
        short: "Plans: Control Override Kit."
    },
    {
        id: "operator-link-harness-blueprint",
        name: "Operator Link Harness Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "dominion",
        icon: "\uD83E\uDD16",
        description: "Blueprint for the Operator Link Harness",
        short: "Plans: Operator Link Harness."
    },
    {
        id: "stability-coupler-blueprint",
        name: "Stability Coupler Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "dominion",
        icon: "\u26A0\uFE0F",
        description: "Blueprint for the Stability Coupler",
        short: "Plans: Stability Coupler."
    },
    {
        id: "spectral-survey-scope-blueprint",
        name: "Spectral Survey Scope Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "dominion",
        icon: "\uD83D\uDD2C",
        description: "Blueprint for the Spectral Survey Scope",
        short: "Plans: Spectral Survey Scope."
    },
    // ===============================
    // Wilders Skill Artifacts
    // ===============================
    {
        id: "harvesting-gauntlet-blueprint",
        name: "Harvesting Gauntlet Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "wilders",
        icon: "\uD83C\uDF31",
        description: "Blueprint for the Harvesting Gauntlet",
        short: "Plans: Harvesting Gauntlet."
    },
    {
        id: "growth-induction-pod-blueprint",
        name: "Growth Induction Pod Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "wilders",
        icon: "\uD83C\uDF3F",
        description: "Blueprint for the Growth Induction Pod",
        short: "Plans: Growth Induction Pod."
    },
    {
        id: "pheromone-relay-belt-blueprint",
        name: "Pheromone Relay Belt Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "wilders",
        icon: "\uD83E\uDD8E",
        description: "Blueprint for the Pheromone Relay Belt",
        short: "Plans: Pheromone Relay Belt."
    },
    {
        id: "respirator-webbing-blueprint",
        name: "Respirator Webbing Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "wilders",
        icon: "\uD83E\uDDEC",
        description: "Blueprint for the Respirator Webbing",
        short: "Plans: Respirator Webbing."
    },
    {
        id: "hazard-recovery-satchel-blueprint",
        name: "Hazard Recovery Satchel Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "wilders",
        icon: "\u2623\uFE0F",
        description: "Blueprint for the Hazard Recovery Satchel",
        short: "Plans: Hazard Recovery Satchel."
    },
    // ===============================
    // Veil Skill Artifacts
    // ===============================
    {
        id: "resonant-survey-array-blueprint",
        name: "Resonant Survey Array Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "veil",
        icon: "\uD83D\uDDFA\uFE0F",
        description: "Blueprint for the Resonant Survey Array",
        short: "Plans: Resonant Survey Array."
    },
    {
        id: "lockpulse-breach-kit-blueprint",
        name: "Lockpulse Breach Kit Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "veil",
        icon: "\uD83D\uDD13",
        description: "Blueprint for the Lockpulse Breach Kit",
        short: "Plans: Lockpulse Breach Kit."
    },
    {
        id: "silent-step-pads-blueprint",
        name: "Silent Step Pads Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "veil",
        icon: "\uD83D\uDC64",
        description: "Blueprint for the Silent Step Pads",
        short: "Plans: Silent Step Pads."
    },
    {
        id: "trace-disruptor-band-blueprint",
        name: "Trace Disruptor Band Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "veil",
        icon: "\uD83D\uDC7B",
        description: "Blueprint for the Trace Disruptor Band",
        short: "Plans: Trace Disruptor Band."
    },
    {
        id: "anchor-resonator-blueprint",
        name: "Anchor Resonator Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "veil",
        icon: "\uD83C\uDF00",
        description: "Blueprint for the Anchor Resonator",
        short: "Plans: Anchor Resonator."
    },
    // ===============================
    // Neutral Utility Artifacts
    // ===============================
    {
        id: "data-cache-drive-blueprint",
        name: "Data Cache Drive Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "neutral",
        icon: "\uD83D\uDCBE",
        description: "Blueprint for the Data Cache Drive",
        short: "Plans: Data Cache Drive."
    },
    {
        id: "relic-resonance-tuner-blueprint",
        name: "Relic Resonance Tuner Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "neutral",
        icon: "\uD83D\uDD2E",
        description: "Blueprint for the Relic Resonance Tuner",
        short: "Plans: Relic Resonance Tuner."
    },
    {
        id: "hazard-lens-visor-blueprint",
        name: "Hazard Lens Visor Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "neutral",
        icon: "\uD83D\uDEE1\uFE0F",
        description: "Blueprint for the Hazard Lens Visor",
        short: "Plans: Hazard Lens Visor."
    },
    {
        id: "recovery-injector-blueprint",
        name: "Recovery Injector Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "neutral",
        icon: "\uD83D\uDC89",
        description: "Blueprint for the Recovery Injector",
        short: "Plans: Recovery Injector."
    },
    {
        id: "contract-beacon-blueprint",
        name: "Contract Beacon Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "neutral",
        icon: "\uD83D\uDCE1",
        description: "Blueprint for the Contract Beacon",
        short: "Plans: Contract Beacon."
    },
    {
        id: "salvage-compression-rig-blueprint",
        name: "Salvage Compression Rig Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "neutral",
        icon: "\uD83D\uDCE6",
        description: "Blueprint for the Salvage Compression Rig",
        short: "Plans: Salvage Compression Rig."
    },
    {
        id: "sync-regulator-watch-blueprint",
        name: "Sync Regulator Watch Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "neutral",
        icon: "\u23F0",
        description: "Blueprint for the Sync Regulator Watch",
        short: "Plans: Sync Regulator Watch."
    },
    {
        id: "auto-stabilizer-pack-blueprint",
        name: "Auto-Stabilizer Pack Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "neutral",
        icon: "\uD83C\uDF86",
        description: "Blueprint for the Auto-Stabilizer Pack",
        short: "Plans: Auto-Stabilizer Pack."
    },
    {
        id: "training-node-deck-blueprint",
        name: "Training Node Deck Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "neutral",
        icon: "\uD83C\uDFAF",
        description: "Blueprint for the Training Node Deck",
        short: "Plans: Training Node Deck."
    },
    {
        id: "crosslink-amplifier-blueprint",
        name: "Crosslink Amplifier Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "neutral",
        icon: "\uD83D\uDD00",
        description: "Blueprint for the Crosslink Amplifier",
        short: "Plans: Crosslink Amplifier."
    },
    {
        id: "material-extractor-blueprint",
        name: "Material Extractor Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "neutral",
        icon: "\u26CF\uFE0F",
        description: "Blueprint for the Material Extractor",
        short: "Plans: Material Extractor."
    },
    {
        id: "memory-crystal-shard-blueprint",
        name: "Memory Crystal Shard Blueprint",
        type: "blueprint",
        rarity: "legendary",
        faction: "neutral",
        icon: "\uD83D\uDD2E",
        description: "Blueprint for the Memory Crystal Shard",
        short: "Plans: Memory Crystal Shard."
    }
];
var $979b99378be707cd$export$39df1497f8fcc025 = [
    // ===============================
    // Common Materials
    // ===============================
    {
        id: "steel-plates",
        name: "Steel Plates",
        type: "material",
        rarity: "common",
        faction: "neutral",
        icon: "\uD83E\uDDF1",
        description: "Reinforced steel sheets salvaged from collapsed structures, used for repairs and fabrication.",
        short: "Structural steel for frames and reinforcements."
    },
    {
        id: "copper-wire",
        name: "Copper Wire",
        type: "material",
        rarity: "common",
        faction: "dominion",
        icon: "\uD83E\uDDF6",
        description: "Insulated copper wire used for communications, power routing, and control circuits.",
        short: "Electrical wiring for circuits and comms."
    },
    {
        id: "brass-fittings",
        name: "Brass Fittings",
        type: "material",
        rarity: "common",
        faction: "veil",
        icon: "\u2699\uFE0F",
        description: "Polished brass connectors and mechanical couplings used in precision assemblies.",
        short: "Mechanical connectors for field gear."
    },
    {
        id: "glass-lens",
        name: "Glass Lens",
        type: "material",
        rarity: "common",
        faction: "neutral",
        icon: "\uD83D\uDD0D",
        description: "Optical glass lens salvaged from scopes and sensors, used in scanning devices.",
        short: "Optical lens for scopes and sensors."
    },
    {
        id: "ceramic-insulator",
        name: "Ceramic Insulator",
        type: "material",
        rarity: "common",
        faction: "dominion",
        icon: "\uD83C\uDFFA",
        description: "High-heat ceramic components that isolate electrical and thermal energy.",
        short: "Heat-resistant electrical insulation."
    },
    {
        id: "composite-casing",
        name: "Composite Casing",
        type: "material",
        rarity: "common",
        faction: "dominion",
        icon: "\uD83D\uDCE6",
        description: "Lightweight polymer and carbon housings used to encase sensitive systems.",
        short: "Protective housing for tech equipment."
    },
    {
        id: "fabric-mesh",
        name: "Fabric Mesh",
        type: "material",
        rarity: "common",
        faction: "wilders",
        icon: "\uD83E\uDEA1",
        description: "Durable woven material used for straps, belts, and wearable rigs.",
        short: "Reinforced cloth for wearable gear."
    },
    {
        id: "canvas-fiber",
        name: "Canvas Fiber",
        type: "material",
        rarity: "common",
        faction: "wilders",
        icon: "\uD83E\uDDF5",
        description: "Tough, weatherproof textile favored by Wilder survival teams for packs and satchels.",
        short: "Heavy fabric for field packs."
    },
    {
        id: "leather-straps",
        name: "Leather Straps",
        type: "material",
        rarity: "common",
        faction: "wilders",
        icon: "\uD83C\uDF92",
        description: "Cured animal hide straps used in Wilder clothing, gloves, and carrying gear.",
        short: "Leather bands for field equipment."
    },
    {
        id: "rubber-seal",
        name: "Rubber Seal",
        type: "material",
        rarity: "common",
        faction: "neutral",
        icon: "\uD83E\uDDF0",
        description: "Rubberized sealing rings for airtight or watertight containers.",
        short: "Insulating seal for protective containers."
    },
    {
        id: "polymer-tubing",
        name: "Polymer Tubing",
        type: "material",
        rarity: "common",
        faction: "wilders",
        icon: "\uD83E\uDDEA",
        description: "Flexible tubing used in breathing rigs, injectors, and liquid transfer systems.",
        short: "Flexible tubing for filtration or injection systems."
    },
    {
        id: "carbon-housing",
        name: "Carbon Housing",
        type: "material",
        rarity: "common",
        faction: "veil",
        icon: "\u2B1B",
        description: "Durable carbon-composite shell used in portable scanning and stealth gear.",
        short: "Lightweight carbon shell for tech devices."
    },
    {
        id: "plastic-casing",
        name: "Plastic Casing",
        type: "material",
        rarity: "common",
        faction: "veil",
        icon: "\uD83E\uDDF4",
        description: "Recycled polymer panels used for consumer-grade or field-modified electronics.",
        short: "Lightweight housing for electronic tools."
    },
    {
        id: "aluminum-shell",
        name: "Aluminum Shell",
        type: "material",
        rarity: "common",
        faction: "dominion",
        icon: "\uD83E\uDD6B",
        description: "Lightweight aluminum housing used for beacons, sensor mounts, and handheld devices.",
        short: "Light metal housing for compact field gear."
    },
    {
        id: "circuit-board",
        name: "Circuit Board",
        type: "material",
        rarity: "common",
        faction: "dominion",
        icon: "\uD83D\uDCBB",
        description: "Salvaged printed circuit board used for control panels and signal devices.",
        short: "Base electronic component for all digital tech."
    },
    {
        id: "resin-casing",
        name: "Resin Casing",
        type: "material",
        rarity: "common",
        faction: "wilders",
        icon: "\uD83E\uDDF4",
        description: "Transparent resin shell used for insulation, bonding, or sealing delicate materials.",
        short: "Clear protective housing for fragile items."
    },
    {
        id: "iron-frame",
        name: "Iron Frame",
        type: "material",
        rarity: "common",
        faction: "neutral",
        icon: "\uD83C\uDFD7\uFE0F",
        description: "Reinforced iron supports salvaged from export construction scaffolds and vehicles.",
        short: "Structural frame material for heavy gear."
    },
    {
        id: "relay-antenna-strut",
        name: "Relay Antenna Strut",
        type: "material",
        rarity: "common",
        faction: "dominion",
        icon: "\uD83D\uDCE1",
        description: "Telescoping antenna segment stripped from dead relay towers, still true enough to hold a signal line.",
        short: "Antenna segment for comm rigs and beacons."
    },
    {
        id: "power-cell-casing",
        name: "Power Cell Casing",
        type: "material",
        rarity: "common",
        faction: "dominion",
        icon: "\uD83D\uDD0B",
        description: "Hardened shell of a depleted power cell, reusable as housing for charge regulators and battery packs.",
        short: "Battery shell for power systems."
    },
    {
        id: "logic-ribbon-cable",
        name: "Logic Ribbon Cable",
        type: "material",
        rarity: "common",
        faction: "dominion",
        icon: "\uD83C\uDF97\uFE0F",
        description: "Flat multi-channel cable pulled from control consoles, carries data lines between salvaged modules.",
        short: "Data cabling for control interfaces."
    },
    {
        id: "chitin-plate",
        name: "Chitin Plate",
        type: "material",
        rarity: "common",
        faction: "wilders",
        icon: "\uD83E\uDEB2",
        description: "Hardened shell segment shed by overgrown insects, light as polymer and twice as tough.",
        short: "Natural armor plating from giant insects."
    },
    {
        id: "spore-felt-padding",
        name: "Spore Felt Padding",
        type: "material",
        rarity: "common",
        faction: "wilders",
        icon: "\uD83C\uDF44",
        description: "Dense fungal felt harvested from spore beds, insulates and cushions delicate biological cargo.",
        short: "Fungal padding for insulation and cushioning."
    },
    {
        id: "tanned-gut-cord",
        name: "Tanned Gut Cord",
        type: "material",
        rarity: "common",
        faction: "wilders",
        icon: "\uD83E\uDEA2",
        description: "Sinew cordage cured over smoke, the Wilders' answer to wire ties and suture thread alike.",
        short: "Tough natural cordage for bindings."
    },
    {
        id: "optic-fiber-spool",
        name: "Optic Fiber Spool",
        type: "material",
        rarity: "common",
        faction: "veil",
        icon: "\uD83E\uDDFF",
        description: "Coil of hair-thin light-guide fiber, favored for taps and scopes that leave no electromagnetic trace.",
        short: "Light-guide fiber for covert optics."
    },
    {
        id: "matte-coating-compound",
        name: "Matte Coating Compound",
        type: "material",
        rarity: "common",
        faction: "veil",
        icon: "\uD83C\uDFA8",
        description: "Light-drinking paste applied to gear that should not glint, reflect, or be remembered.",
        short: "Anti-reflective coating for stealth gear."
    },
    {
        id: "micro-bearing-set",
        name: "Micro Bearing Set",
        type: "material",
        rarity: "common",
        faction: "veil",
        icon: "\u26AA",
        description: "Case of near-frictionless bearings that let mechanisms turn in perfect silence.",
        short: "Silent precision bearings for quiet mechanisms."
    },
    {
        id: "acoustic-foam-wafer",
        name: "Acoustic Foam Wafer",
        type: "material",
        rarity: "common",
        faction: "veil",
        icon: "\uD83D\uDD32",
        description: "Cut sheet of sound-eating foam, lines the housings of equipment meant to run unheard.",
        short: "Sound-dampening liner for covert equipment."
    },
    {
        id: "etched-keyplate-blank",
        name: "Etched Keyplate Blank",
        type: "material",
        rarity: "common",
        faction: "veil",
        icon: "\uD83D\uDDDD\uFE0F",
        description: "Unprogrammed access plate with etched circuit channels, ready to take any lock's profile.",
        short: "Blank keycard stock for bypass tools."
    }
];
var $979b99378be707cd$export$f9575e6a92b5621d = [
    {
        id: "field-health-stim",
        name: "Field Health Stim (35 HP)",
        type: "consumable",
        rarity: "common",
        icon: "\uD83D\uDC8A",
        description: "A quick-use medical injector restoring 35 HP.",
        short: "Restores 35 HP.",
        credits: 25,
        restoresHp: 35,
        recipe: [
            {
                id: "polymer-tubing",
                qty: 2
            },
            {
                id: "plastic-casing",
                qty: 1
            },
            {
                id: "rubber-seal",
                qty: 1
            }
        ]
    },
    {
        id: "portable-energy-pack",
        name: "Portable Energy Pack",
        type: "consumable",
        rarity: "common",
        icon: "\u26A1",
        description: "Compact power injection cell restoring 30 energy.",
        short: "Restores 30 energy.",
        credits: 150,
        restoresEnergy: 30,
        recipe: [
            {
                id: "copper-wire",
                qty: 2
            },
            {
                id: "ceramic-insulator",
                qty: 1
            },
            {
                id: "steel-plates",
                qty: 1
            }
        ]
    },
    {
        id: "credits",
        name: "Credits",
        type: "credits",
        rarity: "currency",
        icon: "\uD83D\uDCB0",
        description: "Standard currency for trade, hiring, and fabrication.",
        short: "Universal currency for trade."
    }
];
var $979b99378be707cd$export$439a14874f0a75e4 = [
    {
        id: "recovery-injector-mk2",
        name: "Recovery Injector (50 HP)",
        type: "consumable",
        rarity: "uncommon",
        icon: "\uD83D\uDC89",
        description: "Upgraded stimulant blend restoring 50 HP with faster onset and reduced side effects.",
        short: "Restores 50 HP.",
        credits: 100,
        restoresHp: 50,
        recipe: [
            {
                id: "medical-stimulant-cartridge",
                qty: 1
            },
            {
                id: "nutrient-catalyst-ampoule",
                qty: 1
            },
            {
                id: "rubber-seal",
                qty: 1
            }
        ]
    },
    {
        id: "energy-conversion-pack",
        name: "Energy Conversion Pack",
        type: "consumable",
        rarity: "uncommon",
        icon: "\uD83D\uDD0B",
        description: "Refined energy module restoring 45 energy.",
        short: "Restores 45 energy.",
        credits: 600,
        restoresEnergy: 45,
        recipe: [
            {
                id: "power-regulation-unit",
                qty: 1
            },
            {
                id: "signal-processor-core",
                qty: 1
            },
            {
                id: "copper-wire",
                qty: 2
            }
        ]
    }
];
var $979b99378be707cd$export$b2b2210935a03dc3 = [
    {
        id: "advanced-recovery-serum",
        name: "Recovery Serum (70 HP)",
        type: "consumable",
        rarity: "rare",
        icon: "\uD83E\uDDEA",
        description: "Refined medical stimulant restoring 70 HP.",
        short: "Restores 70 HP.",
        credits: 300,
        restoresHp: 70,
        recipe: [
            {
                id: "synthetic-pheromone-capsule",
                qty: 1
            },
            {
                id: "medical-stimulant-cartridge",
                qty: 1
            },
            {
                id: "containment-gel-lining",
                qty: 1
            }
        ]
    },
    {
        id: "power-cell-mk3",
        name: "Power Cell Mk. III",
        type: "consumable",
        rarity: "rare",
        icon: "\u2699\uFE0F",
        description: "High-density cell restoring 60 energy.",
        short: "Restores 60 energy.",
        credits: 1800,
        restoresEnergy: 60,
        recipe: [
            {
                id: "power-regulation-unit",
                qty: 1
            },
            {
                id: "voltage-regulator-unit",
                qty: 1
            },
            {
                id: "signal-processor-core",
                qty: 2
            }
        ]
    }
];
var $979b99378be707cd$export$c1a4d9d859d3b7 = [
    {
        id: "relay-stabilizer-gel-pack",
        techniqueId: "relay-stabilizer",
        name: "Relay Stabilizer Gel Packs",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83E\uDDF4\uD83D\uDCE1",
        short: "Quick-sets mast alignment for steady comms.",
        description: "High-viscosity damping gel that reduces dish/mast micro-vibration and bearing drift, stabilizing RF alignment during Signal Relay."
    },
    {
        id: "biofiber-splice-kit",
        techniqueId: "organic-link-adapter",
        name: "Biofiber Splice Kits",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83E\uDEA1\uD83C\uDF3F",
        short: "Patch cracked lines with living fiber.",
        description: "Sterile polymer-fiber splices and crimp ferrules for fast field repairs of damaged signal runs; restores continuity for organic-safe link adapters."
    },
    {
        id: "noise-floor-buffer-pack",
        techniqueId: "silent-channel",
        name: "Noise Floor Buffer Packs",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83D\uDD07\uD83D\uDCF6",
        short: "Drops trace noise below scan.",
        description: "Adaptive notch and low-pass inserts that suppress hiss, intermod, and harmonics to lower the effective noise floor on shared bands."
    },
    {
        id: "multi-node-override-cart",
        techniqueId: "command-cascade",
        name: "Multi-Node Override Cartridges",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83E\uDDE9\uD83D\uDDA5\uFE0F",
        short: "Stage chained takeovers faster.",
        description: "Pre-staged command bundles and credential handoffs that reduce human timing error in sequential takeovers of multiple endpoints."
    },
    {
        id: "surge-damping-couplers",
        techniqueId: "bio-feedback-guard",
        name: "Surge Damping Couplers",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\u26A1\uD83E\uDDEC",
        short: "Soaks reboot spikes safely.",
        description: "Inline TVS elements and RC snubbers that absorb transient voltage spikes during forced reboots to protect connected subsystems."
    },
    {
        id: "decoy-traffic-cartridge",
        techniqueId: "signal-mask-injection",
        name: "Decoy Traffic Cartridges",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83C\uDFAD\uD83D\uDCE1",
        short: "Hide control packets in noise.",
        description: "Traffic-shaping frames and padding packets that disguise control bursts inside believable network chatter without altering payloads."
    },
    {
        id: "swarm-sync-beacon-cart",
        techniqueId: "coordinated-flight-pattern",
        name: "Swarm Sync Beacon Carts",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83D\uDEF0\uFE0F\uD83E\uDD16",
        short: "Snap-syncs drone routes.",
        description: "Short-range UWB timing beacons that provide a common clock for nearby drones, improving lane separation and route timing."
    },
    {
        id: "overgrowth-lidar-pack",
        techniqueId: "rootpath-protocol",
        name: "Overgrowth LIDAR Packs",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83C\uDF3F\uD83D\uDCE1",
        short: "Map safe lanes through brush.",
        description: "Compact LIDAR + proximity sweep that identifies low-resistance channels through dense brush for safer autonomous routing."
    },
    {
        id: "quiet-sonar-cartridge",
        techniqueId: "echo-pulse-beacon",
        name: "Quiet Sonar Cartridges",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83D\uDD08\uD83D\uDEF0\uFE0F",
        short: "Low-profile ping mapping.",
        description: "Low-intensity ultrasonic transceivers that enable short-range mapping with minimal acoustic signature."
    },
    {
        id: "rapid-grounding-spikes",
        techniqueId: "system-ground-loop",
        name: "Rapid Grounding Spikes",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83D\uDCCE\u26A1",
        short: "Drop fault current to ground.",
        description: "Temporary ground electrodes and clamps that create safe earth paths to quickly dissipate fault current."
    },
    {
        id: "vent-cycler-pack",
        techniqueId: "spore-vent-reclaimer",
        name: "Vent Cycler Packs",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83C\uDF2C\uFE0F\uD83E\uDDEA",
        short: "Purge, filter, reuse air.",
        description: "Disposable microfilters and purge actuators that accelerate intake/exhaust cycling and capture particulates for recovery."
    },
    {
        id: "cutoff-line-kit",
        techniqueId: "manual-override-line",
        name: "Cutoff Line Kits",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\u2702\uFE0F\uD83E\uDDF5",
        short: "Install a physical kill-line.",
        description: "Insulated cable, crimps, and lockout tags for adding a physical isolation line to de-energize a local zone quickly."
    },
    {
        id: "scan-link-bridge",
        techniqueId: "entangled-synchrony",
        name: "Scan Link Bridges",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83E\uDDE0\uD83D\uDD17",
        short: "Lock scanners into sync.",
        description: "Clock fan-out and shared buffer modules that keep multiple instruments sampling in the same time base for coherent reads."
    },
    {
        id: "dual-spectrum-cartridge",
        techniqueId: "bio-spectral-crosscheck",
        name: "Dual-Spectrum Cartridges",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83E\uDDEC\uD83D\uDD2C",
        short: "Overlay bio + energy reads.",
        description: "Paired sensors and calibration markers that co-register biological signatures with radiation/field measurements for cross-checks."
    },
    {
        id: "residual-current-probe-kit",
        techniqueId: "ghost-echo-capture",
        name: "Residual Current Probe Kits",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83E\uDDF2\uD83D\uDCCF",
        short: "Sniff faint live lines.",
        description: "High-impedance clamp probes and tracer dye to detect low-level leakage and find viable paths through damaged circuits."
    }
];
var $979b99378be707cd$export$a24b2f292778b5dc = [
    {
        id: "harvest-sync-brace-pack",
        techniqueId: "reclamation-drone-link",
        name: "Harvest Sync Brace Packs",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83E\uDDBE\uD83C\uDF31",
        short: "Lock harvester + drone timing.",
        description: "Rigid braces and timing tabs that mechanically synchronize harvester motion with companion drones to reduce sample loss."
    },
    {
        id: "fast-filter-plenum-cart",
        techniqueId: "mycelial-rebalance",
        name: "Fast Filter Plenum Carts",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83C\uDF44\uD83E\uDDEA",
        short: "Accelerate live fungal sorting.",
        description: "Pre-wetted filtration pads and flow baffles that speed separation of viable biomass from debris in mixed slurries."
    },
    {
        id: "micro-mist-emitter",
        techniqueId: "phase-cleanse",
        name: "Micro-Mist Emitters",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83D\uDCA7\uD83E\uDDFC",
        short: "Lift spores/oils quickly.",
        description: "Single-use atomizer that lays down a uniform cleaning mist to lift spores/oils while minimizing residue."
    },
    {
        id: "rapid-brace-binder",
        techniqueId: "adaptive-lattice",
        name: "Rapid Brace Binders",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83E\uDEB5\uD83D\uDD78\uFE0F",
        short: "Snap-grow support frames.",
        description: "Two-part structural resin and mineral fillers that cure into lightweight struts for quick bracing or gap-spanning."
    },
    {
        id: "light-channel-films",
        techniqueId: "photosymbiosis",
        name: "Light Channel Films",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83D\uDD06\uD83C\uDF3F",
        short: "Pipe light through leaves.",
        description: "Thin-film optics that route and diffuse light to shaded growth surfaces, improving local photosynthetic efficiency."
    },
    {
        id: "root-guidance-stakes",
        techniqueId: "shadowroot-bloom",
        name: "Root Guidance Stakes",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83D\uDCCD\uD83C\uDF31",
        short: "Lead roots through cracks.",
        description: "Moisture-biased guide stakes that encourage root growth along existing micro-fractures to expose cavities safely."
    },
    {
        id: "breath-sync-strips",
        techniqueId: "signal-harmonizer",
        name: "Breath Sync Strips",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83D\uDE2E\u200D\uD83D\uDCA8\uD83C\uDF9A\uFE0F",
        short: "Align heart/breath rhythms.",
        description: "Skin-safe haptic strips that cue synchronized breathing patterns across the team, reducing stress responses without drugs."
    },
    {
        id: "chorus-diffuser-ampoule",
        techniqueId: "pheromone-chorus",
        name: "Chorus Diffuser Ampoules",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83E\uDDEA\uD83C\uDFB6",
        short: "Blend multi-handler signals.",
        description: "Timed micro-diffusers that release low-dose, non-sedative botanical blends to stabilize handler-group behavior."
    },
    {
        id: "scent-dampening-salve",
        techniqueId: "silent-hand",
        name: "Scent Dampening Salves",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83E\uDDF4\uD83D\uDC43",
        short: "Kill trail and gear snaps.",
        description: "Neutralizing balm for fabrics and skin that suppresses volatile compounds and squeak/rattle points at contact surfaces."
    },
    {
        id: "reactive-gel-patch",
        techniqueId: "bio-shielding",
        name: "Reactive Gel Patches",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83E\uDE79\uD83D\uDEE1\uFE0F",
        short: "Spread shock/heat on impact.",
        description: "Non-Newtonian impact-spread gel patches that distribute force and heat, improving short-term tolerance to arcs and hotspots."
    },
    {
        id: "enzyme-swap-kit",
        techniqueId: "shared-immunity",
        name: "Enzyme Swap Kits",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83D\uDD01\uD83E\uDDEC",
        short: "Pass resistance packs fast.",
        description: "Color-coded topical kits containing broad-spectrum cleansing and barrier components for rapid, shared exposure mitigation."
    },
    {
        id: "surface-tuning-spray",
        techniqueId: "dim-shift-layer",
        name: "Surface Tuning Sprays",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83D\uDD8C\uFE0F\uD83E\uDE9E",
        short: "Match tone and sheen quickly.",
        description: "Microflake coating with adjustable binder that tunes reflectivity and tone to match surrounding surfaces."
    },
    {
        id: "hardcase-quickframe-kit",
        techniqueId: "servo-containment",
        name: "Hardcase Quickframe Kits",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83D\uDCE6\uD83E\uDD16",
        short: "Shell hot samples fast.",
        description: "Fold-out frames and latch nets that convert drone housings into sealed transport cases for unstable samples."
    },
    {
        id: "pod-starter-seeds",
        techniqueId: "mutualist-growth",
        name: "Pod Starter Seeds",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83C\uDF30\uD83E\uDDEB",
        short: "Grow living containment.",
        description: "Expandable biopolymer pellets with inert scaffolding that form shock-absorbing pods around irregular objects."
    },
    {
        id: "recovery-pod-capsules",
        techniqueId: "reflex-bloom",
        name: "Recovery Pod Capsules",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83D\uDC8A\uD83C\uDF38",
        short: "Auto-release healing compounds.",
        description: "Timed-release capsules that deploy micro-pods carrying standard wound-care and decontamination compounds post-exposure."
    }
];
var $979b99378be707cd$export$29d1bf8c74230d20 = [
    {
        id: "relay-bridge-link-cart",
        techniqueId: "quantum-relay-hook",
        name: "Relay Bridge Link Carts",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83E\uDE9D\uD83D\uDDFA\uFE0F",
        short: "Piggyback maps on relays.",
        description: "Interface shims that attach mapping metadata to existing relay management frames for reliable piggybacking."
    },
    {
        id: "bio-pulse-amplifier-pack",
        techniqueId: "biotrace-resonance",
        name: "Bio-Pulse Amplifier Packs",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83D\uDCE1\uD83C\uDF31",
        short: "Boost returns off living matter.",
        description: "Low-power pulse amplifiers tuned to common organic absorption/reflectance bands to clarify returns from living matter."
    },
    {
        id: "map-cache-sync-cart",
        techniqueId: "shadow-archive",
        name: "Map Cache Sync Carts",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83D\uDCBE\uD83D\uDDFA\uFE0F",
        short: "Auto-sync portable map caches.",
        description: "Proximity sync cartridges using short-range NFC/optical channels to handshake map caches without manual transfer."
    },
    {
        id: "micro-torque-paste",
        techniqueId: "servo-alignment-tool",
        name: "Micro-Torque Pastes",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83E\uDDF4\uD83D\uDD27",
        short: "Seat pins and rails cleanly.",
        description: "Friction-balanced paste that stabilizes micro-movements in pins and rails for precise servo/lock alignment."
    },
    {
        id: "quiet-seal-injector",
        techniqueId: "biofilm-stabilizer",
        name: "Quiet Seal Injectors",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83E\uDD2B\uD83E\uDDEA",
        short: "Stop rattles and squeals.",
        description: "Thin polymer sealant applied under panel seams to eliminate rattle and high-frequency squeal during movement."
    },
    {
        id: "decoy-pulse-cartridge",
        techniqueId: "echo-pulse-decoy",
        name: "Decoy Pulse Cartridges",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83D\uDCE1\uD83C\uDFAF",
        short: "Flash a harmless misread.",
        description: "Programmable emitters that send harmless ranging pings to bias attention away from the working area."
    },
    {
        id: "route-shadow-taggers",
        techniqueId: "drone-path-shadow",
        name: "Route Shadow Taggers",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83C\uDFF7\uFE0F\uD83D\uDEB6",
        short: "Mark drone lanes for feet.",
        description: "Low-gloss floor markers that couple human pathing to known drone lanes, reducing the number of distinct traces."
    },
    {
        id: "low-shine-veil-pack",
        techniqueId: "spore-veil",
        name: "Low-Shine Veil Packs",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83C\uDF2B\uFE0F\uD83D\uDD76\uFE0F",
        short: "Dull edges, cut glare.",
        description: "Aerosolized matte coat that dulls hard edges and specular highlights to lower visual detection."
    },
    {
        id: "pace-sync-patches",
        techniqueId: "mirror-walk",
        name: "Pace Sync Patches",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83E\uDE79\uD83D\uDC63",
        short: "Keep squad as one trace.",
        description: "Haptic cadence patches that keep a squad\u2019s step timing uniform to reduce multi-source motion cues."
    },
    {
        id: "auth-spoof-keycard",
        techniqueId: "control-spoof",
        name: "Auth Spoof Keycards",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83E\uDEAA\uD83C\uDFAD",
        short: "Borrowed machine identity.",
        description: "Burn-once cards with limited, sandboxed credential profiles for passing routine, low-privilege checks."
    },
    {
        id: "thermal-scent-ampoule",
        techniqueId: "bio-id-mask",
        name: "Thermal Scent Ampoules",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83C\uDF21\uFE0F\uD83D\uDC43",
        short: "Mimic local heat + scent.",
        description: "Dual-channel projectors that shape IR apparent temperature and trace scent to blend with local background."
    },
    {
        id: "temp-log-writer-cart",
        techniqueId: "echo-loop",
        name: "Temp Log Writer Carts",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83D\uDCDD\uD83D\uDD01",
        short: "Plant harmless dummy logs.",
        description: "Write-only, time-limited log entries that add benign detours to audit trails without altering critical records."
    },
    {
        id: "quickset-anchor-rods",
        techniqueId: "phase-anchor",
        name: "Quickset Anchor Rods",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83D\uDEE0\uFE0F\uD83C\uDF00",
        short: "Pin drifting surfaces.",
        description: "Expandable rods and resin anchors that mechanically stabilize shifting walls and floors."
    },
    {
        id: "timing-pulse-tag",
        techniqueId: "depth-step",
        name: "Timing Pulse Tags",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\u23F1\uFE0F\uD83D\uDCCD",
        short: "Step on stable beats.",
        description: "Clip-on transponders that detect vibration cycles and flag brief low-motion windows for safer crossings."
    },
    {
        id: "scan-cache-array-cart",
        techniqueId: "echo-fold",
        name: "Scan Cache Array Carts",
        rarity: "epic",
        type: "consumable",
        effects: {
            "room-time-reduction": 10
        },
        credits: 100,
        icon: "\uD83D\uDDC2\uFE0F\uD83D\uDCE1",
        short: "Pocket + restore scans.",
        description: "Portable buffer arrays that capture recent sensor frames for quick re-loads after interference or resets."
    }
];
var $979b99378be707cd$export$71b953a5ed5f0cd6 = [
    // signal-relay
    {
        id: "precision-mast-calibrator",
        techniqueId: "relay-stabilizer",
        name: "Precision Mast Calibrator",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83C\uDF9B\uFE0F\uD83D\uDCE1",
        short: "Laser-align relay masts.",
        description: "Gyro-stabilized laser jig that zeroes dish bearings and mast tilt for a stable RF path during alignment."
    },
    {
        id: "biofiber-manifold",
        techniqueId: "organic-link-adapter",
        name: "Biofiber Manifold",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83C\uDF3F\uD83E\uDDF0",
        short: "Seat living splices cleanly.",
        description: "Multi-port manifold that tensions and seats polymer fiber splices for durable link repair."
    },
    {
        id: "adaptive-noise-gate",
        techniqueId: "silent-channel",
        name: "Adaptive Noise Gate",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83D\uDD07\uD83D\uDDA7",
        short: "Auto-null scanner pickup.",
        description: "Digital filter that tracks spectrum drift and attenuates pickup around sensitive bands."
    },
    // system-override
    {
        id: "multi-handshake-router",
        techniqueId: "command-cascade",
        name: "Multi-Handshake Router",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83D\uDD01\uD83D\uDDA5\uFE0F",
        short: "Chain control handshakes.",
        description: "Router core that sequences credentials and command bundles to reduce operator timing errors."
    },
    {
        id: "surge-buffer-backplane",
        techniqueId: "bio-feedback-guard",
        name: "Surge Buffer Backplane",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83E\uDDEF\u26A1",
        short: "Bleed off reboot spikes.",
        description: "Dielectric backplane with TVS arrays that bleeds transient load to ground during resets."
    },
    {
        id: "credential-spoof-matrix",
        techniqueId: "signal-mask-injection",
        name: "Credential Spoof Matrix",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83C\uDFAD\uD83D\uDD10",
        short: "Forge believable auth.",
        description: "Hardware emulator that produces constrained, audit-safe credential responses for masking maintenance traffic."
    },
    // drone-command
    {
        id: "swarm-route-controller",
        techniqueId: "coordinated-flight-pattern",
        name: "Swarm Route Controller",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83D\uDD79\uFE0F\uD83D\uDEF8",
        short: "Orchestrate flight lanes.",
        description: "Low-latency planner that de-conflicts headings and intervals across multiple airframes."
    },
    {
        id: "overgrowth-nav-suite",
        techniqueId: "rootpath-protocol",
        name: "Overgrowth Nav Suite",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83C\uDF3F\uD83E\uDDED",
        short: "Plan safe bio-channels.",
        description: "Biometric + terrain planner that fits paths along low-resistance natural channels."
    },
    {
        id: "quiet-sonar-array",
        techniqueId: "echo-pulse-beacon",
        name: "Quiet Sonar Array",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83D\uDCE1\uD83D\uDD08",
        short: "Stealth map pings.",
        description: "Low-signature ultrasonic array for short-range mapping with minimal acoustic profile."
    },
    // safeguard
    {
        id: "auto-ground-bus",
        techniqueId: "system-ground-loop",
        name: "Auto Ground Bus",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83E\uDDF0\u26A1",
        short: "Instant safe ground path.",
        description: "Self-seeking clamp bus that identifies viable earth points and bonds equipment rapidly."
    },
    {
        id: "cycler-governor",
        techniqueId: "spore-vent-reclaimer",
        name: "Cycler Governor",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83C\uDF2C\uFE0F\u2699\uFE0F",
        short: "Regulate purge cycles.",
        description: "Programmable controller that times purge and recapture phases for ventilation cycles."
    },
    {
        id: "hardline-junction-box",
        techniqueId: "manual-override-line",
        name: "Hardline Junction Box",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83E\uDDF2\uD83E\uDDF5",
        short: "Secure physical cut-off.",
        description: "Lockable junction that routes a physically isolated kill line for fast de-energizing."
    },
    // quantum-scan
    {
        id: "scan-link-backbone",
        techniqueId: "entangled-synchrony",
        name: "Scan Link Backbone",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83D\uDD17\uD83D\uDD2C",
        short: "Synchronize instruments.",
        description: "Common-clock distribution and shared buffering that keep instruments time-aligned."
    },
    {
        id: "dual-spectrum-integrator",
        techniqueId: "bio-spectral-crosscheck",
        name: "Dual-Spectrum Integrator",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83E\uDDEC\uD83D\uDCC8",
        short: "Fuse bio + energy bands.",
        description: "Inline integrator that co-registers biological, radiological, and EM field data."
    },
    {
        id: "low-current-amplifier",
        techniqueId: "ghost-echo-capture",
        name: "Low-Current Amplifier",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83D\uDCC8\uD83D\uDD0C",
        short: "Boost trace line signals.",
        description: "High-impedance amplifier that raises low-level line signals above measurement noise."
    }
];
var $979b99378be707cd$export$76261a034023b29 = [
    // reclamation
    {
        id: "harvest-flight-controller",
        techniqueId: "reclamation-drone-link",
        name: "Harvest Flight Controller",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83D\uDEF8\uD83C\uDF31",
        short: "Co-pilot harvest flights.",
        description: "Link hub that synchronizes drone and harvester timing to reduce sample loss."
    },
    {
        id: "fungal-flow-regulator",
        techniqueId: "mycelial-rebalance",
        name: "Fungal Flow Regulator",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83C\uDF44\u2699\uFE0F",
        short: "Stabilize live filters.",
        description: "Pressure/flow controller that maintains efficient separation across bio-filters."
    },
    {
        id: "surface-decon-manifold",
        techniqueId: "phase-cleanse",
        name: "Surface Decon Manifold",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83E\uDDFC\uD83E\uDDE9",
        short: "Evenly spread micro-mist.",
        description: "Distributor that ensures even micro-mist coverage for surface decontamination."
    },
    // growth-control
    {
        id: "lattice-lock-ribs",
        techniqueId: "adaptive-lattice",
        name: "Lattice Lock Ribs",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83E\uDDB4\uD83D\uDD78\uFE0F",
        short: "Harden bio-metal frames.",
        description: "Expandable ribs that stiffen quickly cured resin struts for temporary structural support."
    },
    {
        id: "leaf-optic-panel",
        techniqueId: "photosymbiosis",
        name: "Leaf Optic Panel",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83D\uDD06\uD83E\uDEB4",
        short: "Channel light efficiently.",
        description: "Adjustable optic panel that concentrates and angles light toward growth surfaces."
    },
    {
        id: "seam-probe-kit",
        techniqueId: "shadowroot-bloom",
        name: "Seam Probe Kit",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83E\uDE9B\uD83C\uDF31",
        short: "Find the right crack lines.",
        description: "Micro-sensors that locate moisture-bearing cracks suitable for guided root growth."
    },
    // wild-influence
    {
        id: "rhythm-guide-hub",
        techniqueId: "signal-harmonizer",
        name: "Rhythm Guide Hub",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83C\uDF9A\uFE0F\uD83E\uDEC0",
        short: "Broadcast calm cadence.",
        description: "Biofeedback hub broadcasting calm cadence cues via low-latency haptics."
    },
    {
        id: "multi-diffuser-crown",
        techniqueId: "pheromone-chorus",
        name: "Multi-Diffuser Crown",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83D\uDC51\uD83E\uDEBC",
        short: "Layer handler signals.",
        description: "Head-mounted array that blends multiple low-dose scent channels for wider coverage."
    },
    {
        id: "contact-silence-kit",
        techniqueId: "silent-hand",
        name: "Contact Silence Kit",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83E\uDD2B\uD83E\uDDF0",
        short: "Mute close-range tells.",
        description: "Shims and absorbents that eliminate contact squeaks/snaps on gear and panels."
    },
    // bio-shield
    {
        id: "layer-activator-pad",
        techniqueId: "bio-shielding",
        name: "Layer Activator Pad",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83E\uDDEB\uD83D\uDEE1\uFE0F",
        short: "Prime the spread layer.",
        description: "Induction pad that warms and activates shear-thickening gel layers prior to use."
    },
    {
        id: "enzyme-hub-manifold",
        techniqueId: "shared-immunity",
        name: "Enzyme Hub Manifold",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83E\uDDEC\uD83E\uDDEA",
        short: "Distribute resistance packs.",
        description: "Metering hub that distributes standardized decon/barrier packets among teammates."
    },
    {
        id: "surface-tuner-core",
        techniqueId: "dim-shift-layer",
        name: "Surface Tuner Core",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83C\uDF9B\uFE0F\uD83E\uDE9E",
        short: "Auto-match tone/sheens.",
        description: "Optical feedback controller that adjusts a microflake layer\u2019s reflectivity in real time."
    },
    // containment
    {
        id: "hot-sample-frame",
        techniqueId: "servo-containment",
        name: "Hot Sample Frame",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83D\uDD25\uD83D\uDCE6",
        short: "Carry volatile finds safely.",
        description: "Reconfigurable frame set that converts drone housings into sealed transport cases."
    },
    {
        id: "pod-growth-hub",
        techniqueId: "mutualist-growth",
        name: "Pod Growth Hub",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83C\uDF30\u2699\uFE0F",
        short: "Drive living pod formation.",
        description: "Controller that drives expansion and curing of shock-absorbing biopolymer pods."
    },
    {
        id: "recovery-pod-manifold",
        techniqueId: "reflex-bloom",
        name: "Recovery Pod Manifold",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83C\uDF38\u2699\uFE0F",
        short: "Time restorative releases.",
        description: "Pulse manifold that staggers timed release of standard restorative compounds."
    }
];
var $979b99378be707cd$export$7a39b013515e9c7d = [
    // echo-trace
    {
        id: "relay-pairing-bridge",
        techniqueId: "quantum-relay-hook",
        name: "Relay Pairing Bridge",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83E\uDE9D\uD83D\uDCE1",
        short: "Bind maps to relays.",
        description: "Bridge board that associates scanner output with relay control frames for piggybacking."
    },
    {
        id: "bio-pulse-coupler",
        techniqueId: "biotrace-resonance",
        name: "Bio-Pulse Coupler",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83C\uDF31\uD83D\uDD17",
        short: "Sharpen organic echoes.",
        description: "Coupler optimized for organic reflectance bands to clarify weak returns."
    },
    {
        id: "map-sync-hub",
        techniqueId: "shadow-archive",
        name: "Map Sync Hub",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83D\uDDC2\uFE0F\uD83D\uDD0C",
        short: "Hands-free cache sync.",
        description: "Passive NFC/optical hub that auto-syncs portable map caches within close range."
    },
    // lock-breach
    {
        id: "micro-torque-rail",
        techniqueId: "servo-alignment-tool",
        name: "Micro-Torque Rail",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83E\uDDF0\uD83E\uDDED",
        short: "Guide picks to seat line.",
        description: "Instrument rail with torque sensors that guides precise pick seating and servo alignment."
    },
    {
        id: "quiet-seal-rail",
        techniqueId: "biofilm-stabilizer",
        name: "Quiet Seal Rail",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83E\uDD2B\uD83E\uDDF5",
        short: "Lay silent panel seams.",
        description: "Applicator rail for even deposition of low-noise seam sealant."
    },
    {
        id: "decoy-phase-driver",
        techniqueId: "echo-pulse-decoy",
        name: "Decoy Phase Driver",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83C\uDFAF\uD83D\uDCE1",
        short: "Throw believable pings.",
        description: "Programmable driver that emits harmless distractor pings away from the work zone."
    },
    // stealth-transit
    {
        id: "route-shadow-hub",
        techniqueId: "drone-path-shadow",
        name: "Route Shadow Hub",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83D\uDEE3\uFE0F\uD83D\uDC64",
        short: "Merge with drone lanes.",
        description: "Planner hub that snaps team pathing to known drone traces to reduce distinct movement signatures."
    },
    {
        id: "low-shine-housing",
        techniqueId: "spore-veil",
        name: "Low-Shine Housing",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83D\uDD76\uFE0F\uD83E\uDDE9",
        short: "Cut edges and glare.",
        description: "Matte micro-texture housing that binds dulling coats and cuts specular highlights."
    },
    {
        id: "pace-sync-hub",
        techniqueId: "mirror-walk",
        name: "Pace Sync Hub",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\u23F1\uFE0F\uD83D\uDEB6",
        short: "Keep formation cadence.",
        description: "Haptic metronome router that keeps formation cadence uniform under movement."
    },
    // signal-mask
    {
        id: "auth-emulator-core",
        techniqueId: "control-spoof",
        name: "Auth Emulator Core",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83E\uDEAA\uD83E\uDDE0",
        short: "Clone basic credentials.",
        description: "Constrained emulator that serves limited, low-privilege machine IDs for routine checkpoints."
    },
    {
        id: "thermal-scent-hub",
        techniqueId: "bio-id-mask",
        name: "Thermal Scent Hub",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83C\uDF21\uFE0F\uD83D\uDD75\uFE0F",
        short: "Blend heat + scent masks.",
        description: "Dual-channel projector that blends IR apparent temperature and trace scent output."
    },
    {
        id: "log-sanitizer-kernel",
        techniqueId: "echo-loop",
        name: "Log Sanitizer Kernel",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83E\uDDFC\uD83D\uDCDD",
        short: "Write harmless trails.",
        description: "Kernel that writes time-limited, non-critical log noise to support benign alternate paths."
    },
    // transit-anchor
    {
        id: "anchor-brace-grid",
        techniqueId: "phase-anchor",
        name: "Anchor Brace Grid",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83E\uDDF1\uD83C\uDF00",
        short: "Stiffen local geometry.",
        description: "Rigid grid mounts that couple to braces and anchors to stabilize shifting surfaces."
    },
    {
        id: "timing-window-hub",
        techniqueId: "depth-step",
        name: "Timing Window Hub",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83E\uDE9F\u23F1\uFE0F",
        short: "Spot safe crossing beats.",
        description: "Predictive timing hub that detects low-motion windows using vibration sensors."
    },
    {
        id: "scan-cache-backplane",
        techniqueId: "echo-fold",
        name: "Scan Cache Backplane",
        rarity: "epic",
        type: "techGear",
        effects: {
            "technique-success-bonus": 10
        },
        icon: "\uD83D\uDDC4\uFE0F\uD83D\uDCE1",
        short: "Retain sensor context.",
        description: "Redundant buffer backplane that preserves recent scan frames for rapid re-load."
    }
];
var $979b99378be707cd$export$7f9cadee9e5a61bb = {
    permanentSlotsPerCharacter: 5,
    permanentSlotBinding: "1 per skill (affects one chosen technique for that skill via loadout toggle)",
    consumableCarryLimit: 6,
    consumablePerTechniqueCapPerRoom: 1,
    consumableStackCapPerTechnique: 2,
    consumableTimeBonusCap: -0.4
};
var $979b99378be707cd$export$241bdd39c3e59b72 = [
    {
        id: "encrypted-transceiver-chip",
        name: "Encrypted Transceiver Chip",
        type: "material",
        rarity: "rare",
        faction: "dominion",
        icon: "\uD83D\uDCF6",
        description: "High-security chip enabling encrypted signal transmission and remote control.",
        short: "Encrypted chip for drone and comm systems."
    },
    {
        id: "radiation-sensor-module",
        name: "Radiation Sensor Module",
        type: "material",
        rarity: "rare",
        faction: "dominion",
        icon: "\u2622\uFE0F",
        description: "Advanced sensor module for detecting radiation and electromagnetic anomalies.",
        short: "Detection module for radiation scanners."
    },
    {
        id: "bio-conductive-mesh",
        name: "Bio-Conductive Mesh",
        type: "material",
        rarity: "rare",
        faction: "wilders",
        icon: "\uD83E\uDDEC",
        description: "Flexible organic mesh that transmits low electrical signals through tissue or plant matter.",
        short: "Organic mesh used in biotech interfaces."
    },
    {
        id: "synthetic-pheromone-capsule",
        name: "Synthetic Pheromone Capsule",
        type: "material",
        rarity: "rare",
        faction: "wilders",
        icon: "\uD83E\uDD8B",
        description: "Pressurized capsule releasing synthetic pheromones for wildlife modulation.",
        short: "Behavioral control capsule for wildlife devices."
    },
    {
        id: "em-interference-chip",
        name: "EM Interference Chip",
        type: "material",
        rarity: "rare",
        faction: "veil",
        icon: "\uD83D\uDCBE",
        description: "Microchip designed to emit controlled electromagnetic interference for masking signals.",
        short: "Chip used to disrupt tracking and detection."
    },
    {
        id: "harmonic-stabilizer-core",
        name: "Harmonic Stabilizer Core",
        type: "material",
        rarity: "rare",
        faction: "veil",
        icon: "\uD83C\uDF00",
        description: "Gyroscopic core used to counterbalance unstable structures and terrain.",
        short: "Stabilization core for terrain support units."
    },
    {
        id: "signal-sync-crystal",
        name: "Signal Sync Crystal",
        type: "material",
        rarity: "rare",
        faction: "dominion",
        icon: "\uD83D\uDD00",
        description: "Calibrated crystal matrix that synchronizes multi-device signal frequencies.",
        short: "Signal alignment crystal for coordination amplifiers."
    },
    {
        id: "data-storage-crystal",
        name: "Data Storage Crystal",
        type: "material",
        rarity: "rare",
        faction: "veil",
        icon: "\uD83D\uDD2E",
        description: "Miniature crystal lattice capable of storing large volumes of encoded data.",
        short: "Data storage crystal for recovered memories."
    },
    {
        id: "precision-chrono-core",
        name: "Precision Chrono Core",
        type: "material",
        rarity: "rare",
        faction: "veil",
        icon: "\u23F1\uFE0F",
        description: "High-grade mechanical core used in advanced timekeeping and synchronization devices.",
        short: "Core for timing, synchronization, and cooldown systems."
    },
    {
        id: "high-torque-motor-core",
        name: "High-Torque Motor Core",
        type: "material",
        rarity: "rare",
        faction: "wilders",
        icon: "\uD83D\uDD29",
        description: "Industrial motor assembly capable of driving heavy extraction tools.",
        short: "Motor core for drills and extraction equipment."
    },
    {
        id: "containment-gel-lining",
        name: "Containment Gel Lining",
        type: "material",
        rarity: "rare",
        faction: "wilders",
        icon: "\uD83E\uDDEB",
        description: "Reactive gel layer used to stabilize and store hazardous or bioactive materials safely.",
        short: "Protective lining for biological containment equipment."
    },
    {
        id: "voltage-regulator-unit",
        name: "Voltage Regulator Unit",
        type: "material",
        rarity: "rare",
        faction: "dominion",
        icon: "\u2699\uFE0F",
        description: "Industrial-grade component for maintaining current stability across damaged grids.",
        short: "Voltage control hardware for electrical systems."
    }
];
var $979b99378be707cd$export$d4a72d069095e9e5 = {
    common: {
        name: "Common",
        order: 1,
        color: "#9ca3af",
        craftingCost: 5,
        dropChance: {
            // Per-event chance, DECREASING with tier: early crafting needs healthy common
            // inflow, but at T3 raid volume commons otherwise swamp the inventory.
            // Events are the ONLY common source (the bonus event awards intel credits).
            // T1: 70%, T2: 55%, T3: 40% per event.
            base: 0.7,
            perTier: -0.15,
            max: 0.75,
            // Relative selection weights fitted by tools/loot-equilibrium.mjs --fit
            // (mix-only iterative income-vs-demand fit across factions and regions,
            // mean-1.0 normalized). Regenerate when recipes/events change.
            perItem: {
                // Fitted by tools/loot-equilibrium.mjs --fit against the ownership-
                // clustered recipes (materialOwnership.js): weights reconcile each
                // item's drop income with its recipe demand inside the now-focused
                // pools. Regenerate when recipes/events change.
                "composite-casing": 10,
                "aluminum-shell": 4.82,
                "logic-ribbon-cable": 2.58,
                "circuit-board": 1.55,
                "ceramic-insulator": 1.45,
                "copper-wire": 1.43,
                "relay-antenna-strut": 1.41,
                "power-cell-casing": 1.22,
                "etched-keyplate-blank": 0.15,
                "micro-bearing-set": 0.13,
                "canvas-fiber": 0.12,
                "tanned-gut-cord": 0.12,
                "resin-casing": 0.12,
                "spore-felt-padding": 0.12,
                "plastic-casing": 0.09,
                "glass-lens": 0.09,
                "brass-fittings": 0.09,
                "iron-frame": 0.09,
                "steel-plates": 0.09,
                "fabric-mesh": 0.09,
                "polymer-tubing": 0.09,
                "carbon-housing": 0.09,
                "rubber-seal": 0.09,
                "leather-straps": 0.09,
                "chitin-plate": 0.09,
                "matte-coating-compound": 0.09,
                "acoustic-foam-wafer": 0.09,
                "optic-fiber-spool": 0.09
            }
        },
        quantity: {
            // Sized against the sticky-region player model: 1-2 per drop paces gear
            // completion toward the 30-day target and keeps inventory piles lean
            gate: {
                base: 1,
                random: 1
            },
            hazard: {
                base: 1,
                random: 1
            }
        }
    },
    uncommon: {
        name: "Uncommon",
        order: 2,
        // 6-digit, like every other rarity. This carried a redundant `ff` alpha —
        // no rendering difference, but it is the one swatch that could not be fed
        // to anything expecting #rrggbb, and the old value-pinned test only ever
        // looked at `rare` so nothing noticed.
        color: "#3bf683",
        craftingCost: 15,
        dropChance: {
            // Per-event chance; gates compound over 2-4 events so keep this low
            // (0.30 -> ~66% per gate room, ~41% per hazard room at tier 1)
            base: 0.3,
            perTier: 0.03,
            max: 0.6,
            // Fitted by tools/loot-equilibrium.mjs --fit: uncommon intermediates now
            // drop from the skill chains (full recipe components), so shape the mix
            // to demand like the other tiers. Regenerate when recipes change.
            perItem: {
                "sealed-hydraulic-pump": 10,
                "medical-stimulant-cartridge": 0.22,
                "precision-servo-gear": 0.12,
                "signal-processor-core": 0.12,
                "override-datakey": 0.12,
                "power-regulation-unit": 0.12,
                "drone-gyro-assembly": 0.12,
                "ultrasonic-sensor-grid": 0.12,
                "thermal-polarizer-film": 0.12,
                "nutrient-catalyst-ampoule": 0.12,
                "symbiotic-culture-vial": 0.12,
                "pheromone-distiller-coil": 0.12,
                "nutrient-gel-pack": 0.12,
                "adaptive-filter-membrane": 0.12,
                "phase-lens-array": 0.12,
                "micro-servo-drill": 0.12,
                "vibration-dampener": 0.12,
                "ghost-signal-modulator": 0.12
            }
        },
        quantity: {
            gate: {
                base: 2,
                random: 1
            },
            hazard: {
                base: 1,
                random: 1
            }
        }
    },
    rare: {
        name: "Rare",
        order: 3,
        // blue-400, not blue-500: the -500 stop failed WCAG AA on every background
        // it is used against (4.10 on the raid log, 3.52 on a room-card header,
        // 4.33 on the game body). Same hue, one stop lighter, 5.09-6.26 everywhere.
        color: "#60a5fa",
        craftingCost: 70,
        dropChance: {
            // Per-event chance; also drives the bonus-cascade rare step
            // (~55% per gate room, ~33% per hazard room at tier 1, all paths combined)
            gate: {
                base: 0.18,
                perTier: 0.04,
                max: 0.5
            },
            hazard: {
                base: 0.15,
                perTier: 0.04,
                max: 0.4
            },
            perItem: {
                // Fitted by tools/loot-equilibrium.mjs --fit against the ownership-
                // clustered recipes. Regenerate when recipes change.
                "radiation-sensor-module": 8.0,
                "signal-sync-crystal": 2.41,
                "data-storage-crystal": 0.17,
                "precision-chrono-core": 0.16,
                "high-torque-motor-core": 0.16,
                "encrypted-transceiver-chip": 0.16,
                "voltage-regulator-unit": 0.16,
                "bio-conductive-mesh": 0.16,
                "synthetic-pheromone-capsule": 0.16,
                "containment-gel-lining": 0.16,
                "em-interference-chip": 0.16,
                "harmonic-stabilizer-core": 0.16
            }
        },
        quantity: {
            gate: {
                base: 2,
                perTier: 1,
                max: 4
            },
            hazard: {
                base: 1,
                random: 2
            }
        }
    },
    epic: {
        name: "Epic",
        order: 4,
        // purple-400, not purple-500 — same reason as rare above. The -500 stop was
        // the worst rarity on the palette (3.81 / 3.27 / 4.02); this reads 4.89-6.02
        // and still sits clearly between rare's blue and legendary's gold.
        color: "#c084fc",
        craftingCost: 300,
        dropChance: {
            gate: {
                base: 0.2,
                perTier: 0.05,
                max: 0.4
            },
            hazard: {
                base: 0.15,
                perTier: 0.05,
                max: 0.3
            },
            perItem: {}
        },
        quantity: 1
    },
    legendary: {
        name: "Legendary",
        order: 5,
        color: "#eab308",
        craftingCost: 750,
        dropChance: {
            base: 0.000001,
            perTier: 0.01,
            max: 0.05,
            // Utility-artifact blueprints have no skill tie, so they appear in
            // EVERY room's legendary pool and would soak most rolls. Half weight
            // keeps them obtainable anywhere while skill-tied blueprints (weight
            // 1.0, present only in rooms using their skill) win more of the rolls
            // in the rooms players target for them.
            perItem: {
                "data-cache-drive-blueprint": 0.5,
                "relic-resonance-tuner-blueprint": 0.5,
                "hazard-lens-visor-blueprint": 0.5,
                "recovery-injector-blueprint": 0.5,
                "contract-beacon-blueprint": 0.5,
                "salvage-compression-rig-blueprint": 0.5,
                "sync-regulator-watch-blueprint": 0.5,
                "auto-stabilizer-pack-blueprint": 0.5,
                "training-node-deck-blueprint": 0.5,
                "crosslink-amplifier-blueprint": 0.5,
                "material-extractor-blueprint": 0.5,
                "memory-crystal-shard-blueprint": 0.5
            }
        },
        quantity: 1
    },
    unique: {
        name: "Unique",
        order: 6,
        color: "#f97316",
        craftingCost: 1500,
        dropChance: {
            base: 0.015,
            minTier: 4,
            // Selection WEIGHTS within the pool, like every other rarity here — NOT
            // per-item rates, and they do not override `minTier`. The old comment
            // claimed otherwise and was wrong: `getRarityDropChance` reads minTier
            // and never looks at perItem, so there is no per-item escape from the
            // tier gate. Worth knowing before L4's T0 — reaching story relics below
            // Tier 4 means changing minTier or the pool, not adding entries here.
            perItem: {}
        },
        quantity: 1
    }
};
var $979b99378be707cd$export$a4f81eda8633632 = [
    // === Story Relics ===
    {
        id: "collapse-key-fragment",
        name: "Collapse Key Fragment",
        type: "storyRelic",
        rarity: "unique",
        icon: "\uD83D\uDDDD\uFE0F",
        description: "Encrypted shard containing partial records of the Collapse.",
        short: "Encrypted shard with Collapse records."
    },
    {
        id: "echo-memory-shard",
        name: "Echo Memory Shard",
        type: "storyRelic",
        rarity: "unique",
        icon: "\uD83D\uDC8E",
        description: "Crystallized imprint of pre-collapse memories and signals.",
        short: "Crystallized pre-collapse memories."
    },
    {
        id: "reality-breach-record",
        name: "Reality Breach Record",
        type: "storyRelic",
        rarity: "unique",
        icon: "\uD83D\uDCDC",
        description: "Primary-source documentation of the earliest breach events.",
        short: "Records of the first breaches."
    },
    {
        id: "dimensional-artifact",
        name: "Dimensional Artifact",
        type: "storyRelic",
        rarity: "unique",
        icon: "\uD83C\uDF00",
        description: "Object exhibiting multi-state presence across unstable fields.",
        short: "Object with multi-state presence."
    },
    {
        id: "temporal-echo-crystal",
        name: "Temporal Echo Crystal",
        type: "storyRelic",
        rarity: "unique",
        icon: "\u23F3",
        description: "Crystal with layered timestamps\u2014echoes from divergent timelines.",
        short: "Crystal echoing divergent timelines."
    }
];
var $979b99378be707cd$export$2508a374b14b8e59 = [
    {
        id: "signal-processor-core",
        name: "Signal Processor Core",
        type: "material",
        rarity: "uncommon",
        faction: "dominion",
        icon: "\uD83D\uDCBD",
        description: "Miniature processor unit that boosts data throughput in repeater systems.",
        short: "Processing chip for advanced comm systems."
    },
    {
        id: "precision-servo-gear",
        name: "Precision Servo Gear",
        type: "material",
        rarity: "uncommon",
        faction: "dominion",
        icon: "\u2699\uFE0F",
        description: "Fine-tuned metal servo component used in precision motor assemblies.",
        short: "Precision gear for mechanical control units."
    },
    {
        id: "nutrient-catalyst-ampoule",
        name: "Nutrient Catalyst Ampoule",
        type: "material",
        rarity: "uncommon",
        faction: "wilders",
        icon: "\uD83D\uDCA7",
        description: "Sealed glass vial of nutrient mist used to accelerate biological growth.",
        short: "Catalyst fluid for rapid plant growth."
    },
    {
        id: "adaptive-filter-membrane",
        name: "Adaptive Filter Membrane",
        type: "material",
        rarity: "uncommon",
        faction: "wilders",
        icon: "\uD83C\uDF2B\uFE0F",
        description: "Reactive fiber mesh that filters toxins and airborne pathogens.",
        short: "Filter sheet for respirators and purifiers."
    },
    {
        id: "ultrasonic-sensor-grid",
        name: "Ultrasonic Sensor Grid",
        type: "material",
        rarity: "uncommon",
        faction: "veil",
        icon: "\uD83D\uDCE1",
        description: "Array of micro-emitters tuned for acoustic mapping and detection.",
        short: "Acoustic sensor assembly for scanners."
    },
    {
        id: "micro-servo-drill",
        name: "Micro-Servo Drill",
        type: "material",
        rarity: "uncommon",
        faction: "veil",
        icon: "\uD83E\uDE9B",
        description: "High-speed micro drill used in lockpicking and mechanical breach kits.",
        short: "Precision drill component for breach tools."
    },
    {
        id: "vibration-dampener",
        name: "Vibration Dampener",
        type: "material",
        rarity: "uncommon",
        faction: "veil",
        icon: "\uD83D\uDD07",
        description: "Rubberized composite that absorbs vibration and reduces sound transmission.",
        short: "Noise-canceling gel used in stealth equipment."
    },
    {
        id: "thermal-polarizer-film",
        name: "Thermal Polarizer Film",
        type: "material",
        rarity: "uncommon",
        faction: "veil",
        icon: "\uD83E\uDE9E",
        description: "Transparent sheet that filters heat and glare for protective visors.",
        short: "Heat-filtering film for visors and lenses."
    },
    {
        id: "medical-stimulant-cartridge",
        name: "Medical Stimulant Cartridge",
        type: "material",
        rarity: "uncommon",
        faction: "wilders",
        icon: "\uD83D\uDC89",
        description: "Preloaded cartridge containing controlled restorative compounds.",
        short: "Pharma cartridge for emergency injectors."
    },
    {
        id: "power-regulation-unit",
        name: "Power Regulation Unit",
        type: "material",
        rarity: "uncommon",
        faction: "dominion",
        icon: "\u26A1",
        description: "Compact control block used to distribute and stabilize power flow in complex systems.",
        short: "Stabilizer unit for energy systems and machinery."
    },
    {
        id: "sealed-hydraulic-pump",
        name: "Sealed Hydraulic Pump",
        type: "material",
        rarity: "uncommon",
        faction: "dominion",
        icon: "\uD83D\uDEE0\uFE0F",
        description: "Compact hydraulic pump designed for portable mechanical devices.",
        short: "Fluid pressure unit for small machines and stabilizers."
    },
    {
        id: "nutrient-gel-pack",
        name: "Nutrient Gel Pack",
        type: "material",
        rarity: "uncommon",
        faction: "wilders",
        icon: "\uD83E\uDD7C",
        description: "Sealed packet of regenerative gel used to sustain and accelerate plant regrowth.",
        short: "Growth medium for biological repair devices."
    },
    {
        id: "override-datakey",
        name: "Override Datakey",
        type: "material",
        rarity: "uncommon",
        faction: "dominion",
        icon: "\uD83D\uDD11",
        description: "Pre-authorized command key that grants temporary root access to compliant Dominion systems.",
        short: "Root-access key for system takeovers."
    },
    {
        id: "drone-gyro-assembly",
        name: "Drone Gyro Assembly",
        type: "material",
        rarity: "uncommon",
        faction: "dominion",
        icon: "\uD83D\uDEF8",
        description: "Self-leveling gyroscope block recovered from downed drones, the heart of any stable airframe.",
        short: "Stabilizing gyro for drone frames."
    },
    {
        id: "symbiotic-culture-vial",
        name: "Symbiotic Culture Vial",
        type: "material",
        rarity: "uncommon",
        faction: "wilders",
        icon: "\uD83E\uDDEA",
        description: "Living culture of paired organisms that accelerate each other's growth when introduced to a host.",
        short: "Living culture for growth acceleration."
    },
    {
        id: "pheromone-distiller-coil",
        name: "Pheromone Distiller Coil",
        type: "material",
        rarity: "uncommon",
        faction: "wilders",
        icon: "\uD83D\uDC1D",
        description: "Condensing coil that concentrates raw gland extracts into potent behavioral signals.",
        short: "Distiller coil for pheromone extraction."
    },
    {
        id: "phase-lens-array",
        name: "Phase Lens Array",
        type: "material",
        rarity: "uncommon",
        faction: "veil",
        icon: "\uD83D\uDD2D",
        description: "Stacked lens set that splits and rejoins light out of phase, bending sightlines around its bearer.",
        short: "Phase optics for displacement gear."
    },
    {
        id: "ghost-signal-modulator",
        name: "Ghost Signal Modulator",
        type: "material",
        rarity: "uncommon",
        faction: "veil",
        icon: "\uD83D\uDC7B",
        description: "Modulator that wraps real transmissions inside fabricated noise, leaving trackers chasing echoes.",
        short: "Signal wrapper that fakes transmission sources."
    }
];
var $979b99378be707cd$export$e32476559574be7c = [
    {
        id: "photo-charm",
        name: "Photo Charm Pendant",
        rarity: "common",
        type: "relic",
        icon: "\uD83D\uDCF7",
        description: "Transparent polymer locket containing a color photo of a pet. Image still bright.",
        short: "Polymer locket with pet photo.",
        variantTags: [
            "pendant",
            "jewelry",
            "photo",
            "polymer"
        ],
        credits: 100
    },
    {
        id: "festival-wristband",
        name: "Festival Wristband",
        rarity: "common",
        type: "relic",
        icon: "\uD83C\uDF9F\uFE0F",
        description: "Printed polymer band from a summer event. Microtext lists the performer lineup.",
        short: "Summer event polymer wristband.",
        variantTags: [
            "wristband",
            "festival",
            "plastic",
            "print"
        ],
        credits: 95
    },
    {
        id: "souvenir-mug",
        name: "Souvenir Mug",
        rarity: "common",
        type: "relic",
        icon: "\u2615",
        description: "Ceramic cup labeled 'First Orbit Park.' Glaze intact despite chipping.",
        short: "Ceramic mug from orbit park.",
        variantTags: [
            "mug",
            "ceramic",
            "souvenir",
            "cup"
        ],
        credits: 100
    },
    {
        id: "keyring-tag",
        name: "Keyring Tag",
        rarity: "common",
        type: "relic",
        icon: "\uD83D\uDD11",
        description: "Stamped aluminum key-tag from a transit depot locker bank.",
        short: "Stamped locker key tag.",
        variantTags: [
            "key",
            "tag",
            "metal",
            "transit"
        ],
        credits: 90
    },
    {
        id: "school-badge",
        name: "School Badge",
        rarity: "common",
        type: "relic",
        icon: "\uD83D\uDCDB",
        description: "Enamel pin depicting a school crest with a stylized orbit and laurel.",
        short: "Enamel pin with school crest.",
        variantTags: [
            "pin",
            "enamel",
            "badge",
            "school"
        ],
        credits: 105
    },
    {
        id: "magazine-cover",
        name: "Magazine Cover (Laminate)",
        rarity: "common",
        type: "relic",
        icon: "\uD83D\uDCF0",
        description: "Fashion issue showing bright colors and optimistic slogans about 'The Age of Harmony.'",
        short: "Laminated fashion magazine cover.",
        variantTags: [
            "magazine",
            "print",
            "fashion",
            "poster"
        ],
        credits: 98
    },
    {
        id: "transit-map",
        name: "Transit Map Foldout",
        rarity: "common",
        type: "relic",
        icon: "\uD83D\uDDFA\uFE0F",
        description: "Folding map for a multi-line rail network. Still legible with UV markings.",
        short: "Fold-out map of rail lines.",
        variantTags: [
            "map",
            "paper",
            "transit",
            "foldout"
        ],
        credits: 105
    },
    {
        id: "childrens-figurine",
        name: "Children's Figurine",
        rarity: "common",
        type: "relic",
        icon: "\uD83E\uDDF8",
        description: "Small injection-molded hero figure with a chipped cape and faded paint.",
        short: "Small molded hero figure.",
        variantTags: [
            "toy",
            "figurine",
            "plastic",
            "child"
        ],
        credits: 100
    },
    {
        id: "cafe-token",
        name: "Caf\xe9 Token",
        rarity: "common",
        type: "relic",
        icon: "\uD83E\uDE99",
        description: "Stamped brass token for a downtown caf\xe9's loyalty promotion.",
        short: "Stamped brass caf\xe9 token.",
        variantTags: [
            "token",
            "brass",
            "cafe",
            "coin"
        ],
        credits: 110
    }
];
var $979b99378be707cd$export$5255cc549327de05 = [
    {
        id: "signed-novel",
        name: "Signed Novel",
        rarity: "uncommon",
        type: "relic",
        icon: "\uD83D\uDCDA",
        description: "Printed softcover novel with a personal autograph on the title page.",
        short: "Autographed softcover novel.",
        variantTags: [
            "book",
            "signed",
            "print",
            "literature"
        ],
        credits: 150
    },
    {
        id: "photo-album",
        name: "Family Photo Album",
        rarity: "uncommon",
        type: "relic",
        icon: "\uD83D\uDCD4",
        description: "Cloth-bound album with adhesive pages; family celebrations and travel scenes.",
        short: "Cloth-bound family album.",
        variantTags: [
            "photos",
            "album",
            "family",
            "paper"
        ],
        credits: 140
    },
    {
        id: "gallery-poster",
        name: "Gallery Poster",
        rarity: "uncommon",
        type: "relic",
        icon: "\uD83D\uDDBC\uFE0F",
        description: "Matte poster for a local art gallery opening. Colors remain stable.",
        short: "Matte poster for gallery opening.",
        variantTags: [
            "poster",
            "art",
            "gallery",
            "print"
        ],
        credits: 160
    },
    {
        id: "award-plaque",
        name: "Award Plaque",
        rarity: "uncommon",
        type: "relic",
        icon: "\uD83C\uDFC5",
        description: "Laser-engraved acrylic plaque recognizing a community service contribution.",
        short: "Laser-engraved award plaque.",
        variantTags: [
            "plaque",
            "award",
            "engraved",
            "acrylic"
        ],
        credits: 145
    },
    {
        id: "studio-sketchbook",
        name: "Studio Sketchbook",
        rarity: "uncommon",
        type: "relic",
        icon: "\uD83D\uDCD3",
        description: "Wire-bound sketchbook filled with charcoal studies and ink experiments.",
        short: "Wire-bound artist sketchbook.",
        variantTags: [
            "sketch",
            "charcoal",
            "ink",
            "paper"
        ],
        credits: 155
    },
    {
        id: "recipe-tablet",
        name: "Recipe Tablet",
        rarity: "uncommon",
        type: "relic",
        icon: "\uD83D\uDCF1",
        description: "Lightweight e-ink tablet preloaded with family recipes and grocery lists.",
        short: "E-ink tablet with recipes.",
        variantTags: [
            "tablet",
            "e-ink",
            "recipe",
            "notes"
        ],
        credits: 175
    },
    {
        id: "wedding-invitation",
        name: "Wedding Invitation",
        rarity: "uncommon",
        type: "relic",
        icon: "\uD83D\uDC8C",
        description: "Foil-stamped cardstock with embossed names and an ornate border.",
        short: "Foil-stamped invitation card.",
        variantTags: [
            "invitation",
            "wedding",
            "card",
            "foil"
        ],
        credits: 135
    },
    {
        id: "journal-pen",
        name: "Journal & Pen",
        rarity: "uncommon",
        type: "relic",
        icon: "\uD83D\uDD8A\uFE0F",
        description: "Leatherette notebook paired with a smooth fine-point pen.",
        short: "Notebook with fine-point pen.",
        variantTags: [
            "journal",
            "pen",
            "stationery",
            "paper"
        ],
        credits: 165
    },
    {
        id: "vacation-souvenir",
        name: "Vacation Souvenir",
        rarity: "uncommon",
        type: "relic",
        icon: "\u2744\uFE0F",
        description: "Miniature snow globe of a coastal skyline, filled with preserved glitter flakes.",
        short: "Coastal skyline snow globe.",
        variantTags: [
            "souvenir",
            "snowglobe",
            "travel",
            "miniature"
        ],
        credits: 170
    }
];
var $979b99378be707cd$export$d3e0e7174c382d10 = [
    {
        id: "archive-disk",
        name: "Archive Disk",
        rarity: "rare",
        type: "relic",
        icon: "\uD83D\uDCBD",
        description: "Data crystal containing preserved recordings fro...ly public broadcasts and performances. Still partially readable.",
        short: "Data crystal with old programs.",
        variantTags: [
            "archive",
            "data",
            "recording",
            "media"
        ],
        credits: 350
    },
    {
        id: "unity-ribbon",
        name: "Unity Ribbon",
        rarity: "rare",
        type: "relic",
        icon: "\uD83C\uDF97\uFE0F",
        description: "Ribbon worn during a city-wide unification ceremony; dyes remain vibrant.",
        short: "Ceremonial unity ribbon.",
        variantTags: [
            "ribbon",
            "ceremony",
            "textile",
            "symbol"
        ],
        credits: 320
    },
    {
        id: "art-glass-vase",
        name: "Art Glass Vase",
        rarity: "rare",
        type: "relic",
        icon: "\uD83C\uDFFA",
        description: "Hand-blown glass with layered color bands and a maker's stamp near the base.",
        short: "Hand-blown art glass vase.",
        variantTags: [
            "glass",
            "vase",
            "art",
            "handmade"
        ],
        credits: 375
    },
    {
        id: "architectural-model",
        name: "Architectural Model",
        rarity: "rare",
        type: "relic",
        icon: "\uD83C\uDFD7\uFE0F",
        description: "Scale model of a civic building in foam and resin with etched window detail.",
        short: "Scale model of civic building.",
        variantTags: [
            "model",
            "architecture",
            "scale",
            "civic"
        ],
        credits: 340
    },
    {
        id: "performance-mask",
        name: "Performance Mask",
        rarity: "rare",
        type: "relic",
        icon: "\uD83C\uDFAD",
        description: "Stage mask crafted from lacquered wood; interior padding still intact.",
        short: "Lacquered theatrical mask.",
        variantTags: [
            "mask",
            "theatre",
            "stage",
            "wood"
        ],
        credits: 330
    },
    {
        id: "sports-trophy",
        name: "Sports Trophy",
        rarity: "rare",
        type: "relic",
        icon: "\uD83C\uDFC6",
        description: "Metal cup on a wooden base with a dedication plate for a city championship.",
        short: "Metal cup on wood base.",
        variantTags: [
            "trophy",
            "sports",
            "metal",
            "award"
        ],
        credits: 360
    },
    {
        id: "broadcast-award",
        name: "Broadcast Award",
        rarity: "rare",
        type: "relic",
        icon: "\uD83D\uDCFA",
        description: "Regional accolade for excellence in news programming; engraved date partially worn.",
        short: "Regional news award.",
        variantTags: [
            "award",
            "broadcast",
            "news",
            "engraved"
        ],
        credits: 345
    },
    {
        id: "city-banner-fragment",
        name: "City Banner Fragment",
        rarity: "rare",
        type: "relic",
        icon: "\uD83D\uDEA9",
        description: "Cloth fragment from a civic banner; hemmed edge and reinforced grommet hole.",
        short: "Fragment of civic banner.",
        variantTags: [
            "banner",
            "cloth",
            "city",
            "fragment"
        ],
        credits: 310
    },
    {
        id: "public-sculpture-miniature",
        name: "Public Sculpture Miniature",
        rarity: "rare",
        type: "relic",
        icon: "\uD83D\uDDFF",
        description: "Desk-sized resin replica of a well-known city sculpture.",
        short: "Miniature of public artwork.",
        variantTags: [
            "sculpture",
            "replica",
            "resin",
            "art"
        ],
        credits: 390
    }
];
var $979b99378be707cd$export$d82f13cda8103b44 = [
    {
        id: "time-capsule",
        name: "Time Capsule",
        rarity: "epic",
        type: "relic",
        icon: "\u23F3",
        description: "Sealed alloy container with personal notes, coins, and local newspapers.",
        short: "Sealed container of mementos.",
        variantTags: [
            "capsule",
            "sealed",
            "alloy",
            "time"
        ],
        credits: 850
    },
    {
        id: "national-flag",
        name: "National Flag",
        rarity: "epic",
        type: "relic",
        icon: "\uD83D\uDEA9",
        description: "Folded synthetic fabric in perfect colors, sealed in inert gas casing.",
        short: "Folded synthetic national flag.",
        variantTags: [
            "flag",
            "national",
            "fabric",
            "sealed"
        ],
        credits: 900
    },
    {
        id: "concert-guitar",
        name: "Concert Guitar",
        rarity: "epic",
        type: "relic",
        icon: "\uD83C\uDFB8",
        description: "Stage-played instrument with visible pick wear and intact signature on the body.",
        short: "Signed, stage-played guitar.",
        variantTags: [
            "guitar",
            "music",
            "signed",
            "stage"
        ],
        credits: 950
    },
    {
        id: "literary-manuscript",
        name: "Literary Manuscript",
        rarity: "epic",
        type: "relic",
        icon: "\uD83D\uDCDC",
        description: "Typed pages with redline edits and margin notes; author's seal on first sheet.",
        short: "Typed pages with redlines.",
        variantTags: [
            "manuscript",
            "pages",
            "typed",
            "edits"
        ],
        credits: 820
    },
    {
        id: "museum-maquette",
        name: "Museum Maquette",
        rarity: "epic",
        type: "relic",
        icon: "\uD83C\uDFDB\uFE0F",
        description: "Small-scale exhibition model with labeled plinths and lighting plan.",
        short: "Small-scale museum exhibit model.",
        variantTags: [
            "maquette",
            "museum",
            "model",
            "exhibit"
        ],
        credits: 875
    },
    {
        id: "charter-document",
        name: "Charter Document",
        rarity: "epic",
        type: "relic",
        icon: "\uD83D\uDCDC",
        description: "Parchment-style print with embossed seal and signatures of founding council.",
        short: "Founding charter with seal.",
        variantTags: [
            "charter",
            "document",
            "seal",
            "founding"
        ],
        credits: 880
    },
    {
        id: "film-award",
        name: "Film Award",
        rarity: "epic",
        type: "relic",
        icon: "\uD83C\uDFAC",
        description: "Sculpted statuette for excellence in filmmaking; base plate lists the production crew.",
        short: "Statuette for filmmaking.",
        variantTags: [
            "film",
            "award",
            "statuette",
            "cinema"
        ],
        credits: 925
    },
    {
        id: "fashion-archive",
        name: "Fashion Archive",
        rarity: "epic",
        type: "relic",
        icon: "\uD83D\uDC57",
        description: "Transparent crate of preserved high-fashion garments, colors unfaded.",
        short: "Preserved high-fashion garment collection.",
        variantTags: [
            "fashion",
            "archive",
            "garment",
            "case"
        ],
        credits: 1000
    },
    {
        id: "founders-journal",
        name: "Founders' Journal",
        rarity: "epic",
        type: "relic",
        icon: "\uD83D\uDCD6",
        description: "Leather-bound personal chronicle written by ea...rly colonists, containing reflections on cooperation and hope.",
        short: "Early colonist personal chronicle.",
        variantTags: [
            "journal",
            "book",
            "historic",
            "colonial"
        ],
        credits: 860
    }
];
var $979b99378be707cd$export$2aa6464abbbb5bfc = {
    coreCommons: [
        "steel-plates",
        "glass-lens",
        "rubber-seal",
        "iron-frame"
    ],
    skills: {
        // ===== DOMINION =====
        // c1 copper-wire, c2 circuit-board, c3 relay-antenna-strut,
        // c4 logic-ribbon-cable, c5 ceramic-insulator, c6 power-cell-casing,
        // c7 composite-casing, c8 aluminum-shell
        "signal-relay": {
            commons: [
                "copper-wire",
                "circuit-board",
                "relay-antenna-strut",
                "logic-ribbon-cable"
            ],
            core: [
                "steel-plates",
                "glass-lens"
            ],
            uncommons: [
                "signal-processor-core",
                "precision-servo-gear",
                "power-regulation-unit"
            ],
            rares: [
                "encrypted-transceiver-chip"
            ]
        },
        "system-override": {
            commons: [
                "ceramic-insulator",
                "power-cell-casing",
                "composite-casing",
                "aluminum-shell"
            ],
            core: [
                "rubber-seal",
                "iron-frame"
            ],
            uncommons: [
                "signal-processor-core",
                "override-datakey"
            ],
            rares: [
                "encrypted-transceiver-chip",
                "voltage-regulator-unit"
            ]
        },
        "drone-command": {
            commons: [
                "copper-wire",
                "circuit-board",
                "ceramic-insulator",
                "power-cell-casing"
            ],
            core: [
                "steel-plates",
                "rubber-seal"
            ],
            uncommons: [
                "override-datakey",
                "drone-gyro-assembly",
                "power-regulation-unit"
            ],
            rares: [
                "voltage-regulator-unit",
                "signal-sync-crystal"
            ]
        },
        "safeguard": {
            commons: [
                "relay-antenna-strut",
                "logic-ribbon-cable",
                "composite-casing",
                "aluminum-shell"
            ],
            core: [
                "glass-lens",
                "iron-frame"
            ],
            uncommons: [
                "drone-gyro-assembly",
                "sealed-hydraulic-pump"
            ],
            rares: [
                "signal-sync-crystal",
                "radiation-sensor-module"
            ]
        },
        "quantum-scan": {
            commons: [
                "copper-wire",
                "relay-antenna-strut",
                "ceramic-insulator",
                "composite-casing"
            ],
            core: [
                "steel-plates",
                "iron-frame"
            ],
            uncommons: [
                "sealed-hydraulic-pump",
                "precision-servo-gear"
            ],
            rares: [
                "radiation-sensor-module"
            ]
        },
        // ===== WILDERS =====
        // c1 fabric-mesh, c2 canvas-fiber, c3 leather-straps, c4 tanned-gut-cord,
        // c5 polymer-tubing, c6 resin-casing, c7 chitin-plate, c8 spore-felt-padding
        "reclamation": {
            commons: [
                "fabric-mesh",
                "canvas-fiber",
                "leather-straps",
                "tanned-gut-cord"
            ],
            core: [
                "steel-plates",
                "glass-lens"
            ],
            uncommons: [
                "nutrient-catalyst-ampoule",
                "nutrient-gel-pack",
                "medical-stimulant-cartridge"
            ],
            rares: [
                "high-torque-motor-core"
            ]
        },
        "growth-control": {
            commons: [
                "polymer-tubing",
                "resin-casing",
                "chitin-plate",
                "spore-felt-padding"
            ],
            core: [
                "rubber-seal",
                "iron-frame"
            ],
            uncommons: [
                "nutrient-catalyst-ampoule",
                "symbiotic-culture-vial"
            ],
            rares: [
                "high-torque-motor-core",
                "bio-conductive-mesh"
            ]
        },
        "wild-influence": {
            commons: [
                "fabric-mesh",
                "canvas-fiber",
                "polymer-tubing",
                "resin-casing"
            ],
            core: [
                "steel-plates",
                "rubber-seal"
            ],
            uncommons: [
                "symbiotic-culture-vial",
                "pheromone-distiller-coil",
                "medical-stimulant-cartridge"
            ],
            rares: [
                "bio-conductive-mesh",
                "synthetic-pheromone-capsule"
            ]
        },
        "bio-shield": {
            commons: [
                "leather-straps",
                "tanned-gut-cord",
                "chitin-plate",
                "spore-felt-padding"
            ],
            core: [
                "glass-lens",
                "iron-frame"
            ],
            uncommons: [
                "pheromone-distiller-coil",
                "adaptive-filter-membrane"
            ],
            rares: [
                "synthetic-pheromone-capsule",
                "containment-gel-lining"
            ]
        },
        "containment": {
            commons: [
                "fabric-mesh",
                "leather-straps",
                "polymer-tubing",
                "chitin-plate"
            ],
            core: [
                "steel-plates",
                "iron-frame"
            ],
            uncommons: [
                "adaptive-filter-membrane",
                "nutrient-gel-pack"
            ],
            rares: [
                "containment-gel-lining"
            ]
        },
        // ===== VEIL =====
        // c1 brass-fittings, c2 carbon-housing, c3 plastic-casing,
        // c4 micro-bearing-set, c5 optic-fiber-spool, c6 matte-coating-compound,
        // c7 acoustic-foam-wafer, c8 etched-keyplate-blank
        "echo-trace": {
            commons: [
                "brass-fittings",
                "carbon-housing",
                "plastic-casing",
                "micro-bearing-set"
            ],
            core: [
                "steel-plates",
                "glass-lens"
            ],
            uncommons: [
                "ultrasonic-sensor-grid",
                "phase-lens-array",
                "thermal-polarizer-film"
            ],
            rares: [
                "data-storage-crystal"
            ]
        },
        "lock-breach": {
            commons: [
                "optic-fiber-spool",
                "matte-coating-compound",
                "acoustic-foam-wafer",
                "etched-keyplate-blank"
            ],
            core: [
                "rubber-seal",
                "iron-frame"
            ],
            uncommons: [
                "ultrasonic-sensor-grid",
                "micro-servo-drill"
            ],
            rares: [
                "data-storage-crystal",
                "precision-chrono-core"
            ]
        },
        "stealth-transit": {
            commons: [
                "brass-fittings",
                "carbon-housing",
                "optic-fiber-spool",
                "matte-coating-compound"
            ],
            core: [
                "steel-plates",
                "rubber-seal"
            ],
            uncommons: [
                "micro-servo-drill",
                "vibration-dampener",
                "thermal-polarizer-film"
            ],
            rares: [
                "precision-chrono-core",
                "em-interference-chip"
            ]
        },
        "signal-mask": {
            commons: [
                "plastic-casing",
                "micro-bearing-set",
                "acoustic-foam-wafer",
                "etched-keyplate-blank"
            ],
            core: [
                "glass-lens",
                "iron-frame"
            ],
            uncommons: [
                "vibration-dampener",
                "ghost-signal-modulator"
            ],
            rares: [
                "em-interference-chip",
                "harmonic-stabilizer-core"
            ]
        },
        "transit-anchor": {
            commons: [
                "brass-fittings",
                "plastic-casing",
                "optic-fiber-spool",
                "acoustic-foam-wafer"
            ],
            core: [
                "steel-plates",
                "iron-frame"
            ],
            uncommons: [
                "ghost-signal-modulator",
                "phase-lens-array"
            ],
            rares: [
                "harmonic-stabilizer-core"
            ]
        }
    }
};
var $979b99378be707cd$export$9f9786ac427715c7 = {
    /**
   * Durable-gear craft cap. Skill (tech) gear and artifacts are equip-once
   * items - one slot per skill / per artifact slot, never consumed, sold, or
   * traded - so a second copy earns nothing (marks are already distinct-only)
   * and just burns materials. When false (default) each such design can be
   * crafted once per character; the crafting card shows "✓ CRAFTED" instead.
   * Flip to true to re-enable duplicate crafting (e.g. if a gear marketplace
   * ever makes spare copies worth something). Consumables are unaffected.
   */ allowDuplicateCrafts: false,
    recipeInputs: {
        // Re-tuned for weighted per-item drops: selection weights spread drops across
        // all items (nothing starves to zero anymore), so demand carries the pacing
        common: 5,
        uncommon: 5,
        rare: 4,
        epic: 4,
        legendary: 1,
        unique: 1
    },
    /**
   * Skill points awarded per level up (character-core.js levelUpCore).
   * Formula: base + Math.floor(level / levelDivisor) * increment
   * where `level` is the level just REACHED.
   *
   * With the values below (base: 2, levelDivisor: 2, increment: 3):
   * - Level 1:   3 skill points (the starting allotment, not a level-up grant)
   * - Level 2-3: 5 per level-up
   * - Level 4-5: 8 per level-up
   * - Level 6-7: 11 per level-up
   */ skillPointsPerLevel: {
        base: 2,
        levelDivisor: 2,
        increment: 3
    },
    /**
   * Per-skill synergy unlocks (progressive disclosure of the synergy layer):
   * hidden entirely below minLevel, then each skill's synergies are bought
   * with skill points. A synergy variant can fire only when it touches an
   * unlocked skill on either side (the event's skill, or the skill of the
   * player's partner device).
   */ synergyUnlocks: {
        minLevel: 4,
        cost: 2
    },
    /**
   * Raid XP tier weighting (Command era). The level curve's old assumption
   * ("level 8 in 1-2 months") predates promotion cycling; with 3-5 day
   * tours, character level was the binding progression constraint - tours
   * stalled at level 4-5 on tier-1 XP. Pushing tiers is now the leveling
   * ladder: T1 pacing (and first-promotion timing) unchanged, T2/T3 raids
   * pay multiples so deep tours can level past the plateau.
   */ raidXpTierMultipliers: {
        1: 1,
        2: 3,
        3: 5
    },
    /**
   * Skill event damage scaling per raid tier
   * Damage formula: minDamage + random(0, maxDamage - minDamage)
   * where minDamage = baseDamage * tier, maxDamage = minDamage + (baseDamage * tier)
   *
   * Example with defaults (baseDamage: 5):
   * - Tier 1: 5-15 damage (5 + 0-10)
   * - Tier 2: 10-30 damage (10 + 0-20)
   * - Tier 3: 15-45 damage (15 + 0-30)
   */ skillEventDamage: {
        baseDamage: 5,
        perTier: {
            1: {
                min: 20,
                max: 30
            },
            2: {
                min: 25,
                max: 35
            },
            3: {
                min: 30,
                max: 40
            }
        }
    },
    /**
   * Bonus event cascade chance multipliers, per raid tier AND per cascade step.
   * Applied as: rarityDropChance * bonusEventCascadeMultipliers[tier][nextRarity]
   * when the end-of-room bonus event rolls to cascade common→rare→epic→legendary→unique.
   *
   * Per-rarity so the legendary step can be boosted (its base chance is near zero,
   * this is the main legendary blueprint source) WITHOUT saturating the rare/epic
   * steps - a flat multiplier clamped those to 100% per clean room.
   */ bonusEventCascadeMultipliers: {
        // rare < 1.0 keeps leaf-rare cascade volume near recipe demand.
        // Legendary (= artifact blueprints, the whole legendary pool) is a TIER 3
        // EXCLUSIVE: reaching T3 is the plannable path to artifacts (and the
        // Syndicate boundary), not a lottery ticket at every tier. 50 saturates
        // the legendary step (0.02 base x 50 = chance 1.0 once the cascade
        // reaches epic), so a clean T3 room drops a blueprint at its epic-chain
        // rate (~3% hazard, ~7% gate).
        1: {
            rare: 0.5,
            epic: 1.0,
            legendary: 0,
            unique: 1.0
        },
        2: {
            rare: 0.5,
            epic: 1.0,
            legendary: 0,
            unique: 1.0
        },
        3: {
            rare: 0.5,
            epic: 1.0,
            legendary: 50,
            unique: 1.0
        }
    },
    /**
   * Share of a promoted character's MATERIALS that passes to their successor.
   * The remainder is consigned to the Syndicate dock as Operations cargo
   * (command-core.js disburseInventory).
   *
   * Fixed, and was a three-rank Command upgrade ("Guild Vault", 80/240/720
   * marks) until the S7c pass removed it. The rank bought nothing: gear crafted
   * per tour is FLAT across a 2.5x range of this value - 5.57 at 10/20/30,
   * 6.07 at 15/30/50, 5.61 at 25/50/75, n=4 each - so the upgrade taxed 1,040
   * marks for an effect that does not exist. An upgrade that cannot be measured
   * is worse than no upgrade, because buying it is a trap.
   *
   * Why the share does not matter: it is not a one-way transfer. Whatever the
   * successor inherits and does not CONSUME is disbursed again at their own
   * promotion, and again after that, so the dial changes timing rather than
   * totals. Measured: at 75% carryover the L3 dock was unchanged (17,977 vs
   * 18,504 units) and zero convoys were ever refused for cargo.
   *
   * 0.3 because it equals the old rank-3 value - nobody who had fully invested
   * is worse off - and because a flat "a third of your kit passes on" reads
   * cleanly in the fiction. Any value in 0.1-0.75 measures the same.
   */ vaultCarryover: 0.3,
    /**
   * Share of the NON-carried remainder that reaches the Syndicate dock as
   * Operations cargo. The rest is consumed — spent living, in the fiction.
   *
   * The accounting used to be closed: 30% to the successor, 70% to L3, nothing
   * lost. That was tidy and produced an unusable economy. A dock held ~18,000
   * units while a whole era's convoys consumed ~1,500 (8%), so the "common
   * material piles plateau (<300/signature)" target measured ~2,500 and rising,
   * and cargo could never be a real constraint on Operations — even 10x the
   * cargo per convoy would not have drained it.
   *
   * No dial inside Operations could fix that, because the problem is supply,
   * not demand. This is the supply valve.
   */ consignmentRate: 0.15,
    /**
   * Command layer (M2) - Command Marks formula coefficients + unlock threshold.
   * Consumed by command-core.js calculateCommandMarks:
   *   marks = perTechGear       * distinct tech gear owned (inventory + equipped)
   *         + perArtifactUnlock * lifetime.artifactsUnlocked
   *         + perArtifactCraft  * lifetime.artifactsCrafted
   *         + floor(lifetime.t3Wins / t3WinsDivisor)
   *         + perLevel          * level
   * The sim promotion policy tunes these so an un-upgraded character #1's
   * marks/hour peaks ~day 3-5 (see docs/Roadmap-070426.md playtime budget).
   */ commandMarks: {
        // Marks reward CRAFTING, which is the player's active progress: skill gear
        // early (the only thing craftable at first), artifacts later (once T3 is
        // reachable). Character level is an ENABLER, not a payout - it unlocks
        // higher tiers, which yield T3 wins + blueprints -> artifacts; its direct
        // marks contribution is deliberately small so it can't become the main
        // driver (it previously grew to ~50% of marks as accounts matured).
        // Held at 4. Raising it was MEASURED in the S7c pass and rejected: at 8,
        // three runs put the first founding on day 31/34/31 - identical to the
        // 31-36 baseline - while Writs overshot to 34-38 and the L1 era collapsed
        // from ~40h to 18-21h. Two reasons, both structural:
        //
        //  - It cannot shorten a tour. Tour length is when cumulative marks/hour
        //    PEAKS, and a bigger gear channel moves that peak later by about as
        //    much as it pays, so the schedule does not move.
        //  - Marks are also the CURRENCY for Command upgrades, so doubling this
        //    halves the real price of the whole catalogue. The first promotion
        //    fires at the 60-mark floor, which needs ~15 gear at 4 and only 8 at
        //    8 - halving the onboarding era as a side effect.
        //
        // The L2 era overruns because tours 2-15 run ~26h against the ~18h the
        // 300h budget implies. That is a CYCLE COMPRESSION problem (officer-academy
        // / guild-vault head starts not paying off enough), not a throughput one,
        // and this coefficient is the wrong lever for it.
        perTechGear: 4,
        // Artifacts split into two channels (see command-core unlockArtifactCore):
        //   perArtifactUnlock - ONE-TIME per design per ACCOUNT, banked when the
        //     design's blueprint is consumed to unlock it. The milestone: 27
        //     designs => a finite ~675-mark collection goal.
        //   perArtifactCraft - each distinct craft per character (parallel to gear,
        //     ~2x a gear piece). Keeps a modest sustained artifact-marks trickle
        //     without the runaway 25-per-craft farm.
        perArtifactUnlock: 25,
        perArtifactCraft: 8,
        // T3 wins are the "operating at high tier" marks channel that level
        // enables (2 wins per mark); artifacts are the high-tier crafting payoff
        t3WinsDivisor: 2,
        perLevel: 1,
        // Command tab reveals when estimated marks first reach this. Tied to
        // perTechGear: it fires on the 7th piece of gear. If perTechGear ever
        // moves, scale this by the same ratio - it is a progression milestone
        // measured in what the player has BUILT, and leaving it fixed would slide
        // a designed reveal earlier as a side effect of an unrelated change.
        unlockThreshold: 25
    },
    /**
   * Promotion credit levy (applied in command-core.js promoteCharacterCore).
   * Credits are account-shared, so promotion takes a percentage cut instead
   * of a flat reset: kept = max(floor, credits * keepFraction). The levy is
   * the economy's terminal credit sink — it must scale with wealth to keep
   * absorbing late-game surplus; the floor doubles as a safety net so a
   * broke account still restarts with working capital.
   */ promotionCreditLevy: {
        keepFraction: 0.25,
        floor: 1000
    },
    /**
   * Collapse Key recovery — the ONLY tunable in the story track.
   *
   * Chance that a successful raid recovers the next Collapse Key its faction is
   * still missing. Not an economic number: keys have no value, no sink and no
   * sale, so this tunes STORY PACING alone and no balance target reads it.
   *
   * The tier table (keys 1-2 at T1, 3-4 at T2, 5-7 at T3) is what actually
   * paces the arc — a T1 character can only ever hold two keys, however long
   * they raid. This number decides how quickly they reach that ceiling: at 0.25
   * the first key lands in the opening session and the T1 pair inside ~8 wins,
   * which is the point of shipping keys 1-7 at all. The game previously told
   * the player nothing until ~900 hours in.
   */ collapseKeyDropChance: 0.25,
    /**
   * Raid credit reward scaling (applied in raidUtil.js applyCreditsScaling)
   * effective = earned * globalMultiplier * tierMultipliers[tier]
   */ creditsScaling: {
        globalMultiplier: 0.3,
        tierMultipliers: {
            1: 1.0,
            2: 1.0,
            3: 1.0
        }
    },
    /**
   * Energy repurchase escalation (applied in raidUtil.js
   * getConsumablePurchasePrice): energy-restoring consumables cost
   * base * escalationFactor^(purchases today), resetting daily.
   * The primary Command-era credit sink - converts surplus credits into
   * raid throughput at a net credit loss (late game: 5-6 packs/day
   * ~ the 4-10k/day income it must soak). 1.0 disables escalation.
   */ energyPurchaseScaling: {
        escalationFactor: 2.0
    },
    /**
   * Per-tour crafting discount (Command layer). Each completed tour makes
   * crafting cheaper for every later tour — the institutional-knowledge payoff.
   *
   * DERIVED, never compounded:
   *   globalMultiplier = craftingCostScaling.globalMultiplier * factor^(tour - 1)
   *
   * It used to be applied by multiplying raidUtil's module state at each
   * promotion, which main.js then re-seeded from config on every boot — so the
   * discount silently vanished on reload. Deriving it from `command.tour` makes
   * it reload-safe, and makes L3's founding reset free: tour returns to 1, so
   * the multiplier returns to base with nothing extra to persist.
   *
   * 1.0 disables the discount.
   */ craftingDiscountPerTour: 0.9,
    /**
   * Crafting credit cost scaling (applied in raidUtil.js applyCraftingCostScaling)
   * effective = cost * globalMultiplier * rarityMultipliers[rarity]
   */ craftingCostScaling: {
        globalMultiplier: 5,
        rarityMultipliers: {
            common: 1.0,
            uncommon: 1.0,
            rare: 1.0,
            epic: 1.0,
            legendary: 1.0,
            unique: 1.0,
            artifact: 1.0
        }
    }
};
function $979b99378be707cd$export$6941830bed591a7b(rarity) {
    var multiplier = $979b99378be707cd$export$9f9786ac427715c7.recipeInputs[rarity];
    if (multiplier === undefined) {
        console.warn("Unknown input rarity: ".concat(rarity, ", returning 1.0"));
        return 1.0;
    }
    return multiplier;
}
function $979b99378be707cd$export$2a160ac1bc0ae37b(quantity) {
    if (quantity < 10) // Keep 1-9 as-is
    return Math.max(1, Math.ceil(quantity));
    else if (quantity < 100) // Round 10-99 to nearest 5
    return Math.ceil(quantity / 5) * 5;
    else // Round 100+ to nearest 10
    return Math.ceil(quantity / 10) * 10;
}
function $979b99378be707cd$export$a43c2a5178ae7642(inputs) {
    var getRarityFn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    if (!inputs || !Array.isArray(inputs)) return inputs;
    return inputs.map(function(input) {
        var inputQty = input.qty;
        // Get input rarity (from input object or from provided function)
        var inputRarity = input.rarity;
        if (!inputRarity && getRarityFn) inputRarity = getRarityFn(input.id);
        // Apply per-input scaling based on rarity
        if (inputRarity) {
            var inputMultiplier = $979b99378be707cd$export$6941830bed591a7b(inputRarity);
            inputQty *= inputMultiplier;
        }
        return (0, $715bf31211e65705$export$71511d61b312f219)((0, $fa9769297b8a68c8$export$71511d61b312f219)({}, input), {
            qty: $979b99378be707cd$export$2a160ac1bc0ae37b(inputQty)
        });
    });
}
var $979b99378be707cd$export$94e7ad7999c1ae32 = {
    1: {
        name: "Tier 1 - Exploration",
        description: "Entry-level raids with manageable challenges",
        gridSize: 7,
        gridRows: 7,
        gridCols: 7,
        contractorMinLevel: 1,
        contractorMaxLevel: 8,
        hazardSkillLevel: 3,
        gateSkillLevel: 5,
        creditRewards: {
            baseRoomCredit: 10,
            successEventCredit: 15,
            completionBonus: 30
        }
    },
    2: {
        name: "Tier 2 - Veteran",
        description: "Moderate difficulty with increased rewards",
        gridSize: 9,
        gridRows: 7,
        gridCols: 13,
        contractorMinLevel: 6,
        contractorMaxLevel: 14,
        hazardSkillLevel: 6,
        gateSkillLevel: 8,
        creditRewards: {
            baseRoomCredit: 15,
            successEventCredit: 23,
            completionBonus: 45
        }
    },
    3: {
        name: "Tier 3 - Elite",
        description: "High-risk, high-reward advanced operations",
        gridSize: 11,
        gridRows: 7,
        gridCols: 17,
        contractorMinLevel: 10,
        contractorMaxLevel: 999,
        hazardSkillLevel: 8,
        gateSkillLevel: 10,
        creditRewards: {
            baseRoomCredit: 25,
            successEventCredit: 39,
            completionBonus: 75
        }
    }
};
var $979b99378be707cd$export$8377a367ab2ae550 = {
    entry: {
        description: "Starting area with easier encounters",
        recipes: {
            infrastructure: 35,
            transit: 25,
            security: 20,
            storage: 20
        },
        built: 0.72
    },
    peripheral: {
        description: "Outer areas with mixed encounters",
        recipes: {
            environmental: 40,
            transit: 20,
            storage: 20,
            habitation: 20
        },
        built: 0.58
    },
    security: {
        description: "Defensive checkpoints",
        recipes: {
            security: 45,
            infrastructure: 25,
            storage: 20,
            power: 10
        },
        built: 0.90
    },
    industrial: {
        description: "Resource/infrastructure areas",
        recipes: {
            power: 30,
            storage: 30,
            infrastructure: 25,
            transit: 15
        },
        built: 0.88
    },
    core: {
        description: "High-value protected areas",
        recipes: {
            records: 35,
            commerce: 25,
            security: 20,
            infrastructure: 20
        },
        built: 1.00
    },
    residential: {
        description: "Habitats, apartments, communal living spaces",
        recipes: {
            habitation: 50,
            environmental: 20,
            records: 15,
            commerce: 15
        },
        built: 0.85
    },
    commercial: {
        description: "Shops, offices, market halls, logistics fronts",
        recipes: {
            commerce: 50,
            storage: 20,
            records: 15,
            habitation: 15
        },
        built: 0.95
    }
};
var $979b99378be707cd$export$11209b5126489e67 = {
    campsite: {
        type: "campsite",
        name: "Campsite",
        primary: "",
        support: [],
        baseDuration: 120,
        icon: "\uD83C\uDFD5\uFE0F",
        description: "A safe place to rest and recover",
        healingAmount: 30
    },
    water: {
        type: "water",
        name: "Water",
        primary: "",
        support: [],
        baseDuration: 120,
        icon: "\uD83C\uDF0A",
        description: "A water source for fishing"
    },
    road: {
        type: "road",
        name: "Road",
        primary: "",
        support: [],
        baseDuration: 10,
        icon: "\uD83D\uDEE3\uFE0F",
        description: "A roadway for fast travel"
    }
};
var $979b99378be707cd$export$4fbdcec70fce9d73 = {
    // ======================================================
    "shard-cities": {
        name: "Shard Cities",
        theme: "Collapsed megacities and fractured districts",
        icon: "\uD83C\uDFD9\uFE0F",
        shortDescription: "Towering urban ruins split by broken transit lines and silent civic grids.",
        longDescription: "These were once continuous skylines: stacked transit, dense housing, and civic utilities woven into mile-high towers. Centuries of neglect cracked the pavement and snapped the skyways. You can still read the street plan, even if whole blocks have slumped into their own debris.\n\nPower occasionally surges through old feeders, enough to light a dead intersection for a breath. Most systems do nothing at all\u2014just rust, dust, and old signage pointing nowhere.",
        artDirection: "Two scales of building, and the contrast between them IS the region. The ordinary stock is warm \u2014 brick and brown roofing, low, dense, packed kerb to kerb. Over it stand cool concrete-and-glass masses: tower cores with their service shafts open to the sky, skybridge decks that start nowhere and stop in mid-air, sign gantries still spanning the carriageway. Ground is dark slate tarmac, cracked on a slab pitch, so both tiers read light against it. Street trees have come up through the pavement everywhere there was a cutout.",
        gates: [
            {
                icon: "\uD83D\uDEA7",
                name: "Checkpoint Sector",
                primary: "lock-breach",
                support: [
                    "signal-relay",
                    "stealth-transit"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "critical",
                shortDescription: "Barricaded intersection controlling movement between ruined blocks.",
                longDescription: "Concrete barriers, rusted railings, and makeshift roadblocks choke an old arterial. The city\u2019s last attempts at order still shape the flow of rubble and weeds. Nothing powers here\u2014only wind and dust."
            },
            {
                icon: "\u2699\uFE0F",
                name: "Civic Relay Block",
                primary: "signal-relay",
                support: [
                    "quantum-scan",
                    "lock-breach"
                ],
                baseDuration: 120,
                category: "infrastructure",
                difficulty: "chokepoint",
                placement_priority: "high",
                shortDescription: "Collapsed service block with dead comms towers and trunk conduits.",
                longDescription: "Stubbed antenna masts lean over a plaza of broken panels and cable vaults. Dust-muted signage points to services that no longer exist. A faint click from a relay box sometimes answers fresh power before falling silent again."
            },
            {
                icon: "\uD83C\uDFE2",
                name: "Apartment Access Lot",
                primary: "stealth-transit",
                support: [
                    "quantum-scan",
                    "lock-breach"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "high",
                districtAffinity: "residential",
                shortDescription: "Collapsed housing block entrances clustered around a cracked forecourt.",
                longDescription: "Entry canopies hang at angles over door stacks long since jammed. Mailboxes gape, names scoured to metal. The forecourt is a map of fractures and weeds, with scaffolds rusted into stillness."
            },
            {
                icon: "\uD83D\uDECD\uFE0F",
                name: "Arcade Shutter Sector",
                primary: "system-override",
                support: [
                    "drone-command",
                    "containment"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "high",
                districtAffinity: "commercial",
                shortDescription: "Market frontage sealed by fallen shutters and buckled grates.",
                longDescription: "A run of storefronts slouches under dead signage and twisted awnings. Steel shutters are half-dropped or jammed, creating a maze of narrow access. Any movement here is the wind through canvas and chain."
            }
        ],
        hazards: [
            {
                icon: "\uD83D\uDEE2\uFE0F",
                name: "Residential Power Yard",
                primary: "containment",
                support: [
                    "signal-relay",
                    "transit-anchor"
                ],
                baseDuration: 60,
                category: "power",
                difficulty: "standard",
                placement_priority: "high",
                shortDescription: "Small substation between towers with fallen lines and rusted switchgear.",
                longDescription: "Transformer housings slouch on cracked pads; the fence is more gap than mesh. A wrong step crunches glass and ceramic. If anything lights, it\u2019s for a breath, then the quiet deepens."
            },
            {
                icon: "\uD83C\uDF09",
                name: "Transit Collapse Zone",
                primary: "transit-anchor",
                support: [
                    "reclamation",
                    "system-override"
                ],
                baseDuration: 60,
                category: "infrastructure",
                difficulty: "standard",
                placement_priority: "normal",
                shortDescription: "Broken overpass and skybridge stubs sprawled over a debris-choked road.",
                longDescription: "Guardrails spear the pavement; cables drape from shattered spans. The echo under concrete ribs tells how big it was. Weeds stitch rebar and dust into something like ground again."
            },
            {
                icon: "\uD83D\uDCE6",
                name: "Marketfront Depot",
                primary: "drone-command",
                support: [
                    "transit-anchor",
                    "echo-trace"
                ],
                baseDuration: 60,
                category: "storage",
                difficulty: "high_value",
                placement_priority: "high",
                shortDescription: "Cluster of loading bays and shuttered storerooms behind ruined shops.",
                longDescription: "Dock plates sit crooked; pallets rot into dark lines on the ground. The loading lights are dead\u2014only daylight finds its way in through gaps and broken louvers."
            },
            {
                icon: "\uD83C\uDFE2",
                name: "Administrative Records Block",
                primary: "quantum-scan",
                support: [
                    "system-override",
                    "lock-breach"
                ],
                baseDuration: 60,
                category: "storage",
                difficulty: "high_value",
                placement_priority: "critical",
                shortDescription: "Abandoned office district with shattered facades and paper-littered streets.",
                longDescription: "Stacks of files turned to mulch line the curbs where floodwater once ran. A rusted maintenance crane leans against a curtain wall. Nothing watches here\u2014only glass dust and wind."
            },
            {
                icon: "\uD83D\uDE89",
                name: "Transit Exchange Block",
                primary: "echo-trace",
                support: [
                    "stealth-transit",
                    "containment"
                ],
                baseDuration: 60,
                category: "infrastructure",
                difficulty: "standard",
                placement_priority: "normal",
                shortDescription: "A surface-level transit interchange and service plaza linking several collapsed lines.",
                longDescription: "Once a hub for elevated trams and vertical shuttles, the block still shows the scar of its platforms. Canopies hang over cracked concrete lanes, and access ramps descend into dust-filled tunnels below."
            },
            {
                icon: "\uD83D\uDE9B",
                name: "Logistics Yard Ruins",
                // overturned cargo trucks and container stacks, not a service yard
                recipe: "storage",
                primary: "reclamation",
                support: [
                    "drone-command",
                    "echo-trace"
                ],
                baseDuration: 60,
                category: "infrastructure",
                difficulty: "standard",
                placement_priority: "normal",
                shortDescription: "Collapsed distribution yard filled with overturned cargo trucks and container stacks.",
                longDescription: "What was once a multi-lane loading grid now lies in layers \u2014 trucks fossilized in place, containers torn open by time. Tower cranes stand idle at the corners like monuments to motionless trade."
            },
            {
                icon: "\u26A1",
                name: "Substation Complex",
                primary: "system-override",
                support: [
                    "reclamation",
                    "quantum-scan"
                ],
                baseDuration: 60,
                category: "power",
                difficulty: "high_value",
                placement_priority: "high",
                shortDescription: "A cluster of transformers and conduit fields forming a decommissioned power block.",
                longDescription: "Heavy transformer shells sit on cracked pads, their housings marked with long-gone warning paint. Busbars bridge between fenced sections, while cable vaults yawn open into the dark below."
            },
            {
                icon: "\uD83D\uDEC2",
                name: "Civic Control District",
                // a ring of checkpoints; "civic" pulls it to infrastructure otherwise
                recipe: "security",
                primary: "quantum-scan",
                support: [
                    "transit-anchor",
                    "echo-trace"
                ],
                baseDuration: 60,
                category: "security",
                difficulty: "standard",
                placement_priority: "high",
                shortDescription: "A cluster of interconnected checkpoints surrounding a former civic administration block.",
                longDescription: "Security kiosks ring the perimeter of a low central building, their scanner frames bent but still standing. The entire block was once a controlled corridor \u2014 a mix of barriers, scanners, and causeways now frozen in collapse."
            }
        ]
    },
    // ======================================================
    "verdant-reclamation": {
        name: "Green Reclamation",
        theme: "Overgrown research campuses and greenhouse grids",
        icon: "\uD83C\uDF3F",
        shortDescription: "Bio-reclaimed districts where labs and irrigation frames disappear beneath growth.",
        longDescription: "This landscape was engineered to coax life back into sterile soil. Greenhouses formed shining corridors; irrigation lattices pulsed under glass. After the departure, containment failed and nature took the reins.\n\nNow, fibrous canopies bind whole blocks together. Steel trusses wear bark; road paint lies under moss. Machinery answers only sometimes, a pump stuttering once before the vines hold it still again.",
        artDirection: "Growth is the loudest thing on the tile and the buildings are what it grew over. Heavy canopy in deep greens, moss and wildflowers through the ground, tarmac worn back to soil. The architecture that survives is glasshouse: long shallow glazed spans ridged down their spine with panes missing and the planting showing through, irrigation lattices over what used to be beds, seed silos. Ordinary buildings are muted steel grey and mostly hidden \u2014 that is the point, they lost.",
        gates: [
            {
                icon: "\uD83E\uDDEA",
                name: "Bio-Lab Complex Gate",
                primary: "bio-shield",
                support: [
                    "containment",
                    "growth-control"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "critical",
                shortDescription: "Collapsed research compound entrance tangled in vines and glass.",
                longDescription: "A trellis of bent greenhouse ribs leads into a court of moss and broken tiles. Safety placards lie sun-bleached among seed trays and cracked tanks. The air is warm and wet, heavy with plant breath."
            },
            {
                icon: "\uD83D\uDEBF",
                name: "Irrigation Control Sector",
                primary: "reclamation",
                support: [
                    "growth-control",
                    "wild-influence"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "high",
                shortDescription: "Valve fields, cisterns, and control kiosks overtaken by roots.",
                longDescription: "Pipes run like exposed roots along the ground, bolted kiosks eaten by rust and kudzu. A cistern lid thumps underfoot\u2014water still trapped below. If anything moves, it\u2019s the wind dragging leaves across metal."
            },
            {
                icon: "\uD83C\uDFDA\uFE0F",
                name: "Habitation Annex Gate",
                primary: "wild-influence",
                support: [
                    "bio-shield",
                    "reclamation"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "high",
                districtAffinity: "residential",
                shortDescription: "Apartment annex entrances swallowed by creepers and fallen trellis.",
                longDescription: "Balconies have become planters; stairwells bloom with ferns. Doorways stand open or warped shut, their seals crumbled to powder. A single gutter still drips into a barrel of green water."
            },
            {
                icon: "\uD83E\uDDEA",
                name: "Market Decontamination Sector",
                primary: "containment",
                support: [
                    "safeguard",
                    "reclamation"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "high",
                districtAffinity: "commercial",
                shortDescription: "Outdoor wash stations and shuttered stalls clustered around a drained basin.",
                longDescription: "Decon arches frame a plaza of cracked tile and dried residue. The stalls around it are skeletal, their tarps long rotted away. Nothing cycles here unless you bring the power yourself."
            }
        ],
        hazards: [
            {
                icon: "\uD83C\uDF31",
                name: "Seed Distribution Yard",
                primary: "growth-control",
                support: [
                    "bio-shield",
                    "reclamation"
                ],
                baseDuration: 60,
                category: "storage",
                difficulty: "high_value",
                placement_priority: "high",
                shortDescription: "Silos, bins, and pallet stacks buried in moss and husks.",
                longDescription: "A drift of cracked pods crunches underfoot. Stenciled measurements fade from the silo sides. Somewhere a vent exhales warm, earthy air that smells like the start of rain."
            },
            {
                icon: "\uD83C\uDF44",
                name: "Fungal Spread Block",
                primary: "growth-control",
                support: [
                    "bio-shield",
                    "reclamation"
                ],
                baseDuration: 60,
                category: "environmental",
                difficulty: "standard",
                placement_priority: "normal",
                shortDescription: "A shaded block carpeted with fungus and spore fans.",
                longDescription: "Stems as thick as cable push through fissures in the concrete. Spores hang in the air like dust motes in a cathedral. Your breath fogs just enough to make the light feel heavy."
            },
            {
                icon: "\uD83D\uDCA7",
                name: "Irrigation Breach Sector",
                primary: "bio-shield",
                support: [
                    "growth-control",
                    "safeguard"
                ],
                baseDuration: 60,
                category: "infrastructure",
                difficulty: "standard",
                placement_priority: "normal",
                shortDescription: "Ruptured mains flooding a low lot, roots drinking the overflow.",
                longDescription: "A trench of clear water has cut through soil and tile, pooling around toppled control posts. Algae paints the edges; insects tap the surface. The flow wanes and returns without reason."
            },
            {
                icon: "\uD83D\uDCDA",
                name: "Research Supply Yard",
                primary: "reclamation",
                support: [
                    "wild-influence",
                    "safeguard"
                ],
                baseDuration: 60,
                category: "storage",
                difficulty: "high_value",
                placement_priority: "critical",
                shortDescription: "Crated lab gear and broken cages stacked beside a ruined annex.",
                longDescription: "Numbers stenciled on crates tell of a mission left unfinished. Metal shelving slumps like wet paper. A single rain gutter ticks as it cools in the shade."
            },
            {
                icon: "\uD83C\uDFD7\uFE0F",
                name: "Habitation Block",
                primary: "wild-influence",
                support: [
                    "containment",
                    "growth-control"
                ],
                baseDuration: 60,
                category: "environmental",
                difficulty: "standard",
                placement_priority: "normal",
                districtAffinity: "residential",
                shortDescription: "A cluster of low-rise apartments overtaken by gardens and nests.",
                longDescription: "Bedsprings and trellis wire bind stairwells into new shapes. Window boxes have become small forests. The only movement is leaves, and the small quick things that live in them."
            },
            {
                icon: "\uD83E\uDED7",
                name: "Nutrient Line Rupture",
                primary: "bio-shield",
                support: [
                    "wild-influence",
                    "safeguard"
                ],
                baseDuration: 60,
                category: "infrastructure",
                difficulty: "standard",
                placement_priority: "high",
                districtAffinity: "residential",
                shortDescription: "Leaking feed lines turning a block into a slick, humming wetland.",
                longDescription: "Plastic tubing loops across the ground like shed skin, seeping a sweet, metallic film. New shoots force through asphalt in a straight line where the pipe runs below."
            },
            {
                icon: "\uD83C\uDFEA",
                name: "Agri-Market Depot",
                primary: "growth-control",
                support: [
                    "containment",
                    "bio-shield"
                ],
                baseDuration: 60,
                category: "storage",
                difficulty: "high_value",
                placement_priority: "high",
                districtAffinity: "commercial",
                shortDescription: "Open-air market storage with collapsed canopies and crate rows.",
                longDescription: "Sun-faded tarps hang like old flags. The smell of dust and seed oil lingers. You can still see where chalk mapped out stall fees on the concrete."
            },
            {
                icon: "\uD83E\uDDEF",
                name: "Greenhouse Containment Sector",
                primary: "safeguard",
                support: [
                    "containment",
                    "wild-influence"
                ],
                baseDuration: 60,
                category: "environmental",
                difficulty: "standard",
                placement_priority: "normal",
                districtAffinity: "commercial",
                shortDescription: "Firebreak lanes and isolation frames choking in vines.",
                longDescription: "White-painted fire lanes vanish under creepers. The shutters meant to fall in emergencies are rusted half-down. A distant pane taps in the breeze like a metronome."
            }
        ]
    },
    // ======================================================
    "sunken-bastions": {
        name: "Flooded Bastions",
        theme: "Semi-submerged fortifications and silted logistics",
        icon: "\uD83C\uDF0A",
        shortDescription: "Defense districts with the sea in them: the coast took the low blocks and the silt took the rest.",
        longDescription: "Coastal defenses once ringed this region with docks, bunkers, and pressure locks. Storm surge and slow subsidence rolled in over centuries, flooding the low blocks and salting everything else.\n\nSome pressure doors still cycle if you give them power, drawing a final gulp of air through corroded ducts. Mostly, there is water, silt, and the sound of old metal moving in the tide.",
        artDirection: "One edge of the map is open ocean and everything reads off how far it is from it. At the shore, water over the outer half of the tile, a buttressed sea wall along the waterline with its bollards behind, and what is left of the buildings is mostly wreckage in the shallows. A row in, tidal flats and standing water pooling in the streets first. Beyond that, dry. Ground is cold silt, not sand \u2014 blue-grey, damp-looking, tide-marked. Concrete is wet and weeping rust.",
        gates: [
            {
                icon: "\uD83D\uDED1",
                name: "Pressure Gate Sector",
                primary: "lock-breach",
                support: [
                    "signal-mask",
                    "wild-influence"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "high",
                shortDescription: "Cluster of rusted airlock doors and corroded valves around a flooded court.",
                longDescription: "Door rings sit proud with barnacle rust; inspection windows are opaque with salt. The control pedestals are still in place, their labels sanded flat by wind and spray."
            },
            {
                icon: "\u2693",
                name: "Drydock Access Block",
                primary: "lock-breach",
                support: [
                    "quantum-scan",
                    "system-override"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "critical",
                shortDescription: "Collapsed dock gates and winch frames guarding entry to an old basin.",
                longDescription: "The dock walls lean inward, heavy with waterlogged stone. Winch cables coil like sleeping eels beside shattered bollards. Every surface is stained a dozen kinds of orange."
            },
            {
                icon: "\uD83D\uDEAA",
                name: "Residential Seal Lot",
                primary: "containment",
                support: [
                    "safeguard",
                    "system-override"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "high",
                districtAffinity: "residential",
                shortDescription: "Pressure-rated housing entries scattered along a raised walkway.",
                longDescription: "Doors that once sealed against storms now gape, warped on their hinges. A painted muster diagram flakes off the wall in curls as thin as fish scales."
            },
            {
                icon: "\uD83E\uDDF3",
                name: "Commercial Airlock Sector",
                primary: "signal-mask",
                support: [
                    "bio-shield",
                    "containment"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "high",
                districtAffinity: "commercial",
                shortDescription: "Cargo airlocks and submerged loading bays along a corroded quay.",
                longDescription: "Crate hoists stand frozen above black water. The quay edge is a jag of broken concrete and rebar, polished smooth where the tide reaches."
            }
        ],
        hazards: [
            {
                icon: "\uD83C\uDF0A",
                name: "Flooded Records Sector",
                primary: "reclamation",
                support: [
                    "wild-influence",
                    "transit-anchor"
                ],
                baseDuration: 60,
                category: "storage",
                difficulty: "high_value",
                placement_priority: "critical",
                shortDescription: "Archives drowned to the window line, shelves like ribs under the surface.",
                longDescription: "Folders have turned to silt drifts. A rolling ladder floats, bumping the stacks with a hollow rhythm. Light puddles on the water and slides across the ceiling."
            },
            {
                icon: "\uD83D\uDCA8",
                name: "Ventilation Intake Lot",
                primary: "echo-trace",
                support: [
                    "bio-shield",
                    "reclamation"
                ],
                baseDuration: 60,
                category: "infrastructure",
                difficulty: "standard",
                placement_priority: "normal",
                shortDescription: "Banks of rusted intake fans towering over a silted forecourt.",
                longDescription: "Fan blades are choked with ropeweed and netting. A metal tag rattles faintly when the wind shifts. The air smells like creosote and tide."
            },
            {
                icon: "\uD83D\uDCE6",
                name: "Freight Access Zone",
                primary: "transit-anchor",
                support: [
                    "safeguard",
                    "signal-mask"
                ],
                baseDuration: 60,
                category: "security",
                difficulty: "standard",
                placement_priority: "high",
                shortDescription: "Collapsed ramps and container rows leading into a drowned terminal.",
                longDescription: "Container paint has bled into pastel ghosts. The ramp rails end abruptly in water that hides a second city of debris below."
            },
            {
                icon: "\uD83E\uDEB8",
                name: "Marine Observation Block",
                primary: "wild-influence",
                support: [
                    "echo-trace",
                    "lock-breach"
                ],
                baseDuration: 60,
                category: "environmental",
                difficulty: "standard",
                placement_priority: "normal",
                shortDescription: "Sea-worn platforms and pylons with algae film and broken rails.",
                longDescription: "Scope housings point at horizons no one watches. The handrails flake in layers that stain your gloves. Gulls nest in the elbows of old floodlights that will never shine again."
            },
            {
                icon: "\uD83C\uDFDA\uFE0F",
                name: "Flooded Living Sector",
                primary: "bio-shield",
                support: [
                    "echo-trace",
                    "lock-breach"
                ],
                baseDuration: 60,
                category: "environmental",
                difficulty: "standard",
                placement_priority: "normal",
                districtAffinity: "residential",
                shortDescription: "Lower housing blocks drowned to the window line, interiors slumped inward.",
                longDescription: "Mildew blooms on every surface; curtains drift like slow jelly. The line where the tide reaches is written as a salt band around the rooms."
            },
            {
                icon: "\uD83E\uDE9C",
                name: "Access Tower Sector",
                primary: "safeguard",
                support: [
                    "echo-trace",
                    "lock-breach"
                ],
                baseDuration: 60,
                category: "infrastructure",
                difficulty: "standard",
                placement_priority: "high",
                districtAffinity: "residential",
                shortDescription: "Stair towers and emergency ladders rising above the flood.",
                longDescription: "Cages of stairs keep their geometry against the soft line of the water. Every landing clicks and settles when the wind turns."
            },
            {
                icon: "\uD83D\uDCE6",
                name: "Cargo Intake Block",
                primary: "containment",
                support: [
                    "quantum-scan",
                    "reclamation"
                ],
                baseDuration: 60,
                category: "infrastructure",
                difficulty: "standard",
                placement_priority: "normal",
                districtAffinity: "commercial",
                shortDescription: "Shallow-water cargo ramps and corroded conveyors into a warehouse face.",
                longDescription: "Conveyor housings gape like fish skulls. A strip of weed waves where a belt used to run. The warehouse doors are heavy with swollen wood."
            },
            {
                icon: "\uD83D\uDCB0",
                name: "Finance Quarter",
                primary: "quantum-scan",
                support: [
                    "containment",
                    "transit-anchor"
                ],
                baseDuration: 60,
                category: "storage",
                difficulty: "high_value",
                placement_priority: "high",
                districtAffinity: "commercial",
                shortDescription: "Collapsed teller halls and armored delivery bays, empty as vaults.",
                longDescription: "Coin-counting machines sit in rows like old teeth. Delivery lanes are silted to their thresholds. Everything smells faintly of metal and mildew."
            }
        ]
    },
    // ======================================================
    "cradle-expanse": {
        name: "Industrial Expanse",
        theme: "Manufacturing grids and rust plains",
        icon: "\uD83C\uDF05",
        shortDescription: "Endless factory lots, idle conveyors, and yard-wide machinery asleep in rust.",
        longDescription: "Production once moved through these blocks in steady lines\u2014ore in one side, finished goods out the other. Now the conveyors are seized and the cranes lean on their cables, frozen mid-motion for generations.\n\nWhen power returns, a servo might twitch or a stack light might glow and die. The wind does most of the work here: sandblasting paint, driving grit into bearings, and covering tracks almost as fast as you make them.",
        artDirection: "The one region whose plant stands LIGHTER than its ground: pale umber steel on dark iron-rich dirt, which is the opposite of shard-cities and is what keeps two brown regions apart. Silhouettes are industrial and long \u2014 gantry cranes straddling bays, conveyor runs seized where they stopped and carrying on across tiles, bunded tank farms. Rust everywhere, in streaks and pools and oil stains. Almost nothing green: a few dead snags, and the wind has taken the rest.",
        gates: [
            {
                icon: "\uD83C\uDFED",
                name: "Factory Command Sector",
                // control rooms and relay racks under gantries, not a checkpoint
                recipe: "infrastructure",
                primary: "system-override",
                support: [
                    "growth-control",
                    "signal-mask"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "critical",
                shortDescription: "Central yard of control rooms and relay racks flanked by gantries.",
                longDescription: "Stack lights are long dead above cracked control housings. Catwalks draw hard lines across a sky of dust. A paper logbook lies fused into a solid wedge on a podium."
            },
            {
                icon: "\uD83D\uDE9B",
                name: "Logistics Yard Gate",
                primary: "drone-command",
                support: [
                    "stealth-transit",
                    "signal-relay"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "high",
                shortDescription: "Gatehouse and weighbridge spanning lanes into container lots.",
                longDescription: "The weighbridge plate is welded to its frame by corrosion. The gate arms point at the ground like broken fingers. Dust piles where wheels once wore it away."
            },
            {
                icon: "\uD83E\uDE96",
                name: "Barracks Gate",
                primary: "signal-mask",
                support: [
                    "signal-relay",
                    "system-override"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "high",
                districtAffinity: "residential",
                shortDescription: "Perimeter fence and turnstiles into a worker barracks compound.",
                longDescription: "Turnstiles are frozen mid-rotation. A loudspeaker hangs by its cable, a mouth that will never speak. The ground inside is a quilt of footprints long since filled with dust."
            },
            {
                icon: "\uD83C\uDF7D\uFE0F",
                name: "Commissary Shutter Sector",
                primary: "system-override",
                support: [
                    "safeguard",
                    "drone-command"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "high",
                districtAffinity: "commercial",
                shortDescription: "Canteen frontage sealed by roll-down shutters and collapsed awnings.",
                longDescription: "Menu boards peel in the heat. Trays clatter when the wind gets under them. At noon the whole block smells like hot metal and old oil."
            }
        ],
        hazards: [
            {
                icon: "\u26CF\uFE0F",
                name: "Extraction Yard",
                primary: "drone-command",
                support: [
                    "signal-mask",
                    "stealth-transit"
                ],
                baseDuration: 60,
                category: "storage",
                difficulty: "high_value",
                placement_priority: "high",
                shortDescription: "Ore hoppers, crushed drums, and loader tracks etched into dust.",
                longDescription: "Chutes hang open over empty ground. Piles of fines drift into dunes against dead conveyors. The only sparkle is mica in the grit."
            },
            {
                icon: "\u2699\uFE0F",
                name: "Assembly Corridor Block",
                primary: "drone-command",
                support: [
                    "wild-influence",
                    "stealth-transit"
                ],
                baseDuration: 60,
                category: "infrastructure",
                difficulty: "standard",
                placement_priority: "normal",
                shortDescription: "Long run of conveyor frames and work platforms seized in place.",
                longDescription: "Tool shadows are burned into paint where the sun never reached. Belt rollers are fused in rings of red. The wind writes its own schedule on hanging tags."
            },
            {
                icon: "\uD83D\uDDD1\uFE0F",
                name: "Salvage Lot",
                primary: "wild-influence",
                support: [
                    "drone-command",
                    "signal-relay"
                ],
                baseDuration: 60,
                category: "environmental",
                difficulty: "standard",
                placement_priority: "normal",
                shortDescription: "Heap of stripped machinery and scaffold bones stacked by a fence.",
                longDescription: "Cranes stripped to spines cast laddered shadows. Wire harnesses dangle like dead vines. Footing is uncertain\u2014everything gives a little when you test it."
            },
            {
                icon: "\uD83D\uDD27",
                name: "Operations Hub",
                primary: "signal-relay",
                support: [
                    "drone-command",
                    "system-override"
                ],
                baseDuration: 60,
                category: "infrastructure",
                difficulty: "high_value",
                placement_priority: "critical",
                shortDescription: "Control kiosks and cable troughs forming a nerve-center yard.",
                longDescription: "Cable trays cross like irrigation over bare concrete. A signal flag still flaps from a line that never fell. If anything comes alive, it does so in stutters and stops."
            },
            {
                icon: "\uD83D\uDD25",
                name: "Boiler Leak Row",
                primary: "safeguard",
                support: [
                    "signal-relay",
                    "system-override"
                ],
                baseDuration: 60,
                category: "environmental",
                difficulty: "standard",
                placement_priority: "normal",
                districtAffinity: "residential",
                shortDescription: "Steam-scarred lane between boiler sheds and maintenance stacks.",
                longDescription: "Mineral bloom and peeling paint texture every pipe. Valves whistle ghosts when the wind fits their mouths. The ground is white with the memory of heat."
            },
            {
                icon: "\uD83E\uDD6B",
                name: "Barracks Pantry Depot",
                primary: "stealth-transit",
                support: [
                    "wild-influence",
                    "growth-control"
                ],
                baseDuration: 60,
                category: "storage",
                difficulty: "standard",
                placement_priority: "normal",
                districtAffinity: "residential",
                shortDescription: "Food stores and cold-room bays opened to the air long ago.",
                longDescription: "Shelving prints squares on the walls where cold once lived. A pyramid of cans has slumped into a gentle hill of dull tin."
            },
            {
                icon: "\uD83C\uDFDA\uFE0F",
                name: "Warehouse Racking Collapse",
                primary: "safeguard",
                support: [
                    "drone-command",
                    "system-override"
                ],
                baseDuration: 60,
                category: "infrastructure",
                difficulty: "standard",
                placement_priority: "high",
                districtAffinity: "commercial",
                shortDescription: "Racking aisles tumbled into a lattice of unstable paths.",
                longDescription: "Number placards hang at wrong angles, their arrows pointing into heaps of beams. The floor is a patchwork of shadows and sunlight where the roof gave up."
            },
            {
                icon: "\uD83D\uDCD2",
                name: "Ledger Block",
                primary: "signal-relay",
                support: [
                    "safeguard",
                    "signal-mask"
                ],
                baseDuration: 60,
                category: "storage",
                difficulty: "high_value",
                placement_priority: "high",
                districtAffinity: "commercial",
                shortDescription: "Accounting offices and file stores woven into a single crumbling block.",
                longDescription: "Adding machines sit like fossils on desks. Ledger paper lies fused into brick-hard stacks. The sun makes dust glitter where a roof panel fell away."
            }
        ]
    },
    // ======================================================
    "hollow-core": {
        name: "Hollow Core",
        theme: "Sublevel transit and collapsed substructures",
        icon: "\u26AB",
        shortDescription: "Buried civic arteries: pillared halls, rail spurs and maintenance blocks, half of them sealed by the collapse.",
        longDescription: "Everything aboveground depended on what ran below\u2014transit rings, service corridors, and power trunks stitched together across sublevels. Collapse sealed off some blocks entirely; others breathe stale air through long cracks in the concrete.\n\nOccasionally, indicator strips flare for a moment, enough to show distance receding into black. Then the dark returns, settling even heavier than before.",
        artDirection: "A hall, not a street. Pillars on a regular pitch march across every tile and carry on into the next one \u2014 that rhythm is the only thing a top-down view has to say there is a ceiling overhead. Rock mass laps in from the corners and outer edges where the roof has come down, sealing parts of blocks, carved back around the rooms and never across a route. Rail beds and cable trays run through. Light is the region's subject: almost none of it, teal bioluminescence for ambient, warm pools under the daylight wells, and the darkness graded so it is heaviest against the rock and lightest over the floor. The concrete itself is NOT black \u2014 the palette has to survive the dark and still show which parts are wall.",
        gates: [
            {
                icon: "\uD83D\uDE87",
                name: "Sublevel Transit Hub",
                primary: "transit-anchor",
                support: [
                    "signal-relay",
                    "drone-command"
                ],
                baseDuration: 120,
                category: "storage",
                difficulty: "chokepoint",
                placement_priority: "critical",
                shortDescription: "Collapsed interchange where multiple rail spurs once crossed.",
                longDescription: "Pillars hold up more air than concrete now. Signal plates stand blank along a bed of gravel and dust. The far wall is a shadow that pretends to be distance."
            },
            {
                icon: "\uD83D\uDD0C",
                name: "Power Relay Block",
                primary: "signal-relay",
                support: [
                    "quantum-scan",
                    "stealth-transit"
                ],
                baseDuration: 120,
                category: "infrastructure",
                difficulty: "chokepoint",
                placement_priority: "high",
                shortDescription: "Cable trays and junction housings clustered around a maintenance court.",
                longDescription: "Insulators line a wall like teeth. A skein of cables has slumped from the ceiling into a black loop. Dust swirls when you step, then remembers how to be still."
            },
            {
                icon: "\uD83D\uDEAA",
                name: "Habitat Access Sector",
                primary: "lock-breach",
                support: [
                    "quantum-scan",
                    "signal-mask"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "high",
                districtAffinity: "residential",
                shortDescription: "Door clusters and service nooks leading into sealed living blocks.",
                longDescription: "Numbered arrows march along the wall toward units you\u2019ll never enter. A cart sits on square wheels of dust. The air is dry and old, like a book left open too long."
            },
            {
                icon: "\uD83D\uDED2",
                name: "Commerce Access Sector",
                primary: "signal-mask",
                support: [
                    "lock-breach",
                    "echo-trace"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "high",
                districtAffinity: "commercial",
                shortDescription: "Service corridors feeding into a forgotten plaza and loading cutouts.",
                longDescription: "A map board with no map. A mural worn to colors without shapes. The corridor breathes the same cold air in and out, as if thinking of a crowd."
            }
        ],
        hazards: [
            {
                icon: "\uD83D\uDCE6",
                name: "Storage Compound",
                primary: "quantum-scan",
                support: [
                    "lock-breach",
                    "growth-control"
                ],
                baseDuration: 60,
                category: "storage",
                difficulty: "high_value",
                placement_priority: "critical",
                shortDescription: "Box canyons of crates and shelving under a low slab ceiling.",
                longDescription: "Label paint lingers like ghosts on metal faces. A broken roller door shows a sliver of stale light. The air tastes like paper and iron."
            },
            {
                icon: "\uD83E\uDDF1",
                name: "Maintenance Network Sector",
                primary: "growth-control",
                support: [
                    "signal-relay",
                    "drone-command"
                ],
                baseDuration: 60,
                category: "environmental",
                difficulty: "standard",
                placement_priority: "normal",
                shortDescription: "Grid of service corridors, tool bays, and grates over dark shafts.",
                longDescription: "Tool outlines haunt the walls. Floor grates ring when crossed, answering back from below. The network feels larger than the ground it serves."
            },
            {
                icon: "\u2622\uFE0F",
                name: "Reactor Service Lot",
                primary: "stealth-transit",
                support: [
                    "transit-anchor",
                    "quantum-scan"
                ],
                baseDuration: 60,
                category: "power",
                difficulty: "high_value",
                placement_priority: "high",
                shortDescription: "Shield doors and access gantries around a dead core housing.",
                longDescription: "Warning chevrons fade across concrete that still remembers heat. Cable stumps jut like bones from panel edges. Everything hums with a silence that feels heavy."
            },
            {
                icon: "\uD83D\uDEE0\uFE0F",
                name: "Data Spine Junction",
                primary: "echo-trace",
                support: [
                    "stealth-transit",
                    "signal-mask"
                ],
                baseDuration: 60,
                category: "infrastructure",
                difficulty: "standard",
                placement_priority: "normal",
                shortDescription: "Trunk conduits converge into a node of cracked panels and conduit arcs.",
                longDescription: "Cables repeat the curve of the arching ceiling. Labels peel off in satisfying curls. Your headlamp shows dust floating like a slow snowfall."
            },
            {
                icon: "\uD83D\uDED7",
                name: "Access Network Block",
                primary: "transit-anchor",
                support: [
                    "echo-trace",
                    "growth-control"
                ],
                baseDuration: 60,
                category: "infrastructure",
                difficulty: "standard",
                placement_priority: "normal",
                districtAffinity: "residential",
                shortDescription: "Lift shafts, catwalks, and ladders crisscrossing a deep chamber.",
                longDescription: "Mesh floors draft cool air over your boots. The shaft walls are a history of paint colors layered like sediment. The dark holds its shape until you look into it."
            },
            {
                icon: "\uD83E\uDDF8",
                name: "Nursery Annex Sector",
                primary: "echo-trace",
                support: [
                    "stealth-transit",
                    "signal-mask"
                ],
                baseDuration: 60,
                category: "environmental",
                difficulty: "standard",
                placement_priority: "normal",
                districtAffinity: "residential",
                shortDescription: "Quiet block of sealed playrooms, murals eroded to color fields.",
                longDescription: "Small chairs lie on their backs like beetles. A mobile has tangled into a single shape. Everyone left a long time ago, but the rooms still feel paused."
            },
            {
                icon: "\uD83D\uDCDA",
                name: "Records Quarter",
                primary: "stealth-transit",
                support: [
                    "bio-shield",
                    "transit-anchor"
                ],
                baseDuration: 60,
                category: "storage",
                difficulty: "high_value",
                placement_priority: "high",
                districtAffinity: "commercial",
                shortDescription: "Storage stacks and data cages in a commercial sub-block.",
                longDescription: "Cage doors have slumped out of square. A spill of binders lies like fallen bricks. Your light finds the path numbers and makes them legible for a heartbeat."
            },
            {
                icon: "\uD83C\uDFEC",
                name: "Commerce Plaza",
                primary: "signal-mask",
                support: [
                    "bio-shield",
                    "transit-anchor"
                ],
                baseDuration: 60,
                category: "environmental",
                difficulty: "standard",
                placement_priority: "normal",
                districtAffinity: "commercial",
                shortDescription: "Lower concourse ringed by shuttered storefronts and dead kiosks.",
                longDescription: "A fountain bowl holds dust instead of water. Kiosk screens are gray mirrors. Every footstep you make has an echo measured in seconds."
            }
        ]
    }
};
var $979b99378be707cd$export$85b5153488a36ab6 = {
    civic: [
        "CivicSys",
        "CityWorks",
        "MetroGrid",
        "Municipalix",
        "UrbanNet"
    ],
    industrial: [
        "StrataDyne",
        "HelixCore",
        "OmniForge",
        "FerrumWorks",
        "Rivetron"
    ],
    utilities: [
        "Nextera",
        "Voltline",
        "Auralis",
        "BlueArc",
        "GridNova"
    ],
    retail: [
        "MetroTrade",
        "ApexMart",
        "Cornerline",
        "Shoreline Logistics",
        "Mercantis"
    ],
    bio: [
        "VerdanCo",
        "BioNet",
        "PhytoLabs",
        "GreenRidge",
        "GenExis"
    ],
    defense: [
        "WardTek",
        "Rampart Systems",
        "Bastionex",
        "IronCrest",
        "Shieldline"
    ],
    data: [
        "Archivum",
        "Memora",
        "DataPlain",
        "ByteHarbor",
        "Recorda"
    ]
};
var $979b99378be707cd$export$432c04b9bead009 = {
    "shard-cities": [
        "MetroGuard",
        "CivicSys",
        "CityWorks",
        "UrbanNet",
        "MetroGrid",
        "ApexLift",
        "Blockline Security",
        "SentraCore",
        "Wayfinder Transit",
        "Arcology Services"
    ],
    "verdant-reclamation": [
        "VerdanCo",
        "PhytoLabs",
        "BioNet",
        "Greencap Utilities",
        "GardenWorks",
        "Nutrivane",
        "IrrigaTech",
        "SeedSafe",
        "Rootline Systems",
        "Auralis Bio"
    ],
    "sunken-bastions": [
        "HarborFleet",
        "DryDock Systems",
        "Bastionex",
        "BlueArc Marine",
        "Deepline",
        "Breakwater Logistics",
        "WardTek Maritime",
        "Pierstone",
        "Tidewell",
        "Seaforth Controls"
    ],
    "cradle-expanse": [
        "FerrumWorks",
        "OmniForge",
        "StrataDyne",
        "Rivetron",
        "Gantry & Co.",
        "Loadstar Fabrication",
        "ConveyorDynamics",
        "IronCrest",
        "Forgeway",
        "MachinaGrid"
    ],
    "hollow-core": [
        "CivicSys Sublevel",
        "MetroGrid Infrastructure",
        "Nextera Utility",
        "ServiceWay",
        "Subterra Transit",
        "CorridorWorks",
        "Spanline",
        "NodeWest",
        "ControlPoint",
        "Concourse Ops"
    ]
};
var $979b99378be707cd$export$2c8d0d917dbcc8a5 = {
    power: [
        "Power Node",
        "Junction Panel",
        "Substation",
        "Transformer Bay",
        "Distribution Rack"
    ],
    storage: [
        "Storage Bay",
        "Records Vault",
        "Supply Depot",
        "Inventory Room",
        "Archive Annex"
    ],
    security: [
        "Security Gate",
        "Checkpoint",
        "Access Control",
        "Barrier Post",
        "Perimeter Gate"
    ],
    infrastructure: [
        "Relay Node",
        "Transit Hub",
        "Service Corridor",
        "Maintenance Bay",
        "Control Room"
    ],
    environmental: [
        "Containment Zone",
        "Hazard Control",
        "Firebreak",
        "Isolation Area",
        "Cleanup Sector"
    ],
    wildlife: [
        "Hive Chamber",
        "Containment Atrium",
        "Observation Pen",
        "Keeper Station",
        "Handling Room"
    ],
    power_infra: [
        "Switchgear Room",
        "Feeder Junction",
        "Utility Interface",
        "Load Center",
        "Breaker Hall"
    ],
    records_data: [
        "Records Cache",
        "Data Vault",
        "Archive Store",
        "Tape Annex",
        "Records Room"
    ]
};
var $979b99378be707cd$export$66a51bddf5f03abf = [
    "Block A",
    "Block C",
    "Sector 7",
    "Sector 9",
    "East Annex",
    "West Annex",
    "North Wing",
    "South Wing",
    "Sublevel 2",
    "Sublevel 3",
    "Sublevel 4",
    "Tower 2",
    "Depot Lane",
    "Service Row",
    "Line 3",
    "Bay 12",
    "Bay 17",
    "Midtown Annex"
];
var $979b99378be707cd$export$ae5fd03a6b740baa = {
    "shard-cities": [
        "Midtown Annex",
        "Tower 3",
        "Sector 9",
        "Skyway Deck",
        "Service Row"
    ],
    "verdant-reclamation": [
        "Greenhouse 2A",
        "Irrigation Loop B",
        "Seed Wing",
        "Containment Hall",
        "Botany Annex"
    ],
    "sunken-bastions": [
        "Pier 6",
        "Drydock 3",
        "Bulkhead E",
        "Sublevel Pump 2",
        "Bilge Corridor"
    ],
    "cradle-expanse": [
        "Line 3",
        "Bay 12",
        "Casting Floor",
        "Yard 5",
        "Maintenance Track"
    ],
    "hollow-core": [
        "Sublevel 4",
        "Service Spine",
        "Transit Ring",
        "Access Spur",
        "Node J"
    ]
};
var $979b99378be707cd$export$68faa9057a77ce7d = {
    "shard-cities": [
        "civic",
        "utilities",
        "data",
        "industrial",
        "retail",
        "defense"
    ],
    "verdant-reclamation": [
        "bio",
        "utilities",
        "civic",
        "industrial",
        "data"
    ],
    "sunken-bastions": [
        "defense",
        "utilities",
        "industrial",
        "civic",
        "data"
    ],
    "cradle-expanse": [
        "industrial",
        "utilities",
        "civic",
        "retail",
        "data"
    ],
    "hollow-core": [
        "civic",
        "utilities",
        "industrial",
        "data",
        "retail"
    ],
    zone: {
        residential: [
            "civic",
            "utilities",
            "bio",
            "retail"
        ],
        commercial: [
            "retail",
            "civic",
            "data",
            "utilities"
        ],
        industrial: [
            "industrial",
            "utilities",
            "defense"
        ],
        security: [
            "defense",
            "civic",
            "utilities"
        ],
        core: [
            "data",
            "defense",
            "industrial"
        ],
        transit: [
            "civic",
            "utilities",
            "industrial"
        ],
        peripheral: [
            "civic",
            "industrial",
            "retail"
        ],
        entry: [
            "civic",
            "utilities",
            "retail"
        ]
    },
    category: {
        power: [
            "utilities",
            "industrial",
            "civic"
        ],
        storage: [
            "industrial",
            "retail",
            "data"
        ],
        security: [
            "defense",
            "civic",
            "utilities"
        ],
        infrastructure: [
            "civic",
            "utilities",
            "industrial"
        ],
        environmental: [
            "civic",
            "industrial",
            "utilities"
        ],
        wildlife: [
            "bio",
            "civic",
            "utilities"
        ]
    }
};
// RNG (seeded)
function $979b99378be707cd$var$xmur3(str) {
    var h = 1779033703 ^ str.length;
    for(var i = 0; i < str.length; i++){
        h = Math.imul(h ^ str.charCodeAt(i), 3432918353);
        h = h << 13 | h >>> 19;
    }
    return function() {
        h = Math.imul(h ^ h >>> 16, 2246822507);
        h = Math.imul(h ^ h >>> 13, 3266489909);
        return (h ^ h >>> 16) >>> 0;
    };
}
function $979b99378be707cd$var$mulberry32(a) {
    return function() {
        a |= 0;
        a = a + 0x6d2b79f5 | 0;
        var t = Math.imul(a ^ a >>> 15, 1 | a);
        t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t;
        return ((t ^ t >>> 14) >>> 0) / 4294967296;
    };
}
function $979b99378be707cd$export$c0b222505a3369f3() {
    var seedStr = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var seed = $979b99378be707cd$var$xmur3(seedStr)();
    return $979b99378be707cd$var$mulberry32(seed);
}
function $979b99378be707cd$var$pick(array, rng) {
    return array[Math.floor(rng() * array.length)];
}
// Brand pool builder with regional weighting
function $979b99378be707cd$var$getBrandPool(param) {
    var regionKey = param.regionKey, zone = param.zone, category = param.category;
    var _weighted, _instance;
    var base = $979b99378be707cd$export$68faa9057a77ce7d[regionKey] || [
        "civic",
        "industrial",
        "utilities"
    ];
    var zoneBias = $979b99378be707cd$export$68faa9057a77ce7d.zone[zone] || [];
    var catBias = $979b99378be707cd$export$68faa9057a77ce7d.category[category] || [];
    var order = (0, $4c858c0d999a5b9b$export$71511d61b312f219)(base).concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)(zoneBias), (0, $4c858c0d999a5b9b$export$71511d61b312f219)(catBias));
    var weighted = [];
    var regional = $979b99378be707cd$export$432c04b9bead009[regionKey] || [];
    for(var i = 0; i < 3; i++)(_weighted = weighted).push.apply(_weighted, (0, $4c858c0d999a5b9b$export$71511d61b312f219)(regional)); // heavy regional weight
    order.forEach(function(bucket, idx) {
        var _weighted;
        var list = $979b99378be707cd$export$85b5153488a36ab6[bucket] || [];
        var weight = idx < 2 ? 2 : 1;
        for(var i = 0; i < weight; i++)(_weighted = weighted).push.apply(_weighted, (0, $4c858c0d999a5b9b$export$71511d61b312f219)(list));
    });
    return weighted.length ? weighted : (_instance = []).concat.apply(_instance, (0, $4c858c0d999a5b9b$export$71511d61b312f219)(Object.values($979b99378be707cd$export$85b5153488a36ab6)));
}
function $979b99378be707cd$var$getDescriptorPool(category) {
    if (category === "power" && $979b99378be707cd$export$2c8d0d917dbcc8a5.power_infra) return (0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$2c8d0d917dbcc8a5.power).concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$2c8d0d917dbcc8a5.power_infra));
    if (category === "storage" && $979b99378be707cd$export$2c8d0d917dbcc8a5.records_data) return (0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$2c8d0d917dbcc8a5.storage).concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$2c8d0d917dbcc8a5.records_data));
    return $979b99378be707cd$export$2c8d0d917dbcc8a5[category] || $979b99378be707cd$export$2c8d0d917dbcc8a5.infrastructure;
}
function $979b99378be707cd$var$pickQualifier(regionKey, rng) {
    var base = $979b99378be707cd$export$66a51bddf5f03abf;
    var regional = $979b99378be707cd$export$ae5fd03a6b740baa[regionKey] || [];
    var pool = (0, $4c858c0d999a5b9b$export$71511d61b312f219)(regional).concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)(regional), (0, $4c858c0d999a5b9b$export$71511d61b312f219)(base)); // 2:1 favor regional
    return pool.length ? pool[Math.floor(rng() * pool.length)] : "";
}
function $979b99378be707cd$export$6b7290c54feddd3b(param) {
    var baseName = param.baseName, regionKey = param.regionKey, zone = param.zone, category = param.category, _param_seed = param.seed, seed = _param_seed === void 0 ? "" : _param_seed, count = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 5;
    var rng = $979b99378be707cd$export$c0b222505a3369f3("".concat(seed, "|").concat(baseName, "|").concat(regionKey, "|").concat(zone, "|").concat(category));
    var brands = $979b99378be707cd$var$getBrandPool({
        regionKey: regionKey,
        zone: zone,
        category: category
    });
    var descs = $979b99378be707cd$var$getDescriptorPool(category);
    var names = new Set();
    var canon = [
        baseName,
        "".concat(baseName, " \u2013 ").concat($979b99378be707cd$var$pickQualifier(regionKey, rng))
    ];
    var safety = 200;
    while(names.size < count && safety-- > 0){
        var brand = $979b99378be707cd$var$pick(brands, rng);
        var desc = $979b99378be707cd$var$pick(descs, rng);
        var useBaseTerm = rng() < 0.35; // 35% anchor to base term
        var qualifier = rng() < 0.65 ? " \u2013 ".concat($979b99378be707cd$var$pickQualifier(regionKey, rng)) : "";
        var candidate = useBaseTerm ? "".concat(brand, " ").concat(baseName).concat(qualifier) : "".concat(brand, " ").concat(desc).concat(qualifier);
        names.add(candidate);
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = canon[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var c = _step.value;
            if (names.size >= count) break;
            names.add(c);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return Array.from(names).slice(0, count);
}
var $979b99378be707cd$export$1a6ba7df4555a8dd = {
    defaultTune: {
        buildingScale: 1,
        treeDensity: 1,
        roadWear: 0.15,
        shadowAngle: 45,
        shadowAlpha: 0.85,
        shadowLength: 6,
        lightUptime: 0.12,
        lightFlickerSpeed: 1,
        sinkholeChance: 0.5,
        lightRays: 0,
        // How often a region's own signature props appear — the one pass that is
        // about a PARTICULAR place rather than about a town. 0 turns them off.
        signature: 1,
        // How far inland the sea reaches on a region with a shoreline. 0 = no sea,
        // which is every region but the drowned one.
        floodLevel: 0,
        // How much rock mass has come down around the built ground. Sublevels only.
        enclosure: 0,
        cloudType: 'scattered'
    },
    regions: {
        // Two tiers of architecture per region. `struct` is the ordinary building
        // stock — the sheds, blocks and terraces the whole map is made of. `mass`
        // is the monumental tier: the towers, glasshouses, sea walls, mill frames
        // and pillar halls a region builds at a scale nothing else on the tile
        // reaches. Keeping them apart is what lets shard-cities have warm brown
        // roofs on its small buildings AND cool concrete over them, instead of
        // picking one and reading as somewhere else's town in a filter.
        //
        // The rule both tiers answer to: a structure must separate from the ground
        // it stands on in VALUE, not just in hue. Two regions with the same value
        // relationship look like the same place no matter what colour they are.
        'shard-cities': {
            backdrop: 'city',
            overlay: 'dust',
            tune: {
                buildingScale: 1.3,
                treeDensity: 3,
                roadWear: 0.35,
                shadowAngle: 45,
                shadowAlpha: 0.85,
                shadowLength: 6,
                lightUptime: 0.18,
                lightFlickerSpeed: 1,
                sinkholeChance: 0.5,
                lightRays: 0,
                signature: 1,
                cloudType: 'broken'
            },
            pal: {
                far: '#1c2333',
                // Warm brick and brown roofing, but a stop LIGHTER than it used to be
                // and over darker tarmac. The hue contrast against grey ground always
                // worked; the value contrast did not — seven luma points apart, the
                // roofs sank into the street at map scale and the region read as one
                // undifferentiated grey-brown field.
                struct: '#8a705c',
                structDark: '#15171e',
                structLight: '#b99983',
                mass: '#79828f',
                massDark: '#2a3038',
                massLight: '#a9b6c4',
                ground1: '#3f434e',
                ground2: '#4b5160',
                road: '#20242f',
                metal: '#6b7893',
                rust: '#8a6a4a',
                accent: '#a9bee0',
                veg1: '#3b5841',
                veg2: '#5d8058',
                water1: '#33455c',
                water2: '#55708c',
                glow: '#ffb45e'
            }
        },
        'verdant-reclamation': {
            backdrop: 'greenhouse',
            overlay: 'vines',
            recipes: {
                storage: 'storage-seed'
            },
            tune: {
                buildingScale: 1.1,
                treeDensity: 4,
                roadWear: 0.75,
                cloudType: 'scattered',
                lightUptime: 0.05,
                signature: 1.1
            },
            pal: {
                far: '#4c6350',
                struct: '#7d8a8c',
                structDark: '#455256',
                structLight: '#b0bcba',
                mass: '#9fb0a8',
                massDark: '#4a5a52',
                massLight: '#cfdcd2',
                // The ground is most of the tile, so it decides whether the region reads
                // as flat — and a light mid-green under light grey frames was the whole
                // problem. Taken down to shaded loam, but only halfway: the first attempt
                // went the full distance and the region lost its light instead of gaining
                // contrast. The canopy is darker still, the structures sit well above
                // both, and the tile has a range without going gloomy.
                ground1: '#3e5a34',
                ground2: '#4f5b30',
                road: '#42402f',
                metal: '#8b9598',
                rust: '#8a7050',
                accent: '#d8d2a8',
                // Deep canopy. These are the darkest greens on the tile and the shapes
                // they make are what the eye reads first, so they carry the contrast.
                veg1: '#254d2a',
                veg2: '#4a7a3a',
                water1: '#3f7a70',
                water2: '#6fb0a4',
                glow: '#f4e9c8'
            }
        },
        'sunken-bastions': {
            backdrop: 'harbor',
            overlay: 'flood',
            recipes: {
                storage: 'storage-quay'
            },
            tune: {
                buildingScale: 1.15,
                treeDensity: 1,
                roadWear: 0.4,
                cloudType: 'overcast',
                sinkholeChance: 0.35,
                floodLevel: 1,
                signature: 1
            },
            pal: {
                far: '#3a4854',
                struct: '#6d8290',
                structDark: '#2c3841',
                structLight: '#9db6c2',
                mass: '#7d8f99',
                massDark: '#2c3841',
                massLight: '#a8bcc4',
                ground1: '#4a5450',
                ground2: '#5b6763',
                road: '#39434c',
                metal: '#7b8a93',
                rust: '#b06a3d',
                accent: '#8fc4cc',
                veg1: '#3c5f4c',
                veg2: '#58825e',
                water1: '#2f5c6b',
                water2: '#5a8f9b',
                glow: '#ffd27f'
            }
        },
        'cradle-expanse': {
            backdrop: 'foundry',
            overlay: 'rust',
            recipes: {
                storage: 'storage-silo'
            },
            tune: {
                buildingScale: 1.25,
                treeDensity: 0.8,
                roadWear: 0.3,
                shadowAngle: 15,
                cloudType: 'wispy',
                signature: 1
            },
            pal: {
                far: '#4a3226',
                // The one region whose plant is LIGHTER than its ground. Dark dirt with
                // pale steel on it is the opposite value relationship to shard-cities'
                // dark roofs on grey tarmac, which is what stops two brown regions
                // reading as one.
                struct: '#a5825c',
                structDark: '#3a2417',
                structLight: '#d2ad7f',
                mass: '#a89279',
                massDark: '#4a3a28',
                massLight: '#d3c0a4',
                ground1: '#6b5137',
                ground2: '#7d6244',
                road: '#3d3226',
                metal: '#9c8a6e',
                rust: '#b55a2b',
                accent: '#e8b060',
                veg1: '#635831',
                veg2: '#807236',
                water1: '#5d564a',
                water2: '#7a705c',
                glow: '#ffcf7a'
            }
        },
        'hollow-core': {
            backdrop: 'underground',
            overlay: 'dark',
            // Everything here is lifted a stop from where it was: a sublevel is dark
            // because of its LIGHT, not because its concrete is black. The palette
            // has to survive a x0.5 night tint and a darkness wash on top and still
            // show which parts of the tile are wall.
            tune: {
                buildingScale: 1.1,
                treeDensity: 1,
                roadWear: 0.25,
                lightRays: 1.5,
                enclosure: 1,
                signature: 1.2
            },
            pal: {
                far: '#07080c',
                struct: '#5c6782',
                structDark: '#1b1f2a',
                structLight: '#7f8cad',
                mass: '#6b7690',
                massDark: '#1b1f2a',
                massLight: '#909dbb',
                ground1: '#333a46',
                ground2: '#454d5d',
                road: '#1c212b',
                metal: '#5b6478',
                rust: '#5a4630',
                accent: '#4fa0a0',
                veg1: '#2d473f',
                veg2: '#41684e',
                water1: '#234049',
                water2: '#356470',
                glow: '#ffc46a'
            }
        }
    },
    recipes: {
        power: {
            variants: [
                {
                    elements: [
                        {
                            el: 'transformerPad',
                            x: [
                                9,
                                21
                            ],
                            y: [
                                9,
                                21
                            ]
                        },
                        {
                            el: 'transformerPad',
                            x: [
                                84,
                                93
                            ],
                            y: [
                                84,
                                93
                            ]
                        },
                        {
                            el: 'rect',
                            x: 30,
                            y: [
                                24,
                                30
                            ],
                            w: 3,
                            h: 60,
                            color: 'structDark'
                        },
                        {
                            el: 'rect',
                            x: 30,
                            y: 87,
                            w: [
                                51,
                                60
                            ],
                            h: 3,
                            color: 'structDark'
                        },
                        {
                            el: 'fence',
                            x: 6,
                            y: 6,
                            w: 36,
                            h: 36
                        }
                    ]
                },
                {
                    elements: [
                        {
                            el: 'tank',
                            x: [
                                24,
                                33
                            ],
                            y: [
                                24,
                                33
                            ],
                            r: 18
                        },
                        {
                            el: 'pipeline',
                            x: 6,
                            y: [
                                87,
                                96
                            ],
                            w: 108
                        },
                        {
                            el: 'transformerPad',
                            x: [
                                84,
                                93
                            ],
                            y: [
                                15,
                                24
                            ]
                        }
                    ]
                }
            ]
        },
        storage: {
            variants: [
                {
                    elements: [
                        {
                            el: 'crates',
                            x: [
                                9,
                                15
                            ],
                            y: [
                                9,
                                18
                            ],
                            cols: 3,
                            rows: 2
                        },
                        {
                            el: 'crates',
                            x: [
                                78,
                                87
                            ],
                            y: [
                                78,
                                87
                            ],
                            cols: 2,
                            rows: 2
                        },
                        {
                            el: 'tank',
                            x: [
                                90,
                                99
                            ],
                            y: [
                                21,
                                30
                            ],
                            r: 15
                        },
                        {
                            el: 'building',
                            x: [
                                9,
                                15
                            ],
                            y: [
                                78,
                                84
                            ],
                            w: 27,
                            h: 24
                        }
                    ]
                },
                {
                    elements: [
                        {
                            el: 'container',
                            x: [
                                9,
                                18
                            ],
                            y: [
                                9,
                                15
                            ],
                            vert: 0
                        },
                        {
                            el: 'container',
                            x: [
                                9,
                                18
                            ],
                            y: [
                                27,
                                33
                            ],
                            vert: 0
                        },
                        {
                            el: 'container',
                            x: [
                                81,
                                93
                            ],
                            y: [
                                75,
                                84
                            ],
                            vert: 1
                        },
                        {
                            el: 'crates',
                            x: [
                                15,
                                24
                            ],
                            y: [
                                81,
                                90
                            ],
                            cols: 2,
                            rows: 2
                        }
                    ]
                }
            ]
        },
        // ---- region-specific stock ----
        // A region may point one of the shared recipes at its own layout via
        // `recipes` on its RENDER_CONFIG.regions entry. The signature layer adds a
        // region's landmarks ON TOP of whatever a tile drew; this changes what the
        // tile is made of in the first place, which is the difference between a
        // harbour with containers on it and a harbour built out of them.
        //
        // Kept deliberately few. Every one of these is a second layout to maintain
        // for a recipe that already had one, so it has to earn its place by being
        // somewhere the shared version reads plainly wrong.
        'storage-quay': {
            variants: [
                {
                    elements: [
                        {
                            el: 'container',
                            x: [
                                9,
                                15
                            ],
                            y: [
                                12,
                                18
                            ],
                            vert: 0
                        },
                        {
                            el: 'container',
                            x: [
                                9,
                                15
                            ],
                            y: [
                                27,
                                33
                            ],
                            vert: 0
                        },
                        {
                            el: 'container',
                            x: [
                                9,
                                15
                            ],
                            y: [
                                42,
                                48
                            ],
                            vert: 0
                        },
                        {
                            el: 'container',
                            x: [
                                78,
                                90
                            ],
                            y: [
                                69,
                                81
                            ],
                            vert: 1
                        },
                        {
                            el: 'crates',
                            x: [
                                66,
                                75
                            ],
                            y: [
                                15,
                                24
                            ],
                            cols: 2,
                            rows: 2
                        }
                    ]
                },
                {
                    elements: [
                        {
                            el: 'building',
                            x: [
                                15,
                                24
                            ],
                            y: [
                                15,
                                24
                            ],
                            w: 60,
                            h: 27
                        },
                        {
                            el: 'container',
                            x: [
                                15,
                                27
                            ],
                            y: [
                                78,
                                87
                            ],
                            vert: 0
                        },
                        {
                            el: 'container',
                            x: [
                                60,
                                72
                            ],
                            y: [
                                75,
                                84
                            ],
                            vert: 1
                        }
                    ]
                }
            ]
        },
        'storage-silo': {
            variants: [
                {
                    elements: [
                        {
                            el: 'silo',
                            x: [
                                21,
                                27
                            ],
                            y: [
                                24,
                                30
                            ],
                            r: 13
                        },
                        {
                            el: 'silo',
                            x: [
                                21,
                                27
                            ],
                            y: [
                                69,
                                75
                            ],
                            r: 11
                        },
                        {
                            el: 'silo',
                            x: [
                                72,
                                81
                            ],
                            y: [
                                45,
                                54
                            ],
                            r: 14
                        },
                        {
                            el: 'pipeline',
                            x: 33,
                            y: [
                                51,
                                57
                            ],
                            w: [
                                30,
                                39
                            ]
                        }
                    ]
                },
                {
                    elements: [
                        {
                            el: 'silo',
                            x: [
                                78,
                                87
                            ],
                            y: [
                                24,
                                33
                            ],
                            r: 12
                        },
                        {
                            el: 'tank',
                            x: [
                                24,
                                33
                            ],
                            y: [
                                21,
                                30
                            ],
                            r: 15
                        },
                        {
                            el: 'building',
                            x: [
                                15,
                                24
                            ],
                            y: [
                                72,
                                81
                            ],
                            w: 42,
                            h: 24
                        },
                        {
                            el: 'crates',
                            x: [
                                72,
                                84
                            ],
                            y: [
                                78,
                                90
                            ],
                            cols: 2,
                            rows: 2
                        }
                    ]
                }
            ]
        },
        'storage-seed': {
            variants: [
                {
                    elements: [
                        {
                            el: 'glassSpan',
                            x: [
                                12,
                                18
                            ],
                            y: [
                                15,
                                24
                            ],
                            w: 66,
                            h: 27
                        },
                        {
                            el: 'silo',
                            x: [
                                24,
                                30
                            ],
                            y: [
                                78,
                                87
                            ],
                            r: 11
                        },
                        {
                            el: 'silo',
                            x: [
                                54,
                                63
                            ],
                            y: [
                                81,
                                90
                            ],
                            r: 9
                        },
                        {
                            el: 'crates',
                            x: [
                                84,
                                93
                            ],
                            y: [
                                69,
                                78
                            ],
                            cols: 2,
                            rows: 2
                        }
                    ]
                },
                {
                    elements: [
                        {
                            el: 'silo',
                            x: [
                                18,
                                24
                            ],
                            y: [
                                21,
                                30
                            ],
                            r: 12
                        },
                        {
                            el: 'glassSpan',
                            x: [
                                63,
                                72
                            ],
                            y: [
                                21,
                                30
                            ],
                            w: 33,
                            h: 66
                        },
                        {
                            el: 'crates',
                            x: [
                                15,
                                24
                            ],
                            y: [
                                78,
                                87
                            ],
                            cols: 3,
                            rows: 2
                        }
                    ]
                }
            ]
        },
        security: {
            elements: [
                {
                    el: 'fence',
                    x: 15,
                    y: 15,
                    w: 90,
                    h: 90,
                    gaps: 1
                },
                {
                    el: 'barrier',
                    x: 24,
                    y: 24
                },
                {
                    el: 'barrier',
                    x: 81,
                    y: 81
                },
                {
                    el: 'vehicle',
                    chance: 0.4,
                    x: [
                        72,
                        84
                    ],
                    y: [
                        78,
                        87
                    ],
                    vert: {
                        pick: [
                            0,
                            1
                        ]
                    }
                },
                {
                    el: 'building',
                    x: [
                        72,
                        81
                    ],
                    y: [
                        21,
                        30
                    ],
                    w: 18,
                    h: 15
                }
            ]
        },
        infrastructure: {
            variants: [
                {
                    elements: [
                        {
                            el: 'building',
                            x: [
                                9,
                                15
                            ],
                            y: [
                                9,
                                15
                            ],
                            w: [
                                36,
                                45
                            ],
                            h: [
                                27,
                                33
                            ]
                        },
                        {
                            el: 'pipeline',
                            x: 6,
                            y: [
                                87,
                                96
                            ],
                            w: 108
                        },
                        {
                            el: 'rect',
                            x: [
                                81,
                                93
                            ],
                            y: [
                                15,
                                24
                            ],
                            w: 15,
                            h: 15,
                            color: 'metal'
                        }
                    ]
                },
                {
                    elements: [
                        {
                            el: 'tower',
                            x: [
                                15,
                                24
                            ],
                            y: [
                                15,
                                24
                            ]
                        },
                        {
                            el: 'rect',
                            x: 24,
                            y: 30,
                            w: 3,
                            h: [
                                54,
                                66
                            ],
                            color: 'structDark'
                        },
                        {
                            el: 'rect',
                            x: 24,
                            y: 90,
                            w: [
                                54,
                                66
                            ],
                            h: 3,
                            color: 'structDark'
                        },
                        {
                            el: 'tank',
                            x: [
                                84,
                                93
                            ],
                            y: [
                                81,
                                90
                            ],
                            r: 12
                        },
                        {
                            el: 'rect',
                            x: [
                                81,
                                93
                            ],
                            y: [
                                15,
                                24
                            ],
                            w: 15,
                            h: 15,
                            color: 'metal'
                        }
                    ]
                }
            ]
        },
        transit: {
            elements: [
                {
                    el: 'rect',
                    x: [
                        18,
                        30
                    ],
                    y: [
                        72,
                        84
                    ],
                    w: 6,
                    h: 27,
                    color: 'struct'
                },
                {
                    el: 'rect',
                    x: [
                        78,
                        90
                    ],
                    y: [
                        15,
                        27
                    ],
                    w: 27,
                    h: 6,
                    color: 'struct'
                },
                {
                    el: 'vehicle',
                    x: [
                        12,
                        24
                    ],
                    y: [
                        12,
                        24
                    ],
                    vert: {
                        pick: [
                            0,
                            1
                        ]
                    }
                },
                {
                    el: 'vehicle',
                    chance: 0.6,
                    x: [
                        78,
                        90
                    ],
                    y: [
                        78,
                        90
                    ],
                    vert: {
                        pick: [
                            0,
                            1
                        ]
                    }
                },
                {
                    el: 'rubble',
                    x: 12,
                    y: 12,
                    w: 93,
                    h: 93,
                    n: 12
                }
            ]
        },
        environmental: {
            variantKey: 'sinkholeChance',
            variants: [
                {
                    elements: [
                        {
                            el: 'crack',
                            repeat: 4,
                            x: [
                                9,
                                105
                            ],
                            y: [
                                9,
                                96
                            ],
                            len: [
                                18,
                                36
                            ]
                        },
                        {
                            el: 'rubble',
                            x: 6,
                            y: 6,
                            w: 105,
                            h: 105,
                            n: 18
                        },
                        {
                            el: 'foliage',
                            x: [
                                15,
                                36
                            ],
                            y: [
                                78,
                                102
                            ],
                            size: [
                                4,
                                6
                            ]
                        },
                        {
                            el: 'foliage',
                            x: [
                                81,
                                102
                            ],
                            y: [
                                15,
                                36
                            ],
                            size: [
                                4,
                                6
                            ]
                        },
                        {
                            el: 'tree',
                            x: [
                                81,
                                99
                            ],
                            y: [
                                81,
                                99
                            ],
                            r: [
                                9,
                                12
                            ]
                        }
                    ]
                },
                {
                    elements: [
                        // The hole goes down LAST. Scatter drawn over it is debris hanging in
                        // a shaft; drawn under it, the hole simply swallows whatever fell in
                        // and what is left reads as ground that gave way. The pit brings its
                        // own spoil ring with it, so the rim still has a heap on it.
                        {
                            el: 'rubble',
                            x: 12,
                            y: 12,
                            w: 93,
                            h: 93,
                            n: 14
                        },
                        {
                            el: 'sinkhole',
                            x: [
                                36,
                                78
                            ],
                            y: [
                                36,
                                78
                            ]
                        }
                    ]
                }
            ]
        },
        records: {
            variants: [
                {
                    elements: [
                        {
                            el: 'building',
                            x: [
                                12,
                                18
                            ],
                            y: [
                                12,
                                18
                            ],
                            w: [
                                36,
                                42
                            ],
                            h: [
                                27,
                                33
                            ]
                        },
                        {
                            el: 'building',
                            when: {
                                tune: 'buildingScale',
                                gte: 1.15
                            },
                            x: [
                                78,
                                87
                            ],
                            y: [
                                12,
                                18
                            ],
                            w: 24,
                            h: 21
                        },
                        {
                            el: 'speckle',
                            x: 6,
                            y: 6,
                            w: 105,
                            h: 105,
                            n: 8,
                            color: 'structLight',
                            alpha: 0.8
                        }
                    ]
                },
                {
                    elements: [
                        {
                            el: 'building',
                            x: [
                                12,
                                18
                            ],
                            y: [
                                12,
                                18
                            ],
                            w: [
                                36,
                                42
                            ],
                            h: [
                                27,
                                33
                            ]
                        },
                        {
                            el: 'building',
                            x: [
                                78,
                                84
                            ],
                            y: [
                                78,
                                84
                            ],
                            w: [
                                24,
                                30
                            ],
                            h: [
                                21,
                                27
                            ]
                        },
                        {
                            el: 'building',
                            when: {
                                tune: 'buildingScale',
                                gte: 1.15
                            },
                            x: [
                                78,
                                87
                            ],
                            y: [
                                12,
                                18
                            ],
                            w: 24,
                            h: 21
                        },
                        {
                            el: 'speckle',
                            x: 6,
                            y: 6,
                            w: 105,
                            h: 105,
                            n: 8,
                            color: 'structLight',
                            alpha: 0.8
                        }
                    ]
                },
                // The two above put a hall in each corner, which leaves a road nowhere to
                // go: mirroring the layout only moves which corner is which. These two
                // range the halls along ONE edge instead, so half the tile stays open —
                // and the mirror decides which half, to suit wherever the road landed.
                // Ranged east-west, for a road crossing that way:
                {
                    elements: [
                        {
                            el: 'building',
                            x: [
                                9,
                                15
                            ],
                            y: 9,
                            w: [
                                45,
                                54
                            ],
                            h: [
                                27,
                                33
                            ]
                        },
                        {
                            el: 'building',
                            x: [
                                66,
                                72
                            ],
                            y: 9,
                            w: [
                                33,
                                39
                            ],
                            h: [
                                24,
                                30
                            ]
                        },
                        {
                            el: 'speckle',
                            x: 6,
                            y: 6,
                            w: 105,
                            h: 105,
                            n: 8,
                            color: 'structLight',
                            alpha: 0.8
                        }
                    ]
                },
                // and ranged north-south, for one crossing the other way:
                {
                    elements: [
                        {
                            el: 'building',
                            x: 9,
                            y: [
                                9,
                                15
                            ],
                            w: [
                                27,
                                33
                            ],
                            h: [
                                42,
                                48
                            ]
                        },
                        {
                            el: 'building',
                            x: 9,
                            y: [
                                66,
                                72
                            ],
                            w: [
                                24,
                                30
                            ],
                            h: [
                                33,
                                39
                            ]
                        },
                        {
                            el: 'speckle',
                            x: 6,
                            y: 6,
                            w: 105,
                            h: 105,
                            n: 8,
                            color: 'structLight',
                            alpha: 0.8
                        }
                    ]
                }
            ]
        },
        habitation: {
            variants: [
                {
                    elements: [
                        {
                            el: 'building',
                            x: [
                                9,
                                15
                            ],
                            y: [
                                9,
                                15
                            ],
                            w: [
                                30,
                                36
                            ],
                            h: [
                                24,
                                30
                            ]
                        },
                        {
                            el: 'building',
                            x: [
                                78,
                                84
                            ],
                            y: [
                                12,
                                18
                            ],
                            w: [
                                27,
                                33
                            ],
                            h: [
                                21,
                                27
                            ]
                        },
                        {
                            el: 'building',
                            x: [
                                12,
                                18
                            ],
                            y: [
                                81,
                                87
                            ],
                            w: [
                                27,
                                33
                            ],
                            h: [
                                21,
                                27
                            ]
                        },
                        {
                            el: 'building',
                            when: {
                                tune: 'buildingScale',
                                gte: 1.15
                            },
                            x: [
                                81,
                                87
                            ],
                            y: [
                                81,
                                87
                            ],
                            w: 24,
                            h: 21
                        },
                        {
                            el: 'rect',
                            repeat: 4,
                            x: [
                                78,
                                105
                            ],
                            y: [
                                81,
                                105
                            ],
                            w: 6,
                            h: 6,
                            color: 'veg1'
                        },
                        {
                            el: 'bush',
                            x: [
                                81,
                                102
                            ],
                            y: [
                                18,
                                36
                            ]
                        }
                    ]
                },
                {
                    elements: [
                        {
                            el: 'building',
                            x: [
                                9,
                                15
                            ],
                            y: [
                                9,
                                15
                            ],
                            w: [
                                42,
                                48
                            ],
                            h: [
                                36,
                                42
                            ]
                        },
                        {
                            el: 'tree',
                            x: [
                                84,
                                96
                            ],
                            y: [
                                15,
                                27
                            ],
                            r: 9
                        },
                        {
                            el: 'bush',
                            x: [
                                81,
                                102
                            ],
                            y: [
                                18,
                                36
                            ]
                        }
                    ]
                },
                // Housing is the one thing that is genuinely built in rows, so two of
                // them: one long range and a shorter one behind it, facing the other way
                // as a back street does. The gap between is the lane.
                {
                    elements: [
                        {
                            el: 'terrace',
                            x: [
                                9,
                                15
                            ],
                            y: [
                                9,
                                15
                            ],
                            w: [
                                54,
                                69
                            ],
                            h: [
                                21,
                                27
                            ]
                        },
                        {
                            el: 'terrace',
                            chance: 0.8,
                            x: [
                                15,
                                27
                            ],
                            y: [
                                69,
                                75
                            ],
                            w: [
                                42,
                                57
                            ],
                            h: [
                                21,
                                24
                            ]
                        },
                        {
                            el: 'bush',
                            x: [
                                84,
                                102
                            ],
                            y: [
                                45,
                                63
                            ]
                        }
                    ]
                },
                // and the same row stood on end, so a mirror is not the only way this
                // recipe ever runs north-south
                {
                    elements: [
                        {
                            el: 'terrace',
                            x: [
                                9,
                                15
                            ],
                            y: [
                                9,
                                15
                            ],
                            w: [
                                21,
                                27
                            ],
                            h: [
                                54,
                                69
                            ],
                            vert: 1
                        },
                        {
                            el: 'terrace',
                            chance: 0.8,
                            x: [
                                69,
                                75
                            ],
                            y: [
                                15,
                                27
                            ],
                            w: [
                                21,
                                24
                            ],
                            h: [
                                42,
                                57
                            ],
                            vert: 1
                        },
                        {
                            el: 'bush',
                            x: [
                                45,
                                63
                            ],
                            y: [
                                84,
                                102
                            ]
                        }
                    ]
                }
            ]
        },
        commerce: {
            variants: [
                {
                    elements: [
                        {
                            el: 'storefront',
                            x: [
                                12,
                                18
                            ],
                            y: [
                                9,
                                15
                            ],
                            w: [
                                54,
                                66
                            ],
                            h: [
                                27,
                                33
                            ]
                        },
                        {
                            el: 'stalls'
                        }
                    ]
                },
                {
                    elements: [
                        {
                            el: 'storefront',
                            x: [
                                12,
                                18
                            ],
                            y: [
                                9,
                                15
                            ],
                            w: [
                                54,
                                66
                            ],
                            h: [
                                27,
                                33
                            ]
                        },
                        {
                            el: 'crates',
                            x: [
                                78,
                                90
                            ],
                            y: [
                                75,
                                87
                            ],
                            cols: 2,
                            rows: 2
                        }
                    ]
                },
                // A parade: shops in a row under one roof, with the lot they served in
                // front of them. One storefront alone reads as a retail park; the row is
                // what a high street is.
                //
                // Both ways round, and both shallower than the storefronts above, because
                // this is the only thing in the recipe that fits on a tile the road runs
                // through. A carriageway swings up to EDGE_SWING off centre, so the
                // clear ground beside one is about 43 units — and a storefront is 46 to
                // 49 deep once the region's scale and its awning are on it. It does not
                // fit in either orientation, in any mirror, which left a market tile on a
                // road as bare ground and some crates. A range 27 to 35 deep clears the
                // carriageway with room to spare, and the north-south copy does the same
                // for a road running the other way, which no mirror of an east-west range
                // can do. The layout pass prefers whichever of the five keeps a structure
                // standing, so a tile with no road through it still gets its big shop.
                {
                    elements: [
                        {
                            el: 'terrace',
                            x: [
                                9,
                                15
                            ],
                            y: [
                                9,
                                12
                            ],
                            w: [
                                57,
                                72
                            ],
                            h: [
                                21,
                                27
                            ]
                        },
                        {
                            el: 'crates',
                            chance: 0.5,
                            x: [
                                15,
                                27
                            ],
                            y: [
                                78,
                                87
                            ],
                            cols: 2,
                            rows: 2
                        }
                    ]
                },
                {
                    elements: [
                        {
                            el: 'terrace',
                            x: [
                                9,
                                12
                            ],
                            y: [
                                9,
                                15
                            ],
                            w: [
                                21,
                                27
                            ],
                            h: [
                                57,
                                72
                            ],
                            vert: 1
                        },
                        {
                            el: 'crates',
                            chance: 0.5,
                            x: [
                                78,
                                87
                            ],
                            y: [
                                15,
                                27
                            ],
                            cols: 2,
                            rows: 2
                        }
                    ]
                },
                // A corner unit, for where not even a parade reaches. A bend sweeps an L
                // through the tile and leaves a quarter of it clear, which nothing that
                // has to span an axis can use — so the smallest thing this recipe can be
                // is three shops in a corner rather than no shop at all.
                {
                    elements: [
                        {
                            el: 'terrace',
                            x: [
                                9,
                                15
                            ],
                            y: [
                                9,
                                15
                            ],
                            w: [
                                24,
                                30
                            ],
                            h: [
                                18,
                                24
                            ]
                        },
                        {
                            el: 'stalls',
                            chance: 0.5
                        }
                    ]
                }
            ]
        },
        reactor: {
            elements: [
                {
                    el: 'reactorCore'
                }
            ]
        },
        // Entry and extraction. A portal is a DEVICE somebody installed and powers,
        // so it stands in a facility rather than out in the open: ranges of
        // blockwork around three sides of the aperture, a transformer feeding it,
        // and the pad itself left clear in the middle (portalPad and portalGlow
        // both draw at the tile centre, and the glow goes down last of all).
        //
        // The buildings sit in one corner-half so the layout pass can mirror them
        // clear of the track that runs up to the tile — every mirror leaves two
        // adjacent sides open, which between them covers whichever edge the road
        // arrives from.
        portal: {
            elements: [
                {
                    el: 'building',
                    x: 9,
                    y: 9,
                    w: [
                        48,
                        57
                    ],
                    h: [
                        21,
                        27
                    ]
                },
                {
                    el: 'building',
                    x: 9,
                    y: [
                        36,
                        42
                    ],
                    w: [
                        21,
                        27
                    ],
                    h: [
                        39,
                        45
                    ]
                },
                {
                    el: 'transformerPad',
                    x: [
                        84,
                        93
                    ],
                    y: [
                        12,
                        18
                    ]
                },
                {
                    el: 'crates',
                    x: [
                        78,
                        87
                    ],
                    y: [
                        72,
                        81
                    ],
                    cols: 2,
                    rows: 2
                },
                // a deck under the aperture, so it reads as installed rather than as
                // something that happened to appear in the yard
                {
                    el: 'rect',
                    x: 36,
                    y: 36,
                    w: 48,
                    h: 48,
                    color: 'structDark'
                },
                {
                    el: 'rect',
                    x: 39,
                    y: 39,
                    w: 42,
                    h: 42,
                    color: 'ground2'
                },
                {
                    el: 'portalPad'
                }
            ]
        },
        road: {
            elements: [
                // Debris on the carriageway goes down FIRST, so the frontage below covers
                // what lands on its ground instead of speckling its roofs.
                {
                    el: 'rubble',
                    x: 6,
                    y: 6,
                    w: 105,
                    h: 105,
                    n: 4
                },
                // Frontage. What makes a trunk read as a STREET rather than as a strip of
                // surfacing is the building line either side of it — and the recipe is
                // never told which way the road goes, so it puts a block against all four
                // edges and lets the roadway pick. The layout pass suppresses whatever
                // the road runs through: on a straight run that is the two edges it
                // enters and leaves by, leaving the other two facing each other across
                // the carriageway; on a bend it is the two sides it turns between,
                // leaving the outside of the corner built up. Same rule, no cases.
                //
                // Depth is set so a block stands where a road CAN reach and is dropped
                // when it does. A crossing swings up to EDGE_SWING (24) off centre, so
                // shrinking these until they always survive would leave a strip of open
                // ground between every building and the road it faces — a setback that
                // varies tile to tile and reads as waste. Deep blocks sit tight against
                // the carriageway instead, and where the road hugs one side that side's
                // block goes and the far one stands alone, which is what a street pushed
                // against a boundary actually looks like.
                //
                // The far pair is anchored at 80 rather than hard against the edge, and
                // the near pair at 8: a building is clamped 6 units short of the tile
                // edge, and the layout pass MIRRORS it, so one authored against the edge
                // is measured clamped and then drawn somewhere it is not — bigger than
                // the footprint it was cleared on, with the difference landing on the
                // road. Authored sizes are multiplied by buildingScale (1.3 at most), so
                // 80 + 24 x 1.3 = 111 keeps every one of these inside the clamp at both
                // ends of its mirror, and the two passes agree.
                //
                // Terraced, because a STREET is what this recipe is for. A free-standing
                // block set back behind a carriageway is a depot; a run of units flush
                // along it, sharing party walls, is a street, and the difference is the
                // whole reason a trunk tile exists. The run is authored to the same 8/80
                // anchors and the same depth as the blocks it replaces, so the clamp
                // arithmetic above is unchanged; only what stands on the frontage is.
                {
                    el: 'terrace',
                    chance: 0.85,
                    x: [
                        12,
                        21
                    ],
                    y: 8,
                    w: [
                        45,
                        57
                    ],
                    h: 24
                },
                {
                    el: 'terrace',
                    chance: 0.85,
                    x: [
                        12,
                        21
                    ],
                    y: 80,
                    w: [
                        45,
                        57
                    ],
                    h: 24
                },
                {
                    el: 'terrace',
                    chance: 0.85,
                    x: 8,
                    y: [
                        12,
                        21
                    ],
                    w: 24,
                    h: [
                        45,
                        57
                    ],
                    vert: 1
                },
                {
                    el: 'terrace',
                    chance: 0.85,
                    x: 80,
                    y: [
                        12,
                        21
                    ],
                    w: 24,
                    h: [
                        45,
                        57
                    ],
                    vert: 1
                },
                {
                    el: 'manhole',
                    chance: 0.5,
                    x: [
                        48,
                        72
                    ],
                    y: [
                        48,
                        72
                    ]
                },
                // Traffic is not in here: drawRoadside lays it against the carriageway off
                // the road's own samples, so it lies parallel to the road and on the
                // shoulder, on every tile the network runs through rather than only on
                // the trunk tiles this recipe draws.
                {
                    el: 'streetLamp',
                    x: {
                        pick: [
                            39,
                            78
                        ]
                    },
                    y: [
                        39,
                        81
                    ]
                }
            ]
        },
        // rest stops are untouched clearings, and they
        // sit in the greenest spots on the map (5x the region's tree density)
        water: {
            treeDensity: 5,
            elements: [
                {
                    el: 'pond'
                }
            ]
        },
        campsite: {
            treeDensity: 5,
            elements: [
                {
                    el: 'tent',
                    x: [
                        15,
                        24
                    ],
                    y: [
                        15,
                        24
                    ]
                },
                {
                    el: 'fireRing',
                    x: [
                        78,
                        90
                    ],
                    y: [
                        78,
                        90
                    ]
                },
                {
                    el: 'rect',
                    x: [
                        18,
                        30
                    ],
                    y: [
                        84,
                        96
                    ],
                    w: 18,
                    h: 6,
                    color: 'rust'
                },
                {
                    el: 'rect',
                    x: [
                        81,
                        96
                    ],
                    y: [
                        18,
                        27
                    ],
                    w: 6,
                    h: 15,
                    color: 'structDark'
                }
            ]
        },
        // Impassable because the ground itself has gone, not because something fell
        // over on it: a shaft or a rift opened here and there is no way across.
        // Collapsed slabs read as debris you could pick your way through, which is
        // exactly what these tiles are not.
        // The hole goes down LAST in every variant. Ground litter drawn over it is
        // debris hanging in mid-air above a drop; drawn under it, the hole swallows
        // whatever fell in and what survives reads as the edge of the collapse.
        // Each hole lays its own spoil around its rim afterwards.
        blocked: {
            variants: [
                {
                    elements: [
                        {
                            el: 'crack',
                            repeat: 4,
                            x: [
                                9,
                                105
                            ],
                            y: [
                                9,
                                96
                            ],
                            len: [
                                21,
                                36
                            ]
                        },
                        {
                            el: 'rubble',
                            x: 6,
                            y: 6,
                            w: 105,
                            h: 105,
                            n: 18
                        },
                        {
                            el: 'sinkhole',
                            x: [
                                51,
                                69
                            ],
                            y: [
                                51,
                                69
                            ],
                            r: [
                                33,
                                39
                            ]
                        },
                        {
                            el: 'darkWash',
                            alpha: 0.15
                        }
                    ]
                },
                {
                    elements: [
                        {
                            el: 'crack',
                            repeat: 3,
                            x: [
                                9,
                                105
                            ],
                            y: [
                                9,
                                96
                            ],
                            len: [
                                21,
                                36
                            ]
                        },
                        {
                            el: 'rubble',
                            x: 6,
                            y: 6,
                            w: 105,
                            h: 105,
                            n: 18
                        },
                        {
                            el: 'chasm',
                            x: [
                                54,
                                66
                            ],
                            y: [
                                48,
                                72
                            ],
                            len: [
                                96,
                                108
                            ],
                            r: [
                                18,
                                24
                            ]
                        },
                        {
                            el: 'darkWash',
                            alpha: 0.15
                        }
                    ]
                },
                {
                    elements: [
                        {
                            el: 'crack',
                            repeat: 3,
                            x: [
                                9,
                                105
                            ],
                            y: [
                                9,
                                96
                            ],
                            len: [
                                21,
                                36
                            ]
                        },
                        {
                            el: 'rubble',
                            x: 6,
                            y: 6,
                            w: 105,
                            h: 105,
                            n: 18
                        },
                        {
                            el: 'chasm',
                            x: [
                                48,
                                72
                            ],
                            y: [
                                54,
                                66
                            ],
                            len: [
                                96,
                                108
                            ],
                            r: [
                                18,
                                24
                            ],
                            vert: 1
                        },
                        {
                            el: 'darkWash',
                            alpha: 0.15
                        }
                    ]
                }
            ]
        }
    },
    // ===============================
    // SKILL ANCHORS
    // ===============================
    // A recipe says what kind of place a tile IS; the anchor says what the team
    // will be doing there. One per skill, chosen from the room's primary skill
    // and drawn ON TOP of the recipe — a power yard still reads as a power yard
    // and also shows its skill. Every skill is the primary of exactly four rooms
    // (see tests/data/skillBalance.test.js), so all fifteen of these are reachable.
    //
    // Same element vocabulary and same interpreter as recipes above, with two
    // differences: coordinates are PLATE-RELATIVE (0,0 is the anchor's own top
    // left, not the tile's), and w/h declare the reserved footprint, which must
    // stay within ANCHOR_MAX (24) so the anchor can never land on the connector
    // cross that joins tiles together.
    //
    // Every entry opens with an anchorPlate: it makes an anchor that overlaps a
    // roof read as apparatus installed there, which is what buys us out of doing
    // collision detection against the recipe. shape marks the faction — square
    // for Dominion, cut for Veil, round for Wilders.
    //
    // The anchor tracks the room's PRIMARY skill, not the event it will run —
    // and the two can disagree, because a room's event pool is primary plus
    // support. That is deliberate: a room runs one to four events, so keying the
    // anchor to any single one of them would mismatch the others regardless. The
    // primary is the only skill true for the whole room. (What does follow the
    // pinned event is the roof cutaway — see the environment field on events.)
    skillAnchors: {
        // ---- Dominion: systems and instrumentation ----
        'signal-relay': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24
                },
                {
                    el: 'tower',
                    x: 4,
                    y: 4
                }
            ]
        },
        'system-override': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24
                },
                {
                    el: 'rect',
                    x: 6,
                    y: 5,
                    w: 12,
                    h: 11,
                    color: 'struct'
                },
                {
                    el: 'rect',
                    x: 7,
                    y: 6,
                    w: 10,
                    h: 1,
                    color: 'structLight'
                },
                {
                    el: 'rect',
                    x: 8,
                    y: 8,
                    w: 8,
                    h: 5,
                    color: 'accent'
                },
                {
                    el: 'rect',
                    x: 11,
                    y: 16,
                    w: 2,
                    h: 5,
                    color: 'structDark'
                }
            ]
        },
        'drone-command': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24
                },
                {
                    el: 'dronePad',
                    x: 4,
                    y: 4,
                    s: 16
                }
            ]
        },
        'safeguard': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24
                },
                {
                    el: 'transformerPad',
                    x: 2,
                    y: 2
                }
            ]
        },
        'quantum-scan': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24
                },
                {
                    el: 'dish',
                    x: 12,
                    y: 12,
                    r: 7,
                    rings: 1,
                    arm: 1,
                    color: 'accent'
                }
            ]
        },
        // ---- Veil: access and concealment ----
        'lock-breach': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24,
                    shape: 'cut'
                },
                {
                    el: 'rect',
                    x: 4,
                    y: 4,
                    w: 16,
                    h: 16,
                    color: 'metal'
                },
                {
                    el: 'rect',
                    x: 4,
                    y: 4,
                    w: 16,
                    h: 1,
                    color: 'structLight'
                },
                {
                    el: 'rect',
                    x: 4,
                    y: 19,
                    w: 16,
                    h: 1,
                    color: 'structDark'
                },
                // hazard stripe: a bare metal square reads as nothing from above, and
                // this is the one thing that separates a sealed door from a floor plate
                {
                    el: 'rect',
                    x: 4,
                    y: 5,
                    w: 16,
                    h: 2,
                    color: 'accent',
                    alpha: 0.85
                },
                {
                    el: 'manhole',
                    x: 12,
                    y: 13
                },
                {
                    el: 'rect',
                    x: 3,
                    y: 8,
                    w: 2,
                    h: 3,
                    color: 'structDark'
                },
                {
                    el: 'rect',
                    x: 3,
                    y: 15,
                    w: 2,
                    h: 3,
                    color: 'structDark'
                }
            ]
        },
        'stealth-transit': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24,
                    shape: 'cut'
                },
                {
                    el: 'rect',
                    x: 5,
                    y: 5,
                    w: 3,
                    h: 14,
                    color: 'structDark'
                },
                {
                    el: 'rect',
                    x: 16,
                    y: 5,
                    w: 3,
                    h: 14,
                    color: 'structDark'
                },
                {
                    el: 'rect',
                    x: 5,
                    y: 6,
                    w: 3,
                    h: 1,
                    color: 'metal'
                },
                {
                    el: 'rect',
                    x: 16,
                    y: 6,
                    w: 3,
                    h: 1,
                    color: 'metal'
                },
                {
                    el: 'rect',
                    x: 8,
                    y: 11,
                    w: 8,
                    h: 2,
                    color: 'accent',
                    alpha: 0.7
                }
            ]
        },
        'echo-trace': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24,
                    shape: 'cut'
                },
                {
                    el: 'dish',
                    x: 12,
                    y: 12,
                    r: 3,
                    rings: 2,
                    color: 'accent'
                }
            ]
        },
        'signal-mask': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24,
                    shape: 'cut'
                },
                {
                    el: 'rect',
                    x: 6,
                    y: 9,
                    w: 12,
                    h: 9,
                    color: 'struct'
                },
                {
                    el: 'rect',
                    x: 6,
                    y: 9,
                    w: 12,
                    h: 1,
                    color: 'structLight'
                },
                {
                    el: 'rect',
                    x: 11,
                    y: 2,
                    w: 1,
                    h: 8,
                    color: 'metal'
                },
                {
                    el: 'speckle',
                    x: 3,
                    y: 3,
                    w: 18,
                    h: 18,
                    n: 10,
                    color: 'accent',
                    alpha: 0.35
                }
            ]
        },
        'transit-anchor': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24,
                    shape: 'cut'
                },
                {
                    el: 'crack',
                    x: 4,
                    y: 6,
                    len: 14
                },
                {
                    el: 'rect',
                    x: 4,
                    y: 10,
                    w: 16,
                    h: 5,
                    color: 'rust'
                },
                {
                    el: 'rect',
                    x: 4,
                    y: 10,
                    w: 16,
                    h: 1,
                    color: 'structLight'
                },
                {
                    el: 'rect',
                    x: 4,
                    y: 9,
                    w: 2,
                    h: 7,
                    color: 'metal'
                },
                {
                    el: 'rect',
                    x: 18,
                    y: 9,
                    w: 2,
                    h: 7,
                    color: 'metal'
                }
            ]
        },
        // ---- Wilders: growth, salvage and containment ----
        'reclamation': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24,
                    shape: 'round'
                },
                {
                    el: 'tank',
                    x: 12,
                    y: 13,
                    r: 8
                },
                {
                    el: 'foliage',
                    x: 16,
                    y: 8,
                    size: 3
                }
            ]
        },
        'growth-control': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24,
                    shape: 'round'
                },
                {
                    el: 'rect',
                    x: 4,
                    y: 5,
                    w: 16,
                    h: 14,
                    color: 'structDark'
                },
                {
                    el: 'rect',
                    x: 5,
                    y: 6,
                    w: 14,
                    h: 12,
                    color: 'ground1'
                },
                {
                    el: 'rect',
                    x: 6,
                    y: 8,
                    w: 12,
                    h: 2,
                    color: 'veg1'
                },
                {
                    el: 'rect',
                    x: 6,
                    y: 12,
                    w: 12,
                    h: 2,
                    color: 'veg2'
                },
                {
                    el: 'rect',
                    x: 6,
                    y: 16,
                    w: 12,
                    h: 1,
                    color: 'veg1'
                }
            ]
        },
        'wild-influence': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24,
                    shape: 'round'
                },
                {
                    el: 'dish',
                    x: 12,
                    y: 13,
                    r: 7,
                    rings: 1,
                    color: 'veg2'
                },
                {
                    el: 'rect',
                    x: 11,
                    y: 2,
                    w: 2,
                    h: 5,
                    color: 'structDark'
                }
            ]
        },
        'bio-shield': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24,
                    shape: 'round'
                },
                {
                    el: 'pipeline',
                    x: 2,
                    y: 6,
                    w: 20
                },
                {
                    el: 'tank',
                    x: 15,
                    y: 15,
                    r: 6
                }
            ]
        },
        'containment': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24,
                    shape: 'round'
                },
                {
                    el: 'fence',
                    x: 2,
                    y: 2,
                    w: 20,
                    h: 20
                },
                {
                    el: 'barrier',
                    x: 3,
                    y: 17
                }
            ]
        }
    }
};
var $979b99378be707cd$export$ded4d2beb9be271a = [
    {
        target: "signal-repeater-pack",
        station: "workbench",
        inputs: [
            {
                id: "circuit-board",
                qty: 1
            },
            {
                id: "logic-ribbon-cable",
                qty: 1
            },
            {
                id: "glass-lens",
                qty: 1
            },
            {
                id: "precision-servo-gear",
                qty: 1
            },
            {
                id: "signal-processor-core",
                qty: 1
            },
            {
                id: "encrypted-transceiver-chip",
                qty: 1
            }
        ]
    },
    {
        target: "control-override-kit",
        station: "workbench",
        inputs: [
            {
                id: "aluminum-shell",
                qty: 1
            },
            {
                id: "power-cell-casing",
                qty: 1
            },
            {
                id: "rubber-seal",
                qty: 1
            },
            {
                id: "iron-frame",
                qty: 1
            },
            {
                id: "override-datakey",
                qty: 1
            },
            {
                id: "voltage-regulator-unit",
                qty: 1
            }
        ]
    },
    {
        target: "operator-link-harness",
        station: "workbench",
        inputs: [
            {
                id: "copper-wire",
                qty: 1
            },
            {
                id: "circuit-board",
                qty: 1
            },
            {
                id: "ceramic-insulator",
                qty: 1
            },
            {
                id: "power-regulation-unit",
                qty: 1
            },
            {
                id: "signal-sync-crystal",
                qty: 1
            }
        ]
    },
    {
        target: "stability-coupler",
        station: "workbench",
        inputs: [
            {
                id: "aluminum-shell",
                qty: 1
            },
            {
                id: "relay-antenna-strut",
                qty: 1
            },
            {
                id: "logic-ribbon-cable",
                qty: 1
            },
            {
                id: "sealed-hydraulic-pump",
                qty: 1
            },
            {
                id: "drone-gyro-assembly",
                qty: 1
            },
            {
                id: "signal-sync-crystal",
                qty: 1
            }
        ]
    },
    {
        target: "spectral-survey-scope",
        station: "workbench",
        inputs: [
            {
                id: "composite-casing",
                qty: 1
            },
            {
                id: "steel-plates",
                qty: 1
            },
            {
                id: "iron-frame",
                qty: 1
            },
            {
                id: "copper-wire",
                qty: 1
            },
            {
                id: "precision-servo-gear",
                qty: 1
            },
            {
                id: "radiation-sensor-module",
                qty: 1
            }
        ]
    },
    {
        target: "harvesting-gauntlet",
        station: "workbench",
        inputs: [
            {
                id: "tanned-gut-cord",
                qty: 1
            },
            {
                id: "fabric-mesh",
                qty: 1
            },
            {
                id: "canvas-fiber",
                qty: 1
            },
            {
                id: "medical-stimulant-cartridge",
                qty: 1
            },
            {
                id: "high-torque-motor-core",
                qty: 1
            }
        ]
    },
    {
        target: "growth-induction-pod",
        station: "workbench",
        inputs: [
            {
                id: "resin-casing",
                qty: 1
            },
            {
                id: "spore-felt-padding",
                qty: 1
            },
            {
                id: "polymer-tubing",
                qty: 1
            },
            {
                id: "nutrient-catalyst-ampoule",
                qty: 1
            },
            {
                id: "symbiotic-culture-vial",
                qty: 1
            },
            {
                id: "high-torque-motor-core",
                qty: 1
            }
        ]
    },
    {
        target: "pheromone-relay-belt",
        station: "workbench",
        inputs: [
            {
                id: "resin-casing",
                qty: 1
            },
            {
                id: "fabric-mesh",
                qty: 1
            },
            {
                id: "canvas-fiber",
                qty: 1
            },
            {
                id: "pheromone-distiller-coil",
                qty: 1
            },
            {
                id: "bio-conductive-mesh",
                qty: 1
            }
        ]
    },
    {
        target: "respirator-webbing",
        station: "workbench",
        inputs: [
            {
                id: "leather-straps",
                qty: 1
            },
            {
                id: "tanned-gut-cord",
                qty: 1
            },
            {
                id: "chitin-plate",
                qty: 1
            },
            {
                id: "pheromone-distiller-coil",
                qty: 1
            },
            {
                id: "synthetic-pheromone-capsule",
                qty: 1
            }
        ]
    },
    {
        target: "hazard-recovery-satchel",
        station: "workbench",
        inputs: [
            {
                id: "leather-straps",
                qty: 1
            },
            {
                id: "polymer-tubing",
                qty: 1
            },
            {
                id: "chitin-plate",
                qty: 1
            },
            {
                id: "fabric-mesh",
                qty: 1
            },
            {
                id: "nutrient-gel-pack",
                qty: 1
            },
            {
                id: "containment-gel-lining",
                qty: 1
            }
        ]
    },
    {
        target: "resonant-survey-array",
        station: "workbench",
        inputs: [
            {
                id: "micro-bearing-set",
                qty: 1
            },
            {
                id: "brass-fittings",
                qty: 1
            },
            {
                id: "carbon-housing",
                qty: 1
            },
            {
                id: "plastic-casing",
                qty: 1
            },
            {
                id: "phase-lens-array",
                qty: 1
            },
            {
                id: "data-storage-crystal",
                qty: 1
            }
        ]
    },
    {
        target: "lockpulse-breach-kit",
        station: "workbench",
        inputs: [
            {
                id: "etched-keyplate-blank",
                qty: 1
            },
            {
                id: "matte-coating-compound",
                qty: 1
            },
            {
                id: "acoustic-foam-wafer",
                qty: 1
            },
            {
                id: "ultrasonic-sensor-grid",
                qty: 1
            },
            {
                id: "micro-servo-drill",
                qty: 1
            },
            {
                id: "precision-chrono-core",
                qty: 1
            }
        ]
    },
    {
        target: "silent-step-pads",
        station: "workbench",
        inputs: [
            {
                id: "optic-fiber-spool",
                qty: 1
            },
            {
                id: "matte-coating-compound",
                qty: 1
            },
            {
                id: "brass-fittings",
                qty: 1
            },
            {
                id: "thermal-polarizer-film",
                qty: 1
            },
            {
                id: "precision-chrono-core",
                qty: 1
            }
        ]
    },
    {
        target: "trace-disruptor-band",
        station: "workbench",
        inputs: [
            {
                id: "micro-bearing-set",
                qty: 1
            },
            {
                id: "etched-keyplate-blank",
                qty: 1
            },
            {
                id: "acoustic-foam-wafer",
                qty: 1
            },
            {
                id: "vibration-dampener",
                qty: 1
            },
            {
                id: "em-interference-chip",
                qty: 1
            }
        ]
    },
    {
        target: "anchor-resonator",
        station: "workbench",
        inputs: [
            {
                id: "plastic-casing",
                qty: 1
            },
            {
                id: "optic-fiber-spool",
                qty: 1
            },
            {
                id: "ghost-signal-modulator",
                qty: 1
            },
            {
                id: "phase-lens-array",
                qty: 1
            },
            {
                id: "harmonic-stabilizer-core",
                qty: 1
            }
        ]
    },
    {
        target: "data-cache-drive",
        station: "workbench",
        inputs: [
            {
                id: "steel-plates",
                qty: 1
            },
            {
                id: "rubber-seal",
                qty: 1
            },
            {
                id: "plastic-casing",
                qty: 1
            },
            {
                id: "signal-processor-core",
                qty: 1
            },
            {
                id: "circuit-board",
                qty: 1
            },
            {
                id: "encrypted-transceiver-chip",
                qty: 1
            }
        ]
    },
    {
        target: "relic-resonance-tuner",
        station: "workbench",
        inputs: [
            {
                id: "copper-wire",
                qty: 1
            },
            {
                id: "brass-fittings",
                qty: 1
            },
            {
                id: "iron-frame",
                qty: 1
            },
            {
                id: "ultrasonic-sensor-grid",
                qty: 1
            },
            {
                id: "signal-sync-crystal",
                qty: 1
            }
        ]
    },
    {
        target: "hazard-lens-visor",
        station: "workbench",
        inputs: [
            {
                id: "glass-lens",
                qty: 1
            },
            {
                id: "steel-plates",
                qty: 1
            },
            {
                id: "plastic-casing",
                qty: 1
            },
            {
                id: "thermal-polarizer-film",
                qty: 1
            },
            {
                id: "radiation-sensor-module",
                qty: 1
            }
        ]
    },
    {
        target: "recovery-injector",
        station: "workbench",
        inputs: [
            {
                id: "plastic-casing",
                qty: 1
            },
            {
                id: "polymer-tubing",
                qty: 1
            },
            {
                id: "rubber-seal",
                qty: 1
            },
            {
                id: "medical-stimulant-cartridge",
                qty: 1
            },
            {
                id: "bio-conductive-mesh",
                qty: 1
            }
        ]
    },
    {
        target: "contract-beacon",
        station: "workbench",
        inputs: [
            {
                id: "aluminum-shell",
                qty: 1
            },
            {
                id: "circuit-board",
                qty: 1
            },
            {
                id: "copper-wire",
                qty: 1
            },
            {
                id: "signal-processor-core",
                qty: 1
            },
            {
                id: "signal-sync-crystal",
                qty: 1
            }
        ]
    },
    {
        target: "sync-regulator-watch",
        station: "workbench",
        inputs: [
            {
                id: "brass-fittings",
                qty: 1
            },
            {
                id: "glass-lens",
                qty: 1
            },
            {
                id: "precision-servo-gear",
                qty: 1
            },
            {
                id: "precision-chrono-core",
                qty: 1
            }
        ]
    },
    {
        target: "auto-stabilizer-pack",
        station: "workbench",
        inputs: [
            {
                id: "steel-plates",
                qty: 1
            },
            {
                id: "polymer-tubing",
                qty: 1
            },
            {
                id: "fabric-mesh",
                qty: 1
            },
            {
                id: "precision-servo-gear",
                qty: 1
            },
            {
                id: "sealed-hydraulic-pump",
                qty: 1
            },
            {
                id: "harmonic-stabilizer-core",
                qty: 1
            }
        ]
    },
    {
        target: "training-node-deck",
        station: "workbench",
        inputs: [
            {
                id: "plastic-casing",
                qty: 1
            },
            {
                id: "copper-wire",
                qty: 1
            },
            {
                id: "circuit-board",
                qty: 1
            },
            {
                id: "signal-processor-core",
                qty: 1
            },
            {
                id: "data-storage-crystal",
                qty: 1
            }
        ]
    },
    {
        target: "crosslink-amplifier",
        station: "workbench",
        inputs: [
            {
                id: "copper-wire",
                qty: 1
            },
            {
                id: "aluminum-shell",
                qty: 1
            },
            {
                id: "carbon-housing",
                qty: 1
            },
            {
                id: "signal-processor-core",
                qty: 1
            },
            {
                id: "signal-sync-crystal",
                qty: 1
            }
        ]
    },
    {
        target: "material-extractor",
        station: "workbench",
        inputs: [
            {
                id: "steel-plates",
                qty: 1
            },
            {
                id: "plastic-casing",
                qty: 1
            },
            {
                id: "iron-frame",
                qty: 1
            },
            {
                id: "precision-servo-gear",
                qty: 1
            },
            {
                id: "high-torque-motor-core",
                qty: 1
            }
        ]
    },
    {
        target: "salvage-compression-rig",
        station: "workbench",
        inputs: [
            {
                id: "steel-plates",
                qty: 1
            },
            {
                id: "iron-frame",
                qty: 1
            },
            {
                id: "rubber-seal",
                qty: 1
            },
            {
                id: "sealed-hydraulic-pump",
                qty: 1
            },
            {
                id: "high-torque-motor-core",
                qty: 1
            }
        ]
    },
    {
        target: "memory-crystal-shard",
        station: "workbench",
        inputs: [
            {
                id: "glass-lens",
                qty: 1
            },
            {
                id: "resin-casing",
                qty: 1
            },
            {
                id: "circuit-board",
                qty: 1
            },
            {
                id: "data-storage-crystal",
                qty: 1
            }
        ]
    }
];
var $979b99378be707cd$export$12c2125da4fa007 = [
    {
        target: "relay-stabilizer-gel-pack",
        station: "lab",
        inputs: [
            {
                id: "logic-ribbon-cable",
                qty: 1
            },
            {
                id: "circuit-board",
                qty: 1
            },
            {
                id: "precision-servo-gear",
                qty: 1
            },
            {
                id: "power-regulation-unit",
                qty: 1
            }
        ]
    },
    {
        target: "biofiber-splice-kit",
        station: "lab",
        inputs: [
            {
                id: "logic-ribbon-cable",
                qty: 1
            },
            {
                id: "copper-wire",
                qty: 1
            },
            {
                id: "encrypted-transceiver-chip",
                qty: 1
            }
        ]
    },
    {
        target: "noise-floor-buffer-pack",
        station: "lab",
        inputs: [
            {
                id: "circuit-board",
                qty: 1
            },
            {
                id: "logic-ribbon-cable",
                qty: 1
            },
            {
                id: "encrypted-transceiver-chip",
                qty: 1
            }
        ]
    },
    {
        target: "multi-node-override-cart",
        station: "lab",
        inputs: [
            {
                id: "aluminum-shell",
                qty: 1
            },
            {
                id: "signal-processor-core",
                qty: 1
            },
            {
                id: "override-datakey",
                qty: 1
            }
        ]
    },
    {
        target: "surge-damping-couplers",
        station: "lab",
        inputs: [
            {
                id: "aluminum-shell",
                qty: 2
            },
            {
                id: "ceramic-insulator",
                qty: 1
            },
            {
                id: "signal-processor-core",
                qty: 1
            }
        ]
    },
    {
        target: "decoy-traffic-cartridge",
        station: "lab",
        inputs: [
            {
                id: "power-cell-casing",
                qty: 1
            },
            {
                id: "composite-casing",
                qty: 1
            },
            {
                id: "voltage-regulator-unit",
                qty: 1
            }
        ]
    },
    {
        target: "swarm-sync-beacon-cart",
        station: "lab",
        inputs: [
            {
                id: "copper-wire",
                qty: 2
            },
            {
                id: "circuit-board",
                qty: 1
            },
            {
                id: "drone-gyro-assembly",
                qty: 1
            }
        ]
    },
    {
        target: "overgrowth-lidar-pack",
        station: "lab",
        inputs: [
            {
                id: "ceramic-insulator",
                qty: 1
            },
            {
                id: "power-cell-casing",
                qty: 1
            },
            {
                id: "power-regulation-unit",
                qty: 1
            },
            {
                id: "override-datakey",
                qty: 1
            }
        ]
    },
    {
        target: "quiet-sonar-cartridge",
        station: "lab",
        inputs: [
            {
                id: "copper-wire",
                qty: 1
            },
            {
                id: "circuit-board",
                qty: 1
            },
            {
                id: "drone-gyro-assembly",
                qty: 1
            },
            {
                id: "power-regulation-unit",
                qty: 1
            }
        ]
    },
    {
        target: "rapid-grounding-spikes",
        station: "lab",
        inputs: [
            {
                id: "aluminum-shell",
                qty: 1
            },
            {
                id: "relay-antenna-strut",
                qty: 1
            },
            {
                id: "radiation-sensor-module",
                qty: 1
            }
        ]
    },
    {
        target: "vent-cycler-pack",
        station: "lab",
        inputs: [
            {
                id: "logic-ribbon-cable",
                qty: 1
            },
            {
                id: "sealed-hydraulic-pump",
                qty: 1
            },
            {
                id: "drone-gyro-assembly",
                qty: 1
            }
        ]
    },
    {
        target: "cutoff-line-kit",
        station: "lab",
        inputs: [
            {
                id: "composite-casing",
                qty: 1
            },
            {
                id: "aluminum-shell",
                qty: 1
            },
            {
                id: "relay-antenna-strut",
                qty: 1
            },
            {
                id: "sealed-hydraulic-pump",
                qty: 1
            }
        ]
    },
    {
        target: "scan-link-bridge",
        station: "lab",
        inputs: [
            {
                id: "ceramic-insulator",
                qty: 1
            },
            {
                id: "precision-servo-gear",
                qty: 1
            },
            {
                id: "radiation-sensor-module",
                qty: 1
            }
        ]
    },
    {
        target: "dual-spectrum-cartridge",
        station: "lab",
        inputs: [
            {
                id: "composite-casing",
                qty: 1
            },
            {
                id: "precision-servo-gear",
                qty: 1
            },
            {
                id: "radiation-sensor-module",
                qty: 1
            }
        ]
    },
    {
        target: "residual-current-probe-kit",
        station: "lab",
        inputs: [
            {
                id: "copper-wire",
                qty: 1
            },
            {
                id: "relay-antenna-strut",
                qty: 1
            },
            {
                id: "radiation-sensor-module",
                qty: 1
            }
        ]
    },
    {
        target: "harvest-sync-brace-pack",
        station: "lab",
        inputs: [
            {
                id: "tanned-gut-cord",
                qty: 2
            },
            {
                id: "canvas-fiber",
                qty: 1
            },
            {
                id: "nutrient-gel-pack",
                qty: 1
            }
        ]
    },
    {
        target: "fast-filter-plenum-cart",
        station: "lab",
        inputs: [
            {
                id: "tanned-gut-cord",
                qty: 1
            },
            {
                id: "medical-stimulant-cartridge",
                qty: 1
            },
            {
                id: "nutrient-catalyst-ampoule",
                qty: 1
            }
        ]
    },
    {
        target: "micro-mist-emitter",
        station: "lab",
        inputs: [
            {
                id: "fabric-mesh",
                qty: 1
            },
            {
                id: "canvas-fiber",
                qty: 1
            },
            {
                id: "nutrient-gel-pack",
                qty: 1
            },
            {
                id: "medical-stimulant-cartridge",
                qty: 1
            }
        ]
    },
    {
        target: "rapid-brace-binder",
        station: "lab",
        inputs: [
            {
                id: "spore-felt-padding",
                qty: 2
            },
            {
                id: "polymer-tubing",
                qty: 1
            },
            {
                id: "symbiotic-culture-vial",
                qty: 1
            }
        ]
    },
    {
        target: "light-channel-films",
        station: "lab",
        inputs: [
            {
                id: "spore-felt-padding",
                qty: 1
            },
            {
                id: "nutrient-catalyst-ampoule",
                qty: 1
            },
            {
                id: "symbiotic-culture-vial",
                qty: 1
            }
        ]
    },
    {
        target: "root-guidance-stakes",
        station: "lab",
        inputs: [
            {
                id: "resin-casing",
                qty: 2
            },
            {
                id: "chitin-plate",
                qty: 1
            },
            {
                id: "nutrient-catalyst-ampoule",
                qty: 1
            }
        ]
    },
    {
        target: "breath-sync-strips",
        station: "lab",
        inputs: [
            {
                id: "fabric-mesh",
                qty: 1
            },
            {
                id: "synthetic-pheromone-capsule",
                qty: 1
            }
        ]
    },
    {
        target: "chorus-diffuser-ampoule",
        station: "lab",
        inputs: [
            {
                id: "canvas-fiber",
                qty: 1
            },
            {
                id: "polymer-tubing",
                qty: 1
            },
            {
                id: "synthetic-pheromone-capsule",
                qty: 1
            }
        ]
    },
    {
        target: "scent-dampening-salve",
        station: "lab",
        inputs: [
            {
                id: "resin-casing",
                qty: 1
            },
            {
                id: "pheromone-distiller-coil",
                qty: 1
            },
            {
                id: "bio-conductive-mesh",
                qty: 1
            }
        ]
    },
    {
        target: "reactive-gel-patch",
        station: "lab",
        inputs: [
            {
                id: "tanned-gut-cord",
                qty: 1
            },
            {
                id: "adaptive-filter-membrane",
                qty: 1
            },
            {
                id: "containment-gel-lining",
                qty: 1
            }
        ]
    },
    {
        target: "enzyme-swap-kit",
        station: "lab",
        inputs: [
            {
                id: "spore-felt-padding",
                qty: 1
            },
            {
                id: "pheromone-distiller-coil",
                qty: 1
            },
            {
                id: "containment-gel-lining",
                qty: 1
            }
        ]
    },
    {
        target: "surface-tuning-spray",
        station: "lab",
        inputs: [
            {
                id: "leather-straps",
                qty: 1
            },
            {
                id: "adaptive-filter-membrane",
                qty: 1
            },
            {
                id: "containment-gel-lining",
                qty: 1
            }
        ]
    },
    {
        target: "hardcase-quickframe-kit",
        station: "lab",
        inputs: [
            {
                id: "chitin-plate",
                qty: 4
            },
            {
                id: "fabric-mesh",
                qty: 1
            },
            {
                id: "leather-straps",
                qty: 1
            }
        ]
    },
    {
        target: "pod-starter-seeds",
        station: "lab",
        inputs: [
            {
                id: "nutrient-gel-pack",
                qty: 1
            },
            {
                id: "adaptive-filter-membrane",
                qty: 1
            }
        ]
    },
    {
        target: "recovery-pod-capsules",
        station: "lab",
        inputs: [
            {
                id: "nutrient-gel-pack",
                qty: 1
            },
            {
                id: "adaptive-filter-membrane",
                qty: 1
            }
        ]
    },
    {
        target: "relay-bridge-link-cart",
        station: "lab",
        inputs: [
            {
                id: "micro-bearing-set",
                qty: 1
            },
            {
                id: "carbon-housing",
                qty: 1
            },
            {
                id: "data-storage-crystal",
                qty: 1
            }
        ]
    },
    {
        target: "bio-pulse-amplifier-pack",
        station: "lab",
        inputs: [
            {
                id: "micro-bearing-set",
                qty: 1
            },
            {
                id: "phase-lens-array",
                qty: 1
            },
            {
                id: "data-storage-crystal",
                qty: 1
            }
        ]
    },
    {
        target: "map-cache-sync-cart",
        station: "lab",
        inputs: [
            {
                id: "brass-fittings",
                qty: 1
            },
            {
                id: "carbon-housing",
                qty: 1
            },
            {
                id: "data-storage-crystal",
                qty: 1
            }
        ]
    },
    {
        target: "micro-torque-paste",
        station: "lab",
        inputs: [
            {
                id: "etched-keyplate-blank",
                qty: 1
            },
            {
                id: "ultrasonic-sensor-grid",
                qty: 1
            },
            {
                id: "micro-servo-drill",
                qty: 1
            }
        ]
    },
    {
        target: "quiet-seal-injector",
        station: "lab",
        inputs: [
            {
                id: "etched-keyplate-blank",
                qty: 1
            },
            {
                id: "ultrasonic-sensor-grid",
                qty: 1
            },
            {
                id: "precision-chrono-core",
                qty: 1
            }
        ]
    },
    {
        target: "decoy-pulse-cartridge",
        station: "lab",
        inputs: [
            {
                id: "optic-fiber-spool",
                qty: 1
            },
            {
                id: "micro-servo-drill",
                qty: 1
            },
            {
                id: "precision-chrono-core",
                qty: 1
            }
        ]
    },
    {
        target: "route-shadow-taggers",
        station: "lab",
        inputs: [
            {
                id: "matte-coating-compound",
                qty: 2
            },
            {
                id: "brass-fittings",
                qty: 1
            },
            {
                id: "thermal-polarizer-film",
                qty: 1
            }
        ]
    },
    {
        target: "low-shine-veil-pack",
        station: "lab",
        inputs: [
            {
                id: "carbon-housing",
                qty: 1
            },
            {
                id: "vibration-dampener",
                qty: 1
            },
            {
                id: "thermal-polarizer-film",
                qty: 1
            }
        ]
    },
    {
        target: "pace-sync-patches",
        station: "lab",
        inputs: [
            {
                id: "optic-fiber-spool",
                qty: 1
            },
            {
                id: "matte-coating-compound",
                qty: 1
            },
            {
                id: "em-interference-chip",
                qty: 1
            }
        ]
    },
    {
        target: "auth-spoof-keycard",
        station: "lab",
        inputs: [
            {
                id: "micro-bearing-set",
                qty: 1
            },
            {
                id: "harmonic-stabilizer-core",
                qty: 1
            }
        ]
    },
    {
        target: "thermal-scent-ampoule",
        station: "lab",
        inputs: [
            {
                id: "ghost-signal-modulator",
                qty: 1
            },
            {
                id: "vibration-dampener",
                qty: 1
            }
        ]
    },
    {
        target: "temp-log-writer-cart",
        station: "lab",
        inputs: [
            {
                id: "acoustic-foam-wafer",
                qty: 1
            },
            {
                id: "em-interference-chip",
                qty: 1
            }
        ]
    },
    {
        target: "quickset-anchor-rods",
        station: "lab",
        inputs: [
            {
                id: "plastic-casing",
                qty: 1
            },
            {
                id: "acoustic-foam-wafer",
                qty: 1
            },
            {
                id: "harmonic-stabilizer-core",
                qty: 1
            }
        ]
    },
    {
        target: "timing-pulse-tag",
        station: "lab",
        inputs: [
            {
                id: "brass-fittings",
                qty: 1
            },
            {
                id: "phase-lens-array",
                qty: 1
            },
            {
                id: "harmonic-stabilizer-core",
                qty: 1
            }
        ]
    },
    {
        target: "scan-cache-array-cart",
        station: "lab",
        inputs: [
            {
                id: "plastic-casing",
                qty: 1
            },
            {
                id: "ghost-signal-modulator",
                qty: 1
            },
            {
                id: "harmonic-stabilizer-core",
                qty: 1
            }
        ]
    },
    {
        target: "precision-mast-calibrator",
        station: "lab",
        inputs: [
            {
                id: "logic-ribbon-cable",
                qty: 8
            },
            {
                id: "signal-processor-core",
                qty: 1
            },
            {
                id: "encrypted-transceiver-chip",
                qty: 2
            }
        ]
    },
    {
        target: "biofiber-manifold",
        station: "lab",
        inputs: [
            {
                id: "circuit-board",
                qty: 4
            },
            {
                id: "logic-ribbon-cable",
                qty: 1
            },
            {
                id: "encrypted-transceiver-chip",
                qty: 3
            }
        ]
    },
    {
        target: "adaptive-noise-gate",
        station: "lab",
        inputs: [
            {
                id: "copper-wire",
                qty: 2
            },
            {
                id: "circuit-board",
                qty: 1
            },
            {
                id: "encrypted-transceiver-chip",
                qty: 3
            }
        ]
    },
    {
        target: "multi-handshake-router",
        station: "lab",
        inputs: [
            {
                id: "power-cell-casing",
                qty: 3
            },
            {
                id: "override-datakey",
                qty: 2
            },
            {
                id: "voltage-regulator-unit",
                qty: 1
            },
            {
                id: "encrypted-transceiver-chip",
                qty: 1
            }
        ]
    },
    {
        target: "surge-buffer-backplane",
        station: "lab",
        inputs: [
            {
                id: "aluminum-shell",
                qty: 4
            },
            {
                id: "ceramic-insulator",
                qty: 4
            },
            {
                id: "signal-processor-core",
                qty: 1
            },
            {
                id: "voltage-regulator-unit",
                qty: 1
            }
        ]
    },
    {
        target: "credential-spoof-matrix",
        station: "lab",
        inputs: [
            {
                id: "power-cell-casing",
                qty: 2
            },
            {
                id: "composite-casing",
                qty: 1
            },
            {
                id: "voltage-regulator-unit",
                qty: 2
            },
            {
                id: "encrypted-transceiver-chip",
                qty: 1
            }
        ]
    },
    {
        target: "swarm-route-controller",
        station: "lab",
        inputs: [
            {
                id: "ceramic-insulator",
                qty: 1
            },
            {
                id: "power-cell-casing",
                qty: 1
            },
            {
                id: "power-regulation-unit",
                qty: 2
            },
            {
                id: "signal-sync-crystal",
                qty: 1
            }
        ]
    },
    {
        target: "overgrowth-nav-suite",
        station: "lab",
        inputs: [
            {
                id: "copper-wire",
                qty: 2
            },
            {
                id: "circuit-board",
                qty: 1
            },
            {
                id: "override-datakey",
                qty: 1
            },
            {
                id: "drone-gyro-assembly",
                qty: 1
            }
        ]
    },
    {
        target: "quiet-sonar-array",
        station: "lab",
        inputs: [
            {
                id: "ceramic-insulator",
                qty: 2
            },
            {
                id: "power-cell-casing",
                qty: 1
            },
            {
                id: "copper-wire",
                qty: 1
            },
            {
                id: "power-regulation-unit",
                qty: 1
            }
        ]
    },
    {
        target: "auto-ground-bus",
        station: "lab",
        inputs: [
            {
                id: "aluminum-shell",
                qty: 6
            },
            {
                id: "relay-antenna-strut",
                qty: 3
            },
            {
                id: "logic-ribbon-cable",
                qty: 2
            },
            {
                id: "signal-sync-crystal",
                qty: 1
            }
        ]
    },
    {
        target: "cycler-governor",
        station: "lab",
        inputs: [
            {
                id: "composite-casing",
                qty: 3
            },
            {
                id: "aluminum-shell",
                qty: 1
            },
            {
                id: "sealed-hydraulic-pump",
                qty: 2
            },
            {
                id: "drone-gyro-assembly",
                qty: 1
            }
        ]
    },
    {
        target: "hardline-junction-box",
        station: "lab",
        inputs: [
            {
                id: "relay-antenna-strut",
                qty: 4
            },
            {
                id: "logic-ribbon-cable",
                qty: 4
            },
            {
                id: "composite-casing",
                qty: 2
            },
            {
                id: "sealed-hydraulic-pump",
                qty: 1
            }
        ]
    },
    {
        target: "scan-link-backbone",
        station: "lab",
        inputs: [
            {
                id: "iron-frame",
                qty: 2
            },
            {
                id: "precision-servo-gear",
                qty: 2
            },
            {
                id: "radiation-sensor-module",
                qty: 2
            }
        ]
    },
    {
        target: "dual-spectrum-integrator",
        station: "lab",
        inputs: [
            {
                id: "relay-antenna-strut",
                qty: 2
            },
            {
                id: "ceramic-insulator",
                qty: 2
            },
            {
                id: "radiation-sensor-module",
                qty: 2
            }
        ]
    },
    {
        target: "low-current-amplifier",
        station: "lab",
        inputs: [
            {
                id: "composite-casing",
                qty: 8
            },
            {
                id: "steel-plates",
                qty: 1
            },
            {
                id: "radiation-sensor-module",
                qty: 2
            }
        ]
    },
    {
        target: "harvest-flight-controller",
        station: "lab",
        inputs: [
            {
                id: "tanned-gut-cord",
                qty: 2
            },
            {
                id: "canvas-fiber",
                qty: 2
            },
            {
                id: "medical-stimulant-cartridge",
                qty: 1
            },
            {
                id: "high-torque-motor-core",
                qty: 1
            }
        ]
    },
    {
        target: "fungal-flow-regulator",
        station: "lab",
        inputs: [
            {
                id: "tanned-gut-cord",
                qty: 3
            },
            {
                id: "fabric-mesh",
                qty: 1
            },
            {
                id: "medical-stimulant-cartridge",
                qty: 2
            },
            {
                id: "nutrient-catalyst-ampoule",
                qty: 1
            }
        ]
    },
    {
        target: "surface-decon-manifold",
        station: "lab",
        inputs: [
            {
                id: "canvas-fiber",
                qty: 3
            },
            {
                id: "leather-straps",
                qty: 2
            },
            {
                id: "nutrient-gel-pack",
                qty: 1
            },
            {
                id: "medical-stimulant-cartridge",
                qty: 1
            }
        ]
    },
    {
        target: "lattice-lock-ribs",
        station: "lab",
        inputs: [
            {
                id: "spore-felt-padding",
                qty: 2
            },
            {
                id: "polymer-tubing",
                qty: 1
            },
            {
                id: "symbiotic-culture-vial",
                qty: 1
            },
            {
                id: "high-torque-motor-core",
                qty: 1
            }
        ]
    },
    {
        target: "leaf-optic-panel",
        station: "lab",
        inputs: [
            {
                id: "resin-casing",
                qty: 2
            },
            {
                id: "symbiotic-culture-vial",
                qty: 2
            },
            {
                id: "nutrient-catalyst-ampoule",
                qty: 1
            }
        ]
    },
    {
        target: "seam-probe-kit",
        station: "lab",
        inputs: [
            {
                id: "chitin-plate",
                qty: 2
            },
            {
                id: "spore-felt-padding",
                qty: 2
            },
            {
                id: "symbiotic-culture-vial",
                qty: 1
            },
            {
                id: "bio-conductive-mesh",
                qty: 1
            }
        ]
    },
    {
        target: "rhythm-guide-hub",
        station: "lab",
        inputs: [
            {
                id: "polymer-tubing",
                qty: 1
            },
            {
                id: "bio-conductive-mesh",
                qty: 1
            },
            {
                id: "synthetic-pheromone-capsule",
                qty: 1
            }
        ]
    },
    {
        target: "multi-diffuser-crown",
        station: "lab",
        inputs: [
            {
                id: "resin-casing",
                qty: 3
            },
            {
                id: "fabric-mesh",
                qty: 2
            },
            {
                id: "bio-conductive-mesh",
                qty: 2
            }
        ]
    },
    {
        target: "contact-silence-kit",
        station: "lab",
        inputs: [
            {
                id: "canvas-fiber",
                qty: 2
            },
            {
                id: "pheromone-distiller-coil",
                qty: 1
            },
            {
                id: "synthetic-pheromone-capsule",
                qty: 1
            }
        ]
    },
    {
        target: "layer-activator-pad",
        station: "lab",
        inputs: [
            {
                id: "tanned-gut-cord",
                qty: 1
            },
            {
                id: "pheromone-distiller-coil",
                qty: 1
            },
            {
                id: "containment-gel-lining",
                qty: 1
            },
            {
                id: "synthetic-pheromone-capsule",
                qty: 1
            }
        ]
    },
    {
        target: "enzyme-hub-manifold",
        station: "lab",
        inputs: [
            {
                id: "chitin-plate",
                qty: 3
            },
            {
                id: "pheromone-distiller-coil",
                qty: 1
            },
            {
                id: "containment-gel-lining",
                qty: 1
            }
        ]
    },
    {
        target: "surface-tuner-core",
        station: "lab",
        inputs: [
            {
                id: "spore-felt-padding",
                qty: 1
            },
            {
                id: "adaptive-filter-membrane",
                qty: 2
            },
            {
                id: "synthetic-pheromone-capsule",
                qty: 1
            }
        ]
    },
    {
        target: "hot-sample-frame",
        station: "lab",
        inputs: [
            {
                id: "leather-straps",
                qty: 6
            },
            {
                id: "polymer-tubing",
                qty: 2
            },
            {
                id: "chitin-plate",
                qty: 1
            }
        ]
    },
    {
        target: "pod-growth-hub",
        station: "lab",
        inputs: [
            {
                id: "nutrient-gel-pack",
                qty: 2
            },
            {
                id: "adaptive-filter-membrane",
                qty: 1
            },
            {
                id: "containment-gel-lining",
                qty: 1
            }
        ]
    },
    {
        target: "recovery-pod-manifold",
        station: "lab",
        inputs: [
            {
                id: "nutrient-gel-pack",
                qty: 2
            },
            {
                id: "adaptive-filter-membrane",
                qty: 1
            },
            {
                id: "containment-gel-lining",
                qty: 1
            }
        ]
    },
    {
        target: "relay-pairing-bridge",
        station: "lab",
        inputs: [
            {
                id: "micro-bearing-set",
                qty: 2
            },
            {
                id: "carbon-housing",
                qty: 1
            },
            {
                id: "data-storage-crystal",
                qty: 2
            }
        ]
    },
    {
        target: "bio-pulse-coupler",
        station: "lab",
        inputs: [
            {
                id: "micro-bearing-set",
                qty: 2
            },
            {
                id: "phase-lens-array",
                qty: 1
            },
            {
                id: "data-storage-crystal",
                qty: 1
            }
        ]
    },
    {
        target: "map-sync-hub",
        station: "lab",
        inputs: [
            {
                id: "brass-fittings",
                qty: 2
            },
            {
                id: "carbon-housing",
                qty: 1
            },
            {
                id: "data-storage-crystal",
                qty: 1
            }
        ]
    },
    {
        target: "micro-torque-rail",
        station: "lab",
        inputs: [
            {
                id: "etched-keyplate-blank",
                qty: 3
            },
            {
                id: "ultrasonic-sensor-grid",
                qty: 2
            },
            {
                id: "micro-servo-drill",
                qty: 1
            }
        ]
    },
    {
        target: "quiet-seal-rail",
        station: "lab",
        inputs: [
            {
                id: "etched-keyplate-blank",
                qty: 1
            },
            {
                id: "ultrasonic-sensor-grid",
                qty: 1
            },
            {
                id: "precision-chrono-core",
                qty: 1
            }
        ]
    },
    {
        target: "decoy-phase-driver",
        station: "lab",
        inputs: [
            {
                id: "optic-fiber-spool",
                qty: 1
            },
            {
                id: "micro-servo-drill",
                qty: 1
            },
            {
                id: "precision-chrono-core",
                qty: 1
            }
        ]
    },
    {
        target: "route-shadow-hub",
        station: "lab",
        inputs: [
            {
                id: "matte-coating-compound",
                qty: 1
            },
            {
                id: "optic-fiber-spool",
                qty: 1
            },
            {
                id: "thermal-polarizer-film",
                qty: 1
            }
        ]
    },
    {
        target: "low-shine-housing",
        station: "lab",
        inputs: [
            {
                id: "matte-coating-compound",
                qty: 1
            },
            {
                id: "vibration-dampener",
                qty: 2
            },
            {
                id: "thermal-polarizer-film",
                qty: 1
            }
        ]
    },
    {
        target: "pace-sync-hub",
        station: "lab",
        inputs: [
            {
                id: "brass-fittings",
                qty: 1
            },
            {
                id: "carbon-housing",
                qty: 1
            },
            {
                id: "em-interference-chip",
                qty: 1
            }
        ]
    },
    {
        target: "auth-emulator-core",
        station: "lab",
        inputs: [
            {
                id: "acoustic-foam-wafer",
                qty: 2
            },
            {
                id: "em-interference-chip",
                qty: 1
            },
            {
                id: "harmonic-stabilizer-core",
                qty: 1
            }
        ]
    },
    {
        target: "thermal-scent-hub",
        station: "lab",
        inputs: [
            {
                id: "ghost-signal-modulator",
                qty: 2
            },
            {
                id: "vibration-dampener",
                qty: 1
            },
            {
                id: "em-interference-chip",
                qty: 1
            }
        ]
    },
    {
        target: "log-sanitizer-kernel",
        station: "lab",
        inputs: [
            {
                id: "etched-keyplate-blank",
                qty: 2
            },
            {
                id: "em-interference-chip",
                qty: 1
            },
            {
                id: "harmonic-stabilizer-core",
                qty: 1
            }
        ]
    },
    {
        target: "anchor-brace-grid",
        station: "lab",
        inputs: [
            {
                id: "plastic-casing",
                qty: 2
            },
            {
                id: "acoustic-foam-wafer",
                qty: 2
            },
            {
                id: "harmonic-stabilizer-core",
                qty: 1
            }
        ]
    },
    {
        target: "timing-window-hub",
        station: "lab",
        inputs: [
            {
                id: "plastic-casing",
                qty: 1
            },
            {
                id: "phase-lens-array",
                qty: 1
            },
            {
                id: "harmonic-stabilizer-core",
                qty: 1
            }
        ]
    },
    {
        target: "scan-cache-backplane",
        station: "lab",
        inputs: [
            {
                id: "optic-fiber-spool",
                qty: 2
            },
            {
                id: "ghost-signal-modulator",
                qty: 1
            },
            {
                id: "harmonic-stabilizer-core",
                qty: 2
            }
        ]
    }
];
var $979b99378be707cd$export$c95766f8298d6ed1 = [
    {
        target: "encrypted-transceiver-chip",
        station: "lab",
        inputs: [
            {
                id: "iron-frame",
                qty: 2
            },
            {
                id: "steel-plates",
                qty: 1
            },
            {
                id: "signal-processor-core",
                qty: 1
            }
        ]
    },
    {
        target: "radiation-sensor-module",
        station: "lab",
        inputs: [
            {
                id: "composite-casing",
                qty: 2
            },
            {
                id: "relay-antenna-strut",
                qty: 1
            },
            {
                id: "sealed-hydraulic-pump",
                qty: 1
            }
        ]
    },
    {
        target: "bio-conductive-mesh",
        station: "lab",
        inputs: [
            {
                id: "polymer-tubing",
                qty: 2
            },
            {
                id: "resin-casing",
                qty: 1
            },
            {
                id: "symbiotic-culture-vial",
                qty: 1
            }
        ]
    },
    {
        target: "synthetic-pheromone-capsule",
        station: "lab",
        inputs: [
            {
                id: "glass-lens",
                qty: 2
            },
            {
                id: "rubber-seal",
                qty: 1
            },
            {
                id: "pheromone-distiller-coil",
                qty: 1
            }
        ]
    },
    {
        target: "em-interference-chip",
        station: "lab",
        inputs: [
            {
                id: "iron-frame",
                qty: 2
            },
            {
                id: "steel-plates",
                qty: 1
            },
            {
                id: "vibration-dampener",
                qty: 1
            }
        ]
    },
    {
        target: "harmonic-stabilizer-core",
        station: "lab",
        inputs: [
            {
                id: "acoustic-foam-wafer",
                qty: 2
            },
            {
                id: "plastic-casing",
                qty: 1
            },
            {
                id: "ghost-signal-modulator",
                qty: 1
            }
        ]
    },
    {
        target: "signal-sync-crystal",
        station: "lab",
        inputs: [
            {
                id: "glass-lens",
                qty: 2
            },
            {
                id: "rubber-seal",
                qty: 1
            },
            {
                id: "drone-gyro-assembly",
                qty: 1
            }
        ]
    },
    {
        target: "data-storage-crystal",
        station: "lab",
        inputs: [
            {
                id: "iron-frame",
                qty: 2
            },
            {
                id: "steel-plates",
                qty: 1
            },
            {
                id: "ultrasonic-sensor-grid",
                qty: 1
            }
        ]
    },
    {
        target: "precision-chrono-core",
        station: "lab",
        inputs: [
            {
                id: "optic-fiber-spool",
                qty: 2
            },
            {
                id: "matte-coating-compound",
                qty: 1
            },
            {
                id: "micro-servo-drill",
                qty: 1
            }
        ]
    },
    {
        target: "high-torque-motor-core",
        station: "lab",
        inputs: [
            {
                id: "glass-lens",
                qty: 2
            },
            {
                id: "rubber-seal",
                qty: 1
            },
            {
                id: "nutrient-catalyst-ampoule",
                qty: 1
            }
        ]
    },
    {
        target: "containment-gel-lining",
        station: "lab",
        inputs: [
            {
                id: "chitin-plate",
                qty: 2
            },
            {
                id: "leather-straps",
                qty: 1
            },
            {
                id: "adaptive-filter-membrane",
                qty: 1
            }
        ]
    },
    {
        target: "voltage-regulator-unit",
        station: "lab",
        inputs: [
            {
                id: "ceramic-insulator",
                qty: 2
            },
            {
                id: "power-cell-casing",
                qty: 1
            },
            {
                id: "override-datakey",
                qty: 1
            }
        ]
    }
];
var $979b99378be707cd$export$c4df318d1f4ad4 = [
    {
        target: "signal-processor-core",
        station: "bench",
        inputs: [
            {
                id: "steel-plates",
                qty: 2
            },
            {
                id: "glass-lens",
                qty: 1
            }
        ]
    },
    {
        target: "precision-servo-gear",
        station: "bench",
        inputs: [
            {
                id: "copper-wire",
                qty: 2
            },
            {
                id: "relay-antenna-strut",
                qty: 1
            }
        ]
    },
    {
        target: "nutrient-catalyst-ampoule",
        station: "bench",
        inputs: [
            {
                id: "rubber-seal",
                qty: 1
            },
            {
                id: "iron-frame",
                qty: 1
            },
            {
                id: "steel-plates",
                qty: 1
            }
        ]
    },
    {
        target: "adaptive-filter-membrane",
        station: "bench",
        inputs: [
            {
                id: "leather-straps",
                qty: 2
            },
            {
                id: "chitin-plate",
                qty: 1
            }
        ]
    },
    {
        target: "ultrasonic-sensor-grid",
        station: "bench",
        inputs: [
            {
                id: "glass-lens",
                qty: 1
            },
            {
                id: "rubber-seal",
                qty: 1
            },
            {
                id: "iron-frame",
                qty: 1
            }
        ]
    },
    {
        target: "micro-servo-drill",
        station: "bench",
        inputs: [
            {
                id: "optic-fiber-spool",
                qty: 1
            },
            {
                id: "matte-coating-compound",
                qty: 1
            },
            {
                id: "steel-plates",
                qty: 1
            }
        ]
    },
    {
        target: "vibration-dampener",
        station: "bench",
        inputs: [
            {
                id: "glass-lens",
                qty: 2
            },
            {
                id: "rubber-seal",
                qty: 1
            }
        ]
    },
    {
        target: "thermal-polarizer-film",
        station: "bench",
        inputs: [
            {
                id: "brass-fittings",
                qty: 2
            },
            {
                id: "carbon-housing",
                qty: 1
            }
        ]
    },
    {
        target: "medical-stimulant-cartridge",
        station: "bench",
        inputs: [
            {
                id: "fabric-mesh",
                qty: 1
            },
            {
                id: "canvas-fiber",
                qty: 1
            },
            {
                id: "iron-frame",
                qty: 1
            }
        ]
    },
    {
        target: "power-regulation-unit",
        station: "bench",
        inputs: [
            {
                id: "circuit-board",
                qty: 1
            },
            {
                id: "copper-wire",
                qty: 1
            },
            {
                id: "steel-plates",
                qty: 1
            }
        ]
    },
    {
        target: "sealed-hydraulic-pump",
        station: "bench",
        inputs: [
            {
                id: "composite-casing",
                qty: 1
            },
            {
                id: "relay-antenna-strut",
                qty: 1
            },
            {
                id: "glass-lens",
                qty: 1
            }
        ]
    },
    {
        target: "nutrient-gel-pack",
        station: "bench",
        inputs: [
            {
                id: "fabric-mesh",
                qty: 1
            },
            {
                id: "leather-straps",
                qty: 1
            },
            {
                id: "rubber-seal",
                qty: 1
            }
        ]
    },
    {
        target: "override-datakey",
        station: "bench",
        inputs: [
            {
                id: "ceramic-insulator",
                qty: 2
            },
            {
                id: "power-cell-casing",
                qty: 1
            }
        ]
    },
    {
        target: "drone-gyro-assembly",
        station: "bench",
        inputs: [
            {
                id: "iron-frame",
                qty: 2
            },
            {
                id: "steel-plates",
                qty: 1
            }
        ]
    },
    {
        target: "symbiotic-culture-vial",
        station: "bench",
        inputs: [
            {
                id: "polymer-tubing",
                qty: 2
            },
            {
                id: "resin-casing",
                qty: 1
            }
        ]
    },
    {
        target: "pheromone-distiller-coil",
        station: "bench",
        inputs: [
            {
                id: "glass-lens",
                qty: 2
            },
            {
                id: "rubber-seal",
                qty: 1
            }
        ]
    },
    {
        target: "phase-lens-array",
        station: "bench",
        inputs: [
            {
                id: "plastic-casing",
                qty: 2
            },
            {
                id: "brass-fittings",
                qty: 1
            }
        ]
    },
    {
        target: "ghost-signal-modulator",
        station: "bench",
        inputs: [
            {
                id: "acoustic-foam-wafer",
                qty: 2
            },
            {
                id: "plastic-casing",
                qty: 1
            }
        ]
    }
];
var $979b99378be707cd$export$aafe7b77259ba40d = {
    "dominion": [
        //
        // "signal-relay"
        //
        {
            "id": "relay-stabilizer",
            "name": "Relay Stabilizer",
            "icon": "\uD83D\uDEF0\uFE0F\uD83D\uDCE1",
            "skill": "signal-relay",
            "faction": "dominion",
            "description": "Restores damaged comm towers and aligns dishes for steady transmission.",
            "synergies": [
                {
                    "targetFaction": "wilders",
                    "targetSkill": "growth-control",
                    "targetTechnique": "adaptive-lattice",
                    "effect": "Rooted support frames keep relay masts upright on soft or shifting ground."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "echo-trace",
                    "targetTechnique": "quantum-relay-hook",
                    "effect": "Maps ride the same channel as comm traffic, boosting range while lowering scan noise."
                }
            ]
        },
        {
            "id": "organic-link-adapter",
            "name": "Organic Link Adapter",
            "icon": "\uD83D\uDD17\uD83E\uDDEC",
            "skill": "signal-relay",
            "faction": "dominion",
            "description": "Threads bio-fiber into cracked relay lines to hold connection when metal cabling fails.",
            "synergies": [
                {
                    "targetFaction": "wilders",
                    "targetSkill": "containment",
                    "targetTechnique": "servo-containment",
                    "effect": "Enzyme runoff is routed through bio-sheaths so relay panels don\u2019t corrode."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "transit-anchor",
                    "targetTechnique": "depth-step",
                    "effect": "Relays sync with surface settling moments to reduce transmission interference."
                }
            ]
        },
        {
            "id": "silent-channel",
            "name": "Silent Channel",
            "icon": "\uD83D\uDD15\uD83D\uDCF6",
            "skill": "signal-relay",
            "faction": "dominion",
            "description": "Masks signal noise so scanners can\u2019t trace team transmissions.",
            "synergies": [
                {
                    "targetFaction": "wilders",
                    "targetSkill": "wild-influence",
                    "targetTechnique": "silent-hand",
                    "effect": "Quiet comms match scent-neutral zones so movement near wildlife stays unseen."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "signal-mask",
                    "targetTechnique": "echo-loop",
                    "effect": "Comms timing matches data-scrub cycles so logs don\u2019t record the team\u2019s traffic."
                }
            ]
        },
        //
        // "system-override"
        //
        {
            "id": "command-cascade",
            "name": "Command Cascade",
            "icon": "\uD83E\uDDE9\uD83D\uDCDF",
            "skill": "system-override",
            "faction": "dominion",
            "description": "Links multiple machines to take control in a single sequence.",
            "synergies": [
                {
                    "targetFaction": "wilders",
                    "targetSkill": "wild-influence",
                    "targetTechnique": "signal-harmonizer",
                    "effect": "Pacified groups keep pace with redirected turrets and drones without panic."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "signal-mask",
                    "targetTechnique": "control-spoof",
                    "effect": "Spoofed credentials make the takeover look like a routine maintenance command."
                }
            ]
        },
        {
            "id": "bio-feedback-guard",
            "name": "Bio-Feedback Guard",
            "icon": "\uD83D\uDEE1\uFE0F\u26A1",
            "skill": "system-override",
            "faction": "dominion",
            "description": "Uses flexible bio-couplers to absorb surge current during forced reboots.",
            "synergies": [
                {
                    "targetFaction": "wilders",
                    "targetSkill": "bio-shield",
                    "targetTechnique": "bio-shielding",
                    "effect": "Excess current sinks into bio-layers so panels don\u2019t flash over."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "transit-anchor",
                    "targetTechnique": "phase-anchor",
                    "effect": "Stabilizers bleed off spikes so control doesn't drop mid-sequence."
                }
            ]
        },
        {
            "id": "signal-mask-injection",
            "name": "Signal Mask Injection",
            "icon": "\uD83D\uDCE6\uD83D\uDCE1",
            "skill": "system-override",
            "faction": "dominion",
            "description": "Routes control packets through decoy traffic so monitors don\u2019t flag the breach.",
            "synergies": [
                {
                    "targetFaction": "wilders",
                    "targetSkill": "bio-shield",
                    "targetTechnique": "bio-shielding",
                    "effect": "Bio-layers and signal masks combine to confuse hybrid detection systems."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "signal-mask",
                    "targetTechnique": "control-spoof",
                    "effect": "Borrowed access patterns make the override look authorized."
                }
            ]
        },
        //
        // "drone-command"
        //
        {
            "id": "coordinated-flight-pattern",
            "name": "Coordinated Flight Pattern",
            "icon": "\uD83D\uDEF8\uD83E\uDDED",
            "skill": "drone-command",
            "faction": "dominion",
            "description": "Syncs drone routes to avoid overlap and missed coverage.",
            "synergies": [
                {
                    "targetFaction": "wilders",
                    "targetSkill": "containment",
                    "targetTechnique": "reflex-bloom",
                    "effect": "Drones spread recovery spores evenly after hazards to reduce downtime."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "stealth-transit",
                    "targetTechnique": "drone-path-shadow",
                    "effect": "Veil routes piggy-back drone paths so scouts move under the same visual cover."
                }
            ]
        },
        {
            "id": "rootpath-protocol",
            "name": "Rootpath Protocol",
            "icon": "\uD83E\uDDED\uD83C\uDF3F",
            "skill": "drone-command",
            "faction": "dominion",
            "description": "Programs drones to move along overgrowth channels for safe passage.",
            "synergies": [
                {
                    "targetFaction": "wilders",
                    "targetSkill": "growth-control",
                    "targetTechnique": "adaptive-lattice",
                    "effect": "Vine scaffolds give drones lift points for field repairs."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "echo-trace",
                    "targetTechnique": "biotrace-resonance",
                    "effect": "Organic scans mark low-snag routes through dense brush and debris."
                }
            ]
        },
        {
            "id": "echo-pulse-beacon",
            "name": "Echo Pulse Beacon",
            "icon": "\uD83D\uDCDF\uD83C\uDF0A",
            "skill": "drone-command",
            "faction": "dominion",
            "description": "Adds quiet sonar to drones for mapping and quick relays.",
            "synergies": [
                {
                    "targetFaction": "wilders",
                    "targetSkill": "reclamation",
                    "targetTechnique": "reclamation-drone-link",
                    "effect": "Drones coordinate with bio-harvesters to map and salvage in synchronized sweeps."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "echo-trace",
                    "targetTechnique": "shadow-archive",
                    "effect": "Drones upload map snapshots so scouts don\u2019t need to rescan rooms."
                }
            ]
        },
        //
        // "safeguard"
        //
        {
            "id": "system-ground-loop",
            "name": "System Ground Loop",
            "icon": "\u2693\u26A1",
            "skill": "safeguard",
            "faction": "dominion",
            "description": "Drops unstable current into safe grounds to prevent arcs.",
            "synergies": [
                {
                    "targetFaction": "wilders",
                    "targetSkill": "bio-shield",
                    "targetTechnique": "bio-shielding",
                    "effect": "Grounded charge feeds into bio-layers so suits take less shock."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "transit-anchor",
                    "targetTechnique": "phase-anchor",
                    "effect": "Ground paths tie to stabilizers so readouts don't drift under load."
                }
            ]
        },
        {
            "id": "spore-vent-reclaimer",
            "name": "Spore Vent Reclaimer",
            "icon": "\uD83C\uDF2C\uFE0F\uD83E\uDDFC",
            "skill": "safeguard",
            "faction": "dominion",
            "description": "Purges bad air and filters it for reuse after a spill or fire.",
            "synergies": [
                {
                    "targetFaction": "wilders",
                    "targetSkill": "growth-control",
                    "targetTechnique": "photosymbiosis",
                    "effect": "Plant beds turn vented gas into cleaner air, easing strain on masks."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "transit-anchor",
                    "targetTechnique": "depth-step",
                    "effect": "Purge cycles align with surface dips to stop pressure swings."
                }
            ]
        },
        {
            "id": "manual-override-line",
            "name": "Manual Override Line",
            "icon": "\uD83D\uDEE0\uFE0F\u26D3\uFE0F",
            "skill": "safeguard",
            "faction": "dominion",
            "description": "Adds a physical cut-off so systems can be made safe by hand.",
            "synergies": [
                {
                    "targetFaction": "wilders",
                    "targetSkill": "growth-control",
                    "targetTechnique": "adaptive-lattice",
                    "effect": "Cut-offs trigger lattice to seal, stopping leaks instantly."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "transit-anchor",
                    "targetTechnique": "echo-fold",
                    "effect": "Saved system states let shutoffs restore safe configurations instantly."
                }
            ]
        },
        //
        // "quantum-scan"
        //
        {
            "id": "entangled-synchrony",
            "name": "Entangled Synchrony",
            "icon": "\uD83D\uDD17\uD83D\uDCCA",
            "skill": "quantum-scan",
            "faction": "dominion",
            "description": "Links scanners so readings update together without delay.",
            "synergies": [
                {
                    "targetFaction": "wilders",
                    "targetSkill": "reclamation",
                    "targetTechnique": "phase-cleanse",
                    "effect": "Synchronized scans help target clean samples during salvage operations."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "transit-anchor",
                    "targetTechnique": "echo-fold",
                    "effect": "Results back up to Veil storage so scans can be restored if instruments fail." // revised
                }
            ]
        },
        {
            "id": "bio-spectral-crosscheck",
            "name": "Bio-Spectral Crosscheck",
            "icon": "\uD83E\uDDEA\u2622\uFE0F",
            "skill": "quantum-scan",
            "faction": "dominion",
            "description": "Matches radiation and field strength against known biological sources.",
            "synergies": [
                {
                    "targetFaction": "veil",
                    "targetSkill": "echo-trace",
                    "targetTechnique": "biotrace-resonance",
                    "effect": "Pulse returns show which walls hide root channels or nests."
                },
                {
                    "targetFaction": "wilders",
                    "targetSkill": "reclamation",
                    "targetTechnique": "phase-cleanse",
                    "effect": "Feedback helps break down thin contamination films faster."
                }
            ]
        },
        {
            "id": "ghost-echo-capture",
            "name": "Ghost Echo Capture",
            "icon": "\uD83D\uDD0D\uD83D\uDD0C",
            "skill": "quantum-scan",
            "faction": "dominion",
            "description": "Measures residual current in damaged circuits to locate still-active connections.",
            "synergies": [
                {
                    "targetFaction": "wilders",
                    "targetSkill": "growth-control",
                    "targetTechnique": "shadowroot-bloom",
                    "effect": "Root tips wick trace particles out of hairline cracks for cleaner samples."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "transit-anchor",
                    "targetTechnique": "echo-fold",
                    "effect": "Saved readings fill gaps in later scans for cleaner data continuity." // revised
                }
            ]
        }
    ],
    "wilders": [
        //
        // "reclamation"
        //
        {
            "id": "reclamation-drone-link",
            "name": "Reclamation Drone Link",
            "icon": "\uD83E\uDD16\uD83C\uDF3E",
            "skill": "reclamation",
            "faction": "wilders",
            "description": "Pairs bio-harvesters with repair drones to pull clean samples fast.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "drone-command",
                    "targetTechnique": "coordinated-flight-pattern",
                    "effect": "Shared routes keep harvest and repair flights from crossing paths."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "echo-trace",
                    "targetTechnique": "shadow-archive",
                    "effect": "Findings upload to scout archives so crews don't double dip rooms."
                }
            ]
        },
        {
            "id": "mycelial-rebalance",
            "name": "Mycelial Rebalance",
            "icon": "\uD83C\uDF44\uD83D\uDD01",
            "skill": "reclamation",
            "faction": "wilders",
            "description": "Uses live fungal filters to sort usable tissue from waste.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "safeguard",
                    "targetTechnique": "spore-vent-reclaimer",
                    "effect": "Filtered air keeps samples dry and prevents mold blooms."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "lock-breach",
                    "targetTechnique": "biofilm-stabilizer",
                    "effect": "Seals around work sites so salvage doesn\u2019t set off contact sensors."
                }
            ]
        },
        {
            "id": "phase-cleanse",
            "name": "Phase Cleanse",
            "icon": "\uD83E\uDDFC\uD83C\uDF2B\uFE0F",
            "skill": "reclamation",
            "faction": "wilders",
            "description": "Applies mild disinfectant waves that lift spores and oils from surfaces.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "drone-command",
                    "targetTechnique": "echo-pulse-beacon",
                    "effect": "Drone sweeps spread the cleanse evenly through large rooms."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "echo-trace",
                    "targetTechnique": "quantum-relay-hook",
                    "effect": "Relay points guide cleanse waves to hidden surfaces behind panels."
                }
            ]
        },
        //
        // "growth-control"
        //
        {
            "id": "adaptive-lattice",
            "name": "Adaptive Lattice",
            "icon": "\uD83E\uDDF1\uD83C\uDF3F",
            "skill": "growth-control",
            "faction": "wilders",
            "description": "Grows vine-metal frames that brace walls or span short gaps.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "signal-relay",
                    "targetTechnique": "relay-stabilizer",
                    "effect": "Braced masts don\u2019t drift, keeping long links online."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "transit-anchor",
                    "targetTechnique": "phase-anchor",
                    "effect": "Vine-braced anchors stay stable even when floors shift and settle."
                }
            ]
        },
        {
            "id": "photosymbiosis",
            "name": "Photosymbiosis",
            "icon": "\u2600\uFE0F\uD83C\uDF3F",
            "skill": "growth-control",
            "faction": "wilders",
            "description": "Channels light through leaves to speed growth and thicken cover.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "safeguard",
                    "targetTechnique": "spore-vent-reclaimer",
                    "effect": "Filtered vents feed beds so air clears faster after a spill."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "stealth-transit",
                    "targetTechnique": "spore-veil",
                    "effect": "Light-absorbing spores lower visibility for moving squads."
                }
            ]
        },
        {
            "id": "shadowroot-bloom",
            "name": "Shadowroot Bloom",
            "icon": "\uD83C\uDF31\uD83D\uDD73\uFE0F",
            "skill": "growth-control",
            "faction": "wilders",
            "description": "Guides roots through shaded cracks to open paths and expose hidden space.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "quantum-scan",
                    "targetTechnique": "ghost-echo-capture",
                    "effect": "Roots pull faint power traces out of sealed joints for scanning."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "echo-trace",
                    "targetTechnique": "biotrace-resonance",
                    "effect": "Combined pulses show hollows behind walls and floors."
                }
            ]
        },
        //
        // "wild-influence"
        //
        {
            "id": "signal-harmonizer",
            "name": "Signal Harmonizer",
            "icon": "\uD83C\uDFBC\uD83D\uDC3E",
            "skill": "wild-influence",
            "faction": "wilders",
            "description": "Lines up heart and breath rhythms to calm groups without drugs.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "system-override",
                    "targetTechnique": "command-cascade",
                    "effect": "Calm groups move in step with redirected machines."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "signal-mask",
                    "targetTechnique": "bio-id-mask",
                    "effect": "Calm scent profiles look like background fauna on sensors."
                }
            ]
        },
        {
            "id": "pheromone-chorus",
            "name": "Pheromone Chorus",
            "icon": "\uD83E\uDD8B\uD83C\uDF2C\uFE0F",
            "skill": "wild-influence",
            "faction": "wilders",
            "description": "Blends signals from multiple handlers to widen the calm zone.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "drone-command",
                    "targetTechnique": "coordinated-flight-pattern",
                    "effect": "Drones carry the blend across the room without startling nests."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "stealth-transit",
                    "targetTechnique": "mirror-walk",
                    "effect": "Team steps track as one trace, reducing sudden noise."
                }
            ]
        },
        {
            "id": "silent-hand",
            "name": "Silent Hand",
            "icon": "\uD83E\uDD2B\uD83D\uDC63",
            "skill": "wild-influence",
            "faction": "wilders",
            "description": "Suppresses scent trails and quiets gear snaps near wildlife.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "signal-relay",
                    "targetTechnique": "silent-channel",
                    "effect": "Quiet comms match low-scent lanes so patrols pass by."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "echo-trace",
                    "targetTechnique": "quantum-relay-hook",
                    "effect": "Relay hooks damp vibrations so footfalls don't echo in tight halls."
                }
            ]
        },
        //
        // "bio-shield"
        //
        {
            "id": "bio-shielding",
            "name": "Bio-Shielding",
            "icon": "\uD83D\uDEE1\uFE0F\u26A1",
            "skill": "bio-shield",
            "faction": "wilders",
            "description": "Grows a thin, flexible layer that spreads shock and heat.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "safeguard",
                    "targetTechnique": "system-ground-loop",
                    "effect": "Grounded arcs bleed into the layer so skin doesn\u2019t blister."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "signal-mask",
                    "targetTechnique": "bio-id-mask",
                    "effect": "Heat and scent even out, leaving little for trackers to follow."
                }
            ]
        },
        {
            "id": "shared-immunity",
            "name": "Shared Immunity",
            "icon": "\uD83E\uDDEC\uD83E\uDD1D",
            "skill": "bio-shield",
            "faction": "wilders",
            "description": "Passes enzyme packs between teammates for short-term resistance.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "system-override",
                    "targetTechnique": "bio-feedback-guard",
                    "effect": "Enzymes protect skin from stray surges during forced reboots."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "signal-mask",
                    "targetTechnique": "bio-id-mask",
                    "effect": "Body markers shift enough to pass basic biometric checks."
                }
            ]
        },
        {
            "id": "dim-shift-layer",
            "name": "Dim Shift Layer",
            "icon": "\uD83E\uDE9E\uD83E\uDDE9",
            "skill": "bio-shield",
            "faction": "wilders",
            "description": "Adjusts surface tone and reflectivity to match nearby materials.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "quantum-scan",
                    "targetTechnique": "entangled-synchrony",
                    "effect": "Scan timings help the layer adjust before sensors sweep past."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "transit-anchor",
                    "targetTechnique": "echo-fold",
                    "effect": "Saved lighting profiles help the layer auto-tune along familiar paths." // revised
                }
            ]
        },
        //
        // "containment"
        //
        {
            "id": "servo-containment",
            "name": "Servo Containment",
            "icon": "\uD83D\uDCE6\u2623\uFE0F",
            "skill": "containment",
            "faction": "wilders",
            "description": "Uses drone shells as hard cases for hot samples.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "signal-relay",
                    "targetTechnique": "organic-link-adapter",
                    "effect": "Bio-sheaths in relay bays don\u2019t react to sealed cases."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "lock-breach",
                    "targetTechnique": "servo-alignment-tool",
                    "effect": "Cases align with lock rails, letting crews move them quietly."
                }
            ]
        },
        {
            "id": "mutualist-growth",
            "name": "Mutualist Growth",
            "icon": "\uD83E\uDD1D\uD83C\uDF31",
            "skill": "containment",
            "faction": "wilders",
            "description": "Cultivates living pods around unstable material to keep it from spreading.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "safeguard",
                    "targetTechnique": "manual-override-line",
                    "effect": "Cut-offs trigger pod close-up so leaks don\u2019t escape."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "lock-breach",
                    "targetTechnique": "echo-pulse-decoy",
                    "effect": "Decoy pulses draw guard attention away while pods close and seal."
                }
            ]
        },
        {
            "id": "reflex-bloom",
            "name": "Reflex Bloom",
            "icon": "\uD83D\uDC8A\uD83C\uDF3F",
            "skill": "containment",
            "faction": "wilders",
            "description": "Deploys small regenerative pods that release healing compounds after exposure.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "drone-command",
                    "targetTechnique": "coordinated-flight-pattern",
                    "effect": "Drones spread bloom spores across the team between rooms."
                },
                {
                    "targetFaction": "veil",
                    "targetSkill": "stealth-transit",
                    "targetTechnique": "spore-veil",
                    "effect": "Bloom and veil spores mix to hide heat shimmer and breath."
                }
            ]
        }
    ],
    "veil": [
        //
        // "echo-trace"
        //    
        {
            "id": "quantum-relay-hook",
            "name": "Relay Hook",
            "icon": "\uD83E\uDE9D\uD83D\uDCE1",
            "skill": "echo-trace",
            "faction": "veil",
            "description": "Links mapping scanners to nearby network relays so data and comms share the same path.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "signal-relay",
                    "targetTechnique": "relay-stabilizer",
                    "effect": "Stable masts carry both traffic and survey data without dropouts."
                },
                {
                    "targetFaction": "wilders",
                    "targetSkill": "growth-control",
                    "targetTechnique": "photosymbiosis",
                    "effect": "Growth covers relay lines so data travels protected through the room."
                }
            ]
        },
        {
            "id": "biotrace-resonance",
            "name": "Biotrace Resonance",
            "icon": "\uD83E\uDDEB\uD83D\uDCF6",
            "skill": "echo-trace",
            "faction": "veil",
            "description": "Sends short pulses that reflect off living material to flag organic routes.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "quantum-scan",
                    "targetTechnique": "bio-spectral-crosscheck",
                    "effect": "Combined returns show where growth hides power lines and vents."
                },
                {
                    "targetFaction": "wilders",
                    "targetSkill": "reclamation",
                    "targetTechnique": "phase-cleanse",
                    "effect": "Pulse images reveal thin films left after salvage so teams can clear them."
                }
            ]
        },
        {
            "id": "shadow-archive",
            "name": "Shadow Archive",
            "icon": "\uD83D\uDDC4\uFE0F\uD83D\uDDFA\uFE0F",
            "skill": "echo-trace",
            "faction": "veil",
            "description": "Stores map data in portable memory that syncs on contact.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "drone-command",
                    "targetTechnique": "echo-pulse-beacon",
                    "effect": "Drones post snapshots so scouts don\u2019t re-scan cleared rooms."
                },
                {
                    "targetFaction": "wilders",
                    "targetSkill": "wild-influence",
                    "targetTechnique": "silent-hand",
                    "effect": "Echo dampers cut footfall bounce so nearby wildlife stays calm."
                }
            ]
        },
        //
        // "lock-breach"
        // 
        {
            "id": "servo-alignment-tool",
            "name": "Servo Alignment Tool",
            "icon": "\uD83D\uDD27\uD83D\uDD13",
            "skill": "lock-breach",
            "faction": "veil",
            "description": "Calibrates lock servos so picks and spinners seat cleanly.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "safeguard",
                    "targetTechnique": "manual-override-line",
                    "effect": "Kill-switches and lock rails line up to prevent jolts mid-breach."
                },
                {
                    "targetFaction": "wilders",
                    "targetSkill": "containment",
                    "targetTechnique": "servo-containment",
                    "effect": "Sealed cases ride rails quietly through narrow passages."
                }
            ]
        },
        {
            "id": "biofilm-stabilizer",
            "name": "Biofilm Stabilizer",
            "icon": "\uD83E\uDDF4\uD83D\uDD07",
            "skill": "lock-breach",
            "faction": "veil",
            "description": "Applies a thin organic seal so panels don\u2019t rattle or squeal.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "system-override",
                    "targetTechnique": "signal-mask-injection",
                    "effect": "Quiet seals and decoy traffic hide the sound and the signal of a breach."
                },
                {
                    "targetFaction": "wilders",
                    "targetSkill": "reclamation",
                    "targetTechnique": "mycelial-rebalance",
                    "effect": "Seals keep mold from creeping under plates while crews work."
                }
            ]
        },
        {
            "id": "echo-pulse-decoy",
            "name": "Echo Pulse Decoy",
            "icon": "\uD83C\uDF87\uD83D\uDC40",
            "skill": "lock-breach",
            "faction": "veil",
            "description": "Sends a harmless pulse so guards look the wrong way during a breach.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "system-override",
                    "targetTechnique": "command-cascade",
                    "effect": "Distractions line up with machine takeovers so alarms don\u2019t stack."
                },
                {
                    "targetFaction": "wilders",
                    "targetSkill": "containment",
                    "targetTechnique": "mutualist-growth",
                    "effect": "Pods close while decoys fire, hiding movement sounds."
                }
            ]
        },
        //
        // "stealth-transit"
        // 
        {
            "id": "drone-path-shadow",
            "name": "Drone Path Shadow",
            "icon": "\uD83D\uDD76\uFE0F\uD83E\uDD16",
            "skill": "stealth-transit",
            "faction": "veil",
            "description": "Walks the same lanes as drones so both use one visual trace.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "drone-command",
                    "targetTechnique": "rootpath-protocol",
                    "effect": "Scouts follow programmed drone routes for safe, low-visibility passage."
                },
                {
                    "targetFaction": "wilders",
                    "targetSkill": "wild-influence",
                    "targetTechnique": "pheromone-chorus",
                    "effect": "Air carries calm signals along the same lanes, reducing spooks."
                }
            ]
        },
        {
            "id": "spore-veil",
            "name": "Spore Veil",
            "icon": "\uD83C\uDF2B\uFE0F\uD83D\uDD75\uFE0F",
            "skill": "stealth-transit",
            "faction": "veil",
            "description": "Releases faint spores that dull edges and reduce shine.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "safeguard",
                    "targetTechnique": "system-ground-loop",
                    "effect": "Grounded systems prevent static buildup that could reveal the spore cloud."
                },
                {
                    "targetFaction": "wilders",
                    "targetSkill": "containment",
                    "targetTechnique": "reflex-bloom",
                    "effect": "Veil spores mix with bloom to hide heat shimmer and breath."
                }
            ]
        },
        {
            "id": "mirror-walk",
            "name": "Mirror Walk",
            "icon": "\uD83E\uDE9E\uD83D\uDC63",
            "skill": "stealth-transit",
            "faction": "veil",
            "description": "Matches the lead scout\u2019s pace so the group reads as one unit.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "drone-command",
                    "targetTechnique": "rootpath-protocol",
                    "effect": "Shared pacing and overgrowth lanes reduce brush noise."
                },
                {
                    "targetFaction": "wilders",
                    "targetSkill": "wild-influence",
                    "targetTechnique": "pheromone-chorus",
                    "effect": "Synchronized steps pair with a single calm signal, lowering alert spikes."
                }
            ]
        },
        //
        // "signal-mask"
        // 
        {
            "id": "control-spoof",
            "name": "Control Spoof",
            "icon": "\uD83C\uDFAD\uD83D\uDD10",
            "skill": "signal-mask",
            "faction": "veil",
            "description": "Builds fake machine credentials that pass quick checks.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "system-override",
                    "targetTechnique": "command-cascade",
                    "effect": "Spoofs clear the way for chained takeovers without alarms."
                },
                {
                    "targetFaction": "wilders",
                    "targetSkill": "bio-shield",
                    "targetTechnique": "shared-immunity",
                    "effect": "Shifted biometrics keep gates from flagging the team during checks."
                }
            ]
        },
        {
            "id": "bio-id-mask",
            "name": "Bio-ID Mask",
            "icon": "\uD83E\uDEAA\uD83D\uDC43",
            "skill": "signal-mask",
            "faction": "veil",
            "description": "Mimics heat and scent patterns so sensors read the team as local life.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "system-override",
                    "targetTechnique": "signal-mask-injection",
                    "effect": "Bio and machine masks match, confusing hybrid doors and cameras."
                },
                {
                    "targetFaction": "wilders",
                    "targetSkill": "wild-influence",
                    "targetTechnique": "signal-harmonizer",
                    "effect": "Calm scent profiles slot into the mask so patrols ignore the team."
                }
            ]
        },
        {
            "id": "echo-loop",
            "name": "Echo Loop",
            "icon": "\uD83D\uDD01\uD83D\uDCDC",
            "skill": "signal-mask",
            "faction": "veil",
            "description": "Writes temporary log entries to hide the real exit trail.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "signal-relay",
                    "targetTechnique": "silent-channel",
                    "effect": "Dummy logs and quiet comms leave nothing firm to trace."
                },
                {
                    "targetFaction": "wilders",
                    "targetSkill": "reclamation",
                    "targetTechnique": "mycelial-rebalance",
                    "effect": "Fungal filters break down organic traces that could reveal the exit route."
                }
            ]
        },
        //
        // "transit-anchor"
        // 
        {
            "id": "phase-anchor",
            "name": "Phase Anchor",
            "icon": "\uD83E\uDEA8\uD83D\uDCCD",
            "skill": "transit-anchor",
            "faction": "veil",
            "description": "Drops a small stabilizer so floors and walls stop drifting.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "signal-relay",
                    "targetTechnique": "organic-link-adapter",
                    "effect": "Anchors act as grounds so patched relay lines don\u2019t wander."
                },
                {
                    "targetFaction": "wilders",
                    "targetSkill": "containment",
                    "targetTechnique": "mutualist-growth",
                    "effect": "Pods close around anchors, preventing leaks from creeping."
                }
            ]
        },
        {
            "id": "depth-step",
            "name": "Depth Step",
            "icon": "\u23F1\uFE0F\uD83D\uDC63",
            "skill": "transit-anchor",
            "faction": "veil",
            "description": "Times crossings for moments when surfaces settle.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "safeguard",
                    "targetTechnique": "spore-vent-reclaimer",
                    "effect": "Purge cycles match crossings so pressure and air stay even."
                },
                {
                    "targetFaction": "wilders",
                    "targetSkill": "growth-control",
                    "targetTechnique": "shadowroot-bloom",
                    "effect": "Roots shift to create stable footholds at the right moment."
                }
            ]
        },
        {
            "id": "echo-fold",
            "name": "Echo Fold",
            "icon": "\uD83D\uDDC2\uFE0F\uD83D\uDEF0\uFE0F",
            "skill": "transit-anchor",
            "faction": "veil",
            "description": "Caches visual and sensor data from recent scans for quick reload if equipment glitches.",
            "synergies": [
                {
                    "targetFaction": "dominion",
                    "targetSkill": "quantum-scan",
                    "targetTechnique": "entangled-synchrony",
                    "effect": "Readings merge into cached files so analysts can review full logs later." // revised
                },
                {
                    "targetFaction": "wilders",
                    "targetSkill": "bio-shield",
                    "targetTechnique": "dim-shift-layer",
                    "effect": "Saved lighting profiles help the layer auto-tune along familiar paths." // revised
                }
            ]
        }
    ]
};
var $979b99378be707cd$export$1a64c4c64ba19abd = {
    // ⚠ WORDING CORRECTED S14 — the behaviour was right, the description was not.
    //
    // It used to read "retained through every founding, instead of being re-bought
    // with marks each era", which describes RETENTION and implies you must have
    // owned Auto-Raid Protocol already. `foundSyndicateCore` has always granted it
    // outright, bought or not, and that is the intent: reaching L3 is what
    // automates L1 for good. The old wording made a correct grant look like a
    // 5-Writ exploit on a 300-mark upgrade.
    //
    // The Command upgrade still earns its price as EARLY ACCESS. Measured: a
    // player who banks everything and buys nothing else reaches 300 marks around
    // day 16, against a first founding at day 25 — so it buys about nine days of
    // hands-off raiding, paid for by going without Officer Academy, Forward Depot
    // and Field Conditioning in the meantime. A real trade, not a formality, and
    // nowhere near "automated a few days in".
    "standing-orders": {
        name: "Standing Orders",
        icon: "\uD83D\uDCCB",
        flavor: "The orders outlive the officers who wrote them.",
        effect: "Every founding starts the new era with Auto-Raid Protocol and Auto-Fabricator running \u2014 whether or not Command ever bought them.",
        effectHint: "foundSyndicateCore: grants auto-raid-protocol + auto-fabricator into the fresh command.upgrades",
        costs: [
            5
        ],
        effectValues: [
            true
        ]
    },
    "succession-doctrine": {
        name: "Succession Doctrine",
        icon: "\uD83D\uDD4A\uFE0F",
        flavor: "No chair stays empty long enough to matter.",
        effect: "Promotes at peak marks rate and raises the successor from your template, hands-off.",
        effectHint: "syndicate-core: peak-age policy, evaluated at raid end (requires auto-raid-protocol + auto-fabricator)",
        costs: [
            16
        ],
        effectValues: [
            true
        ],
        // COMMAND upgrades, not charters: the dependency crosses layers on purpose.
        //
        // BOTH, because this charter promotes on the MARKS RATE and 71% of a
        // character's marks are crafting-derived (see `auto-fabricator` in
        // commandUpgrades.js for the measurement). Automating the raid but not the
        // workshop would have this policy promoting off a third of the income it
        // was calibrated against — raid -> craft -> marks -> promote is the loop,
        // and three of four steps automates nothing.
        //
        // `requiresName` is now only a fallback: both upgrades ship in the catalog,
        // so the live name wins. It is kept because it costs nothing and the lock
        // line leaks a raw slug without it if an id is ever renamed.
        requires: [
            "auto-raid-protocol",
            "auto-fabricator"
        ],
        requiresName: "Auto-Raid Protocol"
    },
    "operations-charter": {
        name: "Operations Charter",
        icon: "\uD83D\uDDFA\uFE0F",
        flavor: "Signed routes, sealed manifests, and somebody else's problem at the far end.",
        effect: "Unlocks Operations, and licenses 1 / 2 / 3 concurrent operations.",
        effectHint: "operations: concurrent slot cap = min(this, leader + idle era-Legends)",
        costs: [
            8,
            20,
            45
        ],
        effectValues: [
            1,
            2,
            3
        ]
    },
    "founders-endowment": {
        name: "Founder's Endowment",
        icon: "\uD83C\uDFDB\uFE0F",
        flavor: "Every charter opens with a line of credit against its own reputation.",
        effect: "Each new Command era starts with 100 / 250 / 500 marks.",
        effectHint: "foundSyndicateCore: seeds command.marks after the wipe",
        costs: [
            10,
            25,
            60
        ],
        effectValues: [
            100,
            250,
            500
        ]
    },
    // ⚠ REPURPOSED IN S14, from "Command upgrades cost 20/35/50% less".
    //
    // The discount was a DEAD CHARTER, and measurably so: a batch of 8 runs with
    // the discount forced to 90% moved the era-pacing targets not at all
    // (foundings by day 71: 2.63 before, 2.63 after). Command upgrade cost is
    // simply not what sets era length.
    //
    // What does: era length = Legends required x tour length, and TOUR LENGTH
    // CANNOT BE MOVED BY POWER. The promotion policy ends a tour when the
    // incumbent's marks rate falls below what a fresh recruit averages, and that
    // benchmark is measured from the player's own last three tours — so any
    // uniform buff lifts both sides and the crossover never moves. Three
    // independent buffs confirmed it (see docs/layers/3-syndicate/implementation.md § 2026-08-03 "Era pacing").
    //
    // That leaves the Legend requirement as the only lever on era pacing, which
    // is why this charter now spends its ranks there. It is also the layer's own
    // fantasy stated literally: each Syndicate you found makes the next one
    // easier to found.
    "institutional-memory": {
        name: "Institutional Memory",
        icon: "\uD83D\uDCDA",
        flavor: "The second time a thing is built, nobody pays to learn it again.",
        effect: "Found the next Syndicate with 3 / 5 / 6 fewer Legends.",
        effectHint: "foundingLegendRequirement: subtracts from the Legend gate",
        costs: [
            12,
            16,
            26
        ],
        effectValues: [
            3,
            5,
            6
        ]
    },
    "provision-contracts": {
        name: "Provision Contracts",
        icon: "\uD83D\uDCE6",
        flavor: "Bulk rates, negotiated once, honoured across the whole planet.",
        effect: "Operation cargo costs 25 / 40% less.",
        effectHint: "operations: cargo deduction at launch",
        costs: [
            15,
            40
        ],
        effectValues: [
            0.25,
            0.4
        ]
    },
    "blackout-sanction": {
        name: "Blackout Sanction",
        icon: "\uD83C\uDF11",
        flavor: "Authorisation to run the jobs that were never filed.",
        effect: "Unlocks Blackout Contracts - optional raids under hard modifiers, each paying a permanent perk.",
        effectHint: "raid planning: blackout toggle; perks via getBlackoutPerk",
        costs: [
            30
        ],
        effectValues: [
            true
        ]
    }
};
var $979b99378be707cd$export$e3c642cf362e5b0d = {
    width: 17,
    height: 9,
    // Region ownership. Digits index `regionOrder` below.
    // Row strings are the authoring format: a 153-entry array is unreadable and
    // undiffable, and this is meant to be edited by hand.
    //
    // Flooded Bastions holds a foothold on the EASTERN shore (row 6, column 13),
    // across the strait. Not decoration: Hollow Core's capital is the far side of
    // that water, and with staging points restricted to land there was no
    // other-region land within a Short Haul's reach of it — the destination
    // silently offered no route at all. A region named for water spanning some is
    // also the least strange way to fix it.
    //
    // Boundaries deliberately WOBBLE row to row rather than running straight
    // down. Straight columns read as a bar chart; an irregular border reads as
    // territory. Each region's run must still overlap its own run in the
    // neighbouring rows or the territory splits into islands — worldMap.test.js
    // fails on that, and it is the easy mistake to make while editing these.
    regionRows: [
        "11112223334444555",
        "11122233344455555",
        "11122233334445555",
        "11112223334445555",
        "11112223334444555",
        "11122233344445555",
        "11112223334444555",
        "11122233334445555",
        "11112223334444555"
    ],
    // Terrain, drawn as CONTINENTS rather than textured ground.
    //
    // 9 rows, not 7: 17x9 is close to the 2:1 of an equirectangular world map,
    // and the extra rows are what give the landmasses room to have a shape at all.
    // The old 7-row grid matched a Tier-3 raid map, but that parity was already
    // vestigial — the world map has its own CSS-grid renderer and never used the
    // raid grid's layout.
    //
    // Ocean is `~`, which is PASSABLE at cost 3. That is what keeps every region
    // routable no matter how the coastline is drawn: a strait is a toll, never a
    // wall. Land is deliberately connected east-west through the middle rows so
    // routes stay overland and the cost model barely moves; the one real crossing
    // is the strait at columns 11-13, which puts Hollow Core genuinely across a
    // sea and costs about a quarter of a Grand Circuit to reach.
    //
    // `#` is true impassable and is used only for a couple of inland peaks. Ocean
    // being passable means a peak can never strand a region.
    //
    // THE BORDER IS ALL OCEAN — row 0, row 8, column 0 and column 16. That frame
    // is what makes the grid read as a world rather than as a cropped tile sheet,
    // and it also guarantees no route or staging point can be pinned against an
    // edge with nowhere to go. Keep it when editing.
    terrainRows: [
        "~~~~~~~~~~~~~~~~~",
        "~..^..~~.^..~~..~",
        "~...^.~..^..~.^.~",
        "~~.^..^...^~~..^~",
        "~.....#~..^..~..~",
        "~.^...~~....~~.^~",
        "~~..^.~~~..~~...~",
        "~~~.^~~~~.^~~~..~",
        "~~~~~~~~~~~~~~~~~"
    ],
    // Digit -> region id. Order is west-to-east, which is also longitude order.
    regionOrder: {
        "1": "cradle-expanse",
        "2": "shard-cities",
        "3": "verdant-reclamation",
        "4": "sunken-bastions",
        "5": "hollow-core"
    },
    // Where convoys actually depart from and arrive at. A region is an area, but
    // a route needs a point — this is that point. Every capital must sit inside
    // its own territory and on passable ground; worldMap.test.js enforces both,
    // because either mistake produces a region that silently cannot be reached.
    capitals: {
        "cradle-expanse": {
            row: 2,
            col: 2
        },
        "shard-cities": {
            row: 4,
            col: 5
        },
        "verdant-reclamation": {
            row: 3,
            col: 8
        },
        "sunken-bastions": {
            row: 5,
            col: 11
        },
        "hollow-core": {
            row: 6,
            col: 15
        }
    },
    terrainCost: {
        ".": 1,
        "^": 2,
        "~": 3,
        "#": null
    }
};


//done







//done
//@ts-check



/**
 * Debug logging - channel-gated, silent by default.
 *
 * Shared by the browser game and the headless simulator. Both used to
 * console.log unconditionally from the same -core.js modules, which meant the
 * game spammed the devtools console and a 90-day simulator run produced a
 * ~169MB log that had to be grepped to find anything.
 *
 * Nothing here prints unless a channel is explicitly enabled:
 *
 *   Browser:   localStorage.setItem('debug', 'raid,events')
 *   Node:      DEBUG=raid,events node tools/simulation/game-simulator.js
 *   Either:    setDebugChannels(['raid'])   // programmatic
 *
 * '*' enables everything. Channel names are the CHANNELS keys below.
 *
 * Use isDebug() to guard any message whose ARGUMENTS are expensive to build -
 * debug() itself is cheap when disabled, but its arguments are still evaluated
 * at the call site:
 *
 *   if (isDebug(CH.loot)) debug(CH.loot, `pool: ${buildExpensiveSummary()}`);
 */ /** Channel names. Use these constants rather than bare strings. */ 
var $fb5bf89946773306$export$31ff2235b44019b8 = {
    raid: 'raid',
    events: 'events',
    loot: 'loot',
    craft: 'craft',
    path: 'path',
    sim: 'sim',
    ui: 'ui'
};
var $fb5bf89946773306$var$ALL_CHANNELS = Object.values($fb5bf89946773306$export$31ff2235b44019b8);
/** @type {Set<string>} */ var $fb5bf89946773306$var$enabled = new Set();
function $fb5bf89946773306$var$parseSpec(spec) {
    if (!spec) return [];
    return String(spec).split(/[\s,]+/).map(function(s) {
        return s.trim();
    }).filter(Boolean);
}
function $fb5bf89946773306$export$c2ead4c5b33bf75(channels) {
    var list = Array.isArray(channels) ? channels : $fb5bf89946773306$var$parseSpec(channels);
    $fb5bf89946773306$var$enabled = list.includes('*') ? new Set($fb5bf89946773306$var$ALL_CHANNELS) : new Set(list);
}
function $fb5bf89946773306$export$bc5e1b10378f79c6() {
    return (0, $4c858c0d999a5b9b$export$71511d61b312f219)($fb5bf89946773306$var$enabled);
}
function $fb5bf89946773306$export$5540f6562bfea743(channel) {
    return $fb5bf89946773306$var$enabled.has(channel);
}
function $fb5bf89946773306$export$1c9f709888824e05(channel) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    var _console;
    if ($fb5bf89946773306$var$enabled.has(channel)) (_console = console).log.apply(_console, [
        "[".concat(channel, "]")
    ].concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)(args)));
}
// --- Auto-configure from the ambient environment -------------------------
// Wrapped in try/catch: `process` is undefined in the browser and
// `localStorage` throws in some sandboxed/SSR contexts.
try {
    if (typeof localStorage !== 'undefined') {
        var $fb5bf89946773306$var$spec = localStorage.getItem('debug');
        if ($fb5bf89946773306$var$spec) $fb5bf89946773306$export$c2ead4c5b33bf75($fb5bf89946773306$var$spec);
    }
} catch (e) {
/* leave all channels disabled */ }


var $ca7af38ea7b7b4a8$var$allItems = (0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$39df1497f8fcc025 || []).concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$2508a374b14b8e59 || []), (0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$241bdd39c3e59b72 || []), (0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$11208b4f926fa7ee || []), (0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$f9575e6a92b5621d || []), (0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$439a14874f0a75e4 || []), (0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$b2b2210935a03dc3 || []), (0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$c1a4d9d859d3b7 || []), (0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$a24b2f292778b5dc || []), (0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$29d1bf8c74230d20 || []), (0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$71b953a5ed5f0cd6 || []), (0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$76261a034023b29 || []), (0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$7a39b013515e9c7d || []), (0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$a4f81eda8633632 || []), (0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$e32476559574be7c || []), (0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$5255cc549327de05 || []), (0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$d3e0e7174c382d10 || []), (0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$d82f13cda8103b44 || []));
function $ca7af38ea7b7b4a8$export$7ac3a88d34a76e7(array) {
    var rand = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Math.random;
    var shuffled = (0, $4c858c0d999a5b9b$export$71511d61b312f219)(array);
    for(var i = shuffled.length - 1; i > 0; i--){
        var j = Math.floor(rand() * (i + 1));
        var ref;
        ref = [
            shuffled[j],
            shuffled[i]
        ], shuffled[i] = ref[0], shuffled[j] = ref[1], ref;
    }
    return shuffled;
}
function $ca7af38ea7b7b4a8$export$913078032f14f7f() {
    var faction = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).events, "Selecting random avatar for faction:", faction);
    var factions = [
        'dominion',
        'veil',
        'wilders'
    ];
    var factionKey = faction || factions[Math.floor(Math.random() * factions.length)];
    var position = Math.floor(Math.random() * 32); // 0-31 for 32 avatars per faction
    return "avatar-".concat(factionKey, "-").concat(position);
}
function $ca7af38ea7b7b4a8$export$f3619081e7e8f116(entity) {
    if (!entity) return "seed";
    return entity.avatarSeed || entity.id || entity.name || entity.avatar || "seed";
}
function $ca7af38ea7b7b4a8$export$f06085c61225102a(entity) {
    var faction = entity && entity.faction || "dominion";
    var attrs = 'data-avatar-seed="'.concat($ca7af38ea7b7b4a8$export$f3619081e7e8f116(entity), '" data-avatar-faction="').concat(faction, '"');
    if (entity && entity.avatarFeatures) {
        var json = JSON.stringify(entity.avatarFeatures).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/'/g, "&#39;");
        attrs += " data-avatar-features='".concat(json, "'");
    }
    return attrs;
}
function $ca7af38ea7b7b4a8$export$182937d2e68a339(skillKey) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // Find the skill in faction data
        for(var _iterator = Object.keys($979b99378be707cd$export$aeeef991191508e2)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var factionKey = _step.value;
            var faction = $979b99378be707cd$export$aeeef991191508e2[factionKey];
            if (faction.skills[skillKey]) return faction.skills[skillKey].name;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return skillKey; // Fallback to raw key
}
function $ca7af38ea7b7b4a8$export$8a18dddc0824814c(skillKey) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // Find the skill in faction data
        for(var _iterator = Object.keys($979b99378be707cd$export$aeeef991191508e2)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var factionKey = _step.value;
            var faction = $979b99378be707cd$export$aeeef991191508e2[factionKey];
            if (faction.skills[skillKey]) return faction.skills[skillKey].icon || "\u2753";
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return "\u2753"; // Fallback icon
}
function $ca7af38ea7b7b4a8$export$7c6f492816bf045e(skillIds) {
    // Get display names for an array of skill IDs
    return skillIds.map(function(skillId) {
        return $ca7af38ea7b7b4a8$export$182937d2e68a339(skillId);
    });
}
// skillId -> faction. Memoized: factionSkills is static config, and this is
// called per-tile and per-room in hot paths.
var $ca7af38ea7b7b4a8$var$skillFactionMap = null;
function $ca7af38ea7b7b4a8$export$a3603dda04ca8111(skillId) {
    if (!$ca7af38ea7b7b4a8$var$skillFactionMap) {
        $ca7af38ea7b7b4a8$var$skillFactionMap = {};
        Object.entries($979b99378be707cd$export$aeeef991191508e2).forEach(function(param) {
            var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), faction = _param[0], def = _param[1];
            Object.keys(def.skills || {}).forEach(function(s) {
                $ca7af38ea7b7b4a8$var$skillFactionMap[s] = faction;
            });
        });
    }
    return $ca7af38ea7b7b4a8$var$skillFactionMap[skillId] || null;
}
function $ca7af38ea7b7b4a8$export$96671014a1dabc4c(effectId) {
    return $979b99378be707cd$export$1aaffaaaf67a009d.find(function(effect) {
        return effect && effect.id === effectId;
    });
}
function $ca7af38ea7b7b4a8$export$b7fbae54a8f17db(techniqueId) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // Find the technique in skill techniques data
        for(var _iterator = Object.values($979b99378be707cd$export$aafe7b77259ba40d)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var faction = _step.value;
            var technique = faction.find(function(t) {
                return t.id === techniqueId;
            });
            if (technique) return technique.name;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return techniqueId; // Fallback to ID if not found
}
function $ca7af38ea7b7b4a8$export$bf5389e28ce4699d(techniqueId) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // Find the technique in skill techniques data
        for(var _iterator = Object.values($979b99378be707cd$export$aafe7b77259ba40d)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var faction = _step.value;
            var technique = faction.find(function(t) {
                return t.id === techniqueId;
            });
            if (technique) return technique.icon;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return techniqueId; // Fallback to ID if not found
}
function $ca7af38ea7b7b4a8$export$a6cb179f21ae932e(techniqueId) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // Find the technique in skill techniques data
        for(var _iterator = Object.values($979b99378be707cd$export$aafe7b77259ba40d)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var skillTechnique = _step.value;
            var technique = skillTechnique.find(function(t) {
                return t.id === techniqueId;
            });
            if (technique) return technique.skill;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null; //null if not found 
}
function $ca7af38ea7b7b4a8$export$31330438f6059b08(itemId) {
    // Find item by ID and return its name
    var item = $ca7af38ea7b7b4a8$export$a2dea178c28a0308('id', itemId);
    return item ? item.name : itemId; // Fallback to ID if not found
}
function $ca7af38ea7b7b4a8$export$dd077d95a65121be(roomName, roomType) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (roomType == 'start') return "\uD83C\uDF00";
    else if (roomType == 'exit') return "\uD83C\uDF0C";
    else if (roomType == 'road') return "\uD83C\uDFC3\u200D\u2640\uFE0F\u200D\u27A1\uFE0F";
    else if (roomType == 'blocked') return "\u26D4";
    else if (roomType == 'campsite') return "\uD83C\uDFD5\uFE0F";
    else if (roomType == 'water') return "\uD83C\uDF0A";
    else try {
        for(var _iterator = Object.values($979b99378be707cd$export$4fbdcec70fce9d73)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var region = _step.value;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = region.gates[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var room = _step1.value;
                    if (room.name === roomName) return room.icon || "\u2753";
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
            try {
                for(var _iterator2 = region.hazards[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                    var room1 = _step2.value;
                    if (room1.name === roomName) return room1.icon || "\u2753";
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                        _iterator2.return();
                    }
                } finally{
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return "\u2753"; // Fallback icon
}
function $ca7af38ea7b7b4a8$export$543ea47e61c0d3ee(room) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // Find the room in region data
        for(var _iterator = Object.keys($979b99378be707cd$export$4fbdcec70fce9d73)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var regionKey = _step.value;
            var region = $979b99378be707cd$export$4fbdcec70fce9d73[regionKey];
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = (0, $4c858c0d999a5b9b$export$71511d61b312f219)(region.gates).concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)(region.hazards))[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var roomData = _step1.value;
                    if (roomData.name === room) return roomData.duration || 60; // Default to 1 minutes if not specified
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return 30; // Fallback to 30 seconds
}
function $ca7af38ea7b7b4a8$export$d7a853631095b479(n) {
    var num = Number(n);
    if (!Number.isFinite(num)) return '0';
    var sign = num < 0 ? '-' : '';
    var abs = Math.abs(num);
    if (abs < 100000) return sign + String(Math.floor(abs));
    var units = [
        {
            limit: 1e12,
            suffix: 'T'
        },
        {
            limit: 1e9,
            suffix: 'B'
        },
        {
            limit: 1e6,
            suffix: 'M'
        },
        {
            limit: 1e3,
            suffix: 'K'
        }
    ];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = units[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = _step.value, limit = _step_value.limit, suffix = _step_value.suffix;
            if (abs < limit) continue;
            var scaled = abs / limit;
            var rounded = scaled < 10 ? Math.round(scaled * 10) / 10 : Math.round(scaled);
            // Rounding can carry past the unit: 999,999 scales to 999.999K, which would
            // render "1000K" instead of "1M". Re-enter one unit up rather than printing
            // a value the next suffix already covers.
            if (rounded >= 1000) return $ca7af38ea7b7b4a8$export$d7a853631095b479(limit * 1000);
            return sign + String(rounded) + suffix;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Beyond the largest unit (>=1000T); no suffix left, so give the raw figure.
    return sign + String(Math.floor(abs));
}
function $ca7af38ea7b7b4a8$export$61fc7d43ac8f84b0(func, delay) {
    var timeoutId; // This will store the ID of the setTimeout
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var context = this; // Preserves the 'this' context of the original function
        clearTimeout(timeoutId); // Clear any existing timeout
        timeoutId = setTimeout(function() {
            func.apply(context, args); // Execute the original export function after the delay
        }, delay);
    };
}
function $ca7af38ea7b7b4a8$export$d7e8d4d4450c819c(title, content) {
    var modal = document.createElement('div');
    modal.className = 'modal';
    modal.innerHTML = '\n        <div class="modal-content max-w-5xl">\n            <div class="modal-header">\n                <h3 class="modal-title">'.concat(title, '</h3>\n                <button class="close-btn">&times;</button>\n            </div>\n            <div class="modal-body">\n                ').concat(content, "\n            </div>\n        </div>\n    ");
    document.body.appendChild(modal);
    var closeBtn = modal.querySelector('.close-btn');
    var closeModal = function() {
        //modal.classList.add('animate__animated', 'animate__fadeOut');
        setTimeout(function() {
            document.body.removeChild(modal);
        }, 150);
    };
    closeBtn.addEventListener('click', closeModal);
    var mousedownTarget = null;
    modal.addEventListener('mousedown', function(e) {
        mousedownTarget = e.target;
    });
    modal.addEventListener('click', function(e) {
        if (e.target === modal && mousedownTarget === modal) closeModal();
    });
    //modal.classList.add('animate__animated', 'animate__fadeIn');
    modal.querySelector('.modal-content').classList.add('animate__animated', 'animate__zoomIn');
}
function $ca7af38ea7b7b4a8$export$a2dea178c28a0308(property, value) {
    return $ca7af38ea7b7b4a8$var$allItems.find(function(item) {
        return item && item[property] === value;
    });
}
function $ca7af38ea7b7b4a8$export$4251a114f7437961(itemIds) {
    var result = {};
    itemIds.forEach(function(id) {
        result[id] = undefined;
    });
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $ca7af38ea7b7b4a8$var$allItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            if (!item) continue;
            if (result.hasOwnProperty(item.id) && result[item.id] === undefined) result[item.id] = item;
            if (result.length == itemIds.length) break;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return result;
}
function $ca7af38ea7b7b4a8$export$891bd687a67340b8(property, value) {
    var allArtifacts = (0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$659d2bfa35449fc3 || []).concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$709aa55c173a48b8 || []));
    return allArtifacts.find(function(artifact) {
        return artifact && artifact[property] === value;
    });
}
function $ca7af38ea7b7b4a8$export$15b7d0c192d0aa5d() {
    return $ca7af38ea7b7b4a8$var$allItems;
}
function $ca7af38ea7b7b4a8$export$18c4115a8e7963b() {
    return (0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$659d2bfa35449fc3 || []).concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$709aa55c173a48b8 || []));
}
function $ca7af38ea7b7b4a8$export$189173d473c82c30(markdown) {
    var mdH1Color = 'amber-400';
    var mdH2Color = 'cyan-300';
    var mdH3Color = 'emerald-400';
    var mdH4Color = 'gray-300';
    var lines = markdown.split('\n');
    var result = [];
    var sections = [];
    var inList = false;
    var sectionId = 0;
    for(var i = 0; i < lines.length; i++){
        var line = lines[i];
        // Headers (check longest first)
        if (line.startsWith('#### ')) {
            if (inList) {
                result.push('</ul>');
                inList = false;
            }
            result.push('<h4 class="text-lg font-bold text-'.concat(mdH4Color, ' mt-4 mb-2">').concat(line.slice(5), "</h4>"));
        } else if (line.startsWith('### ')) {
            if (inList) {
                result.push('</ul>');
                inList = false;
            }
            result.push('<h3 class="text-xl font-bold text-'.concat(mdH3Color, ' mt-6 mb-3">').concat(line.slice(4), "</h3>"));
        } else if (line.startsWith('## ')) {
            if (inList) {
                result.push('</ul>');
                inList = false;
            }
            var title = line.slice(3);
            var id = "section-".concat(sectionId++);
            sections.push({
                id: id,
                title: title
            });
            result.push('<h2 id="'.concat(id, '" class="text-2xl font-bold text-').concat(mdH2Color, ' mt-8 mb-4 scroll-mt-36">').concat(title, "</h2>"));
        } else if (line.startsWith('# ')) {
            if (inList) {
                result.push('</ul>');
                inList = false;
            }
            result.push('<h1 class="text-3xl font-bold text-'.concat(mdH1Color, ' mb-6">').concat(line.slice(2), "</h1>"));
        } else if (line === '---') {
            if (inList) {
                result.push('</ul>');
                inList = false;
            }
            result.push('<hr class="border-gray-700 my-6">');
        } else if (line.startsWith('- ')) {
            if (!inList) {
                result.push('<ul class="list-disc ml-6 space-y-1 mb-4">');
                inList = true;
            }
            var content = line.slice(2);
            content = content.replace(/\*\*(.*?)\*\*/g, '<strong class="font-bold text-white">$1</strong>');
            content = content.replace(/`([^`]+)`/g, '<code class="bg-gray-800 px-2 py-1 rounded text-sm">$1</code>');
            result.push('<li class="ml-4">'.concat(content, "</li>"));
        } else if (line.trim() === '') {
            if (inList) {
                result.push('</ul>');
                inList = false;
            }
            result.push('');
        } else {
            if (inList) {
                result.push('</ul>');
                inList = false;
            }
            var content1 = line;
            content1 = content1.replace(/\*\*(.*?)\*\*/g, '<strong class="font-bold text-white">$1</strong>');
            content1 = content1.replace(/`([^`]+)`/g, '<code class="bg-gray-800 px-2 py-1 rounded text-sm">$1</code>');
            result.push('<p class="mb-3 text-gray-300">'.concat(content1, "</p>"));
        }
    }
    // Close any open list
    if (inList) result.push('</ul>');
    // Build navigation
    var nav = sections.map(function(s) {
        return "<button onclick=\"event.stopPropagation(); document.getElementById('".concat(s.id, "').scrollIntoView({behavior:'smooth',block:'start'})\" class=\"px-3 py-1 text-sm bg-game-accent/25 hover:bg-game-accent/50 hover:text-white text-").concat(mdH2Color, ' rounded transition-colors whitespace-nowrap">').concat(s.title, "</button>");
    }).join('');
    var navBar = '<div class="sticky top-0 z-10 bg-game-bg border-b border-gray-700 p-3 mb-4 flex gap-2 flex-wrap">'.concat(nav, "</div>");
    return navBar + '<div class="p-4">' + result.join('\n') + '</div>';
}


//done
//@ts-check




//done









// Per-tier raid economics — the single shared model behind three consumers
// (ServerAuthoritySaveSecurity.md §4/§6):
//   1. Contract-completion payout (un-hired listing) — uses the *expected*
//      (average) per-raid values.
//   2. Class 3 sync rate ceiling (functions/_lib/rateBounds.js) — uses the
//      *max* per-raid values.
//   3. §6 payment amount cap (future) — max credits/raid × reward %.
//
// Pure, and shared by both the server (Pages Functions, via ../../js/modules/…)
// and the client (character.js withdraw reuses the same threshold, so the two
// can't disagree — one source of truth, no duplicated drift-prone math). A
// `*-core` module by the codebase convention (pure / simulator-safe): reads game
// data live from the generated js/constants.js and REPLICATES the small raid
// formulas from raid-core.js (calculateRaidResults / calculateRaidXP /
// calculateEnergyCost), which read gameState and so can't be imported into a
// Worker. The replication is kept honest by a drift-guard test
// (tests/server/raidEconomics.test.js) that runs the real functions and asserts
// equality — the same pattern characterValidation.js uses for the XP /
// skill-point curves. When a raid formula changes, that test fails and points
// here.
//
// Economy numbers (150, 40, 15, 3, 1.5, scaling multipliers, tier multipliers)
// are read live or replicated-with-drift-guard, so they never drift silently.
// The only hand-tuned values are the LAYOUT estimates below (path geometry and
// step mix) — these describe map shape, not economy, and are shared by every
// consumer so a single edit re-tunes them all.

var $7b2bbc8bf6b24d6d$export$111962ea748d5541 = 1.2;
var $7b2bbc8bf6b24d6d$export$dfb43fbf5890e474 = 0.15;
// Representative gate / hazard step durations (seconds). Road/campsite/water are
// read live from commonAreas below; gates and hazards are consistently 120 / 60
// across regions, so they're pinned here with this note rather than scanned.
var $7b2bbc8bf6b24d6d$var$GATE_SECONDS = 120;
var $7b2bbc8bf6b24d6d$var$HAZARD_SECONDS = 60;
// Average duration of one room (non-road) step: campsite : water : gate : hazard
// blended 1 : 1 : 2 : 2 (the loot-analysis room proportions). road/campsite/water
// read live from commonAreas; gate/hazard pinned above.
function $7b2bbc8bf6b24d6d$var$avgRoomStepSeconds() {
    var _ca_campsite, _ca_water;
    var ca = $979b99378be707cd$export$11209b5126489e67 || {};
    var _ca_campsite_baseDuration;
    var campsite = (_ca_campsite_baseDuration = (_ca_campsite = ca.campsite) === null || _ca_campsite === void 0 ? void 0 : _ca_campsite.baseDuration) !== null && _ca_campsite_baseDuration !== void 0 ? _ca_campsite_baseDuration : 120;
    var _ca_water_baseDuration;
    var water = (_ca_water_baseDuration = (_ca_water = ca.water) === null || _ca_water === void 0 ? void 0 : _ca_water.baseDuration) !== null && _ca_water_baseDuration !== void 0 ? _ca_water_baseDuration : 120;
    return (campsite + water + 2 * $7b2bbc8bf6b24d6d$var$GATE_SECONDS + 2 * $7b2bbc8bf6b24d6d$var$HAZARD_SECONDS) / 6;
}
// Average duration of any path step — road and room blended by ROAD_FRACTION,
// the same knob that sets avg rooms per raid.
function $7b2bbc8bf6b24d6d$var$avgStepSeconds() {
    var _config_commonAreas_road, _config_commonAreas;
    var _config_commonAreas_road_baseDuration;
    var road = (_config_commonAreas_road_baseDuration = (_config_commonAreas = $979b99378be707cd$export$11209b5126489e67) === null || _config_commonAreas === void 0 ? void 0 : (_config_commonAreas_road = _config_commonAreas.road) === null || _config_commonAreas_road === void 0 ? void 0 : _config_commonAreas_road.baseDuration) !== null && _config_commonAreas_road_baseDuration !== void 0 ? _config_commonAreas_road_baseDuration : 10;
    return $7b2bbc8bf6b24d6d$export$dfb43fbf5890e474 * road + (1 - $7b2bbc8bf6b24d6d$export$dfb43fbf5890e474) * $7b2bbc8bf6b24d6d$var$avgRoomStepSeconds();
}
var $7b2bbc8bf6b24d6d$export$2eac5152829c7116 = 0.35;
var $7b2bbc8bf6b24d6d$export$f6115a6882d79c56 = 0.8;
var $7b2bbc8bf6b24d6d$export$b434154783011c86 = 30;
var $7b2bbc8bf6b24d6d$export$bd84fb7c03d78e1e = 100;
// --- Replicated raid formulas (drift-guarded) ------------------------------
// Success-branch of calculateRaidResults, WITHOUT the per-player currency-bonus
// artifact and full team survival — a baseline the server can compute for
// anyone. The recipient's own Contract Beacon still applies on collection.
function $7b2bbc8bf6b24d6d$var$raidCreditsBase(tier, rooms) {
    var survivalBonus = 50; // floor(1.0 × 50), full survival
    return tier * 150 + rooms * 40 + survivalBonus;
}
// Credit scaling choke-point (raidUtil.js applyCreditsScaling) minus the
// per-player currency-bonus artifact. The runtime copies these multipliers into
// raidUtil via setCreditsScaling at init; the SSOT is the data below, which the
// server reads directly. (progressionScaling.creditsScaling, NOT a top-level
// config.creditsScaling — that doesn't exist and would silently no-op.)
function $7b2bbc8bf6b24d6d$var$scaleCredits(creditsBase, tier) {
    var _config_progressionScaling, _cs_tierMultipliers;
    var cs = ((_config_progressionScaling = $979b99378be707cd$export$9f9786ac427715c7) === null || _config_progressionScaling === void 0 ? void 0 : _config_progressionScaling.creditsScaling) || {};
    var _cs_globalMultiplier;
    var global = (_cs_globalMultiplier = cs.globalMultiplier) !== null && _cs_globalMultiplier !== void 0 ? _cs_globalMultiplier : 1;
    var _cs_tierMultipliers_tier;
    var tierMult = (_cs_tierMultipliers_tier = (_cs_tierMultipliers = cs.tierMultipliers) === null || _cs_tierMultipliers === void 0 ? void 0 : _cs_tierMultipliers[tier]) !== null && _cs_tierMultipliers_tier !== void 0 ? _cs_tierMultipliers_tier : 1;
    return Math.floor(creditsBase * global * tierMult);
}
// calculateRaidXP, success branch. difficultyBonus assumes an adequate team
// (0); fullPathBonus assumes the path is completed (10). tierMult read live.
function $7b2bbc8bf6b24d6d$var$raidXpValue(tier, rooms) {
    var _config_progressionScaling_raidXpTierMultipliers, _config_progressionScaling;
    var baseXP = tier * 15;
    var roomBonus = rooms * 3;
    var fullPathBonus = 10;
    var tierMult = ((_config_progressionScaling = $979b99378be707cd$export$9f9786ac427715c7) === null || _config_progressionScaling === void 0 ? void 0 : (_config_progressionScaling_raidXpTierMultipliers = _config_progressionScaling.raidXpTierMultipliers) === null || _config_progressionScaling_raidXpTierMultipliers === void 0 ? void 0 : _config_progressionScaling_raidXpTierMultipliers[tier]) || 1;
    return Math.max(5, Math.floor((baseXP + roomBonus + fullPathBonus) * 1.5 * tierMult));
}
// Energy cost for a raid (calculateEnergyCost) at baseline (no reduction
// artifact): base per tier + 1 energy / 2 min of duration.
function $7b2bbc8bf6b24d6d$var$energyForRaid(tier, seconds) {
    var baseCost = 5 + (tier - 1) * 5;
    return baseCost + Math.ceil(seconds / 120);
}
function $7b2bbc8bf6b24d6d$export$b0d36f436a85648b(tier) {
    var _config_raidTierData;
    var t = (_config_raidTierData = $979b99378be707cd$export$94e7ad7999c1ae32) === null || _config_raidTierData === void 0 ? void 0 : _config_raidTierData[tier];
    var _t_gridRows;
    var rows = (_t_gridRows = t === null || t === void 0 ? void 0 : t.gridRows) !== null && _t_gridRows !== void 0 ? _t_gridRows : 7;
    var _t_gridCols;
    var cols = (_t_gridCols = t === null || t === void 0 ? void 0 : t.gridCols) !== null && _t_gridCols !== void 0 ? _t_gridCols : 7;
    return (rows + cols - 1) * $7b2bbc8bf6b24d6d$export$111962ea748d5541;
}
function $7b2bbc8bf6b24d6d$export$ff894ad244f3f26e(tier) {
    var path = $7b2bbc8bf6b24d6d$export$b0d36f436a85648b(tier);
    var avgRaidSeconds = Math.round(path * $7b2bbc8bf6b24d6d$var$avgStepSeconds());
    var avgRooms = Math.max(1, Math.round(path * (1 - $7b2bbc8bf6b24d6d$export$dfb43fbf5890e474)));
    return {
        avgRooms: avgRooms,
        avgRaidSeconds: avgRaidSeconds,
        expectedCredits: $7b2bbc8bf6b24d6d$var$scaleCredits($7b2bbc8bf6b24d6d$var$raidCreditsBase(tier, avgRooms), tier),
        expectedXp: $7b2bbc8bf6b24d6d$var$raidXpValue(tier, avgRooms),
        energyPerRaid: $7b2bbc8bf6b24d6d$var$energyForRaid(tier, avgRaidSeconds)
    };
}
function $7b2bbc8bf6b24d6d$export$e81885fa95b80c17(tier) {
    var maxRooms = Math.ceil($7b2bbc8bf6b24d6d$export$b0d36f436a85648b(tier));
    return {
        maxRooms: maxRooms,
        maxCredits: $7b2bbc8bf6b24d6d$var$scaleCredits($7b2bbc8bf6b24d6d$var$raidCreditsBase(tier, maxRooms), tier),
        maxXp: $7b2bbc8bf6b24d6d$var$raidXpValue(tier, maxRooms)
    };
}
function $7b2bbc8bf6b24d6d$export$64ee8aa79ce9e2e2() {
    var best = 0;
    for(var _i = 0, _iter = [
        1,
        2,
        3
    ]; _i < _iter.length; _i++){
        var tier = _iter[_i];
        var o = $7b2bbc8bf6b24d6d$export$ff894ad244f3f26e(tier);
        if (o.energyPerRaid > 0) best = Math.max(best, o.expectedXp / o.energyPerRaid);
    }
    return best;
}
function $7b2bbc8bf6b24d6d$export$436943fd760cb0d6(param) {
    var commandMult = param.commandMult, contractorFactor = param.contractorFactor;
    return $7b2bbc8bf6b24d6d$export$b434154783011c86 * $7b2bbc8bf6b24d6d$export$64ee8aa79ce9e2e2() * commandMult * contractorFactor;
}
function $7b2bbc8bf6b24d6d$export$1d3299ce9f331b73(param) {
    var commandMult = param.commandMult, contractorFactor = param.contractorFactor;
    return $7b2bbc8bf6b24d6d$export$bd84fb7c03d78e1e * $7b2bbc8bf6b24d6d$export$64ee8aa79ce9e2e2() * commandMult * contractorFactor;
}
function $7b2bbc8bf6b24d6d$export$2c281a3f7943bcb5(level) {
    var tiers = $979b99378be707cd$export$94e7ad7999c1ae32 || {};
    for(var _i = 0, _iter = [
        3,
        2,
        1
    ]; _i < _iter.length; _i++){
        var tier = _iter[_i];
        var band = tiers[tier];
        if (!band) continue;
        var _band_contractorMinLevel;
        var min = (_band_contractorMinLevel = band.contractorMinLevel) !== null && _band_contractorMinLevel !== void 0 ? _band_contractorMinLevel : 0;
        var _band_contractorMaxLevel;
        var max = (_band_contractorMaxLevel = band.contractorMaxLevel) !== null && _band_contractorMaxLevel !== void 0 ? _band_contractorMaxLevel : 999;
        if (level >= min && level <= max) return tier;
    }
    return 1;
}
function $7b2bbc8bf6b24d6d$export$8859df5e0e511018(param) {
    var level = param.level, durationHours = param.durationHours, rewardPercentage = param.rewardPercentage;
    var tier = $7b2bbc8bf6b24d6d$export$2c281a3f7943bcb5(level);
    var out = $7b2bbc8bf6b24d6d$export$ff894ad244f3f26e(tier);
    var raidingSeconds = (durationHours || 0) * 3600 * $7b2bbc8bf6b24d6d$export$2eac5152829c7116;
    var simulatedRaids = Math.floor(raidingSeconds / out.avgRaidSeconds);
    if (simulatedRaids < 1) // Below the minimum: the listing didn't last one average raid's worth of
    // assumed raiding time.
    return {
        qualifies: false,
        simulatedRaids: 0,
        tier: tier,
        credits: 0,
        xp: 0
    };
    var pct = rewardPercentage || 15;
    var credits = Math.floor(simulatedRaids * out.expectedCredits * pct / 100);
    var xp = Math.floor(simulatedRaids * out.expectedXp * $7b2bbc8bf6b24d6d$export$f6115a6882d79c56);
    return {
        qualifies: true,
        simulatedRaids: simulatedRaids,
        tier: tier,
        credits: credits,
        xp: xp
    };
}
function $7b2bbc8bf6b24d6d$export$bc8ed87c3bd68f91(level) {
    var out = $7b2bbc8bf6b24d6d$export$ff894ad244f3f26e($7b2bbc8bf6b24d6d$export$2c281a3f7943bcb5(level));
    return out.avgRaidSeconds / (3600 * $7b2bbc8bf6b24d6d$export$2eac5152829c7116);
}


/**
 * Game State Core - Pure Data Structure
 *
 * Defines the core game state structure without any browser/Alpine dependencies.
 * This is the pure data structure that can be used in both browser and Node.js.
 * UI updates and Alpine reactivity are handled in gameState.js.
 */ 



var $fb87f08ff5f65798$export$9badeb9b04b4b71c = '0.1.765';



var $fe47a452a83d9e00$export$d0f77b711cc9be6c = 3;
function $fe47a452a83d9e00$export$e178d880fd9e46ee(parsed, knownSkillIds) {
    var _parsed_gameState, _parsed_gameState1;
    var known = knownSkillIds instanceof Set ? knownSkillIds : new Set(knownSkillIds || []);
    var chars = (0, $4c858c0d999a5b9b$export$71511d61b312f219)((parsed === null || parsed === void 0 ? void 0 : (_parsed_gameState = parsed.gameState) === null || _parsed_gameState === void 0 ? void 0 : _parsed_gameState.characters) || []).concat([
        parsed === null || parsed === void 0 ? void 0 : (_parsed_gameState1 = parsed.gameState) === null || _parsed_gameState1 === void 0 ? void 0 : _parsed_gameState1.character
    ]).filter(function(c) {
        return c && c.skills && Object.keys(c.skills).length > 0;
    });
    if (chars.length === 0) return false; // no skill data to strand
    return chars.some(function(c) {
        return Object.keys(c.skills).some(function(id) {
            return !known.has(id);
        });
    });
}
function $fe47a452a83d9e00$export$f70dbb2553d659e4(faction, skills) {
    var _config_factionSkills_faction;
    var factionSkills = (_config_factionSkills_faction = $979b99378be707cd$export$aeeef991191508e2[faction]) === null || _config_factionSkills_faction === void 0 ? void 0 : _config_factionSkills_faction.skills;
    if (!factionSkills) return (0, $fa9769297b8a68c8$export$71511d61b312f219)({}, skills || {});
    var filled = {};
    var _skills_skillId;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.keys(factionSkills)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var skillId = _step.value;
            filled[skillId] = (_skills_skillId = skills === null || skills === void 0 ? void 0 : skills[skillId]) !== null && _skills_skillId !== void 0 ? _skills_skillId : 0;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return filled;
}
function $fe47a452a83d9e00$export$f1ea15c7da3a01d1(character) {
    if (!character) return;
    if (!character.equippedTechniqueGear) character.equippedTechniqueGear = {};
    if (!character.techniqueTabSelections) character.techniqueTabSelections = {};
    if (!character.synergyUnlocks) character.synergyUnlocks = {};
    character.skills = $fe47a452a83d9e00$export$f70dbb2553d659e4(character.faction, character.skills);
}
function $fe47a452a83d9e00$export$d79000c880c47c99() {
    return {
        marks: 0,
        tour: 1,
        legends: [],
        upgrades: {},
        charterRegions: [],
        vault: {},
        unlockedArtifacts: [],
        grandfathered: false,
        revealed: false
    };
}
function $fe47a452a83d9e00$export$ddc99ec3c98bbb0a() {
    return {
        writs: 0,
        founded: 0,
        eraMarks: 0,
        totalTours: 0,
        upgrades: {},
        leader: null,
        pastLeaders: [],
        operations: [],
        opsCompleted: 0,
        // The Guild Vault's two operations-side stores. Both live here rather
        // than on `command` because founding REBUILDS that branch from defaults;
        // same reason `eraMarks` and `succession` sit here.
        //
        // consignment — what this Command era has banked for the NEXT founding.
        //   Every promotion splits the outgoing character's materials:
        //   progressionScaling.vaultCarryover keeps a share for the next recruit
        //   (command.vault) and the remainder lands here instead of being
        //   destroyed. Folded into `stores` at founding, then cleared.
        //
        // stores — the founded Syndicate's dock, and the ONLY thing convoys
        //   load from. Filled at founding and spent down over the era; the
        //   current era's promotions feed `consignment`, not this, because that
        //   era is building the next Syndicate, not resupplying this one.
        //
        // Two fields, not one: founding is repeatable. Collapsing them would
        // make every promotion silently top up the live dock and delete the
        // per-era budget entirely.
        //
        // Account-level on purpose. Cargo used to draw from the ACTIVE
        // character's inventory, which meant switching character — or being
        // auto-promoted mid-plan — could invalidate a planned operation and
        // would have broken Operations automation outright.
        consignment: {},
        stores: {},
        // Market saturation: "regionId:faction" -> { level, at }. How much of
        // each region's appetite for each faction's goods is already spent, and
        // when that was last measured — demand-core decays it on read rather
        // than ticking it. Survives founding on purpose (see satiationLevel):
        // it is a fact about the world's markets, not about an era.
        demand: {},
        blackout: {
            cleared: {}
        },
        // Succession Doctrine bookkeeping for the CURRENT Command tour. Lives
        // here rather than on `command` because founding wipes that branch and
        // this is Syndicate machinery; it is reset per tour at promotion.
        succession: {
            tourRaids: 0,
            peakRate: 0,
            peakAtRaid: 0,
            paused: false,
            template: null
        },
        revealed: false
    };
}
function $fe47a452a83d9e00$export$6b22d50e3ddf4789(character) {
    if (character && !character.lifetime) character.lifetime = {
        t3Wins: 0,
        artifactsCrafted: 0,
        artifactsUnlocked: 0
    };
    // Backfill the field on pre-existing saves/characters
    if ((character === null || character === void 0 ? void 0 : character.lifetime) && character.lifetime.artifactsUnlocked == null) character.lifetime.artifactsUnlocked = 0;
    return character === null || character === void 0 ? void 0 : character.lifetime;
}
var $fe47a452a83d9e00$export$8e361a1ffbebf172 = {
    schemaVersion: $fe47a452a83d9e00$export$d0f77b711cc9be6c,
    gameVersion: (0, $fb87f08ff5f65798$export$9badeb9b04b4b71c),
    player: {
        credits: 1000,
        energy: 100,
        maxEnergy: 100,
        lastEnergyUpdate: Date.now(),
        achievements: {},
        // Collapse Keys recovered, by id. ACCOUNT-LEVEL ON PURPOSE: the player
        // object is saved and restored whole and is never rebuilt by a
        // promotion or a founding, so the story survives every prestige without
        // an entry in any reset ledger. A wipe that erased the story would be
        // indefensible, and the cheapest way to guarantee that is to put the
        // record somewhere the wipes cannot reach.
        // See js/modules/collapseKeys-core.js.
        collapseKeys: []
    },
    character: null,
    characters: [],
    activeCharacterId: null,
    contractors: [],
    selectedFaction: null,
    currentRaid: {
        currentRaidGrid: null,
        selectedPath: [],
        selectedRegion: null,
        selectedTier: null,
        // {row, col} on the world map — WHERE in the region this raid is
        // happening. Rolled with the grid, read by the world clock (M3 S9).
        // BELONGS TO THE GRID: meaningless without `currentRaidGrid`, and
        // readers must check that rather than trust the field alone. Two
        // separate teardown paths null the grid (resetRaidCore and main.js's
        // performRaidCancel, which duplicates it inline), so a rule that has to
        // be re-stated in each of them is a rule that will be missed in the
        // third one.
        raidSite: null,
        raidInProgress: null,
        raidCompleted: false,
        completedRaidInfo: null,
        raidOwnerId: null,
        hiredContractors: [],
        reservedContractors: []
    },
    command: $fe47a452a83d9e00$export$d79000c880c47c99(),
    syndicate: $fe47a452a83d9e00$export$ddc99ec3c98bbb0a()
};
function $fe47a452a83d9e00$export$bda034a0354b67bb(character) {
    if (!character) return character;
    return character.id === $fe47a452a83d9e00$export$8e361a1ffbebf172.activeCharacterId && $fe47a452a83d9e00$export$8e361a1ffbebf172.character ? $fe47a452a83d9e00$export$8e361a1ffbebf172.character : character;
}
function $fe47a452a83d9e00$export$e12c04bc0206ba64() {
    // Save current character's inventory, artifacts, and equipped artifacts before saving
    //console.log('Current character:', gameState.character);
    if ($fe47a452a83d9e00$export$8e361a1ffbebf172.character && $fe47a452a83d9e00$export$8e361a1ffbebf172.activeCharacterId) {
        var currentCharIndex = $fe47a452a83d9e00$export$8e361a1ffbebf172.characters.findIndex(function(c) {
            return c.id === $fe47a452a83d9e00$export$8e361a1ffbebf172.activeCharacterId;
        });
        if (currentCharIndex !== -1) $fe47a452a83d9e00$export$8e361a1ffbebf172.characters[currentCharIndex] = (0, $fa9769297b8a68c8$export$71511d61b312f219)({}, $fe47a452a83d9e00$export$8e361a1ffbebf172.characters[currentCharIndex], $fe47a452a83d9e00$export$8e361a1ffbebf172.character);
        (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).sim, 'Saved character:', $fe47a452a83d9e00$export$8e361a1ffbebf172.characters[currentCharIndex]);
    }
    var saveData = {
        version: '1.0',
        timestamp: Date.now(),
        gameState: {
            schemaVersion: $fe47a452a83d9e00$export$d0f77b711cc9be6c,
            gameVersion: (0, $fb87f08ff5f65798$export$9badeb9b04b4b71c),
            player: $fe47a452a83d9e00$export$8e361a1ffbebf172.player,
            character: $fe47a452a83d9e00$export$8e361a1ffbebf172.character,
            characters: $fe47a452a83d9e00$export$8e361a1ffbebf172.characters || [],
            activeCharacterId: $fe47a452a83d9e00$export$8e361a1ffbebf172.activeCharacterId,
            selectedFaction: $fe47a452a83d9e00$export$8e361a1ffbebf172.selectedFaction,
            contractors: $fe47a452a83d9e00$export$8e361a1ffbebf172.contractors,
            currentRaid: $fe47a452a83d9e00$export$8e361a1ffbebf172.currentRaid,
            settings: $fe47a452a83d9e00$export$8e361a1ffbebf172.settings || {},
            command: $fe47a452a83d9e00$export$8e361a1ffbebf172.command || $fe47a452a83d9e00$export$d79000c880c47c99(),
            syndicate: $fe47a452a83d9e00$export$8e361a1ffbebf172.syndicate || $fe47a452a83d9e00$export$ddc99ec3c98bbb0a()
        }
    };
    return saveData;
}
function $fe47a452a83d9e00$export$5a216aa68e49a7fc(parsed) {
    var _parsed_gameState, _parsed_gameState1, _gameState_command;
    (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).sim, 'Loading data:', parsed);
    var _parsed_gameState_schemaVersion;
    // Schema version the save was written at (absent → predates the stamp, treat
    // as 1). The field-level migrations below are additive/idempotent; gate any
    // future version-specific migration on savedVersion, then the state is
    // stamped to the current version at the end of this function.
    var savedVersion = (_parsed_gameState_schemaVersion = parsed === null || parsed === void 0 ? void 0 : (_parsed_gameState = parsed.gameState) === null || _parsed_gameState === void 0 ? void 0 : _parsed_gameState.schemaVersion) !== null && _parsed_gameState_schemaVersion !== void 0 ? _parsed_gameState_schemaVersion : 1;
    var savedGameVersion = parsed === null || parsed === void 0 ? void 0 : (_parsed_gameState1 = parsed.gameState) === null || _parsed_gameState1 === void 0 ? void 0 : _parsed_gameState1.gameVersion; // which build wrote it (provenance)
    // Restore game state - handle both new player object format and legacy format
    if (parsed.gameState.player) $fe47a452a83d9e00$export$8e361a1ffbebf172.player = parsed.gameState.player;
    else // Migrate legacy format
    $fe47a452a83d9e00$export$8e361a1ffbebf172.player = {
        credits: parsed.gameState.credits !== undefined ? parsed.gameState.credits : 1000,
        energy: parsed.gameState.energy !== undefined ? parsed.gameState.energy : 100,
        maxEnergy: parsed.gameState.maxEnergy || 100,
        lastEnergyUpdate: parsed.gameState.lastEnergyUpdate || Date.now(),
        achievements: parsed.gameState.achievements || {}
    };
    // Restore currentRaid - handle both new format and legacy format
    if (parsed.gameState.currentRaid) $fe47a452a83d9e00$export$8e361a1ffbebf172.currentRaid = parsed.gameState.currentRaid;
    else // Migrate legacy format
    $fe47a452a83d9e00$export$8e361a1ffbebf172.currentRaid = {
        currentRaidGrid: parsed.gameState.currentRaidGrid || null,
        selectedPath: parsed.gameState.selectedPath || [],
        selectedRegion: parsed.gameState.selectedRegion || null,
        selectedTier: parsed.gameState.selectedTier || null,
        raidInProgress: parsed.gameState.raidInProgress || null,
        raidCompleted: parsed.gameState.raidCompleted || false,
        completedRaidInfo: parsed.gameState.completedRaidInfo || null,
        raidOwnerId: parsed.gameState.raidOwnerId || null,
        hiredContractors: parsed.gameState.hiredContractors || [],
        reservedContractors: parsed.gameState.reservedContractors || []
    };
    $fe47a452a83d9e00$export$8e361a1ffbebf172.character = parsed.gameState.character || null;
    $fe47a452a83d9e00$export$8e361a1ffbebf172.characters = parsed.gameState.characters || [];
    $fe47a452a83d9e00$export$8e361a1ffbebf172.activeCharacterId = parsed.gameState.activeCharacterId || null;
    // Command layer (M2): restore or initialize. Saves from before the Command
    // layer keep unrestricted region access (grandfathered) so nobody loses
    // regions mid-campaign; region locks apply to fresh accounts and onward.
    if (parsed.gameState.command) $fe47a452a83d9e00$export$8e361a1ffbebf172.command = (0, $fa9769297b8a68c8$export$71511d61b312f219)({}, $fe47a452a83d9e00$export$d79000c880c47c99(), parsed.gameState.command);
    else {
        $fe47a452a83d9e00$export$8e361a1ffbebf172.command = $fe47a452a83d9e00$export$d79000c880c47c99();
        if ($fe47a452a83d9e00$export$8e361a1ffbebf172.characters.length > 0) $fe47a452a83d9e00$export$8e361a1ffbebf172.command.grandfathered = true;
    }
    // Syndicate layer (M3): purely additive, so v2 saves need no migration code -
    // they simply shallow-merge onto the defaults and arrive un-revealed with
    // zero Writs, which is exactly the state a pre-Syndicate account is in.
    $fe47a452a83d9e00$export$8e361a1ffbebf172.syndicate = (0, $fa9769297b8a68c8$export$71511d61b312f219)({}, $fe47a452a83d9e00$export$ddc99ec3c98bbb0a(), parsed.gameState.syndicate || {});
    // Lifetime counters (feed the Command Marks formula) - additive migration
    $fe47a452a83d9e00$export$8e361a1ffbebf172.characters.forEach($fe47a452a83d9e00$export$6b22d50e3ddf4789);
    $fe47a452a83d9e00$export$6b22d50e3ddf4789($fe47a452a83d9e00$export$8e361a1ffbebf172.character);
    // Command-era per-character fields (skill gear / synergies): default them so
    // a save from mid-overhaul loads cleanly.
    $fe47a452a83d9e00$export$8e361a1ffbebf172.characters.forEach($fe47a452a83d9e00$export$f1ea15c7da3a01d1);
    $fe47a452a83d9e00$export$f1ea15c7da3a01d1($fe47a452a83d9e00$export$8e361a1ffbebf172.character);
    // Ensure HP properties are synchronized for character
    if ($fe47a452a83d9e00$export$8e361a1ffbebf172.character) {
        // If currentHp is missing, use hp as fallback (for legacy saves)
        if ($fe47a452a83d9e00$export$8e361a1ffbebf172.character.currentHp === undefined && $fe47a452a83d9e00$export$8e361a1ffbebf172.character.hp !== undefined) $fe47a452a83d9e00$export$8e361a1ffbebf172.character.currentHp = $fe47a452a83d9e00$export$8e361a1ffbebf172.character.hp;
        // Ensure character has a name (for legacy saves)
        if (!$fe47a452a83d9e00$export$8e361a1ffbebf172.character.name) $fe47a452a83d9e00$export$8e361a1ffbebf172.character.name = 'You';
        // If currentHp is still missing, default to maxHp
        if ($fe47a452a83d9e00$export$8e361a1ffbebf172.character.currentHp === undefined) $fe47a452a83d9e00$export$8e361a1ffbebf172.character.currentHp = $fe47a452a83d9e00$export$8e361a1ffbebf172.character.maxHp || 100;
        // Add isAlive and injuries properties if missing
        if ($fe47a452a83d9e00$export$8e361a1ffbebf172.character.isAlive === undefined) $fe47a452a83d9e00$export$8e361a1ffbebf172.character.isAlive = true;
        if (!$fe47a452a83d9e00$export$8e361a1ffbebf172.character.injuries) $fe47a452a83d9e00$export$8e361a1ffbebf172.character.injuries = [];
    }
    $fe47a452a83d9e00$export$8e361a1ffbebf172.selectedFaction = parsed.gameState.selectedFaction || null;
    // Migrate legacy top-level skillPoints/skills to character objects
    if (parsed.gameState.skillPoints !== undefined || parsed.gameState.skills) {
        console.log('Migrating legacy skillPoints/skills to character objects');
        var legacySkillPoints = parsed.gameState.skillPoints !== undefined ? parsed.gameState.skillPoints : 15;
        var legacySkills = parsed.gameState.skills || {};
        $fe47a452a83d9e00$export$8e361a1ffbebf172.characters.forEach(function(character) {
            if (character.skillPoints === undefined) character.skillPoints = legacySkillPoints;
            if (!character.skills) character.skills = (0, $fa9769297b8a68c8$export$71511d61b312f219)({}, legacySkills);
        });
    }
    // Handle inventory migration and loading
    var hasLegacyInventory = parsed.gameState.inventory || parsed.gameState.artifacts || parsed.gameState.equippedArtifacts;
    if (hasLegacyInventory && $fe47a452a83d9e00$export$8e361a1ffbebf172.characters.length > 0) {
        // Legacy save file - migrate shared inventory to character-specific inventories
        console.log('Migrating shared inventory to character-specific inventories');
        var legacyInventory = parsed.gameState.inventory || {};
        var legacyArtifacts = parsed.gameState.artifacts || [];
        var legacyEquippedArtifacts = parsed.gameState.equippedArtifacts || {
            skillSlot: null,
            utilitySlot: null
        };
        $fe47a452a83d9e00$export$8e361a1ffbebf172.characters.forEach(function(character) {
            if (!character.inventory) {
                // Give each character a copy of the shared inventory
                character.inventory = (0, $fa9769297b8a68c8$export$71511d61b312f219)({}, legacyInventory);
                character.artifacts = (0, $4c858c0d999a5b9b$export$71511d61b312f219)(legacyArtifacts);
                character.equippedArtifacts = (0, $fa9769297b8a68c8$export$71511d61b312f219)({}, legacyEquippedArtifacts);
            }
        });
    // Legacy data already migrated to character objects above
    } else if ($fe47a452a83d9e00$export$8e361a1ffbebf172.characters.length > 0) // Modern save - ensure all characters have inventory/artifacts initialized
    $fe47a452a83d9e00$export$8e361a1ffbebf172.characters.forEach(function(character) {
        if (!character.inventory) character.inventory = {};
        if (!character.artifacts) character.artifacts = [];
        if (!character.equippedArtifacts) character.equippedArtifacts = {
            skillSlot: null,
            utilitySlot: null
        };
    });
    // Deduplicate contractors and remove player contractors (they don't belong in the pool)
    var contractorMap = new Map();
    (parsed.gameState.contractors || []).filter(function(c) {
        return c.id < 0;
    }) // Only keep NPC contractors (negative IDs)
    .forEach(function(c) {
        return contractorMap.set(c.id, c);
    });
    $fe47a452a83d9e00$export$8e361a1ffbebf172.contractors = Array.from(contractorMap.values());
    // Migrate old contractor data: convert cost to rewardPercentage and add avatars
    if ($fe47a452a83d9e00$export$8e361a1ffbebf172.contractors && $fe47a452a83d9e00$export$8e361a1ffbebf172.contractors.length > 0) $fe47a452a83d9e00$export$8e361a1ffbebf172.contractors.forEach(function(contractor) {
        if (typeof contractor.rewardPercentage === 'undefined' && typeof contractor.cost !== 'undefined') {
            // Convert old fixed cost to percentage (10-25% range)
            contractor.rewardPercentage = 10 + Math.floor(Math.random() * 16);
            delete contractor.cost; // Remove old property
        }
        // Add avatar if missing
        if (!contractor.avatar) contractor.avatar = (0, $ca7af38ea7b7b4a8$export$913078032f14f7f)(contractor.faction);
        // Backfill procedural avatar seed for old saves. Seed from the
        // already-varied legacy sprite string so faces are stable and distinct
        // without needing a per-contractor id (the id is a reused slot index).
        if (!contractor.avatarSeed) contractor.avatarSeed = contractor.avatar;
        // Add isAlive and injuries properties if missing
        if (contractor.isAlive === undefined) contractor.isAlive = true;
        if (!contractor.injuries) contractor.injuries = [];
    });
    // Also migrate reserved contractors
    if ($fe47a452a83d9e00$export$8e361a1ffbebf172.currentRaid.reservedContractors && $fe47a452a83d9e00$export$8e361a1ffbebf172.currentRaid.reservedContractors.length > 0) $fe47a452a83d9e00$export$8e361a1ffbebf172.currentRaid.reservedContractors.forEach(function(contractor) {
        if (typeof contractor.rewardPercentage === 'undefined' && typeof contractor.cost !== 'undefined') {
            contractor.rewardPercentage = 10 + Math.floor(Math.random() * 16);
            delete contractor.cost;
        }
        // Add avatar if missing
        if (!contractor.avatar) contractor.avatar = (0, $ca7af38ea7b7b4a8$export$913078032f14f7f)(contractor.faction);
        // Backfill procedural avatar seed for old saves. Seed from the
        // already-varied legacy sprite string so faces are stable and distinct
        // without needing a per-contractor id (the id is a reused slot index).
        if (!contractor.avatarSeed) contractor.avatarSeed = contractor.avatar;
        // Add isAlive and injuries properties if missing
        if (contractor.isAlive === undefined) contractor.isAlive = true;
        if (!contractor.injuries) contractor.injuries = [];
    });
    // Also migrate hired contractors
    if ($fe47a452a83d9e00$export$8e361a1ffbebf172.currentRaid.hiredContractors && $fe47a452a83d9e00$export$8e361a1ffbebf172.currentRaid.hiredContractors.length > 0) $fe47a452a83d9e00$export$8e361a1ffbebf172.currentRaid.hiredContractors.forEach(function(contractor) {
        if (typeof contractor.rewardPercentage === 'undefined' && typeof contractor.cost !== 'undefined') {
            contractor.rewardPercentage = 10 + Math.floor(Math.random() * 16);
            delete contractor.cost;
        }
        // Add avatar if missing
        if (!contractor.avatar) contractor.avatar = (0, $ca7af38ea7b7b4a8$export$913078032f14f7f)(contractor.faction);
        // Backfill procedural avatar seed for old saves. Seed from the
        // already-varied legacy sprite string so faces are stable and distinct
        // without needing a per-contractor id (the id is a reused slot index).
        if (!contractor.avatarSeed) contractor.avatarSeed = contractor.avatar;
        // Add isAlive and injuries properties if missing
        if (contractor.isAlive === undefined) contractor.isAlive = true;
        if (!contractor.injuries) contractor.injuries = [];
    });
    $fe47a452a83d9e00$export$8e361a1ffbebf172.settings = parsed.gameState.settings || {};
    // NOTE: `unlockedRegions` was persisted here until 2026-07-28 but gated
    // nothing — region availability is DERIVED (command-core.js
    // availableRegionsForCharacter: faction starting pair + charterRegions).
    // It is no longer read or written; old saves simply drop the field on their
    // next save, so no migration is needed.
    $fe47a452a83d9e00$export$8e361a1ffbebf172.equippedArtifacts = parsed.gameState.equippedArtifacts || {
        skillSlot: null,
        utilitySlot: null
    };
    // Veteran's Stipend was replaced by Field Conditioning (skill points ->
    // max HP). Carry the owned rank across so a player who bought it keeps the
    // slot they paid marks for; command.upgrades is account-permanent and
    // marks are not refundable, so dropping the id would silently confiscate it.
    var upgrades = (_gameState_command = $fe47a452a83d9e00$export$8e361a1ffbebf172.command) === null || _gameState_command === void 0 ? void 0 : _gameState_command.upgrades;
    if (upgrades && upgrades['veterans-stipend'] != null) {
        if (upgrades['field-conditioning'] == null) upgrades['field-conditioning'] = upgrades['veterans-stipend'];
        delete upgrades['veterans-stipend'];
        (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, 'Migrated veterans-stipend rank to field-conditioning');
    }
    // Migrate old generalSlot to utilitySlot in equipped artifacts
    if ($fe47a452a83d9e00$export$8e361a1ffbebf172.equippedArtifacts.generalSlot && !$fe47a452a83d9e00$export$8e361a1ffbebf172.equippedArtifacts.utilitySlot) {
        $fe47a452a83d9e00$export$8e361a1ffbebf172.equippedArtifacts.utilitySlot = $fe47a452a83d9e00$export$8e361a1ffbebf172.equippedArtifacts.generalSlot;
        delete $fe47a452a83d9e00$export$8e361a1ffbebf172.equippedArtifacts.generalSlot;
        console.log('Migrated artifact from generalSlot to utilitySlot');
    } else if ($fe47a452a83d9e00$export$8e361a1ffbebf172.equippedArtifacts.generalSlot) {
        // Clean up any remaining generalSlot references
        delete $fe47a452a83d9e00$export$8e361a1ffbebf172.equippedArtifacts.generalSlot;
        console.log('Cleaned up legacy generalSlot reference');
    }
    // Migrate slot property in artifact objects from generalSlot to utilitySlot
    var artifactsMigrated = false;
    if ($fe47a452a83d9e00$export$8e361a1ffbebf172.artifacts && $fe47a452a83d9e00$export$8e361a1ffbebf172.artifacts.length > 0) $fe47a452a83d9e00$export$8e361a1ffbebf172.artifacts.forEach(function(artifact) {
        if (artifact.slot === 'generalSlot') {
            artifact.slot = 'utilitySlot';
            artifactsMigrated = true;
        }
    });
    // Initialize hired contractors array if it doesn't exist (but don't reset reservedContractors!)
    if (!$fe47a452a83d9e00$export$8e361a1ffbebf172.currentRaid.hiredContractors) $fe47a452a83d9e00$export$8e361a1ffbebf172.currentRaid.hiredContractors = [];
    // Restore active character based on activeCharacterId
    if ($fe47a452a83d9e00$export$8e361a1ffbebf172.activeCharacterId && $fe47a452a83d9e00$export$8e361a1ffbebf172.characters.length > 0) {
        var activeChar = $fe47a452a83d9e00$export$8e361a1ffbebf172.characters.find(function(c) {
            return c.id === $fe47a452a83d9e00$export$8e361a1ffbebf172.activeCharacterId;
        });
        if (activeChar) // Set the active character
        $fe47a452a83d9e00$export$8e361a1ffbebf172.character = (0, $fa9769297b8a68c8$export$71511d61b312f219)({}, activeChar);
        else {
            // activeCharacterId doesn't match any character, reset to first available
            var availableChars = $fe47a452a83d9e00$export$8e361a1ffbebf172.characters.filter(function(c) {
                return !c.isMarketplace;
            });
            if (availableChars.length > 0) {
                $fe47a452a83d9e00$export$8e361a1ffbebf172.character = (0, $fa9769297b8a68c8$export$71511d61b312f219)({}, availableChars[0]);
                $fe47a452a83d9e00$export$8e361a1ffbebf172.activeCharacterId = availableChars[0].id;
            } else {
                // No characters available, reset character state
                $fe47a452a83d9e00$export$8e361a1ffbebf172.character = null;
                $fe47a452a83d9e00$export$8e361a1ffbebf172.activeCharacterId = null;
            }
        }
    } else if ($fe47a452a83d9e00$export$8e361a1ffbebf172.character) // Legacy character loading - display if character exists
    $fe47a452a83d9e00$export$8e361a1ffbebf172.activeCharacterId = $fe47a452a83d9e00$export$8e361a1ffbebf172.character.id;
    // Migrations applied - stamp the live state to the current schema + build.
    if (savedVersion !== $fe47a452a83d9e00$export$d0f77b711cc9be6c) console.log("Migrated save from schema v".concat(savedVersion, " (build ").concat(savedGameVersion || 'unknown', ") to v").concat($fe47a452a83d9e00$export$d0f77b711cc9be6c));
    $fe47a452a83d9e00$export$8e361a1ffbebf172.schemaVersion = $fe47a452a83d9e00$export$d0f77b711cc9be6c;
    $fe47a452a83d9e00$export$8e361a1ffbebf172.gameVersion = (0, $fb87f08ff5f65798$export$9badeb9b04b4b71c);
}
function $fe47a452a83d9e00$export$77866226ea57ca79() {
    if (!$fe47a452a83d9e00$export$8e361a1ffbebf172.character) return false;
    // If no raid in progress, anyone can access
    if (!$fe47a452a83d9e00$export$8e361a1ffbebf172.currentRaid.raidOwnerId) return true;
    // If there's an active raid, only the owner can access
    return $fe47a452a83d9e00$export$8e361a1ffbebf172.currentRaid.raidOwnerId === $fe47a452a83d9e00$export$8e361a1ffbebf172.activeCharacterId;
}


//done
//@ts-check






//done
//@ts-check





//done
// Toast notification system with Animate.css animations.
//
// At most MAX_VISIBLE toasts are on screen, laid out side by side in one row
// (see .toast-container in styles.css). Toasts used to stack without limit, and
// gameplay (raids especially) emits them in bursts, so the column could cover a
// large part of the screen — badly so on tablets. A short row costs far less
// vertical space than a stack. Extra messages queue.
//
// A queue only helps if it keeps up: at the full solo dwell a burst would trail
// gameplay by half a minute. So while messages are waiting the dwell drops to
// BACKLOG_DWELL_MS, and toasts already showing are cut short when something
// queues behind them. The queue is capped, keeping the NEWEST messages — during
// a burst the latest state is what matters, and the raid log keeps the full
// record.
var $b5bda7fdec806d8b$export$312c15c298b6a304 = 2; // toasts on screen at once (row width in styles.css)
var $b5bda7fdec806d8b$export$4eb92f07034723c1 = 5000; // nothing waiting: read at leisure
var $b5bda7fdec806d8b$export$a90a0dcb02b5caf1 = 3000; // something waiting: keep the queue moving
var $b5bda7fdec806d8b$export$9ac10b278ef6fbc2 = 1000; // Animate.css default duration
var $b5bda7fdec806d8b$export$354f03de0bec5c37 = 7;
var $b5bda7fdec806d8b$export$7999238bb9a1816 = 2; // see below — why this is capped at all
var $b5bda7fdec806d8b$var$queue = [];
var $b5bda7fdec806d8b$var$visible = []; // entries on screen: { toast, enterAnimation, exitAnimation, timer, shownAt, dwell }
var $b5bda7fdec806d8b$var$sticky = []; // entries awaiting a click: { toast, exitAnimation }
function $b5bda7fdec806d8b$export$c7def531c087da85(message) {
    var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'info', options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    // No-op in Node.js environment (for simulation/testing)
    if (typeof document === 'undefined') return null;
    if (options.sticky) return $b5bda7fdec806d8b$var$showSticky(message, type);
    $b5bda7fdec806d8b$var$queue.push({
        message: message,
        type: type
    });
    if ($b5bda7fdec806d8b$var$queue.length > $b5bda7fdec806d8b$export$354f03de0bec5c37) $b5bda7fdec806d8b$var$queue.splice(0, $b5bda7fdec806d8b$var$queue.length - $b5bda7fdec806d8b$export$354f03de0bec5c37); // drop oldest, keep newest
    $b5bda7fdec806d8b$var$fillSlots();
    $b5bda7fdec806d8b$var$cutShortIfWaiting();
    return null;
}
/**
 * A toast that waits for a click instead of a timer.
 *
 * Deliberately OUTSIDE the MAX_VISIBLE budget and the queue. Sticky toasts have
 * no timer, so letting them hold one of the two transient slots would let two
 * unread messages deadlock the entire notification system - and because the
 * queue keeps only the newest MAX_QUEUE, everything behind them would be
 * discarded silently. A message the player never dismisses must not be able to
 * suppress every message after it.
 *
 * They are still capped. An uncapped pile of undismissable toasts would bury
 * the screen, which is its own way of going unnoticed; past MAX_STICKY the
 * oldest is retired, having had the most time on screen.
 */ function $b5bda7fdec806d8b$var$showSticky(message, type) {
    var toastContainer = document.getElementById('toast-container');
    if (!toastContainer) return null;
    var toast = document.createElement('div');
    toast.className = "toast ".concat(type, " toast-sticky animate__animated ").concat($b5bda7fdec806d8b$export$7a919e96f3f110b4(type));
    // Announced rather than just drawn: this is the category of message a player
    // is most likely to be looking away from.
    toast.setAttribute('role', 'alert');
    var content = document.createElement('span');
    content.textContent = message;
    toast.appendChild(content);
    var close = document.createElement('button');
    close.className = 'toast-dismiss';
    close.setAttribute('aria-label', 'Dismiss notification');
    close.textContent = "\u2715";
    toast.appendChild(close);
    var entry = {
        toast: toast,
        exitAnimation: $b5bda7fdec806d8b$export$17696d6e8bf46719(type)
    };
    // The whole toast is the hit target, not just the ✕ - the button is the
    // affordance that says "this one waits for you", not the only way out.
    toast.addEventListener('click', function() {
        return $b5bda7fdec806d8b$var$dismissSticky(entry);
    });
    toastContainer.appendChild(toast);
    $b5bda7fdec806d8b$var$sticky.push(entry);
    while($b5bda7fdec806d8b$var$sticky.length > $b5bda7fdec806d8b$export$7999238bb9a1816)$b5bda7fdec806d8b$var$dismissSticky($b5bda7fdec806d8b$var$sticky[0]);
    // Both no-op once the toast is gone (clicked, or retired past MAX_STICKY),
    // so a caller ticking a countdown into `update` never has to track whether
    // the player got there first.
    return {
        dismiss: function() {
            return $b5bda7fdec806d8b$var$dismissSticky(entry);
        },
        update: function(text) {
            if ($b5bda7fdec806d8b$var$sticky.includes(entry)) content.textContent = text;
        }
    };
}
function $b5bda7fdec806d8b$var$dismissSticky(entry) {
    var index = $b5bda7fdec806d8b$var$sticky.indexOf(entry);
    if (index === -1) return; // already dismissed
    $b5bda7fdec806d8b$var$sticky.splice(index, 1);
    entry.toast.classList.add(entry.exitAnimation);
    setTimeout(function() {
        return entry.toast.remove();
    }, $b5bda7fdec806d8b$export$9ac10b278ef6fbc2);
}
// Show queued messages until the row is full.
function $b5bda7fdec806d8b$var$fillSlots() {
    while($b5bda7fdec806d8b$var$visible.length < $b5bda7fdec806d8b$export$312c15c298b6a304 && $b5bda7fdec806d8b$var$queue.length > 0){
        if (!$b5bda7fdec806d8b$var$showNext()) return; // no container — nothing more we can do
    }
}
// Something is queued behind the visible toasts — shorten their remaining time
// so the backlog drains promptly instead of waiting out full solo dwells.
function $b5bda7fdec806d8b$var$cutShortIfWaiting() {
    if ($b5bda7fdec806d8b$var$queue.length === 0) return;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var entry = _step.value;
            if (entry.dwell === $b5bda7fdec806d8b$export$a90a0dcb02b5caf1) return "continue" // already hurried
            ;
            var remaining = Math.max(0, $b5bda7fdec806d8b$export$a90a0dcb02b5caf1 - (Date.now() - entry.shownAt));
            clearTimeout(entry.timer);
            entry.dwell = $b5bda7fdec806d8b$export$a90a0dcb02b5caf1;
            entry.timer = setTimeout(function() {
                return $b5bda7fdec806d8b$var$dismiss(entry);
            }, remaining);
        };
        for(var _iterator = $b5bda7fdec806d8b$var$visible[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
// Renders the next queued message. Returns false if there's nowhere to put it.
function $b5bda7fdec806d8b$var$showNext() {
    var next = $b5bda7fdec806d8b$var$queue.shift();
    if (!next) return false;
    var toastContainer = document.getElementById('toast-container');
    if (!toastContainer) {
        $b5bda7fdec806d8b$var$queue.length = 0;
        return false;
    }
    // Choose entrance animation based on notification type
    var enterAnimation = $b5bda7fdec806d8b$export$7a919e96f3f110b4(next.type);
    var exitAnimation = $b5bda7fdec806d8b$export$17696d6e8bf46719(next.type);
    // Create toast element
    var toast = document.createElement('div');
    toast.className = "toast ".concat(next.type, " animate__animated ").concat(enterAnimation);
    toast.textContent = next.message;
    // Add to container
    toastContainer.appendChild(toast);
    var dwell = $b5bda7fdec806d8b$var$queue.length > 0 ? $b5bda7fdec806d8b$export$a90a0dcb02b5caf1 : $b5bda7fdec806d8b$export$4eb92f07034723c1;
    var entry = {
        toast: toast,
        enterAnimation: enterAnimation,
        exitAnimation: exitAnimation,
        shownAt: Date.now(),
        dwell: dwell,
        timer: null
    };
    entry.timer = setTimeout(function() {
        return $b5bda7fdec806d8b$var$dismiss(entry);
    }, dwell);
    $b5bda7fdec806d8b$var$visible.push(entry);
    return true;
}
// Play the exit animation, remove the node, then backfill the freed slot. The
// entry keeps its slot until the animation finishes — it's still on screen.
function $b5bda7fdec806d8b$var$dismiss(entry) {
    if (!$b5bda7fdec806d8b$var$visible.includes(entry)) return; // already dismissed
    entry.toast.classList.remove(entry.enterAnimation);
    entry.toast.classList.add(entry.exitAnimation);
    setTimeout(function() {
        if (entry.toast.parentNode) entry.toast.parentNode.removeChild(entry.toast);
        var index = $b5bda7fdec806d8b$var$visible.indexOf(entry);
        if (index !== -1) $b5bda7fdec806d8b$var$visible.splice(index, 1);
        $b5bda7fdec806d8b$var$fillSlots();
    }, $b5bda7fdec806d8b$export$9ac10b278ef6fbc2);
}
function $b5bda7fdec806d8b$export$7a919e96f3f110b4(type) {
    switch(type){
        case 'success':
            return 'animate__bounceInRight';
        case 'error':
            return 'animate__shake';
        case 'warning':
            return 'animate__slideInDown';
        case 'info':
        default:
            return 'animate__slideInRight';
    }
}
function $b5bda7fdec806d8b$export$17696d6e8bf46719(type) {
    switch(type){
        case 'success':
            return 'animate__bounceOutRight';
        case 'error':
            return 'animate__slideOutRight';
        case 'warning':
            return 'animate__slideOutUp';
        case 'info':
        default:
            return 'animate__slideOutRight';
    }
}




/**
 * Command Core - Pure logic for the Command prestige layer (M2)
 *
 * No browser/Alpine dependencies: consumed by the UI wrapper (command.js)
 * AND the headless simulator. Player-facing verb is promote/promotion -
 * "retire" never appears in copy.
 *
 * Key concepts:
 * - Command Marks: prestige currency from promoting characters (formula
 *   coefficients live in progressionScaling.commandMarks - balance SSOT).
 * - Legends: immutable snapshots of promoted characters (gallery).
 * - Tours: account-global counter, +1 per promotion (any faction).
 * - Region availability is DERIVED: faction starting pair + charter unlocks
 *   (+ everything, for grandfathered pre-Command saves).
 */ 











/**
 * Character Core Logic - Pure Functions
 *
 * Pure game logic for character progression that has no browser dependencies.
 * Can be used in both browser (character.js) and Node.js (simulator) contexts.
 *
 * Extracted from character.js to separate pure logic from UI updates.
 */ 



/**
 * Blackout Contracts — L3 optional challenge raids (M3 S6).
 *
 * Two halves that must not be confused:
 *
 *   ARMED   — `gameState.currentRaid.blackoutContract`, the contract this raid
 *             is running under. Read for MODIFIERS, and only for the raid in
 *             progress.
 *   CLEARED — `gameState.syndicate.blackout.cleared`, the account's permanent
 *             record. Read for PERKS, forever, whatever raid is running.
 *
 * The perks are permanent and each contract pays once, so this is a finite
 * hand-authored progression rather than a grind. That is what lets the perks be
 * flat and generous, and it is why `getBlackoutPerk` sums over cleared contracts
 * rather than anything time-bound.
 *
 * No browser dependencies — the simulator runs this too.
 *
 * See docs/layers/3-syndicate/design.md §7.
 */ 


/**
 * Syndicate Core - Pure logic for the Syndicate prestige layer (M3)
 *
 * No browser/Alpine dependencies: consumed by the UI wrapper AND the headless
 * simulator, same contract as command-core.js.
 *
 * Where Command prestiges a CHARACTER into marks, Syndicate prestiges an ERA
 * into Writs. Founding wipes the whole Command layer - marks, Legends,
 * upgrades, charters, vault, characters, credits - in exchange for Writs and
 * the charters they buy, which are the things that make each rebuilt era
 * faster than the last.
 *
 * See docs/layers/3-syndicate/design.md. The wipe/persist ledger in §2 is the
 * contract; tests/game/syndicate.test.js asserts BOTH columns, because a
 * prestige reset is equally broken if it keeps too much or too little.
 */ 






var $e39e78d7c65dc336$export$de76d136ab75207a = 15;
var $e39e78d7c65dc336$export$c927ee7382a453ae = 8;
function $e39e78d7c65dc336$export$ab98ff7829062ba4() {
    var relief = $e39e78d7c65dc336$export$d9ea4b2d96397ab9('institutional-memory', 0);
    return Math.max($e39e78d7c65dc336$export$c927ee7382a453ae, $e39e78d7c65dc336$export$de76d136ab75207a - relief);
}
var $e39e78d7c65dc336$export$9455015a451127fb = 1.0;
function $e39e78d7c65dc336$export$cdfa564b532bb699() {
    if (!(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).syndicate) (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).syndicate = (0, $fe47a452a83d9e00$export$ddc99ec3c98bbb0a)();
    // Backfill keys added after a save was written. The branch is created
    // wholesale above, so a save from before `stores` existed has the branch but
    // not the field — and promotion writes to it without a guard.
    if (!(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).syndicate.consignment) (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).syndicate.consignment = {};
    if (!(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).syndicate.stores) (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).syndicate.stores = {};
    if (!(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).syndicate.demand) (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).syndicate.demand = {};
    return (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).syndicate;
}
function $e39e78d7c65dc336$export$fc09ffc64d9013e3(eraMarks) {
    var marks = Number(eraMarks);
    if (!Number.isFinite(marks) || marks <= 0) return 0;
    return Math.floor($e39e78d7c65dc336$export$9455015a451127fb * Math.sqrt(marks));
}
function $e39e78d7c65dc336$export$6955e231f1466c44(charterId) {
    var _gameState_syndicate_upgrades, _gameState_syndicate;
    return ((_gameState_syndicate = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).syndicate) === null || _gameState_syndicate === void 0 ? void 0 : (_gameState_syndicate_upgrades = _gameState_syndicate.upgrades) === null || _gameState_syndicate_upgrades === void 0 ? void 0 : _gameState_syndicate_upgrades[charterId]) || 0;
}
function $e39e78d7c65dc336$export$d9ea4b2d96397ab9(charterId) {
    var fallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var _config_syndicateUpgrades, _def_effectValues;
    var rank = $e39e78d7c65dc336$export$6955e231f1466c44(charterId);
    if (rank <= 0) return fallback;
    var def = (_config_syndicateUpgrades = $979b99378be707cd$export$1a64c4c64ba19abd) === null || _config_syndicateUpgrades === void 0 ? void 0 : _config_syndicateUpgrades[charterId];
    if (!def) return fallback;
    var _def_effectValues_;
    return (_def_effectValues_ = (_def_effectValues = def.effectValues) === null || _def_effectValues === void 0 ? void 0 : _def_effectValues[rank - 1]) !== null && _def_effectValues_ !== void 0 ? _def_effectValues_ : fallback;
}
function $e39e78d7c65dc336$export$f0d4871acc619a3() {
    var _gameState_command_legends, _gameState_command;
    var syndicate = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).syndicate;
    if (!syndicate) return false;
    // Latches on, like Command's: once the player has seen the layer it stays
    // available between eras, which is exactly when charters get bought.
    if (syndicate.revealed) return true;
    if (syndicate.founded > 0 || (((_gameState_command = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).command) === null || _gameState_command === void 0 ? void 0 : (_gameState_command_legends = _gameState_command.legends) === null || _gameState_command_legends === void 0 ? void 0 : _gameState_command_legends.length) || 0) >= $e39e78d7c65dc336$export$de76d136ab75207a) {
        syndicate.revealed = true;
        return true;
    }
    return false;
}
function $e39e78d7c65dc336$export$5799eac7aba24ab2() {
    var _command_legends, _gameState_currentRaid, _gameState_syndicate_operations, _gameState_syndicate;
    var command = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).command;
    if (!command) return {
        ok: false,
        reason: 'no-command-layer'
    };
    var legends = ((_command_legends = command.legends) === null || _command_legends === void 0 ? void 0 : _command_legends.length) || 0;
    var need = $e39e78d7c65dc336$export$ab98ff7829062ba4();
    if (legends < need) return {
        ok: false,
        reason: 'insufficient-legends',
        have: legends,
        need: need
    };
    var character = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character;
    if ((character === null || character === void 0 ? void 0 : character.isMarketplace) || (character === null || character === void 0 ? void 0 : character.marketplaceData)) return {
        ok: false,
        reason: 'listed-on-marketplace'
    };
    // Any owned raid state blocks it, same rule promotion and deletion apply.
    if (((_gameState_currentRaid = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid) === null || _gameState_currentRaid === void 0 ? void 0 : _gameState_currentRaid.raidOwnerId) === (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).activeCharacterId && ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid || (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress || (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidCompleted)) return {
        ok: false,
        reason: 'raid-in-progress'
    };
    // In-flight operations reference era-Legends, who are about to stop existing.
    if ((((_gameState_syndicate = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).syndicate) === null || _gameState_syndicate === void 0 ? void 0 : (_gameState_syndicate_operations = _gameState_syndicate.operations) === null || _gameState_syndicate_operations === void 0 ? void 0 : _gameState_syndicate_operations.length) || 0) > 0) return {
        ok: false,
        reason: 'operations-in-flight'
    };
    return {
        ok: true
    };
}
function $e39e78d7c65dc336$export$9ab0fc0c1d4f0dcd() {
    var legends = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {
        var _gameState_command;
        return ((_gameState_command = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).command) === null || _gameState_command === void 0 ? void 0 : _gameState_command.legends) || [];
    }();
    if (!legends.length) return null;
    var best = legends.reduce(function(a, b) {
        return (b.marksEarned || 0) > (a.marksEarned || 0) ? b : a;
    });
    return {
        name: best.name,
        faction: best.faction,
        avatarSeed: best.avatarSeed,
        level: best.level,
        marksEarned: best.marksEarned || 0,
        promotedRole: best.promotedRole,
        electedAt: Date.now()
    };
}
function $e39e78d7c65dc336$export$1861729e67332c20() {
    var eligible = $e39e78d7c65dc336$export$5799eac7aba24ab2();
    if (!eligible.ok) return {
        success: false,
        reason: eligible.reason
    };
    var syndicate = $e39e78d7c65dc336$export$cdfa564b532bb699();
    var command = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).command;
    // 1. Leader is elected from the era about to end.
    var leader = $e39e78d7c65dc336$export$9ab0fc0c1d4f0dcd(command.legends);
    if (syndicate.leader) syndicate.pastLeaders.push(syndicate.leader);
    // 2. Unbanked marks on the active character count toward the era. Same
    //    figure the promote path banks, so founding and promote-then-found are
    //    worth the same - which is the whole point of decision 8.
    var unbanked = 0;
    if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character) {
        var _calculateCommandMarks;
        unbanked = ((_calculateCommandMarks = (0, $ee71dfe8b201c427$export$ffae5de2f7ddd94d)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character)) === null || _calculateCommandMarks === void 0 ? void 0 : _calculateCommandMarks.total) || 0;
        syndicate.eraMarks += unbanked;
    }
    // 3. Writs price the completed era.
    var eraMarks = syndicate.eraMarks;
    var writs = $e39e78d7c65dc336$export$fc09ffc64d9013e3(eraMarks);
    // 4. The wipe. Blueprints survive for the same reason promotion carries
    //    them at 100%: they are the account-long artifact arc, and the 27-design
    //    unlock record (command.unlockedArtifacts) is explicitly account-level.
    var consignment = syndicate.consignment || (syndicate.consignment = {});
    //    Both the vault's contents and the active character's kit are routed by
    //    the SAME disburseInventory() promotion uses — founding and promotion
    //    are the same event to the economy (a character stops existing and their
    //    kit has to land somewhere), so they must not disagree about where any
    //    item type goes.
    //
    //    vaultShare 0 for both: there is no successor to inherit a share. That
    //    also means the vault's own materials consign rather than vanish —
    //    without it, promote-then-found loses the rank share while founding
    //    directly keeps it, exactly the footgun decision 8 exists to prevent,
    //    just on the material side.
    var survivingBlueprints = {};
    (0, $ee71dfe8b201c427$export$da98dc4e7bdea782)(command.vault, {
        vaultShare: 0,
        vault: survivingBlueprints,
        consignment: consignment
    });
    //    The active character's kit, on the same principle as the unbanked marks
    //    folded in at step 2: founding without promoting first must not silently
    //    cost you the character's stock.
    //
    //    Their relics and consumables are NOT cashed out. Founding resets credits
    //    to the levy floor a few lines below, so crediting them here would be a
    //    number the player watches appear and then vanish in the same click. The
    //    wipe ledger is explicit that the era's wealth does not survive.
    if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character) (0, $ee71dfe8b201c427$export$da98dc4e7bdea782)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.inventory, {
        vaultShare: 0,
        vault: survivingBlueprints,
        consignment: consignment
    });
    //    The consignment is DELIVERED: everything this era banked becomes the
    //    new Syndicate's dock, and the consignment starts empty for the era
    //    about to begin. This is the only thing that ever fills `stores`, which
    //    is what makes a dock a per-era budget rather than a running total.
    Object.entries(consignment).forEach(function(param) {
        var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), itemId = _param[0], qty = _param[1];
        if (qty > 0) syndicate.stores[itemId] = (syndicate.stores[itemId] || 0) + qty;
    });
    syndicate.consignment = {};
    syndicate.totalTours += Math.max(0, (command.tour || 1) - 1);
    syndicate.writs += writs;
    syndicate.eraMarks = 0;
    syndicate.founded += 1;
    syndicate.leader = leader;
    syndicate.revealed = true;
    var preserved = {
        unlockedArtifacts: command.unlockedArtifacts || [],
        revealed: command.revealed,
        grandfathered: command.grandfathered
    };
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).command = (0, $715bf31211e65705$export$71511d61b312f219)((0, $fa9769297b8a68c8$export$71511d61b312f219)({}, (0, $fe47a452a83d9e00$export$d79000c880c47c99)(), preserved), {
        vault: survivingBlueprints
    });
    // 5. Charters that reach back into the fresh era.
    //
    // GRANTED, NOT RETAINED, and deliberately so: reaching L3 is what automates
    // L1 permanently, so the charter hands over Auto-Raid Protocol whether or
    // not Command ever bought it. No check on prior ownership, because there is
    // nothing to check — a player who never bought it is exactly who this is
    // for. The Command upgrade remains worth its 300 marks as EARLY access
    // (~day 16 if you bank for it, against a first founding at ~day 25), not as
    // a prerequisite. See the note on `standing-orders` in syndicateUpgrades.js;
    // the charter's old wording said "retained", which made this read as a bug.
    if ($e39e78d7c65dc336$export$6955e231f1466c44('standing-orders') > 0) {
        (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).command.upgrades['auto-raid-protocol'] = 1;
        // Auto-Fabricator comes with it, and must: a founding wipes Command
        // upgrades, so granting only the raid half would hand every post-
        // founding era a character that raids hands-off and never crafts —
        // which is the ~29%-of-marks hole this pair exists to close. Automation
        // that survives a founding has to survive it whole.
        (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).command.upgrades['auto-fabricator'] = 1;
    }
    var endowment = $e39e78d7c65dc336$export$d9ea4b2d96397ab9('founders-endowment', 0);
    if (endowment > 0) (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).command.marks = endowment;
    // Characters and credits reset; the crafting multiplier follows tour=1 on
    // its own now that it is derived rather than compounded, so there is
    // nothing to restore here.
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).characters = [];
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character = null;
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).activeCharacterId = null;
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player.credits = $979b99378be707cd$export$9f9786ac427715c7.promotionCreditLevy.floor;
    return {
        success: true,
        writs: writs,
        eraMarks: eraMarks,
        unbanked: unbanked,
        leader: leader
    };
}
var $e39e78d7c65dc336$export$65d88b3701cdf574 = {
    minTourRaids: 8,
    peakPatienceRaids: 6,
    maxTourRaids: 60
};
function $e39e78d7c65dc336$export$5d3c2c0349b1c9a4() {
    var syndicate = $e39e78d7c65dc336$export$cdfa564b532bb699();
    if (!syndicate.succession) syndicate.succession = (0, $fe47a452a83d9e00$export$ddc99ec3c98bbb0a)().succession;
    return syndicate.succession;
}
function $e39e78d7c65dc336$export$40d6ac4f92fd7c1c() {
    return $e39e78d7c65dc336$export$6955e231f1466c44('succession-doctrine') > 0 && !$e39e78d7c65dc336$export$5d3c2c0349b1c9a4().paused;
}
function $e39e78d7c65dc336$export$95d51325f081320b() {
    var s = $e39e78d7c65dc336$export$5d3c2c0349b1c9a4();
    s.tourRaids = 0;
    s.peakRate = 0;
    s.peakAtRaid = 0;
}
function $e39e78d7c65dc336$export$ed3f2307dc7cb2a() {
    var cheapest = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.keys($979b99378be707cd$export$617b3a0bcd7cead7 || {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var id = _step.value;
            var cost = (0, $ee71dfe8b201c427$export$21d6f53ea6843ff6)(id);
            if (cost == null) continue; // maxed
            if ((0, $ee71dfe8b201c427$export$21736c92e8c4e21c)($979b99378be707cd$export$617b3a0bcd7cead7[id]).length) continue; // not yet reachable
            if (cheapest === 0 || cost < cheapest) cheapest = cost;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return cheapest;
}
function $e39e78d7c65dc336$export$12d96118114aebf3() {
    var s = $e39e78d7c65dc336$export$5d3c2c0349b1c9a4();
    s.tourRaids += 1;
    var marks = $e39e78d7c65dc336$var$currentCharacterMarks();
    var avgRate = s.tourRaids > 0 ? marks / s.tourRaids : 0;
    // Peak tracking only starts after the minimum tour, so an early one-craft
    // spike cannot anchor a rate the rest of the tour can never beat.
    if (s.tourRaids >= $e39e78d7c65dc336$export$65d88b3701cdf574.minTourRaids && avgRate > s.peakRate) {
        s.peakRate = avgRate;
        s.peakAtRaid = s.tourRaids;
    }
    return $e39e78d7c65dc336$export$8f29b06b79596501();
}
function $e39e78d7c65dc336$var$currentCharacterMarks() {
    var _calculateCommandMarks;
    if (!(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character) return 0;
    return ((_calculateCommandMarks = (0, $ee71dfe8b201c427$export$ffae5de2f7ddd94d)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character)) === null || _calculateCommandMarks === void 0 ? void 0 : _calculateCommandMarks.total) || 0;
}
function $e39e78d7c65dc336$export$8f29b06b79596501() {
    var _gameState_command;
    var s = $e39e78d7c65dc336$export$5d3c2c0349b1c9a4();
    var marks = $e39e78d7c65dc336$var$currentCharacterMarks();
    // Marks BANK across promotions, so the question is not "did this tour earn
    // enough" but "will promoting now let me buy the thing I am saving for".
    var marksIfPromotedNow = (((_gameState_command = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).command) === null || _gameState_command === void 0 ? void 0 : _gameState_command.marks) || 0) + marks;
    var floor = $e39e78d7c65dc336$export$ed3f2307dc7cb2a();
    var avgRate = s.tourRaids > 0 ? marks / s.tourRaids : 0;
    var raidsSincePeak = s.peakAtRaid > 0 ? s.tourRaids - s.peakAtRaid : 0;
    var peakPassed = s.peakAtRaid > 0 && raidsSincePeak >= $e39e78d7c65dc336$export$65d88b3701cdf574.peakPatienceRaids && marksIfPromotedNow >= floor;
    var safetyValve = s.tourRaids >= $e39e78d7c65dc336$export$65d88b3701cdf574.maxTourRaids;
    return {
        tourRaids: s.tourRaids,
        marks: marks,
        avgRate: avgRate,
        peakRate: s.peakRate,
        raidsSincePeak: raidsSincePeak,
        floor: floor,
        marksIfPromotedNow: marksIfPromotedNow,
        due: peakPassed || safetyValve,
        reason: !(peakPassed || safetyValve) ? null : safetyValve ? 'max-tour' : 'marks-rate-peak'
    };
}
function $e39e78d7c65dc336$export$a91ccccac4a2b08() {
    var _s_template;
    var s = $e39e78d7c65dc336$export$5d3c2c0349b1c9a4();
    if ((_s_template = s.template) === null || _s_template === void 0 ? void 0 : _s_template.faction) return s.template;
    var outgoing = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character;
    if (!outgoing) return null;
    return {
        faction: outgoing.faction,
        // Skill PLAN, not levels: the recruit starts at rank 1 and spends its
        // own points, so what carries is the ordering the player favoured.
        skillPlan: Object.entries(outgoing.skills || {}).sort(function(a, b) {
            return (b[1] || 0) - (a[1] || 0);
        }).map(function(param) {
            var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 1), skillId = _param[0];
            return skillId;
        }),
        derived: true
    };
}
function $e39e78d7c65dc336$export$34d3a5a3f7bd399f(template) {
    $e39e78d7c65dc336$export$5d3c2c0349b1c9a4().template = template;
}
function $e39e78d7c65dc336$export$43bf52c97b14116a(paused) {
    $e39e78d7c65dc336$export$5d3c2c0349b1c9a4().paused = !!paused;
    return $e39e78d7c65dc336$export$5d3c2c0349b1c9a4().paused;
}
function $e39e78d7c65dc336$export$db5a865159d9ae65(charterId) {
    var _config_syndicateUpgrades;
    var def = (_config_syndicateUpgrades = $979b99378be707cd$export$1a64c4c64ba19abd) === null || _config_syndicateUpgrades === void 0 ? void 0 : _config_syndicateUpgrades[charterId];
    if (!def) return {
        success: false,
        reason: 'unknown-charter'
    };
    var syndicate = $e39e78d7c65dc336$export$cdfa564b532bb699();
    var rank = $e39e78d7c65dc336$export$6955e231f1466c44(charterId);
    if (rank >= def.costs.length) return {
        success: false,
        reason: 'max-rank'
    };
    var missing = (0, $ee71dfe8b201c427$export$21736c92e8c4e21c)(def);
    if (missing.length > 0) return {
        success: false,
        reason: 'missing-requirement',
        requires: missing
    };
    var cost = def.costs[rank];
    if (syndicate.writs < cost) return {
        success: false,
        reason: 'insufficient-writs'
    };
    syndicate.writs -= cost;
    syndicate.upgrades[charterId] = rank + 1;
    return {
        success: true,
        rank: rank + 1,
        cost: cost
    };
}


function $686e361e5cd4549d$export$6030630ca4e35487() {
    return (0, $e39e78d7c65dc336$export$6955e231f1466c44)('blackout-sanction') > 0;
}
function $686e361e5cd4549d$export$913dd38406a903a1(contractId) {
    var _config_blackoutContracts;
    return ((_config_blackoutContracts = $979b99378be707cd$export$5099ca2cdc0f385a) === null || _config_blackoutContracts === void 0 ? void 0 : _config_blackoutContracts[contractId]) || null;
}
function $686e361e5cd4549d$export$6f07b662ae575a0e() {
    return Object.keys($979b99378be707cd$export$5099ca2cdc0f385a || {});
}
function $686e361e5cd4549d$export$e51189576207fce1(contractId) {
    var _ensureSyndicateState_blackout_cleared, _ensureSyndicateState_blackout;
    return !!((_ensureSyndicateState_blackout = (0, $e39e78d7c65dc336$export$cdfa564b532bb699)().blackout) === null || _ensureSyndicateState_blackout === void 0 ? void 0 : (_ensureSyndicateState_blackout_cleared = _ensureSyndicateState_blackout.cleared) === null || _ensureSyndicateState_blackout_cleared === void 0 ? void 0 : _ensureSyndicateState_blackout_cleared[contractId]);
}
function $686e361e5cd4549d$export$f099249c2cd16830(contractId, tier) {
    if (!$686e361e5cd4549d$export$6030630ca4e35487()) return 'no-sanction';
    var contract = $686e361e5cd4549d$export$913dd38406a903a1(contractId);
    if (!contract) return 'unknown-contract';
    if ($686e361e5cd4549d$export$e51189576207fce1(contractId)) return 'already-cleared';
    if ((tier || 0) < (contract.minTier || 1)) return 'tier-too-low';
    return null;
}
function $686e361e5cd4549d$export$cb7eb378a07c9158(tier) {
    if (!$686e361e5cd4549d$export$6030630ca4e35487()) return [];
    return $686e361e5cd4549d$export$6f07b662ae575a0e().filter(function(id) {
        return !$686e361e5cd4549d$export$f099249c2cd16830(id, tier);
    }).map(function(id) {
        return (0, $fa9769297b8a68c8$export$71511d61b312f219)({
            id: id
        }, $686e361e5cd4549d$export$913dd38406a903a1(id));
    });
}
function $686e361e5cd4549d$export$f266a4caac7fb67d() {
    var _gameState_currentRaid;
    var id = (_gameState_currentRaid = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid) === null || _gameState_currentRaid === void 0 ? void 0 : _gameState_currentRaid.blackoutContract;
    if (!id) return null;
    var contract = $686e361e5cd4549d$export$913dd38406a903a1(id);
    return contract ? (0, $fa9769297b8a68c8$export$71511d61b312f219)({
        id: id
    }, contract) : null;
}
function $686e361e5cd4549d$export$d1bd52becfd6c270(contractId) {
    var tier = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {
        var _gameState_currentRaid;
        return (_gameState_currentRaid = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid) === null || _gameState_currentRaid === void 0 ? void 0 : _gameState_currentRaid.selectedTier;
    }();
    if (!(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid) return {
        ok: false,
        reason: 'no-raid-state'
    };
    if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress) return {
        ok: false,
        reason: 'raid-in-progress'
    };
    if (!contractId) {
        (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.blackoutContract = null;
        return {
            ok: true,
            contract: null
        };
    }
    var reason = $686e361e5cd4549d$export$f099249c2cd16830(contractId, tier);
    if (reason) return {
        ok: false,
        reason: reason
    };
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.blackoutContract = contractId;
    return {
        ok: true,
        contract: (0, $fa9769297b8a68c8$export$71511d61b312f219)({
            id: contractId
        }, $686e361e5cd4549d$export$913dd38406a903a1(contractId))
    };
}
function $686e361e5cd4549d$export$a2c94bc2dc5c01e1(key, fallback) {
    var _contract_modifiers;
    var contract = $686e361e5cd4549d$export$f266a4caac7fb67d();
    if (!contract) return fallback;
    var value = (_contract_modifiers = contract.modifiers) === null || _contract_modifiers === void 0 ? void 0 : _contract_modifiers[key];
    return value === undefined ? fallback : value;
}
function $686e361e5cd4549d$export$f0d942e2e6132b96(param) {
    var success = param.success;
    var contract = $686e361e5cd4549d$export$f266a4caac7fb67d();
    if (!contract) return null;
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.blackoutContract = null;
    if (!success) return null;
    var syndicate = (0, $e39e78d7c65dc336$export$cdfa564b532bb699)();
    if (!syndicate.blackout) syndicate.blackout = {
        cleared: {}
    };
    if (!syndicate.blackout.cleared) syndicate.blackout.cleared = {};
    // First clear only: re-running a cleared contract must not double the perk.
    if (syndicate.blackout.cleared[contract.id]) return null;
    syndicate.blackout.cleared[contract.id] = true;
    return {
        contractId: contract.id,
        perk: contract.perk
    };
}
function $686e361e5cd4549d$export$84f52d60145287(effectKey) {
    var fallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var _ensureSyndicateState_blackout;
    var cleared = ((_ensureSyndicateState_blackout = (0, $e39e78d7c65dc336$export$cdfa564b532bb699)().blackout) === null || _ensureSyndicateState_blackout === void 0 ? void 0 : _ensureSyndicateState_blackout.cleared) || {};
    var total = 0;
    var found = false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.keys(cleared)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var contractId = _step.value;
            var _getBlackoutContract;
            if (!cleared[contractId]) continue;
            var perk = (_getBlackoutContract = $686e361e5cd4549d$export$913dd38406a903a1(contractId)) === null || _getBlackoutContract === void 0 ? void 0 : _getBlackoutContract.perk;
            if ((perk === null || perk === void 0 ? void 0 : perk.key) === effectKey) {
                total += perk.value;
                found = true;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return found ? total : fallback;
}
function $686e361e5cd4549d$export$2d7a0990b0051919() {
    var _ensureSyndicateState_blackout;
    var cleared = ((_ensureSyndicateState_blackout = (0, $e39e78d7c65dc336$export$cdfa564b532bb699)().blackout) === null || _ensureSyndicateState_blackout === void 0 ? void 0 : _ensureSyndicateState_blackout.cleared) || {};
    return $686e361e5cd4549d$export$6f07b662ae575a0e().filter(function(id) {
        return cleared[id];
    }).map(function(id) {
        return (0, $fa9769297b8a68c8$export$71511d61b312f219)({
            id: id
        }, $686e361e5cd4549d$export$913dd38406a903a1(id));
    });
}




var $df8a44d92d572a5c$var$energyRegenRate = 120000; // 2 minutes in milliseconds
function $df8a44d92d572a5c$export$ae545994cbde97ee(currentLevel) {
    // Exponential scaling for long-term progression: Level 1->2 = 1000 XP
    // Target: Level 8 takes 1-2 months of consistent play (~150-600 raids)
    return Math.floor(1000 * Math.pow(1.5, currentLevel - 1));
}
function $df8a44d92d572a5c$export$d48d36379ada8c46(level) {
    return 10 + Math.floor(level / 3) * 5;
}
function $df8a44d92d572a5c$export$266289d5372bee03(level) {
    var maxHp = 100;
    for(var k = 2; k <= level; k++)maxHp += $df8a44d92d572a5c$export$d48d36379ada8c46(k);
    return maxHp;
}
function $df8a44d92d572a5c$export$a811471a09bc04c3(currentSkillLevel) {
    return Math.max(1, Math.floor(currentSkillLevel / 3) + 1);
}
function $df8a44d92d572a5c$export$4207390906be8d62(level) {
    var cfg = $979b99378be707cd$export$9f9786ac427715c7.skillPointsPerLevel;
    var total = 3; // starting skill points at creation (level 1)
    for(var l = 2; l <= level; l++)total += cfg.base + Math.floor(l / cfg.levelDivisor) * cfg.increment;
    return total;
}
function $df8a44d92d572a5c$export$57757d3a3e441a94(character) {
    var xpToNext = $df8a44d92d572a5c$export$ae545994cbde97ee(character.level);
    character.xp -= xpToNext;
    character.level++;
    // Increase max HP (shared curve - see hpGainForLevel)
    var hpIncrease = $df8a44d92d572a5c$export$d48d36379ada8c46(character.level);
    character.maxHp += hpIncrease;
    character.currentHp = Math.min(character.maxHp, character.currentHp + hpIncrease); // Also heal on level up
    // Award skill points using configurable progression scaling
    var cfg = $979b99378be707cd$export$9f9786ac427715c7.skillPointsPerLevel;
    var skillPointsGained = cfg.base + Math.floor(character.level / cfg.levelDivisor) * cfg.increment;
    character.skillPoints += skillPointsGained;
    // Synergy layer reveal: one-time announcement when the character crosses
    // the unlock level (per-skill purchases live on the skill cards)
    if (character.level === $df8a44d92d572a5c$export$d09b0dfa38532c40().minLevel) // Sticky: fires mid-raid (when the player is watching rooms, not the toast
    // row), unlocks a mechanic once, and names an action to take elsewhere.
    (0, $b5bda7fdec806d8b$export$c7def531c087da85)("\u26A1 Synergies discovered! Teammates' gear can now upgrade your events \u2014 unlock per skill from the character page.", 'success', {
        sticky: true
    });
}
function $df8a44d92d572a5c$export$8ae8375981be11e0(character, targetLevel) {
    while(character.level < targetLevel){
        character.xp += $df8a44d92d572a5c$export$ae545994cbde97ee(character.level);
        $df8a44d92d572a5c$export$57757d3a3e441a94(character);
    }
}
function $df8a44d92d572a5c$export$88ec20478ef6bd29(character, xpAmount) {
    if (!character) return;
    // Legend Bonus (Command layer): +XP per enshrined Legend when owned
    character.xp += Math.round(xpAmount * (0, $ee71dfe8b201c427$export$7647bd5455c447e6)());
    // Check for level up
    var xpToNext = $df8a44d92d572a5c$export$ae545994cbde97ee(character.level);
    while(character.xp >= xpToNext){
        $df8a44d92d572a5c$export$57757d3a3e441a94(character);
        xpToNext = $df8a44d92d572a5c$export$ae545994cbde97ee(character.level);
    }
}
function $df8a44d92d572a5c$export$6cdee87198244170(contractor) {
    var xpToNext = $df8a44d92d572a5c$export$ae545994cbde97ee(contractor.level || 1);
    contractor.xp -= xpToNext;
    contractor.level = (contractor.level || 1) + 1;
    // Increase max HP (same shared curve as characters - see hpGainForLevel)
    var hpIncrease = $df8a44d92d572a5c$export$d48d36379ada8c46(contractor.level);
    contractor.maxHp = (contractor.maxHp || 100) + hpIncrease;
    contractor.currentHp = (contractor.currentHp || contractor.maxHp) + hpIncrease; // Also heal on level up
}
function $df8a44d92d572a5c$export$31efd075830c7467(contractor, xpAmount) {
    if (!contractor) return;
    contractor.xp = (contractor.xp || 0) + xpAmount;
    // Check for level up
    var xpToNext = $df8a44d92d572a5c$export$ae545994cbde97ee(contractor.level || 1);
    while(contractor.xp >= xpToNext){
        $df8a44d92d572a5c$export$6cdee87198244170(contractor);
        xpToNext = $df8a44d92d572a5c$export$ae545994cbde97ee(contractor.level);
    }
}
function $df8a44d92d572a5c$export$28bf58d3c9312b43(currentLevel) {
    // Progressive cost: Level 1 = 50, Level 2 = 100, Level 3 = 200, etc.
    // Formula: 50 * (1.5^level), rounded to nearest 25
    var baseCost = 50;
    var scalingFactor = 1.5;
    var rawCost = baseCost * Math.pow(scalingFactor, currentLevel);
    return Math.round(rawCost / 25) * 25; // Round to nearest 25 credits
}
function $df8a44d92d572a5c$export$7d0067675be54b12(currentLevel) {
    return Math.max(1, Math.floor(currentLevel / 3) + 1);
}
function $df8a44d92d572a5c$export$909e62d4478cec23(skillKey) {
    // Check if current character is on marketplace
    if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character && (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.isMarketplace) {
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)('Cannot upgrade skills with a character that is contracted out on the marketplace', 'error');
        return;
    }
    if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.skillPoints <= 0) return;
    if (!(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.skills[skillKey]) (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.skills[skillKey] = 0;
    // Calculate costs for next level (increases with current level)
    var currentLevel = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.skills[skillKey];
    var skillPointCost = $df8a44d92d572a5c$export$7d0067675be54b12(currentLevel);
    var currencyCost = $df8a44d92d572a5c$export$28bf58d3c9312b43(currentLevel);
    if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.skillPoints < skillPointCost) {
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)("\u26A0\uFE0F Need ".concat(skillPointCost, " skill points to upgrade this skill"), 'warning');
        return;
    }
    if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player.credits < currencyCost) {
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)("\u26A0\uFE0F Need ".concat(currencyCost, " credits to upgrade this skill"), 'warning');
        return;
    }
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.skills[skillKey]++;
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.skillPoints -= skillPointCost;
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player.credits -= currencyCost;
    // Update character skills if character exists
    if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character) (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.skills[skillKey] = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.skills[skillKey];
    (0, $b5bda7fdec806d8b$export$c7def531c087da85)("\u2728 Skill upgraded! ".concat((0, $ca7af38ea7b7b4a8$export$182937d2e68a339)(skillKey), " is now level ").concat((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.skills[skillKey], " (-").concat(currencyCost, " credits)"), 'success');
}
function $df8a44d92d572a5c$export$d09b0dfa38532c40() {
    var _config_progressionScaling;
    return ((_config_progressionScaling = $979b99378be707cd$export$9f9786ac427715c7) === null || _config_progressionScaling === void 0 ? void 0 : _config_progressionScaling.synergyUnlocks) || {
        minLevel: 4,
        cost: 2
    };
}
function $df8a44d92d572a5c$export$aaee02d18e8a1c01() {
    var character = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character;
    return ((character === null || character === void 0 ? void 0 : character.level) || 1) >= $df8a44d92d572a5c$export$d09b0dfa38532c40().minLevel;
}
function $df8a44d92d572a5c$export$7d626adf944498ee(skillId) {
    var character = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character;
    var _character_synergyUnlocks;
    return !!(character === null || character === void 0 ? void 0 : (_character_synergyUnlocks = character.synergyUnlocks) === null || _character_synergyUnlocks === void 0 ? void 0 : _character_synergyUnlocks[skillId]);
}
function $df8a44d92d572a5c$export$a2d6ef296e5ae7a1(skillKey) {
    var character = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character;
    var _character_skills;
    var cfg = $df8a44d92d572a5c$export$d09b0dfa38532c40();
    if (!character) return {
        success: false,
        reason: 'no-character'
    };
    if (!$df8a44d92d572a5c$export$aaee02d18e8a1c01(character)) return {
        success: false,
        reason: 'not-revealed'
    };
    if (((_character_skills = character.skills) === null || _character_skills === void 0 ? void 0 : _character_skills[skillKey]) === undefined) return {
        success: false,
        reason: 'unknown-skill'
    };
    if ($df8a44d92d572a5c$export$7d626adf944498ee(skillKey, character)) return {
        success: false,
        reason: 'already-unlocked'
    };
    if ((character.skillPoints || 0) < cfg.cost) return {
        success: false,
        reason: 'insufficient-points'
    };
    character.skillPoints -= cfg.cost;
    if (!character.synergyUnlocks) character.synergyUnlocks = {};
    character.synergyUnlocks[skillKey] = true;
    return {
        success: true,
        cost: cfg.cost
    };
}
function $df8a44d92d572a5c$export$401b195eeeb2d82c(effectId) {
    var character = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character;
    var _character_equippedArtifacts_utilitySlot_effects, _character_equippedArtifacts_utilitySlot, _character_equippedArtifacts;
    return (character === null || character === void 0 ? void 0 : (_character_equippedArtifacts = character.equippedArtifacts) === null || _character_equippedArtifacts === void 0 ? void 0 : (_character_equippedArtifacts_utilitySlot = _character_equippedArtifacts.utilitySlot) === null || _character_equippedArtifacts_utilitySlot === void 0 ? void 0 : (_character_equippedArtifacts_utilitySlot_effects = _character_equippedArtifacts_utilitySlot.effects) === null || _character_equippedArtifacts_utilitySlot_effects === void 0 ? void 0 : _character_equippedArtifacts_utilitySlot_effects[effectId]) || 0;
}
function $df8a44d92d572a5c$export$a5a257639bbcfa93(skillId) {
    var character = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character;
    var _character_equippedArtifacts, _artifact_effects;
    var artifact = character === null || character === void 0 ? void 0 : (_character_equippedArtifacts = character.equippedArtifacts) === null || _character_equippedArtifacts === void 0 ? void 0 : _character_equippedArtifacts.skillSlot;
    if (!artifact || !skillId || artifact.skill !== skillId) return 0;
    return ((_artifact_effects = artifact.effects) === null || _artifact_effects === void 0 ? void 0 : _artifact_effects['skill-success-bonus']) || 0;
}
function $df8a44d92d572a5c$export$ee2b8c06abb0026f() {
    // Command's Forward Depot and L3's Overclocked Grid stack ADDITIVELY into
    // one bonus rather than multiplying: two independent 50% boosts should be
    // "twice as fast", not 2.25x, and additive keeps the ceiling legible.
    var bonus = (0, $686e361e5cd4549d$export$84f52d60145287)('energy-regen', 0) + (0, $ee71dfe8b201c427$export$59fca837549bbada)('forward-depot', 0);
    return $df8a44d92d572a5c$var$energyRegenRate / (1 + bonus);
}
function $df8a44d92d572a5c$export$422aab3227f4499c() {
    return 3600000 / $df8a44d92d572a5c$export$ee2b8c06abb0026f();
}
function $df8a44d92d572a5c$export$e244cc0abc4b66d7(timePassedMs) {
    // Regenerate 1 energy every 2 minutes (120,000 ms)
    // This balances with raid energy cost: raids cost ~1 energy per 10 seconds
    // So a 2-minute raid costs ~12 energy, which takes ~24 minutes to recover (roughly 2x raid time)
    return Math.floor(timePassedMs / $df8a44d92d572a5c$export$ee2b8c06abb0026f());
}
function $df8a44d92d572a5c$export$e4e85317acdbc3c2() {
    var currentTime = Date.now();
    var timeDiffMs = currentTime - (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player.lastEnergyUpdate;
    var energyToRestore = $df8a44d92d572a5c$export$e244cc0abc4b66d7(timeDiffMs);
    if (energyToRestore > 0) {
        if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player.energy < (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player.maxEnergy) {
            (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).raid, "Restoring energy:", energyToRestore, "at 1 every", $df8a44d92d572a5c$var$energyRegenRate / 1000, "s Time since last update (ms):", timeDiffMs);
            (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player.energy = Math.min((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player.maxEnergy, (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player.energy + energyToRestore);
        }
        (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player.lastEnergyUpdate = currentTime;
    }
}
function $df8a44d92d572a5c$export$6b2f9302a94ab080() {
    if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player.energy >= (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player.maxEnergy) return null;
    var currentTime = Date.now();
    var timeSinceLastRegen = currentTime - (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player.lastEnergyUpdate;
    var rate = $df8a44d92d572a5c$export$ee2b8c06abb0026f();
    var timeToNextRegen = rate - timeSinceLastRegen % rate;
    return currentTime + timeToNextRegen;
}
function $df8a44d92d572a5c$export$11d38807a029df6f(member, timePassedMs) {
    // No recovery during active raid
    if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid && (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress) return false;
    var hasChanges = false;
    if (member.injured && member.recoveryTime) {
        if (Date.now() >= member.recoveryTime) {
            (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).raid, "Recovering team member:", member.name);
            member.injured = false;
            member.currentHp = member.maxHp || 100;
            delete member.recoveryTime;
            hasChanges = true;
        }
    } else if (member.currentHp < (member.maxHp || 100)) {
        var healAmount = Math.round(2 * timePassedMs / 1000); // 2 per second
        (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).raid, "Restoring health for", member.name, ":", healAmount, "at 2 every second. Time since last update (ms):", timePassedMs);
        member.currentHp = Math.min(member.maxHp, member.currentHp + healAmount);
        hasChanges = true;
    }
    return hasChanges;
}



var $8bda0cb20f0b197d$export$92731a7af45eafdd = {};
function $8bda0cb20f0b197d$export$16a0347071379537() {
    var multipliers = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    $8bda0cb20f0b197d$export$92731a7af45eafdd = (0, $fa9769297b8a68c8$export$71511d61b312f219)({}, multipliers);
}
function $8bda0cb20f0b197d$export$7d19902b620007ca(itemId) {
    return $8bda0cb20f0b197d$export$92731a7af45eafdd[itemId] !== undefined ? $8bda0cb20f0b197d$export$92731a7af45eafdd[itemId] : 1.0;
}
function $8bda0cb20f0b197d$export$2cbb40695b9e7336(itemIds) {
    var boost = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    if (!itemIds || itemIds.length === 0) return null;
    // Optional selection boost: items passing boost.predicate get their
    // weight multiplied (e.g. the Relic Resonance Tuner favoring relics
    // within a mixed pool without inflating the rest of it)
    var weightOf = boost ? function(id) {
        return $8bda0cb20f0b197d$export$7d19902b620007ca(id) * (boost.predicate(id) ? boost.multiplier : 1);
    } : $8bda0cb20f0b197d$export$7d19902b620007ca;
    var totalWeight = itemIds.reduce(function(sum, id) {
        return sum + weightOf(id);
    }, 0);
    if (totalWeight <= 0) return itemIds[Math.floor(Math.random() * itemIds.length)];
    var roll = Math.random() * totalWeight;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = itemIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var id = _step.value;
            roll -= weightOf(id);
            if (roll <= 0) return id;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return itemIds[itemIds.length - 1];
}
var $8bda0cb20f0b197d$export$517ceadb17e419d2 = {
    globalMultiplier: 1.0,
    tierMultipliers: {
        1: 1.0,
        2: 1.0,
        3: 1.0
    }
};
function $8bda0cb20f0b197d$export$b1b6e81d46587814() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    $8bda0cb20f0b197d$export$517ceadb17e419d2 = {
        globalMultiplier: config.globalMultiplier !== undefined ? config.globalMultiplier : 1.0,
        tierMultipliers: config.tierMultipliers || {
            1: 1.0,
            2: 1.0,
            3: 1.0
        }
    };
}
function $8bda0cb20f0b197d$export$c5c0ad2417da3e22() {
    var tier = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
    var tierMultiplier = $8bda0cb20f0b197d$export$517ceadb17e419d2.tierMultipliers[tier] || 1.0;
    return $8bda0cb20f0b197d$export$517ceadb17e419d2.globalMultiplier * tierMultiplier;
}
function $8bda0cb20f0b197d$export$78a769585121af92(creditsEarned) {
    var tier = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    var multiplier = $8bda0cb20f0b197d$export$c5c0ad2417da3e22(tier);
    var currencyBonus = 1 + (0, $df8a44d92d572a5c$export$401b195eeeb2d82c)('currency-bonus', (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character) / 100;
    return Math.floor(creditsEarned * multiplier * currencyBonus);
}
var $8bda0cb20f0b197d$export$147d39d5ef3f8e42 = {
    globalMultiplier: 1.0,
    rarityMultipliers: {
        common: 1.0,
        uncommon: 1.0,
        rare: 1.0,
        epic: 1.0,
        legendary: 1.0,
        unique: 1.0,
        artifact: 1.0
    }
};
function $8bda0cb20f0b197d$export$b2554e3c8ffeec59() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    $8bda0cb20f0b197d$export$147d39d5ef3f8e42 = {
        globalMultiplier: config.globalMultiplier !== undefined ? config.globalMultiplier : 1.0,
        rarityMultipliers: config.rarityMultipliers || {
            common: 1.0,
            uncommon: 1.0,
            rare: 1.0,
            epic: 1.0,
            legendary: 1.0,
            unique: 1.0,
            artifact: 1.0
        }
    };
}
function $8bda0cb20f0b197d$export$98e32b77d8baebd() {
    var rarity = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'common';
    var rarityMultiplier = $8bda0cb20f0b197d$export$147d39d5ef3f8e42.rarityMultipliers[rarity] || 1.0;
    return $8bda0cb20f0b197d$export$147d39d5ef3f8e42.globalMultiplier * rarityMultiplier;
}
function $8bda0cb20f0b197d$export$574cc08100f7d092(cost) {
    var rarity = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'common';
    var multiplier = $8bda0cb20f0b197d$export$98e32b77d8baebd(rarity);
    return Math.floor(cost * multiplier);
}
var $8bda0cb20f0b197d$export$45cd5f886ea338fc = {
    escalationFactor: 1.0
};
function $8bda0cb20f0b197d$export$12f04c67a6a6e4dd() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    $8bda0cb20f0b197d$export$45cd5f886ea338fc = {
        escalationFactor: config.escalationFactor !== undefined ? config.escalationFactor : 1.0
    };
}
function $8bda0cb20f0b197d$export$41c2b3834e95fdda(player) {
    var now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
    var today = new Date(now).toDateString();
    if (!(player === null || player === void 0 ? void 0 : player.energyPurchases) || player.energyPurchases.day !== today) return 0;
    return player.energyPurchases.count || 0;
}
function $8bda0cb20f0b197d$export$1214c02c27df458d(itemData, player) {
    var now = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Date.now();
    var base = (itemData === null || itemData === void 0 ? void 0 : itemData.credits) || 0;
    if (!(itemData === null || itemData === void 0 ? void 0 : itemData.restoresEnergy)) return base;
    var factor = $8bda0cb20f0b197d$export$45cd5f886ea338fc.escalationFactor || 1.0;
    return Math.round(base * Math.pow(factor, $8bda0cb20f0b197d$export$41c2b3834e95fdda(player, now)));
}
function $8bda0cb20f0b197d$export$cfff9bc32ab6cb78(player) {
    var now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
    var today = new Date(now).toDateString();
    if (!player.energyPurchases || player.energyPurchases.day !== today) player.energyPurchases = {
        day: today,
        count: 0
    };
    player.energyPurchases.count += 1;
}
function $8bda0cb20f0b197d$export$d2ef23ef6c7c6dd5(rarity, tier) {
    var roomType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "gate";
    var rarityConfig = $979b99378be707cd$export$d4a72d069095e9e5[rarity];
    if (!rarityConfig) return 0;
    var dropConfig = rarityConfig.dropChance;
    // Check minimum tier requirement
    if ((dropConfig === null || dropConfig === void 0 ? void 0 : dropConfig.minTier) && tier < dropConfig.minTier) return 0;
    // Handle room-type specific chances (for rare tier)
    if ((dropConfig === null || dropConfig === void 0 ? void 0 : dropConfig.gate) && (dropConfig === null || dropConfig === void 0 ? void 0 : dropConfig.hazard)) {
        var cfg = roomType === "gate" ? dropConfig.gate : dropConfig.hazard;
        return Math.min(cfg.base + (tier - 1) * cfg.perTier, cfg.max);
    }
    // Handle simple base + perTier + max formula
    if ((dropConfig === null || dropConfig === void 0 ? void 0 : dropConfig.base) !== undefined) {
        var chance = dropConfig.base + (tier - 1) * (dropConfig.perTier || 0);
        return dropConfig.max ? Math.min(chance, dropConfig.max) : chance;
    }
    return 0;
}
function $8bda0cb20f0b197d$export$540736c4d7813ac(rarity, tier) {
    var roomType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "gate";
    var rarityConfig = $979b99378be707cd$export$d4a72d069095e9e5[rarity];
    if (!rarityConfig) return 1;
    var quantityConfig = rarityConfig.quantity;
    var minMaxQuantity = {
        min: 1,
        max: 1
    };
    // Simple fixed quantity (epic, unique)
    if (typeof quantityConfig === "number") minMaxQuantity.min = minMaxQuantity.max = quantityConfig;
    // Room-type specific quantity
    if ((quantityConfig === null || quantityConfig === void 0 ? void 0 : quantityConfig.gate) && (quantityConfig === null || quantityConfig === void 0 ? void 0 : quantityConfig.hazard)) {
        var cfg = roomType === "gate" ? quantityConfig.gate : quantityConfig.hazard;
        minMaxQuantity.min = cfg.base ? cfg.base : 1;
        if (cfg.perTier) minMaxQuantity.min = Math.min(cfg.base + (tier - 1) * cfg.perTier, cfg.max);
        minMaxQuantity.max = minMaxQuantity.min;
        if (cfg.max && cfg.max > minMaxQuantity.min) minMaxQuantity.max = cfg.max;
        else if (cfg.random && cfg.random > 0) minMaxQuantity.max = minMaxQuantity.min + cfg.random;
    }
    return minMaxQuantity;
}
function $8bda0cb20f0b197d$export$d2188f6548dbea9f(lootGained, itemType, amount) {
    lootGained[itemType] = (lootGained[itemType] || 0) + amount;
}
function $8bda0cb20f0b197d$export$f4cc72695e6df27a(message, type) {
    var stepIndex = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    // If stepIndex is provided, add to step-specific logs
    if (stepIndex !== null && (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress) {
        if (!(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress.stepLogs) (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress.stepLogs = {};
        if (!(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress.stepLogs[stepIndex]) (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress.stepLogs[stepIndex] = [];
        (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress.stepLogs[stepIndex].push({
            message: message,
            type: type,
            timestamp: Date.now()
        });
    }
}
function $8bda0cb20f0b197d$export$fd59807889add359(message, type) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    // Add to raid log (step-specific if stepIndex provided)
    $8bda0cb20f0b197d$export$f4cc72695e6df27a(message, type, options.stepIndex);
    (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).raid, message);
    // Add notification unless explicitly disabled
    if (options.notify !== false) {
        // Map log types to notification types for better UX
        var notificationTypeMap = {
            failure: "error",
            info: "info",
            success: "success",
            bonus: "bonus"
        };
        var notificationType = notificationTypeMap[type] || type;
        // Use custom notification message if provided, otherwise use log message
        var notificationMessage = options.notificationMessage || message;
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)(notificationMessage, notificationType);
    }
}
function $8bda0cb20f0b197d$export$ad0c244e6b90d977(room) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries($979b99378be707cd$export$aeeef991191508e2)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step.value, 2), factionKey = _step_value[0], faction = _step_value[1];
            if (faction.skills[room.primary]) return factionKey;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
}
function $8bda0cb20f0b197d$export$10ac30a050ae6642(room) {
    var rarity = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "common";
    var roomFaction = $8bda0cb20f0b197d$export$ad0c244e6b90d977(room);
    if (roomFaction) // Get materials that match faction and rarity
    return Object.values((0, $ca7af38ea7b7b4a8$export$15b7d0c192d0aa5d)()).filter(function(item) {
        return item.type === "material" && item.rarity === rarity && item.faction === roomFaction;
    }).map(function(item) {
        return item.id;
    });
    else // Mixed faction room - return all materials of this rarity
    return $8bda0cb20f0b197d$export$b1ad0808e6cb0531("material", rarity);
}
function $8bda0cb20f0b197d$export$61bdab8a63df855c(room) {
    var roomFaction = $8bda0cb20f0b197d$export$ad0c244e6b90d977(room);
    var roomSkills = new Set([
        room.primary
    ].concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)(room.support || [])));
    var artifactById = new Map((0, $ca7af38ea7b7b4a8$export$18c4115a8e7963b)().map(function(a) {
        return [
            a.id,
            a
        ];
    }));
    return Object.values((0, $ca7af38ea7b7b4a8$export$15b7d0c192d0aa5d)()).filter(function(item) {
        if (item.type !== "blueprint") return false;
        if (!item.faction) return false;
        if (item.faction !== roomFaction && item.faction !== "neutral") return false;
        var artifact = artifactById.get(item.id.replace(/-blueprint$/, ""));
        if (artifact === null || artifact === void 0 ? void 0 : artifact.skill) return roomSkills.has(artifact.skill);
        return true;
    }).map(function(item) {
        return item.id;
    });
}
function $8bda0cb20f0b197d$export$b1ad0808e6cb0531() {
    var itemType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "material", rarity = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var items = Object.values((0, $ca7af38ea7b7b4a8$export$15b7d0c192d0aa5d)()).filter(function(item) {
        if (item.type !== itemType) return false;
        if (rarity && item.rarity !== rarity) return false;
        return true;
    });
    return items.map(function(item) {
        return item.id;
    });
}
function $8bda0cb20f0b197d$export$65aa634013c8a9db(tier) {
    var rarityMap = {
        1: "common",
        2: "uncommon",
        3: "rare"
    };
    return rarityMap[tier] || "common";
}



var $ee71dfe8b201c427$export$d94c2b2ebc33805a = {
    dominion: [
        'cradle-expanse',
        'shard-cities'
    ],
    wilders: [
        'verdant-reclamation',
        'sunken-bastions'
    ],
    veil: [
        'hollow-core',
        'sunken-bastions'
    ]
};
function $ee71dfe8b201c427$export$b97b2e8df296cd3b() {
    if (!(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).command) (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).command = (0, $fe47a452a83d9e00$export$d79000c880c47c99)();
    return (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).command;
}
function $ee71dfe8b201c427$export$12c456cbb12a94a8(upgradeId) {
    var _gameState_command_upgrades, _gameState_command;
    return ((_gameState_command = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).command) === null || _gameState_command === void 0 ? void 0 : (_gameState_command_upgrades = _gameState_command.upgrades) === null || _gameState_command_upgrades === void 0 ? void 0 : _gameState_command_upgrades[upgradeId]) || 0;
}
function $ee71dfe8b201c427$export$c95b8ce76efadccf() {
    var _config_progressionScaling;
    return ((_config_progressionScaling = $979b99378be707cd$export$9f9786ac427715c7) === null || _config_progressionScaling === void 0 ? void 0 : _config_progressionScaling.allowDuplicateCrafts) === true;
}
function $ee71dfe8b201c427$export$2886ceaa061d802b(character, itemId) {
    var _character_inventory;
    if (((character === null || character === void 0 ? void 0 : (_character_inventory = character.inventory) === null || _character_inventory === void 0 ? void 0 : _character_inventory[itemId]) || 0) > 0) return true;
    return Object.values((character === null || character === void 0 ? void 0 : character.equippedTechniqueGear) || {}).some(function(g) {
        return g && (g.id === itemId || g === itemId);
    });
}
function $ee71dfe8b201c427$export$770281d4afda41b1(character, artifactId) {
    return ((character === null || character === void 0 ? void 0 : character.artifacts) || []).some(function(a) {
        return a && a.id === artifactId;
    });
}
function $ee71dfe8b201c427$export$59fca837549bbada(upgradeId) {
    var fallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var _config_commandUpgrades, _def_effectValues;
    var rank = $ee71dfe8b201c427$export$12c456cbb12a94a8(upgradeId);
    if (rank <= 0) return fallback;
    var def = (_config_commandUpgrades = $979b99378be707cd$export$617b3a0bcd7cead7) === null || _config_commandUpgrades === void 0 ? void 0 : _config_commandUpgrades[upgradeId];
    var _def_effectValues_;
    return (_def_effectValues_ = def === null || def === void 0 ? void 0 : (_def_effectValues = def.effectValues) === null || _def_effectValues === void 0 ? void 0 : _def_effectValues[rank - 1]) !== null && _def_effectValues_ !== void 0 ? _def_effectValues_ : fallback;
}
function $ee71dfe8b201c427$export$f22d59777b51e96b(character) {
    if (!character) return 0;
    var owned = new Set();
    Object.entries(character.inventory || {}).forEach(function(param) {
        var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), itemId = _param[0], qty = _param[1];
        var _findItem;
        if (qty > 0 && ((_findItem = (0, $ca7af38ea7b7b4a8$export$a2dea178c28a0308)('id', itemId)) === null || _findItem === void 0 ? void 0 : _findItem.type) === 'techGear') owned.add(itemId);
    });
    Object.values(character.equippedTechniqueGear || {}).forEach(function(gearId) {
        var _findItem;
        if (gearId && ((_findItem = (0, $ca7af38ea7b7b4a8$export$a2dea178c28a0308)('id', gearId)) === null || _findItem === void 0 ? void 0 : _findItem.type) === 'techGear') owned.add(gearId);
    });
    return owned.size;
}
function $ee71dfe8b201c427$export$ffae5de2f7ddd94d(character) {
    var _character_lifetime, _character_lifetime1, _character_lifetime2;
    // Direct read, no fallback: an inline default here would silently compute a
    // DIFFERENT marks curve if constants.js were stale, and the old fallback had
    // itself drifted years out of date while reading like documentation.
    // configValidation.js proves this exists at boot.
    var c = $979b99378be707cd$export$9f9786ac427715c7.commandMarks;
    var techGear = $ee71dfe8b201c427$export$f22d59777b51e96b(character);
    var artifactsUnlocked = (character === null || character === void 0 ? void 0 : (_character_lifetime = character.lifetime) === null || _character_lifetime === void 0 ? void 0 : _character_lifetime.artifactsUnlocked) || 0;
    var artifacts = (character === null || character === void 0 ? void 0 : (_character_lifetime1 = character.lifetime) === null || _character_lifetime1 === void 0 ? void 0 : _character_lifetime1.artifactsCrafted) || 0;
    var t3Wins = (character === null || character === void 0 ? void 0 : (_character_lifetime2 = character.lifetime) === null || _character_lifetime2 === void 0 ? void 0 : _character_lifetime2.t3Wins) || 0;
    var level = (character === null || character === void 0 ? void 0 : character.level) || 1;
    var _c_perArtifactUnlock, _c_perArtifactCraft;
    // All banked at promotion. Artifacts split into the one-time-per-design
    // UNLOCK milestone (the account-level achievement, credited to whichever
    // character consumed the blueprint) and the repeatable per-CRAFT value.
    var breakdown = {
        techGear: {
            count: techGear,
            marks: techGear * c.perTechGear
        },
        artifactUnlocks: {
            count: artifactsUnlocked,
            marks: artifactsUnlocked * ((_c_perArtifactUnlock = c.perArtifactUnlock) !== null && _c_perArtifactUnlock !== void 0 ? _c_perArtifactUnlock : 0)
        },
        artifacts: {
            count: artifacts,
            marks: artifacts * ((_c_perArtifactCraft = c.perArtifactCraft) !== null && _c_perArtifactCraft !== void 0 ? _c_perArtifactCraft : 0)
        },
        t3Wins: {
            count: t3Wins,
            marks: Math.floor(t3Wins / c.t3WinsDivisor)
        },
        level: {
            count: level,
            marks: level * c.perLevel
        }
    };
    var total = Object.values(breakdown).reduce(function(sum, b) {
        return sum + b.marks;
    }, 0);
    return {
        total: total,
        breakdown: breakdown
    };
}
function $ee71dfe8b201c427$export$2ab3ae91631fe8e5(artifactId) {
    return ($ee71dfe8b201c427$export$b97b2e8df296cd3b().unlockedArtifacts || []).includes(artifactId);
}
function $ee71dfe8b201c427$export$5361c32fc9d089b2(artifactId) {
    var _character_inventory, _config_progressionScaling_commandMarks, _config_progressionScaling;
    var command = $ee71dfe8b201c427$export$b97b2e8df296cd3b();
    if (!command.unlockedArtifacts) command.unlockedArtifacts = [];
    if (command.unlockedArtifacts.includes(artifactId)) return {
        success: false,
        reason: 'already-unlocked'
    };
    var blueprintId = "".concat(artifactId, "-blueprint");
    var character = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character;
    if (!character || (((_character_inventory = character.inventory) === null || _character_inventory === void 0 ? void 0 : _character_inventory[blueprintId]) || 0) < 1) return {
        success: false,
        reason: 'no-blueprint'
    };
    character.inventory[blueprintId] -= 1;
    if (character.inventory[blueprintId] <= 0) delete character.inventory[blueprintId];
    command.unlockedArtifacts.push(artifactId);
    (0, $fe47a452a83d9e00$export$6b22d50e3ddf4789)(character);
    character.lifetime.artifactsUnlocked = (character.lifetime.artifactsUnlocked || 0) + 1;
    var marks = ((_config_progressionScaling = $979b99378be707cd$export$9f9786ac427715c7) === null || _config_progressionScaling === void 0 ? void 0 : (_config_progressionScaling_commandMarks = _config_progressionScaling.commandMarks) === null || _config_progressionScaling_commandMarks === void 0 ? void 0 : _config_progressionScaling_commandMarks.perArtifactUnlock) || 0;
    return {
        success: true,
        marks: marks
    };
}
function $ee71dfe8b201c427$export$25d1e5af45c35a33() {
    var command = $ee71dfe8b201c427$export$b97b2e8df296cd3b();
    if (command.revealed) return true;
    var threshold = $979b99378be707cd$export$9f9786ac427715c7.commandMarks.unlockThreshold;
    if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character && $ee71dfe8b201c427$export$ffae5de2f7ddd94d((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character).total >= threshold) command.revealed = true;
    return command.revealed;
}
function $ee71dfe8b201c427$export$99736e0126d21b50(character) {
    var allRegions = Object.keys($979b99378be707cd$export$4fbdcec70fce9d73);
    var command = $ee71dfe8b201c427$export$b97b2e8df296cd3b();
    if (command.grandfathered) return allRegions;
    var starts = $ee71dfe8b201c427$export$d94c2b2ebc33805a[character === null || character === void 0 ? void 0 : character.faction];
    if (!starts) return allRegions;
    var available = new Set((0, $4c858c0d999a5b9b$export$71511d61b312f219)(starts).concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)(command.charterRegions || [])));
    return allRegions.filter(function(r) {
        return available.has(r);
    });
}
function $ee71dfe8b201c427$export$5a56eaf8a61d7ab9(character) {
    var _config_contractorSkillFlavors, _flavor_roles, _flavor_promotedQuotes;
    var skills = (character === null || character === void 0 ? void 0 : character.skills) || {};
    var bestSkill = Object.keys(skills).sort(function(a, b) {
        return (skills[b] || 0) - (skills[a] || 0);
    })[0];
    var flavor = (_config_contractorSkillFlavors = $979b99378be707cd$export$9be8953559278e7) === null || _config_contractorSkillFlavors === void 0 ? void 0 : _config_contractorSkillFlavors[bestSkill];
    var promoted = flavor === null || flavor === void 0 ? void 0 : flavor.promotedRoles;
    if (!(promoted === null || promoted === void 0 ? void 0 : promoted.length)) return {
        role: (character === null || character === void 0 ? void 0 : character.title) || null,
        quote: null
    };
    var _flavor_roles_indexOf;
    var idx = (_flavor_roles_indexOf = (_flavor_roles = flavor.roles) === null || _flavor_roles === void 0 ? void 0 : _flavor_roles.indexOf(character === null || character === void 0 ? void 0 : character.title)) !== null && _flavor_roles_indexOf !== void 0 ? _flavor_roles_indexOf : -1;
    if (idx < 0 || !promoted[idx]) {
        // Deterministic fallback: hash the name so preview and Legend agree
        var name = (character === null || character === void 0 ? void 0 : character.name) || '';
        var h = 0;
        for(var i = 0; i < name.length; i++)h = h * 31 + name.charCodeAt(i) | 0;
        idx = Math.abs(h) % promoted.length;
    }
    return {
        role: promoted[idx],
        quote: ((_flavor_promotedQuotes = flavor.promotedQuotes) === null || _flavor_promotedQuotes === void 0 ? void 0 : _flavor_promotedQuotes[idx]) || null
    };
}
function $ee71dfe8b201c427$export$be02e18412b74462(character) {
    return $ee71dfe8b201c427$export$5a56eaf8a61d7ab9(character).role;
}
function $ee71dfe8b201c427$export$d7db1ce90eca9a05() {
    var _gameState_currentRaid;
    var character = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character;
    if (!character) return {
        ok: false,
        reason: 'no-active-character'
    };
    if (character.isMarketplace || character.marketplaceData) return {
        ok: false,
        reason: 'listed-on-marketplace'
    };
    // Any owned raid state blocks promotion (planning grid, active run, or an
    // unclaimed completed raid) - same rule character deletion applies
    if (((_gameState_currentRaid = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid) === null || _gameState_currentRaid === void 0 ? void 0 : _gameState_currentRaid.raidOwnerId) === (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).activeCharacterId && ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid || (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress || (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidCompleted)) return {
        ok: false,
        reason: 'raid-in-progress'
    };
    return {
        ok: true
    };
}
function $ee71dfe8b201c427$export$da98dc4e7bdea782(inventory) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_vaultShare = _ref.vaultShare, vaultShare = _ref_vaultShare === void 0 ? 0 : _ref_vaultShare, _ref_vault = _ref.vault, vault = _ref_vault === void 0 ? null : _ref_vault, _ref_consignment = _ref.consignment, consignment = _ref_consignment === void 0 ? null : _ref_consignment, _ref_consignRate = _ref.consignRate, consignRate = _ref_consignRate === void 0 ? null : _ref_consignRate;
    var credits = 0;
    var liquidated = 0;
    var consumed = 0;
    if (consignRate == null) consignRate = $979b99378be707cd$export$9f9786ac427715c7.consignmentRate;
    Object.entries(inventory || {}).forEach(function(param) {
        var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), itemId = _param[0], qty = _param[1];
        if (qty <= 0) return;
        var item = (0, $ca7af38ea7b7b4a8$export$a2dea178c28a0308)('id', itemId);
        switch(item === null || item === void 0 ? void 0 : item.type){
            case 'blueprint':
            case 'storyRelic':
                if (vault) vault[itemId] = (vault[itemId] || 0) + qty;
                break;
            case 'material':
                {
                    var kept = Math.floor(qty * vaultShare);
                    if (kept > 0 && vault) vault[itemId] = (vault[itemId] || 0) + kept;
                    // What the successor does not inherit is NOT all convoy cargo.
                    // Only `consignmentRate` of it reaches the Syndicate; the rest
                    // is spent living — the settlement eats, repairs and rebuilds
                    // out of the same stock. See progressionScaling.consignmentRate
                    // for why the accounting had to stop being closed.
                    var remainder = qty - kept;
                    var shipped = Math.floor(remainder * consignRate);
                    if (shipped > 0 && consignment) consignment[itemId] = (consignment[itemId] || 0) + shipped;
                    consumed += remainder - shipped;
                    break;
                }
            case 'relic':
            case 'consumable':
                if (item.credits > 0) {
                    credits += item.credits * qty;
                    liquidated += 1;
                }
                break;
            default:
                break;
        }
    });
    return {
        credits: credits,
        liquidated: liquidated,
        consumed: consumed
    };
}
function $ee71dfe8b201c427$export$f0bd6e9010bb1600() {
    var _gameState_syndicate;
    var _gameState_syndicate1;
    var eligible = $ee71dfe8b201c427$export$d7db1ce90eca9a05();
    if (!eligible.ok) return {
        success: false,
        reason: eligible.reason
    };
    var character = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character;
    var command = $ee71dfe8b201c427$export$b97b2e8df296cd3b();
    (0, $fe47a452a83d9e00$export$6b22d50e3ddf4789)(character);
    var marks = $ee71dfe8b201c427$export$ffae5de2f7ddd94d(character);
    // Skeleton Crew's perk. Applied to the BANKED total rather than inside
    // calculateCommandMarks, because that function is also the promote modal's
    // preview and the succession doctrine's rate input — inflating it there
    // would make the peak policy chase a number that is not what it measures.
    var blackoutMarks = (0, $686e361e5cd4549d$export$84f52d60145287)('promotion-marks', 0);
    if (blackoutMarks > 0) marks.total = Math.round(marks.total * (1 + blackoutMarks));
    // Guild Vault: SPLIT the outgoing character's materials, destroy nothing.
    //
    // A fixed share keeps materials for the next recruit (command.vault, as
    // before) and the remainder — which used to evaporate with the character —
    // is consigned to `syndicate.consignment` as Operations cargo. The promoted
    // member packs up their kit; what the successor does not inherit is what the
    // convoys carry.
    //
    // The CONSIGNMENT, not the live dock (`syndicate.stores`). Founding is
    // repeatable, so this era's promotions are provisioning the NEXT Syndicate;
    // writing straight to the dock would top up the current one and dissolve
    // the per-era budget.
    //
    // So the rank is now a DIAL between two destinations rather than a
    // save-versus-destroy switch, and rank 0 consigns 100% rather than losing
    // it. Flagged for S7: that inverts the upgrade's purchase logic, since marks
    // spent here make convoys leaner.
    //
    // Everything that is NOT material is routed by disburseInventory() — see
    // there for why blueprints and story relics are filed whole, and why relics
    // and consumables are sold rather than dropped.
    var vaultShare = $979b99378be707cd$export$9f9786ac427715c7.vaultCarryover;
    var consignment = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).syndicate ? (_gameState_syndicate1 = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).syndicate).consignment || (_gameState_syndicate1.consignment = {}) : null;
    var disbursed = $ee71dfe8b201c427$export$da98dc4e7bdea782(character.inventory, {
        vaultShare: vaultShare,
        vault: command.vault,
        consignment: consignment
    });
    // Credited BEFORE the levy, deliberately. Relics and consumables are wealth,
    // and the levy exists because "credits are account-shared, so a flat reset
    // would be trivially dodged by holding wealth elsewhere". Crediting after
    // the levy would make stockpiling purchasable consumables exactly that dodge
    // — buy at full price before promoting, cash out untaxed after.
    if (disbursed.credits > 0) (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player.credits = ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player.credits || 0) + disbursed.credits;
    var legend = {
        name: character.name,
        avatar: character.avatar,
        avatarSeed: character.avatarSeed,
        faction: character.faction,
        level: character.level || 1,
        tour: command.tour,
        techGear: marks.breakdown.techGear.count,
        artifactsUnlocked: marks.breakdown.artifactUnlocks.count,
        artifactsCrafted: marks.breakdown.artifacts.count,
        t3Wins: marks.breakdown.t3Wins.count,
        marksEarned: marks.total,
        promotedRole: $ee71dfe8b201c427$export$be02e18412b74462(character),
        promotedAt: Date.now()
    };
    command.marks += marks.total;
    // Writ input for the Syndicate layer (M3). Tracked separately from
    // command.marks because that is a spendable BALANCE - it drops every time
    // the player buys an upgrade, and Writs must price the era that was run,
    // not the change left in the player's pocket at the end of it. Every marks
    // source funnels through promotion, so this line is the whole accumulator.
    if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).syndicate) (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).syndicate.eraMarks += marks.total;
    command.legends.push(legend);
    command.tour += 1;
    // A new tour starts with a fresh rate curve — carrying the old peak forward
    // would have the doctrine judging the successor against their predecessor's
    // best run and promoting them almost immediately.
    if ((_gameState_syndicate = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).syndicate) === null || _gameState_syndicate === void 0 ? void 0 : _gameState_syndicate.succession) {
        (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).syndicate.succession.tourRaids = 0;
        (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).syndicate.succession.peakRate = 0;
        (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).syndicate.succession.peakAtRaid = 0;
    }
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).characters = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).characters.filter(function(c) {
        return c.id !== character.id;
    });
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character = null;
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).activeCharacterId = null;
    var levy = $979b99378be707cd$export$9f9786ac427715c7.promotionCreditLevy;
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player.credits = Math.max(levy.floor, Math.floor(((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player.credits || 0) * levy.keepFraction));
    // Re-derive from the new tour rather than compounding module state (see
    // applyCraftingDiscountForTour).
    $ee71dfe8b201c427$export$6d153901dd951884();
    return {
        success: true,
        marks: marks,
        legend: legend,
        disbursed: disbursed
    };
}
function $ee71dfe8b201c427$export$4ece4efb45f52fed(tour) {
    var cfg = $979b99378be707cd$export$9f9786ac427715c7.craftingCostScaling;
    var factor = $979b99378be707cd$export$9f9786ac427715c7.craftingDiscountPerTour;
    var perTour = cfg.globalMultiplier * Math.pow(factor, Math.max(0, (tour || 1) - 1));
    // Cold Drop's perk. Multiplied INTO the curve rather than clamped under it:
    // the spec calls it a "floor" discount, and the per-tour curve is already a
    // decaying multiplier — a separate floor would fight it, and the deeper a
    // player goes the more a subtraction would distort. Same shape, one factor.
    return perTour * (1 - (0, $686e361e5cd4549d$export$84f52d60145287)('crafting-floor', 0));
}
function $ee71dfe8b201c427$export$6d153901dd951884() {
    var tour = $ee71dfe8b201c427$export$b97b2e8df296cd3b().tour;
    (0, $8bda0cb20f0b197d$export$b2554e3c8ffeec59)({
        globalMultiplier: $ee71dfe8b201c427$export$4ece4efb45f52fed(tour),
        rarityMultipliers: $979b99378be707cd$export$9f9786ac427715c7.craftingCostScaling.rarityMultipliers
    });
    return (0, $8bda0cb20f0b197d$export$98e32b77d8baebd)();
}
function $ee71dfe8b201c427$export$7647bd5455c447e6() {
    var _gameState_command_legends, _gameState_command;
    var perLegend = $ee71dfe8b201c427$export$59fca837549bbada('legend-bonus', 0);
    if (perLegend <= 0) return 1;
    return 1 + perLegend * (((_gameState_command = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).command) === null || _gameState_command === void 0 ? void 0 : (_gameState_command_legends = _gameState_command.legends) === null || _gameState_command_legends === void 0 ? void 0 : _gameState_command_legends.length) || 0);
}
function $ee71dfe8b201c427$export$b80ce5f774104e94(character) {
    var command = $ee71dfe8b201c427$export$b97b2e8df296cd3b();
    var granted = {};
    Object.entries(command.vault || {}).forEach(function(param) {
        var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), itemId = _param[0], qty = _param[1];
        if (qty > 0) {
            character.inventory[itemId] = (character.inventory[itemId] || 0) + qty;
            granted[itemId] = qty;
        }
    });
    command.vault = {};
    return granted;
}
function $ee71dfe8b201c427$export$21d6f53ea6843ff6(upgradeId) {
    var rank = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $ee71dfe8b201c427$export$12c456cbb12a94a8(upgradeId);
    var _config_commandUpgrades;
    var def = (_config_commandUpgrades = $979b99378be707cd$export$617b3a0bcd7cead7) === null || _config_commandUpgrades === void 0 ? void 0 : _config_commandUpgrades[upgradeId];
    if (!def || rank >= def.costs.length) return null;
    return def.costs[rank];
}
function $ee71dfe8b201c427$export$21736c92e8c4e21c(def) {
    if (!(def === null || def === void 0 ? void 0 : def.requires)) return [];
    var required = Array.isArray(def.requires) ? def.requires : [
        def.requires
    ];
    return required.filter(function(id) {
        return $ee71dfe8b201c427$export$12c456cbb12a94a8(id) <= 0;
    });
}
function $ee71dfe8b201c427$export$a9f5f3e18483ed51(upgradeId) {
    var choice = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var _config_commandUpgrades;
    var def = (_config_commandUpgrades = $979b99378be707cd$export$617b3a0bcd7cead7) === null || _config_commandUpgrades === void 0 ? void 0 : _config_commandUpgrades[upgradeId];
    if (!def) return {
        success: false,
        reason: 'unknown-upgrade'
    };
    var command = $ee71dfe8b201c427$export$b97b2e8df296cd3b();
    var rank = $ee71dfe8b201c427$export$12c456cbb12a94a8(upgradeId);
    if (rank >= def.costs.length) return {
        success: false,
        reason: 'max-rank'
    };
    // Prerequisite upgrades (auto-raid-protocol needs auto-scout + foremans-
    // ledger). Checked before the cost so a player is told what is missing
    // rather than being told they are short of marks they would waste anyway.
    var missing = $ee71dfe8b201c427$export$21736c92e8c4e21c(def);
    if (missing.length > 0) return {
        success: false,
        reason: 'missing-requirement',
        requires: missing
    };
    var cost = $ee71dfe8b201c427$export$21d6f53ea6843ff6(upgradeId, rank);
    if (command.marks < cost) return {
        success: false,
        reason: 'insufficient-marks'
    };
    if (def.choice === 'region') {
        if (!choice || !$979b99378be707cd$export$4fbdcec70fce9d73[choice]) return {
            success: false,
            reason: 'invalid-region'
        };
        if (command.charterRegions.includes(choice)) return {
            success: false,
            reason: 'region-already-chartered'
        };
    }
    command.marks -= cost;
    command.upgrades[upgradeId] = rank + 1;
    if (def.choice === 'region') command.charterRegions.push(choice);
    return {
        success: true,
        rank: rank + 1,
        cost: cost
    };
}



//done
//@ts-check






//done
//@ts-check






/**
 * An item row's searchable description.
 *
 * This was CALLED but never defined — not here, not imported, not on window. So
 * `filteredItems` threw a ReferenceError on any search term that failed to match
 * by name, since the `||` only reaches this when the name misses. Alpine
 * swallows getter throws, so the symptom was a search box that silently stopped
 * narrowing rather than an error anyone would notice.
 */ function $80ed874fd909c4ae$var$getItemDescription(item) {
    var data = (item === null || item === void 0 ? void 0 : item.artifact) || (0, $ca7af38ea7b7b4a8$export$a2dea178c28a0308)('id', item === null || item === void 0 ? void 0 : item.id);
    return (data === null || data === void 0 ? void 0 : data.description) || (data === null || data === void 0 ? void 0 : data.short) || '';
}
/**
 * A plain { itemId: qty } map as the item rows the grid and filters read.
 *
 * Shared by the character's inventory and the layer vaults so all four sources
 * sort, filter and search identically — the vault screens are the same screen
 * pointed somewhere else, not a second implementation of it.
 */ function $80ed874fd909c4ae$var$itemRows(map) {
    var rows = [];
    Object.entries(map || {}).forEach(function(param) {
        var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), id = _param[0], quantity = _param[1];
        if (quantity <= 0 || id === 'Fish') return;
        var item = (0, $ca7af38ea7b7b4a8$export$a2dea178c28a0308)('id', id);
        if (!item) return;
        rows.push({
            id: id,
            name: item.name,
            quantity: quantity,
            type: (0, $a575049a7e5cb3a1$export$28b75a4bedf6475d)(id),
            rarity: item.rarity || 'common'
        });
    });
    return rows;
}
var $80ed874fd909c4ae$export$43ae57abf049ebd8 = {
    character: [
        {
            key: 'items',
            label: "\uD83C\uDF92 Carried"
        }
    ],
    commandVault: [
        {
            key: 'vault',
            label: "\uD83E\uDDD1 Outbound to next recruit"
        },
        {
            key: 'consignment',
            label: "\u23F3 Outbound at next founding"
        }
    ],
    syndicateStores: [
        {
            key: 'stores',
            label: "\uD83D\uDCE6 Dock"
        }
    ]
};
function $80ed874fd909c4ae$export$5e57bb1ccaa580e5() {
    // Alpine.js Contractor Store
    (0, $da6f71b8677b901e$export$2e2bcd8739ae039).store("inventory", {
        items: [],
        // The layer vaults. Live on the same store as the character's inventory so
        // one refresh() keeps every screen current — a second store would be a
        // second thing to remember to refresh.
        vault: [],
        stores: [],
        consignment: [],
        init: function() {
            // Initialize with current gameState data
            this.refresh();
        },
        refresh: function() {
            var _gameState_command, _gameState_syndicate, _gameState_syndicate1;
            this.vault = $80ed874fd909c4ae$var$itemRows((_gameState_command = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).command) === null || _gameState_command === void 0 ? void 0 : _gameState_command.vault);
            this.stores = $80ed874fd909c4ae$var$itemRows((_gameState_syndicate = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).syndicate) === null || _gameState_syndicate === void 0 ? void 0 : _gameState_syndicate.stores);
            this.consignment = $80ed874fd909c4ae$var$itemRows((_gameState_syndicate1 = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).syndicate) === null || _gameState_syndicate1 === void 0 ? void 0 : _gameState_syndicate1.consignment);
            // Convert gameState.character.inventory to an array format
            var inventoryItems = [];
            if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character && (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.inventory) {
                // Add regular inventory items
                Object.entries((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.inventory || {}).forEach(function(param) {
                    var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), id = _param[0], quantity = _param[1];
                    if (quantity > 0 && id != 'Fish') {
                        var item = (0, $ca7af38ea7b7b4a8$export$a2dea178c28a0308)('id', id);
                        //remove this later, check based on old name logic
                        if (item) inventoryItems.push({
                            id: id,
                            name: item.name,
                            quantity: quantity,
                            type: (0, $a575049a7e5cb3a1$export$28b75a4bedf6475d)(id),
                            rarity: item.rarity || 'common'
                        });
                    }
                });
                // Add artifacts
                if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.artifacts) (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.artifacts.forEach(function(artifact) {
                    inventoryItems.push({
                        id: artifact.id,
                        name: artifact.name,
                        quantity: 1,
                        type: "artifact",
                        rarity: artifact.rarity || 'unique',
                        artifact: artifact
                    });
                });
            }
            this.items = inventoryItems;
        },
        update: function(newInventory, newArtifacts) {
            if (newInventory != null) (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.inventory = newInventory;
            if (newArtifacts != null) (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.artifacts = newArtifacts;
            // Refresh from gameState and save
            this.refresh();
        },
        get all () {
            return this.items;
        },
        get count () {
            return this.items.length;
        }
    });
}
function $80ed874fd909c4ae$export$277774029cdaf1() {
    var source = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "character", readOnly = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return {
        searchTerm: "",
        selectedType: "all",
        selectedRarity: "all",
        sortBy: "name",
        source: source,
        readOnly: readOnly,
        activePool: ($80ed874fd909c4ae$export$43ae57abf049ebd8[source] || $80ed874fd909c4ae$export$43ae57abf049ebd8.character)[0].key,
        get pools () {
            return $80ed874fd909c4ae$export$43ae57abf049ebd8[this.source] || $80ed874fd909c4ae$export$43ae57abf049ebd8.character;
        },
        setPool: function(key) {
            this.activePool = key;
        },
        get items () {
            // Use the Alpine store instead of direct gameState access
            return this.$store.inventory[this.activePool] || [];
        },
        get filteredItems () {
            var _this = this;
            var filtered = this.items;
            // Filter by search term
            if (this.searchTerm) {
                var searchLower = this.searchTerm.toLowerCase();
                filtered = filtered.filter(function(item) {
                    return item.name.toLowerCase().includes(searchLower) || $80ed874fd909c4ae$var$getItemDescription(item).toLowerCase().includes(searchLower);
                });
            }
            // Filter by category
            if (this.selectedType !== "all") filtered = filtered.filter(function(item) {
                return item.type === _this.selectedType;
            });
            // Filter by rarity
            if (this.selectedRarity !== "all") filtered = filtered.filter(function(item) {
                return item.rarity === _this.selectedRarity;
            });
            // Sort items
            filtered.sort(function(a, b) {
                switch(_this.sortBy){
                    case "name":
                        return a.name.localeCompare(b.name);
                    case "quantity":
                        return b.quantity - a.quantity;
                    case "type":
                        var typeOrder = {
                            material: 1,
                            techGear: 2,
                            artifact: 3,
                            blueprint: 4,
                            consumable: 5
                        };
                        var typeDiff = (typeOrder[a.type] || 0) - (typeOrder[b.type] || 0);
                        return typeDiff !== 0 ? typeDiff : a.name.localeCompare(b.name);
                    case "rarity":
                        var rarityOrder = {
                            common: 1,
                            uncommon: 2,
                            rare: 3,
                            epic: 4,
                            legendary: 5,
                            unique: 6
                        };
                        var rarityDiff = (rarityOrder[a.rarity] || 0) - (rarityOrder[b.rarity] || 0);
                        return rarityDiff !== 0 ? rarityDiff : a.name.localeCompare(b.name);
                    case "credits":
                        var _findItem, _findItem1;
                        var aCredits = Number(((_findItem = (0, $ca7af38ea7b7b4a8$export$a2dea178c28a0308)('name', a.name)) === null || _findItem === void 0 ? void 0 : _findItem.credits) || 0);
                        var bCredits = Number(((_findItem1 = (0, $ca7af38ea7b7b4a8$export$a2dea178c28a0308)('name', b.name)) === null || _findItem1 === void 0 ? void 0 : _findItem1.credits) || 0);
                        return bCredits - aCredits; // High to low
                    default:
                        return 0;
                }
            });
            //console.log("Filtered items:", [...filtered]);
            return filtered;
        },
        get totalItems () {
            return this.items.length;
        },
        get filteredCount () {
            return this.filteredItems.length;
        },
        get itemTypes () {
            var itemTypes = new Set([
                "all"
            ]);
            this.items.forEach(function(item) {
                return itemTypes.add(item.type);
            });
            return Array.from(itemTypes).map(function(itemType) {
                return {
                    value: itemType,
                    label: itemType === "all" ? "All Items" : $979b99378be707cd$export$d02ea220375e4aff[itemType] ? $979b99378be707cd$export$d02ea220375e4aff[itemType].name : itemType.charAt(0).toUpperCase() + itemType.slice(1)
                };
            });
        },
        get itemRarities () {
            var rarities = new Set([
                "all"
            ]);
            this.items.forEach(function(item) {
                return rarities.add(item.rarity);
            });
            return Array.from(rarities).map(function(rarity) {
                return {
                    value: rarity,
                    label: rarity === "all" ? "All Rarities" : $979b99378be707cd$export$d4a72d069095e9e5[rarity] ? $979b99378be707cd$export$d4a72d069095e9e5[rarity].name : rarity.charAt(0).toUpperCase() + rarity.slice(1)
                };
            });
        },
        clearFilters: function() {
            this.searchTerm = "";
            this.selectedType = "all";
            this.selectedRarity = "all";
            this.sortBy = "name";
        }
    };
}
function $80ed874fd909c4ae$export$4d450619ebe70217(source, accent, empty) {
    var pools = $80ed874fd909c4ae$export$43ae57abf049ebd8[source] || [];
    // One pool needs no switcher — a single tab that cannot be switched away from
    // is a control that only takes up space.
    var poolTabs = pools.length < 2 ? '' : '\n    <div class="flex gap-1 mb-3">\n      '.concat(pools.map(function(p) {
        return '\n        <button type="button" @click="setPool(\''.concat(p.key, '\')"\n          class="px-3 py-1.5 rounded text-xs font-bold border-2"\n          :style="activePool === \'').concat(p.key, "'\n            ? 'border-color:").concat(accent, "; background:").concat(accent, "22; color:").concat(accent, "'\n            : 'border-color:#374151; color:#9ca3af'\">\n          ").concat(p.label, " <span class=\"opacity-70\" x-text=\"'\xb7 ' + ($store.inventory['").concat(p.key, "'] || []).length\"></span>\n        </button>");
    }).join(''), "\n    </div>");
    return "\n    ".concat(poolTabs, '\n    <div class="mb-4 space-y-4">\n      <div class="flex space-x-2 text-sm">\n        <div class="flex-grow">\n          <input type="text" x-model="searchTerm" placeholder="Search by name or description..."\n            class="w-full px-4 py-2 bg-gray-800 border border-gray-600 rounded-lg text-white placeholder-gray-400 focus:border-game-accent focus:outline-none">\n        </div>\n        <div class="flex-grow">\n          <select x-model="selectedType"\n            class="w-full px-4 py-[10px] bg-gray-800 border border-gray-600 rounded-lg text-white focus:border-game-accent focus:outline-none">\n            <option value="all">All Categories</option>\n            <template x-for="[itemTypeKey, itemType] in Object.entries(config.itemTypes).filter(([key]) => key !== \'credits\')" :key="itemTypeKey">\n              <option :value="itemTypeKey" x-text="`${itemType.icon} ${itemType.name}`"></option>\n            </template>\n          </select>\n        </div>\n        <div class="flex-grow">\n          <select x-model="selectedRarity"\n            class="w-full px-4 py-[10px] bg-gray-800 border border-gray-600 rounded-lg text-white focus:border-game-accent focus:outline-none">\n            <template x-for="rarity in itemRarities" :key="rarity.value">\n              <option :value="rarity.value" x-text="rarity.label"></option>\n            </template>\n          </select>\n        </div>\n        <div class="flex-grow">\n          <select x-model="sortBy"\n            class="w-full px-4 py-[10px] bg-gray-800 border border-gray-600 rounded-lg text-white focus:border-game-accent focus:outline-none">\n            <option value="name">Sort by Name</option>\n            <option value="quantity">Sort by Quantity</option>\n            <option value="type">Sort by Type</option>\n            <option value="rarity">Sort by Rarity</option>\n            <option value="credits">Sort by Value</option>\n          </select>\n        </div>\n        <div class="text-center">\n          <button @click="clearFilters()"\n            class="bg-blue-400 hover:bg-blue-300 text-black text-sm px-4 py-[10px] rounded font-bold whitespace-nowrap">\uD83E\uDDF9 Clear Filters</button>\n        </div>\n      </div>\n      <div class="text-base text-gray-300 text-center">\n        <span x-text="`Showing ${filteredItems.length} of ${totalItems} items`"></span>\n      </div>\n    </div>\n\n    <div class="grid gap-4" style="grid-template-columns: repeat(auto-fit, 11rem); justify-content: center;">\n      <template x-for="item in filteredItems" :key="item.name">\n        <div x-html="window.createInventoryCard(item, \'inventory\', null, null, { collapsed: true, hideActions: true })"></div>\n      </template>\n      <div x-show="filteredItems.length === 0" class="col-span-full text-center text-gray-400 py-8">\n        <span x-show="totalItems === 0">').concat(empty, '</span>\n        <span x-show="totalItems > 0 && filteredItems.length === 0">No items match your search criteria</span>\n      </div>\n    </div>');
}
function $80ed874fd909c4ae$export$5b73e6a29e58b929() {
    // Update the Alpine store with current gameState data
    if ((0, $da6f71b8677b901e$export$2e2bcd8739ae039).store("inventory")) (0, $da6f71b8677b901e$export$2e2bcd8739ae039).store("inventory").refresh();
}


//done
//@ts-check








// ===============================
// DISTRICTS
// ===============================
// The districts a map is laid out in, and the only place their names are
// written down. A cell's district is a property of the CELL — `room.zone` — and
// of nothing else; a room template says which district it would rather stand in
// with `districtAffinity`, which is a different question and now has a
// different name for it. The two were both called `zone`, which is how the map
// came to have an invisible district structure that agreed with nothing.
//
// No `transit` district. Roads are already a layer of their own — `room.road`,
// `roadRank`, `roadDist` — and a transit district is the same claim made twice
// by two systems that will disagree about where it is. Its entry in the old
// preferences table was, tellingly, empty.
// `recipes` is what a district is BUILT of: the mix of tile art its ordinary
// cells are drawn from, weighted, summing to 100 so the numbers read as
// percentages. It is what makes a district look like one.
//
// It is deliberately separate from which ROOM stands on a cell. A region owns
// twelve room templates for a map of up to 119 cells, so each is reused eight
// to eleven times — far too few to build a district out of. Picking rooms by
// district instead would collapse a residential district onto the one
// residential template, testing the one skill it carries. So the district
// decides the building type, the room keeps its own name, category and skill,
// and the skill anchor already drawn on every encounter tile says what is
// actually being attempted there. The recipe says where you are; the anchor
// says what you are doing; the name says what it is called.
//
// Every district leads on one recipe at around half its cells, which is what
// makes it recognisable, and carries three or four others so it does not read
// as a monoculture.
// `built` is how densely a district is built up, 0..1, and the renderer reads
// it directly: it thins a tile's structures, and inversely lets the growth back
// in and the tarmac go to seed. Authored rather than sampled from noise so a
// district's look and its name agree — an outskirt is thin because it IS the
// outskirts, not because a lattice happened to dip there.
//
// The numbers are centred on MEAN_BUILT (roomImageGen) so the average tile
// lands where it already was. This redistributes built stock across the map; it
// does not delete it, and there is a test holding the total to within a tenth.

var $980f67465e309611$export$8377a367ab2ae550 = {
    entry: {
        description: "Starting area with easier encounters",
        recipes: {
            infrastructure: 35,
            transit: 25,
            security: 20,
            storage: 20
        },
        built: 0.72
    },
    peripheral: {
        description: "Outer areas with mixed encounters",
        recipes: {
            environmental: 40,
            transit: 20,
            storage: 20,
            habitation: 20
        },
        built: 0.58
    },
    security: {
        description: "Defensive checkpoints",
        recipes: {
            security: 45,
            infrastructure: 25,
            storage: 20,
            power: 10
        },
        built: 0.90
    },
    industrial: {
        description: "Resource/infrastructure areas",
        recipes: {
            power: 30,
            storage: 30,
            infrastructure: 25,
            transit: 15
        },
        built: 0.88
    },
    core: {
        description: "High-value protected areas",
        recipes: {
            records: 35,
            commerce: 25,
            security: 20,
            infrastructure: 20
        },
        built: 1.00
    },
    residential: {
        description: "Habitats, apartments, communal living spaces",
        recipes: {
            habitation: 50,
            environmental: 20,
            records: 15,
            commerce: 15
        },
        built: 0.85
    },
    commercial: {
        description: "Shops, offices, market halls, logistics fronts",
        recipes: {
            commerce: 50,
            storage: 20,
            records: 15,
            habitation: 15
        },
        built: 0.95
    }
};
var $980f67465e309611$export$11209b5126489e67 = {
    campsite: {
        type: "campsite",
        name: "Campsite",
        primary: "",
        support: [],
        baseDuration: 120,
        icon: "\uD83C\uDFD5\uFE0F",
        description: "A safe place to rest and recover",
        healingAmount: 30
    },
    water: {
        type: "water",
        name: "Water",
        primary: "",
        support: [],
        baseDuration: 120,
        icon: "\uD83C\uDF0A",
        description: "A water source for fishing"
    },
    road: {
        type: "road",
        name: "Road",
        primary: "",
        support: [],
        baseDuration: 10,
        icon: "\uD83D\uDEE3\uFE0F",
        description: "A roadway for fast travel"
    }
};
var $980f67465e309611$export$4fbdcec70fce9d73 = {
    // ======================================================
    "shard-cities": {
        name: "Shard Cities",
        theme: "Collapsed megacities and fractured districts",
        icon: "\uD83C\uDFD9\uFE0F",
        shortDescription: "Towering urban ruins split by broken transit lines and silent civic grids.",
        longDescription: "These were once continuous skylines: stacked transit, dense housing, and civic utilities woven into mile-high towers. Centuries of neglect cracked the pavement and snapped the skyways. You can still read the street plan, even if whole blocks have slumped into their own debris.\n\nPower occasionally surges through old feeders, enough to light a dead intersection for a breath. Most systems do nothing at all\u2014just rust, dust, and old signage pointing nowhere.",
        artDirection: "Two scales of building, and the contrast between them IS the region. The ordinary stock is warm \u2014 brick and brown roofing, low, dense, packed kerb to kerb. Over it stand cool concrete-and-glass masses: tower cores with their service shafts open to the sky, skybridge decks that start nowhere and stop in mid-air, sign gantries still spanning the carriageway. Ground is dark slate tarmac, cracked on a slab pitch, so both tiers read light against it. Street trees have come up through the pavement everywhere there was a cutout.",
        gates: [
            {
                icon: "\uD83D\uDEA7",
                name: "Checkpoint Sector",
                primary: "lock-breach",
                support: [
                    "signal-relay",
                    "stealth-transit"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "critical",
                shortDescription: "Barricaded intersection controlling movement between ruined blocks.",
                longDescription: "Concrete barriers, rusted railings, and makeshift roadblocks choke an old arterial. The city\u2019s last attempts at order still shape the flow of rubble and weeds. Nothing powers here\u2014only wind and dust."
            },
            {
                icon: "\u2699\uFE0F",
                name: "Civic Relay Block",
                primary: "signal-relay",
                support: [
                    "quantum-scan",
                    "lock-breach"
                ],
                baseDuration: 120,
                category: "infrastructure",
                difficulty: "chokepoint",
                placement_priority: "high",
                shortDescription: "Collapsed service block with dead comms towers and trunk conduits.",
                longDescription: "Stubbed antenna masts lean over a plaza of broken panels and cable vaults. Dust-muted signage points to services that no longer exist. A faint click from a relay box sometimes answers fresh power before falling silent again."
            },
            {
                icon: "\uD83C\uDFE2",
                name: "Apartment Access Lot",
                primary: "stealth-transit",
                support: [
                    "quantum-scan",
                    "lock-breach"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "high",
                districtAffinity: "residential",
                shortDescription: "Collapsed housing block entrances clustered around a cracked forecourt.",
                longDescription: "Entry canopies hang at angles over door stacks long since jammed. Mailboxes gape, names scoured to metal. The forecourt is a map of fractures and weeds, with scaffolds rusted into stillness."
            },
            {
                icon: "\uD83D\uDECD\uFE0F",
                name: "Arcade Shutter Sector",
                primary: "system-override",
                support: [
                    "drone-command",
                    "containment"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "high",
                districtAffinity: "commercial",
                shortDescription: "Market frontage sealed by fallen shutters and buckled grates.",
                longDescription: "A run of storefronts slouches under dead signage and twisted awnings. Steel shutters are half-dropped or jammed, creating a maze of narrow access. Any movement here is the wind through canvas and chain."
            }
        ],
        hazards: [
            {
                icon: "\uD83D\uDEE2\uFE0F",
                name: "Residential Power Yard",
                primary: "containment",
                support: [
                    "signal-relay",
                    "transit-anchor"
                ],
                baseDuration: 60,
                category: "power",
                difficulty: "standard",
                placement_priority: "high",
                shortDescription: "Small substation between towers with fallen lines and rusted switchgear.",
                longDescription: "Transformer housings slouch on cracked pads; the fence is more gap than mesh. A wrong step crunches glass and ceramic. If anything lights, it\u2019s for a breath, then the quiet deepens."
            },
            {
                icon: "\uD83C\uDF09",
                name: "Transit Collapse Zone",
                primary: "transit-anchor",
                support: [
                    "reclamation",
                    "system-override"
                ],
                baseDuration: 60,
                category: "infrastructure",
                difficulty: "standard",
                placement_priority: "normal",
                shortDescription: "Broken overpass and skybridge stubs sprawled over a debris-choked road.",
                longDescription: "Guardrails spear the pavement; cables drape from shattered spans. The echo under concrete ribs tells how big it was. Weeds stitch rebar and dust into something like ground again."
            },
            {
                icon: "\uD83D\uDCE6",
                name: "Marketfront Depot",
                primary: "drone-command",
                support: [
                    "transit-anchor",
                    "echo-trace"
                ],
                baseDuration: 60,
                category: "storage",
                difficulty: "high_value",
                placement_priority: "high",
                shortDescription: "Cluster of loading bays and shuttered storerooms behind ruined shops.",
                longDescription: "Dock plates sit crooked; pallets rot into dark lines on the ground. The loading lights are dead\u2014only daylight finds its way in through gaps and broken louvers."
            },
            {
                icon: "\uD83C\uDFE2",
                name: "Administrative Records Block",
                primary: "quantum-scan",
                support: [
                    "system-override",
                    "lock-breach"
                ],
                baseDuration: 60,
                category: "storage",
                difficulty: "high_value",
                placement_priority: "critical",
                shortDescription: "Abandoned office district with shattered facades and paper-littered streets.",
                longDescription: "Stacks of files turned to mulch line the curbs where floodwater once ran. A rusted maintenance crane leans against a curtain wall. Nothing watches here\u2014only glass dust and wind."
            },
            {
                icon: "\uD83D\uDE89",
                name: "Transit Exchange Block",
                primary: "echo-trace",
                support: [
                    "stealth-transit",
                    "containment"
                ],
                baseDuration: 60,
                category: "infrastructure",
                difficulty: "standard",
                placement_priority: "normal",
                shortDescription: "A surface-level transit interchange and service plaza linking several collapsed lines.",
                longDescription: "Once a hub for elevated trams and vertical shuttles, the block still shows the scar of its platforms. Canopies hang over cracked concrete lanes, and access ramps descend into dust-filled tunnels below."
            },
            {
                icon: "\uD83D\uDE9B",
                name: "Logistics Yard Ruins",
                // overturned cargo trucks and container stacks, not a service yard
                recipe: "storage",
                primary: "reclamation",
                support: [
                    "drone-command",
                    "echo-trace"
                ],
                baseDuration: 60,
                category: "infrastructure",
                difficulty: "standard",
                placement_priority: "normal",
                shortDescription: "Collapsed distribution yard filled with overturned cargo trucks and container stacks.",
                longDescription: "What was once a multi-lane loading grid now lies in layers \u2014 trucks fossilized in place, containers torn open by time. Tower cranes stand idle at the corners like monuments to motionless trade."
            },
            {
                icon: "\u26A1",
                name: "Substation Complex",
                primary: "system-override",
                support: [
                    "reclamation",
                    "quantum-scan"
                ],
                baseDuration: 60,
                category: "power",
                difficulty: "high_value",
                placement_priority: "high",
                shortDescription: "A cluster of transformers and conduit fields forming a decommissioned power block.",
                longDescription: "Heavy transformer shells sit on cracked pads, their housings marked with long-gone warning paint. Busbars bridge between fenced sections, while cable vaults yawn open into the dark below."
            },
            {
                icon: "\uD83D\uDEC2",
                name: "Civic Control District",
                // a ring of checkpoints; "civic" pulls it to infrastructure otherwise
                recipe: "security",
                primary: "quantum-scan",
                support: [
                    "transit-anchor",
                    "echo-trace"
                ],
                baseDuration: 60,
                category: "security",
                difficulty: "standard",
                placement_priority: "high",
                shortDescription: "A cluster of interconnected checkpoints surrounding a former civic administration block.",
                longDescription: "Security kiosks ring the perimeter of a low central building, their scanner frames bent but still standing. The entire block was once a controlled corridor \u2014 a mix of barriers, scanners, and causeways now frozen in collapse."
            }
        ]
    },
    // ======================================================
    "verdant-reclamation": {
        name: "Green Reclamation",
        theme: "Overgrown research campuses and greenhouse grids",
        icon: "\uD83C\uDF3F",
        shortDescription: "Bio-reclaimed districts where labs and irrigation frames disappear beneath growth.",
        longDescription: "This landscape was engineered to coax life back into sterile soil. Greenhouses formed shining corridors; irrigation lattices pulsed under glass. After the departure, containment failed and nature took the reins.\n\nNow, fibrous canopies bind whole blocks together. Steel trusses wear bark; road paint lies under moss. Machinery answers only sometimes, a pump stuttering once before the vines hold it still again.",
        artDirection: "Growth is the loudest thing on the tile and the buildings are what it grew over. Heavy canopy in deep greens, moss and wildflowers through the ground, tarmac worn back to soil. The architecture that survives is glasshouse: long shallow glazed spans ridged down their spine with panes missing and the planting showing through, irrigation lattices over what used to be beds, seed silos. Ordinary buildings are muted steel grey and mostly hidden \u2014 that is the point, they lost.",
        gates: [
            {
                icon: "\uD83E\uDDEA",
                name: "Bio-Lab Complex Gate",
                primary: "bio-shield",
                support: [
                    "containment",
                    "growth-control"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "critical",
                shortDescription: "Collapsed research compound entrance tangled in vines and glass.",
                longDescription: "A trellis of bent greenhouse ribs leads into a court of moss and broken tiles. Safety placards lie sun-bleached among seed trays and cracked tanks. The air is warm and wet, heavy with plant breath."
            },
            {
                icon: "\uD83D\uDEBF",
                name: "Irrigation Control Sector",
                primary: "reclamation",
                support: [
                    "growth-control",
                    "wild-influence"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "high",
                shortDescription: "Valve fields, cisterns, and control kiosks overtaken by roots.",
                longDescription: "Pipes run like exposed roots along the ground, bolted kiosks eaten by rust and kudzu. A cistern lid thumps underfoot\u2014water still trapped below. If anything moves, it\u2019s the wind dragging leaves across metal."
            },
            {
                icon: "\uD83C\uDFDA\uFE0F",
                name: "Habitation Annex Gate",
                primary: "wild-influence",
                support: [
                    "bio-shield",
                    "reclamation"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "high",
                districtAffinity: "residential",
                shortDescription: "Apartment annex entrances swallowed by creepers and fallen trellis.",
                longDescription: "Balconies have become planters; stairwells bloom with ferns. Doorways stand open or warped shut, their seals crumbled to powder. A single gutter still drips into a barrel of green water."
            },
            {
                icon: "\uD83E\uDDEA",
                name: "Market Decontamination Sector",
                primary: "containment",
                support: [
                    "safeguard",
                    "reclamation"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "high",
                districtAffinity: "commercial",
                shortDescription: "Outdoor wash stations and shuttered stalls clustered around a drained basin.",
                longDescription: "Decon arches frame a plaza of cracked tile and dried residue. The stalls around it are skeletal, their tarps long rotted away. Nothing cycles here unless you bring the power yourself."
            }
        ],
        hazards: [
            {
                icon: "\uD83C\uDF31",
                name: "Seed Distribution Yard",
                primary: "growth-control",
                support: [
                    "bio-shield",
                    "reclamation"
                ],
                baseDuration: 60,
                category: "storage",
                difficulty: "high_value",
                placement_priority: "high",
                shortDescription: "Silos, bins, and pallet stacks buried in moss and husks.",
                longDescription: "A drift of cracked pods crunches underfoot. Stenciled measurements fade from the silo sides. Somewhere a vent exhales warm, earthy air that smells like the start of rain."
            },
            {
                icon: "\uD83C\uDF44",
                name: "Fungal Spread Block",
                primary: "growth-control",
                support: [
                    "bio-shield",
                    "reclamation"
                ],
                baseDuration: 60,
                category: "environmental",
                difficulty: "standard",
                placement_priority: "normal",
                shortDescription: "A shaded block carpeted with fungus and spore fans.",
                longDescription: "Stems as thick as cable push through fissures in the concrete. Spores hang in the air like dust motes in a cathedral. Your breath fogs just enough to make the light feel heavy."
            },
            {
                icon: "\uD83D\uDCA7",
                name: "Irrigation Breach Sector",
                primary: "bio-shield",
                support: [
                    "growth-control",
                    "safeguard"
                ],
                baseDuration: 60,
                category: "infrastructure",
                difficulty: "standard",
                placement_priority: "normal",
                shortDescription: "Ruptured mains flooding a low lot, roots drinking the overflow.",
                longDescription: "A trench of clear water has cut through soil and tile, pooling around toppled control posts. Algae paints the edges; insects tap the surface. The flow wanes and returns without reason."
            },
            {
                icon: "\uD83D\uDCDA",
                name: "Research Supply Yard",
                primary: "reclamation",
                support: [
                    "wild-influence",
                    "safeguard"
                ],
                baseDuration: 60,
                category: "storage",
                difficulty: "high_value",
                placement_priority: "critical",
                shortDescription: "Crated lab gear and broken cages stacked beside a ruined annex.",
                longDescription: "Numbers stenciled on crates tell of a mission left unfinished. Metal shelving slumps like wet paper. A single rain gutter ticks as it cools in the shade."
            },
            {
                icon: "\uD83C\uDFD7\uFE0F",
                name: "Habitation Block",
                primary: "wild-influence",
                support: [
                    "containment",
                    "growth-control"
                ],
                baseDuration: 60,
                category: "environmental",
                difficulty: "standard",
                placement_priority: "normal",
                districtAffinity: "residential",
                shortDescription: "A cluster of low-rise apartments overtaken by gardens and nests.",
                longDescription: "Bedsprings and trellis wire bind stairwells into new shapes. Window boxes have become small forests. The only movement is leaves, and the small quick things that live in them."
            },
            {
                icon: "\uD83E\uDED7",
                name: "Nutrient Line Rupture",
                primary: "bio-shield",
                support: [
                    "wild-influence",
                    "safeguard"
                ],
                baseDuration: 60,
                category: "infrastructure",
                difficulty: "standard",
                placement_priority: "high",
                districtAffinity: "residential",
                shortDescription: "Leaking feed lines turning a block into a slick, humming wetland.",
                longDescription: "Plastic tubing loops across the ground like shed skin, seeping a sweet, metallic film. New shoots force through asphalt in a straight line where the pipe runs below."
            },
            {
                icon: "\uD83C\uDFEA",
                name: "Agri-Market Depot",
                primary: "growth-control",
                support: [
                    "containment",
                    "bio-shield"
                ],
                baseDuration: 60,
                category: "storage",
                difficulty: "high_value",
                placement_priority: "high",
                districtAffinity: "commercial",
                shortDescription: "Open-air market storage with collapsed canopies and crate rows.",
                longDescription: "Sun-faded tarps hang like old flags. The smell of dust and seed oil lingers. You can still see where chalk mapped out stall fees on the concrete."
            },
            {
                icon: "\uD83E\uDDEF",
                name: "Greenhouse Containment Sector",
                primary: "safeguard",
                support: [
                    "containment",
                    "wild-influence"
                ],
                baseDuration: 60,
                category: "environmental",
                difficulty: "standard",
                placement_priority: "normal",
                districtAffinity: "commercial",
                shortDescription: "Firebreak lanes and isolation frames choking in vines.",
                longDescription: "White-painted fire lanes vanish under creepers. The shutters meant to fall in emergencies are rusted half-down. A distant pane taps in the breeze like a metronome."
            }
        ]
    },
    // ======================================================
    "sunken-bastions": {
        name: "Flooded Bastions",
        theme: "Semi-submerged fortifications and silted logistics",
        icon: "\uD83C\uDF0A",
        shortDescription: "Defense districts with the sea in them: the coast took the low blocks and the silt took the rest.",
        longDescription: "Coastal defenses once ringed this region with docks, bunkers, and pressure locks. Storm surge and slow subsidence rolled in over centuries, flooding the low blocks and salting everything else.\n\nSome pressure doors still cycle if you give them power, drawing a final gulp of air through corroded ducts. Mostly, there is water, silt, and the sound of old metal moving in the tide.",
        artDirection: "One edge of the map is open ocean and everything reads off how far it is from it. At the shore, water over the outer half of the tile, a buttressed sea wall along the waterline with its bollards behind, and what is left of the buildings is mostly wreckage in the shallows. A row in, tidal flats and standing water pooling in the streets first. Beyond that, dry. Ground is cold silt, not sand \u2014 blue-grey, damp-looking, tide-marked. Concrete is wet and weeping rust.",
        gates: [
            {
                icon: "\uD83D\uDED1",
                name: "Pressure Gate Sector",
                primary: "lock-breach",
                support: [
                    "signal-mask",
                    "wild-influence"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "high",
                shortDescription: "Cluster of rusted airlock doors and corroded valves around a flooded court.",
                longDescription: "Door rings sit proud with barnacle rust; inspection windows are opaque with salt. The control pedestals are still in place, their labels sanded flat by wind and spray."
            },
            {
                icon: "\u2693",
                name: "Drydock Access Block",
                primary: "lock-breach",
                support: [
                    "quantum-scan",
                    "system-override"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "critical",
                shortDescription: "Collapsed dock gates and winch frames guarding entry to an old basin.",
                longDescription: "The dock walls lean inward, heavy with waterlogged stone. Winch cables coil like sleeping eels beside shattered bollards. Every surface is stained a dozen kinds of orange."
            },
            {
                icon: "\uD83D\uDEAA",
                name: "Residential Seal Lot",
                primary: "containment",
                support: [
                    "safeguard",
                    "system-override"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "high",
                districtAffinity: "residential",
                shortDescription: "Pressure-rated housing entries scattered along a raised walkway.",
                longDescription: "Doors that once sealed against storms now gape, warped on their hinges. A painted muster diagram flakes off the wall in curls as thin as fish scales."
            },
            {
                icon: "\uD83E\uDDF3",
                name: "Commercial Airlock Sector",
                primary: "signal-mask",
                support: [
                    "bio-shield",
                    "containment"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "high",
                districtAffinity: "commercial",
                shortDescription: "Cargo airlocks and submerged loading bays along a corroded quay.",
                longDescription: "Crate hoists stand frozen above black water. The quay edge is a jag of broken concrete and rebar, polished smooth where the tide reaches."
            }
        ],
        hazards: [
            {
                icon: "\uD83C\uDF0A",
                name: "Flooded Records Sector",
                primary: "reclamation",
                support: [
                    "wild-influence",
                    "transit-anchor"
                ],
                baseDuration: 60,
                category: "storage",
                difficulty: "high_value",
                placement_priority: "critical",
                shortDescription: "Archives drowned to the window line, shelves like ribs under the surface.",
                longDescription: "Folders have turned to silt drifts. A rolling ladder floats, bumping the stacks with a hollow rhythm. Light puddles on the water and slides across the ceiling."
            },
            {
                icon: "\uD83D\uDCA8",
                name: "Ventilation Intake Lot",
                primary: "echo-trace",
                support: [
                    "bio-shield",
                    "reclamation"
                ],
                baseDuration: 60,
                category: "infrastructure",
                difficulty: "standard",
                placement_priority: "normal",
                shortDescription: "Banks of rusted intake fans towering over a silted forecourt.",
                longDescription: "Fan blades are choked with ropeweed and netting. A metal tag rattles faintly when the wind shifts. The air smells like creosote and tide."
            },
            {
                icon: "\uD83D\uDCE6",
                name: "Freight Access Zone",
                primary: "transit-anchor",
                support: [
                    "safeguard",
                    "signal-mask"
                ],
                baseDuration: 60,
                category: "security",
                difficulty: "standard",
                placement_priority: "high",
                shortDescription: "Collapsed ramps and container rows leading into a drowned terminal.",
                longDescription: "Container paint has bled into pastel ghosts. The ramp rails end abruptly in water that hides a second city of debris below."
            },
            {
                icon: "\uD83E\uDEB8",
                name: "Marine Observation Block",
                primary: "wild-influence",
                support: [
                    "echo-trace",
                    "lock-breach"
                ],
                baseDuration: 60,
                category: "environmental",
                difficulty: "standard",
                placement_priority: "normal",
                shortDescription: "Sea-worn platforms and pylons with algae film and broken rails.",
                longDescription: "Scope housings point at horizons no one watches. The handrails flake in layers that stain your gloves. Gulls nest in the elbows of old floodlights that will never shine again."
            },
            {
                icon: "\uD83C\uDFDA\uFE0F",
                name: "Flooded Living Sector",
                primary: "bio-shield",
                support: [
                    "echo-trace",
                    "lock-breach"
                ],
                baseDuration: 60,
                category: "environmental",
                difficulty: "standard",
                placement_priority: "normal",
                districtAffinity: "residential",
                shortDescription: "Lower housing blocks drowned to the window line, interiors slumped inward.",
                longDescription: "Mildew blooms on every surface; curtains drift like slow jelly. The line where the tide reaches is written as a salt band around the rooms."
            },
            {
                icon: "\uD83E\uDE9C",
                name: "Access Tower Sector",
                primary: "safeguard",
                support: [
                    "echo-trace",
                    "lock-breach"
                ],
                baseDuration: 60,
                category: "infrastructure",
                difficulty: "standard",
                placement_priority: "high",
                districtAffinity: "residential",
                shortDescription: "Stair towers and emergency ladders rising above the flood.",
                longDescription: "Cages of stairs keep their geometry against the soft line of the water. Every landing clicks and settles when the wind turns."
            },
            {
                icon: "\uD83D\uDCE6",
                name: "Cargo Intake Block",
                primary: "containment",
                support: [
                    "quantum-scan",
                    "reclamation"
                ],
                baseDuration: 60,
                category: "infrastructure",
                difficulty: "standard",
                placement_priority: "normal",
                districtAffinity: "commercial",
                shortDescription: "Shallow-water cargo ramps and corroded conveyors into a warehouse face.",
                longDescription: "Conveyor housings gape like fish skulls. A strip of weed waves where a belt used to run. The warehouse doors are heavy with swollen wood."
            },
            {
                icon: "\uD83D\uDCB0",
                name: "Finance Quarter",
                primary: "quantum-scan",
                support: [
                    "containment",
                    "transit-anchor"
                ],
                baseDuration: 60,
                category: "storage",
                difficulty: "high_value",
                placement_priority: "high",
                districtAffinity: "commercial",
                shortDescription: "Collapsed teller halls and armored delivery bays, empty as vaults.",
                longDescription: "Coin-counting machines sit in rows like old teeth. Delivery lanes are silted to their thresholds. Everything smells faintly of metal and mildew."
            }
        ]
    },
    // ======================================================
    "cradle-expanse": {
        name: "Industrial Expanse",
        theme: "Manufacturing grids and rust plains",
        icon: "\uD83C\uDF05",
        shortDescription: "Endless factory lots, idle conveyors, and yard-wide machinery asleep in rust.",
        longDescription: "Production once moved through these blocks in steady lines\u2014ore in one side, finished goods out the other. Now the conveyors are seized and the cranes lean on their cables, frozen mid-motion for generations.\n\nWhen power returns, a servo might twitch or a stack light might glow and die. The wind does most of the work here: sandblasting paint, driving grit into bearings, and covering tracks almost as fast as you make them.",
        artDirection: "The one region whose plant stands LIGHTER than its ground: pale umber steel on dark iron-rich dirt, which is the opposite of shard-cities and is what keeps two brown regions apart. Silhouettes are industrial and long \u2014 gantry cranes straddling bays, conveyor runs seized where they stopped and carrying on across tiles, bunded tank farms. Rust everywhere, in streaks and pools and oil stains. Almost nothing green: a few dead snags, and the wind has taken the rest.",
        gates: [
            {
                icon: "\uD83C\uDFED",
                name: "Factory Command Sector",
                // control rooms and relay racks under gantries, not a checkpoint
                recipe: "infrastructure",
                primary: "system-override",
                support: [
                    "growth-control",
                    "signal-mask"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "critical",
                shortDescription: "Central yard of control rooms and relay racks flanked by gantries.",
                longDescription: "Stack lights are long dead above cracked control housings. Catwalks draw hard lines across a sky of dust. A paper logbook lies fused into a solid wedge on a podium."
            },
            {
                icon: "\uD83D\uDE9B",
                name: "Logistics Yard Gate",
                primary: "drone-command",
                support: [
                    "stealth-transit",
                    "signal-relay"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "high",
                shortDescription: "Gatehouse and weighbridge spanning lanes into container lots.",
                longDescription: "The weighbridge plate is welded to its frame by corrosion. The gate arms point at the ground like broken fingers. Dust piles where wheels once wore it away."
            },
            {
                icon: "\uD83E\uDE96",
                name: "Barracks Gate",
                primary: "signal-mask",
                support: [
                    "signal-relay",
                    "system-override"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "high",
                districtAffinity: "residential",
                shortDescription: "Perimeter fence and turnstiles into a worker barracks compound.",
                longDescription: "Turnstiles are frozen mid-rotation. A loudspeaker hangs by its cable, a mouth that will never speak. The ground inside is a quilt of footprints long since filled with dust."
            },
            {
                icon: "\uD83C\uDF7D\uFE0F",
                name: "Commissary Shutter Sector",
                primary: "system-override",
                support: [
                    "safeguard",
                    "drone-command"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "high",
                districtAffinity: "commercial",
                shortDescription: "Canteen frontage sealed by roll-down shutters and collapsed awnings.",
                longDescription: "Menu boards peel in the heat. Trays clatter when the wind gets under them. At noon the whole block smells like hot metal and old oil."
            }
        ],
        hazards: [
            {
                icon: "\u26CF\uFE0F",
                name: "Extraction Yard",
                primary: "drone-command",
                support: [
                    "signal-mask",
                    "stealth-transit"
                ],
                baseDuration: 60,
                category: "storage",
                difficulty: "high_value",
                placement_priority: "high",
                shortDescription: "Ore hoppers, crushed drums, and loader tracks etched into dust.",
                longDescription: "Chutes hang open over empty ground. Piles of fines drift into dunes against dead conveyors. The only sparkle is mica in the grit."
            },
            {
                icon: "\u2699\uFE0F",
                name: "Assembly Corridor Block",
                primary: "drone-command",
                support: [
                    "wild-influence",
                    "stealth-transit"
                ],
                baseDuration: 60,
                category: "infrastructure",
                difficulty: "standard",
                placement_priority: "normal",
                shortDescription: "Long run of conveyor frames and work platforms seized in place.",
                longDescription: "Tool shadows are burned into paint where the sun never reached. Belt rollers are fused in rings of red. The wind writes its own schedule on hanging tags."
            },
            {
                icon: "\uD83D\uDDD1\uFE0F",
                name: "Salvage Lot",
                primary: "wild-influence",
                support: [
                    "drone-command",
                    "signal-relay"
                ],
                baseDuration: 60,
                category: "environmental",
                difficulty: "standard",
                placement_priority: "normal",
                shortDescription: "Heap of stripped machinery and scaffold bones stacked by a fence.",
                longDescription: "Cranes stripped to spines cast laddered shadows. Wire harnesses dangle like dead vines. Footing is uncertain\u2014everything gives a little when you test it."
            },
            {
                icon: "\uD83D\uDD27",
                name: "Operations Hub",
                primary: "signal-relay",
                support: [
                    "drone-command",
                    "system-override"
                ],
                baseDuration: 60,
                category: "infrastructure",
                difficulty: "high_value",
                placement_priority: "critical",
                shortDescription: "Control kiosks and cable troughs forming a nerve-center yard.",
                longDescription: "Cable trays cross like irrigation over bare concrete. A signal flag still flaps from a line that never fell. If anything comes alive, it does so in stutters and stops."
            },
            {
                icon: "\uD83D\uDD25",
                name: "Boiler Leak Row",
                primary: "safeguard",
                support: [
                    "signal-relay",
                    "system-override"
                ],
                baseDuration: 60,
                category: "environmental",
                difficulty: "standard",
                placement_priority: "normal",
                districtAffinity: "residential",
                shortDescription: "Steam-scarred lane between boiler sheds and maintenance stacks.",
                longDescription: "Mineral bloom and peeling paint texture every pipe. Valves whistle ghosts when the wind fits their mouths. The ground is white with the memory of heat."
            },
            {
                icon: "\uD83E\uDD6B",
                name: "Barracks Pantry Depot",
                primary: "stealth-transit",
                support: [
                    "wild-influence",
                    "growth-control"
                ],
                baseDuration: 60,
                category: "storage",
                difficulty: "standard",
                placement_priority: "normal",
                districtAffinity: "residential",
                shortDescription: "Food stores and cold-room bays opened to the air long ago.",
                longDescription: "Shelving prints squares on the walls where cold once lived. A pyramid of cans has slumped into a gentle hill of dull tin."
            },
            {
                icon: "\uD83C\uDFDA\uFE0F",
                name: "Warehouse Racking Collapse",
                primary: "safeguard",
                support: [
                    "drone-command",
                    "system-override"
                ],
                baseDuration: 60,
                category: "infrastructure",
                difficulty: "standard",
                placement_priority: "high",
                districtAffinity: "commercial",
                shortDescription: "Racking aisles tumbled into a lattice of unstable paths.",
                longDescription: "Number placards hang at wrong angles, their arrows pointing into heaps of beams. The floor is a patchwork of shadows and sunlight where the roof gave up."
            },
            {
                icon: "\uD83D\uDCD2",
                name: "Ledger Block",
                primary: "signal-relay",
                support: [
                    "safeguard",
                    "signal-mask"
                ],
                baseDuration: 60,
                category: "storage",
                difficulty: "high_value",
                placement_priority: "high",
                districtAffinity: "commercial",
                shortDescription: "Accounting offices and file stores woven into a single crumbling block.",
                longDescription: "Adding machines sit like fossils on desks. Ledger paper lies fused into brick-hard stacks. The sun makes dust glitter where a roof panel fell away."
            }
        ]
    },
    // ======================================================
    "hollow-core": {
        name: "Hollow Core",
        theme: "Sublevel transit and collapsed substructures",
        icon: "\u26AB",
        shortDescription: "Buried civic arteries: pillared halls, rail spurs and maintenance blocks, half of them sealed by the collapse.",
        longDescription: "Everything aboveground depended on what ran below\u2014transit rings, service corridors, and power trunks stitched together across sublevels. Collapse sealed off some blocks entirely; others breathe stale air through long cracks in the concrete.\n\nOccasionally, indicator strips flare for a moment, enough to show distance receding into black. Then the dark returns, settling even heavier than before.",
        artDirection: "A hall, not a street. Pillars on a regular pitch march across every tile and carry on into the next one \u2014 that rhythm is the only thing a top-down view has to say there is a ceiling overhead. Rock mass laps in from the corners and outer edges where the roof has come down, sealing parts of blocks, carved back around the rooms and never across a route. Rail beds and cable trays run through. Light is the region's subject: almost none of it, teal bioluminescence for ambient, warm pools under the daylight wells, and the darkness graded so it is heaviest against the rock and lightest over the floor. The concrete itself is NOT black \u2014 the palette has to survive the dark and still show which parts are wall.",
        gates: [
            {
                icon: "\uD83D\uDE87",
                name: "Sublevel Transit Hub",
                primary: "transit-anchor",
                support: [
                    "signal-relay",
                    "drone-command"
                ],
                baseDuration: 120,
                category: "storage",
                difficulty: "chokepoint",
                placement_priority: "critical",
                shortDescription: "Collapsed interchange where multiple rail spurs once crossed.",
                longDescription: "Pillars hold up more air than concrete now. Signal plates stand blank along a bed of gravel and dust. The far wall is a shadow that pretends to be distance."
            },
            {
                icon: "\uD83D\uDD0C",
                name: "Power Relay Block",
                primary: "signal-relay",
                support: [
                    "quantum-scan",
                    "stealth-transit"
                ],
                baseDuration: 120,
                category: "infrastructure",
                difficulty: "chokepoint",
                placement_priority: "high",
                shortDescription: "Cable trays and junction housings clustered around a maintenance court.",
                longDescription: "Insulators line a wall like teeth. A skein of cables has slumped from the ceiling into a black loop. Dust swirls when you step, then remembers how to be still."
            },
            {
                icon: "\uD83D\uDEAA",
                name: "Habitat Access Sector",
                primary: "lock-breach",
                support: [
                    "quantum-scan",
                    "signal-mask"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "high",
                districtAffinity: "residential",
                shortDescription: "Door clusters and service nooks leading into sealed living blocks.",
                longDescription: "Numbered arrows march along the wall toward units you\u2019ll never enter. A cart sits on square wheels of dust. The air is dry and old, like a book left open too long."
            },
            {
                icon: "\uD83D\uDED2",
                name: "Commerce Access Sector",
                primary: "signal-mask",
                support: [
                    "lock-breach",
                    "echo-trace"
                ],
                baseDuration: 120,
                category: "security",
                difficulty: "chokepoint",
                placement_priority: "high",
                districtAffinity: "commercial",
                shortDescription: "Service corridors feeding into a forgotten plaza and loading cutouts.",
                longDescription: "A map board with no map. A mural worn to colors without shapes. The corridor breathes the same cold air in and out, as if thinking of a crowd."
            }
        ],
        hazards: [
            {
                icon: "\uD83D\uDCE6",
                name: "Storage Compound",
                primary: "quantum-scan",
                support: [
                    "lock-breach",
                    "growth-control"
                ],
                baseDuration: 60,
                category: "storage",
                difficulty: "high_value",
                placement_priority: "critical",
                shortDescription: "Box canyons of crates and shelving under a low slab ceiling.",
                longDescription: "Label paint lingers like ghosts on metal faces. A broken roller door shows a sliver of stale light. The air tastes like paper and iron."
            },
            {
                icon: "\uD83E\uDDF1",
                name: "Maintenance Network Sector",
                primary: "growth-control",
                support: [
                    "signal-relay",
                    "drone-command"
                ],
                baseDuration: 60,
                category: "environmental",
                difficulty: "standard",
                placement_priority: "normal",
                shortDescription: "Grid of service corridors, tool bays, and grates over dark shafts.",
                longDescription: "Tool outlines haunt the walls. Floor grates ring when crossed, answering back from below. The network feels larger than the ground it serves."
            },
            {
                icon: "\u2622\uFE0F",
                name: "Reactor Service Lot",
                primary: "stealth-transit",
                support: [
                    "transit-anchor",
                    "quantum-scan"
                ],
                baseDuration: 60,
                category: "power",
                difficulty: "high_value",
                placement_priority: "high",
                shortDescription: "Shield doors and access gantries around a dead core housing.",
                longDescription: "Warning chevrons fade across concrete that still remembers heat. Cable stumps jut like bones from panel edges. Everything hums with a silence that feels heavy."
            },
            {
                icon: "\uD83D\uDEE0\uFE0F",
                name: "Data Spine Junction",
                primary: "echo-trace",
                support: [
                    "stealth-transit",
                    "signal-mask"
                ],
                baseDuration: 60,
                category: "infrastructure",
                difficulty: "standard",
                placement_priority: "normal",
                shortDescription: "Trunk conduits converge into a node of cracked panels and conduit arcs.",
                longDescription: "Cables repeat the curve of the arching ceiling. Labels peel off in satisfying curls. Your headlamp shows dust floating like a slow snowfall."
            },
            {
                icon: "\uD83D\uDED7",
                name: "Access Network Block",
                primary: "transit-anchor",
                support: [
                    "echo-trace",
                    "growth-control"
                ],
                baseDuration: 60,
                category: "infrastructure",
                difficulty: "standard",
                placement_priority: "normal",
                districtAffinity: "residential",
                shortDescription: "Lift shafts, catwalks, and ladders crisscrossing a deep chamber.",
                longDescription: "Mesh floors draft cool air over your boots. The shaft walls are a history of paint colors layered like sediment. The dark holds its shape until you look into it."
            },
            {
                icon: "\uD83E\uDDF8",
                name: "Nursery Annex Sector",
                primary: "echo-trace",
                support: [
                    "stealth-transit",
                    "signal-mask"
                ],
                baseDuration: 60,
                category: "environmental",
                difficulty: "standard",
                placement_priority: "normal",
                districtAffinity: "residential",
                shortDescription: "Quiet block of sealed playrooms, murals eroded to color fields.",
                longDescription: "Small chairs lie on their backs like beetles. A mobile has tangled into a single shape. Everyone left a long time ago, but the rooms still feel paused."
            },
            {
                icon: "\uD83D\uDCDA",
                name: "Records Quarter",
                primary: "stealth-transit",
                support: [
                    "bio-shield",
                    "transit-anchor"
                ],
                baseDuration: 60,
                category: "storage",
                difficulty: "high_value",
                placement_priority: "high",
                districtAffinity: "commercial",
                shortDescription: "Storage stacks and data cages in a commercial sub-block.",
                longDescription: "Cage doors have slumped out of square. A spill of binders lies like fallen bricks. Your light finds the path numbers and makes them legible for a heartbeat."
            },
            {
                icon: "\uD83C\uDFEC",
                name: "Commerce Plaza",
                primary: "signal-mask",
                support: [
                    "bio-shield",
                    "transit-anchor"
                ],
                baseDuration: 60,
                category: "environmental",
                difficulty: "standard",
                placement_priority: "normal",
                districtAffinity: "commercial",
                shortDescription: "Lower concourse ringed by shuttered storefronts and dead kiosks.",
                longDescription: "A fountain bowl holds dust instead of water. Kiosk screens are gray mirrors. Every footstep you make has an echo measured in seconds."
            }
        ]
    }
};
var $980f67465e309611$export$85b5153488a36ab6 = {
    civic: [
        "CivicSys",
        "CityWorks",
        "MetroGrid",
        "Municipalix",
        "UrbanNet"
    ],
    industrial: [
        "StrataDyne",
        "HelixCore",
        "OmniForge",
        "FerrumWorks",
        "Rivetron"
    ],
    utilities: [
        "Nextera",
        "Voltline",
        "Auralis",
        "BlueArc",
        "GridNova"
    ],
    retail: [
        "MetroTrade",
        "ApexMart",
        "Cornerline",
        "Shoreline Logistics",
        "Mercantis"
    ],
    bio: [
        "VerdanCo",
        "BioNet",
        "PhytoLabs",
        "GreenRidge",
        "GenExis"
    ],
    defense: [
        "WardTek",
        "Rampart Systems",
        "Bastionex",
        "IronCrest",
        "Shieldline"
    ],
    data: [
        "Archivum",
        "Memora",
        "DataPlain",
        "ByteHarbor",
        "Recorda"
    ]
};
var $980f67465e309611$export$432c04b9bead009 = {
    "shard-cities": [
        "MetroGuard",
        "CivicSys",
        "CityWorks",
        "UrbanNet",
        "MetroGrid",
        "ApexLift",
        "Blockline Security",
        "SentraCore",
        "Wayfinder Transit",
        "Arcology Services"
    ],
    "verdant-reclamation": [
        "VerdanCo",
        "PhytoLabs",
        "BioNet",
        "Greencap Utilities",
        "GardenWorks",
        "Nutrivane",
        "IrrigaTech",
        "SeedSafe",
        "Rootline Systems",
        "Auralis Bio"
    ],
    "sunken-bastions": [
        "HarborFleet",
        "DryDock Systems",
        "Bastionex",
        "BlueArc Marine",
        "Deepline",
        "Breakwater Logistics",
        "WardTek Maritime",
        "Pierstone",
        "Tidewell",
        "Seaforth Controls"
    ],
    "cradle-expanse": [
        "FerrumWorks",
        "OmniForge",
        "StrataDyne",
        "Rivetron",
        "Gantry & Co.",
        "Loadstar Fabrication",
        "ConveyorDynamics",
        "IronCrest",
        "Forgeway",
        "MachinaGrid"
    ],
    "hollow-core": [
        "CivicSys Sublevel",
        "MetroGrid Infrastructure",
        "Nextera Utility",
        "ServiceWay",
        "Subterra Transit",
        "CorridorWorks",
        "Spanline",
        "NodeWest",
        "ControlPoint",
        "Concourse Ops"
    ]
};
var $980f67465e309611$export$2c8d0d917dbcc8a5 = {
    power: [
        "Power Node",
        "Junction Panel",
        "Substation",
        "Transformer Bay",
        "Distribution Rack"
    ],
    storage: [
        "Storage Bay",
        "Records Vault",
        "Supply Depot",
        "Inventory Room",
        "Archive Annex"
    ],
    security: [
        "Security Gate",
        "Checkpoint",
        "Access Control",
        "Barrier Post",
        "Perimeter Gate"
    ],
    infrastructure: [
        "Relay Node",
        "Transit Hub",
        "Service Corridor",
        "Maintenance Bay",
        "Control Room"
    ],
    environmental: [
        "Containment Zone",
        "Hazard Control",
        "Firebreak",
        "Isolation Area",
        "Cleanup Sector"
    ],
    wildlife: [
        "Hive Chamber",
        "Containment Atrium",
        "Observation Pen",
        "Keeper Station",
        "Handling Room"
    ],
    power_infra: [
        "Switchgear Room",
        "Feeder Junction",
        "Utility Interface",
        "Load Center",
        "Breaker Hall"
    ],
    records_data: [
        "Records Cache",
        "Data Vault",
        "Archive Store",
        "Tape Annex",
        "Records Room"
    ]
};
var $980f67465e309611$export$66a51bddf5f03abf = [
    "Block A",
    "Block C",
    "Sector 7",
    "Sector 9",
    "East Annex",
    "West Annex",
    "North Wing",
    "South Wing",
    "Sublevel 2",
    "Sublevel 3",
    "Sublevel 4",
    "Tower 2",
    "Depot Lane",
    "Service Row",
    "Line 3",
    "Bay 12",
    "Bay 17",
    "Midtown Annex"
];
var $980f67465e309611$export$ae5fd03a6b740baa = {
    "shard-cities": [
        "Midtown Annex",
        "Tower 3",
        "Sector 9",
        "Skyway Deck",
        "Service Row"
    ],
    "verdant-reclamation": [
        "Greenhouse 2A",
        "Irrigation Loop B",
        "Seed Wing",
        "Containment Hall",
        "Botany Annex"
    ],
    "sunken-bastions": [
        "Pier 6",
        "Drydock 3",
        "Bulkhead E",
        "Sublevel Pump 2",
        "Bilge Corridor"
    ],
    "cradle-expanse": [
        "Line 3",
        "Bay 12",
        "Casting Floor",
        "Yard 5",
        "Maintenance Track"
    ],
    "hollow-core": [
        "Sublevel 4",
        "Service Spine",
        "Transit Ring",
        "Access Spur",
        "Node J"
    ]
};
var $980f67465e309611$export$68faa9057a77ce7d = {
    "shard-cities": [
        "civic",
        "utilities",
        "data",
        "industrial",
        "retail",
        "defense"
    ],
    "verdant-reclamation": [
        "bio",
        "utilities",
        "civic",
        "industrial",
        "data"
    ],
    "sunken-bastions": [
        "defense",
        "utilities",
        "industrial",
        "civic",
        "data"
    ],
    "cradle-expanse": [
        "industrial",
        "utilities",
        "civic",
        "retail",
        "data"
    ],
    "hollow-core": [
        "civic",
        "utilities",
        "industrial",
        "data",
        "retail"
    ],
    zone: {
        residential: [
            "civic",
            "utilities",
            "bio",
            "retail"
        ],
        commercial: [
            "retail",
            "civic",
            "data",
            "utilities"
        ],
        industrial: [
            "industrial",
            "utilities",
            "defense"
        ],
        security: [
            "defense",
            "civic",
            "utilities"
        ],
        core: [
            "data",
            "defense",
            "industrial"
        ],
        transit: [
            "civic",
            "utilities",
            "industrial"
        ],
        peripheral: [
            "civic",
            "industrial",
            "retail"
        ],
        entry: [
            "civic",
            "utilities",
            "retail"
        ]
    },
    category: {
        power: [
            "utilities",
            "industrial",
            "civic"
        ],
        storage: [
            "industrial",
            "retail",
            "data"
        ],
        security: [
            "defense",
            "civic",
            "utilities"
        ],
        infrastructure: [
            "civic",
            "utilities",
            "industrial"
        ],
        environmental: [
            "civic",
            "industrial",
            "utilities"
        ],
        wildlife: [
            "bio",
            "civic",
            "utilities"
        ]
    }
};
// RNG (seeded)
function $980f67465e309611$var$xmur3(str) {
    var h = 1779033703 ^ str.length;
    for(var i = 0; i < str.length; i++){
        h = Math.imul(h ^ str.charCodeAt(i), 3432918353);
        h = h << 13 | h >>> 19;
    }
    return function() {
        h = Math.imul(h ^ h >>> 16, 2246822507);
        h = Math.imul(h ^ h >>> 13, 3266489909);
        return (h ^ h >>> 16) >>> 0;
    };
}
function $980f67465e309611$var$mulberry32(a) {
    return function() {
        a |= 0;
        a = a + 0x6d2b79f5 | 0;
        var t = Math.imul(a ^ a >>> 15, 1 | a);
        t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t;
        return ((t ^ t >>> 14) >>> 0) / 4294967296;
    };
}
function $980f67465e309611$export$c0b222505a3369f3() {
    var seedStr = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var seed = $980f67465e309611$var$xmur3(seedStr)();
    return $980f67465e309611$var$mulberry32(seed);
}
function $980f67465e309611$var$pick(array, rng) {
    return array[Math.floor(rng() * array.length)];
}
// Brand pool builder with regional weighting
function $980f67465e309611$var$getBrandPool(param) {
    var regionKey = param.regionKey, zone = param.zone, category = param.category;
    var _weighted, _instance;
    var base = $980f67465e309611$export$68faa9057a77ce7d[regionKey] || [
        "civic",
        "industrial",
        "utilities"
    ];
    var zoneBias = $980f67465e309611$export$68faa9057a77ce7d.zone[zone] || [];
    var catBias = $980f67465e309611$export$68faa9057a77ce7d.category[category] || [];
    var order = (0, $4c858c0d999a5b9b$export$71511d61b312f219)(base).concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)(zoneBias), (0, $4c858c0d999a5b9b$export$71511d61b312f219)(catBias));
    var weighted = [];
    var regional = $980f67465e309611$export$432c04b9bead009[regionKey] || [];
    for(var i = 0; i < 3; i++)(_weighted = weighted).push.apply(_weighted, (0, $4c858c0d999a5b9b$export$71511d61b312f219)(regional)); // heavy regional weight
    order.forEach(function(bucket, idx) {
        var _weighted;
        var list = $980f67465e309611$export$85b5153488a36ab6[bucket] || [];
        var weight = idx < 2 ? 2 : 1;
        for(var i = 0; i < weight; i++)(_weighted = weighted).push.apply(_weighted, (0, $4c858c0d999a5b9b$export$71511d61b312f219)(list));
    });
    return weighted.length ? weighted : (_instance = []).concat.apply(_instance, (0, $4c858c0d999a5b9b$export$71511d61b312f219)(Object.values($980f67465e309611$export$85b5153488a36ab6)));
}
function $980f67465e309611$var$getDescriptorPool(category) {
    if (category === "power" && $980f67465e309611$export$2c8d0d917dbcc8a5.power_infra) return (0, $4c858c0d999a5b9b$export$71511d61b312f219)($980f67465e309611$export$2c8d0d917dbcc8a5.power).concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)($980f67465e309611$export$2c8d0d917dbcc8a5.power_infra));
    if (category === "storage" && $980f67465e309611$export$2c8d0d917dbcc8a5.records_data) return (0, $4c858c0d999a5b9b$export$71511d61b312f219)($980f67465e309611$export$2c8d0d917dbcc8a5.storage).concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)($980f67465e309611$export$2c8d0d917dbcc8a5.records_data));
    return $980f67465e309611$export$2c8d0d917dbcc8a5[category] || $980f67465e309611$export$2c8d0d917dbcc8a5.infrastructure;
}
function $980f67465e309611$var$pickQualifier(regionKey, rng) {
    var base = $980f67465e309611$export$66a51bddf5f03abf;
    var regional = $980f67465e309611$export$ae5fd03a6b740baa[regionKey] || [];
    var pool = (0, $4c858c0d999a5b9b$export$71511d61b312f219)(regional).concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)(regional), (0, $4c858c0d999a5b9b$export$71511d61b312f219)(base)); // 2:1 favor regional
    return pool.length ? pool[Math.floor(rng() * pool.length)] : "";
}
function $980f67465e309611$export$6b7290c54feddd3b(param) {
    var baseName = param.baseName, regionKey = param.regionKey, zone = param.zone, category = param.category, _param_seed = param.seed, seed = _param_seed === void 0 ? "" : _param_seed, count = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 5;
    var rng = $980f67465e309611$export$c0b222505a3369f3("".concat(seed, "|").concat(baseName, "|").concat(regionKey, "|").concat(zone, "|").concat(category));
    var brands = $980f67465e309611$var$getBrandPool({
        regionKey: regionKey,
        zone: zone,
        category: category
    });
    var descs = $980f67465e309611$var$getDescriptorPool(category);
    var names = new Set();
    var canon = [
        baseName,
        "".concat(baseName, " \u2013 ").concat($980f67465e309611$var$pickQualifier(regionKey, rng))
    ];
    var safety = 200;
    while(names.size < count && safety-- > 0){
        var brand = $980f67465e309611$var$pick(brands, rng);
        var desc = $980f67465e309611$var$pick(descs, rng);
        var useBaseTerm = rng() < 0.35; // 35% anchor to base term
        var qualifier = rng() < 0.65 ? " \u2013 ".concat($980f67465e309611$var$pickQualifier(regionKey, rng)) : "";
        var candidate = useBaseTerm ? "".concat(brand, " ").concat(baseName).concat(qualifier) : "".concat(brand, " ").concat(desc).concat(qualifier);
        names.add(candidate);
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = canon[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var c = _step.value;
            if (names.size >= count) break;
            names.add(c);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return Array.from(names).slice(0, count);
}
var $980f67465e309611$export$1a6ba7df4555a8dd = {
    defaultTune: {
        buildingScale: 1,
        treeDensity: 1,
        roadWear: 0.15,
        shadowAngle: 45,
        shadowAlpha: 0.85,
        shadowLength: 6,
        lightUptime: 0.12,
        lightFlickerSpeed: 1,
        sinkholeChance: 0.5,
        lightRays: 0,
        // How often a region's own signature props appear — the one pass that is
        // about a PARTICULAR place rather than about a town. 0 turns them off.
        signature: 1,
        // How far inland the sea reaches on a region with a shoreline. 0 = no sea,
        // which is every region but the drowned one.
        floodLevel: 0,
        // How much rock mass has come down around the built ground. Sublevels only.
        enclosure: 0,
        cloudType: 'scattered'
    },
    regions: {
        // Two tiers of architecture per region. `struct` is the ordinary building
        // stock — the sheds, blocks and terraces the whole map is made of. `mass`
        // is the monumental tier: the towers, glasshouses, sea walls, mill frames
        // and pillar halls a region builds at a scale nothing else on the tile
        // reaches. Keeping them apart is what lets shard-cities have warm brown
        // roofs on its small buildings AND cool concrete over them, instead of
        // picking one and reading as somewhere else's town in a filter.
        //
        // The rule both tiers answer to: a structure must separate from the ground
        // it stands on in VALUE, not just in hue. Two regions with the same value
        // relationship look like the same place no matter what colour they are.
        'shard-cities': {
            backdrop: 'city',
            overlay: 'dust',
            tune: {
                buildingScale: 1.3,
                treeDensity: 3,
                roadWear: 0.35,
                shadowAngle: 45,
                shadowAlpha: 0.85,
                shadowLength: 6,
                lightUptime: 0.18,
                lightFlickerSpeed: 1,
                sinkholeChance: 0.5,
                lightRays: 0,
                signature: 1,
                cloudType: 'broken'
            },
            pal: {
                far: '#1c2333',
                // Warm brick and brown roofing, but a stop LIGHTER than it used to be
                // and over darker tarmac. The hue contrast against grey ground always
                // worked; the value contrast did not — seven luma points apart, the
                // roofs sank into the street at map scale and the region read as one
                // undifferentiated grey-brown field.
                struct: '#8a705c',
                structDark: '#15171e',
                structLight: '#b99983',
                mass: '#79828f',
                massDark: '#2a3038',
                massLight: '#a9b6c4',
                ground1: '#3f434e',
                ground2: '#4b5160',
                road: '#20242f',
                metal: '#6b7893',
                rust: '#8a6a4a',
                accent: '#a9bee0',
                veg1: '#3b5841',
                veg2: '#5d8058',
                water1: '#33455c',
                water2: '#55708c',
                glow: '#ffb45e'
            }
        },
        'verdant-reclamation': {
            backdrop: 'greenhouse',
            overlay: 'vines',
            recipes: {
                storage: 'storage-seed'
            },
            tune: {
                buildingScale: 1.1,
                treeDensity: 4,
                roadWear: 0.75,
                cloudType: 'scattered',
                lightUptime: 0.05,
                signature: 1.1
            },
            pal: {
                far: '#4c6350',
                struct: '#7d8a8c',
                structDark: '#455256',
                structLight: '#b0bcba',
                mass: '#9fb0a8',
                massDark: '#4a5a52',
                massLight: '#cfdcd2',
                // The ground is most of the tile, so it decides whether the region reads
                // as flat — and a light mid-green under light grey frames was the whole
                // problem. Taken down to shaded loam, but only halfway: the first attempt
                // went the full distance and the region lost its light instead of gaining
                // contrast. The canopy is darker still, the structures sit well above
                // both, and the tile has a range without going gloomy.
                ground1: '#3e5a34',
                ground2: '#4f5b30',
                road: '#42402f',
                metal: '#8b9598',
                rust: '#8a7050',
                accent: '#d8d2a8',
                // Deep canopy. These are the darkest greens on the tile and the shapes
                // they make are what the eye reads first, so they carry the contrast.
                veg1: '#254d2a',
                veg2: '#4a7a3a',
                water1: '#3f7a70',
                water2: '#6fb0a4',
                glow: '#f4e9c8'
            }
        },
        'sunken-bastions': {
            backdrop: 'harbor',
            overlay: 'flood',
            recipes: {
                storage: 'storage-quay'
            },
            tune: {
                buildingScale: 1.15,
                treeDensity: 1,
                roadWear: 0.4,
                cloudType: 'overcast',
                sinkholeChance: 0.35,
                floodLevel: 1,
                signature: 1
            },
            pal: {
                far: '#3a4854',
                struct: '#6d8290',
                structDark: '#2c3841',
                structLight: '#9db6c2',
                mass: '#7d8f99',
                massDark: '#2c3841',
                massLight: '#a8bcc4',
                ground1: '#4a5450',
                ground2: '#5b6763',
                road: '#39434c',
                metal: '#7b8a93',
                rust: '#b06a3d',
                accent: '#8fc4cc',
                veg1: '#3c5f4c',
                veg2: '#58825e',
                water1: '#2f5c6b',
                water2: '#5a8f9b',
                glow: '#ffd27f'
            }
        },
        'cradle-expanse': {
            backdrop: 'foundry',
            overlay: 'rust',
            recipes: {
                storage: 'storage-silo'
            },
            tune: {
                buildingScale: 1.25,
                treeDensity: 0.8,
                roadWear: 0.3,
                shadowAngle: 15,
                cloudType: 'wispy',
                signature: 1
            },
            pal: {
                far: '#4a3226',
                // The one region whose plant is LIGHTER than its ground. Dark dirt with
                // pale steel on it is the opposite value relationship to shard-cities'
                // dark roofs on grey tarmac, which is what stops two brown regions
                // reading as one.
                struct: '#a5825c',
                structDark: '#3a2417',
                structLight: '#d2ad7f',
                mass: '#a89279',
                massDark: '#4a3a28',
                massLight: '#d3c0a4',
                ground1: '#6b5137',
                ground2: '#7d6244',
                road: '#3d3226',
                metal: '#9c8a6e',
                rust: '#b55a2b',
                accent: '#e8b060',
                veg1: '#635831',
                veg2: '#807236',
                water1: '#5d564a',
                water2: '#7a705c',
                glow: '#ffcf7a'
            }
        },
        'hollow-core': {
            backdrop: 'underground',
            overlay: 'dark',
            // Everything here is lifted a stop from where it was: a sublevel is dark
            // because of its LIGHT, not because its concrete is black. The palette
            // has to survive a x0.5 night tint and a darkness wash on top and still
            // show which parts of the tile are wall.
            tune: {
                buildingScale: 1.1,
                treeDensity: 1,
                roadWear: 0.25,
                lightRays: 1.5,
                enclosure: 1,
                signature: 1.2
            },
            pal: {
                far: '#07080c',
                struct: '#5c6782',
                structDark: '#1b1f2a',
                structLight: '#7f8cad',
                mass: '#6b7690',
                massDark: '#1b1f2a',
                massLight: '#909dbb',
                ground1: '#333a46',
                ground2: '#454d5d',
                road: '#1c212b',
                metal: '#5b6478',
                rust: '#5a4630',
                accent: '#4fa0a0',
                veg1: '#2d473f',
                veg2: '#41684e',
                water1: '#234049',
                water2: '#356470',
                glow: '#ffc46a'
            }
        }
    },
    recipes: {
        power: {
            variants: [
                {
                    elements: [
                        {
                            el: 'transformerPad',
                            x: [
                                9,
                                21
                            ],
                            y: [
                                9,
                                21
                            ]
                        },
                        {
                            el: 'transformerPad',
                            x: [
                                84,
                                93
                            ],
                            y: [
                                84,
                                93
                            ]
                        },
                        {
                            el: 'rect',
                            x: 30,
                            y: [
                                24,
                                30
                            ],
                            w: 3,
                            h: 60,
                            color: 'structDark'
                        },
                        {
                            el: 'rect',
                            x: 30,
                            y: 87,
                            w: [
                                51,
                                60
                            ],
                            h: 3,
                            color: 'structDark'
                        },
                        {
                            el: 'fence',
                            x: 6,
                            y: 6,
                            w: 36,
                            h: 36
                        }
                    ]
                },
                {
                    elements: [
                        {
                            el: 'tank',
                            x: [
                                24,
                                33
                            ],
                            y: [
                                24,
                                33
                            ],
                            r: 18
                        },
                        {
                            el: 'pipeline',
                            x: 6,
                            y: [
                                87,
                                96
                            ],
                            w: 108
                        },
                        {
                            el: 'transformerPad',
                            x: [
                                84,
                                93
                            ],
                            y: [
                                15,
                                24
                            ]
                        }
                    ]
                }
            ]
        },
        storage: {
            variants: [
                {
                    elements: [
                        {
                            el: 'crates',
                            x: [
                                9,
                                15
                            ],
                            y: [
                                9,
                                18
                            ],
                            cols: 3,
                            rows: 2
                        },
                        {
                            el: 'crates',
                            x: [
                                78,
                                87
                            ],
                            y: [
                                78,
                                87
                            ],
                            cols: 2,
                            rows: 2
                        },
                        {
                            el: 'tank',
                            x: [
                                90,
                                99
                            ],
                            y: [
                                21,
                                30
                            ],
                            r: 15
                        },
                        {
                            el: 'building',
                            x: [
                                9,
                                15
                            ],
                            y: [
                                78,
                                84
                            ],
                            w: 27,
                            h: 24
                        }
                    ]
                },
                {
                    elements: [
                        {
                            el: 'container',
                            x: [
                                9,
                                18
                            ],
                            y: [
                                9,
                                15
                            ],
                            vert: 0
                        },
                        {
                            el: 'container',
                            x: [
                                9,
                                18
                            ],
                            y: [
                                27,
                                33
                            ],
                            vert: 0
                        },
                        {
                            el: 'container',
                            x: [
                                81,
                                93
                            ],
                            y: [
                                75,
                                84
                            ],
                            vert: 1
                        },
                        {
                            el: 'crates',
                            x: [
                                15,
                                24
                            ],
                            y: [
                                81,
                                90
                            ],
                            cols: 2,
                            rows: 2
                        }
                    ]
                }
            ]
        },
        // ---- region-specific stock ----
        // A region may point one of the shared recipes at its own layout via
        // `recipes` on its RENDER_CONFIG.regions entry. The signature layer adds a
        // region's landmarks ON TOP of whatever a tile drew; this changes what the
        // tile is made of in the first place, which is the difference between a
        // harbour with containers on it and a harbour built out of them.
        //
        // Kept deliberately few. Every one of these is a second layout to maintain
        // for a recipe that already had one, so it has to earn its place by being
        // somewhere the shared version reads plainly wrong.
        'storage-quay': {
            variants: [
                {
                    elements: [
                        {
                            el: 'container',
                            x: [
                                9,
                                15
                            ],
                            y: [
                                12,
                                18
                            ],
                            vert: 0
                        },
                        {
                            el: 'container',
                            x: [
                                9,
                                15
                            ],
                            y: [
                                27,
                                33
                            ],
                            vert: 0
                        },
                        {
                            el: 'container',
                            x: [
                                9,
                                15
                            ],
                            y: [
                                42,
                                48
                            ],
                            vert: 0
                        },
                        {
                            el: 'container',
                            x: [
                                78,
                                90
                            ],
                            y: [
                                69,
                                81
                            ],
                            vert: 1
                        },
                        {
                            el: 'crates',
                            x: [
                                66,
                                75
                            ],
                            y: [
                                15,
                                24
                            ],
                            cols: 2,
                            rows: 2
                        }
                    ]
                },
                {
                    elements: [
                        {
                            el: 'building',
                            x: [
                                15,
                                24
                            ],
                            y: [
                                15,
                                24
                            ],
                            w: 60,
                            h: 27
                        },
                        {
                            el: 'container',
                            x: [
                                15,
                                27
                            ],
                            y: [
                                78,
                                87
                            ],
                            vert: 0
                        },
                        {
                            el: 'container',
                            x: [
                                60,
                                72
                            ],
                            y: [
                                75,
                                84
                            ],
                            vert: 1
                        }
                    ]
                }
            ]
        },
        'storage-silo': {
            variants: [
                {
                    elements: [
                        {
                            el: 'silo',
                            x: [
                                21,
                                27
                            ],
                            y: [
                                24,
                                30
                            ],
                            r: 13
                        },
                        {
                            el: 'silo',
                            x: [
                                21,
                                27
                            ],
                            y: [
                                69,
                                75
                            ],
                            r: 11
                        },
                        {
                            el: 'silo',
                            x: [
                                72,
                                81
                            ],
                            y: [
                                45,
                                54
                            ],
                            r: 14
                        },
                        {
                            el: 'pipeline',
                            x: 33,
                            y: [
                                51,
                                57
                            ],
                            w: [
                                30,
                                39
                            ]
                        }
                    ]
                },
                {
                    elements: [
                        {
                            el: 'silo',
                            x: [
                                78,
                                87
                            ],
                            y: [
                                24,
                                33
                            ],
                            r: 12
                        },
                        {
                            el: 'tank',
                            x: [
                                24,
                                33
                            ],
                            y: [
                                21,
                                30
                            ],
                            r: 15
                        },
                        {
                            el: 'building',
                            x: [
                                15,
                                24
                            ],
                            y: [
                                72,
                                81
                            ],
                            w: 42,
                            h: 24
                        },
                        {
                            el: 'crates',
                            x: [
                                72,
                                84
                            ],
                            y: [
                                78,
                                90
                            ],
                            cols: 2,
                            rows: 2
                        }
                    ]
                }
            ]
        },
        'storage-seed': {
            variants: [
                {
                    elements: [
                        {
                            el: 'glassSpan',
                            x: [
                                12,
                                18
                            ],
                            y: [
                                15,
                                24
                            ],
                            w: 66,
                            h: 27
                        },
                        {
                            el: 'silo',
                            x: [
                                24,
                                30
                            ],
                            y: [
                                78,
                                87
                            ],
                            r: 11
                        },
                        {
                            el: 'silo',
                            x: [
                                54,
                                63
                            ],
                            y: [
                                81,
                                90
                            ],
                            r: 9
                        },
                        {
                            el: 'crates',
                            x: [
                                84,
                                93
                            ],
                            y: [
                                69,
                                78
                            ],
                            cols: 2,
                            rows: 2
                        }
                    ]
                },
                {
                    elements: [
                        {
                            el: 'silo',
                            x: [
                                18,
                                24
                            ],
                            y: [
                                21,
                                30
                            ],
                            r: 12
                        },
                        {
                            el: 'glassSpan',
                            x: [
                                63,
                                72
                            ],
                            y: [
                                21,
                                30
                            ],
                            w: 33,
                            h: 66
                        },
                        {
                            el: 'crates',
                            x: [
                                15,
                                24
                            ],
                            y: [
                                78,
                                87
                            ],
                            cols: 3,
                            rows: 2
                        }
                    ]
                }
            ]
        },
        security: {
            elements: [
                {
                    el: 'fence',
                    x: 15,
                    y: 15,
                    w: 90,
                    h: 90,
                    gaps: 1
                },
                {
                    el: 'barrier',
                    x: 24,
                    y: 24
                },
                {
                    el: 'barrier',
                    x: 81,
                    y: 81
                },
                {
                    el: 'vehicle',
                    chance: 0.4,
                    x: [
                        72,
                        84
                    ],
                    y: [
                        78,
                        87
                    ],
                    vert: {
                        pick: [
                            0,
                            1
                        ]
                    }
                },
                {
                    el: 'building',
                    x: [
                        72,
                        81
                    ],
                    y: [
                        21,
                        30
                    ],
                    w: 18,
                    h: 15
                }
            ]
        },
        infrastructure: {
            variants: [
                {
                    elements: [
                        {
                            el: 'building',
                            x: [
                                9,
                                15
                            ],
                            y: [
                                9,
                                15
                            ],
                            w: [
                                36,
                                45
                            ],
                            h: [
                                27,
                                33
                            ]
                        },
                        {
                            el: 'pipeline',
                            x: 6,
                            y: [
                                87,
                                96
                            ],
                            w: 108
                        },
                        {
                            el: 'rect',
                            x: [
                                81,
                                93
                            ],
                            y: [
                                15,
                                24
                            ],
                            w: 15,
                            h: 15,
                            color: 'metal'
                        }
                    ]
                },
                {
                    elements: [
                        {
                            el: 'tower',
                            x: [
                                15,
                                24
                            ],
                            y: [
                                15,
                                24
                            ]
                        },
                        {
                            el: 'rect',
                            x: 24,
                            y: 30,
                            w: 3,
                            h: [
                                54,
                                66
                            ],
                            color: 'structDark'
                        },
                        {
                            el: 'rect',
                            x: 24,
                            y: 90,
                            w: [
                                54,
                                66
                            ],
                            h: 3,
                            color: 'structDark'
                        },
                        {
                            el: 'tank',
                            x: [
                                84,
                                93
                            ],
                            y: [
                                81,
                                90
                            ],
                            r: 12
                        },
                        {
                            el: 'rect',
                            x: [
                                81,
                                93
                            ],
                            y: [
                                15,
                                24
                            ],
                            w: 15,
                            h: 15,
                            color: 'metal'
                        }
                    ]
                }
            ]
        },
        transit: {
            elements: [
                {
                    el: 'rect',
                    x: [
                        18,
                        30
                    ],
                    y: [
                        72,
                        84
                    ],
                    w: 6,
                    h: 27,
                    color: 'struct'
                },
                {
                    el: 'rect',
                    x: [
                        78,
                        90
                    ],
                    y: [
                        15,
                        27
                    ],
                    w: 27,
                    h: 6,
                    color: 'struct'
                },
                {
                    el: 'vehicle',
                    x: [
                        12,
                        24
                    ],
                    y: [
                        12,
                        24
                    ],
                    vert: {
                        pick: [
                            0,
                            1
                        ]
                    }
                },
                {
                    el: 'vehicle',
                    chance: 0.6,
                    x: [
                        78,
                        90
                    ],
                    y: [
                        78,
                        90
                    ],
                    vert: {
                        pick: [
                            0,
                            1
                        ]
                    }
                },
                {
                    el: 'rubble',
                    x: 12,
                    y: 12,
                    w: 93,
                    h: 93,
                    n: 12
                }
            ]
        },
        environmental: {
            variantKey: 'sinkholeChance',
            variants: [
                {
                    elements: [
                        {
                            el: 'crack',
                            repeat: 4,
                            x: [
                                9,
                                105
                            ],
                            y: [
                                9,
                                96
                            ],
                            len: [
                                18,
                                36
                            ]
                        },
                        {
                            el: 'rubble',
                            x: 6,
                            y: 6,
                            w: 105,
                            h: 105,
                            n: 18
                        },
                        {
                            el: 'foliage',
                            x: [
                                15,
                                36
                            ],
                            y: [
                                78,
                                102
                            ],
                            size: [
                                4,
                                6
                            ]
                        },
                        {
                            el: 'foliage',
                            x: [
                                81,
                                102
                            ],
                            y: [
                                15,
                                36
                            ],
                            size: [
                                4,
                                6
                            ]
                        },
                        {
                            el: 'tree',
                            x: [
                                81,
                                99
                            ],
                            y: [
                                81,
                                99
                            ],
                            r: [
                                9,
                                12
                            ]
                        }
                    ]
                },
                {
                    elements: [
                        // The hole goes down LAST. Scatter drawn over it is debris hanging in
                        // a shaft; drawn under it, the hole simply swallows whatever fell in
                        // and what is left reads as ground that gave way. The pit brings its
                        // own spoil ring with it, so the rim still has a heap on it.
                        {
                            el: 'rubble',
                            x: 12,
                            y: 12,
                            w: 93,
                            h: 93,
                            n: 14
                        },
                        {
                            el: 'sinkhole',
                            x: [
                                36,
                                78
                            ],
                            y: [
                                36,
                                78
                            ]
                        }
                    ]
                }
            ]
        },
        records: {
            variants: [
                {
                    elements: [
                        {
                            el: 'building',
                            x: [
                                12,
                                18
                            ],
                            y: [
                                12,
                                18
                            ],
                            w: [
                                36,
                                42
                            ],
                            h: [
                                27,
                                33
                            ]
                        },
                        {
                            el: 'building',
                            when: {
                                tune: 'buildingScale',
                                gte: 1.15
                            },
                            x: [
                                78,
                                87
                            ],
                            y: [
                                12,
                                18
                            ],
                            w: 24,
                            h: 21
                        },
                        {
                            el: 'speckle',
                            x: 6,
                            y: 6,
                            w: 105,
                            h: 105,
                            n: 8,
                            color: 'structLight',
                            alpha: 0.8
                        }
                    ]
                },
                {
                    elements: [
                        {
                            el: 'building',
                            x: [
                                12,
                                18
                            ],
                            y: [
                                12,
                                18
                            ],
                            w: [
                                36,
                                42
                            ],
                            h: [
                                27,
                                33
                            ]
                        },
                        {
                            el: 'building',
                            x: [
                                78,
                                84
                            ],
                            y: [
                                78,
                                84
                            ],
                            w: [
                                24,
                                30
                            ],
                            h: [
                                21,
                                27
                            ]
                        },
                        {
                            el: 'building',
                            when: {
                                tune: 'buildingScale',
                                gte: 1.15
                            },
                            x: [
                                78,
                                87
                            ],
                            y: [
                                12,
                                18
                            ],
                            w: 24,
                            h: 21
                        },
                        {
                            el: 'speckle',
                            x: 6,
                            y: 6,
                            w: 105,
                            h: 105,
                            n: 8,
                            color: 'structLight',
                            alpha: 0.8
                        }
                    ]
                },
                // The two above put a hall in each corner, which leaves a road nowhere to
                // go: mirroring the layout only moves which corner is which. These two
                // range the halls along ONE edge instead, so half the tile stays open —
                // and the mirror decides which half, to suit wherever the road landed.
                // Ranged east-west, for a road crossing that way:
                {
                    elements: [
                        {
                            el: 'building',
                            x: [
                                9,
                                15
                            ],
                            y: 9,
                            w: [
                                45,
                                54
                            ],
                            h: [
                                27,
                                33
                            ]
                        },
                        {
                            el: 'building',
                            x: [
                                66,
                                72
                            ],
                            y: 9,
                            w: [
                                33,
                                39
                            ],
                            h: [
                                24,
                                30
                            ]
                        },
                        {
                            el: 'speckle',
                            x: 6,
                            y: 6,
                            w: 105,
                            h: 105,
                            n: 8,
                            color: 'structLight',
                            alpha: 0.8
                        }
                    ]
                },
                // and ranged north-south, for one crossing the other way:
                {
                    elements: [
                        {
                            el: 'building',
                            x: 9,
                            y: [
                                9,
                                15
                            ],
                            w: [
                                27,
                                33
                            ],
                            h: [
                                42,
                                48
                            ]
                        },
                        {
                            el: 'building',
                            x: 9,
                            y: [
                                66,
                                72
                            ],
                            w: [
                                24,
                                30
                            ],
                            h: [
                                33,
                                39
                            ]
                        },
                        {
                            el: 'speckle',
                            x: 6,
                            y: 6,
                            w: 105,
                            h: 105,
                            n: 8,
                            color: 'structLight',
                            alpha: 0.8
                        }
                    ]
                }
            ]
        },
        habitation: {
            variants: [
                {
                    elements: [
                        {
                            el: 'building',
                            x: [
                                9,
                                15
                            ],
                            y: [
                                9,
                                15
                            ],
                            w: [
                                30,
                                36
                            ],
                            h: [
                                24,
                                30
                            ]
                        },
                        {
                            el: 'building',
                            x: [
                                78,
                                84
                            ],
                            y: [
                                12,
                                18
                            ],
                            w: [
                                27,
                                33
                            ],
                            h: [
                                21,
                                27
                            ]
                        },
                        {
                            el: 'building',
                            x: [
                                12,
                                18
                            ],
                            y: [
                                81,
                                87
                            ],
                            w: [
                                27,
                                33
                            ],
                            h: [
                                21,
                                27
                            ]
                        },
                        {
                            el: 'building',
                            when: {
                                tune: 'buildingScale',
                                gte: 1.15
                            },
                            x: [
                                81,
                                87
                            ],
                            y: [
                                81,
                                87
                            ],
                            w: 24,
                            h: 21
                        },
                        {
                            el: 'rect',
                            repeat: 4,
                            x: [
                                78,
                                105
                            ],
                            y: [
                                81,
                                105
                            ],
                            w: 6,
                            h: 6,
                            color: 'veg1'
                        },
                        {
                            el: 'bush',
                            x: [
                                81,
                                102
                            ],
                            y: [
                                18,
                                36
                            ]
                        }
                    ]
                },
                {
                    elements: [
                        {
                            el: 'building',
                            x: [
                                9,
                                15
                            ],
                            y: [
                                9,
                                15
                            ],
                            w: [
                                42,
                                48
                            ],
                            h: [
                                36,
                                42
                            ]
                        },
                        {
                            el: 'tree',
                            x: [
                                84,
                                96
                            ],
                            y: [
                                15,
                                27
                            ],
                            r: 9
                        },
                        {
                            el: 'bush',
                            x: [
                                81,
                                102
                            ],
                            y: [
                                18,
                                36
                            ]
                        }
                    ]
                },
                // Housing is the one thing that is genuinely built in rows, so two of
                // them: one long range and a shorter one behind it, facing the other way
                // as a back street does. The gap between is the lane.
                {
                    elements: [
                        {
                            el: 'terrace',
                            x: [
                                9,
                                15
                            ],
                            y: [
                                9,
                                15
                            ],
                            w: [
                                54,
                                69
                            ],
                            h: [
                                21,
                                27
                            ]
                        },
                        {
                            el: 'terrace',
                            chance: 0.8,
                            x: [
                                15,
                                27
                            ],
                            y: [
                                69,
                                75
                            ],
                            w: [
                                42,
                                57
                            ],
                            h: [
                                21,
                                24
                            ]
                        },
                        {
                            el: 'bush',
                            x: [
                                84,
                                102
                            ],
                            y: [
                                45,
                                63
                            ]
                        }
                    ]
                },
                // and the same row stood on end, so a mirror is not the only way this
                // recipe ever runs north-south
                {
                    elements: [
                        {
                            el: 'terrace',
                            x: [
                                9,
                                15
                            ],
                            y: [
                                9,
                                15
                            ],
                            w: [
                                21,
                                27
                            ],
                            h: [
                                54,
                                69
                            ],
                            vert: 1
                        },
                        {
                            el: 'terrace',
                            chance: 0.8,
                            x: [
                                69,
                                75
                            ],
                            y: [
                                15,
                                27
                            ],
                            w: [
                                21,
                                24
                            ],
                            h: [
                                42,
                                57
                            ],
                            vert: 1
                        },
                        {
                            el: 'bush',
                            x: [
                                45,
                                63
                            ],
                            y: [
                                84,
                                102
                            ]
                        }
                    ]
                }
            ]
        },
        commerce: {
            variants: [
                {
                    elements: [
                        {
                            el: 'storefront',
                            x: [
                                12,
                                18
                            ],
                            y: [
                                9,
                                15
                            ],
                            w: [
                                54,
                                66
                            ],
                            h: [
                                27,
                                33
                            ]
                        },
                        {
                            el: 'stalls'
                        }
                    ]
                },
                {
                    elements: [
                        {
                            el: 'storefront',
                            x: [
                                12,
                                18
                            ],
                            y: [
                                9,
                                15
                            ],
                            w: [
                                54,
                                66
                            ],
                            h: [
                                27,
                                33
                            ]
                        },
                        {
                            el: 'crates',
                            x: [
                                78,
                                90
                            ],
                            y: [
                                75,
                                87
                            ],
                            cols: 2,
                            rows: 2
                        }
                    ]
                },
                // A parade: shops in a row under one roof, with the lot they served in
                // front of them. One storefront alone reads as a retail park; the row is
                // what a high street is.
                //
                // Both ways round, and both shallower than the storefronts above, because
                // this is the only thing in the recipe that fits on a tile the road runs
                // through. A carriageway swings up to EDGE_SWING off centre, so the
                // clear ground beside one is about 43 units — and a storefront is 46 to
                // 49 deep once the region's scale and its awning are on it. It does not
                // fit in either orientation, in any mirror, which left a market tile on a
                // road as bare ground and some crates. A range 27 to 35 deep clears the
                // carriageway with room to spare, and the north-south copy does the same
                // for a road running the other way, which no mirror of an east-west range
                // can do. The layout pass prefers whichever of the five keeps a structure
                // standing, so a tile with no road through it still gets its big shop.
                {
                    elements: [
                        {
                            el: 'terrace',
                            x: [
                                9,
                                15
                            ],
                            y: [
                                9,
                                12
                            ],
                            w: [
                                57,
                                72
                            ],
                            h: [
                                21,
                                27
                            ]
                        },
                        {
                            el: 'crates',
                            chance: 0.5,
                            x: [
                                15,
                                27
                            ],
                            y: [
                                78,
                                87
                            ],
                            cols: 2,
                            rows: 2
                        }
                    ]
                },
                {
                    elements: [
                        {
                            el: 'terrace',
                            x: [
                                9,
                                12
                            ],
                            y: [
                                9,
                                15
                            ],
                            w: [
                                21,
                                27
                            ],
                            h: [
                                57,
                                72
                            ],
                            vert: 1
                        },
                        {
                            el: 'crates',
                            chance: 0.5,
                            x: [
                                78,
                                87
                            ],
                            y: [
                                15,
                                27
                            ],
                            cols: 2,
                            rows: 2
                        }
                    ]
                },
                // A corner unit, for where not even a parade reaches. A bend sweeps an L
                // through the tile and leaves a quarter of it clear, which nothing that
                // has to span an axis can use — so the smallest thing this recipe can be
                // is three shops in a corner rather than no shop at all.
                {
                    elements: [
                        {
                            el: 'terrace',
                            x: [
                                9,
                                15
                            ],
                            y: [
                                9,
                                15
                            ],
                            w: [
                                24,
                                30
                            ],
                            h: [
                                18,
                                24
                            ]
                        },
                        {
                            el: 'stalls',
                            chance: 0.5
                        }
                    ]
                }
            ]
        },
        reactor: {
            elements: [
                {
                    el: 'reactorCore'
                }
            ]
        },
        // Entry and extraction. A portal is a DEVICE somebody installed and powers,
        // so it stands in a facility rather than out in the open: ranges of
        // blockwork around three sides of the aperture, a transformer feeding it,
        // and the pad itself left clear in the middle (portalPad and portalGlow
        // both draw at the tile centre, and the glow goes down last of all).
        //
        // The buildings sit in one corner-half so the layout pass can mirror them
        // clear of the track that runs up to the tile — every mirror leaves two
        // adjacent sides open, which between them covers whichever edge the road
        // arrives from.
        portal: {
            elements: [
                {
                    el: 'building',
                    x: 9,
                    y: 9,
                    w: [
                        48,
                        57
                    ],
                    h: [
                        21,
                        27
                    ]
                },
                {
                    el: 'building',
                    x: 9,
                    y: [
                        36,
                        42
                    ],
                    w: [
                        21,
                        27
                    ],
                    h: [
                        39,
                        45
                    ]
                },
                {
                    el: 'transformerPad',
                    x: [
                        84,
                        93
                    ],
                    y: [
                        12,
                        18
                    ]
                },
                {
                    el: 'crates',
                    x: [
                        78,
                        87
                    ],
                    y: [
                        72,
                        81
                    ],
                    cols: 2,
                    rows: 2
                },
                // a deck under the aperture, so it reads as installed rather than as
                // something that happened to appear in the yard
                {
                    el: 'rect',
                    x: 36,
                    y: 36,
                    w: 48,
                    h: 48,
                    color: 'structDark'
                },
                {
                    el: 'rect',
                    x: 39,
                    y: 39,
                    w: 42,
                    h: 42,
                    color: 'ground2'
                },
                {
                    el: 'portalPad'
                }
            ]
        },
        road: {
            elements: [
                // Debris on the carriageway goes down FIRST, so the frontage below covers
                // what lands on its ground instead of speckling its roofs.
                {
                    el: 'rubble',
                    x: 6,
                    y: 6,
                    w: 105,
                    h: 105,
                    n: 4
                },
                // Frontage. What makes a trunk read as a STREET rather than as a strip of
                // surfacing is the building line either side of it — and the recipe is
                // never told which way the road goes, so it puts a block against all four
                // edges and lets the roadway pick. The layout pass suppresses whatever
                // the road runs through: on a straight run that is the two edges it
                // enters and leaves by, leaving the other two facing each other across
                // the carriageway; on a bend it is the two sides it turns between,
                // leaving the outside of the corner built up. Same rule, no cases.
                //
                // Depth is set so a block stands where a road CAN reach and is dropped
                // when it does. A crossing swings up to EDGE_SWING (24) off centre, so
                // shrinking these until they always survive would leave a strip of open
                // ground between every building and the road it faces — a setback that
                // varies tile to tile and reads as waste. Deep blocks sit tight against
                // the carriageway instead, and where the road hugs one side that side's
                // block goes and the far one stands alone, which is what a street pushed
                // against a boundary actually looks like.
                //
                // The far pair is anchored at 80 rather than hard against the edge, and
                // the near pair at 8: a building is clamped 6 units short of the tile
                // edge, and the layout pass MIRRORS it, so one authored against the edge
                // is measured clamped and then drawn somewhere it is not — bigger than
                // the footprint it was cleared on, with the difference landing on the
                // road. Authored sizes are multiplied by buildingScale (1.3 at most), so
                // 80 + 24 x 1.3 = 111 keeps every one of these inside the clamp at both
                // ends of its mirror, and the two passes agree.
                //
                // Terraced, because a STREET is what this recipe is for. A free-standing
                // block set back behind a carriageway is a depot; a run of units flush
                // along it, sharing party walls, is a street, and the difference is the
                // whole reason a trunk tile exists. The run is authored to the same 8/80
                // anchors and the same depth as the blocks it replaces, so the clamp
                // arithmetic above is unchanged; only what stands on the frontage is.
                {
                    el: 'terrace',
                    chance: 0.85,
                    x: [
                        12,
                        21
                    ],
                    y: 8,
                    w: [
                        45,
                        57
                    ],
                    h: 24
                },
                {
                    el: 'terrace',
                    chance: 0.85,
                    x: [
                        12,
                        21
                    ],
                    y: 80,
                    w: [
                        45,
                        57
                    ],
                    h: 24
                },
                {
                    el: 'terrace',
                    chance: 0.85,
                    x: 8,
                    y: [
                        12,
                        21
                    ],
                    w: 24,
                    h: [
                        45,
                        57
                    ],
                    vert: 1
                },
                {
                    el: 'terrace',
                    chance: 0.85,
                    x: 80,
                    y: [
                        12,
                        21
                    ],
                    w: 24,
                    h: [
                        45,
                        57
                    ],
                    vert: 1
                },
                {
                    el: 'manhole',
                    chance: 0.5,
                    x: [
                        48,
                        72
                    ],
                    y: [
                        48,
                        72
                    ]
                },
                // Traffic is not in here: drawRoadside lays it against the carriageway off
                // the road's own samples, so it lies parallel to the road and on the
                // shoulder, on every tile the network runs through rather than only on
                // the trunk tiles this recipe draws.
                {
                    el: 'streetLamp',
                    x: {
                        pick: [
                            39,
                            78
                        ]
                    },
                    y: [
                        39,
                        81
                    ]
                }
            ]
        },
        // rest stops are untouched clearings, and they
        // sit in the greenest spots on the map (5x the region's tree density)
        water: {
            treeDensity: 5,
            elements: [
                {
                    el: 'pond'
                }
            ]
        },
        campsite: {
            treeDensity: 5,
            elements: [
                {
                    el: 'tent',
                    x: [
                        15,
                        24
                    ],
                    y: [
                        15,
                        24
                    ]
                },
                {
                    el: 'fireRing',
                    x: [
                        78,
                        90
                    ],
                    y: [
                        78,
                        90
                    ]
                },
                {
                    el: 'rect',
                    x: [
                        18,
                        30
                    ],
                    y: [
                        84,
                        96
                    ],
                    w: 18,
                    h: 6,
                    color: 'rust'
                },
                {
                    el: 'rect',
                    x: [
                        81,
                        96
                    ],
                    y: [
                        18,
                        27
                    ],
                    w: 6,
                    h: 15,
                    color: 'structDark'
                }
            ]
        },
        // Impassable because the ground itself has gone, not because something fell
        // over on it: a shaft or a rift opened here and there is no way across.
        // Collapsed slabs read as debris you could pick your way through, which is
        // exactly what these tiles are not.
        // The hole goes down LAST in every variant. Ground litter drawn over it is
        // debris hanging in mid-air above a drop; drawn under it, the hole swallows
        // whatever fell in and what survives reads as the edge of the collapse.
        // Each hole lays its own spoil around its rim afterwards.
        blocked: {
            variants: [
                {
                    elements: [
                        {
                            el: 'crack',
                            repeat: 4,
                            x: [
                                9,
                                105
                            ],
                            y: [
                                9,
                                96
                            ],
                            len: [
                                21,
                                36
                            ]
                        },
                        {
                            el: 'rubble',
                            x: 6,
                            y: 6,
                            w: 105,
                            h: 105,
                            n: 18
                        },
                        {
                            el: 'sinkhole',
                            x: [
                                51,
                                69
                            ],
                            y: [
                                51,
                                69
                            ],
                            r: [
                                33,
                                39
                            ]
                        },
                        {
                            el: 'darkWash',
                            alpha: 0.15
                        }
                    ]
                },
                {
                    elements: [
                        {
                            el: 'crack',
                            repeat: 3,
                            x: [
                                9,
                                105
                            ],
                            y: [
                                9,
                                96
                            ],
                            len: [
                                21,
                                36
                            ]
                        },
                        {
                            el: 'rubble',
                            x: 6,
                            y: 6,
                            w: 105,
                            h: 105,
                            n: 18
                        },
                        {
                            el: 'chasm',
                            x: [
                                54,
                                66
                            ],
                            y: [
                                48,
                                72
                            ],
                            len: [
                                96,
                                108
                            ],
                            r: [
                                18,
                                24
                            ]
                        },
                        {
                            el: 'darkWash',
                            alpha: 0.15
                        }
                    ]
                },
                {
                    elements: [
                        {
                            el: 'crack',
                            repeat: 3,
                            x: [
                                9,
                                105
                            ],
                            y: [
                                9,
                                96
                            ],
                            len: [
                                21,
                                36
                            ]
                        },
                        {
                            el: 'rubble',
                            x: 6,
                            y: 6,
                            w: 105,
                            h: 105,
                            n: 18
                        },
                        {
                            el: 'chasm',
                            x: [
                                48,
                                72
                            ],
                            y: [
                                54,
                                66
                            ],
                            len: [
                                96,
                                108
                            ],
                            r: [
                                18,
                                24
                            ],
                            vert: 1
                        },
                        {
                            el: 'darkWash',
                            alpha: 0.15
                        }
                    ]
                }
            ]
        }
    },
    // ===============================
    // SKILL ANCHORS
    // ===============================
    // A recipe says what kind of place a tile IS; the anchor says what the team
    // will be doing there. One per skill, chosen from the room's primary skill
    // and drawn ON TOP of the recipe — a power yard still reads as a power yard
    // and also shows its skill. Every skill is the primary of exactly four rooms
    // (see tests/data/skillBalance.test.js), so all fifteen of these are reachable.
    //
    // Same element vocabulary and same interpreter as recipes above, with two
    // differences: coordinates are PLATE-RELATIVE (0,0 is the anchor's own top
    // left, not the tile's), and w/h declare the reserved footprint, which must
    // stay within ANCHOR_MAX (24) so the anchor can never land on the connector
    // cross that joins tiles together.
    //
    // Every entry opens with an anchorPlate: it makes an anchor that overlaps a
    // roof read as apparatus installed there, which is what buys us out of doing
    // collision detection against the recipe. shape marks the faction — square
    // for Dominion, cut for Veil, round for Wilders.
    //
    // The anchor tracks the room's PRIMARY skill, not the event it will run —
    // and the two can disagree, because a room's event pool is primary plus
    // support. That is deliberate: a room runs one to four events, so keying the
    // anchor to any single one of them would mismatch the others regardless. The
    // primary is the only skill true for the whole room. (What does follow the
    // pinned event is the roof cutaway — see the environment field on events.)
    skillAnchors: {
        // ---- Dominion: systems and instrumentation ----
        'signal-relay': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24
                },
                {
                    el: 'tower',
                    x: 4,
                    y: 4
                }
            ]
        },
        'system-override': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24
                },
                {
                    el: 'rect',
                    x: 6,
                    y: 5,
                    w: 12,
                    h: 11,
                    color: 'struct'
                },
                {
                    el: 'rect',
                    x: 7,
                    y: 6,
                    w: 10,
                    h: 1,
                    color: 'structLight'
                },
                {
                    el: 'rect',
                    x: 8,
                    y: 8,
                    w: 8,
                    h: 5,
                    color: 'accent'
                },
                {
                    el: 'rect',
                    x: 11,
                    y: 16,
                    w: 2,
                    h: 5,
                    color: 'structDark'
                }
            ]
        },
        'drone-command': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24
                },
                {
                    el: 'dronePad',
                    x: 4,
                    y: 4,
                    s: 16
                }
            ]
        },
        'safeguard': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24
                },
                {
                    el: 'transformerPad',
                    x: 2,
                    y: 2
                }
            ]
        },
        'quantum-scan': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24
                },
                {
                    el: 'dish',
                    x: 12,
                    y: 12,
                    r: 7,
                    rings: 1,
                    arm: 1,
                    color: 'accent'
                }
            ]
        },
        // ---- Veil: access and concealment ----
        'lock-breach': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24,
                    shape: 'cut'
                },
                {
                    el: 'rect',
                    x: 4,
                    y: 4,
                    w: 16,
                    h: 16,
                    color: 'metal'
                },
                {
                    el: 'rect',
                    x: 4,
                    y: 4,
                    w: 16,
                    h: 1,
                    color: 'structLight'
                },
                {
                    el: 'rect',
                    x: 4,
                    y: 19,
                    w: 16,
                    h: 1,
                    color: 'structDark'
                },
                // hazard stripe: a bare metal square reads as nothing from above, and
                // this is the one thing that separates a sealed door from a floor plate
                {
                    el: 'rect',
                    x: 4,
                    y: 5,
                    w: 16,
                    h: 2,
                    color: 'accent',
                    alpha: 0.85
                },
                {
                    el: 'manhole',
                    x: 12,
                    y: 13
                },
                {
                    el: 'rect',
                    x: 3,
                    y: 8,
                    w: 2,
                    h: 3,
                    color: 'structDark'
                },
                {
                    el: 'rect',
                    x: 3,
                    y: 15,
                    w: 2,
                    h: 3,
                    color: 'structDark'
                }
            ]
        },
        'stealth-transit': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24,
                    shape: 'cut'
                },
                {
                    el: 'rect',
                    x: 5,
                    y: 5,
                    w: 3,
                    h: 14,
                    color: 'structDark'
                },
                {
                    el: 'rect',
                    x: 16,
                    y: 5,
                    w: 3,
                    h: 14,
                    color: 'structDark'
                },
                {
                    el: 'rect',
                    x: 5,
                    y: 6,
                    w: 3,
                    h: 1,
                    color: 'metal'
                },
                {
                    el: 'rect',
                    x: 16,
                    y: 6,
                    w: 3,
                    h: 1,
                    color: 'metal'
                },
                {
                    el: 'rect',
                    x: 8,
                    y: 11,
                    w: 8,
                    h: 2,
                    color: 'accent',
                    alpha: 0.7
                }
            ]
        },
        'echo-trace': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24,
                    shape: 'cut'
                },
                {
                    el: 'dish',
                    x: 12,
                    y: 12,
                    r: 3,
                    rings: 2,
                    color: 'accent'
                }
            ]
        },
        'signal-mask': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24,
                    shape: 'cut'
                },
                {
                    el: 'rect',
                    x: 6,
                    y: 9,
                    w: 12,
                    h: 9,
                    color: 'struct'
                },
                {
                    el: 'rect',
                    x: 6,
                    y: 9,
                    w: 12,
                    h: 1,
                    color: 'structLight'
                },
                {
                    el: 'rect',
                    x: 11,
                    y: 2,
                    w: 1,
                    h: 8,
                    color: 'metal'
                },
                {
                    el: 'speckle',
                    x: 3,
                    y: 3,
                    w: 18,
                    h: 18,
                    n: 10,
                    color: 'accent',
                    alpha: 0.35
                }
            ]
        },
        'transit-anchor': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24,
                    shape: 'cut'
                },
                {
                    el: 'crack',
                    x: 4,
                    y: 6,
                    len: 14
                },
                {
                    el: 'rect',
                    x: 4,
                    y: 10,
                    w: 16,
                    h: 5,
                    color: 'rust'
                },
                {
                    el: 'rect',
                    x: 4,
                    y: 10,
                    w: 16,
                    h: 1,
                    color: 'structLight'
                },
                {
                    el: 'rect',
                    x: 4,
                    y: 9,
                    w: 2,
                    h: 7,
                    color: 'metal'
                },
                {
                    el: 'rect',
                    x: 18,
                    y: 9,
                    w: 2,
                    h: 7,
                    color: 'metal'
                }
            ]
        },
        // ---- Wilders: growth, salvage and containment ----
        'reclamation': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24,
                    shape: 'round'
                },
                {
                    el: 'tank',
                    x: 12,
                    y: 13,
                    r: 8
                },
                {
                    el: 'foliage',
                    x: 16,
                    y: 8,
                    size: 3
                }
            ]
        },
        'growth-control': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24,
                    shape: 'round'
                },
                {
                    el: 'rect',
                    x: 4,
                    y: 5,
                    w: 16,
                    h: 14,
                    color: 'structDark'
                },
                {
                    el: 'rect',
                    x: 5,
                    y: 6,
                    w: 14,
                    h: 12,
                    color: 'ground1'
                },
                {
                    el: 'rect',
                    x: 6,
                    y: 8,
                    w: 12,
                    h: 2,
                    color: 'veg1'
                },
                {
                    el: 'rect',
                    x: 6,
                    y: 12,
                    w: 12,
                    h: 2,
                    color: 'veg2'
                },
                {
                    el: 'rect',
                    x: 6,
                    y: 16,
                    w: 12,
                    h: 1,
                    color: 'veg1'
                }
            ]
        },
        'wild-influence': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24,
                    shape: 'round'
                },
                {
                    el: 'dish',
                    x: 12,
                    y: 13,
                    r: 7,
                    rings: 1,
                    color: 'veg2'
                },
                {
                    el: 'rect',
                    x: 11,
                    y: 2,
                    w: 2,
                    h: 5,
                    color: 'structDark'
                }
            ]
        },
        'bio-shield': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24,
                    shape: 'round'
                },
                {
                    el: 'pipeline',
                    x: 2,
                    y: 6,
                    w: 20
                },
                {
                    el: 'tank',
                    x: 15,
                    y: 15,
                    r: 6
                }
            ]
        },
        'containment': {
            w: 24,
            h: 24,
            elements: [
                {
                    el: 'anchorPlate',
                    x: 0,
                    y: 0,
                    w: 24,
                    h: 24,
                    shape: 'round'
                },
                {
                    el: 'fence',
                    x: 2,
                    y: 2,
                    w: 20,
                    h: 20
                },
                {
                    el: 'barrier',
                    x: 3,
                    y: 17
                }
            ]
        }
    }
};



// Worker pool for parallel pathfinding
var $b8968b5a5b432368$var$pathfindingWorkers = [];
function $b8968b5a5b432368$export$a048d4b963a3f5ad() {
    var workerCode = "\n        function countStepsInPath(gridData, startPos, endPos, excludePath, returnPath, selectedPath) {\n            const queue = [{pos: startPos, steps: 0, visited: new Set()}];\n            const visited = new Set();\n\n            while (queue.length > 0) {\n                const {pos, steps, visited: pathVisited} = queue.shift();\n                const posKey = pos.row + ',' + pos.col;\n\n                if (visited.has(posKey)) continue;\n                visited.add(posKey);\n\n                if (pos.row === endPos.row && pos.col === endPos.col) {\n                    if (returnPath) {\n                        const path = new Set(pathVisited);\n                        path.add(posKey);\n                        return {steps, path};\n                    }\n                    return steps;\n                }\n\n                const directions = [{row: -1, col: 0}, {row: 1, col: 0}, {row: 0, col: -1}, {row: 0, col: 1}];\n\n                for (const dir of directions) {\n                    const newRow = pos.row + dir.row;\n                    const newCol = pos.col + dir.col;\n                    const newPosKey = newRow + ',' + newCol;\n\n                    if (newRow < 0 || newRow >= (gridData.rows || gridData.size) || newCol < 0 || newCol >= (gridData.cols || gridData.size)) continue;\n                    if (pathVisited.has(newPosKey)) continue;\n                    if (excludePath && excludePath.has(newPosKey) && !(newRow === endPos.row && newCol === endPos.col)) continue;\n\n                    const room = gridData.grid[newRow][newCol];\n                    if (!room || room.type === 'blocked') continue;\n                    if (room.type === 'exit' && !(newRow === endPos.row && newCol === endPos.col)) continue;\n\n                    const isInPath = selectedPath.some(p => p.row === newRow && p.col === newCol);\n                    if (isInPath && !(newRow === endPos.row && newCol === endPos.col)) continue;\n\n                    let newSteps = steps;\n                    if (room.type === 'gate' || room.type === 'hazard') {\n                        newSteps += 1;\n                    }\n\n                    const newVisited = new Set(pathVisited);\n                    newVisited.add(posKey);\n                    queue.push({pos: {row: newRow, col: newCol}, steps: newSteps, visited: newVisited});\n                }\n            }\n            return returnPath ? Infinity : Infinity;\n        }\n\n        function findMultiplePaths(gridData, startPos, endPos, excludePath, depth, selectedPath) {\n            const directions = [{row: -1, col: 0}, {row: 1, col: 0}, {row: 0, col: -1}, {row: 0, col: 1}];\n\n            function exploreFrom(pos, visited, stepsLeft, forcedStepCost) {\n                const paths = [];\n\n                if (pos.row === endPos.row && pos.col === endPos.col) {\n                    return [{steps: forcedStepCost, path: new Set(visited)}];\n                }\n\n                if (stepsLeft === 0) {\n                    const pathResult = countStepsInPath(gridData, pos, endPos, visited, true, selectedPath);\n                    if (pathResult !== Infinity) {\n                        visited.forEach(cell => pathResult.path.add(cell));\n                        pathResult.steps += forcedStepCost;\n                        paths.push(pathResult);\n                    }\n                    return paths;\n                }\n\n                for (const dir of directions) {\n                    const newRow = pos.row + dir.row;\n                    const newCol = pos.col + dir.col;\n                    const newKey = newRow + ',' + newCol;\n\n                    if (newRow < 0 || newRow >= (gridData.rows || gridData.size) || newCol < 0 || newCol >= (gridData.cols || gridData.size)) continue;\n                    const room = gridData.grid[newRow][newCol];\n                    if (!room || room.type === 'blocked') continue;\n                    if (visited.has(newKey)) continue;\n                    if (excludePath && excludePath.has(newKey)) continue;\n                    if (selectedPath.some(p => p.row === newRow && p.col === newCol)) continue;\n\n                    const stepCost = (room.type === 'gate' || room.type === 'hazard') ? 1 : 0;\n                    const newVisited = new Set(visited);\n                    newVisited.add(newKey);\n                    const subPaths = exploreFrom({row: newRow, col: newCol}, newVisited, stepsLeft - 1, forcedStepCost + stepCost);\n                    paths.push(...subPaths);\n                }\n                return paths;\n            }\n\n            const startKey = startPos.row + ',' + startPos.col;\n            return exploreFrom(startPos, new Set([startKey]), depth, 0);\n        }\n\n        function canReachRoomAndExit(currentPos, targetPos, exitPos, remainingSteps, targetRoom, gridData, selectedPath) {\n            const excludeForTargetPath = new Set();\n            \n            if (targetPos.row !== exitPos.row || targetPos.col !== exitPos.col) {\n                excludeForTargetPath.add(exitPos.row + ',' + exitPos.col);\n            }\n\n            const depth = remainingSteps <= 9 ? remainingSteps : 9;\n            const pathsToTarget = findMultiplePaths(gridData, currentPos, targetPos, excludeForTargetPath, depth, selectedPath);\n\n            if (pathsToTarget.length === 0) {\n                return { canReach: false };\n            }\n\n            const excludedFromSelectedPath = new Set();\n            selectedPath.forEach(step => {\n                excludedFromSelectedPath.add(step.row + ',' + step.col);\n            });\n\n            for (const pathToTarget of pathsToTarget) {\n                const stepsToReachTarget = pathToTarget.steps;\n                if (stepsToReachTarget > remainingSteps) continue;\n\n                const excludedForExitCheck = new Set(excludedFromSelectedPath);\n                pathToTarget.path.forEach(cell => excludedForExitCheck.add(cell));\n                excludedForExitCheck.delete(targetPos.row + ',' + targetPos.col);\n\n                const stepsFromTargetToExit = countStepsInPath(gridData, targetPos, exitPos, excludedForExitCheck, false, selectedPath);\n                const totalStepsNeeded = stepsToReachTarget + stepsFromTargetToExit;\n\n                if (stepsFromTargetToExit !== Infinity && totalStepsNeeded <= remainingSteps) {\n                    return { canReach: true };\n                }\n            }\n            return { canReach: false };\n        }\n\n        self.onmessage = function(e) {\n            const { gridData, currentPos, exitPos, remainingSteps, cellsToCheck, selectedPath, calculationId } = e.data;\n            const dimmedCells = [];\n\n            for (const cell of cellsToCheck) {\n                const { row, col, room } = cell;\n                const result = canReachRoomAndExit(currentPos, { row, col }, exitPos, remainingSteps, room, gridData, selectedPath);\n                if (!result.canReach) {\n                    dimmedCells.push({ row, col });\n                }\n            }\n\n            self.postMessage({ dimmedCells, calculationId });\n        };\n    ";
    var blob = new Blob([
        workerCode
    ], {
        type: 'application/javascript'
    });
    return new Worker(URL.createObjectURL(blob));
}
function $b8968b5a5b432368$export$efe69f901af7b3f6() {
    return $b8968b5a5b432368$var$pathfindingWorkers.length > 0;
}
function $b8968b5a5b432368$export$720bfee83fe27440() {
    var workerCount = navigator.hardwareConcurrency || 4;
    $b8968b5a5b432368$var$pathfindingWorkers = [];
    for(var i = 0; i < workerCount; i++)$b8968b5a5b432368$var$pathfindingWorkers.push($b8968b5a5b432368$export$a048d4b963a3f5ad());
}
function $b8968b5a5b432368$export$e25fa5fd5f04d38c() {
    return $b8968b5a5b432368$var$pathfindingWorkers;
}














// One-way channel from the raid's resolution code to the map, and the timing
// maths for what it draws.
//
// A skill check resolving is the raid's whole beat, and until now the map said
// nothing about it — the log scrolled and the tiles carried on as they were.
// `processSkillCheckEvent` knows the outcome, whether a synergy variant fired,
// who took the hit and what was salvaged; it posts that here, and the map picks
// it up on its next frame.
//
// A QUEUE rather than a callback, for two reasons. The resolution code is
// headless — it runs in the simulator and under vitest with no renderer at all
// — so it must not hold a reference to one. And the map animates at 12fps while
// the raid loop ticks at 1Hz, so the two are never in the same call stack
// anyway. Nothing here touches the DOM.
/**
 * How long each effect lives, in ms.
 *
 * A synergy runs longest because it has the most to say and is the rarest
 * thing on the list; a failure is the shortest because it is a flinch. All of
 * them are well under the ~1s the raid loop takes to move on, so effects
 * belong to the beat that caused them rather than smearing across the next.
 */ var $cf1d0720eef4c612$export$af2bc5480524a085 = {
    success: 900,
    synergy: 1400,
    failure: 700,
    loot: 1100
};
// The queue is bounded because nothing guarantees anyone drains it: a raid run
// in the simulator, or with the Field screen closed, posts effects that will
// never be drawn. Dropping the OLDEST is deliberate — if the map does come
// back, the newest handful is what it should be showing.
var $cf1d0720eef4c612$var$QUEUE_CAP = 24;
var $cf1d0720eef4c612$var$queue = [];
function $cf1d0720eef4c612$export$5b7d16983d60107d(kind) {
    var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!$cf1d0720eef4c612$export$af2bc5480524a085[kind]) return null;
    var _opts_memberId, _opts_nowMs;
    var fx = {
        kind: kind,
        memberId: (_opts_memberId = opts.memberId) !== null && _opts_memberId !== void 0 ? _opts_memberId : null,
        rarity: opts.rarity || null,
        startMs: ((_opts_nowMs = opts.nowMs) !== null && _opts_nowMs !== void 0 ? _opts_nowMs : Date.now()) + (opts.delayMs || 0),
        ttl: $cf1d0720eef4c612$export$af2bc5480524a085[kind],
        // Decorrelates one effect's sparks from the next's without a per-frame
        // random, which would make them shimmer instead of move.
        seed: $cf1d0720eef4c612$var$queue.length * 2654435761 + (opts.memberId ? String(opts.memberId).length * 40503 : 0) >>> 0
    };
    $cf1d0720eef4c612$var$queue.push(fx);
    if ($cf1d0720eef4c612$var$queue.length > $cf1d0720eef4c612$var$QUEUE_CAP) $cf1d0720eef4c612$var$queue.splice(0, $cf1d0720eef4c612$var$queue.length - $cf1d0720eef4c612$var$QUEUE_CAP);
    return fx;
}
function $cf1d0720eef4c612$export$e81dc0d2f0f0a3e4() {
    if (!$cf1d0720eef4c612$var$queue.length) return [];
    var out = $cf1d0720eef4c612$var$queue;
    $cf1d0720eef4c612$var$queue = [];
    return out;
}
function $cf1d0720eef4c612$export$fd4b5295b61ee6bc() {
    $cf1d0720eef4c612$var$queue = [];
}
function $cf1d0720eef4c612$export$f82af1eaff316176(fx, nowMs) {
    return (nowMs - fx.startMs) / fx.ttl;
}
function $cf1d0720eef4c612$export$4eb22852cf19c442(list, nowMs) {
    return (list || []).filter(function(fx) {
        return $cf1d0720eef4c612$export$f82af1eaff316176(fx, nowMs) < 1;
    });
}
var $cf1d0720eef4c612$export$2ff71a728686ddfb = function(p) {
    return p < 0 ? 0 : p >= 1 ? 0 : Math.pow(1 - p, 1.8);
};
var $cf1d0720eef4c612$export$b822c8d32c815bfc = function(p) {
    return p < 0 ? 0 : p >= 1 ? 1 : 1 - Math.pow(1 - p, 2.4);
};


function $52a7294453bdb6d1$export$5c6c29dc14ccb545(room, state) {
    var _state_currentRaid;
    if (!((_state_currentRaid = state.currentRaid) === null || _state_currentRaid === void 0 ? void 0 : _state_currentRaid.raidInProgress)) return;
    // Create unified events object if it doesn't exist
    if (!state.currentRaid.raidInProgress.events) state.currentRaid.raidInProgress.events = {
        skillCheckEvents: [],
        bonusLootEvent: null,
        fishingEvent: null
    };
    // Initialize based on room type
    if (room.type === 'water') // Water room: initialize fishing only
    $52a7294453bdb6d1$var$initializeFishingEvent(room, state);
    else if (room.type === 'gate' || room.type === 'hazard') {
        // Gate/hazard room: initialize skill-check events + conditional bonus loot
        $52a7294453bdb6d1$export$f778e7c4dbbbd49b(room, state);
        $52a7294453bdb6d1$export$3e2a422d19cb46bc(room, state);
    }
    (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).events, "Events initialized for ".concat(room.type, " room"));
}
function $52a7294453bdb6d1$export$3d092dd9a898451d(eventData, roomIndex, state, team) {
    var event = eventData.event;
    if (!(event === null || event === void 0 ? void 0 : event.variants) || event.variants.length === 0) return;
    // The SAME variant that will resolve this event. This used to hardcode
    // variants[0], so a team carrying the right cross-faction tool was told about
    // one problem and then read a resolution to a different one — and the 90
    // problem statements on the synergy variants were never shown to anyone.
    var variant = $52a7294453bdb6d1$export$c7f3781b6ac25bb8(event, state, team).variant;
    if (!variant) return;
    var problemText = $52a7294453bdb6d1$export$dedbe468d8b2fc6c(variant.problem, event, variant);
    var skillName = (0, $ca7af38ea7b7b4a8$export$182937d2e68a339)(event.relatedSkillId);
    var primaryTechniqueName = (0, $ca7af38ea7b7b4a8$export$b7fbae54a8f17db)(event.relatedTechniqueId);
    var techniqueIcon = (0, $ca7af38ea7b7b4a8$export$bf5389e28ce4699d)(event.relatedTechniqueId);
    (0, $8bda0cb20f0b197d$export$fd59807889add359)("\u26A0\uFE0F ".concat(skillName, ": ").concat(techniqueIcon, " ").concat(primaryTechniqueName, ' Needed <div class="event-problem-text">').concat(problemText, "</div>"), 'warning', {
        stepIndex: roomIndex,
        notificationMessage: "\u26A0\uFE0F ".concat(skillName, " - ").concat(variant.title) // Show toast notification
    });
    (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).events, "Event problem triggered: ".concat(variant.title));
}
function $52a7294453bdb6d1$export$851890b870f423fa(state) {
    var _state_currentRaid_raidInProgress, _state_currentRaid, _events_skillCheckEvents;
    if (!((_state_currentRaid = state.currentRaid) === null || _state_currentRaid === void 0 ? void 0 : (_state_currentRaid_raidInProgress = _state_currentRaid.raidInProgress) === null || _state_currentRaid_raidInProgress === void 0 ? void 0 : _state_currentRaid_raidInProgress.events)) return {
        skillCheckCount: 0,
        hasBonusLoot: false
    };
    var events = state.currentRaid.raidInProgress.events;
    var skillCheckCount = ((_events_skillCheckEvents = events.skillCheckEvents) === null || _events_skillCheckEvents === void 0 ? void 0 : _events_skillCheckEvents.length) || 0;
    var hasBonusLoot = !!events.bonusLootEvent;
    return {
        skillCheckCount: skillCheckCount,
        hasBonusLoot: hasBonusLoot
    };
}
function $52a7294453bdb6d1$export$a1ce0db419e3821f(tier, rarity) {
    var _config_progressionScaling_bonusEventCascadeMultipliers, _config_progressionScaling;
    var tierMultipliers = (_config_progressionScaling = $979b99378be707cd$export$9f9786ac427715c7) === null || _config_progressionScaling === void 0 ? void 0 : (_config_progressionScaling_bonusEventCascadeMultipliers = _config_progressionScaling.bonusEventCascadeMultipliers) === null || _config_progressionScaling_bonusEventCascadeMultipliers === void 0 ? void 0 : _config_progressionScaling_bonusEventCascadeMultipliers[tier];
    if (tierMultipliers == null) return 1.0;
    if (typeof tierMultipliers === 'number') return tierMultipliers;
    var _tierMultipliers_rarity;
    return (_tierMultipliers_rarity = tierMultipliers[rarity]) !== null && _tierMultipliers_rarity !== void 0 ? _tierMultipliers_rarity : 1.0;
}
function $52a7294453bdb6d1$export$8f7497017a33a708(tier, room) {
    var expectedEvents = room.type === 'hazard' ? 1.5 : 3; // midpoints of 1-2 and 2-4
    var directChance = function(rarity) {
        var perEvent = (0, $8bda0cb20f0b197d$export$d2ef23ef6c7c6dd5)(rarity, tier, room.type);
        return 1 - Math.pow(1 - perEvent, expectedEvents);
    };
    var cascadeStep = function(rarity) {
        return Math.min((0, $8bda0cb20f0b197d$export$d2ef23ef6c7c6dd5)(rarity, tier, room.type) * $52a7294453bdb6d1$export$a1ce0db419e3821f(tier, rarity), 1);
    };
    // Bonus cascade chain probabilities (bonus event itself awards common outright)
    var bonusRare = cascadeStep('rare');
    var bonusEpic = bonusRare * cascadeStep('epic');
    var bonusLegendary = bonusEpic * cascadeStep('legendary');
    var bonusUnique = bonusLegendary * cascadeStep('unique');
    var combine = function(direct, viaBonus) {
        return 1 - (1 - direct) * (1 - viaBonus);
    };
    return {
        common: directChance('common'),
        uncommon: directChance('uncommon'),
        rare: combine(directChance('rare'), bonusRare),
        epic: bonusEpic,
        legendary: bonusLegendary,
        unique: bonusUnique
    };
}
function $52a7294453bdb6d1$export$3645ad137fdaf2f9(state) {
    var _state_currentRaid_raidInProgress, _state_currentRaid, _events_skillCheckEvents;
    if (!((_state_currentRaid = state.currentRaid) === null || _state_currentRaid === void 0 ? void 0 : (_state_currentRaid_raidInProgress = _state_currentRaid.raidInProgress) === null || _state_currentRaid_raidInProgress === void 0 ? void 0 : _state_currentRaid_raidInProgress.events)) return;
    var events = state.currentRaid.raidInProgress.events;
    // Cleanup skill-check events
    if (((_events_skillCheckEvents = events.skillCheckEvents) === null || _events_skillCheckEvents === void 0 ? void 0 : _events_skillCheckEvents.length) > 0) events.skillCheckEvents = [];
    // Cleanup bonus loot event
    if (events.bonusLootEvent) $52a7294453bdb6d1$export$adaa23be627dd8c9(state);
    // Cleanup fishing event
    if (events.fishingEvent) $52a7294453bdb6d1$var$cleanupFishingEvent(state);
}
function $52a7294453bdb6d1$export$fe4b77ffe9a80e97(state) {
    var _state_currentRaid_raidInProgress, _state_currentRaid, _events_skillCheckEvents, _events_bonusLootEvent, _events_fishingEvent;
    if (!((_state_currentRaid = state.currentRaid) === null || _state_currentRaid === void 0 ? void 0 : (_state_currentRaid_raidInProgress = _state_currentRaid.raidInProgress) === null || _state_currentRaid_raidInProgress === void 0 ? void 0 : _state_currentRaid_raidInProgress.events)) return {
        skillCheckEvents: 0,
        bonusLoot: false,
        fishing: false
    };
    var events = state.currentRaid.raidInProgress.events;
    var skillCheckSummary = (events.skillCheckEvents || []).reduce(function(acc, e) {
        return (0, $715bf31211e65705$export$71511d61b312f219)((0, $fa9769297b8a68c8$export$71511d61b312f219)({}, acc), (0, $ec426015f75d7738$export$71511d61b312f219)({}, e.status, (acc[e.status] || 0) + 1));
    }, {});
    return {
        skillCheckEvents: ((_events_skillCheckEvents = events.skillCheckEvents) === null || _events_skillCheckEvents === void 0 ? void 0 : _events_skillCheckEvents.length) || 0,
        skillCheckStatus: skillCheckSummary,
        bonusLoot: !!((_events_bonusLootEvent = events.bonusLootEvent) === null || _events_bonusLootEvent === void 0 ? void 0 : _events_bonusLootEvent.scheduled),
        fishing: ((_events_fishingEvent = events.fishingEvent) === null || _events_fishingEvent === void 0 ? void 0 : _events_fishingEvent.active) || false
    };
}
function $52a7294453bdb6d1$export$a2efc3d0c71d9b81(state, team) {
    var _state_currentRaid_raidInProgress, _state_currentRaid, _raid_events_skillCheckEvents, _raid_events_fishingEvent;
    if (!((_state_currentRaid = state.currentRaid) === null || _state_currentRaid === void 0 ? void 0 : (_state_currentRaid_raidInProgress = _state_currentRaid.raidInProgress) === null || _state_currentRaid_raidInProgress === void 0 ? void 0 : _state_currentRaid_raidInProgress.events)) return;
    var raid = state.currentRaid.raidInProgress;
    var currentTime = Date.now() - (raid.roomStartTime || Date.now());
    // Skill-check events run in two phases: 'start' shows the problem, 'end'
    // resolves it. Return at most ONE transition per tick, resolving a finished
    // event before ever starting a new one, and never starting one while another
    // is in progress. This serializes events so a new one cannot begin before the
    // previous has finished - the old code kept the LAST due transition from a
    // forEach and flipped every due event to 'started', so when an event's end
    // and a later event's start fell in the same tick (a frame gap, e.g. after the
    // tab was backgrounded) the start pre-empted the end and the events overlapped.
    if (((_raid_events_skillCheckEvents = raid.events.skillCheckEvents) === null || _raid_events_skillCheckEvents === void 0 ? void 0 : _raid_events_skillCheckEvents.length) > 0) {
        var events = raid.events.skillCheckEvents;
        // 1) Resolve the earliest event whose duration has elapsed.
        var toEnd = null;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = events[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var e = _step.value;
                if (e.status === 'started' && currentTime >= e.scheduledTimeMs + e.thisEventDurationMs) {
                    if (!toEnd || e.scheduledTimeMs + e.thisEventDurationMs < toEnd.scheduledTimeMs + toEnd.thisEventDurationMs) toEnd = e;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (toEnd) return {
            eventLifeCycle: 'end',
            eventType: 'skillCheck',
            eventData: toEnd
        };
        // 2) Start the earliest due event, but only when none is still in progress.
        var anyInProgress = events.some(function(e) {
            return e.status === 'started';
        });
        if (!anyInProgress) {
            var toStart = null;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = events[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var e1 = _step1.value;
                    if (e1.status === 'pending' && currentTime >= e1.scheduledTimeMs) {
                        if (!toStart || e1.scheduledTimeMs < toStart.scheduledTimeMs) toStart = e1;
                    }
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            if (toStart) {
                toStart.status = 'started';
                return {
                    eventLifeCycle: 'start',
                    eventType: 'skillCheck',
                    eventData: toStart
                };
            }
        }
    }
    // Process bonus loot event (only if all skill checks passed)
    if (raid.events.bonusLootEvent) {
        var bonusEvent = raid.events.bonusLootEvent;
        if (bonusEvent.scheduled && !bonusEvent.triggered && $52a7294453bdb6d1$export$edf2a8e4414546a8(state) && currentTime >= bonusEvent.scheduledTimeMs) return {
            eventLifeCycle: 'start',
            eventType: 'bonusLoot',
            eventData: null
        };
    }
    // Process fishing event (water rooms only)
    if ((_raid_events_fishingEvent = raid.events.fishingEvent) === null || _raid_events_fishingEvent === void 0 ? void 0 : _raid_events_fishingEvent.active) {
        var fishingEvent = raid.events.fishingEvent;
        if (!fishingEvent.targetActive && Date.now() >= fishingEvent.nextFishTime) return {
            eventLifeCycle: 'start',
            eventType: 'fishing',
            eventData: null
        };
    }
}
// ============================================================================
// Skill-Check Events
// ============================================================================
/**
 * Get all available events for a room based on primary and support skills
 * @param {Object} room - Room object
 * @param {Object} state - gameState object
 * @returns {Array} Array of event definitions matching room skills
 */ // Memoized on the room's skills, which is all the pool depends on — `state`
// is declared for call-site symmetry and has never been read. Worth caching
// because pre-rolling now calls this once per room at grid generation, and the
// simulator builds up to three candidate grids per raid.
var $52a7294453bdb6d1$var$eventPoolCache = new Map();
function $52a7294453bdb6d1$export$e0c93437f7880972(room, state) {
    var key = "".concat(room.primary, "|").concat((room.support || []).join(','));
    var cached = $52a7294453bdb6d1$var$eventPoolCache.get(key);
    if (cached) return cached;
    var allEvents = (0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$f152896064e09913).concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$9435522665f2dda4), (0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$1cd1fab9b9844b76));
    // Build set of relevant skill IDs (primary + support)
    var relevantSkills = new Set([
        room.primary
    ].concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)(room.support || [])));
    // Filter events matching any relevant skill
    var pool = allEvents.filter(function(event) {
        return relevantSkills.has(event.relatedSkillId || event.favoredSkill);
    });
    $52a7294453bdb6d1$var$eventPoolCache.set(key, pool);
    return pool;
}
function $52a7294453bdb6d1$export$1408911de9ef605d(id) {
    for(var _i = 0, _iter = [
        $979b99378be707cd$export$f152896064e09913,
        $979b99378be707cd$export$9435522665f2dda4,
        $979b99378be707cd$export$1cd1fab9b9844b76
    ]; _i < _iter.length; _i++){
        var list = _iter[_i];
        var found = list.find(function(e) {
            return e.id === id;
        });
        if (found) return found;
    }
    return null;
}
function $52a7294453bdb6d1$export$81e7862f0868f5bc(grid) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator = (grid || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
            var row = _step.value;
            try {
                for(var _iterator1 = (row || [])[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                    var room = _step1.value;
                    if (!room || room.type !== 'gate' && room.type !== 'hazard') continue;
                    var pool = $52a7294453bdb6d1$export$e0c93437f7880972(room);
                    if (!pool.length) continue;
                    // the un-multiplied ceiling for this room type; a blackout raid that
                    // wants more rolls the extras fresh
                    var most = room.type === 'hazard' ? 2 : 4;
                    var ids = [];
                    var lastIdx = -1;
                    for(var i = 0; i < most; i++){
                        var idx = Math.floor(Math.random() * pool.length);
                        // no two in a row the same, when the pool is big enough to avoid it
                        if (pool.length > 1) while(idx === lastIdx)idx = Math.floor(Math.random() * pool.length);
                        ids.push(pool[idx].id);
                        lastIdx = idx;
                    }
                    room.plannedEventIds = ids;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return grid;
}
function $52a7294453bdb6d1$export$f778e7c4dbbbd49b(room, state) {
    // Get available events for this room
    var availableEvents = $52a7294453bdb6d1$export$e0c93437f7880972(room, state);
    if (availableEvents.length === 0) {
        console.warn("No events available for room with primary skill: ".concat(room.primary));
        state.currentRaid.raidInProgress.events.skillCheckEvents = [];
        return;
    }
    // Randomly determine event count (1-2 for hazards, 2-4 for gates)
    var eventCountRange = room.type === 'hazard' ? [
        1,
        2
    ] : [
        2,
        4
    ];
    // Overclocked Grid doubles the RANGE, not the roll: doubling afterwards would
    // turn a 1 into a 2 and a 4 into an 8, compressing the low end and blowing
    // out the high one. Scaling the bounds keeps the distribution's shape.
    var rateMultiplier = (0, $686e361e5cd4549d$export$a2c94bc2dc5c01e1)('eventChanceMultiplier', 1);
    var scaled = eventCountRange.map(function(n) {
        return Math.round(n * rateMultiplier);
    });
    var eventCount = scaled[0] + Math.floor(Math.random() * (scaled[1] - scaled[0] + 1));
    // Take the events the grid already committed to (see preRollGridEvents), so
    // the encounter matches what the map has been showing since the grid was
    // drawn. A raid generated before pre-rolling existed — or one whose blackout
    // multiplier asks for more events than were pinned — rolls the remainder
    // here, which is also the whole of the old behaviour.
    var planned = (room.plannedEventIds || []).map($52a7294453bdb6d1$export$1408911de9ef605d).filter(Boolean);
    var selectedEvents = planned.slice(0, eventCount);
    var lastEventIdx = selectedEvents.length ? availableEvents.indexOf(selectedEvents[selectedEvents.length - 1]) : -1;
    while(selectedEvents.length < eventCount){
        var thisEventIdx = Math.floor(Math.random() * availableEvents.length);
        // the anti-repeat guard used to roll a THIRD index for the push, so it
        // never actually prevented a repeat; the drawn index is the one used now
        if (availableEvents.length > 1) while(thisEventIdx === lastEventIdx)thisEventIdx = Math.floor(Math.random() * availableEvents.length);
        selectedEvents.push(availableEvents[thisEventIdx]);
        lastEventIdx = thisEventIdx;
    }
    // Calculate room duration in seconds
    var jitterPercent = 0.1; // ±10%
    var roomDurationSec = (room.baseDuration > 0 ? room.baseDuration - 15 : 0) * (1 - jitterPercent * eventCount); //account for bonus event in last 15sec
    // Schedule events at semi-random intervals (2 events/min ≈ 30s spacing)
    // Evenly space them across room duration with ±10% jitter
    var eventDurationMs = roomDurationSec / eventCount * 1000;
    var prevEventEndTimeMs = -1;
    var scheduledEvents = selectedEvents.map(function(event, index) {
        var thisEventDurationMs = eventDurationMs;
        var jitterMs = Math.random() * thisEventDurationMs * jitterPercent;
        var scheduledTimeMs = index * thisEventDurationMs + jitterMs;
        if (prevEventEndTimeMs > -1 && scheduledTimeMs < prevEventEndTimeMs) scheduledTimeMs = prevEventEndTimeMs + 1000;
        if (scheduledTimeMs + thisEventDurationMs > (room.baseDuration > 0 ? room.baseDuration - 15 : 0) * 1000) thisEventDurationMs = thisEventDurationMs - (scheduledTimeMs - (room.baseDuration > 0 ? room.baseDuration - 15 : 0) * 1000);
        prevEventEndTimeMs = scheduledTimeMs + thisEventDurationMs;
        return {
            event: event,
            scheduledTimeMs: scheduledTimeMs,
            thisEventDurationMs: thisEventDurationMs,
            status: 'pending',
            index: index
        };
    });
    state.currentRaid.raidInProgress.events.skillCheckEvents = scheduledEvents;
    state.currentRaid.raidInProgress.hasSkillEventFailure = false;
    (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).events, "Scheduled ".concat(eventCount, " skill-check events for room"), {
        roomType: room.type,
        eventCount: eventCount,
        baseDuration: room.baseDuration,
        scheduledTimes: scheduledEvents.map(function(e) {
            return (e.scheduledTimeMs / 1000).toFixed(1) + 's';
        })
    });
}
function $52a7294453bdb6d1$export$7408e7aadd9fb0b0(eventData, state, room, team) {
    var _getEffect, // Training Node Deck: only when this room actually has support skills
    _room_support, _this;
    var event = eventData.event;
    var currentRoomIndex = state.currentRaid.raidInProgress.currentRoomIndex;
    var tier = state.currentRaid.currentRaidGrid.tier;
    // Step 1: Get team skill levels
    var teamSkills = {};
    team.forEach(function(member) {
        Object.entries(member.skills || {}).forEach(function(param) {
            var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), skillId = _param[0], level = _param[1];
            teamSkills[skillId] = Math.max(teamSkills[skillId] || 0, level);
        });
    });
    // Step 2 + 3: Select the best available variant (synergy variants need the
    // right cross-faction tool in someone's kit; priority variant[1] > [2] >
    // primary). Shared with logEventProblem so the problem the player was shown
    // and the outcome they get are the same scenario — see resolveEventVariant.
    // The +10% device success bonus below is the gear layer - never gated.
    var _resolveEventVariant = $52a7294453bdb6d1$export$c7f3781b6ac25bb8(event, state, team), variant = _resolveEventVariant.variant, availableTechniques = _resolveEventVariant.availableTechniques;
    if (!variant) {
        console.warn("Could not select variant for event ".concat(event.id));
        return {
            success: false,
            variant: null,
            loot: [],
            damage: 0,
            casualties: []
        };
    }
    // Step 4: Resolve outcome. Flat chance bonuses stack inside the 97% clamp:
    // - device gear bonus when the event's primary technique is tooled up
    // - the equipped skill artifact when it matches the event's skill
    // - the Crosslink Amplifier when a synergy variant actually fired
    var gearBonus = availableTechniques.includes(event.relatedTechniqueId) ? (((_getEffect = (0, $ca7af38ea7b7b4a8$export$96671014a1dabc4c)('technique-success-bonus')) === null || _getEffect === void 0 ? void 0 : _getEffect.value) || 0) / 100 : 0;
    var artifactBonus = (0, $df8a44d92d572a5c$export$a5a257639bbcfa93)(event.relatedSkillId || event.favoredSkill, state.character) / 100 + (variant.variantIndex > 0 ? (0, $df8a44d92d572a5c$export$401b195eeeb2d82c)('faction-synergy-bonus', state.character) / 100 : 0) + (((_room_support = room.support) === null || _room_support === void 0 ? void 0 : _room_support.length) > 0 ? (0, $df8a44d92d572a5c$export$401b195eeeb2d82c)('support-skill-bonus', state.character) / 100 : 0);
    var outcome = $52a7294453bdb6d1$export$6f562e7d3f793247(event, variant, teamSkills, tier, room, gearBonus + artifactBonus);
    // Who the map should play this on. The check resolves against the team's
    // BEST level in the event's skill, so the member holding that level is the
    // one who ran it — which is the honest answer and also the one the player
    // would name if you asked them.
    var actor = $52a7294453bdb6d1$export$6c65f1aff219e169(event.relatedSkillId || event.favoredSkill, team);
    // Step 5a: If success - generate loot based on rarity drops (like bonus loot)
    var eventLoot = [];
    // Whoever the failure actually landed on, for the map. Declared out here
    // because the damage result is scoped to the failure branch.
    var hitMember = null;
    if (outcome.success) {
        var _loop = function(_i, _iter) {
            var rarity = _iter[_i];
            var pool = fullLootPool.filter(function(itemId) {
                var _findItem;
                return ((_findItem = (0, $ca7af38ea7b7b4a8$export$a2dea178c28a0308)('id', itemId)) === null || _findItem === void 0 ? void 0 : _findItem.rarity) === rarity;
            });
            if (pool.length === 0) return "continue";
            if (rarity !== 'common' && Math.random() >= (0, $8bda0cb20f0b197d$export$d2ef23ef6c7c6dd5)(rarity, tier, room.type)) return "continue";
            var picked = (0, $8bda0cb20f0b197d$export$2cbb40695b9e7336)(pool);
            if (picked) {
                eventLoot.push(picked);
                return "break";
            }
        };
        // Generate skill-check event loot using rarity-based drops (common, uncommon, and rare).
        // The pool is filtered to the rolled rarity - the skill's loot pool bottoms out in
        // commons, and an unfiltered pick made every rarity roll shovel mostly commons.
        var eventRarities = [
            'common',
            'uncommon',
            'rare'
        ];
        var fullLootPool = $52a7294453bdb6d1$export$6f1a1ae8eddfba2c(event, state);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop1 = function() {
                var rarity = _step.value;
                var dropChance = (0, $8bda0cb20f0b197d$export$d2ef23ef6c7c6dd5)(rarity, tier, room.type);
                if (Math.random() < dropChance) {
                    var lootPool = fullLootPool.filter(function(itemId) {
                        var _findItem;
                        return ((_findItem = (0, $ca7af38ea7b7b4a8$export$a2dea178c28a0308)('id', itemId)) === null || _findItem === void 0 ? void 0 : _findItem.rarity) === rarity;
                    });
                    if (lootPool.length > 0) {
                        // Get quantity range for this rarity (utility artifacts can boost)
                        var quantityRange = (0, $8bda0cb20f0b197d$export$540736c4d7813ac)(rarity, tier, room.type);
                        var quantity = $52a7294453bdb6d1$export$65439b695d7608c2(typeof quantityRange === 'number' ? quantityRange : Math.round(Math.random() * (quantityRange.max - quantityRange.min)) + quantityRange.min, room, state.character);
                        // Select items from skill-specific loot pool, weighted by per-item drop weights
                        for(var q = 0; q < quantity && lootPool.length > 0; q++){
                            var picked = (0, $8bda0cb20f0b197d$export$2cbb40695b9e7336)(lootPool);
                            if (picked) eventLoot.push(picked);
                        }
                    }
                }
            };
            for(var _iterator = eventRarities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop1();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        // Synergy bonus: a synergy variant's combined approach recovers one
        // extra guaranteed salvage pick - rare/uncommon at their normal odds,
        // falling back to a common so the jackpot never comes up empty
        if (variant.variantIndex > 0) for(var _i = 0, _iter = [
            'rare',
            'uncommon',
            'common'
        ]; _i < _iter.length; _i++){
            var _ret = _loop(_i, _iter);
            if (_ret === "break") break;
        }
    } else {
        var raid = state.currentRaid.raidInProgress;
        var hazardReduction = room.type === 'hazard' ? (0, $df8a44d92d572a5c$export$401b195eeeb2d82c)('hazard-damage-reduction', state.character) : 0;
        var canPreventKnockout = (0, $df8a44d92d572a5c$export$401b195eeeb2d82c)('knockout-prevention', state.character) > 0 && !raid.knockoutPrevented;
        var damageResult = $52a7294453bdb6d1$export$8c917c953701923b(tier, team, {
            damageMultiplier: 1 - hazardReduction / 100,
            preventKnockout: canPreventKnockout
        });
        (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).events, "DAMAGED", damageResult.damage);
        eventData.damage = damageResult.damage;
        eventData.casualties = damageResult.casualties;
        hitMember = damageResult.member;
        raid.hasSkillEventFailure = true;
        if (damageResult.knockoutPrevented) {
            raid.knockoutPrevented = true;
            (0, $8bda0cb20f0b197d$export$fd59807889add359)("\uD83D\uDEE1\uFE0F ".concat(damageResult.member.name, " is stabilized at the brink \u2014 the injector fires before they fall!"), 'bonus', {
                stepIndex: currentRoomIndex,
                notificationMessage: "\uD83D\uDEE1\uFE0F ".concat(damageResult.member.name, " stabilized")
            });
        }
    }
    // The map's version of the same news. Posted here rather than off the log
    // messages below, because a log line is prose and this has to key off what
    // actually happened: a synergy variant is `variantIndex > 0`, and a failure
    // is played on whoever took the hit, not on whoever ran the check.
    if (outcome.success) (0, $cf1d0720eef4c612$export$5b7d16983d60107d)(variant.variantIndex > 0 ? 'synergy' : 'success', {
        memberId: actor === null || actor === void 0 ? void 0 : actor.id
    });
    else (0, $cf1d0720eef4c612$export$5b7d16983d60107d)('failure', {
        memberId: (_this = hitMember !== null && hitMember !== void 0 ? hitMember : actor) === null || _this === void 0 ? void 0 : _this.id
    });
    // Step 6: Show UI message with technique name substitutions
    var messageText = $52a7294453bdb6d1$export$dedbe468d8b2fc6c(outcome.success ? variant.success || 'Event succeeded!' : variant.fail || 'Event failed!', event, variant);
    // Marker and title OUTSIDE the flavour span, matching logEventProblem's
    // shape: the header is what happened, the prose is what it felt like. They
    // shared one span until the prose was styled down, which would have taken
    // the tick or the cross down with it.
    (0, $8bda0cb20f0b197d$export$fd59807889add359)("".concat(outcome.success ? "\u2713" : "\u2717", " ").concat(variant.title, '<div class="event-outcome-text">').concat(messageText, "</div>"), outcome.success ? 'success' : 'failure', {
        stepIndex: currentRoomIndex,
        notificationMessage: "".concat(outcome.success ? "\u2713" : "\u2717", " ").concat(variant.title)
    });
    // Step 6a: On success, celebrate a fired synergy variant and auto-deploy
    // a technique consumable (if carried)
    if (outcome.success) {
        if (variant.variantIndex > 0 && variant.synergyTechniqueId) {
            var synergyTechniqueName = (0, $ca7af38ea7b7b4a8$export$b7fbae54a8f17db)(variant.synergyTechniqueId);
            (0, $8bda0cb20f0b197d$export$fd59807889add359)("\u26A1 Synergy: ".concat(synergyTechniqueName, " amplifies the approach \u2014 extra salvage recovered!"), 'bonus', {
                stepIndex: currentRoomIndex,
                notificationMessage: "\u26A1 Synergy: ".concat(synergyTechniqueName)
            });
        }
        $52a7294453bdb6d1$export$2ebfe836f4eff9d2(event, state, room);
    }
    // Step 6b: Award loot and credits on success
    if (outcome.success && eventLoot.length > 0) {
        // Group loot by item ID to show quantities
        var lootMap = {};
        eventLoot.forEach(function(item) {
            lootMap[item] = (lootMap[item] || 0) + 1;
        });
        // Award loot and display messages
        var lootMessage = '';
        Object.entries(lootMap).forEach(function(param, idx) {
            var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), itemId = _param[0], amount = _param[1];
            var _findItem;
            (0, $8bda0cb20f0b197d$export$d2188f6548dbea9f)(state.currentRaid.raidInProgress.lootGained, itemId, amount);
            var itemName = (0, $ca7af38ea7b7b4a8$export$31330438f6059b08)(itemId);
            lootMessage += (idx == 0 ? '' : ', ') + "".concat(amount, "x ").concat(itemName);
            // One mote per distinct find, held back a beat each so a good haul
            // arrives as a run of finds rather than a single flash. The rarity is
            // what the mote is coloured by, which is the whole point of showing it
            // on the map at all: a rare coming up looks different from a common.
            (0, $cf1d0720eef4c612$export$5b7d16983d60107d)('loot', {
                memberId: actor === null || actor === void 0 ? void 0 : actor.id,
                rarity: (_findItem = (0, $ca7af38ea7b7b4a8$export$a2dea178c28a0308)('id', itemId)) === null || _findItem === void 0 ? void 0 : _findItem.rarity,
                delayMs: 260 + idx * 220
            });
        });
        (0, $8bda0cb20f0b197d$export$fd59807889add359)("\u26A1 Salvaged: ".concat(lootMessage, "!"), 'bonus', {
            stepIndex: currentRoomIndex
        });
        // Award event success credits
        var tierData = $979b99378be707cd$export$94e7ad7999c1ae32[tier];
        if (tierData && tierData.creditRewards) {
            var eventCredits = tierData.creditRewards.successEventCredit;
            // Apply credit scaling multipliers
            eventCredits = (0, $8bda0cb20f0b197d$export$78a769585121af92)(eventCredits, tier);
            (0, $8bda0cb20f0b197d$export$d2188f6548dbea9f)(state.currentRaid.raidInProgress.lootGained, 'Credits', eventCredits);
            (0, $8bda0cb20f0b197d$export$fd59807889add359)("\uD83D\uDCB0 Intelligence Bonus: ".concat(eventCredits, " Credits"), 'bonus', {
                stepIndex: currentRoomIndex
            });
        }
    }
    // Step 7: Mark event as completed
    eventData.status = outcome.success ? 'completed' : 'failed';
    return {
        success: outcome.success,
        variant: variant,
        loot: eventLoot,
        damage: eventData.damage || 0,
        casualties: eventData.casualties || [],
        outcome: outcome
    };
}
function $52a7294453bdb6d1$export$65439b695d7608c2(quantity, room, character) {
    var pct = (0, $df8a44d92d572a5c$export$401b195eeeb2d82c)('loot-quantity-bonus', character);
    if ((room === null || room === void 0 ? void 0 : room.type) === 'gate') pct += (0, $df8a44d92d572a5c$export$401b195eeeb2d82c)('gate-material-bonus', character);
    if (pct <= 0 || quantity <= 0) return quantity;
    var boosted = quantity * (1 + pct / 100);
    var floor = Math.floor(boosted);
    return floor + (Math.random() < boosted - floor ? 1 : 0);
}
function $52a7294453bdb6d1$export$2ebfe836f4eff9d2(event, state, room) {
    var _state_currentRaid, _item_effects;
    var raid = (_state_currentRaid = state.currentRaid) === null || _state_currentRaid === void 0 ? void 0 : _state_currentRaid.raidInProgress;
    if (!raid) return null;
    if (!(room === null || room === void 0 ? void 0 : room.baseDuration) || room.baseDuration <= 0) return null;
    var techniqueId = event.relatedTechniqueId;
    if (!techniqueId) return null;
    var rigged = raid.riggedTechniques = raid.riggedTechniques || {};
    var item = null;
    var firstRig = false;
    if (rigged[techniqueId]) item = (0, $ca7af38ea7b7b4a8$export$a2dea178c28a0308)('id', rigged[techniqueId]);
    else {
        var _state_character;
        var inventory = (_state_character = state.character) === null || _state_character === void 0 ? void 0 : _state_character.inventory;
        if (!inventory) return null;
        var itemId = Object.keys(inventory).find(function(id) {
            var _candidate_effects;
            if ((inventory[id] || 0) <= 0) return false;
            var candidate = (0, $ca7af38ea7b7b4a8$export$a2dea178c28a0308)('id', id);
            return (candidate === null || candidate === void 0 ? void 0 : candidate.type) === 'consumable' && candidate.techniqueId === techniqueId && (((_candidate_effects = candidate.effects) === null || _candidate_effects === void 0 ? void 0 : _candidate_effects['room-time-reduction']) || 0) > 0;
        });
        if (!itemId) return null;
        item = (0, $ca7af38ea7b7b4a8$export$a2dea178c28a0308)('id', itemId);
        inventory[itemId]--;
        if (inventory[itemId] <= 0) delete inventory[itemId];
        rigged[techniqueId] = itemId;
        firstRig = true;
    }
    if (!item) return null;
    var pct = ((_item_effects = item.effects) === null || _item_effects === void 0 ? void 0 : _item_effects['room-time-reduction']) || 0;
    if (pct <= 0) return null;
    var reductionSec = room.baseDuration * (pct / 100);
    var reductionMs = reductionSec * 1000;
    raid.roomStartTime -= reductionMs;
    raid.nextRoomTime -= reductionMs;
    (0, $8bda0cb20f0b197d$export$fd59807889add359)(firstRig ? "".concat(item.icon, " ").concat(item.name, " rigged for this raid \u2014 ").concat((0, $ca7af38ea7b7b4a8$export$b7fbae54a8f17db)(techniqueId), " rooms run ").concat(pct, "% faster (\u2212").concat(Math.round(reductionSec), "s)") : "".concat(item.icon, " ").concat(item.name, ": cleared ").concat(Math.round(reductionSec), "s off the room"), 'bonus', {
        stepIndex: raid.currentRoomIndex,
        notificationMessage: firstRig ? "".concat(item.icon, " ").concat(item.name, " rigged for this raid") : "".concat(item.icon, " \u2212").concat(Math.round(reductionSec), "s off the room")
    });
    return {
        item: item,
        reductionSec: reductionSec,
        firstRig: firstRig
    };
}
// ---------------------------------------------------------------------------
// Synergy partner maps (cached from event definitions). Every event carries
// two cross-faction synergy variants; these lookups answer "which techniques
// can upgrade this skill's events" and the reverse - the data behind the
// contractor-hiring synergy indicators.
// ---------------------------------------------------------------------------
var $52a7294453bdb6d1$var$synergyPartnersBySkill = null; // skillId -> Set<partner techniqueId>
var $52a7294453bdb6d1$var$synergySkillsByTechnique = null; // techniqueId -> Set<skillId it upgrades>
var $52a7294453bdb6d1$var$synergyPartnersByTechnique = null; // primary techniqueId -> Set<partner techniqueId>
function $52a7294453bdb6d1$var$buildSynergyMaps() {
    $52a7294453bdb6d1$var$synergyPartnersBySkill = {};
    $52a7294453bdb6d1$var$synergySkillsByTechnique = {};
    $52a7294453bdb6d1$var$synergyPartnersByTechnique = {};
    var allEvents = (0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$f152896064e09913).concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$9435522665f2dda4), (0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$1cd1fab9b9844b76));
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = allEvents[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var event = _step.value;
            var skill = event.relatedSkillId || event.favoredSkill;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = (event.variants || [])[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var v = _step1.value;
                    var _synergyPartnersBySkill, _skill, _synergySkillsByTechnique, _v_synergyTechniqueId, _synergyPartnersByTechnique, _event_relatedTechniqueId;
                    if (!v.synergyTechniqueId) continue;
                    ((_synergyPartnersBySkill = $52a7294453bdb6d1$var$synergyPartnersBySkill)[_skill = skill] || (_synergyPartnersBySkill[_skill] = new Set())).add(v.synergyTechniqueId);
                    ((_synergySkillsByTechnique = $52a7294453bdb6d1$var$synergySkillsByTechnique)[_v_synergyTechniqueId = v.synergyTechniqueId] || (_synergySkillsByTechnique[_v_synergyTechniqueId] = new Set())).add(skill);
                    if (event.relatedTechniqueId) ((_synergyPartnersByTechnique = $52a7294453bdb6d1$var$synergyPartnersByTechnique)[_event_relatedTechniqueId = event.relatedTechniqueId] || (_synergyPartnersByTechnique[_event_relatedTechniqueId] = new Set())).add(v.synergyTechniqueId);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $52a7294453bdb6d1$export$3a3bfc913ac4efaa(skillId) {
    if (!$52a7294453bdb6d1$var$synergyPartnersBySkill) $52a7294453bdb6d1$var$buildSynergyMaps();
    return $52a7294453bdb6d1$var$synergyPartnersBySkill[skillId] || new Set();
}
function $52a7294453bdb6d1$export$9f7e6ebcfcd92245(techniqueId) {
    if (!$52a7294453bdb6d1$var$synergySkillsByTechnique) $52a7294453bdb6d1$var$buildSynergyMaps();
    return $52a7294453bdb6d1$var$synergySkillsByTechnique[techniqueId] || new Set();
}
function $52a7294453bdb6d1$export$fe6715e7f54582df(techniqueId) {
    if (!$52a7294453bdb6d1$var$synergyPartnersByTechnique) $52a7294453bdb6d1$var$buildSynergyMaps();
    return $52a7294453bdb6d1$var$synergyPartnersByTechnique[techniqueId] || new Set();
}
function $52a7294453bdb6d1$export$271813734e1c621(event, availableTechniques) {
    var variants = event.variants || [];
    if (variants.length === 0) {
        console.warn("Event ".concat(event.id, " has no variants"));
        return null;
    }
    var techSet = new Set(availableTechniques);
    // Priority: variant[1] synergy > variant[2] synergy > variant[0] primary
    for(var i = 1; i < Math.min(3, variants.length); i++){
        if (variants[i].synergyTechniqueId && techSet.has(variants[i].synergyTechniqueId)) return (0, $715bf31211e65705$export$71511d61b312f219)((0, $fa9769297b8a68c8$export$71511d61b312f219)({}, variants[i]), {
            variantIndex: i
        });
    }
    // Fallback to primary-only variant
    return (0, $715bf31211e65705$export$71511d61b312f219)((0, $fa9769297b8a68c8$export$71511d61b312f219)({}, variants[0]), {
        variantIndex: 0
    });
}
function $52a7294453bdb6d1$export$6c65f1aff219e169(skillId, team) {
    if (!skillId || !(team === null || team === void 0 ? void 0 : team.length)) return (team === null || team === void 0 ? void 0 : team[0]) || null;
    var best = null, bestLevel = -1;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = team[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var m = _step.value;
            var _m_skills;
            if ((m === null || m === void 0 ? void 0 : m.isAlive) === false) continue;
            var level = (m === null || m === void 0 ? void 0 : (_m_skills = m.skills) === null || _m_skills === void 0 ? void 0 : _m_skills[skillId]) || 0;
            if (level > bestLevel) {
                bestLevel = level;
                best = m;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return best || team.find(function(m) {
        return (m === null || m === void 0 ? void 0 : m.isAlive) !== false;
    }) || team[0];
}
function $52a7294453bdb6d1$export$c7f3781b6ac25bb8(event, state, team) {
    // Available techniques = the team's equipped skill gear (one per skill per
    // member). Gear is the gate: skills make a technique attemptable, the
    // equipped tool unlocks synergy variants and the success bonus. Members may
    // be raw character/contractor objects (equippedTechniqueGear map) or
    // initializeRaidTeam snapshots (equippedTechniques array).
    var availableTechniques = [];
    (team || []).forEach(function(member) {
        var techniques = member.equippedTechniques || Object.keys(member.equippedTechniqueGear || {});
        techniques.forEach(function(t) {
            return availableTechniques.push(t);
        });
    });
    // Per-skill synergy unlocks gate WHICH techniques may drive a synergy variant
    // (either-side rule): allowed when the event's skill is unlocked, or when the
    // technique is the player's own gear from an unlocked skill.
    var character = state === null || state === void 0 ? void 0 : state.character;
    var playerTechniques = new Set(Object.keys((character === null || character === void 0 ? void 0 : character.equippedTechniqueGear) || {}));
    var eventSkillUnlocked = (0, $df8a44d92d572a5c$export$7d626adf944498ee)(event.relatedSkillId || event.favoredSkill, character);
    var synergyCapable = availableTechniques.filter(function(t) {
        return eventSkillUnlocked || playerTechniques.has(t) && (0, $df8a44d92d572a5c$export$7d626adf944498ee)((0, $ca7af38ea7b7b4a8$export$a6cb179f21ae932e)(t), character);
    });
    return {
        variant: $52a7294453bdb6d1$export$271813734e1c621(event, synergyCapable),
        availableTechniques: availableTechniques
    };
}
function $52a7294453bdb6d1$export$dedbe468d8b2fc6c(text, event, variant) {
    if (!text) return text;
    var out = text.replace(/@techName/g, (0, $ca7af38ea7b7b4a8$export$b7fbae54a8f17db)(event.relatedTechniqueId));
    if (variant === null || variant === void 0 ? void 0 : variant.synergyTechniqueId) out = out.replace(/@synergyTechName/g, (0, $ca7af38ea7b7b4a8$export$b7fbae54a8f17db)(variant.synergyTechniqueId));
    return out;
}
function $52a7294453bdb6d1$export$2ad5af141c2ca6d2(skillLevel, targetSkillLevel) {
    var supportBonus = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    var chance = 0.76 + (skillLevel - targetSkillLevel) * 0.05 + supportBonus;
    return Math.max(0.20, Math.min(0.97, chance));
}
function $52a7294453bdb6d1$export$6f562e7d3f793247(event, variant, teamSkills, raidTier, room) {
    var gearBonus = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0;
    // Get target skill level from raid tier configuration
    var tierData = $979b99378be707cd$export$94e7ad7999c1ae32[raidTier] || {
        gateSkillLevel: 50,
        hazardSkillLevel: 40
    };
    var targetSkillLevel = room.type === 'gate' ? tierData.gateSkillLevel : tierData.hazardSkillLevel;
    // Get primary skill level for this event
    var primarySkill = event.favoredSkill || event.relatedSkillId;
    var primarySkillLevel = teamSkills[primarySkill] || 0;
    // Calculate skill difference
    var skillDiff = primarySkillLevel - targetSkillLevel;
    // Calculate support bonus from support skills (capped at 0.15)
    var supportBonus = 0;
    if (room.support && Array.isArray(room.support)) {
        var supportSum = room.support.reduce(function(sum, skillId) {
            return sum + (teamSkills[skillId] || 0);
        }, 0);
        supportBonus = Math.min(supportSum * 0.1, 0.15);
    }
    // Calculate success chance using raid formula. The equipped-gear bonus
    // rides through the same clamp, so the 97% ceiling still applies.
    var successChance = $52a7294453bdb6d1$export$2ad5af141c2ca6d2(primarySkillLevel, targetSkillLevel, supportBonus + gearBonus);
    // Roll 1d100 (0-100)
    var roll = Math.random() * 100;
    var success = roll < successChance * 100;
    return {
        success: success,
        chance: successChance,
        roll: roll / 100,
        skillDiff: skillDiff,
        supportBonus: supportBonus,
        gearBonus: gearBonus,
        targetSkillLevel: targetSkillLevel,
        primarySkillLevel: primarySkillLevel
    };
}
function $52a7294453bdb6d1$export$6f1a1ae8eddfba2c(event, state) {
    var favoredSkill = event.favoredSkill || event.relatedSkillId;
    var favoredTechnique = event.favoredTechnique || event.relatedTechniqueId;
    var materialIds = new Set();
    var visitedItems = new Set();
    // Get all recipes
    var allRecipes = (0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$c4df318d1f4ad4 || []).concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$c95766f8298d6ed1 || []), (0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$12c2125da4fa007 || []), (0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$ded4d2beb9be271a || []));
    // Get all craftable items (excludes common and blueprints which can't be crafted)
    var craftableItems = (0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$2508a374b14b8e59 || []).concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$241bdd39c3e59b72 || []), (0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$439a14874f0a75e4 || []), (0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$b2b2210935a03dc3 || []), (0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$c1a4d9d859d3b7 || []), (0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$a24b2f292778b5dc || []), (0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$29d1bf8c74230d20 || []), (0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$71b953a5ed5f0cd6 || []), (0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$76261a034023b29 || []), (0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$7a39b013515e9c7d || []), (0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$659d2bfa35449fc3 || []), (0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$709aa55c173a48b8 || []));
    /**
   * Recursively collect every recipe component at every depth: craftable
   * intermediates (uncommon/rare materials, consumables) AND base leaves.
   * The room's skill loot must span the whole chain toward its epic
   * gear/artifacts, not just the commons the chain bottoms out in —
   * otherwise uncommon/rare rarity rolls find an empty pool and drop nothing.
   */ var collectIngredients = function(itemId) {
        if (visitedItems.has(itemId)) return;
        visitedItems.add(itemId);
        var recipe = allRecipes.find(function(r) {
            return r.target === itemId;
        });
        if (!recipe || !recipe.inputs) return;
        recipe.inputs.forEach(function(input) {
            if (!input.id) return;
            materialIds.add(input.id);
            collectIngredients(input.id);
        });
    };
    // Find all items related to this skill/technique and collect ingredients
    craftableItems.filter(function(item) {
        // Match by skill (for skill artifacts) or by techniqueId (for epic items)
        return item.skill === favoredSkill || item.techniqueId === favoredTechnique;
    }).forEach(function(item) {
        return collectIngredients(item.id);
    });
    (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).loot, "Loot pool for event ".concat(event.id, " (skill: ").concat(favoredSkill, ", technique: ").concat(favoredTechnique, "): ").concat(materialIds.size, " materials"));
    return Array.from(materialIds);
}
function $52a7294453bdb6d1$export$8c917c953701923b(raidTier, team) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var _config_progressionScaling;
    var _options_damageMultiplier = options.damageMultiplier, damageMultiplier = _options_damageMultiplier === void 0 ? 1 : _options_damageMultiplier, _options_preventKnockout = options.preventKnockout, preventKnockout = _options_preventKnockout === void 0 ? false : _options_preventKnockout;
    if (!team || team.length === 0) {
        (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).raid, "TEAM MISSING");
        return {
            damaged: false,
            member: null,
            damage: 0,
            casualties: []
        };
    }
    // Find alive team members only
    var aliveMembers = team.filter(function(m) {
        return m.isAlive;
    });
    if (aliveMembers.length === 0) {
        (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).raid, "TEAM DEAD ALREADY");
        return {
            damaged: false,
            member: null,
            damage: 0,
            casualties: []
        };
    }
    // Select random alive member
    var member = aliveMembers[Math.floor(Math.random() * aliveMembers.length)];
    // Apply damage using configurable tier scaling
    var dmgConfig = ((_config_progressionScaling = $979b99378be707cd$export$9f9786ac427715c7) === null || _config_progressionScaling === void 0 ? void 0 : _config_progressionScaling.skillEventDamage) || {};
    var minDamage, maxDamage;
    // Check if per-tier damage is configured
    if (dmgConfig.perTier && dmgConfig.perTier[raidTier]) {
        var tierDamage = dmgConfig.perTier[raidTier];
        var _tierDamage_min;
        minDamage = (_tierDamage_min = tierDamage.min) !== null && _tierDamage_min !== void 0 ? _tierDamage_min : 5;
        var _tierDamage_max;
        maxDamage = (_tierDamage_max = tierDamage.max) !== null && _tierDamage_max !== void 0 ? _tierDamage_max : 15;
    } else {
        var _dmgConfig_baseDamage;
        // Fall back to baseDamage * tier formula
        var baseDamage = (_dmgConfig_baseDamage = dmgConfig.baseDamage) !== null && _dmgConfig_baseDamage !== void 0 ? _dmgConfig_baseDamage : 5;
        minDamage = baseDamage * raidTier;
        maxDamage = minDamage + baseDamage * raidTier;
    }
    var damage = Math.max(1, Math.round((minDamage + Math.floor(Math.random() * (maxDamage - minDamage + 1))) * damageMultiplier));
    member.currentHp = Math.max(0, member.currentHp - damage);
    var casualties = [];
    var knockoutPrevented = false;
    if (member.currentHp <= 1) {
        if (preventKnockout) {
            // Stabilized at the brink instead of falling
            member.currentHp = 1;
            knockoutPrevented = true;
        } else {
            member.isAlive = false;
            casualties.push(member);
        }
    }
    return {
        damaged: true,
        member: member,
        damage: damage,
        casualties: casualties,
        knockoutPrevented: knockoutPrevented
    };
}
function $52a7294453bdb6d1$export$edf2a8e4414546a8(state) {
    var _state_currentRaid_raidInProgress, _state_currentRaid;
    if (!((_state_currentRaid = state.currentRaid) === null || _state_currentRaid === void 0 ? void 0 : (_state_currentRaid_raidInProgress = _state_currentRaid.raidInProgress) === null || _state_currentRaid_raidInProgress === void 0 ? void 0 : _state_currentRaid_raidInProgress.events)) return false;
    // Bonus triggers only if no skill event failures occurred
    return !state.currentRaid.raidInProgress.hasSkillEventFailure;
}
function $52a7294453bdb6d1$export$3e2a422d19cb46bc(room, state) {
    var _state_currentRaid_raidInProgress, _state_currentRaid;
    if (!((_state_currentRaid = state.currentRaid) === null || _state_currentRaid === void 0 ? void 0 : (_state_currentRaid_raidInProgress = _state_currentRaid.raidInProgress) === null || _state_currentRaid_raidInProgress === void 0 ? void 0 : _state_currentRaid_raidInProgress.events)) return;
    // Schedule bonus at room duration - 15 seconds (converted to milliseconds)
    var bonusEventTimeMs = room.baseDuration == 0 ? 0 : (room.baseDuration - 15) * 1000;
    state.currentRaid.raidInProgress.events.bonusLootEvent = {
        scheduled: true,
        scheduledTimeMs: bonusEventTimeMs,
        triggered: false,
        active: false,
        element: null,
        roomIndex: state.currentRaid.raidInProgress.currentRoomIndex
    };
    (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).events, "Scheduled bonus loot event at ".concat(bonusEventTimeMs / 1000, "s for room ").concat(room.type));
}
function $52a7294453bdb6d1$export$dfbeebc3d1509da(room, tier, rarity) {
    var character = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    var loot = {};
    var quantityRange = (0, $8bda0cb20f0b197d$export$540736c4d7813ac)(rarity, tier, room.type);
    var quantity = $52a7294453bdb6d1$export$65439b695d7608c2(Math.round(Math.random() * (quantityRange.max - quantityRange.min)) + quantityRange.min, room, character);
    var itemPool = $52a7294453bdb6d1$export$ded25040c5f0ed12(room, tier, rarity);
    if (rarity === 'legendary') (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).loot, "[LEGENDARY] generateBonusLoot: tier=".concat(tier, ", itemPool.length=").concat(itemPool.length, ", quantity=").concat(quantity));
    // Relic Resonance Tuner: relics get a heavier hand inside mixed pools
    // without inflating the rest of the pool's drop odds
    var relicBoostPct = (0, $df8a44d92d572a5c$export$401b195eeeb2d82c)('relic-quality-bonus', character);
    var boost = relicBoostPct > 0 ? {
        predicate: function(id) {
            var _findItem;
            return ((_findItem = (0, $ca7af38ea7b7b4a8$export$a2dea178c28a0308)('id', id)) === null || _findItem === void 0 ? void 0 : _findItem.type) === 'relic';
        },
        multiplier: 1 + relicBoostPct / 100
    } : null;
    // Select item from pool, weighted by per-item drop weights
    if (itemPool.length > 0) {
        var item = (0, $8bda0cb20f0b197d$export$2cbb40695b9e7336)(itemPool, boost);
        loot[item] = quantity;
        if (rarity === 'legendary') (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).loot, "[LEGENDARY] Selected item: ".concat(item));
    } else if (rarity === 'legendary') console.warn("[LEGENDARY] No items in pool! Cannot generate loot.");
    return loot;
}
/**
 * Get item pool for a specific rarity tier
 * @param {Object} room - Room object
 * @param {Number} tier - Raid tier
 * @param {string} rarity - Rarity tier
 * @returns {Array} Array of item IDs that can drop at this rarity
 */ // Union of the room's skill-chain pools (every recipe component reachable
// from the epic gear/artifacts tied to the room's primary+support skills).
// Cached per skill signature — pure config data.
var $52a7294453bdb6d1$var$roomChainCache = new Map();
function $52a7294453bdb6d1$var$getRoomChainMaterials(room) {
    var key = "".concat(room.primary || '', "|").concat((room.support || []).slice().sort().join(','));
    if ($52a7294453bdb6d1$var$roomChainCache.has(key)) return $52a7294453bdb6d1$var$roomChainCache.get(key);
    var set = new Set();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator = $52a7294453bdb6d1$export$e0c93437f7880972(room, null)[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
            var event = _step.value;
            try {
                for(var _iterator1 = $52a7294453bdb6d1$export$6f1a1ae8eddfba2c(event, null)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                    var id = _step1.value;
                    set.add(id);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    $52a7294453bdb6d1$var$roomChainCache.set(key, set);
    return set;
}
function $52a7294453bdb6d1$export$ded25040c5f0ed12(room, tier, rarity) {
    var itemPool = [];
    switch(rarity){
        case 'common':
        case 'uncommon':
        case 'rare':
            {
                // Scope bonus materials to the room's skill chains so bonus events
                // reinforce the room's signature instead of re-washing every faction
                // material into every faction room. Fall back to the faction pool if
                // the intersection is empty (e.g. a room with no chain materials at
                // this rarity) so the bonus roll never comes up empty-handed.
                var factionPool = (0, $8bda0cb20f0b197d$export$10ac30a050ae6642)(room, rarity);
                var chain = $52a7294453bdb6d1$var$getRoomChainMaterials(room);
                var scoped = factionPool.filter(function(id) {
                    return chain.has(id);
                });
                itemPool = scoped.length > 0 ? scoped : factionPool;
                break;
            }
        case 'epic':
            var tierRarity = (0, $8bda0cb20f0b197d$export$65aa634013c8a9db)(tier);
            // Exclude HP/Energy consumables from epic loot (now purchaseable only)
            var epicConsumables = (0, $8bda0cb20f0b197d$export$b1ad0808e6cb0531)('consumable', tierRarity).filter(function(item) {
                return item !== 'field-health-stim' && item !== 'portable-energy-pack' && item !== 'recovery-injector-mk2' && item !== 'energy-conversion-pack' && item !== 'advanced-recovery-serum' && item !== 'power-cell-mk3';
            });
            itemPool = epicConsumables.concat((0, $8bda0cb20f0b197d$export$b1ad0808e6cb0531)('relic', tierRarity));
            break;
        case 'legendary':
            itemPool = (0, $8bda0cb20f0b197d$export$61bdab8a63df855c)(room);
            (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).loot, "[LEGENDARY] getItemPoolForRarity: found ".concat(itemPool.length, " blueprints for faction ").concat((0, $8bda0cb20f0b197d$export$ad0c244e6b90d977)(room)));
            if (itemPool.length === 0) console.warn("[LEGENDARY] WARNING: No blueprints found for room with primary=".concat(room.primary));
            break;
        case 'unique':
            itemPool = tier >= 4 ? (0, $8bda0cb20f0b197d$export$b1ad0808e6cb0531)('storyRelic') : [];
            break;
        default:
            itemPool = [];
    }
    return itemPool;
}
// ============================================================================
// PLANNING: which items a room could drop (for the raid-grid item highlight)
// ============================================================================
var $52a7294453bdb6d1$var$SKILL_CHECK_RARITIES = [
    'common',
    'uncommon',
    'rare'
];
var $52a7294453bdb6d1$var$ALL_RARITIES = [
    'common',
    'uncommon',
    'rare',
    'epic',
    'legendary',
    'unique'
];
function $52a7294453bdb6d1$export$a8a308eea90e6ddf(room, tier) {
    var opts = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var ids = new Set();
    if (!room || !room.type) return ids;
    if (room.type === 'water') {
        ids.add('Fish');
        return ids;
    }
    if (room.type !== 'gate' && room.type !== 'hazard') return ids;
    var itemsById = opts.itemsById || new Map((0, $ca7af38ea7b7b4a8$export$15b7d0c192d0aa5d)().map(function(i) {
        return [
            i.id,
            i
        ];
    }));
    var canDrop = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $52a7294453bdb6d1$var$ALL_RARITIES[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var r = _step.value;
            canDrop[r] = (0, $8bda0cb20f0b197d$export$d2ef23ef6c7c6dd5)(r, tier, room.type) > 0;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined, _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
    try {
        // Skill-check pool — recipe components tied to the room's skills
        for(var _iterator1 = $52a7294453bdb6d1$export$e0c93437f7880972(room, null)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion2 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion2 = true){
            var event = _step1.value;
            try {
                for(var _iterator2 = $52a7294453bdb6d1$export$6f1a1ae8eddfba2c(event, null)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion1 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion1 = true){
                    var itemId = _step2.value;
                    var _itemsById_get;
                    var rarity = (_itemsById_get = itemsById.get(itemId)) === null || _itemsById_get === void 0 ? void 0 : _itemsById_get.rarity;
                    if ($52a7294453bdb6d1$var$SKILL_CHECK_RARITIES.includes(rarity) && canDrop[rarity]) ids.add(itemId);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator2.return != null) {
                        _iterator2.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }
    var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
    try {
        // Bonus-loot pools per droppable rarity
        for(var _iterator3 = $52a7294453bdb6d1$var$ALL_RARITIES[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
            var r1 = _step3.value;
            if (!canDrop[r1]) continue;
            var _iteratorNormalCompletion4 = true, _didIteratorError4 = false, _iteratorError4 = undefined;
            try {
                for(var _iterator4 = $52a7294453bdb6d1$export$ded25040c5f0ed12(room, tier, r1)[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true){
                    var itemId1 = _step4.value;
                    ids.add(itemId1);
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                        _iterator4.return();
                    }
                } finally{
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                _iterator3.return();
            }
        } finally{
            if (_didIteratorError3) {
                throw _iteratorError3;
            }
        }
    }
    ids.delete('Credits');
    return ids;
}
function $52a7294453bdb6d1$export$433f18e5bfab36e1(gridData) {
    var itemToCells = new Map();
    if (!gridData || !gridData.grid) return {
        itemToCells: itemToCells,
        items: []
    };
    var itemsById = new Map((0, $ca7af38ea7b7b4a8$export$15b7d0c192d0aa5d)().map(function(i) {
        return [
            i.id,
            i
        ];
    }));
    var tier = gridData.tier;
    var rows = gridData.rows || gridData.grid.length;
    var cols = gridData.cols || (gridData.grid[0] ? gridData.grid[0].length : 0);
    var bySignature = new Map(); // signature -> Set<itemId>
    for(var row = 0; row < rows; row++)for(var col = 0; col < cols; col++){
        var _gridData_grid_row;
        var room = (_gridData_grid_row = gridData.grid[row]) === null || _gridData_grid_row === void 0 ? void 0 : _gridData_grid_row[col];
        if (!room || room.type === 'blocked') continue;
        var sig = "".concat(room.type, "|").concat(room.primary || '', "|").concat((room.support || []).slice().sort().join(','));
        var set = bySignature.get(sig);
        if (!set) {
            set = $52a7294453bdb6d1$export$a8a308eea90e6ddf(room, tier, {
                itemsById: itemsById
            });
            bySignature.set(sig, set);
        }
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = set[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var id = _step.value;
                var cells = itemToCells.get(id);
                if (!cells) {
                    cells = [];
                    itemToCells.set(id, cells);
                }
                cells.push({
                    row: row,
                    col: col
                });
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    // Sorted distinct item list: by rarity order, then display name. 'Fish' has
    // no catalog entry — bucket it last as a "Special" group.
    var rarityOrder = function(r) {
        var _config_itemRarities_r, _config_itemRarities;
        var _config_itemRarities_r_order;
        return (_config_itemRarities_r_order = (_config_itemRarities = $979b99378be707cd$export$d4a72d069095e9e5) === null || _config_itemRarities === void 0 ? void 0 : (_config_itemRarities_r = _config_itemRarities[r]) === null || _config_itemRarities_r === void 0 ? void 0 : _config_itemRarities_r.order) !== null && _config_itemRarities_r_order !== void 0 ? _config_itemRarities_r_order : 99;
    };
    var items = Array.from(itemToCells.keys()).map(function(id) {
        var item = itemsById.get(id);
        return {
            id: id,
            type: (item === null || item === void 0 ? void 0 : item.type) || '',
            rarity: (item === null || item === void 0 ? void 0 : item.rarity) || 'special',
            count: itemToCells.get(id).length
        };
    }).sort(function(a, b) {
        var oa = a.rarity === 'special' ? 100 : rarityOrder(a.rarity);
        var ob = b.rarity === 'special' ? 100 : rarityOrder(b.rarity);
        if (oa !== ob) return oa - ob;
        return (0, $ca7af38ea7b7b4a8$export$31330438f6059b08)(a.id).localeCompare((0, $ca7af38ea7b7b4a8$export$31330438f6059b08)(b.id));
    });
    return {
        itemToCells: itemToCells,
        items: items
    };
}
function $52a7294453bdb6d1$export$adaa23be627dd8c9(state) {
    var bonusEvent = state.currentRaid.raidInProgress.events.bonusLootEvent;
    if (typeof document != 'undefined' && bonusEvent.element && bonusEvent.element.parentNode) bonusEvent.element.remove();
    bonusEvent.active = false;
    bonusEvent.scheduled = false;
    bonusEvent.triggered = false;
    bonusEvent.element = null;
    bonusEvent.roomIndex = null;
}
function $52a7294453bdb6d1$export$852a40f600fb6319(state) {
    var bonusEvent = state.currentRaid.raidInProgress.events.bonusLootEvent;
    var currentRoomIndex = state.currentRaid.raidInProgress.currentRoomIndex;
    // Verify we're still in the right room
    if (currentRoomIndex !== bonusEvent.roomIndex) {
        bonusEvent.scheduled = false;
        return;
    }
    // Distribute bonus loot (starting with common rarity, cascades up)
    $52a7294453bdb6d1$export$480ef632888d5e53(state, 'common');
    // Clean up the event
    $52a7294453bdb6d1$export$adaa23be627dd8c9(state);
}
function $52a7294453bdb6d1$export$480ef632888d5e53(state) {
    var rarity = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'common';
    if (state.currentRaid.raidInProgress == null) {
        (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).events, "tried to process bonus loot event after raid ended");
        return;
    }
    var currentRoomIndex = state.currentRaid.raidInProgress.currentRoomIndex;
    var pathStep = state.currentRaid.selectedPath[currentRoomIndex];
    var room = pathStep.room;
    var tier = state.currentRaid.currentRaidGrid.tier;
    if (rarity === 'common') {
        var _tierData_creditRewards;
        // The base bonus rewards faction intel CREDITS instead of common items:
        // the team logs field data valuable to the faction. Keeps common material
        // income demand-shaped (weighted event loot only) and feeds the shared
        // credit pool that multiplayer team members split.
        var tierData = $979b99378be707cd$export$94e7ad7999c1ae32[tier];
        var intelCredits = (0, $8bda0cb20f0b197d$export$78a769585121af92)((tierData === null || tierData === void 0 ? void 0 : (_tierData_creditRewards = tierData.creditRewards) === null || _tierData_creditRewards === void 0 ? void 0 : _tierData_creditRewards.successEventCredit) || 15, tier);
        (0, $8bda0cb20f0b197d$export$d2188f6548dbea9f)(state.currentRaid.raidInProgress.lootGained, 'Credits', intelCredits);
        (0, $8bda0cb20f0b197d$export$fd59807889add359)("\uD83E\uDDE0 Field Intelligence: the team files what this site remembers \u2014 ".concat(intelCredits, " credits!"), 'bonus', {
            stepIndex: currentRoomIndex,
            notificationMessage: "\uD83E\uDDE0 Field Intelligence: +".concat(intelCredits, " credits")
        });
    } else {
        // Cascaded tiers award items from the room-faction pool
        var bonusLoot = $52a7294453bdb6d1$export$dfbeebc3d1509da(room, tier, rarity, state.character);
        Object.entries(bonusLoot).forEach(function(param) {
            var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), item = _param[0], amount = _param[1];
            (0, $8bda0cb20f0b197d$export$d2188f6548dbea9f)(state.currentRaid.raidInProgress.lootGained, item, amount);
            var itemName = (0, $ca7af38ea7b7b4a8$export$31330438f6059b08)(item);
            var rarityIcons = {
                rare: "\uD83D\uDC8E",
                epic: "\uD83D\uDCDC",
                legendary: "\uD83D\uDCDC",
                unique: "\uD83C\uDF1F"
            };
            var icon = rarityIcons[rarity] || "\u2728";
            (0, $8bda0cb20f0b197d$export$fd59807889add359)("".concat(icon, " Exploration Bonus: Found ").concat(amount, "x ").concat(itemName, "!"), 'bonus', {
                stepIndex: currentRoomIndex,
                notificationMessage: "".concat(icon, " Exploration Bonus: ").concat(amount, "x ").concat(itemName, "!")
            });
        });
        (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).loot, "Bonus loot (".concat(rarity, ") awarded:"), bonusLoot);
    }
    // Cascade to next rarity tier using same drop chances as normal loot
    var rarityProgression = {
        common: 'rare',
        rare: 'epic',
        epic: 'legendary',
        legendary: 'unique'
    };
    var nextRarity = rarityProgression[rarity];
    if (nextRarity) {
        var cascadeChance = (0, $8bda0cb20f0b197d$export$d2ef23ef6c7c6dd5)(nextRarity, tier, room.type);
        // Apply per-rarity cascade multiplier from config
        var cascadeMultiplier = $52a7294453bdb6d1$export$a1ce0db419e3821f(tier, nextRarity);
        cascadeChance = cascadeChance * cascadeMultiplier;
        // Memory Crystal Shard: relative boost on the step INTO legendary
        // (where blueprints live) - "the crystal resonates with blueprint caches"
        if (nextRarity === 'legendary') cascadeChance *= 1 + (0, $df8a44d92d572a5c$export$401b195eeeb2d82c)('blueprint-find-bonus', state.character) / 100;
        var cascadeRoll = Math.random();
        // Guarded: the message re-calls getRarityDropChance(), so building it
        // unconditionally would cost a lookup per cascade roll.
        if ((0, $fb5bf89946773306$export$5540f6562bfea743)((0, $fb5bf89946773306$export$31ff2235b44019b8).loot)) (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).loot, "Cascade from ".concat(rarity, " to ").concat(nextRarity, ": baseChance=").concat(((0, $8bda0cb20f0b197d$export$d2ef23ef6c7c6dd5)(nextRarity, tier, room.type) * 100).toFixed(4), "%, multiplier=").concat(cascadeMultiplier, ", finalChance=").concat((cascadeChance * 100).toFixed(4), "%, roll=").concat((cascadeRoll * 100).toFixed(4), "%, triggers=").concat(cascadeRoll < cascadeChance));
        if (cascadeRoll < cascadeChance) {
            if (typeof document != 'undefined') setTimeout(function() {
                (0, $b5bda7fdec806d8b$export$c7def531c087da85)("\uD83C\uDFB0 Extra bonus loot discovered!", 'success');
                $52a7294453bdb6d1$export$480ef632888d5e53(state, nextRarity);
            }, 500);
            else {
                (0, $b5bda7fdec806d8b$export$c7def531c087da85)("\uD83C\uDFB0 Extra bonus loot discovered!", 'success');
                $52a7294453bdb6d1$export$480ef632888d5e53(state, nextRarity);
            }
        }
    }
}
// ============================================================================
// FISHING EVENT (WATER ROOMS)
// ============================================================================
/**
 * Initialize fishing event for water rooms
 * Sets up fishing state and schedules first fish to spawn after 15 seconds
 * @param {Object} room - Room object (type === 'water')
 * @param {Object} state - gameState object
 */ function $52a7294453bdb6d1$var$initializeFishingEvent(room, state) {
    var _state_currentRaid_raidInProgress, _state_currentRaid;
    if (!((_state_currentRaid = state.currentRaid) === null || _state_currentRaid === void 0 ? void 0 : (_state_currentRaid_raidInProgress = _state_currentRaid.raidInProgress) === null || _state_currentRaid_raidInProgress === void 0 ? void 0 : _state_currentRaid_raidInProgress.events)) return;
    state.currentRaid.raidInProgress.events.fishingEvent = {
        active: true,
        targetActive: false,
        nextFishTime: Date.now() + (typeof document !== 'undefined' ? 15000 : 0),
        count: 0,
        element: null,
        roomIndex: state.currentRaid.raidInProgress.currentRoomIndex
    };
    (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).events, 'Fishing event initialized for water room');
}
/**
 * Cleanup fishing event when leaving water room
 * Removes active fish and deactivates fishing
 * @param {Object} state - gameState object
 */ function $52a7294453bdb6d1$var$cleanupFishingEvent(state) {
    var _state_currentRaid_raidInProgress_events, _state_currentRaid_raidInProgress, _state_currentRaid;
    var fishingEvent = (_state_currentRaid = state.currentRaid) === null || _state_currentRaid === void 0 ? void 0 : (_state_currentRaid_raidInProgress = _state_currentRaid.raidInProgress) === null || _state_currentRaid_raidInProgress === void 0 ? void 0 : (_state_currentRaid_raidInProgress_events = _state_currentRaid_raidInProgress.events) === null || _state_currentRaid_raidInProgress_events === void 0 ? void 0 : _state_currentRaid_raidInProgress_events.fishingEvent;
    if (!fishingEvent) return;
    if (fishingEvent.element && fishingEvent.element.parentNode) fishingEvent.element.remove();
    fishingEvent.active = false;
    fishingEvent.targetActive = false;
    fishingEvent.element = null;
    fishingEvent.roomIndex = null;
}
function $52a7294453bdb6d1$export$4fe3116762178ea8(state, roomIndex) {
    var raid = state.currentRaid.raidInProgress;
    (0, $8bda0cb20f0b197d$export$d2188f6548dbea9f)(raid.lootGained, 'Fish', 1);
    (0, $8bda0cb20f0b197d$export$fd59807889add359)("\uD83C\uDFA3 Caught 1x Fish!", 'success', {
        stepIndex: roomIndex,
        notificationMessage: "\uD83C\uDFA3 Caught Fish!"
    });
}
function $52a7294453bdb6d1$export$555d86a21075197e(state) {
    var raid = state.currentRaid.raidInProgress;
    var fishingEvent = raid.events.fishingEvent;
    // Don't spawn if already active or room changed
    if (fishingEvent.count >= 5 || fishingEvent.targetActive || fishingEvent.roomIndex !== raid.currentRoomIndex) return false;
    // No browser to click the fish — auto-catch it and award the loot
    $52a7294453bdb6d1$export$4fe3116762178ea8(state, fishingEvent.roomIndex);
    fishingEvent.count++;
    fishingEvent.targetActive = false;
    fishingEvent.nextFishTime = Date.now();
    (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).events, "Fish caught (count: ".concat(fishingEvent.count, ")"));
    return true;
}
// ============================================================================
// EVENT PRESENTATION (INJECTABLE)
// ============================================================================
// How a bonus-loot / fishing event is presented when it fires. The default
// is the headless auto-grant above, which the 90-day simulator and unit tests
// rely on. In the browser, raid.js calls setEventPresenters() to swap in the
// clickable collectibles from eventSystem.js, so the player must click the
// diamond / fish to collect the reward — the original intended behavior.
var $52a7294453bdb6d1$var$bonusLootPresenter = $52a7294453bdb6d1$export$852a40f600fb6319;
var $52a7294453bdb6d1$var$fishingPresenter = $52a7294453bdb6d1$export$555d86a21075197e;
function $52a7294453bdb6d1$export$26550d9454cb718e() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, bonusLoot = _ref.bonusLoot, fishing = _ref.fishing;
    if (bonusLoot) $52a7294453bdb6d1$var$bonusLootPresenter = bonusLoot;
    if (fishing) $52a7294453bdb6d1$var$fishingPresenter = fishing;
}
function $52a7294453bdb6d1$export$4e4214e38193ac1d() {
    $52a7294453bdb6d1$var$bonusLootPresenter = $52a7294453bdb6d1$export$852a40f600fb6319;
    $52a7294453bdb6d1$var$fishingPresenter = $52a7294453bdb6d1$export$555d86a21075197e;
}
function $52a7294453bdb6d1$export$de2180cc63765512(state) {
    return $52a7294453bdb6d1$var$bonusLootPresenter(state);
}
function $52a7294453bdb6d1$export$99ca7bb292cc775d(state) {
    return $52a7294453bdb6d1$var$fishingPresenter(state);
}


//@ts-check
/**
 * Event System Module
 *
 * Unified event handling for:
 * - Skill-check events (from event definitions)
 * - Bonus loot events (conditional on skill event success)
 * - Fishing events (water rooms only)
 *
 * All events are scheduled and processed through this module.
 * Integrates with raid.js for room progression timing.
 */ 






function $eb7853ba84a48a26$export$88787157d4846f70() {
    (0, $52a7294453bdb6d1$export$26550d9454cb718e)({
        bonusLoot: $eb7853ba84a48a26$var$spawnBonusLootEvent,
        fishing: $eb7853ba84a48a26$var$spawnFish
    });
}
function $eb7853ba84a48a26$export$93eaf817d66094f2(param) {
    var automated = param.automated;
    if (automated) (0, $52a7294453bdb6d1$export$4e4214e38193ac1d)();
    else $eb7853ba84a48a26$export$88787157d4846f70();
}
function $eb7853ba84a48a26$export$a6b9fb5db39e986b(state, team) {
    var _state_currentRaid_raidInProgress, _state_currentRaid;
    if (!((_state_currentRaid = state.currentRaid) === null || _state_currentRaid === void 0 ? void 0 : (_state_currentRaid_raidInProgress = _state_currentRaid.raidInProgress) === null || _state_currentRaid_raidInProgress === void 0 ? void 0 : _state_currentRaid_raidInProgress.events)) return;
    var raid = state.currentRaid.raidInProgress;
    var pathStep = state.currentRaid.selectedPath[raid.currentRoomIndex];
    var eventInfo = (0, $52a7294453bdb6d1$export$a2efc3d0c71d9b81)(state, team);
    if ((eventInfo === null || eventInfo === void 0 ? void 0 : eventInfo.eventLifeCycle) == 'start') switch(eventInfo.eventType){
        case 'skillCheck':
            (0, $52a7294453bdb6d1$export$3d092dd9a898451d)(eventInfo.eventData, raid.currentRoomIndex, state, team);
            break;
        case 'bonusLoot':
            $eb7853ba84a48a26$var$spawnBonusLootEvent(state);
            break;
        case 'fishing':
            $eb7853ba84a48a26$var$spawnFish(state);
            break;
    }
    else if ((eventInfo === null || eventInfo === void 0 ? void 0 : eventInfo.eventLifeCycle) == 'end') switch(eventInfo.eventType){
        case 'skillCheck':
            (0, $52a7294453bdb6d1$export$7408e7aadd9fb0b0)(eventInfo.eventData, state, pathStep.room, team);
            break;
    }
}
// ============================================================================
// BONUS LOOT EVENT (CONDITIONAL)
// ============================================================================
/**
 * Spawn bonus loot event when it triggers
 * Creates clickable icon on grid that players must click to claim bonus
 * @param {Object} state - gameState object
 */ function $eb7853ba84a48a26$var$spawnBonusLootEvent(state) {
    var bonusEvent = state.currentRaid.raidInProgress.events.bonusLootEvent;
    var currentRoomIndex = state.currentRaid.raidInProgress.currentRoomIndex;
    // Verify we're still in the right room
    if (currentRoomIndex !== bonusEvent.roomIndex) {
        bonusEvent.scheduled = false;
        return;
    }
    // Find the current room cell
    var pathStep = state.currentRaid.selectedPath[currentRoomIndex];
    var cell = document.querySelector('[data-row="'.concat(pathStep.row, '"][data-col="').concat(pathStep.col, '"]'));
    if (!cell) {
        console.error('Could not find current room cell for bonus event');
        bonusEvent.scheduled = false;
        return;
    }
    // Create bonus event target element (diamond icon)
    var target = document.createElement('div');
    target.className = 'loot-event-target';
    target.innerHTML = "\uD83D\uDC8E";
    target.title = 'Click for bonus loot!';
    // Position randomly within cell bounds
    var margin = 25; // Percentage from edge
    var leftPercent = margin + Math.random() * (100 - 2 * margin);
    var topPercent = margin + Math.random() * (100 - 2 * margin);
    target.style.left = "".concat(leftPercent, "%");
    target.style.top = "".concat(topPercent, "%");
    // Add click handler
    target.addEventListener('click', function(e) {
        e.stopPropagation();
        $eb7853ba84a48a26$var$handleBonusLootClick(state);
    });
    // Add to cell
    cell.appendChild(target);
    // Update state
    bonusEvent.active = true;
    bonusEvent.scheduled = false;
    bonusEvent.triggered = true;
    bonusEvent.element = target;
    // Play sound effect
    var audio = new Audio('./sounds/chime.mp3');
    audio.volume = 0.3;
    audio.play().catch(function() {}); // Ignore if autoplay blocked
    // Notify user with persistent toast
    var roomEndTime = state.currentRaid.raidInProgress.nextRoomTime;
    $eb7853ba84a48a26$var$showBonusLootToast(roomEndTime);
    (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).events, "Bonus loot event spawned in room ".concat(currentRoomIndex));
}
// The live bonus-loot toast, or null. Module-level so the click handler can
// retract it the moment the loot is collected.
var $eb7853ba84a48a26$var$bonusToast = null;
/**
 * Announce a bonus loot event, counting down the window to collect it.
 *
 * Used to be a hand-rolled `#bonus-event-toast` pinned to the opposite corner
 * from every other notification. It is now a sticky toast in the shared row:
 * sticky because a 5s fade is exactly how a timed opportunity gets missed, and
 * shared because there was no reason for this one message to have its own
 * widget beyond sticky support not existing yet.
 *
 * Sticky here still means "does not fade on a timer", NOT "stays forever" — the
 * offer expires with the room, and a toast still advertising it afterwards
 * would be worse than one that faded. It retracts on collect, at the countdown,
 * and if the event goes inactive for any other reason.
 *
 * @param {Number} roomEndTime - epoch ms when the room (and the offer) ends
 */ function $eb7853ba84a48a26$var$showBonusLootToast(roomEndTime) {
    $eb7853ba84a48a26$var$bonusToast === null || $eb7853ba84a48a26$var$bonusToast === void 0 ? void 0 : $eb7853ba84a48a26$var$bonusToast.dismiss(); // never stack two
    var secondsLeft = function() {
        return Math.max(0, Math.ceil((roomEndTime - Date.now()) / 1000));
    };
    var label = function(secs) {
        return "\uD83D\uDC8E Bonus loot! Click the \uD83D\uDC8E in the room \u2014 ".concat(secs, "s left");
    };
    $eb7853ba84a48a26$var$bonusToast = (0, $b5bda7fdec806d8b$export$c7def531c087da85)(label(secondsLeft()), 'warning', {
        sticky: true
    });
    if (!$eb7853ba84a48a26$var$bonusToast) return; // no container
    var handle = $eb7853ba84a48a26$var$bonusToast;
    var tick = function() {
        var _gameState_currentRaid_raidInProgress_events, _gameState_currentRaid_raidInProgress, _gameState_currentRaid;
        if (handle !== $eb7853ba84a48a26$var$bonusToast) return; // superseded by a newer event
        // Watch the event itself, not just the clock. cleanupRoomEvents() clears
        // `active` when the room ends or the raid is abandoned, and that lives in
        // headless core where it cannot reach the DOM — so the toast follows the
        // flag rather than needing a callback plumbed out of core.
        var offer = (_gameState_currentRaid = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid) === null || _gameState_currentRaid === void 0 ? void 0 : (_gameState_currentRaid_raidInProgress = _gameState_currentRaid.raidInProgress) === null || _gameState_currentRaid_raidInProgress === void 0 ? void 0 : (_gameState_currentRaid_raidInProgress_events = _gameState_currentRaid_raidInProgress.events) === null || _gameState_currentRaid_raidInProgress_events === void 0 ? void 0 : _gameState_currentRaid_raidInProgress_events.bonusLootEvent;
        var secs = secondsLeft();
        if (secs <= 0 || !(offer === null || offer === void 0 ? void 0 : offer.active)) {
            handle.dismiss();
            $eb7853ba84a48a26$var$bonusToast = null;
            return;
        }
        handle.update(label(secs));
        setTimeout(tick, 1000);
    };
    setTimeout(tick, 1000);
}
/**
 * Handle click on bonus loot target
 * Distributes cascading bonus loot and cleans up
 * @param {Object} state - gameState object
 */ function $eb7853ba84a48a26$var$handleBonusLootClick(state) {
    var bonusEvent = state.currentRaid.raidInProgress.events.bonusLootEvent;
    if (!bonusEvent.active || !bonusEvent.element) return;
    // Distribute bonus loot (starting with common rarity, cascades up)
    (0, $52a7294453bdb6d1$export$480ef632888d5e53)(state, 'common');
    // Clean up the event
    (0, $52a7294453bdb6d1$export$adaa23be627dd8c9)(state);
    // Retract the offer immediately rather than waiting for the next countdown
    // tick to notice the event went inactive.
    $eb7853ba84a48a26$var$bonusToast === null || $eb7853ba84a48a26$var$bonusToast === void 0 ? void 0 : $eb7853ba84a48a26$var$bonusToast.dismiss();
    $eb7853ba84a48a26$var$bonusToast = null;
    // Update UI
    (0, $59924438766e7d8e$export$d1c957a54f7124bc)();
    (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
    (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).events, 'Bonus loot event clicked and distributed');
}
// ============================================================================
// FISHING EVENT (WATER ROOMS)
// ============================================================================
/**
 * Spawn a fish target in the room for player to click
 * Called when fishing timer triggers
 * @param {Object} state - gameState object
 */ function $eb7853ba84a48a26$var$spawnFish(state) {
    var raid = state.currentRaid.raidInProgress;
    var fishingEvent = raid.events.fishingEvent;
    // Don't spawn if already active or room changed
    if (fishingEvent.targetActive || fishingEvent.roomIndex !== raid.currentRoomIndex) return;
    // Get the cell
    var pathStep = state.currentRaid.selectedPath[fishingEvent.roomIndex];
    var cell = document.querySelector('[data-row="'.concat(pathStep.row, '"][data-col="').concat(pathStep.col, '"]'));
    if (!cell) return;
    // Create fish target element
    var fish = [
        "\uD83D\uDC1F",
        "\uD83D\uDC20",
        "\uD83E\uDD9E",
        "\uD83E\uDD80"
    ];
    var target = document.createElement('div');
    target.className = 'loot-event-target';
    target.innerHTML = fish[Math.floor(Math.random() * 4)];
    target.title = 'Click to catch fish!';
    // Position randomly within cell bounds
    var margin = 15;
    var leftPercent = margin + Math.random() * (100 - 2 * margin);
    var topPercent = margin + Math.random() * (100 - 2 * margin);
    target.style.left = "".concat(leftPercent, "%");
    target.style.top = "".concat(topPercent, "%");
    // Add click handler
    target.addEventListener('click', function(e) {
        e.stopPropagation();
        $eb7853ba84a48a26$var$catchFish(state);
    });
    // Add to cell
    cell.appendChild(target);
    // Update state
    fishingEvent.targetActive = true;
    fishingEvent.element = target;
    // Play sound effect
    var audio = new Audio('./sounds/fish.mp3');
    audio.volume = 0.3;
    audio.play().catch(function() {});
    (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).events, 'Fish spawned for catching');
}
/**
 * Handle fish catch when player clicks fish
 * Awards Fish item and schedules next fish
 * @param {Object} state - gameState object
 */ function $eb7853ba84a48a26$var$catchFish(state) {
    var raid = state.currentRaid.raidInProgress;
    var fishingEvent = raid.events.fishingEvent;
    if (!fishingEvent.targetActive) return;
    // Remove the target
    if (fishingEvent.element) {
        fishingEvent.element.remove();
        fishingEvent.element = null;
    }
    // Award the catch (shared with the headless auto-catch path)
    (0, $52a7294453bdb6d1$export$4fe3116762178ea8)(state, fishingEvent.roomIndex);
    fishingEvent.count++;
    fishingEvent.targetActive = false;
    fishingEvent.nextFishTime = Date.now() + 15000; // Next fish in 15 seconds
    (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).events, "Fish caught (count: ".concat(fishingEvent.count, "):"), fishLoot);
    (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
} // ============================================================================
 // EXPORTED FUNCTIONS SUMMARY
 // ============================================================================
 // Public API for raid.js integration:
 // - initializeRoomEvents(room, state) - Called when entering room
 // - processScheduledEvents(state, team) - Called each tick in main loop
 // - cleanupRoomEvents(state) - Called when room completes
 // - getEventsSummary(state) - For UI/debugging
 //
 // Internal functions (private to this module):
 // - Skill-check events: getEventsForRoom, scheduleSkillCheckEvents, selectEventVariant,
 //   resolveSkillCheckOutcome, generateSkillEventLootPool, applySkillEventDamage,
 //   processSkillCheckEvent
 // - Bonus loot: shouldTriggerBonusLoot, scheduleConditionalBonusLoot, spawnBonusLootEvent,
 //   showBonusLootToast, handleBonusLootClick, processBonusLootEvent, generateBonusLoot,
 //   getItemPoolForRarity, cleanupBonusLootEvent
 // - Fishing: initializeFishingEvent, spawnFish, catchFish, cleanupFishingEvent


// Always-animated raid map tiles. Each grid cell gets a live TILE_PX canvas
// and a cached still layer: a frame is a blit of that layer, a multiply for
// the hour, then only the things that actually move (canopies, lamps, clouds
// — see the static/dynamic split in roomImageGen.js). World-space effects
// sample by grid row/col, so neighboring tiles stay seamless without a
// whole-map canvas.


/**
 * Procedural room background generator for the raid grid.
 *
 * Composes a 120x120 top-down pixel-art map tile for any room from a
 * shared element library (roofs, pads, crates, fences, trees, water...)
 * arranged by a recipe chosen from the room name, painted and weathered
 * with the owning region's theme. Road/path connectors meet at cell edges
 * so the whole grid reads as one continuous map, and opts.anim drives the
 * live effects: wind, day/night, clouds, powered lights, daylight wells.
 *
 * Deterministic: the same room name in the same region always yields the
 * same image (seeded with the same PRNG the room-naming system uses).
 * Selection logic is pure and Node-safe; only the renderer touches the DOM.
 */ 





/**
 * Road network for a raid grid — pure, seedless, DOM-free.
 *
 * The map used to draw a road cross on every tile, because the connector
 * directions came from "is this neighbour walkable", which is true almost
 * everywhere. Every tile therefore looked the same and the roads said nothing
 * about the place.
 *
 * A grid now gets ONE major route that bisects it edge to edge, wandering
 * rather than running straight, plus minor pathways branching off it until
 * most of the map is reachable from a road. A tile draws road only where the
 * network runs, and only toward the neighbours it actually continues to.
 *
 * The trunk becomes road ROOMS (fast travel) — see createRoadNetwork. The
 * minor pathways are a visual layer only: they run over whatever room is
 * already there, so encounter counts and raid duration are untouched.
 *
 * Directions carry their OWN rank, not the tile's. A trunk tile that anchors a
 * branch continues at full width along the trunk and leaves as a narrow lane
 * toward the branch, so the branch starts at the roadway rather than at the
 * tile edge.
 */ 


var $57ad8bd108ea335d$export$39615881bb0d21f6 = 'major';
var $57ad8bd108ea335d$export$f23edc19d247fd25 = 'minor';
var $57ad8bd108ea335d$var$DIRS = {
    n: [
        -1,
        0
    ],
    s: [
        1,
        0
    ],
    e: [
        0,
        1
    ],
    w: [
        0,
        -1
    ]
};
var $57ad8bd108ea335d$var$OPPOSITE = {
    n: 's',
    s: 'n',
    e: 'w',
    w: 'e'
};
var $57ad8bd108ea335d$export$6013c12dea2de543 = 3;
var $57ad8bd108ea335d$var$key = function(row, col) {
    return "".concat(row, ",").concat(col);
};
function $57ad8bd108ea335d$var$shuffle(list, rand) {
    var out = (0, $4c858c0d999a5b9b$export$71511d61b312f219)(list);
    for(var i = out.length - 1; i > 0; i--){
        var j = Math.floor(rand() * (i + 1));
        var ref;
        ref = [
            out[j],
            out[i]
        ], out[i] = ref[0], out[j] = ref[1], ref;
    }
    return out;
}
function $57ad8bd108ea335d$var$dirBetween(a, b) {
    if (b.row === a.row - 1 && b.col === a.col) return 'n';
    if (b.row === a.row + 1 && b.col === a.col) return 's';
    if (b.row === a.row && b.col === a.col + 1) return 'e';
    if (b.row === a.row && b.col === a.col - 1) return 'w';
    return null;
}
/**
 * A wandering line of cells from one edge of the grid to the opposite one.
 *
 * The two ends are chosen up front, at least MIN_TERMINUS_OFFSET apart across
 * the axis, and the jogs are then dealt out to walk between them. Rolling each
 * jog independently (as an earlier version did) let a route come out nearly
 * straight whenever the rolls happened to cancel.
 */ function $57ad8bd108ea335d$var$bisectingRoute(rows, cols, horizontal, rand) {
    var span = horizontal ? cols : rows;
    var cross = horizontal ? rows : cols;
    var offset = Math.min($57ad8bd108ea335d$export$6013c12dea2de543, cross - 1);
    var slots = Math.max(1, span - 1);
    // A jog costs a slot, and a route with a jog in every slot is a staircase.
    // Half the slots is the ceiling — enough to wander, and it leaves a straight
    // stretch between every turn. Small grids are where this bites: seven columns
    // give six slots, and an unbounded drift wanted a turn in all of them.
    var maxJogs = Math.max(offset, Math.ceil(slots / 2));
    var startLane = Math.floor(rand() * cross);
    // land the far end at least `offset` away, and no further than the route has
    // slots to get there in
    var room = [];
    for(var lane = 0; lane < cross; lane++){
        var away = Math.abs(lane - startLane);
        if (away >= offset && away <= maxJogs) room.push(lane);
    }
    var endLane = room.length ? room[Math.floor(rand() * room.length)] : cross - 1 - startLane;
    // one jog per unit of drift, plus a cancelling pair when there is slack for
    // it, so the route wanders instead of walking a clean diagonal
    var drift = endLane - startLane;
    var steps = [];
    for(var i = 0; i < Math.abs(drift); i++)steps.push(Math.sign(drift));
    if (steps.length + 2 <= maxJogs && rand() < 0.5) {
        steps.push(1);
        steps.push(-1);
    }
    for(var i1 = steps.length - 1; i1 > 0; i1--){
        var j = Math.floor(rand() * (i1 + 1));
        var ref;
        ref = [
            steps[j],
            steps[i1]
        ], steps[i1] = ref[0], steps[j] = ref[1], ref;
    }
    // One jog per slot, each in its own column. Letting a slot take two steps
    // allowed a +1 and a -1 to land together, which walked the route off its
    // lane and straight back onto the cell it had just left.
    //
    // The jogs are then SPREAD rather than scattered: the run is divided into one
    // bucket per jog and each jog placed somewhere inside its own bucket, which
    // leaves a straight stretch between turns. Picking slots at random let
    // several land in consecutive columns, and a route that turns in every column
    // crosses the map as a staircase — a pattern rather than a road.
    var at = new Map();
    var used = steps.slice(0, Math.min(slots, maxJogs));
    used.forEach(function(step, i) {
        var lo = Math.floor(i * slots / used.length);
        var hi = Math.max(lo + 1, Math.floor((i + 1) * slots / used.length));
        at.set(lo + Math.floor(rand() * (hi - lo)), [
            step
        ]);
    });
    var cells = [];
    var push = function(along, across) {
        return cells.push(horizontal ? {
            row: across,
            col: along
        } : {
            row: along,
            col: across
        });
    };
    var lane1 = startLane;
    for(var along = 0; along < span; along++){
        push(along, lane1);
        if (along === span - 1) break;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = (at.get(along) || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var step = _step.value;
                var next = lane1 + step;
                if (next < 0 || next >= cross) continue;
                lane1 = next;
                push(along, lane1);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return cells;
}
/**
 * Grow a pathway from a cell already on the network toward `target`.
 *
 * Aimed rather than random: growing in a random direction spends most of its
 * cells re-covering ground already beside the trunk, which left a third of the
 * map with no road within reach however large the budget got.
 */ function $57ad8bd108ea335d$var$growToward(from, target, rows, cols, taken, rand, maxLen) {
    var free = function(c) {
        return c.row >= 0 && c.col >= 0 && c.row < rows && c.col < cols && !taken.has($57ad8bd108ea335d$var$key(c.row, c.col));
    };
    var cells = [];
    var cur = from;
    var heading = null; // the way the last step went
    var run = 0; // and how far it has gone that way
    var hold = 2 + Math.floor(rand() * 3); // cells to keep a heading before turning
    for(var i = 0; i < maxLen; i++){
        var dr = Math.sign(target.row - cur.row), dc = Math.sign(target.col - cur.col);
        var byRow = {
            row: cur.row + dr,
            col: cur.col
        };
        var byCol = {
            row: cur.row,
            col: cur.col + dc
        };
        // Hold the current heading for a few cells before turning again. Choosing
        // the axis afresh every step walks a diagonal target as a staircase — a
        // turn in every single cell — which reads as a pattern, not a road.
        var order = null;
        if (heading && run < hold) {
            var keep = {
                row: cur.row + heading[0],
                col: cur.col + heading[1]
            };
            var stillHelps = heading[0] ? dr === heading[0] : dc === heading[1];
            if (stillHelps) order = [
                keep,
                byRow,
                byCol
            ];
        }
        if (!order) {
            // close the larger gap first; the occasional swap keeps tracks from all
            // turning at the same point
            var wantRowFirst = Math.abs(target.row - cur.row) > Math.abs(target.col - cur.col);
            order = (rand() < 0.8 ? wantRowFirst : !wantRowFirst) ? [
                byRow,
                byCol
            ] : [
                byCol,
                byRow
            ];
        }
        var step = order.find(function(c) {
            return (c.row !== cur.row || c.col !== cur.col) && free(c);
        });
        if (!step) break;
        var went = [
            step.row - cur.row,
            step.col - cur.col
        ];
        if (heading && went[0] === heading[0] && went[1] === heading[1]) run++;
        else {
            heading = went;
            run = 1;
        }
        cells.push(step);
        taken.add($57ad8bd108ea335d$var$key(step.row, step.col));
        cur = step;
        if (cur.row === target.row && cur.col === target.col) break;
    }
    return cells;
}
/** Remove a dead-end cell, unwiring the neighbour that pointed at it. */ function $57ad8bd108ea335d$var$dropLeaf(map, row, col) {
    var entry = map.get($57ad8bd108ea335d$var$key(row, col));
    if (!entry) return;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.keys(entry.conn)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var dir = _step.value;
            var _DIRS_dir = (0, $1788e2ed61915b1e$export$71511d61b312f219)($57ad8bd108ea335d$var$DIRS[dir], 2), dr = _DIRS_dir[0], dc = _DIRS_dir[1];
            var other = map.get($57ad8bd108ea335d$var$key(row + dr, col + dc));
            if (other) delete other.conn[$57ad8bd108ea335d$var$OPPOSITE[dir]];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    map.delete($57ad8bd108ea335d$var$key(row, col));
}
/** Record that `cell` carries road heading `dir` at `rank`. MAJOR wins ties. */ function $57ad8bd108ea335d$var$link(map, cell, dir, rank) {
    var k = $57ad8bd108ea335d$var$key(cell.row, cell.col);
    var entry = map.get(k) || {
        row: cell.row,
        col: cell.col,
        conn: {},
        rank: rank
    };
    if (dir) entry.conn[dir] = entry.conn[dir] === $57ad8bd108ea335d$export$39615881bb0d21f6 ? $57ad8bd108ea335d$export$39615881bb0d21f6 : rank;
    if (rank === $57ad8bd108ea335d$export$39615881bb0d21f6) entry.rank = $57ad8bd108ea335d$export$39615881bb0d21f6;
    map.set(k, entry);
}
function $57ad8bd108ea335d$var$linkRun(map, cells, rank) {
    for(var i = 0; i < cells.length - 1; i++){
        var dir = $57ad8bd108ea335d$var$dirBetween(cells[i], cells[i + 1]);
        if (!dir) continue;
        $57ad8bd108ea335d$var$link(map, cells[i], dir, rank);
        $57ad8bd108ea335d$var$link(map, cells[i + 1], $57ad8bd108ea335d$var$OPPOSITE[dir], rank);
    }
}
function $57ad8bd108ea335d$export$ff48eb85551f8323(rows, cols, isRoad) {
    var dist = Array.from({
        length: rows
    }, function() {
        return new Array(cols).fill(Infinity);
    });
    var queue = [];
    for(var row = 0; row < rows; row++){
        for(var col = 0; col < cols; col++)if (isRoad(row, col)) {
            dist[row][col] = 0;
            queue.push([
                row,
                col
            ]);
        }
    }
    for(var i = 0; i < queue.length; i++){
        var _queue_i = (0, $1788e2ed61915b1e$export$71511d61b312f219)(queue[i], 2), row1 = _queue_i[0], col1 = _queue_i[1];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.values($57ad8bd108ea335d$var$DIRS)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step.value, 2), dr = _step_value[0], dc = _step_value[1];
                var nr = row1 + dr, nc = col1 + dc;
                if (nr < 0 || nc < 0 || nr >= rows || nc >= cols) continue;
                if (dist[nr][nc] <= dist[row1][col1] + 1) continue;
                dist[nr][nc] = dist[row1][col1] + 1;
                queue.push([
                    nr,
                    nc
                ]);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return dist;
}
function $57ad8bd108ea335d$export$f5e4d8b41fa47b81(rows, cols, isRoad) {
    var dist = $57ad8bd108ea335d$export$ff48eb85551f8323(rows, cols, isRoad);
    var worst = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator = dist[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
            var row = _step.value;
            try {
                for(var _iterator1 = row[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                    var d = _step1.value;
                    worst = Math.max(worst, d);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return worst;
}
var $57ad8bd108ea335d$export$3099f16d77e25bd6 = 2;
var $57ad8bd108ea335d$export$32c84ffa87e816c4 = new Set([
    'start',
    'exit'
]);
/**
 * Hang pathways off the network until nothing is more than `maxDist` steps from
 * one.
 *
 * Run at generation AND again after the network is trimmed against the finished
 * grid: cutting a spur back from collapsed ground is what actually strands a
 * quarter of a map, and the generator never sees that grid.
 *
 * @param {Set} [opts.avoid]    cells a pathway may not enter — collapsed ground, water
 * @param {Set} [opts.noStopAt] cells a pathway may pass but not END on
 */ /**
 * Run one new pathway from the network to `target`.
 *
 * growToward only ever considers the two steps that close on its target, so an
 * obstruction sitting square between anchor and target stops it dead — which is
 * why this tries the nearest several road cells rather than only the nearest
 * one. Picking just the nearest meant re-trying the same hopeless pair forever
 * while a workable anchor sat a few cells along the row.
 *
 * @returns the cells laid, or null if no anchor could reach
 */ function $57ad8bd108ea335d$var$joinToNetwork(map, rows, cols, rand, target, o) {
    // Never hang a new track off off-limits ground. A campsite is approached from
    // one side and left at that; running a second track off it would turn it into
    // a route straight through.
    var anchors = (0, $4c858c0d999a5b9b$export$71511d61b312f219)(map.values()).filter(function(c) {
        return !o.avoid.has($57ad8bd108ea335d$var$key(c.row, c.col));
    }).sort(function(a, b) {
        return Math.abs(a.row - target.row) + Math.abs(a.col - target.col) - (Math.abs(b.row - target.row) + Math.abs(b.col - target.col));
    }).slice(0, 8);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = anchors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var anchor = _step.value;
            var branch = $57ad8bd108ea335d$var$growToward(anchor, target, rows, cols, o.taken, rand, o.maxLen);
            while(!o.relax && branch.length && o.noStopAt.has($57ad8bd108ea335d$var$key(branch[branch.length - 1].row, branch[branch.length - 1].col))){
                var dropped = branch.pop();
                o.taken.delete($57ad8bd108ea335d$var$key(dropped.row, dropped.col));
            }
            if (!branch.length) continue;
            $57ad8bd108ea335d$var$linkRun(map, [
                anchor
            ].concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)(branch)), $57ad8bd108ea335d$export$f23edc19d247fd25);
            return {
                anchor: anchor,
                branch: branch
            };
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
}
function $57ad8bd108ea335d$export$71e6814eda2893bd(map, rows, cols, target, taken) {
    var cameFrom = new Map([
        [
            $57ad8bd108ea335d$var$key(target.row, target.col),
            null
        ]
    ]);
    var queue = [
        target
    ];
    while(queue.length){
        var cur = queue.shift();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.values($57ad8bd108ea335d$var$DIRS)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step.value, 2), dr = _step_value[0], dc = _step_value[1];
                var row = cur.row + dr, col = cur.col + dc;
                if (row < 0 || col < 0 || row >= rows || col >= cols) continue;
                var k = $57ad8bd108ea335d$var$key(row, col);
                if (cameFrom.has(k)) continue;
                var onNetwork = map.get(k);
                if (onNetwork) {
                    var run = [];
                    for(var at = cur; at; at = cameFrom.get($57ad8bd108ea335d$var$key(at.row, at.col)))run.push(at);
                    return [
                        onNetwork
                    ].concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)(run)); // anchor, then every step up to the target
                }
                if (taken.has(k)) continue; // ground a track may not enter
                cameFrom.set(k, cur);
                queue.push({
                    row: row,
                    col: col
                });
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return null;
}
function $57ad8bd108ea335d$export$d4627e3f14810012(map, rows, cols, rand, maxDist) {
    var opts = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
    var avoid = opts.avoid || new Set();
    var noStopAt = opts.noStopAt || new Set();
    var _opts_budget;
    var budget = (_opts_budget = opts.budget) !== null && _opts_budget !== void 0 ? _opts_budget : Infinity;
    var taken = new Set((0, $4c858c0d999a5b9b$export$71511d61b312f219)(map.keys()).concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)(avoid)));
    for(var pass = 0; pass < 200; pass++){
        if (map.size >= budget) break;
        var dist = $57ad8bd108ea335d$export$ff48eb85551f8323(rows, cols, function(r, c) {
            return map.has($57ad8bd108ea335d$var$key(r, c));
        });
        var far = [];
        for(var row = 0; row < rows; row++){
            for(var col = 0; col < cols; col++)if (dist[row][col] > maxDist) far.push({
                row: row,
                col: col
            });
        }
        if (!far.length) break;
        // Aim at a cell that is not itself off-limits where possible: a track has
        // to end somewhere, and a track cannot end on ground it may not enter.
        var open = far.filter(function(c) {
            return !avoid.has($57ad8bd108ea335d$var$key(c.row, c.col));
        });
        var pool = $57ad8bd108ea335d$var$shuffle(open.length ? open : far, rand);
        // The second sweep drops the no-dead-end-beside-rubble rule. Where a corner
        // is boxed in by collapsed ground, EVERY cell that could serve it is
        // alongside that ground, and the two rules cannot both hold. A track that
        // stops short of the rubble is a smaller wrong than a corner of the map
        // nothing reaches, so coverage wins — but only after the tidy route has
        // been ruled out for every stranded cell, not the first one.
        var placed = false;
        for(var _i = 0, _iter = [
            false,
            true
        ]; _i < _iter.length; _i++){
            var relax = _iter[_i];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = pool[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var target = _step.value;
                    var laid = $57ad8bd108ea335d$var$joinToNetwork(map, rows, cols, rand, target, {
                        taken: taken,
                        avoid: avoid,
                        noStopAt: noStopAt,
                        relax: relax,
                        maxLen: maxDist + 6
                    });
                    if (!laid) continue;
                    var anchor = laid.anchor, branch = laid.branch;
                    // Having spent the rule, spend no more of it than the map needs: pull
                    // the relaxed track back off the rubble cell by cell for as long as
                    // coverage survives without it.
                    while(relax && branch.length && noStopAt.has($57ad8bd108ea335d$var$key(branch[branch.length - 1].row, branch[branch.length - 1].col))){
                        var _map_get;
                        var tip = branch[branch.length - 1];
                        var conn = (0, $fa9769297b8a68c8$export$71511d61b312f219)({}, (_map_get = map.get($57ad8bd108ea335d$var$key(tip.row, tip.col))) === null || _map_get === void 0 ? void 0 : _map_get.conn);
                        $57ad8bd108ea335d$var$dropLeaf(map, tip.row, tip.col);
                        if ($57ad8bd108ea335d$export$f5e4d8b41fa47b81(rows, cols, function(r, c) {
                            return map.has($57ad8bd108ea335d$var$key(r, c));
                        }) > maxDist) {
                            $57ad8bd108ea335d$var$linkRun(map, [
                                branch[branch.length - 2] || anchor,
                                tip
                            ], $57ad8bd108ea335d$export$f23edc19d247fd25);
                            var back = map.get($57ad8bd108ea335d$var$key(tip.row, tip.col));
                            if (back) Object.assign(back.conn, conn);
                            break;
                        }
                        taken.delete($57ad8bd108ea335d$var$key(tip.row, tip.col));
                        branch.pop();
                    }
                    placed = branch.length > 0;
                    if (placed) break;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            if (placed) break;
        }
        if (!placed) break; // nothing left that can be joined
    }
}
function $57ad8bd108ea335d$export$d1d5b8da68c444ff(rows, cols) {
    var rand = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Math.random, opts = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var avoid = opts.avoid || new Set();
    // Retry rather than steer around the entry and extraction points: they sit
    // on opposite map edges and so do the trunk's ends, so a collision is easy
    // to roll and trivial to re-roll.
    // Two things have to hold, and both are cheaper to re-roll than to steer:
    // the trunk must miss the entry and extraction points (they sit on opposite
    // map edges, and so do its ends), and its ends must be far enough apart
    // across the axis to read as a route rather than a straight line. The second
    // is not guaranteed by construction because a jog that would leave the grid
    // is dropped, which quietly eats some of the intended drift.
    var trunk = null;
    var horizontal = rand() < 0.5;
    for(var tries = 0; tries < 80; tries++){
        var orient = tries === 0 ? horizontal : rand() < 0.5;
        var candidate = $57ad8bd108ea335d$var$bisectingRoute(rows, cols, orient, rand);
        var cross = orient ? rows : cols;
        var first = candidate[0], last = candidate[candidate.length - 1];
        var spread = orient ? Math.abs(first.row - last.row) : Math.abs(first.col - last.col);
        if (spread < Math.min($57ad8bd108ea335d$export$6013c12dea2de543, cross - 1)) continue;
        if (candidate.some(function(c) {
            return avoid.has($57ad8bd108ea335d$var$key(c.row, c.col));
        })) continue;
        trunk = candidate;
        horizontal = orient;
        break;
    }
    if (!trunk) trunk = $57ad8bd108ea335d$var$bisectingRoute(rows, cols, horizontal, rand);
    var map = new Map();
    $57ad8bd108ea335d$var$linkRun(map, trunk, $57ad8bd108ea335d$export$39615881bb0d21f6);
    // The two ends run OFF the map — a highway that stops dead at the border
    // reads as a mistake rather than as a road that came from somewhere.
    var head = trunk[0], tail = trunk[trunk.length - 1];
    $57ad8bd108ea335d$var$link(map, head, horizontal ? 'w' : 'n', $57ad8bd108ea335d$export$39615881bb0d21f6);
    $57ad8bd108ea335d$var$link(map, tail, horizontal ? 'e' : 's', $57ad8bd108ea335d$export$39615881bb0d21f6);
    var _opts_maxDist, _opts_coverage;
    // Pathways branch until nothing on the map is more than MAX_ROAD_DISTANCE
    // from a road. Anchors are drawn from the whole network, not just the trunk,
    // so later branches hang off earlier ones and the far corners are not
    // stranded. The budget is only a runaway guard — the distance goal is what
    // actually stops the loop.
    $57ad8bd108ea335d$export$d4627e3f14810012(map, rows, cols, rand, (_opts_maxDist = opts.maxDist) !== null && _opts_maxDist !== void 0 ? _opts_maxDist : $57ad8bd108ea335d$export$3099f16d77e25bd6, {
        budget: Math.round(rows * cols * ((_opts_coverage = opts.coverage) !== null && _opts_coverage !== void 0 ? _opts_coverage : 0.7))
    });
    return map;
}
function $57ad8bd108ea335d$export$c7de1644901a490c(grid, rows, cols, prebuilt) {
    var block = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [], exclude = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : [];
    var net = prebuilt || $57ad8bd108ea335d$export$d1d5b8da68c444ff(rows, cols);
    var blocked = new Set(block);
    var banned = new Set(exclude);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var entry = _step.value;
            var _grid_entry_row;
            var room = grid === null || grid === void 0 ? void 0 : (_grid_entry_row = grid[entry.row]) === null || _grid_entry_row === void 0 ? void 0 : _grid_entry_row[entry.col];
            if (!room || !blocked.has(room.type)) return "continue";
            var dirs = Object.keys(entry.conn);
            var approach = dirs.find(function(d) {
                return entry.conn[d] === $57ad8bd108ea335d$export$39615881bb0d21f6;
            }) || dirs[0];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = dirs[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var dir = _step1.value;
                    if (dir === approach) continue;
                    var _DIRS_dir = (0, $1788e2ed61915b1e$export$71511d61b312f219)($57ad8bd108ea335d$var$DIRS[dir], 2), dr = _DIRS_dir[0], dc = _DIRS_dir[1];
                    var other = net.get($57ad8bd108ea335d$var$key(entry.row + dr, entry.col + dc));
                    if (other) delete other.conn[$57ad8bd108ea335d$var$OPPOSITE[dir]];
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            net.delete($57ad8bd108ea335d$var$key(entry.row, entry.col));
        };
        // A track leads up to the water's edge, or to the edge of a campsite, and
        // stops there — it does not carry on across the pond or through somebody's
        // camp. So the cell itself leaves the network and draws no road at all, while
        // the ONE neighbour it was approached from keeps pointing at it: that
        // neighbour runs its road to the shared edge and ends. Keeping a single
        // connection on the cell instead drew a stub of road onto the water.
        //
        // Neither type is ever laid on the trunk (see placeCampsite), so nothing here
        // can sever the through-route.
        for(var _iterator = (0, $4c858c0d999a5b9b$export$71511d61b312f219)(net.values())[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Cells the network may not touch at all. Collapsed ground is not somewhere
    // a road stops, the way a campsite or a shoreline is — a track running up to
    // a slab of rubble and ending still draws a road onto a tile nobody can
    // enter. Drop the cell and unwire whatever pointed at it.
    var orphans = [];
    var drop = function(entry) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.keys(entry.conn)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var dir = _step.value;
                var _DIRS_dir = (0, $1788e2ed61915b1e$export$71511d61b312f219)($57ad8bd108ea335d$var$DIRS[dir], 2), dr = _DIRS_dir[0], dc = _DIRS_dir[1];
                var other = net.get($57ad8bd108ea335d$var$key(entry.row + dr, entry.col + dc));
                if (!other) continue;
                delete other.conn[$57ad8bd108ea335d$var$OPPOSITE[dir]];
                orphans.push(other);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        net.delete($57ad8bd108ea335d$var$key(entry.row, entry.col));
    };
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = (0, $4c858c0d999a5b9b$export$71511d61b312f219)(net.values())[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var entry = _step1.value;
            var _grid_entry_row;
            var room = grid === null || grid === void 0 ? void 0 : (_grid_entry_row = grid[entry.row]) === null || _grid_entry_row === void 0 ? void 0 : _grid_entry_row[entry.col];
            if (!room || !banned.has(room.type)) continue;
            // never sever the through-route; the trunk is laid as road rooms before
            // anything else is placed, so this should be unreachable
            if (entry.rank === $57ad8bd108ea335d$export$39615881bb0d21f6) continue;
            drop(entry);
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    // Pull the rest of that spur back with it, and take any other track that
    // dead-ends beside the rubble with it. A road that stopped one tile short is
    // the same complaint one tile over, and a spur only grew that way to reach
    // ground that is now unreachable. Pruning stops at the first cell still
    // holding two ways out, so junctions and through-routes survive.
    var pruneSpurs = function() {
        while(orphans.length){
            var _grid_entry_row_entry_col, _grid_entry_row;
            var entry = orphans.pop();
            if (entry.rank === $57ad8bd108ea335d$export$39615881bb0d21f6) continue;
            if (!net.has($57ad8bd108ea335d$var$key(entry.row, entry.col))) continue;
            if (Object.keys(entry.conn).length > 1) continue;
            // a campsite or a shoreline is SUPPOSED to sit at the end of a track
            if (blocked.has(grid === null || grid === void 0 ? void 0 : (_grid_entry_row = grid[entry.row]) === null || _grid_entry_row === void 0 ? void 0 : (_grid_entry_row_entry_col = _grid_entry_row[entry.col]) === null || _grid_entry_row_entry_col === void 0 ? void 0 : _grid_entry_row_entry_col.type)) continue;
            drop(entry);
        }
    };
    var seedFromBanned = function() {
        for(var row = 0; row < rows; row++)for(var col = 0; col < cols; col++){
            var _grid_row_col, _grid_row;
            if (!banned.has(grid === null || grid === void 0 ? void 0 : (_grid_row = grid[row]) === null || _grid_row === void 0 ? void 0 : (_grid_row_col = _grid_row[col]) === null || _grid_row_col === void 0 ? void 0 : _grid_row_col.type)) continue;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.values($57ad8bd108ea335d$var$DIRS)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step.value, 2), dr = _step_value[0], dc = _step_value[1];
                    var other = net.get($57ad8bd108ea335d$var$key(row + dr, col + dc));
                    if (other) orphans.push(other);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    };
    seedFromBanned();
    pruneSpurs();
    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
    try {
        // a cell left with nothing to connect to is not on the network at all
        for(var _iterator2 = (0, $4c858c0d999a5b9b$export$71511d61b312f219)(net.entries())[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var _step_value = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step2.value, 2), k = _step_value[0], entry1 = _step_value[1];
            if (!Object.keys(entry1.conn).length) net.delete(k);
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
            }
        } finally{
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }
    // Cutting a pathway at a blocked or rest-stop cell can strand whatever lay
    // beyond it. Those cells still hold valid-looking links to each other, so
    // they would render as a length of road joined to nothing. Keep only what is
    // still reachable from the trunk.
    var roots = (0, $4c858c0d999a5b9b$export$71511d61b312f219)(net.values()).filter(function(c) {
        return c.rank === $57ad8bd108ea335d$export$39615881bb0d21f6;
    });
    var live = new Set(roots.map(function(c) {
        return $57ad8bd108ea335d$var$key(c.row, c.col);
    }));
    var queue = (0, $4c858c0d999a5b9b$export$71511d61b312f219)(roots);
    while(queue.length){
        var cur = queue.pop();
        var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
        try {
            for(var _iterator3 = Object.keys(cur.conn)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                var dir = _step3.value;
                var _DIRS_dir = (0, $1788e2ed61915b1e$export$71511d61b312f219)($57ad8bd108ea335d$var$DIRS[dir], 2), dr = _DIRS_dir[0], dc = _DIRS_dir[1];
                var k1 = $57ad8bd108ea335d$var$key(cur.row + dr, cur.col + dc);
                var next = net.get(k1);
                if (!next || live.has(k1) || !next.conn[$57ad8bd108ea335d$var$OPPOSITE[dir]]) continue;
                live.add(k1);
                queue.push(next);
            }
        } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                    _iterator3.return();
                }
            } finally{
                if (_didIteratorError3) {
                    throw _iteratorError3;
                }
            }
        }
    }
    var _iteratorNormalCompletion4 = true, _didIteratorError4 = false, _iteratorError4 = undefined;
    try {
        for(var _iterator4 = (0, $4c858c0d999a5b9b$export$71511d61b312f219)(net.entries())[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true){
            var _step_value1 = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step4.value, 2), k2 = _step_value1[0], entry2 = _step_value1[1];
            if (live.has(k2)) continue;
            var _iteratorNormalCompletion5 = true, _didIteratorError5 = false, _iteratorError5 = undefined;
            try {
                for(var _iterator5 = Object.keys(entry2.conn)[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true){
                    var dir1 = _step5.value;
                    var _DIRS_dir1 = (0, $1788e2ed61915b1e$export$71511d61b312f219)($57ad8bd108ea335d$var$DIRS[dir1], 2), dr1 = _DIRS_dir1[0], dc1 = _DIRS_dir1[1];
                    var other = net.get($57ad8bd108ea335d$var$key(entry2.row + dr1, entry2.col + dc1));
                    if (other) delete other.conn[$57ad8bd108ea335d$var$OPPOSITE[dir1]];
                }
            } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
                        _iterator5.return();
                    }
                } finally{
                    if (_didIteratorError5) {
                        throw _iteratorError5;
                    }
                }
            }
            net.delete(k2);
        }
    } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                _iterator4.return();
            }
        } finally{
            if (_didIteratorError4) {
                throw _iteratorError4;
            }
        }
    }
    seedFromBanned(); // the sweep can leave a fresh dead end by the rubble
    pruneSpurs();
    // Everything above this point REMOVES road, and between them they can strand
    // whole quarters of a map — a spur cut back from a slab of rubble takes the
    // ground it served with it. The generator laid the network out against an
    // empty grid and never sees this one, so the coverage rule has to be restored
    // here, against the map as it finally stands.
    var offLimits = new Set();
    var beside = new Set();
    for(var row = 0; row < rows; row++)for(var col = 0; col < cols; col++){
        var _grid_row_col, _grid_row;
        var type = grid === null || grid === void 0 ? void 0 : (_grid_row = grid[row]) === null || _grid_row === void 0 ? void 0 : (_grid_row_col = _grid_row[col]) === null || _grid_row_col === void 0 ? void 0 : _grid_row_col.type;
        if (!banned.has(type) && !blocked.has(type)) continue;
        offLimits.add($57ad8bd108ea335d$var$key(row, col)); // may not be entered
        if (!banned.has(type)) continue;
        var _iteratorNormalCompletion6 = true, _didIteratorError6 = false, _iteratorError6 = undefined;
        try {
            for(var _iterator6 = Object.values($57ad8bd108ea335d$var$DIRS)[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true){
                var _step_value2 = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step6.value, 2), dr2 = _step_value2[0], dc2 = _step_value2[1];
                beside.add($57ad8bd108ea335d$var$key(row + dr2, col + dc2));
            }
        } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
                    _iterator6.return();
                }
            } finally{
                if (_didIteratorError6) {
                    throw _iteratorError6;
                }
            }
        }
    }
    $57ad8bd108ea335d$export$d4627e3f14810012(net, rows, cols, Math.random, $57ad8bd108ea335d$export$3099f16d77e25bd6, {
        avoid: offLimits,
        noStopAt: beside
    });
    // A portal is a device somebody installed, not a clearing — so something
    // drove to it. Run a track right up onto the entry and extraction tiles,
    // last of all, where no later trimming can pull it back off again. The trunk
    // deliberately steers clear of both (they sit on opposite map edges and so do
    // its ends), which is exactly why they need connecting by hand.
    var taken = new Set((0, $4c858c0d999a5b9b$export$71511d61b312f219)(net.keys()).concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)(offLimits)));
    for(var row1 = 0; row1 < rows; row1++)for(var col1 = 0; col1 < cols; col1++){
        var _grid_row_col1, _grid_row1;
        if (!$57ad8bd108ea335d$export$32c84ffa87e816c4.has(grid === null || grid === void 0 ? void 0 : (_grid_row1 = grid[row1]) === null || _grid_row1 === void 0 ? void 0 : (_grid_row_col1 = _grid_row1[col1]) === null || _grid_row_col1 === void 0 ? void 0 : _grid_row_col1.type)) continue;
        if (net.has($57ad8bd108ea335d$var$key(row1, col1))) continue;
        $57ad8bd108ea335d$var$joinToNetwork(net, rows, cols, Math.random, {
            row: row1,
            col: col1
        }, {
            taken: taken,
            avoid: offLimits,
            noStopAt: new Set(),
            relax: true,
            maxLen: rows + cols
        });
        // ...and if the greedy walk could not get there, find the way properly.
        // A portal boxed in by a campsite and a shoreline has no approach that
        // closes the gap on every step, so growToward reports nothing while an
        // obvious way round sits one tile out. Measured, that left a portal with
        // no road on three maps in a thousand.
        if (net.has($57ad8bd108ea335d$var$key(row1, col1))) continue;
        var run = $57ad8bd108ea335d$export$71e6814eda2893bd(net, rows, cols, {
            row: row1,
            col: col1
        }, taken);
        if (!run) continue; // genuinely walled in; nothing to be done
        $57ad8bd108ea335d$var$linkRun(net, run, $57ad8bd108ea335d$export$f23edc19d247fd25);
        var _iteratorNormalCompletion7 = true, _didIteratorError7 = false, _iteratorError7 = undefined;
        try {
            for(var _iterator7 = run[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true){
                var cell = _step7.value;
                taken.add($57ad8bd108ea335d$var$key(cell.row, cell.col));
            }
        } catch (err) {
            _didIteratorError7 = true;
            _iteratorError7 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
                    _iterator7.return();
                }
            } finally{
                if (_didIteratorError7) {
                    throw _iteratorError7;
                }
            }
        }
    }
    var _iteratorNormalCompletion8 = true, _didIteratorError8 = false, _iteratorError8 = undefined;
    try {
        for(var _iterator8 = net.values()[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true){
            var _step_value3 = _step8.value, row2 = _step_value3.row, col2 = _step_value3.col, conn = _step_value3.conn, rank = _step_value3.rank;
            var _grid_row2;
            var room1 = grid === null || grid === void 0 ? void 0 : (_grid_row2 = grid[row2]) === null || _grid_row2 === void 0 ? void 0 : _grid_row2[col2];
            if (!room1) continue;
            room1.road = {
                n: conn.n || null,
                e: conn.e || null,
                s: conn.s || null,
                w: conn.w || null
            };
            room1.roadRank = Object.values(conn).includes($57ad8bd108ea335d$export$39615881bb0d21f6) ? $57ad8bd108ea335d$export$39615881bb0d21f6 : rank;
        }
    } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion8 && _iterator8.return != null) {
                _iterator8.return();
            }
        } finally{
            if (_didIteratorError8) {
                throw _iteratorError8;
            }
        }
    }
    // How far each tile sits from the nearest roadway, written alongside the road
    // itself and for the same reason: it has to be in hand wherever the tile is
    // drawn, and it has to survive a save. The renderer thins a recipe's
    // buildings with it, so frontage on a road is built up and the ground behind
    // it empties out — which is what settles along a route in the first place.
    //
    // Coverage keeps this within MAX_ROAD_DISTANCE for anywhere a team can walk;
    // the clamp is for the handful of cells a pathway is forbidden to reach at
    // all (collapsed ground), which are landmarks the renderer never thins.
    var dist = $57ad8bd108ea335d$export$ff48eb85551f8323(rows, cols, function(r, c) {
        return net.has($57ad8bd108ea335d$var$key(r, c));
    });
    for(var row3 = 0; row3 < rows; row3++)for(var col3 = 0; col3 < cols; col3++){
        var _grid_row3;
        var room2 = grid === null || grid === void 0 ? void 0 : (_grid_row3 = grid[row3]) === null || _grid_row3 === void 0 ? void 0 : _grid_row3[col3];
        if (room2) room2.roadDist = Math.min(dist[row3][col3], $57ad8bd108ea335d$export$3099f16d77e25bd6);
    }
    return net;
}


var $3c042d4e8c9507db$export$9e15ff8aa6bc996f = 120; // authoring grid, in units
var $3c042d4e8c9507db$export$fae5d17304677194 = 1; // device px per unit
var $3c042d4e8c9507db$export$3175e1b22a5f59e8 = $3c042d4e8c9507db$export$9e15ff8aa6bc996f * $3c042d4e8c9507db$export$fae5d17304677194; // 120 — the canvas a tile is drawn into
var $3c042d4e8c9507db$export$a7e851dd01b7bece = $3c042d4e8c9507db$export$3175e1b22a5f59e8; // PNG export size (image lab)
// How close to the tile edge a structure may be drawn. A roof clipped by the
// canvas reads as a rendering fault rather than as a building continuing into
// the next tile, because the neighbour draws its own recipe and never
// continues it — so structures are held short of the join instead.
var $3c042d4e8c9507db$var$TILE_CLAMP = 6;
var $3c042d4e8c9507db$export$3d672f2aedd16af9 = 40; // world units across one tile
var $3c042d4e8c9507db$export$a4097a0a1d4593d2 = 2; // world units per effect cell
var $3c042d4e8c9507db$var$FX_PX = $3c042d4e8c9507db$export$3175e1b22a5f59e8 / $3c042d4e8c9507db$export$3d672f2aedd16af9; // device px per world unit
var $3c042d4e8c9507db$export$6915278477114e25 = (0, $980f67465e309611$export$1a6ba7df4555a8dd).defaultTune;
var $3c042d4e8c9507db$export$d4f789780201d4a = (0, $980f67465e309611$export$1a6ba7df4555a8dd).regions;
var $3c042d4e8c9507db$export$a571935592b1ff4d = (0, $980f67465e309611$export$1a6ba7df4555a8dd).recipes;
var $3c042d4e8c9507db$export$73b3f97728261c35 = (0, $980f67465e309611$export$1a6ba7df4555a8dd).skillAnchors || {};
var $3c042d4e8c9507db$var$FALLBACK_THEME = $3c042d4e8c9507db$export$d4f789780201d4a['shard-cities'];
var $3c042d4e8c9507db$export$ea4f1160001ec0c0 = {
    scattered: {
        scale: 65,
        stretch: 1,
        sharp: 2.2,
        maxA: 0.40,
        thr: function(c) {
            return 0.78 - c * 0.50;
        }
    },
    broken: {
        scale: 100,
        stretch: 1,
        sharp: 2.8,
        maxA: 0.42,
        thr: function(c) {
            return 0.72 - c * 0.45;
        }
    },
    overcast: {
        scale: 130,
        stretch: 1.2,
        sharp: 1.2,
        maxA: 0.30,
        thr: function(c) {
            return 0.85 - c * 0.65;
        }
    },
    wispy: {
        scale: 75,
        stretch: 3.5,
        sharp: 1.6,
        maxA: 0.24,
        thr: function(c) {
            return 0.75 - c * 0.45;
        }
    }
};
// ===============================
// RECIPE SELECTION (pure, Node-safe)
// ===============================
// Ordered: first match against the lowercased room name wins. Short tokens
// that hide inside other words (lock in "block", hive in "archive", vent in
// "inventory") are anchored with \b.
//
// The order runs from what a name tells you MOST about how the tile looks from
// above, down to what it tells you least.
//
// Room names are built as "<place> <fitting> <sector>" — Arcade Shutter Sector,
// Marketfront Depot, Habitation Annex Gate — and every region names all four of
// its gates that way. With the fitting tokens above the place tokens, a name
// resolved to whatever was bolted to it: every gate in the game came out as
// `security`, `depot` beat `market`, `shutter` beat `arcade`, and `commerce`
// went from being a whole recipe to being drawn three times in sixty rooms
// while `security` and `storage` took a third of the map between them.
//
// Reading down: a reactor is unmistakable. A substation, an archive, a
// shopfront and a housing block each have their own architecture and keep it
// even in ruin. Then `environmental` — because a collapse or a breach REPLACES
// what was there with rubble and weeds, and that is louder than the two uses
// below it: a yard and a deck are generic enough that the damage is the more
// legible thing on the tile. `security` is the lowest real match because a
// checkpoint is the most portable fitting of the lot, and gateEmphasis dresses
// a gate tile as a gate whatever recipe it draws — so nothing is lost by
// letting the arcade underneath it show through. `infrastructure` is the
// catch-all and stays last.
var $3c042d4e8c9507db$var$KEYWORD_RECIPES = [
    [
        /reactor/,
        'reactor'
    ],
    [
        /substation|transformer|\bpower|switchgear|feeder|breaker|boiler|volt|generat|energy/,
        'power'
    ],
    [
        /record|archive|ledger|librar|registr/,
        'records'
    ],
    // `commerc`, not `commerce`: "Commercial Airlock Sector" shares no prefix
    // with the noun, and matched `airlock` instead for want of two letters.
    [
        /market|arcade|commissary|canteen|commerc|plaza|\bmart\b|\bshop|finance|teller|retail/,
        'commerce'
    ],
    [
        /apartment|housing|habitat|barrack|residential|nursery|dorm|\bliving/,
        'habitation'
    ],
    [
        /fungal|spore|breach|ruptur|\bleak|collapse|salvage|scrap|hazard|firebreak|isolation|cleanup|containment|\bwild|\bhive\b|observation/,
        'environmental'
    ],
    [
        /skybridge|overpass|interchange|\brail|transit|causeway|skyway/,
        'transit'
    ],
    [
        /silo|\bseed|storage|depot|vault|supply|inventory|cache|pantry|warehouse|freight|cargo/,
        'storage'
    ],
    [
        /checkpoint|security|barricade|barrier|perimeter|\block\b|\bseal|airlock|turnstile|shutter|decon|\bgate/,
        'security'
    ],
    [
        /relay|junction|conduit|spine|network|maintenance|control|operations|\bhub\b|assembl|conveyor|logistic|crane|drydock|\bdock|intake|\bvent|tower|\blift\b|access/,
        'infrastructure'
    ]
];
var $3c042d4e8c9507db$var$CATEGORY_RECIPES = {
    power: 'power',
    storage: 'storage',
    security: 'security',
    infrastructure: 'infrastructure',
    environmental: 'environmental',
    wildlife: 'environmental'
};
var $3c042d4e8c9507db$var$TYPE_RECIPES = {
    start: 'portal',
    exit: 'portal',
    road: 'road',
    water: 'water',
    campsite: 'campsite',
    blocked: 'blocked'
};
function $3c042d4e8c9507db$export$5f148632ad7917b2() {
    var roomName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '', category = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : '', type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : '';
    if ($3c042d4e8c9507db$var$TYPE_RECIPES[type]) return $3c042d4e8c9507db$var$TYPE_RECIPES[type];
    var name = String(roomName).toLowerCase();
    if (name === 'entry' || name === 'exit') return 'portal';
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $3c042d4e8c9507db$var$KEYWORD_RECIPES[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step.value, 2), re = _step_value[0], recipe = _step_value[1];
            if (re.test(name)) return recipe;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return $3c042d4e8c9507db$var$CATEGORY_RECIPES[category] || 'infrastructure';
}
// ===============================
// PIXEL HELPERS
// ===============================
// Shadow-casting content is rendered in two passes over identical rng
// streams: pass 1 (SHADOW_PASS) lets only the shadow helpers paint, so
// every shadow lands on the bare ground; pass 2 suppresses the shadow
// helpers and paints the objects on top. That way one object's shadow can
// never fall across a neighboring object (same idea as the lake banks).
var $3c042d4e8c9507db$var$SHADOW_PASS = false;
var $3c042d4e8c9507db$var$IN_SHADOW = false;
function $3c042d4e8c9507db$var$castShadow(fn) {
    $3c042d4e8c9507db$var$IN_SHADOW = true;
    fn();
    $3c042d4e8c9507db$var$IN_SHADOW = false;
}
// ---- static / dynamic split ----
// Almost all of a tile sits perfectly still: floor, roads, structures,
// weathering. Only a handful of things move between frames — swaying
// canopies, lamp strobes, flame and portal glow, pond crests — and those are
// wrapped in dynamic(). During a STATIC render the wrapped closures are
// RECORDED instead of drawn, so the cached layer holds only the still parts;
// the animation loop then replays that short list over a blit of the cache
// every frame (see composite). Recording rather than re-running the recipe
// interpreter is the point: the interpreter's rng streams and element
// dispatch cost as much as the painting does.
//
// A recorded closure takes (g, T) so replay can hand it the live context and
// the day-tinted palette; it must not touch the rng, or the tile's layout
// would drift every frame. Resolve anything seeded BEFORE the wrapper and
// capture it. A one-shot drawRoomTile leaves DYN null and the closures run
// inline against CUR_G/CUR_T, which is what the image lab still does.
var $3c042d4e8c9507db$var$DYN = null; // recording target during a static render
var $3c042d4e8c9507db$var$CUR_G = null, $3c042d4e8c9507db$var$CUR_T = null; // inline target when not recording
function $3c042d4e8c9507db$var$dynamic(fn) {
    if ($3c042d4e8c9507db$var$SHADOW_PASS) return; // pass 1 replays the same stream; record once
    if ($3c042d4e8c9507db$var$DYN) $3c042d4e8c9507db$var$DYN.push(fn);
    else fn($3c042d4e8c9507db$var$CUR_G, $3c042d4e8c9507db$var$CUR_T);
}
/**
 * A small offscreen surface for pre-rasterising something that will be blitted
 * many times rather than redrawn.
 *
 * A detached <canvas>, deliberately, and NOT an OffscreenCanvas. The two are
 * interchangeable here and OffscreenCanvas is the tidier object — it carries no
 * DOM node, and a wooded tier-3 grid asks for a couple of thousand of these —
 * but as a drawImage SOURCE it is three times slower on a browser that
 * GPU-accelerates canvas (11.2ms a frame against 3.7ms, same count, same
 * sizes, same draws). A main-thread OffscreenCanvas does not get the same
 * accelerated backing, so every blit pays to fetch the pixels. Browsers that
 * rasterise canvas in software show no difference at all, which is exactly why
 * this is worth a comment: it is invisible in the wrong environment.
 */ function $3c042d4e8c9507db$var$scratchCanvas(w, h) {
    var c = document.createElement('canvas');
    c.width = w;
    c.height = h;
    return c;
}
// ---- above the weather ----
// A second recording channel, replayed AFTER the world-space effects instead of
// before them. Almost nothing belongs here: clouds and daylight shafts are the
// air of the place and should fall on everything the tile contains.
//
// The exception is anything that is not IN the room but over it. A sublevel's
// rock masses are a cutaway through stone that runs up to the cavern roof, so a
// shaft of daylight crossing one would be light passing through the ceiling.
// Recorded rather than drawn in place because the sampling that finds the rock
// is expensive and the fills are not — this replays a few dozen rects a frame
// off work done once per still-layer repaint.
var $3c042d4e8c9507db$var$OVER = null;
// Where the tile's GROUND PLAN is collected during a static render, on the same
// pattern as DYN and OVER above: composeBody fills it in if somebody put one
// here, and ignores it otherwise. The renderer already measures every footprint
// it draws in order to route roads and keep vegetation off roofs — this just
// stops that knowledge being thrown away at the end of the pass, so the raid
// team can be kept off the roofs as well as the shrubbery.
var $3c042d4e8c9507db$var$PLAN = null;
/**
 * Record `fn` to be replayed above the effects, or — when nobody is collecting —
 * draw it into `g`/`T` right now.
 *
 * The fallback target is passed in rather than read from CUR_G/CUR_T the way
 * dynamic() does it. Both of the real paths always collect, so that pair is
 * only ever whatever the LAST inline render happened to leave behind, and a
 * caller outside those paths would silently paint into a stale canvas.
 */ function $3c042d4e8c9507db$var$overhead(g, T, fn) {
    if ($3c042d4e8c9507db$var$SHADOW_PASS) return; // same reason as dynamic: record once
    if ($3c042d4e8c9507db$var$OVER) $3c042d4e8c9507db$var$OVER.push(fn);
    else fn(g, T);
}
/**
 * A graphics object that draws nothing and remembers where it would have.
 *
 * Element functions draw straight from the rng, so an element that is going to
 * be measured or suppressed still has to RUN — skipping the call outright would
 * shift the stream for everything after it and reshuffle the whole tile. It
 * runs into this instead of into the canvas.
 *
 * Measuring beats declaring: a hand-written "this recipe's building sits here"
 * table is a second copy of the art's coordinates, and the two drift the first
 * time anyone edits a recipe.
 */ function $3c042d4e8c9507db$var$makeProbeG() {
    var box = {
        x0: Infinity,
        y0: Infinity,
        x1: -Infinity,
        y1: -Infinity
    };
    var add = function(x, y, w, h, s) {
        box.x0 = Math.min(box.x0, x / s);
        box.y0 = Math.min(box.y0, y / s);
        box.x1 = Math.max(box.x1, (x + w) / s);
        box.y1 = Math.max(box.y1, (y + h) / s);
    };
    return {
        box: box,
        r: function(x, y, w, h) {
            if ($3c042d4e8c9507db$var$SHADOW_PASS !== $3c042d4e8c9507db$var$IN_SHADOW) return;
            add(x | 0, y | 0, w | 0, h | 0, 1);
        },
        p: function(x, y, w, h) {
            if ($3c042d4e8c9507db$var$SHADOW_PASS !== $3c042d4e8c9507db$var$IN_SHADOW) return;
            add(x | 0, y | 0, w | 0, h | 0, $3c042d4e8c9507db$export$fae5d17304677194);
        },
        a: function(alpha, fn) {
            fn();
        }
    };
}
function $3c042d4e8c9507db$var$makeG(ctx) {
    return {
        ctx: ctx,
        // authoring units — the whole element library draws through this
        r: function(x, y, w, h, c) {
            if ($3c042d4e8c9507db$var$SHADOW_PASS !== $3c042d4e8c9507db$var$IN_SHADOW) return;
            ctx.fillStyle = c;
            ctx.fillRect((x | 0) * $3c042d4e8c9507db$export$fae5d17304677194, (y | 0) * $3c042d4e8c9507db$export$fae5d17304677194, (w | 0) * $3c042d4e8c9507db$export$fae5d17304677194, (h | 0) * $3c042d4e8c9507db$export$fae5d17304677194);
        },
        // device pixels, for detail finer than the authoring grid
        p: function(x, y, w, h, c) {
            if ($3c042d4e8c9507db$var$SHADOW_PASS !== $3c042d4e8c9507db$var$IN_SHADOW) return;
            ctx.fillStyle = c;
            ctx.fillRect(x | 0, y | 0, w | 0, h | 0);
        },
        a: function(alpha, fn) {
            ctx.globalAlpha = alpha;
            fn();
            ctx.globalAlpha = 1;
        }
    };
}
// Speckle at DEVICE resolution: the base tone laid down in units, the grain
// scattered in device pixels. Coverage matches what the old unit-space
// dither gave, so surfaces read the same from across the map and gain
// texture up close. SPECK trades grain size against fillRect count — 2px
// specks are still a third the size of the old unit-grid blocks and cost a
// quarter of what 1px ones would on the roads, which are the widest dithered
// areas left now that floors go through grain().
var $3c042d4e8c9507db$var$SPECK = 2;
function $3c042d4e8c9507db$var$dither(g, rng, x, y, w, h, c1, c2) {
    var density = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : 0.2;
    g.r(x, y, w, h, c1);
    var n = Math.floor(w * h * $3c042d4e8c9507db$export$fae5d17304677194 * $3c042d4e8c9507db$export$fae5d17304677194 * density / ($3c042d4e8c9507db$var$SPECK * $3c042d4e8c9507db$var$SPECK));
    for(var i = 0; i < n; i++)g.p((x + rng() * w) * $3c042d4e8c9507db$export$fae5d17304677194, (y + rng() * h) * $3c042d4e8c9507db$export$fae5d17304677194, $3c042d4e8c9507db$var$SPECK, $3c042d4e8c9507db$var$SPECK, c2);
}
var $3c042d4e8c9507db$var$hexRGB = function(hex) {
    return [
        parseInt(hex.slice(1, 3), 16),
        parseInt(hex.slice(3, 5), 16),
        parseInt(hex.slice(5, 7), 16)
    ];
};
/**
 * A palette colour taken down, and optionally toward grey — for material that
 * is the same stuff as its neighbour but in a different state. `k` scales
 * brightness; `grey` (0..1) pulls the channels toward the colour's own
 * luminance, which is what turns a brown into charcoal rather than into a
 * darker brown. Memoised: this runs per element, per tile, per repaint.
 */ var $3c042d4e8c9507db$var$shadeCache = new Map();
function $3c042d4e8c9507db$var$shade(hex, k) {
    var grey = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    var key = "".concat(hex, "|").concat(k, "|").concat(grey);
    var out = $3c042d4e8c9507db$var$shadeCache.get(key);
    if (out) return out;
    var _hexRGB = (0, $1788e2ed61915b1e$export$71511d61b312f219)($3c042d4e8c9507db$var$hexRGB(hex), 3), r = _hexRGB[0], g = _hexRGB[1], b = _hexRGB[2];
    var lum = 0.3 * r + 0.59 * g + 0.11 * b;
    var ch = function(c) {
        return Math.max(0, Math.min(255, Math.round((c * (1 - grey) + lum * grey) * k)));
    };
    $3c042d4e8c9507db$var$shadeCache.set(key, out = "#".concat([
        ch(r),
        ch(g),
        ch(b)
    ].map(function(c) {
        return c.toString(16).padStart(2, '0');
    }).join('')));
    return out;
}
// Full-tile floor grain, written straight into an ImageData buffer. The
// ground is 100% of a tile's area, so it is where added resolution shows
// first — 3x3 blocks of flat color read as an upscale, per-pixel grain reads
// as dirt. Scattering 14k 1px fillRects would cost more than the entire rest
// of the tile; one buffer write costs almost nothing.
var $3c042d4e8c9507db$var$grainBuf = null; // one scratch buffer: putImageData copies out of it
function $3c042d4e8c9507db$var$grain(g, rng, c1, c2, density) {
    if ($3c042d4e8c9507db$var$SHADOW_PASS !== $3c042d4e8c9507db$var$IN_SHADOW) return;
    var img = $3c042d4e8c9507db$var$grainBuf || ($3c042d4e8c9507db$var$grainBuf = new ImageData($3c042d4e8c9507db$export$3175e1b22a5f59e8, $3c042d4e8c9507db$export$3175e1b22a5f59e8));
    var d = img.data;
    var _hexRGB = (0, $1788e2ed61915b1e$export$71511d61b312f219)($3c042d4e8c9507db$var$hexRGB(c1), 3), r1 = _hexRGB[0], g1 = _hexRGB[1], b1 = _hexRGB[2], _hexRGB1 = (0, $1788e2ed61915b1e$export$71511d61b312f219)($3c042d4e8c9507db$var$hexRGB(c2), 3), r2 = _hexRGB1[0], g2 = _hexRGB1[1], b2 = _hexRGB1[2];
    for(var i = 0, o = 0; i < $3c042d4e8c9507db$export$3175e1b22a5f59e8 * $3c042d4e8c9507db$export$3175e1b22a5f59e8; i++, o += 4){
        var speck = rng() < density;
        d[o] = speck ? r2 : r1;
        d[o + 1] = speck ? g2 : g1;
        d[o + 2] = speck ? b2 : b1;
        d[o + 3] = 255;
    }
    g.ctx.putImageData(img, 0, 0);
}
var $3c042d4e8c9507db$var$ri = function(rng, min, max) {
    return min + Math.floor(rng() * (max - min + 1));
};
// ===============================
// SHARED ELEMENT LIBRARY
// ===============================
// Broken chunks with a lit top edge — on the old 3px grid a chunk WAS one
// block, so it could only ever be a dot.
/**
 * One hole in the ground: shadowed lip, the far dark below, and a crumbling rim
 * catching the light. Shared by the sinkhole and the chasm — they differ only
 * in how many of these there are and where.
 */ function $3c042d4e8c9507db$var$voidPit(g, rng, T, cx, cy, r) {
    var left = $3c042d4e8c9507db$var$wobbler(rng), right = $3c042d4e8c9507db$var$wobbler(rng);
    $3c042d4e8c9507db$var$blob(g, cx, cy, r + 3, T.structDark, left, right); // crumbling rim
    g.a(0.3, function() {
        return $3c042d4e8c9507db$var$blob(g, cx, cy, r + 2, T.structLight, left, right);
    });
    $3c042d4e8c9507db$var$blob(g, cx, cy, r, T.far, left, right); // the ground below
    g.a(0.6, function() {
        return $3c042d4e8c9507db$var$blob(g, cx, cy, Math.max(2, r - 6), '#000000', left, right);
    });
}
function $3c042d4e8c9507db$var$rubbleChunk(g, rng, T, x, y) {
    var c = [
        T.structDark,
        T.metal,
        T.struct
    ][$3c042d4e8c9507db$var$ri(rng, 0, 2)];
    var w = $3c042d4e8c9507db$var$ri(rng, 2, 6), h = $3c042d4e8c9507db$var$ri(rng, 1, 3);
    g.r(Math.round(x), Math.round(y), w, h, c);
    if (h > 1) g.r(Math.round(x), Math.round(y), w, 1, T.structLight);
}
function $3c042d4e8c9507db$var$rubble(g, rng, T, x1, x2, y1, y2) {
    var n = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : 12;
    for(var i = 0; i < n; i++)$3c042d4e8c9507db$var$rubbleChunk(g, rng, T, $3c042d4e8c9507db$var$ri(rng, x1, x2), $3c042d4e8c9507db$var$ri(rng, y1, y2));
}
// A hairline that wanders a pixel at a time. This is the clearest single
// example of what the finer grid bought: the same call used to lay down a
// chain of 3x3 blocks.
function $3c042d4e8c9507db$var$crack(g, rng, T, x, y) {
    var len = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 10;
    var cx = x, cy = y;
    for(var i = 0; i < len; i++){
        g.r(cx, cy, 1, 1, T.road);
        cx += $3c042d4e8c9507db$var$ri(rng, -1, 1);
        cy += $3c042d4e8c9507db$var$ri(rng, 0, 1);
    }
}
function $3c042d4e8c9507db$var$foliageClump(g, rng, T, x, y) {
    var size = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 5;
    for(var i = 0; i < size; i++)g.r(x + $3c042d4e8c9507db$var$ri(rng, -6, 6), y - $3c042d4e8c9507db$var$ri(rng, 0, 9), $3c042d4e8c9507db$var$ri(rng, 5, 9), 5, T.veg1);
    for(var i1 = 0; i1 < Math.ceil(size / 2); i1++)g.r(x + $3c042d4e8c9507db$var$ri(rng, -6, 3), y - $3c042d4e8c9507db$var$ri(rng, 3, 9), $3c042d4e8c9507db$var$ri(rng, 3, 6), 3, T.veg2);
    for(var i2 = 0; i2 < size; i2++)g.r(x + $3c042d4e8c9507db$var$ri(rng, -5, 5), y - $3c042d4e8c9507db$var$ri(rng, 0, 8), 1, 1, T.veg2);
}
// ===============================
// TOP-DOWN STYLE
// ===============================
// Map tiles viewed from above. Connectivity comes from two rules: floors are
// full-cell fills whose detail lines sit at fixed offsets (so they continue
// across cells), and road/path connectors always run from the cell center to
// the edge midpoint at a fixed width — two adjacent cells that both draw a
// connector on their shared edge meet exactly. No vignette, no sky.
function $3c042d4e8c9507db$var$disc(g, cx, cy, r, c) {
    for(var dy = -r; dy <= r; dy++){
        var dx = Math.floor(Math.sqrt(r * r - dy * dy));
        g.r(cx - dx, cy + dy, 2 * dx + 1, 1, c);
    }
}
function $3c042d4e8c9507db$var$ringO(g, cx, cy, r, c) {
    for(var dy = -r; dy <= r; dy++){
        var dx = Math.round(Math.sqrt(r * r - dy * dy));
        g.r(cx - dx, cy + dy, 1, 1, c);
        g.r(cx + dx, cy + dy, 1, 1, c);
    }
}
// How coarsely a pre-rasterised sprite tracks the daylight. Anything cached
// across frames has to be rebuilt when the palette under it moves, and `light`
// moves continuously — tintPalette alone buckets it 512 ways, which over a
// ten-minute day is a fresh palette every half second and so no cache at all.
//
// 16 steps rebuilds roughly twice a game minute and cannot be seen: the tint
// scales a channel by 0.30 + 0.70q, so quantising q to 1/16 moves a mid-toned
// leaf by under a level and a half out of 255 — inside the rounding difference
// that already exists between tinting a colour and multiplying a pixel.
var $3c042d4e8c9507db$var$TINT_STEPS = 16;
// ...but every sprite on the map crossing the SAME step on the same frame is
// its own problem: a wooded tier-3 grid rebuilds ~1500 canopies at once, which
// measured at 227k fillRects in a single frame — worse, in one hitch, than the
// per-frame cost the sprites were introduced to remove. So each sprite is given
// a fixed fraction of a step to cross on instead, spreading the rebuilds evenly
// across the whole step. The count of them over a day is unchanged; only the
// clumping goes. The offset is derived from position so it is stable across
// reloads, and costs at most one extra step of tint error between neighbours,
// which is the same level-and-a-half nobody can see.
var $3c042d4e8c9507db$var$TINT_SPREAD = 16;
var $3c042d4e8c9507db$var$tintPhase = function(x, y) {
    return (x * 7 + y * 13) % $3c042d4e8c9507db$var$TINT_SPREAD / $3c042d4e8c9507db$var$TINT_SPREAD;
};
// Animation state for the current draw call, set once per render like
// SHADOW below. wind (0..1) sways tree canopies; t is elapsed seconds and
// phases the sway per tree; lamp (0..1) is how lit the powered lights are —
// it ramps up at dusk and back down at dawn. Zero when rendering static
// tiles. tintScale is the daylight on the sprite-cache scale above — a cache
// floors it with its own tintPhase offset to decide whether to rebuild.
var $3c042d4e8c9507db$var$ANIM = {
    wind: 0,
    t: 0,
    lamp: 0,
    lightUptime: 0.12,
    lightSpeed: 1,
    tintScale: $3c042d4e8c9507db$var$TINT_STEPS
};
// Drop shadows give top-down structures depth and lift them off the floor.
// The direction comes from tune.shadowAngle, set once per render — rendering
// is synchronous, so module state is safe here and keeps element signatures
// free of tune plumbing.
var $3c042d4e8c9507db$var$SHADOW = {
    dx: 1,
    dy: 1
};
// dist grows when the sun is low (dawn/dusk) so shadow length conveys the
// time of day, not just its direction. alpha comes from tune.shadowAlpha.
// The offset is quantized to SHADOW_STEP pixels rather than following the
// finer art grid, for two reasons: a shadow that creeps a pixel at a time
// reads as jitter, and the cached still layer is keyed on this offset — at
// 1px granularity every tile would repaint three times as often (staticKey).
var $3c042d4e8c9507db$var$SHADOW_STEP = 3;
function $3c042d4e8c9507db$var$setShadowAngle(angleDeg) {
    var dist = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1.4, alpha = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0.6;
    var a = angleDeg * Math.PI / 180;
    $3c042d4e8c9507db$var$SHADOW = {
        dx: Math.round(Math.cos(a) * dist) * $3c042d4e8c9507db$var$SHADOW_STEP,
        dy: Math.round(Math.sin(a) * dist) * $3c042d4e8c9507db$var$SHADOW_STEP,
        a: alpha
    };
}
function $3c042d4e8c9507db$var$dropShadow(g, T, x, y, w, h) {
    $3c042d4e8c9507db$var$castShadow(function() {
        return g.a($3c042d4e8c9507db$var$SHADOW.a, function() {
            return g.r(x + $3c042d4e8c9507db$var$SHADOW.dx, y + $3c042d4e8c9507db$var$SHADOW.dy, w, h, T.far);
        });
    });
}
/**
 * A smooth loop of seeded wobble: t in [0,1] around the shape, returning a
 * radius multiplier near 1. Wraps, so the outline closes without a seam.
 */ function $3c042d4e8c9507db$var$wobbler(rng) {
    var knots = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 5, amount = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0.2;
    var k = Array.from({
        length: knots
    }, function() {
        return 1 + (rng() * 2 - 1) * amount;
    });
    return function(t) {
        var x = Math.max(0, Math.min(0.9999, t)) * knots, i = Math.floor(x), f = x - i;
        var s = f * f * (3 - 2 * f); // smoothstep between knots
        return k[i % knots] + (k[(i + 1) % knots] - k[i % knots]) * s;
    };
}
/**
 * An irregular disc, scanline by scanline: each side's half-width is scaled by
 * its own wobble, so a pond or a sinkhole reads as something that formed rather
 * than something drawn with a compass. Same shape of loop as disc(), so the two
 * can be nested to build a bank or a rim that follows the outline.
 */ function $3c042d4e8c9507db$var$blob(g, cx, cy, r, c, left, right) {
    for(var dy = -r; dy <= r; dy++){
        var t = (dy + r) / (2 * r);
        var base = Math.sqrt(Math.max(0, r * r - dy * dy));
        var l = Math.round(base * left(t)), rr = Math.round(base * right(t));
        if (l + rr < 1) continue;
        g.r(cx - l, cy + dy, l + rr + 1, 1, c);
    }
}
/** Half-widths of a blob on a given scanline — what the wave crests ride on. */ function $3c042d4e8c9507db$var$blobSpan(r, dy, left, right) {
    var t = (dy + r) / (2 * r);
    var base = Math.sqrt(Math.max(0, r * r - dy * dy));
    return [
        Math.round(base * left(t)),
        Math.round(base * right(t))
    ];
}
function $3c042d4e8c9507db$var$discShadow(g, T, cx, cy, r) {
    $3c042d4e8c9507db$var$castShadow(function() {
        return g.a($3c042d4e8c9507db$var$SHADOW.a, function() {
            return $3c042d4e8c9507db$var$disc(g, cx + $3c042d4e8c9507db$var$SHADOW.dx, cy + $3c042d4e8c9507db$var$SHADOW.dy, r, T.far);
        });
    });
}
// Pulse 0..1 for light sources (portals, fires, lamps, fungi). Phase comes
// from the light's position so neighbors don't blink in unison; a fixed 0.5
// when not animating so static renders keep today's look.
function $3c042d4e8c9507db$var$flicker(cx, cy) {
    var speed = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 6;
    return $3c042d4e8c9507db$var$ANIM.t ? 0.5 + 0.5 * Math.sin($3c042d4e8c9507db$var$ANIM.t * speed + cx * 3.1 + cy * 1.7) : 0.5;
}
// The grid is failing: a powered light is DARK most of the time, then a
// power surge hits and it strobes rapidly for a moment before dying again.
// tune.lightUptime sets how often the surges come, tune.lightFlickerSpeed
// the strobe rate; the seed staggers the schedule so tiles don't blink
// together. Zero when static — the dead grid is the daytime look too.
function $3c042d4e8c9507db$var$powerFlicker(seed) {
    if (!$3c042d4e8c9507db$var$ANIM.t) return 0;
    var n = $3c042d4e8c9507db$var$smoothNoise($3c042d4e8c9507db$var$ANIM.t * 0.9 + seed * 13.7, seed * 7.3);
    if (n < 1 - $3c042d4e8c9507db$var$ANIM.lightUptime) return 0; // dead, most of the time
    var s = Math.sin($3c042d4e8c9507db$var$ANIM.t * 55 * $3c042d4e8c9507db$var$ANIM.lightSpeed + seed * 9);
    return s > -0.25 ? 0.95 : 0.1; // rapid surge strobe
}
// Soft tonal patches that break up flat floors without disturbing edge
// continuity (same tones as the floor itself).
function $3c042d4e8c9507db$var$mottle(g, rng, c) {
    var n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 3, alpha = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0.12;
    for(var i = 0; i < n; i++)g.a(alpha, function() {
        return $3c042d4e8c9507db$var$disc(g, $3c042d4e8c9507db$var$ri(rng, 6, 111), $3c042d4e8c9507db$var$ri(rng, 6, 111), $3c042d4e8c9507db$var$ri(rng, 12, 21), c);
    });
}
/**
 * A plant's own green: a shade down from the palette's, and nudged warm or cool
 * per plant.
 *
 * DOWN, because the ground it stands on is drawn from the same two greens — a
 * canopy over a patch of grass was the same colour as the grass and dissolved
 * into it. The shift moves red and blue in opposite directions and leaves green
 * alone, which walks along the green arc of the wheel — toward olive one way,
 * toward pine the other — rather than off it. Where a region's own vegetation
 * is already a dry khaki the guard does nothing and it stays khaki; all it
 * stops is a shift turning a green into something that is not one.
 *
 * `hue` is quantised by the caller so this memoises against a bounded key set:
 * it is called per plant, per frame, on the animated canopies.
 */ var $3c042d4e8c9507db$var$LEAF_DARKEN = 0.85, $3c042d4e8c9507db$var$LEAF_HUE = 0.22;
/**
 * The canopy's own outline, a shade under its body. Two greens of similar
 * weight sitting on each other — a crown over the grass it is growing out of —
 * have no edge between them to read, and no amount of darkening the whole tree
 * fixes that because the grass moves with it. A rim does: it is a boundary
 * rather than a contrast.
 */ var $3c042d4e8c9507db$var$LEAF_RIM = 0.58;
var $3c042d4e8c9507db$var$leafCache = new Map();
function $3c042d4e8c9507db$export$b2a4daa97bd45a21(hex, hue) {
    var dark = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $3c042d4e8c9507db$var$LEAF_DARKEN;
    var key = "".concat(hex, "|").concat(hue, "|").concat(dark);
    var out = $3c042d4e8c9507db$var$leafCache.get(key);
    if (out) return out;
    var _hexRGB = (0, $1788e2ed61915b1e$export$71511d61b312f219)($3c042d4e8c9507db$var$hexRGB(hex), 3), r = _hexRGB[0], g = _hexRGB[1], b = _hexRGB[2];
    var ch = function(v) {
        return Math.max(0, Math.min(255, Math.round(v * dark)));
    };
    var ng = ch(g);
    var nr = ch(r * (1 + hue * $3c042d4e8c9507db$var$LEAF_HUE));
    var nb = ch(b * (1 - hue * $3c042d4e8c9507db$var$LEAF_HUE));
    if (r <= g) nr = Math.min(nr, ng); // a green stays a green
    $3c042d4e8c9507db$var$leafCache.set(key, out = "#".concat([
        nr,
        ng,
        nb
    ].map(function(c) {
        return c.toString(16).padStart(2, '0');
    }).join('')));
    return out;
}
/** Nine steps of warm-to-cool, so leafTone's cache stays small. */ var $3c042d4e8c9507db$var$LEAF_STEPS = 4;
var $3c042d4e8c9507db$var$leafHue = function(rng) {
    return $3c042d4e8c9507db$var$ri(rng, -$3c042d4e8c9507db$var$LEAF_STEPS, $3c042d4e8c9507db$var$LEAF_STEPS) / $3c042d4e8c9507db$var$LEAF_STEPS;
};
function $3c042d4e8c9507db$export$f26d486e6e8aa256(T) {
    var out = new Set();
    for(var k = -$3c042d4e8c9507db$var$LEAF_STEPS; k <= $3c042d4e8c9507db$var$LEAF_STEPS; k++)for(var _i = 0, _iter = [
        T.veg1,
        T.veg2
    ]; _i < _iter.length; _i++){
        var hex = _iter[_i];
        out.add($3c042d4e8c9507db$export$b2a4daa97bd45a21(hex, k / $3c042d4e8c9507db$var$LEAF_STEPS));
        out.add($3c042d4e8c9507db$export$b2a4daa97bd45a21(hex, k / $3c042d4e8c9507db$var$LEAF_STEPS, $3c042d4e8c9507db$var$LEAF_RIM));
    }
    return out;
}
function $3c042d4e8c9507db$var$tree(g, rng, T, cx, cy) {
    var r = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 9;
    // Wind sways the canopy around the anchored trunk/shadow, so the shadow is
    // static and the canopy is not. The leaf detail is resolved from the stream
    // here and captured — the replayed closure must never touch the rng, or the
    // tile's layout would drift every frame. The hue is resolved here for the
    // same reason, and applied to the palette the replay hands back so the canopy
    // still dims with the hour.
    $3c042d4e8c9507db$var$discShadow(g, T, cx, cy, r);
    var hue = $3c042d4e8c9507db$var$leafHue(rng);
    var speck = rng() < 0.5 ? [
        $3c042d4e8c9507db$var$ri(rng, -3, 3),
        $3c042d4e8c9507db$var$ri(rng, -3, 3)
    ] : null;
    // clumped foliage: offsets within the crown, fixed per tree so the canopy
    // keeps its shape while it sways
    var leaves = [];
    for(var i = 0, n = $3c042d4e8c9507db$var$ri(rng, 3, 6); i < n; i++)leaves.push([
        $3c042d4e8c9507db$var$ri(rng, -r + 2, r - 2),
        $3c042d4e8c9507db$var$ri(rng, -r + 2, r - 2),
        $3c042d4e8c9507db$var$ri(rng, 1, 3)
    ]);
    // The canopy is ONE FIXED IMAGE THAT SLIDES. sway is Math.round()ed and the
    // gust formula never exceeds 0.42, so it only ever takes the five values -2..2,
    // and cy never moves at all: every frame redrew the same discs one integer
    // pixel to the left or right of where it had just drawn them. At ~55 fillRects
    // a tree that was by a wide margin the most expensive thing on the map — a
    // wooded tier-3 grid spent 144k fillRects per frame on it, held 31% of a core,
    // and still missed its 12fps target. So it is rasterised once and blitted
    // thereafter, which is the same picture for one draw call instead of 55.
    //
    // It stays in dynamic() rather than moving somewhere the day tint could reach
    // it, because the draw ORDER here is load-bearing: vegetation composes last,
    // so a canopy paints over the lit windows of the house it overhangs. Lights
    // only stay bright by landing after the tint (tintPalette exempts `glow`), so
    // anything that must cover them has to land after it too. Hence a pre-tinted
    // sprite, rebuilt when the hour has moved far enough to see (see TINT_STEPS).
    //
    // Leaf clumps reach r+1 from the centre and the speck reaches 5, so the
    // surface is padded to whichever is larger rather than to r.
    var pad = Math.max(r + 1, 5);
    // The canopy itself, wherever it is going. Both routes below go through this
    // one function at the same coordinates, so the cached path cannot quietly
    // drift from the drawn one — and the geometry stays visible to a caller that
    // is counting rects rather than looking at pixels.
    var paintCanopy = function(gg, ox, oy, T) {
        // Outer disc in the rim tone, inner one a unit smaller in the body tone —
        // one pixel of outline the whole way round, and the two agree on where the
        // edge is because they are the same routine at r and r-1. Stroking a ring
        // over the top would not: ringO rounds where disc floors.
        $3c042d4e8c9507db$var$disc(gg, ox, oy, r, $3c042d4e8c9507db$export$b2a4daa97bd45a21(T.veg1, hue, $3c042d4e8c9507db$var$LEAF_RIM));
        $3c042d4e8c9507db$var$disc(gg, ox, oy, r - 1, $3c042d4e8c9507db$export$b2a4daa97bd45a21(T.veg1, hue));
        gg.a(0.85, function() {
            return $3c042d4e8c9507db$var$disc(gg, ox - 3, oy - 3, Math.max(2, r - 5), $3c042d4e8c9507db$export$b2a4daa97bd45a21(T.veg2, hue));
        }); // lit crown
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var _step_value = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step.value, 3), lx = _step_value[0], ly = _step_value[1], lr = _step_value[2];
                gg.a(0.35, function() {
                    return $3c042d4e8c9507db$var$disc(gg, ox + lx, oy + ly, lr, T.structDark);
                });
            };
            for(var _iterator = leaves[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (speck) gg.r(ox + speck[0], oy + speck[1], 2, 2, T.structDark);
    };
    var qPhase = $3c042d4e8c9507db$var$tintPhase(cx, cy);
    var surf; // undefined = untried, null = no surface to be had
    var spriteQ = null;
    $3c042d4e8c9507db$var$dynamic(function(g, T) {
        // phase from the tree's position (not rng) so neighbors sway apart
        var sway = $3c042d4e8c9507db$var$ANIM.wind ? Math.round($3c042d4e8c9507db$var$ANIM.wind * 6 * Math.sin($3c042d4e8c9507db$var$ANIM.t * 1.8 + cx * 0.3 + cy * 0.23)) : 0;
        if (surf === undefined) surf = $3c042d4e8c9507db$var$spriteSurface((pad * 2 + 1) * $3c042d4e8c9507db$export$fae5d17304677194, g.ctx);
        // Nothing to rasterise into or to blit with — draw it in place instead.
        if (!surf) return paintCanopy(g, cx + sway, cy, T);
        var q = Math.floor($3c042d4e8c9507db$var$ANIM.tintScale + qPhase);
        if (spriteQ !== q) {
            surf.ctx.clearRect(0, 0, surf.canvas.width, surf.canvas.height);
            paintCanopy(surf.g, pad, pad, T);
            spriteQ = q;
        }
        g.ctx.drawImage(surf.canvas, (cx + sway - pad) * $3c042d4e8c9507db$export$fae5d17304677194, (cy - pad) * $3c042d4e8c9507db$export$fae5d17304677194);
    });
}
/**
 * A surface to pre-rasterise a sprite onto, or null if this environment has no
 * such thing. Both halves have to hold: somewhere to draw the sprite, and a
 * target able to blit it. The renderer is driven through a recording stub in
 * the tests and through the image lab's own contexts as well as the game's, so
 * the answer is not always yes and the caller needs a way to fall back.
 */ function $3c042d4e8c9507db$var$spriteSurface(size, target) {
    var _canvas_getContext;
    if (typeof (target === null || target === void 0 ? void 0 : target.drawImage) !== 'function') return null;
    var canvas = $3c042d4e8c9507db$var$scratchCanvas(size, size);
    var ctx = canvas === null || canvas === void 0 ? void 0 : (_canvas_getContext = canvas.getContext) === null || _canvas_getContext === void 0 ? void 0 : _canvas_getContext.call(canvas, '2d');
    if (typeof (ctx === null || ctx === void 0 ? void 0 : ctx.clearRect) !== 'function') return null;
    return {
        canvas: canvas,
        ctx: ctx,
        g: $3c042d4e8c9507db$var$makeG(ctx)
    };
}
function $3c042d4e8c9507db$var$bushPatch(g, rng, T, cx, cy) {
    var hue = $3c042d4e8c9507db$var$leafHue(rng); // same treatment, same reason
    $3c042d4e8c9507db$var$disc(g, cx, cy, 3, $3c042d4e8c9507db$export$b2a4daa97bd45a21(T.veg1, hue));
    g.r(cx + $3c042d4e8c9507db$var$ri(rng, -3, 3), cy - 3, 2, 2, $3c042d4e8c9507db$export$b2a4daa97bd45a21(T.veg2, hue));
    g.r(cx + $3c042d4e8c9507db$var$ri(rng, -2, 2), cy + $3c042d4e8c9507db$var$ri(rng, -1, 2), 1, 1, $3c042d4e8c9507db$export$b2a4daa97bd45a21(T.veg2, hue));
}
// A bare snag: forked limbs rather than the old plus-sign of four blocks.
function $3c042d4e8c9507db$var$deadTree(g, rng, T, cx, cy) {
    g.r(cx - 1, cy - 6, 2, 13, T.structDark); // trunk
    for(var _i = 0, _iter = [
        [
            -1,
            -4,
            6
        ],
        [
            1,
            -1,
            5
        ],
        [
            -1,
            2,
            4
        ]
    ]; _i < _iter.length; _i++){
        var _iter__i = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_iter[_i], 3), dx = _iter__i[0], dy = _iter__i[1], len = _iter__i[2];
        var s = Math.sign(dx);
        for(var i = 0; i < len; i++)g.r(cx + s * (1 + i), cy + dy - (i >> 1), 1, 1, T.structDark);
    }
}
function $3c042d4e8c9507db$var$glowShroom(g, rng, T, cx, cy) {
    for(var i = 0, n = $3c042d4e8c9507db$var$ri(rng, 3, 5); i < n; i++){
        var sx = cx + $3c042d4e8c9507db$var$ri(rng, -6, 6), sy = cy + $3c042d4e8c9507db$var$ri(rng, -6, 6);
        g.r(sx, sy, 1, 2, T.structDark); // stalk
        g.r(sx - 1, sy - 1, 3, 1, T.accent); // cap
    }
    // teal like the caps, not warm — amber halos read as lamplight
    $3c042d4e8c9507db$var$dynamic(function(g, T) {
        return g.a(0.18 + 0.24 * $3c042d4e8c9507db$var$flicker(cx, cy, 3), function() {
            return $3c042d4e8c9507db$var$disc(g, cx, cy, 7, T.accent);
        });
    }); // slow bioluminescent pulse
}
var $3c042d4e8c9507db$export$8ce2cf2f7041018f = 24, $3c042d4e8c9507db$export$f6b0e5d6358e6bd8 = 9;
function $3c042d4e8c9507db$var$vehicle(g, rng, T, x, y, vert) {
    var w = vert ? $3c042d4e8c9507db$export$f6b0e5d6358e6bd8 : $3c042d4e8c9507db$export$8ce2cf2f7041018f, h = vert ? $3c042d4e8c9507db$export$8ce2cf2f7041018f : $3c042d4e8c9507db$export$f6b0e5d6358e6bd8;
    $3c042d4e8c9507db$var$dropShadow(g, T, x, y, w, h);
    var body = [
        T.rust,
        T.accent,
        T.metal
    ][$3c042d4e8c9507db$var$ri(rng, 0, 2)];
    g.r(x, y, w, h, body);
    if (vert) {
        g.r(x, y, w, 1, T.structLight); // lit roof edge
        g.r(x, y, 1, h, T.structLight);
        g.r(x + w - 1, y, 1, h, T.structDark);
        g.r(x + 2, y + 5, w - 4, 4, T.structDark); // windshield
        g.r(x + 2, y + 15, w - 4, 3, T.structDark); // rear glass
        g.r(x + 1, y + 10, w - 2, 1, T.structLight); // roof seam
    } else {
        g.r(x, y, 1, h, T.structLight);
        g.r(x, y, w, 1, T.structLight);
        g.r(x, y + h - 1, w, 1, T.structDark);
        g.r(x + 5, y + 2, 4, h - 4, T.structDark);
        g.r(x + 15, y + 2, 3, h - 4, T.structDark);
        g.r(x + 10, y + 1, 1, h - 2, T.structLight);
    }
}
function $3c042d4e8c9507db$var$containerBox(g, rng, T, x, y, vert) {
    var w = vert ? 12 : 27, h = vert ? 27 : 12;
    $3c042d4e8c9507db$var$dropShadow(g, T, x, y, w, h);
    var c = [
        T.rust,
        T.accent,
        T.veg1,
        T.metal
    ][$3c042d4e8c9507db$var$ri(rng, 0, 3)];
    g.r(x, y, w, h, c);
    g.r(x, y, w, 1, T.structLight); // lit top edge
    g.r(x, y, 1, h, T.structLight);
    g.r(x, y + h - 1, w, 1, T.structDark);
    g.r(x + w - 1, y, 1, h, T.structDark);
    g.a(0.3, function() {
        if (vert) for(var ry = y + 3; ry < y + h - 2; ry += 3)g.r(x + 1, ry, w - 2, 1, T.far);
        else for(var rx = x + 3; rx < x + w - 2; rx += 3)g.r(rx, y + 1, 1, h - 2, T.far);
    });
    if (rng() < 0.5) g.a(0.5, function() {
        if (vert) g.r(x + 1, y + h - 5, w - 2, 4, T.structDark);
        else g.r(x + w - 5, y + 1, 4, h - 2, T.structDark);
    });
}
// A compact car for parking stalls (9x18, nose-in).
// 9 x 18 units — 1.8 x 3.6 m, a compact. `vert` is its default and means the
// car's LENGTH runs down the screen; a row of bays alongside a north-south road
// needs the other one, since a car always parks nose-in to the row.
function $3c042d4e8c9507db$var$carSmall(g, rng, T, x, y) {
    var vert = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : true;
    var w = vert ? 9 : 18, h = vert ? 18 : 9;
    $3c042d4e8c9507db$var$dropShadow(g, T, x, y, w, h);
    var body = [
        T.rust,
        T.accent,
        T.metal
    ][$3c042d4e8c9507db$var$ri(rng, 0, 2)];
    g.r(x, y, w, h, body);
    if (vert) {
        g.r(x, y, 9, 1, T.structLight);
        g.r(x + 8, y, 1, 18, T.structDark);
        g.r(x + 1, y + 4, 7, 3, T.structDark); // windshield
        g.r(x + 1, y + 12, 7, 2, T.structDark); // rear glass
        g.r(x + 1, y + 9, 7, 1, T.structLight); // roof seam
    } else {
        g.r(x, y, 1, 9, T.structLight);
        g.r(x, y + 8, 18, 1, T.structDark);
        g.r(x + 4, y + 1, 3, 7, T.structDark);
        g.r(x + 12, y + 1, 2, 7, T.structDark);
        g.r(x + 9, y + 1, 1, 7, T.structLight);
    }
}
// A paved parking lot: solid pad with a full curb ring, worn stall markings,
// and a random count of compact cars in the stalls.
//
// The bays run along the lot's LONG axis, and `vert` says which that is. The
// row used to be laid out along w whichever way the lot was turned, so a lot
// beside a north-south road counted its bays across its own depth and came out
// with one. The pavement paints through the pass-1 (castShadow) channel — it is
// ground, so car shadows must land ON it rather than be covered by it.
var $3c042d4e8c9507db$var$STALL_PITCH = 12; // 2.4 m, a real bay
var $3c042d4e8c9507db$var$BAY_DEPTH = 24; // 4.8 m, one row nose-in
/** Length of a lot holding `bays` stalls, given how stalls are counted below. */ var $3c042d4e8c9507db$var$lotLength = function(bays) {
    return bays * $3c042d4e8c9507db$var$STALL_PITCH + 6;
};
function $3c042d4e8c9507db$var$parkingLot(g, rng, T, x, y, w, h) {
    var _loop = function(i) {
        if (rng() < 0.85) g.a(0.8, function() {
            return vert ? g.r(x + 6, y + 3 + i * $3c042d4e8c9507db$var$STALL_PITCH, 15, 1, T.accent) : g.r(x + 3 + i * $3c042d4e8c9507db$var$STALL_PITCH, y + 6, 1, 15, T.accent);
        });
    };
    var vert = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : false;
    $3c042d4e8c9507db$var$castShadow(function() {
        $3c042d4e8c9507db$var$dither(g, rng, x, y, w, h, T.road, T.ground2, 0.06);
        g.r(x, y, w, 2, T.structDark); // full curb ring
        g.r(x, y + h - 2, w, 2, T.structDark);
        g.r(x, y, 2, h, T.structDark);
        g.r(x + w - 2, y, 2, h, T.structDark);
        g.a(0.35, function() {
            return g.r(x + 1, y + 1, w - 2, 1, T.structLight);
        }); // lit curb lip
    });
    var along = vert ? h : w, deep = vert ? w : h;
    var stalls = Math.floor((along - 6) / $3c042d4e8c9507db$var$STALL_PITCH);
    for(var i = 0; i <= stalls; i++)_loop(i);
    // Nose-in, and kept inside the kerb: a car is 18 long in a 24-deep bay, so
    // there is 3 units of clearance at each end and nothing to jitter over.
    for(var i1 = 0; i1 < stalls; i1++){
        var slack = $3c042d4e8c9507db$var$ri(rng, 0, Math.max(0, deep - 18 - 6));
        if (rng() < 0.6) {
            var at = 3 + slack;
            $3c042d4e8c9507db$var$carSmall(g, rng, T, vert ? x + at : x + 6 + i1 * $3c042d4e8c9507db$var$STALL_PITCH, vert ? y + 6 + i1 * $3c042d4e8c9507db$var$STALL_PITCH : y + at, !vert);
        }
    }
}
/**
 * A run of pipe on the surface, lit along its crown and dark along its
 * underside, with flanges at a fixed pitch. Irrigation lattices, cable trays
 * and conveyor runs are all this shape at different widths and axes, so it
 * lives here rather than being copied into each of them.
 *
 * @param {number} th  the run's thickness across its axis
 * @param {number} [pitch] units between flanges; 0 draws a bare run
 */ function $3c042d4e8c9507db$var$pipeRun(g, T, x, y, len, vert) {
    var th = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : 6, pitch = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : 24, body = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : 'metal';
    var w = vert ? th : len, h = vert ? len : th;
    g.r(x, y, w, h, T[body]);
    if (vert) {
        g.r(x, y, 1, h, T.structLight);
        g.r(x + th - 1, y, 1, h, T.structDark);
    } else {
        g.r(x, y, w, 1, T.structLight);
        g.r(x, y + th - 1, w, 1, T.structDark);
    }
    if (!pitch) return;
    for(var d = pitch >> 1; d < len; d += pitch)if (vert) g.r(x - 2, y + d, th + 4, 3, T.structDark);
    else g.r(x + d, y - 2, 3, th + 4, T.structDark);
}
function $3c042d4e8c9507db$var$tankTop(g, rng, T, cx, cy) {
    var r = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 15;
    $3c042d4e8c9507db$var$discShadow(g, T, cx, cy, r);
    $3c042d4e8c9507db$var$disc(g, cx, cy, r, T.metal);
    $3c042d4e8c9507db$var$ringO(g, cx, cy, r, T.structDark);
    $3c042d4e8c9507db$var$ringO(g, cx, cy, r - 1, T.structDark);
    g.a(0.5, function() {
        return $3c042d4e8c9507db$var$disc(g, cx - 2, cy - 2, Math.max(2, r - 7), T.structLight);
    }); // sheen
    g.a(0.25, function() {
        return $3c042d4e8c9507db$var$ringO(g, cx, cy, Math.max(3, r - 5), T.structDark);
    }); // seam ring
    for(var i = 0; i < 4; i++){
        var a = i * Math.PI / 2 + 0.4;
        g.r(cx + Math.round(Math.cos(a) * (r - 4)) - 1, cy + Math.round(Math.sin(a) * (r - 4)) - 1, 3, 3, T.structDark);
    }
    g.r(cx - 2, cy - 2, 5, 5, T.structDark); // center cap
    g.r(cx - 1, cy - 1, 3, 3, T.metal);
}
function $3c042d4e8c9507db$var$towerTop(g, rng, T, x, y) {
    $3c042d4e8c9507db$var$castShadow(function() {
        return g.a(0.4, function() {
            return g.r(x + $3c042d4e8c9507db$var$SHADOW.dx * 2, y + $3c042d4e8c9507db$var$SHADOW.dy * 2, 15, 15, T.far);
        });
    }); // tall = long shadow
    g.r(x, y, 15, 15, T.struct);
    g.r(x, y, 15, 1, T.structLight);
    g.r(x, y, 1, 15, T.structLight);
    g.r(x, y + 14, 15, 1, T.structDark);
    g.r(x + 14, y, 1, 15, T.structDark);
    // lattice legs meeting at the mast
    g.a(0.45, function() {
        for(var i = 1; i < 14; i++){
            g.r(x + i, y + i, 1, 1, T.structDark);
            g.r(x + 14 - i, y + i, 1, 1, T.structDark);
        }
    });
    g.r(x + 5, y + 5, 5, 5, T.metal); // mast base
    g.r(x + 6, y + 6, 3, 3, T.accent); // mast tip
}
var $3c042d4e8c9507db$export$f4eeec8c0ee13647 = {
    city: function(g, rng, T) {
        $3c042d4e8c9507db$var$grain(g, rng, T.ground1, T.ground2, 0.18);
        $3c042d4e8c9507db$var$mottle(g, rng, T.structDark, 2);
        $3c042d4e8c9507db$var$mottle(g, rng, T.structLight, 1, 0.07);
        // Pavement slab seams. The pitch stays on the 30px world grid so slabs
        // line up across cells, but the seam itself is now a 1px score line
        // rather than a 3px band — the reason it had to be held at alpha 0.06 to
        // avoid reading as a grid, so it can carry a little more weight.
        g.a(0.10, function() {
            for(var i = 0; i < $3c042d4e8c9507db$export$9e15ff8aa6bc996f; i += 30){
                g.r(i, 0, 1, $3c042d4e8c9507db$export$9e15ff8aa6bc996f, T.structDark);
                g.r(0, i, $3c042d4e8c9507db$export$9e15ff8aa6bc996f, 1, T.structDark);
            }
        });
        for(var i = 0; i < 2; i++)$3c042d4e8c9507db$var$crack(g, rng, T, $3c042d4e8c9507db$var$ri(rng, 12, 102), $3c042d4e8c9507db$var$ri(rng, 12, 90), $3c042d4e8c9507db$var$ri(rng, 15, 27));
    },
    greenhouse: function(g, rng, T) {
        $3c042d4e8c9507db$var$grain(g, rng, T.ground1, T.ground2, 0.25);
        $3c042d4e8c9507db$var$mottle(g, rng, T.veg1, 3, 0.18);
        $3c042d4e8c9507db$var$mottle(g, rng, T.veg2, 2, 0.1);
        for(var i = 0; i < 30; i++)g.r($3c042d4e8c9507db$var$ri(rng, 0, 116), $3c042d4e8c9507db$var$ri(rng, 0, 116), $3c042d4e8c9507db$var$ri(rng, 2, 5), $3c042d4e8c9507db$var$ri(rng, 1, 2), T.veg1); // moss
        for(var i1 = 0; i1 < 24; i1++)g.r($3c042d4e8c9507db$var$ri(rng, 0, 118), $3c042d4e8c9507db$var$ri(rng, 0, 118), $3c042d4e8c9507db$var$ri(rng, 1, 2), 1, T.veg2);
        for(var i2 = 0; i2 < 10; i2++)g.r($3c042d4e8c9507db$var$ri(rng, 0, 118), $3c042d4e8c9507db$var$ri(rng, 0, 118), 1, 1, T.glow); // wildflowers
        for(var i3 = 0; i3 < 14; i3++){
            var bx = $3c042d4e8c9507db$var$ri(rng, 0, 118), by = $3c042d4e8c9507db$var$ri(rng, 2, 118);
            g.r(bx, by - 2, 1, 3, T.veg2);
        }
    },
    harbor: function(g, rng, T) {
        var _loop = function(i) {
            var ty = $3c042d4e8c9507db$var$ri(rng, 6, 114);
            g.a(0.18, function() {
                return g.r($3c042d4e8c9507db$var$ri(rng, 0, 90), ty, $3c042d4e8c9507db$var$ri(rng, 12, 30), 1, T.water2);
            });
        };
        $3c042d4e8c9507db$var$grain(g, rng, T.ground1, T.ground2, 0.2);
        $3c042d4e8c9507db$var$mottle(g, rng, T.structDark, 2);
        $3c042d4e8c9507db$var$mottle(g, rng, T.water1, 2, 0.15); // damp silt sheen
        for(var i = 0; i < 8; i++)_loop(i);
    },
    foundry: function(g, rng, T) {
        $3c042d4e8c9507db$var$grain(g, rng, T.ground1, T.ground2, 0.22);
        $3c042d4e8c9507db$var$mottle(g, rng, T.rust, 2, 0.18);
        $3c042d4e8c9507db$var$mottle(g, rng, T.structDark, 1);
        for(var i = 0; i < 18; i++)g.a(0.5, function() {
            return g.r($3c042d4e8c9507db$var$ri(rng, 6, 108), $3c042d4e8c9507db$var$ri(rng, 6, 108), $3c042d4e8c9507db$var$ri(rng, 3, 9), $3c042d4e8c9507db$var$ri(rng, 1, 2), T.rust);
        });
        g.a(0.15, function() {
            return g.r(0, 60, $3c042d4e8c9507db$export$9e15ff8aa6bc996f, 2, T.structDark);
        }); // expansion joint
        g.a(0.10, function() {
            return g.r(0, 59, $3c042d4e8c9507db$export$9e15ff8aa6bc996f, 1, T.structLight);
        });
    },
    underground: function(g, rng, T) {
        $3c042d4e8c9507db$var$grain(g, rng, T.ground1, T.ground2, 0.18);
        $3c042d4e8c9507db$var$mottle(g, rng, T.far, 2, 0.2);
        g.a(0.3, function() {
            for(var i = 12; i < $3c042d4e8c9507db$export$9e15ff8aa6bc996f; i += 24){
                g.r(i, 0, 1, $3c042d4e8c9507db$export$9e15ff8aa6bc996f, T.structDark);
                g.r(0, i, $3c042d4e8c9507db$export$9e15ff8aa6bc996f, 1, T.structDark);
            } // floor grating
        });
        g.a(0.15, function() {
            for(var i = 0; i < $3c042d4e8c9507db$export$9e15ff8aa6bc996f; i += 24){
                g.r(i, 0, 1, $3c042d4e8c9507db$export$9e15ff8aa6bc996f, T.structLight);
                g.r(0, i, $3c042d4e8c9507db$export$9e15ff8aa6bc996f, 1, T.structLight);
            }
        });
    }
};
// ---- clearings ----
// A rest stop and a shoreline are the two places on the map nobody paved. They
// were drawn as the region's own floor with a tent or a lake dropped on it,
// which read as a pond in a car park. They get turf instead: solid across the
// middle, and thinning to nothing over the last CLEARING_MARGIN units so the
// tile still meets whatever is next door without a line around it. The seam
// has to survive in every direction — a clearing can have a street, a hazard
// or another clearing on any side.
var $3c042d4e8c9507db$var$CLEARING_MARGIN = 14;
/** The rooms nobody paved. */ var $3c042d4e8c9507db$var$CLEARING_RECIPES = new Set([
    'water',
    'campsite'
]);
/**
 * @param {object} [cont] which sides the open ground carries on across, from
 *   room.clearing. Those sides run full bleed instead of fading, or the rest
 *   stop and the shoreline beside it each fade at the edge they share and put
 *   a strip of tarmac through the middle of one clearing.
 */ function $3c042d4e8c9507db$var$clearing(g, rng, T) {
    var cont = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var M = $3c042d4e8c9507db$var$CLEARING_MARGIN;
    var x0 = cont.w ? 0 : M, y0 = cont.n ? 0 : M;
    var x1 = cont.e ? $3c042d4e8c9507db$export$9e15ff8aa6bc996f : $3c042d4e8c9507db$export$9e15ff8aa6bc996f - M, y1 = cont.s ? $3c042d4e8c9507db$export$9e15ff8aa6bc996f : $3c042d4e8c9507db$export$9e15ff8aa6bc996f - M;
    g.r(x0, y0, x1 - x0, y1 - y0, T.veg1); // turf
    // The fringe reaches from the turf out toward the edges that END here,
    // thinning as it goes, so the two grounds interleave rather than meeting at a
    // border. It overlaps the turf by a few units, which hides the turf's own
    // edge. A side the clearing continues across is already full bleed and has
    // nothing to fade into.
    var OPEN = $3c042d4e8c9507db$export$9e15ff8aa6bc996f; // a side that never fades
    for(var i = 0; i < 3600; i++){
        var x = rng() * $3c042d4e8c9507db$export$9e15ff8aa6bc996f, y = rng() * $3c042d4e8c9507db$export$9e15ff8aa6bc996f;
        var d = Math.min(cont.w ? OPEN : x, cont.n ? OPEN : y, cont.e ? OPEN : $3c042d4e8c9507db$export$9e15ff8aa6bc996f - x, cont.s ? OPEN : $3c042d4e8c9507db$export$9e15ff8aa6bc996f - y);
        if (d > M + 4 || rng() > Math.pow(d / M, 1.5)) continue;
        g.r(x | 0, y | 0, $3c042d4e8c9507db$var$ri(rng, 2, 5), $3c042d4e8c9507db$var$ri(rng, 1, 3), rng() < 0.65 ? T.veg1 : T.veg2);
    }
    // and the turf is not a flat colour: tufts, moss and blades, the same
    // vocabulary the greenhouse floor is built from
    for(var i1 = 0; i1 < 150; i1++)g.r($3c042d4e8c9507db$var$ri(rng, x0, x1), $3c042d4e8c9507db$var$ri(rng, y0, y1), $3c042d4e8c9507db$var$ri(rng, 2, 6), $3c042d4e8c9507db$var$ri(rng, 1, 2), T.veg2);
    for(var i2 = 0; i2 < 60; i2++)g.a(0.5, function() {
        return g.r($3c042d4e8c9507db$var$ri(rng, x0, x1), $3c042d4e8c9507db$var$ri(rng, y0, y1), $3c042d4e8c9507db$var$ri(rng, 1, 3), 1, T.ground2);
    });
    for(var i3 = 0; i3 < 40; i3++){
        var bx = $3c042d4e8c9507db$var$ri(rng, x0, x1), by = $3c042d4e8c9507db$var$ri(rng, y0 + 3, y1);
        g.r(bx, by - 2, 1, 3, T.veg2);
    }
}
// Road/path connectors, drawn ONLY where the generated road network says a
// road runs (see roadNetwork-core.js). Directions come from that network, not
// from "is this neighbour walkable" — under the old rule almost every tile was
// connected to all four sides, so every tile drew the same cross and the roads
// told you nothing about the place.
//
// The trunk gets the full roadway; branches get a narrower lane. A tile the
// network misses draws nothing at all.
// tune.roadWear (0..1) degrades surfaces: potholes, missing lane paint,
// cracks, and vegetation reclaiming the pavement.
var $3c042d4e8c9507db$var$ROAD_W = 30, $3c042d4e8c9507db$var$LANE_W = 15;
var $3c042d4e8c9507db$var$RANK_W = {
    major: $3c042d4e8c9507db$var$ROAD_W,
    minor: $3c042d4e8c9507db$var$LANE_W
};
// ---- where a road crosses a tile edge ----
//
// Locking every crossing to the edge midpoint is what forced the old shapes: a
// tile with road on opposite edges could only draw a straight line or a bow,
// and bowing each tile independently produced a sine wave with a one-tile
// period, because the curvature reversed at every seam.
//
// So the crossings move. Both tiles sharing an edge derive the SAME offset from
// that edge's own coordinates, so they agree without talking to each other —
// there is no propagation across the grid, and no way for one tile to pick a
// crossing its neighbour cannot meet.
//
// The offset is sampled from the smooth-noise field rather than hashed per
// edge. Neighbouring edges then get SIMILAR offsets and a road wanders over
// several tiles; hashing each edge independently would kink at every seam, the
// same mistake as the bow at a different frequency.
var $3c042d4e8c9507db$var$EDGE_DRIFT = 3.5; // tiles per wavelength of the wander
var $3c042d4e8c9507db$var$EDGE_SWING = 24; // furthest a crossing may sit off centre
var $3c042d4e8c9507db$var$EDGE_MARGIN = 6; // and never nearer than this to a corner
function $3c042d4e8c9507db$export$cfdc75f9711ba396(row, col) {
    var dir = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'n', w = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $3c042d4e8c9507db$var$LANE_W;
    // Without a grid position there is no shared edge to key off, so every
    // crossing goes down the middle. Unhelpful, but every tile agrees — which is
    // the one property that must never break. Defaulting the position to 0,0
    // instead gave each tile the same WRONG pair of offsets (a tile's north edge
    // and its neighbour's south edge are different samples at 0,0), and the
    // seams came apart wherever a caller forgot to pass the position.
    if (row == null || col == null) return 0;
    var horizontal = dir === 'n' || dir === 's';
    // the edge's own identity: the cells either side of it name it the same way
    var r = dir === 's' ? row + 1 : row;
    var c = dir === 'e' ? col + 1 : col;
    var n = $3c042d4e8c9507db$var$smoothNoise((c + (horizontal ? 0.5 : 0)) / $3c042d4e8c9507db$var$EDGE_DRIFT, (r + (horizontal ? 0 : 0.5)) / $3c042d4e8c9507db$var$EDGE_DRIFT + (horizontal ? 0 : 37));
    var limit = Math.min($3c042d4e8c9507db$var$EDGE_SWING, Math.max(0, ($3c042d4e8c9507db$export$9e15ff8aa6bc996f - w) / 2 - $3c042d4e8c9507db$var$EDGE_MARGIN));
    return Math.round((n * 2 - 1) * limit);
}
// ---- stroking a road along a path ----
// Every form is a centreline and a width. Rendering them all through one
// routine means a bend, a straight run and a junction arm get the same surface,
// curbs and paint, and a new shape is a new list of points rather than new
// drawing code — which is what the quarter-annulus could never be.
var $3c042d4e8c9507db$var$mid2 = function() {
    return $3c042d4e8c9507db$export$9e15ff8aa6bc996f / 2;
};
/** Where a road meets one edge of the tile, given that edge's offset. */ var $3c042d4e8c9507db$var$edgePoint = function(dir, off) {
    return dir === 'n' ? [
        $3c042d4e8c9507db$var$mid2() + off,
        0
    ] : dir === 's' ? [
        $3c042d4e8c9507db$var$mid2() + off,
        $3c042d4e8c9507db$export$9e15ff8aa6bc996f
    ] : dir === 'w' ? [
        0,
        $3c042d4e8c9507db$var$mid2() + off
    ] : [
        $3c042d4e8c9507db$export$9e15ff8aa6bc996f,
        $3c042d4e8c9507db$var$mid2() + off
    ];
};
/** A point straight in from an edge — a control point that leaves it squarely. */ var $3c042d4e8c9507db$var$inward = function(dir, param, d) {
    var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), x = _param[0], y = _param[1];
    return dir === 'n' ? [
        x,
        y + d
    ] : dir === 's' ? [
        x,
        y - d
    ] : dir === 'w' ? [
        x + d,
        y
    ] : [
        x - d,
        y
    ];
};
/**
 * Cubic through p0 and p3 with the tangents fixed by c1/c2.
 *
 * Cubic rather than quadratic because both ends need their own tangent: a road
 * has to leave every edge at right angles to it, or its tangent disagrees with
 * the neighbour's and the seam shows as a kink.
 */ function $3c042d4e8c9507db$var$cubic(p0, c1, c2, p3, n) {
    var out = [];
    for(var i = 0; i <= n; i++){
        var t = i / n, u = 1 - t;
        var a = u * u * u, b = 3 * u * u * t, c = 3 * u * t * t, d = t * t * t;
        out.push([
            a * p0[0] + b * c1[0] + c * c2[0] + d * p3[0],
            a * p0[1] + b * c1[1] + c * c2[1] + d * p3[1]
        ]);
    }
    return out;
}
/** 1px line between two points, for curbs that follow a curve. */ function $3c042d4e8c9507db$var$plot(g, param, param1, c) {
    var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), x0 = _param[0], y0 = _param[1], _param1 = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param1, 2), x1 = _param1[0], y1 = _param1[1];
    var steps = Math.max(1, Math.round(Math.max(Math.abs(x1 - x0), Math.abs(y1 - y0))));
    for(var i = 0; i <= steps; i++)g.r(Math.round(x0 + (x1 - x0) * i / steps), Math.round(y0 + (y1 - y0) * i / steps), 1, 1, c);
}
/**
 * Lay road down a centreline.
 *
 * The band is the centreline offset by half its width to either side, filled by
 * scanline. An earlier version drew one axis-aligned span per sample, picking
 * the axis from the local tangent — but that choice flips somewhere in every
 * turn, and where it did, the two families of spans met at a corner and left a
 * triangular notch bitten out of the outside of the bend. Offsetting the curve
 * has no axis to flip, and costs less: the work follows the tile's height
 * rather than the number of samples.
 *
 * `width` may be a number or a function of t, which is what lets a branch flare
 * out where it meets the roadway.
 */ function $3c042d4e8c9507db$var$strokePath(g, rng, T, pts, p, tune) {
    var width = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : p.w;
    var wear = tune.roadWear;
    var at = typeof width === 'function' ? width : function() {
        return width;
    };
    var left = [], right = [];
    var lo = $3c042d4e8c9507db$export$9e15ff8aa6bc996f, hi = 0;
    for(var i = 0; i < pts.length; i++){
        var a = pts[Math.max(0, i - 1)], b = pts[Math.min(pts.length - 1, i + 1)];
        var tx = b[0] - a[0], ty = b[1] - a[1];
        var len = Math.hypot(tx, ty) || 1;
        tx /= len;
        ty /= len;
        var h = at(i / (pts.length - 1)) / 2;
        var _pts_i = (0, $1788e2ed61915b1e$export$71511d61b312f219)(pts[i], 2), x = _pts_i[0], y = _pts_i[1];
        left.push([
            x - ty * h,
            y + tx * h
        ]);
        right.push([
            x + ty * h,
            y - tx * h
        ]);
        lo = Math.min(lo, y - h);
        hi = Math.max(hi, y + h);
    }
    var poly = (0, $4c858c0d999a5b9b$export$71511d61b312f219)(left).concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)(right.slice().reverse()));
    // scanline fill; a turn can put two runs of road on one row, so cross every
    // edge and fill the crossings in pairs
    var rows = [];
    for(var y1 = Math.max(0, Math.floor(lo)); y1 < Math.min($3c042d4e8c9507db$export$9e15ff8aa6bc996f, Math.ceil(hi) + 1); y1++){
        var yc = y1 + 0.5, xs = [];
        for(var i1 = 0, n = poly.length; i1 < n; i1++){
            var _poly_i = (0, $1788e2ed61915b1e$export$71511d61b312f219)(poly[i1], 2), x1 = _poly_i[0], y11 = _poly_i[1], _poly_ = (0, $1788e2ed61915b1e$export$71511d61b312f219)(poly[(i1 + 1) % n], 2), x2 = _poly_[0], y2 = _poly_[1];
            if (y11 <= yc === y2 <= yc) continue;
            xs.push(x1 + (yc - y11) / (y2 - y11) * (x2 - x1));
        }
        xs.sort(function(a, b) {
            return a - b;
        });
        for(var i2 = 0; i2 + 1 < xs.length; i2 += 2){
            var x0 = Math.max(0, Math.round(xs[i2])), x11 = Math.min($3c042d4e8c9507db$export$9e15ff8aa6bc996f, Math.round(xs[i2 + 1]));
            if (x11 > x0) rows.push([
                x0,
                y1,
                x11 - x0
            ]);
        }
    }
    if (!rows.length) return;
    var grit = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = rows[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step.value, 3), x3 = _step_value[0], y3 = _step_value[1], w = _step_value[2];
            g.r(x3, y3, w, 1, p.col);
            grit += w * $3c042d4e8c9507db$export$fae5d17304677194 * $3c042d4e8c9507db$export$fae5d17304677194 * p.den / ($3c042d4e8c9507db$var$SPECK * $3c042d4e8c9507db$var$SPECK);
            while(grit >= 1){
                g.p((x3 + rng() * w) * $3c042d4e8c9507db$export$fae5d17304677194, y3 * $3c042d4e8c9507db$export$fae5d17304677194, $3c042d4e8c9507db$var$SPECK, $3c042d4e8c9507db$var$SPECK, p.alt);
                grit--;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    for(var i3 = 0, n1 = Math.round(rows.length * wear * 0.06); i3 < n1; i3++){
        var _rows_Math_floor = (0, $1788e2ed61915b1e$export$71511d61b312f219)(rows[Math.floor(rng() * rows.length)], 3), x4 = _rows_Math_floor[0], y4 = _rows_Math_floor[1], w1 = _rows_Math_floor[2]; // wear, scattered along the run
        var pw = $3c042d4e8c9507db$var$ri(rng, 3, 8);
        g.r(x4 + rng() * Math.max(1, w1 - pw), y4, pw, $3c042d4e8c9507db$var$ri(rng, 2, 4), rng() < 0.5 ? T.ground1 : T.ground2);
    }
    if (!p.isMajor) return;
    for(var i4 = 1; i4 < left.length; i4++){
        $3c042d4e8c9507db$var$plot(g, left[i4 - 1], left[i4], T.structDark);
        $3c042d4e8c9507db$var$plot(g, right[i4 - 1], right[i4], T.structDark);
    }
    // Dashed centreline, by arc length — and only where the surface is still a
    // full roadway. A branch flaring out to meet the road, or a run narrowing
    // into a lane, carries the median no further than its own width earns it.
    var run = 0;
    for(var i5 = 1; i5 < pts.length; i5++){
        run += Math.hypot(pts[i5][0] - pts[i5 - 1][0], pts[i5][1] - pts[i5 - 1][1]);
        if (at(i5 / (pts.length - 1)) < $3c042d4e8c9507db$var$ROAD_W - 1) continue;
        if (run % 18 > 9 || rng() < wear) continue;
        g.r(Math.round(pts[i5][0]) - 1, Math.round(pts[i5][1]) - 1, 2, 2, T.accent);
    }
}
// Surface of one band: base tone, grit, potholes, and for the roadway some
// growth pushing through and the odd crack.
function $3c042d4e8c9507db$var$potholes(g, rng, T, bx, by, bw, bh, wear) {
    var _loop = function(i) {
        var px = bx + rng() * bw, py = by + rng() * bh;
        var pw = $3c042d4e8c9507db$var$ri(rng, 3, 9), ph = $3c042d4e8c9507db$var$ri(rng, 2, 4);
        g.r(px, py, pw, ph, rng() < 0.5 ? T.ground1 : T.ground2);
        g.a(0.4, function() {
            return g.r(px, py, pw, 1, T.structDark);
        }); // broken lip
    };
    var n = Math.round(bw * bh * wear * 0.006); // px^2 — densities are per pixel
    for(var i = 0; i < n; i++)_loop(i);
}
function $3c042d4e8c9507db$var$bandSurface(g, rng, T, bx, by, bw, bh, col, alt, den, isMajor, wear) {
    $3c042d4e8c9507db$var$dither(g, rng, bx, by, bw, bh, col, alt, den);
    $3c042d4e8c9507db$var$potholes(g, rng, T, bx, by, bw, bh, wear);
    if (!isMajor) return;
    var tufts = Math.round(bw * bh * wear * wear * 0.02); // growth through pavement
    for(var i = 0; i < tufts; i++)g.r(bx + rng() * bw, by + rng() * bh, $3c042d4e8c9507db$var$ri(rng, 1, 2), $3c042d4e8c9507db$var$ri(rng, 1, 2), rng() < 0.6 ? T.veg1 : T.veg2);
    if (rng() < wear) $3c042d4e8c9507db$var$crack(g, rng, T, bx + (bw >> 1), by + (bh >> 1), $3c042d4e8c9507db$var$ri(rng, 12, 24));
}
// ---- road forms ----
// The network already produces a good spread of shapes — a third of road tiles
// run straight through, a quarter bend, a sixth dead-end. A form turns one of
// those into a centreline: two edge crossings (wherever edgeOffset puts them)
// joined by a curve that leaves each edge squarely, so the tangent agrees with
// whatever the neighbour drew.
var $3c042d4e8c9507db$var$CURVE_SAMPLES = 48; // enough for the offset band to read smooth
var $3c042d4e8c9507db$var$REACH_IN = $3c042d4e8c9507db$export$9e15ff8aa6bc996f * 0.55; // control-point pull off an edge
/**
 * A run between two edges — opposite or adjacent, it is the same curve.
 *
 * `pull` is how far the control points sit off each edge, which sets the turn
 * radius. It does not affect the tangent AT the edge, so tightening a turn
 * cannot break the seam. Junction fillets use a short pull: at the full sweep
 * a three-way turned the whole tile into one apron of asphalt.
 */ function $3c042d4e8c9507db$var$throughPath(d0, off0, d1, off1) {
    var pull = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : $3c042d4e8c9507db$var$REACH_IN;
    var a = $3c042d4e8c9507db$var$edgePoint(d0, off0), b = $3c042d4e8c9507db$var$edgePoint(d1, off1);
    return $3c042d4e8c9507db$var$cubic(a, $3c042d4e8c9507db$var$inward(d0, a, pull), $3c042d4e8c9507db$var$inward(d1, b, pull), b, $3c042d4e8c9507db$var$CURVE_SAMPLES);
}
/** An arm from one edge to the apron in the middle of the junction. */ function $3c042d4e8c9507db$var$armPath(dir, off, to) {
    var a = $3c042d4e8c9507db$var$edgePoint(dir, off);
    return $3c042d4e8c9507db$var$cubic(a, $3c042d4e8c9507db$var$inward(dir, a, $3c042d4e8c9507db$var$REACH_IN * 0.6), to, to, $3c042d4e8c9507db$var$CURVE_SAMPLES >> 1);
}
var $3c042d4e8c9507db$var$OPPOSITE_DIR = {
    n: 's',
    s: 'n',
    e: 'w',
    w: 'e'
};
function $3c042d4e8c9507db$export$a9b8e204c1a2976e(dirs, road) {
    var rank = function(d) {
        return $3c042d4e8c9507db$var$RANK_W[road[d]] || $3c042d4e8c9507db$var$LANE_W;
    };
    var pairs = [];
    for(var i = 0; i < dirs.length; i++)for(var j = i + 1; j < dirs.length; j++)pairs.push([
        dirs[i],
        dirs[j]
    ]);
    var opposed = function(param) {
        var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), a = _param[0], b = _param[1];
        return $3c042d4e8c9507db$var$OPPOSITE_DIR[a] === b ? 1 : 0;
    };
    pairs.sort(function(a, b) {
        return Math.min(rank(b[0]), rank(b[1])) - Math.min(rank(a[0]), rank(a[1])) || opposed(b) - opposed(a);
    });
    var through = [], rest = new Set(dirs);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = pairs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step.value, 2), a = _step_value[0], b = _step_value[1];
            if (!rest.has(a) || !rest.has(b)) continue;
            through.push([
                a,
                b
            ]);
            rest.delete(a);
            rest.delete(b);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        through: through,
        joins: (0, $4c858c0d999a5b9b$export$71511d61b312f219)(rest)
    };
}
/** A round patch of road surface — the base of a turning circle. */ function $3c042d4e8c9507db$var$pavedDisc(g, rng, T, cx, cy, r, p, wear) {
    $3c042d4e8c9507db$var$disc(g, cx, cy, r, p.col);
    var specks = Math.round(r * r * 3 * p.den / ($3c042d4e8c9507db$var$SPECK * $3c042d4e8c9507db$var$SPECK));
    for(var i = 0; i < specks; i++){
        var a = rng() * Math.PI * 2, d = Math.sqrt(rng()) * r;
        g.p(cx + Math.cos(a) * d, cy + Math.sin(a) * d, $3c042d4e8c9507db$var$SPECK, $3c042d4e8c9507db$var$SPECK, p.alt);
    }
    for(var i1 = 0, n = Math.round(r * wear * 0.3); i1 < n; i1++){
        var a1 = rng() * Math.PI * 2, d1 = Math.sqrt(rng()) * (r - 3);
        g.r(cx + Math.cos(a1) * d1, cy + Math.sin(a1) * d1, $3c042d4e8c9507db$var$ri(rng, 2, 5), 2, rng() < 0.5 ? T.ground1 : T.ground2);
    }
}
// A branch meeting the roadway shouldn't jump to lane width the moment it
// leaves — that reads as a step. Width eases from the arm's own road at the
// tile edge to the apron's at the middle, so a narrow branch flares as it joins.
var $3c042d4e8c9507db$var$smoothstep = function(t) {
    return t * t * (3 - 2 * t);
};
var $3c042d4e8c9507db$var$easedWidth = function(w0, w1) {
    return function(t) {
        return w0 + (w1 - w0) * $3c042d4e8c9507db$var$smoothstep(t);
    };
};
/**
 * The end of a track. Three ways for a road to stop, where before there was
 * only a band that ran to the middle of the tile and quit: a gated entryway
 * that never reaches the centre, a turning circle, and a hardstand apron.
 */ function $3c042d4e8c9507db$var$terminus(g, rng, T, dir, p, tune, kind, reach) {
    var off = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : 0;
    var wear = tune.roadWear;
    var horizontal = dir === 'e' || dir === 'w';
    var start = $3c042d4e8c9507db$var$edgePoint(dir, off);
    // the run heads straight in from wherever it crossed the edge and stops
    var stop = $3c042d4e8c9507db$var$inward(dir, start, reach);
    $3c042d4e8c9507db$var$strokePath(g, rng, T, $3c042d4e8c9507db$var$cubic(start, $3c042d4e8c9507db$var$inward(dir, start, reach * 0.5), stop, stop, 90), p, tune);
    var _stop_map = (0, $1788e2ed61915b1e$export$71511d61b312f219)(stop.map(Math.round), 2), hx = _stop_map[0], hy = _stop_map[1];
    var o = Math.round((horizontal ? hy : hx) - p.w / 2);
    if (kind === 'gate') {
        var post = function(x, y) {
            g.r(x, y, 3, 3, T.structDark);
            g.r(x, y, 3, 1, T.structLight);
        };
        if (horizontal) {
            post(hx - 1, o - 4);
            post(hx - 1, o + p.w + 1);
            g.a(0.8, function() {
                return g.r(hx - 1, o - 3, 2, p.w + 6, T.metal);
            }); // the barrier itself
        } else {
            post(o - 4, hy - 1);
            post(o + p.w + 1, hy - 1);
            g.a(0.8, function() {
                return g.r(o - 3, hy - 1, p.w + 6, 2, T.metal);
            });
        }
    } else if (kind === 'circle') {
        var r = Math.max(12, p.w);
        $3c042d4e8c9507db$var$pavedDisc(g, rng, T, hx, hy, r, p, wear);
        g.a(0.35, function() {
            return $3c042d4e8c9507db$var$ringO(g, hx, hy, r, T.structDark);
        });
        // a third of the radius, not a fixed inset — at lane width a fixed one ate
        // the whole circle and left a donut
        var island = Math.max(3, Math.round(r * 0.36));
        $3c042d4e8c9507db$var$disc(g, hx, hy, island, T.ground2);
        g.a(0.4, function() {
            return $3c042d4e8c9507db$var$ringO(g, hx, hy, island, T.structDark);
        });
        for(var i = 0, n = Math.round(r * 0.4); i < n; i++){
            var a = rng() * Math.PI * 2, d = Math.sqrt(rng()) * Math.max(2, island - 2);
            g.r(hx + Math.cos(a) * d, hy + Math.sin(a) * d, 2, 2, rng() < 0.6 ? T.veg1 : T.veg2);
        }
    } else {
        var aw = $3c042d4e8c9507db$var$ri(rng, 30, 42), ah = $3c042d4e8c9507db$var$ri(rng, 24, 33);
        var ax = Math.round(hx - aw / 2), ay = Math.round(hy - ah / 2);
        $3c042d4e8c9507db$var$bandSurface(g, rng, T, ax, ay, aw, ah, p.col, p.alt, p.den, p.isMajor, wear);
        g.a(0.3, function() {
            g.r(ax, ay, aw, 1, T.structDark);
            g.r(ax, ay + ah - 1, aw, 1, T.structDark);
            g.r(ax, ay, 1, ah, T.structDark);
            g.r(ax + aw - 1, ay, 1, ah, T.structDark);
        });
    }
}
// ---- routing around what a road cannot cross ----
// Every form above is one CANDIDATE. Which one a tile uses is settled by
// sampling each candidate's centreline against the buildings the recipe is
// about to draw (measured, not declared — see makeProbeG) and taking the one
// that runs through the fewest. The seeded preference order decides ties, so
// tiles still vary wherever there is nothing to avoid.
var $3c042d4e8c9507db$var$SAMPLE_STEP = 4; // units between centreline samples
// Samples are a BOUND on where the roadway lands, not a copy of it, so they run
// a shade wider than the surface: a disc rasterises a pixel past its radius, a
// kerb sits on the outside of its band, and every coordinate rounds. Suppressing
// a building a pixel early costs nothing anybody can see; keeping one a pixel
// late is a roof on the tarmac.
var $3c042d4e8c9507db$var$CLEARANCE = 1;
function $3c042d4e8c9507db$var$samplesFor(spec) {
    var mid = $3c042d4e8c9507db$export$9e15ff8aa6bc996f >> 1, out = [];
    var step = $3c042d4e8c9507db$var$SAMPLE_STEP / 2;
    // A sample covers the road's full width ACROSS its direction of travel and
    // only one step ALONG it. Squaring it off instead would claim the road is as
    // long as it is wide at every point, which reads a building well ahead of
    // the road as being in its way.
    var along = function(pts, w) {
        for(var i = 0; i < pts.length; i += 2){
            var a = pts[Math.max(0, i - 1)], b = pts[Math.min(pts.length - 1, i + 1)];
            var horizontal = Math.abs(b[0] - a[0]) >= Math.abs(b[1] - a[1]);
            out.push({
                x: pts[i][0],
                y: pts[i][1],
                hx: (horizontal ? step : w / 2) + $3c042d4e8c9507db$var$CLEARANCE,
                hy: (horizontal ? w / 2 : step) + $3c042d4e8c9507db$var$CLEARANCE
            });
        }
    };
    var blob = function(x, y, w) {
        return out.push({
            x: x,
            y: y,
            hx: w / 2 + $3c042d4e8c9507db$var$CLEARANCE,
            hy: w / 2 + $3c042d4e8c9507db$var$CLEARANCE
        });
    };
    if (spec.form === 'through') along($3c042d4e8c9507db$var$throughPath(spec.d0, spec.off0, spec.d1, spec.off1), spec.p.w);
    else if (spec.form === 'end') {
        var start = $3c042d4e8c9507db$var$edgePoint(spec.dir, spec.off || 0);
        var stop = $3c042d4e8c9507db$var$inward(spec.dir, start, spec.reach);
        along($3c042d4e8c9507db$var$cubic(start, $3c042d4e8c9507db$var$inward(spec.dir, start, spec.reach * 0.5), stop, stop, 60), spec.p.w);
        var pad = spec.kind === 'gate' ? spec.p.w : Math.max(24, spec.p.w * 2);
        blob(stop[0], stop[1], pad); // the pad is the widest part
    } else {
        var _spec_offs;
        var _junctionParts = $3c042d4e8c9507db$export$a9b8e204c1a2976e(spec.dirs, spec.road), through = _junctionParts.through, joins = _junctionParts.joins;
        var runs = through.map(function(param) {
            var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), a = _param[0], b = _param[1];
            var _spec_offs, _spec_offs1;
            var _spec_offs_a, _spec_offs_b;
            return $3c042d4e8c9507db$var$throughPath(a, (_spec_offs_a = (_spec_offs = spec.offs) === null || _spec_offs === void 0 ? void 0 : _spec_offs[a]) !== null && _spec_offs_a !== void 0 ? _spec_offs_a : 0, b, (_spec_offs_b = (_spec_offs1 = spec.offs) === null || _spec_offs1 === void 0 ? void 0 : _spec_offs1[b]) !== null && _spec_offs_b !== void 0 ? _spec_offs_b : 0);
        });
        runs.forEach(function(pts, i) {
            return along(pts, Math.max(spec.widths[through[i][0]], spec.widths[through[i][1]]));
        });
        var host = runs[runs.length - 1];
        var meet = host[host.length >> 1];
        var _spec_offs_dir;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = joins[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var dir = _step.value;
                along($3c042d4e8c9507db$var$armPath(dir, (_spec_offs_dir = (_spec_offs = spec.offs) === null || _spec_offs === void 0 ? void 0 : _spec_offs[dir]) !== null && _spec_offs_dir !== void 0 ? _spec_offs_dir : 0, meet), spec.widths[dir]);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return out;
}
// Inclusive at both ends: a band whose edge lands exactly on a building's edge
// shares that row of pixels with it, and the strict comparison this replaced
// called that a clear miss — the roadway then painted a sliver of roof.
var $3c042d4e8c9507db$var$runsThrough = function(samples, b) {
    return samples.some(function(s) {
        return s.x + s.hx >= b.x0 && s.x - s.hx <= b.x1 && s.y + s.hy >= b.y0 && s.y - s.hy <= b.y1;
    });
};
/** Seeded shuffle, so the preference order varies per tile but stays stable. */ function $3c042d4e8c9507db$var$shuffled(list, rng) {
    var out = (0, $4c858c0d999a5b9b$export$71511d61b312f219)(list);
    for(var i = out.length - 1; i > 0; i--){
        var j = Math.floor(rng() * (i + 1));
        var ref;
        ref = [
            out[j],
            out[i]
        ], out[i] = ref[0], out[j] = ref[1], ref;
    }
    return out;
}
function $3c042d4e8c9507db$export$56465e66d3491b39(options, solids, rng) {
    var ordered = (0, $4c858c0d999a5b9b$export$71511d61b312f219)($3c042d4e8c9507db$var$shuffled(options.filter(function(o) {
        return !o.fallback;
    }), rng)).concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)(options.filter(function(o) {
        return o.fallback;
    })));
    var scored = ordered.map(function(o) {
        var samples = $3c042d4e8c9507db$var$samplesFor(o);
        return {
            o: o,
            samples: samples,
            hit: solids.filter(function(s) {
                return $3c042d4e8c9507db$var$runsThrough(samples, s);
            })
        };
    });
    var best = scored.reduce(function(a, b) {
        return b.hit.length < a.hit.length ? b : a;
    });
    return {
        form: best.o,
        samples: best.samples
    };
}
function $3c042d4e8c9507db$export$fa7182ef09b736f8(g, rng, T, road, tune) {
    var solids = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : [], row = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null, col = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : null;
    var dirs = [
        'n',
        'e',
        's',
        'w'
    ].filter(function(d) {
        return road[d];
    });
    if (!dirs.length) return null;
    var mid = $3c042d4e8c9507db$export$9e15ff8aa6bc996f >> 1;
    var wear = tune.roadWear;
    // A minor road is the SAME MATERIAL as a major one, just narrower, older and
    // less swept — so it is a shade of the road colour rather than a different
    // palette key. It used to borrow structDark, which is a building colour and
    // in several regions a different hue entirely: the lanes came out blue-grey
    // against brown-grey arterials and read as two unrelated networks. Deriving
    // it keeps the hue identical by construction, in every region, for free.
    var paint = function(rank) {
        return {
            w: $3c042d4e8c9507db$var$RANK_W[rank] || $3c042d4e8c9507db$var$LANE_W,
            isMajor: rank === (0, $57ad8bd108ea335d$export$39615881bb0d21f6),
            col: rank === (0, $57ad8bd108ea335d$export$39615881bb0d21f6) ? T.road : $3c042d4e8c9507db$var$shade(T.road, 0.78),
            alt: rank === (0, $57ad8bd108ea335d$export$39615881bb0d21f6) ? T.ground2 : T.road,
            den: rank === (0, $57ad8bd108ea335d$export$39615881bb0d21f6) ? 0.08 : 0.30
        };
    };
    // where this tile's road meets each of its edges — agreed with the neighbour
    // on the far side of that edge, by construction
    var off = function(dir) {
        return $3c042d4e8c9507db$export$cfdc75f9711ba396(row, col, dir, $3c042d4e8c9507db$var$RANK_W[road[dir]] || $3c042d4e8c9507db$var$LANE_W);
    };
    // Every roll happens here, whatever the tile ends up drawing, so a tile's
    // appearance never depends on which candidate wins.
    var reach = $3c042d4e8c9507db$var$ri(rng, 30, 45);
    var options;
    if (dirs.length === 1) {
        var p = paint(road[dirs[0]]);
        // The crossing offset belongs on the option, not just on the draw call:
        // samplesFor reads it, and without it every dead end was measured running
        // down the middle of the tile while being drawn up to 24 units off it — so
        // the layout pass cleared a strip of ground the road was never on, and
        // built on the strip it was. Entry and extraction tiles are dead ends by
        // construction, which is where it showed worst.
        var o = off(dirs[0]);
        options = [
            {
                form: 'end',
                dir: dirs[0],
                off: o,
                p: p,
                kind: 'gate',
                reach: reach
            },
            {
                form: 'end',
                dir: dirs[0],
                off: o,
                p: p,
                kind: 'circle',
                reach: mid
            },
            {
                form: 'end',
                dir: dirs[0],
                off: o,
                p: p,
                kind: 'apron',
                reach: mid
            }
        ];
    } else if (dirs.length === 2) // One curve covers the straight run AND the bend: it leaves each edge
    // square to it and joins the two crossings. Where the crossings sit apart,
    // the run drifts across the tile — and because neighbouring edges get
    // similar offsets, that drift carries into the next tile instead of
    // reversing at the seam. Ranks need not match: a bend from a roadway into a
    // lane is still one run, and routing it through the junction code instead
    // gave it a square elbow on the inside of the turn.
    options = [
        {
            form: 'through',
            d0: dirs[0],
            d1: dirs[1],
            off0: off(dirs[0]),
            off1: off(dirs[1]),
            p: paint(road[dirs[0]]),
            p1: paint(road[dirs[1]])
        }
    ];
    else {
        var widths = Object.fromEntries(dirs.map(function(d) {
            return [
                d,
                paint(road[d]).w
            ];
        }));
        var offs = Object.fromEntries(dirs.map(function(d) {
            return [
                d,
                off(d)
            ];
        }));
        options = [
            {
                form: 'junction',
                dirs: dirs,
                widths: widths,
                offs: offs,
                road: road
            }
        ];
    }
    var _pickRoadForm = $3c042d4e8c9507db$export$56465e66d3491b39(options, solids, rng), chosen = _pickRoadForm.form, samples = _pickRoadForm.samples;
    if (chosen.form === 'end') {
        $3c042d4e8c9507db$var$terminus(g, rng, T, chosen.dir, chosen.p, tune, chosen.kind, chosen.reach, chosen.off);
        return samples;
    }
    if (chosen.form === 'through') {
        var wide = chosen.p.w >= chosen.p1.w ? chosen.p : chosen.p1;
        $3c042d4e8c9507db$var$strokePath(g, rng, T, $3c042d4e8c9507db$var$throughPath(chosen.d0, chosen.off0, chosen.d1, chosen.off1), wide, tune, $3c042d4e8c9507db$var$easedWidth(chosen.p.w, chosen.p1.w));
        return samples;
    }
    var _junctionParts = $3c042d4e8c9507db$export$a9b8e204c1a2976e(dirs, road), through = _junctionParts.through, joins = _junctionParts.joins;
    var runs = through.map(function(param) {
        var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), a = _param[0], b = _param[1];
        return {
            pts: $3c042d4e8c9507db$var$throughPath(a, chosen.offs[a], b, chosen.offs[b]),
            pa: paint(road[a]),
            pb: paint(road[b])
        };
    }).sort(function(x, y) {
        return Math.max(x.pa.w, x.pb.w) - Math.max(y.pa.w, y.pb.w);
    });
    // Arms first, so the through-road's surface covers where they land on it —
    // which is what a side road joining a main road actually looks like.
    var host = runs[runs.length - 1];
    var meet = host.pts[host.pts.length >> 1];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = joins[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var dir = _step.value;
            var p1 = paint(road[dir]);
            $3c042d4e8c9507db$var$strokePath(g, rng, T, $3c042d4e8c9507db$var$armPath(dir, chosen.offs[dir], meet), p1, tune, $3c042d4e8c9507db$var$easedWidth(p1.w, Math.max(host.pa.w, host.pb.w)));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = runs[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var run = _step1.value;
            $3c042d4e8c9507db$var$strokePath(g, rng, T, run.pts, run.pa.w >= run.pb.w ? run.pa : run.pb, tune, $3c042d4e8c9507db$var$easedWidth(run.pa.w, run.pb.w));
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return samples;
}
// ---- top-down elements ----
// The roof carries most of what a building reads as, and at 3px-per-block it
// could only ever be a slab with a stripe. Everything below — parapet, panel
// seams, plant, hatch — is one or two pixels wide and simply had nowhere to
// live before.
function $3c042d4e8c9507db$var$roofRect(g, rng, T, x, y, w, h) {
    $3c042d4e8c9507db$var$dropShadow(g, T, x, y, w, h);
    g.r(x, y, w, h, T.struct);
    if (rng() < 0.25) g.a(0.2, function() {
        return g.r(x + 1, y + 1, w - 2, h - 2, T.structDark);
    }); // darker roofing material
    // panel seams across the long axis, under the edging
    g.a(0.16, function() {
        if (w >= h) for(var sx = x + 6; sx < x + w - 2; sx += 6)g.r(sx, y + 2, 1, h - 4, T.structDark);
        else for(var sy = y + 6; sy < y + h - 2; sy += 6)g.r(x + 2, sy, w - 4, 1, T.structDark);
    });
    g.r(x, y, w, 1, T.structLight); // lit N/W edges, 1px
    g.r(x, y, 1, h, T.structLight);
    g.r(x, y + h - 1, w, 1, T.structDark); // shaded S/E edges
    g.r(x + w - 1, y, 1, h, T.structDark);
    if (w >= 9 && h >= 9) g.a(0.3, function() {
        g.r(x + 2, y + 2, w - 4, 1, T.structLight);
        g.r(x + 2, y + 2, 1, h - 4, T.structLight);
        g.r(x + 2, y + h - 3, w - 4, 1, T.structDark);
        g.r(x + w - 3, y + 2, 1, h - 4, T.structDark);
    });
    if (w >= h) g.r(x + 1, y + (h >> 1), w - 2, 1, T.structDark); // roof ridge
    else g.r(x + (w >> 1), y + 1, 1, h - 2, T.structDark);
    if (rng() < 0.7) {
        var vx = x + 4 + $3c042d4e8c9507db$var$ri(rng, 0, Math.max(0, w - 12)), vy = y + 4;
        g.r(vx, vy, 6, 5, T.metal);
        g.r(vx, vy, 6, 1, T.structLight);
        g.r(vx, vy + 4, 6, 1, T.structDark);
        g.a(0.5, function() {
            for(var i = 1; i < 5; i += 2)g.r(vx + i, vy + 1, 1, 3, T.structDark);
        }) // louvres
        ;
    }
    // Size-gated detail rolls its dice BEFORE the gate, never inside it. A roof
    // is measured where the recipe authored it and drawn where the layout pass
    // mirrored it to, and the canvas clamp can leave those two sizes different —
    // so `w >= 24 && rng() < 0.35` short-circuits in one pass and not the other,
    // spending a different number of rolls on a stream every later element
    // shares. What that cost was a building measured clear of the road being
    // drawn with a neighbour's mirror offset, square on the roadway. Same rule as
    // the day/night gate below: what is DRAWN may depend on size, what is DRAWN
    // FROM may not.
    var skylight = rng() < 0.35, skylightX = $3c042d4e8c9507db$var$ri(rng, 0, Math.max(0, w - 16));
    if (w >= 24 && h >= 21 && skylight) {
        var sx = x + 4 + skylightX, sy = y + h - 11;
        g.r(sx, sy, 9, 7, T.structDark);
        g.r(sx + 1, sy + 1, 7, 5, T.water1);
        g.a(0.45, function() {
            return g.r(sx + 1, sy + 1, 7, 1, T.structLight);
        }); // glare on the pane
    }
    var hatch = rng() < 0.5;
    if (w >= 15 && h >= 15 && hatch) {
        var hx = x + w - 8, hy = y + h - 8;
        g.r(hx, hy, 5, 5, T.structDark);
        g.r(hx + 1, hy + 1, 3, 3, T.metal);
    }
    // Window light spilling out at the south wall after dusk. The rng calls
    // run unconditionally so the tile layout is identical day and night; the
    // lamp gate lives INSIDE the closure so dusk falling never invalidates the
    // cached static layer — it just starts painting on replay.
    var spillX = x + 1 + $3c042d4e8c9507db$var$ri(rng, 0, Math.max(0, w - 3));
    var hasLight = rng() < 0.55;
    if (hasLight) $3c042d4e8c9507db$var$dynamic(function(g, T) {
        if ($3c042d4e8c9507db$var$ANIM.lamp <= 0.02) return;
        var a = $3c042d4e8c9507db$var$ANIM.lamp * $3c042d4e8c9507db$var$powerFlicker(spillX * 5.1 + y * 3.3);
        if (a <= 0.05) return;
        g.a(0.3 * a, function() {
            return $3c042d4e8c9507db$var$disc(g, spillX, y + h, 6, T.glow);
        }); // pool on the ground
        g.a(0.9 * a, function() {
            return g.r(spillX - 1, y + h - 2, 3, 2, T.glow);
        }); // the lit window
    });
}
// Building footprint with tune.buildingScale applied, anchored at x,y and
// clamped to the canvas. Larger footprints pick a composite shape from the
// seed — L-shaped or main-block-plus-wing — so blocks read as real
// structures instead of uniform rectangles.
//
// The shape is chosen from the SCALED size, before the clamp, and deliberately
// not from the clamped one. The layout pass measures a recipe where it was
// authored and then draws it mirrored, so the same building is clamped
// differently in the two passes — and each branch below spends a different
// number of draws on the stream every element after it shares. Branching on
// the clamped size therefore desynchronised measuring from drawing, and the
// elements downstream were drawn with another element's mirror offset: a
// building that had been measured clear of the road, and moved on that basis,
// landed on it. The clamp still decides what is DRAWN; it just no longer
// decides how much of the stream gets spent.
function $3c042d4e8c9507db$var$buildingTop(g, rng, T, tune, x, y, w, h) {
    var s = tune.buildingScale;
    var full = Math.round(w * s), tall = Math.round(h * s);
    w = Math.min(full, $3c042d4e8c9507db$export$9e15ff8aa6bc996f - $3c042d4e8c9507db$var$TILE_CLAMP - x);
    h = Math.min(tall, $3c042d4e8c9507db$export$9e15ff8aa6bc996f - $3c042d4e8c9507db$var$TILE_CLAMP - y);
    var composite = full >= 30 && tall >= 27;
    var shape = rng();
    if (composite && shape < 0.35) {
        var wingW = $3c042d4e8c9507db$var$ri(rng, Math.max(12, w >> 1), Math.max(12, w - 9));
        var wingH = $3c042d4e8c9507db$var$ri(rng, 9, Math.max(9, (h >> 1) - 3));
        $3c042d4e8c9507db$var$roofRect(g, rng, T, x, y, w, h - wingH);
        $3c042d4e8c9507db$var$roofRect(g, rng, T, x, y + h - wingH - 3, wingW, wingH + 3);
    } else if (composite && shape < 0.6) {
        $3c042d4e8c9507db$var$roofRect(g, rng, T, x, y, w, h - 12);
        var wingW1 = $3c042d4e8c9507db$var$ri(rng, 12, Math.max(12, w - 15));
        $3c042d4e8c9507db$var$roofRect(g, rng, T, x + $3c042d4e8c9507db$var$ri(rng, 0, Math.max(0, w - wingW1)), y + h - 15, wingW1, 15);
    } else $3c042d4e8c9507db$var$roofRect(g, rng, T, x, y, w, h);
}
// ---- terraces ----
// A free-standing block is a thing somebody built. A TERRACE is a thing
// somebody built a street out of: a run of units under one roof, sharing party
// walls, flush along a common frontage and ragged at the back. Every structure
// on the map being free-standing is most of why it reads as a business park
// rather than a town — real built ground is mostly attached, and the gaps
// between attached ranges are what a street IS.
//
// What makes it legible from directly overhead, in order of how much it
// carries: the comb of party walls crossing the run at uneven intervals, a
// stack straddling most of those walls, a continuous ridge down the length,
// and a back line that steps where a unit was built shallower than its
// neighbours. The frontage never steps — a terrace is flush at the street,
// which is the whole reason it looks planned and a row of sheds does not.
var $3c042d4e8c9507db$var$TERRACE_UNIT = [
    12,
    22
]; // one unit's frontage, before scale
var $3c042d4e8c9507db$var$TERRACE_MIN = 9; // a last unit narrower than this joins the one before
/**
 * Plan the run: where the party walls fall, how deep each unit is, which walls
 * carry a stack. EVERY roll this element makes happens here, off the scaled
 * but UNCLAMPED length, and the drawing below spends none — same rule as
 * buildingTop and for the same reason. A terrace is measured where the recipe
 * authored it and drawn where the layout pass mirrored it to, so the canvas
 * clamp can leave those two lengths different; a plan that rolled per drawn
 * unit would spend a different number of draws in the two passes and every
 * element after it would land somewhere the measuring pass never cleared.
 */ function $3c042d4e8c9507db$var$planTerrace(rng, run, depth, s) {
    var units = [];
    var min = Math.round($3c042d4e8c9507db$var$TERRACE_MIN * s);
    for(var at = 0; at < run;){
        var wide = Math.min(Math.round($3c042d4e8c9507db$var$ri(rng, $3c042d4e8c9507db$var$TERRACE_UNIT[0], $3c042d4e8c9507db$var$TERRACE_UNIT[1]) * s), run - at);
        // A unit built shallower than its neighbours steps the back line. The
        // frontage stays flush: that is what separates a terrace from a row.
        var back = rng() < 0.3 ? Math.round($3c042d4e8c9507db$var$ri(rng, 3, 7) * s) : 0;
        var stack = rng() < 0.65;
        var lit = rng() < 0.5; // whether this one is still occupied
        units.push({
            at: at,
            wide: wide,
            back: back,
            stack: stack,
            lit: lit
        });
        at += wide;
        if (run - at > 0 && run - at < min) {
            units[units.length - 1].wide += run - at;
            at = run;
        }
    }
    return units;
}
/**
 * @param {number} w,h  the footprint in TILE space; the longer of the two is
 *   the run unless vert says otherwise, and y (or x, when vert) is the frontage
 */ function $3c042d4e8c9507db$var$terraceTop(g, rng, T, tune, x, y, w, h, vert) {
    var s = tune.buildingScale;
    var full = Math.round((vert ? h : w) * s), deep = Math.round((vert ? w : h) * s);
    var units = $3c042d4e8c9507db$var$planTerrace(rng, full, deep, s);
    // Clamped only now, and only for what is DRAWN.
    var run = Math.min(full, $3c042d4e8c9507db$export$9e15ff8aa6bc996f - $3c042d4e8c9507db$var$TILE_CLAMP - (vert ? y : x));
    var across = Math.min(deep, $3c042d4e8c9507db$export$9e15ff8aa6bc996f - $3c042d4e8c9507db$var$TILE_CLAMP - (vert ? x : y));
    if (run < 6 || across < 6) return;
    // `a` runs along the terrace, `c` across it from the frontage back, so one
    // body of code draws both a street facing north and one facing west.
    var put = function(a, c, la, lc, col) {
        var la2 = Math.min(la, run - a), lc2 = Math.min(lc, across - c);
        if (a >= run || c >= across || la2 <= 0 || lc2 <= 0) return;
        if (vert) g.r(x + c, y + a, lc2, la2, col);
        else g.r(x + a, y + c, la2, lc2, col);
    };
    var atXY = function(a, c) {
        return vert ? [
            x + c,
            y + a
        ] : [
            x + a,
            y + c
        ];
    };
    $3c042d4e8c9507db$var$dropShadow(g, T, x, y, vert ? across : run, vert ? run : across);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = units[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var u = _step.value;
            var deepU = across - u.back;
            put(u.at, 0, u.wide, deepU, T.struct); // the unit's slab
            put(u.at, deepU - 1, u.wide, 1, T.structDark); // its own back edge, stepped
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // The roof reads as pitched: the frontage slope catches the sun, the rear
    // slope does not, and the ridge is the line between them.
    var ridge = across >> 1;
    g.a(0.13, function() {
        return put(0, 0, run, ridge, T.structLight);
    });
    g.a(0.13, function() {
        return put(0, ridge, run, across - ridge, T.structDark);
    });
    // Rafters across both slopes, close enough together to read as texture
    // rather than as detail — the same job roofRect's panel seams do, at the
    // pitch a house roof is boarded at.
    g.a(0.1, function() {
        for(var a = 3; a < run; a += 3)put(a, 1, 1, across - 2, T.structDark);
    });
    put(0, ridge, run, 1, T.structDark);
    put(0, 0, run, 1, T.structLight); // the flush frontage
    put(0, 0, 1, across, T.structLight); // and the lit end of the run
    put(run - 1, 0, 1, across, T.structDark);
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        // The comb. A party wall is one line, not two edges and a gap — that is the
        // whole difference between a terrace and two buildings standing near enough
        // to look like one.
        for(var _iterator1 = units[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var u1 = _step1.value;
            if (!u1.at) continue;
            put(u1.at - 1, 0, 1, across - u1.back, T.structDark);
            put(u1.at, 0, 1, across - u1.back, T.structLight);
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    // Stacks on the party walls, which is what says HOUSES from overhead.
    var stackW = Math.max(2, Math.round(2 * s));
    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
    try {
        for(var _iterator2 = units[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var u2 = _step2.value;
            if (!u2.stack || !u2.at) continue;
            put(u2.at - stackW, ridge - 3, stackW * 2, 5, T.structDark);
            put(u2.at - stackW, ridge - 3, stackW * 2, 1, T.structLight);
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
            }
        } finally{
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }
    var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
    try {
        var _loop = function() {
            var u = _step3.value;
            if (!u.lit || u.at + u.wide > run) return "continue";
            var _atXY = (0, $1788e2ed61915b1e$export$71511d61b312f219)(atXY(u.at + (u.wide >> 1), 0), 2), wx = _atXY[0], wy = _atXY[1];
            $3c042d4e8c9507db$var$dynamic(function(g, T) {
                if ($3c042d4e8c9507db$var$ANIM.lamp <= 0.02) return;
                var a = $3c042d4e8c9507db$var$ANIM.lamp * $3c042d4e8c9507db$var$powerFlicker(wx * 4.7 + wy * 2.9);
                if (a <= 0.05) return;
                g.a(0.28 * a, function() {
                    return $3c042d4e8c9507db$var$disc(g, wx, wy, 5, T.glow);
                }); // pooled on the pavement
                g.a(0.9 * a, function() {
                    return vert ? g.r(wx, wy - 1, 2, 3, T.glow) : g.r(wx - 1, wy, 3, 2, T.glow);
                });
            });
        };
        // Lit windows on the frontage after dusk, unit by unit. Without this a
        // street of terraces is the one black stretch on a map whose every
        // free-standing block glows — roofRect has spilled light since it was
        // written, and a terrace is the same building repeated. Same shape of gate,
        // for the same reason: the rolls are already spent, the lamp test lives
        // inside the closure so nightfall never invalidates the cached still layer.
        for(var _iterator3 = units[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true)_loop();
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                _iterator3.return();
            }
        } finally{
            if (_didIteratorError3) {
                throw _iteratorError3;
            }
        }
    }
}
function $3c042d4e8c9507db$var$transformerPad(g, rng, T, x, y) {
    $3c042d4e8c9507db$var$dropShadow(g, T, x, y, 21, 21);
    g.r(x, y, 21, 21, T.structDark); // fenced compound
    g.r(x + 1, y + 1, 19, 19, T.ground2);
    g.r(x + 3, y + 3, 15, 15, T.metal); // the transformer
    g.r(x + 3, y + 3, 15, 1, T.structLight);
    g.r(x + 3, y + 17, 15, 1, T.structDark);
    g.a(0.55, function() {
        for(var i = x + 5; i < x + 17; i += 3)g.r(i, y + 5, 1, 11, T.structDark);
    });
    g.r(x + 8, y + 9, 5, 3, T.structDark); // core block
    for(var _i = 0, _iter = [
        [
            x + 4,
            y + 4
        ],
        [
            x + 16,
            y + 4
        ],
        [
            x + 4,
            y + 16
        ],
        [
            x + 16,
            y + 16
        ]
    ]; _i < _iter.length; _i++){
        var _iter__i = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_iter[_i], 2), bx = _iter__i[0], by = _iter__i[1];
        g.r(bx, by, 1, 1, T.accent); // bushing terminals
    }
}
function $3c042d4e8c9507db$var$crateCluster(g, rng, T, x, y, cols, rows) {
    $3c042d4e8c9507db$var$dropShadow(g, T, x, y, cols * 12, rows * 12);
    for(var cy = 0; cy < rows; cy++){
        var _loop = function(cx) {
            if (rng() < 0.15) return "continue";
            var c = rng() < 0.5 ? T.metal : T.struct;
            var bx = x + cx * 12, by = y + cy * 12;
            g.r(bx, by, 11, 11, c);
            g.r(bx, by, 11, 1, T.structLight); // lit lid edge
            g.r(bx, by, 1, 11, T.structLight);
            g.r(bx, by + 10, 11, 1, T.structDark);
            g.r(bx + 10, by, 1, 11, T.structDark);
            g.a(0.4, function() {
                g.r(bx + 1, by + 3, 9, 1, T.structDark);
                g.r(bx + 1, by + 7, 9, 1, T.structDark);
            });
            if (rng() < 0.35) g.r(bx + 3, by + 4, 4, 3, T.accent); // stencilled marking
        };
        for(var cx = 0; cx < cols; cx++)_loop(cx);
    }
}
function $3c042d4e8c9507db$var$fenceRing(g, rng, T, x, y, w, h, conn) {
    // chain-link: posts every 9px with a thin rail between them
    g.a(0.75, function() {
        g.r(x, y, w, 1, T.structDark);
        g.r(x, y + h - 1, w, 1, T.structDark);
        g.r(x, y, 1, h, T.structDark);
        g.r(x + w - 1, y, 1, h, T.structDark);
    });
    for(var px = x; px < x + w; px += 9){
        g.r(px, y, 1, 2, T.metal);
        g.r(px, y + h - 2, 1, 2, T.metal);
    }
    for(var py = y; py < y + h; py += 9){
        g.r(x, py, 2, 1, T.metal);
        g.r(x + w - 2, py, 2, 1, T.metal);
    }
    for(var _i = 0, _iter = [
        [
            x,
            y
        ],
        [
            x + w - 2,
            y
        ],
        [
            x,
            y + h - 2
        ],
        [
            x + w - 2,
            y + h - 2
        ]
    ]; _i < _iter.length; _i++){
        var _iter__i = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_iter[_i], 2), cx = _iter__i[0], cy = _iter__i[1];
        g.r(cx, cy, 2, 2, T.metal); // corner posts
    }
    // gaps where a connector passes through
    var gx = x + (w >> 1) - 9, gy = y + (h >> 1) - 9;
    if (conn.n) g.r(gx, y, 21, 2, T.ground1);
    if (conn.s) g.r(gx, y + h - 2, 21, 2, T.ground1);
    if (conn.w) g.r(x, gy, 2, 21, T.ground1);
    if (conn.e) g.r(x + w - 2, gy, 2, 21, T.ground1);
}
function $3c042d4e8c9507db$var$tentTop(g, rng, T, x, y) {
    var s = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 21;
    for(var i = 0; i < s; i++){
        var half = Math.min(i, s - 1 - i) + 1;
        g.r(x + (s >> 1) - half + 1, y + i, half * 2 - 1, 1, T.struct); // diamond canopy
    }
    g.r(x + (s >> 1), y, 1, s, T.structLight); // ridge seam
    g.a(0.3, function() {
        g.r(x + (s >> 1) - 4, y + 4, 1, s - 8, T.structDark);
        g.r(x + (s >> 1) + 4, y + 4, 1, s - 8, T.structDark);
    });
}
function $3c042d4e8c9507db$var$fireRing(g, rng, T, cx, cy) {
    for(var i = 0; i < 9; i++){
        var a = i / 9 * Math.PI * 2;
        g.r(cx + Math.round(Math.cos(a) * 9) - 1, cy + Math.round(Math.sin(a) * 9) - 1, 3, 3, T.structDark);
    }
    g.a(0.5, function() {
        return $3c042d4e8c9507db$var$disc(g, cx, cy, 6, T.structDark);
    }); // ash bed
    $3c042d4e8c9507db$var$dynamic(function(g, T) {
        var f = $3c042d4e8c9507db$var$flicker(cx, cy, 9); // fast flame flicker
        g.a(0.1 + 0.15 * f, function() {
            return $3c042d4e8c9507db$var$disc(g, cx, cy, 13, T.glow);
        });
        g.a(0.35 + 0.3 * f, function() {
            return $3c042d4e8c9507db$var$disc(g, cx, cy, 6, T.glow);
        });
        g.a(0.9, function() {
            return $3c042d4e8c9507db$var$disc(g, cx, cy, 2 + (f > 0.5 ? 1 : 0), T.glow);
        });
    });
}
// ===============================
// ELEMENT REGISTRY + RECIPE INTERPRETER
// ===============================
// Recipes in RENDER_CONFIG.recipes are pure data: lists of element specs
// that reference this registry by name. Every element receives the resolved
// params object p; color params are palette key names (literal hex also
// works). Adding a new drawable primitive = one entry here; composing a new
// room look = config only.
var $3c042d4e8c9507db$var$pcolor = function(T, c, fallback) {
    return T[c] || c || T[fallback];
};
var $3c042d4e8c9507db$export$a6d18b072e3b7ccb = {
    rect: function(g, rng, T, tune, conn, p) {
        var c = $3c042d4e8c9507db$var$pcolor(T, p.color, 'structDark');
        if (p.alpha != null) g.a(p.alpha, function() {
            return g.r(p.x, p.y, p.w, p.h, c);
        });
        else g.r(p.x, p.y, p.w, p.h, c);
    },
    // ---- skill-anchor primitives ----
    // The deployed pad every anchor stands on. It does the work that collision
    // detection would otherwise have to: an anchor landing on a warehouse roof
    // reads as apparatus INSTALLED on the roof rather than a mis-layered sprite,
    // and the player learns one silhouette instead of fifteen. shape is set per
    // faction so allegiance is legible even when the device is too small to read.
    anchorPlate: function(g, rng, T, tune, conn, p) {
        var _p_w, _p_h;
        var x = p.x, y = p.y, w = (_p_w = p.w) !== null && _p_w !== void 0 ? _p_w : 24, h = (_p_h = p.h) !== null && _p_h !== void 0 ? _p_h : 24;
        $3c042d4e8c9507db$var$dropShadow(g, T, x, y, w, h);
        g.r(x, y, w, h, T.structDark);
        g.r(x + 1, y + 1, w - 2, h - 2, T.ground2);
        if (p.shape === 'cut') for(var i = 0; i < 4; i++){
            g.r(x + i, y + i, 4 - i, 1, T.structDark);
            g.r(x + w - 4, y + i, 4 - i, 1, T.structDark);
        }
        else if (p.shape === 'round') for(var _i = 0, _iter = [
            [
                x + 1,
                y + 1
            ],
            [
                x + w - 2,
                y + 1
            ],
            [
                x + 1,
                y + h - 2
            ],
            [
                x + w - 2,
                y + h - 2
            ]
        ]; _i < _iter.length; _i++){
            var _iter__i = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_iter[_i], 2), cx = _iter__i[0], cy = _iter__i[1];
            g.r(cx, cy, 1, 1, T.structDark);
        }
        g.r(x + 1, y + 1, w - 2, 1, T.structLight); // lit N/W lip
        g.r(x + 1, y + 1, 1, h - 2, T.structLight);
        g.r(x + 1, y + h - 2, w - 2, 1, T.structDark);
        for(var _i1 = 0, _iter1 = [
            [
                x + 2,
                y + 2
            ],
            [
                x + w - 3,
                y + 2
            ],
            [
                x + 2,
                y + h - 3
            ],
            [
                x + w - 3,
                y + h - 3
            ]
        ]; _i1 < _iter1.length; _i1++){
            var _iter__i1 = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_iter1[_i1], 2), bx = _iter__i1[0], by = _iter__i1[1];
            g.r(bx, by, 1, 1, T.metal); // corner bolts
        }
    },
    // One primitive covering the dish/emitter/bloom family: a disc body, an
    // optional rim, concentric ground rings and an optional feed strut. Three
    // anchors use it at different radii and colors rather than three near-copies.
    dish: function(g, rng, T, tune, conn, p) {
        var _loop = function(i) {
            g.a(0.3 - i * 0.06, function() {
                return $3c042d4e8c9507db$var$ringO(g, x, y, r + i * 4, c);
            });
        };
        var _p_r;
        var x = p.x, y = p.y, r = (_p_r = p.r) !== null && _p_r !== void 0 ? _p_r : 9;
        var c = $3c042d4e8c9507db$var$pcolor(T, p.color, 'accent');
        $3c042d4e8c9507db$var$discShadow(g, T, x, y, r);
        var _p_rings;
        for(var i = 1; i <= ((_p_rings = p.rings) !== null && _p_rings !== void 0 ? _p_rings : 0); i++)_loop(i);
        $3c042d4e8c9507db$var$disc(g, x, y, r, T.metal);
        $3c042d4e8c9507db$var$ringO(g, x, y, r, c);
        g.a(0.5, function() {
            return $3c042d4e8c9507db$var$disc(g, x - 1, y - 1, Math.max(1, r - 4), T.structLight);
        });
        if (p.arm) {
            g.r(x, y - r - 3, 1, r + 3, T.structDark);
            g.r(x - 1, y - r - 4, 3, 2, T.metal);
        }
        g.r(x - 1, y - 1, 3, 3, T.structDark);
    },
    // A landing pad with corner lights and one airframe sitting on it.
    dronePad: function(g, rng, T, tune, conn, p) {
        var _p_s;
        var x = p.x, y = p.y, s = (_p_s = p.s) !== null && _p_s !== void 0 ? _p_s : 16;
        g.r(x, y, s, s, T.structDark);
        // the cross and the lights are what make this read as a pad rather than a
        // dark square, so they carry nearly full weight
        g.a(0.85, function() {
            g.r(x + (s >> 1) - 1, y + 2, 2, s - 4, T.accent);
            g.r(x + 2, y + (s >> 1) - 1, s - 4, 2, T.accent);
        });
        for(var _i = 0, _iter = [
            [
                x,
                y
            ],
            [
                x + s - 3,
                y
            ],
            [
                x,
                y + s - 3
            ],
            [
                x + s - 3,
                y + s - 3
            ]
        ]; _i < _iter.length; _i++){
            var _iter__i = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_iter[_i], 2), cx = _iter__i[0], cy = _iter__i[1];
            g.r(cx, cy, 3, 3, T.structDark); // light housings
            g.r(cx + 1, cy + 1, 2, 2, T.glow); // pad lights
        }
        var dx = x + (s >> 1) - 3, dy = y + (s >> 1) - 3;
        $3c042d4e8c9507db$var$dropShadow(g, T, dx, dy, 6, 6);
        g.r(dx + 1, dy + 1, 4, 4, T.metal); // parked airframe
        for(var _i1 = 0, _iter1 = [
            [
                dx - 1,
                dy - 1
            ],
            [
                dx + 4,
                dy - 1
            ],
            [
                dx - 1,
                dy + 4
            ],
            [
                dx + 4,
                dy + 4
            ]
        ]; _i1 < _iter1.length; _i1++){
            var _iter__i1 = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_iter1[_i1], 2), rx = _iter__i1[0], ry = _iter__i1[1];
            g.r(rx, ry, 3, 3, T.structDark); // rotor booms
        }
    },
    speckle: function(g, rng, T, tune, conn, p) {
        var c = $3c042d4e8c9507db$var$pcolor(T, p.color, 'structLight');
        var _p_n, _p_alpha;
        for(var i = 0; i < ((_p_n = p.n) !== null && _p_n !== void 0 ? _p_n : 8); i++)// scraps, not pixels — n is a count in the recipe data, so the specks
        // themselves have to carry the area they used to cover as 3px blocks
        g.a((_p_alpha = p.alpha) !== null && _p_alpha !== void 0 ? _p_alpha : 1, function() {
            return g.r(p.x + $3c042d4e8c9507db$var$ri(rng, 0, p.w), p.y + $3c042d4e8c9507db$var$ri(rng, 0, p.h), $3c042d4e8c9507db$var$ri(rng, 2, 4), $3c042d4e8c9507db$var$ri(rng, 1, 3), c);
        });
    },
    darkWash: function(g, rng, T, tune, conn, p) {
        var _p_alpha;
        g.a((_p_alpha = p.alpha) !== null && _p_alpha !== void 0 ? _p_alpha : 0.15, function() {
            return g.r(0, 0, $3c042d4e8c9507db$export$9e15ff8aa6bc996f, $3c042d4e8c9507db$export$9e15ff8aa6bc996f, T.far);
        });
    },
    building: function(g, rng, T, tune, conn, p) {
        $3c042d4e8c9507db$var$buildingTop(g, rng, T, tune, p.x, p.y, p.w, p.h);
    },
    terrace: function(g, rng, T, tune, conn, p) {
        $3c042d4e8c9507db$var$terraceTop(g, rng, T, tune, p.x, p.y, p.w, p.h, p.vert);
    },
    storefront: function(g, rng, T, tune, conn, p) {
        var w = Math.min(Math.round(p.w * tune.buildingScale), $3c042d4e8c9507db$export$9e15ff8aa6bc996f - $3c042d4e8c9507db$var$TILE_CLAMP - p.x);
        var h = Math.min(Math.round(p.h * tune.buildingScale), 60 - p.y);
        $3c042d4e8c9507db$var$roofRect(g, rng, T, p.x, p.y, w, h);
        for(var i = 0; i < w; i += 3)g.r(p.x + i, p.y + h, 3, 6, i / 3 % 2 ? T.accent : T.structDark);
        g.a(0.4, function() {
            return g.r(p.x, p.y + h + 5, w, 1, T.structDark);
        }); // awning drop shadow
    },
    stalls: function(g, rng, T, tune, conn, p) {
        var _loop = function(sx) {
            var sy = $3c042d4e8c9507db$var$ri(rng, 84, 93);
            g.r(sx, sy, 15, 12, T.struct);
            g.r(sx, sy, 15, 1, T.structLight);
            g.r(sx, sy + 11, 15, 1, T.structDark);
            g.a(0.35, function() {
                for(var i = 3; i < 15; i += 4)g.r(sx + i, sy + 1, 1, 10, T.structDark);
            });
            g.r(sx + 3, sy + 3, 9, 4, T.rust); // goods on the counter
        };
        for(var sx = 18; sx < 90; sx += 27)_loop(sx);
    },
    transformerPad: function(g, rng, T, tune, conn, p) {
        $3c042d4e8c9507db$var$transformerPad(g, rng, T, p.x, p.y);
    },
    tank: function(g, rng, T, tune, conn, p) {
        var _p_r;
        $3c042d4e8c9507db$var$tankTop(g, rng, T, p.x, p.y, (_p_r = p.r) !== null && _p_r !== void 0 ? _p_r : 15);
    },
    tower: function(g, rng, T, tune, conn, p) {
        $3c042d4e8c9507db$var$towerTop(g, rng, T, p.x, p.y);
    },
    // The monumental tier, exposed to the recipes. These are authored for the
    // signature layer (see TD_SIGNATURE) but nothing about them is region-bound,
    // so a recipe that wants a silo yard or a glasshouse can just ask for one.
    silo: function(g, rng, T, tune, conn, p) {
        var _p_r;
        $3c042d4e8c9507db$var$silo(g, rng, T, p.x, p.y, Math.round(((_p_r = p.r) !== null && _p_r !== void 0 ? _p_r : 12) * tune.buildingScale));
    },
    gantry: function(g, rng, T, tune, conn, p) {
        var _p_len;
        $3c042d4e8c9507db$var$gantry(g, rng, T, p.x, p.y, (_p_len = p.len) !== null && _p_len !== void 0 ? _p_len : 54, !!p.vert);
    },
    glassSpan: function(g, rng, T, tune, conn, p) {
        var _p_w, _p_h;
        $3c042d4e8c9507db$var$glassSpan(g, rng, T, p.x, p.y, Math.round(((_p_w = p.w) !== null && _p_w !== void 0 ? _p_w : 54) * tune.buildingScale), Math.round(((_p_h = p.h) !== null && _p_h !== void 0 ? _p_h : 24) * tune.buildingScale));
    },
    towerCore: function(g, rng, T, tune, conn, p) {
        var _p_w, _p_h;
        $3c042d4e8c9507db$var$towerCore(g, rng, T, p.x, p.y, Math.round(((_p_w = p.w) !== null && _p_w !== void 0 ? _p_w : 33) * tune.buildingScale), Math.round(((_p_h = p.h) !== null && _p_h !== void 0 ? _p_h : 33) * tune.buildingScale));
    },
    crates: function(g, rng, T, tune, conn, p) {
        var _p_cols, _p_rows;
        $3c042d4e8c9507db$var$crateCluster(g, rng, T, p.x, p.y, (_p_cols = p.cols) !== null && _p_cols !== void 0 ? _p_cols : 2, (_p_rows = p.rows) !== null && _p_rows !== void 0 ? _p_rows : 2);
    },
    container: function(g, rng, T, tune, conn, p) {
        $3c042d4e8c9507db$var$containerBox(g, rng, T, p.x, p.y, !!p.vert);
    },
    vehicle: function(g, rng, T, tune, conn, p) {
        $3c042d4e8c9507db$var$vehicle(g, rng, T, p.x, p.y, !!p.vert);
    },
    barrier: function(g, rng, T, tune, conn, p) {
        for(var i = 0; i < 6; i++)g.r(p.x + i * 3, p.y, 3, 6, i % 2 ? T.accent : T.structDark);
        g.r(p.x, p.y + 6, 18, 1, T.structDark); // base shadow line
        g.r(p.x + 1, p.y - 1, 16, 1, T.structLight); // lit top rail
    },
    fence: function(g, rng, T, tune, conn, p) {
        $3c042d4e8c9507db$var$fenceRing(g, rng, T, p.x, p.y, p.w, p.h, p.gaps ? conn : {
            n: false,
            e: false,
            s: false,
            w: false
        });
    },
    pipeline: function(g, rng, T, tune, conn, p) {
        $3c042d4e8c9507db$var$pipeRun(g, T, p.x, p.y, p.w, false, 6, 24);
    },
    tree: function(g, rng, T, tune, conn, p) {
        var _p_r;
        $3c042d4e8c9507db$var$tree(g, rng, T, p.x, p.y, (_p_r = p.r) !== null && _p_r !== void 0 ? _p_r : 9);
    },
    bush: function(g, rng, T, tune, conn, p) {
        $3c042d4e8c9507db$var$bushPatch(g, rng, T, p.x, p.y);
    },
    foliage: function(g, rng, T, tune, conn, p) {
        var _p_size;
        $3c042d4e8c9507db$var$foliageClump(g, rng, T, p.x, p.y, (_p_size = p.size) !== null && _p_size !== void 0 ? _p_size : 5);
    },
    crack: function(g, rng, T, tune, conn, p) {
        var _p_len;
        $3c042d4e8c9507db$var$crack(g, rng, T, p.x, p.y, (_p_len = p.len) !== null && _p_len !== void 0 ? _p_len : 30);
    },
    rubble: function(g, rng, T, tune, conn, p) {
        var _p_n;
        $3c042d4e8c9507db$var$rubble(g, rng, T, p.x, p.x + p.w, p.y, p.y + p.h, (_p_n = p.n) !== null && _p_n !== void 0 ? _p_n : 12);
    },
    parkingLot: function(g, rng, T, tune, conn, p) {
        var _p_w, _p_h;
        $3c042d4e8c9507db$var$parkingLot(g, rng, T, p.x, p.y, (_p_w = p.w) !== null && _p_w !== void 0 ? _p_w : 66, (_p_h = p.h) !== null && _p_h !== void 0 ? _p_h : 33);
    },
    tent: function(g, rng, T, tune, conn, p) {
        var _p_s;
        $3c042d4e8c9507db$var$tentTop(g, rng, T, p.x, p.y, (_p_s = p.s) !== null && _p_s !== void 0 ? _p_s : 21);
    },
    fireRing: function(g, rng, T, tune, conn, p) {
        $3c042d4e8c9507db$var$fireRing(g, rng, T, p.x, p.y);
    },
    manhole: function(g, rng, T, tune, conn, p) {
        $3c042d4e8c9507db$var$disc(g, p.x, p.y, 4, T.structDark);
        $3c042d4e8c9507db$var$ringO(g, p.x, p.y, 4, T.metal);
        g.a(0.4, function() {
            return g.r(p.x - 3, p.y, 7, 1, T.structLight);
        }); // lid slot
    },
    streetLamp: function(g, rng, T, tune, conn, p) {
        g.r(p.x, p.y, 2, 6, T.structDark); // dusk on the intermittent grid
        g.r(p.x - 1, p.y - 4, 4, 4, T.metal); // lamp head
        g.r(p.x - 1, p.y - 4, 4, 1, T.structLight);
        $3c042d4e8c9507db$var$dynamic(function(g, T) {
            if ($3c042d4e8c9507db$var$ANIM.lamp <= 0.02) return;
            var a = $3c042d4e8c9507db$var$ANIM.lamp * $3c042d4e8c9507db$var$powerFlicker(p.x * 7.7 + p.y * 3.1);
            if (a <= 0.05) return;
            g.a(0.3 * a, function() {
                return $3c042d4e8c9507db$var$disc(g, p.x, p.y - 3, 9, T.glow);
            });
            g.a(0.9 * a, function() {
                return g.r(p.x - 1, p.y - 3, 3, 2, T.glow);
            });
        });
    },
    sinkhole: function(g, rng, T, tune, conn, p) {
        var _p_r;
        var r = (_p_r = p.r) !== null && _p_r !== void 0 ? _p_r : 21;
        $3c042d4e8c9507db$var$voidPit(g, rng, T, p.x, p.y, r);
        for(var i = 0; i < 3; i++)$3c042d4e8c9507db$var$crack(g, rng, T, p.x + $3c042d4e8c9507db$var$ri(rng, -r - 3, r + 3), p.y + $3c042d4e8c9507db$var$ri(rng, -r - 3, r + 3), $3c042d4e8c9507db$var$ri(rng, 15, 27));
        // Spoil lands on the RIM, in a ring — scattering it across the pit's
        // bounding box put four fifths of it inside the shaft, debris hanging in a
        // hole that goes down to nothing.
        for(var i1 = 0; i1 < 8; i1++){
            var a = rng() * Math.PI * 2, d = r + $3c042d4e8c9507db$var$ri(rng, 1, 7);
            $3c042d4e8c9507db$var$rubbleChunk(g, rng, T, p.x + Math.cos(a) * d, p.y + Math.sin(a) * d);
        }
    },
    // A rift rather than a shaft. Built as one continuous swept shape — a chain
    // of overlapping discs each drew its own rim, and the result read as a row of
    // scalloped circles rather than as ground that had torn open.
    chasm: function(g, rng, T, tune, conn, p) {
        var _p_len, _p_r;
        var len = (_p_len = p.len) !== null && _p_len !== void 0 ? _p_len : 60, r = (_p_r = p.r) !== null && _p_r !== void 0 ? _p_r : 15, vert = !!p.vert;
        var half = len / 2;
        // half-width along the rift: pinched to nothing at both tips, uneven between
        var knots = [];
        for(var i = 0; i <= 6; i++)knots.push(0.6 + rng() * 0.55);
        var widthAt = function(t) {
            var taper = Math.pow(Math.sin(Math.PI * Math.min(1, Math.max(0, t))), 0.55);
            var k = t * 6, i = Math.min(5, Math.floor(k)), f = k - i;
            var bend = knots[i] + (knots[i + 1] - knots[i]) * (f * f * (3 - 2 * f));
            return Math.max(1, r * taper * bend);
        };
        var drift = function(t) {
            return Math.round(Math.sin(t * Math.PI * 1.6) * r * 0.28);
        };
        var spans = [];
        for(var d = 0; d <= len; d++){
            var t = d / len, h = Math.round(widthAt(t)), off = drift(t);
            var along = Math.round(-half + d);
            spans.push(vert ? [
                Math.round(p.x + off - h),
                Math.round(p.y + along),
                h * 2,
                1
            ] : [
                Math.round(p.x + along),
                Math.round(p.y + off - h),
                1,
                h * 2
            ]);
        }
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = spans[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step.value, 4), x = _step_value[0], y = _step_value[1], w = _step_value[2], h1 = _step_value[3];
                g.r(x, y, w, h1, T.far); // the ground below
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        g.a(0.6, function() {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = spans[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step.value, 4), x = _step_value[0], y = _step_value[1], w = _step_value[2], h = _step_value[3];
                    var inset = Math.round((vert ? w : h) * 0.3);
                    if ((vert ? w : h) - inset * 2 < 2) continue;
                    g.r(vert ? x + inset : x, vert ? y : y + inset, vert ? w - inset * 2 : w, vert ? h : h - inset * 2, '#000000');
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        });
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = spans[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var _step_value1 = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step1.value, 4), x1 = _step_value1[0], y1 = _step_value1[1], w1 = _step_value1[2], h2 = _step_value1[3];
                if (vert) {
                    g.r(x1, y1, 1, 1, T.structDark);
                    g.r(x1 + w1 - 1, y1, 1, 1, T.structDark);
                } else {
                    g.r(x1, y1, 1, 1, T.structDark);
                    g.r(x1, y1 + h2 - 1, 1, 1, T.structDark);
                }
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        // Lit lip: ONE pixel on the sunward edge of each span, whichever way the
        // rift runs. Taking the span's full width when it ran north-south washed
        // the whole chasm pale instead of catching its edge.
        g.a(0.3, function() {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = spans[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step.value, 2), x = _step_value[0], y = _step_value[1];
                    g.r(x, y, 1, 1, T.structLight);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        });
        for(var i1 = 0; i1 < 5; i1++){
            var _spans_ri = (0, $1788e2ed61915b1e$export$71511d61b312f219)(spans[$3c042d4e8c9507db$var$ri(rng, 0, spans.length - 1)], 2), x2 = _spans_ri[0], y2 = _spans_ri[1];
            $3c042d4e8c9507db$var$crack(g, rng, T, x2 + $3c042d4e8c9507db$var$ri(rng, -6, 6), y2 + $3c042d4e8c9507db$var$ri(rng, -6, 6), $3c042d4e8c9507db$var$ri(rng, 12, 27));
        }
        // Spoil lines both LIPS of the rift rather than filling its bounding box:
        // a rift is mostly hole, so a box scatter dropped most of the debris into
        // it. Each chunk picks a span and steps out past that span's own edge, so
        // the heap follows the tear however it wanders and pinches in at the tips.
        for(var i2 = 0; i2 < 14; i2++){
            var _spans_ri1 = (0, $1788e2ed61915b1e$export$71511d61b312f219)(spans[$3c042d4e8c9507db$var$ri(rng, 0, spans.length - 1)], 4), x3 = _spans_ri1[0], y3 = _spans_ri1[1], w2 = _spans_ri1[2], h3 = _spans_ri1[3];
            var out = $3c042d4e8c9507db$var$ri(rng, 1, 7), far = rng() < 0.5;
            $3c042d4e8c9507db$var$rubbleChunk(g, rng, T, vert ? far ? x3 + w2 + out : x3 - out - 4 : x3, vert ? y3 : far ? y3 + h3 + out : y3 - out - 4);
        }
    },
    pond: function(g, rng, T, tune, conn, p) {
        var _g;
        var C = $3c042d4e8c9507db$export$da8728cc680c21d8.cx, R = $3c042d4e8c9507db$export$da8728cc680c21d8.r;
        // A shoreline is not a circle: each side of every scanline gets its own
        // smooth wobble, and the bank, the water and the deep all follow the same
        // one so they stay concentric with it.
        var left = $3c042d4e8c9507db$var$wobbler(rng, 6, 0.16), right = $3c042d4e8c9507db$var$wobbler(rng, 6, 0.16);
        $3c042d4e8c9507db$var$blob(g, C, C, R + 3, T.ground2, left, right); // bank
        $3c042d4e8c9507db$var$blob(g, C, C, R, T.water1, left, right);
        g.a(0.25, function() {
            return $3c042d4e8c9507db$var$blob(g, C, C, R - 9, T.water2, left, right);
        }); // deeper in the middle
        for(var i = 0; i < 26; i++){
            var dy = $3c042d4e8c9507db$var$ri(rng, -R + 6, R - 6);
            var _blobSpan = (0, $1788e2ed61915b1e$export$71511d61b312f219)($3c042d4e8c9507db$var$blobSpan(R, dy, left, right), 2), l = _blobSpan[0], r = _blobSpan[1];
            if (l + r < 14) continue;
            g.r(C - l + 3 + $3c042d4e8c9507db$var$ri(rng, 0, Math.max(1, l + r - 9)), C + dy, $3c042d4e8c9507db$var$ri(rng, 3, 8), 1, T.water2);
        }
        // wave crests drift across the pond (position-phased, no rng, so the
        // pond layout stays identical while the crests slide when animating)
        $3c042d4e8c9507db$var$dynamic(function(g, T) {
            var _loop = function(i) {
                var _Math;
                var wy = C + i * 8;
                var half = (_Math = Math).min.apply(_Math, (0, $4c858c0d999a5b9b$export$71511d61b312f219)($3c042d4e8c9507db$var$blobSpan(R, wy - C, left, right)));
                if (half < 12) return "continue";
                var xo = Math.round(7 * Math.sin($3c042d4e8c9507db$var$ANIM.t * 0.8 + i * 1.9));
                g.a(0.5, function() {
                    g.r(C - (half >> 1) + xo, wy, 9, 1, T.water2);
                    g.r(C + (half >> 2) + xo, wy + 5, 7, 1, T.water2);
                });
            };
            for(var i = -4; i <= 4; i++)_loop(i);
        });
        var dock = conn.e ? [
            81,
            54,
            36,
            12
        ] : conn.w ? [
            3,
            54,
            36,
            12
        ] : conn.n ? [
            54,
            3,
            12,
            36
        ] : [
            54,
            81,
            12,
            36
        ];
        (_g = g).r.apply(_g, (0, $4c858c0d999a5b9b$export$71511d61b312f219)(dock).concat([
            T.rust
        ])); // plank walkway
        g.a(0.4, function() {
            if (dock[2] > dock[3]) for(var i = 3; i < dock[2]; i += 6)g.r(dock[0] + i, dock[1], 1, dock[3], T.structDark);
            else for(var i1 = 3; i1 < dock[3]; i1 += 6)g.r(dock[0], dock[1] + i1, dock[2], 1, T.structDark);
        });
        g.r(dock[0], dock[1], dock[2] > dock[3] ? dock[2] : 1, dock[2] > dock[3] ? 1 : dock[3], T.structLight);
    },
    reactorCore: function(g, rng, T, tune, conn, p) {
        var C = $3c042d4e8c9507db$export$9e15ff8aa6bc996f >> 1;
        $3c042d4e8c9507db$var$disc(g, C, C, 27, T.metal);
        $3c042d4e8c9507db$var$ringO(g, C, C, 27, T.structDark);
        $3c042d4e8c9507db$var$ringO(g, C, C, 26, T.structDark);
        $3c042d4e8c9507db$var$ringO(g, C, C, 15, T.structDark);
        g.a(0.3, function() {
            for(var i = 0; i < 8; i++){
                var a = i / 8 * Math.PI * 2;
                for(var d = 16; d < 27; d++)g.r(C + Math.round(Math.cos(a) * d), C + Math.round(Math.sin(a) * d), 1, 1, T.structDark);
            }
        });
        // the core's own light: dynamic so the day tint never dims it (T.glow is
        // exempt from tinting, and the composite-time multiply is not)
        $3c042d4e8c9507db$var$dynamic(function(g, T) {
            g.a(0.6, function() {
                return $3c042d4e8c9507db$var$disc(g, C, C, 9, T.glow);
            });
            g.a(0.9, function() {
                return $3c042d4e8c9507db$var$disc(g, C, C, 4, T.glow);
            });
            g.r(C - 1, C - 1, 3, 3, T.accent);
        });
        for(var _i = 0, _iter = [
            [
                21,
                21
            ],
            [
                96,
                21
            ],
            [
                21,
                96
            ],
            [
                96,
                96
            ]
        ]; _i < _iter.length; _i++){
            var _iter__i = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_iter[_i], 2), cx = _iter__i[0], cy = _iter__i[1];
            g.r(cx, cy, 6, 6, T.accent); // marker pads
        }
    },
    portalPad: function(g, rng, T, tune, conn, p) {
        // pad only — the energy glow is drawn by portalGlow() as the very last
        // pass so nothing (flood water, growth, clouds) can cover it
        var C = $3c042d4e8c9507db$export$9e15ff8aa6bc996f >> 1;
        $3c042d4e8c9507db$var$disc(g, C, C, 15, T.metal);
        $3c042d4e8c9507db$var$ringO(g, C, C, 15, T.accent);
        $3c042d4e8c9507db$var$ringO(g, C, C, 14, T.accent);
        g.a(0.35, function() {
            return $3c042d4e8c9507db$var$ringO(g, C, C, 10, T.structDark);
        });
    }
};
// Resolve a config param value: [min,max] draws a seeded integer in range;
// { pick: [...] } draws a seeded choice (entries may be scalars or ranges);
// anything else passes through.
function $3c042d4e8c9507db$var$resolveVal(v, rng) {
    if (Array.isArray(v)) return $3c042d4e8c9507db$var$ri(rng, v[0], v[1]);
    if (v && (typeof v === "undefined" ? "undefined" : (0, $1968e3edfc5cfc11$export$71511d61b312f219)(v)) === 'object' && v.pick) return $3c042d4e8c9507db$var$resolveVal(v.pick[$3c042d4e8c9507db$var$ri(rng, 0, v.pick.length - 1)], rng);
    return v;
}
var $3c042d4e8c9507db$var$SPEC_KEYS = new Set([
    'el',
    'chance',
    'when',
    'repeat'
]);
var $3c042d4e8c9507db$export$258e2d684a2e26ab = new Set([
    'building',
    'terrace',
    'storefront',
    'tower',
    'tank',
    'transformerPad',
    'sinkhole',
    'tent',
    'silo',
    'glassSpan',
    'towerCore'
]);
var $3c042d4e8c9507db$export$da8728cc680c21d8 = {
    cx: $3c042d4e8c9507db$export$9e15ff8aa6bc996f >> 1,
    cy: $3c042d4e8c9507db$export$9e15ff8aa6bc996f >> 1,
    r: 39,
    bank: 42
};
// ---- building density by distance from a road ----
// People build where they can get to. A map that draws every recipe at full
// strength everywhere reads as one uniform sprawl; thinning the built stock
// with distance from the roadway gives the map a grain — frontage along the
// trunk, back lots behind it, and near-open ground where nothing runs.
/**
 * What thins out with distance. Built structures only: the things somebody put
 * up because there was a way to reach them. Ground works — a parking lot, a
 * fence, a pipeline, a hardstand, crates — stay, and read the better for the
 * buildings having gone: an empty lot is exactly what the edge of a settlement
 * looks like.
 *
 * Tents and sinkholes are absent on purpose, though both are solid: a camp is
 * one tent, and a shaft is the whole point of the tile it opened on.
 */ var $3c042d4e8c9507db$var$BUILT_ELEMENTS = new Set([
    'building',
    'terrace',
    'storefront',
    'tower',
    'tank',
    'transformerPad',
    'container',
    'silo',
    'glassSpan',
    'towerCore'
]);
/**
 * Recipes the map PLACES rather than grows: the portal facilities a raid enters
 * and leaves by, the reactor, the rest stop and its shoreline, and collapsed
 * ground. These are landmarks, drawn in full wherever they land. Checkpoints
 * are exempt too (see composeBody) for the same reason gateEmphasis dresses
 * them heavier — they are what the player navigates by.
 *
 * The roadway is exempt for the opposite reason: a trunk tile IS the frontage
 * this whole gradient is measured from, so it is never anything but full.
 */ var $3c042d4e8c9507db$var$DENSITY_EXEMPT = new Set([
    'portal',
    'reactor',
    'water',
    'campsite',
    'blocked',
    'road'
]);
/**
 * How much of a recipe's built stock survives, indexed by distance from the
 * nearest roadway. Index 0 is unused — a tile the road runs through is scored
 * by rank instead, since a trunk frontage is worth more than a back lane.
 * Coverage caps the distance at MAX_ROAD_DISTANCE (2), so the last entry is
 * the emptiest ground on the map.
 */ var $3c042d4e8c9507db$var$DENSITY_BY_DIST = [
    1,
    0.6,
    0.3
];
var $3c042d4e8c9507db$var$MINOR_ROAD_DENSITY = 0.85;
/**
 * How built-up this part of the MAP is, on top of how near this tile is to a
 * road.
 *
 * Distance from the roadway is the only thing the gradient above knows, and
 * the network covers the grid to MAX_ROAD_DISTANCE (2) — so every tile on the
 * map lands in one of three states, interleaved evenly, and the map comes out
 * one settlement of uniform thickness with lanes through it. A town has a core
 * and it has outskirts, and which you are standing in has nothing to do with
 * the nearest road: there are busy back lots and there are empty frontages.
 *
 * The second gradient is the DISTRICT the cell is in — an authored figure on
 * the archetype, so a district's look and its name agree.
 *
 * This used to be a world-space noise field, and it was wrong in a way that
 * took a while to see: it sampled the tile's raw grid position with no per-map
 * term, and a map is at most 7x17 starting at (0,0). Every raid in the game
 * therefore drew from the same patch of lattice — dense in the north-west, a
 * hard sparse band right of centre — the same stencil every time. It broke up
 * density within a map, which was the point, but contributed nothing between
 * maps and imposed a fixed pattern in exchange.
 *
 * What the noise was genuinely good at is kept: it is continuous, so
 * neighbours agree, which makes it the right thing to vary a district
 * INTERNALLY with. It survives as grain of a few per cent about the district's
 * own figure, so a core does not read as flat.
 */ var $3c042d4e8c9507db$var$SETTLEMENT_CELL = 5; // tiles across one lobe of the field
var $3c042d4e8c9507db$var$GRAIN = 0.08; // how far the grain moves a tile off its district
/**
 * What the average tile is built up to. Every district factor is centred on
 * this, so the mix redistributes stock rather than deleting it.
 */ var $3c042d4e8c9507db$var$MEAN_BUILT = 0.85;
function $3c042d4e8c9507db$var$settlement(col, row) {
    // Offset the sample so the lattice's own zero does not sit on the map origin,
    // where every region would open on the same value.
    var s = $3c042d4e8c9507db$var$smoothNoise(col / $3c042d4e8c9507db$var$SETTLEMENT_CELL + 11.3, row / $3c042d4e8c9507db$var$SETTLEMENT_CELL + 7.7);
    // Value noise interpolates between lattice heights, so most of what comes out
    // of it is near the middle; the smoothstep pushes it toward its own ends.
    return s * s * (3 - 2 * s);
}
/**
 * How much of the sea's own tile is still standing. A shore tile is half under
 * water, and what the water took it took a long time ago — so the standing
 * stock there is thin and what is left of the rest is rubble.
 *
 * Expressed through `built` rather than as its own mechanism because `built`
 * already does exactly the right things with it: it shrinks footprints, drops
 * the LARGEST ones first (thinForDistance), lets growth back in, and wears the
 * tarmac. A separate "drown the buildings" pass would have had to reinvent all
 * four and would have disagreed with them at the margins.
 */ var $3c042d4e8c9507db$var$SHORE_BUILT = 0.45; // how much of a shore tile survives
function $3c042d4e8c9507db$export$5553b5f9fd6fa0ba(zone, col, row, shore) {
    var _ZONE_BUILT_zone;
    var base = (_ZONE_BUILT_zone = $3c042d4e8c9507db$var$ZONE_BUILT[zone]) !== null && _ZONE_BUILT_zone !== void 0 ? _ZONE_BUILT_zone : $3c042d4e8c9507db$var$MEAN_BUILT; // unknown district, or a save from before them
    var drowned = shore === 0 ? $3c042d4e8c9507db$var$SHORE_BUILT : shore === 1 ? (1 + $3c042d4e8c9507db$var$SHORE_BUILT) / 2 : 1;
    return base * drowned * (1 - $3c042d4e8c9507db$var$GRAIN + 2 * $3c042d4e8c9507db$var$GRAIN * $3c042d4e8c9507db$var$settlement(col, row));
}
var $3c042d4e8c9507db$var$ZONE_BUILT = Object.fromEntries(Object.entries((0, $980f67465e309611$export$8377a367ab2ae550)).map(function(param) {
    var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), zone = _param[0], a = _param[1];
    var _a_built;
    return [
        zone,
        (_a_built = a.built) !== null && _a_built !== void 0 ? _a_built : $3c042d4e8c9507db$var$MEAN_BUILT
    ];
}));
/**
 * Size moves less than count. Footprint drives the recipes' own
 * `when: buildingScale >= n` gates, and a district that swung it as hard as the
 * count would switch those on and off by neighborhood.
 */ var $3c042d4e8c9507db$var$builtScale = function(b) {
    return 0.72 + 0.28 * (b / $3c042d4e8c9507db$var$MEAN_BUILT);
};
/**
 * Growth fills what is not built, and tarmac nobody drives goes to seed. Both
 * run INVERSE to the district and are centred on the mean tile, so the map
 * gains no vegetation overall — it just stops spreading it evenly.
 */ var $3c042d4e8c9507db$var$builtGrowth = function(b) {
    return 1 + ($3c042d4e8c9507db$var$MEAN_BUILT - b);
};
var $3c042d4e8c9507db$var$builtWear = function(wear, b) {
    return Math.min(1, Math.max(0, wear + ($3c042d4e8c9507db$var$MEAN_BUILT - b) * 0.5));
};
function $3c042d4e8c9507db$export$b0ba4899f6951e17(boxes, dist, rank, built) {
    var stock = boxes.filter(function(b) {
        return $3c042d4e8c9507db$var$BUILT_ELEMENTS.has(b.el);
    });
    if (stock.length < 2) return new Set();
    var density = (dist > 0 ? $3c042d4e8c9507db$var$DENSITY_BY_DIST[Math.min(dist, $3c042d4e8c9507db$var$DENSITY_BY_DIST.length - 1)] : rank === (0, $57ad8bd108ea335d$export$39615881bb0d21f6) ? 1 : $3c042d4e8c9507db$var$MINOR_ROAD_DENSITY) * (built != null ? built : 1);
    var drop = stock.length - Math.max(1, Math.round(stock.length * density));
    if (drop <= 0) return new Set();
    var area = function(b) {
        return (b.x1 - b.x0) * (b.y1 - b.y0);
    };
    return new Set((0, $4c858c0d999a5b9b$export$71511d61b312f219)(stock).sort(function(a, b) {
        return area(b) - area(a);
    }).slice(0, drop).map(function(b) {
        return b.n;
    }));
}
/**
 * Buildings do not only get fewer with distance from a road, they get smaller.
 *
 * Count alone barely moves half the map: most recipes carry one or two
 * structures, and the last one always stands. Scaling the footprint is what
 * actually opens the ground up — and it drives the recipes' own
 * `when: buildingScale >= n` gates, which is exactly where the extra hall and
 * the fourth block were already authored to appear only at a bigger scale. So
 * one knob thins by size and by count together, in the terms the art was
 * written in.
 */ var $3c042d4e8c9507db$var$BUILDING_SCALE_BY_DIST = [
    1,
    0.88,
    0.78
];
var $3c042d4e8c9507db$var$MINOR_ROAD_SCALE = 0.95;
/**
 * The region's tune adjusted for one tile: its structures scaled to the
 * distance from a road and to how built up its district is, its growth and its
 * road wear set inverse to the same district figure.
 *
 * Scale follows `thinnable`, exactly as the count thinning does — a portal
 * facility or a rest stop is drawn in full wherever it lands. Growth and wear
 * do NOT: vegetation reclaiming the outskirts and tarmac going to seed have no
 * business stopping at a road tile's border, and a gate on the edge of town
 * should look like it is on the edge of town.
 *
 * Cached per (tune, factors): a repaint runs this for every tile on the grid,
 * and the tune is read on every element a recipe draws. The key quantises, so
 * a region holds a couple of dozen entries rather than one per tile.
 */ var $3c042d4e8c9507db$var$scaledTunes = new WeakMap();
function $3c042d4e8c9507db$var$tuneForTile(tune, dist, rank, built, thinnable) {
    var q = function(n) {
        return Math.round(n * 40) / 40;
    };
    var scale = q(!thinnable ? 1 : (dist > 0 ? $3c042d4e8c9507db$var$BUILDING_SCALE_BY_DIST[Math.min(dist, $3c042d4e8c9507db$var$BUILDING_SCALE_BY_DIST.length - 1)] : rank === (0, $57ad8bd108ea335d$export$39615881bb0d21f6) ? 1 : $3c042d4e8c9507db$var$MINOR_ROAD_SCALE) * (built != null ? $3c042d4e8c9507db$var$builtScale(built) : 1));
    var growth = q(built != null ? $3c042d4e8c9507db$var$builtGrowth(built) : 1);
    var wear = q(built != null ? $3c042d4e8c9507db$var$builtWear(tune.roadWear, built) : tune.roadWear);
    if (scale === 1 && growth === 1 && wear === q(tune.roadWear)) return tune;
    var key = "".concat(scale, "|").concat(growth, "|").concat(wear);
    var byKey = $3c042d4e8c9507db$var$scaledTunes.get(tune);
    if (!byKey) $3c042d4e8c9507db$var$scaledTunes.set(tune, byKey = new Map());
    var out = byKey.get(key);
    if (!out) byKey.set(key, out = (0, $715bf31211e65705$export$71511d61b312f219)((0, $fa9769297b8a68c8$export$71511d61b312f219)({}, tune), {
        buildingScale: tune.buildingScale * scale,
        treeDensity: tune.treeDensity * growth,
        roadWear: wear
    }));
    return out;
}
/**
 * @param {object} [opts.record] array to collect solid element footprints into;
 *   when present NOTHING is drawn — this is the measuring pass
 * @param {Set} [opts.skip] element instance indices to run but not draw
 */ /**
 * @param {object} [opts.record] array to collect element footprints into; when
 *   present NOTHING is drawn — this is the measuring pass
 * @param {Set}    [opts.skip]   element instance indices to run but not draw
 * @param {number} [opts.variant] force a variant instead of rolling one
 * @param {Array}  [opts.shift]  per-element [dx, dy], indexed as `record` was
 */ function $3c042d4e8c9507db$var$runRecipe(def, g, rng, T, tune, conn) {
    var ox = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : 0, oy = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : 0, opts = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : {};
    var elements = def.elements;
    if (def.variants) {
        var _tune_def_variantKey;
        // The roll happens either way, even when the variant is forced: element
        // functions draw from this stream, so skipping a draw from it would shift
        // everything after and the measuring pass would stop matching the real one.
        var rolled = def.variantKey != null ? rng() < ((_tune_def_variantKey = tune[def.variantKey]) !== null && _tune_def_variantKey !== void 0 ? _tune_def_variantKey : 0.5) ? 1 : 0 // tune-gated pair
         : $3c042d4e8c9507db$var$ri(rng, 0, def.variants.length - 1);
        var _opts_variant;
        elements = def.variants[(_opts_variant = opts.variant) !== null && _opts_variant !== void 0 ? _opts_variant : rolled].elements;
    }
    // A measuring pass must not leave anything behind. Elements that animate hand
    // a closure to dynamic(), which either records it for the caller or runs it
    // against the live canvas — neither is wanted here, so it goes to a bin that
    // is thrown away. Guarding this at the call site instead left it to every
    // caller to remember.
    var wasDyn = $3c042d4e8c9507db$var$DYN;
    if (opts.record) $3c042d4e8c9507db$var$DYN = [];
    var index = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = (elements || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var spec = _step.value;
            var fn = $3c042d4e8c9507db$export$a6d18b072e3b7ccb[spec.el];
            if (!fn) continue;
            var _tune_spec_when_tune;
            if (spec.when && ((_tune_spec_when_tune = tune[spec.when.tune]) !== null && _tune_spec_when_tune !== void 0 ? _tune_spec_when_tune : 0) < spec.when.gte) continue;
            if (spec.chance != null && rng() >= spec.chance) continue;
            var count = spec.repeat != null ? $3c042d4e8c9507db$var$resolveVal(spec.repeat, rng) : 1;
            for(var i = 0; i < count; i++){
                var _opts_shift, _opts_skip;
                var n = index++;
                var _ref = (0, $1788e2ed61915b1e$export$71511d61b312f219)(((_opts_shift = opts.shift) === null || _opts_shift === void 0 ? void 0 : _opts_shift[n]) || [
                    0,
                    0
                ], 2), sx = _ref[0], sy = _ref[1];
                var p = {};
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = Object.keys(spec)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var key = _step1.value;
                        if ($3c042d4e8c9507db$var$SPEC_KEYS.has(key)) continue;
                        var v = $3c042d4e8c9507db$var$resolveVal(spec[key], rng);
                        p[key] = key === 'x' ? v + ox + sx : key === 'y' ? v + oy + sy : v;
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                var probe = opts.record || ((_opts_skip = opts.skip) === null || _opts_skip === void 0 ? void 0 : _opts_skip.has(n)) ? $3c042d4e8c9507db$var$makeProbeG() : null;
                fn(probe || g, rng, T, tune, conn, p);
                if (opts.record && probe.box.x1 > probe.box.x0) opts.record.push((0, $fa9769297b8a68c8$export$71511d61b312f219)({
                    n: n,
                    el: spec.el,
                    solid: $3c042d4e8c9507db$export$258e2d684a2e26ab.has(spec.el)
                }, probe.box));
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    $3c042d4e8c9507db$var$DYN = wasDyn;
}
/**
 * Choose which of a recipe's layouts to draw, given where the road already is.
 *
 * The road's position is settled by the tile's edges before any of this runs,
 * so the layout is what adapts. Each variant is measured once, then mirrored
 * about the tile's centre line — mirroring the PLACEMENT rather than the
 * drawing, so every roof keeps its lit north-west edge and every shadow still
 * falls the way the sun says. That turns one authored layout into four, with no
 * second copy of the art's coordinates to drift out of step with it.
 *
 * Whatever the winning layout still leaves under the road is suppressed: better
 * a missing outbuilding than a road driven through one.
 */ var $3c042d4e8c9507db$var$MIRRORS = [
    [
        false,
        false
    ],
    [
        true,
        false
    ],
    [
        false,
        true
    ],
    [
        true,
        true
    ]
];
/**
 * Every element's drawn footprint SIZE under a given shift, by instance index.
 * A probe pass, so nothing is drawn and nothing else is disturbed.
 */ function $3c042d4e8c9507db$var$measureSizes(def, rng, T, tune, conn, variant, shift) {
    var boxes = [];
    $3c042d4e8c9507db$var$runRecipe(def, null, rng, T, tune, conn, 0, 0, {
        record: boxes,
        variant: variant,
        shift: shift
    });
    return new Map(boxes.map(function(b) {
        return [
            b.n,
            "".concat(b.x1 - b.x0, "x").concat(b.y1 - b.y0)
        ];
    }));
}
/**
 * The per-element shift that reflects a measured layout about the tile's
 * centre line. Mirroring never changes a footprint's size or its index, so
 * this is a pure translation per element and the boxes stay comparable.
 */ function $3c042d4e8c9507db$var$mirrorShift(boxes, flipX, flipY) {
    var shift = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = boxes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var b = _step.value;
            shift[b.n] = [
                flipX ? $3c042d4e8c9507db$export$9e15ff8aa6bc996f - b.x1 - b.x0 : 0,
                flipY ? $3c042d4e8c9507db$export$9e15ff8aa6bc996f - b.y1 - b.y0 : 0
            ];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return shift;
}
/**
 * Every tile is entitled to a mirror; only a tile with a road through it has a
 * reason to prefer one. Off the network there is nothing to dodge, so the seed
 * picks — without which the whole map draws every recipe the same way round,
 * and a majority of tiles are off the network.
 */ function $3c042d4e8c9507db$var$seededMirror(boxes, rng) {
    return $3c042d4e8c9507db$var$mirrorShift.apply(void 0, [
        boxes
    ].concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)($3c042d4e8c9507db$var$MIRRORS[Math.floor(rng() * $3c042d4e8c9507db$var$MIRRORS.length)])));
}
function $3c042d4e8c9507db$export$9de203fcc6e657de(def, freshRng, T, tune, conn, samples, rng) {
    var count = def.variants ? def.variants.length : 1;
    var layouts = [];
    for(var v = 0; v < count; v++){
        var boxes = [];
        $3c042d4e8c9507db$var$runRecipe(def, null, freshRng(), T, tune, conn, 0, 0, {
            record: boxes,
            variant: v
        });
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = $3c042d4e8c9507db$var$MIRRORS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step.value, 2), flipX = _step_value[0], flipY = _step_value[1];
                var shift = $3c042d4e8c9507db$var$mirrorShift(boxes, flipX, flipY);
                var solids = [];
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = boxes[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var b = _step1.value;
                        if (!b.solid) continue;
                        var _shift_b_n = (0, $1788e2ed61915b1e$export$71511d61b312f219)(shift[b.n], 2), dx = _shift_b_n[0], dy = _shift_b_n[1];
                        solids.push((0, $715bf31211e65705$export$71511d61b312f219)((0, $fa9769297b8a68c8$export$71511d61b312f219)({}, b), {
                            x0: b.x0 + dx,
                            x1: b.x1 + dx,
                            y0: b.y0 + dy,
                            y1: b.y1 + dy
                        }));
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                layouts.push({
                    variant: v,
                    shift: shift,
                    solids: solids,
                    boxes: boxes
                });
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    var scored = $3c042d4e8c9507db$var$shuffled(layouts, rng).map(function(l) {
        return (0, $715bf31211e65705$export$71511d61b312f219)((0, $fa9769297b8a68c8$export$71511d61b312f219)({}, l), {
            hit: l.solids.filter(function(b) {
                return $3c042d4e8c9507db$var$runsThrough(samples, b);
            })
        });
    });
    // What a layout costs, in the order the costs matter.
    //
    // Losing every structure is not one more of the same loss, it is a different
    // outcome: a market with no shop on it, a housing block with no housing, a
    // tile the player walks into and finds bare ground. Scoring on the count
    // alone could not see that — a variant carrying ONE structure that the road
    // runs through ties with a variant carrying four that loses one, and the
    // seeded shuffle then picked between them at random. Measured across every
    // road position on the tile, that emptied a habitation tile eighteen times
    // out of eighteen where a layout that kept a building was available.
    //
    // Nothing else changes: every layout still suppresses whatever it leaves
    // under the roadway, so this decides WHICH layout is drawn and never puts a
    // roof on the tarmac.
    var cost = function(l) {
        return [
            l.solids.length && l.hit.length === l.solids.length ? 1 : 0,
            l.hit.length
        ];
    };
    var best = scored.reduce(function(a, b) {
        var _cost = (0, $1788e2ed61915b1e$export$71511d61b312f219)(cost(a), 2), aBare = _cost[0], aHit = _cost[1], _cost1 = (0, $1788e2ed61915b1e$export$71511d61b312f219)(cost(b), 2), bBare = _cost1[0], bHit = _cost1[1];
        return bBare < aBare || bBare === aBare && bHit < aHit ? b : a;
    });
    // boxes comes back so the caller can thin the winner by road distance: a
    // variant's element indices only mean anything within that variant, so the
    // thinning has to score the layout that actually won, not the one the first
    // measuring pass happened to roll. Mirroring never changes a footprint's
    // size or its index, so the unshifted boxes are the right thing to score.
    return {
        variant: best.variant,
        shift: best.shift,
        boxes: best.boxes,
        skip: new Set(best.hit.map(function(b) {
            return b.n;
        }))
    };
}
// ---- where the tile sets its structures down ----
// Recipes anchor their structures a fixed distance in from the tile edge — 9
// to 18 units of a 120-unit tile — and chooseLayout mirrors corner to corner,
// which maps a margin to the margin on the opposite side and so preserves the
// set of them. Across a grid that repeats on a 120-unit rhythm and leaves an
// open lane at every tile join, and the eye reads the lattice long before it
// reads the town.
//
// Carrying the whole composition sideways does not fix it: a recipe puts a
// block in one corner and another in the opposite one, so its bounding box is
// most of the tile and there is nowhere rigid to carry it TO. Structures have
// to move against each other, which means the thing that was holding them
// apart — an author's coordinates — has to be replaced by something. That
// something is the measurement: what a footprint SITS ON may not change.
//
// One rule covers every case a recipe author was relying on:
//   - a block standing clear of everything has to stay clear of everything,
//     of the roadway included, so nothing lands on anything;
//   - a guard post inside its compound fence stays inside it, because leaving
//     would drop its overlap with the fence;
//   - a shed on a field of rubble is already covered by it and stays covered
//     wherever it goes, so ground litter never pins anything down;
//   - a storefront authored clear of its market keeps clear of it.
// No element list, no special cases, and a recipe can be rewritten without
// this having to be told about it.
/**
 * How far a structure may walk from where it was authored.
 *
 * A structure cannot leave the tile, so a wander is not symmetric: there is
 * always more room toward the middle than toward the join, and every unit of
 * reach therefore also widens the open lane between tiles a little. Measured
 * across a grid, reach buys a flatter tile interior and costs frontage, and
 * the two cross here — past this the hole in the middle of every tile is
 * already gone and the lane is all that is still growing.
 */ var $3c042d4e8c9507db$var$PLACE_JITTER = 16;
/**
 * How many placements to try before leaving a structure where it was. Backs
 * off toward the authored position as it goes, so a tight tile ends up nudged
 * rather than unmoved.
 */ var $3c042d4e8c9507db$var$PLACE_TRIES = 6;
/**
 * A footprint this long on an axis is the TILE, not something standing on it:
 * a pipe run, a compound fence, a field of scatter. Those never move — a
 * pipeline still has to meet its neighbour's at the join — but they are very
 * much still something to sit on, so they stay in the overlap test.
 */ var $3c042d4e8c9507db$var$SPANNING = 96;
var $3c042d4e8c9507db$var$tileWide = function(b) {
    return b.x1 - b.x0 >= $3c042d4e8c9507db$var$SPANNING || b.y1 - b.y0 >= $3c042d4e8c9507db$var$SPANNING;
};
var $3c042d4e8c9507db$var$overlap = function(a, b) {
    return Math.max(0, Math.min(a.x1, b.x1) - Math.max(a.x0, b.x0)) * Math.max(0, Math.min(a.y1, b.y1) - Math.max(a.y0, b.y0));
};
/**
 * Walk each structure off its authored spot, as far as the tile allows.
 *
 * Works on footprints as they will be DRAWN — mirrored by the layout pass,
 * thinned by distance, scaled by the region — for the same reason everything
 * else in this file does: the authored coordinates are not where anything
 * ends up. Mutates the boxes it is given as it goes, so each structure is
 * placed against where the previous ones actually landed.
 *
 * @param {Array} placed  footprints in draw order; MUTATED to their new spots
 * @param {Array} samples the roadway's bound, when the network runs through
 * @returns {Map} element instance index -> [dx, dy]
 */ function $3c042d4e8c9507db$var$placeStructures(placed, rng, samples) {
    var moved = new Map();
    var sits = function(b, box) {
        var before = 0, after = 0;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = placed[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var o = _step.value;
                if (o === b) continue;
                before += $3c042d4e8c9507db$var$overlap(o, b);
                after += $3c042d4e8c9507db$var$overlap(o, box);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return before === after;
    };
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = placed[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _loop = function(t) {
                var reach = $3c042d4e8c9507db$var$PLACE_JITTER * (1 - t / $3c042d4e8c9507db$var$PLACE_TRIES);
                // Drawn from what the tile edge actually allows, not drawn and then
                // tested against it. Rejecting an out-of-bounds offset and rolling again
                // is a bias toward the middle of the tile — the closer a structure
                // stands to an edge, the more of its offsets die on that side — which
                // trades one uniformity for another, and this whole pass exists to stop
                // structures landing a predictable distance from the join.
                var span = function(lo, hi) {
                    var a = Math.max(-reach, lo), z = Math.min(reach, hi);
                    return z > a ? Math.round(a + rng() * (z - a)) : 0;
                };
                // A footprint that reaches the far clamp may have been TRUNCATED by it
                // — buildingTop and storefront both size themselves against the tile
                // edge — and what was measured is the truncated version. Move it back
                // toward the origin and the clamp stops biting: it draws wider than the
                // box this pass cleared, and lands on whatever that box was clearing it
                // of. So a structure against the clamp does not move on that axis; only
                // one with room to spare on both sides has a measurement to trust.
                var dx = span(b.x1 >= $3c042d4e8c9507db$export$9e15ff8aa6bc996f - $3c042d4e8c9507db$var$TILE_CLAMP ? 0 : $3c042d4e8c9507db$var$TILE_CLAMP - b.x0, $3c042d4e8c9507db$export$9e15ff8aa6bc996f - $3c042d4e8c9507db$var$TILE_CLAMP - b.x1);
                var dy = span(b.y1 >= $3c042d4e8c9507db$export$9e15ff8aa6bc996f - $3c042d4e8c9507db$var$TILE_CLAMP ? 0 : $3c042d4e8c9507db$var$TILE_CLAMP - b.y0, $3c042d4e8c9507db$export$9e15ff8aa6bc996f - $3c042d4e8c9507db$var$TILE_CLAMP - b.y1);
                if (!dx && !dy) return "break";
                var box = {
                    x0: b.x0 + dx,
                    x1: b.x1 + dx,
                    y0: b.y0 + dy,
                    y1: b.y1 + dy
                };
                // The layout that won did so by standing clear of the carriageway, and
                // an offset that puts a wall back on it costs more than the uniformity
                // it was buying.
                if (b.solid && samples && $3c042d4e8c9507db$var$runsThrough(samples, box)) return "continue";
                if (!sits(b, box)) return "continue";
                Object.assign(b, box);
                moved.set(b.n, [
                    dx,
                    dy
                ]);
                return "break";
            };
            var b = _step.value;
            if ($3c042d4e8c9507db$var$tileWide(b)) continue;
            for(var t = 0; t < $3c042d4e8c9507db$var$PLACE_TRIES; t++){
                var _ret = _loop(t);
                if (_ret === "break") break;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return moved;
}
// ---- daylight wells (underground regions) ----
// A few large cave openings light whole AREAS of the map, like sun pouring
// into a cavern. Wells live on a fixed WORLD grid (same trick as the cloud
// field): every tile derives the identical well set from hashed super-cell
// coordinates, then shades its own pixels by distance to the nearest well —
// so one opening illuminates a neighborhood of tiles with a wide, seamless
// falloff and no cross-tile coordination. tune.lightRays is well density.
var $3c042d4e8c9507db$var$WELL_CELL = 120; // world units between candidate openings (3 tiles)
function $3c042d4e8c9507db$var$lightWellsNear(col, row, density) {
    var wells = [];
    var cx = Math.floor((col * $3c042d4e8c9507db$export$3d672f2aedd16af9 + $3c042d4e8c9507db$export$3d672f2aedd16af9 / 2) / $3c042d4e8c9507db$var$WELL_CELL);
    var cy = Math.floor((row * $3c042d4e8c9507db$export$3d672f2aedd16af9 + $3c042d4e8c9507db$export$3d672f2aedd16af9 / 2) / $3c042d4e8c9507db$var$WELL_CELL);
    for(var gy = cy - 1; gy <= cy + 1; gy++)for(var gx = cx - 1; gx <= cx + 1; gx++){
        if ($3c042d4e8c9507db$var$noiseHash(gx * 31 + 7, gy * 17 + 3) > density * 0.5) continue;
        wells.push({
            x: (gx + 0.15 + 0.7 * $3c042d4e8c9507db$var$noiseHash(gx, gy)) * $3c042d4e8c9507db$var$WELL_CELL,
            y: (gy + 0.15 + 0.7 * $3c042d4e8c9507db$var$noiseHash(gx + 99, gy + 41)) * $3c042d4e8c9507db$var$WELL_CELL,
            r: 55 + 40 * $3c042d4e8c9507db$var$noiseHash(gx + 7, gy + 77)
        });
    }
    return wells;
}
// The landing pool tracks the sun through the day (west of the opening at
// sunrise, plumb beneath it at noon, east at dusk) and its intensity
// follows the SURFACE day cycle — gone at night.
// Each well also casts visible god rays: thin streaks that hang from the
// STATIC opening and slant down to wherever the pool currently lands. The
// beam spreads cone-like from opening to landing, is longest when the sun
// is low, and fades out near noon when the vertical shaft is seen end-on.
// Lanes come from world-space noise on the perpendicular axis — seamless
// across tiles — and drift slowly with time like dust in the shaft.
// The rays' visible ORIGIN is fixed up-screen of the well — the ceiling
// opening projected ~one tile north — so beams always slant DOWN into the
// pool instead of lying flat across it; at noon they pour straight down-screen.
var $3c042d4e8c9507db$var$RAY_RISE = 36;
/**
 * Where the sun is putting a shaft of daylight, this frame.
 *
 * Shared by the shafts themselves and by the shadows the rock throws in them,
 * because those two have to agree about where the light is coming from or the
 * stone will shade the wrong way.
 *
 * The landing point tracks the sun: west of the opening at sunrise, sweeping
 * left to right through the day, directly beneath it at noon. Vertically it
 * keeps a gentle southward drift that peaks mid-morning and mid-afternoon and
 * vanishes at dawn, noon and dusk.
 */ function $3c042d4e8c9507db$var$sunShaft(anim) {
    var elev = 0.7, dayFrac = 0.35; // static renders: late-morning sun
    if (anim && anim.dayPhase != null) {
        var f = (anim.dayPhase - 0.25) / 0.5; // 06:00 -> 18:00
        dayFrac = Math.min(1, Math.max(0, f));
        elev = f >= 0 && f <= 1 ? Math.sin(f * Math.PI) : 0;
    }
    var bx = (dayFrac - 0.5) * 160;
    var by = elev * (1 - elev) * 18;
    var vx = bx, vy = by + $3c042d4e8c9507db$var$RAY_RISE; // beam vector: origin -> pool
    var bl = Math.hypot(vx, vy);
    return {
        elev: elev,
        bx: bx,
        by: by,
        bl: bl,
        ux: vx / bl,
        uy: vy / bl
    };
}
function $3c042d4e8c9507db$var$drawLightWells(g, T, tune, anim, col, row) {
    var _sunShaft = $3c042d4e8c9507db$var$sunShaft(anim), elev = _sunShaft.elev, bx = _sunShaft.bx, by = _sunShaft.by, bl = _sunShaft.bl, ux = _sunShaft.ux, uy = _sunShaft.uy;
    if (elev <= 0.03) return; // night
    var wells = $3c042d4e8c9507db$var$lightWellsNear(col, row, tune.lightRays);
    if (!wells.length) return;
    // world units, NOT the authoring grid — see WORLD/FX_STEP. Every constant
    // in this function is tuned in these units, and the loop below is the
    // per-tile cost of the whole ambient layer.
    var ox = col * $3c042d4e8c9507db$export$3d672f2aedd16af9, oy = row * $3c042d4e8c9507db$export$3d672f2aedd16af9;
    var t = (anim === null || anim === void 0 ? void 0 : anim.t) || 0;
    for(var y = 0; y < $3c042d4e8c9507db$export$3d672f2aedd16af9; y += $3c042d4e8c9507db$export$a4097a0a1d4593d2){
        var _loop = function(x) {
            var I = 0, ray = 0, wave = 0.5;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = wells[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var w = _step.value;
                    var rx = ox + x - w.x - bx, ry = oy + y - w.y - by;
                    var f = 1 - Math.hypot(rx, ry) / w.r;
                    if (f > I) I = f;
                    var orx = ox + x - w.x, ory = oy + y - (w.y - $3c042d4e8c9507db$var$RAY_RISE); // relative to the raised origin
                    var along = orx * ux + ory * uy;
                    if (along < -2) continue; // nothing behind the origin
                    var perp = -orx * uy + ory * ux;
                    // the beam spreads cone-like from the origin toward the landing
                    var width = w.r * (0.35 + 0.55 * Math.min(1, along / bl));
                    var envP = 1 - Math.abs(perp) / width;
                    if (envP <= 0) continue;
                    var seed = w.x * 0.37 + w.y * 0.61;
                    var lane = $3c042d4e8c9507db$var$smoothNoise(perp / 7 + t * 0.1, seed);
                    if (lane <= 0.6) continue;
                    // each ray terminates at its own point INSIDE the landing pool: a
                    // per-lane endpoint on this lane's chord, so the beam lands with a
                    // ragged natural edge and never overshoots the pool
                    var chord = Math.sqrt(Math.max(0, w.r * w.r - perp * perp));
                    var end = bl + chord * (-0.5 + 1.2 * $3c042d4e8c9507db$var$smoothNoise(perp / 7, seed + 57));
                    if (along > end) continue;
                    var stop = Math.min(1, (end - along) / 6); // soft landing at the endpoint
                    var start = Math.min(1, (along + 2) / 6); // soft emergence at the origin
                    // shimmer: a slow brightness wave travels down the beam toward the
                    // pool, phased per lane so the streaks pulse independently; static
                    // renders sit at the neutral midpoint (factor 1.0)
                    var wv = t ? 0.5 + 0.5 * Math.sin(t * 1.6 - along * 0.12 + perp * 0.35) : 0.5;
                    var s2 = envP * ((lane - 0.6) / 0.4) * stop * start * (0.78 + 0.44 * wv);
                    if (s2 > ray) {
                        ray = s2;
                        wave = wv;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            var px = x * $3c042d4e8c9507db$var$FX_PX, py = y * $3c042d4e8c9507db$var$FX_PX, ps = $3c042d4e8c9507db$export$a4097a0a1d4593d2 * $3c042d4e8c9507db$var$FX_PX;
            if (I > 0.03) {
                var s = I * I * (3 - 2 * I) * elev * 0.4; // smooth wide falloff
                g.a(Math.min(0.62, s * 0.8), function() {
                    return g.p(px, py, ps, ps, '#f6e9c2');
                }); // daylight
                if (s > 0.55) g.a((s - 0.55) * 0.8, function() {
                    return g.p(px, py, ps, ps, '#fff8e2');
                }); // hot core
            }
            if (ray > 0.02) {
                // the shimmer wave also drifts color temperature: warmer in the
                // troughs, whiter at the crests (midpoint = the tuned #fbf3d9)
                var rr = Math.min(255, Math.round(243 + 16 * wave));
                var gg = Math.min(255, Math.round(233 + 20 * wave));
                var bb = Math.min(255, Math.round(197 + 40 * wave));
                g.a(Math.min(0.16, ray * elev * 0.1), function() {
                    return g.p(px, py, ps, ps, "rgb(".concat(rr, ",").concat(gg, ",").concat(bb, ")"));
                });
            }
        };
        for(var x = 0; x < $3c042d4e8c9507db$export$3d672f2aedd16af9; x += $3c042d4e8c9507db$export$a4097a0a1d4593d2)_loop(x);
    }
}
// The portal's energy glow, drawn as the final pass of a portal tile so it
// renders above flood water, vegetation, weathering, and even cloud cover.
function $3c042d4e8c9507db$var$portalGlow(g, T) {
    var C = $3c042d4e8c9507db$export$9e15ff8aa6bc996f >> 1;
    var f = $3c042d4e8c9507db$var$flicker(C, C, 4); // slow energy shimmer
    g.a(0.15 + 0.18 * f, function() {
        return $3c042d4e8c9507db$var$disc(g, C, C, 27, T.glow);
    });
    g.a(0.65 + 0.3 * f, function() {
        return $3c042d4e8c9507db$var$disc(g, C, C, 9, T.glow);
    });
    g.a(0.5 + 0.4 * f, function() {
        return $3c042d4e8c9507db$var$ringO(g, C, C, 13 + Math.round(f * 3), T.glow);
    }); // pulsing containment ring
    g.r(C - 1, C - 1, 3, 3, T.structLight);
}
// Gates take twice as long to traverse as hazards, so dress them as major
// areas of interest: an extra structure in a free corner and a perimeter
// wall around the compound (skipped when the recipe already fenced the
// yard). Gate vegetation is also boosted in the renderer.
function $3c042d4e8c9507db$var$gateEmphasis(g, rng, T, tune, conn, recipe, samples) {
    // Every roll happens up front, whichever corner wins — this draws on the same
    // stream the recipe used, so a choice that spent a different number of rolls
    // would move everything after it (see buildingTop).
    var pick = $3c042d4e8c9507db$var$ri(rng, 0, 3);
    var jx = $3c042d4e8c9507db$var$ri(rng, 0, 6), jy = $3c042d4e8c9507db$var$ri(rng, 0, 6);
    var bw = $3c042d4e8c9507db$var$ri(rng, 21, 27), bh = $3c042d4e8c9507db$var$ri(rng, 18, 24);
    // This block is drawn OUTSIDE the recipe, so the layout pass never measures
    // it and cannot suppress it — on a gate the road runs through, it simply
    // landed on the roadway. Score the corners here on the same rule instead,
    // starting from the seeded pick so a tile with no road looks as it did; and
    // where a road reaches every corner, drop the block rather than pave over it.
    var corners = [
        [
            12,
            12
        ],
        [
            78,
            12
        ],
        [
            12,
            78
        ],
        [
            78,
            78
        ]
    ];
    var s = tune.buildingScale;
    var boxAt = function(param) {
        var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), cx = _param[0], cy = _param[1];
        return {
            x0: cx + jx,
            y0: cy + jy,
            x1: cx + jx + Math.round(bw * s),
            y1: cy + jy + Math.round(bh * s)
        };
    };
    var order = corners.map(function(_, i) {
        return corners[(pick + i) % 4];
    });
    var clear = (samples === null || samples === void 0 ? void 0 : samples.length) ? order.find(function(c) {
        return !$3c042d4e8c9507db$var$runsThrough(samples, boxAt(c));
    }) : order[0];
    var _ref = (0, $1788e2ed61915b1e$export$71511d61b312f219)(clear || order[0], 2), bx = _ref[0], by = _ref[1];
    $3c042d4e8c9507db$var$buildingTop(clear ? g : $3c042d4e8c9507db$var$makeProbeG(), rng, T, tune, bx + jx, by + jy, bw, bh);
    if (recipe !== 'security') $3c042d4e8c9507db$var$fenceRing(g, rng, T, 6, 6, 108, 108, conn);
    // Hand the footprint back. Drawn outside the recipe, this block is in no
    // measurement anyone downstream has — which is how the vegetation pass came
    // to plant on it, and every tree on a roof anywhere on the map was this one.
    return clear ? boxAt(clear) : null;
}
var $3c042d4e8c9507db$export$df5605651df73ebd = 24; // largest footprint, in units (~4.8 m of ground)
var $3c042d4e8c9507db$export$193bd40b90286d11 = 4; // wall ring around an indoor anchor
// Connector bands run centre-to-edge and occupy x,y in [45,75] at their
// widest, so anchors take a seeded corner quadrant. The 9px outer margin also
// clears the perimeter fence gateEmphasis puts on gate tiles.
function $3c042d4e8c9507db$var$anchorSpot(rng, w, h) {
    var c = $3c042d4e8c9507db$var$ri(rng, 0, 3);
    return [
        c & 1 ? $3c042d4e8c9507db$var$ri(rng, 75, 111 - w) : $3c042d4e8c9507db$var$ri(rng, 9, 45 - w),
        c & 2 ? $3c042d4e8c9507db$var$ri(rng, 75, 111 - h) : $3c042d4e8c9507db$var$ri(rng, 9, 45 - h)
    ];
}
// Roof cutaway for an encounter that happens INDOORS. The map looks down at
// roofs, but most event prose is written inside halls and bays — rather than
// move those outdoors or pretend the tile is an interior, the one structure
// the encounter happens in gets its roof taken off, and the anchor sits on the
// floor of the open bay. A doorway faces the tile centre so the bay reads as
// enterable from the path rather than sealed.
function $3c042d4e8c9507db$var$drawCutaway(g, T, x, y, w, h) {
    $3c042d4e8c9507db$var$dropShadow(g, T, x, y, w, h);
    g.r(x, y, w, h, T.structDark); // wall mass
    g.r(x, y, w, 1, T.structLight); // lit wall cap
    g.r(x, y, 1, h, T.structLight);
    g.r(x, y + h - 1, w, 1, T.far);
    g.r(x + w - 1, y, 1, h, T.far);
    var p = $3c042d4e8c9507db$export$193bd40b90286d11;
    g.r(x + p - 1, y + p - 1, w - 2 * p + 2, h - 2 * p + 2, T.ground2); // interior floor
    g.a(0.35, function() {
        return g.r(x + p - 1, y + p - 1, w - 2 * p + 2, h - 2 * p + 2, T.far);
    }); // roofed shade
    g.a(0.5, function() {
        g.r(x + p - 1, y + p - 1, w - 2 * p + 2, 1, T.structDark);
        g.r(x + p - 1, y + p - 1, 1, h - 2 * p + 2, T.structDark);
    });
    var dw = 8; // doorway, on the wall nearest the hub
    var cx = x + (w >> 1), cy = y + (h >> 1), mid = $3c042d4e8c9507db$export$9e15ff8aa6bc996f >> 1;
    if (Math.abs(cx - mid) > Math.abs(cy - mid)) g.r(cx < mid ? x + w - p : x, y + (h >> 1) - (dw >> 1), p, dw, T.ground2);
    else g.r(x + (w >> 1) - (dw >> 1), cy < mid ? y + h - p : y, dw, p, T.ground2);
}
// Returns without touching the rng when there is no anchor to draw — roads,
// water, campsites, entry/exit and blocked cells all have no primary skill.
// Because the anchor owns its own rng phase, that early return leaves those
// tiles pixel-identical to what they rendered before anchors existed.
function $3c042d4e8c9507db$var$runAnchor(skillId, g, rng, T, tune, conn, indoor) {
    var def = skillId && $3c042d4e8c9507db$export$73b3f97728261c35[skillId];
    if (!def || !Array.isArray(def.elements)) return;
    var _def_w, _def_h;
    var w = (_def_w = def.w) !== null && _def_w !== void 0 ? _def_w : $3c042d4e8c9507db$export$df5605651df73ebd, h = (_def_h = def.h) !== null && _def_h !== void 0 ? _def_h : $3c042d4e8c9507db$export$df5605651df73ebd;
    var pad = indoor ? $3c042d4e8c9507db$export$193bd40b90286d11 : 0;
    var _anchorSpot = (0, $1788e2ed61915b1e$export$71511d61b312f219)($3c042d4e8c9507db$var$anchorSpot(rng, w + pad * 2, h + pad * 2), 2), ox = _anchorSpot[0], oy = _anchorSpot[1];
    if (indoor) $3c042d4e8c9507db$var$drawCutaway(g, T, ox, oy, w + pad * 2, h + pad * 2);
    $3c042d4e8c9507db$var$runRecipe(def, g, rng, T, tune, conn, ox + pad, oy + pad);
}
// ---- ruins pass ----
// The city was denser than what is still standing in it. A ruin is a
// building-sized footprint of what came down: the floor slab, the wall stubs
// that outlast a roof, and the roof itself piled on the floor. Drawn from the
// same vocabulary as an intact building so the two read as one architecture in
// two states, and drawn as a PASS rather than as a recipe element so every
// room gets them without thirteen recipes each having to say so.
/**
 * Rubble is DARKER than the building it came from. A heap of broken material
 * is mostly the shadow between its pieces, and the bright faces an intact roof
 * shows are surfaces still pointing at the sky — a pile has few of those. Some
 * of it burned, and what burned goes further: down and toward grey, because
 * char has no colour of its own left.
 *
 * The whole ruin is drawn from ONE derived palette rather than from T, so the
 * shared rubble helper stays exactly as the roads and the collapse tiles use
 * it, and the two states of a ruin differ in one place.
 */ var $3c042d4e8c9507db$var$RUBBLE_SHADE = 0.72;
var $3c042d4e8c9507db$var$CHARRED_CHANCE = 0.22;
function $3c042d4e8c9507db$var$ruinPalette(T, charred) {
    var k = charred ? 0.4 : $3c042d4e8c9507db$var$RUBBLE_SHADE;
    var grey = charred ? 0.85 : 0;
    return (0, $715bf31211e65705$export$71511d61b312f219)((0, $fa9769297b8a68c8$export$71511d61b312f219)({}, T), {
        struct: $3c042d4e8c9507db$var$shade(T.struct, k, grey),
        structLight: $3c042d4e8c9507db$var$shade(T.structLight, charred ? 0.34 : 0.62, grey),
        structDark: $3c042d4e8c9507db$var$shade(T.structDark, charred ? 0.7 : 1, grey),
        metal: $3c042d4e8c9507db$var$shade(T.metal, charred ? 0.4 : 0.72, grey),
        stub: $3c042d4e8c9507db$var$shade(T.struct, charred ? 0.5 : 0.85, grey)
    });
}
function $3c042d4e8c9507db$var$ruinedBuilding(g, rng, T, x, y, w, h, charred) {
    var P = $3c042d4e8c9507db$var$ruinPalette(T, charred);
    $3c042d4e8c9507db$var$dropShadow(g, T, x + 2, y + 2, w - 4, h - 4);
    // The heap, in the same masonry the buildings are made of and NOT in the
    // dark of a hole: this is material piled up, not ground fallen away, and the
    // collapse tiles already own the second reading. What separates it from a
    // roof at a glance is its edge — a rectangle that has lost its corners,
    // ragged a few units in and out on every row.
    for(var ry = 0; ry < h; ry++){
        var l = $3c042d4e8c9507db$var$ri(rng, 0, 4), r = $3c042d4e8c9507db$var$ri(rng, 0, 4);
        g.r(x + l, y + ry, Math.max(1, w - l - r), 1, P.struct);
    }
    // broken up: light where a face has sheared and caught the sun, dark in the
    // gaps between slabs
    for(var i = 0, n = Math.round(w * h * 0.09); i < n; i++)g.r(x + $3c042d4e8c9507db$var$ri(rng, 2, Math.max(2, w - 4)), y + $3c042d4e8c9507db$var$ri(rng, 1, Math.max(1, h - 2)), $3c042d4e8c9507db$var$ri(rng, 2, 4), 1, rng() < 0.55 ? P.structDark : P.structLight);
    // Wall stubs. A broken RUN on each side, never the whole side: four
    // continuous walls would read as a building with its roof off, and the point
    // of these is that they are past saving.
    var stub = function(sx, sy, sw, sh) {
        $3c042d4e8c9507db$var$dropShadow(g, T, sx, sy, sw, sh);
        g.r(sx, sy, sw, sh, P.stub); // a standing face, so a shade up
        g.r(sx, sy, sw, 1, P.structLight); // lit top of the stub
        g.r(sx, sy + sh - 1, sw, 1, P.structDark);
    };
    var run = function(span) {
        var len = $3c042d4e8c9507db$var$ri(rng, Math.max(5, span >> 2), Math.max(6, span - 5));
        return [
            $3c042d4e8c9507db$var$ri(rng, 0, Math.max(0, span - len)),
            len
        ];
    };
    var _run = (0, $1788e2ed61915b1e$export$71511d61b312f219)(run(w), 2), ax = _run[0], aw = _run[1];
    stub(x + ax, y, aw, 3);
    var _run1 = (0, $1788e2ed61915b1e$export$71511d61b312f219)(run(w), 2), bx = _run1[0], bw = _run1[1];
    stub(x + bx, y + h - 3, bw, 3);
    var _run2 = (0, $1788e2ed61915b1e$export$71511d61b312f219)(run(h), 2), ay = _run2[0], ah = _run2[1];
    stub(x, y + ay, 3, ah);
    var _run3 = (0, $1788e2ed61915b1e$export$71511d61b312f219)(run(h), 2), by = _run3[0], bh = _run3[1];
    stub(x + w - 3, y + by, 3, bh);
    // and what spilled off the edges when it came down, in the ruin's own tones
    $3c042d4e8c9507db$var$rubble(g, rng, P, x - 4, x + w, y - 4, y + h, Math.max(5, Math.round(w * h / 130)));
}
/** Rooms the map places whole, and which a fresh ruin would only clutter. */ var $3c042d4e8c9507db$var$RUIN_EXEMPT = new Set([
    'water',
    'blocked',
    'reactor',
    'portal',
    'campsite'
]);
/**
 * @param {Array} keepOut structures already standing; a ruin never lands on one
 * @param {Array} samples the roadway, for the same reason
 */ function $3c042d4e8c9507db$var$drawRuins(g, rng, T, tune, keepOut, samples, shore) {
    var taken = (0, $4c858c0d999a5b9b$export$71511d61b312f219)(keepOut);
    var clash = function(b) {
        return taken.some(function(k) {
            return b.x0 <= k.x1 && b.x1 >= k.x0 && b.y0 <= k.y1 && b.y1 >= k.y0;
        }) || !!(samples === null || samples === void 0 ? void 0 : samples.length) && $3c042d4e8c9507db$var$runsThrough(samples, b);
    };
    // On the shore row, the seaward half of the tile is mostly wrecks: more of
    // them, and pushed into the band the water reaches. Paired with the thinned
    // standing stock in builtUp, that half comes out as ruins in the shallows and
    // the landward half stays a street.
    var drowned = (shore === null || shore === void 0 ? void 0 : shore.at) === 0;
    var band = drowned ? shore.side === 'n' ? [
        0,
        $3c042d4e8c9507db$var$WATERLINE
    ] : [
        $3c042d4e8c9507db$export$9e15ff8aa6bc996f - $3c042d4e8c9507db$var$WATERLINE,
        $3c042d4e8c9507db$export$9e15ff8aa6bc996f
    ] : null;
    for(var i = 0, n = $3c042d4e8c9507db$var$ri(rng, 1, drowned ? 4 : 2); i < n; i++){
        var w = Math.round($3c042d4e8c9507db$var$ri(rng, 24, 39) * tune.buildingScale);
        var h = Math.round($3c042d4e8c9507db$var$ri(rng, 18, 30) * tune.buildingScale);
        var box = null;
        // Same retry-and-give-up as the vegetation: on a tile with no room left,
        // the ruin that was never there is the right answer. Safe to vary the roll
        // count here — the ruins have their own seeded stream and both drawing
        // passes replay it against the same obstacles.
        for(var t = 0; t < 10 && !box; t++){
            var x = $3c042d4e8c9507db$var$ri(rng, 6, Math.max(6, $3c042d4e8c9507db$export$9e15ff8aa6bc996f - 6 - w));
            var y = band ? $3c042d4e8c9507db$var$ri(rng, band[0], Math.max(band[0], band[1] - h)) : $3c042d4e8c9507db$var$ri(rng, 6, Math.max(6, $3c042d4e8c9507db$export$9e15ff8aa6bc996f - 6 - h));
            var b = {
                x0: x,
                y0: y,
                x1: x + w,
                y1: y + h
            };
            if (!clash(b)) box = b;
        }
        if (!box) continue;
        $3c042d4e8c9507db$var$ruinedBuilding(g, rng, T, box.x0, box.y0, w, h, rng() < $3c042d4e8c9507db$var$CHARRED_CHANCE);
        taken.push(box); // ruins do not pile on each other either
    }
    // What this pass actually put down, so the signature layer can keep off it.
    // A gantry lying across a fresh ruin is the one clash the recipe's own
    // keep-out list cannot see, because a ruin is not in the recipe.
    return taken.slice(keepOut.length);
}
// ---- parking ----
/**
 * A parking lot is part of the road structure. It is the same tarmac, and it
 * only exists because something could drive onto it — so it is laid AGAINST the
 * carriageway off the road's own samples, the same way the traffic is, rather
 * than authored into a recipe's layout and then fought over.
 *
 * That is what fixes the overlap. A lot placed into a layout has to be either
 * mirrored clear of the road or dropped, and a lot is wide enough that most of
 * them ended up dropped; a lot placed off the roadway cannot be crossed by it,
 * and reads as what a lot actually is — an apron off the street.
 *
 * A tile the network misses gets no lot at all. There is nowhere to put one
 * that is not detached: an apron with no way onto it is not a car park, it is a
 * rectangle of tarmac in the middle of a block.
 */ var $3c042d4e8c9507db$var$PARKING_RECIPES = new Set([
    'records',
    'habitation',
    'commerce'
]);
/**
 * Depth is fixed because it is a real dimension: 24 units is 4.8 m, one row of
 * bays parked nose-in, and a shallower lot would not be a lot. Length is
 * whatever fits — the longest row the spot allows, down to a floor of two. A
 * single bay is a driveway, not a car park, so a spot that only takes one is
 * treated as no spot at all.
 */ var $3c042d4e8c9507db$var$MIN_BAYS = 2, $3c042d4e8c9507db$var$MAX_BAYS = 5;
function $3c042d4e8c9507db$var$drawParking(g, rng, T, samples, keepOut) {
    if (!(samples === null || samples === void 0 ? void 0 : samples.length)) return null;
    var clash = function(b) {
        return keepOut.some(function(k) {
            return b.x0 <= k.x1 && b.x1 >= k.x0 && b.y0 <= k.y1 && b.y1 >= k.y0;
        });
    };
    // Being clear of the sample it was hung off is not enough: a road that bends
    // can come back around and pass under the far end of the lot. Test the whole
    // footprint against the tarmac — measured a unit inside the sample bounds, or
    // the lot would reject the very band it is meant to be flush against.
    var crossed = function(b) {
        return samples.some(function(s) {
            var hx = s.hx - $3c042d4e8c9507db$var$CLEARANCE - 1, hy = s.hy - $3c042d4e8c9507db$var$CLEARANCE - 1;
            return s.x + hx > b.x0 && s.x - hx < b.x1 && s.y + hy > b.y0 && s.y - hy < b.y1;
        });
    };
    // A lot is a big rectangle that has to be flush to the tarmac, clear of every
    // building, and clear of the rest of the road's run. On a busy tile that is a
    // narrow target, so it gets plenty of tries before giving up.
    for(var t = 0; t < 30; t++){
        var s = samples[$3c042d4e8c9507db$var$ri(rng, 0, samples.length - 1)];
        var vert = s.hx > s.hy; // the lot runs alongside, so it takes the road's axis
        var far = rng() < 0.5;
        // Flush to the DRAWN road, not to the sample bound — the samples run a
        // clearance wider than the tarmac they describe, and a lot set against that
        // would stand off the kerb by a pixel of bare ground.
        var ox = s.hx - $3c042d4e8c9507db$var$CLEARANCE, oy = s.hy - $3c042d4e8c9507db$var$CLEARANCE;
        // Longest row this spot will take. Depth never moves, so the only thing
        // being traded is how many bays fit alongside the road.
        for(var bays = $3c042d4e8c9507db$var$MAX_BAYS; bays >= $3c042d4e8c9507db$var$MIN_BAYS; bays--){
            var long = $3c042d4e8c9507db$var$lotLength(bays);
            var w = vert ? $3c042d4e8c9507db$var$BAY_DEPTH : long, h = vert ? long : $3c042d4e8c9507db$var$BAY_DEPTH;
            var x = Math.round(vert ? far ? s.x + ox : s.x - ox - w : s.x - w / 2);
            var y = Math.round(vert ? s.y - h / 2 : far ? s.y + oy : s.y - oy - h);
            var box = {
                x0: x,
                y0: y,
                x1: x + w,
                y1: y + h
            };
            if (x < 3 || y < 3 || x + w > $3c042d4e8c9507db$export$9e15ff8aa6bc996f - 3 || y + h > $3c042d4e8c9507db$export$9e15ff8aa6bc996f - 3) continue;
            if (clash(box) || crossed(box)) continue;
            $3c042d4e8c9507db$var$parkingLot(g, rng, T, x, y, w, h, vert);
            return box;
        }
    }
    return null;
}
// ---- roadside traffic ----
/**
 * What was on the road when it stopped being a road.
 *
 * Placed off the roadway's OWN centreline samples rather than scattered on the
 * tile: take a sample, take a side, and step out across the band. That gets a
 * wreck lying parallel to the carriageway it was on — whichever way the road
 * runs, and around a bend as readily as along a straight — without the pass
 * ever being told the road's shape. It also gets the wreck onto the shoulder
 * instead of the middle of the lane, which is where an abandoned car ends up.
 *
 * A trunk carried the traffic; a back lane carried less of it. Count follows
 * the rank the tile's roadway is drawn at.
 */ var $3c042d4e8c9507db$var$ROADSIDE_COUNT = {
    major: [
        1,
        3
    ],
    minor: [
        0,
        1
    ]
};
function $3c042d4e8c9507db$var$drawRoadside(g, rng, T, samples, rank, keepOut) {
    var _loop = function(i, n) {
        var s = samples[$3c042d4e8c9507db$var$ri(rng, 0, samples.length - 1)];
        // a sample is narrow ALONG the road and wide ACROSS it, so the wider half
        // says which way the traffic was going
        var vert = s.hx > s.hy;
        var far = rng() < 0.5; // which shoulder
        var bite = $3c042d4e8c9507db$var$ri(rng, 0, 5); // how far it is still on the tarmac
        var w = vert ? $3c042d4e8c9507db$export$f6b0e5d6358e6bd8 : $3c042d4e8c9507db$export$8ce2cf2f7041018f, h = vert ? $3c042d4e8c9507db$export$8ce2cf2f7041018f : $3c042d4e8c9507db$export$f6b0e5d6358e6bd8;
        var x = Math.round(vert ? far ? s.x + s.hx - bite : s.x - s.hx - w + bite : s.x - w / 2);
        var y = Math.round(vert ? s.y - h / 2 : far ? s.y + s.hy - bite : s.y - s.hy - h + bite);
        if (x < 3 || y < 3 || x + w > $3c042d4e8c9507db$export$9e15ff8aa6bc996f - 3 || y + h > $3c042d4e8c9507db$export$9e15ff8aa6bc996f - 3) return "continue";
        if (keepOut.some(function(k) {
            return x <= k.x1 && x + w >= k.x0 && y <= k.y1 && y + h >= k.y0;
        })) return "continue";
        $3c042d4e8c9507db$var$vehicle(g, rng, T, x, y, vert);
    };
    if (!(samples === null || samples === void 0 ? void 0 : samples.length)) return;
    var _ROADSIDE_COUNT_ = (0, $1788e2ed61915b1e$export$71511d61b312f219)($3c042d4e8c9507db$var$ROADSIDE_COUNT[rank === (0, $57ad8bd108ea335d$export$39615881bb0d21f6) ? 'major' : 'minor'], 2), lo = _ROADSIDE_COUNT_[0], hi = _ROADSIDE_COUNT_[1];
    for(var i = 0, n = $3c042d4e8c9507db$var$ri(rng, lo, hi); i < n; i++)_loop(i, n);
}
// ---- vegetation pass (per region backdrop, drawn over the content) ----
// Positions strongly favor the corner quadrants so growth stays off the
// road/path connectors — a stray tree over the roadway is allowed but rare.
//
// `keepOut` is the footprint of every structure the recipe actually drew. A
// canopy OVERHANGING a roof is the point — it is what makes the growth read as
// having taken the place back — but a trunk standing on one is not, so a spot
// that lands too near a building is re-rolled. Re-rolling is safe here where it
// would not be inside a recipe: vegetation has its own seeded stream, both the
// shadow and content passes replay it from identical copies, and both are
// handed the same keep-out list, so they always agree on where growth went.
var $3c042d4e8c9507db$var$VEG_TRIES = 14;
/**
 * How far a TRUNK stands off a building, as a fraction of its own canopy. At
 * 0.6 a tree keeps most of its spread clear of the roof and laps the rest over
 * the edge. Testing the bare POINT, as this did, let a tree stand one unit from
 * a wall with its entire crown over the building.
 */ var $3c042d4e8c9507db$var$VEG_CLEARANCE = 0.6;
var $3c042d4e8c9507db$var$SHRUB_CLEARANCE = 4; // growth with no radius of its own to scale by
/** @returns a spot, or null when there is nowhere on this tile to plant one. */ function $3c042d4e8c9507db$var$vegSpot(rng, keepOut) {
    var clear = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $3c042d4e8c9507db$var$SHRUB_CLEARANCE;
    var roll = function() {
        var band = function() {
            return rng() < 0.5 ? $3c042d4e8c9507db$var$ri(rng, 9, 33) : $3c042d4e8c9507db$var$ri(rng, 84, 108);
        };
        if (rng() < 0.8) return [
            band(),
            band()
        ];
        return rng() < 0.5 ? [
            band(),
            $3c042d4e8c9507db$var$ri(rng, 9, 108)
        ] : [
            $3c042d4e8c9507db$var$ri(rng, 9, 108),
            band()
        ];
    };
    if (!(keepOut === null || keepOut === void 0 ? void 0 : keepOut.length)) return roll();
    var onStructure = function(param) {
        var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), x = _param[0], y = _param[1];
        return keepOut.some(function(b) {
            return x >= b.x0 - clear && x <= b.x1 + clear && y >= b.y0 - clear && y <= b.y1 + clear;
        });
    };
    for(var i = 0; i < $3c042d4e8c9507db$var$VEG_TRIES; i++){
        var spot = roll();
        if (!onStructure(spot)) return spot;
    }
    // Nowhere to put it. Giving up rather than planting anyway is also what ties
    // the density to the open ground: a tile built kerb to kerb grows little, and
    // the same budget over open tarmac lands in full.
    return null;
}
// m = density multiplier (tune.treeDensity, 5x for campsite/water tiles).
// The ceiling bounds how thick one tile can get; it is not a tuning knob, and
// at 12 the rest stops and shorelines were flattening against it.
var $3c042d4e8c9507db$var$VEG_MAX = 24;
var $3c042d4e8c9507db$var$vegCount = function(rng, lo, hi, m) {
    return Math.min($3c042d4e8c9507db$var$VEG_MAX, Math.round($3c042d4e8c9507db$var$ri(rng, lo, hi) * m));
};
/**
 * Irregular grass at the foot of a stand of trees.
 *
 * Only where they came out THICK. One tree on a street is a tree in a pavement
 * cutout and the paving around it is intact; three growing into each other have
 * had long enough to break the surface between them. Each qualifying trunk gets
 * its own wobbled patch and the patches merge, so the outline of a stand is the
 * union of its trees rather than a shape drawn on purpose.
 *
 * Laid as GROUND: before the canopies, so it reads as what they are standing
 * in, and outside castShadow, because grass casts nothing.
 */ var $3c042d4e8c9507db$var$STAND_REACH = 24; // how near two trunks must be to count as one stand
var $3c042d4e8c9507db$var$STAND_MIN = 3; // ...and how many neighbours before it is one
function $3c042d4e8c9507db$var$grassUnder(g, rng, T, stand, keepOut) {
    // A patch spreads wider than the canopy above it, so the trunk's own
    // clearance does not cover it: without this the grass laps onto the roof
    // next door, and grass on a roof is not a thing that happens.
    var inTheOpen = function(x, y, rad) {
        return !keepOut.some(function(b) {
            return x + rad > b.x0 && x - rad < b.x1 && y + rad > b.y0 && y - rad < b.y1;
        });
    };
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var _step_value = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step.value, 3), x = _step_value[0], y = _step_value[1], r = _step_value[2];
            var near = stand.filter(function(param) {
                var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), ox = _param[0], oy = _param[1];
                return Math.hypot(ox - x, oy - y) < $3c042d4e8c9507db$var$STAND_REACH;
            }).length - 1;
            if (near < $3c042d4e8c9507db$var$STAND_MIN) return "continue";
            var rad = r + $3c042d4e8c9507db$var$ri(rng, 2, 6);
            if (!inTheOpen(x, y, rad)) return "continue";
            var left = $3c042d4e8c9507db$var$wobbler(rng), right = $3c042d4e8c9507db$var$wobbler(rng);
            $3c042d4e8c9507db$var$blob(g, x, y, rad, T.veg1, left, right);
            for(var i = 0, n = $3c042d4e8c9507db$var$ri(rng, 6, 14); i < n; i++){
                var a = rng() * Math.PI * 2, d = Math.sqrt(rng()) * rad;
                g.r(Math.round(x + Math.cos(a) * d), Math.round(y + Math.sin(a) * d), $3c042d4e8c9507db$var$ri(rng, 2, 4), 1, T.veg2);
            }
        };
        for(var _iterator = stand[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
// Counts are doubled from what they were, authored here rather than hidden
// behind a global factor. A tree clears by its own canopy; a shrub takes the
// flat margin. Where there is nowhere to plant, nothing is planted — which is
// what puts the extra growth on the open tarmac instead of on the roofs.
//
// Trees are all SITED before any of them is drawn, so grassUnder can see the
// whole stand and get its grass down underneath them.
var $3c042d4e8c9507db$var$TD_VEGETATION = {
    city: function(g, rng, T, m, keep) {
        var stand = [];
        for(var i = 0, n = $3c042d4e8c9507db$var$vegCount(rng, 2, 4, m); i < n; i++){
            var r = $3c042d4e8c9507db$var$ri(rng, 6, 9), s = $3c042d4e8c9507db$var$vegSpot(rng, keep, Math.round(r * $3c042d4e8c9507db$var$VEG_CLEARANCE));
            if (s) stand.push([
                s[0],
                s[1],
                r
            ]);
        }
        $3c042d4e8c9507db$var$grassUnder(g, rng, T, stand, keep);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = stand[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step.value, 3), x = _step_value[0], y = _step_value[1], r1 = _step_value[2];
                $3c042d4e8c9507db$var$tree(g, rng, T, x, y, r1);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        for(var i1 = 0, n1 = $3c042d4e8c9507db$var$vegCount(rng, 2, 6, m); i1 < n1; i1++){
            var s1 = $3c042d4e8c9507db$var$vegSpot(rng, keep);
            if (s1) $3c042d4e8c9507db$var$bushPatch(g, rng, T, s1[0], s1[1]);
        }
    },
    greenhouse: function(g, rng, T, m, keep) {
        var stand = [];
        for(var i = 0, n = $3c042d4e8c9507db$var$vegCount(rng, 4, 8, m); i < n; i++){
            var r = $3c042d4e8c9507db$var$ri(rng, 9, 15), s = $3c042d4e8c9507db$var$vegSpot(rng, keep, Math.round(r * $3c042d4e8c9507db$var$VEG_CLEARANCE));
            if (s) stand.push([
                s[0],
                s[1],
                r
            ]);
        }
        $3c042d4e8c9507db$var$grassUnder(g, rng, T, stand, keep);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = stand[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step.value, 3), x = _step_value[0], y = _step_value[1], r1 = _step_value[2];
                $3c042d4e8c9507db$var$tree(g, rng, T, x, y, r1);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        for(var i1 = 0, n1 = $3c042d4e8c9507db$var$vegCount(rng, 6, 12, m); i1 < n1; i1++){
            var s1 = $3c042d4e8c9507db$var$vegSpot(rng, keep);
            if (s1) $3c042d4e8c9507db$var$bushPatch(g, rng, T, s1[0], s1[1]);
        }
    },
    harbor: function(g, rng, T, m, keep) {
        for(var i = 0, n = $3c042d4e8c9507db$var$vegCount(rng, 2, 4, m); i < n; i++){
            var s = $3c042d4e8c9507db$var$vegSpot(rng, keep);
            if (s) $3c042d4e8c9507db$var$bushPatch(g, rng, T, s[0], s[1]);
        }
        var stand = [];
        for(var i1 = 0, n1 = $3c042d4e8c9507db$var$vegCount(rng, 0, 2, m); i1 < n1; i1++){
            var s1 = $3c042d4e8c9507db$var$vegSpot(rng, keep, Math.round(6 * $3c042d4e8c9507db$var$VEG_CLEARANCE));
            if (s1) stand.push([
                s1[0],
                s1[1],
                6
            ]);
        }
        $3c042d4e8c9507db$var$grassUnder(g, rng, T, stand, keep);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = stand[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step.value, 3), x = _step_value[0], y = _step_value[1], r = _step_value[2];
                $3c042d4e8c9507db$var$tree(g, rng, T, x, y, r);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    },
    foundry: function(g, rng, T, m, keep) {
        for(var i = 0, n = $3c042d4e8c9507db$var$vegCount(rng, 0, 2, m); i < n; i++){
            var s = $3c042d4e8c9507db$var$vegSpot(rng, keep);
            if (s) $3c042d4e8c9507db$var$deadTree(g, rng, T, s[0], s[1]);
        }
        if (rng() < 0.8 * m) {
            var s1 = $3c042d4e8c9507db$var$vegSpot(rng, keep);
            if (s1) $3c042d4e8c9507db$var$bushPatch(g, rng, T, s1[0], s1[1]);
        }
    },
    underground: function(g, rng, T, m, keep) {
        for(var i = 0, n = $3c042d4e8c9507db$var$vegCount(rng, 2, 6, m); i < n; i++){
            var s = $3c042d4e8c9507db$var$vegSpot(rng, keep);
            if (s) $3c042d4e8c9507db$var$glowShroom(g, rng, T, s[0], s[1]);
        }
    }
};
// ===============================
// REGION SIGNATURE STRUCTURES
// ===============================
// The one drawing pass that is about a PARTICULAR region rather than about a
// town. Everything else on a tile — the recipes, the road network, the parking,
// the ruins — is deliberately region-agnostic, which is right for a game where
// the same fifteen room types appear everywhere. The cost of that was that five
// regions rendered as one settlement under five palettes: same footprints, same
// silhouettes, a colour filter apart.
//
// This layer is the answer, and it is kept to the same shape as FLOORS,
// TD_VEGETATION and TD_OVERLAYS above it — a table keyed by theme.backdrop — so
// there is one obvious place to add a region's own architecture and one obvious
// place to look for it.
//
// The contract:
//   (g, rng, T, tune, ctx) -> Array<{x0,y0,x1,y1}>   the footprints it drew
//   ctx = { keep, samples, conn, col, row, built, recipe }
// Returning the footprints matters: the growth pass has to keep off them, the
// same way it keeps off everything the recipe drew.
/**
 * Whether a signature prop fires on this tile. Scaled by the region's own
 * `signature` knob (0 turns the layer off entirely) and by how built up the
 * district is — an outskirt gets fewer monuments than a core, for the same
 * reason it gets fewer buildings.
 */ var $3c042d4e8c9507db$var$sigRoll = function(rng, chance, tune, built) {
    var _tune_signature;
    return rng() < chance * ((_tune_signature = tune.signature) !== null && _tune_signature !== void 0 ? _tune_signature : 1) * (built != null ? 0.5 + 0.7 * built : 1);
};
/**
 * Somewhere on the tile to stand a prop of this size: clear of everything
 * already placed, off the roadway, and held inside TILE_CLAMP. The box-based
 * sibling of vegSpot, and it gives up the same way — on a tile with no room
 * left, the monument that was never built is the right answer, and it is what
 * ties this layer's density to the open ground.
 */ function $3c042d4e8c9507db$var$sigSpot(rng, ctx, w, h) {
    var _loop = function(i) {
        var _ctx_samples;
        var x = $3c042d4e8c9507db$var$ri(rng, lo, hiX), y = $3c042d4e8c9507db$var$ri(rng, lo, hiY);
        var b = {
            x0: x,
            y0: y,
            x1: x + w,
            y1: y + h
        };
        var clash = ctx.keep.some(function(k) {
            return b.x0 <= k.x1 && b.x1 >= k.x0 && b.y0 <= k.y1 && b.y1 >= k.y0;
        }) || !!((_ctx_samples = ctx.samples) === null || _ctx_samples === void 0 ? void 0 : _ctx_samples.length) && $3c042d4e8c9507db$var$runsThrough(ctx.samples, b);
        if (!clash) return {
            v: b
        };
    };
    var tries = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 12;
    var lo = $3c042d4e8c9507db$var$TILE_CLAMP, hiX = $3c042d4e8c9507db$export$9e15ff8aa6bc996f - $3c042d4e8c9507db$var$TILE_CLAMP - w, hiY = $3c042d4e8c9507db$export$9e15ff8aa6bc996f - $3c042d4e8c9507db$var$TILE_CLAMP - h;
    if (hiX < lo || hiY < lo) return null;
    for(var i = 0; i < tries; i++){
        var _ret = _loop(i);
        if ((0, $1968e3edfc5cfc11$export$71511d61b312f219)(_ret) === "object") return _ret.v;
    }
    return null;
}
// ---- world-lattice features ----
// TILE_CLAMP exists because a neighbour draws its OWN recipe and never
// continues this tile's, so a roof clipped by the canvas reads as a fault. A
// feature laid on a world lattice is the exception, and it is exempt by
// construction: both tiles derive the identical run from the same hashed world
// cell, both draw it, and each canvas clips its own half. The join is exact
// because neither tile decided anything locally.
//
// This is the lightWellsNear trick generalised, and it is what breaks the
// 120-unit rhythm the map otherwise reads on — a colonnade or a conveyor that
// marches across four tiles is the strongest cue that the map is one place
// rather than a grid of stamps.
/**
 * @param {number} cell  authoring units between candidate features
 * @returns {Array<{x,y,len,vert}>} runs in TILE-LOCAL coordinates
 */ // A run is up to LEN_MAX cells long, so a tile has to consider every cell that
// could REACH it, not just the ones next door. Searching ±1 cell looked right
// and was not: a long run originating two cells west was drawn by one tile and
// not by its neighbour, so it stopped dead at the join — the exact failure the
// whole world-lattice idea exists to avoid, and invisible in any single tile.
var $3c042d4e8c9507db$var$LEN_MIN = 1.2, $3c042d4e8c9507db$var$LEN_MAX = 2.2; // run length, in cells
var $3c042d4e8c9507db$var$FEATURE_RADIUS = Math.ceil($3c042d4e8c9507db$var$LEN_MAX) + 1; // cells to search either way
/**
 * @param {number} cell  authoring units between candidate features
 * @returns {Array<{x,y,len,vert}>} runs in TILE-LOCAL coordinates
 */ function $3c042d4e8c9507db$var$worldFeaturesNear(col, row, cell, salt, density) {
    var out = [];
    var cx = Math.floor(col * $3c042d4e8c9507db$export$9e15ff8aa6bc996f / cell), cy = Math.floor(row * $3c042d4e8c9507db$export$9e15ff8aa6bc996f / cell);
    for(var gy = cy - $3c042d4e8c9507db$var$FEATURE_RADIUS; gy <= cy + $3c042d4e8c9507db$var$FEATURE_RADIUS; gy++)for(var gx = cx - $3c042d4e8c9507db$var$FEATURE_RADIUS; gx <= cx + $3c042d4e8c9507db$var$FEATURE_RADIUS; gx++){
        if ($3c042d4e8c9507db$var$noiseHash(gx * 13 + salt, gy * 29 + salt) > density) continue;
        var vert = $3c042d4e8c9507db$var$noiseHash(gx + salt, gy + 5 + salt) < 0.5;
        var len = Math.round(cell * ($3c042d4e8c9507db$var$LEN_MIN + ($3c042d4e8c9507db$var$LEN_MAX - $3c042d4e8c9507db$var$LEN_MIN) * $3c042d4e8c9507db$var$noiseHash(gx + 3 + salt, gy + 11 + salt)));
        var wx = (gx + 0.1 + 0.8 * $3c042d4e8c9507db$var$noiseHash(gx + 17 + salt, gy + salt)) * cell;
        var wy = (gy + 0.1 + 0.8 * $3c042d4e8c9507db$var$noiseHash(gx + salt, gy + 23 + salt)) * cell;
        // tile-local, so a run that straddles the join is drawn by both sides
        var x = Math.round(wx - col * $3c042d4e8c9507db$export$9e15ff8aa6bc996f), y = Math.round(wy - row * $3c042d4e8c9507db$export$9e15ff8aa6bc996f);
        // Reject on the run's whole BOX, both axes. Testing only the long axis
        // kept vertical runs that sat entirely off the west edge.
        var x1 = x + (vert ? $3c042d4e8c9507db$var$FEATURE_TH : len), y1 = y + (vert ? len : $3c042d4e8c9507db$var$FEATURE_TH);
        if (x1 < 0 || y1 < 0 || x > $3c042d4e8c9507db$export$9e15ff8aa6bc996f || y > $3c042d4e8c9507db$export$9e15ff8aa6bc996f) continue;
        out.push({
            x: x,
            y: y,
            len: len,
            vert: vert
        });
    }
    return out;
}
// Widest a lattice run gets across its axis; only used to reject runs that
// cannot touch the tile, so an over-estimate is harmless.
var $3c042d4e8c9507db$var$FEATURE_TH = 22;
// ---- the props ----
/**
 * The monumental tier: a tower's footprint seen from above. This is the one
 * silhouette that has to read at 80px, so it is drawn big, in the `mass`
 * material rather than the ordinary building stock, and it throws a shadow at
 * twice the usual reach because it is the tallest thing for blocks. The skirt
 * of debris around its base is what says the tower is a ruin rather than a
 * warehouse: nothing this tall came through the centuries with its cladding on.
 */ function $3c042d4e8c9507db$var$towerCore(g, rng, T, x, y, w, h) {
    $3c042d4e8c9507db$var$castShadow(function() {
        return g.a($3c042d4e8c9507db$var$SHADOW.a * 0.8, function() {
            return g.r(x + $3c042d4e8c9507db$var$SHADOW.dx * 3, y + $3c042d4e8c9507db$var$SHADOW.dy * 3, w, h, T.far);
        });
    });
    g.r(x, y, w, h, T.mass);
    g.r(x, y, w, 1, T.massLight); // lit north and west faces
    g.r(x, y, 1, h, T.massLight);
    g.r(x, y + h - 1, w, 1, T.massDark);
    g.r(x + w - 1, y, 1, h, T.massDark);
    // the service core: every tower of this era has one, and from above it is
    // the only thing that breaks the roof plate
    var cw = Math.max(6, w >> 2), ch = Math.max(6, h >> 2);
    var cxp = x + (w - cw >> 1), cyp = y + (h - ch >> 1);
    g.r(cxp, cyp, cw, ch, T.massDark);
    g.r(cxp, cyp, cw, 1, T.mass);
    g.a(0.35, function() {
        for(var i = 6; i < w - 2; i += 6)g.r(x + i, y + 1, 1, h - 2, T.massDark);
    });
    $3c042d4e8c9507db$var$rubble(g, rng, T, x - 5, x + w + 5, y - 5, y + h + 5, Math.max(6, w * h / 150));
}
/**
 * PARKED — not referenced by TD_SIGNATURE.city. Kept because the idea is right
 * and the execution is not: at 80px this reads as a plain grey bar, because
 * what says "elevated walkway" is the support piers under it and the shadow it
 * throws across the street, and neither is drawn. Bring it back with those.
 *
 * What is left of an elevated walkway: a deck that starts nowhere and stops in
 * mid-air. Drawn as a world-lattice run so it crosses tiles, which is the whole
 * point — a skybridge that fits inside one cell is a footbridge.
 */ function $3c042d4e8c9507db$var$skybridgeStub(g, rng, T, x, y, len, vert) {
    var th = 11;
    $3c042d4e8c9507db$var$castShadow(function() {
        return g.a($3c042d4e8c9507db$var$SHADOW.a * 0.7, function() {
            return g.r(x + $3c042d4e8c9507db$var$SHADOW.dx * 2, y + $3c042d4e8c9507db$var$SHADOW.dy * 2, vert ? th : len, vert ? len : th, T.far);
        });
    });
    $3c042d4e8c9507db$var$pipeRun(g, T, x, y, len, vert, th, 0, 'mass');
    g.a(0.4, function() {
        for(var d = 3; d < len; d += 5)if (vert) {
            g.r(x, y + d, 1, 2, T.massDark);
            g.r(x + th - 1, y + d, 1, 2, T.massDark);
        } else {
            g.r(x + d, y, 2, 1, T.massDark);
            g.r(x + d, y + th - 1, 2, 1, T.massDark);
        }
    });
    // the broken end, ragged and shedding
    var ex = vert ? x : x + len - 4, ey = vert ? y + len - 4 : y;
    g.r(ex, ey, vert ? th : 4, vert ? 4 : th, T.structDark);
    $3c042d4e8c9507db$var$rubble(g, rng, T, ex - 4, ex + th, ey - 4, ey + th, 6);
}
/**
 * A civic perimeter block: a monumental range built right round an open yard.
 *
 * This is what replaced the sign gantry, and the reason is the camera. A sign
 * is defined by its FACE, and from directly overhead a face is an edge — the
 * gantry came out as a small striped bar standing in the open, and no amount of
 * detail on a surface the player cannot see was going to fix that. What reads
 * from above is what is defined by its PLAN, and the plan of a perimeter block
 * — a rectangle with a hole in it — is unmistakable at any size.
 *
 * It pairs with towerCore rather than repeating it: one is a solid mass, this
 * is a hollow one, so the monumental tier has two silhouettes instead of one.
 */ function $3c042d4e8c9507db$var$civicBlock(g, rng, T, x, y, w, h) {
    var th = Math.max(7, Math.min(w, h) >> 2); // depth of the range
    $3c042d4e8c9507db$var$castShadow(function() {
        return g.a($3c042d4e8c9507db$var$SHADOW.a * 0.6, function() {
            return g.r(x + $3c042d4e8c9507db$var$SHADOW.dx * 2, y + $3c042d4e8c9507db$var$SHADOW.dy * 2, w, h, T.far);
        });
    });
    g.r(x, y, w, h, T.mass);
    g.r(x, y, w, 1, T.massLight); // lit north and west faces
    g.r(x, y, 1, h, T.massLight);
    g.r(x, y + h - 1, w, 1, T.massDark);
    g.r(x + w - 1, y, 1, h, T.massDark);
    g.a(0.3, function() {
        for(var i = 5; i < w - 4; i += 9)g.r(x + i, y + 2, 4, 3, T.massDark);
        for(var i1 = 5; i1 < h - 4; i1 += 9)g.r(x + 2, y + i1, 3, 4, T.massDark);
    });
    // The yard. Open ground, so the region's own floor shows through and the
    // growth has somewhere to be — a courtyard nobody has crossed in centuries.
    var ix = x + th, iy = y + th, iw = w - th * 2, ih = h - th * 2;
    if (iw > 3 && ih > 3) {
        g.r(ix, iy, iw, ih, T.ground2);
        g.a(0.5, function() {
            for(var i = 0, n = Math.round(iw * ih / 22); i < n; i++)g.r(ix + $3c042d4e8c9507db$var$ri(rng, 0, iw - 1), iy + $3c042d4e8c9507db$var$ri(rng, 0, ih - 1), 2, 1, T.ground1);
        });
        for(var i = 0, n = $3c042d4e8c9507db$var$ri(rng, 3, 7); i < n; i++)g.r(ix + $3c042d4e8c9507db$var$ri(rng, 0, Math.max(0, iw - 3)), iy + $3c042d4e8c9507db$var$ri(rng, 0, Math.max(0, ih - 2)), $3c042d4e8c9507db$var$ri(rng, 2, 4), 2, rng() < 0.6 ? T.veg1 : T.veg2);
        // the yard is a well: its own walls light the opposite way to the outside
        g.r(ix, iy, iw, 1, T.massDark);
        g.r(ix, iy, 1, ih, T.massDark);
        g.r(ix, iy + ih - 1, iw, 1, T.massLight);
        g.r(ix + iw - 1, iy, 1, ih, T.massLight);
    }
    // ...and a length of the range that has come down, which is what makes it a
    // ruin rather than a building. Taken out of one side, full depth, so the yard
    // is open to the street through the gap.
    for(var i1 = 0, n1 = $3c042d4e8c9507db$var$ri(rng, 1, 2); i1 < n1; i1++){
        var side = $3c042d4e8c9507db$var$ri(rng, 0, 3);
        var span = $3c042d4e8c9507db$var$ri(rng, 9, 18);
        if (side === 0 || side === 1) {
            var gx = x + $3c042d4e8c9507db$var$ri(rng, 2, Math.max(2, w - span - 2));
            var gy = side === 0 ? y : y + h - th;
            g.r(gx, gy, span, th, T.ground2);
            $3c042d4e8c9507db$var$rubble(g, rng, T, gx - 2, gx + span + 2, gy - 2, gy + th + 2, Math.max(4, span >> 1));
        } else {
            var gy1 = y + $3c042d4e8c9507db$var$ri(rng, 2, Math.max(2, h - span - 2));
            var gx1 = side === 2 ? x : x + w - th;
            g.r(gx1, gy1, th, span, T.ground2);
            $3c042d4e8c9507db$var$rubble(g, rng, T, gx1 - 2, gx1 + th + 2, gy1 - 2, gy1 + span + 2, Math.max(4, span >> 1));
        }
    }
}
/**
 * A glasshouse span: a long shallow roof of glazing, ridged down its spine,
 * with panes missing. The gaps show the growth underneath, which is the thing
 * that makes it read as a greenhouse rather than as a shed — the region's whole
 * story is that the glass failed and the planting did not.
 */ function $3c042d4e8c9507db$var$glassSpan(g, rng, T, x, y, w, h) {
    var _loop = function(i, n) {
        var pw = $3c042d4e8c9507db$var$ri(rng, 4, 9), ph = $3c042d4e8c9507db$var$ri(rng, 4, 9);
        var px = $3c042d4e8c9507db$var$ri(rng, x + 1, Math.max(x + 1, x + w - pw - 1));
        var py = $3c042d4e8c9507db$var$ri(rng, y + 1, Math.max(y + 1, y + h - ph - 1));
        g.r(px, py, pw, ph, T.veg1);
        g.a(0.5, function() {
            return g.r(px, py, pw, 1, T.veg2);
        });
    };
    $3c042d4e8c9507db$var$dropShadow(g, T, x, y, w, h);
    g.r(x, y, w, h, T.mass);
    g.r(x, y, w, 1, T.massLight);
    g.r(x, y + h - 1, w, 1, T.massDark);
    var vert = h > w;
    var ridge = vert ? x + (w >> 1) : y + (h >> 1);
    if (vert) {
        g.r(ridge, y, 2, h, T.massLight);
        g.r(ridge + 2, y, 1, h, T.massDark);
    } else {
        g.r(x, ridge, w, 2, T.massLight);
        g.r(x, ridge + 2, w, 1, T.massDark);
    }
    g.a(0.4, function() {
        if (vert) for(var d = 5; d < h - 2; d += 5)g.r(x + 1, y + d, w - 2, 1, T.massDark);
        else for(var d1 = 5; d1 < w - 2; d1 += 5)g.r(x + d1, y + 1, 1, h - 2, T.massDark);
    });
    for(var i = 0, n = $3c042d4e8c9507db$var$ri(rng, 2, 5); i < n; i++)_loop(i, n);
}
/** A grid of irrigation pipe over what used to be beds. */ function $3c042d4e8c9507db$var$irrigationLattice(g, rng, T, x, y, w, h) {
    for(var d = 0; d < h; d += 9)$3c042d4e8c9507db$var$pipeRun(g, T, x, y + d, w, false, 3, 0);
    $3c042d4e8c9507db$var$pipeRun(g, T, x, y, h, true, 4, 0); // the header main they all feed off
    g.a(0.4, function() {
        for(var d = 6; d < w; d += 12)g.r(x + d, y, 1, h, T.structDark);
    });
}
/** A storage silo: tall, round, with a conical cap and a feed chute. */ function $3c042d4e8c9507db$var$silo(g, rng, T, cx, cy, r) {
    $3c042d4e8c9507db$var$castShadow(function() {
        return g.a($3c042d4e8c9507db$var$SHADOW.a * 0.8, function() {
            return $3c042d4e8c9507db$var$disc(g, cx + $3c042d4e8c9507db$var$SHADOW.dx * 2, cy + $3c042d4e8c9507db$var$SHADOW.dy * 2, r, T.far);
        });
    });
    $3c042d4e8c9507db$var$disc(g, cx, cy, r, T.mass);
    $3c042d4e8c9507db$var$ringO(g, cx, cy, r, T.massDark);
    g.a(0.5, function() {
        return $3c042d4e8c9507db$var$disc(g, cx - 2, cy - 2, Math.max(2, r - 5), T.massLight);
    }); // sheen off the cap
    $3c042d4e8c9507db$var$disc(g, cx, cy, Math.max(2, r >> 2), T.massDark); // the cap vent
    var a = rng() * Math.PI * 2; // feed chute off one side
    $3c042d4e8c9507db$var$pipeRun(g, T, Math.round(cx + Math.cos(a) * r), Math.round(cy + Math.sin(a) * r), $3c042d4e8c9507db$var$ri(rng, 9, 18), Math.abs(Math.sin(a)) > 0.5, 4, 0);
}
/** Mooring bollards, set in a row back from the water. */ function $3c042d4e8c9507db$var$bollardRow(g, rng, T, x, y, len, vert) {
    for(var d = 0; d < len; d += 12){
        var bx = vert ? x : x + d, by = vert ? y + d : y;
        $3c042d4e8c9507db$var$discShadow(g, T, bx, by, 3);
        $3c042d4e8c9507db$var$disc(g, bx, by, 3, T.metal);
        $3c042d4e8c9507db$var$ringO(g, bx, by, 3, T.structDark);
        g.r(bx - 1, by - 1, 2, 2, T.rust);
    }
}
/** A gantry crane straddling a bay: two leg pads and a lattice beam between. */ function $3c042d4e8c9507db$var$gantry(g, rng, T, x, y, len, vert) {
    var th = 7;
    $3c042d4e8c9507db$var$castShadow(function() {
        return g.a($3c042d4e8c9507db$var$SHADOW.a * 0.7, function() {
            return g.r(x + $3c042d4e8c9507db$var$SHADOW.dx * 2, y + $3c042d4e8c9507db$var$SHADOW.dy * 2, vert ? th : len, vert ? len : th, T.far);
        });
    });
    $3c042d4e8c9507db$var$pipeRun(g, T, x, y, len, vert, th, 0, 'mass');
    g.a(0.5, function() {
        for(var d = 2; d < len - 2; d += 4)if (vert) g.r(x + 1, y + d, th - 2, 1, T.massDark);
        else g.r(x + d, y + 1, 1, th - 2, T.massDark);
    });
    for(var _i = 0, _iter = [
        0,
        len - 8
    ]; _i < _iter.length; _i++){
        var end = _iter[_i];
        var px = vert ? x - 3 : x + end, py = vert ? y + end : y - 3;
        g.r(px, py, vert ? th + 6 : 8, vert ? 8 : th + 6, T.metal);
        g.r(px, py, vert ? th + 6 : 8, 1, T.structLight);
    }
}
/** A conveyor run: a belt on trestles, seized where it stopped. */ function $3c042d4e8c9507db$var$conveyorRun(g, rng, T, x, y, len, vert) {
    $3c042d4e8c9507db$var$pipeRun(g, T, x, y, len, vert, 9, 15, 'metal');
    g.a(0.5, function() {
        if (vert) g.r(x + 2, y, 5, len, T.structDark);
        else g.r(x, y + 2, len, 5, T.structDark);
    });
    for(var d = 8; d < len; d += 8){
        if (rng() < 0.5) continue;
        var sx = vert ? x + (rng() < 0.5 ? -3 : 9) : x + d;
        var sy = vert ? y + d : y + (rng() < 0.5 ? -3 : 9);
        g.r(sx, sy, 3, 3, T.rust);
    }
}
/** A bunded tank farm: two or three tanks inside a spill wall. */ function $3c042d4e8c9507db$var$tankFarm(g, rng, T, x, y, w, h) {
    g.a(0.5, function() {
        return g.r(x, y, w, h, T.structDark);
    }); // the bund floor
    g.r(x, y, w, 2, T.mass);
    g.r(x, y + h - 2, w, 2, T.mass);
    g.r(x, y, 2, h, T.mass);
    g.r(x + w - 2, y, 2, h, T.mass);
    var r = Math.max(6, Math.min(w, h) >> 2);
    for(var i = 0, n = $3c042d4e8c9507db$var$ri(rng, 2, 3); i < n; i++)$3c042d4e8c9507db$var$tankTop(g, rng, T, $3c042d4e8c9507db$var$ri(rng, x + r + 3, Math.max(x + r + 3, x + w - r - 3)), $3c042d4e8c9507db$var$ri(rng, y + r + 3, Math.max(y + r + 3, y + h - r - 3)), r);
}
/**
 * A structural pillar in a sublevel hall, seen from above: a squat column with
 * a flared capital and a pool of shadow under it. Laid in colonnades on a world
 * lattice — a row of these marching off the edge of the tile and picked up by
 * the neighbour is the single strongest cue that the ceiling is overhead.
 */ function $3c042d4e8c9507db$var$pillarSquat(g, rng, T, cx, cy, r) {
    $3c042d4e8c9507db$var$discShadow(g, T, cx, cy, r + 2);
    $3c042d4e8c9507db$var$disc(g, cx, cy, r, T.massDark); // the flared capital
    $3c042d4e8c9507db$var$disc(g, cx, cy, Math.max(2, r - 2), T.mass);
    g.a(0.5, function() {
        return $3c042d4e8c9507db$var$disc(g, cx - 1, cy - 1, Math.max(1, r - 4), T.massLight);
    });
    $3c042d4e8c9507db$var$ringO(g, cx, cy, r, T.structDark);
}
/**
 * Ballast, sleepers and two rails, laid down the tile like a minor road.
 *
 * A railway is a ROUTE, so it is drawn as one: it enters at the north edge and
 * leaves at the south, and both crossings come from edgeOffset — the same
 * function the roads use, so the two tiles either side of a join derive the
 * same crossing and the line meets itself exactly. It was a scattered prop
 * before, which gave the map short lengths of track starting and stopping in
 * the middle of nowhere.
 */ var $3c042d4e8c9507db$var$RAIL_TH = 21;
function $3c042d4e8c9507db$var$railBed(g, rng, T, row, col) {
    var th = $3c042d4e8c9507db$var$RAIL_TH;
    // where the line crosses this tile's north and south edges
    var top = $3c042d4e8c9507db$export$9e15ff8aa6bc996f / 2 + $3c042d4e8c9507db$export$cfdc75f9711ba396(row, col, 'n', th);
    var bot = $3c042d4e8c9507db$export$9e15ff8aa6bc996f / 2 + $3c042d4e8c9507db$export$cfdc75f9711ba396(row, col, 's', th);
    for(var y = 0; y < $3c042d4e8c9507db$export$9e15ff8aa6bc996f; y++){
        var t = y / ($3c042d4e8c9507db$export$9e15ff8aa6bc996f - 1);
        var s = t * t * (3 - 2 * t); // ease between the two crossings
        var cx = Math.round(top + (bot - top) * s);
        var x = cx - (th >> 1);
        g.r(x, y, th, 1, T.ground2); // the ballast shoulder
        if (y % 6 < 3) g.r(x + 2, y, th - 4, 1, T.structDark); // sleepers
        for(var _i = 0, _iter = [
            6,
            th - 8
        ]; _i < _iter.length; _i++){
            var off = _iter[_i];
            g.r(x + off, y, 2, 1, T.metal);
            g.r(x + off, y, 1, 1, T.structLight);
        }
    }
}
/** A tray of cable running along a wall line, lids long gone. */ function $3c042d4e8c9507db$var$cableTray(g, rng, T, x, y, len, vert) {
    $3c042d4e8c9507db$var$pipeRun(g, T, x, y, len, vert, 6, 0, 'structDark');
    g.a(0.6, function() {
        if (vert) g.r(x + 1, y, 4, len, T.metal);
        else g.r(x, y + 1, len, 4, T.metal);
    });
    for(var d = 4; d < len; d += 9)if (vert) g.r(x - 2, y + d, 10, 1, T.structDark);
    else g.r(x + d, y - 2, 1, 10, T.structDark);
}
var $3c042d4e8c9507db$export$ecbd1adefe7cd5ab = {
    // Two monumental silhouettes, one solid and one hollow. Both are read from
    // their PLAN, which is the only thing a top-down camera can show — the two
    // props cut from here failed on exactly that point (a skybridge deck and a
    // sign gantry are both defined by a face, and a face seen from overhead is a
    // bar). A shape that could be anything is worse than no shape: it reads as a
    // rendering fault rather than as architecture.
    city: function(g, rng, T, tune, ctx) {
        var drew = [];
        // Towers only where the district is genuinely built up — a tower on an
        // outskirt is what made the old map read as one uniform city.
        if ((ctx.built == null || ctx.built >= 0.8) && $3c042d4e8c9507db$var$sigRoll(rng, 0.34, tune, ctx.built)) {
            var w = $3c042d4e8c9507db$var$ri(rng, 27, 42), h = $3c042d4e8c9507db$var$ri(rng, 27, 42);
            // The debris skirt spills SKIRT units past the tower on every side, so the
            // spot is cleared at that size and the tower is drawn inset into it.
            // Clearing only the tower's own box let the rubble land in a sinkhole next
            // door — which the shared "nothing hangs in the hole" test caught.
            var SKIRT = 6;
            var b = $3c042d4e8c9507db$var$sigSpot(rng, ctx, w + SKIRT * 2, h + SKIRT * 2);
            if (b) {
                $3c042d4e8c9507db$var$towerCore(g, rng, T, b.x0 + SKIRT, b.y0 + SKIRT, w, h);
                drew.push(b);
            }
        } else if ((ctx.built == null || ctx.built >= 0.6) && $3c042d4e8c9507db$var$sigRoll(rng, 0.26, tune, ctx.built)) {
            // ...and where a tower did not go up, the block that ran round a yard.
            // Deliberately in the tower's `else`: two monuments on one tile is a
            // skyline, not a street. Gated on density too, if more loosely — a civic
            // range needs a city round it as much as a tower does, just less of one.
            var w1 = $3c042d4e8c9507db$var$ri(rng, 45, 63), h1 = $3c042d4e8c9507db$var$ri(rng, 45, 63);
            var b1 = $3c042d4e8c9507db$var$sigSpot(rng, ctx, w1 + 4, h1 + 4);
            if (b1) {
                $3c042d4e8c9507db$var$civicBlock(g, rng, T, b1.x0 + 2, b1.y0 + 2, w1, h1);
                drew.push(b1);
            }
        }
        return drew;
    },
    greenhouse: function(g, rng, T, tune, ctx) {
        var drew = [];
        if ($3c042d4e8c9507db$var$sigRoll(rng, 0.28, tune, ctx.built)) {
            var vert = rng() < 0.5;
            var w = vert ? $3c042d4e8c9507db$var$ri(rng, 18, 27) : $3c042d4e8c9507db$var$ri(rng, 42, 66);
            var h = vert ? $3c042d4e8c9507db$var$ri(rng, 42, 66) : $3c042d4e8c9507db$var$ri(rng, 18, 27);
            var b = $3c042d4e8c9507db$var$sigSpot(rng, ctx, w, h);
            if (b) {
                $3c042d4e8c9507db$var$glassSpan(g, rng, T, b.x0, b.y0, w, h);
                drew.push(b);
            }
        }
        if ($3c042d4e8c9507db$var$sigRoll(rng, 0.20, tune, ctx.built)) {
            var w1 = $3c042d4e8c9507db$var$ri(rng, 30, 48), h1 = $3c042d4e8c9507db$var$ri(rng, 21, 33);
            var b1 = $3c042d4e8c9507db$var$sigSpot(rng, ctx, w1, h1);
            if (b1) {
                $3c042d4e8c9507db$var$irrigationLattice(g, rng, T, b1.x0, b1.y0, w1, h1);
                drew.push(b1);
            }
        }
        if ($3c042d4e8c9507db$var$sigRoll(rng, 0.12, tune, ctx.built)) {
            var r = $3c042d4e8c9507db$var$ri(rng, 9, 14);
            var b2 = $3c042d4e8c9507db$var$sigSpot(rng, ctx, r * 2, r * 2);
            if (b2) {
                $3c042d4e8c9507db$var$silo(g, rng, T, b2.x0 + r, b2.y0 + r, r);
                drew.push(b2);
            }
        }
        return drew;
    },
    // The sea wall is NOT here. It belongs to the tide pass (drawSeaWall), because
    // a coast defence and the coast have to be two readings of one field or they
    // disagree — which is exactly what happened while this layer owned it: the
    // wall was laid on a world lattice that knew nothing about the water, so it
    // wandered in and out of the sea on the shore row and, worse, went on being
    // laid two rows inland where there was no water at all. Walls across dry
    // districts were the single loudest wrong note in the region.
    harbor: function(g, rng, T, tune, ctx) {
        var drew = [];
        // Bollards, though, ARE dockside furniture rather than coast defence, and
        // they read as a quay wherever the water reaches.
        if (ctx.shore === 0) {
            var y = ctx.shoreSide === 's' ? $3c042d4e8c9507db$export$9e15ff8aa6bc996f - $3c042d4e8c9507db$var$WATERLINE + 16 : $3c042d4e8c9507db$var$WATERLINE + 4;
            $3c042d4e8c9507db$var$bollardRow(g, rng, T, 8, y, $3c042d4e8c9507db$export$9e15ff8aa6bc996f - 8, false);
        }
        if ($3c042d4e8c9507db$var$sigRoll(rng, 0.2, tune, ctx.built)) {
            var b = $3c042d4e8c9507db$var$sigSpot(rng, ctx, 30, 30);
            if (b) {
                for(var i = 0, n = $3c042d4e8c9507db$var$ri(rng, 2, 4); i < n; i++)$3c042d4e8c9507db$var$containerBox(g, rng, T, b.x0 + $3c042d4e8c9507db$var$ri(rng, 0, 15), b.y0 + $3c042d4e8c9507db$var$ri(rng, 0, 3) * 9, rng() < 0.5);
                drew.push(b);
            }
        }
        return drew;
    },
    foundry: function(g, rng, T, tune, ctx) {
        var drew = [];
        var _tune_signature;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = $3c042d4e8c9507db$var$worldFeaturesNear(ctx.col, ctx.row, 140, 23, 0.09 * ((_tune_signature = tune.signature) !== null && _tune_signature !== void 0 ? _tune_signature : 1))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var f = _step.value;
                $3c042d4e8c9507db$var$conveyorRun(g, rng, T, f.x, f.y, f.len, f.vert);
                drew.push({
                    x0: f.x,
                    y0: f.y,
                    x1: f.x + (f.vert ? 9 : f.len),
                    y1: f.y + (f.vert ? f.len : 9)
                });
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if ($3c042d4e8c9507db$var$sigRoll(rng, 0.22, tune, ctx.built)) {
            var vert = rng() < 0.5, len = $3c042d4e8c9507db$var$ri(rng, 42, 72);
            var b = $3c042d4e8c9507db$var$sigSpot(rng, ctx, vert ? 13 : len, vert ? len : 13);
            if (b) {
                $3c042d4e8c9507db$var$gantry(g, rng, T, b.x0 + 3, b.y0 + 3, len, vert);
                drew.push(b);
            }
        }
        if ($3c042d4e8c9507db$var$sigRoll(rng, 0.13, tune, ctx.built)) {
            var w = $3c042d4e8c9507db$var$ri(rng, 39, 54), h = $3c042d4e8c9507db$var$ri(rng, 33, 45);
            var b1 = $3c042d4e8c9507db$var$sigSpot(rng, ctx, w, h);
            if (b1) {
                $3c042d4e8c9507db$var$tankFarm(g, rng, T, b1.x0, b1.y0, w, h);
                drew.push(b1);
            }
        }
        return drew;
    },
    underground: function(g, rng, T, tune, ctx) {
        var drew = [];
        // The line first, so the pillars and everything after it keep off the track.
        if (ctx.rail) {
            $3c042d4e8c9507db$var$railBed(g, rng, T, ctx.row, ctx.col);
            var c = $3c042d4e8c9507db$export$9e15ff8aa6bc996f / 2 + $3c042d4e8c9507db$export$cfdc75f9711ba396(ctx.row, ctx.col, 'n', $3c042d4e8c9507db$var$RAIL_TH);
            var d = $3c042d4e8c9507db$export$9e15ff8aa6bc996f / 2 + $3c042d4e8c9507db$export$cfdc75f9711ba396(ctx.row, ctx.col, 's', $3c042d4e8c9507db$var$RAIL_TH);
            drew.push({
                x0: Math.min(c, d) - $3c042d4e8c9507db$var$RAIL_TH,
                y0: 0,
                x1: Math.max(c, d) + $3c042d4e8c9507db$var$RAIL_TH,
                y1: $3c042d4e8c9507db$export$9e15ff8aa6bc996f
            });
        }
        // The colonnade is not rolled for — a sublevel hall always has its pillars,
        // and it is their rhythm across tiles that says there is a ceiling on this.
        //
        // The pitch is wide. It was half this, which put roughly a dozen pillars on
        // every tile and read as a car park rather than as a hall — and it was doing
        // work the rock masses in the corners already do, since a hall with its
        // walls coming in needs fewer columns, not more.
        var pitch = 55, r = 7;
        var ox = (ctx.col * $3c042d4e8c9507db$export$9e15ff8aa6bc996f % pitch + pitch) % pitch;
        var oy = (ctx.row * $3c042d4e8c9507db$export$9e15ff8aa6bc996f % pitch + pitch) % pitch;
        for(var py = -oy; py < $3c042d4e8c9507db$export$9e15ff8aa6bc996f + pitch; py += pitch){
            var _loop = function(px) {
                var _ctx_samples;
                var cx = px + (pitch >> 1), cy = py + (pitch >> 1);
                if (cx < -r || cy < -r || cx > $3c042d4e8c9507db$export$9e15ff8aa6bc996f + r || cy > $3c042d4e8c9507db$export$9e15ff8aa6bc996f + r) return "continue";
                var b = {
                    x0: cx - r,
                    y0: cy - r,
                    x1: cx + r,
                    y1: cy + r
                };
                // `drew` as well as ctx.keep: the rail bed went down a moment ago and a
                // pillar standing in the four-foot is the same mistake as one standing
                // in the roadway.
                var hits = function(k) {
                    return b.x0 <= k.x1 && b.x1 >= k.x0 && b.y0 <= k.y1 && b.y1 >= k.y0;
                };
                if (ctx.keep.some(hits) || drew.some(hits)) return "continue";
                if (((_ctx_samples = ctx.samples) === null || _ctx_samples === void 0 ? void 0 : _ctx_samples.length) && $3c042d4e8c9507db$var$runsThrough(ctx.samples, b)) return "continue";
                $3c042d4e8c9507db$var$pillarSquat(g, rng, T, cx, cy, r);
                drew.push(b);
            };
            for(var px = -ox; px < $3c042d4e8c9507db$export$9e15ff8aa6bc996f + pitch; px += pitch)_loop(px);
        }
        if ($3c042d4e8c9507db$var$sigRoll(rng, 0.22, tune, ctx.built)) {
            var vert = rng() < 0.5, len = $3c042d4e8c9507db$var$ri(rng, 42, 78);
            var b = $3c042d4e8c9507db$var$sigSpot(rng, ctx, vert ? 10 : len, vert ? len : 10);
            if (b) {
                $3c042d4e8c9507db$var$cableTray(g, rng, T, b.x0 + 2, b.y0 + 2, len, vert);
                drew.push(b);
            }
        }
        return drew;
    }
};
// Small standing-water lakes: 2-3 overlapping lobes each give irregular
// shapes, drawn like the water tile — bank ring, opaque water, sparkle
// glints — just smaller. All banks across every lake are laid down before
// any water, so one lake's shore never cuts across another's surface where
// they overlap; touching lakes merge into a single larger body.
function $3c042d4e8c9507db$var$drawLakes(g, rng, T, count) {
    var lobes = [];
    for(var i = 0; i < count; i++){
        var cx = $3c042d4e8c9507db$var$ri(rng, 21, 96), cy = $3c042d4e8c9507db$var$ri(rng, 21, 96);
        for(var j = 0, m = $3c042d4e8c9507db$var$ri(rng, 2, 3); j < m; j++)lobes.push([
            cx + $3c042d4e8c9507db$var$ri(rng, -9, 9),
            cy + $3c042d4e8c9507db$var$ri(rng, -9, 9),
            $3c042d4e8c9507db$var$ri(rng, 6, 12)
        ]);
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = lobes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step.value, 3), x = _step_value[0], y = _step_value[1], r = _step_value[2];
            $3c042d4e8c9507db$var$disc(g, x, y, r + 3, T.ground2); // all banks first
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = lobes[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var _step_value1 = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step1.value, 3), x1 = _step_value1[0], y1 = _step_value1[1], r1 = _step_value1[2];
            $3c042d4e8c9507db$var$disc(g, x1, y1, r1, T.water1); // then all water
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
    try {
        for(var _iterator2 = lobes[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var _step_value2 = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step2.value, 3), x2 = _step_value2[0], y2 = _step_value2[1], r2 = _step_value2[2];
            if (rng() < 0.8) g.r(x2 - (r2 >> 1) + $3c042d4e8c9507db$var$ri(rng, 0, r2), y2 + $3c042d4e8c9507db$var$ri(rng, -3, 3), $3c042d4e8c9507db$var$ri(rng, 4, 7), 1, T.water2); // glints
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
            }
        } finally{
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }
}
// ---- the tide ----
// Where the water is, on a region the sea got into. The old flood pass dropped
// one to three lakes on every tile, which read as polka dots: uniformly damp,
// with no sense that the water had come from anywhere. This one grades inland
// from an ocean along one edge of the map, so the same region reads drowned at
// the shore, tidal a row in, and dry at the far side.
//
// Two rules make it work across tile joins without any tile knowing what its
// neighbour drew:
//
//   1. Depth is measured in WORLD units from the ocean edge, not in rows. The
//      shore row's far edge is 119 and the next row's near edge is 120, so the
//      waterline is continuous across a horizontal seam. Measuring per row would
//      put a step at every join.
//   2. The wobble that makes the waterline ragged is sampled on world X, so two
//      tiles either side of a vertical seam compute the identical value there.
//
// WATERLINE is half a tile on purpose. The shore row has to stay walkable — a
// row of impassable water would be a balance change, and this is meant to be
// nothing but a change of scenery — so the sea takes the outer half of those
// tiles and stops.
//
// The line itself is the SEA WALL, not a noise contour. A ragged natural
// waterline with a wall drawn on top of it read as neither: the wall wandered
// in and out of the water instead of holding it. So the wall is straight, it
// defines where the sea stops, and it has BREACHES — and the breaches are the
// point. They say why this district drowned, they give the water a way in, and
// every inland flood traces back through one of them. A sea defence that failed
// somewhere is a story; a sea defence with water on both sides is a mistake.
// How far inland the wall — and so the sea — reaches. Set so the wall clears
// the roadway rather than being cut in half by it: an east-west road runs down
// the tile's mid-line and is ROAD_W wide, so it occupies 45..75, and the wall
// has to finish before that. The coast road then runs just INSIDE the defence,
// which is where a coast road goes.
var $3c042d4e8c9507db$var$WATERLINE = 45;
var $3c042d4e8c9507db$var$WALL_TH = 9; // the wall's own thickness
var $3c042d4e8c9507db$var$BREACH_CELL = 190; // one gap per this much wall
var $3c042d4e8c9507db$var$BREACH_HALF_MIN = 16; // ...of this half-width
var $3c042d4e8c9507db$var$BREACH_HALF_MAX = 27;
var $3c042d4e8c9507db$var$BREACH_SHOULDER = 14; // how quickly a gap opens to full width
var $3c042d4e8c9507db$var$SPILL = 130; // how far inland the widest breach reaches
var $3c042d4e8c9507db$var$REACH = 330; // how far inland standing water is found at all
// The low-ground field does NOT start at the wall. On the shore row the only
// water past the wall should be what came through a gap — that is what makes
// the breaches read as the cause rather than as decoration, and it is what
// keeps the landward half of the row looking like land.
var $3c042d4e8c9507db$var$LOW_START = 85;
var $3c042d4e8c9507db$var$TIDE_STEP = 3; // sampling resolution, in authoring units
function $3c042d4e8c9507db$export$16356d731e5dcef3(wx) {
    var c = Math.floor(wx / $3c042d4e8c9507db$var$BREACH_CELL);
    var open = 0;
    // the neighbouring cells too, so a gap sitting near a cell edge is not clipped
    for(var i = c - 1; i <= c + 1; i++){
        var mid = (i + 0.25 + 0.5 * $3c042d4e8c9507db$var$noiseHash(i * 7 + 3, 91)) * $3c042d4e8c9507db$var$BREACH_CELL;
        var half = $3c042d4e8c9507db$var$BREACH_HALF_MIN + ($3c042d4e8c9507db$var$BREACH_HALF_MAX - $3c042d4e8c9507db$var$BREACH_HALF_MIN) * $3c042d4e8c9507db$var$noiseHash(i * 11, 57);
        var d = Math.abs(wx - mid);
        if (d < half) open = Math.max(open, Math.min(1, (half - d) / $3c042d4e8c9507db$var$BREACH_SHOULDER));
    }
    return open;
}
/**
 * The SEA: everything seaward of the wall, plus what is coming through the gaps
 * in it. Above zero is water.
 *
 * Kept apart from the standing water below because they are drawn differently —
 * the sea and its spill are deep water, the pools left behind inland are not,
 * and telling them apart is the difference between "the coast got in here" and
 * "this street holds a puddle". A single depth threshold could not say it: the
 * far end of a spill fan is shallow and still sea.
 */ function $3c042d4e8c9507db$var$tideSea(wx, depthIn, level) {
    var wall = $3c042d4e8c9507db$var$WATERLINE * level;
    if (depthIn < wall) return 1 - 0.4 * (depthIn / Math.max(1, wall)); // open sea
    var open = $3c042d4e8c9507db$export$16356d731e5dcef3(wx);
    var past = depthIn - wall;
    // Through a breach: a fan of water spreading inland from the gap, narrowing
    // as it goes. This is the ONLY thing that connects the inland water to the
    // sea, so it is deliberately generous near the wall.
    // A SUBTRACTIVE taper, not a multiplicative one. Scaling the gap's width by
    // distance keeps every gap wet for the whole spill length, just fainter, so
    // the wetted area behind the wall is the gap's full width all the way in.
    // Subtracting distance instead means only the wider gaps reach far, and the
    // wet patch narrows to a point — which is what water coming through a hole
    // and spreading out actually looks like from above.
    var fan = open > 0 ? open - past / ($3c042d4e8c9507db$var$SPILL * level) : -1;
    // Smoothstep the fan. A linear taper meets the ground along a straight line,
    // which was half of why the flood used to have corners.
    return fan > 0 ? fan * fan * (3 - 2 * Math.min(1, fan)) : fan;
}
/**
 * The STANDING WATER: what the sea left behind once it was through the wall.
 *
 * One continuous field rather than scattered pools, and biased toward the gaps —
 * `breachAt` widens it wherever a breach is upstream, so the inland water joins
 * up with the fan that fed it instead of sitting in the map as an archipelago
 * nothing explains.
 */ function $3c042d4e8c9507db$var$tideStanding(wx, depthIn, level, roadBias) {
    var past = depthIn - $3c042d4e8c9507db$var$WATERLINE * level;
    if (past < 0) return -1;
    // How far the water got is a property of the GROUND, so it varies along the
    // coast. Holding it at a constant depth put the inland edge of the flood on a
    // ruler-straight line right across the map — the one thing that says "field
    // evaluated against a threshold" rather than "water found the low ground".
    // Both ends wander, so neither edge is a horizon.
    var drift = $3c042d4e8c9507db$var$smoothNoise(wx / 260 + 51.3, 9.1);
    var reach = $3c042d4e8c9507db$var$REACH * (0.45 + 1.1 * drift) * level;
    var start = $3c042d4e8c9507db$var$LOW_START * (0.6 + 0.8 * $3c042d4e8c9507db$var$smoothNoise(wx / 180 + 7.7, 33.3));
    var inland = (past - start) / Math.max(1, reach);
    if (inland < 0 || inland > 1) return -1;
    // Almost all of the shape comes from ONE coarse octave, smoothstepped, so
    // the body is round and the edges curve. The fine octave that used to carry
    // a fifth of the weight was what gave the flood its crimped, angular outline
    // — detail at that scale reads as noise rather than as a shoreline.
    var n = $3c042d4e8c9507db$var$smoothNoise(wx / 150 + 31.7, depthIn / 150 + 5.1);
    var body = n * n * (3 - 2 * n);
    var fine = $3c042d4e8c9507db$var$smoothNoise(wx / 62 + 3.3, depthIn / 62 + 17.9);
    return body * 0.9 + fine * 0.1 + roadBias + 0.22 * $3c042d4e8c9507db$export$16356d731e5dcef3(wx) - (0.46 + 0.42 * inland);
}
function $3c042d4e8c9507db$export$98b4df498e934cf(shore, shoreSide, level) {
    if (shore !== 0) return null;
    var wall = $3c042d4e8c9507db$var$WATERLINE * level;
    var y0 = shoreSide === 's' ? $3c042d4e8c9507db$export$9e15ff8aa6bc996f - wall : wall - $3c042d4e8c9507db$var$WALL_TH;
    return y0 < 0 || y0 + $3c042d4e8c9507db$var$WALL_TH > $3c042d4e8c9507db$export$9e15ff8aa6bc996f ? null : Math.round(y0);
}
function $3c042d4e8c9507db$var$drawSeaWall(g, T, ctx, level, side) {
    var y0 = $3c042d4e8c9507db$export$98b4df498e934cf(ctx.shore, side, level);
    if (y0 == null) return;
    var wx0 = ctx.col * $3c042d4e8c9507db$export$9e15ff8aa6bc996f;
    var y = Math.round(y0);
    var runX = -1;
    var flush = function(x1) {
        if (runX < 0) return;
        var w = x1 - runX;
        g.r(runX, y, w, $3c042d4e8c9507db$var$WALL_TH, T.mass);
        g.r(runX, y, w, 1, T.massLight); // lit crown
        g.r(runX, y + $3c042d4e8c9507db$var$WALL_TH - 1, w, 1, T.massDark);
        for(var d = 7; d < w; d += 15)if (side === 'n') g.r(runX + d, y + $3c042d4e8c9507db$var$WALL_TH, 5, 5, T.mass);
        else g.r(runX + d, y - 5, 5, 5, T.mass);
        g.a(0.45, function() {
            for(var d = 2; d < w; d += 5)g.r(runX + d, side === 'n' ? y : y + $3c042d4e8c9507db$var$WALL_TH - 2, 2, 2, T.rust);
        });
        runX = -1;
    };
    for(var x = 0; x < $3c042d4e8c9507db$export$9e15ff8aa6bc996f; x += $3c042d4e8c9507db$var$TIDE_STEP){
        if ($3c042d4e8c9507db$export$16356d731e5dcef3(wx0 + x) > 0) {
            flush(x);
            continue;
        } // the gap
        if (runX < 0) runX = x;
    }
    flush($3c042d4e8c9507db$export$9e15ff8aa6bc996f);
    // Rubble where it failed — the ends of the standing sections, spilling into
    // the gap. Without this a breach reads as a wall that was built with a hole.
    var prev = false;
    for(var x1 = 0; x1 < $3c042d4e8c9507db$export$9e15ff8aa6bc996f; x1 += $3c042d4e8c9507db$var$TIDE_STEP){
        var open = $3c042d4e8c9507db$export$16356d731e5dcef3(wx0 + x1) > 0;
        if (open !== prev) for(var i = 0; i < 4; i++)g.r(x1 + $3c042d4e8c9507db$var$ri3(x1 + i * 7) - 6, y + $3c042d4e8c9507db$var$ri3(x1 + i * 3) - 3, 3, 2, T.massDark);
        prev = open;
    }
}
/** A tiny deterministic 0..8 jitter off a world coordinate. */ var $3c042d4e8c9507db$var$ri3 = function(n) {
    return Math.floor($3c042d4e8c9507db$var$noiseHash(n | 0, 977) * 9);
};
function $3c042d4e8c9507db$var$drawTide(g, rng, T, ctx) {
    var _loop = function(iy) {
        var y = iy * $3c042d4e8c9507db$var$TIDE_STEP;
        var depthIn = ctx.shore * $3c042d4e8c9507db$export$9e15ff8aa6bc996f + (side === 'n' ? y : $3c042d4e8c9507db$export$9e15ff8aa6bc996f - 1 - y);
        var runX = -1, runDeep = false;
        var flush = function(x1) {
            if (runX >= 0) (runDeep ? seaRuns : poolRuns).push([
                runX,
                y,
                x1 - runX,
                $3c042d4e8c9507db$var$TIDE_STEP
            ]);
            runX = -1;
        };
        for(var ix = 0; ix < N; ix++){
            var x = ix * $3c042d4e8c9507db$var$TIDE_STEP, wx = wx0 + x;
            var sea = $3c042d4e8c9507db$var$tideSea(wx, depthIn, level);
            var pool = $3c042d4e8c9507db$var$tideStanding(wx, depthIn, level, (roadMask === null || roadMask === void 0 ? void 0 : roadMask[iy * N + ix]) ? 0.12 : 0);
            // The wall stops the water only where the wall is actually THERE. Skipping
            // the whole band left a dry stripe straight through every breach — the sea
            // pouring in, then a gap, then the flood again — which is the one place
            // the water most needs to be continuous.
            var walled = onWall(y) && $3c042d4e8c9507db$export$16356d731e5dcef3(wx) <= 0;
            var wet = Math.max(sea, pool) > 0 && !walled && !blocked(x + 1, y + 1);
            if (!wet) {
                flush(x);
                continue;
            }
            // Deep only where the SEA is deep. Standing water never is, however much
            // of it there is — a flooded street is ankle deep whatever its extent.
            var deep = sea >= pool && sea > SEA_SHALLOW;
            if (runX >= 0 && deep !== runDeep) flush(x);
            if (runX < 0) {
                runX = x;
                runDeep = deep;
            }
        }
        flush($3c042d4e8c9507db$export$9e15ff8aa6bc996f);
    };
    var _ctx_samples;
    var _ctx_floodLevel;
    var level = Math.max(0.01, (_ctx_floodLevel = ctx.floodLevel) !== null && _ctx_floodLevel !== void 0 ? _ctx_floodLevel : 1);
    var side = ctx.shoreSide === 's' ? 's' : 'n';
    var wx0 = ctx.col * $3c042d4e8c9507db$export$9e15ff8aa6bc996f;
    // Streets flood first: they are the low ground, and a drowned district reads
    // as one the moment the carriageway goes under while the lots are still dry.
    // The roadway is rasterised once into a coarse mask so the per-cell test is a
    // lookup — testing every sample against every road sample is not affordable.
    var N = Math.ceil($3c042d4e8c9507db$export$9e15ff8aa6bc996f / $3c042d4e8c9507db$var$TIDE_STEP);
    var roadMask = null;
    if ((_ctx_samples = ctx.samples) === null || _ctx_samples === void 0 ? void 0 : _ctx_samples.length) {
        roadMask = new Uint8Array(N * N);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = ctx.samples[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var s = _step.value;
                var x0 = Math.max(0, (s.x - s.hx) / $3c042d4e8c9507db$var$TIDE_STEP | 0), x1 = Math.min(N - 1, (s.x + s.hx) / $3c042d4e8c9507db$var$TIDE_STEP | 0);
                var y0 = Math.max(0, (s.y - s.hy) / $3c042d4e8c9507db$var$TIDE_STEP | 0), y1 = Math.min(N - 1, (s.y + s.hy) / $3c042d4e8c9507db$var$TIDE_STEP | 0);
                for(var yy = y0; yy <= y1; yy++)for(var xx = x0; xx <= x1; xx++)roadMask[yy * N + xx] = 1;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    // Structures stand OUT of the water — the recipe's and the region's own both.
    var standing = (0, $4c858c0d999a5b9b$export$71511d61b312f219)(ctx.keep || []).concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)(ctx.props || []));
    var blocked = function(x, y) {
        return standing.some(function(b) {
            return x >= b.x0 && x <= b.x1 && y >= b.y0 && y <= b.y1;
        });
    };
    // The wall went down with the ground, so the water stops at its face rather
    // than washing over the top of it — otherwise the defence disappears under
    // the very sea it is holding back.
    var wallTop = $3c042d4e8c9507db$export$98b4df498e934cf(ctx.shore, side, level);
    var onWall = function(y) {
        return wallTop != null && y + $3c042d4e8c9507db$var$TIDE_STEP > wallTop && y < wallTop + $3c042d4e8c9507db$var$WALL_TH;
    };
    // Two lists. The distinction is WHAT the water is first and how deep it is
    // second: standing water left inland is always the light tone, while the sea
    // and its inflows are deep in the body and light around their margins — the
    // shelving edge where a breach spills onto the street. Splitting on depth
    // alone put the same contour through the standing water as through the sea;
    // ignoring depth entirely flattened the inflows into one hard shape.
    var SEA_SHALLOW = 0.35;
    var seaRuns = [], poolRuns = [];
    for(var iy = 0; iy < N; iy++)_loop(iy);
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = seaRuns[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var _step_value = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step1.value, 4), x = _step_value[0], y = _step_value[1], w = _step_value[2], h = _step_value[3];
            g.r(x, y, w, h, T.water1);
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    g.a(0.55, function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = poolRuns[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step.value, 4), x = _step_value[0], y = _step_value[1], w = _step_value[2], h = _step_value[3];
                g.r(x, y, w, h, T.water2);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    // The line where the water meets the land, picked out along the top of every
    // run so a shelving beach reads as a shore rather than as a flat blue shape.
    g.a(0.5, function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = poolRuns[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step.value, 3), x = _step_value[0], y = _step_value[1], w = _step_value[2];
                g.r(x, y, w, 1, T.water2);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    // What is floating in it. Seeded, unlike everything above — this is debris,
    // not terrain, and it only ever lands where the field already said water is.
    var wetRuns = seaRuns.concat(poolRuns);
    if (!wetRuns.length) return;
    for(var i = 0, n = $3c042d4e8c9507db$var$ri(rng, 0, 3); i < n; i++){
        var _wetRuns_ri = (0, $1788e2ed61915b1e$export$71511d61b312f219)(wetRuns[$3c042d4e8c9507db$var$ri(rng, 0, wetRuns.length - 1)], 3), x2 = _wetRuns_ri[0], y2 = _wetRuns_ri[1], w1 = _wetRuns_ri[2];
        if (w1 < 15) continue;
        if (rng() < 0.5) $3c042d4e8c9507db$var$containerBox(g, rng, T, x2 + $3c042d4e8c9507db$var$ri(rng, 0, w1 - 12), y2, rng() < 0.5);
        else $3c042d4e8c9507db$var$rubbleChunk(g, rng, T, x2 + $3c042d4e8c9507db$var$ri(rng, 0, w1 - 6), y2);
    }
}
// ---- the rock ----
// A sublevel drawn top-down has a problem no other region has: the one thing
// that makes it a sublevel — the ceiling — is the thing a top-down view cannot
// show. Left to the palette alone it came out as an open suburb at night, which
// is why it was the region furthest from its own description.
//
// So the walls come down instead. Rock mass laps into the tile from its corners
// and outer band, carved back around the room, the roadway and the structures,
// which reads as a hall whose roof has come in over the edges of the block. The
// same field grades the darkness: black where the rock is close, clear over the
// middle where the room is. One function, two jobs, and the second one is what
// makes the region legible again — the flat 0.35 wash it replaces took the
// centre of the tile as hard as it took the corners.
var $3c042d4e8c9507db$var$ROCK_STEP = 2; // sampling resolution: fine enough for a broken edge
var $3c042d4e8c9507db$var$ROAD_R = 26; // clearance kept around the roadway, so a route never seals
var $3c042d4e8c9507db$var$DARK_MIN = 0.12; // the darkness wash out in the open
var $3c042d4e8c9507db$var$DARK_MAX = 0.34; // ...and up against the rock
// A mass is anchored to a tile CORNER — that is, to a vertex of the grid, the
// point four tiles share. Each of those four draws the quarter of it that falls
// on its own canvas, so the mass is one shape spanning a junction rather than
// four shapes that have to be made to agree. Seamless by construction, corner-
// only by construction, and no carving needed to keep the routes open: a vertex
// is ROCK_KEEP away from the nearest ground a connection can cross, and no lobe
// is allowed to reach that far.
//
// This replaces a noise field clipped by a hard cross. That guaranteed the same
// things but looked it — the field's soft blobs came out with two straight sides
// wherever the clip bit, which read as black buildings rather than as stone. The
// shape has to be right in the first place, not corrected afterwards.
var $3c042d4e8c9507db$var$ROCK_DENSITY = 0.55; // share of grid vertices carrying a mass
var $3c042d4e8c9507db$var$ROCK_R_MIN = 12, $3c042d4e8c9507db$var$ROCK_R_MAX = 19;
var $3c042d4e8c9507db$var$ROCK_WOBBLE = 0.15; // how far the outline strays from a circle
var $3c042d4e8c9507db$var$ROCK_LOBES = 4; // satellites per mass, scattered round the vertex
var $3c042d4e8c9507db$var$ROCK_KEEP = 21; // nearest a connection comes to a vertex
// Where a connection can run, in the VERTEX's own frame: four rays leaving the
// corner along the tile edges, starting ROCK_KEEP out. Expressed from the
// vertex rather than from a tile because that is the frame a mass lives in —
// the same four rays whichever of the four tiles is asking, so every one of
// them fits a lobe identically.
var $3c042d4e8c9507db$var$CROSS_BANDS = [
    [
        $3c042d4e8c9507db$var$ROCK_KEEP,
        0,
        $3c042d4e8c9507db$export$9e15ff8aa6bc996f - $3c042d4e8c9507db$var$ROCK_KEEP,
        0
    ],
    [
        -$3c042d4e8c9507db$var$ROCK_KEEP,
        0,
        -($3c042d4e8c9507db$export$9e15ff8aa6bc996f - $3c042d4e8c9507db$var$ROCK_KEEP),
        0
    ],
    [
        0,
        $3c042d4e8c9507db$var$ROCK_KEEP,
        0,
        $3c042d4e8c9507db$export$9e15ff8aa6bc996f - $3c042d4e8c9507db$var$ROCK_KEEP
    ],
    [
        0,
        -$3c042d4e8c9507db$var$ROCK_KEEP,
        0,
        -($3c042d4e8c9507db$export$9e15ff8aa6bc996f - $3c042d4e8c9507db$var$ROCK_KEEP)
    ]
];
// How far rock has to stay off a crossing. The bands above are LINES along the
// tile edges, but what has to stay clear is a strip: a carriageway occupies the
// last few pixels before the join, and a run of rock is filled ROCK_STEP wide
// from its last solid sample. Measuring to the line and allowing only the run
// overhang left rock a pixel inside the strip — which is one pixel of stone
// across a route, and the guard exists precisely so that cannot happen.
var $3c042d4e8c9507db$var$CROSS_CLEAR = $3c042d4e8c9507db$var$ROCK_STEP + 4;
function $3c042d4e8c9507db$var$distToSegment(px, py, param) {
    var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 4), x0 = _param[0], y0 = _param[1], x1 = _param[2], y1 = _param[3];
    var dx = x1 - x0, dy = y1 - y0, len2 = dx * dx + dy * dy;
    var t = len2 ? Math.max(0, Math.min(1, ((px - x0) * dx + (py - y0) * dy) / len2)) : 0;
    return Math.hypot(px - (x0 + t * dx), py - (y0 + t * dy));
}
/**
 * The largest this lobe may be and still clear every crossing band.
 *
 * The guarantee is stated here, once, rather than being hand-computed into the
 * radius constants — which is how it got away twice: the main lobe sits on the
 * diagonal and the satellites do not, so each has a different worst case, and
 * an arithmetic margin that covered one missed the other by a pixel. Shrinking
 * rather than dropping keeps the mass where the map wanted one, and it is
 * deterministic, so all four tiles sharing the vertex shrink it identically.
 */ function $3c042d4e8c9507db$var$fitLobe(x, y, r) {
    var limit = Infinity;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $3c042d4e8c9507db$var$CROSS_BANDS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var band = _step.value;
            limit = Math.min(limit, $3c042d4e8c9507db$var$distToSegment(x, y, band));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return Math.min(r, (limit - $3c042d4e8c9507db$var$CROSS_CLEAR) / (1 + $3c042d4e8c9507db$var$ROCK_WOBBLE));
}
function $3c042d4e8c9507db$export$aceae09a505d3fb5(col, row) {
    var _loop = function(_i, _iter) {
        var _iter__i = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_iter[_i], 2), vx = _iter__i[0], vy = _iter__i[1];
        var gx = col + vx / $3c042d4e8c9507db$export$9e15ff8aa6bc996f, gy = row + vy / $3c042d4e8c9507db$export$9e15ff8aa6bc996f;
        if ($3c042d4e8c9507db$var$noiseHash(gx * 17 + 5, gy * 23 + 9) > $3c042d4e8c9507db$var$ROCK_DENSITY) return "continue";
        var seed = (0, $980f67465e309611$export$c0b222505a3369f3)("rock|".concat(gx, "|").concat(gy));
        var r = $3c042d4e8c9507db$var$ROCK_R_MIN + ($3c042d4e8c9507db$var$ROCK_R_MAX - $3c042d4e8c9507db$var$ROCK_R_MIN) * seed();
        // Lobes are placed in the VERTEX's frame and then translated onto this
        // tile, so all four tiles round the corner derive one identical mass and
        // each simply draws the part that lands on its own canvas.
        //
        // They used to be offset toward whichever tile was asking, on the reasoning
        // that the diagonal is the direction furthest from every crossing. It is —
        // but it meant the four tiles each pulled a lobe into themselves, and the
        // union came out as a four-pointed clover on every junction, the same way
        // round every time. A mass has to be ONE shape, not four agreeing ones.
        var add = function(lx, ly, rad) {
            var fitted = $3c042d4e8c9507db$var$fitLobe(lx, ly, rad);
            if (fitted <= 2) return;
            // How far this lobe can matter at all. Cached so the per-sample test can
            // reject on a box comparison before it reaches for a hypot and an atan2 —
            // a tile is thousands of samples against a score of lobes, and all but
            // two or three are nowhere near.
            //
            // TWICE the outline's reach, not once: the darkness gradient runs on the
            // same field and fades out over a lobe's width of floor BEYOND the stone,
            // so cutting at the outline would pull the vignette in tight around it.
            var fade = fitted * (1 + $3c042d4e8c9507db$var$ROCK_WOBBLE) * 2;
            out.push({
                x: vx + lx,
                y: vy + ly,
                r: fitted,
                fade: fade,
                wob: $3c042d4e8c9507db$var$wobbler(seed, 5, $3c042d4e8c9507db$var$ROCK_WOBBLE)
            });
        };
        add(0, 0, r);
        for(var i = 0; i < $3c042d4e8c9507db$var$ROCK_LOBES; i++){
            var a = seed() * Math.PI * 2;
            var d = 8 + 11 * seed();
            var sr = r * (0.45 + 0.4 * seed());
            add(Math.cos(a) * d, Math.sin(a) * d, sr);
        }
    };
    var out = [];
    for(var _i = 0, _iter = [
        [
            0,
            0
        ],
        [
            $3c042d4e8c9507db$export$9e15ff8aa6bc996f,
            0
        ],
        [
            0,
            $3c042d4e8c9507db$export$9e15ff8aa6bc996f
        ],
        [
            $3c042d4e8c9507db$export$9e15ff8aa6bc996f,
            $3c042d4e8c9507db$export$9e15ff8aa6bc996f
        ]
    ]; _i < _iter.length; _i++)_loop(_i, _iter);
    return out;
}
/**
 * How far INSIDE the rock a point is: above zero is stone, and the larger the
 * value the deeper. Wobbled per lobe, so the outline is an irregular closed
 * curve rather than a threshold on a grid.
 */ function $3c042d4e8c9507db$var$rockDepth(lobes, x, y) {
    var best = -1;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = lobes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var m = _step.value;
            var dx = x - m.x, dy = y - m.y;
            // Outside the lobe's reach in either axis, it cannot contribute anything
            // above -1, and `best` already starts there. Two comparisons instead of a
            // hypot and an atan2; without it a hollow-core tile was spending millions
            // of transcendentals a frame on lobes at the far corner.
            if (dx > m.fade || dx < -m.fade || dy > m.fade || dy < -m.fade) continue;
            var d = Math.hypot(dx, dy);
            if (d > m.fade) continue;
            var t = Math.atan2(dy, dx) / (Math.PI * 2) + 0.5;
            var rr = m.r * m.wob(t);
            if (rr > 0) best = Math.max(best, 1 - d / rr);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return best;
}
// How far a mass throws its shadow, and how dark. LONG: a formation runs from
// the floor to the cavern roof, so it is taller than anything built down here
// by an order of magnitude and its shade reaches most of a tile. Scaled by the
// sun's elevation the way a real one is — shortest at noon, drawn right out
// when the shaft comes in low.
var $3c042d4e8c9507db$var$ROCK_SHADOW_LEN = 30;
var $3c042d4e8c9507db$var$ROCK_SHADOW_A = 0.5;
/**
 * The shade a rock mass throws when a daylight shaft is falling on it.
 *
 * Drawn on the overhead channel with the stone, so it lands over the shaft that
 * casts it — a shadow painted UNDER the light would be lit back up by it, which
 * is the one thing a shadow cannot survive.
 *
 * Direction comes from `sunShaft`, the same function that aims the beams, so
 * the shade always falls away from the light rather than in some fixed
 * direction that happens to look right at noon.
 */ // The offset is quantised before the shade is rasterised, so the sun has to
// move a noticeable amount before the work is redone — the same bargain
// staticKey strikes for the building shadows, and for the same reason.
var $3c042d4e8c9507db$var$ROCK_SHADOW_STEP = 3;
/**
 * Where the sun is throwing the shade of a set of upright things, or null if
 * they are throwing none.
 *
 * Nothing in a sublevel casts a shadow through the ordinary machinery: dayState
 * caps the light down here below the threshold at which it gives the sun a
 * direction, so SHADOW comes out as a zero offset and every drop shadow lands
 * exactly under the thing that cast it. That is right for a cavern lit by
 * nothing — and wrong the moment a shaft of daylight comes through the roof.
 *
 * @param {Array<{x,y}>} pts  where the uprights stand, for the light test
 * @param {number} baseLen    how far the shade reaches, before elevation
 */ function $3c042d4e8c9507db$var$shaftShadowPlan(fx, pts, baseLen) {
    var _fx_tune;
    if (!fx || !pts.length || !(((_fx_tune = fx.tune) === null || _fx_tune === void 0 ? void 0 : _fx_tune.lightRays) > 0)) return null;
    var _sunShaft = $3c042d4e8c9507db$var$sunShaft(fx.anim), elev = _sunShaft.elev, bx = _sunShaft.bx, by = _sunShaft.by, ux = _sunShaft.ux, uy = _sunShaft.uy;
    if (elev <= 0.03) return null; // night: no shaft, no shade
    var wells = $3c042d4e8c9507db$var$lightWellsNear(fx.col, fx.row, fx.tune.lightRays);
    if (!wells.length) return null;
    // How lit the uprights are. One figure for the whole group rather than one
    // per pixel: a well is one to two tiles across, so the light over a single
    // tile barely varies, and this is asked every frame.
    var ox = fx.col * $3c042d4e8c9507db$export$3d672f2aedd16af9, oy = fx.row * $3c042d4e8c9507db$export$3d672f2aedd16af9;
    var scale = $3c042d4e8c9507db$export$3d672f2aedd16af9 / $3c042d4e8c9507db$export$9e15ff8aa6bc996f; // authoring units -> world units
    var lit = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = pts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var p = _step.value;
            var px = ox + p.x * scale, py = oy + p.y * scale;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = wells[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var w = _step1.value;
                    lit = Math.max(lit, 1 - Math.hypot(px - w.x - bx, py - w.y - by) / w.r);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (lit <= 0.05) return null;
    var len = baseLen * (0.8 + 0.9 * (1 - elev));
    var q = function(v) {
        return Math.round(v * len / $3c042d4e8c9507db$var$ROCK_SHADOW_STEP) * $3c042d4e8c9507db$var$ROCK_SHADOW_STEP;
    };
    return {
        dx: q(ux),
        dy: q(uy),
        lit: Math.min(1, lit)
    };
}
/**
 * The shade itself, as runs: everything within a lobe's radius of the SEGMENT
 * from where that lobe stands to where its shade falls.
 *
 * A segment, not a point. A shadow is the whole column projected, so it runs
 * from the foot of the stone out to the tip — drawing the offset shape alone
 * left a dark patch floating clear of the mass that threw it, with a gap of
 * lit floor between the two.
 */ function $3c042d4e8c9507db$var$rockShadowRuns(lobes, dx, dy) {
    var _loop = function(iy) {
        var y = iy * $3c042d4e8c9507db$var$ROCK_STEP;
        var runX = -1;
        var flush = function(x1) {
            if (runX >= 0) runs.push([
                runX,
                y,
                x1 - runX,
                $3c042d4e8c9507db$var$ROCK_STEP
            ]);
            runX = -1;
        };
        for(var ix = 0; ix < N; ix++){
            var x = ix * $3c042d4e8c9507db$var$ROCK_STEP;
            var hit = false;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = segs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var s = _step.value;
                    if (x < s.lo.x || x > s.hi.x || y < s.lo.y || y > s.hi.y) continue;
                    if ($3c042d4e8c9507db$var$distToSegment(x, y, s.seg) <= s.r) {
                        hit = true;
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            if (!hit) {
                flush(x);
                continue;
            }
            if (runX < 0) runX = x;
        }
        flush($3c042d4e8c9507db$export$9e15ff8aa6bc996f);
    };
    var N = Math.ceil($3c042d4e8c9507db$export$9e15ff8aa6bc996f / $3c042d4e8c9507db$var$ROCK_STEP);
    var segs = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = lobes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var m = _step.value;
            var x1 = m.x + dx, y1 = m.y + dy;
            // the swept capsule's bounds, for a cheap reject before the distance test
            var lo = {
                x: Math.min(m.x, x1) - m.r,
                y: Math.min(m.y, y1) - m.r
            };
            var hi = {
                x: Math.max(m.x, x1) + m.r,
                y: Math.max(m.y, y1) + m.r
            };
            if (hi.x < 0 || hi.y < 0 || lo.x > $3c042d4e8c9507db$export$9e15ff8aa6bc996f || lo.y > $3c042d4e8c9507db$export$9e15ff8aa6bc996f) continue;
            segs.push({
                seg: [
                    m.x,
                    m.y,
                    x1,
                    y1
                ],
                r: m.r,
                lo: lo,
                hi: hi
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var runs = [];
    if (!segs.length) return runs;
    for(var iy = 0; iy < N; iy++)_loop(iy);
    return runs;
}
/**
 * A drawer for one mass's shade, with the rasterised runs cached against the
 * quantised sun offset.
 *
 * Cast from the LOBES, not from the stone this tile happened to rasterise. At
 * this length a shadow lands a good way from the mass that threw it — often in
 * a neighbouring tile — and each tile only ever rasterises the quarter of a
 * mass inside its own bounds. Offsetting those runs would throw away three
 * quarters of every shadow and leave a hard edge down the tile centre lines.
 * The lobes are shared by all four tiles round the vertex, so casting from them
 * means whichever tile the shade falls in draws the whole of it.
 */ // A building, a pillar, a rail gantry — none of them reach the roof, so their
// shade is a fraction of what the stone throws.
var $3c042d4e8c9507db$var$BUILT_SHADOW_LEN = 11;
/** Is (x,y) anywhere the box passes through as it is dragged along (dx, dy)? */ function $3c042d4e8c9507db$var$inSweptBox(b, x, y, dx, dy) {
    var lo = 0, hi = 1;
    if (dx === 0) {
        if (x < b.x0 || x > b.x1) return false;
    } else {
        var t1 = (x - b.x1) / dx, t2 = (x - b.x0) / dx;
        lo = Math.max(lo, Math.min(t1, t2));
        hi = Math.min(hi, Math.max(t1, t2));
    }
    if (dy === 0) {
        if (y < b.y0 || y > b.y1) return false;
    } else {
        var t11 = (y - b.y1) / dy, t21 = (y - b.y0) / dy;
        lo = Math.max(lo, Math.min(t11, t21));
        hi = Math.min(hi, Math.max(t11, t21));
    }
    return lo <= hi;
}
/**
 * The shade the tile's uprights throw, as runs.
 *
 * The footprints themselves are cut out of it. This pass lands after the world
 * effects — it has to, or the shaft it is cast into would wash it out — and by
 * then the buildings have long since been painted, so anything drawn over their
 * own ground would be drawn over THEM. What is left is exactly the part a
 * player can see anyway: the shade beyond the walls.
 */ function $3c042d4e8c9507db$var$structureShadowRuns(boxes, dx, dy) {
    var _loop = function(iy) {
        var y = iy * $3c042d4e8c9507db$var$ROCK_STEP;
        var runX = -1;
        var flush = function(x1) {
            if (runX >= 0) runs.push([
                runX,
                y,
                x1 - runX,
                $3c042d4e8c9507db$var$ROCK_STEP
            ]);
            runX = -1;
        };
        for(var ix = 0; ix < N; ix++){
            var x = ix * $3c042d4e8c9507db$var$ROCK_STEP;
            var onFootprint = false, swept = false;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = boxes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var b = _step.value;
                    // a footprint wins outright: no shade is drawn on the thing casting it
                    if (x >= b.x0 && x <= b.x1 && y >= b.y0 && y <= b.y1) {
                        onFootprint = true;
                        break;
                    }
                    if (!swept && $3c042d4e8c9507db$var$inSweptBox(b, x, y, dx, dy)) swept = true;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            if (onFootprint || !swept) {
                flush(x);
                continue;
            }
            if (runX < 0) runX = x;
        }
        flush($3c042d4e8c9507db$export$9e15ff8aa6bc996f);
    };
    var N = Math.ceil($3c042d4e8c9507db$export$9e15ff8aa6bc996f / $3c042d4e8c9507db$var$ROCK_STEP);
    var runs = [];
    for(var iy = 0; iy < N; iy++)_loop(iy);
    return runs;
}
function $3c042d4e8c9507db$export$d8acf7b29b621d22(boxes) {
    var pts = boxes.map(function(b) {
        return {
            x: (b.x0 + b.x1) / 2,
            y: (b.y0 + b.y1) / 2
        };
    });
    var key = null, runs = null;
    return function(g, T, fx) {
        var plan = $3c042d4e8c9507db$var$shaftShadowPlan(fx, pts, $3c042d4e8c9507db$var$BUILT_SHADOW_LEN);
        if (!plan) return;
        var k = "".concat(plan.dx, ",").concat(plan.dy);
        if (k !== key) {
            key = k;
            runs = $3c042d4e8c9507db$var$structureShadowRuns(boxes, plan.dx, plan.dy);
        }
        if (!runs.length) return;
        g.a($3c042d4e8c9507db$var$ROCK_SHADOW_A * plan.lit, function() {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = runs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step.value, 4), x = _step_value[0], y = _step_value[1], w = _step_value[2], h = _step_value[3];
                    g.r(x, y, w, h, T.far);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        });
    };
}
function $3c042d4e8c9507db$export$113936d15000c5cd(lobes) {
    var key = null, runs = null;
    return function(g, T, fx) {
        var plan = $3c042d4e8c9507db$var$shaftShadowPlan(fx, lobes, $3c042d4e8c9507db$var$ROCK_SHADOW_LEN);
        if (!plan) return;
        var k = "".concat(plan.dx, ",").concat(plan.dy);
        if (k !== key) {
            key = k;
            runs = $3c042d4e8c9507db$var$rockShadowRuns(lobes, plan.dx, plan.dy);
        }
        if (!runs.length) return;
        g.a($3c042d4e8c9507db$var$ROCK_SHADOW_A * plan.lit, function() {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = runs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step.value, 4), x = _step_value[0], y = _step_value[1], w = _step_value[2], h = _step_value[3];
                    g.r(x, y, w, h, T.far);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        });
    };
}
function $3c042d4e8c9507db$var$drawRockMass(g, rng, T, ctx) {
    var _loop = function(iy) {
        var y = iy * $3c042d4e8c9507db$var$ROCK_STEP;
        var runX = -1, runKind = 0;
        var flush = function(x1) {
            if (runX < 0) return;
            (runKind === 2 ? deep : face).push([
                runX,
                y,
                x1 - runX,
                $3c042d4e8c9507db$var$ROCK_STEP
            ]);
            runX = -1;
        };
        for(var ix = 0; ix < N; ix++){
            var x = ix * $3c042d4e8c9507db$var$ROCK_STEP;
            var m = lobes.length ? $3c042d4e8c9507db$var$rockDepth(lobes, x, y) : -1;
            // The roadway still clears itself. The mass cannot reach a crossing by
            // construction, but a road wanders inside the tile too and rock standing
            // in the carriageway would be wrong wherever it happened.
            var onRoad = roadMask === null || roadMask === void 0 ? void 0 : roadMask[iy * N + ix];
            var solid = m > 0 && !onRoad && !built(x + 1, y + 1);
            // The darkness follows the same field: full out where the rock is close,
            // easing off over the open floor in the middle where the room is. `m` is
            // -1 at twice a lobe's radius and 1 at its core, so the gradient covers
            // roughly a lobe's width of floor outside the stone.
            var near = Math.max(0, Math.min(1, (m + 1) / 1.2));
            wash.push([
                x,
                y,
                $3c042d4e8c9507db$var$DARK_MIN + ($3c042d4e8c9507db$var$DARK_MAX - $3c042d4e8c9507db$var$DARK_MIN) * near
            ]);
            if (!solid) {
                flush(x);
                continue;
            }
            var kind = m > 0.1 ? 2 : 1;
            if (runX >= 0 && kind !== runKind) flush(x);
            if (runX < 0) {
                runX = x;
                runKind = kind;
            }
        }
        flush($3c042d4e8c9507db$export$9e15ff8aa6bc996f);
    };
    var _ctx_samples;
    var _ctx_enclosure;
    var amount = (_ctx_enclosure = ctx === null || ctx === void 0 ? void 0 : ctx.enclosure) !== null && _ctx_enclosure !== void 0 ? _ctx_enclosure : 0;
    var _ctx_col, _ctx_row;
    var col = (_ctx_col = ctx === null || ctx === void 0 ? void 0 : ctx.col) !== null && _ctx_col !== void 0 ? _ctx_col : 0, row = (_ctx_row = ctx === null || ctx === void 0 ? void 0 : ctx.row) !== null && _ctx_row !== void 0 ? _ctx_row : 0;
    var N = Math.ceil($3c042d4e8c9507db$export$9e15ff8aa6bc996f / $3c042d4e8c9507db$var$ROCK_STEP);
    // The roadway carves its own corridor. The road network is symmetric across
    // every edge by construction, so both tiles carve the same seam and a route
    // is never sealed off by rock that only one side knew about.
    var roadMask = null;
    if (ctx === null || ctx === void 0 ? void 0 : (_ctx_samples = ctx.samples) === null || _ctx_samples === void 0 ? void 0 : _ctx_samples.length) {
        roadMask = new Uint8Array(N * N);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = ctx.samples[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var s = _step.value;
                var x0 = Math.max(0, (s.x - s.hx - $3c042d4e8c9507db$var$ROAD_R) / $3c042d4e8c9507db$var$ROCK_STEP | 0);
                var x1 = Math.min(N - 1, (s.x + s.hx + $3c042d4e8c9507db$var$ROAD_R) / $3c042d4e8c9507db$var$ROCK_STEP | 0);
                var y0 = Math.max(0, (s.y - s.hy - $3c042d4e8c9507db$var$ROAD_R) / $3c042d4e8c9507db$var$ROCK_STEP | 0);
                var y1 = Math.min(N - 1, (s.y + s.hy + $3c042d4e8c9507db$var$ROAD_R) / $3c042d4e8c9507db$var$ROCK_STEP | 0);
                for(var yy = y0; yy <= y1; yy++)for(var xx = x0; xx <= x1; xx++)roadMask[yy * N + xx] = 1;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    // ...and so does everything standing on the tile, or the mass buries the room
    // it is supposed to be the walls of.
    var built = function(x, y) {
        var _ctx_keep;
        return ctx === null || ctx === void 0 ? void 0 : (_ctx_keep = ctx.keep) === null || _ctx_keep === void 0 ? void 0 : _ctx_keep.some(function(b) {
            return x > b.x0 - 10 && x < b.x1 + 10 && y > b.y0 - 10 && y < b.y1 + 10;
        });
    };
    var lobes = amount ? $3c042d4e8c9507db$export$aceae09a505d3fb5(col, row) : [];
    var face = [], deep = [], wash = [];
    for(var iy = 0; iy < N; iy++)_loop(iy);
    // The wash first, so the rock itself is not dimmed by its own shadow.
    // Quantised to a handful of levels and merged into runs — a per-cell alpha
    // would be 1600 fills of near-identical darkness.
    var runA = -1, runX = 0, runY = -1;
    var flushWash = function(x1, y, a) {
        if (runA <= 0.001) return;
        g.a(runA, function() {
            return g.r(runX, y, x1 - runX, $3c042d4e8c9507db$var$ROCK_STEP, T.far);
        });
    };
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = wash[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var _step_value = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step1.value, 3), x = _step_value[0], y = _step_value[1], a = _step_value[2];
            var q = Math.round(a * 12) / 12;
            if (y !== runY || q !== runA) {
                if (runY >= 0) flushWash(y === runY ? x : $3c042d4e8c9507db$export$9e15ff8aa6bc996f, runY, runA);
                runA = q;
                runX = x;
                runY = y;
            }
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    if (runY >= 0) flushWash($3c042d4e8c9507db$export$9e15ff8aa6bc996f, runY, runA);
    // Everything upright on the tile throws shade in a shaft, not just the stone.
    var upright = (0, $4c858c0d999a5b9b$export$71511d61b312f219)((ctx === null || ctx === void 0 ? void 0 : ctx.keep) || []).concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)((ctx === null || ctx === void 0 ? void 0 : ctx.props) || []));
    // Lobes, not runs: a tile with a mass at one of its corners may rasterise
    // none of it (buried under a structure, or the whole quarter suppressed) and
    // still be the tile that mass throws its shade into. And a tile with no mass
    // at all still has buildings on it, which is why the structures are their own
    // clause rather than something the rock's presence gates.
    if (!amount || !lobes.length && !upright.length) return;
    // Facets are rolled HERE, while the seeded stream is in hand, and drawn from
    // the resulting list below. The draw is replayed every frame on the overhead
    // channel and a replay must never touch the rng — it would reshuffle the
    // stone on every tick.
    var facets = [];
    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
    try {
        for(var _iterator2 = face.concat(deep)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var _step_value1 = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step2.value, 3), x2 = _step_value1[0], y2 = _step_value1[1], w = _step_value1[2];
            if (w < 5 || rng() < 0.5) continue;
            var fw = $3c042d4e8c9507db$var$ri(rng, 2, Math.min(9, w));
            facets.push([
                x2 + $3c042d4e8c9507db$var$ri(rng, 0, w - fw),
                y2,
                fw,
                rng() < 0.55
            ]);
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
            }
        } finally{
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }
    // The mass goes ON TOP OF EVERYTHING, above even the clouds and the daylight
    // shafts. It is a cutaway through stone that carries on up to the cavern
    // roof, so nothing in the room can be in front of it and a shaft of daylight
    // crossing one would be light coming through the ceiling.
    //
    // Rock is not a silhouette either, and drawing it as two flat fills of the
    // void colour made it one — a black shape with a hard edge, which the eye
    // files as a building seen from above. What says stone is the interior:
    // facets that catch what little light there is, crevices that catch none,
    // and a broken lit edge where the mass has come away.
    // Built once per still-layer repaint, so their run caches survive frames.
    // The buildings, pillars and gantries are shorter than the stone, so their
    // shadows are, and they go down first because the stone stands over them all.
    var builtShade = upright.length ? $3c042d4e8c9507db$export$d8acf7b29b621d22(upright) : null;
    var rockShade = $3c042d4e8c9507db$export$113936d15000c5cd(lobes);
    $3c042d4e8c9507db$var$overhead(g, T, function(g2, T2, fx) {
        // The shadows first: they darken the lit floor, and the stone then covers
        // the end of its own. Skipped entirely when the tile is nowhere near a
        // shaft, which is most of them — a sublevel is dark, and a shadow with no
        // light to cast it is just a smudge.
        if (builtShade) builtShade(g2, T2, fx);
        rockShade(g2, T2, fx);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = face[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step.value, 4), x = _step_value[0], y = _step_value[1], w = _step_value[2], h = _step_value[3];
                g2.r(x, y, w, h, T2.structDark);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = deep[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var _step_value1 = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step1.value, 4), x1 = _step_value1[0], y1 = _step_value1[1], w1 = _step_value1[2], h1 = _step_value1[3];
                g2.r(x1, y1, w1, h1, $3c042d4e8c9507db$var$shade(T2.structDark, 0.6));
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        g2.a(0.5, function() {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = facets[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step.value, 4), x = _step_value[0], y = _step_value[1], w = _step_value[2], light = _step_value[3];
                    g2.r(x, y, w, $3c042d4e8c9507db$var$ROCK_STEP, light ? T2.mass : T2.far);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        });
        g2.a(0.4, function() {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = face[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step.value, 3), x = _step_value[0], y = _step_value[1], w = _step_value[2];
                    if (w > 5) g2.r(x, y, w, 1, T2.mass);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        });
    });
}
var $3c042d4e8c9507db$export$a78a4d42e3d4c561 = {
    dust: function(g, rng, T) {
        var _loop = function(i1) {
            var dx = $3c042d4e8c9507db$var$ri(rng, 6, 100), dy = $3c042d4e8c9507db$var$ri(rng, 6, 114);
            g.a(0.08, function() {
                return g.r(dx, dy, $3c042d4e8c9507db$var$ri(rng, 9, 20), $3c042d4e8c9507db$var$ri(rng, 1, 2), T.structLight);
            });
        };
        for(var i = 0; i < 60; i++)g.a(0.12, function() {
            return g.r($3c042d4e8c9507db$var$ri(rng, 0, 118), $3c042d4e8c9507db$var$ri(rng, 0, 118), $3c042d4e8c9507db$var$ri(rng, 1, 3), 1, T.accent);
        });
        for(var i1 = 0; i1 < 6; i1++)_loop(i1);
    },
    vines: function(g, rng, T) {
        for(var i = 0; i < 4; i++){
            var edge = $3c042d4e8c9507db$var$ri(rng, 0, 3);
            var p = $3c042d4e8c9507db$var$ri(rng, 12, 105);
            var _ref = (0, $1788e2ed61915b1e$export$71511d61b312f219)(edge === 0 ? [
                p,
                3
            ] : edge === 1 ? [
                p,
                114
            ] : edge === 2 ? [
                3,
                p
            ] : [
                114,
                p
            ], 2), x = _ref[0], y = _ref[1];
            $3c042d4e8c9507db$var$foliageClump(g, rng, T, x, y, $3c042d4e8c9507db$var$ri(rng, 3, 5));
            // a runner trailing inward from the clump
            var rx = x, ry = y;
            for(var s = 0, n = $3c042d4e8c9507db$var$ri(rng, 8, 18); s < n; s++){
                rx += $3c042d4e8c9507db$var$ri(rng, -2, 2) + (x < 20 ? 1 : x > 100 ? -1 : 0);
                ry += $3c042d4e8c9507db$var$ri(rng, -2, 2) + (y < 20 ? 1 : y > 100 ? -1 : 0);
                g.r(rx, ry, 1, 1, T.veg1);
                if (s % 4 === 0) g.r(rx + $3c042d4e8c9507db$var$ri(rng, -1, 1), ry + $3c042d4e8c9507db$var$ri(rng, -1, 1), 1, 1, T.veg2);
            }
        }
        g.a(0.05, function() {
            return g.r(0, 0, $3c042d4e8c9507db$export$9e15ff8aa6bc996f, $3c042d4e8c9507db$export$9e15ff8aa6bc996f, T.veg2);
        });
    },
    flood: function(g, rng, T, recipe, ctx) {
        // A tile with no shoreline stamped on it — the image lab previewing a room
        // on its own, or a save written before the sea existed — gets the old
        // scattered standing water rather than nothing at all.
        if (recipe === 'water' || recipe === 'portal') return;
        if ((ctx === null || ctx === void 0 ? void 0 : ctx.shore) == null) $3c042d4e8c9507db$var$drawLakes(g, rng, T, $3c042d4e8c9507db$var$ri(rng, 1, 3));
        else $3c042d4e8c9507db$var$drawTide(g, rng, T, ctx);
        for(var i = 0; i < 24; i++)g.r($3c042d4e8c9507db$var$ri(rng, 6, 111), $3c042d4e8c9507db$var$ri(rng, 6, 111), $3c042d4e8c9507db$var$ri(rng, 1, 3), $3c042d4e8c9507db$var$ri(rng, 1, 2), T.rust);
    },
    // Rust is what happens to STEEL, so it goes on the steel. Scattered over the
    // whole tile it landed on grass, in sinkholes and across open chasms — which
    // reads as an orange filter over the region rather than as corrosion, and it
    // was the one thing making a foundry tile look painted rather than weathered.
    //
    // What is left on open ground is the oil: a yard that ran machinery for a
    // century has stains on its hardstanding, and those belong on the floor.
    rust: function(g, rng, T, recipe, ctx) {
        var steel = (0, $4c858c0d999a5b9b$export$71511d61b312f219)((ctx === null || ctx === void 0 ? void 0 : ctx.keep) || []).concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)((ctx === null || ctx === void 0 ? void 0 : ctx.props) || []));
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var _loop = function(i, n) {
                    var cx = b.x0 + $3c042d4e8c9507db$var$ri(rng, 2, Math.max(2, w - 2));
                    var cy = b.y0 + $3c042d4e8c9507db$var$ri(rng, 2, Math.max(2, h - 2));
                    var r = $3c042d4e8c9507db$var$ri(rng, 2, Math.max(2, Math.min(7, Math.min(w, h) >> 1)));
                    g.a(0.45, function() {
                        for(var j = 0, m = $3c042d4e8c9507db$var$ri(rng, 2, 4); j < m; j++){
                            var dx = cx + $3c042d4e8c9507db$var$ri(rng, -r, r), dy = cy + $3c042d4e8c9507db$var$ri(rng, -r, r);
                            // clipped to the structure — a bloom that spills off its own edge
                            // is back to being paint on the ground
                            var rr = Math.max(1, Math.min(r, dx - b.x0, b.x1 - dx, dy - b.y0, b.y1 - dy));
                            $3c042d4e8c9507db$var$disc(g, dx, dy, rr, T.rust);
                        }
                    });
                };
                var b = _step.value;
                var w = b.x1 - b.x0, h = b.y1 - b.y0;
                if (w < 6 || h < 6) return "continue";
                // Patches, not a wash: a few irregular blooms per structure, each a
                // cluster of overlapping discs so the outline is ragged.
                for(var i = 0, n = $3c042d4e8c9507db$var$ri(rng, 1, 3); i < n; i++)_loop(i, n);
                // and the streaks running down off it
                for(var i1 = 0, n1 = $3c042d4e8c9507db$var$ri(rng, 1, 3); i1 < n1; i1++)g.a(0.3, function() {
                    return g.r(b.x0 + $3c042d4e8c9507db$var$ri(rng, 0, Math.max(0, w - 4)), b.y1 - $3c042d4e8c9507db$var$ri(rng, 0, 2), $3c042d4e8c9507db$var$ri(rng, 2, 5), 1, T.rust);
                });
            };
            for(var _iterator = steel[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        // Oil on the hardstanding, wherever the ground is open.
        for(var i = 0, n = $3c042d4e8c9507db$var$ri(rng, 1, 2); i < n; i++)g.a(0.3, function() {
            return $3c042d4e8c9507db$var$disc(g, $3c042d4e8c9507db$var$ri(rng, 24, 93), $3c042d4e8c9507db$var$ri(rng, 24, 93), $3c042d4e8c9507db$var$ri(rng, 6, 10), T.structDark);
        });
    },
    dark: function(g, rng, T, recipe, ctx) {
        $3c042d4e8c9507db$var$drawRockMass(g, rng, T, ctx);
    }
};
// ===============================
// RENDERER (browser only)
// ===============================
// The game draws live tiles via drawRoomTile (see raidMapAnim.js); the
// static renderRoomImage below remains for the image lab's export tooling.
// ---- cloud cover ----
// Deterministic 2D noise. Clouds are sampled in WORLD coordinates (grid
// col/row * BASE + pixel), so every tile reads the same global cloud field
// and banks flow seamlessly across tile edges — no whole-map canvas needed.
function $3c042d4e8c9507db$var$hashBits(x, y) {
    var h = Math.imul(x, 374761393) + Math.imul(y, 668265263) | 0;
    h = Math.imul(h ^ h >>> 13, 1274126177);
    return (h ^ h >>> 16) >>> 0;
}
// 0..1 from the same bits. Daylight wells, shorelines and the lamp flicker
// all sample this and the value noise below; only the clouds moved on to
// gradient noise, so those are left exactly as they drew before.
function $3c042d4e8c9507db$var$noiseHash(x, y) {
    return $3c042d4e8c9507db$var$hashBits(x, y) / 4294967296;
}
function $3c042d4e8c9507db$var$smoothNoise(x, y) {
    var xi = Math.floor(x), yi = Math.floor(y);
    var fx = x - xi, fy = y - yi;
    var sx = fx * fx * (3 - 2 * fx), sy = fy * fy * (3 - 2 * fy);
    var a = $3c042d4e8c9507db$var$noiseHash(xi, yi), b = $3c042d4e8c9507db$var$noiseHash(xi + 1, yi);
    var c = $3c042d4e8c9507db$var$noiseHash(xi, yi + 1), d = $3c042d4e8c9507db$var$noiseHash(xi + 1, yi + 1);
    return a + (b - a) * sx + (c - a) * sy + (a - b - c + d) * sx * sy;
}
// Gradient (Perlin) noise, which the clouds use in place of the value noise
// above. Value noise interpolates four random HEIGHTS and the lattice
// survives it: features line up with the grid axes and a big bank comes out
// a bumpy quilt.
// Gradient noise interpolates four random DIRECTIONS through a quintic
// fade, which is the shape every cloud and terrain generator has been built
// on since Perlin '85. Four dot products dearer per sample, no more hashes.
// The eight gradients are the axes and diagonals — the classic set; using
// unnormalised diagonals is the standard cheat and costs nothing visible.
var $3c042d4e8c9507db$var$GRAD_X = [
    1,
    -1,
    1,
    -1,
    1,
    -1,
    0,
    0
];
var $3c042d4e8c9507db$var$GRAD_Y = [
    1,
    1,
    -1,
    -1,
    0,
    0,
    1,
    -1
];
function $3c042d4e8c9507db$var$gradDot(ix, iy, dx, dy) {
    var g = $3c042d4e8c9507db$var$hashBits(ix, iy) & 7;
    return $3c042d4e8c9507db$var$GRAD_X[g] * dx + $3c042d4e8c9507db$var$GRAD_Y[g] * dy;
}
// Returns ~0..1, centred on 0.5. Perlin's own range is roughly ±0.7 and
// bell-shaped rather than flat, so SPREAD sets how much of the 0..1 band it
// actually uses — it is what keeps the CLOUD_TYPES thresholds, which were
// authored against the old flat-ish value noise, meaning what they meant.
var $3c042d4e8c9507db$var$NOISE_SPREAD = 0.70;
function $3c042d4e8c9507db$var$gradNoise(x, y) {
    var xi = Math.floor(x), yi = Math.floor(y);
    var fx = x - xi, fy = y - yi;
    var u = fx * fx * fx * (fx * (fx * 6 - 15) + 10);
    var v = fy * fy * fy * (fy * (fy * 6 - 15) + 10);
    var n00 = $3c042d4e8c9507db$var$gradDot(xi, yi, fx, fy);
    var n10 = $3c042d4e8c9507db$var$gradDot(xi + 1, yi, fx - 1, fy);
    var n01 = $3c042d4e8c9507db$var$gradDot(xi, yi + 1, fx, fy - 1);
    var n11 = $3c042d4e8c9507db$var$gradDot(xi + 1, yi + 1, fx - 1, fy - 1);
    var a = n00 + (n10 - n00) * u;
    var b = n01 + (n11 - n01) * u;
    return 0.5 + $3c042d4e8c9507db$var$NOISE_SPREAD * (a + (b - a) * v);
}
// How far a cloud's shadow lands from the cloud itself, up and to the left
// of it, in WORLD units (a tile is WORLD across). Far enough that the shadow
// is a dark patch of its own rather than a rim around the bright one, close
// enough that it is still recognisably the same bank's shape — which means
// it is really a fraction of CLOUD_TYPES.scale, about half a feature, and
// wants moving if the presets are ever rescaled. The sun is a fixed
// direction here rather than the day's swinging shadowAngle: a shadow that
// swung round the compass over ten real minutes would draw the eye to the
// sky instead of the map. CLOUD_SHADOW_A scales the shadow off the
// cloud's own opacity — thicker cloud, darker ground — up to a ceiling that
// keeps a dense bank from blacking the tile out.
var $3c042d4e8c9507db$var$CLOUD_SHADOW_OFF = 50;
var $3c042d4e8c9507db$var$CLOUD_SHADOW_A = 1.5;
var $3c042d4e8c9507db$var$CLOUD_SHADOW_MAX = 0.34;
var $3c042d4e8c9507db$var$CLOUD_SHADOW_INK = '#0b1018';
// The sky is not one sheet. Three decks at different heights ride the same
// wind at different speeds, and it is that shear — banks sliding across each
// other, gaps opening and closing where they cross — that stops a drifting
// field from reading as one rigid texture towed over the map.
//   speed: multiplies the drift the caller integrates (1 = the wind it
//     thinks it is blowing, so the mid deck is the old single layer).
//   px/py: a fixed lead into the same noise field, so no two decks ever
//     show the same shape. Far larger than any preset's feature scale.
// Each deck is thresholded at a SHARE of the requested cover rather than
// all of it: three decks veiling a third of the sky each come out at the
// coverage one deck at full cover used to give. The share is not 1/3 — the
// decks overlap, and cover maps to a threshold on a bell-shaped noise
// distribution, not to an area — so it is calibrated, not derived.
var $3c042d4e8c9507db$var$CLOUD_DECKS = [
    {
        speed: 0.62,
        px: 0,
        py: 0
    },
    {
        speed: 1.00,
        px: 811.3,
        py: 517.7
    },
    {
        speed: 1.55,
        px: 269.1,
        py: 943.5
    }
];
var $3c042d4e8c9507db$var$CLOUD_DECK_SHARE = 0.65;
// Per-deck world offsets for the tile being drawn. Module scratch, not a
// fresh array per tile: one cloud pass runs at a time, and this is the
// hottest loop in the frame.
var $3c042d4e8c9507db$var$deckOx = new Float64Array($3c042d4e8c9507db$var$CLOUD_DECKS.length);
var $3c042d4e8c9507db$var$deckOy = new Float64Array($3c042d4e8c9507db$var$CLOUD_DECKS.length);
// The cloud field, resolved once per tile so the cloud pass and its shadow
// read the same noise. dx/dy shift where the field is SAMPLED, so a positive
// offset moves what is drawn the other way — see the call below.
function $3c042d4e8c9507db$var$cloudField(anim, tune) {
    var type = $3c042d4e8c9507db$export$ea4f1160001ec0c0[tune.cloudType] || $3c042d4e8c9507db$export$ea4f1160001ec0c0.scattered;
    // WORLD units, not the authoring grid: the noise scales are tuned in
    // them, and this loop is the single biggest per-frame cost in the game's
    // composite pass — following a finer art grid would multiply it by 9.
    // The tile's own world position is common to every deck; only the drift
    // is scaled, which is what makes one deck outrun another.
    var wx = (anim.col || 0) * $3c042d4e8c9507db$export$3d672f2aedd16af9, wy = (anim.row || 0) * $3c042d4e8c9507db$export$3d672f2aedd16af9;
    for(var i = 0; i < $3c042d4e8c9507db$var$CLOUD_DECKS.length; i++){
        var d = $3c042d4e8c9507db$var$CLOUD_DECKS[i];
        $3c042d4e8c9507db$var$deckOx[i] = wx - (anim.cloud.x || 0) * d.speed + d.px;
        $3c042d4e8c9507db$var$deckOy[i] = wy - (anim.cloud.y || 0) * d.speed + d.py;
    }
    return {
        type: type,
        thr: type.thr(anim.cloud.cover * $3c042d4e8c9507db$var$CLOUD_DECK_SHARE),
        sx: type.scale * type.stretch,
        sy: type.scale,
        morph: (anim.t || 0) * 0.05
    };
}
// How far the fine octave drags the coarse lookup, in coarse noise cells.
// This is domain warping: sampling the broad shape at a position that the
// detail octave has displaced. It is the cheapest trick in procedural
// texturing and the one that matters most here — summed octaves alone give
// lumpy blobs with the same lumpiness everywhere, while a warped lookup
// stretches, hooks and curls the edges the way moving air actually does.
// Free, because the octave doing the warping is one the field already pays
// for. Push it past ~1.2 and banks tear into filaments.
var $3c042d4e8c9507db$var$CLOUD_WARP = 0.75;
// Density at one point of the sky, already shaped into an alpha. 0 = clear.
// Each deck is two octaves warped by each other, the fine one's coordinates
// creeping with time so shapes slowly morph while the whole field drifts.
// The decks are combined as stacked translucency (what is left clear after
// all three) rather than painted one over another — identical result, since
// they share a colour, at one fill per cell instead of three.
function $3c042d4e8c9507db$var$cloudAlpha(f, x, y, dx, dy) {
    var clear = 1;
    for(var i = 0; i < $3c042d4e8c9507db$var$CLOUD_DECKS.length; i++){
        var wx = (x + dx + $3c042d4e8c9507db$var$deckOx[i]) / f.sx, wy = (y + dy + $3c042d4e8c9507db$var$deckOy[i]) / f.sy;
        var fine = $3c042d4e8c9507db$var$gradNoise(wx * 2.7 + 31.7 + f.morph, wy * 2.7 + 17.3);
        // the warp is stronger across than along, so banks shear rather than
        // just wobble — the two axes must differ or the whole field skews 45°
        var w = (fine - 0.5) * $3c042d4e8c9507db$var$CLOUD_WARP;
        var d = $3c042d4e8c9507db$var$gradNoise(wx + w, wy + w * 0.55) * 0.65 + fine * 0.35;
        if (d <= f.thr) continue;
        // smoothstep, not a linear ramp into a hard ceiling: the old profile put
        // a visible contour line wherever a bank hit full opacity
        var e = Math.min(1, (d - f.thr) * f.type.sharp / f.type.maxA);
        clear *= 1 - f.type.maxA * e * e * (3 - 2 * e);
    }
    return 1 - clear;
}
// anim.cloud = { cover: 0..1, x, y } — x/y are the accumulated drift offset
// (world px, integrated by the caller so gusty wind doesn't jitter the
// clouds). Two passes: the shadow the bank casts on the ground, then the
// bank itself, pale and thin over the top. The tile's own contents are what
// the shadow falls on, so the darkening is what sells the weather — the
// clouds alone read as fog laid over the map.
function $3c042d4e8c9507db$var$drawCloudLayer(g, anim, light, tune) {
    var _loop = function(y) {
        var _loop = function(x) {
            // sampled down-sun, so the shadow lands up and left of its own cloud
            var a = $3c042d4e8c9507db$var$cloudAlpha(f, x, y, $3c042d4e8c9507db$var$CLOUD_SHADOW_OFF, $3c042d4e8c9507db$var$CLOUD_SHADOW_OFF);
            if (a === 0) return "continue";
            g.a(Math.min($3c042d4e8c9507db$var$CLOUD_SHADOW_MAX, a * $3c042d4e8c9507db$var$CLOUD_SHADOW_A * light), function() {
                return g.p(x * $3c042d4e8c9507db$var$FX_PX, y * $3c042d4e8c9507db$var$FX_PX, scell, scell, $3c042d4e8c9507db$var$CLOUD_SHADOW_INK);
            });
        };
        for(var x = 0; x < $3c042d4e8c9507db$export$3d672f2aedd16af9; x += step)_loop(x);
    }, _loop1 = function(y1) {
        var _loop = function(x) {
            var alpha = $3c042d4e8c9507db$var$cloudAlpha(f, x, y1, 0, 0);
            if (alpha === 0) return "continue";
            g.a(alpha, function() {
                return g.p(x * $3c042d4e8c9507db$var$FX_PX, y1 * $3c042d4e8c9507db$var$FX_PX, cell, cell, color);
            });
        };
        for(var x = 0; x < $3c042d4e8c9507db$export$3d672f2aedd16af9; x += $3c042d4e8c9507db$export$a4097a0a1d4593d2)_loop(x);
    };
    var f = $3c042d4e8c9507db$var$cloudField(anim, tune);
    var cell = $3c042d4e8c9507db$export$a4097a0a1d4593d2 * $3c042d4e8c9507db$var$FX_PX;
    // Half resolution: a shadow is a soft dark patch with no edge to lose, so
    // this costs a quarter of the cloud pass rather than another one of it.
    // It scales with the light that casts it — by night the ground is dark
    // already and the mottling all but disappears.
    var step = $3c042d4e8c9507db$export$a4097a0a1d4593d2 * 2, scell = step * $3c042d4e8c9507db$var$FX_PX;
    for(var y = 0; y < $3c042d4e8c9507db$export$3d672f2aedd16af9; y += step)_loop(y);
    var l = Math.round(80 + 150 * light); // pale by day, near-dark by night
    var color = "rgb(".concat(l, ",").concat(l + 4, ",").concat(Math.min(255, l + 12), ")");
    for(var y1 = 0; y1 < $3c042d4e8c9507db$export$3d672f2aedd16af9; y1 += $3c042d4e8c9507db$export$a4097a0a1d4593d2)_loop1(y1);
}
// Dim and cool a palette toward night. light: 1 = full day, 0 = midnight.
// Blue dims less than red/green so nights read cold rather than gray, and
// glow is exempt entirely — handheld lights and fires pop after dark.
// Memoized per palette on a 1/512 light quantization: light sweeps a full
// day in 10 minutes, so each palette re-tints at most every ~1.2s instead
// of re-parsing every hex color on every tile draw (up to 119 tiles/frame).
// The 1/512 snap is far below a visible color step.
var $3c042d4e8c9507db$var$tintCache = new WeakMap(); // pal -> Map<bucket, tinted pal>
function $3c042d4e8c9507db$export$ff1cf6056aa7ef44(pal, light) {
    if (light >= 1) return pal;
    var bucket = Math.round(Math.max(0, light) * 512);
    var byBucket = $3c042d4e8c9507db$var$tintCache.get(pal);
    if (!byBucket) $3c042d4e8c9507db$var$tintCache.set(pal, byBucket = new Map());
    var cached = byBucket.get(bucket);
    if (cached) return cached;
    var q = bucket / 512;
    var out = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(pal)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step.value, 2), key = _step_value[0], hex = _step_value[1];
            if (key === 'glow') {
                out[key] = hex;
                continue;
            }
            var n = parseInt(hex.slice(1), 16);
            var r = Math.round((n >> 16 & 255) * (0.30 + 0.70 * q));
            var g = Math.round((n >> 8 & 255) * (0.34 + 0.66 * q));
            var b = Math.round((n & 255) * (0.50 + 0.50 * q));
            out[key] = "#".concat((r << 16 | g << 8 | b).toString(16).padStart(6, '0'));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (byBucket.size > 600) byBucket.clear(); // a day sweeps ~300 buckets
    byBucket.set(bucket, out);
    return out;
}
// Merged-tune cache for the game's static REGION_THEMES only - the image
// lab passes opts.theme and mutates its tune live, so that path recomputes
var $3c042d4e8c9507db$var$tuneCache = new WeakMap(); // theme -> merged tune
function $3c042d4e8c9507db$var$resolveTheme(regionKey, opts) {
    var theme = opts.theme || $3c042d4e8c9507db$export$d4f789780201d4a[regionKey] || $3c042d4e8c9507db$var$FALLBACK_THEME;
    if (opts.theme) return {
        theme: theme,
        tune: (0, $fa9769297b8a68c8$export$71511d61b312f219)({}, $3c042d4e8c9507db$export$6915278477114e25, theme.tune || {})
    };
    var tune = $3c042d4e8c9507db$var$tuneCache.get(theme);
    if (!tune) $3c042d4e8c9507db$var$tuneCache.set(theme, tune = (0, $fa9769297b8a68c8$export$71511d61b312f219)({}, $3c042d4e8c9507db$export$6915278477114e25, theme.tune || {}));
    return {
        theme: theme,
        tune: tune
    };
}
function $3c042d4e8c9507db$export$f7a259d7313a81f1(theme, tune, dayPhase) {
    if (dayPhase == null) return {
        light: 1,
        shadowAngle: tune.shadowAngle,
        shadowDist: 1.4,
        shadowAlpha: tune.shadowAlpha,
        lamp: 0
    };
    // 1. the raw daylight curve (15 hours of light, 9 hours of dark)
    var clamped = Math.max(0.4, Math.min(1, 0.4 + 0.85 * Math.cos((dayPhase - 0.5) * 2 * Math.PI)));
    // 2. smoothstep for a soft twilight and dawn fade
    var surface = clamped * clamped * (3 - 2 * clamped);
    // Sublevels get a faint ambient echo of the surface day: a floor so the dark
    // hours aren't pitch black, plus a slice of the normal brightness curve.
    // The floor was 0.06, which compounded with the night tint (x0.30 red at the
    // bottom of its range) and the darkness wash into a tile you could not read
    // at all — the region was distinguishable only by being black. The ceiling
    // MUST stay under 0.4: above it dayState switches on moving sun shadows, and
    // a sublevel that has no sun would start churning its cached still layer for
    // shadows it should never cast.
    var light = theme.backdrop === 'underground' ? 0.22 + 0.16 * surface : surface;
    var dayFrac = Math.min(1, Math.max(0, (dayPhase - 0.25) / 0.5)); // 06:00 -> 18:00
    var ds = {
        light: light,
        shadowAngle: 180 - dayFrac * 180,
        shadowDist: 0,
        shadowAlpha: tune.shadowAlpha,
        // powered lights ramp on as daylight fades below ~0.45 (dusk) and off
        // again at dawn; they never light in static daytime renders
        lamp: Math.min(1, Math.max(0, (0.45 - light) / 0.2))
    };
    if (light > 0.4) {
        ds.shadowDist = 1 + (tune.shadowLength - 1) * (1 - Math.sin(dayFrac * Math.PI)); // long at dawn/dusk, short at noon
        ds.shadowAlpha = (light - 0.4) / 0.6 * tune.shadowAlpha;
    }
    return ds;
}
function $3c042d4e8c9507db$export$8ee26169c9b5b8ee(light) {
    var q = Math.min(1, Math.max(0, light));
    return "rgb(".concat(Math.round(255 * (0.30 + 0.70 * q)), ",").concat(Math.round(255 * (0.34 + 0.66 * q)), ",").concat(Math.round(255 * (0.50 + 0.50 * q)), ")");
}
function $3c042d4e8c9507db$export$527771e9cfacbb46(ds) {
    var a = ds.shadowAngle * Math.PI / 180;
    return "".concat(Math.round(Math.cos(a) * ds.shadowDist), ",").concat(Math.round(Math.sin(a) * ds.shadowDist), ",").concat(Math.round(ds.shadowAlpha * 6));
}
function $3c042d4e8c9507db$var$setAnim(anim, ds, tune) {
    $3c042d4e8c9507db$var$ANIM = {
        wind: (anim === null || anim === void 0 ? void 0 : anim.wind) || 0,
        t: (anim === null || anim === void 0 ? void 0 : anim.t) || 0,
        lamp: ds.lamp,
        lightUptime: tune.lightUptime,
        lightSpeed: tune.lightFlickerSpeed,
        tintScale: ds.light * $3c042d4e8c9507db$var$TINT_STEPS
    };
}
// The tile itself: floor, roads, structures, weathering, growth. Identical
// for the one-shot and static paths — the only difference is whether
// dynamic() draws inline or records.
function $3c042d4e8c9507db$var$composeBody(g, T, theme, baseTune, regionKey, recipe, roomName, opts) {
    var _theme_recipes, _opts_anim, _opts_anim1, _opts_anim2, _opts_anim3, _opts_anim4;
    var conn = opts.conn || {
        n: true,
        e: true,
        s: true,
        w: true
    };
    // each drawing phase gets its own seeded stream: the shadow and content
    // passes below replay identical layouts from fresh copies of the same
    // stream, and no phase can perturb another's composition
    var phaseRng = function(phase) {
        return (0, $980f67465e309611$export$c0b222505a3369f3)("img|".concat(regionKey, "|").concat(roomName).concat(opts.salt || '', "|").concat(phase));
    };
    // A region may draw one of the shared recipes from its own layout instead:
    // a harbour's storage is a container yard, a foundry's is a silo farm. This
    // resolves ONLY the layout lookup — `recipe` itself stays the string it was,
    // because it is a classification key everywhere else in this file
    // (CLEARING_RECIPES, DENSITY_EXEMPT, RUIN_EXEMPT, PARKING_RECIPES, and the
    // `=== 'portal'` / `!== 'water'` tests in the effect and weathering passes).
    // Rewriting it here would quietly reclassify the tile as well as redraw it.
    var def = $3c042d4e8c9507db$export$a571935592b1ff4d[((_theme_recipes = theme.recipes) === null || _theme_recipes === void 0 ? void 0 : _theme_recipes[recipe]) || recipe] || $3c042d4e8c9507db$export$a571935592b1ff4d.infrastructure;
    var rng = phaseRng('floor');
    ($3c042d4e8c9507db$export$f4eeec8c0ee13647[theme.backdrop] || $3c042d4e8c9507db$export$f4eeec8c0ee13647.city)(g, rng, T);
    // The clearings lay their turf straight over the region floor, off their own
    // stream so the floor underneath stays byte-identical to every other tile's.
    if ($3c042d4e8c9507db$var$CLEARING_RECIPES.has(recipe)) $3c042d4e8c9507db$var$clearing(g, phaseRng('turf'), T, opts.clearing);
    var _opts_col, _ref, _baseTune_floodLevel;
    // The sea wall is TERRAIN — effectively where the map stops — so it goes down
    // with the ground and everything the tile is built of sits on top of it. Drawn
    // with the weathering, as it was, it laid concrete over roads and roofs, which
    // reads as a wall built straight through a street.
    if (theme.overlay === 'flood' && opts.shore === 0) $3c042d4e8c9507db$var$drawSeaWall(g, T, {
        shore: opts.shore,
        col: (_ref = (_opts_col = opts.col) !== null && _opts_col !== void 0 ? _opts_col : (_opts_anim = opts.anim) === null || _opts_anim === void 0 ? void 0 : _opts_anim.col) !== null && _ref !== void 0 ? _ref : 0
    }, Math.max(0.01, (_baseTune_floodLevel = baseTune.floodLevel) !== null && _baseTune_floodLevel !== void 0 ? _baseTune_floodLevel : 1), opts.shoreSide === 's' ? 's' : 'n');
    // Roads come from the generated network (opts.road), so only tiles the
    // network runs through draw one. The network is authoritative even over a
    // lake or a collapsed slab: those rooms are placed AFTER it is laid out, so
    // letting them suppress the roadway would punch gaps into a through route.
    //
    // The road is routed around the recipe's buildings, so it has to know where
    // they will land before it draws. A measuring pass runs the recipe against a
    // probe that draws nothing (makeProbeG) off a FRESH copy of the same stream
    // the real passes use, so what it measures is exactly what gets drawn. A
    // parking lot, gate, fence or pipeline is not measured — a road crossing one
    // of those is fine, and usually better.
    var isGate = opts.roomType === 'gate';
    // How much of the recipe's built stock this tile is entitled to. A tile the
    // roadway runs through is at distance 0 by definition, whatever a stale save
    // says, so the road itself is the authority when it is present.
    var thinnable = !$3c042d4e8c9507db$var$DENSITY_EXEMPT.has(recipe) && !isGate;
    var _opts_roadDist;
    var roadDist = opts.road ? 0 : (_opts_roadDist = opts.roadDist) !== null && _opts_roadDist !== void 0 ? _opts_roadDist : 0;
    var _opts_col1, _ref1, _opts_row, _ref2;
    // ...and how built-up its DISTRICT is, which the roadway knows nothing about.
    // A tile with no district — a save written before they existed, or the image
    // lab previewing a room on its own — gets none of this and is drawn exactly
    // as it was.
    var built = opts.zone ? $3c042d4e8c9507db$export$5553b5f9fd6fa0ba(opts.zone, (_ref1 = (_opts_col1 = opts.col) !== null && _opts_col1 !== void 0 ? _opts_col1 : (_opts_anim1 = opts.anim) === null || _opts_anim1 === void 0 ? void 0 : _opts_anim1.col) !== null && _ref1 !== void 0 ? _ref1 : 0, (_ref2 = (_opts_row = opts.row) !== null && _opts_row !== void 0 ? _opts_row : (_opts_anim2 = opts.anim) === null || _opts_anim2 === void 0 ? void 0 : _opts_anim2.row) !== null && _ref2 !== void 0 ? _ref2 : 0, opts.shore) : null;
    // Everything downstream — the measuring pass, the road's route around the
    // buildings, and the drawing itself — works off the tile's own scale, so it
    // has to be settled here, before any of it runs.
    var tune = $3c042d4e8c9507db$var$tuneForTile(baseTune, roadDist, opts.roadRank, built, thinnable);
    // One measuring pass, always: three separate things downstream need to know
    // what this recipe is about to put where — routing the road around it,
    // thinning it back by distance, and keeping the vegetation off its roofs.
    // It runs off a fresh copy of the content stream, so it rolls the same
    // variant the drawing passes will.
    var skip = new Set(), variant, shift = [], samples = null;
    var boxes = [];
    $3c042d4e8c9507db$var$runRecipe(def, g, phaseRng('content'), T, tune, conn, 0, 0, {
        record: boxes
    });
    if (opts.road) {
        var _opts_anim5, _opts_anim6;
        var _opts_row1, _opts_col2;
        // The road is routed by the tile's edges, not by what is on the tile, so it
        // can be laid before the recipe — and the recipe can then be laid to suit
        // it. The dead-end forms still want to know what is in the way first, which
        // is what the measurement above gives them.
        samples = $3c042d4e8c9507db$export$fa7182ef09b736f8(g, rng, T, opts.road, tune, boxes.filter(function(b) {
            return b.solid;
        }), (_opts_row1 = opts.row) !== null && _opts_row1 !== void 0 ? _opts_row1 : (_opts_anim5 = opts.anim) === null || _opts_anim5 === void 0 ? void 0 : _opts_anim5.row, (_opts_col2 = opts.col) !== null && _opts_col2 !== void 0 ? _opts_col2 : (_opts_anim6 = opts.anim) === null || _opts_anim6 === void 0 ? void 0 : _opts_anim6.col);
        var ref;
        // The layout pass re-measures per variant and returns the winner's own
        // boxes: a variant's element indices only mean anything within it.
        ref = $3c042d4e8c9507db$export$9de203fcc6e657de(def, function() {
            return phaseRng('content');
        }, T, tune, conn, samples || [], phaseRng('layout')), variant = ref.variant, shift = ref.shift, skip = ref.skip, boxes = ref.boxes, ref;
    } else if (thinnable) // Off the network the choice is free, and the same stream makes it, so a
    // tile that later gains a road does not also change hands.
    shift = $3c042d4e8c9507db$var$seededMirror(boxes, phaseRng('layout'));
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    // Thin the buildings back with distance from the roadway, on top of whatever
    // the road already suppressed. Suppression, not relocation: a structure that
    // was never built leaves its lot behind, which is the look we are after.
    if (thinnable) try {
        for(var _iterator = $3c042d4e8c9507db$export$b0ba4899f6951e17(boxes, roadDist, opts.roadRank, built)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var n = _step.value;
            skip.add(n);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Where the structures actually end up: measured footprints, moved to
    // wherever the layout put them, minus whatever was suppressed.
    var at = function() {
        return boxes.filter(function(b) {
            return !skip.has(b.n);
        }).map(function(b) {
            var _ref = (0, $1788e2ed61915b1e$export$71511d61b312f219)(shift[b.n] || [
                0,
                0
            ], 2), dx = _ref[0], dy = _ref[1];
            return (0, $715bf31211e65705$export$71511d61b312f219)((0, $fa9769297b8a68c8$export$71511d61b312f219)({}, b), {
                x0: b.x0 + dx,
                y0: b.y0 + dy,
                x1: b.x1 + dx,
                y1: b.y1 + dy
            });
        });
    };
    var placed = at();
    // Then walk them off the tile's own corners, so the map stops repeating on a
    // 120-unit rhythm. Landmarks sit it out for the same reason they sit out the
    // thinning: a portal facility or a rest stop is PLACED, and a placed thing
    // belongs where it was put.
    if (thinnable) {
        var moved = $3c042d4e8c9507db$var$placeStructures(placed, phaseRng('place'), samples);
        if (moved.size) {
            var _shift_n, _shift_n1;
            var before = $3c042d4e8c9507db$var$measureSizes(def, phaseRng('content'), T, tune, conn, variant, shift);
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = moved[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var _step_value = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step1.value, 2), n1 = _step_value[0], _step_value_ = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step_value[1], 2), dx = _step_value_[0], dy = _step_value_[1];
                    shift[n1] = [
                        (((_shift_n = shift[n1]) === null || _shift_n === void 0 ? void 0 : _shift_n[0]) || 0) + dx,
                        (((_shift_n1 = shift[n1]) === null || _shift_n1 === void 0 ? void 0 : _shift_n1[1]) || 0) + dy
                    ];
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            // Not every element is the same size wherever it stands: buildingTop
            // sizes itself against the tile edge, storefront against a line halfway
            // down. A structure that changed size is one whose drawn footprint is no
            // longer the one this pass cleared — bigger, and it lands on what it was
            // cleared of. Rather than teach the placement pass every clamp in the
            // element library, measure again and take back the offsets that moved a
            // size. An element's size depends only on its own position, so putting
            // one back restores it exactly and no second correction is needed.
            var after = $3c042d4e8c9507db$var$measureSizes(def, phaseRng('content'), T, tune, conn, variant, shift);
            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
            try {
                for(var _iterator2 = moved[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                    var _step_value1 = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step2.value, 2), n2 = _step_value1[0], _step_value_1 = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step_value1[1], 2), dx1 = _step_value_1[0], dy1 = _step_value_1[1];
                    if (after.get(n2) === before.get(n2)) continue;
                    shift[n2] = [
                        shift[n2][0] - dx1,
                        shift[n2][1] - dy1
                    ];
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                        _iterator2.return();
                    }
                } finally{
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
            placed = at();
        }
    }
    // What the vegetation, the ruins and the traffic have to grow around.
    var keepOut = placed.filter(function(b) {
        return b.solid;
    }).map(function(param) {
        var x0 = param.x0, y0 = param.y0, x1 = param.x1, y1 = param.y1;
        return {
            x0: x0,
            y0: y0,
            x1: x1,
            y1: y1
        };
    });
    var _def_treeDensity;
    // vegetation density: region knob x the recipe's own multiplier;
    // gates are dressed denser as major areas of interest
    var vegMult = tune.treeDensity * ((_def_treeDensity = def.treeDensity) !== null && _def_treeDensity !== void 0 ? _def_treeDensity : 1) * (isGate ? 1.7 : 1);
    // Returns the gate's extra block, which nothing else has measured, so the
    // growth can keep off it like it keeps off everything the recipe drew.
    var drawStructures = function(r) {
        $3c042d4e8c9507db$var$runRecipe(def, g, r, T, tune, conn, 0, 0, {
            skip: skip,
            variant: variant,
            shift: shift
        });
        return isGate ? $3c042d4e8c9507db$var$gateEmphasis(g, r, T, tune, conn, recipe, samples) : null;
    };
    // `extra` is everything drawn on this tile that the recipe did not measure —
    // a gate's dressing block and the signature props. Growth has to keep off all
    // of it, or you get a tree on a tower roof (see the gateEmphasis test).
    var drawVegetation = function(r, extra) {
        var more = (extra === null || extra === void 0 ? void 0 : extra.filter(Boolean)) || []; // a tile with no gate passes null
        return ($3c042d4e8c9507db$var$TD_VEGETATION[theme.backdrop] || $3c042d4e8c9507db$var$TD_VEGETATION.city)(g, r, T, vegMult, more.length ? (0, $4c858c0d999a5b9b$export$71511d61b312f219)(keepOut).concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)(more)) : keepOut);
    };
    // Ruins go down with the structures, not with the growth: they are what is
    // left of the same city, and vegetation is meant to reclaim them, so the
    // canopies come over the top afterwards. Rooms the map places whole sit them
    // out — a shaft, a lake, a rest stop or a portal facility is the tile.
    var drawRuinsPass = $3c042d4e8c9507db$var$RUIN_EXEMPT.has(recipe) ? function() {
        return [];
    } : function(r, lot) {
        return $3c042d4e8c9507db$var$drawRuins(g, r, T, tune, lot ? (0, $4c858c0d999a5b9b$export$71511d61b312f219)(keepOut).concat([
            lot
        ]) : keepOut, samples, opts.shore != null ? {
            at: opts.shore,
            side: opts.shoreSide
        } : null);
    };
    // The region's own architecture, and the only pass on the tile that is about
    // a particular place. It goes down AFTER the recipe (so it can see where the
    // buildings landed) and BEFORE the traffic, weathering and growth (which are
    // things that happen TO architecture, and must happen to this too).
    // Rooms the map places WHOLE sit the signature layer out, for exactly the
    // reason they sit the ruins out: a shaft, a lake, a rest stop or a portal
    // facility IS the tile, and a tower core or a colonnade standing in one is
    // the same mistake as a fresh ruin there. This is also what kept a tower's
    // debris skirt out of the collapsed ground it was landing in.
    var drawSignature = $3c042d4e8c9507db$var$RUIN_EXEMPT.has(recipe) ? function() {
        return [];
    } : function(r, ruins, gate) {
        var _opts_anim, _opts_anim1;
        var _opts_col, _ref, _opts_row, _ref1;
        return ($3c042d4e8c9507db$export$ecbd1adefe7cd5ab[theme.backdrop] || function() {
            return [];
        })(g, r, T, tune, {
            keep: (0, $4c858c0d999a5b9b$export$71511d61b312f219)(keepOut).concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)(ruins || []), (0, $4c858c0d999a5b9b$export$71511d61b312f219)(gate ? [
                gate
            ] : [])),
            samples: samples,
            conn: conn,
            col: (_ref = (_opts_col = opts.col) !== null && _opts_col !== void 0 ? _opts_col : (_opts_anim = opts.anim) === null || _opts_anim === void 0 ? void 0 : _opts_anim.col) !== null && _ref !== void 0 ? _ref : 0,
            row: (_ref1 = (_opts_row = opts.row) !== null && _opts_row !== void 0 ? _opts_row : (_opts_anim1 = opts.anim) === null || _opts_anim1 === void 0 ? void 0 : _opts_anim1.row) !== null && _ref1 !== void 0 ? _ref1 : 0,
            built: built,
            recipe: recipe,
            shore: opts.shore,
            shoreSide: opts.shoreSide,
            rail: opts.rail
        });
    };
    // Traffic sits against the roadway, so it needs the road's samples and the
    // rank they were drawn at. Tiles the network misses have neither and get none.
    // It also needs the lot: both hug the same band and the traffic draws last, so
    // without it a wreck lies across the bays of the car park it is parked beside.
    var drawTraffic = function(r, lot) {
        return $3c042d4e8c9507db$var$drawRoadside(g, r, T, samples, opts.roadRank, lot ? (0, $4c858c0d999a5b9b$export$71511d61b312f219)(keepOut).concat([
            lot
        ]) : keepOut);
    };
    // Parking goes down before the ruins so a ruin never lands on the lot, and
    // hands its footprint on for exactly that.
    var drawParkingPass = $3c042d4e8c9507db$var$PARKING_RECIPES.has(recipe) ? function(r) {
        return $3c042d4e8c9507db$var$drawParking(g, r, T, samples, keepOut);
    } : function() {
        return null;
    };
    // pass 1: every shadow lands on the bare ground first, so no object's
    // before the weathering overlay so dust and rust settle on it like anything
    // else. Its own 'anchor' stream keeps every other phase byte-identical to
    // what it drew before anchors existed, and means a skill rebalance changes
    // WHICH device a tile shows without moving WHERE it sits.
    var drawAnchor = function(r) {
        return $3c042d4e8c9507db$var$runAnchor(opts.primary, g, r, T, tune, conn, opts.indoor);
    };
    // pass 1: every shadow lands on the bare ground first, so no object's
    // shadow can fall across a neighboring object
    $3c042d4e8c9507db$var$SHADOW_PASS = true;
    var shadowLot = drawParkingPass(phaseRng('lot'));
    var shadowRuins = drawRuinsPass(phaseRng('ruin'), shadowLot);
    var shadowGate = drawStructures(phaseRng('content'));
    var shadowSig = drawSignature(phaseRng('signature'), shadowRuins, shadowGate);
    drawTraffic(phaseRng('traffic'), shadowLot);
    drawAnchor(phaseRng('anchor'));
    drawVegetation(phaseRng('veg'), [
        shadowGate
    ].concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)(shadowSig)));
    $3c042d4e8c9507db$var$SHADOW_PASS = false;
    // pass 2: the objects over their shadows — anchor off a FRESH copy of the
    // same stream, or it would pick a different corner than its shadow did
    var lot = drawParkingPass(phaseRng('lot'));
    var ruins = drawRuinsPass(phaseRng('ruin'), lot);
    var gate = drawStructures(phaseRng('content'));
    var sig = drawSignature(phaseRng('signature'), ruins, gate);
    drawTraffic(phaseRng('traffic'), lot);
    drawAnchor(phaseRng('anchor'));
    var _opts_col3, _ref3, _opts_row2, _ref4;
    // The weathering pass gets the same context the signature layer does, plus
    // the shoreline: the tide is weather in the sense that matters here — it
    // settles on top of what was built and under what has grown since.
    // `keep` is what the recipe built; `props` is what the signature layer added.
    // They are handed over separately because the two overlays that use them want
    // different things: the tide has to stay out of BOTH (a sea wall standing in
    // the sea is not holding anything back), while the rock mass only answers to
    // the recipe — a colonnade is inside the hall, and if pillars pushed the walls
    // away there would be no walls left anywhere.
    ($3c042d4e8c9507db$export$a78a4d42e3d4c561[theme.overlay] || $3c042d4e8c9507db$export$a78a4d42e3d4c561.dust)(g, phaseRng('overlay'), T, recipe, {
        keep: keepOut,
        props: sig.filter(Boolean),
        samples: samples,
        col: (_ref3 = (_opts_col3 = opts.col) !== null && _opts_col3 !== void 0 ? _opts_col3 : (_opts_anim3 = opts.anim) === null || _opts_anim3 === void 0 ? void 0 : _opts_anim3.col) !== null && _ref3 !== void 0 ? _ref3 : 0,
        row: (_ref4 = (_opts_row2 = opts.row) !== null && _opts_row2 !== void 0 ? _opts_row2 : (_opts_anim4 = opts.anim) === null || _opts_anim4 === void 0 ? void 0 : _opts_anim4.row) !== null && _ref4 !== void 0 ? _ref4 : 0,
        shore: opts.shore,
        shoreSide: opts.shoreSide,
        floodLevel: tune.floodLevel,
        enclosure: tune.enclosure,
        built: built
    });
    // vegetation content still renders after weathering: canopies overhang
    // it, and hollow-core's bioluminescent fungi must glow through the
    // darkness overlay (their shadows already went down in pass 1)
    drawVegetation(phaseRng('veg'), [
        gate
    ].concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)(sig)));
    // Hand the finished ground plan to whoever asked for one. Deliberately the
    // same list the vegetation keeps off — anything a tree may not grow on is
    // something a person may not stand on, and keeping the two answers identical
    // is what stops the map disagreeing with itself about where the ground is.
    //
    // Ruins are NOT in it: rubble is walkable, and half of it is ankle-high.
    if ($3c042d4e8c9507db$var$PLAN) {
        $3c042d4e8c9507db$var$PLAN.blocks = (0, $4c858c0d999a5b9b$export$71511d61b312f219)(keepOut).concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)(gate ? [
            gate
        ] : []), (0, $4c858c0d999a5b9b$export$71511d61b312f219)(sig.filter(Boolean))).map(function(param) {
            var x0 = param.x0, y0 = param.y0, x1 = param.x1, y1 = param.y1;
            return {
                x0: x0,
                y0: y0,
                x1: x1,
                y1: y1
            };
        });
        // The lake is a disc, not one of these boxes — see POND.
        $3c042d4e8c9507db$var$PLAN.water = recipe === 'water' ? (0, $fa9769297b8a68c8$export$71511d61b312f219)({}, $3c042d4e8c9507db$export$da8728cc680c21d8) : null;
        // What the tile is ABOUT, when it is about one thing. Only the campsite
        // has one so far: its fire ring is where a team that has stopped to rest
        // would actually sit, and it is dealt a different spot on every map, so
        // nothing downstream can assume where it is.
        var focus = placed.find(function(b) {
            return b.el === 'fireRing';
        });
        $3c042d4e8c9507db$var$PLAN.focus = focus ? {
            x: (focus.x0 + focus.x1) / 2,
            y: (focus.y0 + focus.y1) / 2
        } : null;
    }
}
// World-space effects, drawn over everything and never cached: they move
// every frame and are sampled by grid position so neighbouring tiles stay
// seamless. Cheap despite the tile size — both step in AUTHORING units, so
// their cell count is what it was at 40px.
function $3c042d4e8c9507db$var$drawEffects(g, T, theme, tune, ds, anim, recipe, opts) {
    var _anim_cloud;
    var _opts_col, _ref, _opts_row, _ref1;
    // daylight wells: cave openings overhead light whole areas of the map
    if (tune.lightRays > 0 && theme.backdrop === 'underground') $3c042d4e8c9507db$var$drawLightWells(g, T, tune, anim, (_ref = (_opts_col = opts.col) !== null && _opts_col !== void 0 ? _opts_col : anim === null || anim === void 0 ? void 0 : anim.col) !== null && _ref !== void 0 ? _ref : 0, (_ref1 = (_opts_row = opts.row) !== null && _opts_row !== void 0 ? _opts_row : anim === null || anim === void 0 ? void 0 : anim.row) !== null && _ref1 !== void 0 ? _ref1 : 0);
    // clouds pass over everything; the sublevels have no sky
    if ((anim === null || anim === void 0 ? void 0 : (_anim_cloud = anim.cloud) === null || _anim_cloud === void 0 ? void 0 : _anim_cloud.cover) > 0 && theme.backdrop !== 'underground') $3c042d4e8c9507db$var$drawCloudLayer(g, anim, ds.light, tune);
    // the portal's energy glow punches through flood, growth, and cloud
    if (recipe === 'portal') $3c042d4e8c9507db$var$portalGlow(g, T);
}
function $3c042d4e8c9507db$export$f0a8786a677b14c5(ctx, regionKey, recipe, roomName) {
    var opts = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
    var _resolveTheme = $3c042d4e8c9507db$var$resolveTheme(regionKey, opts), theme = _resolveTheme.theme, tune = _resolveTheme.tune;
    var anim = opts.anim;
    var ds = $3c042d4e8c9507db$export$f7a259d7313a81f1(theme, tune, anim === null || anim === void 0 ? void 0 : anim.dayPhase);
    var T = $3c042d4e8c9507db$export$ff1cf6056aa7ef44(theme.pal, ds.light);
    $3c042d4e8c9507db$var$setAnim(anim, ds, tune);
    $3c042d4e8c9507db$var$setShadowAngle(ds.shadowAngle, ds.shadowDist, ds.shadowAlpha);
    var g = $3c042d4e8c9507db$var$makeG(ctx);
    $3c042d4e8c9507db$var$DYN = null; // draw the animated parts inline
    $3c042d4e8c9507db$var$CUR_G = g;
    $3c042d4e8c9507db$var$CUR_T = T;
    // ...but the overhead channel is still RECORDED even here, because its whole
    // point is to land after the effects, and composeBody runs before them.
    var over = $3c042d4e8c9507db$var$OVER = [];
    $3c042d4e8c9507db$var$composeBody(g, T, theme, tune, regionKey, recipe, roomName, opts);
    $3c042d4e8c9507db$var$OVER = null;
    $3c042d4e8c9507db$var$drawEffects(g, T, theme, tune, ds, anim, recipe, opts);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = over[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var fn = _step.value;
            fn(g, T, $3c042d4e8c9507db$var$overheadFx(tune, anim, opts));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
/**
 * What an overhead closure is told about the frame it is being replayed into.
 *
 * The same handful of facts drawEffects works from, because anything drawn
 * above the effects generally has to agree with them about the light — the
 * rock's shadow is cast by the very shafts it is drawn over.
 */ var $3c042d4e8c9507db$var$overheadFx = function(tune, anim, opts) {
    var _anim_col, _ref, _anim_row, _ref1;
    return {
        tune: tune,
        anim: anim,
        col: (_ref = (_anim_col = anim === null || anim === void 0 ? void 0 : anim.col) !== null && _anim_col !== void 0 ? _anim_col : opts.col) !== null && _ref !== void 0 ? _ref : 0,
        row: (_ref1 = (_anim_row = anim === null || anim === void 0 ? void 0 : anim.row) !== null && _anim_row !== void 0 ? _anim_row : opts.row) !== null && _ref1 !== void 0 ? _ref1 : 0
    };
};
function $3c042d4e8c9507db$export$9b747065b14bfa5f(regionKey, recipe, roomName) {
    var opts = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var _resolveTheme = $3c042d4e8c9507db$var$resolveTheme(regionKey, opts), theme = _resolveTheme.theme, tune = _resolveTheme.tune;
    // `plan` is the tile's ground plan (see PLAN): where its buildings and its
    // water are, for anything that has to walk about on it. Filled by the first
    // refreshStatic, because it takes a full compose pass to know.
    return {
        regionKey: regionKey,
        recipe: recipe,
        roomName: roomName,
        opts: opts,
        theme: theme,
        tune: tune,
        canvas: null,
        dyn: [],
        over: [],
        key: null,
        plan: null
    };
}
function $3c042d4e8c9507db$export$ca17ef1db7f8dd8f(tile, dayPhase) {
    var ds = $3c042d4e8c9507db$export$f7a259d7313a81f1(tile.theme, tile.tune, dayPhase);
    var key = $3c042d4e8c9507db$export$527771e9cfacbb46(ds);
    if (key === tile.key) return false;
    if (!tile.canvas) {
        tile.canvas = document.createElement('canvas');
        tile.canvas.width = tile.canvas.height = $3c042d4e8c9507db$export$3175e1b22a5f59e8;
    }
    var g = $3c042d4e8c9507db$var$makeG(tile.canvas.getContext('2d'));
    $3c042d4e8c9507db$var$setAnim(null, ds, tile.tune);
    $3c042d4e8c9507db$var$setShadowAngle(ds.shadowAngle, ds.shadowDist, ds.shadowAlpha);
    var dyn = $3c042d4e8c9507db$var$DYN = [];
    var over = $3c042d4e8c9507db$var$OVER = [];
    // The plan does not depend on the hour, so it is only collected the first
    // time — a tile repaints a couple of dozen times a game day and the buildings
    // do not move between one and the next.
    var plan = $3c042d4e8c9507db$var$PLAN = tile.plan ? null : {
        blocks: [],
        water: null,
        focus: null
    };
    $3c042d4e8c9507db$var$CUR_G = null;
    $3c042d4e8c9507db$var$CUR_T = null;
    // UNTINTED: brightness is applied at composite time as a multiply
    $3c042d4e8c9507db$var$composeBody(g, tile.theme.pal, tile.theme, tile.tune, tile.regionKey, tile.recipe, tile.roomName, tile.opts);
    $3c042d4e8c9507db$var$DYN = null;
    $3c042d4e8c9507db$var$OVER = null;
    $3c042d4e8c9507db$var$PLAN = null;
    tile.dyn = dyn;
    tile.over = over;
    if (plan) tile.plan = plan;
    tile.key = key;
    return true;
}
function $3c042d4e8c9507db$export$217de4d82c975a34(ctx, tile, anim) {
    var ds = $3c042d4e8c9507db$export$f7a259d7313a81f1(tile.theme, tile.tune, anim === null || anim === void 0 ? void 0 : anim.dayPhase);
    var T = $3c042d4e8c9507db$export$ff1cf6056aa7ef44(tile.theme.pal, ds.light);
    ctx.globalAlpha = 1;
    ctx.globalCompositeOperation = 'source-over';
    ctx.drawImage(tile.canvas, 0, 0);
    if (ds.light < 1) {
        ctx.globalCompositeOperation = 'multiply';
        ctx.fillStyle = $3c042d4e8c9507db$export$8ee26169c9b5b8ee(ds.light);
        ctx.fillRect(0, 0, $3c042d4e8c9507db$export$3175e1b22a5f59e8, $3c042d4e8c9507db$export$3175e1b22a5f59e8);
        ctx.globalCompositeOperation = 'source-over';
    }
    $3c042d4e8c9507db$var$setAnim(anim, ds, tile.tune);
    $3c042d4e8c9507db$var$setShadowAngle(ds.shadowAngle, ds.shadowDist, ds.shadowAlpha);
    $3c042d4e8c9507db$var$SHADOW_PASS = false;
    $3c042d4e8c9507db$var$IN_SHADOW = false;
    $3c042d4e8c9507db$var$DYN = null;
    $3c042d4e8c9507db$var$OVER = null;
    var g = $3c042d4e8c9507db$var$makeG(ctx);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = tile.dyn[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var fn = _step.value;
            fn(g, T);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _anim_col, _anim_row;
    $3c042d4e8c9507db$var$drawEffects(g, T, tile.theme, tile.tune, ds, anim, tile.recipe, (0, $715bf31211e65705$export$71511d61b312f219)((0, $fa9769297b8a68c8$export$71511d61b312f219)({}, tile.opts), {
        col: (_anim_col = anim === null || anim === void 0 ? void 0 : anim.col) !== null && _anim_col !== void 0 ? _anim_col : tile.opts.col,
        row: (_anim_row = anim === null || anim === void 0 ? void 0 : anim.row) !== null && _anim_row !== void 0 ? _anim_row : tile.opts.row
    }));
    // ...and last of all, what is over the room rather than in it
    var fx = $3c042d4e8c9507db$var$overheadFx(tile.tune, anim, tile.opts);
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = tile.over[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var fn1 = _step1.value;
            fn1(g, T, fx);
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
}
function $3c042d4e8c9507db$export$9f394932e7372a96(regionKey, recipe, roomName) {
    var opts = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var out = document.createElement('canvas');
    out.width = $3c042d4e8c9507db$export$3175e1b22a5f59e8;
    out.height = $3c042d4e8c9507db$export$3175e1b22a5f59e8;
    $3c042d4e8c9507db$export$f0a8786a677b14c5(out.getContext('2d'), regionKey, recipe, roomName, opts);
    return out.toDataURL('image/png');
}


/**
 * World Clock — one planetary rotation, a local time for every TILE (M3 S9).
 *
 * The raid map already had a wall-clock day/night cycle, but it was a GLOBAL
 * one: every region shared a single `dayPhase`, so raiding the far east and the
 * far west showed the same sun. This promotes that cycle into a world clock.
 * There is still exactly one planet and one rotation — what changes is that
 * local time is derived from where you are standing on it.
 *
 * THE CLOCK IS KEYED TO TILES, NOT REGIONS. `getTilePhase({row, col})` is the
 * primitive; a region's clock is just its capital tile's, and a raid's clock is
 * just its site tile's. This costs nothing today (each region is one contiguous
 * blob, so its capital is a fair stand-in) and it is what stops the clock ever
 * having to be rewritten: the day a region is scattered across two hemispheres
 * — L6's world reseed, or simply a second Shard Cities on the far side — every
 * caller already asks about a place rather than about a name, and nothing here
 * has to change. Time and territory are separate facts about a tile.
 *
 * LONGITUDE COMES FROM THE MAP, NOT FROM A TABLE. A tile's longitude is its
 * COLUMN in `worldMap.js`, so geography and time cannot drift apart: move a
 * capital east and its clock moves with it. That is deliberate — see the header
 * of `js/data/worldMap.js`, which names this file as the reason it is
 * hand-authored and fixed. (L6's reseed inherits the coupling for free.)
 *
 * The planet rotates WEST TO EAST, so an eastern tile meets the sun first and
 * its local time runs AHEAD. `planetPhase()` is the time at the prime meridian
 * (the map's western edge); every local time is that plus a longitude offset.
 * The map is 17 columns wide and spans the whole planet, so the two outermost
 * capitals sit ~18 hours apart — the difference is meant to be dramatic.
 *
 * NO MECHANICAL EFFECT IN M3. Nothing here is read by a raid roll, a payout or
 * a check; it is time-of-day made visible while L3 calibrates. The full
 * day/night raid mechanic is L4 work, and it will read `getTilePhase` rather
 * than inventing a second clock.
 *
 * No browser dependencies.
 *
 * See docs/layers/3-syndicate/design.md §8.
 */ 


var $05f2074f6c82f4e0$export$fa2e89afea4272f6 = 600000;
// Where "now" sits in the cycle on first ship. Arbitrary — the world runs
// continuously either way — but it is part of the clock's definition, so it
// lives with the clock.
var $05f2074f6c82f4e0$var$PHASE_OFFSET = 0.35;
var $05f2074f6c82f4e0$export$675fe0ed743a3b5 = 0.25;
var $05f2074f6c82f4e0$export$1ec997190f8239d2 = 0.75;
var $05f2074f6c82f4e0$export$8f9a7291e7690131 = 0.0625;
function $05f2074f6c82f4e0$export$45255f3db062a699() {
    var now = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Date.now();
    return (now / $05f2074f6c82f4e0$export$fa2e89afea4272f6 + $05f2074f6c82f4e0$var$PHASE_OFFSET) % 1;
}
function $05f2074f6c82f4e0$export$45596f28e35b9f51(col) {
    var width = $979b99378be707cd$export$e3c642cf362e5b0d.width;
    return (col + 0.5) / width % 1;
}
function $05f2074f6c82f4e0$export$bd93155bc5e87ed(tile) {
    return tile ? $05f2074f6c82f4e0$export$45596f28e35b9f51(tile.col) : null;
}
function $05f2074f6c82f4e0$export$36b939441d399160(regionId) {
    return $979b99378be707cd$export$e3c642cf362e5b0d.capitals[regionId] || null;
}
function $05f2074f6c82f4e0$export$3fc841c22b2803(regionId) {
    return $05f2074f6c82f4e0$export$bd93155bc5e87ed($05f2074f6c82f4e0$export$36b939441d399160(regionId));
}
// Terrain a raid can be sited on. Ocean is excluded because a raid happens on
// the ground, and `#` because it is the map's "nothing here" marker — the same
// land-only rule Operations already applies to staging points.
var $05f2074f6c82f4e0$var$RAID_TERRAIN = new Set([
    '.',
    '^'
]);
function $05f2074f6c82f4e0$export$97e2a9580a4aea8d(regionId) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_raidable = _ref.raidable, raidable = _ref_raidable === void 0 ? false : _ref_raidable;
    var _config_worldMap = $979b99378be707cd$export$e3c642cf362e5b0d, width = _config_worldMap.width, height = _config_worldMap.height, regionRows = _config_worldMap.regionRows, terrainRows = _config_worldMap.terrainRows, regionOrder = _config_worldMap.regionOrder;
    var tiles = [];
    for(var row = 0; row < height; row++)for(var col = 0; col < width; col++){
        var _regionRows_row, _terrainRows_row;
        if (regionOrder[(_regionRows_row = regionRows[row]) === null || _regionRows_row === void 0 ? void 0 : _regionRows_row[col]] !== regionId) continue;
        if (raidable && !$05f2074f6c82f4e0$var$RAID_TERRAIN.has((_terrainRows_row = terrainRows[row]) === null || _terrainRows_row === void 0 ? void 0 : _terrainRows_row[col])) continue;
        tiles.push({
            row: row,
            col: col
        });
    }
    return tiles;
}
function $05f2074f6c82f4e0$export$73436c04d978a296(regionId) {
    var rng = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Math.random;
    var tiles = $05f2074f6c82f4e0$export$97e2a9580a4aea8d(regionId, {
        raidable: true
    });
    if (!tiles.length) return $05f2074f6c82f4e0$export$36b939441d399160(regionId);
    return tiles[Math.floor(rng() * tiles.length)];
}
function $05f2074f6c82f4e0$export$e9c9190bc51f46a8(longitude) {
    var now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
    return ($05f2074f6c82f4e0$export$45255f3db062a699(now) + longitude) % 1;
}
function $05f2074f6c82f4e0$export$a16ed293100b6f71(phase) {
    return Math.max(0.4, Math.min(1, 0.4 + 0.85 * Math.cos((phase - 0.5) * 2 * Math.PI)));
}
function $05f2074f6c82f4e0$export$45f6af437d59d9ba(phase) {
    return ($05f2074f6c82f4e0$export$a16ed293100b6f71(phase) - 0.4) / 0.6;
}
function $05f2074f6c82f4e0$export$1f0424de551b57e2(phase) {
    var p = (phase % 1 + 1) % 1;
    if (p < $05f2074f6c82f4e0$export$675fe0ed743a3b5 || p >= $05f2074f6c82f4e0$export$1ec997190f8239d2) return 'night';
    if (p < $05f2074f6c82f4e0$export$675fe0ed743a3b5 + $05f2074f6c82f4e0$export$8f9a7291e7690131) return 'dawn';
    if (p >= $05f2074f6c82f4e0$export$1ec997190f8239d2 - $05f2074f6c82f4e0$export$8f9a7291e7690131) return 'dusk';
    return 'day';
}
var $05f2074f6c82f4e0$export$398c19453c5d1c47 = {
    night: "\uD83C\uDF19",
    dawn: "\uD83C\uDF05",
    day: "\u2600\uFE0F",
    dusk: "\uD83C\uDF07"
};
function $05f2074f6c82f4e0$export$f6001aa54a01efa(phase) {
    var p = (phase % 1 + 1) % 1;
    var totalMinutes = Math.floor(p * 1440);
    var h = Math.floor(totalMinutes / 60);
    var m = totalMinutes % 60;
    return "".concat(String(h).padStart(2, '0'), ":").concat(String(m).padStart(2, '0'));
}
function $05f2074f6c82f4e0$export$239629a81011f2a4(tile) {
    var now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
    var _tileLongitude;
    var longitude = (_tileLongitude = $05f2074f6c82f4e0$export$bd93155bc5e87ed(tile)) !== null && _tileLongitude !== void 0 ? _tileLongitude : 0;
    var phase = $05f2074f6c82f4e0$export$e9c9190bc51f46a8(longitude, now);
    var name = $05f2074f6c82f4e0$export$1f0424de551b57e2(phase);
    return {
        tile: tile || null,
        longitude: longitude,
        phase: phase,
        name: name,
        icon: $05f2074f6c82f4e0$export$398c19453c5d1c47[name],
        light: $05f2074f6c82f4e0$export$a16ed293100b6f71(phase),
        time: $05f2074f6c82f4e0$export$f6001aa54a01efa(phase)
    };
}
function $05f2074f6c82f4e0$export$30a7d07879d0db1d(regionId) {
    var now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
    return (0, $715bf31211e65705$export$71511d61b312f219)((0, $fa9769297b8a68c8$export$71511d61b312f219)({}, $05f2074f6c82f4e0$export$239629a81011f2a4($05f2074f6c82f4e0$export$36b939441d399160(regionId), now)), {
        regionId: regionId
    });
}
function $05f2074f6c82f4e0$export$e15059ad23f67dd4(regionId, site) {
    var now = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Date.now();
    return $05f2074f6c82f4e0$export$239629a81011f2a4(site || $05f2074f6c82f4e0$export$36b939441d399160(regionId), now);
}
function $05f2074f6c82f4e0$export$d728c3c4e18e092b() {
    var now = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Date.now();
    return Object.values($979b99378be707cd$export$e3c642cf362e5b0d.regionOrder).map(function(id) {
        return $05f2074f6c82f4e0$export$30a7d07879d0db1d(id, now);
    });
}


// Where the raid team IS while a raid runs, and how each member is standing.
//
// Pure geometry over the raid's own clock — no DOM, no canvas — so the whole
// motion model is testable headless. raidTeamAnim.js turns what this returns
// into pixels; raidMapAnim.js decides which tiles to draw it on.
//
// Two coordinate spaces, and they are easy to confuse:
//   GRID space — fractional (row, col) over the raid grid. 1 unit = one tile.
//                col is +x (right), row is +y (down), so a heading angle is
//                atan2(dRow, dCol) and screen-space rotation Just Works.
//   PARTY space — a member's offset from the party's own centre, in TILE
//                FRACTIONS (0.1 = a tenth of a tile edge). The caller scales
//                by whatever a tile is worth in pixels, so nothing in here
//                has to know that a tile canvas is 120px.
// Half a tile of walking. The party crosses a tile boundary in two of these —
// the second half of one room and the first half of the next — so ONE constant
// sets the walking speed everywhere on the map.
//
// It is tuned to the road: a road room's baseDuration is 10s and the clamp
// below turns that into a continuous 5s-per-half-tile traverse with no dwell
// at all. Gates and hazards run 60-120s, so they get the same 5s walk in, a
// long search, and the same 5s walk out. Rooms therefore differ in how long
// the team STAYS, never in how fast it moves — which is what makes a road read
// as a road rather than as a room the team happens to leave early.
var $00f2bfbf94a5f5a3$export$83960d63e81a8a78 = 5000;
// A room the team cannot cross at that pace in the time it lasts has no dwell
// phase at all: the two legs are squeezed until they meet and the team crosses
// without stopping. That is what a road IS — 10s against the ~10s it takes to
// walk a tile — and it is why road tiles need no special case anywhere here.
// How far a member has to walk from their place in the file to their post,
// when the tile does not say. Tiles vary a lot — a lakeside post is out on the
// bank, most posts are a stone's throw from the middle — so `partyAt` takes the
// real figure and this is only the fallback.
var $00f2bfbf94a5f5a3$var$SPREAD_TILES = 0.25;
/**
 * How long the team takes to fan out on arrival, and to gather back up before
 * leaving, for a spread of `tiles`.
 *
 * NOT a look-right number. It is the distance at the walking speed set above,
 * with the smoothstep's 1.5x peak factor allowed for, so **the fastest a member
 * ever moves while spreading out is the speed they walk at** — whatever the
 * tile asks them to spread across.
 *
 * It was a flat 1100ms, which put the peak at three and a half times walking
 * pace and read as three people being yanked apart. A flat figure large enough
 * for a lakeside post would have had the other tiles crawling instead. The
 * distance is the thing you can measure and the speed is the thing the eye
 * judges, so the duration is the one that gets to be derived.
 */ var $00f2bfbf94a5f5a3$var$settleFor = function(tiles) {
    return Math.max(0.02, tiles) / 0.5 * $00f2bfbf94a5f5a3$export$83960d63e81a8a78 * 1.5;
};
// ...and the spread happens while the party is STANDING STILL, in the dwell
// either side, rather than over the last stretch of the walk in. Overlapping
// the two added the walk's own velocity to the spread's, so the one moment the
// team was meant to settle was the moment it moved fastest.
var $00f2bfbf94a5f5a3$var$TAU = Math.PI * 2;
var $00f2bfbf94a5f5a3$var$clamp01 = function(v) {
    return v < 0 ? 0 : v > 1 ? 1 : v;
};
var $00f2bfbf94a5f5a3$var$mix = function(a, b, t) {
    return a + (b - a) * t;
};
// Smoothstep. Zero slope at both ends, which is the whole point: it is what
// keeps a blend from starting and stopping abruptly.
var $00f2bfbf94a5f5a3$var$smooth = function(t) {
    return t * t * (3 - 2 * t);
};
function $00f2bfbf94a5f5a3$export$3c05aaf71f141f73(a) {
    var x = a % $00f2bfbf94a5f5a3$var$TAU;
    if (x > Math.PI) x -= $00f2bfbf94a5f5a3$var$TAU;
    if (x <= -Math.PI) x += $00f2bfbf94a5f5a3$var$TAU;
    return x;
}
function $00f2bfbf94a5f5a3$export$91fbc6e5ab9ab0f5(a, b, t) {
    var d = (b - a) % $00f2bfbf94a5f5a3$var$TAU;
    if (d > Math.PI) d -= $00f2bfbf94a5f5a3$var$TAU;
    if (d < -Math.PI) d += $00f2bfbf94a5f5a3$var$TAU;
    return $00f2bfbf94a5f5a3$export$3c05aaf71f141f73(a + d * t);
}
function $00f2bfbf94a5f5a3$export$e35a622415b5919f(path, index, elapsedMs, durationMs) {
    var stage = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null;
    var n = (path === null || path === void 0 ? void 0 : path.length) || 0;
    if (!n) return {
        row: 0,
        col: 0,
        heading: 0,
        gait: 0,
        walking: false
    };
    var i = Math.max(0, Math.min(n - 1, index | 0));
    var A = path[i];
    var P = i > 0 ? path[i - 1] : null;
    var N = i + 1 < n ? path[i + 1] : null;
    var dur = Math.max(0, durationMs || 0);
    // A room the team has overstayed (the raid loop ticks at 1Hz, so a step can
    // be up to a second past due before the index flips) holds them at the seam
    // rather than extrapolating past it — walking on and then being yanked back
    // when the tick lands is worse than marching on the spot for a moment.
    var e = Math.max(0, Math.min(dur, elapsedMs || 0));
    // Where they gather, and therefore how far each leg of the crossing is.
    // On almost every tile this is the middle and both legs are half a tile,
    // which is the case every constant in here was tuned against.
    var anchor = stage === null || stage === void 0 ? void 0 : stage.anchor;
    var aRow = A.row + ((anchor === null || anchor === void 0 ? void 0 : anchor.y) || 0), aCol = A.col + ((anchor === null || anchor === void 0 ? void 0 : anchor.x) || 0);
    // Each leg is timed by its OWN length, so the pace is the same on a tile
    // the team walks straight across and one where it has to come round a lake.
    // A leg that will not fit in the room's own clock is scaled down with its
    // partner rather than on its own — a road's two halves have to keep meeting
    // in the middle, and that is what makes it a continuous traverse.
    var legIn = P ? Math.hypot(aRow - (A.row + P.row) / 2, aCol - (A.col + P.col) / 2) : 0;
    var legOut = N ? Math.hypot((A.row + N.row) / 2 - aRow, (A.col + N.col) / 2 - aCol) : 0;
    var wIn = legIn / $00f2bfbf94a5f5a3$var$WALK_SPEED, wOut = legOut / $00f2bfbf94a5f5a3$var$WALK_SPEED;
    if (wIn + wOut > dur && wIn + wOut > 0) {
        var squeeze = dur / (wIn + wOut);
        wIn *= squeeze;
        wOut *= squeeze;
    }
    // How long they actually stand on this tile, and how much of that each end
    // of it spends spreading out and gathering back up. A road's dwell is zero,
    // so its settle is zero and the team marches straight through in file —
    // still no road special case anywhere.
    var dwell = Math.max(0, dur - wIn - wOut);
    var _stage_spread;
    var settle = Math.min($00f2bfbf94a5f5a3$var$settleFor((_stage_spread = stage === null || stage === void 0 ? void 0 : stage.spread) !== null && _stage_spread !== void 0 ? _stage_spread : $00f2bfbf94a5f5a3$var$SPREAD_TILES), dwell / 2);
    // The two bearings this tile has: the one they arrive on and the one they
    // leave on. They differ wherever the path turns, and the whole tile has to
    // get from one to the other WITHOUT a step in it — see the dwell below.
    var inHeading = P ? Math.atan2(A.row - P.row, A.col - P.col) : null;
    var outHeading = N ? Math.atan2(N.row - A.row, N.col - A.col) : null;
    // ...so the team TURNS ACROSS THE TILE rather than pivoting at some instant
    // inside it. Interpolating over the whole step is what makes this continuous
    // everywhere at once: it leaves at `inHeading`, which is the bearing the
    // previous step arrived on, and reaches `outHeading` exactly as the next
    // step begins on it. A tile the path runs straight through has the two
    // equal and nothing rotates at all.
    //
    // Every earlier attempt pinned the turn to a phase boundary — arrival,
    // then the dwell — and each one moved the jump somewhere else instead of
    // removing it. A road has no dwell to hide a turn in, which is what finally
    // made that obvious.
    var row = aRow, col = aCol;
    var _ref;
    var heading = inHeading != null && outHeading != null ? $00f2bfbf94a5f5a3$export$91fbc6e5ab9ab0f5(inHeading, outHeading, dur > 0 ? e / dur : 1) : (_ref = outHeading !== null && outHeading !== void 0 ? outHeading : inHeading) !== null && _ref !== void 0 ? _ref : 0;
    var walking = false;
    // Marching unless they are standing still — see the settle ramps below.
    var gait = 1;
    if (wIn > 0 && e < wIn) {
        // walking in from the shared edge with the previous tile
        var k = e / wIn;
        row = $00f2bfbf94a5f5a3$var$mix((A.row + P.row) / 2, aRow, k);
        col = $00f2bfbf94a5f5a3$var$mix((A.col + P.col) / 2, aCol, k);
        walking = true;
    } else if (wOut > 0 && e >= dur - wOut) {
        // `>=` rather than `>` so the two walk windows TILE the duration when
        // the squeeze makes them meet in the middle — a road would otherwise
        // have a single frame of standing still at its exact midpoint.
        // walking out toward the shared edge with the next tile
        var k1 = (e - (dur - wOut)) / wOut;
        row = $00f2bfbf94a5f5a3$var$mix(aRow, (A.row + N.row) / 2, k1);
        col = $00f2bfbf94a5f5a3$var$mix(aCol, (A.col + N.col) / 2, k1);
        walking = true;
    } else if (settle > 0) {
        // Standing on the tile. They arrive in file and fan out over `settle`,
        // hold their posts, then gather back into file in time to leave — so
        // the formation only ever changes while the party's own centre is
        // still, and the walk's velocity is never added to the spread's.
        var into = e - wIn;
        gait = $00f2bfbf94a5f5a3$var$clamp01(into < settle ? 1 - into / settle : into > dwell - settle ? 1 - (dwell - into) / settle : 0);
    } else gait = 0; // a dwell too short to spread out in: just stand there
    return {
        row: row,
        col: col,
        heading: heading,
        gait: gait,
        walking: walking
    };
}
function $00f2bfbf94a5f5a3$export$340c4cb4c285ee0f(raid, now) {
    var _raid_roomStartTime, _ref;
    var start = (_ref = (_raid_roomStartTime = raid === null || raid === void 0 ? void 0 : raid.roomStartTime) !== null && _raid_roomStartTime !== void 0 ? _raid_roomStartTime : raid === null || raid === void 0 ? void 0 : raid.startTime) !== null && _ref !== void 0 ? _ref : now;
    var _raid_nextRoomTime;
    var end = (_raid_nextRoomTime = raid === null || raid === void 0 ? void 0 : raid.nextRoomTime) !== null && _raid_nextRoomTime !== void 0 ? _raid_nextRoomTime : start;
    return {
        elapsedMs: now - start,
        durationMs: Math.max(0, end - start)
    };
}
// ============================================================================
// SEARCH POSTS — where on a tile a member actually stands
// ============================================================================
// Until now the team searched from a slowly turning ring about the tile's
// centre, which is a shape, not a place: it put people on roofs, and on the
// water tile it put all three of them in the lake.
//
// A post is a spot on the tile that a person could really stand on, picked
// once per tile from the ground plan the renderer now publishes. Members walk
// out to their posts on arrival and potter about them until it is time to
// leave. Fixing the post rather than continuously projecting a moving ring out
// of the obstacles is the whole trick: a projection is discontinuous wherever
// the nearest way out of a building flips from one wall to another, and this
// animation has already been bitten twice by exactly that class of bug.
// How close to a wall or a waterline a post may sit. A figure is ~6px wide in
// a 120px tile, so this is a comfortable body's width clear of it.
var $00f2bfbf94a5f5a3$var$POST_CLEARANCE = 0.055;
// Rings the candidates are drawn from, as a fraction of the tile. Far enough
// apart to look like three people covering an area, near enough that the team
// still reads as a team. The rings widen when the inner ones are built over.
//
// The outermost is 0.42 for a specific reason: the lake's bank sits at 0.35 and
// a post needs POST_CLEARANCE beyond that, which leaves a walkable band from
// 0.405 to the 0.445 where a figure starts hanging into the next room. There
// is one ring's worth of dry land on a water tile and this is it. (Diagonally
// there is far more, and the golden-angle sweep finds it first.)
var $00f2bfbf94a5f5a3$var$POST_RINGS = [
    0.20,
    0.30,
    0.42
];
var $00f2bfbf94a5f5a3$var$POST_ANGLES = 16;
function $00f2bfbf94a5f5a3$export$210e317b6c4ae768(plan, tilePx) {
    if (!plan || !tilePx) return null;
    var f = function(v) {
        return v / tilePx - 0.5;
    };
    return {
        blocks: (plan.blocks || []).map(function(b) {
            return {
                x0: f(b.x0),
                y0: f(b.y0),
                x1: f(b.x1),
                y1: f(b.y1)
            };
        }),
        water: plan.water ? {
            cx: f(plan.water.cx),
            cy: f(plan.water.cy),
            r: plan.water.r / tilePx,
            bank: plan.water.bank / tilePx
        } : null,
        focus: plan.focus ? {
            x: f(plan.focus.x),
            y: f(plan.focus.y)
        } : null
    };
}
// How tightly the team gathers round a campfire. Close enough to be sharing
// it, far enough not to be standing in it.
var $00f2bfbf94a5f5a3$var$CAMP_RINGS = [
    0.085,
    0.125,
    0.17
];
function $00f2bfbf94a5f5a3$export$e09eea79f1e22a62(plan, x, y) {
    var clear = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $00f2bfbf94a5f5a3$var$POST_CLEARANCE;
    if (Math.abs(x) > 0.5 - clear || Math.abs(y) > 0.5 - clear) return false;
    var w = plan === null || plan === void 0 ? void 0 : plan.water;
    // The bank is walkable shingle; the water itself is not.
    if (w && Math.hypot(x - w.cx, y - w.cy) < w.bank + clear) return false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = ((plan === null || plan === void 0 ? void 0 : plan.blocks) || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var b = _step.value;
            if (x > b.x0 - clear && x < b.x1 + clear && y > b.y0 - clear && y < b.y1 + clear) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}
function $00f2bfbf94a5f5a3$export$1c385e8d618a62c3(count, plan) {
    var seed = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, opts = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var n = Math.max(0, count | 0);
    if (!n) return [];
    // Where the ring of candidates is centred, and how wide it runs. A camp
    // gathers round its fire; everywhere else works outward from the middle of
    // the tile. Same routine either way — the tile just says where and how far.
    var around = opts.around || {
        x: 0,
        y: 0
    };
    var rings = opts.rings || $00f2bfbf94a5f5a3$var$POST_RINGS;
    var _opts_spacing;
    var spacing = (_opts_spacing = opts.spacing) !== null && _opts_spacing !== void 0 ? _opts_spacing : [
        0.17,
        0.10,
        0
    ];
    var phase = seed % 360 / 360 * $00f2bfbf94a5f5a3$var$TAU;
    var taken = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var apart = _step.value;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = rings[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _loop = function(a) {
                        // Golden-angle order rather than sweeping round, so the first
                        // few candidates tried are already spread out
                        var ang = phase + a * 2.39996;
                        var x = around.x + Math.cos(ang) * radius, y = around.y + Math.sin(ang) * radius;
                        if (!$00f2bfbf94a5f5a3$export$e09eea79f1e22a62(plan, x, y)) return "continue";
                        if (taken.some(function(p) {
                            return Math.hypot(p.x - x, p.y - y) < apart;
                        })) return "continue";
                        taken.push({
                            x: x,
                            y: y,
                            radius: radius
                        });
                    };
                    var radius = _step1.value;
                    for(var a = 0; a < $00f2bfbf94a5f5a3$var$POST_ANGLES && taken.length < n; a++)_loop(a);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            if (taken.length >= n) return "break";
        };
        // A post has to be this far from the ones already taken. Relaxed if the
        // walkable ground is too tight to honour it — better crowded than nobody.
        for(var _iterator = spacing[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _ret = _loop();
            if (_ret === "break") break;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Nowhere at all would stand on: a tile built kerb to kerb. Fall back to
    // the ring the team used before any of this existed — being on a roof beats
    // being in a heap on one spot, and it cannot happen on a generated map.
    while(taken.length < n){
        var ang = phase + taken.length * 2.39996;
        taken.push({
            x: around.x + Math.cos(ang) * 0.115,
            y: around.y + Math.sin(ang) * 0.115,
            radius: 0.115
        });
    }
    return taken.slice(0, n);
}
function $00f2bfbf94a5f5a3$export$5c7563bc4285410(plan, count, seed, roomType) {
    // A campsite is the one room the team stops AT rather than searches. It
    // needs a fire to gather round; a save written before tiles had plans, or
    // a region that draws its rest stop some other way, falls back to an
    // ordinary search and looks exactly as it did before.
    var camping = roomType === 'campsite' && !!(plan === null || plan === void 0 ? void 0 : plan.focus);
    var posts = camping ? $00f2bfbf94a5f5a3$export$1c385e8d618a62c3(count, plan, seed, {
        around: plan.focus,
        rings: $00f2bfbf94a5f5a3$var$CAMP_RINGS,
        spacing: [
            0.075,
            0.05,
            0
        ]
    }) : $00f2bfbf94a5f5a3$export$1c385e8d618a62c3(count, plan, seed);
    var anchor = camping ? plan.focus : $00f2bfbf94a5f5a3$export$98f127b3f50724cc(plan);
    return {
        anchor: anchor,
        resting: camping,
        spread: $00f2bfbf94a5f5a3$export$f01814d0e31cb32b(posts, anchor),
        // Posts are places ON THE TILE; what a pose wants is an offset from the
        // party, and the anchor sits between the two. Rebased once here rather
        // than in every drawn frame.
        postOffsets: posts.map(function(p) {
            return {
                x: p.x - anchor.x,
                y: p.y - anchor.y
            };
        })
    };
}
function $00f2bfbf94a5f5a3$export$f01814d0e31cb32b(posts) {
    var anchor = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var ax = (anchor === null || anchor === void 0 ? void 0 : anchor.x) || 0, ay = (anchor === null || anchor === void 0 ? void 0 : anchor.y) || 0;
    var far = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = (posts || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var p = _step.value;
            far = Math.max(far, Math.hypot(p.x - ax, p.y - ay));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return far || $00f2bfbf94a5f5a3$var$SPREAD_TILES;
}
function $00f2bfbf94a5f5a3$export$98f127b3f50724cc(plan) {
    if ($00f2bfbf94a5f5a3$export$e09eea79f1e22a62(plan, 0, 0)) return {
        x: 0,
        y: 0
    };
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $00f2bfbf94a5f5a3$var$POST_RINGS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var radius = _step.value;
            var best = null;
            for(var a = 0; a < $00f2bfbf94a5f5a3$var$POST_ANGLES * 2; a++){
                var ang = a / ($00f2bfbf94a5f5a3$var$POST_ANGLES * 2) * $00f2bfbf94a5f5a3$var$TAU;
                var x = Math.cos(ang) * radius, y = Math.sin(ang) * radius;
                if (!$00f2bfbf94a5f5a3$export$e09eea79f1e22a62(plan, x, y)) continue;
                // The shallowest way out: whichever direction reaches ground first
                if (!best || Math.hypot(x, y) < Math.hypot(best.x, best.y)) best = {
                    x: x,
                    y: y
                };
            }
            if (best) return best;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        x: 0,
        y: 0
    }; // nowhere to stand at all; see searchPosts
}
// Tiles per millisecond, from the one constant that sets the pace.
var $00f2bfbf94a5f5a3$var$WALK_SPEED = 0.5 / $00f2bfbf94a5f5a3$export$83960d63e81a8a78;
function $00f2bfbf94a5f5a3$export$5ae338d6b723c743(i, count, tSec, party) {
    var seed = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0, post = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null;
    // golden-angle spacing plus the seed: two members are never in step, and
    // the same member is in the same place every frame
    var ph = i * 2.39996 + seed % 997 * 0.0063;
    var _party_gait;
    // Eased rather than linear: the settle starts and ends at rest, so the
    // formation change reads as three people spreading out rather than three
    // people being slid into place at a constant rate.
    var gait = $00f2bfbf94a5f5a3$var$smooth($00f2bfbf94a5f5a3$var$clamp01((_party_gait = party === null || party === void 0 ? void 0 : party.gait) !== null && _party_gait !== void 0 ? _party_gait : 0));
    var _party_heading;
    var heading = (_party_heading = party === null || party === void 0 ? void 0 : party.heading) !== null && _party_heading !== void 0 ? _party_heading : 0;
    // --- marching: single file, staggered a little off the centreline so the
    // one behind is not hidden by the one in front. Authored in the party's
    // own frame (forward/right) and rotated into grid space below.
    var rank = Math.floor((i + 1) / 2);
    var mf = -0.085 * rank;
    var mr = i === 0 ? 0 : 0.05 * (i % 2 ? -1 : 1);
    var c = Math.cos(heading), s = Math.sin(heading);
    var mx = mf * c - mr * s;
    var my = mf * s + mr * c;
    // --- searching: their post, with a small amount of shifting about on it.
    // The wander is a fraction of the clearance a post is chosen with, so
    // pottering can never carry anyone into the wall they are standing beside.
    var px = post ? post.x : Math.cos(ph + tSec * 0.10) * 0.115;
    var py = post ? post.y : Math.sin(ph + tSec * 0.10) * 0.115;
    var sx = px + 0.016 * Math.sin(tSec * 0.29 + ph);
    var sy = py + 0.016 * Math.sin(tSec * 0.23 + ph * 1.7);
    // The torch leads where they walk and sweeps where they search. The sweep
    // is centred on the way they face out of the tile's middle, so three
    // members between them cover the ground instead of all raking one corner.
    var sweep = Math.atan2(sy, sx) + Math.sin(tSec * 0.55 + ph) * 0.9;
    return {
        dx: $00f2bfbf94a5f5a3$var$mix(sx, mx, gait),
        dy: $00f2bfbf94a5f5a3$var$mix(sy, my, gait),
        facing: $00f2bfbf94a5f5a3$export$91fbc6e5ab9ab0f5(sweep, heading, gait),
        // a two-beat walk cycle, decaying to a slow shift of weight on the spot
        stride: gait * Math.sin(tSec * 5.6 + ph) + (1 - gait) * 0.16 * Math.sin(tSec * 0.9 + ph),
        gait: gait
    };
}



// The raid team, drawn on the map tile it is standing on.
//
// A figure is a pixel silhouette about 15px tall in a tile's own 120px space —
// roughly a tenth of the tile, which is several times life size against the
// buildings beside it. That is deliberate: a to-scale person on this map would
// be two pixels and would vanish at the 64-80px the cell is actually displayed
// at. These are map TOKENS that happen to be shaped like people, and the thing
// that actually reads at that size is not the body at all, it is the torch —
// a moving light on dark ground is legible when the figure holding it is not.
//
// Drawn by raidMapAnim.js AFTER composite(), which means after the day tint's
// multiply pass. Nothing here is darkened for us, so everything here darkens
// itself (see shade()) — otherwise the team would glow at midnight like the
// lit windows do, and lit windows are lit for a reason.

// Procedural, seeded character portraits.
//
// A front-facing pixel-art bust drawn from a single seeded PRNG: the same
// (seed, faction) always yields the same face, so a portrait can be derived
// from a character's identity and re-rolled at will — unlimited variety, no art
// assets. This mirrors the map-tile renderer (js/modules/roomImageGen.js): a
// stable string->PRNG (makePRNG) plus a tiny rect/disc drawing API
// (js/modules/pixelDraw.js) painting a small logical canvas that gets
// nearest-neighbour upscaled to display size.
//
// Authored on a fixed 64x64 logical grid (AVATAR_BASE). All feature values are
// rolled up front, in a fixed order, into a `feat` object; drawing then reads
// that object. Rolling before drawing means a disabled config toggle removes
// only its own feature instead of shifting every later rng draw, so toggling a
// knob in avatar-lab.html changes one thing at a time.




// Shared, tile-agnostic pixel-drawing primitives.
//
// These are lifted verbatim (minus the tile renderer's SHADOW_PASS bookkeeping)
// from js/modules/roomImageGen.js so that other pixel-art generators — the
// avatar portraits in avatarGen.js, for one — can reuse the same tiny rect/disc
// API without importing the whole map-tile renderer (region themes, recipes,
// animation loop). roomImageGen.js keeps its own copies for now; if these two
// ever diverge, reconcile here first. Deduping the tile renderer onto this
// module is a deliberate follow-up, kept out of scope to avoid touching the
// working map pipeline.
// makeG(ctx) -> a minimal drawing API over a 2D context.
//   g.r(x, y, w, h, color)  fill a rectangle (coords floored to whole pixels)
//   g.a(alpha, fn)          run fn with a temporary globalAlpha, then restore
// The context only needs fillStyle, fillRect and globalAlpha, so a lightweight
// recording stub works in tests where no real canvas exists.
function $ebbe444d7b37c3d1$export$a2661aea9d478234(ctx) {
    return {
        r: function(x, y, w, h, c) {
            ctx.fillStyle = c;
            ctx.fillRect(x | 0, y | 0, w | 0, h | 0);
        },
        a: function(alpha, fn) {
            ctx.globalAlpha = alpha;
            fn();
            ctx.globalAlpha = 1;
        }
    };
}
var $ebbe444d7b37c3d1$export$d0f79e97207f27e3 = function(rng, min, max) {
    return min + Math.floor(rng() * (max - min + 1));
};
function $ebbe444d7b37c3d1$export$56b4dd62e08af00e(g, cx, cy, r, c) {
    for(var dy = -r; dy <= r; dy++){
        var dx = Math.floor(Math.sqrt(r * r - dy * dy));
        g.r(cx - dx, cy + dy, 2 * dx + 1, 1, c);
    }
}
function $ebbe444d7b37c3d1$export$3c006493fcc1917a(g, cx, cy, r, c) {
    for(var dy = -r; dy <= r; dy++){
        var dx = Math.round(Math.sqrt(r * r - dy * dy));
        g.r(cx - dx, cy + dy, 1, 1, c);
        g.r(cx + dx, cy + dy, 1, 1, c);
    }
}
function $ebbe444d7b37c3d1$export$585177364ee175b7(g, rng, x, y, w, h, c1, c2) {
    var density = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : 0.2;
    g.r(x, y, w, h, c1);
    var n = Math.floor(w * h * density);
    for(var i = 0; i < n; i++)g.r(x + rng() * w, y + rng() * h, 1, 1, c2);
}
function $ebbe444d7b37c3d1$export$5c4c5253709c2db0(g, x, y, len, c) {
    g.r(x, y, len, 1, c);
}
function $ebbe444d7b37c3d1$export$77998c5980b7319b(g, x, y, len, c) {
    g.r(x, y, 1, len, c);
}
function $ebbe444d7b37c3d1$export$f09f4965d11229b7(srcCanvas, size, makeCanvas) {
    var out = makeCanvas(size, size);
    var octx = out.getContext("2d");
    octx.imageSmoothingEnabled = false;
    octx.drawImage(srcCanvas, 0, 0, size, size);
    return out;
}


var $9b7c6ba2608f0479$export$aaa4582620b40efc = 64; // authored logical resolution
var $9b7c6ba2608f0479$export$ba4617d152d9e9eb = 80; // default display px (the in-game avatar box)
var $9b7c6ba2608f0479$export$3a2c4b2c8c374a0f = {
    dominion: {
        bg1: "#2b3446",
        bg2: "#141a24",
        garb: "#3f4a5e",
        garbDark: "#28303f",
        accent: "#e0b45e",
        glow: "#7ec8ff"
    },
    veil: {
        bg1: "#433a5a",
        bg2: "#14111d",
        garb: "#3a2c52",
        garbDark: "#221836",
        accent: "#b98cff",
        glow: "#66f0e0"
    },
    wilders: {
        bg1: "#33301f",
        bg2: "#17160e",
        garb: "#4b3d29",
        garbDark: "#2e2519",
        accent: "#d8c9a0",
        glow: "#8fe37a"
    }
};
var $9b7c6ba2608f0479$var$SKIN_TONES = [
    "#f2cba3",
    "#e6b487",
    "#d69a6a",
    "#c07f4f",
    "#9c6238",
    "#7a4a2b",
    "#5a3720",
    "#f7d9bd"
];
var $9b7c6ba2608f0479$var$HAIR_COLORS = [
    "#1c1a19",
    "#241f1b",
    "#3a2a1e",
    "#4a3527",
    "#5e3a22",
    "#6b4a2c",
    "#836a3f",
    "#b89b6a",
    "#8a8f98",
    "#2f2a26"
];
// Uncommon / dyed hair colours — auburn, ginger, red, rose, purple, blue, teal,
// platinum, pink. Rare in random generation, always available in the creator.
var $9b7c6ba2608f0479$var$UNCOMMON_HAIR_COLORS = [
    "#7a3b2a",
    "#a64b2a",
    "#9c3a4a",
    "#b0555f",
    "#5a4a8c",
    "#3d6b8c",
    "#3f8a5f",
    "#d9d4cc",
    "#c77fbf"
];
var $9b7c6ba2608f0479$var$EYE_COLORS = [
    "#5b3a1e",
    "#3a2a18",
    "#3f5a3a",
    "#3a5570",
    "#5a5a62",
    "#2a2a2e"
];
var $9b7c6ba2608f0479$var$EARRING_STYLES = [
    "stud",
    "hoop",
    "drop"
];
// Gold, silver, then gemstone hues (ruby, sapphire, emerald, amethyst, rose).
var $9b7c6ba2608f0479$var$EARRING_COLORS = [
    "#e6c06a",
    "#cfd3db",
    "#c8384a",
    "#3f6fd0",
    "#3fa06a",
    "#9a6ad0",
    "#d65f95"
];
var $9b7c6ba2608f0479$var$HAIR_STYLES = [
    "bald",
    "buzz",
    "crop",
    "swept",
    "long",
    "topknot",
    "curly"
];
var $9b7c6ba2608f0479$var$FEMALE_HAIR_STYLES = [
    "long",
    "bob",
    "ponytail",
    "bun",
    "wavy",
    "curly"
];
var $9b7c6ba2608f0479$export$210f63acf4dbee61 = {
    vignette: 0,
    hairChance: 0.9,
    facialHairChance: 0.35,
    scarChance: 0.16,
    visorChance: 0.01,
    eyepatchChance: 0.05,
    glassesChance: 0.15,
    markingsChance: 0.26,
    earringChance: 0.12,
    sigilChance: 0.05,
    glowEyeDominion: 0.05,
    glowEyeVeil: 0.55,
    glowEyeWilders: 0.15,
    veilHoodChance: 0.4,
    femaleChance: 0.5,
    wildHairChance: 0.08
};
// Every editable feature, for building an avatar-creator UI. Types: bool; int
// (min/max); color (options = a suggested swatch pool); enum (options are plain
// values or [label, value] pairs). A field may carry get/set to map onto a
// different shape on the feature object — eyewear is stored as three booleans.
var $9b7c6ba2608f0479$var$ALL_HAIR_STYLES = (0, $4c858c0d999a5b9b$export$71511d61b312f219)(new Set((0, $4c858c0d999a5b9b$export$71511d61b312f219)($9b7c6ba2608f0479$var$HAIR_STYLES).concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)($9b7c6ba2608f0479$var$FEMALE_HAIR_STYLES))));
var $9b7c6ba2608f0479$var$ACC = "Accessories & markings";
// Capitalize an internal value string for display without changing the value.
var $9b7c6ba2608f0479$var$titleOpt = function(v) {
    return [
        v.charAt(0).toUpperCase() + v.slice(1),
        v
    ];
};
var $9b7c6ba2608f0479$export$54d4f0a9b0c6e9b3 = [
    {
        group: "Face",
        key: "gender",
        type: "enum",
        label: "Gender",
        options: [
            [
                "Male",
                false
            ],
            [
                "Female",
                true
            ]
        ],
        get: function(f) {
            return !!f.female;
        },
        set: function(f, v) {
            f.female = v;
        }
    },
    {
        group: "Face",
        key: "skin",
        type: "color",
        label: "Skin",
        options: $9b7c6ba2608f0479$var$SKIN_TONES
    },
    {
        group: "Face",
        key: "faceW",
        type: "int",
        label: "Width",
        min: 14,
        max: 20
    },
    {
        group: "Face",
        key: "faceH",
        type: "int",
        label: "Height",
        min: 34,
        max: 46
    },
    {
        group: "Face",
        key: "jaw",
        type: "enum",
        label: "Jaw",
        options: [
            [
                "Round",
                0
            ],
            [
                "Square",
                1
            ],
            [
                "Narrow",
                2
            ]
        ]
    },
    {
        group: "Face",
        key: "shadeSide",
        type: "enum",
        label: "Light from",
        options: [
            [
                "Left",
                1
            ],
            [
                "Right",
                -1
            ]
        ]
    },
    {
        group: "Face",
        key: "mouthW",
        type: "int",
        label: "Mouth width",
        min: 3,
        max: 10
    },
    {
        group: "Face",
        key: "mouthCurve",
        type: "enum",
        label: "Mouth",
        options: [
            [
                "Frown",
                -1
            ],
            [
                "Neutral",
                0
            ],
            [
                "Smile",
                1
            ]
        ]
    },
    {
        group: "Hair",
        key: "hairStyle",
        type: "enum",
        label: "Style",
        options: $9b7c6ba2608f0479$var$ALL_HAIR_STYLES.map($9b7c6ba2608f0479$var$titleOpt)
    },
    {
        group: "Hair",
        key: "hairColor",
        type: "color",
        label: "Color",
        options: (0, $4c858c0d999a5b9b$export$71511d61b312f219)($9b7c6ba2608f0479$var$HAIR_COLORS).concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)($9b7c6ba2608f0479$var$UNCOMMON_HAIR_COLORS))
    },
    {
        group: "Hair",
        key: "hairline",
        type: "int",
        label: "Hairline",
        min: 4,
        max: 14
    },
    {
        group: "Hair",
        key: "facialHair",
        type: "enum",
        label: "Facial hair",
        options: [
            [
                "None",
                null
            ],
            [
                "Stubble",
                "stubble"
            ],
            [
                "Mustache",
                "mustache"
            ],
            [
                "Beard",
                "beard"
            ],
            [
                "Goatee",
                "goatee"
            ]
        ]
    },
    {
        group: "Eyes",
        key: "eyeColor",
        type: "color",
        label: "Color",
        options: $9b7c6ba2608f0479$var$EYE_COLORS
    },
    {
        group: "Eyes",
        key: "eyeGap",
        type: "int",
        label: "Spacing",
        min: 10,
        max: 18
    },
    {
        group: "Eyes",
        key: "eyeYoff",
        type: "int",
        label: "Height",
        min: -2,
        max: 2
    },
    {
        group: "Eyes",
        key: "gaze",
        type: "int",
        label: "Gaze",
        min: -1,
        max: 1
    },
    {
        group: "Eyes",
        key: "browRaise",
        type: "int",
        label: "Brow raise",
        min: 0,
        max: 3
    },
    {
        group: "Eyes",
        key: "browThick",
        type: "int",
        label: "Brow thickness",
        min: 1,
        max: 2
    },
    {
        group: "Eyes",
        key: "glowEye",
        type: "bool",
        label: "Glow eyes"
    },
    {
        group: $9b7c6ba2608f0479$var$ACC,
        key: "eyewear",
        type: "enum",
        label: "Eyewear",
        options: [
            [
                "None",
                "none"
            ],
            [
                "Visor",
                "visor"
            ],
            [
                "Glasses",
                "glasses"
            ],
            [
                "Eyepatch",
                "eyepatch"
            ]
        ],
        get: function(f) {
            return f.visor ? "visor" : f.glasses ? "glasses" : f.eyepatch ? "eyepatch" : "none";
        },
        set: function(f, v) {
            f.visor = v === "visor";
            f.glasses = v === "glasses";
            f.eyepatch = v === "eyepatch";
        }
    },
    {
        group: $9b7c6ba2608f0479$var$ACC,
        key: "glassesStyle",
        type: "enum",
        label: "Glasses style",
        options: [
            [
                "Clear",
                "clear"
            ],
            [
                "Sunglasses",
                "sun"
            ],
            [
                "Aviators",
                "aviator"
            ]
        ]
    },
    {
        group: $9b7c6ba2608f0479$var$ACC,
        key: "earrings",
        type: "enum",
        label: "Earrings",
        options: [
            [
                "None",
                "none"
            ],
            [
                "One",
                "1"
            ],
            [
                "Two",
                "2"
            ]
        ],
        get: function(f) {
            return f.earring ? f.earringBoth ? "2" : "1" : "none";
        },
        set: function(f, v) {
            f.earring = v !== "none";
            f.earringBoth = v === "2";
        }
    },
    {
        group: $9b7c6ba2608f0479$var$ACC,
        key: "earringStyle",
        type: "enum",
        label: "Earring style",
        options: $9b7c6ba2608f0479$var$EARRING_STYLES.map($9b7c6ba2608f0479$var$titleOpt)
    },
    {
        group: $9b7c6ba2608f0479$var$ACC,
        key: "earringColor",
        type: "color",
        label: "Earring color",
        options: $9b7c6ba2608f0479$var$EARRING_COLORS
    },
    {
        group: $9b7c6ba2608f0479$var$ACC,
        key: "scar",
        type: "bool",
        label: "Scar"
    },
    {
        group: $9b7c6ba2608f0479$var$ACC,
        key: "scarSide",
        type: "enum",
        label: "Scar side",
        options: [
            [
                "Left",
                -1
            ],
            [
                "Right",
                1
            ]
        ]
    },
    {
        group: $9b7c6ba2608f0479$var$ACC,
        key: "markings",
        type: "bool",
        label: "Markings"
    },
    {
        group: $9b7c6ba2608f0479$var$ACC,
        key: "markStyle",
        type: "enum",
        label: "Marking style",
        options: [
            [
                "Eye Stripes",
                0
            ],
            [
                "Cheek Dashes",
                1
            ],
            [
                "Forehead Mark",
                2
            ]
        ]
    },
    {
        group: $9b7c6ba2608f0479$var$ACC,
        key: "sigil",
        type: "bool",
        label: "Faction sigil"
    },
    {
        group: $9b7c6ba2608f0479$var$ACC,
        key: "hood",
        type: "bool",
        label: "Hood",
        factions: [
            "veil"
        ]
    }
];
// ---- colour helpers -------------------------------------------------------
var $9b7c6ba2608f0479$var$clamp255 = function(n) {
    return n < 0 ? 0 : n > 255 ? 255 : n | 0;
};
function $9b7c6ba2608f0479$var$hexToRgb(hex) {
    var n = parseInt(hex.slice(1), 16);
    return [
        n >> 16 & 255,
        n >> 8 & 255,
        n & 255
    ];
}
var $9b7c6ba2608f0479$var$rgbToHex = function(r, g, b) {
    return "#" + [
        r,
        g,
        b
    ].map(function(v) {
        return $9b7c6ba2608f0479$var$clamp255(v).toString(16).padStart(2, "0");
    }).join("");
};
// Multiply toward black (f<1) or white-ish (f>1) for cheap shading/highlights.
function $9b7c6ba2608f0479$var$shade(hex, f) {
    var _hexToRgb = (0, $1788e2ed61915b1e$export$71511d61b312f219)($9b7c6ba2608f0479$var$hexToRgb(hex), 3), r = _hexToRgb[0], g = _hexToRgb[1], b = _hexToRgb[2];
    return $9b7c6ba2608f0479$var$rgbToHex(r * f, g * f, b * f);
}
function $9b7c6ba2608f0479$var$lerpHex(a, b, t) {
    var _hexToRgb = (0, $1788e2ed61915b1e$export$71511d61b312f219)($9b7c6ba2608f0479$var$hexToRgb(a), 3), r1 = _hexToRgb[0], g1 = _hexToRgb[1], b1 = _hexToRgb[2], _hexToRgb1 = (0, $1788e2ed61915b1e$export$71511d61b312f219)($9b7c6ba2608f0479$var$hexToRgb(b), 3), r2 = _hexToRgb1[0], g2 = _hexToRgb1[1], b2 = _hexToRgb1[2];
    return $9b7c6ba2608f0479$var$rgbToHex(r1 + (r2 - r1) * t, g1 + (g2 - g1) * t, b1 + (b2 - b1) * t);
}
function $9b7c6ba2608f0479$var$pick(rng, arr) {
    return arr[Math.floor(rng() * arr.length)];
}
// Deterministic 0..1 value hash for position-based texture (no rng stream, so
// it never perturbs feature rolls).
function $9b7c6ba2608f0479$var$hash2(x, y) {
    var n = Math.sin(x * 12.9898 + y * 78.233) * 43758.5453;
    return n - Math.floor(n);
}
// ---- feature roll ---------------------------------------------------------
// Consume the rng in a FIXED order regardless of config, so toggles are local.
function $9b7c6ba2608f0479$var$rollFeatures(rng, faction, cfg) {
    var f = {};
    f.skin = $9b7c6ba2608f0479$var$pick(rng, $9b7c6ba2608f0479$var$SKIN_TONES);
    f.female = rng() < cfg.femaleChance;
    f.faceW = (0, $ebbe444d7b37c3d1$export$d0f79e97207f27e3)(rng, 16, 18); // half-width at the cheekbones (widest)
    f.faceH = (0, $ebbe444d7b37c3d1$export$d0f79e97207f27e3)(rng, 38, 42); // crown-to-chin height
    f.jaw = (0, $ebbe444d7b37c3d1$export$d0f79e97207f27e3)(rng, 0, 2); // 0 round, 1 square, 2 narrow
    f.shadeSide = rng() < 0.5 ? -1 : 1;
    // Both the presence check and the style pick always consume the rng (fixed
    // stream). Females always have hair and draw from a female style pool.
    var hairPresent = rng() < cfg.hairChance;
    var styleRoll = $9b7c6ba2608f0479$var$pick(rng, f.female ? $9b7c6ba2608f0479$var$FEMALE_HAIR_STYLES : $9b7c6ba2608f0479$var$HAIR_STYLES);
    f.hairStyle = f.female || hairPresent ? styleRoll : "bald";
    var wildHair = rng() < cfg.wildHairChance; // rolled + both pools picked always (fixed stream)
    var normalHair = $9b7c6ba2608f0479$var$pick(rng, $9b7c6ba2608f0479$var$HAIR_COLORS), wildHairCol = $9b7c6ba2608f0479$var$pick(rng, $9b7c6ba2608f0479$var$UNCOMMON_HAIR_COLORS);
    f.hairColor = wildHair ? wildHairCol : normalHair;
    f.hairline = (0, $ebbe444d7b37c3d1$export$d0f79e97207f27e3)(rng, 7, 11); // px of forehead the hair leaves bare
    f.eyeColor = $9b7c6ba2608f0479$var$pick(rng, $9b7c6ba2608f0479$var$EYE_COLORS);
    f.eyeYoff = (0, $ebbe444d7b37c3d1$export$d0f79e97207f27e3)(rng, -1, 1);
    f.eyeGap = (0, $ebbe444d7b37c3d1$export$d0f79e97207f27e3)(rng, 14, 16);
    f.gaze = (0, $ebbe444d7b37c3d1$export$d0f79e97207f27e3)(rng, -1, 1);
    f.browRaise = (0, $ebbe444d7b37c3d1$export$d0f79e97207f27e3)(rng, 0, 2);
    f.browThick = rng() < 0.4 ? 2 : 1;
    f.mouthW = (0, $ebbe444d7b37c3d1$export$d0f79e97207f27e3)(rng, 4, 8);
    f.mouthCurve = (0, $ebbe444d7b37c3d1$export$d0f79e97207f27e3)(rng, -1, 1); // -1 frown, 0 neutral, 1 smile
    var fhPresent = rng() < cfg.facialHairChance; // rolled + picked always (fixed stream)
    var fhStyle = $9b7c6ba2608f0479$var$pick(rng, [
        "stubble",
        "mustache",
        "beard",
        "goatee"
    ]);
    f.facialHair = !f.female && fhPresent ? fhStyle : null; // females: no facial hair
    f.scar = rng() < cfg.scarChance;
    f.scarSide = rng() < 0.5 ? -1 : 1;
    f.visor = rng() < cfg.visorChance;
    f.eyepatch = !f.visor && rng() < cfg.eyepatchChance;
    var glassesRoll = rng() < cfg.glassesChance; // rolled always so the stream stays fixed
    f.glasses = !f.visor && !f.eyepatch && glassesRoll; // one eyewear accessory at a time
    var gsRoll = rng();
    f.glassesStyle = gsRoll < 0.5 ? "clear" : gsRoll < 0.8 ? "sun" : "aviator"; // clear / sunglasses / aviator
    f.markings = rng() < cfg.markingsChance;
    f.markStyle = (0, $ebbe444d7b37c3d1$export$d0f79e97207f27e3)(rng, 0, 2);
    f.earring = rng() < cfg.earringChance * (f.female ? 2.5 : 1); // more common on females
    f.earringStyle = $9b7c6ba2608f0479$var$pick(rng, $9b7c6ba2608f0479$var$EARRING_STYLES);
    f.earringBoth = rng() < (f.female ? 0.6 : 0.2); // one or two earrings
    f.earringColor = $9b7c6ba2608f0479$var$pick(rng, $9b7c6ba2608f0479$var$EARRING_COLORS);
    f.sigil = rng() < cfg.sigilChance;
    var _faction;
    var glowChance = (_faction = ({
        dominion: cfg.glowEyeDominion,
        veil: cfg.glowEyeVeil,
        wilders: cfg.glowEyeWilders
    })[faction]) !== null && _faction !== void 0 ? _faction : 0.1;
    f.glowEye = rng() < glowChance;
    var hoodRoll = rng() < cfg.veilHoodChance; // rolled always so the stream stays fixed
    f.hood = faction === "veil" && hoodRoll; // only veil wears the head covering, and only sometimes
    return f;
}
// ---- layers ---------------------------------------------------------------
function $9b7c6ba2608f0479$var$drawBackground(g, pal, cfg) {
    // Vertical gradient bands (bg1 top -> bg2 bottom).
    for(var y = 0; y < $9b7c6ba2608f0479$export$aaa4582620b40efc; y++)g.r(0, y, $9b7c6ba2608f0479$export$aaa4582620b40efc, 1, $9b7c6ba2608f0479$var$lerpHex(pal.bg1, pal.bg2, y / $9b7c6ba2608f0479$export$aaa4582620b40efc));
    // Corner vignette.
    if (cfg.vignette > 0) {
        var _loop = function(_i, _iter) {
            var _iter__i = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_iter[_i], 2), cx = _iter__i[0], cy = _iter__i[1];
            g.a(cfg.vignette, function() {
                return (0, $ebbe444d7b37c3d1$export$56b4dd62e08af00e)(g, cx, cy, 22, v);
            });
        };
        var v = $9b7c6ba2608f0479$var$shade(pal.bg2, 0.5);
        for(var _i = 0, _iter = [
            [
                0,
                0
            ],
            [
                $9b7c6ba2608f0479$export$aaa4582620b40efc,
                0
            ],
            [
                0,
                $9b7c6ba2608f0479$export$aaa4582620b40efc
            ],
            [
                $9b7c6ba2608f0479$export$aaa4582620b40efc,
                $9b7c6ba2608f0479$export$aaa4582620b40efc
            ]
        ]; _i < _iter.length; _i++)_loop(_i, _iter);
    }
}
// A parametric skull silhouette shared by every layer: a rounded crown, roughly
// straight temples/cheeks (widest), then a jaw that tapers to the chin.
// faceHalf(y) returns the head's half-width at row y, so skin, hair, beard and
// cowl all trace the same outline. Authored to fill most of the 64px frame and
// crop the shoulders at the edges, matching the reference sprite busts.
function $9b7c6ba2608f0479$var$buildFaceHalf(headTop, headH, maxHalf, chinHalf, jaw) {
    return function(y) {
        var t = (y - headTop) / headH;
        if (t < 0 || t > 1) return 0;
        if (t < 0.3) {
            var tt = t / 0.3; // crown: elliptical dome
            return maxHalf * Math.sqrt(Math.max(0, 1 - (1 - tt) * (1 - tt)));
        }
        if (t < 0.58) return maxHalf; // temples + cheekbones (widest)
        var tt1 = (t - 0.58) / 0.42; // jaw -> chin
        if (jaw === 1) // square: hold width, then clip in near the bottom
        return tt1 < 0.72 ? maxHalf : Math.max(chinHalf, maxHalf - (maxHalf - chinHalf) * ((tt1 - 0.72) / 0.28));
        return maxHalf + (chinHalf - maxHalf) * (tt1 * tt1); // round/narrow: eased curve
    };
}
function $9b7c6ba2608f0479$var$makeGeom(f) {
    var cx = 32, headTop = 5, headH = f.faceH;
    // Females get a slightly narrower face and always use a soft, rounded jaw
    // profile (never the angular square). The jaw option still applies — it varies
    // the chin width: round (soft), square (fuller jaw), narrow (pointed / heart).
    var maxHalf = f.female ? f.faceW - 1 : f.faceW;
    var jaw = f.female ? 0 : f.jaw;
    var chinY = headTop + headH;
    var chinHalf = f.female ? Math.round(maxHalf * (f.jaw === 1 ? 0.56 : f.jaw === 2 ? 0.36 : 0.46)) : jaw === 2 ? Math.round(maxHalf * 0.42) // narrow
     : jaw === 1 ? Math.round(maxHalf * 0.62) // square
     : Math.round(maxHalf * 0.52); // round
    var faceHalf = $9b7c6ba2608f0479$var$buildFaceHalf(headTop, headH, maxHalf, chinHalf, jaw);
    // A 1px-inflated silhouette used to lay down a dark self-outline before skin.
    var outlineHalf = $9b7c6ba2608f0479$var$buildFaceHalf(headTop - 1, headH + 2, maxHalf + 1, chinHalf + 1, jaw);
    // Eyeline at ~half the head, with wider gaps down to the nose base and mouth so
    // the features fill the face instead of bunching in the lower-middle.
    var eyeY = Math.round(headTop + headH * 0.5) + f.eyeYoff;
    return {
        cx: cx,
        headTop: headTop,
        headH: headH,
        maxHalf: maxHalf,
        chinHalf: chinHalf,
        chinY: chinY,
        faceHalf: faceHalf,
        outlineHalf: outlineHalf,
        jaw: jaw,
        eyeY: eyeY,
        noseY: eyeY + 7,
        mouthY: eyeY + 14,
        hairlineY: headTop + f.hairline,
        neckHalf: Math.max(5, Math.round(chinHalf * 0.8)),
        shoulderTop: chinY + 5
    };
}
// Half-width of the veil hood — the head outline plus a margin, holding wide all
// the way down to the shoulders.
function $9b7c6ba2608f0479$var$makeHoodHalf(geom) {
    var top = geom.headTop - 4, span = geom.chinY + 8 - top, wide = geom.maxHalf + 5;
    return function(y) {
        var t = (y - top) / span;
        if (t < 0 || t > 1) return 0;
        if (t < 0.34) {
            var tt = t / 0.34;
            return wide * Math.sqrt(Math.max(0, 1 - (1 - tt) * (1 - tt)));
        }
        return wide;
    };
}
function $9b7c6ba2608f0479$var$drawBody(g, geom, rng, f, pal, faction) {
    var cx = geom.cx, shoulderTop = geom.shoulderTop;
    var gd = pal.garbDark, gl = $9b7c6ba2608f0479$var$shade(pal.garb, 1.16);
    var fold = $9b7c6ba2608f0479$var$shade(pal.garb, 0.68), foldLit = $9b7c6ba2608f0479$var$shade(pal.garb, 1.24);
    var inner = geom.neckHalf + 3, full = 40, drop = 0.45;
    // Sloped shoulders descending from the neck. topAt is the garment's top edge
    // per column, halfAt its half-width per row. (A fast sqrt curve used to flare
    // the shoulder tops up too high, near the jaw.) Drawing by column makes the
    // sloped top edge — and the detail that rides it — fall out for free.
    var topAt = function(x) {
        return shoulderTop + Math.round(drop * Math.max(0, Math.abs(x - cx) - inner));
    };
    var halfAt = function(y) {
        return Math.min(full, inner + (y - shoulderTop) / drop);
    };
    var edge = function(fn) {
        for(var x = cx - full; x <= cx + full; x++){
            var top = topAt(x);
            if (top < $9b7c6ba2608f0479$export$aaa4582620b40efc) fn(x, top, Math.abs(x - cx));
        }
    };
    // Fill by columns from the sloped top edge to the bottom. Overdraw one row past
    // the bottom edge so a breathing lift never exposes a gap there (clipped away).
    edge(function(x, top) {
        return g.r(x, top, 1, $9b7c6ba2608f0479$export$aaa4582620b40efc - top + 1, pal.garb);
    });
    // Collar rising up either side of the neck.
    g.r(cx - geom.neckHalf - 3, shoulderTop - 4, 3, 6, pal.garb);
    g.r(cx + geom.neckHalf, shoulderTop - 4, 3, 6, pal.garb);
    // Shading: highlight riding the shoulder edge, a centre-chest shadow, and
    // darker lower-outer corners, so the garment reads rounded not slab-flat.
    g.a(0.4, function() {
        return edge(function(x, top, dx) {
            if (dx >= inner) g.r(x, top, 1, 2, gl);
        });
    });
    g.a(0.22, function() {
        for(var y = shoulderTop + 4; y < $9b7c6ba2608f0479$export$aaa4582620b40efc; y++)g.r(cx - 3, y, 6, 1, gd);
    });
    g.a(0.35, function() {
        for(var y = shoulderTop + 8; y < $9b7c6ba2608f0479$export$aaa4582620b40efc; y++){
            var h = halfAt(y);
            g.r(cx - h, y, 5, 1, gd);
            g.r(cx + h - 5, y, 5, 1, gd);
        }
    });
    // Fabric weave: a deterministic speckle so cloth reads textured, not plastic —
    // a dark grain plus a sparser lit fleck.
    g.a(0.18, function() {
        return edge(function(x, top) {
            for(var y = top; y < $9b7c6ba2608f0479$export$aaa4582620b40efc; y++)if ($9b7c6ba2608f0479$var$hash2(x * 1.3, y * 2.1) > 0.86) g.r(x, y, 1, 1, gd);
        });
    });
    g.a(0.12, function() {
        return edge(function(x, top) {
            for(var y = top; y < $9b7c6ba2608f0479$export$aaa4582620b40efc; y++)if ($9b7c6ba2608f0479$var$hash2(x * 2.7, y * 1.1) < 0.07) g.r(x, y, 1, 1, gl);
        });
    });
    // Wrinkle creases fanning down-outward from the collar (short dark diagonals),
    // the readable, hand-placed counterpart to the random weave.
    g.a(0.3, function() {
        for(var _i = 0, _iter = [
            -1,
            1
        ]; _i < _iter.length; _i++){
            var sgn = _iter[_i];
            for(var _i1 = 0, _iter1 = [
                0,
                1,
                2
            ]; _i1 < _iter1.length; _i1++){
                var k = _iter1[_i1];
                var wx = cx + sgn * (inner + 1), wy = shoulderTop + 3 + k * 4;
                for(var j = 0; j < 6 - k; j++){
                    if (wy >= topAt(wx) && wy < $9b7c6ba2608f0479$export$aaa4582620b40efc) g.r(wx, wy, 1, 1, fold);
                    wx += sgn;
                    wy += 1;
                }
            }
        }
    });
    // Stacked fabric folds (dark crease + lit edge above), clamped inside the body.
    var folds = function(count, startY, spacing, w0, dw) {
        var _loop = function(i) {
            var y = startY + i * spacing, w = Math.min(halfAt(y) - 1, w0 + i * dw);
            for(var x = cx - w; x <= cx + w; x++){
                var t = (x - cx) / w;
                g.r(x, y + Math.round(2.2 * t * t), 1, 1, fold);
            }
            g.a(0.45, function() {
                for(var x = cx - w; x <= cx + w; x++){
                    var t = (x - cx) / w;
                    g.r(x, y + Math.round(2.2 * t * t) - 1, 1, 1, foldLit);
                }
            });
        };
        for(var i = 0; i < count; i++)_loop(i);
    };
    if (faction === "dominion") {
        // Stiff high collar, a zipper seam down the chest, gold neckline trim + stud.
        folds(1, shoulderTop + 5, 0, geom.neckHalf + 7, 0);
        g.a(0.7, function() {
            return g.r(cx - 1, shoulderTop + 2, 2, $9b7c6ba2608f0479$export$aaa4582620b40efc - shoulderTop, gd);
        }); // seam channel
        for(var y = shoulderTop + 3; y < $9b7c6ba2608f0479$export$aaa4582620b40efc; y += 2)g.r(cx, y, 1, 1, foldLit); // zipper teeth
        (0, $ebbe444d7b37c3d1$export$5c4c5253709c2db0)(g, cx - inner, shoulderTop, inner * 2, pal.accent); // collar trim across the neckline
        g.r(cx - 1, shoulderTop + 5, 3, 3, pal.accent); // stud
    } else if (faction === "veil") {
        // Layered scarf/cowl wraps — the signature veil look — plus one faint
        // asymmetric accent thread.
        folds(3, shoulderTop + 3, 3, geom.neckHalf + 5, 5);
        g.a(0.25, function() {
            for(var y = shoulderTop + 4; y < $9b7c6ba2608f0479$export$aaa4582620b40efc; y++)g.r(cx - 9 + (y - shoulderTop), y, 1, 1, pal.accent);
        });
    } else {
        // Wilders: ragged fur riding the sloped top edge, a diagonal leather strap,
        // one heavy fold, and a bone pendant.
        edge(function(x, top, dx) {
            if (dx < inner - 2) return;
            var jag = (0, $ebbe444d7b37c3d1$export$d0f79e97207f27e3)(rng, 0, 2);
            g.r(x, top + jag - 1, 1, 2, (0, $ebbe444d7b37c3d1$export$d0f79e97207f27e3)(rng, 0, 1) ? gd : gl);
        });
        folds(1, shoulderTop + 8, 0, geom.neckHalf + 8, 0);
        for(var i = 0; i < 16; i++){
            var x = cx - 10 + i, y1 = shoulderTop + 5 + i;
            if (y1 > topAt(x)) g.r(x, y1, 2, 1, $9b7c6ba2608f0479$var$shade(pal.garb, 0.58));
        } // strap
        (0, $ebbe444d7b37c3d1$export$77998c5980b7319b)(g, cx, shoulderTop + 5, 4, pal.accent);
        g.r(cx - 1, shoulderTop + 8, 3, 2, pal.accent); // bone pendant
    }
}
// Veil cowl framing — a hood BEHIND the head; the front rim is redrawn after
// hair so it sits over the crown and closes around the face.
function $9b7c6ba2608f0479$var$cowlBack(g, geom, pal) {
    var hood = $9b7c6ba2608f0479$var$makeHoodHalf(geom);
    for(var y = geom.headTop - 4; y <= geom.shoulderTop + 2; y++){
        var h = Math.round(hood(y));
        if (h > 0) g.r(geom.cx - h, y, 2 * h, 1, pal.garbDark);
    }
}
function $9b7c6ba2608f0479$var$cowlFront(g, geom, pal) {
    var cx = geom.cx;
    var hood = $9b7c6ba2608f0479$var$makeHoodHalf(geom);
    var shadow = $9b7c6ba2608f0479$var$shade(pal.garbDark, 0.75);
    for(var y = geom.headTop - 4; y <= geom.chinY; y++){
        var hh = Math.round(hood(y));
        if (hh <= 0) continue;
        if (y < geom.hairlineY) g.r(cx - hh, y, 2 * hh, 1, pal.garbDark); // hood over the crown
        else {
            var fh = Math.round(geom.faceHalf(y)) + 1; // frame the sides, leave the face open
            g.r(cx - hh, y, hh - fh, 1, pal.garbDark);
            g.r(cx + fh, y, hh - fh, 1, pal.garbDark);
        }
    }
    g.a(0.5, function() {
        return g.r(cx - geom.maxHalf, geom.hairlineY, geom.maxHalf * 2, 3, shadow);
    }); // brow shadow under the hood
}
function $9b7c6ba2608f0479$var$drawHead(g, geom, f) {
    var cx = geom.cx, headTop = geom.headTop, chinY = geom.chinY, faceHalf = geom.faceHalf, outlineHalf = geom.outlineHalf;
    var skin = f.skin;
    var base = skin;
    var shadow = $9b7c6ba2608f0479$var$shade(skin, 0.74); // shadow plane
    var deep = $9b7c6ba2608f0479$var$shade(skin, 0.56); // core shadows (sockets, under-jaw)
    var lit = $9b7c6ba2608f0479$var$shade(skin, 1.12); // lit plane
    var hi = $9b7c6ba2608f0479$var$shade(skin, 1.20); // highlight points (cheekbone, chin, brow ridge)
    var line = $9b7c6ba2608f0479$var$shade(skin, 0.42); // self-outline
    var s = f.shadeSide; // face lit from -s, shadowed toward +s
    var eyeY = geom.eyeY;
    var er = Math.round(faceHalf(eyeY + 1)); // cheekbone half-width, reused for shading below
    // Neck dropping from the chin into the collar, in shadow.
    var nh = geom.neckHalf;
    g.r(cx - nh - 1, chinY - 3, 1, geom.shoulderTop + 2 - (chinY - 3), line); // neck outline
    g.r(cx + nh, chinY - 3, 1, geom.shoulderTop + 2 - (chinY - 3), line);
    g.r(cx - nh, chinY - 3, nh * 2, geom.shoulderTop + 2 - (chinY - 3), shadow);
    g.r(cx - nh, chinY - 3, nh * 2, 2, deep); // under-jaw shadow
    // 1) Dark self-outline (inflated silhouette).
    for(var y = headTop - 1; y <= chinY + 1; y++){
        var h = Math.round(outlineHalf(y));
        if (h > 0) g.r(cx - h, y, 2 * h, 1, line);
    }
    // 2) Base skin.
    for(var y1 = headTop; y1 <= chinY; y1++){
        var h1 = Math.round(faceHalf(y1));
        if (h1 > 0) g.r(cx - h1, y1, 2 * h1, 1, base);
    }
    // 3) Shadow plane: a soft band along the shadow-side edge only (not half the
    // face) — the outer third, so most of the face stays base tone.
    for(var y2 = headTop + 1; y2 <= chinY; y2++){
        var h2 = Math.round(faceHalf(y2));
        if (h2 <= 1) continue;
        var w = Math.max(2, Math.round(h2 * 0.4));
        if (s > 0) g.r(cx + (h2 - w), y2, w, 1, shadow);
        else g.r(cx - h2, y2, w, 1, shadow);
    }
    // 4) Lit plane: a gentle highlight down the lit cheek/temple + nose bridge.
    g.a(0.5, function() {
        for(var y = geom.hairlineY + 1; y < eyeY; y++){
            var h = Math.round(faceHalf(y));
            g.r(s > 0 ? cx - h + 1 : cx + Math.round(h * 0.35), y, Math.round(h * 0.4), 1, lit);
        }
        g.r(s > 0 ? cx - er + 1 : cx + Math.round(er * 0.35), eyeY + 4, 3, 2, lit); // cheekbone
    });
    // 5) Under-cheek jaw shadow (eye sockets are shaded per-eye in drawFace).
    g.a(0.16, function() {
        for(var y = geom.mouthY; y <= chinY - 2; y++){
            var h = Math.round(faceHalf(y));
            if (h > 2) g.r(cx - h + 1, y, 2 * h - 2, 1, shadow);
        }
    });
    // 6) Ears: a vertical oval protruding from each side (brow-to-nose level). An
    // elliptical protrusion gives the rounded oval outline, an outer outline is the
    // helix, and an inner shadow curve is the concha bowl — so they read as ears,
    // not bumps. Hair/sideburns cover the tops.
    var earTop = eyeY - 1, earBot = geom.noseY;
    var earCy = (earTop + earBot) / 2, earHh = (earBot - earTop) / 2 + 0.6;
    for(var _i = 0, _iter = [
        -1,
        1
    ]; _i < _iter.length; _i++){
        var sgn = _iter[_i];
        var earSkin = sgn === s ? shadow : base;
        for(var y3 = earTop; y3 <= earBot; y3++){
            var edge = Math.round(faceHalf(y3));
            var nrm = (y3 - earCy) / earHh; // -1 top .. +1 bottom
            var prot = Math.round(3.2 * Math.sqrt(Math.max(0, 1 - nrm * nrm))); // ellipse -> rounded oval
            if (prot <= 0) continue;
            for(var k = 0; k < prot; k++)g.r(cx + sgn * (edge + k), y3, 1, 1, earSkin);
            g.r(cx + sgn * (edge + prot), y3, 1, 1, line); // outer helix outline
            g.r(cx + sgn * (edge - 1), y3, 1, 1, deep); // behind-ear (attach) shadow
            if (Math.abs(nrm) < 0.6 && prot >= 3) g.r(cx + sgn * (edge + 1), y3, 1, 1, deep); // concha bowl
        }
    }
    // 7) Facial contours (cheekbones, cheek hollows, brow ridge, chin, temples).
    $9b7c6ba2608f0479$var$drawContours(g, geom, f, {
        shadow: shadow,
        deep: deep,
        lit: lit,
        hi: hi
    });
}
// Local contour shading that gives the face form instead of a flat mask. All
// shapes are anchored to the same geometry and lit from -s (the shadow side is
// +s), so every portrait reads with one coherent light. Kept low-alpha and small
// so it sculpts without muddying.
function $9b7c6ba2608f0479$var$drawContours(g, geom, f, param) {
    var _loop = function(_i, _iter) {
        var sgn = _iter[_i];
        var cheekY = eyeY + 4;
        var cbx = cx + sgn * Math.round(faceHalf(cheekY) * 0.6);
        g.a(sgn === -s ? 0.55 : 0.3, function() {
            return g.r(cbx - 1, cheekY, 3, 2, hi);
        }); // cheekbone
        var hx = cx + sgn * Math.round(faceHalf(cheekY + 2) * 0.74);
        g.a(sgn === s ? 0.32 : 0.16, function() {
            for(var y = cheekY + 2; y < mouthY; y++){
                g.r(hx - (sgn < 0 ? 1 : 0), y, 2, 1, shadow);
                hx -= sgn; // curve inward toward the mouth
            }
        });
    };
    var shadow = param.shadow, deep = param.deep, lit = param.lit, hi = param.hi;
    var cx = geom.cx, eyeY = geom.eyeY, noseY = geom.noseY, mouthY = geom.mouthY, chinY = geom.chinY, hairlineY = geom.hairlineY, faceHalf = geom.faceHalf;
    var s = f.shadeSide;
    var mw = f.mouthW;
    // Brow-bone catch-light just above the brows (stronger on the lit side).
    g.a(0.45, function() {
        var w = Math.round(faceHalf(eyeY) * 0.55);
        g.r(s > 0 ? cx - w - 1 : cx + 2, eyeY - 4, w, 1, lit);
    });
    // Cheekbone highlight + a cheek hollow curving down toward the mouth corner.
    // The hollow is the main "this is a face, not a ball" cue; deeper on the shadow
    // side, hinted on the lit side.
    for(var _i = 0, _iter = [
        -1,
        1
    ]; _i < _iter.length; _i++)_loop(_i, _iter);
    // Temple hollow on the lit side (the shadow side is already covered by the
    // shadow plane) so the forehead reads rounded, not flat.
    g.a(0.2, function() {
        for(var y = hairlineY + 1; y < eyeY - 2; y++){
            var h = Math.round(faceHalf(y));
            g.r(s > 0 ? cx - h : cx + h - 2, y, 2, 1, shadow);
        }
    });
    // Philtrum (under-nose) soft shadow on the shadow side.
    g.a(0.22, function() {
        return g.r(cx + (s > 0 ? 0 : -2), noseY + 5, 2, 1, shadow);
    });
    // Under-lip crease + a lit chin ball below it.
    g.a(0.3, function() {
        return g.r(cx - (mw >> 1) + 1, mouthY + 2, mw - 2, 1, deep);
    });
    g.a(0.5, function() {
        return g.r(cx - 2, chinY - 2, 5, 2, hi);
    });
}
function $9b7c6ba2608f0479$var$drawHair(g, geom, f) {
    var _loop = function(y2) {
        var h = Math.round(hairHalf(Math.max(y2, headTop)));
        g.a(0.6, function() {
            return g.r(cx - Math.round(h * 0.5), y2, Math.round(h), 1, dark);
        }); // soft strand line
    };
    var anim = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    var cx = geom.cx, headTop = geom.headTop, chinY = geom.chinY, faceHalf = geom.faceHalf, hairlineY = geom.hairlineY, maxHalf = geom.maxHalf;
    if (f.hairStyle === "bald") {
        g.a(0.1, function() {
            return g.r(cx - 4, headTop + 4, 7, 3, $9b7c6ba2608f0479$var$shade(f.skin, 1.14));
        }); // scalp sheen
        return;
    }
    var col = f.hairColor, dark = $9b7c6ba2608f0479$var$shade(col, 0.66), line = $9b7c6ba2608f0479$var$shade(col, 0.45), lit = $9b7c6ba2608f0479$var$shade(col, 1.2);
    var s = f.shadeSide;
    // Wind rustle (idle animation): the loose hair leans horizontally, growing from
    // the roots (hairline) toward the tips, so it flutters rather than sliding as a
    // rigid block. sway(y) is 0 without a gust, so static output stays unchanged.
    var wind = (anim === null || anim === void 0 ? void 0 : anim.wind) || 0;
    var sway = wind === 0 ? function() {
        return 0;
    } : function(y) {
        return Math.round(wind * 2 * Math.min(1, Math.max(0, (y - hairlineY) / 26)));
    };
    // Darken a strand that falls on the shadow side (sign === s), so a drape over
    // the cheek carries the same side shadow as the face beneath it.
    var sideCol = function(sign, base) {
        return $9b7c6ba2608f0479$var$shade(base, sign === s ? 0.72 : 1);
    };
    var curly = f.hairStyle === "curly";
    // Hair is the head silhouette lifted up by `lift` and inflated by 1px, so the
    // crown is one smooth continuous dome (no pinch/gap at the apex) that sits just
    // outside the skin at the hairline.
    var lift = curly ? 3 : 2;
    var hairTop = headTop - lift;
    var hairProfile = $9b7c6ba2608f0479$var$buildFaceHalf(hairTop, geom.headH, maxHalf + 1, geom.chinHalf, geom.jaw);
    var hairHalf = function(y) {
        return hairProfile(y) + (curly && $9b7c6ba2608f0479$var$hash2(y, 7) > 0.55 ? 1 : 0);
    };
    // Solid crown: outline, fill, then a shadow-side plane like the skin.
    for(var y = hairTop; y <= hairlineY; y++){
        var h = Math.round(hairHalf(y));
        if (h <= 0) continue;
        g.r(cx - h - 1, y, 2 * h + 2, 1, line);
        g.r(cx - h, y, 2 * h, 1, col);
        var w = Math.max(2, Math.round(h * 0.4)); // shadow side
        if (s > 0) g.r(cx + h - w, y, w, 1, dark);
        else g.r(cx - h, y, w, 1, dark);
    }
    // Soft hairline shadow where the hair meets the forehead (one row, so it reads
    // as a hairline, not a hat brim).
    {
        var h1 = Math.round(hairHalf(hairlineY));
        if (h1 > 0) g.a(0.55, function() {
            return g.r(cx - h1, hairlineY, 2 * h1, 1, dark);
        });
    }
    // Small highlight patch on the lit side of the crown.
    g.a(0.5, function() {
        for(var y = hairTop + 1; y < headTop + 4; y++){
            var h = Math.round(hairHalf(y));
            g.r(s > 0 ? cx - Math.round(h * 0.75) : cx + Math.round(h * 0.35), y, Math.max(2, Math.round(h * 0.35)), 1, lit);
        }
    });
    // Restrained texture: a few dark strand clumps only (no scattered light pixels
    // — those read as noise). Curly gets a regular clump pattern.
    if (curly) for(var y1 = hairTop + 1; y1 < hairlineY; y1 += 2){
        var h2 = Math.round(hairHalf(Math.max(y1, headTop)));
        for(var x = cx - h2 + 1; x < cx + h2 - 1; x += 3)if ($9b7c6ba2608f0479$var$hash2(x, y1) > 0.5) g.r(x + ($9b7c6ba2608f0479$var$hash2(x, y1) > 0.75 ? 1 : 0), y1, 2, 1, dark);
    }
    else for(var y2 = hairTop + 2; y2 < hairlineY - 1; y2 += 3)_loop(y2);
    // Frame the face: hair descends the temples down to cheek level (drapes lower
    // for long hair), so it wraps the face instead of sitting as a flat cap.
    var bobBot = Math.round((geom.mouthY + chinY) / 2); // bob ends midway between mouth and chin
    var longDrape = f.hairStyle === "long" || f.hairStyle === "wavy";
    var coversEars = longDrape || f.hairStyle === "bob"; // longer styles reach out over the ears
    // The ear bulge eases in from the hairline and back out around the mouth, so
    // the widening is very gradual (peak ~3px near the ear centre).
    var earTop = hairlineY - 2, earBot = geom.mouthY + 2, earSpan = earBot - earTop;
    var frameBottom = f.hairStyle === "bob" ? bobBot : longDrape ? chinY - 2 : f.hairStyle === "buzz" ? hairlineY + 3 : geom.eyeY + 2;
    var sideW = f.female ? 4 : curly ? 4 : 3;
    for(var y3 = hairlineY - 1; y3 <= frameBottom; y3++){
        var _faceHalf;
        var h3 = Math.round((_faceHalf = faceHalf(Math.min(y3, chinY))) !== null && _faceHalf !== void 0 ? _faceHalf : 0) + 1;
        // A smooth bulge out over the ears — ramps gradually out and back in.
        var ext = coversEars && y3 >= earTop && y3 <= earBot ? Math.round(3.3 * Math.sin((y3 - earTop) / earSpan * Math.PI)) : 0;
        var sw = sway(y3);
        g.r(cx - h3 - 1 - ext + sw, y3, 1, 1, sideCol(-1, line));
        g.r(cx - h3 - ext + sw, y3, sideW + ext, 1, sideCol(-1, $9b7c6ba2608f0479$var$hash2(y3, 1) > 0.8 ? dark : col));
        g.r(cx + h3 - sideW + sw, y3, sideW + ext, 1, sideCol(1, $9b7c6ba2608f0479$var$hash2(y3, 2) > 0.8 ? dark : col));
        g.r(cx + h3 + ext + sw, y3, 1, 1, sideCol(1, line));
    }
    // Style-specific extras.
    switch(f.hairStyle){
        case "swept":
            {
                var dir = -s;
                for(var i = 0; i < maxHalf + 2; i++){
                    var x1 = cx - maxHalf * dir + i * dir;
                    g.r(x1, hairlineY - 2 + (i / 4 | 0), 2, 2, i % 3 ? col : dark);
                }
                break;
            }
        case "long":
        case "wavy":
            {
                var w1 = f.female ? 4 : 3, wavy = f.hairStyle === "wavy";
                for(var y4 = geom.eyeY - 1; y4 < chinY + 16; y4++){
                    var h4 = Math.round(faceHalf(Math.min(y4, chinY))) + 1;
                    var wob = wavy ? Math.max(0, Math.round(1.6 * Math.sin(y4 * 0.55))) : 0;
                    var c = $9b7c6ba2608f0479$var$hash2(y4, 3) > 0.82 ? dark : col, sw1 = sway(y4);
                    g.r(cx - h4 - 1 - wob + sw1, y4, w1, 1, sideCol(-1, c));
                    g.r(cx + h4 - w1 + 1 + wob + sw1, y4, w1, 1, sideCol(1, c));
                }
                break;
            }
        case "bob":
            for(var y5 = geom.eyeY - 2; y5 <= bobBot; y5++){
                var h5 = Math.round(faceHalf(Math.min(y5, chinY))) + 1;
                var inCurl = Math.max(0, y5 - (bobBot - 3));
                var c1 = $9b7c6ba2608f0479$var$hash2(y5, 3) > 0.85 ? dark : col, sw2 = sway(y5);
                g.r(cx - h5 - 1 + inCurl + sw2, y5, 4, 1, sideCol(-1, c1));
                g.r(cx + h5 - 3 - inCurl + sw2, y5, 4, 1, sideCol(1, c1));
            }
            break;
        case "ponytail":
            {
                var tx = cx + s * (maxHalf + 2);
                g.r(tx - 1, geom.eyeY - 2, 3, 2, dark); // hair tie
                for(var y6 = geom.eyeY; y6 < chinY + 12; y6++){
                    var wob1 = Math.round(1.4 * Math.sin(y6 * 0.5));
                    g.r(tx - 1 + wob1 + sway(y6), y6, 3, 1, sideCol(s, $9b7c6ba2608f0479$var$hash2(y6, 5) > 0.75 ? dark : col));
                }
                break;
            }
        case "bun":
            (0, $ebbe444d7b37c3d1$export$56b4dd62e08af00e)(g, cx, hairTop - 2, 5, line);
            (0, $ebbe444d7b37c3d1$export$56b4dd62e08af00e)(g, cx, hairTop - 2, 4, col);
            g.a(0.5, function() {
                return (0, $ebbe444d7b37c3d1$export$56b4dd62e08af00e)(g, cx - 1, hairTop - 3, 2, lit);
            });
            break;
        case "topknot":
            g.r(cx - 2, hairTop - 4, 4, 5, col); // knot stub
            (0, $ebbe444d7b37c3d1$export$56b4dd62e08af00e)(g, cx, hairTop - 1, 3, col);
            g.a(0.6, function() {
                return (0, $ebbe444d7b37c3d1$export$56b4dd62e08af00e)(g, cx - 1, hairTop - 2, 1, lit);
            });
            break;
    }
}
function $9b7c6ba2608f0479$var$drawFace(g, geom, f, pal) {
    var anim = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null;
    var cx = geom.cx, ey = geom.eyeY, noseY = geom.noseY, my = geom.mouthY;
    var _ref = [
        cx - (f.eyeGap >> 1),
        cx + (f.eyeGap >> 1)
    ], lx = _ref[0], rx = _ref[1];
    var browCol = $9b7c6ba2608f0479$var$shade(f.hairStyle === "bald" ? "#5a4634" : f.hairColor, 0.8);
    var iris = f.glowEye ? pal.glow : f.eyeColor;
    var socket = $9b7c6ba2608f0479$var$shade(f.skin, 0.82);
    // Idle-animation deltas (all no-ops when anim is null, so static renders and
    // the unit tests are unchanged): a gaze saccade, a brow flick, a blink, and a
    // multiplier on the glow-eye pulse.
    var gaze = Math.max(-2, Math.min(2, f.gaze + ((anim === null || anim === void 0 ? void 0 : anim.gaze) || 0)));
    var browRaise = f.browRaise + ((anim === null || anim === void 0 ? void 0 : anim.brow) || 0);
    var shut = ((anim === null || anim === void 0 ? void 0 : anim.blink) || 0) > 0.6; // eyes closed this frame
    var _anim_glow;
    var glowMul = (_anim_glow = anim === null || anim === void 0 ? void 0 : anim.glow) !== null && _anim_glow !== void 0 ? _anim_glow : 1;
    var eye = function(ex, dir) {
        g.a(0.55, function() {
            return g.r(ex - 2, ey - 1, 5, 1, socket);
        }); // socket shading above the eye
        if (shut) {
            // Closed lid: a soft skin crease where the eye was, no iris/catch-light.
            g.r(ex - 2, ey, 4, 1, $9b7c6ba2608f0479$var$shade(f.skin, 0.9));
            g.r(ex - 2, ey + 1, 4, 1, $9b7c6ba2608f0479$var$shade(f.skin, 0.7));
        } else {
            g.r(ex - 2, ey, 4, 1, "#e9e6de"); // small almond sclera
            g.r(ex - 2, ey + 1, 4, 1, $9b7c6ba2608f0479$var$shade("#e9e6de", 0.8)); // lower lid line
            g.r(ex - 1 + gaze, ey, 2, 2, iris); // iris fills most of the eye
            g.r(ex + gaze, ey, 1, 1, "#141317"); // pupil
            g.r(ex - 2, ey, 1, 1, "#2a2622"); // inner/outer canthus
            g.r(ex + 1, ey, 1, 1, "#2a2622");
            // Catch-light: a single lit iris pixel, drawn last so the canthus can't
            // paint over it, and on the same side of both eyes so they match.
            g.r(ex - 1 + gaze, ey, 1, 1, "#ffffff");
            if (f.glowEye) g.a(0.22 * glowMul, function() {
                return (0, $ebbe444d7b37c3d1$export$56b4dd62e08af00e)(g, ex + gaze, ey + 1, 2, pal.glow);
            });
        }
        // Brow: a short stroke angled down toward the nose. Females get a thinner,
        // slightly higher, arched brow plus a lash at the outer corner.
        if (f.female) {
            var bw = 5, by = ey - 4 - browRaise;
            (0, $ebbe444d7b37c3d1$export$5c4c5253709c2db0)(g, ex - 2, by, bw, browCol);
            g.r(ex - 2 + (dir > 0 ? bw - 1 : 0), by - 1, 1, 1, browCol); // outer tip arches up
            g.r(ex + (dir > 0 ? 2 : -2), ey - 1, 1, 1, "#241f1b"); // eyelash
        } else {
            var bw1 = 6, by1 = ey - 3 - browRaise;
            (0, $ebbe444d7b37c3d1$export$5c4c5253709c2db0)(g, ex - 3, by1, bw1, browCol);
            g.r(ex - 3 + (dir > 0 ? bw1 - 1 : 0), by1 + 1, 1, 1, browCol); // outer end drops
            if (f.browThick === 2) (0, $ebbe444d7b37c3d1$export$5c4c5253709c2db0)(g, ex - 3, by1 + 1, bw1, browCol);
        }
    };
    eye(lx, -1);
    eye(rx, 1);
    // Nose: a shaded ridge on the shadow side, a lit bridge on the lit side, and a
    // nostril base (an L of shadow).
    var ns = $9b7c6ba2608f0479$var$shade(f.skin, 0.74), s = f.shadeSide;
    (0, $ebbe444d7b37c3d1$export$77998c5980b7319b)(g, cx + (s > 0 ? 1 : -1), noseY, 4, ns);
    g.a(0.6, function() {
        return (0, $ebbe444d7b37c3d1$export$77998c5980b7319b)(g, cx - (s > 0 ? 1 : -1), noseY - 1, 4, $9b7c6ba2608f0479$var$shade(f.skin, 1.1));
    }); // bridge highlight
    g.r(cx - 1, noseY + 4, 3, 1, ns);
    g.r(cx + (s > 0 ? 2 : -2), noseY + 3, 1, 1, ns);
    // Mouth: a shaded upper-lip line; endpoints lift for a smile, drop for a frown.
    // Females get fuller, subtly rosy lips with a sheen.
    var mw = f.mouthW, x0 = cx - (mw >> 1);
    var open = (anim === null || anim === void 0 ? void 0 : anim.mouthOpen) || 0;
    var mc = f.female ? $9b7c6ba2608f0479$var$lerpHex($9b7c6ba2608f0479$var$shade(f.skin, 0.55), "#9c4f57", 0.55) : $9b7c6ba2608f0479$var$shade(f.skin, 0.5);
    var lipCol = f.female ? $9b7c6ba2608f0479$var$lerpHex($9b7c6ba2608f0479$var$shade(f.skin, 0.95), "#c07a80", 0.45) : $9b7c6ba2608f0479$var$shade(f.skin, 1.06);
    g.r(x0, my, mw, 1, mc); // upper lip line
    if (f.female) {
        g.r(x0, my + 1, mw, 1, lipCol); // lower lip
        g.a(0.6, function() {
            return g.r(x0 + 1, my + 1, mw - 2, 1, $9b7c6ba2608f0479$var$lerpHex(lipCol, "#ffffff", 0.3));
        }); // sheen
    } else g.a(0.5, function() {
        return g.r(x0, my + 1, mw, 1, lipCol);
    });
    // Idle parting: a dark gap opens BETWEEN the lips. Its centre widens
    // symmetrically as `open` (0..1) grows (a pixel added each side at once), and
    // the middle of the lower lip drops one row so the gap sits between the two
    // lips instead of over the bottom lip. open === 0 is the static look.
    if (open > 0) {
        var h = Math.round(open * (mw - 2 >> 1)), w = 2 * h + 1, gx = cx - h;
        g.r(gx, my + 2, w, 1, f.female ? lipCol : $9b7c6ba2608f0479$var$shade(f.skin, 0.9)); // dropped lower-lip centre
        g.r(gx, my + 1, w, 1, $9b7c6ba2608f0479$var$shade(f.skin, 0.3)); // dark cavity where the lips part
    }
    var _anim_mouthCurve;
    // Expression: use the animated curve when present (it morphs between the
    // character's expression and neutral), else the static one. Either way it
    // flattens toward neutral as the mouth opens.
    var curve = Math.round(((_anim_mouthCurve = anim === null || anim === void 0 ? void 0 : anim.mouthCurve) !== null && _anim_mouthCurve !== void 0 ? _anim_mouthCurve : f.mouthCurve) * (1 - open));
    if (curve !== 0) {
        g.r(x0 - 1, my - curve, 1, 1, mc);
        g.r(cx + (mw >> 1), my - curve, 1, 1, mc);
    }
}
function $9b7c6ba2608f0479$var$drawFacialHair(g, geom, f) {
    if (!f.facialHair) return;
    var cx = geom.cx, faceHalf = geom.faceHalf, chinY = geom.chinY, my = geom.mouthY, maxHalf = geom.maxHalf;
    var col = $9b7c6ba2608f0479$var$shade(f.hairColor, 0.9), dark = $9b7c6ba2608f0479$var$shade(f.hairColor, 0.6), lit = $9b7c6ba2608f0479$var$shade(f.hairColor, 1.16);
    // Jaw-hair top edge curves up the cheeks (sideburns) instead of a straight line.
    var bTop = function(x) {
        return my - 2 - Math.round(7 * Math.pow(Math.abs(x - cx) / maxHalf, 2));
    };
    switch(f.facialHair){
        case "stubble":
            // Stippled shadow over the jaw, with the same curved cheek top as the beard.
            g.a(0.34, function() {
                for(var y = my - 9; y <= chinY; y++){
                    var h = Math.round(faceHalf(y));
                    if (h <= 1) continue;
                    for(var x = cx - h; x < cx + h; x++){
                        if (y < bTop(x) || $9b7c6ba2608f0479$var$hash2(x * 2.1, y * 1.3) < 0.45) continue; // curved top + sparse stipple
                        g.r(x, y, 1, 1, col);
                    }
                }
            });
            break;
        case "mustache":
            g.r(cx - (f.mouthW >> 1) - 1, my - 2, f.mouthW + 2, 2, col);
            break;
        case "beard":
            // Full beard, textured with lighter/darker strands, a lips gap, and a darker
            // jaw-underline shadow. Top edge curves up the cheeks (shared bTop).
            for(var y = my - 9; y <= chinY + 2; y++){
                var h = Math.round(faceHalf(Math.min(y, chinY)));
                if (h <= 1) continue;
                for(var x = cx - h; x < cx + h; x++){
                    if (y < bTop(x)) continue; // curved top edge following the cheeks
                    if (y >= my - 1 && y <= my + 1 && Math.abs(x - cx) <= f.mouthW >> 1) continue; // lips show through
                    var n = $9b7c6ba2608f0479$var$hash2(x * 1.8, y * 1.5);
                    g.r(x, y, 1, 1, n > 0.8 ? dark : n < 0.13 ? lit : col);
                }
            }
            g.a(0.4, function() {
                var h = Math.round(faceHalf(chinY));
                g.r(cx - h + 1, chinY, 2 * h - 2, 2, dark);
            }); // jaw shadow
            for(var x1 = cx - (f.mouthW >> 1) - 1; x1 <= cx + (f.mouthW >> 1); x1++)g.r(x1, my - 2, 1, 2, $9b7c6ba2608f0479$var$hash2(x1 * 1.8, (my - 2) * 1.5) > 0.8 ? dark : col); // moustache
            break;
        case "goatee":
            g.r(cx - 3, my + 3, 6, 6, col);
            g.r(cx - (f.mouthW >> 1) - 1, my - 2, f.mouthW + 2, 1, col);
            break;
    }
}
// A single earring at (ex, y) — the lobe attach point. Style: stud / hoop / drop.
function $9b7c6ba2608f0479$var$drawEarring(g, ex, y, style, color) {
    if (style === "hoop") {
        g.r(ex, y, 1, 1, color); // top attach
        g.r(ex - 1, y + 1, 1, 1, color);
        g.r(ex + 1, y + 1, 1, 1, color);
        g.r(ex - 1, y + 2, 1, 1, color);
        g.r(ex + 1, y + 2, 1, 1, color);
        g.r(ex - 1, y + 3, 1, 1, color);
        g.r(ex + 1, y + 3, 1, 1, color);
        g.r(ex, y + 4, 1, 1, color); // bottom of the ring
    } else if (style === "drop") {
        g.r(ex, y, 1, 1, color); // stud
        g.r(ex, y + 2, 1, 2, color); // dangling drop
    } else g.r(ex, y, 1, 2, color);
}
// Earrings from the earlobe(s). Drawn before hair so long styles cover them (and
// short styles leave them showing). One ear, or both.
function $9b7c6ba2608f0479$var$drawEarrings(g, geom, f) {
    if (!f.earring) return;
    var cx = geom.cx, eyeY = geom.eyeY, y = eyeY + 7;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = (f.earringBoth ? [
            -1,
            1
        ] : [
            1
        ])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var sgn = _step.value;
            $9b7c6ba2608f0479$var$drawEarring(g, cx + sgn * Math.round(geom.faceHalf(y) + 0.5), y, f.earringStyle, f.earringColor);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
// Facial scar / clan markings / faction sigil. Drawn on the skin BEFORE hair, so
// hair renders over them where they overlap (hairline, temples).
function $9b7c6ba2608f0479$var$drawFaceMarks(g, geom, f, pal, faction) {
    var cx = geom.cx, ey = geom.eyeY;
    // Scar: a short diagonal across one cheek/brow.
    if (f.scar) {
        var x = cx + f.scarSide * 8, y = ey - 3;
        for(var i = 0; i < 7; i++){
            g.r(x, y, 1, 1, $9b7c6ba2608f0479$var$shade(f.skin, 0.6));
            x += f.scarSide;
            y += 1;
        }
    }
    // Warpaint / clan markings (wilders skew here via markStyle).
    if (f.markings) {
        var ac = faction === "wilders" ? pal.accent : $9b7c6ba2608f0479$var$shade(pal.accent, 0.9);
        if (f.markStyle === 0) g.a(0.7, function() {
            (0, $ebbe444d7b37c3d1$export$77998c5980b7319b)(g, cx - 6, ey - 1, 6, ac);
            (0, $ebbe444d7b37c3d1$export$77998c5980b7319b)(g, cx + 6, ey - 1, 6, ac);
        });
        else if (f.markStyle === 1) // Cheek dashes (below the eyes).
        g.a(0.7, function() {
            for(var _i = 0, _iter = [
                -1,
                1
            ]; _i < _iter.length; _i++){
                var sgn = _iter[_i];
                for(var i = 0; i < 3; i++)g.r(sgn < 0 ? cx - 8 : cx + 5, ey + 3 + i * 2, 3, 1, ac);
            }
        });
        else g.a(0.6, function() {
            g.r(cx - 3, ey - 6, 6, 1, ac);
            (0, $ebbe444d7b37c3d1$export$56b4dd62e08af00e)(g, cx, ey - 8, 1, ac);
        });
    }
    // Faction sigil on the forehead (dominion mark reads strongest).
    if (f.sigil) {
        var sy = ey - 7;
        if (faction === "dominion") {
            g.r(cx - 1, sy, 2, 3, pal.accent);
            g.r(cx - 2, sy + 1, 4, 1, pal.accent);
        } else if (faction === "veil") g.a(0.8, function() {
            return (0, $ebbe444d7b37c3d1$export$56b4dd62e08af00e)(g, cx, sy + 1, 2, pal.glow);
        });
        else {
            g.r(cx - 2, sy, 1, 3, pal.accent);
            g.r(cx + 1, sy, 1, 3, pal.accent);
        }
    }
}
// Eyewear (visor / glasses / eyepatch) — drawn on top of everything.
function $9b7c6ba2608f0479$var$drawExtras(g, geom, f, pal, faction) {
    var cx = geom.cx, ey = geom.eyeY;
    var _ref = [
        cx - (f.eyeGap >> 1),
        cx + (f.eyeGap >> 1)
    ], lx = _ref[0], rx = _ref[1];
    // Face mask / visor: a solid band wrapping the eyes that follows the face
    // silhouette (so it covers the sides) with a top edge curving up at the
    // temples, a lit top rim, and a glowing eye slit.
    if (f.visor) {
        var _loop = function(x) {
            if (Math.abs(x - cx) > Wface) return "continue";
            var t = (x - cx) / W, off = Math.round(3 * t * t);
            var top = ey - 1 - off, bot = ey + 3 - off, slit = ey - off;
            var lit = Math.abs(x - cx) <= browSpan; // glow limited to the eyebrow span
            for(var y = top; y <= bot; y++)g.r(x, y, 1, 1, lit && y === slit ? pal.glow : y === top ? rim : dk);
            if (lit) g.a(0.45, function() {
                return g.r(x, slit + 1, 1, 1, ug);
            }); // under-slit glow, curved too
        };
        var dk = pal.garbDark, rim = $9b7c6ba2608f0479$var$shade(pal.garbDark, 1.5), ug = $9b7c6ba2608f0479$var$shade(pal.glow, 0.6);
        var W = Math.round(geom.faceHalf(ey + 1)), Wface = Math.round(geom.faceHalf(ey));
        var browSpan = (f.eyeGap >> 1) + 3; // glow only reaches as wide as the eyebrows
        // The whole band curves up at the edges — top, slit and bottom all rise by the
        // same offset, so the visor keeps a constant thickness and hugs the face.
        for(var x = cx - W; x <= cx + W; x++)_loop(x);
    } else if (f.glasses) {
        // Eyewear frame around each eye, a bridge, and arms back to the ears. Style is
        // clear (transparent), sun (dark tinted), or aviator (teardrop metal frame).
        var aviator = f.glassesStyle === "aviator";
        var fr = aviator ? "#8a7452" : "#26221e";
        var er = Math.round(geom.faceHalf(ey));
        // Aviator lens: half-widths top->bottom (dy -3..+4). Big teardrop widest near
        // the top, tapering to a rounded bottom point that leans slightly outward.
        var AV = [
            5,
            6,
            6,
            6,
            5,
            5,
            4,
            3
        ];
        var avC = function(ex, dy) {
            return ex + Math.round((ex < cx ? -1 : 1) * Math.max(0, dy) * 0.28);
        };
        var lens = function(ex) {
            if (aviator) {
                var _loop = function(i) {
                    var dy = -3 + i, w = AV[i], c = avC(ex, dy);
                    var tint = $9b7c6ba2608f0479$var$lerpHex("#2a1e12", "#5c4020", i / (AV.length - 1)); // amber gradient, darker up top
                    g.a(0.82, function() {
                        return g.r(c - w, ey + dy, 2 * w, 1, tint);
                    });
                    g.r(c - w, ey + dy, 1, 1, fr);
                    g.r(c + w - 1, ey + dy, 1, 1, fr);
                };
                for(var i = 0; i < AV.length; i++)_loop(i);
                (0, $ebbe444d7b37c3d1$export$5c4c5253709c2db0)(g, ex - AV[0], ey - 3, AV[0] * 2, fr); // flat top
                var bw = AV[AV.length - 1], bc = avC(ex, 4);
                g.r(bc - bw, ey + 5, bw * 2, 1, fr); // rounded bottom rim
                g.a(0.5, function() {
                    return g.r(ex - 3, ey - 2, 5, 1, "#c9d6e2");
                }); // reflection streak
            } else {
                (0, $ebbe444d7b37c3d1$export$5c4c5253709c2db0)(g, ex - 4, ey - 3, 9, fr); // rectangular frame
                (0, $ebbe444d7b37c3d1$export$5c4c5253709c2db0)(g, ex - 4, ey + 3, 9, fr);
                (0, $ebbe444d7b37c3d1$export$77998c5980b7319b)(g, ex - 4, ey - 3, 7, fr);
                (0, $ebbe444d7b37c3d1$export$77998c5980b7319b)(g, ex + 4, ey - 3, 7, fr);
                if (f.glassesStyle === "sun") {
                    g.a(0.82, function() {
                        return g.r(ex - 3, ey - 2, 7, 5, "#161b24");
                    }); // dark tint
                    g.a(0.5, function() {
                        for(var k = 0; k < 4; k++)g.r(ex - 3 + k, ey + 1 - k, 1, 1, "#5a6b82");
                    }); // reflection streak
                } else {
                    g.a(0.2, function() {
                        return g.r(ex - 3, ey - 2, 7, 5, "#bcd0e0");
                    }); // faint clear tint
                    g.r(ex - 2, ey - 2, 1, 1, "#f2f6fa"); // glint
                }
            }
        };
        lens(lx);
        lens(rx);
        if (aviator) {
            var bx = lx + AV[0], bw = Math.max(2, rx - lx - AV[0] * 2);
            (0, $ebbe444d7b37c3d1$export$5c4c5253709c2db0)(g, bx, ey - 2, bw, fr); // double bridge over the nose
            (0, $ebbe444d7b37c3d1$export$5c4c5253709c2db0)(g, bx, ey, bw, fr);
            (0, $ebbe444d7b37c3d1$export$5c4c5253709c2db0)(g, cx - er, ey - 3, lx - AV[1] - (cx - er), fr); // arms at the brow line
            (0, $ebbe444d7b37c3d1$export$5c4c5253709c2db0)(g, rx + AV[1], ey - 3, cx + er - (rx + AV[1]), fr);
        } else {
            (0, $ebbe444d7b37c3d1$export$5c4c5253709c2db0)(g, lx + 4, ey - 1, Math.max(2, rx - lx - 8), fr); // single bridge
            (0, $ebbe444d7b37c3d1$export$5c4c5253709c2db0)(g, cx - er, ey - 2, lx - 4 - (cx - er), fr); // arms to the ears
            (0, $ebbe444d7b37c3d1$export$5c4c5253709c2db0)(g, rx + 4, ey - 2, cx + er - (rx + 4), fr);
        }
    } else if (f.eyepatch) {
        var ex = cx + (f.scarSide < 0 ? -(f.eyeGap >> 1) : f.eyeGap >> 1);
        g.r(ex - 2, ey - 2, 6, 6, "#303030");
        g.r(ex - 3, ey - 2, 8, 5, "#303030");
        g.r(ex + 3, ey - 2, 1, 5, "#202020");
        g.r(ex - 3, ey + 2, 7, 1, "#202020");
        g.r(ex + 4, ey - 2, 1, 5, "#000000");
        g.r(ex - 2, ey + 3, 6, 1, "#000000");
        (0, $ebbe444d7b37c3d1$export$5c4c5253709c2db0)(g, cx - geom.maxHalf, ey - 3, geom.maxHalf * 2, "#161418"); // strap
    }
}
// ---- entry points ---------------------------------------------------------
// Paint a portrait from an explicit feature object into a 2D context sized
// AVATAR_BASE x AVATAR_BASE. `rng` drives the few remaining cosmetic randoms
// (the wilders fur edge). Works against any object exposing
// fillStyle/fillRect/globalAlpha (a real canvas, or a recording stub in tests).
function $9b7c6ba2608f0479$var$paintAvatar(ctx, f, faction, cfg, rng) {
    var anim = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null;
    var pal = $9b7c6ba2608f0479$export$3a2c4b2c8c374a0f[faction] || $9b7c6ba2608f0479$export$3a2c4b2c8c374a0f.dominion;
    var geom = $9b7c6ba2608f0479$var$makeGeom(f);
    var g = (0, $ebbe444d7b37c3d1$export$a2661aea9d478234)(ctx);
    // `transparentBackground` skips the faction fill so the portrait composites
    // onto whatever is behind it (e.g. a card's own gradient) instead of drawing
    // its own rectangle. Not a DEFAULT_AVATAR_CONFIG knob — callers opt in.
    if (!cfg.transparentBackground) $9b7c6ba2608f0479$var$drawBackground(g, pal, cfg);
    if (f.hood) $9b7c6ba2608f0479$var$cowlBack(g, geom, pal);
    // Breathing lifts only the body/shoulders a pixel (the head stays put, so it
    // reads as the chest rising, not the whole portrait jumping). The head is
    // drawn afterward and covers the 1px more of neck the raised collar exposes.
    var breath = (anim === null || anim === void 0 ? void 0 : anim.breath) | 0;
    if (breath) ctx.translate(0, -breath);
    $9b7c6ba2608f0479$var$drawBody(g, geom, rng, f, pal, faction);
    if (breath) ctx.translate(0, breath);
    $9b7c6ba2608f0479$var$drawHead(g, geom, f);
    $9b7c6ba2608f0479$var$drawEarrings(g, geom, f); // before hair, so long styles cover the ears + earrings
    $9b7c6ba2608f0479$var$drawFaceMarks(g, geom, f, pal, faction); // scar/markings/sigil under the hair
    $9b7c6ba2608f0479$var$drawHair(g, geom, f, anim);
    if (f.hood) $9b7c6ba2608f0479$var$cowlFront(g, geom, pal);
    $9b7c6ba2608f0479$var$drawFace(g, geom, f, pal, anim);
    $9b7c6ba2608f0479$var$drawFacialHair(g, geom, f);
    $9b7c6ba2608f0479$var$drawExtras(g, geom, f, pal, faction);
    return f;
}
function $9b7c6ba2608f0479$export$ea6464b4fe67e5f2(ctx, seedStr) {
    var faction = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "dominion", config = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var cfg = (0, $fa9769297b8a68c8$export$71511d61b312f219)({}, $9b7c6ba2608f0479$export$210f63acf4dbee61, config);
    var rng = (0, $980f67465e309611$export$c0b222505a3369f3)("avatar|".concat(faction, "|").concat(seedStr));
    var f = $9b7c6ba2608f0479$var$rollFeatures(rng, faction, cfg);
    return $9b7c6ba2608f0479$var$paintAvatar(ctx, f, faction, cfg, rng); // rng continues past the roll
}
function $9b7c6ba2608f0479$export$4fafee04cbe5d540(seedStr) {
    var faction = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "dominion", config = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var cfg = (0, $fa9769297b8a68c8$export$71511d61b312f219)({}, $9b7c6ba2608f0479$export$210f63acf4dbee61, config);
    return $9b7c6ba2608f0479$var$rollFeatures((0, $980f67465e309611$export$c0b222505a3369f3)("avatar|".concat(faction, "|").concat(seedStr)), faction, cfg);
}
function $9b7c6ba2608f0479$export$a046ef6d7517111c(ctx, features) {
    var faction = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "dominion", config = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, anim = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null;
    var cfg = (0, $fa9769297b8a68c8$export$71511d61b312f219)({}, $9b7c6ba2608f0479$export$210f63acf4dbee61, config);
    var rng = (0, $980f67465e309611$export$c0b222505a3369f3)("avatar-manual|".concat(faction, "|").concat(features.skin, "|").concat(features.hairStyle));
    return $9b7c6ba2608f0479$var$paintAvatar(ctx, (0, $fa9769297b8a68c8$export$71511d61b312f219)({}, features), faction, cfg, rng, anim);
}
function $9b7c6ba2608f0479$export$e5cd63d32a946e1d(tMs) {
    var phase = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, mouthCurve = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    var t = tMs / 1000 + phase;
    // Blink: shut for ~140ms once per ~4.2s cycle.
    var blinkCycle = t % 4.2;
    var blink = blinkCycle > 4.06 ? 1 : 0;
    // Gaze saccade: hold centre, occasionally flick to a side and back.
    var g = Math.sin(t * 0.37 + phase * 2.3);
    var gaze = g > 0.9 ? 1 : g < -0.9 ? -1 : 0;
    // Glow pulse: continuous, so it reads smoothly even at this resolution.
    var glow = 0.7 + 0.3 * Math.sin(t * 2.1 + phase);
    // Brow flick: a brief raise, rarely.
    var brow = Math.sin(t * 0.23 + phase) > 0.985 ? 1 : 0;
    // Breathing: the shoulders rise a pixel on the slow inhale (body only).
    var breath = Math.sin(t * 0.8) > 0.3 ? 1 : 0;
    // Expression: slowly morph between the character's set expression and neutral
    // (a neutral character drifts toward a smile or frown, picked per-avatar from
    // phase). Runs at the cadence the mouth-open used to — roughly every ~13s.
    var target = mouthCurve !== 0 ? mouthCurve : Math.sin(phase * 7) >= 0 ? 1 : -1;
    var k = (Math.sin(t * 0.5 + phase * 5) + 1) / 2;
    var animCurve = Math.round(target * k); // -1 / 0 / 1
    // Mouth opening: now ~4x rarer (a slow ~50s cycle whose peak parts the lips for
    // a few seconds); still a continuous 0..1 that drawFace maps to slit width.
    var mo = Math.sin(t * 0.125 + phase * 3);
    var mouthOpen = mo > 0.93 ? (mo - 0.93) / 0.07 : 0;
    // Wind: mostly still, with occasional gusts that flutter the loose hair. A slow
    // envelope gates a faster oscillation, so gusts arrive and fade (~every 50s).
    var gust = Math.max(0, Math.sin(t * 0.13 + phase * 4) - 0.85) / 0.15;
    var wind = gust * Math.sin(t * 2.4 + phase);
    return {
        blink: blink,
        gaze: gaze,
        glow: glow,
        brow: brow,
        breath: breath,
        mouthOpen: mouthOpen,
        mouthCurve: animCurve,
        wind: wind
    };
}
// Browser/lab-only: nearest-neighbour upscale of a 64px portrait to `size` px.
function $9b7c6ba2608f0479$var$upscaledDataURL(drawInto, size) {
    var src = document.createElement("canvas");
    src.width = src.height = $9b7c6ba2608f0479$export$aaa4582620b40efc;
    drawInto(src.getContext("2d"));
    var out = document.createElement("canvas");
    out.width = out.height = size;
    var octx = out.getContext("2d");
    octx.imageSmoothingEnabled = false;
    octx.drawImage(src, 0, 0, size, size);
    return out.toDataURL("image/png");
}
function $9b7c6ba2608f0479$export$df23e55b8e3e0ed8(seedStr) {
    var faction = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "dominion", size = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $9b7c6ba2608f0479$export$ba4617d152d9e9eb, config = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return $9b7c6ba2608f0479$var$upscaledDataURL(function(ctx) {
        return $9b7c6ba2608f0479$export$ea6464b4fe67e5f2(ctx, seedStr, faction, config);
    }, size);
}
function $9b7c6ba2608f0479$export$adacf7b1df9d4c0e(features) {
    var faction = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "dominion", size = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $9b7c6ba2608f0479$export$ba4617d152d9e9eb, config = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return $9b7c6ba2608f0479$var$upscaledDataURL(function(ctx) {
        return $9b7c6ba2608f0479$export$a046ef6d7517111c(ctx, features, faction, config);
    }, size);
}





// Figure geometry, in the tile's authored 120px space. Scaled by u = tile/120
// at draw time so a different tile size costs nothing.
var $babd2312889b27ed$var$REF_TILE = 120;
var $babd2312889b27ed$var$BEAM_LEN = 30; // how far the torch reaches across the ground
var $babd2312889b27ed$var$BEAM_WIDE = 9; // half-width where it lands
// The ground plane is seen from above, so a beam pointing up or down the
// screen is foreshortened. Squashing y by this much is the whole of the
// perspective in here, and it is enough to stop a torch aimed "north" from
// reading as one aimed at the sky.
var $babd2312889b27ed$var$GROUND_SQUASH = 0.5;
// Torch strength against the hour. It never reaches zero: a team searching a
// tile at noon still has to LOOK like it is searching, and the faint daytime
// beam is the only thing on screen that says so. At night it carries the
// figure as well as the search.
var $babd2312889b27ed$var$BEAM_DAY = 0.10, $babd2312889b27ed$var$BEAM_NIGHT = 0.55;
// How dark a silhouette gets. Floored well above the tile's own night tint —
// a figure shaded honestly against midnight ground is a figure nobody can
// find, and these three are the thing the player is watching.
var $babd2312889b27ed$var$SHADE_FLOOR = 0.52;
// ---- outcome effects ----
// A skill check resolving is the raid's whole beat and the map used to say
// nothing about it. These are one-shots played on the member the check ran
// through (see raidFx-core.js). All of them are drawn with 'lighter' and none
// of them is shaded for the hour: they are light sources, like the torches and
// the lit windows, and light is the one thing the day tint must not touch.
var $babd2312889b27ed$var$FX = {
    // Chest height on the figure, where a person's hands are.
    HAND_Y: -10,
    success: {
        ring: 17,
        spokes: 0,
        color: '#b9f5c8',
        core: '#ffffff'
    },
    // Twice the reach and a full corona: a synergy is the rarest thing that
    // happens in a raid and it should be the one effect visible at a glance.
    synergy: {
        ring: 30,
        spokes: 7,
        color: '#ffd479',
        core: '#fff3cf'
    },
    failure: {
        ring: 15,
        spokes: 0,
        color: '#ff7a6b',
        core: '#ffd9d2'
    }
};
// How far a member is knocked about by a failure landing on them, in tile px.
var $babd2312889b27ed$var$FX_JOLT = 2.2;
// A found item's mote is tinted by its rarity, off the same table the item
// tooltips and the inventory use — a rare coming up has to look like a rare,
// and inventing a second palette here would make it look like something else.
var $babd2312889b27ed$var$RARITY_FALLBACK = '#cfd6e0';
function $babd2312889b27ed$var$rarityColor(rarity) {
    var _config_itemRarities_rarity, _config_itemRarities;
    return ((_config_itemRarities = $979b99378be707cd$export$d4a72d069095e9e5) === null || _config_itemRarities === void 0 ? void 0 : (_config_itemRarities_rarity = _config_itemRarities[rarity]) === null || _config_itemRarities_rarity === void 0 ? void 0 : _config_itemRarities_rarity.color) || $babd2312889b27ed$var$RARITY_FALLBACK;
}
var $babd2312889b27ed$var$TAU = Math.PI * 2;
var $babd2312889b27ed$var$clamp01 = function(v) {
    return v < 0 ? 0 : v > 1 ? 1 : v;
};
// Multiply a #rrggbb by a constant. Memoized because the same dozen
// (colour, brightness step) pairs recur every frame for the life of a raid.
var $babd2312889b27ed$var$shadeCache = new Map();
function $babd2312889b27ed$var$shade(hex, k) {
    var q = Math.round(k * 24); // 24 brightness steps is under
    var key = "".concat(hex, "|").concat(q); // the eye's threshold at this size
    var out = $babd2312889b27ed$var$shadeCache.get(key);
    if (out) return out;
    var n = parseInt(hex.slice(1), 16);
    var f = q / 24;
    out = "rgb(".concat(Math.round((n >> 16 & 255) * f), ",").concat(Math.round((n >> 8 & 255) * f), ",").concat(Math.round((n & 255) * f), ")");
    $babd2312889b27ed$var$shadeCache.set(key, out);
    return out;
}
function $babd2312889b27ed$export$bdfac2c19033ece4(team) {
    return (team || []).filter(function(m) {
        return m && m.isAlive !== false;
    }).map(function(m, i) {
        var _m_id, _ref, _ref1, _m_currentHp;
        return {
            // What an outcome effect addresses them by. The drawn roster drops
            // the dead, so an index would shift onto somebody else the moment
            // anyone fell — mid-raid, which is exactly when failures happen.
            id: (_ref1 = (_ref = (_m_id = m.id) !== null && _m_id !== void 0 ? _m_id : m.avatarSeed) !== null && _ref !== void 0 ? _ref : m.name) !== null && _ref1 !== void 0 ? _ref1 : i,
            faction: (0, $9b7c6ba2608f0479$export$3a2c4b2c8c374a0f)[m.faction] ? m.faction : 'dominion',
            // Decorrelates one member's wander and torch sweep from the next.
            // avatarSeed is the same token the portrait is generated from, so
            // a given contractor moves the same way every raid they are on.
            seed: $babd2312889b27ed$var$hashSeed(m.avatarSeed || m.id || m.name || i),
            // Below a third HP the figure stoops and the torch dips — the map
            // says "this is going badly" before the log scrolls to it.
            hurt: m.maxHp > 0 ? $babd2312889b27ed$var$clamp01(1 - ((_m_currentHp = m.currentHp) !== null && _m_currentHp !== void 0 ? _m_currentHp : m.maxHp) / m.maxHp) : 0
        };
    });
}
function $babd2312889b27ed$var$hashSeed(v) {
    var s = String(v);
    var h = 2166136261;
    for(var i = 0; i < s.length; i++){
        h ^= s.charCodeAt(i);
        h = Math.imul(h, 16777619);
    }
    return h >>> 0;
}
function $babd2312889b27ed$export$d0f529c5e2e21188(ctx, x, y, opts) {
    var members = opts.members;
    if (!members || !members.length) return;
    var tile = opts.tile || $babd2312889b27ed$var$REF_TILE;
    var u = tile / $babd2312889b27ed$var$REF_TILE;
    var tSec = opts.tSec || 0;
    var _opts_dayPhase;
    var light = (0, $05f2074f6c82f4e0$export$45f6af437d59d9ba)((_opts_dayPhase = opts.dayPhase) !== null && _opts_dayPhase !== void 0 ? _opts_dayPhase : 0.5);
    var beamA = $babd2312889b27ed$var$BEAM_DAY + ($babd2312889b27ed$var$BEAM_NIGHT - $babd2312889b27ed$var$BEAM_DAY) * (1 - light);
    var bright = $babd2312889b27ed$var$SHADE_FLOOR + (1 - $babd2312889b27ed$var$SHADE_FLOOR) * light;
    var _opts_nowMs;
    var nowMs = (_opts_nowMs = opts.nowMs) !== null && _opts_nowMs !== void 0 ? _opts_nowMs : Date.now();
    // Effects are addressed by member id, because the drawn roster drops the
    // dead and an index would quietly shift onto somebody else the moment
    // anyone fell. One that names nobody on screen plays on the whole party.
    var fx = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var f = _step.value;
            var phase = (0, $cf1d0720eef4c612$export$f82af1eaff316176)(f, nowMs);
            if (phase <= 0 || phase >= 1) return "continue" // not started, or over
            ;
            fx.push({
                f: f,
                phase: phase,
                i: members.findIndex(function(m) {
                    return m.id != null && m.id === f.memberId;
                })
            });
        };
        for(var _iterator = (opts.fx || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // A party near a corner is inside the draw radius of all eight neighbouring
    // tiles, but a member only ever puts ink within a torch's length of itself.
    // Dropping the ones that cannot reach this canvas is what stops a stationary
    // team costing three beam gradients on each of nine tiles every frame.
    // An effect reaches further than a torch, so the margin grows while one runs.
    var reach = (fx.length ? $babd2312889b27ed$var$FX.synergy.ring * 1.3 : $babd2312889b27ed$var$BEAM_LEN * 1.15) * u;
    var poses = [];
    for(var i = 0; i < members.length; i++){
        var _opts_posts;
        var p = (0, $00f2bfbf94a5f5a3$export$5ae338d6b723c743)(i, members.length, tSec, opts.party, members[i].seed, (_opts_posts = opts.posts) === null || _opts_posts === void 0 ? void 0 : _opts_posts[i]);
        var px = x + p.dx * tile, py = y + p.dy * tile;
        if (px < -reach || px > tile + reach || py < -reach || py > tile + reach) continue;
        // A failure landing on somebody knocks them about — the one place an
        // effect moves a figure rather than being drawn beside it, because a
        // flinch is what tells you WHO it happened to.
        var jolt = 0;
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = fx[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var e = _step1.value;
                if (e.f.kind !== 'failure' || e.i !== i) continue;
                jolt += Math.sin(e.phase * 34) * $babd2312889b27ed$var$FX_JOLT * u * (0, $cf1d0720eef4c612$export$2ff71a728686ddfb)(e.phase);
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        px += jolt;
        // How far down they have sat. `gait` is already the "have they settled
        // onto their post yet" number, so a camp needs no second clock: they
        // walk in, set up, and sink down as they arrive, then stand back up as
        // the party gathers to leave.
        poses.push({
            m: members[i],
            p: p,
            px: px,
            py: py,
            i: i,
            sit: opts.resting ? 1 - p.gait : 0
        });
    }
    if (!poses.length) return;
    // Painter's order: whoever is further up the tile is further away.
    poses.sort(function(a, b) {
        return a.py - b.py;
    });
    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
    try {
        // Every torch first, so a beam never lies over the figure standing in it.
        for(var _iterator2 = poses[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var s = _step2.value;
            $babd2312889b27ed$var$drawBeam(ctx, s, u, beamA, tSec);
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
            }
        } finally{
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }
    var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
    try {
        for(var _iterator3 = poses[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
            var s1 = _step3.value;
            $babd2312889b27ed$var$drawFigure(ctx, s1, u, bright, beamA);
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                _iterator3.return();
            }
        } finally{
            if (_didIteratorError3) {
                throw _iteratorError3;
            }
        }
    }
    var _iteratorNormalCompletion4 = true, _didIteratorError4 = false, _iteratorError4 = undefined;
    try {
        // ...and the outcome over everything, because it is the news.
        for(var _iterator4 = fx[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true){
            var e1 = _step4.value;
            $babd2312889b27ed$var$drawFx(ctx, e1, poses, x, y, u);
        }
    } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                _iterator4.return();
            }
        } finally{
            if (_didIteratorError4) {
                throw _iteratorError4;
            }
        }
    }
}
function $babd2312889b27ed$var$drawBeam(ctx, s, u, alpha, tSec) {
    // A wounded member's torch hangs low and short, and a seated one has put
    // theirs down — a camp is lit by its fire, which the tile draws itself.
    var a = alpha * (1 - 0.45 * s.m.hurt) * (1 - s.sit);
    if (a < 0.02) return;
    var len = $babd2312889b27ed$var$BEAM_LEN * u * (1 - 0.25 * s.m.hurt);
    ctx.save();
    ctx.globalCompositeOperation = 'lighter';
    ctx.translate(s.px, s.py);
    ctx.scale(1, $babd2312889b27ed$var$GROUND_SQUASH);
    ctx.rotate(s.p.facing);
    var g = ctx.createLinearGradient(0, 0, len, 0);
    g.addColorStop(0, "rgba(255,246,214,".concat(a, ")"));
    g.addColorStop(0.4, "rgba(255,238,196,".concat(a * 0.5, ")"));
    g.addColorStop(1, 'rgba(255,232,176,0)');
    ctx.fillStyle = g;
    ctx.beginPath();
    ctx.moveTo(0, 0);
    ctx.lineTo(len, -$babd2312889b27ed$var$BEAM_WIDE * u);
    ctx.lineTo(len * 1.06, 0);
    ctx.lineTo(len, $babd2312889b27ed$var$BEAM_WIDE * u);
    ctx.closePath();
    ctx.fill();
    ctx.restore();
    // The pool of light around their own feet, which is what actually lifts
    // the figure off dark ground. Breathes slightly, so a stationary team
    // still has something moving about it.
    var r = 7 * u * (1 + 0.06 * Math.sin(tSec * 1.7 + s.m.seed % 7));
    ctx.save();
    ctx.globalCompositeOperation = 'lighter';
    ctx.translate(s.px, s.py);
    ctx.scale(1, $babd2312889b27ed$var$GROUND_SQUASH);
    var pool = ctx.createRadialGradient(0, 0, 0, 0, 0, r);
    pool.addColorStop(0, "rgba(255,240,205,".concat(a * 0.55, ")"));
    pool.addColorStop(1, 'rgba(255,230,180,0)');
    ctx.fillStyle = pool;
    ctx.fillRect(-r, -r, r * 2, r * 2);
    ctx.restore();
}
function $babd2312889b27ed$var$drawFigure(ctx, s, u, bright, beamA) {
    var pal = (0, $9b7c6ba2608f0479$export$3a2c4b2c8c374a0f)[s.m.faction];
    var garb = $babd2312889b27ed$var$shade(pal.garb, bright);
    var dark = $babd2312889b27ed$var$shade(pal.garbDark, bright);
    var accent = $babd2312889b27ed$var$shade(pal.accent, bright * 0.9);
    var px = s.px, py = s.py;
    // Which way the sprite is turned. The body is a flat upright token on a
    // top-down map, so only the sign of the torch's x-component is expressible
    // — the true direction lives in the beam.
    var face = Math.cos(s.p.facing) >= 0 ? 1 : -1;
    // Nobody strides while sitting down.
    var swing = s.p.stride * (1 - s.sit);
    // Wounded members stoop; a full-height stride also lifts the body a little
    // off its feet on each step. Sitting takes a third off the whole figure,
    // which at fifteen pixels is the difference between standing and not.
    var H = (1 - 0.13 * s.m.hurt) * (1 - 0.34 * s.sit);
    var bob = -Math.abs(swing) * 0.7 * u * s.p.gait;
    var r = function(dx, dy, w, h, c) {
        ctx.fillStyle = c;
        ctx.fillRect(Math.round(px + dx * u), Math.round(py + dy * u * H + bob), Math.max(1, Math.round(w * u)), Math.max(1, Math.round(h * u)));
    };
    // contact shadow — the only thing tying a token to the ground
    ctx.save();
    ctx.globalAlpha = 0.34;
    ctx.fillStyle = '#000000';
    ctx.beginPath();
    ctx.ellipse(px, py, 4.4 * u, 1.7 * u, 0, 0, $babd2312889b27ed$var$TAU);
    ctx.fill();
    ctx.restore();
    // A dark ground line under the whole figure. At noon the silhouette sits
    // on pale concrete with nothing separating the two, and one row of shadow
    // is cheaper than outlining every part.
    r(-3.2, -0.8, 6.4, 1, '#000000');
    // Legs, swinging out of phase — and drawn out in front rather than under
    // the body once they are sitting, which is the read at this size: knees up,
    // not a shorter person.
    if (s.sit > 0.5) r(-1 + face * 1.2, -2.6, 3.4, 2.6, dark);
    else {
        r(-2.4 + swing * 1.1, -5, 2, 5, dark);
        r(0.4 - swing * 1.1, -5, 2, 5, dark);
    }
    // pack, on the back — behind whichever way they are turned
    r(face > 0 ? -3.9 : 1.9, -10.5, 2, 4.5, dark);
    // torso and shoulders
    r(-3, -11, 6, 6.2, garb);
    r(-3.4, -11.6, 6.8, 1.6, dark);
    // a single accent pixel each, so three silhouettes are three people
    r(face > 0 ? 1.4 : -2.4, -10.6, 1, 1, accent);
    // head — one row narrower top and bottom, which is all a 4px head needs
    // to stop reading as a brick
    r(-2.1, -15.6, 4.2, 3.8, dark);
    r(-1.4, -16.1, 2.8, 0.6, dark);
    // Underlight from their own torch, on the side they are holding it. WARM
    // and only a few pixels: the earlier version ran a cold rim down the full
    // height of the body, which at this size is not a highlight, it is a
    // fluorescent tube standing next to a person. What actually separates a
    // figure from dark ground is the pool it is standing in, not its edge.
    ctx.save();
    ctx.globalAlpha = Math.min(0.45, 0.12 + beamA * 0.5);
    var lit = face > 0 ? 2.2 : -2.8;
    r(lit, -11.2, 0.6, 2.4, '#ffe9bd'); // shoulder catching the lamp
    r(lit - face * 0.2, -15.2, 0.6, 1.4, '#ffe4b0'); // cheekbone
    ctx.restore();
}
// ============================================================================
// OUTCOME EFFECTS
// ============================================================================
// Everything here is drawn with 'lighter' onto the composited tile, so it adds
// light rather than painting over the art. That is also why none of it is put
// through shade(): a flare is a light source, and the day tint has already
// been applied underneath it.
/**
 * Where an effect happens.
 *
 * On its member's hands. An effect that names a member who is not drawn on
 * THIS canvas returns null and is skipped here — they are drawn on a
 * neighbouring tile and their effect belongs over there with them. Falling
 * back to the party's centre instead would put a second copy of every flare
 * in the wrong place on every tile the member had been culled from.
 *
 * The centre is only for an effect naming nobody on the roster at all — a
 * member who fell between the check resolving and the frame being drawn.
 */ function $babd2312889b27ed$var$fxOrigin(e, poses, x, y, u) {
    if (e.i >= 0) {
        var on = poses.find(function(p) {
            return p.i === e.i;
        });
        return on ? {
            x: on.px,
            y: on.py + $babd2312889b27ed$var$FX.HAND_Y * u
        } : null;
    }
    return {
        x: x,
        y: y + $babd2312889b27ed$var$FX.HAND_Y * u
    };
}
function $babd2312889b27ed$var$drawFx(ctx, e, poses, x, y, u) {
    var at = $babd2312889b27ed$var$fxOrigin(e, poses, x, y, u);
    if (!at) return;
    ctx.save();
    ctx.globalCompositeOperation = 'lighter';
    if (e.f.kind === 'loot') $babd2312889b27ed$var$drawLootMote(ctx, e, at, u);
    else $babd2312889b27ed$var$drawBurst(ctx, e, at, u);
    ctx.restore();
}
/**
 * Success, synergy and failure: a ring going out from the member's hands, a
 * core that flashes and dies, and — for a synergy only — a corona of spokes.
 *
 * One routine for the three of them because they differ in colour, reach and
 * whether they have spokes, and in nothing else. Three near-identical draw
 * functions would drift apart the first time one was tuned.
 */ function $babd2312889b27ed$var$drawBurst(ctx, e, at, u) {
    var spec = $babd2312889b27ed$var$FX[e.f.kind] || $babd2312889b27ed$var$FX.success;
    var p = e.phase;
    var fade = (0, $cf1d0720eef4c612$export$2ff71a728686ddfb)(p);
    var r = Math.max(1, (0, $cf1d0720eef4c612$export$b822c8d32c815bfc)(p) * spec.ring * u);
    // the ring
    ctx.globalAlpha = Math.min(1, fade * 0.95);
    ctx.strokeStyle = spec.color;
    ctx.lineWidth = Math.max(1, (1 + 2.2 * (1 - p)) * u);
    ctx.beginPath();
    // Squashed on the same ground plane the torches use, so a ring reads as
    // lying on the tile rather than standing up off it.
    ctx.ellipse(at.x, at.y, r, r * $babd2312889b27ed$var$GROUND_SQUASH, 0, 0, $babd2312889b27ed$var$TAU);
    ctx.stroke();
    // the core: a hard flash at the hands that is gone within a third of the
    // effect, which is what gives it a moment of impact rather than a swell
    var coreP = $babd2312889b27ed$var$clamp01(p / 0.33);
    if (coreP < 1) {
        var cr = (2 + 5 * coreP) * u;
        var g = ctx.createRadialGradient(at.x, at.y, 0, at.x, at.y, cr);
        g.addColorStop(0, spec.core);
        g.addColorStop(1, 'rgba(0,0,0,0)');
        ctx.globalAlpha = (0, $cf1d0720eef4c612$export$2ff71a728686ddfb)(coreP);
        ctx.fillStyle = g;
        ctx.fillRect(at.x - cr, at.y - cr, cr * 2, cr * 2);
    }
    // the corona — synergy only. Two skills meeting is the fiction, so the
    // spokes come in pairs about a common centre rather than radiating evenly.
    if (spec.spokes) {
        ctx.globalAlpha = fade * 0.8;
        ctx.strokeStyle = spec.core;
        ctx.lineWidth = Math.max(1, 1.2 * u);
        for(var i = 0; i < spec.spokes; i++){
            var a = i / spec.spokes * $babd2312889b27ed$var$TAU + p * 0.7 + e.f.seed % 100 * 0.06;
            var inner = r * 0.55, outer = r * (1 + 0.35 * Math.sin(i * 2.3));
            ctx.beginPath();
            ctx.moveTo(at.x + Math.cos(a) * inner, at.y + Math.sin(a) * inner * $babd2312889b27ed$var$GROUND_SQUASH);
            ctx.lineTo(at.x + Math.cos(a) * outer, at.y + Math.sin(a) * outer * $babd2312889b27ed$var$GROUND_SQUASH);
            ctx.stroke();
        }
    }
}
/**
 * A found item: a mote that lifts out of the member's hands, hangs, and goes
 * out — tinted by the item's rarity, which is the whole reason for putting it
 * on the map. A common coming up should look like nothing much; a rare should
 * make you look.
 */ function $babd2312889b27ed$var$drawLootMote(ctx, e, at, u) {
    var p = e.phase;
    var color = $babd2312889b27ed$var$rarityColor(e.f.rarity);
    // Rises most of the way in the first half, then holds and fades, so the
    // eye has something still to land on rather than chasing it off the tile.
    var rise = (0, $cf1d0720eef4c612$export$b822c8d32c815bfc)($babd2312889b27ed$var$clamp01(p / 0.55)) * 11 * u;
    var drift = Math.sin(e.f.seed % 20 + p * 2.2) * 2.4 * u;
    var cx = at.x + drift, cy = at.y - rise;
    var fade = p < 0.15 ? p / 0.15 : (0, $cf1d0720eef4c612$export$2ff71a728686ddfb)((p - 0.15) / 0.85);
    // halo
    var hr = 6 * u;
    var g = ctx.createRadialGradient(cx, cy, 0, cx, cy, hr);
    g.addColorStop(0, color);
    g.addColorStop(1, 'rgba(0,0,0,0)');
    ctx.globalAlpha = fade * 0.75;
    ctx.fillStyle = g;
    ctx.fillRect(cx - hr, cy - hr, hr * 2, hr * 2);
    // the mote itself, and a four-point sparkle as it peaks
    ctx.globalAlpha = Math.min(1, fade * 1.2);
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(Math.round(cx - u), Math.round(cy - u), Math.max(1, 2 * u), Math.max(1, 2 * u));
    var spark = 1 - Math.abs(p - 0.5) * 3.2;
    if (spark > 0) {
        ctx.globalAlpha = spark * 0.9;
        ctx.fillStyle = color;
        var arm = 4 * u * spark;
        ctx.fillRect(cx - arm, cy, arm * 2, Math.max(1, u));
        ctx.fillRect(cx, cy - arm, Math.max(1, u), arm * 2);
    }
}



var $bfcb035c6f32f2dc$var$BASE_WIND = 0.35; // gust formula peaks at 0.42 — never clamps
var $bfcb035c6f32f2dc$var$CLOUD_BASE = 0.3; // three decks stack, so less cover reads as more sky
// Ambient motion here is slow: clouds are drawn in 2px cells and drift
// 3-7 world px/s (a visible step every ~0.4s), tree sway rounds to a ±1px
// twitch over a ~3.5s cycle, and the lamp strobe is aliased at any frame
// rate. 12fps is indistinguishable from 30 and costs a third as much.
//
// The map still slows when another window has focus, because rAF keeps firing
// at full rate on an unfocused-but-VISIBLE window and there is no reason to
// spend a core on an animation nobody is attending to. But it slows far less
// than it used to. This was 500ms — 2fps — and that was a workaround for the
// canopies redrawing themselves 55 discs at a time, which made a visible map
// cost enough to stutter video playing in another window. They are blitted
// now, the map costs a third of what it did, and the video does not care.
//
// 2fps was also below the content's own floor: the fastest thing on screen is
// the cloud drift at ~2.5 visible steps a second, so sampling it twice a second
// UNDERSAMPLES it and the sky jumps instead of drifting. 6fps clears that with
// margin, and it matters because this is an idle game — a raid left running on
// a second monitor while you work is the ordinary way to watch one, not an edge
// case, and it is the exact case this governs. The window being properly hidden
// is already handled: the browser stops rAF entirely and neither figure applies.
var $bfcb035c6f32f2dc$var$FRAME_MS = 83; // ~12fps, focused
var $bfcb035c6f32f2dc$var$BLUR_FRAME_MS = 166; // ~6fps, another window has focus
var $bfcb035c6f32f2dc$var$LAYOUT_MS = 250; // cadence for the layout-forcing DOM reads
var $bfcb035c6f32f2dc$var$animCells = [];
// WHERE on the planet the grid on screen is. One raid is one place, so one
// clock serves every cell. The region id comes along only to name the site in
// the readout and to stand in for a pre-S9 save that has no site.
var $bfcb035c6f32f2dc$var$animRegionId = null;
var $bfcb035c6f32f2dc$var$animSite = null;
var $bfcb035c6f32f2dc$var$rafId = null;
var $bfcb035c6f32f2dc$var$lastFrame = 0;
var $bfcb035c6f32f2dc$var$cloudX = 0, $bfcb035c6f32f2dc$var$cloudY = 0;
var $bfcb035c6f32f2dc$var$drawCursor = 0; // round-robin position for the frame budget
var $bfcb035c6f32f2dc$var$lastClockUpdate = 0;
var $bfcb035c6f32f2dc$var$maxCol = 0; // grid width, for viewport column culling
var $bfcb035c6f32f2dc$var$lastLayoutCheck = 0;
var $bfcb035c6f32f2dc$var$gridVisible = false;
var $bfcb035c6f32f2dc$var$vpEl = null;
var $bfcb035c6f32f2dc$var$vpW = 0; // viewport client width
var $bfcb035c6f32f2dc$var$colW = 0; // grid column width; 0 = no horizontal culling
// The team walking the selected path, or null when no raid is running. Pushed
// in by the raid loop once a second (setRaidParty); the position between those
// updates is interpolated here off the raid's own schedule, so the figures
// move at frame rate while the game keeps ticking at 1Hz.
var $bfcb035c6f32f2dc$var$party = null;
// Outcome effects still playing — a check passing, a synergy firing, somebody
// taking a hit, an item coming up. Posted by the raid's resolution code, which
// is headless and knows nothing about this module, and collected here each
// frame. See raidFx-core.js.
var $bfcb035c6f32f2dc$var$fx = [];
// How far from the party a tile has to be before it is left to the ordinary
// round-robin. Figures are drawn within DRAW_R (a party straddling a seam
// lands on both tiles); cells out to FORCE_R are redrawn every frame anyway,
// so the tile the team has just walked off is cleared of them immediately
// rather than whenever the rotation next reaches it.
var $bfcb035c6f32f2dc$var$DRAW_R = 1.2;
var $bfcb035c6f32f2dc$var$FORCE_R = 2.2;
// Per-frame composite budget. Compositing is a blit, a multiply, the short
// dynamic list and the cloud pass — ~0.14ms a cell, against ~0.44ms for the
// full redraw it replaces. At 120 the whole of a tier-3 grid (153 cells)
// still lands inside the frame cost the 40px renderer used to pay for 48 of
// them. Cells rotate round-robin, so exceeding the budget just means a cell
// refreshes every other frame — adjacent tiles a frame apart diverge by
// <1px of cloud drift, below visibility.
var $bfcb035c6f32f2dc$var$FRAME_BUDGET = 120;
// Still-layer repaints per frame. The cached layer only changes when the
// sun moves the shadows a whole unit (a couple of dozen times a game day),
// and then EVERY cell needs it — so the sweep is spread across frames
// instead of hitching. 4/frame clears a tier-3 grid in ~3s of the ~24s
// between changes.
var $bfcb035c6f32f2dc$var$STATIC_BUDGET = 4;
var $bfcb035c6f32f2dc$var$reducedMotion = typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion: reduce)').matches;
function $bfcb035c6f32f2dc$export$8a6e680b278759fc() {
    return (0, $05f2074f6c82f4e0$export$e15059ad23f67dd4)($bfcb035c6f32f2dc$var$animRegionId, $bfcb035c6f32f2dc$var$animSite).phase;
}
function $bfcb035c6f32f2dc$export$bcbc425da348b5df(regionId, site) {
    $bfcb035c6f32f2dc$var$animRegionId = regionId;
    $bfcb035c6f32f2dc$var$animSite = site || null;
}
// Is this room's committed encounter set indoors? The grid pins its events at
// generation (preRollGridEvents), so the tile can be drawn for the encounter it
// will actually run — an indoor one gets its roof cut away. Read out of the
// generated constants rather than importing the event system, which would drag
// the whole raid-loot graph into the renderer's call path for one string.
var $bfcb035c6f32f2dc$var$envCache = new Map();
function $bfcb035c6f32f2dc$var$isIndoorEncounter(room) {
    var _room_plannedEventIds;
    var id = room === null || room === void 0 ? void 0 : (_room_plannedEventIds = room.plannedEventIds) === null || _room_plannedEventIds === void 0 ? void 0 : _room_plannedEventIds[0];
    if (!id) return false;
    if (!$bfcb035c6f32f2dc$var$envCache.has(id)) {
        var env = null;
        for(var _i = 0, _iter = [
            $979b99378be707cd$export$f152896064e09913,
            $979b99378be707cd$export$1cd1fab9b9844b76,
            $979b99378be707cd$export$9435522665f2dda4
        ]; _i < _iter.length; _i++){
            var list = _iter[_i];
            var found = list === null || list === void 0 ? void 0 : list.find(function(e) {
                return e.id === id;
            });
            if (found) {
                env = found.environment;
                break;
            }
        }
        $bfcb035c6f32f2dc$var$envCache.set(id, env);
    }
    return $bfcb035c6f32f2dc$var$envCache.get(id) === 'indoor';
}
function $bfcb035c6f32f2dc$export$2eefc97a05b1cdd3(p) {
    var was = $bfcb035c6f32f2dc$var$party && $bfcb035c6f32f2dc$var$party.pos;
    $bfcb035c6f32f2dc$var$party = p && p.path && p.path.length && p.members && p.members.length ? (0, $715bf31211e65705$export$71511d61b312f219)((0, $fa9769297b8a68c8$export$71511d61b312f219)({}, p), {
        pos: null,
        stage: null,
        stageKey: null
    }) : null;
    // A raid ending takes its outcomes with it: a flare still playing over a
    // completed grid is announcing something the player has already been paid
    // for. Reduced motion never starts a loop and so never draws these at all,
    // which is the right answer for a screen full of flashes anyway — the log
    // and the notifications carry the same news.
    if (!$bfcb035c6f32f2dc$var$party) {
        $bfcb035c6f32f2dc$var$fx = [];
        (0, $cf1d0720eef4c612$export$fd4b5295b61ee6bc)();
        $bfcb035c6f32f2dc$var$setTransit(false);
    }
    if ($bfcb035c6f32f2dc$var$party) $bfcb035c6f32f2dc$var$party.pos = $bfcb035c6f32f2dc$var$partyNow();
    // Nothing else repaints the tiles the team has LEFT. The animation loop
    // covers that while it is running (it redraws the neighbourhood every
    // frame), but two cases have no loop to rely on: reduced motion, which
    // never starts one, and the end of a raid, which clears the party and
    // would otherwise leave three figures standing on the last tile until the
    // round-robin happened past them.
    var cellOf = function(q) {
        return q && "".concat(Math.round(q.row), ",").concat(Math.round(q.col));
    };
    if ($bfcb035c6f32f2dc$var$reducedMotion || !$bfcb035c6f32f2dc$var$party) {
        if (cellOf(was) !== cellOf($bfcb035c6f32f2dc$var$party && $bfcb035c6f32f2dc$var$party.pos)) {
            $bfcb035c6f32f2dc$var$redrawNearParty(was);
            $bfcb035c6f32f2dc$var$redrawNearParty($bfcb035c6f32f2dc$var$party && $bfcb035c6f32f2dc$var$party.pos);
        }
    }
}
// Resolve the party snapshot against the wall clock. Returns what partyAt
// returns, or null when no raid is running.
function $bfcb035c6f32f2dc$var$partyNow() {
    var _party_raid, _party_path;
    if (!$bfcb035c6f32f2dc$var$party) return null;
    var _stepClock = (0, $00f2bfbf94a5f5a3$export$340c4cb4c285ee0f)($bfcb035c6f32f2dc$var$party.raid, Date.now()), elapsedMs = _stepClock.elapsedMs, durationMs = _stepClock.durationMs;
    var _party_raid_currentRoomIndex;
    // The step index comes off the LIVE raid when there is one, not off the
    // snapshot: the index and the schedule have to be from the same tick. A
    // room that ended between two pushes would otherwise pair a fresh
    // roomStartTime with the previous step and put the team back at the tile
    // they just left for the rest of the second.
    var index = (_party_raid_currentRoomIndex = (_party_raid = $bfcb035c6f32f2dc$var$party.raid) === null || _party_raid === void 0 ? void 0 : _party_raid.currentRoomIndex) !== null && _party_raid_currentRoomIndex !== void 0 ? _party_raid_currentRoomIndex : $bfcb035c6f32f2dc$var$party.index;
    // The tile's own stage first: how far the team spreads decides how long the
    // spreading takes, and where it gathers decides how far it has to walk to
    // get there. Both come out of the tile's ground plan.
    var stage = $bfcb035c6f32f2dc$var$stageFor((_party_path = $bfcb035c6f32f2dc$var$party.path) === null || _party_path === void 0 ? void 0 : _party_path[index], $bfcb035c6f32f2dc$var$party.members.length);
    return (0, $00f2bfbf94a5f5a3$export$e35a622415b5919f)($bfcb035c6f32f2dc$var$party.path, index, elapsedMs, durationMs, stage);
}
// What this tile makes of the party: the standing posts, how far they are
// spread, and where the party gathers. Worked out once per path step and
// cached, because it is a scan over the tile's footprints and it cannot change
// while the team is standing on it.
//
// The ground plan is the renderer's own record of where it put the buildings
// and the water, so the team is kept off exactly what the map drew rather than
// off a guess about what it might have drawn.
function $bfcb035c6f32f2dc$var$stageFor(step, count) {
    var _cell_tile, _step_room;
    if (!step) return null;
    var key = "".concat(step.row, ",").concat(step.col, ",").concat(count);
    if ($bfcb035c6f32f2dc$var$party.stageKey === key) return $bfcb035c6f32f2dc$var$party.stage;
    var cell = $bfcb035c6f32f2dc$var$animCells.find(function(c) {
        return c.row === step.row && c.col === step.col;
    });
    var plan = (0, $00f2bfbf94a5f5a3$export$210e317b6c4ae768)(cell === null || cell === void 0 ? void 0 : (_cell_tile = cell.tile) === null || _cell_tile === void 0 ? void 0 : _cell_tile.plan, (0, $3c042d4e8c9507db$export$3175e1b22a5f59e8));
    // Seeded by the tile, so a given room lays its posts out the same way every
    // time the team walks into it, exactly as its art is the same every time.
    $bfcb035c6f32f2dc$var$party.stageKey = key;
    $bfcb035c6f32f2dc$var$party.stage = (0, $00f2bfbf94a5f5a3$export$5c7563bc4285410)(plan, count, step.row * 31 + step.col * 17 >>> 0, (_step_room = step.room) === null || _step_room === void 0 ? void 0 : _step_room.type);
    return $bfcb035c6f32f2dc$var$party.stage;
}
function $bfcb035c6f32f2dc$export$72b470d5f7d48c79() {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // drop the cached still layers with the cells — a tier-3 grid holds ~9MB
        // of them, and a new raid rebuilds every tile anyway
        for(var _iterator = $bfcb035c6f32f2dc$var$animCells[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var c = _step.value;
            c.tile.canvas = null;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    $bfcb035c6f32f2dc$var$animCells = [];
    $bfcb035c6f32f2dc$var$animRegionId = null;
    $bfcb035c6f32f2dc$var$animSite = null;
    $bfcb035c6f32f2dc$var$party = null;
    $bfcb035c6f32f2dc$var$fx = [];
    (0, $cf1d0720eef4c612$export$fd4b5295b61ee6bc)();
    $bfcb035c6f32f2dc$var$setTransit(false);
    $bfcb035c6f32f2dc$var$drawCursor = 0;
    $bfcb035c6f32f2dc$var$maxCol = 0;
    $bfcb035c6f32f2dc$var$lastLayoutCheck = 0;
    $bfcb035c6f32f2dc$var$gridVisible = false;
    $bfcb035c6f32f2dc$var$vpEl = null;
    $bfcb035c6f32f2dc$var$vpW = 0;
    $bfcb035c6f32f2dc$var$colW = 0;
}
// offsetParent, scrollWidth and clientWidth each force a style + layout
// flush, so they're sampled on the slow cadence rather than every frame;
// only scrollLeft (which has to track the user's scrolling) is read live.
function $bfcb035c6f32f2dc$var$refreshLayout() {
    var grid = document.getElementById('raid-grid');
    // Raid tab not visible — the loop stays scheduled but skips the work
    // (the browser already pauses rAF entirely when the window is hidden)
    $bfcb035c6f32f2dc$var$gridVisible = !!grid && grid.offsetParent !== null;
    $bfcb035c6f32f2dc$var$vpEl = document.getElementById('raid-grid-viewport');
    $bfcb035c6f32f2dc$var$vpW = $bfcb035c6f32f2dc$var$vpEl ? $bfcb035c6f32f2dc$var$vpEl.clientWidth : 0;
    $bfcb035c6f32f2dc$var$colW = $bfcb035c6f32f2dc$var$gridVisible && $bfcb035c6f32f2dc$var$vpEl && $bfcb035c6f32f2dc$var$maxCol > 0 && $bfcb035c6f32f2dc$var$vpEl.scrollWidth > $bfcb035c6f32f2dc$var$vpW ? $bfcb035c6f32f2dc$var$vpEl.scrollWidth / ($bfcb035c6f32f2dc$var$maxCol + 1) : 0;
}
// ============================================================================
// DAY-CLOCK BAR (#raid-day-clock, above the raid grid)
// ============================================================================
// A window onto 1/3 of the game day: the gradient (one full day = 3 bar
// widths) and the dawn/noon/dusk/midnight icons scroll right-to-left as time
// passes, wrapping around; the fixed center marker is "now".
//
// Since S9 the bar reads the RAIDING REGION's local time, and says so: the
// readout is the only place the world clock is legible as a number, and
// "17:42" over an unnamed bar invites the player to assume it is the same
// 17:42 everywhere.
// Icon markers live in index.html as .raid-day-clock-icon spans with
// data-phase attributes — noon (0.5) and midnight (0). Sunrise and sunset are
// worldClock-core's SUNRISE/SUNSET, and they read off the gradient without
// needing their own glyphs.
// One static gradient sampling the daylight curve across a full day,
// night-navy -> dawn-amber -> noon-cream -> dusk-amber -> navy
function $bfcb035c6f32f2dc$var$buildDayGradient() {
    var _loop = function(i) {
        var phase = i / 24;
        var light = ((0, $05f2074f6c82f4e0$export$a16ed293100b6f71)(phase) - 0.4) / 0.6; // 0..1
        // blend night->warm->day: warm band in the transition
        var t = light, w = Math.max(0, 1 - Math.abs(t - 0.45) / 0.35); // warmth bump around transitions
        var mix = function(a, b, f) {
            return Math.round(a + (b - a) * f);
        };
        var base = night.map(function(n, ch) {
            return mix(n, day[ch], t);
        });
        var rgb = base.map(function(b, ch) {
            return mix(b, warm[ch], w * 0.55);
        });
        stops.push("rgb(".concat(rgb.join(','), ") ").concat((phase * 100).toFixed(1), "%"));
    };
    var night = [
        26,
        33,
        58
    ], day = [
        255,
        236,
        179
    ], warm = [
        255,
        171,
        94
    ];
    var stops = [];
    for(var i = 0; i <= 24; i++)_loop(i);
    return "linear-gradient(90deg, ".concat(stops.join(', '), ")");
}
var $bfcb035c6f32f2dc$var$clockInitialized = false;
function $bfcb035c6f32f2dc$var$updateDayClock() {
    var track = document.getElementById('raid-day-clock-track');
    if (!track) return;
    if (!$bfcb035c6f32f2dc$var$clockInitialized) {
        track.style.backgroundImage = $bfcb035c6f32f2dc$var$buildDayGradient();
        track.style.backgroundSize = '300% 100%';
        track.style.backgroundRepeat = 'repeat-x';
        $bfcb035c6f32f2dc$var$clockInitialized = true;
    }
    var local = (0, $05f2074f6c82f4e0$export$e15059ad23f67dd4)($bfcb035c6f32f2dc$var$animRegionId, $bfcb035c6f32f2dc$var$animSite);
    var readout = document.getElementById('raid-day-clock-readout');
    if (readout) {
        var _config_raidRegions_animRegionId, _config_raidRegions;
        var regionName = (_config_raidRegions = $979b99378be707cd$export$4fbdcec70fce9d73) === null || _config_raidRegions === void 0 ? void 0 : (_config_raidRegions_animRegionId = _config_raidRegions[$bfcb035c6f32f2dc$var$animRegionId]) === null || _config_raidRegions_animRegionId === void 0 ? void 0 : _config_raidRegions_animRegionId.name;
        readout.textContent = "".concat(local.icon, " ").concat(local.time);
        readout.title = regionName ? "".concat(regionName, " \u2014 local time at THIS raid site, ").concat(local.name, ". A region spans several hours of longitude, so the next raid there can meet a different sun. The map's daylight follows this clock.") : "Local time \u2014 ".concat(local.name);
    }
    var width = track.clientWidth;
    if (!width) return;
    var dayPhase = local.phase;
    var lineNow = document.getElementById('raid-day-clock-now');
    var lineNowColor = (1 - (0, $05f2074f6c82f4e0$export$a16ed293100b6f71)(dayPhase)) * 255;
    lineNow.style.backgroundColor = "rgb(".concat(lineNowColor, ",").concat(lineNowColor, ",").concat(lineNowColor, ")");
    // gradient's t=dayPhase point sits at the bar center; repeat-x wraps
    track.style.backgroundPositionX = "".concat(width / 2 - dayPhase * 3 * width, "px");
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = track.querySelectorAll('.raid-day-clock-icon')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var el = _step.value;
            var phase = parseFloat(el.dataset.phase);
            var delta = (phase - dayPhase + 1.5) % 1 - 0.5; // days from now, [-0.5, 0.5)
            el.style.left = "".concat(width / 2 + delta * 3 * width, "px");
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $bfcb035c6f32f2dc$export$5f82487e371f5e57(cellEl, room, conn, regionKey) {
    if (typeof document === 'undefined' || !room || !room.name) return;
    // Belt and braces for the tile palette, which is keyed to the region: a
    // caller that forgot setRaidSite still gets the right art, and the clock
    // falls back to the region capital rather than the meridian.
    if (!$bfcb035c6f32f2dc$var$animRegionId) $bfcb035c6f32f2dc$var$animRegionId = regionKey;
    var recipe = typeof room.recipe === 'string' && (0, $3c042d4e8c9507db$export$a571935592b1ff4d)[room.recipe] ? room.recipe : (0, $3c042d4e8c9507db$export$5f148632ad7917b2)(room.name, room.category, room.type);
    // Position-salted seed: persisted row/col keep compositions stable
    // across reloads while twin rooms get distinct layouts
    var salt = room.row != null ? "@".concat(room.row, ",").concat(room.col) : '';
    var canvas = document.createElement('canvas');
    canvas.width = (0, $3c042d4e8c9507db$export$3175e1b22a5f59e8);
    canvas.height = (0, $3c042d4e8c9507db$export$3175e1b22a5f59e8);
    canvas.className = 'room-tile-canvas';
    cellEl.prepend(canvas);
    var cell = {
        ctx: canvas.getContext('2d'),
        tile: (0, $3c042d4e8c9507db$export$9b747065b14bfa5f)(regionKey, recipe, room.name, {
            salt: salt,
            conn: conn,
            roomType: room.type,
            col: room.col,
            row: room.row,
            // the skill this room's encounter tests, for its map anchor;
            // absent on roads, water, campsites, entry/exit and blocked cells
            primary: room.primary,
            indoor: $bfcb035c6f32f2dc$var$isIndoorEncounter(room),
            // the generated road layer: which way the roadway leaves this tile,
            // and whether it is the trunk or a branch. Absent on most tiles.
            road: room.road,
            roadRank: room.roadRank,
            // steps to the nearest roadway: how built-up this tile is allowed
            // to be, so development thickens along the routes and thins out
            // behind them
            roadDist: room.roadDist,
            // the district this cell sits in: how built up the ground around it
            // is, and so how much growth and how worn a road gets. Distance to
            // a road cannot say that — there are busy back lots and empty
            // frontages — and it is what makes an outskirt look like one.
            zone: room.zone,
            // how far this cell is from the open ocean, in whole tiles, and
            // which edge of the map that is. Only a region the sea got into
            // has them; everywhere else they are absent and nothing floods.
            shore: room.shore,
            shoreSide: room.shoreSide,
            // the sublevel's rail spur — one column of the map, laid like a road
            rail: room.rail,
            // which sides a rest stop or shoreline carries its open ground
            // across, so two clearings side by side read as one
            clearing: room.clearing
        }),
        row: room.row,
        col: room.col
    };
    if (room.col != null && room.col > $bfcb035c6f32f2dc$var$maxCol) $bfcb035c6f32f2dc$var$maxCol = room.col;
    $bfcb035c6f32f2dc$var$animCells.push(cell);
    // First frame immediately so the grid is never blank; for reduced-motion
    // users this is also the final (static) picture (clock included)
    (0, $3c042d4e8c9507db$export$ca17ef1db7f8dd8f)(cell.tile, $bfcb035c6f32f2dc$export$8a6e680b278759fc());
    $bfcb035c6f32f2dc$var$drawCell(cell, $bfcb035c6f32f2dc$var$animParams(performance.now(), 0), $bfcb035c6f32f2dc$var$partyNow());
    $bfcb035c6f32f2dc$var$updateDayClock();
    if (!$bfcb035c6f32f2dc$var$reducedMotion && $bfcb035c6f32f2dc$var$rafId == null) {
        $bfcb035c6f32f2dc$var$lastFrame = 0;
        $bfcb035c6f32f2dc$var$rafId = requestAnimationFrame($bfcb035c6f32f2dc$var$animFrame);
    }
}
function $bfcb035c6f32f2dc$var$animParams(ts, dt) {
    var t = ts / 1000;
    var wind = $bfcb035c6f32f2dc$var$BASE_WIND * (0.7 + 0.3 * Math.sin(t * 0.35) + 0.2 * Math.sin(t * 1.3));
    var dayPhase = $bfcb035c6f32f2dc$export$8a6e680b278759fc();
    $bfcb035c6f32f2dc$var$cloudX += dt * (3 + wind * 12);
    $bfcb035c6f32f2dc$var$cloudY += dt * (1 + wind * 4);
    var cover = $bfcb035c6f32f2dc$var$CLOUD_BASE * (0.85 + 0.3 * Math.sin(t * 0.04) + 0.15 * Math.sin(t * 0.017));
    // Effects are posted by the raid loop, which runs on the wall clock, so
    // they are timed against that rather than against `t` (which counts from
    // whenever the page happened to load).
    return {
        wind: wind,
        dayPhase: dayPhase,
        t: t,
        nowMs: Date.now(),
        cloud: {
            cover: cover,
            x: $bfcb035c6f32f2dc$var$cloudX,
            y: $bfcb035c6f32f2dc$var$cloudY
        }
    };
}
function $bfcb035c6f32f2dc$var$drawCell(c, p, pos) {
    var _party_stage, _party_stage1;
    (0, $3c042d4e8c9507db$export$217de4d82c975a34)(c.ctx, c.tile, (0, $715bf31211e65705$export$71511d61b312f219)((0, $fa9769297b8a68c8$export$71511d61b312f219)({}, p), {
        row: c.row,
        col: c.col
    }));
    // The team goes on last, over everything the tile is and everything
    // overhead. Their pixel position is relative to THIS canvas, so a party
    // between two tiles is drawn on both and each clips its own half.
    if ($bfcb035c6f32f2dc$var$party && pos && Math.abs(pos.col - c.col) <= $bfcb035c6f32f2dc$var$DRAW_R && Math.abs(pos.row - c.row) <= $bfcb035c6f32f2dc$var$DRAW_R) (0, $babd2312889b27ed$export$d0f529c5e2e21188)(c.ctx, (pos.col - c.col + 0.5) * (0, $3c042d4e8c9507db$export$3175e1b22a5f59e8), (pos.row - c.row + 0.5) * (0, $3c042d4e8c9507db$export$3175e1b22a5f59e8), {
        party: pos,
        members: $bfcb035c6f32f2dc$var$party.members,
        tSec: p.t,
        dayPhase: p.dayPhase,
        tile: (0, $3c042d4e8c9507db$export$3175e1b22a5f59e8),
        posts: (_party_stage = $bfcb035c6f32f2dc$var$party.stage) === null || _party_stage === void 0 ? void 0 : _party_stage.postOffsets,
        resting: (_party_stage1 = $bfcb035c6f32f2dc$var$party.stage) === null || _party_stage1 === void 0 ? void 0 : _party_stage1.resting,
        fx: $bfcb035c6f32f2dc$var$fx,
        nowMs: p.nowMs
    });
}
// Repaint every tile within reach of `at`, off the animation loop's cadence.
// The team is drawn from the party's CURRENT position, so passing an old one
// here is how a tile they have left gets cleared.
function $bfcb035c6f32f2dc$var$redrawNearParty(at) {
    if (!at || !$bfcb035c6f32f2dc$var$animCells.length) return;
    var pos = $bfcb035c6f32f2dc$var$partyNow();
    var p = $bfcb035c6f32f2dc$var$animParams(typeof performance !== 'undefined' ? performance.now() : 0, 0);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $bfcb035c6f32f2dc$var$animCells[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var c = _step.value;
            if (!$bfcb035c6f32f2dc$var$nearParty(c, at)) continue;
            (0, $3c042d4e8c9507db$export$ca17ef1db7f8dd8f)(c.tile, p.dayPhase);
            $bfcb035c6f32f2dc$var$drawCell(c, p, pos);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
// ---- the current room's zoom, and why the map has to switch it off ----
// The room the team is in is magnified (styles.css `.current-room`), which is
// a good way to say "here" and a bad way to cross a boundary: the team is
// drawn on BOTH tiles either side of a seam and each canvas clips its own
// half, so a magnified tile beside an unmagnified one splits the party into
// two different sizes down the join.
//
// So the zoom is dropped for as long as the team is between tiles and put back
// once they have settled. `walking` is exactly that window — it is true for the
// walk out and the walk in and false for the whole dwell — and it starts a full
// half-tile before they reach the edge, which is seconds of room for the CSS
// transition to finish in. A road, where the team never stops, never zooms.
var $bfcb035c6f32f2dc$var$transit = false;
function $bfcb035c6f32f2dc$var$setTransit(on) {
    var _document_getElementById;
    if (on === $bfcb035c6f32f2dc$var$transit) return;
    $bfcb035c6f32f2dc$var$transit = on;
    (_document_getElementById = document.getElementById('raid-grid')) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.classList.toggle('team-in-transit', on);
}
// Is this cell close enough to the party to need repainting every frame?
// Generous by a full tile beyond where a figure can be drawn, so leaving a
// tile clears it in the same frame.
function $bfcb035c6f32f2dc$var$nearParty(c, pos) {
    return !!pos && c.col != null && Math.abs(pos.col - c.col) <= $bfcb035c6f32f2dc$var$FORCE_R && Math.abs(pos.row - c.row) <= $bfcb035c6f32f2dc$var$FORCE_R;
}
function $bfcb035c6f32f2dc$var$animFrame(ts) {
    if ($bfcb035c6f32f2dc$var$animCells.length === 0) {
        $bfcb035c6f32f2dc$var$rafId = null;
        return;
    }
    $bfcb035c6f32f2dc$var$rafId = requestAnimationFrame($bfcb035c6f32f2dc$var$animFrame);
    if (ts - $bfcb035c6f32f2dc$var$lastFrame < (document.hasFocus() ? $bfcb035c6f32f2dc$var$FRAME_MS : $bfcb035c6f32f2dc$var$BLUR_FRAME_MS)) return;
    // dt caps at the background interval so cloud drift stays wall-clock
    // honest at 2fps, while a return from a long pause can't jump the sky
    var dt = $bfcb035c6f32f2dc$var$lastFrame ? Math.min($bfcb035c6f32f2dc$var$BLUR_FRAME_MS / 1000, (ts - $bfcb035c6f32f2dc$var$lastFrame) / 1000) : 0;
    $bfcb035c6f32f2dc$var$lastFrame = ts;
    if (ts - $bfcb035c6f32f2dc$var$lastLayoutCheck > $bfcb035c6f32f2dc$var$LAYOUT_MS) {
        $bfcb035c6f32f2dc$var$lastLayoutCheck = ts;
        $bfcb035c6f32f2dc$var$refreshLayout();
    }
    if (!$bfcb035c6f32f2dc$var$gridVisible) return;
    var p = $bfcb035c6f32f2dc$var$animParams(ts, dt);
    // Collect whatever the raid resolved since the last frame, and drop what
    // has finished playing. Drained even with no party on the map so a queue
    // posted while the screen was elsewhere cannot arrive stale later.
    var posted = (0, $cf1d0720eef4c612$export$e81dc0d2f0f0a3e4)();
    if (posted.length) $bfcb035c6f32f2dc$var$fx = $bfcb035c6f32f2dc$var$party ? $bfcb035c6f32f2dc$var$fx.concat(posted) : [];
    if ($bfcb035c6f32f2dc$var$fx.length) $bfcb035c6f32f2dc$var$fx = (0, $cf1d0720eef4c612$export$4eb22852cf19c442)($bfcb035c6f32f2dc$var$fx, p.nowMs);
    // Sweep the still layers back up to date after the sun moves them. The
    // check is cheap and returns false for a cell that is already current,
    // so scanning from the front each frame walks the sweep forward on its
    // own — no dirty queue to keep in sync with the cell list.
    for(var i = 0, repainted = 0; i < $bfcb035c6f32f2dc$var$animCells.length && repainted < $bfcb035c6f32f2dc$var$STATIC_BUDGET; i++)if ((0, $3c042d4e8c9507db$export$ca17ef1db7f8dd8f)($bfcb035c6f32f2dc$var$animCells[i].tile, p.dayPhase)) repainted++;
    // Viewport column culling: #raid-grid-viewport scrolls horizontally on
    // tier 2/3, and the grid is uniform - the visible column window falls
    // straight out of the scroll offsets, no per-cell rect queries. The ±2
    // column margin absorbs the grid's inner padding and keeps edge tiles
    // fresh mid-scroll; a cell scrolled into view redraws within a frame
    // or two when the rotation reaches it.
    var colMin = -Infinity, colMax = Infinity;
    if ($bfcb035c6f32f2dc$var$colW) {
        colMin = Math.floor($bfcb035c6f32f2dc$var$vpEl.scrollLeft / $bfcb035c6f32f2dc$var$colW) - 2;
        colMax = Math.ceil(($bfcb035c6f32f2dc$var$vpEl.scrollLeft + $bfcb035c6f32f2dc$var$vpW) / $bfcb035c6f32f2dc$var$colW) + 1;
    }
    // The team's own neighbourhood is drawn first and every frame, outside
    // both the rotation and the column cull: it is the one part of the map
    // that MUST be current, and it is a couple of dozen cells at most.
    var pos = $bfcb035c6f32f2dc$var$partyNow();
    // Drop the current room's zoom while the team is crossing between tiles.
    $bfcb035c6f32f2dc$var$setTransit(!!pos && pos.walking);
    var len = $bfcb035c6f32f2dc$var$animCells.length;
    var drawn = 0;
    if (pos) for(var i1 = 0; i1 < len; i1++){
        var c = $bfcb035c6f32f2dc$var$animCells[i1];
        if (!$bfcb035c6f32f2dc$var$nearParty(c, pos)) continue;
        $bfcb035c6f32f2dc$var$drawCell(c, p, pos);
        c.partyFrame = ts;
        drawn++;
    }
    // Rotate through the rest under the frame budget (see FRAME_BUDGET);
    // culled cells cost nothing and don't consume budget, so the visible
    // window refreshes at full rate
    for(var scanned = 0; scanned < len && drawn < $bfcb035c6f32f2dc$var$FRAME_BUDGET; scanned++){
        var c1 = $bfcb035c6f32f2dc$var$animCells[$bfcb035c6f32f2dc$var$drawCursor % len];
        $bfcb035c6f32f2dc$var$drawCursor++;
        if (c1.partyFrame === ts) continue; // already drawn above
        if (c1.col != null && (c1.col < colMin || c1.col > colMax)) continue;
        $bfcb035c6f32f2dc$var$drawCell(c1, p, pos);
        drawn++;
    }
    // The clock crawls (a full day = 10 minutes): 4Hz DOM writes are plenty
    if (ts - $bfcb035c6f32f2dc$var$lastClockUpdate > 250) {
        $bfcb035c6f32f2dc$var$lastClockUpdate = ts;
        $bfcb035c6f32f2dc$var$updateDayClock();
    }
}




/**
 * Raid Logic Core - Pure Functions
 *
 * Extract pure game logic functions from raid.js without browser dependencies
 *
 * These are exact copies of functions from raid.js that:
 * - Calculate drop rates and loot pools
 * - Generate raid grid layouts
 * - Determine faction-based drops
 * - Validate paths and calculate game mechanics
 *
 * Can be imported and used in Node.js for testing and simulation
 */ 









//done
//@ts-check

function $bcce38db0d2b4516$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $53f3ce6e74f6aaad$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $53f3ce6e74f6aaad$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $53f3ce6e74f6aaad$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $53f3ce6e74f6aaad$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}










// Multiplayer system using Cloudflare Pages Functions (functions/api/*) + Neon PostgreSQL
// Falls back to local storage when offline or headless
// How long a marketplace listing response stays reusable. Long enough to collapse
// the burst of refreshes fired during page load, short enough that another
// player's listing shows up promptly. Mutations clear the cache outright.
var $fde0976ce5d1665d$var$MARKETPLACE_CACHE_MS = 5000;
// Sticky opt-in for talking to a locally-served API (see the constructor).
// `?multiplayer=1` turns it on and persists; `?multiplayer=0` turns it back off.
// localStorage access can throw (private mode), so treat any failure as "off".
function $fde0976ce5d1665d$var$readMultiplayerOverride() {
    try {
        var param = new URLSearchParams(window.location.search).get('multiplayer');
        if (param === '1') localStorage.setItem('forceMultiplayer', '1');
        else if (param === '0') localStorage.removeItem('forceMultiplayer');
        return localStorage.getItem('forceMultiplayer') === '1';
    } catch (error) {
        return false;
    }
}
var $fde0976ce5d1665d$var$MultiplayerSystem = /*#__PURE__*/ function() {
    "use strict";
    function MultiplayerSystem() {
        var _this = this;
        (0, $bcce38db0d2b4516$export$71511d61b312f219)(this, MultiplayerSystem);
        // Headless environments (Node simulator/tests) have no window; run local/offline
        var hasWindow = typeof window !== 'undefined';
        // Check if we're in local development (no actual server)
        this.isLocalDevelopment = !hasWindow || window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.protocol === 'file:';
        // Local dev forces offline because `npm run dev` (Parcel) serves no API.
        // `npm run dev:api` DOES serve the real Pages Functions locally, so opt in
        // with ?multiplayer=1 to exercise the marketplace end-to-end against real
        // server logic (see README "Testing marketplace behavior locally").
        // Gated on hasWindow so the headless simulator/tests always stay offline.
        this.forceMultiplayer = hasWindow && $fde0976ce5d1665d$var$readMultiplayerOverride();
        // Override online status for local development
        this.isOnline = hasWindow && navigator.onLine && (!this.isLocalDevelopment || this.forceMultiplayer);
        this.baseUrl = hasWindow ? window.location.origin : '';
        this.localCharacters = this.loadLocalCharacters();
        this._marketplaceCache = new Map(); // key -> { value, at } | { promise }
        if (hasWindow) {
            var mode = this.forceMultiplayer ? 'Local Development (multiplayer forced ON)' : this.isLocalDevelopment ? 'Local Development' : 'Production';
            (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "\uD83C\uDF10 Multiplayer mode: ".concat(mode));
            (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "\uD83D\uDCF6 Online status: ".concat(this.isOnline));
            if (this.forceMultiplayer) {
                // Easy mistake: the flag is sticky, so hitting the Parcel port with
                // it on makes every API call parse index.html as JSON ("Unexpected
                // token '<'") and every POST fail with a bare 405. Say which origin
                // we're actually calling, then confirm the API is really there.
                console.log("\uD83D\uDD27 API base: ".concat(this.baseUrl, " \u2014 this must be the port serving /api (npm run dev:api, default 8788), NOT the Parcel port. Use ?multiplayer=0 to turn this off."));
                this.verifyLocalApi();
            }
            // Listen for online/offline events
            window.addEventListener('online', function() {
                _this.isOnline = navigator.onLine && (!_this.isLocalDevelopment || _this.forceMultiplayer);
                (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "Multiplayer: Network online, effective status: ".concat(_this.isOnline));
            });
            window.addEventListener('offline', function() {
                _this.isOnline = false;
                (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, 'Multiplayer: Gone offline, using local storage');
            });
        }
    }
    (0, $53f3ce6e74f6aaad$export$71511d61b312f219)(MultiplayerSystem, [
        {
            key: "verifyLocalApi",
            value: // Confirm the forced-on API base is actually serving the Pages Functions.
            // Pointing ?multiplayer=1 at the Parcel port is the easy mistake, and it fails
            // confusingly: GETs return index.html ("Unexpected token '<'") and POSTs come
            // back as a bare 405 from the static server. Detect that once, up front, and
            // fail closed so the game drops back to offline instead of spraying dozens of
            // misleading errors. Fire-and-forget from the constructor.
            function verifyLocalApi() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                    var response, contentType, error;
                    return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    fetch("".concat(this.baseUrl, "/api/characters?action=my-listings&ids="))
                                ];
                            case 1:
                                response = _state.sent();
                                contentType = response.headers.get('content-type') || '';
                                if (contentType.includes('application/json')) return [
                                    2
                                ]; // API is live
                                this.isOnline = false;
                                console.error("\u274C Multiplayer forced ON, but ".concat(this.baseUrl, " is not serving the API ") + "(got HTTP ".concat(response.status, ', content-type "').concat(contentType || 'unknown', '"). ') + "Multiplayer disabled for this session to avoid misleading errors.\n" + 'Fix: run "npm run dev:api" and open http://localhost:8788/?multiplayer=1 ' + "\u2014 the Parcel port (3000) serves no API.");
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                error = _state.sent();
                                this.isOnline = false;
                                console.error("\u274C Multiplayer forced ON, but ".concat(this.baseUrl, "/api is unreachable (").concat(error.message, "). ") + 'Start it with "npm run dev:api". Multiplayer disabled for this session.');
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            // Load characters from local storage (fallback)
            key: "loadLocalCharacters",
            value: function loadLocalCharacters() {
                if (typeof localStorage === 'undefined') return [];
                try {
                    return JSON.parse(localStorage.getItem('multiplayerCharacters') || '[]');
                } catch (error) {
                    console.error('Error loading local characters:', error);
                    return [];
                }
            }
        },
        {
            // Save characters to local storage (fallback)
            key: "saveLocalCharacters",
            value: function saveLocalCharacters() {
                if (typeof localStorage === 'undefined') return;
                try {
                    localStorage.setItem('multiplayerCharacters', JSON.stringify(this.localCharacters));
                } catch (error) {
                    console.error('Error saving local characters:', error);
                }
            }
        },
        {
            key: "isCharacterNameUnique",
            value: // Check if character name is unique globally
            function isCharacterNameUnique(name) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                    var conflicts, isUnique, response, data, error;
                    return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, '\uD83D\uDD0D Checking uniqueness for: "'.concat(name, '"'));
                                (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "\uD83D\uDCF6 Online status: ".concat(this.isOnline));
                                if (!this.isOnline) {
                                    // Offline fallback - check local storage for global uniqueness
                                    (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "\uD83D\uDCCA Checking against ".concat(this.localCharacters.length, " local characters:"), this.localCharacters);
                                    conflicts = this.localCharacters.filter(function(char) {
                                        return char.name.toLowerCase() === name.toLowerCase();
                                    });
                                    (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "\u2694\uFE0F Name conflicts found:", conflicts);
                                    isUnique = conflicts.length === 0;
                                    (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, '\u2705 Name "'.concat(name, '" is unique: ').concat(isUnique));
                                    return [
                                        2,
                                        isUnique
                                    ];
                                }
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    fetch("".concat(this.baseUrl, "/api/characters?action=check-name&name=").concat(encodeURIComponent(name)))
                                ];
                            case 2:
                                response = _state.sent();
                                return [
                                    4,
                                    response.json()
                                ];
                            case 3:
                                data = _state.sent();
                                if (data.success) return [
                                    2,
                                    data.isUnique
                                ];
                                else {
                                    console.error('Name check failed:', data.message);
                                    return [
                                        2,
                                        false
                                    ];
                                }
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                error = _state.sent();
                                console.error('Error checking name uniqueness:', error);
                                // Fallback to local check for global uniqueness
                                return [
                                    2,
                                    !this.localCharacters.some(function(char) {
                                        return char.name.toLowerCase() === name.toLowerCase();
                                    })
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "registerCharacter",
            value: // Register a new character
            function registerCharacter(character) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                    var response, data, error;
                    return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!this.isOnline) throw new Error('Cannot register character while offline');
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    fetch("".concat(this.baseUrl, "/api/characters?action=create"), {
                                        method: 'POST',
                                        headers: {
                                            'Content-Type': 'application/json'
                                        },
                                        body: JSON.stringify({
                                            // Identity/cosmetic only — the server sets all stats (hardened create).
                                            name: character.name,
                                            faction: character.faction,
                                            avatar: character.avatar,
                                            avatarSeed: character.avatarSeed || null,
                                            avatarFeatures: character.avatarFeatures || null,
                                            title: character.title || null,
                                            quote: character.quote || null
                                        })
                                    })
                                ];
                            case 2:
                                response = _state.sent();
                                return [
                                    4,
                                    response.json()
                                ];
                            case 3:
                                data = _state.sent();
                                if (data.success) // Attach the one-time ownership token to the returned row so the
                                // caller can persist it on the character (see gameState §2).
                                return [
                                    2,
                                    (0, $715bf31211e65705$export$71511d61b312f219)((0, $fa9769297b8a68c8$export$71511d61b312f219)({}, data.character), {
                                        ownerToken: data.token
                                    })
                                ];
                                else throw new Error(data.message);
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                error = _state.sent();
                                console.error('Error registering character:', error);
                                throw error;
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "claimLegacyCharacter",
            value: // Claim a pre-token (legacy) character row, upgrading it from open "grace"
            // writes to token-owned. Only succeeds for eligible rows (server-checked:
            // null hash, level <= 2, no artifacts/gear). Returns the new token or null.
            function claimLegacyCharacter(characterId) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                    var response, data, error;
                    return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!this.isOnline || !characterId) return [
                                    2,
                                    null
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    fetch("".concat(this.baseUrl, "/api/characters?action=claim-legacy"), {
                                        method: 'POST',
                                        headers: {
                                            'Content-Type': 'application/json'
                                        },
                                        body: JSON.stringify({
                                            characterId: characterId
                                        })
                                    })
                                ];
                            case 2:
                                response = _state.sent();
                                return [
                                    4,
                                    response.json()
                                ];
                            case 3:
                                data = _state.sent();
                                return [
                                    2,
                                    data.success ? data.token : null
                                ];
                            case 4:
                                error = _state.sent();
                                console.error('Error claiming legacy character:', error);
                                return [
                                    2,
                                    null
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            // Build request headers, attaching the ownership token for the character
            // with this multiplayerId when we hold it (looked up from gameState). The
            // server requires it for writes to a token-bearing row.
            key: "_authHeaders",
            value: function _authHeaders(characterId) {
                var headers = {
                    'Content-Type': 'application/json'
                };
                var owner = ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).characters || []).find(function(c) {
                    return c.multiplayerId === characterId;
                });
                if (owner === null || owner === void 0 ? void 0 : owner.ownerToken) headers['Authorization'] = "Bearer ".concat(owner.ownerToken);
                return headers;
            }
        },
        {
            key: "updateCharacter",
            value: // Update character data
            function updateCharacter(characterId, updates) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                    var localIndex, response, data, error;
                    return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Update local character if it exists
                                localIndex = this.localCharacters.findIndex(function(char) {
                                    return char.id === characterId;
                                });
                                if (localIndex !== -1) {
                                    this.localCharacters[localIndex] = (0, $fa9769297b8a68c8$export$71511d61b312f219)({}, this.localCharacters[localIndex], updates);
                                    this.saveLocalCharacters();
                                }
                                if (!this.isOnline) return [
                                    2
                                ]; // Only local update needed
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    fetch("".concat(this.baseUrl, "/api/characters"), {
                                        method: 'PUT',
                                        headers: this._authHeaders(characterId),
                                        body: JSON.stringify((0, $fa9769297b8a68c8$export$71511d61b312f219)({
                                            id: characterId
                                        }, updates))
                                    })
                                ];
                            case 2:
                                response = _state.sent();
                                return [
                                    4,
                                    response.json()
                                ];
                            case 3:
                                data = _state.sent();
                                if (!data.success) console.error('Error updating character:', data.message);
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                error = _state.sent();
                                console.error('Error updating character:', error);
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getAllContractors",
            value: // Get all available contractors
            function getAllContractors() {
                var excludeCharacterId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                    var contractors, url, response, data, error, localContractors;
                    return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                contractors = [];
                                if (!this.isOnline) return [
                                    3,
                                    5
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    4,
                                    ,
                                    5
                                ]);
                                url = excludeCharacterId ? "".concat(this.baseUrl, "/api/characters?action=contractors&exclude=").concat(excludeCharacterId) : "".concat(this.baseUrl, "/api/characters?action=contractors");
                                return [
                                    4,
                                    fetch(url)
                                ];
                            case 2:
                                response = _state.sent();
                                return [
                                    4,
                                    response.json()
                                ];
                            case 3:
                                data = _state.sent();
                                if (data.success) contractors = data.contractors.map(function(char) {
                                    return (0, $715bf31211e65705$export$71511d61b312f219)((0, $fa9769297b8a68c8$export$71511d61b312f219)({}, char), {
                                        isPlayerCharacter: true,
                                        isOnline: true
                                    });
                                });
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                error = _state.sent();
                                console.error('Error fetching online contractors:', error);
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                // Add local characters (excluding current character)
                                localContractors = this.localCharacters.filter(function(char) {
                                    return char.id !== excludeCharacterId;
                                }).map(function(char) {
                                    return (0, $715bf31211e65705$export$71511d61b312f219)((0, $fa9769297b8a68c8$export$71511d61b312f219)({}, char), {
                                        isPlayerCharacter: true,
                                        isLocal: true
                                    });
                                });
                                return [
                                    2,
                                    (0, $4c858c0d999a5b9b$export$71511d61b312f219)(contractors).concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)(localContractors))
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "listCharacterOnMarketplace",
            value: // List character on marketplace
            function listCharacterOnMarketplace(characterId) {
                var durationHours = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 24, rewardPercentage = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 15;
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                    var response, data, error;
                    return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "\uD83D\uDCE2 Listing character ".concat(characterId, " on marketplace for ").concat(durationHours, " hours"));
                                if (!this.isOnline) throw new Error('Cannot list characters on marketplace. Please connect to internet.');
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    4,
                                    ,
                                    5
                                ]);
                                (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, 'Sending request to list character on marketplace...');
                                return [
                                    4,
                                    fetch("".concat(this.baseUrl, "/api/characters?action=list-marketplace"), {
                                        method: 'POST',
                                        headers: this._authHeaders(characterId),
                                        body: JSON.stringify({
                                            characterId: characterId,
                                            durationHours: durationHours,
                                            rewardPercentage: rewardPercentage
                                        })
                                    })
                                ];
                            case 2:
                                response = _state.sent();
                                (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, 'Listing character on marketplace, response:', response);
                                return [
                                    4,
                                    response.json()
                                ];
                            case 3:
                                data = _state.sent();
                                (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, 'Listing character on marketplace, data:', data);
                                if (data.success) {
                                    this.invalidateMarketplaceCache();
                                    return [
                                        2,
                                        data.listing
                                    ];
                                } else throw new Error(data.message);
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                error = _state.sent();
                                console.error('Error listing character on marketplace:', error);
                                throw error;
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "claimContractCompletion",
            value: // Claim the un-hired contract-completion payout for an expired listing.
            // The server decides eligibility (expired, never hired, not already claimed)
            // and computes the reward; a payment then arrives via the normal pending
            // flow. Owner-authenticated. Returns the server response (may be
            // { claimed: false }) or null when offline.
            function claimContractCompletion(characterId) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                    var response, error;
                    return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!this.isOnline) return [
                                    2,
                                    null
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    fetch("".concat(this.baseUrl, "/api/characters?action=claim-contract-completion"), {
                                        method: 'POST',
                                        headers: this._authHeaders(characterId),
                                        body: JSON.stringify({
                                            characterId: characterId
                                        })
                                    })
                                ];
                            case 2:
                                response = _state.sent();
                                return [
                                    4,
                                    response.json()
                                ];
                            case 3:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 4:
                                error = _state.sent();
                                console.error('Error claiming contract completion:', error);
                                throw error;
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "removeCharacterFromMarketplace",
            value: // Remove character from marketplace
            function removeCharacterFromMarketplace(characterId) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                    var response, data, error;
                    return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!this.isOnline) throw new Error('Cannot access marketplace while offline');
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    fetch("".concat(this.baseUrl, "/api/characters?action=marketplace&id=").concat(characterId), {
                                        method: 'DELETE',
                                        headers: this._authHeaders(characterId)
                                    })
                                ];
                            case 2:
                                response = _state.sent();
                                return [
                                    4,
                                    response.json()
                                ];
                            case 3:
                                data = _state.sent();
                                if (data.success) this.invalidateMarketplaceCache();
                                return [
                                    2,
                                    data.success
                                ];
                            case 4:
                                error = _state.sent();
                                console.error('Error removing character from marketplace:', error);
                                throw error;
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getMarketplaceListings",
            value: // Get marketplace listings with optional level filtering.
            //
            // Page load fans out several near-simultaneous refreshes (Alpine store init,
            // displayContractors, the gameState load hook, the periodic timer), which
            // previously meant ~6 identical requests. Concurrent callers now share one
            // in-flight request, and the result is held for MARKETPLACE_CACHE_MS so a
            // burst collapses to a single call. Any marketplace mutation clears the cache
            // (see invalidateMarketplaceCache), so the UI never shows stale listings.
            function getMarketplaceListings() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                    var _this, minLevel, maxLevel, excludeIds, key, entry, promise;
                    var _arguments = arguments;
                    return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
                        _this = this;
                        minLevel = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : null, maxLevel = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : null, excludeIds = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : [];
                        if (!this.isOnline) return [
                            2,
                            []
                        ];
                        key = "".concat(minLevel, "|").concat(maxLevel, "|").concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)(excludeIds).sort().join(','));
                        entry = this._marketplaceCache.get(key);
                        if (entry) {
                            if (entry.promise) return [
                                2,
                                entry.promise
                            ]; // already in flight
                            if (Date.now() - entry.at < $fde0976ce5d1665d$var$MARKETPLACE_CACHE_MS) return [
                                2,
                                entry.value
                            ]; // still fresh
                        }
                        // `entry` (captured before we overwrite it below) carries the previous
                        // value + ETag, so a 304 can be answered from it without a body.
                        promise = this._fetchMarketplaceListings(minLevel, maxLevel, excludeIds, entry).then(function(param) {
                            var value = param.value, etag = param.etag;
                            _this._marketplaceCache.set(key, {
                                value: value,
                                etag: etag,
                                at: Date.now()
                            });
                            return value;
                        });
                        this._marketplaceCache.set(key, {
                            promise: promise
                        });
                        return [
                            2,
                            promise
                        ];
                    });
                }).apply(this, arguments);
            }
        },
        {
            key: "_fetchMarketplaceListings",
            value: // Uncached fetch. Never throws — callers treat [] as "nothing available".
            //
            // Sends If-None-Match when we've seen this list before. The contractors UI
            // polls every 10s, and listings rarely change, so the overwhelmingly common
            // response is a bodiless 304: no JOIN server-side, no payload, no JSON parse.
            function _fetchMarketplaceListings(minLevel, maxLevel, excludeIds, previous) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                    var url, options, response, _previous_value, _previous_etag, etag, data, error;
                    return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    3,
                                    ,
                                    4
                                ]);
                                url = "".concat(this.baseUrl, "/api/characters?action=marketplace");
                                if (minLevel !== null) url += "&minLevel=".concat(minLevel);
                                if (maxLevel !== null) url += "&maxLevel=".concat(maxLevel);
                                if (excludeIds && excludeIds.length > 0) url += "&exclude=".concat(excludeIds.join(','));
                                options = (previous === null || previous === void 0 ? void 0 : previous.etag) ? {
                                    headers: {
                                        'If-None-Match': previous.etag
                                    }
                                } : {};
                                return [
                                    4,
                                    fetch(url, options)
                                ];
                            case 1:
                                response = _state.sent();
                                // Not modified — keep what we already parsed.
                                if (response.status === 304) return [
                                    2,
                                    {
                                        value: (_previous_value = previous === null || previous === void 0 ? void 0 : previous.value) !== null && _previous_value !== void 0 ? _previous_value : [],
                                        etag: (_previous_etag = previous === null || previous === void 0 ? void 0 : previous.etag) !== null && _previous_etag !== void 0 ? _previous_etag : null
                                    }
                                ];
                                etag = response.headers.get('ETag');
                                return [
                                    4,
                                    response.json()
                                ];
                            case 2:
                                data = _state.sent();
                                if (data.success) return [
                                    2,
                                    {
                                        value: data.listings,
                                        etag: etag
                                    }
                                ];
                                console.error('Error getting marketplace listings:', data.message);
                                return [
                                    2,
                                    {
                                        value: [],
                                        etag: null
                                    }
                                ];
                            case 3:
                                error = _state.sent();
                                console.error('Error fetching marketplace listings:', error);
                                return [
                                    2,
                                    {
                                        value: [],
                                        etag: null
                                    }
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            // Drop cached listings after anything that changes them (list, withdraw,
            // reserve, hire, release, settle) so the next read reflects the change.
            key: "invalidateMarketplaceCache",
            value: function invalidateMarketplaceCache() {
                this._marketplaceCache.clear();
            }
        },
        {
            key: "getMyMarketplaceListings",
            value: // Server truth for this player's own listings, keyed by character id. The
            // client caches marketplaceData at listing time and would otherwise never see
            // a server-side change to it (notably the dev time-shift tool).
            //
            // Returns an array on success (possibly empty = "you have no listings") and
            // null when we couldn't find out. Callers MUST distinguish the two: treating
            // a failed request as "no listings" would wrongly clear a live listing from
            // local state on any network blip.
            function getMyMarketplaceListings() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                    var characterIds, url, response, data, error;
                    var _arguments = arguments;
                    return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                characterIds = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : [];
                                if (!this.isOnline || characterIds.length === 0) return [
                                    2,
                                    null
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    4,
                                    ,
                                    5
                                ]);
                                url = "".concat(this.baseUrl, "/api/characters?action=my-listings&ids=").concat(characterIds.join(','));
                                return [
                                    4,
                                    fetch(url)
                                ];
                            case 2:
                                response = _state.sent();
                                return [
                                    4,
                                    response.json()
                                ];
                            case 3:
                                data = _state.sent();
                                if (!data.success) {
                                    console.error('Error getting own marketplace listings:', data.message);
                                    return [
                                        2,
                                        null
                                    ];
                                }
                                return [
                                    2,
                                    data.listings
                                ];
                            case 4:
                                error = _state.sent();
                                console.error('Error fetching own marketplace listings:', error);
                                return [
                                    2,
                                    null
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
        },
        {
            // Get connection status
            key: "getStatus",
            value: function getStatus() {
                return {
                    isOnline: this.isOnline,
                    localCharacters: this.localCharacters.length,
                    hasInternetConnection: navigator.onLine
                };
            }
        },
        {
            key: "syncLocalCharacters",
            value: // Sync local characters to online database when coming back online
            function syncLocalCharacters() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                    var localCharsToSync, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _this, _loop, _iterator, _step, err;
                    return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!this.isOnline) return [
                                    2
                                ];
                                localCharsToSync = this.localCharacters.filter(function(char) {
                                    return char.isLocal;
                                });
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    7,
                                    8
                                ]);
                                _loop = function() {
                                    var localChar, isUnique, onlineChar, localIndex, error;
                                    return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                localChar = _step.value;
                                                _state.label = 1;
                                            case 1:
                                                _state.trys.push([
                                                    1,
                                                    6,
                                                    ,
                                                    7
                                                ]);
                                                return [
                                                    4,
                                                    _this.isCharacterNameUnique(localChar.name)
                                                ];
                                            case 2:
                                                isUnique = _state.sent();
                                                if (!isUnique) return [
                                                    3,
                                                    4
                                                ];
                                                return [
                                                    4,
                                                    _this.registerCharacter(localChar)
                                                ];
                                            case 3:
                                                onlineChar = _state.sent();
                                                // Remove from local characters and update any references
                                                localIndex = _this.localCharacters.findIndex(function(char) {
                                                    return char.id === localChar.id;
                                                });
                                                if (localIndex !== -1) _this.localCharacters.splice(localIndex, 1);
                                                (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "Synced local character ".concat(localChar.name, " to online database"));
                                                return [
                                                    3,
                                                    5
                                                ];
                                            case 4:
                                                console.warn("Cannot sync ".concat(localChar.name, " - name already exists online"));
                                                _state.label = 5;
                                            case 5:
                                                return [
                                                    3,
                                                    7
                                                ];
                                            case 6:
                                                error = _state.sent();
                                                console.error("Failed to sync character ".concat(localChar.name, ":"), error);
                                                return [
                                                    3,
                                                    7
                                                ];
                                            case 7:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                };
                                _iterator = localCharsToSync[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    5
                                ];
                                _this = this;
                                return [
                                    5,
                                    (0, $4fa1715f971c561b$export$19a8beecd37a4c45)(_loop())
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 5:
                                return [
                                    3,
                                    8
                                ];
                            case 6:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 8:
                                this.saveLocalCharacters();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "deleteOwnCharacter",
            value: // Delete own character (removes from database and local storage)
            function deleteOwnCharacter(characterId) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                    var index, response, data, error;
                    return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Remove from local storage first
                                index = this.localCharacters.findIndex(function(char) {
                                    return char.id === characterId;
                                });
                                if (index !== -1) {
                                    this.localCharacters.splice(index, 1);
                                    this.saveLocalCharacters();
                                    (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "Removed character ".concat(characterId, " from local storage"));
                                } else console.warn("Character ".concat(characterId, " not found in local storage"));
                                if (!this.isOnline) return [
                                    3,
                                    5
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    fetch("".concat(this.baseUrl, "/api/characters?action=character&id=").concat(characterId), {
                                        method: 'DELETE',
                                        headers: this._authHeaders(characterId)
                                    })
                                ];
                            case 2:
                                response = _state.sent();
                                return [
                                    4,
                                    response.json()
                                ];
                            case 3:
                                data = _state.sent();
                                return [
                                    2,
                                    data.success
                                ];
                            case 4:
                                error = _state.sent();
                                console.error('Error deleting character from database:', error);
                                return [
                                    2,
                                    false
                                ];
                            case 5:
                                return [
                                    2,
                                    true
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "createPaymentRecord",
            value: // Create payment record for contractor payments
            function createPaymentRecord(paymentData) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                    var headers, response, data, error;
                    return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!this.isOnline) {
                                    console.warn('Cannot create payment record while offline');
                                    return [
                                        2,
                                        false
                                    ];
                                }
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    4,
                                    ,
                                    5
                                ]);
                                headers = {
                                    'Content-Type': 'application/json'
                                };
                                if (paymentData.hirerToken) headers['Authorization'] = "Bearer ".concat(paymentData.hirerToken);
                                return [
                                    4,
                                    fetch("".concat(this.baseUrl, "/api/payments?action=create"), {
                                        method: 'POST',
                                        headers: headers,
                                        body: JSON.stringify({
                                            recipientCharacterId: paymentData.recipientCharacterId,
                                            hirerCharacterId: paymentData.hirerCharacterId,
                                            amount: paymentData.amount,
                                            xp: paymentData.xp || 0,
                                            source: paymentData.source || 'contractor_payment',
                                            raidId: paymentData.raidId
                                        })
                                    })
                                ];
                            case 2:
                                response = _state.sent();
                                return [
                                    4,
                                    response.json()
                                ];
                            case 3:
                                data = _state.sent();
                                return [
                                    2,
                                    data.success
                                ];
                            case 4:
                                error = _state.sent();
                                console.error('Error creating payment record:', error);
                                return [
                                    2,
                                    false
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getPendingPayments",
            value: // Get pending payments for one character. Reads require the recipient's
            // token (server enforces ownership), so this is per-character, not a batch.
            function getPendingPayments(characterId) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                    var response, data, error;
                    return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!this.isOnline) {
                                    console.warn('Cannot get pending payments while offline');
                                    return [
                                        2,
                                        []
                                    ];
                                }
                                if (!characterId) return [
                                    2,
                                    []
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    fetch("".concat(this.baseUrl, "/api/payments?action=pending&characterId=").concat(characterId), {
                                        headers: this._authHeaders(characterId)
                                    })
                                ];
                            case 2:
                                response = _state.sent();
                                return [
                                    4,
                                    response.json()
                                ];
                            case 3:
                                data = _state.sent();
                                if (data.success) return [
                                    2,
                                    data.payments
                                ];
                                else {
                                    console.error('Failed to get pending payments:', data.message);
                                    return [
                                        2,
                                        []
                                    ];
                                }
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                error = _state.sent();
                                console.error('Error getting pending payments:', error);
                                return [
                                    2,
                                    []
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "markPaymentsProcessed",
            value: // Mark one character's payments as processed (requires the recipient's token).
            function markPaymentsProcessed(characterId, paymentIds) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                    var response, data, error;
                    return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!this.isOnline) {
                                    console.warn('Cannot mark payments processed while offline');
                                    return [
                                        2,
                                        false
                                    ];
                                }
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    fetch("".concat(this.baseUrl, "/api/payments"), {
                                        method: 'PUT',
                                        headers: this._authHeaders(characterId),
                                        body: JSON.stringify({
                                            characterId: characterId,
                                            paymentIds: paymentIds
                                        })
                                    })
                                ];
                            case 2:
                                response = _state.sent();
                                return [
                                    4,
                                    response.json()
                                ];
                            case 3:
                                data = _state.sent();
                                return [
                                    2,
                                    data.success
                                ];
                            case 4:
                                error = _state.sent();
                                console.error('Error marking payments processed:', error);
                                return [
                                    2,
                                    false
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "reserveContractor",
            value: // Reserve a contractor in the database to prevent concurrent reservations
            function reserveContractor(contractorCharacterId, reservedByCharacterId) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                    var response, data, error;
                    return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!this.isOnline) {
                                    console.warn('Cannot reserve contractor while offline');
                                    return [
                                        2,
                                        {
                                            success: true
                                        }
                                    ]; // Allow local reservation when offline
                                }
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    fetch("".concat(this.baseUrl, "/api/characters?action=reserve-contractor"), {
                                        method: 'POST',
                                        headers: this._authHeaders(reservedByCharacterId),
                                        body: JSON.stringify({
                                            contractorCharacterId: contractorCharacterId,
                                            reservedByCharacterId: reservedByCharacterId
                                        })
                                    })
                                ];
                            case 2:
                                response = _state.sent();
                                return [
                                    4,
                                    response.json()
                                ];
                            case 3:
                                data = _state.sent();
                                return [
                                    2,
                                    data
                                ];
                            case 4:
                                error = _state.sent();
                                console.error('Error reserving contractor:', error);
                                return [
                                    2,
                                    {
                                        success: false,
                                        message: 'Network error'
                                    }
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "releaseContractor",
            value: // Release a contractor reservation in the database
            function releaseContractor(contractorCharacterId, releasedByCharacterId) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                    var response, data, error;
                    return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!this.isOnline) {
                                    console.warn('Cannot release contractor while offline');
                                    return [
                                        2,
                                        {
                                            success: true
                                        }
                                    ]; // Allow local release when offline
                                }
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    fetch("".concat(this.baseUrl, "/api/characters?action=release-contractor"), {
                                        method: 'POST',
                                        headers: this._authHeaders(releasedByCharacterId),
                                        body: JSON.stringify({
                                            contractorCharacterId: contractorCharacterId,
                                            reservedByCharacterId: releasedByCharacterId
                                        })
                                    })
                                ];
                            case 2:
                                response = _state.sent();
                                return [
                                    4,
                                    response.json()
                                ];
                            case 3:
                                data = _state.sent();
                                return [
                                    2,
                                    data
                                ];
                            case 4:
                                error = _state.sent();
                                console.error('Error releasing contractor:', error);
                                return [
                                    2,
                                    {
                                        success: false,
                                        message: 'Network error'
                                    }
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "hireContractor",
            value: // Hire a contractor (transition from reserved to hired for raid)
            function hireContractor(contractorCharacterId, hiredByCharacterId, raidId) {
                var tier = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                    var response, data, error;
                    return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!this.isOnline) {
                                    console.warn('Cannot hire contractor while offline');
                                    return [
                                        2,
                                        {
                                            success: true
                                        }
                                    ]; // Allow local hiring when offline
                                }
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    fetch("".concat(this.baseUrl, "/api/characters?action=hire-contractor"), {
                                        method: 'POST',
                                        headers: this._authHeaders(hiredByCharacterId),
                                        body: JSON.stringify({
                                            contractorCharacterId: contractorCharacterId,
                                            hiredByCharacterId: hiredByCharacterId,
                                            raidId: raidId,
                                            tier: tier
                                        })
                                    })
                                ];
                            case 2:
                                response = _state.sent();
                                return [
                                    4,
                                    response.json()
                                ];
                            case 3:
                                data = _state.sent();
                                return [
                                    2,
                                    data
                                ];
                            case 4:
                                error = _state.sent();
                                console.error('Error hiring contractor:', error);
                                return [
                                    2,
                                    {
                                        success: false,
                                        message: 'Network error'
                                    }
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "releaseHiredContractor",
            value: // Release a hired contractor (when raid ends)
            function releaseHiredContractor(contractorCharacterId, releasedByCharacterId) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                    var response, data, error;
                    return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!this.isOnline) {
                                    console.warn('Cannot release hired contractor while offline');
                                    return [
                                        2,
                                        {
                                            success: true
                                        }
                                    ]; // Allow local release when offline
                                }
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    fetch("".concat(this.baseUrl, "/api/characters?action=release-hired-contractor"), {
                                        method: 'POST',
                                        headers: this._authHeaders(releasedByCharacterId),
                                        body: JSON.stringify({
                                            contractorCharacterId: contractorCharacterId,
                                            releasedByCharacterId: releasedByCharacterId
                                        })
                                    })
                                ];
                            case 2:
                                response = _state.sent();
                                return [
                                    4,
                                    response.json()
                                ];
                            case 3:
                                data = _state.sent();
                                return [
                                    2,
                                    data
                                ];
                            case 4:
                                error = _state.sent();
                                console.error('Error releasing hired contractor:', error);
                                return [
                                    2,
                                    {
                                        success: false,
                                        message: 'Network error'
                                    }
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            // Debug utility to clear all multiplayer data
            key: "clearMultiplayerData",
            value: function clearMultiplayerData() {
                (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, 'Clearing all multiplayer data...');
                localStorage.removeItem('multiplayerCharacters');
                this.localCharacters = [];
                (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, 'Multiplayer data cleared. Page refresh recommended.');
            }
        }
    ]);
    return MultiplayerSystem;
}();
var $fde0976ce5d1665d$export$e4477200b6413a70 = new $fde0976ce5d1665d$var$MultiplayerSystem();
function $fde0976ce5d1665d$export$6ec81efa6b4944af(name) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var localDuplicate;
        return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    // Check against local characters first
                    localDuplicate = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).characters.find(function(c) {
                        return c.name.toLowerCase() === name.toLowerCase();
                    });
                    if (localDuplicate) return [
                        2,
                        false
                    ];
                    return [
                        4,
                        $fde0976ce5d1665d$export$e4477200b6413a70.isCharacterNameUnique(name)
                    ];
                case 1:
                    // Then check multiplayer database
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    })();
}
function $fde0976ce5d1665d$export$639a6fa06b9578d3(characterName) {
    console.log("\uD83D\uDD0D DEBUG: Checking all storage locations for character:", characterName);
    // Check main game state
    console.log("\uD83D\uDCCB Main gameState.character:", (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character);
    // Check multiplayer local characters
    console.log("\uD83C\uDF10 Multiplayer localCharacters:", $fde0976ce5d1665d$export$e4477200b6413a70.localCharacters);
    // Check all localStorage keys
    console.log("\uD83D\uDCBE All localStorage keys:");
    for(var i = 0; i < localStorage.length; i++){
        var key = localStorage.key(i);
        var value = localStorage.getItem(key);
        console.log("  ".concat(key, ":"), value);
        // Check if this value contains the character name
        if (value && value.includes(characterName)) console.log("  \u26A0\uFE0F CHARACTER NAME FOUND IN: ".concat(key));
    }
    // Test name uniqueness check
    console.log("\uD83D\uDD0E Testing name uniqueness check...");
    $fde0976ce5d1665d$export$6ec81efa6b4944af(characterName).then(function(isUnique) {
        console.log('  Name "'.concat(characterName, '" is unique:'), isUnique);
    }).catch(function(error) {
        console.error('  Error checking name uniqueness:', error);
    });
}
function $fde0976ce5d1665d$export$347a45e01153443c() {
    (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "\uD83E\uDDF9 Cleaning up multiplayer storage...");
    var relevantCharacterIds = new Set();
    // Keep current player character
    if (typeof (0, $fe47a452a83d9e00$export$8e361a1ffbebf172) !== 'undefined' && (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character && (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.multiplayerId) {
        relevantCharacterIds.add((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.multiplayerId);
        (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "\uD83D\uDCDD Keeping current player character: ".concat((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.name, " (").concat((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.multiplayerId, ")"));
    }
    // Keep characters in current raid team
    if (typeof (0, $fe47a452a83d9e00$export$8e361a1ffbebf172) !== 'undefined' && (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.hiredContractors) (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.hiredContractors.forEach(function(contractor) {
        if (contractor.multiplayerId) {
            relevantCharacterIds.add(contractor.multiplayerId);
            (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "\u2694\uFE0F Keeping hired contractor: ".concat(contractor.name, " (").concat(contractor.multiplayerId, ")"));
        }
    });
    // Keep characters in reserved contractors (for active raid)
    if (typeof (0, $fe47a452a83d9e00$export$8e361a1ffbebf172) !== 'undefined' && (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.reservedContractors) (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.reservedContractors.forEach(function(contractor) {
        if (contractor.multiplayerId) {
            relevantCharacterIds.add(contractor.multiplayerId);
            (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "\uD83D\uDD12 Keeping reserved contractor: ".concat(contractor.name, " (").concat(contractor.multiplayerId, ")"));
        }
    });
    (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "\uD83C\uDFAF Total relevant character IDs: ".concat(relevantCharacterIds.size));
    // Filter multiplayer storage to only keep relevant characters
    var beforeCount = $fde0976ce5d1665d$export$e4477200b6413a70.localCharacters.length;
    $fde0976ce5d1665d$export$e4477200b6413a70.localCharacters = $fde0976ce5d1665d$export$e4477200b6413a70.localCharacters.filter(function(char) {
        var isRelevant = relevantCharacterIds.has(char.id);
        if (!isRelevant) (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "\uD83D\uDDD1\uFE0F Removing orphaned character: ".concat(char.name, " (").concat(char.id, ")"));
        return isRelevant;
    });
    var afterCount = $fde0976ce5d1665d$export$e4477200b6413a70.localCharacters.length;
    var removedCount = beforeCount - afterCount;
    if (removedCount > 0) {
        $fde0976ce5d1665d$export$e4477200b6413a70.saveLocalCharacters();
        (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "\u2705 Cleanup complete: removed ".concat(removedCount, " orphaned characters, kept ").concat(afterCount));
    } else (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "\u2705 Cleanup complete: no orphaned characters found");
}
function $fde0976ce5d1665d$export$6ebef846cc736ea(name) {
    var currentName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var isUnique, error;
        return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!name) return [
                        2,
                        {
                            valid: false,
                            message: '',
                            className: 'hidden'
                        }
                    ];
                    if (name.length < 2) return [
                        2,
                        {
                            valid: false,
                            message: 'Name must be at least 2 characters',
                            className: 'text-game-warning'
                        }
                    ];
                    if (name.length > 20) return [
                        2,
                        {
                            valid: false,
                            message: 'Name must be 20 characters or less',
                            className: 'text-game-warning'
                        }
                    ];
                    // Skip uniqueness check if name hasn't changed
                    if (currentName && name === currentName) return [
                        2,
                        {
                            valid: true,
                            message: '',
                            className: 'hidden'
                        }
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        $fde0976ce5d1665d$export$6ec81efa6b4944af(name)
                    ];
                case 2:
                    isUnique = _state.sent();
                    if (isUnique) return [
                        2,
                        {
                            valid: true,
                            message: "\u2705 Name is available",
                            className: 'text-game-success'
                        }
                    ];
                    else return [
                        2,
                        {
                            valid: false,
                            message: "\u274C Name already exists",
                            className: 'text-game-danger'
                        }
                    ];
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        2,
                        {
                            valid: false,
                            message: "\u26A0\uFE0F Could not check name availability",
                            className: 'text-game-warning'
                        }
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    })();
}
function $fde0976ce5d1665d$export$2d25a36fab5567cb(contractorPayments) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var hirer, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, payment, _gameState_currentRaid, error, err;
        return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    // The hiring (active) character authenticates the payment: the server
                    // verifies this character owns itself and actually hired each recipient.
                    hirer = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character;
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        8,
                        9,
                        10
                    ]);
                    _iterator = contractorPayments[Symbol.iterator]();
                    _state.label = 2;
                case 2:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        7
                    ];
                    payment = _step.value;
                    if (!(payment.isPlayerContractor && payment.contractorId > 0)) return [
                        3,
                        6
                    ];
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        5,
                        ,
                        6
                    ]);
                    // Create payment record in database - contractorId is the recipient character ID
                    return [
                        4,
                        $fde0976ce5d1665d$export$e4477200b6413a70.createPaymentRecord({
                            recipientCharacterId: payment.contractorId,
                            hirerCharacterId: (hirer === null || hirer === void 0 ? void 0 : hirer.multiplayerId) || null,
                            hirerToken: (hirer === null || hirer === void 0 ? void 0 : hirer.ownerToken) || null,
                            amount: payment.credits,
                            xp: payment.xp || 0,
                            source: 'contractor_payment',
                            raidId: ((_gameState_currentRaid = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid) === null || _gameState_currentRaid === void 0 ? void 0 : _gameState_currentRaid.id) || null,
                            timestamp: new Date().toISOString()
                        })
                    ];
                case 4:
                    _state.sent();
                    (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "Recorded payment of ".concat(payment.credits, " credits and ").concat(payment.xp, " XP for contractor ").concat(payment.contractorName, " (ID: ").concat(payment.contractorId, ")"));
                    return [
                        3,
                        6
                    ];
                case 5:
                    error = _state.sent();
                    console.error("Failed to record payment for contractor ".concat(payment.contractorName, ":"), error);
                    return [
                        3,
                        6
                    ];
                case 6:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        2
                    ];
                case 7:
                    return [
                        3,
                        10
                    ];
                case 8:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        10
                    ];
                case 9:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 10:
                    return [
                        2
                    ];
            }
        });
    })();
}










/**
 * Collapse Keys — the story track's delivery mechanism (TODO §B).
 *
 * A key is an ACCOUNT-LEVEL RECORD, not an item. `gameState.player.collapseKeys`
 * holds recovered ids; nothing enters an inventory, so a key cannot be sold,
 * crafted, consigned, levied or lost. That shape was chosen deliberately over
 * the `unique` story-relic loot pool:
 *
 *   - The loot route would have meant lowering `itemRarities.unique.minTier`
 *     from 4, which makes the unique leg of getRoomRarityChances() non-zero at
 *     T1-T3 (visible in the raid planner), drags the Relic Resonance Tuner's
 *     selection boost into the story, and puts a balance surface under content
 *     that has no economic value.
 *   - It would ALSO have needed an explicit entry in foundSyndicateCore's
 *     preserved ledger, because a founding rebuilds command and wipes
 *     inventories. Account-level state needs no such entry — the player object
 *     is saved and restored whole and no prestige touches it. The invariant is
 *     enforced by construction rather than by remembering.
 *
 * The five placeholder story relics in itemsStoryRelics.js are untouched and
 * remain unreachable until L4's T0 adds raidTierData[4]. They are that layer's
 * business; keys 8-10 are where the two paths meet.
 *
 * ORDER MATTERS. The fragments build an argument, so the next key a faction
 * recovers is always its LOWEST unrecovered one — the roll decides *whether*,
 * never *which*. Tier is a ceiling rather than a bucket (`tier <= raidTier`),
 * so a player who out-levels T1 can still recover D1; nobody is locked out of
 * the first page of their own story.
 *
 * No browser dependencies — the simulator runs this too.
 *
 * See docs/story/StoryAlignment.md §Where the Collapse Keys sit in the ladder.
 */ 

function $756a1bfec6d494f3$export$933049ca86d1db4() {
    var player = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player || ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player = {});
    if (!Array.isArray(player.collapseKeys)) player.collapseKeys = [];
    return player.collapseKeys;
}
function $756a1bfec6d494f3$export$182e380db95340ce() {
    return $979b99378be707cd$export$2da4db3f6fd1335b || [];
}
function $756a1bfec6d494f3$export$bd3eb2c1f422af95(id) {
    return $756a1bfec6d494f3$export$182e380db95340ce().find(function(k) {
        return k.id === id;
    }) || null;
}
function $756a1bfec6d494f3$export$b3bc6b2877d37c66(id) {
    return $756a1bfec6d494f3$export$933049ca86d1db4().includes(id);
}
function $756a1bfec6d494f3$export$c9e2c9e9eddcd297(faction) {
    return $756a1bfec6d494f3$export$182e380db95340ce().filter(function(k) {
        return k.faction === faction;
    }).sort(function(a, b) {
        return a.index - b.index;
    });
}
function $756a1bfec6d494f3$export$5f1383f2388f21ce(faction, tier) {
    if (!faction) return null;
    var owned = $756a1bfec6d494f3$export$933049ca86d1db4();
    return $756a1bfec6d494f3$export$c9e2c9e9eddcd297(faction).find(function(k) {
        return k.tier <= tier && !owned.includes(k.id);
    }) || null;
}
function $756a1bfec6d494f3$export$8f051122a7ec4f94(id) {
    var key = $756a1bfec6d494f3$export$bd3eb2c1f422af95(id);
    if (!key) return null;
    var owned = $756a1bfec6d494f3$export$933049ca86d1db4();
    if (owned.includes(id)) return null;
    owned.push(id);
    return key;
}
function $756a1bfec6d494f3$export$9d589cbf453e87ad(faction, tier) {
    var rng = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Math.random;
    var candidate = $756a1bfec6d494f3$export$5f1383f2388f21ce(faction, tier);
    if (!candidate) return null;
    // Direct read, no `?? 0` fallback: a silent 0 would disable the whole story
    // track and look exactly like a player who has not found a key yet.
    // configValidation.js makes a missing value a loud boot failure instead.
    if (rng() >= $979b99378be707cd$export$9f9786ac427715c7.collapseKeyDropChance) return null;
    return $756a1bfec6d494f3$export$8f051122a7ec4f94(candidate.id);
}
function $756a1bfec6d494f3$export$1bf1759a5184ddbd() {
    var owned = $756a1bfec6d494f3$export$933049ca86d1db4();
    var byFaction = {};
    Object.keys($979b99378be707cd$export$aeeef991191508e2 || {}).forEach(function(faction) {
        var keys = $756a1bfec6d494f3$export$c9e2c9e9eddcd297(faction);
        byFaction[faction] = {
            owned: keys.filter(function(k) {
                return owned.includes(k.id);
            }).length,
            total: keys.length
        };
    });
    return byFaction;
}
function $756a1bfec6d494f3$export$22a05a8b58c72cba() {
    return $756a1bfec6d494f3$export$933049ca86d1db4().length;
}


function $1249ab814b7054d4$export$fae1502b09cc01ab(room, regionKey, zone, row, col) {
    if (!room || !room.name || !room.category) return room;
    var roomNames = (0, $980f67465e309611$export$6b7290c54feddd3b)({
        baseName: room.name,
        regionKey: regionKey,
        zone: zone,
        category: room.category,
        seed: "".concat(regionKey, ":").concat(row, ",").concat(col)
    });
    return (0, $715bf31211e65705$export$71511d61b312f219)((0, $fa9769297b8a68c8$export$71511d61b312f219)({}, room), {
        nameOptions: roomNames,
        displayName: roomNames[0] // Default to first option
    });
}
function $1249ab814b7054d4$export$42e60f2f430e66a4(rooms, categories) {
    var difficulty = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, zone = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    // Normalize categories to array
    if (!Array.isArray(categories)) categories = [
        categories
    ];
    // Filter by category
    var filtered = rooms.filter(function(r) {
        return categories.includes(r.category);
    });
    // Further filter by difficulty if specified
    if (difficulty && filtered.length > 0) {
        var difficultyFiltered = filtered.filter(function(r) {
            return r.difficulty === difficulty;
        });
        if (difficultyFiltered.length > 0) filtered = difficultyFiltered;
    }
    // Then by district. A template that names one is asking to be kept for it;
    // a template that names none will stand anywhere, so it stays in the running
    // either way. This is the one place a template's own district preference has
    // ever had an effect, and it is worth keeping: it is what puts an apartment
    // gate in the housing and an arcade gate on the shopping street.
    if (zone && filtered.length > 0) {
        var local = filtered.filter(function(r) {
            return r.districtAffinity === zone || !r.districtAffinity;
        });
        if (local.length > 0) filtered = local;
    }
    // Fallback to all rooms if no matches
    if (filtered.length === 0) filtered = rooms;
    return filtered[Math.floor(Math.random() * filtered.length)];
}
/**
 * Create a road room object
 * Exact copy from raid.js line 422
 */ var $1249ab814b7054d4$var$createRoad = function(row, col) {
    return (0, $715bf31211e65705$export$71511d61b312f219)((0, $fa9769297b8a68c8$export$71511d61b312f219)({}, $979b99378be707cd$export$11209b5126489e67['road']), {
        row: row,
        col: col
    });
};
/**
 * Create a campsite room object
 * Exact copy from raid.js line 420
 */ var $1249ab814b7054d4$var$createCampsite = function(row, col) {
    return (0, $715bf31211e65705$export$71511d61b312f219)((0, $fa9769297b8a68c8$export$71511d61b312f219)({}, $979b99378be707cd$export$11209b5126489e67['campsite']), {
        row: row,
        col: col
    });
};
/**
 * Create a water room object
 * Exact copy from raid.js line 421
 */ var $1249ab814b7054d4$var$createWater = function(row, col) {
    return (0, $715bf31211e65705$export$71511d61b312f219)((0, $fa9769297b8a68c8$export$71511d61b312f219)({}, $979b99378be707cd$export$11209b5126489e67['water']), {
        row: row,
        col: col
    });
};
function $1249ab814b7054d4$export$2ebdd7a7b7382080(regionKey, tier) {
    var region = $979b99378be707cd$export$4fbdcec70fce9d73[regionKey];
    var tierInfo = $979b99378be707cd$export$94e7ad7999c1ae32[tier];
    var gridRows = tierInfo.gridRows || tierInfo.gridSize;
    var gridCols = tierInfo.gridCols || tierInfo.gridSize;
    // Generate strategic layout for all regions
    return $1249ab814b7054d4$export$28f2fc0c31206252(region, gridRows, gridCols, tier, regionKey);
}
function $1249ab814b7054d4$export$28f2fc0c31206252(region, gridRows, gridCols, tier, regionKey) {
    var grid = [];
    // Initialize empty grid
    for(var row = 0; row < gridRows; row++){
        grid[row] = [];
        for(var col = 0; col < gridCols; col++)grid[row][col] = null;
    }
    // The road layout is decided before anything is placed, so the fast-travel
    // rooms can be put ON the trunk rather than scattered independently of it.
    var startRowSeed = Math.floor(gridRows / 2);
    var roadNet = (0, $57ad8bd108ea335d$export$d1d5b8da68c444ff)(gridRows, gridCols, Math.random, {
        // the trunk runs edge to edge and so do these, so keep it off them
        avoid: new Set([
            "".concat(startRowSeed, ",0"),
            "".concat(startRowSeed, ",").concat(gridCols - 1)
        ])
    });
    // Define zones for strategic placement
    var zones = $1249ab814b7054d4$export$bd3f9f980af68c96(gridRows, gridCols);
    // Set start and end positions
    var startRow = Math.floor(gridRows / 2);
    var endRow = Math.floor(gridRows / 2);
    grid[startRow][0] = {
        type: 'start',
        name: 'Entry',
        primary: '',
        support: [],
        row: startRow,
        col: 0,
        zone: 'entry',
        baseDuration: 0,
        icon: "\uD83C\uDF00"
    };
    grid[endRow][gridCols - 1] = {
        type: 'exit',
        name: 'Exit',
        primary: '',
        support: [],
        row: endRow,
        col: gridCols - 1,
        zone: 'core',
        baseDuration: 0,
        icon: "\uD83C\uDF0C"
    };
    // Generate strategic layout
    $1249ab814b7054d4$export$c7be4a5231a3c1d5(grid, zones, gridRows, gridCols, roadNet);
    $1249ab814b7054d4$export$a1095e56569a7bbd(grid, zones, region, regionKey, gridRows, gridCols);
    $1249ab814b7054d4$export$c2b6eb32afc42797(grid, zones, region, regionKey);
    $1249ab814b7054d4$export$a99502f327eb386e(grid, zones, region, regionKey, gridRows, gridCols);
    // Fill any remaining null cells with road rooms
    $1249ab814b7054d4$export$5a5853dd98a11973(grid, gridRows, gridCols);
    // Place campsite after grid is fully populated
    $1249ab814b7054d4$export$88789d02c8b75477(grid, gridRows, gridCols, new Set((0, $4c858c0d999a5b9b$export$71511d61b312f219)(roadNet.values()).filter(function(c) {
        return c.rank === (0, $57ad8bd108ea335d$export$39615881bb0d21f6);
    }).map(function(c) {
        return "".concat(c.row, ",").concat(c.col);
    })));
    // Stamp the road layer onto whatever ended up in each cell. It is a layer,
    // not a room type: a gate the trunk runs past shows its frontage, and a tile
    // the network misses draws no road at all.
    // campsite and water may end a track; collapsed ground may not even be
    // approached, so it drops out of the network entirely
    (0, $57ad8bd108ea335d$export$c7de1644901a490c)(grid, gridRows, gridCols, roadNet, [
        'campsite',
        'water'
    ], [
        'blocked'
    ]);
    $1249ab814b7054d4$export$eae5917029d72dd7(grid, gridRows, gridCols);
    // Every cell learns its district, including the ones placed by hand and the
    // ones that are not encounters at all. Placement stamps the district on the
    // rooms it selects, but the roads, the water, the campsite and the collapsed
    // ground never went through it — and the renderer wants a district on those
    // as much as on anything else, since growth reclaiming the outskirts should
    // not stop at a road tile's border.
    $1249ab814b7054d4$export$125f97059f561163(grid, zones);
    // ...and, on a region the sea got into, how far each cell is from it. This is
    // stamped LAST and read only by the renderer: nothing above this line has seen
    // it, so the map that gets played is the same map either way.
    var shore = $1249ab814b7054d4$export$73848b2e713ad45b(regionKey) ? $1249ab814b7054d4$export$77e51d0aafb84b9d() : null;
    if (shore) $1249ab814b7054d4$export$7977e6f4ebd3580e(grid, shore);
    var railway = $1249ab814b7054d4$export$44fd09db052e90f2(regionKey) ? $1249ab814b7054d4$export$a212d3baae84988f(grid, gridCols) : null;
    if (railway != null) $1249ab814b7054d4$export$7a45acab3254e781(grid, railway);
    // Commit each encounter room to the events it will run. The map is drawn
    // from this, so it has to be decided before the grid is displayed — and it
    // is safe here because the event pool depends only on the room's own skills,
    // not on the team, which is not hired until after planning.
    (0, $52a7294453bdb6d1$export$81e7862f0868f5bc)(grid);
    return {
        grid: grid,
        rows: gridRows,
        cols: gridCols,
        startPos: {
            row: startRow,
            col: 0
        },
        endPos: {
            row: endRow,
            col: gridCols - 1
        },
        region: region,
        tier: tier,
        zones: zones,
        shore: shore,
        railway: railway
    };
}
// ---- districts ----
// A raid is a walk from the west edge to the east one, so a district is a BAND
// of columns: you leave the entry, cross two or three neighbourhoods, and
// arrive at the core. What the map used to do instead was carve fixed
// rectangles out of the grid dimensions — which meant every raid of a tier was
// laid out identically, `commercial` swallowed `security` whole at 7 columns
// because the rectangles overlapped and the first match won, and about a third
// of a 17-column map matched no rectangle at all and fell through to
// `peripheral` by default rather than by design.
var $1249ab814b7054d4$var$ANCHOR_COLS = 2; // columns the entry and core districts hold at the ends
var $1249ab814b7054d4$var$MIN_BAND = 3; // narrower than this and a district cannot be read as one
var $1249ab814b7054d4$var$SPLIT_CHANCE = 0.4; // how often a band is cut north/south into two districts
var $1249ab814b7054d4$var$MIN_SPLIT = 2; // rows each half of a cut band must have to read as one
function $1249ab814b7054d4$export$bd3f9f980af68c96(gridRows, gridCols) {
    var rand = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Math.random;
    var middle = Object.keys($979b99378be707cd$export$8377a367ab2ae550).filter(function(z) {
        return z !== 'entry' && z !== 'core';
    });
    var free = Math.max(0, gridCols - $1249ab814b7054d4$var$ANCHOR_COLS * 2);
    var bands = Math.max(1, Math.min(middle.length, Math.floor(free / $1249ab814b7054d4$var$MIN_BAND)));
    var picked = (0, $ca7af38ea7b7b4a8$export$7ac3a88d34a76e7)(middle, rand);
    var order = [
        'entry'
    ].concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)(picked.slice(0, bands)), [
        'core'
    ]);
    // Where each district starts, before the per-row wobble. The middle bands
    // split what the anchors leave as evenly as the columns allow.
    var starts = [
        0
    ];
    for(var i = 0; i <= bands; i++)starts.push($1249ab814b7054d4$var$ANCHOR_COLS + Math.round(free * i / bands));
    starts.push(gridCols);
    // A band may hand half of itself to an archetype the order did not use.
    // Which half is rolled too: always giving away the north would put every
    // split district along the top of the map, which is its own fixed pattern.
    var spare = picked.slice(bands);
    var splits = order.map(function(_, i) {
        if (i === 0 || i === order.length - 1 || !spare.length) return null;
        if (gridRows < $1249ab814b7054d4$var$MIN_SPLIT * 2 || rand() >= $1249ab814b7054d4$var$SPLIT_CHANCE) return null;
        // Both halves get MIN_SPLIT rows at least: a one-row strip of another
        // district does not read as a district, it reads as a stray row.
        var room = gridRows - $1249ab814b7054d4$var$MIN_SPLIT * 2;
        return {
            at: $1249ab814b7054d4$var$MIN_SPLIT + Math.floor(rand() * (room + 1)),
            north: rand() < 0.5,
            zone: spare.pop()
        };
    });
    var cells = [];
    for(var row = 0; row < gridRows; row++){
        // Wobble every interior boundary, left to right, each one kept at least a
        // column past the last and far enough from the east edge that every
        // district still left to place gets a column of its own. Districts can
        // therefore never cross or vanish, whatever the rolls do.
        var edge = [
            0
        ];
        for(var i1 = 1; i1 < starts.length - 1; i1++){
            var drift = rand() < 0.5 ? 0 : rand() < 0.5 ? -1 : 1;
            edge.push(Math.max(edge[i1 - 1] + 1, Math.min(starts[i1] + drift, gridCols - (order.length - i1))));
        }
        edge.push(gridCols);
        var line = [];
        for(var i2 = 0; i2 < order.length; i2++){
            var cut = splits[i2];
            var zone = cut && row < cut.at === cut.north ? cut.zone : order[i2];
            for(var col = edge[i2]; col < edge[i2 + 1]; col++)line[col] = zone;
        }
        cells.push(line);
    }
    return {
        cells: cells,
        order: order
    };
}
function $1249ab814b7054d4$export$125f97059f561163(grid, zones) {
    for(var row = 0; row < grid.length; row++){
        for(var col = 0; col < grid[row].length; col++)if (grid[row][col]) grid[row][col].zone = $1249ab814b7054d4$export$db5786fdbbf0e297(row, col, zones);
    }
}
function $1249ab814b7054d4$export$77e51d0aafb84b9d() {
    var rand = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Math.random;
    return rand() < 0.5 ? 'n' : 's';
}
function $1249ab814b7054d4$export$7977e6f4ebd3580e(grid, side) {
    var rows = grid.length;
    var seaward = side === 'n' ? 'n' : 's';
    for(var row = 0; row < rows; row++){
        var shore = side === 'n' ? row : rows - 1 - row;
        for(var col = 0; col < grid[row].length; col++){
            var room = grid[row][col];
            if (!room) continue;
            room.shore = shore;
            room.shoreSide = side;
            if (shore === 0 && room.road) delete room.road[seaward];
        }
    }
}
/** Regions whose art direction says the sea got in. */ var $1249ab814b7054d4$var$SHORELINE_REGIONS = new Set([
    'sunken-bastions'
]);
var $1249ab814b7054d4$export$73848b2e713ad45b = function(regionKey) {
    return $1249ab814b7054d4$var$SHORELINE_REGIONS.has(regionKey);
};
// ---- the railway ----
// A sublevel is transit infrastructure before it is anything else, so it gets a
// rail spur — but ONE, and laid the way a road is laid rather than scattered.
// Sprinkling rail beds around as props gave the map disconnected lengths of
// track that started and stopped for no reason; a railway is only a railway if
// it goes somewhere. The trunk road runs west to east, so the line runs north
// to south and the two cross, which is what a transit interchange looks like.
/** Regions whose art direction says something still runs on rails down there. */ var $1249ab814b7054d4$var$RAILWAY_REGIONS = new Set([
    'hollow-core'
]);
var $1249ab814b7054d4$export$44fd09db052e90f2 = function(regionKey) {
    return $1249ab814b7054d4$var$RAILWAY_REGIONS.has(regionKey);
};
/** Ground the line may not be laid across at all. */ var $1249ab814b7054d4$var$RAIL_BLOCKERS = new Set([
    'water',
    'campsite'
]);
function $1249ab814b7054d4$export$a212d3baae84988f(grid, gridCols) {
    var rand = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Math.random;
    // Kept off the entry and extraction columns too: those are the portals' own,
    // and a line down either would run through the room the raid starts or ends in.
    var best = Infinity, options = [];
    for(var col = 2; col <= gridCols - 3; col++){
        var blocked = false, roads = 0;
        for(var row = 0; row < grid.length && !blocked; row++){
            var room = grid[row][col];
            if (!room || $1249ab814b7054d4$var$RAIL_BLOCKERS.has(room.type)) blocked = true;
            else if (room.type === 'road') roads++;
        }
        if (blocked) continue;
        if (roads < best) {
            best = roads;
            options = [
                col
            ];
        } else if (roads === best) options.push(col);
    }
    return options.length ? options[Math.floor(rand() * options.length)] : null;
}
function $1249ab814b7054d4$export$7a45acab3254e781(grid, col) {
    for(var row = 0; row < grid.length; row++)if (grid[row][col]) grid[row][col].rail = true;
}
function $1249ab814b7054d4$export$c7be4a5231a3c1d5(grid, zones, gridRows, gridCols, roadNet) {
    // First, create road network
    $1249ab814b7054d4$export$eedef1d3c26e0a97(grid, zones, gridRows, gridCols, roadNet);
    // Create blocked areas representing collapsed structures (randomized positions)
    //
    // Roll each one clear of the road network where possible. Collapsed ground
    // carries no pathway at all, and a track cut short by rubble has its whole
    // spur pruned back to the last junction — so rubble dropped on the network
    // costs several tiles of reachable map, not one. Falls back to the first roll
    // when the grid is too congested to find anything better.
    var offNetwork = function(spot) {
        for(var tries = 0; tries < 12; tries++){
            var candidate = spot();
            if (!(roadNet === null || roadNet === void 0 ? void 0 : roadNet.has("".concat(candidate.row, ",").concat(candidate.col)))) return candidate;
        }
        return spot();
    };
    var blockedAreas = [
        // Collapsed skybridge (randomized position)
        offNetwork(function() {
            return {
                row: 1 + Math.floor(Math.random() * Math.max(1, gridRows - 4)),
                col: Math.floor(gridCols * (0.3 + Math.random() * 0.4)),
                type: 'collapsed_bridge'
            };
        }),
        // Radiation zone in industrial area (randomized)
        offNetwork(function() {
            return {
                row: Math.floor(gridRows * (0.6 + Math.random() * 0.3)),
                col: 2 + Math.floor(Math.random() * 3),
                type: 'radiation_zone'
            };
        }),
        // Structural damage in commercial district (randomized)
        offNetwork(function() {
            return {
                row: 1 + Math.floor(Math.random() * 3),
                col: 1 + Math.floor(Math.random() * 3),
                type: 'structural_damage'
            };
        })
    ];
    blockedAreas.forEach(function(blocked) {
        if (blocked.row >= 0 && blocked.row < gridRows && blocked.col >= 0 && blocked.col < gridCols) {
            if (!grid[blocked.row][blocked.col]) grid[blocked.row][blocked.col] = {
                type: 'blocked',
                name: 'Blocked',
                row: blocked.row,
                col: blocked.col,
                subtype: blocked.type
            };
        }
    });
}
function $1249ab814b7054d4$export$eedef1d3c26e0a97(grid, zones, gridRows, gridCols, roadNet) {
    // Fast-travel rooms sit ON the trunk. They used to be scattered by their own
    // rules, which had two problems: the "main thoroughfare" was a straight run
    // down the centre row covering only part of the width, and the vertical
    // connector wrote grid[centerRow][col] inside a loop over ROW, so it only
    // ever placed a single cell. Putting them on the trunk also means the road
    // you can see and the road you can travel quickly are the same road.
    var net = roadNet || (0, $57ad8bd108ea335d$export$d1d5b8da68c444ff)(gridRows, gridCols);
    var trunk = (0, $4c858c0d999a5b9b$export$71511d61b312f219)(net.values()).filter(function(c) {
        return c.rank === (0, $57ad8bd108ea335d$export$39615881bb0d21f6);
    });
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // EVERY trunk cell becomes a road room. Budgeting them (as an earlier pass
        // did) left most of the route as gates and hazards, which then drew the
        // roadway across their own frontage — a four-lane road through the middle of
        // a warehouse. The trunk you can see and the trunk you can travel are the
        // same cells, so the roadway only ever renders on a road tile.
        //
        // This runs before blocked areas and every encounter placement, and those
        // only ever fill EMPTY cells, so nothing can punch a hole in the route
        // afterwards. The one thing already on the grid is the start/exit pair.
        for(var _iterator = trunk[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var cell = _step.value;
            var _grid_cell_row;
            if ((_grid_cell_row = grid[cell.row]) === null || _grid_cell_row === void 0 ? void 0 : _grid_cell_row[cell.col]) continue; // never displace start/exit
            grid[cell.row][cell.col] = $1249ab814b7054d4$var$createRoad(cell.row, cell.col);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $1249ab814b7054d4$export$a1095e56569a7bbd(grid, zones, region, regionKey, gridRows, gridCols) {
    // Main security gate controlling access to core
    var coreGateRow = Math.floor(grid.length / 2);
    var coreGateCol = grid[0].length - 3;
    if (!grid[coreGateRow][coreGateCol]) {
        var currentZone = $1249ab814b7054d4$export$db5786fdbbf0e297(coreGateRow, coreGateCol, zones);
        var gateTemplate = $1249ab814b7054d4$export$42e60f2f430e66a4(region.gates, 'security', 'chokepoint', currentZone);
        var roomWithNames = $1249ab814b7054d4$export$fae1502b09cc01ab(gateTemplate, regionKey, currentZone, coreGateRow, coreGateCol);
        grid[coreGateRow][coreGateCol] = (0, $715bf31211e65705$export$71511d61b312f219)((0, $fa9769297b8a68c8$export$71511d61b312f219)({
            type: 'gate'
        }, roomWithNames), {
            priority: 'critical',
            zone: currentZone,
            strategic_value: 'chokepoint',
            row: coreGateRow,
            col: coreGateCol
        });
    }
    // Secondary checkpoints with zone-aware placement
    var secondaryGates = [
        {
            row: 2,
            col: Math.floor(grid[0].length / 3)
        },
        {
            row: grid.length - 3,
            col: Math.floor(grid[0].length / 3)
        },
        {
            row: 1,
            col: 4
        },
        {
            row: grid.length - 2,
            col: 4
        },
        {
            row: 3,
            col: 3
        },
        {
            row: grid.length - 4,
            col: 3
        } // Commercial gate
    ];
    secondaryGates.forEach(function(pos) {
        if (pos.row >= 0 && pos.row < grid.length && pos.col >= 0 && pos.col < grid[0].length) {
            if (!grid[pos.row][pos.col]) {
                var currentZone = $1249ab814b7054d4$export$db5786fdbbf0e297(pos.row, pos.col, zones);
                var gateTemplate = $1249ab814b7054d4$export$42e60f2f430e66a4(region.gates, 'security', 'chokepoint', currentZone);
                var roomWithNames = $1249ab814b7054d4$export$fae1502b09cc01ab(gateTemplate, regionKey, currentZone, pos.row, pos.col);
                grid[pos.row][pos.col] = (0, $715bf31211e65705$export$71511d61b312f219)((0, $fa9769297b8a68c8$export$71511d61b312f219)({
                    type: 'gate'
                }, roomWithNames), {
                    priority: 'high',
                    zone: currentZone,
                    strategic_value: 'access_control',
                    row: pos.row,
                    col: pos.col
                });
            }
        }
    });
}
function $1249ab814b7054d4$export$c2b6eb32afc42797(grid, zones, region, regionKey, gridRows, gridCols) {
    // Primary target: High-value storage in core zone
    var vaultRow = Math.floor(grid.length / 2);
    var vaultCol = grid[0].length - 2;
    if (!grid[vaultRow][vaultCol]) {
        var currentZone = $1249ab814b7054d4$export$db5786fdbbf0e297(vaultRow, vaultCol, zones);
        var hazardTemplate = $1249ab814b7054d4$export$42e60f2f430e66a4(region.hazards, 'storage', 'high_value', currentZone);
        var roomWithNames = $1249ab814b7054d4$export$fae1502b09cc01ab(hazardTemplate, regionKey, currentZone, vaultRow, vaultCol);
        grid[vaultRow][vaultCol] = (0, $715bf31211e65705$export$71511d61b312f219)((0, $fa9769297b8a68c8$export$71511d61b312f219)({
            type: 'hazard'
        }, roomWithNames), {
            priority: 'critical',
            zone: currentZone,
            strategic_value: 'high_value_target',
            reward_multiplier: 2.5,
            row: vaultRow,
            col: vaultCol
        });
    }
    // Secondary targets spread throughout with zone-specific placement
    var secondaryTargets = [
        {
            row: 1,
            col: grid[0].length - 4,
            category: [
                'power',
                'infrastructure'
            ]
        },
        {
            row: grid.length - 2,
            col: grid[0].length - 4,
            category: [
                'infrastructure',
                'storage'
            ]
        },
        {
            row: 1,
            col: 5,
            category: [
                'environmental',
                'infrastructure'
            ]
        },
        {
            row: grid.length - 2,
            col: 5,
            category: [
                'environmental',
                'storage'
            ]
        },
        {
            row: 3,
            col: 4,
            category: [
                'storage',
                'infrastructure'
            ]
        },
        {
            row: grid.length - 4,
            col: 4,
            category: [
                'storage',
                'power'
            ]
        } // Commercial
    ];
    secondaryTargets.forEach(function(target) {
        if (target.row >= 0 && target.row < grid.length && target.col >= 0 && target.col < grid[0].length) {
            if (!grid[target.row][target.col]) {
                var currentZone = $1249ab814b7054d4$export$db5786fdbbf0e297(target.row, target.col, zones);
                var hazardTemplate = $1249ab814b7054d4$export$42e60f2f430e66a4(region.hazards, target.category, 'high_value', currentZone);
                var roomWithNames = $1249ab814b7054d4$export$fae1502b09cc01ab(hazardTemplate, regionKey, currentZone, target.row, target.col);
                grid[target.row][target.col] = (0, $715bf31211e65705$export$71511d61b312f219)((0, $fa9769297b8a68c8$export$71511d61b312f219)({
                    type: 'hazard'
                }, roomWithNames), {
                    priority: 'high',
                    zone: currentZone,
                    strategic_value: 'infrastructure',
                    reward_multiplier: 1.5,
                    row: target.row,
                    col: target.col
                });
            }
        }
    });
}
/** The rooms nobody paved: their ground is turf, not the region's floor. */ var $1249ab814b7054d4$var$CLEARING_TYPES = new Set([
    'campsite',
    'water'
]);
function $1249ab814b7054d4$export$eae5917029d72dd7(grid, rows, cols) {
    var open = function(r, c) {
        var _grid_r_c, _grid_r;
        return $1249ab814b7054d4$var$CLEARING_TYPES.has(grid === null || grid === void 0 ? void 0 : (_grid_r = grid[r]) === null || _grid_r === void 0 ? void 0 : (_grid_r_c = _grid_r[c]) === null || _grid_r_c === void 0 ? void 0 : _grid_r_c.type);
    };
    for(var row = 0; row < rows; row++)for(var col = 0; col < cols; col++){
        var _grid_row;
        var room = grid === null || grid === void 0 ? void 0 : (_grid_row = grid[row]) === null || _grid_row === void 0 ? void 0 : _grid_row[col];
        if (!room || !$1249ab814b7054d4$var$CLEARING_TYPES.has(room.type)) continue;
        room.clearing = {
            n: open(row - 1, col),
            e: open(row, col + 1),
            s: open(row + 1, col),
            w: open(row, col - 1)
        };
    }
}
function $1249ab814b7054d4$export$88789d02c8b75477(grid, gridRows, gridCols) {
    var trunk = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : new Set();
    // The rest stop may not sit on the trunk. It used to PREFER road cells
    // (candidates.road below), which was harmless while roads were scattered
    // filler — now that the whole through-route is road rooms, it meant the camp
    // and its water landed on the highway and overwrote it, leaving a hole in
    // the route and a roadway drawn across a lake.
    var onTrunk = function(row, col) {
        return trunk.has("".concat(row, ",").concat(col));
    };
    // Middle portion: columns from 1/3 to 2/3 of grid
    var minCol = Math.floor(gridCols / 3);
    var maxCol = Math.floor(2 * gridCols / 3);
    // Try to place in middle rows (avoid top/bottom edges)
    var minRow = Math.floor(gridRows / 3);
    var maxRow = Math.floor(2 * gridRows / 3);
    // Collect candidate cells by priority: empty > road > no priority > high priority > any
    var candidates = {
        empty: [],
        road: [],
        normal: [],
        high: [],
        any: []
    };
    for(var row = minRow; row <= maxRow; row++)for(var col = minCol; col <= maxCol; col++){
        var room = grid[row][col];
        if (onTrunk(row, col)) continue;
        else if (!room) candidates.empty.push({
            row: row,
            col: col
        });
        else if (room.type === 'road') candidates.road.push({
            row: row,
            col: col
        });
        else if (room.type !== 'start' && room.type !== 'exit') {
            if (!room.priority) candidates.normal.push({
                row: row,
                col: col
            });
            else if (room.priority === 'high') candidates.high.push({
                row: row,
                col: col
            });
            else if (room.priority !== 'critical') candidates.any.push({
                row: row,
                col: col
            });
        }
    }
    // Try each priority group in order
    var priorityOrder = [
        candidates.empty,
        candidates.road,
        candidates.normal,
        candidates.high,
        candidates.any
    ];
    var campsiteRow, campsiteCol;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = priorityOrder[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var group = _step.value;
            if (group.length > 0) {
                // Pick random cell from this priority group
                var cell = group[Math.floor(Math.random() * group.length)];
                grid[cell.row][cell.col] = $1249ab814b7054d4$var$createCampsite(cell.row, cell.col);
                campsiteRow = cell.row;
                campsiteCol = cell.col;
                break;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Place water adjacent to campsite
    if (campsiteRow !== undefined && campsiteCol !== undefined) {
        var adjacentCells = [
            {
                row: campsiteRow - 1,
                col: campsiteCol
            },
            {
                row: campsiteRow + 1,
                col: campsiteCol
            },
            {
                row: campsiteRow,
                col: campsiteCol - 1
            },
            {
                row: campsiteRow,
                col: campsiteCol + 1
            }
        ].filter(function(pos) {
            return pos.row >= 0 && pos.row < gridRows && pos.col >= 0 && pos.col < gridCols && !onTrunk(pos.row, pos.col);
        });
        // Water takes the best neighbour it can get, in the same priority order the
        // campsite uses above. It used to accept only empty/road/blocked, which
        // worked while roads were scattered filler — once the roads became the
        // trunk (and the trunk became off-limits) that left almost nothing legal
        // beside a campsite, and the fishing room all but disappeared from raids.
        var rank = function(room) {
            if (!room) return 0;
            if (room.type === 'road' || room.type === 'blocked') return 1;
            if (room.type === 'start' || room.type === 'exit' || room.type === 'campsite') return Infinity;
            if (room.priority === 'critical' || room.priority === 'high') return Infinity;
            return 2; // an ordinary encounter, yielded reluctantly
        };
        var spot = adjacentCells.map(function(pos) {
            return {
                pos: pos,
                rank: rank(grid[pos.row][pos.col])
            };
        }).filter(function(x) {
            return x.rank !== Infinity;
        }).sort(function(a, b) {
            return a.rank - b.rank;
        })[0];
        if (spot) grid[spot.pos.row][spot.pos.col] = $1249ab814b7054d4$var$createWater(spot.pos.row, spot.pos.col);
    }
}
function $1249ab814b7054d4$export$157aa935a4ff3471(zone) {
    var rand = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Math.random;
    var _config_zoneArchetypes_zone;
    var mix = (_config_zoneArchetypes_zone = $979b99378be707cd$export$8377a367ab2ae550[zone]) === null || _config_zoneArchetypes_zone === void 0 ? void 0 : _config_zoneArchetypes_zone.recipes;
    if (!mix) return null;
    var entries = Object.entries(mix);
    var roll = rand() * entries.reduce(function(sum, param) {
        var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), w = _param[1];
        return sum + w;
    }, 0);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step.value, 2), recipe = _step_value[0], weight = _step_value[1];
            roll -= weight;
            if (roll < 0) return recipe;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return entries[entries.length - 1][0];
}
function $1249ab814b7054d4$export$a99502f327eb386e(grid, zones, region, regionKey, gridRows, gridCols) {
    // Create a diverse pool of rooms to avoid clustering
    var roomPool = $1249ab814b7054d4$export$8d00a8f7bf03e003(region, gridRows, gridCols);
    var roomIndex = 0;
    // Fill remaining empty spaces with diverse rooms
    for(var row = 0; row < gridRows; row++){
        for(var col = 0; col < gridCols; col++)if (!grid[row][col]) {
            // Get next room from diverse pool, avoiding adjacent duplicates
            var roomData = $1249ab814b7054d4$export$7762ee06a83058a3(grid, row, col, roomPool, roomIndex, gridRows, gridCols);
            roomIndex = (roomIndex + 1) % roomPool.length;
            var currentZone = $1249ab814b7054d4$export$db5786fdbbf0e297(row, col, zones);
            var roomWithNames = $1249ab814b7054d4$export$fae1502b09cc01ab(roomData, regionKey, currentZone, row, col);
            grid[row][col] = (0, $715bf31211e65705$export$71511d61b312f219)((0, $fa9769297b8a68c8$export$71511d61b312f219)({}, roomWithNames), {
                row: row,
                col: col,
                zone: currentZone,
                // What this cell is BUILT of comes from the district, not from the
                // room standing on it — see zoneArchetypes for why. Only the fill
                // takes it: the checkpoints and high-value targets the map places by
                // hand are landmarks, and a landmark has to look like itself.
                recipe: $1249ab814b7054d4$export$157aa935a4ff3471(currentZone),
                priority: 'normal'
            });
        }
    }
}
function $1249ab814b7054d4$export$8d00a8f7bf03e003(region, gridRows, gridCols) {
    var totalRooms = gridRows * gridCols;
    var roomPool = [];
    // Calculate target counts for each room type
    var gateCount = Math.floor(totalRooms * 0.3);
    var hazardCount = Math.floor(totalRooms * 0.7);
    // Add gates with even distribution
    for(var i = 0; i < gateCount; i++){
        var gateTemplate = region.gates[i % region.gates.length];
        roomPool.push((0, $fa9769297b8a68c8$export$71511d61b312f219)({
            type: 'gate'
        }, gateTemplate));
    }
    // Add hazards with even distribution
    for(var i1 = 0; i1 < hazardCount; i1++){
        var hazardTemplate = region.hazards[i1 % region.hazards.length];
        roomPool.push((0, $fa9769297b8a68c8$export$71511d61b312f219)({
            type: 'hazard'
        }, hazardTemplate));
    }
    // Shuffle the pool to ensure random but diverse distribution
    return (0, $ca7af38ea7b7b4a8$export$7ac3a88d34a76e7)(roomPool);
}
function $1249ab814b7054d4$export$7762ee06a83058a3(grid, row, col, roomPool, startIndex, gridRows, gridCols) {
    var adjacentRooms = $1249ab814b7054d4$export$1a16c97e5b52afb(grid, row, col, gridRows, gridCols);
    // Try to find a room that's not adjacent to identical rooms
    for(var i = 0; i < roomPool.length; i++){
        var roomIndex = (startIndex + i) % roomPool.length;
        var room = roomPool[roomIndex];
        if (!adjacentRooms.includes(room.name)) return room;
    }
    // If all rooms are adjacent, just return the next one
    return roomPool[startIndex % roomPool.length];
}
function $1249ab814b7054d4$export$1a16c97e5b52afb(grid, row, col, gridRows, gridCols) {
    var adjacent = [];
    var directions = [
        [
            -1,
            0
        ],
        [
            1,
            0
        ],
        [
            0,
            -1
        ],
        [
            0,
            1
        ]
    ]; // up, down, left, right
    directions.forEach(function(param) {
        var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), dr = _param[0], dc = _param[1];
        var newRow = row + dr;
        var newCol = col + dc;
        if (newRow >= 0 && newRow < gridRows && newCol >= 0 && newCol < gridCols) {
            var room = grid[newRow][newCol];
            if (room && room.name) adjacent.push(room.name);
        }
    });
    return adjacent;
}
function $1249ab814b7054d4$export$db5786fdbbf0e297(row, col, zones) {
    var _zones_cells_row, _zones_cells;
    return (zones === null || zones === void 0 ? void 0 : (_zones_cells = zones.cells) === null || _zones_cells === void 0 ? void 0 : (_zones_cells_row = _zones_cells[row]) === null || _zones_cells_row === void 0 ? void 0 : _zones_cells_row[col]) || 'peripheral';
}
function $1249ab814b7054d4$export$5a5853dd98a11973(grid, gridRows, gridCols) {
    for(var row = 0; row < gridRows; row++){
        for(var col = 0; col < gridCols; col++)if (grid[row] && grid[row][col] === null) grid[row][col] = $1249ab814b7054d4$var$createRoad(row, col);
    }
}
function $1249ab814b7054d4$export$a678af82bf766611(path, gridData) {
    if (path.length < 2) return false;
    var start = path[0];
    var end = path[path.length - 1];
    // Must start at start position and end at end position
    if (start.row !== gridData.startPos.row || start.col !== gridData.startPos.col) return false;
    if (end.row !== gridData.endPos.row || end.col !== gridData.endPos.col) return false;
    // Check if path is continuous (adjacent moves only)
    for(var i = 1; i < path.length; i++){
        var prev = path[i - 1];
        var curr = path[i];
        var rowDiff = Math.abs(curr.row - prev.row);
        var colDiff = Math.abs(curr.col - prev.col);
        // Allow only orthogonal moves (not diagonal)
        if (rowDiff === 1 && colDiff === 0 || rowDiff === 0 && colDiff === 1) continue;
        else return false;
    }
    return true;
}
function $1249ab814b7054d4$export$7e86a2006a620b57(room, teamSkills) {
    if (room.type === 'blocked') return;
    var primarySkillLevel = teamSkills[room.primary] || 0;
    var supportSkillLevels = room.support.map(function(skill) {
        return teamSkills[skill] || 0;
    });
    var totalSupportLevel = supportSkillLevels.reduce(function(sum, level) {
        return sum + level;
    }, 0);
    // Check if primary skill is covered
    var primaryCovered = primarySkillLevel > 0;
    // Check support coverage - require at least some level in each support skill
    var supportCovered = room.support.length === 0 || room.support.every(function(skill) {
        return (teamSkills[skill] || 0) > 0;
    });
    if (primaryCovered && supportCovered) return {
        class: 'skill-covered',
        indicator: 'covered',
        symbol: "\u2713"
    };
    else if (primaryCovered) return {
        class: 'skill-match',
        indicator: 'partial',
        symbol: "\u25B2"
    };
    else return {
        class: 'skill-missing',
        indicator: 'missing',
        symbol: "\u2717"
    };
}
function $1249ab814b7054d4$export$aedd9bb9e278a90a(path) {
    if (!path || path.length === 0) return 0;
    return path.filter(function(step) {
        return step.room && (step.room.type === 'gate' || step.room.type === 'hazard');
    }).length;
}
function $1249ab814b7054d4$export$86025a0d632dc830(path, index) {
    if (!path || index < 0 || index >= path.length) return index + 1;
    var stepNumber = 1;
    for(var i = 0; i <= index; i++){
        var room = path[i].room;
        // Only count gates and hazards as actual steps
        if (room && (room.type === 'gate' || room.type === 'hazard')) {
            if (i === index) return stepNumber;
            stepNumber++;
        } else if (i === index) return '-'; // Roads, start, exit, water and campsite don't get numbers
    }
    return stepNumber;
}
function $1249ab814b7054d4$export$b381c7b121792f39(team, totalHealing) {
    var _gameState_character, _gameState_currentRaid_raidInProgress, _gameState_currentRaid;
    var injuredMembers = team.filter(function(member) {
        return member.isAlive && member.currentHp < member.maxHp;
    });
    if (injuredMembers.length === 0) return;
    // 1. Consumables FIRST: top each member off with the raid owner's HP
    //    consumables (biggest heal first, one of each, only when the deficit
    //    exceeds the value so none is wasted / overshoots maxHp).
    var inventory = ((_gameState_character = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character) === null || _gameState_character === void 0 ? void 0 : _gameState_character.inventory) || {};
    var hpConsumables = (0, $ca7af38ea7b7b4a8$export$15b7d0c192d0aa5d)().filter(function(item) {
        return item.restoresHp > 0;
    }).sort(function(a, b) {
        return b.restoresHp - a.restoresHp;
    });
    var used = {};
    injuredMembers.forEach(function(member) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = hpConsumables[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var consumable = _step.value;
                if ((inventory[consumable.id] || 0) > 0 && member.maxHp - member.currentHp > consumable.restoresHp) {
                    member.currentHp += consumable.restoresHp;
                    inventory[consumable.id] -= 1;
                    if (inventory[consumable.id] <= 0) delete inventory[consumable.id];
                    used[consumable.name] = (used[consumable.name] || 0) + 1;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    // 2. Base healing AFTER items, split by remaining need (not equally): each
    //    member gets a share proportional to its share of the total missing HP,
    //    so it flows to the worst-hurt and fills the small residual deficits the
    //    consumables' no-overshoot rule left behind. Clamped to maxHp.
    if (totalHealing > 0) {
        var deficits = injuredMembers.map(function(m) {
            return m.maxHp - m.currentHp;
        });
        var totalDeficit = deficits.reduce(function(sum, d) {
            return sum + d;
        }, 0);
        if (totalDeficit > 0) injuredMembers.forEach(function(member, i) {
            var share = Math.floor(totalHealing * deficits[i] / totalDeficit);
            member.currentHp = Math.min(member.maxHp, member.currentHp + share);
        });
    }
    var usedList = Object.entries(used);
    if (usedList.length) (0, $8bda0cb20f0b197d$export$fd59807889add359)("\uD83E\uDE79 Used ".concat(usedList.map(function(param) {
        var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), name = _param[0], qty = _param[1];
        return "".concat(qty, "\xd7 ").concat(name);
    }).join(', '), " to patch up the team"), 'info', {
        notify: false,
        stepIndex: (_gameState_currentRaid = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid) === null || _gameState_currentRaid === void 0 ? void 0 : (_gameState_currentRaid_raidInProgress = _gameState_currentRaid.raidInProgress) === null || _gameState_currentRaid_raidInProgress === void 0 ? void 0 : _gameState_currentRaid_raidInProgress.currentRoomIndex
    });
}
function $1249ab814b7054d4$export$59bc35895553fb06(team) {
    //console.log("CHECKING FOR ALIVE TEAM", team);
    if (!team || !Array.isArray(team)) return false;
    return team.some(function(member) {
        return member.isAlive;
    });
}
function $1249ab814b7054d4$export$95648a2a64dc501c(success, roomsCompleted, totalRooms, region, team, tier) {
    var creditsEarned = 0;
    if (success) {
        // Full success bonus (increased for monthly progression)
        creditsEarned = tier * 150 + roomsCompleted * 40;
        // Bonus for team survival
        var survivingMembers = team.filter(function(member) {
            return member.isAlive;
        }).length;
        var survivalBonus = Math.floor(survivingMembers / team.length * 50);
        creditsEarned += survivalBonus;
    } else {
        // Partial rewards based on completion
        var completionRatio = roomsCompleted / (totalRooms - 1);
        creditsEarned = Math.floor(tier * 100 * completionRatio);
    }
    // Apply credit scaling to raid completion bonus
    creditsEarned = (0, $8bda0cb20f0b197d$export$78a769585121af92)(creditsEarned, tier);
    return {
        creditsEarned: creditsEarned,
        success: success,
        completionRatio: roomsCompleted / (totalRooms - 1)
    };
}
function $1249ab814b7054d4$export$c994d11f45f33eb9(team) {
    team.forEach(function(member) {
        if (member.type === 'player') // Update player health
        (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.currentHp = member.currentHp;
        else if (member.type === 'contractor') {
            // Find the original contractor and update health
            var originalContractor = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.hiredContractors.find(function(c) {
                return c.id === member.id;
            });
            if (originalContractor) {
                originalContractor.currentHp = member.currentHp;
                originalContractor.maxHp = member.maxHp;
                // If contractor died, they become unavailable for a while
                if (!member.isAlive) {
                    originalContractor.injured = true;
                    originalContractor.recoveryTime = Date.now() + 86400000; // 24 hours
                }
            }
        }
    });
}
function $1249ab814b7054d4$export$1a56a513ad3028b0(success, roomsCompleted, totalRooms, region, team, tier) {
    var _config_progressionScaling_raidXpTierMultipliers, _config_progressionScaling;
    // Reduced for long-term idle progression (1-5 months to reach Tier 3)
    var baseXP = tier * 15; // 15/30/45 base XP
    // Room completion bonus
    var roomBonus = roomsCompleted * 3;
    // Success multiplier
    var successMultiplier = success ? 1.5 : 0.8;
    // Difficulty bonus based on team size vs difficulty
    var teamSize = team.filter(function(member) {
        return member.isAlive;
    }).length;
    var difficultyBonus = Math.max(0, tier * 2 - teamSize) * 3;
    // Full path completion bonus
    var fullPathBonus = roomsCompleted === totalRooms - 1 ? 10 : 0;
    // Command-era tier weighting (progressionScaling SSOT): pushing tiers
    // is the leveling ladder - T2/T3 raids pay multiples of T1
    var tierMultiplier = ((_config_progressionScaling = $979b99378be707cd$export$9f9786ac427715c7) === null || _config_progressionScaling === void 0 ? void 0 : (_config_progressionScaling_raidXpTierMultipliers = _config_progressionScaling.raidXpTierMultipliers) === null || _config_progressionScaling_raidXpTierMultipliers === void 0 ? void 0 : _config_progressionScaling_raidXpTierMultipliers[tier]) || 1;
    var totalXP = Math.floor((baseXP + roomBonus + difficultyBonus + fullPathBonus) * successMultiplier * tierMultiplier);
    return Math.max(5, totalXP); // Minimum 5 XP
}
function $1249ab814b7054d4$export$849a3b972df07241(durationInSeconds) {
    if (!durationInSeconds || durationInSeconds <= 0) return 0;
    return Math.ceil(durationInSeconds / 120); // 1 energy per 2 minutes, from character.js
}
function $1249ab814b7054d4$export$78de3bc967b7be(tier, path) {
    // Calculate total duration in seconds from all rooms in path
    //console.log('Calculating energy cost for path:', path);
    var totalDuration = path.reduce(function(sum, step) {
        return sum + (step.room.baseDuration ? step.room.baseDuration : 0);
    }, 0);
    // Energy cost: Base cost per tier + 1 energy per 40 seconds of raid duration.
    // The Sync Regulator Watch trims the total (raid-energy-reduction).
    // Base: T1: 5, T2: 10, T3: 15
    // Realistic T3 worst: 21-room path with mix of gates (120s) and hazards (60s)
    // Example: 10 gates + 11 hazards = 1200 + 660 = 1860s
    // Cost: 15 + (1860/40) = 15 + 47 = 62 energy (well under 100)
    var baseCost = 5 + (tier - 1) * 5;
    var durationCost = $1249ab814b7054d4$export$849a3b972df07241(totalDuration);
    var reduction = 1 - (0, $df8a44d92d572a5c$export$401b195eeeb2d82c)('raid-energy-reduction') / 100;
    var energyCost = Math.max(1, Math.ceil((baseCost + durationCost) * reduction));
    //console.log(`Calculated energy cost for tier ${tier} and duration ${totalDuration}s: Base ${baseCost} + Duration ${durationCost} = Total ${energyCost}`);
    return energyCost;
}
function $1249ab814b7054d4$export$595cb98aec43dd71(contractorId) {
    return (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.reservedContractors.some(function(c) {
        return c.id == contractorId;
    });
}
function $1249ab814b7054d4$export$4c8adf450afe39a2(contractorId) {
    return (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.hiredContractors.some(function(c) {
        return c.id == contractorId;
    });
}
function $1249ab814b7054d4$export$2a6c93141872f156(row, col) {
    var gridData = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid;
    // First click must be start position
    if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath.length === 0) return row === gridData.startPos.row && col === gridData.startPos.col;
    // If path already ends at exit, can't add more rooms
    if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath.length > 0) {
        var lastPos = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath[(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath.length - 1];
        var lastRoom = gridData.grid[lastPos.row][lastPos.col];
        if (lastRoom.type === 'exit') return false;
    }
    // Can't add the same room twice
    var isAlreadyInPath = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath.some(function(p) {
        return p.row === row && p.col === col;
    });
    if (isAlreadyInPath) return false;
    // Check if target cell is blocked
    var targetRoom = gridData.grid[row][col];
    if (targetRoom && targetRoom.type === 'blocked') return false;
    // Check maximum path length: rows + cols - 1 (excluding roads)
    // BUT allow connection to exit even at max steps since exit doesn't count
    var maxPathLength = (gridData.rows || gridData.size) + (gridData.cols || gridData.size) - 1;
    var currentStepCount = $1249ab814b7054d4$export$aedd9bb9e278a90a((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath);
    if (currentStepCount >= maxPathLength) {
        // At max steps, only allow roads/campsite (0 cost) or exit
        if (targetRoom && (targetRoom.type === 'exit' || targetRoom.type === 'road' || targetRoom.type === 'campsite' || targetRoom.type === 'water')) ;
        else return false; // Block gates/hazards
    }
    // Must be adjacent to last position in path
    var lastPos1 = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath[(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath.length - 1];
    var rowDiff = Math.abs(row - lastPos1.row);
    var colDiff = Math.abs(col - lastPos1.col);
    // Only allow orthogonal moves (not diagonal)
    return rowDiff === 1 && colDiff === 0 || rowDiff === 0 && colDiff === 1;
}
function $1249ab814b7054d4$export$1311cf265aa89b71() {
    var skills = new Set();
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath.forEach(function(step) {
        var room = step.room;
        if (room.type !== 'start' && room.type !== 'exit') {
            skills.add(room.primary);
            room.support.forEach(function(skill) {
                return skills.add(skill);
            });
        }
    });
    return skills;
}
function $1249ab814b7054d4$export$b34e3d9756d33d8e() {
    var skillDetails = {};
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath.forEach(function(step) {
        var room = step.room;
        if (room.type !== 'start' && room.type !== 'exit') {
            // Track primary skills
            if (!skillDetails[room.primary]) skillDetails[room.primary] = {
                name: getSkillDisplayName(room.primary),
                isPrimary: true,
                isSupport: false,
                rooms: []
            };
            skillDetails[room.primary].rooms.push(room.name);
            // Track support skills
            room.support.forEach(function(skill) {
                if (!skillDetails[skill]) skillDetails[skill] = {
                    name: getSkillDisplayName(skill),
                    isPrimary: false,
                    isSupport: true,
                    rooms: []
                };
                else if (!skillDetails[skill].isSupport) skillDetails[skill].isSupport = true;
                skillDetails[skill].rooms.push("".concat(room.name, " (support)"));
            });
        }
    });
    return skillDetails;
}
function $1249ab814b7054d4$export$bf19dc1273cbd1a1() {
    var raidTeam = $1249ab814b7054d4$export$d17f5534c14b3dc5();
    var teamSkills = {};
    //console.log('Calculating team skills from raid team:', raidTeam);
    raidTeam.forEach(function(member) {
        Object.entries(member.skills).forEach(function(param) {
            var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), skill = _param[0], level = _param[1];
            teamSkills[skill] = Math.max(teamSkills[skill] || 0, level);
        });
    });
    return teamSkills;
}
function $1249ab814b7054d4$export$c41f4a6445888331() {
    var techniques = new Set();
    $1249ab814b7054d4$export$d17f5534c14b3dc5().forEach(function(member) {
        var list = member.equippedTechniques || Object.keys(member.equippedTechniqueGear || {});
        list.forEach(function(t) {
            return techniques.add(t);
        });
    });
    return techniques;
}
function $1249ab814b7054d4$export$4b1577d33ea2a4be(skillId, teamTechniques) {
    var _getEffect;
    if (!teamTechniques || teamTechniques.size === 0) return 0;
    var total = 0, covered = 0;
    Object.values($979b99378be707cd$export$aafe7b77259ba40d).forEach(function(list) {
        return list.forEach(function(t) {
            if (t.skill === skillId) {
                total++;
                if (teamTechniques.has(t.id)) covered++;
            }
        });
    });
    if (total === 0 || covered === 0) return 0;
    var bonus = (((_getEffect = (0, $ca7af38ea7b7b4a8$export$96671014a1dabc4c)('technique-success-bonus')) === null || _getEffect === void 0 ? void 0 : _getEffect.value) || 0) / 100;
    return bonus * covered / total;
}
function $1249ab814b7054d4$export$b66d09bc2336a346() {
    return "raid_".concat(Date.now(), "_").concat(Math.random().toString(36).substr(2, 9));
}
function $1249ab814b7054d4$export$8d04a96d2d0c681f(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
}
function $1249ab814b7054d4$export$9e1671340fa76e74(itemName) {
    var ctx = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _config_raidFlavor_item_type;
    var itemSearch = Object.values((0, $ca7af38ea7b7b4a8$export$15b7d0c192d0aa5d)()).filter(function(item) {
        return item.name === itemName;
    });
    if (itemSearch.length === 0) return ""; // silent if no item found
    var item = itemSearch[0];
    var base = (_config_raidFlavor_item_type = $979b99378be707cd$export$3e15389530921005[item.type]) === null || _config_raidFlavor_item_type === void 0 ? void 0 : _config_raidFlavor_item_type[item.tier];
    if (!base) return ""; // silent if no template
    var core = $1249ab814b7054d4$export$8d04a96d2d0c681f(base);
    // 20% chance to append a faction "tag" (keeps lines short)
    var tag = "";
    if (ctx.faction && $979b99378be707cd$export$ca2adec0fe632974[ctx.faction] && Math.random() < 0.2) tag = " " + $1249ab814b7054d4$export$8d04a96d2d0c681f($979b99378be707cd$export$ca2adec0fe632974[ctx.faction]);
    // 20% chance to weave a tiny context shard
    var shard = "";
    if (Math.random() < 0.2) {
        var a = $1249ab814b7054d4$export$8d04a96d2d0c681f($979b99378be707cd$export$732c9d6827dc2245.action);
        var l = ctx.shortLocation || $1249ab814b7054d4$export$8d04a96d2d0c681f($979b99378be707cd$export$732c9d6827dc2245.location);
        shard = " (".concat(a, " from ").concat(l, ")");
    }
    // keep under ~80 chars
    var line = "".concat(core).concat(tag).concat(shard);
    if (line.length > 84) line = core + (tag ? tag : "");
    return line;
}
function $1249ab814b7054d4$export$dfbeebc3d1509da(room, tier, rarity) {
    var loot = {};
    var quantityRange = (0, $8bda0cb20f0b197d$export$540736c4d7813ac)(rarity, tier, room.type);
    var quantity = Math.round(Math.random() * (quantityRange.max - quantityRange.min)) + quantityRange.min;
    var itemPool = (0, $52a7294453bdb6d1$export$ded25040c5f0ed12)(room, tier, rarity);
    // Select random item from pool
    if (itemPool.length > 0) {
        var item = itemPool[Math.floor(Math.random() * itemPool.length)];
        loot[item] = quantity;
    }
    return loot;
}
function $1249ab814b7054d4$export$ac5141fc59c5fe4f(room, regionTier) {
    if (room.type === 'start' || room.type === 'exit' || room.type === 'road') return [];
    var possibleLoot = [];
    if (room.type === 'gate') {
        var // Rare materials
        _possibleLoot, // Story relics (tier 4+)
        _possibleLoot1;
        (_possibleLoot = possibleLoot).push.apply(_possibleLoot, (0, $4c858c0d999a5b9b$export$71511d61b312f219)((0, $52a7294453bdb6d1$export$ded25040c5f0ed12)(room, regionTier, 'rare').slice(0, 3)));
        // Blueprints
        possibleLoot.push($979b99378be707cd$export$d02ea220375e4aff.blueprint.name);
        (_possibleLoot1 = possibleLoot).push.apply(_possibleLoot1, (0, $4c858c0d999a5b9b$export$71511d61b312f219)((0, $52a7294453bdb6d1$export$ded25040c5f0ed12)(room, regionTier, 'unique').slice(0, 2)));
    } else {
        var // Common materials
        _possibleLoot2, _possibleLoot3, _consumables, _possibleLoot4, _relics, _possibleLoot5;
        (_possibleLoot2 = possibleLoot).push.apply(_possibleLoot2, (0, $4c858c0d999a5b9b$export$71511d61b312f219)((0, $52a7294453bdb6d1$export$ded25040c5f0ed12)(room, regionTier, 'common').slice(0, 2)));
        // Rare materials (tier 3+)
        if (regionTier >= 3) (_possibleLoot3 = possibleLoot).push.apply(_possibleLoot3, (0, $4c858c0d999a5b9b$export$71511d61b312f219)((0, $52a7294453bdb6d1$export$ded25040c5f0ed12)(room, regionTier, 'rare').slice(0, 2)));
        // Consumables by tier
        var tierRarity = (0, $8bda0cb20f0b197d$export$65aa634013c8a9db)(regionTier);
        var consumables = (0, $8bda0cb20f0b197d$export$b1ad0808e6cb0531)('consumable', tierRarity);
        if (consumables.length === 0) (_consumables = consumables).push.apply(_consumables, (0, $4c858c0d999a5b9b$export$71511d61b312f219)((0, $8bda0cb20f0b197d$export$b1ad0808e6cb0531)('consumable', 'common')));
        (_possibleLoot4 = possibleLoot).push.apply(_possibleLoot4, (0, $4c858c0d999a5b9b$export$71511d61b312f219)(consumables.slice(0, 2)));
        // Relics by tier
        var relics = (0, $8bda0cb20f0b197d$export$b1ad0808e6cb0531)('relic', tierRarity);
        if (relics.length === 0) (_relics = relics).push.apply(_relics, (0, $4c858c0d999a5b9b$export$71511d61b312f219)((0, $8bda0cb20f0b197d$export$b1ad0808e6cb0531)('relic', 'common')));
        (_possibleLoot5 = possibleLoot).push.apply(_possibleLoot5, (0, $4c858c0d999a5b9b$export$71511d61b312f219)(relics.slice(0, 2)));
    }
    // All rooms - credits
    possibleLoot.push('Credits');
    return possibleLoot;
}
function $1249ab814b7054d4$export$1bd6296261413c8c(team) {
    var skills = {};
    team.forEach(function(member) {
        if (member.isAlive) Object.entries(member.skills).forEach(function(param) {
            var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), skill = _param[0], level = _param[1];
            skills[skill] = Math.max(skills[skill] || 0, level);
        });
    });
    return skills;
}
var $1249ab814b7054d4$export$1b78a23f03a8d95f = 0.7;
var $1249ab814b7054d4$export$e19e68234418033a = 0.4;
function $1249ab814b7054d4$export$ac3767a8a135daf7(successChance) {
    if (successChance >= $1249ab814b7054d4$export$1b78a23f03a8d95f) return {
        indicator: 'strong',
        symbol: "\u2713"
    };
    if (successChance >= $1249ab814b7054d4$export$e19e68234418033a) return {
        indicator: 'risky',
        symbol: "\u25B2"
    };
    return {
        indicator: 'poor',
        symbol: "\u2717"
    };
}
function $1249ab814b7054d4$export$278313c6a8f74dd(room, teamSkills) {
    var raidTier = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, teamTechniques = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    if (room.type === 'start' || room.type === 'exit' || room.type === 'road') return 1.0; // Always succeed for special rooms
    // Get raid tier from current grid if not provided
    if (!raidTier && (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid) raidTier = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid.tier;
    raidTier = raidTier || 1; // Default to tier 1
    // Get target skill level for this room type and tier
    var targetSkill = room.type == 'gate' ? $979b99378be707cd$export$94e7ad7999c1ae32[raidTier].gateSkillLevel : $979b99378be707cd$export$94e7ad7999c1ae32[raidTier].hazardSkillLevel;
    var primarySkill = teamSkills[room.primary] || 0;
    // Calculate support bonus with 15% cap to prevent exploits
    var rawSupportBonus = room.support.reduce(function(sum, skill) {
        return sum + (teamSkills[skill] || 0);
    }, 0) * 0.1;
    var supportBonus = Math.min(rawSupportBonus, 0.15);
    //console.log(`Calculating success chance for room ${room.name} (Type: ${room.type}, Tier: ${raidTier})`);
    //console.log(` - Target Skill: ${targetSkill}`);
    //console.log(` - Primary Skill (${room.primary}): ${primarySkill}`);
    //console.log(` - Support Bonus: ${supportBonus.toFixed(2)} (capped from ${rawSupportBonus.toFixed(2)})`);
    // Improved progression-based success chance calculation
    // Base 76% chance when skill equals target, +/- 5% per skill level
    // difference; equipped gear adds its expected bonus (see
    // getGearExpectedBonus) and the equipped skill artifact its flat +5%
    // when it matches the room's primary skill (exact, not an expectation)
    var skillDifference = primarySkill - targetSkill;
    var gearBonus = $1249ab814b7054d4$export$4b1577d33ea2a4be(room.primary, teamTechniques);
    var artifactBonus = (0, $df8a44d92d572a5c$export$a5a257639bbcfa93)(room.primary) / 100;
    var successChance = 0.76 + skillDifference * 0.05 + supportBonus + gearBonus + artifactBonus;
    // Ensure minimum 20% chance
    successChance = Math.max(0.20, successChance);
    // Cap at 97%
    successChance = Math.min(0.97, successChance);
    return successChance;
}
function $1249ab814b7054d4$export$26622a6bc351fd6d() {
    var path = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    if (!path) path = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath;
    if (!path || path.length === 0) return 0;
    var teamSkills = $1249ab814b7054d4$export$bf19dc1273cbd1a1();
    var teamTechniques = $1249ab814b7054d4$export$c41f4a6445888331();
    var raidTier = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid ? (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid.tier : 1;
    var overallChance = 1.0;
    // Calculate compound probability across all rooms that require skill checks
    path.forEach(function(step) {
        var room = step.room;
        if (room.type !== 'start' && room.type !== 'exit' && room.type !== 'road' && room.type !== 'campsite' && room.type !== 'water') {
            var roomChance = $1249ab814b7054d4$export$278313c6a8f74dd(room, teamSkills, raidTier, teamTechniques);
            //console.log(overallChance, '*', roomChance, '=', overallChance * roomChance);
            overallChance *= roomChance;
        }
    });
    return overallChance;
}
function $1249ab814b7054d4$export$6d9d0391c1a1da34() {
    var team = [];
    // Add player character
    team.push({
        id: 'player',
        name: (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.name,
        type: 'player',
        faction: (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.faction,
        skills: (0, $fa9769297b8a68c8$export$71511d61b312f219)({}, (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.skills),
        // Equipped skill-gear technique ids: drive event variant selection
        // and the per-technique success bonus during the raid
        equippedTechniques: Object.keys((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.equippedTechniqueGear || {}),
        maxHp: (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.maxHp,
        currentHp: (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.currentHp || (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.maxHp,
        isAlive: true,
        injuries: []
    });
    // Add hired contractors
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.hiredContractors.forEach(function(contractor) {
        team.push({
            id: contractor.id,
            name: contractor.name,
            type: 'contractor',
            faction: contractor.faction,
            skills: (0, $fa9769297b8a68c8$export$71511d61b312f219)({}, contractor.skills),
            equippedTechniques: Object.keys(contractor.equippedTechniqueGear || {}),
            maxHp: contractor.maxHp || 100,
            currentHp: contractor.currentHp || contractor.maxHp || 100,
            isAlive: true,
            injuries: [],
            cost: contractor.cost
        });
    });
    // Set current HP to max for all members
    team.forEach(function(member) {
        if (member.currentHp === null) member.currentHp = member.maxHp;
    });
    return team;
}
function $1249ab814b7054d4$export$d17f5534c14b3dc5() {
    var team = [];
    //console.log("CREATING TEAM", gameState.currentRaid.hiredContractors);
    if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character) team.push((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character);
    if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid) {
        if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.hiredContractors && (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.hiredContractors.length > 0) (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.hiredContractors.forEach(function(contractor) {
            team.push(contractor);
        });
        else if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.reservedContractors && (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.reservedContractors.length > 0) (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.reservedContractors.forEach(function(contractor) {
            team.push(contractor);
        });
    }
    //console.log("CREATED TEAM OF ", team.length);
    return team;
}
function $1249ab814b7054d4$export$81a3d8aa8b7e7939() {
    if (!(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid || !(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character || (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath.length === 0) return false;
    // Check if current character is on marketplace
    if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.isMarketplace) {
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)('Cannot start raids with a character that is contracted out on the marketplace', 'error');
        return false;
    }
    // Validate path
    if (!$1249ab814b7054d4$export$a678af82bf766611((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath, (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid)) {
        var errorMsg = 'Invalid path! Make sure you start at the entry portal and end at the exit portal.';
        if (typeof alert !== 'undefined') alert(errorMsg);
        else console.warn(errorMsg);
        return false;
    }
    // Check energy requirements
    var tier = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid.tier;
    var energyCost = $1249ab814b7054d4$export$78de3bc967b7be(tier, (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath);
    if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player.energy < energyCost) {
        var errorMsg1 = "Not enough energy! This raid requires ".concat(energyCost, " energy. You have ").concat((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player.energy, ". Energy regenerates over time.");
        if (typeof alert !== 'undefined') alert(errorMsg1);
        else console.warn(errorMsg1);
        return false;
    }
    return true;
}
function $1249ab814b7054d4$export$43eae605f498c00a() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var _gameState_characters, tier, energyCost, currentCharacter, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, contractor, raidId, err, startHpFraction, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, member;
        return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    // Consume energy
                    tier = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid.tier;
                    energyCost = $1249ab814b7054d4$export$78de3bc967b7be(tier, (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath);
                    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player.energy -= energyCost;
                    // Hire reserved contractors (no upfront cost - they take percentage of rewards)
                    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.hiredContractors = (0, $4c858c0d999a5b9b$export$71511d61b312f219)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.reservedContractors);
                    // Update database for multiplayer contractors
                    currentCharacter = (_gameState_characters = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).characters) === null || _gameState_characters === void 0 ? void 0 : _gameState_characters.find(function(c) {
                        return c.id === (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).activeCharacterId;
                    });
                    if (!currentCharacter) return [
                        3,
                        8
                    ];
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        8
                    ]);
                    _iterator = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.hiredContractors[Symbol.iterator]();
                    _state.label = 2;
                case 2:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        5
                    ];
                    contractor = _step.value;
                    if (!contractor.multiplayerId) return [
                        3,
                        4
                    ];
                    raidId = $1249ab814b7054d4$export$b66d09bc2336a346(); // Generate unique raid ID
                    // tier lets the server reject a contract that would expire mid-raid
                    return [
                        4,
                        (0, $fde0976ce5d1665d$export$e4477200b6413a70).hireContractor(contractor.multiplayerId, currentCharacter.multiplayerId, raidId, tier)
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        8
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        8
                    ];
                case 7:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 8:
                    // Clear reserved contractors
                    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.reservedContractors = [];
                    // Cold Drop: the convoy arrives already hurt. Applied HERE, at raid init and
                    // to the whole team, rather than at team assembly — assembly runs while the
                    // player is still planning, and docking HP there would let them heal back up
                    // before launching and pocket the perk for free.
                    startHpFraction = (0, $686e361e5cd4549d$export$a2c94bc2dc5c01e1)('startHpFraction', 1);
                    _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    if (startHpFraction < 1) try {
                        for(_iterator1 = $1249ab814b7054d4$export$d17f5534c14b3dc5()[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            member = _step1.value;
                            member.currentHp = Math.max(1, Math.floor(member.maxHp * startHpFraction));
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    // Record raid time
                    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).lastRaidTime = Date.now();
                    // Initialize raid state in gameState for persistence
                    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress = {
                        raidTeam: $1249ab814b7054d4$export$d17f5534c14b3dc5(),
                        teamSkills: null,
                        raidSuccess: true,
                        roomsCompleted: 0,
                        lootGained: {},
                        currentRoomIndex: 0,
                        startTime: Date.now(),
                        nextRoomTime: Date.now(),
                        logEntries: [],
                        progressiveLoot: {
                            active: false,
                            totalLoot: {},
                            distributedLoot: {},
                            intervals: [],
                            nextLootTime: 0,
                            roomName: ''
                        },
                        specialEvent: {
                            active: false,
                            scheduled: false,
                            spawnTime: null,
                            element: null,
                            roomIndex: null
                        }
                    };
                    // Calculate team skills
                    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress.teamSkills = $1249ab814b7054d4$export$1bd6296261413c8c($1249ab814b7054d4$export$d17f5534c14b3dc5());
                    return [
                        2
                    ];
            }
        });
    })();
}
function $1249ab814b7054d4$export$493c70936cbe8c13() {
    if (!(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress) return;
    var currentTime = Date.now();
    var raid = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress;
    var pathStep = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath[raid.currentRoomIndex];
    // Process all scheduled events for the current room (skill-check, bonus loot, fishing) via unified event system
    var eventInfo = (0, $52a7294453bdb6d1$export$a2efc3d0c71d9b81)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172), $1249ab814b7054d4$export$d17f5534c14b3dc5());
    if (eventInfo) for(var i = 0; i < 10; i++){
        if ((eventInfo === null || eventInfo === void 0 ? void 0 : eventInfo.eventLifeCycle) == 'start') switch(eventInfo.eventType){
            case 'skillCheck':
                // team read live, like the resolve call below: this loop can resolve
                // one event and start the next in the same tick, and a casualty in
                // between changes which techniques are available
                (0, $52a7294453bdb6d1$export$3d092dd9a898451d)(eventInfo.eventData, raid.currentRoomIndex, (0, $fe47a452a83d9e00$export$8e361a1ffbebf172), $1249ab814b7054d4$export$d17f5534c14b3dc5());
                break;
            case 'bonusLoot':
                (0, $52a7294453bdb6d1$export$de2180cc63765512)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172));
                break;
            case 'fishing':
                (0, $52a7294453bdb6d1$export$99ca7bb292cc775d)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172));
                break;
        }
        else if ((eventInfo === null || eventInfo === void 0 ? void 0 : eventInfo.eventLifeCycle) == 'end') switch(eventInfo.eventType){
            case 'skillCheck':
                (0, $52a7294453bdb6d1$export$7408e7aadd9fb0b0)(eventInfo.eventData, (0, $fe47a452a83d9e00$export$8e361a1ffbebf172), pathStep.room, $1249ab814b7054d4$export$d17f5534c14b3dc5());
                break;
        }
        eventInfo = (0, $52a7294453bdb6d1$export$a2efc3d0c71d9b81)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172), $1249ab814b7054d4$export$d17f5534c14b3dc5());
    }
    //processScheduledEvents(gameState, getRaidTeam());
    // No time check for simulation
    //console.log("time check debug:", gameState.simulated||"no-sim", currentTime, gameState.currentRaid.raidInProgress.nextRoomTime);
    if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).simulated || currentTime >= (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress.nextRoomTime) {
        var shouldContinue = $1249ab814b7054d4$export$755aced95cf6ca1e();
        if (shouldContinue) $1249ab814b7054d4$export$40c1d154d5089b4f();
    }
}
function $1249ab814b7054d4$export$755aced95cf6ca1e() {
    var raid = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress;
    if (raid.currentRoomIndex >= (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath.length) {
        //somehow we exited but something went wrong
        $1249ab814b7054d4$export$58d6519cd8e111b3();
        return false; // Don't enter next room
    }
    var pathStep = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath[raid.currentRoomIndex];
    var room = pathStep.room;
    // Count room events before cleanup (for tracking/analytics)
    var eventCounts = (0, $52a7294453bdb6d1$export$851890b870f423fa)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172));
    // Accumulate event statistics in raid object for later retrieval
    if (!raid.eventStats) raid.eventStats = {
        skillCheckEvents: 0,
        bonusLootEvents: 0
    };
    raid.eventStats.skillCheckEvents += eventCounts.skillCheckCount;
    raid.eventStats.bonusLootEvents += eventCounts.hasBonusLoot ? 1 : 0;
    // Cleanup all room events (skill-check, bonus loot, fishing) via eventSystem
    (0, $52a7294453bdb6d1$export$3645ad137fdaf2f9)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172));
    (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).raid, "Completing room ".concat(raid.currentRoomIndex, "/").concat((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath.length - 1, ": ").concat(room.name, " (").concat(room.type, ")"));
    switch(room.type){
        case 'exit':
            $1249ab814b7054d4$var$processExitRoomCompletion(raid, room);
            return false;
        case 'start':
            $1249ab814b7054d4$var$processEntryRoomCompletion(raid, room);
            break;
        case 'road':
            $1249ab814b7054d4$var$processRoadRoomCompletion(raid, room);
            break;
        case 'campsite':
            $1249ab814b7054d4$var$processCampsiteRoomCompletion(raid, room);
            break;
        case 'water':
            $1249ab814b7054d4$var$processWaterRoomCompletion(raid, room);
            break;
        case 'gate':
        case 'hazard':
            var proceed = $1249ab814b7054d4$var$processNormalRoomCompletion(raid, room);
            if (!proceed) return false;
    }
    raid.currentRoomIndex++;
    //raid.nextRoomTime = Date.now() + (room.baseDuration*1000);
    // Check if we've completed all rooms or raid failed
    //console.log('checking currentRoomIndex', raid.currentRoomIndex, gameState.currentRaid.selectedPath.length, raid.raidSuccess);
    if (raid.currentRoomIndex >= (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath.length || !raid.raidSuccess) {
        $1249ab814b7054d4$export$58d6519cd8e111b3();
        return false; // Don't enter next area
    } else return true; // Continue to next area
}
function $1249ab814b7054d4$var$processExitRoomCompletion(raid, room) {
    (0, $8bda0cb20f0b197d$export$fd59807889add359)("\uD83C\uDF0C Reached the exit portal! Raid completed successfully!", 'success', {
        notificationMessage: "\uD83C\uDF0C Raid completed successfully!",
        stepIndex: raid.currentRoomIndex
    });
    room.result = {
        success: true,
        damage: 0,
        healing: 0,
        loot: {}
    };
    raid.currentRoomIndex++;
    $1249ab814b7054d4$export$58d6519cd8e111b3();
}
function $1249ab814b7054d4$var$processEntryRoomCompletion(raid, room) {
    var nextPathStep = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath[raid.currentRoomIndex];
    var nextRoom = nextPathStep.room;
    room.result = {
        success: true,
        damage: 0,
        healing: 0,
        loot: {}
    };
}
function $1249ab814b7054d4$var$processRoadRoomCompletion(raid, room) {
    (0, $8bda0cb20f0b197d$export$fd59807889add359)("\uD83D\uDEE3\uFE0F Leaving ".concat(room.name), 'info', {
        notificationMessage: "\uD83D\uDEE3\uFE0F Leaving ".concat(room.name),
        stepIndex: raid.currentRoomIndex
    });
    room.result = {
        success: true,
        damage: 0,
        healing: 0,
        loot: {}
    };
}
function $1249ab814b7054d4$var$processCampsiteRoomCompletion(raid, room) {
    var raidTeam = $1249ab814b7054d4$export$d17f5534c14b3dc5();
    var healingAmount = room.healingAmount || 30;
    Object.entries(raid.lootGained).forEach(function(param) {
        var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), item = _param[0], amount = _param[1];
        if (item === 'Fish') {
            var foodHealingAmount = room.healingAmount * 0.1 * amount;
            $1249ab814b7054d4$export$b381c7b121792f39(raidTeam, foodHealingAmount);
            (0, $8bda0cb20f0b197d$export$fd59807889add359)("\uD83D\uDC1F Team eats a meal of fresh caught fish", 'success', {
                notificationMessage: "\uD83D\uDC1F Team healed for ".concat(foodHealingAmount, " HP"),
                stepIndex: raid.currentRoomIndex
            });
        }
    });
    $1249ab814b7054d4$export$b381c7b121792f39(raidTeam, healingAmount);
    (0, $8bda0cb20f0b197d$export$fd59807889add359)("\uD83D\uDC9A Team tended to their wounds", 'success', {
        notificationMessage: "\uD83D\uDC9A Team healed for ".concat(healingAmount, " HP"),
        stepIndex: raid.currentRoomIndex
    });
    // Show healing details for each team member
    raidTeam.forEach(function(member) {
        if (member.currentHp > 1) (0, $8bda0cb20f0b197d$export$fd59807889add359)("\uD83D\uDC9A ".concat(member.name, " recovered HP (").concat(member.currentHp, "/").concat(member.maxHp, ")"), 'success', {
            notify: false,
            stepIndex: raid.currentRoomIndex
        });
    });
    room.result = {
        success: true,
        damage: 0,
        healing: healingAmount,
        loot: {}
    };
    raid.roomsCompleted++;
}
function $1249ab814b7054d4$var$processWaterRoomCompletion(raid, room) {
    // Fishing events are handled separately
    room.result = {
        success: true,
        damage: 0,
        healing: 0,
        loot: {}
    };
    raid.roomsCompleted++;
}
function $1249ab814b7054d4$var$processNormalRoomCompletion(raid, room) {
    var _raid_events;
    // Check if all skill-check events have completed (event system handles outcomes and damage)
    var tier = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid.tier;
    var skillCheckEvents = ((_raid_events = raid.events) === null || _raid_events === void 0 ? void 0 : _raid_events.skillCheckEvents) || [];
    var allEventsCompleted = skillCheckEvents.length === 0 || skillCheckEvents.every(function(e) {
        return e.status === 'completed' || e.status === 'failed';
    });
    // If events haven't finished yet, don't process room completion
    if (skillCheckEvents.length > 0 && !allEventsCompleted) return false;
    var roomSuccess = !raid.hasSkillEventFailure;
    room.result = {
        success: roomSuccess
    };
    if (roomSuccess) {
        (0, $8bda0cb20f0b197d$export$fd59807889add359)("\u2705 Area secured successfully!", 'success', {
            notificationMessage: "\u2705 ".concat(room.name, " secured!"),
            stepIndex: raid.currentRoomIndex
        });
        raid.roomsCompleted++;
    } else {
        (0, $8bda0cb20f0b197d$export$fd59807889add359)("\u274C Failed to clear ".concat(room.name, "!"), 'failure', {
            stepIndex: raid.currentRoomIndex
        });
        // A member who went down stops contributing their skills to the rest of
        // the raid. calculateTeamSkills filters on isAlive, so this recalculation
        // is what actually removes them — without it a knocked-out specialist
        // keeps passing checks for every remaining room.
        //
        // RESTORED 2026-08-02. The old applyDamageToTeam did this inline; the
        // rewrite to per-event damage in eventSystem-core dropped it, and nothing
        // caught it because applyDamageToTeam was left in place as dead code that
        // still looked like the live path. Consequence while it was missing:
        // raids were EASIER than designed, so expect Tier 3 success to fall now.
        raid.teamSkills = $1249ab814b7054d4$export$1bd6296261413c8c($1249ab814b7054d4$export$d17f5534c14b3dc5());
        // Check if raid should continue - only team wipe ends the raid
        if (!$1249ab814b7054d4$export$59bc35895553fb06($1249ab814b7054d4$export$d17f5534c14b3dc5())) {
            (0, $8bda0cb20f0b197d$export$fd59807889add359)("\uD83D\uDC80 All team members incapacitated - raid terminated!", 'failure', {
                notificationMessage: "\uD83D\uDC80 All team members incapacitated!",
                stepIndex: raid.currentRoomIndex
            });
            raid.raidSuccess = false;
            $1249ab814b7054d4$export$58d6519cd8e111b3();
            return false;
        } else (0, $8bda0cb20f0b197d$export$fd59807889add359)("\u26A0\uFE0F The team continues despite setbacks...", 'info', {
            notify: false,
            stepIndex: raid.currentRoomIndex
        });
    }
    // Award base room credits
    var tierData = $979b99378be707cd$export$94e7ad7999c1ae32[tier];
    if (tierData && tierData.creditRewards) {
        var baseCredit = tierData.creditRewards.baseRoomCredit;
        // Apply credit scaling multipliers
        baseCredit = (0, $8bda0cb20f0b197d$export$78a769585121af92)(baseCredit, tier);
        (0, $8bda0cb20f0b197d$export$d2188f6548dbea9f)(raid.lootGained, 'Credits', baseCredit);
        (0, $8bda0cb20f0b197d$export$fd59807889add359)("\uD83D\uDCB0 Intelligence report payout: ".concat(baseCredit, " credits"), 'bonus', {
            stepIndex: raid.currentRoomIndex
        });
        // Award completion bonus if all skill-check events passed
        if (!raid.hasSkillEventFailure) {
            var completionBonus = tierData.creditRewards.completionBonus;
            // Apply credit scaling multipliers
            completionBonus = (0, $8bda0cb20f0b197d$export$78a769585121af92)(completionBonus, tier);
            (0, $8bda0cb20f0b197d$export$d2188f6548dbea9f)(raid.lootGained, 'Credits', completionBonus);
            (0, $8bda0cb20f0b197d$export$fd59807889add359)("\uD83D\uDCB0 Complete intelligence bonus: ".concat(completionBonus, " credits"), 'bonus', {
                stepIndex: raid.currentRoomIndex
            });
        }
    }
    (0, $8bda0cb20f0b197d$export$fd59807889add359)("\uD83D\uDCCD Leaving ".concat(room.name, " (").concat(raid.currentRoomIndex, "/").concat((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath.length - 2, ")"), 'info', {
        notificationMessage: "\uD83D\uDCCD Leaving ".concat(room.name),
        stepIndex: raid.currentRoomIndex
    });
    return true;
}
function $1249ab814b7054d4$export$40c1d154d5089b4f() {
    var raid = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress;
    var pathStep = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath[raid.currentRoomIndex];
    var room = pathStep.room;
    // Schedule room start and end times
    raid.roomStartTime = Date.now();
    raid.nextRoomTime = raid.roomStartTime + room.baseDuration * 1000;
    switch(room.type){
        case 'gate':
        case 'hazard':
            (0, $8bda0cb20f0b197d$export$fd59807889add359)("\uD83D\uDCCD Entered ".concat(room.name, " (").concat(raid.roomsCompleted + 1, "/").concat($1249ab814b7054d4$export$aedd9bb9e278a90a((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath), ")"), 'info', {
                notificationMessage: "\uD83D\uDCCD Entered ".concat(room.name),
                stepIndex: raid.currentRoomIndex
            });
            // Initialize skill-check events and conditional bonus loot via eventSystem
            (0, $52a7294453bdb6d1$export$5c6c29dc14ccb545)(room, (0, $fe47a452a83d9e00$export$8e361a1ffbebf172));
            break;
        case 'road':
            (0, $8bda0cb20f0b197d$export$fd59807889add359)("\uD83D\uDEE3\uFE0F Entered ".concat(room.name), 'info', {
                notificationMessage: "\uD83D\uDEE3\uFE0F Entered ".concat(room.name),
                stepIndex: raid.currentRoomIndex
            });
            break;
        case 'campsite':
            (0, $8bda0cb20f0b197d$export$fd59807889add359)("\uD83C\uDFD5\uFE0F Team sets up camp and recovers", 'info', {
                notificationMessage: "\uD83C\uDFD5\uFE0F Found a safe campsite",
                stepIndex: raid.currentRoomIndex
            });
            break;
        case 'water':
            (0, $8bda0cb20f0b197d$export$fd59807889add359)("\uD83C\uDF0A Team discovers a fishing spot", 'info', {
                notificationMessage: "\uD83C\uDF0A Found water source",
                stepIndex: raid.currentRoomIndex
            });
            // Initialize fishing event via eventSystem
            (0, $52a7294453bdb6d1$export$5c6c29dc14ccb545)(room, (0, $fe47a452a83d9e00$export$8e361a1ffbebf172));
            break;
    }
}
function $1249ab814b7054d4$export$58d6519cd8e111b3() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var _gameState_characters, raid, region, tier, finalResults, totalContractorPercentage, contractorPayment, playerCredits, xpEarned, contractorXP, contractorPayments, onlinePayments, _gameState_currentRaid_currentRaidGrid, _gameState_currentRaid_currentRaidGrid1, key, blackoutEarned, _getBlackoutContract, currentCharacter, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, contractor, err;
        return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    raid = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress;
                    region = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid.region;
                    // Clean up any active special events
                    //if (raid.specialEvent && raid.specialEvent.active) {
                    //cleanupBonusEvent();
                    //}
                    // Calculate final results
                    tier = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid.tier;
                    finalResults = $1249ab814b7054d4$export$95648a2a64dc501c(raid.raidSuccess, raid.roomsCompleted, (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath.length, region, $1249ab814b7054d4$export$d17f5534c14b3dc5(), tier);
                    // Calculate contractor payments from total credits earned
                    totalContractorPercentage = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.hiredContractors.length > 0 ? (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.hiredContractors.reduce(function(sum, contractor) {
                        return sum + contractor.rewardPercentage;
                    }, 0) : 0;
                    contractorPayment = Math.floor(finalResults.creditsEarned * totalContractorPercentage / 100);
                    playerCredits = finalResults.creditsEarned - contractorPayment;
                    // Note: Credit scaling is already applied when individual credits are looted (base room, events, completion bonus)
                    // This finalResults amount is a bonus calculation separate from looted credits
                    // Apply results to hiring player (they pay for all contractors)
                    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player.credits += playerCredits;
                    // Calculate XP for contractors (before payments to avoid duplication)
                    xpEarned = $1249ab814b7054d4$export$1a56a513ad3028b0(raid.raidSuccess, raid.roomsCompleted, (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath.length, region, $1249ab814b7054d4$export$d17f5534c14b3dc5(), tier);
                    contractorXP = Math.floor(xpEarned * 0.8); // Contractors get 80% of player XP
                    // Calculate individual contractor payments and send to owners
                    contractorPayments = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.hiredContractors.map(function(contractor) {
                        return {
                            contractorId: contractor.id,
                            contractorName: contractor.name,
                            isPlayerContractor: contractor.id > 0,
                            percentage: contractor.rewardPercentage,
                            credits: Math.floor(finalResults.creditsEarned * contractor.rewardPercentage / 100),
                            xp: contractorXP
                        };
                    });
                    // Send credits and XP to player contractor owners (AI contractors don't get real credits/XP).
                    // Awaited so the payments are recorded while the contractors are still marked
                    // hired — the server verifies the hire relationship, and the release below
                    // clears it (see finishRaid contractor release).
                    onlinePayments = contractorPayments.filter(function(p) {
                        return p.isPlayerContractor;
                    });
                    if (!(onlinePayments.length > 0)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        (0, $fde0976ce5d1665d$export$2d25a36fab5567cb)(onlinePayments)
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    if (finalResults.creditsEarned > 0) {
                        (0, $8bda0cb20f0b197d$export$fd59807889add359)("\uD83D\uDCB0 Total raid earnings: ".concat(finalResults.creditsEarned, " credits"), 'success', {
                            stepIndex: (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath.length - 1,
                            notificationMessage: "\uD83D\uDCB0 Earned ".concat(playerCredits, " credits")
                        });
                        if (contractorPayment > 0) {
                            (0, $8bda0cb20f0b197d$export$fd59807889add359)("\uD83D\uDCBC Contractor payments: ".concat(contractorPayment, " credits (").concat(totalContractorPercentage, "%)"), 'info', {
                                notify: false,
                                stepIndex: (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath.length - 1
                            });
                            (0, $8bda0cb20f0b197d$export$fd59807889add359)("\uD83D\uDCB0 Your share: ".concat(playerCredits, " credits"), 'success', {
                                notify: false,
                                stepIndex: (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath.length - 1
                            });
                        }
                    }
                    // Award XP for the raid (already calculated above for contractor payments)
                    if (xpEarned > 0) {
                        (0, $8bda0cb20f0b197d$export$fd59807889add359)("\u2B50 Gained ".concat(xpEarned, " experience points"), 'success', {
                            stepIndex: (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath.length - 1,
                            notificationMessage: "\u2B50 Gained ".concat(xpEarned, " XP")
                        });
                        (0, $df8a44d92d572a5c$export$88ec20478ef6bd29)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character, xpEarned);
                        // Award XP to all contractors who participated in the raid
                        if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.hiredContractors && (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.hiredContractors.length > 0) {
                            (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.hiredContractors.forEach(function(contractor) {
                                if (contractor) (0, $df8a44d92d572a5c$export$31efd075830c7467)(contractor, contractorXP);
                            });
                            if (contractorXP > 0) (0, $8bda0cb20f0b197d$export$fd59807889add359)("\uD83D\uDC65 Contractors gained ".concat(contractorXP, " experience points"), 'info', {
                                stepIndex: (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath.length - 1,
                                notify: false
                            });
                        }
                    }
                    // Add loot to inventory and credits (per-item scarcity is applied at drop
                    // time via weighted selection, so logged loot matches inventory exactly)
                    if (raid.lootGained) {
                        (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.inventory = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.inventory || {};
                        Object.entries(raid.lootGained).forEach(function(param) {
                            var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), item = _param[0], amount = _param[1];
                            if (item === 'Credits' && amount) (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player.credits += amount;
                            else if (raid.raidSuccess && item != 'Fish') (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.inventory[item] = ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.inventory[item] || 0) + amount;
                        });
                    }
                    // Apply injuries to contractors (they heal over time)
                    $1249ab814b7054d4$export$c994d11f45f33eb9($1249ab814b7054d4$export$d17f5534c14b3dc5());
                    // Final status report
                    if (raid.raidSuccess) {
                        ;
                        (0, $8bda0cb20f0b197d$export$fd59807889add359)("\uD83C\uDF89 Raid completed successfully!", 'success', {
                            stepIndex: (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath.length - 1
                        });
                        // Lifetime counter for the Command Marks formula
                        if (((_gameState_currentRaid_currentRaidGrid = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid) === null || _gameState_currentRaid_currentRaidGrid === void 0 ? void 0 : _gameState_currentRaid_currentRaidGrid.tier) === 3 && (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character) {
                            (0, $fe47a452a83d9e00$export$6b22d50e3ddf4789)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character);
                            (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.lifetime.t3Wins += 1;
                        }
                        // Collapse Key recovery. The whole of the story track's award path is
                        // this call: keys are account-level records rather than loot, so nothing
                        // here touches lootGained, the inventory, or any drop table.
                        if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character) {
                            ;
                            key = (0, $756a1bfec6d494f3$export$9d589cbf453e87ad)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.faction, ((_gameState_currentRaid_currentRaidGrid1 = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid) === null || _gameState_currentRaid_currentRaidGrid1 === void 0 ? void 0 : _gameState_currentRaid_currentRaidGrid1.tier) || 1);
                            if (key) (0, $8bda0cb20f0b197d$export$fd59807889add359)("\uD83D\uDDDD\uFE0F Collapse Key ".concat(key.code, " recovered \u2014 \u201C").concat(key.name, "\u201D. Filed to the Archive."), 'bonus', {
                                stepIndex: (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath.length - 1,
                                notificationMessage: "\uD83D\uDDDD\uFE0F Collapse Key ".concat(key.code, " \u2014 \u201C").concat(key.name, "\u201D")
                            });
                        }
                    } else {
                        (0, $8bda0cb20f0b197d$export$fd59807889add359)("\uD83D\uDC80 Raid failed - retreat initiated!", 'failure', {
                            stepIndex: (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath.length - 1
                        });
                        (0, $8bda0cb20f0b197d$export$fd59807889add359)("\uD83D\uDC80 Raid failed - items dropped!", 'failure', {
                            stepIndex: (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath.length - 1
                        });
                    }
                    (0, $8bda0cb20f0b197d$export$fd59807889add359)("\uD83D\uDCCA Final Report: ".concat(raid.roomsCompleted, "/").concat($1249ab814b7054d4$export$aedd9bb9e278a90a((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath), " rooms cleared without incident"), 'info', {
                        notify: false,
                        stepIndex: (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath.length - 1
                    });
                    // Save completed raid info for restoration after page reload
                    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.completedRaidInfo = {
                        region: region,
                        selectedPath: (0, $4c858c0d999a5b9b$export$71511d61b312f219)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath),
                        roomsCompleted: raid.roomsCompleted,
                        raidSuccess: raid.raidSuccess,
                        logEntries: raid.logEntries ? (0, $4c858c0d999a5b9b$export$71511d61b312f219)(raid.logEntries) : [],
                        stepLogs: raid.stepLogs ? JSON.parse(JSON.stringify(raid.stepLogs)) : {},
                        currentRaidGrid: (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid,
                        eventStats: raid.eventStats,
                        // Snapshot for the raid-panel Loot tab (raidInProgress is torn down
                        // after this; on failure the items were discarded — the tab shows them
                        // as lost)
                        lootGained: raid.lootGained ? (0, $fa9769297b8a68c8$export$71511d61b312f219)({}, raid.lootGained) : {}
                    };
                    // Settle the Blackout contract. Only a SUCCESSFUL run pays — the modifiers
                    // are the price of the perk, and clearing on any completion would let a
                    // player arm the hardest contract and walk into the first hazard.
                    blackoutEarned = (0, $686e361e5cd4549d$export$f0d942e2e6132b96)({
                        success: !!raid.raidSuccess
                    });
                    if (blackoutEarned) {
                        ;
                        (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.completedRaidInfo.blackoutEarned = blackoutEarned;
                        (0, $b5bda7fdec806d8b$export$c7def531c087da85)("\uD83C\uDF11 ".concat((_getBlackoutContract = (0, $686e361e5cd4549d$export$913dd38406a903a1)(blackoutEarned.contractId)) === null || _getBlackoutContract === void 0 ? void 0 : _getBlackoutContract.name, " cleared \u2014 ").concat(blackoutEarned.perk.label, ", permanently."), 'success', {
                            sticky: true
                        } // one-time, irreversible, and easy to miss in the results wall
                        );
                    }
                    // Release hired contractors in database
                    currentCharacter = (_gameState_characters = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).characters) === null || _gameState_characters === void 0 ? void 0 : _gameState_characters.find(function(c) {
                        return c.id === (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).activeCharacterId;
                    });
                    if (!currentCharacter) return [
                        3,
                        10
                    ];
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        8,
                        9,
                        10
                    ]);
                    _iterator = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.hiredContractors[Symbol.iterator]();
                    _state.label = 4;
                case 4:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        7
                    ];
                    contractor = _step.value;
                    if (!contractor.multiplayerId) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        (0, $fde0976ce5d1665d$export$e4477200b6413a70).releaseHiredContractor(contractor.multiplayerId, currentCharacter.multiplayerId)
                    ];
                case 5:
                    _state.sent();
                    _state.label = 6;
                case 6:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        4
                    ];
                case 7:
                    return [
                        3,
                        10
                    ];
                case 8:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        10
                    ];
                case 9:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 10:
                    // Clean up raid state
                    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress = null;
                    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidCompleted = true;
                    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidOwnerId = null;
                    // Succession Doctrine: a raid ending is when the marks rate actually moves,
                    // so it is where the promotion peak is re-evaluated. Tracked unconditionally,
                    // not only when the charter is owned — the Command panel shows the same rate
                    // line, and the spec requires panel and automation to share ONE computation.
                    (0, $e39e78d7c65dc336$export$12d96118114aebf3)();
                    (0, $8bda0cb20f0b197d$export$fd59807889add359)("\uD83C\uDFEA New contractors have arrived at the outpost!", 'info', {
                        notify: false,
                        stepIndex: (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath.length - 1
                    });
                    return [
                        2
                    ];
            }
        });
    })();
}
function $1249ab814b7054d4$export$fae9674fe5380657() {
    var _gameState_characters;
    // Clean up any active special events
    //if (gameState.currentRaid.raidInProgress && gameState.currentRaid.raidInProgress.specialEvent && gameState.currentRaid.raidInProgress.specialEvent.active) {
    //cleanupBonusEvent();
    //}
    // Clear raid state. selectedRegion/selectedTier deliberately survive the
    // reset so the next New Raid screen starts from the previous choices
    // (players mostly re-run the same setup); generateRegionTiles() still
    // clears a selection that a region lock has made unavailable.
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid = null;
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath = [];
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidCompleted = false;
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.completedRaidInfo = null;
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidOwnerId = null;
    // Release marketplace contractors on server before clearing
    var currentCharacter = (_gameState_characters = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).characters) === null || _gameState_characters === void 0 ? void 0 : _gameState_characters.find(function(c) {
        return c.id === (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).activeCharacterId;
    });
    if (currentCharacter) // Release all reserved marketplace contractors
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.reservedContractors.forEach(function(contractor) {
        if (contractor.id > 0) (0, $fde0976ce5d1665d$export$e4477200b6413a70).releaseContractor(contractor.id, currentCharacter.multiplayerId).catch(function(err) {
            return console.error('Error releasing reserved contractor:', err);
        });
    });
    // Clear local contractor arrays
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.reservedContractors = [];
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.hiredContractors = [];
}










//@ts-check
/**
 * Team Carousel Component
 * Displays 3 team member cards in a centered stack layout
 * Active card in the middle, previous and next cards peeking from above/below
 */ /** @type {{activeIndex: number, members: Array<any>, container: HTMLElement | null, scrollTimeout: ReturnType<typeof setTimeout> | null}} */ var $8b8b7141704a735c$var$teamCarouselState = {
    activeIndex: 0,
    members: [],
    container: null,
    scrollTimeout: null
};
function $8b8b7141704a735c$export$f1143e4c4cd76114(container, members) {
    $8b8b7141704a735c$var$teamCarouselState.container = container;
    $8b8b7141704a735c$var$teamCarouselState.members = members;
    // Preserve active index if it's still valid, otherwise reset to 0
    if ($8b8b7141704a735c$var$teamCarouselState.activeIndex >= members.length) $8b8b7141704a735c$var$teamCarouselState.activeIndex = 0;
    $8b8b7141704a735c$export$2602fbc45dfcf30d();
    $8b8b7141704a735c$var$attachCarouselEventHandlers();
}
function $8b8b7141704a735c$export$32c8855874220763() {
    return $8b8b7141704a735c$var$teamCarouselState.activeIndex;
}
function $8b8b7141704a735c$export$b9bd062e5e9731c7(index) {
    if (index >= 0 && index < $8b8b7141704a735c$var$teamCarouselState.members.length) {
        $8b8b7141704a735c$var$teamCarouselState.activeIndex = index;
        $8b8b7141704a735c$export$2602fbc45dfcf30d();
        $8b8b7141704a735c$var$attachCarouselEventHandlers();
    }
}
function $8b8b7141704a735c$export$f537ff3e97ce27ef(direction) {
    var members = $8b8b7141704a735c$var$teamCarouselState.members, activeIndex = $8b8b7141704a735c$var$teamCarouselState.activeIndex;
    var newIndex = activeIndex;
    if (direction === 'next') newIndex = (activeIndex + 1) % members.length;
    else if (direction === 'prev') newIndex = (activeIndex - 1 + members.length) % members.length;
    $8b8b7141704a735c$export$b9bd062e5e9731c7(newIndex);
}
/**
 * Calculate which member should be in which position (previous, active, next)
 * @returns {{previous: number, active: number, next: number}} Object with indices for previous, active, and next positions
 */ function $8b8b7141704a735c$var$calculatePositions() {
    var activeIndex = $8b8b7141704a735c$var$teamCarouselState.activeIndex, members = $8b8b7141704a735c$var$teamCarouselState.members;
    var length = members.length;
    return {
        previous: (activeIndex - 1 + length) % length,
        active: activeIndex,
        next: (activeIndex + 1) % length
    };
}
/**
 * Get Tailwind classes for a card based on its position
 * @param {string} position - 'previous', 'active', or 'next'
 * @returns {string} Tailwind classes for positioning and styling
 *
 * Horizontal spread: Cards offset by ~40px (1/6 of 256px card width for 2/3 overlap)
 * - active: top right
 * - next: middle
 * - previous: bottom left
*/ function $8b8b7141704a735c$var$getCardPositionClass(position) {
    var baseTransition = 'transition-all duration-300';
    switch(position){
        case 'previous':
            // Bottom and left edges aligned with container, semi-transparent
            return "absolute scale-[0.90] bottom-0 left-0 saturate-[0.5] z-10 ".concat(baseTransition);
        case 'next':
            // Center, fully visible
            return "absolute scale-[0.95] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 saturate-[0.75] z-20 ".concat(baseTransition);
        case 'active':
            // Top and right edges aligned with container, semi-transparent
            return "absolute top-0 right-0 z-30 ".concat(baseTransition);
        default:
            return baseTransition;
    }
}
/**
 * Render the team carousel HTML
 * Uses Tailwind classes for styling (no external CSS needed)
 */ /**
 * Update button interaction states based on card positions
 * Only allows buttons on the active (centered) card to be clickable
 */ function $8b8b7141704a735c$var$updateCardButtonStates() {
    var container = $8b8b7141704a735c$var$teamCarouselState.container;
    if (!container) return;
    setTimeout(function() {
        var cardDivs = container.querySelectorAll('[data-carousel-position]');
        cardDivs.forEach(function(/** @type {any} */ card) {
            var position = card.getAttribute('data-carousel-position');
            var buttons = card.querySelectorAll('button');
            buttons.forEach(function(/** @type {any} */ button) {
                if (position === 'active') // Active card: enable buttons
                button.classList.remove('pointer-events-none');
                else // Background cards: disable buttons
                button.classList.add('pointer-events-none');
            });
        });
    }, 0);
}
function $8b8b7141704a735c$export$2602fbc45dfcf30d() {
    var _members_prevIndex, _members_actIndex, _members_nextIndex;
    var container = $8b8b7141704a735c$var$teamCarouselState.container, members = $8b8b7141704a735c$var$teamCarouselState.members, activeIndex = $8b8b7141704a735c$var$teamCarouselState.activeIndex;
    if (!container || members.length === 0) return;
    var positions = $8b8b7141704a735c$var$calculatePositions();
    var prevIndex = positions.previous;
    var actIndex = positions.active;
    var nextIndex = positions.next;
    // Build the carousel HTML using Tailwind classes
    var carouselHTML = '\n        <div class="flex flex-col items-center gap-4">\n            <!-- Cards Stack Container -->\n            <!-- Width allows for card overlap with minimal extra space -->\n            <!-- Supports click and scroll wheel controls -->\n            <div id="carousel-cards-container" class="relative h-[32rem] w-[21rem] xl:w-[26rem] 2xl:w-[28rem] cursor-pointer">\n                <!-- Previous Card -->\n                <div class="'.concat($8b8b7141704a735c$var$getCardPositionClass('previous'), '" data-carousel-position="previous">\n                    ').concat(((_members_prevIndex = members[prevIndex]) === null || _members_prevIndex === void 0 ? void 0 : _members_prevIndex.html) || '', '\n                </div>\n\n                <!-- Active Card -->\n                <div class="').concat($8b8b7141704a735c$var$getCardPositionClass('active'), '" data-carousel-position="active">\n                    ').concat(((_members_actIndex = members[actIndex]) === null || _members_actIndex === void 0 ? void 0 : _members_actIndex.html) || '', '\n                </div>\n\n                <!-- Next Card -->\n                <div class="').concat($8b8b7141704a735c$var$getCardPositionClass('next'), '" data-carousel-position="next">\n                    ').concat(((_members_nextIndex = members[nextIndex]) === null || _members_nextIndex === void 0 ? void 0 : _members_nextIndex.html) || '', "\n                </div>\n            </div>\n        </div>\n    ");
    container.innerHTML = carouselHTML;
    $8b8b7141704a735c$var$updateCardButtonStates();
}
/**
 * Attach event listeners to the carousel for click and scroll controls
 * - Click on cards: moves clicked card to the front
 * - Scroll up over cards: advances to next member
 * - Scroll down over cards: advances to previous member
 */ function $8b8b7141704a735c$var$attachCarouselEventHandlers() {
    var container = $8b8b7141704a735c$var$teamCarouselState.container;
    if (!container) return;
    // Wait for DOM to be ready, then attach handlers
    setTimeout(function() {
        var cardsContainer = container.querySelector('#carousel-cards-container');
        if (!cardsContainer) return;
        // Click handler: move clicked card to front
        cardsContainer.addEventListener('click', function(/** @type {any} */ e) {
            e.stopPropagation();
            // Ignore clicks on buttons or other interactive elements
            if (e.target.closest('button') || e.target.closest('[onclick]')) return;
            // Find which card was clicked
            var clickedElement = e.target.closest('[data-carousel-position]');
            if (!clickedElement) return;
            var position = clickedElement.getAttribute('data-carousel-position');
            // Don't transition if clicking the active card
            if (position === 'active') return;
            // Move clicked card (previous or next) to the front
            var activeIndex = $8b8b7141704a735c$var$teamCarouselState.activeIndex, members = $8b8b7141704a735c$var$teamCarouselState.members;
            var length = members.length;
            var newIndex = activeIndex;
            if (position === 'previous') newIndex = (activeIndex - 1 + length) % length;
            else if (position === 'next') newIndex = (activeIndex + 1) % length;
            $8b8b7141704a735c$export$b9bd062e5e9731c7(newIndex);
        });
        // Scroll wheel handler: up = next, down = prev
        cardsContainer.addEventListener('wheel', function(/** @type {any} */ e) {
            e.preventDefault();
            e.stopPropagation();
            // Debounce scroll events to prevent rapid consecutive rotations
            if ($8b8b7141704a735c$var$teamCarouselState.scrollTimeout) clearTimeout($8b8b7141704a735c$var$teamCarouselState.scrollTimeout);
            $8b8b7141704a735c$var$teamCarouselState.scrollTimeout = setTimeout(function() {
                var direction = e.deltaY < 0 ? 'next' : 'prev';
                $8b8b7141704a735c$export$f537ff3e97ce27ef(direction);
                $8b8b7141704a735c$var$teamCarouselState.scrollTimeout = null;
            }, 100);
        }, {
            passive: false
        });
    }, 0);
}
/**
 * Export functions for global window access (needed for inline onclick handlers)
 */ window.teamCarouselNext = function() {
    $8b8b7141704a735c$export$f537ff3e97ce27ef('next');
};
window.teamCarouselPrev = function() {
    $8b8b7141704a735c$export$f537ff3e97ce27ef('prev');
};



/**
 * The Archive — where recovered Collapse Keys are read, and re-read.
 *
 * One instance of the shared collection archetype (collectionView.js), not a
 * bespoke screen. A key arrives as a raid message that scrolls away; this is
 * the surface that makes it permanent, which is the requirement
 * `docs/archive/BreachLayer.md` recorded as "neither a toast nor a modal".
 *
 * Grouped by faction rather than by tier, because the three sets are three
 * arguments and reading one straight through is the point. Every faction's set
 * is shown, including factions the account has never played — the shape of what
 * is missing is what makes the collection legible, and it is also what tells a
 * player that the other two theories exist at all.
 *
 * The header states the seven-key ceiling plainly. Keys 8-10 are authored and
 * land at Tier 4 with L4; saying so is better than a set that silently stops at
 * seven and reads as unfinished content.
 */ 
/**
 * Collection view — the shared archetype for "a set of things you gather".
 *
 * `docs/systemsRework/LayerNavigation.md` flags this as a pattern that recurs
 * across the ladder (artifacts, Legends, Blackout perks, Collapse Keys, L4's
 * traced hubs) and asks for it to be extracted on the SECOND instance rather
 * than the fifth. This is that extraction, built for the Archive first.
 *
 * It is a PURE STRING BUILDER — no DOM, no state, no event wiring — so it can
 * be asserted headlessly and reused by any screen that owns its own container.
 *
 * Two rules the archetype encodes, because both are easy to get wrong once per
 * screen otherwise:
 *
 *   1. LOCKED SLOTS ARE SHOWN. A collection that hides what you have not found
 *      cannot tell you that anything is missing, and the shape of the set is
 *      most of what makes collecting one interesting.
 *   2. FOUND ENTRIES STAY READABLE. Everything is a <details>, so an entry can
 *      be re-opened forever with no JS state to lose. That is the whole reason
 *      the Archive exists rather than a toast: `docs/archive/BreachLayer.md`
 *      records that story previously had nowhere to live.
 *
 * @typedef {Object} CollectionEntry
 * @property {string}  id        - stable id, used for the DOM id
 * @property {boolean} owned     - found, or a locked slot
 * @property {string}  title     - shown on the card face when owned
 * @property {string} [subtitle] - small line under the title
 * @property {string} [icon]     - leading glyph
 * @property {string} [marker]   - short designation shown on locked slots too
 * @property {Array<{label?: string, text: string, quote?: boolean}>} [sections]
 *                               - the body, revealed on open
 *
 * @typedef {Object} CollectionGroup
 * @property {string}  id
 * @property {string}  label
 * @property {string} [icon]
 * @property {string} [accent]   - CSS colour for this group's rules and counts
 * @property {string} [blurb]    - one line under the group heading
 * @property {Array<CollectionEntry>} entries
 */ var $e01b67002cd01745$var$escapeHtml = function(s) {
    return String(s !== null && s !== void 0 ? s : '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
};
var $e01b67002cd01745$var$DEFAULT_ACCENT = '#9ca3af';
function $e01b67002cd01745$var$entryHtml(entry, accent) {
    var marker = entry.marker ? $e01b67002cd01745$var$escapeHtml(entry.marker) : '';
    if (!entry.owned) // A locked slot still carries its designation. Knowing that D3 exists and
    // is missing is the information a collection is FOR.
    return '\n      <div class="collection-slot locked rounded-lg border border-dashed border-gray-700 bg-white/[0.02] p-3 text-center">\n        <div class="text-xl leading-none opacity-40">\uD83D\uDD12</div>\n        '.concat(marker ? '<div class="text-[11px] font-bold tracking-widest mt-1 text-gray-500">'.concat(marker, "</div>") : '', '\n        <div class="text-[11px] text-gray-600 mt-1">Not recovered</div>\n      </div>');
    var body = (entry.sections || []).map(function(section) {
        var label = section.label ? '<div class="uppercase tracking-widest text-[10px] font-bold mb-1" style="color:'.concat(accent, '">').concat($e01b67002cd01745$var$escapeHtml(section.label), "</div>") : '';
        var text = section.quote ? '<div class="text-sm italic leading-relaxed border-l-2 pl-3 py-1" style="border-color:'.concat(accent, '; color:#d6cdf0;">').concat($e01b67002cd01745$var$escapeHtml(section.text), "</div>") : '<div class="text-sm leading-relaxed text-gray-300">'.concat($e01b67002cd01745$var$escapeHtml(section.text), "</div>");
        return '<div class="mb-3">'.concat(label).concat(text, "</div>");
    }).join('');
    return '\n    <details id="collection-'.concat($e01b67002cd01745$var$escapeHtml(entry.id), '" class="collection-slot rounded-lg border bg-white/5 p-3 h-full" style="border-color:').concat(accent, '66;">\n      <summary class="cursor-pointer list-none">\n        <div class="flex items-baseline gap-2">\n          ').concat(entry.icon ? '<span class="text-lg leading-none">'.concat(entry.icon, "</span>") : '', '\n          <span class="font-bold text-white text-sm">').concat($e01b67002cd01745$var$escapeHtml(entry.title), "</span>\n          ").concat(marker ? '<span class="text-[10px] font-bold tracking-widest ml-auto" style="color:'.concat(accent, '">').concat(marker, "</span>") : '', "\n        </div>\n        ").concat(entry.subtitle ? '<div class="text-[11px] text-gray-400 mt-1">'.concat($e01b67002cd01745$var$escapeHtml(entry.subtitle), "</div>") : '', '\n      </summary>\n      <div class="mt-3 pt-3 border-t border-gray-700">').concat(body, "</div>\n    </details>");
}
function $e01b67002cd01745$var$groupHtml(group) {
    var accent = group.accent || $e01b67002cd01745$var$DEFAULT_ACCENT;
    var found = group.entries.filter(function(e) {
        return e.owned;
    }).length;
    var total = group.entries.length;
    return '\n    <section class="mb-6">\n      <div class="flex items-baseline gap-2 border-b pb-1 mb-2" style="border-color:'.concat(accent, '55;">\n        <h3 class="font-bold" style="color:').concat(accent, '">').concat(group.icon || '', " ").concat($e01b67002cd01745$var$escapeHtml(group.label), '</h3>\n        <span class="text-xs ml-auto" style="color:').concat(accent, '">').concat(found, "/").concat(total, "</span>\n      </div>\n      ").concat(group.blurb ? '<p class="text-xs text-gray-400 mb-3">'.concat($e01b67002cd01745$var$escapeHtml(group.blurb), "</p>") : '', '\n      <div class="grid gap-2 collection-grid">\n        ').concat(group.entries.map(function(e) {
        return $e01b67002cd01745$var$entryHtml(e, accent);
    }).join(''), "\n      </div>\n    </section>");
}
function $e01b67002cd01745$export$e6fe4dbcc57eb54(spec) {
    var groups = (spec === null || spec === void 0 ? void 0 : spec.groups) || [];
    var populated = groups.filter(function(g) {
        return (g.entries || []).length > 0;
    });
    if (!populated.length) return '<div class="text-center text-gray-400 py-8 border border-dashed border-gray-600 rounded-lg">\n      '.concat($e01b67002cd01745$var$escapeHtml((spec === null || spec === void 0 ? void 0 : spec.empty) || 'Nothing collected yet.'), "\n    </div>");
    return populated.map($e01b67002cd01745$var$groupHtml).join('');
}



var $11d54c59f84070a9$var$FACTION_ACCENTS = {
    dominion: '#7cc4ff',
    wilders: '#7bd88f',
    veil: '#b18cff'
};
function $11d54c59f84070a9$var$keyEntry(key, owned) {
    return {
        id: key.id,
        owned: owned,
        marker: key.code,
        icon: "\uD83D\uDDDD\uFE0F",
        title: key.name,
        subtitle: "Tier ".concat(key.tier, " \xb7 ").concat(key.recoveredFrom),
        sections: [
            {
                label: "Fragment \u2014 ".concat(key.source),
                text: key.fragment,
                quote: true
            },
            {
                label: 'Interpretation',
                text: key.interpretation
            }
        ]
    };
}
function $11d54c59f84070a9$export$5dc9bc24597948d9() {
    var container = document.getElementById('archive-body');
    if (!container) return;
    var owned = (0, $756a1bfec6d494f3$export$933049ca86d1db4)();
    var progress = (0, $756a1bfec6d494f3$export$1bf1759a5184ddbd)();
    var totalOwned = Object.values(progress).reduce(function(n, p) {
        return n + p.owned;
    }, 0);
    var totalKeys = Object.values(progress).reduce(function(n, p) {
        return n + p.total;
    }, 0);
    var groups = Object.keys($979b99378be707cd$export$aeeef991191508e2 || {}).map(function(factionKey) {
        var faction = $979b99378be707cd$export$aeeef991191508e2[factionKey];
        return {
            id: factionKey,
            label: "".concat(faction.name, " \u2014 Collapse Keys"),
            icon: faction.icon,
            accent: $11d54c59f84070a9$var$FACTION_ACCENTS[factionKey] || '#9ca3af',
            blurb: faction.doctrine,
            entries: (0, $756a1bfec6d494f3$export$c9e2c9e9eddcd297)(factionKey).map(function(k) {
                return $11d54c59f84070a9$var$keyEntry(k, owned.includes(k.id));
            })
        };
    });
    var summary = document.getElementById('archive-summary');
    if (summary) summary.textContent = totalOwned === 0 ? "Nothing recovered yet. Keys surface in the field \u2014 raid, and your faction will start filing them here." : "".concat(totalOwned, " of ").concat(totalKeys, " recovered. A key is filed to the account, not to a character: promotion and founding never take one back.");
    container.innerHTML = (0, $e01b67002cd01745$export$e6fe4dbcc57eb54)({
        groups: groups,
        empty: 'No Collapse Keys have been authored yet.'
    });
}


/**
 * Layer navigation toolbar - renders the header from the layer registry.
 *
 * The registry (layers-core.js) says WHAT each layer has; this module is the
 * only place that turns that into DOM. Adding a layer is an entry there, not
 * markup here. See docs/systemsRework/LayerNavigation.md.
 *
 * Two render paths on purpose:
 *
 *   renderLayerToolbar()   full structural rebuild - on boot, layer switch, and
 *                          unlock changes. Replaces DOM.
 *   refreshToolbarValues() patches text only - safe to call every second.
 *
 * The split matters: the energy popup is anchored to the ⚡ chip and closes on
 * an outside click, so rebuilding chips underneath it once a second would tear
 * it out from under the player mid-purchase. Values change constantly;
 * structure changes rarely.
 */ /**
 * Layer Registry - the data behind layer navigation.
 *
 * The unification this rests on: the base game is itself a layer. Characters
 * and Contractors are not tabs competing with Command; they are Field's
 * screens. That gives one rule the toolbar follows everywhere:
 *
 *   The toolbar shows exactly one layer's context at a time - never the union.
 *
 * Both the switcher and the toolbar render from this registry, so adding a
 * layer is an entry here rather than UI surgery. See
 * docs/systemsRework/LayerNavigation.md.
 *
 * WHY THIS IS A MODULE, NOT js/data/: files in js/data/ are concatenated
 * verbatim into the generated js/constants.js and therefore cannot import
 * anything. This registry has to read live state (unlock latches, currency
 * values, task status), so it needs imports. It stays free of DOM so the
 * simulator and tests can load it - see tests/game/coreModulesHeadless.test.js.
 *
 * NO DOM HERE. `activeTask()` reports WHAT the task is and which screen it
 * belongs to; the header binds HOW activating it switches screens. Keeping the
 * "how" out is what lets this be tested headlessly.
 */ 


/**
 * Operations Core — the L3 active layer (M3 S4).
 *
 * Where L1 plans a path through a room grid, L3 plans a ROUTE across the world
 * map: same mental model, planetary scale. Transit is real-time in hours, the
 * cargo is the designed material sink, and the destination matters because of
 * faction demand (S5).
 *
 * No browser dependencies — the simulator runs this too.
 *
 * Three invariants worth stating up front, because each is easy to break later:
 *
 *  1. OPERATIONS DRAW ENERGY. Decided 2026-07-27 and required to land in this
 *     slice, not after: energy is the single input to L4's signature system,
 *     and planet-scale convoys under live telemetry cannot emit nothing.
 *     Building it in now is a line of code; retrofitting after L3 calibrates is
 *     a re-calibration of the whole milestone.
 *
 *  2. AT MOST ONE ROUND PER SLOT SETTLES OFFLINE, AND NEVER CHAINS. An op
 *     completing while away is intended; automation starting the NEXT one is
 *     not. Enforced in the settlement path rather than trusted to the launcher,
 *     so the invariant holds however L4's auto-launcher is later written — a
 *     player away for a week returns to the same completed ops as one away
 *     overnight.
 *
 *  3. CHARTER LOCKS DO NOT GATE ROUTES. Region locks are gate allocation and
 *     licensing, not physical reachability. A region whose RAIDS are locked is
 *     still traversable and still a valid destination.
 *
 * See docs/layers/3-syndicate/design.md §5.
 */ 






/**
 * Faction Demand Economy — L3 Operations pricing (M3 S5).
 *
 * This is what makes the DESTINATION matter. Without it every region pays the
 * same and the map is scenery: a convoy's route was already priced by terrain,
 * but where it ended up was a free variable.
 *
 * The one idea: a region pays a premium for the material signatures its own
 * faction mix does not produce. Verdant Reclamation is 92% wilders, so wilders
 * goods are the thing it already has — dominion and veil cargo is what it wants.
 *
 * AND A MARKET THAT IS FED STOPS BEING HUNGRY. The mix above is static, so on
 * its own it is a table the player solves once: pick the signature, read off the
 * region that pays ×2.00, and run that pairing forever. Every route costs the
 * same time, cargo and energy, so a fixed premium made destination a lookup
 * rather than a decision. Saturation is what turns it back into one — delivering
 * into a region consumes its appetite for that faction's goods, and the appetite
 * refills on a clock. The best destination is still the best destination; it
 * just stops being the best destination once you have used it.
 *
 * DERIVED, NOT AUTHORED. There is no hand-written economy table here, because a
 * hand-written one drifts: add a room to a region, and an authored demand table
 * silently keeps pricing the old geography. The mix is computed from the same
 * thing that decides what actually DROPS in a region — the faction of each
 * gate/hazard room's primary skill — so demand and supply cannot disagree.
 * This reproduces §1 of tools/loot-equilibrium.mjs exactly; that tool is the
 * offline analysis of the same numbers.
 *
 * No browser dependencies — the simulator runs this too.
 *
 * See docs/layers/3-syndicate/design.md §6.
 */ 





/**
 * Room draw rates per raid, mirroring the income model in loot-equilibrium.mjs.
 *
 * Hazards outnumber gates 2:1 in a typical path, so a region's character is set
 * more by its hazards than its gates. Weighting them equally would misread every
 * region whose gates and hazards pull toward different factions.
 */ var $35d30e7dcff465af$var$GATES_PER_RAID = 2;
var $35d30e7dcff465af$var$HAZARDS_PER_RAID = 4;
var $35d30e7dcff465af$export$2119d59df637b878 = 1.0;
var $35d30e7dcff465af$export$3dbc410517215979 = 2.0;
var $35d30e7dcff465af$export$dd23e574c7d7ff20 = 1.5;
// Region mixes are a pure function of static config; compute once.
var $35d30e7dcff465af$var$mixCache = null;
/**
 * What share of a region's loot-bearing rooms belongs to each faction.
 *
 * @returns {Object<string, Object<string, number>>} regionId -> faction -> share
 */ function $35d30e7dcff465af$var$allRegionMixes() {
    if ($35d30e7dcff465af$var$mixCache) return $35d30e7dcff465af$var$mixCache;
    $35d30e7dcff465af$var$mixCache = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries($979b99378be707cd$export$4fbdcec70fce9d73 || {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step.value, 2), regionId = _step_value[0], region = _step_value[1];
            var share = {};
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = Object.keys($979b99378be707cd$export$aeeef991191508e2 || {})[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var faction = _step1.value;
                    share[faction] = 0;
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            var total = 0;
            for(var _i = 0, _iter = [
                [
                    region.gates || [],
                    $35d30e7dcff465af$var$GATES_PER_RAID
                ],
                [
                    region.hazards || [],
                    $35d30e7dcff465af$var$HAZARDS_PER_RAID
                ]
            ]; _i < _iter.length; _i++){
                var _iter__i = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_iter[_i], 2), rooms = _iter__i[0], perRaid = _iter__i[1];
                if (!rooms.length) continue;
                // Rooms are drawn uniformly from the region's pool, so a region with
                // few gates weights each of them more heavily.
                var weight = perRaid / rooms.length;
                var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                try {
                    for(var _iterator2 = rooms[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                        var room = _step2.value;
                        var faction1 = (0, $ca7af38ea7b7b4a8$export$a3603dda04ca8111)(room.primary);
                        if (faction1 && faction1 in share) share[faction1] += weight;
                        total += weight;
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                            _iterator2.return();
                        }
                    } finally{
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
            }
            var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
            if (total > 0) try {
                for(var _iterator3 = Object.keys(share)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                    var faction2 = _step3.value;
                    share[faction2] /= total;
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                        _iterator3.return();
                    }
                } finally{
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }
            $35d30e7dcff465af$var$mixCache[regionId] = share;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return $35d30e7dcff465af$var$mixCache;
}
function $35d30e7dcff465af$export$5d226cc5df4caa71(regionId) {
    var mix = $35d30e7dcff465af$var$allRegionMixes()[regionId];
    if (mix) return (0, $fa9769297b8a68c8$export$71511d61b312f219)({}, mix);
    return Object.fromEntries(Object.keys($979b99378be707cd$export$aeeef991191508e2 || {}).map(function(f) {
        return [
            f,
            0
        ];
    }));
}
function $35d30e7dcff465af$export$37444e2aca3975f8(regionId, faction) {
    var _Math;
    if (!faction) return $35d30e7dcff465af$export$2119d59df637b878;
    var mix = $35d30e7dcff465af$export$5d226cc5df4caa71(regionId);
    var peak = (_Math = Math).max.apply(_Math, [
        0
    ].concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)(Object.values(mix))));
    if (peak <= 0) return $35d30e7dcff465af$export$2119d59df637b878;
    var relative = Math.min(1, (mix[faction] || 0) / peak);
    return +($35d30e7dcff465af$export$3dbc410517215979 - relative * ($35d30e7dcff465af$export$3dbc410517215979 - $35d30e7dcff465af$export$2119d59df637b878)).toFixed(2);
}
var $35d30e7dcff465af$export$84b9749393a572a5 = 3200;
var $35d30e7dcff465af$export$11ee3e0b19f61859 = 72;
var $35d30e7dcff465af$var$RECOVERY_MS = $35d30e7dcff465af$export$11ee3e0b19f61859 * 3600000;
var $35d30e7dcff465af$var$clamp01 = function(n) {
    return Math.min(1, Math.max(0, n));
};
var $35d30e7dcff465af$var$satiationKey = function(regionId, faction) {
    return "".concat(regionId, ":").concat(faction);
};
/**
 * The saturation ledger, keyed by (region, faction).
 *
 * That granularity is the multiplier's own: the price is per-faction, so a
 * finer per-SIGNATURE ledger would be fake precision the player could game by
 * rotating the five signatures of one faction through the same fat region,
 * while a coarser per-REGION one would suppress a region's dominion price
 * because you sold it veil goods. Fifteen cells, one per price the game quotes.
 *
 * Lives on `syndicate` because it is world state that outlives an era — see the
 * founding note on `satiationLevel`. Returns null before the branch exists,
 * which is simply "nothing has ever been delivered".
 */ function $35d30e7dcff465af$var$satiationStore() {
    var syndicate = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).syndicate;
    if (!syndicate) return null;
    if (!syndicate.demand) syndicate.demand = {};
    return syndicate.demand;
}
function $35d30e7dcff465af$export$f9e4fa3cb5360b25(regionId, faction) {
    var now = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Date.now();
    var _satiationStore;
    var cell = (_satiationStore = $35d30e7dcff465af$var$satiationStore()) === null || _satiationStore === void 0 ? void 0 : _satiationStore[$35d30e7dcff465af$var$satiationKey(regionId, faction)];
    if (!cell) return 0;
    var elapsed = Math.max(0, now - (cell.at || 0));
    return $35d30e7dcff465af$var$clamp01((cell.level || 0) - elapsed / $35d30e7dcff465af$var$RECOVERY_MS);
}
function $35d30e7dcff465af$export$5839d85e36227b6a(regionId, faction) {
    var now = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Date.now();
    return Math.round($35d30e7dcff465af$export$f9e4fa3cb5360b25(regionId, faction, now) * $35d30e7dcff465af$var$RECOVERY_MS);
}
function $35d30e7dcff465af$export$bd4b24a19973285f(regionId, skillId, units) {
    var now = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Date.now();
    var faction = (0, $ca7af38ea7b7b4a8$export$a3603dda04ca8111)(skillId);
    var store = $35d30e7dcff465af$var$satiationStore();
    if (!faction || !store || !(units > 0)) return 0;
    var level = $35d30e7dcff465af$var$clamp01($35d30e7dcff465af$export$f9e4fa3cb5360b25(regionId, faction, now) + units / $35d30e7dcff465af$export$84b9749393a572a5);
    store[$35d30e7dcff465af$var$satiationKey(regionId, faction)] = {
        level: level,
        at: now
    };
    return level;
}
function $35d30e7dcff465af$export$b9d88bbf27398a14(regionId, faction) {
    var now = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Date.now();
    var base = $35d30e7dcff465af$export$37444e2aca3975f8(regionId, faction);
    var level = $35d30e7dcff465af$export$f9e4fa3cb5360b25(regionId, faction, now);
    if (level <= 0) return base;
    return +($35d30e7dcff465af$export$2119d59df637b878 + (base - $35d30e7dcff465af$export$2119d59df637b878) * (1 - level)).toFixed(2);
}
function $35d30e7dcff465af$export$6bba5a60cd02466f(regionId, skillId) {
    var now = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Date.now();
    return $35d30e7dcff465af$export$b9d88bbf27398a14(regionId, (0, $ca7af38ea7b7b4a8$export$a3603dda04ca8111)(skillId), now);
}
function $35d30e7dcff465af$export$345f4d5270758759(regionId) {
    var now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
    var mix = $35d30e7dcff465af$export$5d226cc5df4caa71(regionId);
    return Object.keys(mix).map(function(faction) {
        var _config_factionSkills_faction, _config_factionSkills;
        return {
            faction: faction,
            name: ((_config_factionSkills = $979b99378be707cd$export$aeeef991191508e2) === null || _config_factionSkills === void 0 ? void 0 : (_config_factionSkills_faction = _config_factionSkills[faction]) === null || _config_factionSkills_faction === void 0 ? void 0 : _config_factionSkills_faction.name) || faction,
            share: mix[faction],
            multiplier: $35d30e7dcff465af$export$b9d88bbf27398a14(regionId, faction, now),
            base: $35d30e7dcff465af$export$37444e2aca3975f8(regionId, faction),
            saturation: $35d30e7dcff465af$export$f9e4fa3cb5360b25(regionId, faction, now),
            recoveryMs: $35d30e7dcff465af$export$5839d85e36227b6a(regionId, faction, now)
        };
    }).sort(function(a, b) {
        return b.multiplier - a.multiplier;
    });
}
function $35d30e7dcff465af$export$d48946d0a3e2934b(multiplier) {
    return (multiplier || 0) >= $35d30e7dcff465af$export$dd23e574c7d7ff20;
}



/**
 * Material credit values — DERIVED FROM RECIPES, NOT AUTHORED (M3 S13).
 *
 * What a unit of material is worth, in credits, so that systems which need to
 * compare a common against a rare have one honest answer instead of each
 * inventing its own.
 *
 * THE WHOLE POINT IS THAT NOBODY WRITES THESE NUMBERS DOWN. A hand-authored
 * rarity price table drifts the moment a recipe changes: retune what an
 * uncommon costs to craft and the table keeps quoting the old economy, silently,
 * forever. The same argument demand-core makes for region mixes (§6, "DERIVED,
 * NOT AUTHORED") applies here with more force, because this one prices a sink.
 *
 * The derivation is the game's own crafting ladder:
 *
 *     value(rarity) = craftingCost(rarity) + Σ value(each input)
 *
 * with the base of the recursion being a rarity nothing crafts — commons drop,
 * they are not made, so a common is worth exactly what the ladder charges to
 * work with it. Everything above is that plus what it consumed.
 *
 * Against the shipped data that resolves to:
 *
 *     common    5      (craftingCost, the unit of account)
 *     uncommon  30     = 3 commons + 15
 *     rare      115    = 3 commons + 1 uncommon + 70
 *
 * — a 1 : 6 : 23 ladder. Worth knowing WHY that is exact rather than an average:
 * all 18 uncommon recipes take exactly 3 commons and all 12 rare recipes take
 * exactly 3 commons and 1 uncommon. Thirty recipes, two shapes. If that ever
 * stops being true this file keeps working — it walks the actual recipes — but
 * the per-rarity summary above stops being a fair description of it.
 *
 * No browser dependencies — the simulator runs this too.
 */ 



var $00cd2a5b8f760625$export$a00161bf038b88d1 = 8;
/** Every recipe in the game, whatever tier it crafts. */ function $00cd2a5b8f760625$var$allRecipes() {
    return (0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$exports.recipesUncommon || []).concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$exports.recipesRare || []), (0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$exports.recipesEpic || []), (0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$exports.recipesArtifact || []));
}
// Pure function of static config, and walked recursively — compute once.
var $00cd2a5b8f760625$var$valueCache = null;
/**
 * Credit value per unit, keyed by material id.
 *
 * Built by walking each recipe from its target back through its inputs.
 * Memoised per id with an in-progress guard, so a cyclic recipe graph (which
 * would otherwise recurse forever) resolves to the bare crafting cost rather
 * than hanging the game.
 */ function $00cd2a5b8f760625$var$allValues() {
    if ($00cd2a5b8f760625$var$valueCache) return $00cd2a5b8f760625$var$valueCache;
    var recipeFor = new Map();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $00cd2a5b8f760625$var$allRecipes()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var recipe = _step.value;
            if ((recipe === null || recipe === void 0 ? void 0 : recipe.target) && !recipeFor.has(recipe.target)) recipeFor.set(recipe.target, recipe);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var values = new Map();
    var resolving = new Set();
    var costOf = function(rarity) {
        var _config_itemRarities_rarity, _config_itemRarities;
        return ((_config_itemRarities = $979b99378be707cd$exports.itemRarities) === null || _config_itemRarities === void 0 ? void 0 : (_config_itemRarities_rarity = _config_itemRarities[rarity]) === null || _config_itemRarities_rarity === void 0 ? void 0 : _config_itemRarities_rarity.craftingCost) || 0;
    };
    var valueOf = function(itemId) {
        if (values.has(itemId)) return values.get(itemId);
        var item = (0, $ca7af38ea7b7b4a8$export$a2dea178c28a0308)('id', itemId);
        var base = costOf(item === null || item === void 0 ? void 0 : item.rarity);
        // Guard BEFORE recursing. A recipe graph is a tree today; a cycle
        // introduced later should degrade to "worth its crafting cost" rather than
        // blow the stack on load.
        if (resolving.has(itemId)) return base;
        var recipe = recipeFor.get(itemId);
        if (!recipe) {
            values.set(itemId, base); // a drop, not a craft — the base of the ladder
            return base;
        }
        resolving.add(itemId);
        var total = base;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = (recipe.inputs || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var input = _step.value;
                total += valueOf(input.id) * (input.qty || 0);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        resolving.delete(itemId);
        values.set(itemId, total);
        return total;
    };
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    for(var _i = 0, _iter = [
        'itemsCommon',
        'itemsUncommon',
        'itemsRare'
    ]; _i < _iter.length; _i++){
        var pool = _iter[_i];
        try {
            for(var _iterator1 = ($979b99378be707cd$exports[pool] || [])[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var item = _step1.value;
                valueOf(item.id);
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
    try {
        for(var _iterator2 = $00cd2a5b8f760625$var$allRecipes()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var recipe1 = _step2.value;
            if (recipe1 === null || recipe1 === void 0 ? void 0 : recipe1.target) valueOf(recipe1.target);
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
            }
        } finally{
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }
    $00cd2a5b8f760625$var$valueCache = values;
    return $00cd2a5b8f760625$var$valueCache;
}
function $00cd2a5b8f760625$export$fec63043638a29c9(itemId) {
    var _config_itemRarities_item_rarity, _config_itemRarities;
    if (!itemId) return 0;
    // Scaled at the PUBLIC boundary, not inside the recursion — `allValues()`
    // walks recipes and would compound the factor once per tier if it were
    // applied there, making a rare 8x too dear relative to a common and breaking
    // the very ratios the ladder exists to give.
    var cached = $00cd2a5b8f760625$var$allValues().get(itemId);
    if (cached != null) return cached * $00cd2a5b8f760625$export$a00161bf038b88d1;
    var item = (0, $ca7af38ea7b7b4a8$export$a2dea178c28a0308)('id', itemId);
    return (((_config_itemRarities = $979b99378be707cd$exports.itemRarities) === null || _config_itemRarities === void 0 ? void 0 : (_config_itemRarities_item_rarity = _config_itemRarities[item === null || item === void 0 ? void 0 : item.rarity]) === null || _config_itemRarities_item_rarity === void 0 ? void 0 : _config_itemRarities_item_rarity.craftingCost) || 0) * $00cd2a5b8f760625$export$a00161bf038b88d1;
}
function $00cd2a5b8f760625$export$f92dab4a7d67d380(manifest) {
    var total = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(manifest || {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step.value, 2), itemId = _step_value[0], qty = _step_value[1];
            total += $00cd2a5b8f760625$export$fec63043638a29c9(itemId) * (qty || 0);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return total;
}
function $00cd2a5b8f760625$export$24d7f05899f6f0f2() {
    var out = {};
    for(var _i = 0, _iter = [
        [
            'itemsCommon',
            'common'
        ],
        [
            'itemsUncommon',
            'uncommon'
        ],
        [
            'itemsRare',
            'rare'
        ]
    ]; _i < _iter.length; _i++){
        var _iter__i = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_iter[_i], 2), pool = _iter__i[0], rarity = _iter__i[1];
        var first = ($979b99378be707cd$exports[pool] || [])[0];
        if (first) out[rarity] = $00cd2a5b8f760625$export$fec63043638a29c9(first.id);
    }
    return out;
}
function $00cd2a5b8f760625$export$b6b29545c91ff407() {
    $00cd2a5b8f760625$var$valueCache = null;
}



var $aee9584c1e6e51e7$var$HOUR_MS = 3600000;
var $aee9584c1e6e51e7$export$36ac5ebae0245093 = {
    'short-haul': {
        name: 'Short Haul',
        icon: "\uD83D\uDEFB",
        legendsRequired: 0,
        cargoValue: 800,
        energy: 10,
        credits: 1800,
        creditsPerHour: 450,
        writEligible: false
    },
    'long-haul': {
        name: 'Long Haul',
        icon: "\uD83D\uDE9A",
        legendsRequired: 3,
        cargoValue: 2720,
        energy: 25,
        credits: 2800,
        creditsPerHour: 700,
        writEligible: false
    },
    'grand-circuit': {
        name: 'Grand Circuit',
        icon: "\uD83D\uDE9B",
        legendsRequired: 6,
        cargoValue: 5960,
        energy: 45,
        credits: 4000,
        creditsPerHour: 1000,
        writEligible: true
    }
};
var $aee9584c1e6e51e7$export$9c559bdbc416d871 = {
    common: 0.5,
    uncommon: 0.3,
    rare: 0.2
};
var $aee9584c1e6e51e7$export$27e3703df3a11e61 = 0.001;
var $aee9584c1e6e51e7$export$2a1adeeaefb6ac28 = 0.11;
function $aee9584c1e6e51e7$export$8fe62d261aacdb61() {
    var map = $979b99378be707cd$export$e3c642cf362e5b0d;
    return {
        width: map.width,
        height: map.height,
        tiles: map.terrainRows.map(function(row) {
            return row.split('');
        }),
        regions: map.regionRows.map(function(row) {
            return row.split('').map(function(d) {
                return map.regionOrder[d] || null;
            });
        })
    };
}
function $aee9584c1e6e51e7$export$a4fafcaec3d77925(char) {
    var cost = $979b99378be707cd$export$e3c642cf362e5b0d.terrainCost[char];
    return cost === undefined ? null : cost;
}
function $aee9584c1e6e51e7$export$8660d3afb66129a5(row, col) {
    var _config_worldMap_regionRows_row;
    var digit = (_config_worldMap_regionRows_row = $979b99378be707cd$export$e3c642cf362e5b0d.regionRows[row]) === null || _config_worldMap_regionRows_row === void 0 ? void 0 : _config_worldMap_regionRows_row[col];
    return $979b99378be707cd$export$e3c642cf362e5b0d.regionOrder[digit] || null;
}
function $aee9584c1e6e51e7$export$9caf4fdf37b2a28(regionId) {
    var capital = $979b99378be707cd$export$e3c642cf362e5b0d.capitals[regionId];
    return capital ? (0, $fa9769297b8a68c8$export$71511d61b312f219)({}, capital) : null;
}
function $aee9584c1e6e51e7$export$4a444fae199f4849() {
    return Object.values($979b99378be707cd$export$e3c642cf362e5b0d.regionOrder);
}
var $aee9584c1e6e51e7$export$dff7303faedba2f = 0.5;
/** A region id or a literal tile, normalised to a tile. */ function $aee9584c1e6e51e7$var$asTile(x) {
    if (!x) return null;
    return typeof x === 'string' ? $aee9584c1e6e51e7$export$9caf4fdf37b2a28(x) : {
        row: x.row,
        col: x.col
    };
}
function $aee9584c1e6e51e7$export$c8a5c29d2838f4de(waypoints) {
    if (!waypoints || waypoints.length < 2) return null;
    var tiles = [];
    var cost = 0;
    for(var i = 0; i < waypoints.length - 1; i++){
        var _tiles;
        var leg = $aee9584c1e6e51e7$export$4fa936acba669006(waypoints[i], waypoints[i + 1]);
        if (!leg) return null;
        cost += leg.cost;
        (_tiles = tiles).push.apply(_tiles, (0, $4c858c0d999a5b9b$export$71511d61b312f219)(i === 0 ? leg.tiles : leg.tiles.slice(1)));
    }
    return {
        tiles: tiles,
        cost: cost
    };
}
function $aee9584c1e6e51e7$export$f41c2be0717214ee(toRegionId) {
    var to = $aee9584c1e6e51e7$var$asTile(toRegionId);
    if (!to) return [];
    return $aee9584c1e6e51e7$export$4a444fae199f4849()// A convoy has to actually go somewhere. Staging in the destination itself
    // is a zero-hour route, which is not a cheap operation — it is not one.
    .filter(function(fromRegionId) {
        return fromRegionId !== toRegionId;
    }).map(function(fromRegionId) {
        var from = $aee9584c1e6e51e7$var$asTile(fromRegionId);
        var route = $aee9584c1e6e51e7$export$4fa936acba669006(from, to);
        if (!route) return null;
        return {
            fromRegionId: fromRegionId,
            from: from,
            toRegionId: toRegionId,
            to: to,
            // Two waypoints is the whole route now. Kept as a waypoint LIST rather
            // than a pair because that is the shape already persisted on every
            // in-flight operation, and `routeFromWaypoints` rebuilds either.
            waypoints: [
                from,
                to
            ],
            tiles: route.tiles,
            cost: route.cost,
            hours: $aee9584c1e6e51e7$export$56ee0a61fc2e748(from, to)
        };
    }).filter(Boolean);
}
function $aee9584c1e6e51e7$export$4fa936acba669006(from, to) {
    // Accepts a region id OR a literal tile at either end: destinations are
    // always region capitals, but origins are now arbitrary tiles chosen by
    // reach rather than a fixed set of five.
    var start = $aee9584c1e6e51e7$var$asTile(from);
    var end = $aee9584c1e6e51e7$var$asTile(to);
    if (!start || !end) return null;
    if (start.row === end.row && start.col === end.col) return {
        tiles: [
            start
        ],
        cost: 0
    };
    var _getWorldGrid = $aee9584c1e6e51e7$export$8fe62d261aacdb61(), width = _getWorldGrid.width, height = _getWorldGrid.height, tiles = _getWorldGrid.tiles;
    var key = function(r, c) {
        return "".concat(r, ",").concat(c);
    };
    var dist = new Map([
        [
            key(start.row, start.col),
            0
        ]
    ]);
    var prev = new Map();
    var queue = [
        [
            0,
            start
        ]
    ];
    while(queue.length){
        queue.sort(function(a, b) {
            return a[0] - b[0];
        });
        var _queue_shift = (0, $1788e2ed61915b1e$export$71511d61b312f219)(queue.shift(), 2), d = _queue_shift[0], cur = _queue_shift[1];
        if (cur.row === end.row && cur.col === end.col) break;
        var _dist_get;
        if (d > ((_dist_get = dist.get(key(cur.row, cur.col))) !== null && _dist_get !== void 0 ? _dist_get : Infinity)) continue;
        for(var _i = 0, _iter = [
            [
                0,
                1
            ],
            [
                1,
                0
            ],
            [
                0,
                -1
            ],
            [
                -1,
                0
            ]
        ]; _i < _iter.length; _i++){
            var _iter__i = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_iter[_i], 2), dr = _iter__i[0], dc = _iter__i[1];
            var nr = cur.row + dr, nc = cur.col + dc;
            if (nr < 0 || nc < 0 || nr >= height || nc >= width) continue;
            var cost = $aee9584c1e6e51e7$export$a4fafcaec3d77925(tiles[nr][nc]);
            if (cost == null) continue; // impassable
            var nd = d + cost;
            var _dist_get1;
            if (nd < ((_dist_get1 = dist.get(key(nr, nc))) !== null && _dist_get1 !== void 0 ? _dist_get1 : Infinity)) {
                dist.set(key(nr, nc), nd);
                prev.set(key(nr, nc), cur);
                queue.push([
                    nd,
                    {
                        row: nr,
                        col: nc
                    }
                ]);
            }
        }
    }
    var endKey = key(end.row, end.col);
    if (!dist.has(endKey)) return null;
    var route = [];
    var cur1 = end;
    while(cur1){
        route.unshift(cur1);
        cur1 = prev.get(key(cur1.row, cur1.col));
    }
    return {
        tiles: route,
        cost: dist.get(endKey)
    };
}
function $aee9584c1e6e51e7$export$f23f7f2631f7375a(route, pct) {
    var tiles = (route === null || route === void 0 ? void 0 : route.tiles) || [];
    if (!tiles.length) return {
        fills: [],
        index: 0
    };
    var _getWorldGrid = $aee9584c1e6e51e7$export$8fe62d261aacdb61(), terrain = _getWorldGrid.tiles;
    // Cost of ENTERING each tile — matches how findRoute accumulates, so the
    // shares add up to exactly the cost that priced the duration.
    var costs = tiles.map(function(t, i) {
        var _tileCost;
        return i === 0 ? 0 : (_tileCost = $aee9584c1e6e51e7$export$a4fafcaec3d77925(terrain[t.row][t.col])) !== null && _tileCost !== void 0 ? _tileCost : 1;
    });
    var total = costs.reduce(function(a, b) {
        return a + b;
    }, 0);
    if (total <= 0) return {
        fills: tiles.map(function() {
            return 1;
        }),
        index: tiles.length - 1
    };
    var clamped = Math.min(1, Math.max(0, pct));
    var spent = clamped * total;
    var running = 0;
    var index = 0;
    var fills = tiles.map(function(_, i) {
        var cost = costs[i];
        // Departure tile: crossed as soon as the convoy is moving at all.
        if (cost === 0) return clamped > 0 ? 1 : 0;
        var fill = Math.min(1, Math.max(0, (spent - running) / cost));
        running += cost;
        if (fill > 0) index = i;
        return fill;
    });
    return {
        fills: fills,
        index: index
    };
}
function $aee9584c1e6e51e7$export$56ee0a61fc2e748(from, to) {
    var route = $aee9584c1e6e51e7$export$4fa936acba669006(from, to);
    if (!route) return null;
    return Math.max($aee9584c1e6e51e7$export$dff7303faedba2f, route.cost * $aee9584c1e6e51e7$export$dff7303faedba2f);
}
function $aee9584c1e6e51e7$export$34097b07af09d661() {
    var _gameState_command;
    var syndicate = (0, $e39e78d7c65dc336$export$cdfa564b532bb699)();
    var busy = new Set((syndicate.operations || []).map(function(op) {
        return op.leadName;
    }));
    var leads = [];
    if (syndicate.leader) leads.push({
        name: syndicate.leader.name,
        marksEarned: syndicate.leader.marksEarned || 0,
        isLeader: true
    });
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = (((_gameState_command = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).command) === null || _gameState_command === void 0 ? void 0 : _gameState_command.legends) || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var legend = _step.value;
            leads.push({
                name: legend.name,
                marksEarned: legend.marksEarned || 0,
                isLeader: false
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return leads.filter(function(l) {
        return !busy.has(l.name);
    });
}
function $aee9584c1e6e51e7$export$c87f3aa20ea43c6e() {
    var _gameState_command_legends, _gameState_command;
    var licensed = (0, $e39e78d7c65dc336$export$d9ea4b2d96397ab9)('operations-charter', 0);
    if (!licensed) return 0;
    var syndicate = (0, $e39e78d7c65dc336$export$cdfa564b532bb699)();
    var bodies = (syndicate.leader ? 1 : 0) + (((_gameState_command = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).command) === null || _gameState_command === void 0 ? void 0 : (_gameState_command_legends = _gameState_command.legends) === null || _gameState_command_legends === void 0 ? void 0 : _gameState_command_legends.length) || 0);
    // Lights Out adds a licensed slot. Applied to the LICENCE, not the min: the
    // extra slot is paperwork, and it still needs a body to lead it — otherwise
    // clearing the contract would conjure a convoy with nobody in charge.
    var slots = licensed + (0, $686e361e5cd4549d$export$84f52d60145287)('operation-slots', 0);
    return Math.min(slots, bodies);
}
function $aee9584c1e6e51e7$export$71db14eff0d59723() {
    return ((0, $e39e78d7c65dc336$export$cdfa564b532bb699)().operations || []).length;
}
function $aee9584c1e6e51e7$export$21c1c9fc1bed7f77() {
    return (0, $e39e78d7c65dc336$export$cdfa564b532bb699)().stores || {};
}
function $aee9584c1e6e51e7$export$812feee522dc8b7() {
    return (0, $e39e78d7c65dc336$export$cdfa564b532bb699)().consignment || {};
}
function $aee9584c1e6e51e7$export$7284881aebf5498e(skillId) {
    var _config_materialOwnership_skills, _config_materialOwnership;
    var byRarity = {
        common: [],
        uncommon: [],
        rare: []
    };
    var owned = (_config_materialOwnership = $979b99378be707cd$export$2aa6464abbbb5bfc) === null || _config_materialOwnership === void 0 ? void 0 : (_config_materialOwnership_skills = _config_materialOwnership.skills) === null || _config_materialOwnership_skills === void 0 ? void 0 : _config_materialOwnership_skills[skillId];
    if (!owned) return byRarity;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator = Object.values(owned)[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
            var ids = _step.value;
            try {
                for(var _iterator1 = (ids || [])[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                    var id = _step1.value;
                    var _findItem;
                    var rarity = (_findItem = (0, $ca7af38ea7b7b4a8$export$a2dea178c28a0308)('id', id)) === null || _findItem === void 0 ? void 0 : _findItem.rarity;
                    var bucket = byRarity[rarity];
                    // `core` overlaps `commons` in the source matrix, so dedupe: a doubled id
                    // would be offered twice and drain the same pile twice as fast.
                    if (bucket && !bucket.includes(id)) bucket.push(id);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return byRarity;
}
function $aee9584c1e6e51e7$export$94a2b01ae45f0aa0(skillId) {
    var inventory = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $aee9584c1e6e51e7$export$21c1c9fc1bed7f77();
    var units = 0;
    var value = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator = Object.values($aee9584c1e6e51e7$export$7284881aebf5498e(skillId))[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
            var ids = _step.value;
            try {
                for(var _iterator1 = ids[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                    var id = _step1.value;
                    var qty = inventory[id] || 0;
                    units += qty;
                    value += (0, $00cd2a5b8f760625$export$fec63043638a29c9)(id) * qty;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return {
        units: units,
        value: value
    };
}
function $aee9584c1e6e51e7$export$804dfc1c9f8f293a(templateId) {
    var template = $aee9584c1e6e51e7$export$36ac5ebae0245093[templateId];
    if (!template) return 0;
    return Math.max(1, Math.ceil(template.energy));
}
function $aee9584c1e6e51e7$export$a666674acd11f81d(templateId, skillId) {
    var inventory = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $aee9584c1e6e51e7$export$21c1c9fc1bed7f77();
    var template = $aee9584c1e6e51e7$export$36ac5ebae0245093[templateId];
    if (!template) return {
        manifest: {},
        value: 0,
        budget: 0,
        short: {
            value: 0
        }
    };
    var discount = (0, $e39e78d7c65dc336$export$d9ea4b2d96397ab9)('provision-contracts', 0);
    var budget = Math.max(0, Math.round(template.cargoValue * (1 - discount)));
    var byRarity = $aee9584c1e6e51e7$export$7284881aebf5498e(skillId);
    var manifest = {};
    var loaded = 0;
    // Piles for a set of ids, biggest first, with whatever is already on the
    // manifest deducted so the two passes cannot spend the same unit twice.
    var pilesFor = function(ids) {
        return ids.map(function(id) {
            return {
                id: id,
                qty: (inventory[id] || 0) - (manifest[id] || 0),
                value: (0, $00cd2a5b8f760625$export$fec63043638a29c9)(id)
            };
        }).filter(function(p) {
            return p.qty > 0 && p.value > 0;
        }).sort(function(a, b) {
            return b.qty - a.qty;
        });
    };
    var everything = (0, $4c858c0d999a5b9b$export$71511d61b312f219)(byRarity.common).concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)(byRarity.uncommon), (0, $4c858c0d999a5b9b$export$71511d61b312f219)(byRarity.rare));
    var fill = function(ids, target) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = pilesFor(ids)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var pile = _step.value;
                while(pile.qty > 0 && loaded + pile.value <= target){
                    manifest[pile.id] = (manifest[pile.id] || 0) + 1;
                    pile.qty -= 1;
                    loaded += pile.value;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
    // Pass 1: the preferred mix. Targets are cumulative because `loaded` is a
    // running total — each rarity is asked to bring the manifest up to its share
    // of the budget, not to contribute a share in isolation.
    var cumulative = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries($aee9584c1e6e51e7$export$9c559bdbc416d871)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step.value, 2), rarity = _step_value[0], share = _step_value[1];
            cumulative += budget * share;
            fill(byRarity[rarity] || [], cumulative);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Pass 2: spill. Everything the signature owns, regardless of rarity.
    fill(everything, budget);
    var remaining = pilesFor(everything);
    // Nothing fitted at all — take the cheapest thing there is and eat the
    // overshoot, so a dock of nothing but rares still ships.
    if (!loaded && remaining.length) {
        var cheapest = remaining.reduce(function(a, b) {
            return b.value < a.value ? b : a;
        });
        manifest[cheapest.id] = (manifest[cheapest.id] || 0) + 1;
        loaded += cheapest.value;
    }
    // Short only when the dock genuinely ran dry. Stock left over means the
    // convoy declined to overpay, which is a full manifest, not a failed one.
    var short = remaining.length ? 0 : Math.max(0, budget - loaded);
    return {
        manifest: manifest,
        value: loaded,
        budget: budget,
        short: {
            value: short
        }
    };
}
function $aee9584c1e6e51e7$export$4f87675e88a56589(param) {
    var templateId = param.templateId, fromRegionId = param.fromRegionId, toRegionId = param.toRegionId, skillId = param.skillId, leadName = param.leadName;
    var _gameState_command_legends, _gameState_command, _gameState_player;
    var template = $aee9584c1e6e51e7$export$36ac5ebae0245093[templateId];
    if (!template) return {
        ok: false,
        reason: 'unknown-template'
    };
    if ((0, $e39e78d7c65dc336$export$6955e231f1466c44)('operations-charter') <= 0) return {
        ok: false,
        reason: 'no-charter'
    };
    if ($aee9584c1e6e51e7$export$71db14eff0d59723() >= $aee9584c1e6e51e7$export$c87f3aa20ea43c6e()) return {
        ok: false,
        reason: 'no-free-slot'
    };
    var eraLegends = ((_gameState_command = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).command) === null || _gameState_command === void 0 ? void 0 : (_gameState_command_legends = _gameState_command.legends) === null || _gameState_command_legends === void 0 ? void 0 : _gameState_command_legends.length) || 0;
    if (eraLegends < template.legendsRequired) return {
        ok: false,
        reason: 'insufficient-legends',
        have: eraLegends,
        need: template.legendsRequired
    };
    var lead = $aee9584c1e6e51e7$export$34097b07af09d661().find(function(l) {
        return l.name === leadName;
    });
    if (!lead) return {
        ok: false,
        reason: 'lead-unavailable'
    };
    // A convoy has to travel. Staging in the destination is a zero-hour route
    // that would take cargo and energy and pay nothing back — refused as a route
    // problem rather than left to price itself at zero.
    var route = $aee9584c1e6e51e7$export$4fa936acba669006(fromRegionId, toRegionId);
    if (!route || route.cost <= 0) return {
        ok: false,
        reason: 'no-route'
    };
    var short = $aee9584c1e6e51e7$export$a666674acd11f81d(templateId, skillId).short;
    if (short.value > 0) return {
        ok: false,
        reason: 'insufficient-cargo',
        short: short
    };
    var energy = $aee9584c1e6e51e7$export$804dfc1c9f8f293a(templateId);
    if ((((_gameState_player = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player) === null || _gameState_player === void 0 ? void 0 : _gameState_player.energy) || 0) < energy) return {
        ok: false,
        reason: 'insufficient-energy',
        need: energy
    };
    return {
        ok: true
    };
}
function $aee9584c1e6e51e7$export$9cb89297e30fe792(param) {
    var templateId = param.templateId, fromRegionId = param.fromRegionId, toRegionId = param.toRegionId, skillId = param.skillId, leadName = param.leadName, _param_originRegionId = param.originRegionId, originRegionId = _param_originRegionId === void 0 ? null : _param_originRegionId, _param_now = param.now, now = _param_now === void 0 ? Date.now() : _param_now;
    var eligible = $aee9584c1e6e51e7$export$4f87675e88a56589({
        templateId: templateId,
        fromRegionId: fromRegionId,
        toRegionId: toRegionId,
        skillId: skillId,
        leadName: leadName
    });
    if (!eligible.ok) return (0, $fa9769297b8a68c8$export$71511d61b312f219)({
        success: false
    }, eligible);
    // The route is the price of the journey and the clock it runs on, so it is
    // read once, here, from the two endpoints the player named. No `waypoints`
    // argument any more: a caller cannot hand in a path that disagrees with its
    // own endpoints, because there is only one route between them.
    var hours = $aee9584c1e6e51e7$export$56ee0a61fc2e748(fromRegionId, toRegionId);
    var syndicate = (0, $e39e78d7c65dc336$export$cdfa564b532bb699)();
    var manifest = $aee9584c1e6e51e7$export$a666674acd11f81d(templateId, skillId).manifest;
    var lead = $aee9584c1e6e51e7$export$34097b07af09d661().find(function(l) {
        return l.name === leadName;
    });
    // Deducted from the Guild Vault's dock, not from any character. Cargo is spent
    // at launch and does not come back — that is the whole point of the sink.
    var stores = syndicate.stores || (syndicate.stores = {});
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(manifest)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step.value, 2), itemId = _step_value[0], qty = _step_value[1];
            stores[itemId] = Math.max(0, (stores[itemId] || 0) - qty);
            if (stores[itemId] === 0) delete stores[itemId]; // keep the dock readable
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player.energy = Math.max(0, ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player.energy || 0) - $aee9584c1e6e51e7$export$804dfc1c9f8f293a(templateId));
    var from = $aee9584c1e6e51e7$var$asTile(fromRegionId);
    var operation = {
        id: "op_".concat(now, "_").concat(syndicate.opsCompleted, "_").concat(syndicate.operations.length),
        templateId: templateId,
        // The literal staging tile, plus the region that owns it. The tile draws
        // the route; the region is what demand pricing (S5) and the UI read.
        from: from,
        // Origin first, destination last — two capitals, and the tile path between
        // them is derived by `routeFromWaypoints`. Still a LIST rather than a pair
        // because that is the shape already on disk for in-flight convoys, and a
        // two-element list rebuilds through exactly the same code a longer one did.
        waypoints: [
            from,
            $aee9584c1e6e51e7$var$asTile(toRegionId)
        ],
        fromRegionId: originRegionId || (typeof fromRegionId === 'string' ? fromRegionId : $aee9584c1e6e51e7$export$8660d3afb66129a5(fromRegionId.row, fromRegionId.col)),
        toRegionId: toRegionId,
        skillId: skillId,
        cargo: manifest,
        leadName: leadName,
        leadMarks: (lead === null || lead === void 0 ? void 0 : lead.marksEarned) || 0,
        startedAt: now,
        // The demand premium agreed at launch, for the same reason `hours` is
        // recorded: a region's mix is derived from its room pools, so adding a
        // single hazard to a region would silently re-price convoys already in
        // transit. What the player launched is what they get.
        // Priced at `now`, not at the wall clock: saturation decays against the
        // caller's clock, and the simulator's is virtual. Defaulting here would
        // have quoted every simulated convoy against real elapsed time.
        demand: (0, $35d30e7dcff465af$export$6bba5a60cd02466f)(toRegionId, skillId, now),
        // The PLANNED duration, recorded at launch and used for the payout.
        // Deriving yield from `completesAt - startedAt` instead would make it a
        // function of two mutable timestamps: anything that touches either (a clock
        // change, a future server reconciliation, a save edit) silently re-prices a
        // convoy that was already agreed. What the player launched is what they get.
        hours: hours,
        completesAt: now + Math.round(hours * $aee9584c1e6e51e7$var$HOUR_MS)
    };
    syndicate.operations.push(operation);
    // Feed the destination's market — AFTER `operation.demand` is fixed above, so
    // a convoy is never priced against its own delivery.
    //
    // At launch rather than at settlement, which is the same rule the cargo and
    // energy already follow. Settling instead would leave a window exactly one
    // slot-count wide: three convoys fired at the same hungry region would all
    // collect the undiminished premium, because none of them had landed yet.
    //
    // Measured in the manifest's CREDIT VALUE, not its unit count. Now that a
    // manifest can be any mix of rarities, a unit is not a unit: a rare is 23
    // commons of goods on the derived ladder, and counting them alike would let a
    // rare-heavy convoy satiate a market as little as a handful of scrap. Value
    // is what the market actually absorbed.
    (0, $35d30e7dcff465af$export$bd4b24a19973285f)(toRegionId, skillId, (0, $00cd2a5b8f760625$export$f92dab4a7d67d380)(manifest), now);
    return {
        success: true,
        operation: operation,
        hours: hours
    };
}
function $aee9584c1e6e51e7$export$a4ac0527bd343e81(operation) {
    var template = $aee9584c1e6e51e7$export$36ac5ebae0245093[operation.templateId];
    if (!template) return {
        credits: 0,
        writs: 0,
        leadBonus: 0,
        demand: (0, $35d30e7dcff465af$export$2119d59df637b878)
    };
    var _operation_hours;
    // Prefer the duration and premium agreed at launch; recompute only for
    // operations written before those fields were recorded.
    var hours = (_operation_hours = operation.hours) !== null && _operation_hours !== void 0 ? _operation_hours : (operation.completesAt - operation.startedAt) / $aee9584c1e6e51e7$var$HOUR_MS;
    var _operation_demand;
    var demand = (_operation_demand = operation.demand) !== null && _operation_demand !== void 0 ? _operation_demand : (0, $35d30e7dcff465af$export$6bba5a60cd02466f)(operation.toRegionId, operation.skillId);
    // Ration Cut pays on every convoy, forever — a permanent multiplier, applied
    // alongside demand and the lead bonus rather than folded into any of them.
    var blackoutYield = 1 + (0, $686e361e5cd4549d$export$84f52d60145287)('op-credit-yield', 0);
    // Sale + haulage. The flat term is what keeps a short route worth running —
    // see the note above OPERATION_TEMPLATES for why a pure per-hour rate makes
    // the staging point a non-decision.
    var base = Math.round((template.credits || 0) + template.creditsPerHour * hours);
    var leadBonus = Math.min($aee9584c1e6e51e7$export$2a1adeeaefb6ac28, (operation.leadMarks || 0) * $aee9584c1e6e51e7$export$27e3703df3a11e61);
    // The trickle is the ONLY ops Writ, and it rides demand: earned by shipping
    // into a genuinely hungry market, never by shipping a lot. Gated to the top
    // class so a 2.5-hour Short Haul cannot become the cheapest Writ in the game,
    // and self-limiting because a delivery is what stops a market being hungry.
    var demandWrit = template.writEligible && (0, $35d30e7dcff465af$export$d48946d0a3e2934b)(demand) ? 1 : 0;
    return {
        credits: Math.round(base * (1 + leadBonus) * demand * blackoutYield),
        writs: demandWrit,
        leadBonus: leadBonus,
        demand: demand,
        demandWrit: demandWrit
    };
}
function $aee9584c1e6e51e7$export$b68d61a5f45d991c() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_now = _ref.now, now = _ref_now === void 0 ? Date.now() : _ref_now, _ref_maxPerSlot = _ref.maxPerSlot, maxPerSlot = _ref_maxPerSlot === void 0 ? Infinity : _ref_maxPerSlot;
    var syndicate = (0, $e39e78d7c65dc336$export$cdfa564b532bb699)();
    var due = (syndicate.operations || []).filter(function(op) {
        return op.completesAt <= now;
    });
    // Oldest first, so a cap keeps the ops that finished earliest rather than an
    // arbitrary slice.
    due.sort(function(a, b) {
        return a.completesAt - b.completesAt;
    });
    var settling = Number.isFinite(maxPerSlot) ? due.slice(0, maxPerSlot * Math.max(1, $aee9584c1e6e51e7$export$c87f3aa20ea43c6e())) : due;
    var credits = 0, writs = 0;
    var settled = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = settling[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var op = _step.value;
            var payout = $aee9584c1e6e51e7$export$a4ac0527bd343e81(op);
            credits += payout.credits;
            writs += payout.writs;
            settled.push((0, $715bf31211e65705$export$71511d61b312f219)((0, $fa9769297b8a68c8$export$71511d61b312f219)({}, op), {
                payout: payout
            }));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (settled.length) {
        var settledIds = new Set(settled.map(function(o) {
            return o.id;
        }));
        syndicate.operations = syndicate.operations.filter(function(op) {
            return !settledIds.has(op.id);
        });
        syndicate.opsCompleted += settled.length;
        syndicate.writs += writs;
        (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player.credits = ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player.credits || 0) + credits;
    }
    return {
        settled: settled,
        credits: credits,
        writs: writs
    };
}



/**
 * @typedef {'idle'|'running'|'complete'|'automated'|'none'} TaskState
 *   none      - this layer has no active task worth a button (slot hides)
 *   idle      - a task can be started
 *   running   - in progress; label carries live status
 *   complete  - finished and awaiting collection; this is what badges the switcher
 *   automated - a higher layer runs this loop hands-off (L3+)
 */ /** Field's raid, read from the same state today's raid-tab button reads. */ function $cda2111f1d5bcde8$var$fieldActiveTask() {
    var raid = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid || {};
    if (!(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character) return {
        state: 'none',
        label: '',
        screen: null
    };
    // Another character owns the active raid — the screen is not ours to open.
    if (!(0, $fe47a452a83d9e00$export$77866226ea57ca79)()) return {
        state: 'none',
        label: '',
        screen: null
    };
    if (raid.raidOwnerId && raid.raidInProgress != null) return {
        state: 'running',
        label: 'Raid in Progress',
        screen: 'raid'
    };
    if (raid.raidCompleted) return {
        state: 'complete',
        label: 'Raid Completed',
        screen: 'raid'
    };
    if (raid.currentRaidGrid && raid.selectedTier) return {
        state: 'running',
        label: 'Raid in Planning',
        screen: 'raid'
    };
    return {
        state: 'idle',
        label: 'New Raid',
        screen: 'raid'
    };
}
/**
 * Syndicate's active task is launching an OPERATION, not founding.
 *
 * Founding stays off the toolbar: it is irreversible and available for most of
 * an era, so a permanent "Found" button would be both a dead control and a
 * dangerous one. Launching a convoy is the opposite - repeatable, cheap to
 * decide, and the thing a player returns to the layer to do.
 *
 * `mode` splits one screen into two views. Planning a new operation and
 * watching three in flight are different jobs, and putting both on one page
 * meant the map carried every route at once. The toolbar button opens the
 * PLANNER; the screen tab opens the in-transit board.
 */ function $cda2111f1d5bcde8$var$syndicateActiveTask() {
    var _gameState_syndicate_operations, _gameState_syndicate;
    if ((0, $e39e78d7c65dc336$export$6955e231f1466c44)('operations-charter') <= 0) return {
        state: 'none',
        label: '',
        screen: null
    };
    var inFlight = ((_gameState_syndicate = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).syndicate) === null || _gameState_syndicate === void 0 ? void 0 : (_gameState_syndicate_operations = _gameState_syndicate.operations) === null || _gameState_syndicate_operations === void 0 ? void 0 : _gameState_syndicate_operations.length) || 0;
    var slots = (0, $aee9584c1e6e51e7$export$c87f3aa20ea43c6e)();
    if (inFlight >= slots) // Informational, not actionable - same role as Field's "Raid in
    // Progress". Clicking still reaches the transit board, which is the
    // useful destination when everything is already out.
    return {
        state: 'running',
        label: "Convoys out ".concat(inFlight, "/").concat(slots),
        screen: 'operations'
    };
    return {
        state: 'idle',
        label: 'New Operation',
        screen: 'operations',
        mode: 'plan'
    };
}
/**
 * Command's promotion.
 *
 * Deliberately never reports 'complete' yet. `canPromoteCore()` is a BLOCKER
 * check (no character / on marketplace / mid-raid) - it says promotion is
 * *permitted*, not that it is *worthwhile*, and it is true almost always. Using
 * it for the badge would light the switcher permanently, which is worse than
 * not badging at all.
 *
 * A real readiness signal arrives with L3's `succession-doctrine`, which ports
 * the simulator's marks-rate-peak policy into the game so the Command panel and
 * the automation share one computation (docs/layers/3-syndicate/design.md §4.4). Until
 * then Command reports 'idle', and the spec hides the slot when idle.
 */ function $cda2111f1d5bcde8$var$commandActiveTask() {
    // 'none', not 'idle': the spec hides Command's slot when idle, and promotion
    // is started from the Promotion screen rather than the toolbar. Showing a
    // permanent "Promote" button here would be the dead control the active-task
    // slot exists to avoid. This becomes 'complete' -> "Promotion ready" once a
    // readiness signal exists (L3 succession-doctrine).
    return {
        state: 'none',
        label: '',
        screen: null
    };
}
function $cda2111f1d5bcde8$export$555e6e56b118f15() {
    var _gameState_command_legends, _gameState_command, _gameState_command1, _gameState_syndicate;
    return (((_gameState_command = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).command) === null || _gameState_command === void 0 ? void 0 : (_gameState_command_legends = _gameState_command.legends) === null || _gameState_command_legends === void 0 ? void 0 : _gameState_command_legends.length) || 0) > 0 || (((_gameState_command1 = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).command) === null || _gameState_command1 === void 0 ? void 0 : _gameState_command1.tour) || 1) > 1 || (((_gameState_syndicate = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).syndicate) === null || _gameState_syndicate === void 0 ? void 0 : _gameState_syndicate.founded) || 0) > 0;
}
var $cda2111f1d5bcde8$export$fdca3ba65b5cceec = [
    {
        id: 'field',
        // Label is display-only; `id` stays 'field' because saves, lastScreenByLayer
        // and every test key off it. Renaming the id would strand saved UI state.
        label: 'The Field',
        icon: "\u2694\uFE0F",
        accent: '#7cc4ff',
        unlocked: function() {
            return true;
        },
        // `visible` is declarative on purpose. This used to be imperative — the old
        // updateTabVisibility() added a `hidden` class — which stopped working the
        // moment the toolbar started re-rendering: the next render simply rebuilt
        // the buttons without it. Anything the renderer owns has to be expressed as
        // state the renderer reads.
        //
        // On a BRAND NEW account the creation screen is the only view, so Field
        // offers no navigation. Between characters is a different state and needs a
        // different answer: `#character-tab` hosts the creator as well as the
        // roster, so gating it on `gameState.character` left a promoted or
        // post-founding account with no visible Field screen at all — switchLayer
        // had no tab to click, and "The Field" went nowhere.
        screens: [
            {
                id: 'character',
                label: 'Characters',
                icon: "\uD83E\uDDD1",
                tab: 'character',
                visible: function() {
                    return !!(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character || $cda2111f1d5bcde8$export$555e6e56b118f15();
                }
            },
            // Contractors stays strict: a hiring pool with nobody to hire for is a
            // genuinely dead screen, not a route to the creator.
            {
                id: 'contractors',
                label: 'Contractors',
                icon: "\uD83E\uDD1D",
                tab: 'contractors',
                visible: function() {
                    return !!(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character;
                }
            },
            // The Archive appears with the first Collapse Key and never leaves — the
            // record is account-level, so it outlives every character.
            //
            // Gated on HAVING one rather than on having a character, and that is not
            // just dead-control hygiene: Field's toolbar row measured 753 of 768px
            // with two screens, so a third is a real width cost and it should not be
            // paid until there is something behind it. Below 900px the toolbar drops
            // labels for icons, which is what keeps three Field screens inside the
            // tablet budget once it does appear.
            {
                id: 'archive',
                label: 'Archive',
                icon: "\uD83D\uDDDD\uFE0F",
                tab: 'archive',
                visible: function() {
                    var _gameState_player_collapseKeys, _gameState_player;
                    return (((_gameState_player = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player) === null || _gameState_player === void 0 ? void 0 : (_gameState_player_collapseKeys = _gameState_player.collapseKeys) === null || _gameState_player_collapseKeys === void 0 ? void 0 : _gameState_player_collapseKeys.length) || 0) > 0;
                }
            }
        ],
        currencies: [
            // `compact` bounds the chip at 5 characters. Credits are the one value
            // here that grows without limit, and the chip grew with it.
            {
                id: 'credits',
                icon: "\uD83D\uDCB0",
                value: function() {
                    var _gameState_player;
                    var _gameState_player_credits;
                    return (_gameState_player_credits = (_gameState_player = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player) === null || _gameState_player === void 0 ? void 0 : _gameState_player.credits) !== null && _gameState_player_credits !== void 0 ? _gameState_player_credits : 0;
                },
                compact: true
            },
            {
                id: 'energy',
                icon: "\u26A1",
                // Already bounded by maxEnergy, and it is a ratio - abbreviating would
                // cost clarity to save nothing.
                value: function() {
                    var _gameState_player, _gameState_player1;
                    var _gameState_player_energy, _gameState_player_maxEnergy;
                    return "".concat((_gameState_player_energy = (_gameState_player = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player) === null || _gameState_player === void 0 ? void 0 : _gameState_player.energy) !== null && _gameState_player_energy !== void 0 ? _gameState_player_energy : 0, "/").concat((_gameState_player_maxEnergy = (_gameState_player1 = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player) === null || _gameState_player1 === void 0 ? void 0 : _gameState_player1.maxEnergy) !== null && _gameState_player_maxEnergy !== void 0 ? _gameState_player_maxEnergy : 0);
                }
            }
        ],
        activeTask: $cda2111f1d5bcde8$var$fieldActiveTask
    },
    {
        id: 'command',
        label: 'Command',
        icon: "\uD83C\uDF96\uFE0F",
        accent: '#b18cff',
        // Reveal latch, not a live check - Command stays available between tours,
        // which is exactly when upgrades get bought.
        unlocked: function() {
            return (0, $ee71dfe8b201c427$export$25d1e5af45c35a33)();
        },
        screens: [
            {
                id: 'command',
                label: 'Promotion',
                icon: "\uD83C\uDF96\uFE0F",
                tab: 'command'
            },
            {
                id: 'command-vault',
                label: 'Vault',
                icon: "\uD83C\uDFE6",
                tab: 'command-vault'
            }
        ],
        currencies: [
            // Marks accumulate across every tour, so they grow without limit too.
            {
                id: 'marks',
                icon: "\uD83C\uDF96\uFE0F",
                value: function() {
                    var _gameState_command;
                    var _gameState_command_marks;
                    return (_gameState_command_marks = (_gameState_command = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).command) === null || _gameState_command === void 0 ? void 0 : _gameState_command.marks) !== null && _gameState_command_marks !== void 0 ? _gameState_command_marks : 0;
                },
                compact: true
            }
        ],
        activeTask: $cda2111f1d5bcde8$var$commandActiveTask
    },
    {
        id: 'syndicate',
        label: 'Syndicate',
        icon: "\uD83D\uDCDC",
        accent: '#e0a84c',
        unlocked: function() {
            return (0, $e39e78d7c65dc336$export$f0d4871acc619a3)();
        },
        // 'Charter' rather than 'Syndicate': the layer name is already in the
        // switcher, so repeating it here would spend header width saying nothing.
        // It is also short, which matters - at 1024 the toolbar's spare room is
        // ~117px and a long label is what would actually break portrait.
        screens: [
            {
                id: 'charter',
                label: 'Charter',
                icon: "\uD83D\uDCDC",
                tab: 'syndicate'
            },
            // Operations appear only once licensed. A screen for a system the player
            // cannot use yet is the dead control the `visible` predicate exists to
            // avoid — and unlike Field's screens this one is bought, not unlocked by
            // progression, so it can also disappear again on a fresh era.
            {
                id: 'operations',
                label: 'Operations',
                icon: "\uD83D\uDDFA\uFE0F",
                tab: 'operations',
                visible: function() {
                    var _gameState_syndicate_upgrades, _gameState_syndicate;
                    return (((_gameState_syndicate = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).syndicate) === null || _gameState_syndicate === void 0 ? void 0 : (_gameState_syndicate_upgrades = _gameState_syndicate.upgrades) === null || _gameState_syndicate_upgrades === void 0 ? void 0 : _gameState_syndicate_upgrades['operations-charter']) || 0) > 0;
                }
            },
            {
                id: 'syndicate-stores',
                label: 'Stores',
                icon: "\uD83D\uDCE6",
                tab: 'syndicate-stores'
            }
        ],
        currencies: [
            // Writs accumulate across every founding, so they need the same compact
            // treatment as marks and credits.
            {
                id: 'writs',
                icon: "\uD83D\uDCDC",
                value: function() {
                    var _gameState_syndicate;
                    var _gameState_syndicate_writs;
                    return (_gameState_syndicate_writs = (_gameState_syndicate = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).syndicate) === null || _gameState_syndicate === void 0 ? void 0 : _gameState_syndicate.writs) !== null && _gameState_syndicate_writs !== void 0 ? _gameState_syndicate_writs : 0;
                },
                compact: true
            },
            // Energy appears here even though Command deliberately hides it, because
            // the rule is "show what is ACTIONABLE in this layer" rather than "hide
            // everything from below". Operations spend energy, so a player planning
            // one needs to see it without leaving the layer.
            {
                id: 'energy',
                icon: "\u26A1",
                value: function() {
                    var _gameState_player, _gameState_player1;
                    var _gameState_player_energy, _gameState_player_maxEnergy;
                    return "".concat((_gameState_player_energy = (_gameState_player = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player) === null || _gameState_player === void 0 ? void 0 : _gameState_player.energy) !== null && _gameState_player_energy !== void 0 ? _gameState_player_energy : 0, "/").concat((_gameState_player_maxEnergy = (_gameState_player1 = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player) === null || _gameState_player1 === void 0 ? void 0 : _gameState_player1.maxEnergy) !== null && _gameState_player_maxEnergy !== void 0 ? _gameState_player_maxEnergy : 0);
                }
            }
        ],
        activeTask: $cda2111f1d5bcde8$var$syndicateActiveTask
    }
];
function $cda2111f1d5bcde8$export$61f6a9c831786408() {
    return $cda2111f1d5bcde8$export$fdca3ba65b5cceec;
}
function $cda2111f1d5bcde8$export$f5b74d0d242cec02(id) {
    return $cda2111f1d5bcde8$export$fdca3ba65b5cceec.find(function(l) {
        return l.id === id;
    }) || null;
}
function $cda2111f1d5bcde8$export$e4f119c4ad718995() {
    return $cda2111f1d5bcde8$export$fdca3ba65b5cceec.filter(function(l) {
        try {
            return l.unlocked();
        } catch (e) {
            return false;
        }
    });
}
function $cda2111f1d5bcde8$export$cdfede5cf3580bc3() {
    var _gameState_ui;
    var id = (_gameState_ui = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).ui) === null || _gameState_ui === void 0 ? void 0 : _gameState_ui.currentLayer;
    var layer = id ? $cda2111f1d5bcde8$export$f5b74d0d242cec02(id) : null;
    if (layer && layer.unlocked()) return layer.id;
    return 'field';
}
function $cda2111f1d5bcde8$export$622b0388371c420c(id) {
    var layer = $cda2111f1d5bcde8$export$f5b74d0d242cec02(id);
    if (!layer || !layer.unlocked()) return false;
    if (!(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).ui) (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).ui = {};
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).ui.currentLayer = id;
    return true;
}
function $cda2111f1d5bcde8$export$b6b1c75d2c3e7681() {
    var layerId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $cda2111f1d5bcde8$export$cdfede5cf3580bc3();
    var _getLayer;
    var _getLayer_screens;
    return ((_getLayer_screens = (_getLayer = $cda2111f1d5bcde8$export$f5b74d0d242cec02(layerId)) === null || _getLayer === void 0 ? void 0 : _getLayer.screens) !== null && _getLayer_screens !== void 0 ? _getLayer_screens : []).filter(function(s) {
        return !s.visible || s.visible();
    });
}
function $cda2111f1d5bcde8$export$7c0a2b034b740aec() {
    var layerId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $cda2111f1d5bcde8$export$cdfede5cf3580bc3();
    var _getLayer;
    var _getLayer_currencies;
    return ((_getLayer_currencies = (_getLayer = $cda2111f1d5bcde8$export$f5b74d0d242cec02(layerId)) === null || _getLayer === void 0 ? void 0 : _getLayer.currencies) !== null && _getLayer_currencies !== void 0 ? _getLayer_currencies : []).map(function(c) {
        var raw = c.value();
        var value = c.compact ? (0, $ca7af38ea7b7b4a8$export$d7a853631095b479)(raw) : raw;
        // `exact` is null unless abbreviating actually hid something, so the header
        // only carries a tooltip where there is something to reveal. Hover is not
        // reachable on tablet - a supported target - so this is a supplement to the
        // 100,000 exact-digits floor, never the thing that makes it usable.
        var exact = c.compact && value !== String(raw) ? Number(raw).toLocaleString() : null;
        return {
            id: c.id,
            icon: c.icon,
            value: value,
            exact: exact
        };
    });
}
function $cda2111f1d5bcde8$export$47888485123801c8() {
    var layerId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $cda2111f1d5bcde8$export$cdfede5cf3580bc3();
    var layer = $cda2111f1d5bcde8$export$f5b74d0d242cec02(layerId);
    if (!layer) return {
        state: 'none',
        label: '',
        screen: null
    };
    return layer.activeTask();
}
function $cda2111f1d5bcde8$export$2230f7bb8ebaf8be() {
    var currentId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $cda2111f1d5bcde8$export$cdfede5cf3580bc3();
    return $cda2111f1d5bcde8$export$e4f119c4ad718995().filter(function(l) {
        return l.id !== currentId && l.activeTask().state === 'complete';
    }).map(function(l) {
        return l.id;
    });
}



// Last screen visited per layer, so returning to Command lands where you left
// it. This is what makes switching cheap rather than punishing.
var $8896b37f0fd85895$var$lastScreenByLayer = new Map();
/**
 * The screen the player is on (or heading to), as a `data-tab` value.
 *
 * This is INTENT, deliberately not derived from `.tab-content.active`. Tab
 * switching is animated: the outgoing pane keeps `.active` until its fade-out
 * ends, so anything reading the DOM synchronously after a click sees the
 * PREVIOUS screen. That made the toolbar paint the wrong button active, and
 * because the click handler skips buttons already marked active, the stale
 * class then swallowed the next navigation to that screen.
 */ var $8896b37f0fd85895$var$currentScreenTab = null;
function $8896b37f0fd85895$export$517113b01f92f5fe() {
    return $8896b37f0fd85895$var$currentScreenTab;
}
// Below this width screen tabs drop their labels and show icons only. The layer
// name already appears in the switcher, so screen tabs carry less naming burden
// and are the right thing to shed labels first.
var $8896b37f0fd85895$var$ICON_ONLY_MAX_WIDTH = 900;
var $8896b37f0fd85895$var$isNarrow = function() {
    return window.innerWidth <= $8896b37f0fd85895$var$ICON_ONLY_MAX_WIDTH;
};
var $8896b37f0fd85895$var$BTN_BASE = 'tab-btn font-bold py-1 rounded-lg border-2 hover:shadow-lg whitespace-nowrap';
/**
 * Horizontal padding for every toolbar button, tightened on narrow viewports.
 *
 * The toolbar's width budget is genuinely tight — Field measured 753 of 768 —
 * and a third Syndicate screen (Charter / Operations / Stores) pushed it 34px
 * over, silently clipping the help button off the right edge. One uniform rule
 * beats shaving a label: it recovers the room from the whole bar rather than
 * from whichever control was added last, and it leaves headroom for the next
 * screen instead of paying this cost again.
 */ var $8896b37f0fd85895$var$btnBase = function() {
    return "".concat($8896b37f0fd85895$var$BTN_BASE, " ").concat($8896b37f0fd85895$var$isNarrow() ? 'px-1.5' : 'px-3');
};
/**
 * Active-task button styling, keyed by task state.
 *
 * The rule the header reads by: **solid means act, quiet means FYI.** A player
 * scanning the toolbar should be able to tell "you owe me an input" from "this
 * is running fine" without reading the label.
 *
 * `complete` deliberately mirrors the in-game raid button's own "Complete Raid"
 * styling (`raid.js` updateRaidButtonStates) - same gradient, same foil. It is
 * the same action on two surfaces, so it should not be a different colour on
 * each; it previously rendered `bg-green-400/10`, which is 10% green over a
 * dark header and reads as near-black.
 *
 * `bg-amber-* text-black` is the idiom used everywhere else in the app for a
 * solid amber control. The raid button reaches the same place by a different
 * route - `.start-raid-btn` sets #1a1a2e in CSS - and the difference is not
 * perceptible on amber, so this stays with the Tailwind idiom.
 *
 * `running` is the only state with nothing to do, so it is the only quiet one.
 * That contrast is what gives the solid states meaning - if every state were
 * solid, "solid" would signal nothing.
 */ var $8896b37f0fd85895$var$TASK_TONES = {
    // Finished, awaiting collection - the strongest call to action.
    complete: 'border-amber-300 text-black bg-gradient-to-r from-amber-500 to-amber-600',
    // Startable now.
    idle: 'border-amber-400 text-black bg-amber-600 hover:bg-amber-500',
    // In progress - informational, nothing for the player to do.
    running: 'border-amber-800/70 text-amber-100/80 bg-white/5',
    // A higher layer runs this loop hands-off (L3+): also nothing to do.
    automated: 'border-sky-800/70 text-sky-100/80 bg-white/5'
};
function $8896b37f0fd85895$var$el(tag, className, html) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (html != null) node.innerHTML = html;
    return node;
}
/** The layer switcher - shows where you are, and badges when elsewhere needs you. */ function $8896b37f0fd85895$var$renderSwitcher(container, layer) {
    container.replaceChildren();
    var btn = $8896b37f0fd85895$var$el('button', "".concat($8896b37f0fd85895$var$btnBase(), " relative bg-white/5"));
    btn.id = 'layer-switcher-btn';
    btn.style.borderColor = layer.accent;
    btn.style.color = layer.accent;
    btn.title = "Current layer: ".concat(layer.label);
    btn.innerHTML = "".concat(layer.icon, " ").concat(layer.label, ' <span class="opacity-70">\u25BE</span>');
    // Badge counts LAYERS needing attention, not tasks, so it stays stable as
    // layers and task counts grow. Neutral colour: "something needs you" must
    // never read as a layer identity.
    var waiting = (0, $cda2111f1d5bcde8$export$2230f7bb8ebaf8be)(layer.id);
    if (waiting.length > 0) {
        var badge = $8896b37f0fd85895$var$el('span', "absolute -top-2 -right-2 min-w-[18px] h-[18px] px-1 rounded-full bg-amber-500 text-black text-[10px] font-extrabold grid place-items-center", String(waiting.length));
        badge.title = "Needs attention: ".concat(waiting.join(', '));
        btn.appendChild(badge);
    }
    btn.addEventListener('click', function(e) {
        e.stopPropagation();
        $8896b37f0fd85895$export$c937970754507226();
    });
    container.appendChild(btn);
}
/** The current layer's screens. Never the union - one layer's context at a time. */ function $8896b37f0fd85895$var$renderScreens(container, layer) {
    container.replaceChildren();
    // Intent, not `.tab-content.active` — see currentScreenTab.
    var activeTab = $8896b37f0fd85895$var$currentScreenTab;
    var narrow = $8896b37f0fd85895$var$isNarrow();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // screensFor() applies each screen's `visible` predicate — do not read
        // layer.screens directly, or hidden screens come back on every render.
        for(var _iterator = (0, $cda2111f1d5bcde8$export$b6b1c75d2c3e7681)(layer.id)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var screen = _step.value;
            var isActive = screen.tab === activeTab;
            var btn = $8896b37f0fd85895$var$el('button', "".concat($8896b37f0fd85895$var$btnBase(), " ").concat(isActive ? 'active' : '', " text-gray-300 bg-white/5"));
            btn.dataset.tab = screen.tab;
            btn.style.borderColor = isActive ? layer.accent : '';
            btn.title = screen.label;
            btn.textContent = narrow ? screen.icon : screen.label;
            if (!isActive) btn.classList.add('border-gray-500');
            container.appendChild(btn);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
/**
 * The active-task slot - shortcut to *and* live status of this layer's task.
 * Replaces the hardcoded "New Raid" button: raiding is Field's task, not a
 * privileged global one.
 */ function $8896b37f0fd85895$var$renderTask(container, layer) {
    container.replaceChildren();
    var task = (0, $cda2111f1d5bcde8$export$47888485123801c8)(layer.id);
    if (task.state === 'none') return; // spec: hide the slot rather than show a dead control
    var _TASK_TONES_task_state;
    var btn = $8896b37f0fd85895$var$el('button', "".concat($8896b37f0fd85895$var$btnBase(), " ").concat((_TASK_TONES_task_state = $8896b37f0fd85895$var$TASK_TONES[task.state]) !== null && _TASK_TONES_task_state !== void 0 ? _TASK_TONES_task_state : $8896b37f0fd85895$var$TASK_TONES.idle));
    btn.id = 'layer-task-btn';
    btn.dataset.tab = task.screen;
    // Stamped here, not only in refreshToolbarValues: this is what the tick
    // compares against to decide whether a structural rebuild is needed. Leaving
    // it unset meant any external renderLayerToolbar() call looked like a state
    // change on the next tick, forcing a rebuild that closed an open panel.
    btn.dataset.state = task.state;
    // Optional: a task can ask for a particular VIEW of its screen. Syndicate's
    // Operations screen is both a planner and a transit board, and the toolbar
    // button means "plan a new one" while the screen tab means "show me what is
    // running". The tab handler reads this off the clicked element.
    if (task.mode) btn.dataset.mode = task.mode;
    btn.textContent = task.label;
    if (task.state === 'complete') btn.classList.add('foil-card');
    container.appendChild(btn);
}
/**
 * Currencies for this layer only - NOT accumulated. Credits and energy are not
 * actionable in Command, so they do not appear there. This is the single change
 * that stops the right-hand cluster growing once per layer, and it is most of
 * the portrait-clipping fix.
 */ function $8896b37f0fd85895$var$renderCurrencies(container, layer) {
    container.replaceChildren();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = (0, $cda2111f1d5bcde8$export$7c0a2b034b740aec)(layer.id)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var currency = _step.value;
            var chip = $8896b37f0fd85895$var$el('div', 'flex items-center gap-1 px-2 py-1 bg-white/10 rounded-lg border-2 border-gray-900');
            chip.id = "".concat(currency.id, "-chip");
            if (currency.exact) chip.title = currency.exact;
            chip.appendChild($8896b37f0fd85895$var$el('span', null, currency.icon));
            var value = $8896b37f0fd85895$var$el('span', 'font-bold');
            value.id = "currency-".concat(currency.id);
            value.textContent = currency.value;
            value.style.color = currency.id === 'energy' ? '#60a5fa' : layer.accent;
            chip.appendChild(value);
            // Energy carries a purchase affordance. The popup itself lives outside the
            // chips (see index.html) so re-rendering currencies cannot destroy it.
            if (currency.id === 'energy') {
                var buy = $8896b37f0fd85895$var$el('button', "ml-1 px-1.5 rounded font-bold text-blue-300 bg-blue-900/60 border border-blue-700 hover:bg-blue-700 hover:text-white transition-colors", '+');
                buy.id = 'buy-energy-btn';
                buy.title = 'Buy energy';
                buy.addEventListener('click', function(e) {
                    var _window_toggleEnergyPopup, _window;
                    return (_window_toggleEnergyPopup = (_window = window).toggleEnergyPopup) === null || _window_toggleEnergyPopup === void 0 ? void 0 : _window_toggleEnergyPopup.call(_window, e);
                });
                chip.appendChild(buy);
            }
            container.appendChild(chip);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $8896b37f0fd85895$export$5672aa0b2d188c2b() {
    var layer = (0, $cda2111f1d5bcde8$export$f5b74d0d242cec02)((0, $cda2111f1d5bcde8$export$cdfede5cf3580bc3)());
    if (!layer) return;
    var switcher = document.getElementById('layer-switcher');
    var screens = document.getElementById('layer-screens');
    var task = document.getElementById('layer-task');
    var currencies = document.getElementById('layer-currencies');
    if (!switcher || !screens || !task || !currencies) return; // header not on this page
    // A structural rebuild replaces the switcher button the panel is anchored to
    // and whose outside-click handler references it, so an open panel cannot
    // survive one. Rare in practice — this fires on layer switch, unlock, and
    // task-state change, not on the per-second tick.
    if ($8896b37f0fd85895$var$panelIsOpen()) $8896b37f0fd85895$export$9722d62d688a2b10();
    $8896b37f0fd85895$var$renderSwitcher(switcher, layer);
    $8896b37f0fd85895$var$renderScreens(screens, layer);
    $8896b37f0fd85895$var$renderTask(task, layer);
    $8896b37f0fd85895$var$renderCurrencies(currencies, layer);
}
function $8896b37f0fd85895$export$c6af328ac5cab01b() {
    var layerId = (0, $cda2111f1d5bcde8$export$cdfede5cf3580bc3)();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = (0, $cda2111f1d5bcde8$export$7c0a2b034b740aec)(layerId)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var currency = _step.value;
            var node = document.getElementById("currency-".concat(currency.id));
            if (node) node.textContent = currency.value;
            // Patched here too, not only on a structural rebuild: an abbreviated chip
            // holds the exact figure in its tooltip, and credits change every raid
            // while structure does not. Missing this would pin the tooltip to whatever
            // the balance was at the last rebuild.
            var chip = document.getElementById("".concat(currency.id, "-chip"));
            if (chip) {
                if (currency.exact) chip.title = currency.exact;
                else chip.removeAttribute('title');
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // The task's LABEL changes constantly (raid progress); its presence and tone
    // change rarely. Rebuild only when the state actually changes.
    var task = (0, $cda2111f1d5bcde8$export$47888485123801c8)(layerId);
    var btn = document.getElementById('layer-task-btn');
    var _btn_dataset_state;
    var stateChanged = ((_btn_dataset_state = btn === null || btn === void 0 ? void 0 : btn.dataset.state) !== null && _btn_dataset_state !== void 0 ? _btn_dataset_state : 'none') !== task.state;
    if (stateChanged) {
        $8896b37f0fd85895$export$5672aa0b2d188c2b(); // renderTask stamps the new state
        return;
    }
    if (btn) btn.textContent = task.label;
    // A layer unlocking (or a raid completing elsewhere) changes the badge.
    var expected = (0, $cda2111f1d5bcde8$export$2230f7bb8ebaf8be)(layerId).length;
    var shown = document.querySelector('#layer-switcher .bg-amber-500');
    if (expected > 0 !== !!shown) $8896b37f0fd85895$export$5672aa0b2d188c2b();
}
function $8896b37f0fd85895$export$7e55ff4ad8ce9b5a(layerId) {
    if (!(0, $cda2111f1d5bcde8$export$622b0388371c420c)(layerId)) return false;
    var layer = (0, $cda2111f1d5bcde8$export$f5b74d0d242cec02)(layerId);
    var remembered = $8896b37f0fd85895$var$lastScreenByLayer.get(layerId);
    // Only currently-visible screens are valid targets, or we would try to click
    // a button that was never rendered.
    var visible = (0, $cda2111f1d5bcde8$export$b6b1c75d2c3e7681)(layerId);
    var target = visible.find(function(s) {
        return s.tab === remembered;
    }) || visible[0];
    // Render first so the new layer's screen buttons exist to be clicked.
    $8896b37f0fd85895$export$5672aa0b2d188c2b();
    if (target) {
        var _document_querySelector;
        if (target.tab === $8896b37f0fd85895$var$currentScreenTab) // Already displaying the target screen. The click handler would treat
        // this as a no-op and return, leaving the toolbar unpainted, so repaint
        // directly. Cannot happen while layers own distinct screens, but the
        // registry does not guarantee that.
        $8896b37f0fd85895$export$5672aa0b2d188c2b();
        else (_document_querySelector = document.querySelector('#layer-screens [data-tab="'.concat(target.tab, '"]'))) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.click();
    }
    (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "switched to layer ".concat(layerId));
    return true;
}
// --- Switcher panel -------------------------------------------------------
// The badge says *something* needs you; the panel says *which* layer. That
// split is why the badge can stay a stable count of layers rather than trying
// to describe tasks.
var $8896b37f0fd85895$var$closePanelOnOutside = null;
/** Is the panel currently open? */ function $8896b37f0fd85895$var$panelIsOpen() {
    var _document_getElementById;
    return !((_document_getElementById = document.getElementById('layer-panel')) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.classList.contains('hidden'));
}
/**
 * One row per layer, in ladder order.
 *
 * Locked layers are shown dimmed with a lock rather than hidden — a prestige
 * ladder should advertise what is ahead (spec open question 1). They render
 * from the same registry list, so a new layer appears here by existing.
 */ function $8896b37f0fd85895$var$renderLayerPanel() {
    var panel = document.getElementById('layer-panel');
    if (!panel) return;
    panel.replaceChildren();
    var activeId = (0, $cda2111f1d5bcde8$export$cdfede5cf3580bc3)();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var layer = _step.value;
            var unlocked = layer.unlocked();
            var isCurrent = layer.id === activeId;
            var task = unlocked ? (0, $cda2111f1d5bcde8$export$47888485123801c8)(layer.id) : {
                state: 'none',
                label: ''
            };
            var needsAttention = task.state === 'complete';
            var row = document.createElement('button');
            row.className = 'w-full flex items-center gap-2 px-2 py-2 mb-1 rounded-lg border-2 text-left ' + (unlocked ? 'hover:bg-white/10 ' : 'opacity-40 cursor-not-allowed ');
            row.disabled = !unlocked;
            row.dataset.layer = layer.id;
            // Current layer wears its own accent; a layer asking for attention is
            // outlined in the neutral alert colour so "needs you" never reads as an
            // identity. Everything else stays quiet.
            row.style.borderColor = needsAttention ? '#f59e0b' : isCurrent ? layer.accent : 'transparent';
            var icon = $8896b37f0fd85895$var$el('span', 'text-lg', unlocked ? layer.icon : "\uD83D\uDD12");
            var label = $8896b37f0fd85895$var$el('span', 'font-bold flex-1');
            label.textContent = layer.label;
            if (unlocked) label.style.color = isCurrent ? layer.accent : '#d1d5db';
            row.append(icon, label);
            if (needsAttention) row.appendChild($8896b37f0fd85895$var$el('span', 'text-[10px] font-bold px-2 py-0.5 rounded-full bg-amber-500 text-black whitespace-nowrap', task.label));
            else if (isCurrent) row.appendChild($8896b37f0fd85895$var$el('span', 'text-[10px] text-gray-500', 'here'));
            if (unlocked && !isCurrent) row.addEventListener('click', function() {
                $8896b37f0fd85895$export$9722d62d688a2b10();
                $8896b37f0fd85895$export$7e55ff4ad8ce9b5a(layer.id);
            });
            else if (isCurrent) row.addEventListener('click', $8896b37f0fd85895$export$9722d62d688a2b10);
            panel.appendChild(row);
        };
        for(var _iterator = (0, $cda2111f1d5bcde8$export$61f6a9c831786408)()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $8896b37f0fd85895$export$9f3f9ca9a516ab25() {
    var panel = document.getElementById('layer-panel');
    var anchor = document.getElementById('layer-switcher-btn');
    if (!panel || !anchor) return;
    $8896b37f0fd85895$var$renderLayerPanel();
    panel.classList.remove('hidden');
    var rect = anchor.getBoundingClientRect();
    panel.style.top = "".concat(rect.bottom + 8, "px");
    panel.style.left = "".concat(Math.max(8, rect.left), "px");
    // Deferred so the click that opened it does not immediately close it.
    $8896b37f0fd85895$var$closePanelOnOutside = function(e) {
        if (!panel.contains(e.target) && e.target !== anchor) $8896b37f0fd85895$export$9722d62d688a2b10();
    };
    setTimeout(function() {
        return document.addEventListener('click', $8896b37f0fd85895$var$closePanelOnOutside);
    }, 0);
    document.addEventListener('keydown', $8896b37f0fd85895$var$closeOnEscape);
}
function $8896b37f0fd85895$export$9722d62d688a2b10() {
    var panel = document.getElementById('layer-panel');
    if (!panel) return;
    panel.classList.add('hidden');
    if ($8896b37f0fd85895$var$closePanelOnOutside) {
        document.removeEventListener('click', $8896b37f0fd85895$var$closePanelOnOutside);
        $8896b37f0fd85895$var$closePanelOnOutside = null;
    }
    document.removeEventListener('keydown', $8896b37f0fd85895$var$closeOnEscape);
}
function $8896b37f0fd85895$var$closeOnEscape(e) {
    if (e.key === 'Escape') $8896b37f0fd85895$export$9722d62d688a2b10();
}
function $8896b37f0fd85895$export$c937970754507226() {
    if ($8896b37f0fd85895$var$panelIsOpen()) $8896b37f0fd85895$export$9722d62d688a2b10();
    else $8896b37f0fd85895$export$9f3f9ca9a516ab25();
}
function $8896b37f0fd85895$export$581d35409857f84f(tabName) {
    var _getLayer;
    if (!tabName) return;
    $8896b37f0fd85895$var$currentScreenTab = tabName;
    var layerId = (0, $cda2111f1d5bcde8$export$cdfede5cf3580bc3)();
    if ((_getLayer = (0, $cda2111f1d5bcde8$export$f5b74d0d242cec02)(layerId)) === null || _getLayer === void 0 ? void 0 : _getLayer.screens.some(function(s) {
        return s.tab === tabName;
    })) $8896b37f0fd85895$var$lastScreenByLayer.set(layerId, tabName);
}
function $8896b37f0fd85895$export$544b0f50b5799474() {
    var _document_querySelector_id, _document_querySelector, _getLayer_screens_, _getLayer;
    // Seed the current screen from the DOM. Safe here and only here: at boot
    // nothing is mid-animation, so `.tab-content.active` is the truth rather
    // than a lagging snapshot. Falls back to the layer's first screen.
    var active = (_document_querySelector = document.querySelector('.tab-content.active')) === null || _document_querySelector === void 0 ? void 0 : (_document_querySelector_id = _document_querySelector.id) === null || _document_querySelector_id === void 0 ? void 0 : _document_querySelector_id.replace(/-tab$/, '');
    $8896b37f0fd85895$export$581d35409857f84f(active || ((_getLayer = (0, $cda2111f1d5bcde8$export$f5b74d0d242cec02)((0, $cda2111f1d5bcde8$export$cdfede5cf3580bc3)())) === null || _getLayer === void 0 ? void 0 : (_getLayer_screens_ = _getLayer.screens[0]) === null || _getLayer_screens_ === void 0 ? void 0 : _getLayer_screens_.tab));
    $8896b37f0fd85895$export$5672aa0b2d188c2b();
    // Crossing the icon-only breakpoint changes structure, not just values.
    var wasNarrow = $8896b37f0fd85895$var$isNarrow();
    window.addEventListener('resize', function() {
        if ($8896b37f0fd85895$var$isNarrow() !== wasNarrow) {
            wasNarrow = $8896b37f0fd85895$var$isNarrow();
            $8896b37f0fd85895$export$5672aa0b2d188c2b();
        }
    });
}
// Exposed for the same reason the rest of the game's handlers are: inline
// onclick attributes and cross-module calls without an import cycle.
if (typeof window !== 'undefined') {
    window.renderLayerToolbar = $8896b37f0fd85895$export$5672aa0b2d188c2b;
    window.switchLayer = $8896b37f0fd85895$export$7e55ff4ad8ce9b5a;
    window.toggleLayerPanel = $8896b37f0fd85895$export$c937970754507226;
}


function $3f29ea4265abff3b$export$b127b30033aaeba9(event, room) {
    if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress || (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidCompleted) return;
    var content = document.getElementById('tooltip-content');
    if (!content) {
        console.error("content div missing");
        return;
    }
    if (room.type === 'blocked') return '';
    if (room.type === 'start' || room.type === 'exit') content.innerHTML = "\n            <h5>".concat(room.type === 'start' ? "\uD83C\uDF00 Entry Portal" : "\uD83C\uDF0C Exit Portal", "</h5>\n            <div>").concat(room.type === 'start' ? 'Your team enters here' : 'Your team exits here', "</div>\n        ");
    else if (room.type === 'campsite') content.innerHTML = "\n            <h5>\uD83C\uDFD5\uFE0F ".concat(room.name, '</h5>\n            <div class="tooltip-skills">\n                <div style="color: #6bcf7f; margin-bottom: 8px;">\n                    <strong>Safe Zone</strong> - Team heals ').concat(room.healingAmount || 30, " HP and uses consumables\n                </div>\n            </div>\n        ");
    else if (room.type === 'road') content.innerHTML = "\n            <h5>".concat(room.name, '</h5>\n            <div class="tooltip-skills">\n                Allows the team to travel faster\n            </div>\n        ');
    else {
        var teamSkills = (0, $1249ab814b7054d4$export$bf19dc1273cbd1a1)();
        var skillStatus = (0, $1249ab814b7054d4$export$7e86a2006a620b57)(room, teamSkills);
        var primarySkillName = (0, $ca7af38ea7b7b4a8$export$182937d2e68a339)(room.primary);
        var supportSkillNames = room.support.map(function(skill) {
            return "\uD83D\uDD27 " + (0, $ca7af38ea7b7b4a8$export$182937d2e68a339)(skill);
        }).join('<br/>');
        var skillsHTML = room.primary ? "\n                \u2B50 ".concat(primarySkillName, "<br/>\n                ").concat(room.support.length > 0 ? "".concat(supportSkillNames) : '', '<br/>\n                <div class="mt-1" style="color: ').concat(skillStatus.indicator === 'covered' ? '#6bcf7f' : skillStatus.indicator === 'partial' ? '#ffa502' : '#ff4757', '">\n                    ').concat(skillStatus.symbol, " ").concat(skillStatus.indicator === 'covered' ? 'Fully Covered' : skillStatus.indicator === 'partial' ? 'Support Missing' : 'Primary Missing', "\n                </div>\n        ") : '<strong>No skills used</strong>';
        content.innerHTML = "\n            <h5>".concat(room.name, '</h5>\n            <div class="tooltip-skills">\n                ').concat(skillsHTML, "    \n            </div>\n        ");
    }
    var tooltip = document.getElementById('room-tooltip');
    if (tooltip) tooltip.classList.remove('hidden');
    $3f29ea4265abff3b$export$7fa52bbeeb0b31af(event);
}
function $3f29ea4265abff3b$export$a23289342bf715b2() {
    var tooltip = document.getElementById('room-tooltip');
    if (tooltip) tooltip.classList.add('hidden');
}
function $3f29ea4265abff3b$export$7fa52bbeeb0b31af(event) {
    var tooltip = document.getElementById('room-tooltip');
    if (!tooltip) return;
    var offset = 30;
    var height = tooltip.offsetHeight; // real: showRoomTooltip un-hides before positioning
    var flipAbove = window.innerHeight - (event.clientY + offset) < height;
    var top = flipAbove ? event.pageY - offset - height : event.pageY + offset;
    tooltip.style.left = event.pageX + offset + 'px';
    // Clamped so a tooltip taller than the space above it lands on screen
    // rather than off the top of the page.
    tooltip.style.top = Math.max(window.scrollY + offset, top) + 'px';
}
function $3f29ea4265abff3b$export$1ed604ed32abca42(skillKey) {
    if (!(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid) return;
    // Clear existing skill highlights
    document.querySelectorAll('.grid-cell').forEach(function(cell) {
        cell.classList.remove('skill-highlight');
    });
    if (!skillKey) return;
    // Highlight rooms that use this skill
    for(var row = 0; row < (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid.size; row++)for(var col = 0; col < (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid.size; col++){
        var room = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid.grid[row][col];
        if (room.type !== 'start' && room.type !== 'exit') {
            var usesSkill = room.primary === skillKey || room.support.includes(skillKey);
            if (usesSkill) {
                var cell = document.querySelector('[data-row="'.concat(row, '"][data-col="').concat(col, '"]'));
                if (cell) cell.classList.add('skill-highlight');
            }
        }
    }
}
// ============================================================================
// ITEM-DROP HIGHLIGHT (raid planning)
// ============================================================================
// Transient, planning-only UI state — NOT persisted (kept out of the saved
// gameState.currentRaid). gridLootIndex is rebuilt per generated grid.
var $3f29ea4265abff3b$var$gridLootIndex = null;
var $3f29ea4265abff3b$var$highlightedItemIds = new Set(); // multi-select: rooms show a badge per match
var $3f29ea4265abff3b$var$itemPickerWired = false;
var $3f29ea4265abff3b$var$MAX_BADGE_ICONS = 3; // beyond this the badge shows "+N"
function $3f29ea4265abff3b$var$itemIconFor(id) {
    var _findItem;
    return id === 'Fish' ? "\uD83D\uDC1F" : ((_findItem = (0, $ca7af38ea7b7b4a8$export$a2dea178c28a0308)('id', id)) === null || _findItem === void 0 ? void 0 : _findItem.icon) || "\u2753";
}
function $3f29ea4265abff3b$var$itemNameFor(id) {
    return id === 'Fish' ? 'Fish' : (0, $ca7af38ea7b7b4a8$export$31330438f6059b08)(id);
}
function $3f29ea4265abff3b$export$d72ea71bfd67dd40() {
    var select = document.getElementById('item-highlight-picker');
    if (!select || !(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid) return;
    if (!$3f29ea4265abff3b$var$gridLootIndex) $3f29ea4265abff3b$var$gridLootIndex = (0, $52a7294453bdb6d1$export$433f18e5bfab36e1)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid);
    if (!$3f29ea4265abff3b$var$itemPickerWired) {
        select.addEventListener('change', function(e) {
            var id = e.target.value;
            if (id) $3f29ea4265abff3b$var$highlightedItemIds.add(id);
            e.target.value = '';
            $3f29ea4265abff3b$var$renderItemChips();
            $3f29ea4265abff3b$var$renderItemBadges();
        });
        $3f29ea4265abff3b$var$itemPickerWired = true;
    }
    var html = '<option value="">\u2014 Add items \u2014</option>';
    var groups = new Map(); // rarity -> items[] (items already sorted by rarity then name)
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $3f29ea4265abff3b$var$gridLootIndex.items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var it = _step.value;
            if (!groups.has(it.rarity)) groups.set(it.rarity, []);
            groups.get(it.rarity).push(it);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = groups[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var _step_value = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step1.value, 2), rarity = _step_value[0], items = _step_value[1];
            var _config_itemRarities_rarity, _config_itemRarities;
            var label = rarity === 'special' ? 'Special' : ((_config_itemRarities = $979b99378be707cd$export$d4a72d069095e9e5) === null || _config_itemRarities === void 0 ? void 0 : (_config_itemRarities_rarity = _config_itemRarities[rarity]) === null || _config_itemRarities_rarity === void 0 ? void 0 : _config_itemRarities_rarity.name) || rarity;
            html += '<optgroup label="'.concat(label, '">');
            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
            try {
                for(var _iterator2 = items[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                    var it1 = _step2.value;
                    // Relics aren't recipe components (sell-for-credits only) — skip
                    if (it1.type === "relic") continue;
                    html += '<option value="'.concat(it1.id, '">').concat($3f29ea4265abff3b$var$itemIconFor(it1.id), " ").concat($3f29ea4265abff3b$var$itemNameFor(it1.id).replace(/Blueprint/g, "").trim(), " (").concat(it1.count, ")</option>");
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                        _iterator2.return();
                    }
                } finally{
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
            html += '</optgroup>';
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    select.innerHTML = html;
    select.value = '';
    select.classList.remove('hidden');
    $3f29ea4265abff3b$var$renderItemChips();
    $3f29ea4265abff3b$export$ec61d7059805f99b(); // the skill filter shares the same grid/lifecycle
}
// Removable chips beside the picker showing the active item filters.
function $3f29ea4265abff3b$var$renderItemChips() {
    var box = document.getElementById('item-highlight-chips');
    if (!box) return;
    if ($3f29ea4265abff3b$var$highlightedItemIds.size === 0) {
        box.innerHTML = '';
        return;
    }
    box.innerHTML = (0, $4c858c0d999a5b9b$export$71511d61b312f219)($3f29ea4265abff3b$var$highlightedItemIds).map(function(id) {
        return '<span class="item-filter-chip h-6" title="'.concat($3f29ea4265abff3b$var$itemNameFor(id), '">\n            <span>').concat($3f29ea4265abff3b$var$itemIconFor(id), '</span>\n            <span class="item-filter-chip-x" onclick="removeHighlightItem(\'').concat(id, "')\">\xd7</span>\n        </span>");
    }).join('');
    box.classList.remove('hidden');
}
// Draw a bottom-right badge on every room that can drop one or more of the
// selected items: up to MAX_BADGE_ICONS icons, then a "+N" counter.
function $3f29ea4265abff3b$var$renderItemBadges() {
    document.querySelectorAll('.item-drop-badge').forEach(function(b) {
        return b.remove();
    });
    if ($3f29ea4265abff3b$var$highlightedItemIds.size === 0 || !$3f29ea4265abff3b$var$gridLootIndex) return;
    var perCell = new Map(); // "row,col" -> [icons] (selection order)
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $3f29ea4265abff3b$var$highlightedItemIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var id = _step.value;
            var icon = $3f29ea4265abff3b$var$itemIconFor(id);
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = ($3f29ea4265abff3b$var$gridLootIndex.itemToCells.get(id) || [])[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var _step_value = _step1.value, row = _step_value.row, col = _step_value.col;
                    var key = "".concat(row, ",").concat(col);
                    if (!perCell.has(key)) perCell.set(key, []);
                    perCell.get(key).push(icon);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
    try {
        for(var _iterator2 = perCell[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var _step_value1 = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step2.value, 2), key1 = _step_value1[0], icons = _step_value1[1];
            var _key_split = (0, $1788e2ed61915b1e$export$71511d61b312f219)(key1.split(','), 2), row1 = _key_split[0], col1 = _key_split[1];
            var cell = document.querySelector('[data-row="'.concat(row1, '"][data-col="').concat(col1, '"]'));
            if (!cell) continue;
            var shown = icons.slice(0, $3f29ea4265abff3b$var$MAX_BADGE_ICONS);
            var extra = icons.length - shown.length;
            var badge = document.createElement('div');
            badge.className = 'item-drop-badge';
            badge.innerHTML = shown.map(function(ic) {
                return "<span>".concat(ic, "</span>");
            }).join('') + (extra > 0 ? '<span class="item-drop-more">+'.concat(extra, "</span>") : '');
            cell.appendChild(badge);
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
            }
        } finally{
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }
}
function $3f29ea4265abff3b$export$edb541e336ea9a21() {
    if ($3f29ea4265abff3b$var$highlightedItemIds.size > 0) $3f29ea4265abff3b$var$renderItemBadges();
    if ($3f29ea4265abff3b$var$highlightedSkillIds.size > 0) $3f29ea4265abff3b$var$renderSkillBadges();
}
function $3f29ea4265abff3b$export$a2d78d1f68010f97() {
    if ($3f29ea4265abff3b$var$highlightedItemIds.size === 0 || !$3f29ea4265abff3b$var$gridLootIndex) return null;
    var wanted = new Set();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator = $3f29ea4265abff3b$var$highlightedItemIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
            var id = _step.value;
            try {
                for(var _iterator1 = ($3f29ea4265abff3b$var$gridLootIndex.itemToCells.get(id) || [])[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = _step1.value, row = _step_value.row, col = _step_value.col;
                    wanted.add("".concat(row, ",").concat(col));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return wanted.size > 0 ? wanted : null;
}
// Remove one item from the filter (chip × handler).
function $3f29ea4265abff3b$var$removeHighlightItem(id) {
    $3f29ea4265abff3b$var$highlightedItemIds.delete(id);
    $3f29ea4265abff3b$var$renderItemChips();
    $3f29ea4265abff3b$var$renderItemBadges();
}
window.removeHighlightItem = $3f29ea4265abff3b$var$removeHighlightItem;
// Clear all item highlights (Clear button), keeping the picker populated.
function $3f29ea4265abff3b$var$clearItemHighlight() {
    $3f29ea4265abff3b$var$highlightedItemIds.clear();
    $3f29ea4265abff3b$var$renderItemChips();
    $3f29ea4265abff3b$var$renderItemBadges();
}
window.clearItemHighlight = $3f29ea4265abff3b$var$clearItemHighlight;
function $3f29ea4265abff3b$export$6c9e89b1ffed34d7() {
    $3f29ea4265abff3b$var$gridLootIndex = null;
    $3f29ea4265abff3b$var$highlightedItemIds = new Set();
    var select = document.getElementById('item-highlight-picker');
    if (select) select.value = '';
    var chips = document.getElementById('item-highlight-chips');
    if (chips) chips.innerHTML = '';
    document.querySelectorAll('.item-drop-badge').forEach(function(b) {
        return b.remove();
    });
    $3f29ea4265abff3b$export$59cebfb19ddd1f77(); // both room-highlight filters clear together
}
// ============================================================================
// SKILL HIGHLIGHT — mirrors the item highlight above but keys on the skills a
// room uses (primary + support). Rooms get a SEPARATE badge row of skill icons.
// ============================================================================
var $3f29ea4265abff3b$var$gridSkillIndex = null; // { skillToCells: Map<skillId, cells[]>, skills: skillId[] }
var $3f29ea4265abff3b$var$highlightedSkillIds = new Set();
var $3f29ea4265abff3b$var$skillPickerWired = false;
function $3f29ea4265abff3b$var$buildGridSkillIndex(gridData) {
    var skillToCells = new Map();
    if (!gridData || !gridData.grid) return {
        skillToCells: skillToCells,
        skills: []
    };
    var rows = gridData.rows || gridData.grid.length;
    var cols = gridData.cols || (gridData.grid[0] ? gridData.grid[0].length : 0);
    for(var row = 0; row < rows; row++)for(var col = 0; col < cols; col++){
        var _gridData_grid_row;
        var room = (_gridData_grid_row = gridData.grid[row]) === null || _gridData_grid_row === void 0 ? void 0 : _gridData_grid_row[col];
        if (!room || room.type === 'blocked') continue;
        var skills = [
            room.primary
        ].concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)(room.support || [])).filter(Boolean);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = new Set(skills)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var s = _step.value;
                var cells = skillToCells.get(s);
                if (!cells) {
                    cells = [];
                    skillToCells.set(s, cells);
                }
                cells.push({
                    row: row,
                    col: col
                });
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    var skills1 = (0, $4c858c0d999a5b9b$export$71511d61b312f219)(skillToCells.keys()).sort(function(a, b) {
        return (0, $ca7af38ea7b7b4a8$export$182937d2e68a339)(a).localeCompare((0, $ca7af38ea7b7b4a8$export$182937d2e68a339)(b));
    });
    return {
        skillToCells: skillToCells,
        skills: skills1
    };
}
function $3f29ea4265abff3b$export$ec61d7059805f99b() {
    var select = document.getElementById('skill-highlight-picker');
    if (!select || !(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid) return;
    if (!$3f29ea4265abff3b$var$gridSkillIndex) $3f29ea4265abff3b$var$gridSkillIndex = $3f29ea4265abff3b$var$buildGridSkillIndex((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid);
    if (!$3f29ea4265abff3b$var$skillPickerWired) {
        select.addEventListener('change', function(e) {
            var id = e.target.value;
            if (id) $3f29ea4265abff3b$var$highlightedSkillIds.add(id);
            e.target.value = '';
            $3f29ea4265abff3b$var$renderSkillChips();
            $3f29ea4265abff3b$var$renderSkillBadges();
        });
        $3f29ea4265abff3b$var$skillPickerWired = true;
    }
    var html = '<option value="">\u2014 Add skills \u2014</option>';
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $3f29ea4265abff3b$var$gridSkillIndex.skills[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var s = _step.value;
            html += '<option value="'.concat(s, '">').concat((0, $ca7af38ea7b7b4a8$export$8a18dddc0824814c)(s), " ").concat((0, $ca7af38ea7b7b4a8$export$182937d2e68a339)(s), " (").concat($3f29ea4265abff3b$var$gridSkillIndex.skillToCells.get(s).length, ")</option>");
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    select.innerHTML = html;
    select.value = '';
    select.classList.remove('hidden');
    $3f29ea4265abff3b$var$renderSkillChips();
}
function $3f29ea4265abff3b$var$renderSkillChips() {
    var box = document.getElementById('skill-highlight-chips');
    if (!box) return;
    if ($3f29ea4265abff3b$var$highlightedSkillIds.size === 0) {
        box.innerHTML = '';
        return;
    }
    box.innerHTML = (0, $4c858c0d999a5b9b$export$71511d61b312f219)($3f29ea4265abff3b$var$highlightedSkillIds).map(function(id) {
        return '<span class="item-filter-chip h-6" title="'.concat((0, $ca7af38ea7b7b4a8$export$182937d2e68a339)(id), '">\n            <span>').concat((0, $ca7af38ea7b7b4a8$export$8a18dddc0824814c)(id), '</span>\n            <span class="item-filter-chip-x" onclick="removeHighlightSkill(\'').concat(id, "')\">\xd7</span>\n        </span>");
    }).join('');
}
// A separate badge row (skill icons) on each room that uses a selected skill,
// stacked below the item-drop badge so the two categories stay visually apart.
function $3f29ea4265abff3b$var$renderSkillBadges() {
    document.querySelectorAll('.skill-mark-badge').forEach(function(b) {
        return b.remove();
    });
    if ($3f29ea4265abff3b$var$highlightedSkillIds.size === 0 || !$3f29ea4265abff3b$var$gridSkillIndex) return;
    var perCell = new Map();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $3f29ea4265abff3b$var$highlightedSkillIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var id = _step.value;
            var icon = (0, $ca7af38ea7b7b4a8$export$8a18dddc0824814c)(id);
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = ($3f29ea4265abff3b$var$gridSkillIndex.skillToCells.get(id) || [])[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var _step_value = _step1.value, row = _step_value.row, col = _step_value.col;
                    var key = "".concat(row, ",").concat(col);
                    if (!perCell.has(key)) perCell.set(key, []);
                    perCell.get(key).push(icon);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
    try {
        for(var _iterator2 = perCell[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var _step_value1 = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step2.value, 2), key1 = _step_value1[0], icons = _step_value1[1];
            var _key_split = (0, $1788e2ed61915b1e$export$71511d61b312f219)(key1.split(','), 2), row1 = _key_split[0], col1 = _key_split[1];
            var cell = document.querySelector('[data-row="'.concat(row1, '"][data-col="').concat(col1, '"]'));
            if (!cell) continue;
            var shown = icons.slice(0, $3f29ea4265abff3b$var$MAX_BADGE_ICONS);
            var extra = icons.length - shown.length;
            var badge = document.createElement('div');
            badge.className = 'skill-mark-badge';
            badge.innerHTML = shown.map(function(ic) {
                return "<span>".concat(ic, "</span>");
            }).join('') + (extra > 0 ? '<span class="item-drop-more">+'.concat(extra, "</span>") : '');
            cell.appendChild(badge);
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
            }
        } finally{
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }
}
function $3f29ea4265abff3b$var$removeHighlightSkill(id) {
    $3f29ea4265abff3b$var$highlightedSkillIds.delete(id);
    $3f29ea4265abff3b$var$renderSkillChips();
    $3f29ea4265abff3b$var$renderSkillBadges();
}
window.removeHighlightSkill = $3f29ea4265abff3b$var$removeHighlightSkill;
// Clear all skill highlights (Clear button), keeping the picker populated.
function $3f29ea4265abff3b$var$clearSkillHighlight() {
    $3f29ea4265abff3b$var$highlightedSkillIds.clear();
    $3f29ea4265abff3b$var$renderSkillChips();
    $3f29ea4265abff3b$var$renderSkillBadges();
}
window.clearSkillHighlight = $3f29ea4265abff3b$var$clearSkillHighlight;
function $3f29ea4265abff3b$export$59cebfb19ddd1f77() {
    $3f29ea4265abff3b$var$gridSkillIndex = null;
    $3f29ea4265abff3b$var$highlightedSkillIds = new Set();
    var select = document.getElementById('skill-highlight-picker');
    if (select) select.value = '';
    var chips = document.getElementById('skill-highlight-chips');
    if (chips) chips.innerHTML = '';
    document.querySelectorAll('.skill-mark-badge').forEach(function(b) {
        return b.remove();
    });
}
// ============================================================================
// RAID PANEL TABS (Log | Loot) — the middle panel next to the map
// ============================================================================
var $3f29ea4265abff3b$var$activeRaidPanelTab = 'highlights';
function $3f29ea4265abff3b$export$a21eeedead301a30(name) {
    $3f29ea4265abff3b$var$activeRaidPanelTab = name;
    var panes = {
        highlights: document.getElementById('raid-highlights-pane'),
        log: document.getElementById('path-rooms'),
        loot: document.getElementById('raid-loot-pane'),
        team: document.getElementById('raid-team-pane')
    };
    Object.entries(panes).forEach(function(param) {
        var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), key = _param[0], el = _param[1];
        el === null || el === void 0 ? void 0 : el.classList.toggle('hidden', key !== name);
    });
    document.querySelectorAll('.raid-panel-tabs .char-subtab-btn').forEach(function(btn) {
        var on = btn.dataset.raidTab === name;
        btn.classList.toggle('active', on);
        btn.classList.toggle('bg-gradient-to-r', on);
        btn.classList.toggle('from-gray-700', on);
        btn.classList.toggle('to-gray-600', on);
    });
    if (name === 'log') {
        // scrollIntoView no-ops while the pane is display:none — re-sync now
        $3f29ea4265abff3b$export$f4fa7fe8ae486c6();
        $3f29ea4265abff3b$export$3de9c504cadcc6ea();
    } else if (name === 'loot') $3f29ea4265abff3b$export$cc4a7a45a09f1743();
    else if (name === 'highlights') $3f29ea4265abff3b$export$d72ea71bfd67dd40(); // refresh both filter pickers from the current grid
}
window.setRaidPanelTab = $3f29ea4265abff3b$export$a21eeedead301a30;
// Expand/collapse overrides for loot-tab cards (collapsed is the default).
// The pane re-renders on every loot change, so toggle state must live outside
// the DOM — same pattern as the gear tab's toggleGearExpand.
var $3f29ea4265abff3b$var$lootCardExpanded = new Set();
var $3f29ea4265abff3b$var$lastLootSignature = null;
function $3f29ea4265abff3b$var$toggleLootCardExpand(itemId) {
    if ($3f29ea4265abff3b$var$lootCardExpanded.has(itemId)) $3f29ea4265abff3b$var$lootCardExpanded.delete(itemId);
    else $3f29ea4265abff3b$var$lootCardExpanded.add(itemId);
    $3f29ea4265abff3b$var$lastLootSignature = null; // content unchanged, but the view must redraw
    $3f29ea4265abff3b$export$cc4a7a45a09f1743();
}
window.toggleLootCardExpand = $3f29ea4265abff3b$var$toggleLootCardExpand;
function $3f29ea4265abff3b$export$d955e43ec94b6b38() {
    $3f29ea4265abff3b$var$lootCardExpanded = new Set();
    $3f29ea4265abff3b$var$lastLootSignature = null;
}
function $3f29ea4265abff3b$export$cc4a7a45a09f1743() {
    var _window_reinitializeInventoryTooltips, _window;
    var pane = document.getElementById('raid-loot-pane');
    if (!pane) return;
    var raid = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress;
    var completed = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidCompleted ? (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.completedRaidInfo : null;
    var _raid_lootGained, _ref;
    var lootGained = (_ref = (_raid_lootGained = raid === null || raid === void 0 ? void 0 : raid.lootGained) !== null && _raid_lootGained !== void 0 ? _raid_lootGained : completed === null || completed === void 0 ? void 0 : completed.lootGained) !== null && _ref !== void 0 ? _ref : null;
    var failed = !raid && completed && completed.raidSuccess === false;
    // Skip the redraw when nothing changed — the 1Hz raid tick would
    // otherwise wipe expand toggles and open tooltips every second
    var signature = JSON.stringify([
        lootGained,
        failed
    ]);
    if (signature === $3f29ea4265abff3b$var$lastLootSignature) return;
    $3f29ea4265abff3b$var$lastLootSignature = signature;
    if (!lootGained || Object.keys(lootGained).length === 0) {
        pane.innerHTML = '<p class="placeholder-text mt-2">Nothing collected yet.</p>';
        return;
    }
    var credits = lootGained.Credits || 0;
    var html = '\n        <div class="flex items-center gap-2 my-2 text-yellow-300 font-bold">\n            \uD83D\uDCB0 Credits earned: '.concat(credits.toLocaleString(), "\n        </div>");
    if (failed) html += '<div class="text-red-400 text-sm mb-2">Raid failed \u2014 recovered items were lost. Credits are kept.</div>';
    // Sort by rarity ascending, then item name ascending; Fish (no catalog
    // entry) sorts last
    var rarityOrder = function(r) {
        var _config_itemRarities_r, _config_itemRarities;
        var _config_itemRarities_r_order;
        return (_config_itemRarities_r_order = (_config_itemRarities = $979b99378be707cd$export$d4a72d069095e9e5) === null || _config_itemRarities === void 0 ? void 0 : (_config_itemRarities_r = _config_itemRarities[r]) === null || _config_itemRarities_r === void 0 ? void 0 : _config_itemRarities_r.order) !== null && _config_itemRarities_r_order !== void 0 ? _config_itemRarities_r_order : 99;
    };
    var entries = Object.entries(lootGained).filter(function(param) {
        var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), id = _param[0], qty = _param[1];
        return id !== 'Credits' && qty;
    }).map(function(param) {
        var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), id = _param[0], qty = _param[1];
        if (id === 'Fish') return {
            id: id,
            qty: qty,
            order: 100,
            name: 'Fish',
            fish: true
        };
        var item = (0, $ca7af38ea7b7b4a8$export$a2dea178c28a0308)('id', id);
        return item ? {
            id: id,
            qty: qty,
            item: item,
            order: rarityOrder(item.rarity),
            name: item.name
        } : null;
    }).filter(Boolean).sort(function(a, b) {
        return a.order - b.order || a.name.localeCompare(b.name);
    });
    var cards = entries.map(function(e) {
        if (e.fish) return '\n                <div class="inv-card inv-card-collapsed relative rounded-lg border border-gray-600 bg-gray-800 px-3 py-2">\n                    <div class="flex items-center">\n                        <span class="font-bold text-gray-100 text-xs tracking-tighter">Fish</span>\n                        <span class="ml-1 text-sm leading-none" title="Camp rations \u2014 eaten at campsites, never banked">\uD83D\uDC1F</span>\n                    </div>\n                    <div class="mt-2">\n                        <div class="bg-gray-700 text-gray-100 px-2 py-1 rounded-full text-xs font-bold border border-gray-500 inline-block">\xd7'.concat(e.qty, "</div>\n                    </div>\n                </div>");
        // Collapsed by default; player toggles are tracked in lootCardExpanded
        // so they survive the re-render (retarget the chevron like gear.js)
        var cardHtml = (0, $a575049a7e5cb3a1$export$4ac7f915da1fa1c4)((0, $715bf31211e65705$export$71511d61b312f219)((0, $fa9769297b8a68c8$export$71511d61b312f219)({}, e.item), {
            quantity: e.qty
        }), 'inventory', null, null, {
            hideActions: true,
            collapsed: !$3f29ea4265abff3b$var$lootCardExpanded.has(e.id)
        });
        return cardHtml.replaceAll('toggleInventoryCardCollapse(this);', "toggleLootCardExpand('".concat(e.id, "');"));
    });
    html += '\n        <div class="grid gap-2 '.concat(failed ? 'opacity-50' : '', '" style="grid-template-columns: repeat(auto-fit, 10rem); justify-content: center;">\n            ').concat(cards.map(function(c) {
        return '<div class="relative">'.concat(c, "</div>");
    }).join(''), "\n        </div>");
    pane.innerHTML = html;
    (_window_reinitializeInventoryTooltips = (_window = window).reinitializeInventoryTooltips) === null || _window_reinitializeInventoryTooltips === void 0 ? void 0 : _window_reinitializeInventoryTooltips.call(_window);
}
function $3f29ea4265abff3b$export$f2a0cf624bd292ab(row, col) {
    // Prevent path modification when raid is in progress or completed
    if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress || (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidCompleted) return;
    var gridData = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid;
    if (gridData) {
        var room = gridData.grid[row][col];
        // Handle path selection
        var isAlreadyInPath = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath.some(function(p) {
            return p.row === row && p.col === col;
        });
        if (isAlreadyInPath) {
            // Prevent unselecting the start room
            if (gridData.startPos && row === gridData.startPos.row && col === gridData.startPos.col) return;
            // Remove this room and all rooms after it from the path
            var index = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath.findIndex(function(p) {
                return p.row === row && p.col === col;
            });
            (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath.slice(0, index);
        } else {
            // Add to path if it's a valid next step
            if ((0, $1249ab814b7054d4$export$2a6c93141872f156)(row, col)) (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath.push({
                row: row,
                col: col,
                room: room
            });
            else // Provide specific feedback for different invalid move types
            if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath.length === 0) $3f29ea4265abff3b$export$b15c046faf64b0d4("Start your path by clicking the entry portal (\uD83C\uDF00)");
            else {
                var gridData1 = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid;
                var lastPos = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath[(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath.length - 1];
                var lastRoom = gridData1.grid[lastPos.row][lastPos.col];
                // Check if path already ends at exit
                if (lastRoom.type === 'exit') $3f29ea4265abff3b$export$b15c046faf64b0d4("Path complete! You've reached the exit portal \uD83C\uDF0C");
                else {
                    var maxPathLength = (gridData1.rows || gridData1.size) + (gridData1.cols || gridData1.size) - 1;
                    var currentStepCount = (0, $1249ab814b7054d4$export$aedd9bb9e278a90a)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath);
                    // Check if path has reached maximum length (excluding roads)
                    if (currentStepCount >= maxPathLength) $3f29ea4265abff3b$export$b15c046faf64b0d4("Path too long! Maximum length is ".concat(maxPathLength, " rooms (roads don't count)"));
                    else // Default adjacency message
                    $3f29ea4265abff3b$export$b15c046faf64b0d4('You can only move to adjacent rooms (up, down, left, right)');
                }
            }
        }
        $3f29ea4265abff3b$export$f4fa7fe8ae486c6();
        $3f29ea4265abff3b$export$c9b7157fc13410c5(); // Update room count in grid header
        $3f29ea4265abff3b$export$ed4907da7d4af889();
        $3f29ea4265abff3b$export$25fc6ae0ff69cc();
        $3f29ea4265abff3b$export$96635d91a6ab659a(); // Update energy/cooldown info
        $3f29ea4265abff3b$var$debouncedHighlightValidMoves();
        // Update contractor status indicators when path changes
        if ((0, $da6f71b8677b901e$export$2e2bcd8739ae039).store('contractors')) (0, $da6f71b8677b901e$export$2e2bcd8739ae039).store('contractors').updateContractorStatuses();
        (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
    }
}
function $3f29ea4265abff3b$export$b15c046faf64b0d4(message) {
    // Create or update a temporary message display
    var messageDiv = document.getElementById('path-message');
    if (!messageDiv) {
        messageDiv = document.createElement('div');
        messageDiv.id = 'path-message';
        messageDiv.className = 'fixed top-5 right-5 bg-red-500/90 text-white px-4 py-2 rounded z-50 text-sm max-w-xs animate__animated';
        document.body.appendChild(messageDiv);
    }
    messageDiv.textContent = message;
    // Reset animation classes and trigger entrance animation
    messageDiv.classList.remove('hidden', 'animate__slideOutRight');
    messageDiv.classList.add('animate__slideInRight');
    // Auto-hide after 3 seconds with exit animation
    setTimeout(function() {
        if (messageDiv) {
            messageDiv.classList.remove('animate__slideInRight');
            messageDiv.classList.add('animate__slideOutRight');
            // Hide after animation completes
            setTimeout(function() {
                if (messageDiv) messageDiv.classList.add('hidden');
            }, 500);
        }
    }, 3000);
}
var $3f29ea4265abff3b$var$currentCalculationId = 0;
function $3f29ea4265abff3b$export$c3f865504cdad6c4() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var myCalculationId, gridData, lastPos, lastRoom, _loop, row, maxPathLength, currentStepCount, remainingSteps, startCell, lastPos1, atMaxSteps, adjacentPositions;
        return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, 'Highlighting valid moves...');
                    // Cancel any pending dim calculation
                    $3f29ea4265abff3b$var$currentCalculationId++;
                    myCalculationId = $3f29ea4265abff3b$var$currentCalculationId;
                    (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, 'Starting new dim calculation ' + myCalculationId);
                    // Remove existing valid move highlights only (keep dimming until new calculation finishes)
                    document.querySelectorAll('.grid-cell').forEach(function(cell) {
                        cell.classList.remove('valid-move');
                    });
                    gridData = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid;
                    if (!gridData) return [
                        2
                    ];
                    // If path already ends at exit, dim all non-path rooms
                    if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath.length > 0) {
                        lastPos = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath[(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath.length - 1];
                        lastRoom = gridData.grid[lastPos.row][lastPos.col];
                        if (lastRoom.type === 'exit') {
                            _loop = function(row) {
                                var _loop = function(col) {
                                    var isInPath = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath.some(function(p) {
                                        return p.row === row && p.col === col;
                                    });
                                    if (!isInPath) {
                                        var cell = document.querySelector('[data-row="'.concat(row, '"][data-col="').concat(col, '"]'));
                                        if (cell) cell.classList.add('raid-dimmed');
                                    }
                                };
                                for(var col = 0; col < (gridData.cols || gridData.size); col++)_loop(col);
                            };
                            // Path is complete, dim all rooms not in the path
                            for(row = 0; row < (gridData.rows || gridData.size); row++)_loop(row);
                            return [
                                2
                            ]; // No need to process further
                        }
                    }
                    // Calculate path constraints
                    maxPathLength = (gridData.rows || gridData.size) + (gridData.cols || gridData.size) - 1;
                    currentStepCount = (0, $1249ab814b7054d4$export$aedd9bb9e278a90a)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath);
                    remainingSteps = maxPathLength - currentStepCount;
                    // Debug logging
                    (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "Dimming calculation: maxPathLength=".concat(maxPathLength, ", currentStepCount=").concat(currentStepCount, ", remainingSteps=").concat(remainingSteps));
                    if (!((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath.length === 0)) return [
                        3,
                        2
                    ];
                    // Highlight start position
                    startCell = document.querySelector('[data-row="'.concat(gridData.startPos.row, '"][data-col="').concat(gridData.startPos.col, '"]'));
                    if (startCell) startCell.classList.add('valid-move');
                    // Dim rooms that are too far from start to be reachable within path limits
                    return [
                        4,
                        $3f29ea4265abff3b$export$e39f4236aa572c6a(gridData, gridData.startPos, remainingSteps, myCalculationId)
                    ];
                case 1:
                    _state.sent();
                    return [
                        3,
                        4
                    ];
                case 2:
                    // Highlight adjacent cells from current position
                    lastPos1 = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath[(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath.length - 1];
                    atMaxSteps = currentStepCount >= maxPathLength;
                    adjacentPositions = [
                        {
                            row: lastPos1.row - 1,
                            col: lastPos1.col
                        },
                        {
                            row: lastPos1.row + 1,
                            col: lastPos1.col
                        },
                        {
                            row: lastPos1.row,
                            col: lastPos1.col - 1
                        },
                        {
                            row: lastPos1.row,
                            col: lastPos1.col + 1
                        } // Right
                    ];
                    adjacentPositions.forEach(function(pos) {
                        // Check if position is within grid bounds
                        if (pos.row >= 0 && pos.row < (gridData.rows || gridData.size) && pos.col >= 0 && pos.col < (gridData.cols || gridData.size)) {
                            // Check if position is not already in path
                            var isInPath = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath.some(function(p) {
                                return p.row === pos.row && p.col === pos.col;
                            });
                            if (!isInPath) {
                                var room = gridData.grid[pos.row][pos.col];
                                // If at max steps, only highlight exit portal
                                if (atMaxSteps && room && room.type !== 'exit') return; // Skip highlighting non-exit cells
                                var cell = document.querySelector('[data-row="'.concat(pos.row, '"][data-col="').concat(pos.col, '"]'));
                                if (cell) cell.classList.add('valid-move');
                            }
                        }
                    });
                    // Dim rooms that are unreachable from current position within remaining path limits
                    return [
                        4,
                        $3f29ea4265abff3b$export$e39f4236aa572c6a(gridData, lastPos1, remainingSteps, myCalculationId)
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        2
                    ];
            }
        });
    })();
}
// Create debounced version once to reuse
var $3f29ea4265abff3b$var$debouncedHighlightValidMoves = (0, $ca7af38ea7b7b4a8$export$61fc7d43ac8f84b0)($3f29ea4265abff3b$export$c3f865504cdad6c4, 250);
function $3f29ea4265abff3b$export$e39f4236aa572c6a(gridData, currentPos, remainingSteps, calculationId) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var _loop, exitPos, cellsToCheck, row, result, dimmedCells, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, row1, col, cell;
        return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _loop = function(row) {
                        var _loop = function(col) {
                            var room = gridData.grid[row][col];
                            var isInPath = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath.some(function(p) {
                                return p.row === row && p.col === col;
                            });
                            if (!isInPath && room && room.type !== 'blocked') cellsToCheck.push({
                                row: row,
                                col: col,
                                room: room
                            });
                        };
                        for(var col = 0; col < (gridData.cols || gridData.size); col++)_loop(col);
                    };
                    exitPos = gridData.endPos;
                    // Collect cells to check (even with 0 remaining steps, roads/campsite might reach exit)
                    cellsToCheck = [];
                    for(row = 0; row < (gridData.rows || gridData.size); row++)_loop(row);
                    // Initialize workers if needed
                    if (!(0, $b8968b5a5b432368$export$efe69f901af7b3f6)()) (0, $b8968b5a5b432368$export$720bfee83fe27440)();
                    (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "checking rooms: ", cellsToCheck);
                    return [
                        4,
                        $3f29ea4265abff3b$var$dimUnreachableRoomsParallel(gridData, currentPos, exitPos, remainingSteps, cellsToCheck, calculationId)
                    ];
                case 1:
                    result = _state.sent();
                    // Check if this calculation is still valid (result will be null if cancelled)
                    if (!result || calculationId !== $3f29ea4265abff3b$var$currentCalculationId) return [
                        2
                    ]; // Cancelled, don't apply results
                    dimmedCells = result;
                    // Clear all dimming first, then apply new dimming
                    document.querySelectorAll('.grid-cell').forEach(function(cell) {
                        cell.classList.remove('raid-dimmed');
                    });
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        // Apply dimming to DOM
                        for(_iterator = dimmedCells[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            _step_value = _step.value, row1 = _step_value.row, col = _step_value.col;
                            cell = document.querySelector('[data-row="'.concat(row1, '"][data-col="').concat(col, '"]'));
                            if (cell) cell.classList.add('raid-dimmed');
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return [
                        2
                    ];
            }
        });
    })();
}
function $3f29ea4265abff3b$var$dimUnreachableRoomsParallel(gridData, currentPos, exitPos, remainingSteps, cellsToCheck, calculationId) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var _loop, pathfindingWorkers, workerCount, chunkSize, promises, i, results;
        return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _loop = function(i) {
                        var start = i * chunkSize;
                        var end = Math.min(start + chunkSize, cellsToCheck.length);
                        var chunk = cellsToCheck.slice(start, end);
                        if (chunk.length === 0) return "continue";
                        var worker = pathfindingWorkers[i];
                        var promise = new Promise(function(resolve) {
                            var handler = function(e) {
                                // Check if this result is from a cancelled calculation
                                if (e.data.calculationId !== calculationId) {
                                    resolve(null); // Ignore old results
                                    return;
                                }
                                resolve(e.data.dimmedCells);
                            };
                            // Remove old handler and add new one to avoid memory leaks
                            worker.onmessage = handler;
                            worker.postMessage({
                                gridData: gridData,
                                currentPos: currentPos,
                                exitPos: exitPos,
                                remainingSteps: remainingSteps,
                                cellsToCheck: chunk,
                                selectedPath: (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath,
                                calculationId: calculationId
                            });
                        });
                        promises.push(promise);
                    };
                    pathfindingWorkers = (0, $b8968b5a5b432368$export$e25fa5fd5f04d38c)();
                    workerCount = pathfindingWorkers.length;
                    chunkSize = Math.ceil(cellsToCheck.length / workerCount);
                    promises = [];
                    for(i = 0; i < workerCount; i++)_loop(i);
                    return [
                        4,
                        Promise.all(promises)
                    ];
                case 1:
                    results = _state.sent();
                    (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "dimming results:", results);
                    // If any result is null, the calculation was cancelled
                    if (results.some(function(r) {
                        return r === null;
                    })) return [
                        2,
                        null
                    ];
                    return [
                        2,
                        results.flat()
                    ];
            }
        });
    })();
}
/**
 * The leading icon of a log message, if it has one.
 *
 * Log messages arrive as one string with the icon baked into the front
 * ("📍 Entered Marketfront Depot"), which leaves nothing for the layout to grip:
 * the text cannot line up with the room name in the header while it is the same
 * text node as the glyph in front of it. Splitting the two gives `.log-line` a
 * real icon cell to centre and a real text cell to align.
 *
 * Extended_Pictographic alone is not enough — the log leads with ✓ ✗ ⚠️ 🛣️ as
 * well, so the ranges cover arrows and dingbats, and the optional VS16 and ZWJ
 * runs keep multi-codepoint emoji (🏃‍♀️‍➡️) in one piece rather than splitting
 * them mid-sequence. Verified against all 18 distinct leading tokens in a real
 * raid's 155 messages; the only two that do not match are genuinely icon-less
 * ("Path planned: ...") and correctly fall through to the text column.
 */ var $3f29ea4265abff3b$var$LOG_ICON = RegExp("^((?:\\p{Extended_Pictographic}|[\u2190-\u21FF\u2300-\u27BF\u2B00-\u2BFF])\uFE0F?(?:\u200D(?:\\p{Extended_Pictographic}|[\u2190-\u21FF\u2300-\u27BF\u2B00-\u2BFF])\uFE0F?)*)\\s+", "u");
function $3f29ea4265abff3b$export$db35362777aa005a(message, type) {
    var match = message.match($3f29ea4265abff3b$var$LOG_ICON);
    var icon = match ? match[1] : '';
    var body = match ? message.slice(match[0].length) : message;
    var typeClass = type ? " log-".concat(type) : '';
    return '<div class="log-line tracking-tighter my-1'.concat(typeClass, '">') + '<span class="log-icon">'.concat(icon, "</span>") + '<div class="log-text mr-1">'.concat(body, "</div>") + "</div>";
}
function $3f29ea4265abff3b$export$8c20d1ca09eb894f(stepIndex) {
    if (!isNaN(stepIndex) && stepIndex >= 0) {
        var _raid_raidInProgress_stepLogs, _raid_completedRaidInfo_stepLogs, _raid_completedRaidInfo;
        var raid = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid;
        // In-progress logs first, then the completed raid's — the same shape
        // either way, so the rendering is shared rather than duplicated.
        var stepLogs = raid.raidInProgress && ((_raid_raidInProgress_stepLogs = raid.raidInProgress.stepLogs) === null || _raid_raidInProgress_stepLogs === void 0 ? void 0 : _raid_raidInProgress_stepLogs[stepIndex]) || raid.raidCompleted && ((_raid_completedRaidInfo = raid.completedRaidInfo) === null || _raid_completedRaidInfo === void 0 ? void 0 : (_raid_completedRaidInfo_stepLogs = _raid_completedRaidInfo.stepLogs) === null || _raid_completedRaidInfo_stepLogs === void 0 ? void 0 : _raid_completedRaidInfo_stepLogs[stepIndex]);
        if (stepLogs) return stepLogs.map(function(log) {
            return $3f29ea4265abff3b$export$db35362777aa005a(log.message, log.type);
        }).join('');
    }
    // Default placeholder when no logs exist yet
    return $3f29ea4265abff3b$export$db35362777aa005a('No activity yet.');
}
function $3f29ea4265abff3b$export$f4fa7fe8ae486c6() {
    var pathContainer = document.getElementById('path-rooms');
    if (pathContainer) {
        if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath.length === 0) {
            pathContainer.innerHTML = '<p class="text-gray-500">Click rooms to build your path</p>';
            return;
        }
        var pathHtml = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath.map(function(step, index) {
            var room = step.room;
            var roomIcon = (0, $ca7af38ea7b7b4a8$export$dd077d95a65121be)(room.name, room.type);
            var styleHiddenIfRaidInProgress = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress || (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidCompleted ? 'hidden' : '';
            var styleHiddenIfRaidNotStarted = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress || (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidCompleted ? '' : 'hidden';
            var isCurrentRoom = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress && (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress.currentRoomIndex === index;
            var currentStepClass = isCurrentRoom ? 'current-step' : '';
            //console.log(`Rendering path step ${index}: ${room.name} (${room.type})`);
            //console.log('Raid in progress:', gameState.currentRaid.raidInProgress);
            if (room.type === 'start') return '\n                    <div class="path-step" data-step-index="'.concat(index, '">\n                        <div class="path-room">\n                            <div class="path-room-header gap-2">\n                                <div class="step-number ').concat(currentStepClass, '">').concat(roomIcon, "</div>\n                                <strong>").concat(room.name, '</strong>\n                            </div>\n                            <div class="path-room-details ').concat(styleHiddenIfRaidInProgress, '">\n                                <span class="text-green-500 px-2">Entry point for the raid</span>\n                            </div>\n                            <div class="path-room-log ').concat(styleHiddenIfRaidNotStarted, '">\n                                ').concat($3f29ea4265abff3b$export$8c20d1ca09eb894f(index), "\n                            </div>\n                        </div>\n                    </div>\n                ");
            else if (room.type === 'exit') return '\n                    <div class="path-step" data-step-index="'.concat(index, '">\n                        <div class="path-room">\n                            <div class="path-room-header gap-2">\n                                <div class="step-number ').concat(currentStepClass, '">').concat(roomIcon, "</div>\n                                <strong>").concat(room.name, '</strong>\n                            </div>\n                            <div class="path-room-details ').concat(styleHiddenIfRaidInProgress, '">\n                                <span class="text-game-gold px-2">Exit point for the raid</span>\n                            </div>\n                            <div class="path-room-log ').concat(styleHiddenIfRaidNotStarted, '">\n                                ').concat($3f29ea4265abff3b$export$8c20d1ca09eb894f(index), "\n                            </div>\n                        </div>\n                    </div>\n                ");
            else if (room.type === 'road' || room.type === 'campsite' || room.type === 'water') {
                var successPercentage = 100;
                var successColor = '#4caf50';
                var roomDuration = room.baseDuration;
                var lootItemsHtml = room.type === 'water' ? $3f29ea4265abff3b$export$1967c0c6b54773a5(1, room) : 'None';
                return '\n                    <div class="path-step" data-step-index="'.concat(index, '">\n                        <div class="path-room">\n                            <div class="path-room-header gap-2">\n                                <div class="step-number ').concat(currentStepClass, '">').concat(roomIcon, '</div>\n                                <!-- No type tag here. These three rooms are named exactly after\n                                     their type \u2014 "Road", "Water", "Campsite" \u2014 so a "(ROAD)" beside\n                                     "Road" restated the word next to it. The gate and hazard tags\n                                     earn their place by carrying a risk mark; there is no risk to\n                                     mark on a room where no encounter runs, which is what the\n                                     absence of a tag now says. -->\n                                <div class="leading-[1]">').concat(room.name, '</div>\n                                <div class="flex-col leading-[1]">\n                                    <div class="">\u23F1\uFE0F').concat(roomDuration, '</div>\n                                    <div class="" style="color: ').concat(successColor, ';">\uD83C\uDFAF').concat(successPercentage, '%</div>\n                                </div>\n                            </div>\n                            <div class="path-room-details" ').concat(styleHiddenIfRaidInProgress, '>\n                                <div class="loot-section">\n                                    <div class="hidden loot-header cursor-pointer flex items-center justify-between bg-gray-700/40 px-2 py-1 rounded hover:bg-gray-600/40" onclick="this.parentElement.classList.toggle(\'expanded\')">\n                                        <span class="text-sm font-bold">\uD83D\uDCB0 Possible Loot</span>\n                                        <span class="expand-icon text-xs">\u25BC</span>\n                                    </div>\n                                    <div class="loot-content hidden mt-1 pl-2">\n                                        ').concat(lootItemsHtml, '\n                                    </div>\n                                </div>\n                            </div>                        \n                            <div class="path-room-log ').concat(styleHiddenIfRaidNotStarted, '">\n                                ').concat($3f29ea4265abff3b$export$8c20d1ca09eb894f(index), "\n                            </div>\n                        </div>\n                    </div>\n                ");
            } else {
                var _config_factionSkills_primaryFactionKey_skills_room_primary, _gameState_currentRaid_currentRaidGrid, _gameState_currentRaid_currentRaidGrid1;
                var faction = Object.values($979b99378be707cd$export$aeeef991191508e2).find(function(f) {
                    return Object.keys(f.skills).includes(room.primary);
                });
                var primaryFactionKey = faction ? Object.keys($979b99378be707cd$export$aeeef991191508e2).find(function(k) {
                    return $979b99378be707cd$export$aeeef991191508e2[k] === faction;
                }) : 'dominion';
                var primarySkillName = ((_config_factionSkills_primaryFactionKey_skills_room_primary = $979b99378be707cd$export$aeeef991191508e2[primaryFactionKey].skills[room.primary]) === null || _config_factionSkills_primaryFactionKey_skills_room_primary === void 0 ? void 0 : _config_factionSkills_primaryFactionKey_skills_room_primary.name) || room.primary;
                // Get team skills for coverage checking
                var teamSkills = (0, $1249ab814b7054d4$export$bf19dc1273cbd1a1)();
                var region = (_gameState_currentRaid_currentRaidGrid = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid) === null || _gameState_currentRaid_currentRaidGrid === void 0 ? void 0 : _gameState_currentRaid_currentRaidGrid.region;
                var raidTier = (_gameState_currentRaid_currentRaidGrid1 = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid) === null || _gameState_currentRaid_currentRaidGrid1 === void 0 ? void 0 : _gameState_currentRaid_currentRaidGrid1.tier;
                // Calculate success chance (folds in the team's equipped-gear
                // expected bonus, same clamp as the runtime formula)
                var successChance = (0, $1249ab814b7054d4$export$278313c6a8f74dd)(room, teamSkills, raidTier, (0, $1249ab814b7054d4$export$c41f4a6445888331)());
                var successPercentage1 = Math.round(successChance * 100);
                // The mark and the percentage beside it now come off the SAME
                // number and the SAME thresholds, so they cannot say different
                // things about the same room.
                var roomStatus = (0, $1249ab814b7054d4$export$ac3767a8a135daf7)(successChance);
                var successColor1 = successChance >= (0, $1249ab814b7054d4$export$1b78a23f03a8d95f) ? '#4caf50' : successChance >= (0, $1249ab814b7054d4$export$e19e68234418033a) ? '#ff9800' : '#ff6b6b';
                var roomDuration1 = room.baseDuration;
                // Get possible loot with icons
                //const possibleLoot = getPossibleRoomLoot(room, raidTier);
                var lootItemsHtml1 = $3f29ea4265abff3b$export$1967c0c6b54773a5(raidTier, room);
                // Primary skill with team level and coverage
                var roomTypeMark = room.type === 'gate' ? "\u25CF\u25CF" : "\u25CF";
                var primaryTeamLevel = teamSkills[room.primary] || 0;
                var primaryCovered = primaryTeamLevel > 0;
                var primarySkillIcon = (0, $ca7af38ea7b7b4a8$export$8a18dddc0824814c)(room.primary);
                var primaryCoverageIcon = primaryCovered ? "\u2713" : "\u2717";
                var primaryCoverageColor = primaryCovered ? '#4caf50' : '#ff6b6b';
                var supportSkills = room.support.map(function(skill) {
                    var _config_factionSkills_factionKey_skills_skill;
                    var skillFaction = Object.values($979b99378be707cd$export$aeeef991191508e2).find(function(f) {
                        return Object.keys(f.skills).includes(skill);
                    });
                    var factionKey = skillFaction ? Object.keys($979b99378be707cd$export$aeeef991191508e2).find(function(k) {
                        return $979b99378be707cd$export$aeeef991191508e2[k] === skillFaction;
                    }) : 'dominion';
                    var skillName = ((_config_factionSkills_factionKey_skills_skill = $979b99378be707cd$export$aeeef991191508e2[factionKey].skills[skill]) === null || _config_factionSkills_factionKey_skills_skill === void 0 ? void 0 : _config_factionSkills_factionKey_skills_skill.name) || skill;
                    var skillIcon = (0, $ca7af38ea7b7b4a8$export$8a18dddc0824814c)(skill);
                    // Support skill team level and coverage
                    var supportTeamLevel = teamSkills[skill] || 0;
                    var supportCovered = supportTeamLevel > 0;
                    var supportCoverageIcon = supportCovered ? "\u2713" : "\u2717";
                    var supportCoverageColor = supportCovered ? '#4caf50' : '#ff6b6b';
                    return '<div class="p-1">'.concat(skillIcon, " ").concat(skillName, '</div> <div class="p-1 font-bold" style="color: ').concat(supportCoverageColor, ';">').concat(supportCoverageIcon).concat(supportTeamLevel, "</div>");
                }).join('');
                return '\n                    <div class="path-step" data-step-index="'.concat(index, '">\n                        <div class="path-room">\n                            <div class="path-room-header gap-2">\n                                <div class="step-number ').concat(currentStepClass, '">').concat((0, $1249ab814b7054d4$export$86025a0d632dc830)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath, index), '</div>                            \n                                <!-- The same tag the map tile carries: \u25CF\u25CF for a gate, \u25CF for a\n                                     hazard, then the risk mark. Built from getRoomOddsStatus off\n                                     the SAME chance the \uD83C\uDFAF percentage to the right prints, so the\n                                     mark and the number on this one line cannot contradict each\n                                     other, and so the log and the map cannot disagree either.\n                                     It used to read (GATE)/(HAZARD) coloured by TYPE, which said\n                                     the same thing the room name already did and left the risk \u2014\n                                     the part worth knowing at a glance \u2014 only on the map. -->\n                                <div class="leading-[1]">').concat(room.name, ' <span class="room-tag text-xs ').concat(roomStatus.indicator, '"><span class="mr-1">').concat(roomTypeMark, "</span>").concat(roomStatus.symbol, '</span></div>\n                                <div class="flex-col leading-[1]">\n                                    <div class="">\u23F1\uFE0F').concat(roomDuration1, '</div>\n                                    <div class="" style="color: ').concat(successColor1, ';">\uD83C\uDFAF').concat(successPercentage1, '%</div>\n                                </div>\n                            </div>\n                            <div class="path-room-skills" ').concat(styleHiddenIfRaidInProgress, '>\n                                <div class="primary-skill-column text-sm">\n                                    <div class="bg-gray-600/50 p-1 font-bold">\u2B50 Primary</div>\n                                    <div class="grid grid-cols-[auto_fit-content(100%)]">\n                                        <div class="p-1">').concat(primarySkillIcon, " ").concat(primarySkillName, '</div>\n                                        <div class="p-1 font-bold" style="color: ').concat(primaryCoverageColor, ';">').concat(primaryCoverageIcon).concat(primaryTeamLevel, '</div>\n                                    </div>\n                                </div>\n                                <div class="support-skills-column text-sm">\n                                    <div class="bg-gray-600/50 p-1 font-bold">\uD83D\uDD27 Support</div>\n                                    <div class="grid grid-cols-[auto_fit-content(100%)]">\n                                        ').concat(supportSkills || '<div class="p-1 text-gray-500 italic">No support skills</div>', '\n                                    </div>\n                                </div>\n                            </div>\n                            <div class="path-room-details" ').concat(styleHiddenIfRaidInProgress, '>\n                                <div class="loot-section">\n                                    <div class="loot-header cursor-pointer flex items-center justify-between bg-gray-700/40 px-2 py-1 rounded hover:bg-gray-600/40" onclick="this.parentElement.classList.toggle(\'expanded\')">\n                                        <span class="text-sm font-bold">\uD83D\uDCB0 Possible Loot</span>\n                                        <span class="expand-icon text-xs">\u25BC</span>\n                                    </div>\n                                    <div class="loot-content hidden mt-1 pl-2">\n                                        ').concat(lootItemsHtml1, '\n                                    </div>\n                                </div>\n                            </div>\n                            <div class="path-room-log" ').concat(styleHiddenIfRaidNotStarted, ">\n                                ").concat($3f29ea4265abff3b$export$8c20d1ca09eb894f(index), "\n                            </div>\n                        </div>\n                    </div>\n                ");
            }
        }).join('');
        pathContainer.innerHTML = pathHtml;
    }
}
function $3f29ea4265abff3b$export$c9b7157fc13410c5() {
    var gridData = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid;
    var roomCountElement = document.getElementById('grid-room-count');
    if (!gridData || !roomCountElement) return;
    // Calculate and update room count
    var maxPathLength = (gridData.rows || gridData.size) + (gridData.cols || gridData.size) - 1;
    var currentStepCount = (0, $1249ab814b7054d4$export$aedd9bb9e278a90a)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath);
    roomCountElement.textContent = "".concat(currentStepCount, " / ").concat(maxPathLength);
    // Update styling based on limit
    if (currentStepCount >= maxPathLength) roomCountElement.classList.add('at-limit');
    else roomCountElement.classList.remove('at-limit');
}
function $3f29ea4265abff3b$export$ed4907da7d4af889() {
    // Exit early if raid is completed - don't override completed raid visualization
    if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidCompleted && (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.completedRaidInfo) {
        (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, 'Skipping grid path highlight - raid is completed');
        return;
    }
    // Clear all path highlights and path numbers
    document.querySelectorAll('.grid-cell').forEach(function(cell) {
        cell.classList.remove('path', 'selected');
        var pathNumber = cell.querySelector('.path-number');
        if (pathNumber) pathNumber.remove();
    });
    // Highlight path and add numbers
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath.forEach(function(step, index) {
        var cell = document.querySelector('[data-row="'.concat(step.row, '"][data-col="').concat(step.col, '"]'));
        if (cell) {
            cell.classList.add('path');
            if (index === (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath.length - 1) cell.classList.add('selected');
            // Add path number for non-start/end rooms
            if (step.room.type !== 'start' && step.room.type !== 'exit' && index > 0) {
                var pathNumber = document.createElement('div');
                pathNumber.className = '';
                // Show dash for roads, step number for gates/hazards
                pathNumber.textContent = (0, $1249ab814b7054d4$export$86025a0d632dc830)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath, index);
                pathNumber.className = 'path-number absolute bottom-1 right-1 bg-white/50 text-black rounded-full w-5 h-5 text-sm flex items-center justify-center font-bold shadow-md z-10';
                cell.appendChild(pathNumber);
            }
        }
    });
}
function $3f29ea4265abff3b$export$25fc6ae0ff69cc() {
    var startBtn = document.getElementById('start-raid');
    if (startBtn) {
        var gridData = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid;
        if (gridData) {
            if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath.length === 0) {
                startBtn.disabled = true;
                return;
            }
            // Check if path is valid (starts at start, ends at exit)
            var pathValid = (0, $1249ab814b7054d4$export$a678af82bf766611)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath, gridData);
            startBtn.disabled = !pathValid;
        }
    }
}
function $3f29ea4265abff3b$export$d6f634bba1273a2b() {
    var currentRaidInfo = document.getElementById('current-raid-info');
    if (currentRaidInfo) {
        //console.log('region and tier', gameState.currentRaid.selectedRegion, gameState.currentRaid.selectedTier);
        if (!(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedRegion || !(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedTier) {
            currentRaidInfo.innerHTML = '';
            return;
        }
        var region = $979b99378be707cd$export$4fbdcec70fce9d73[(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedRegion];
        var tier = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedTier;
        var tierInfo = $979b99378be707cd$export$94e7ad7999c1ae32[tier];
        currentRaidInfo.innerHTML = '\n            <div class="path-info-region inline-block text-white">'.concat(region.name, '</div> // \n            <div class="path-info-tier inline-block text-game-gold">').concat(tierInfo.name, "</div>\n        ");
    }
}
var $3f29ea4265abff3b$export$42079bc77e782d23 = [
    'raid-planning',
    'raid-in-progress',
    'raid-completed'
];
function $3f29ea4265abff3b$export$2d4508142cc72b6e() {
    var _gameState_currentRaid, _gameState_currentRaid1;
    var grid = document.getElementById('raid-grid');
    if (!grid) return null;
    var state = ((_gameState_currentRaid = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid) === null || _gameState_currentRaid === void 0 ? void 0 : _gameState_currentRaid.raidCompleted) ? 'raid-completed' : ((_gameState_currentRaid1 = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid) === null || _gameState_currentRaid1 === void 0 ? void 0 : _gameState_currentRaid1.raidInProgress) ? 'raid-in-progress' : 'raid-planning';
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // toggle(name, bool) for all three rather than remove-then-add: it cannot
        // leave a stale one behind, which is the failure mode the `raid-cols-N`
        // classes have to hand-guard against a few lines below.
        for(var _iterator = $3f29ea4265abff3b$export$42079bc77e782d23[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var cls = _step.value;
            grid.classList.toggle(cls, cls === state);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return state;
}
function $3f29ea4265abff3b$export$cf8b2a65252147ea() {
    var gridContainer = document.getElementById('raid-grid');
    // Lights Out masks unvisited rooms. A class on the container rather than
    // per-cell state: the reveal condition is classes the raid progression
    // already maintains, so CSS can express the whole rule (see styles.css).
    gridContainer === null || gridContainer === void 0 ? void 0 : gridContainer.classList.toggle('blackout-dark', !!(0, $686e361e5cd4549d$export$a2c94bc2dc5c01e1)('noGridPreview', false));
    $3f29ea4265abff3b$export$2d4508142cc72b6e();
    var gridData = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid;
    if (gridContainer && gridData) {
        var _loop = function(row) {
            var _loop = function(col) {
                //console.log(`Rendering cell at (${row},${col})`);
                var room = gridData.grid[row][col];
                var conn = {
                    n: isOpen(row - 1, col),
                    s: isOpen(row + 1, col),
                    e: isOpen(row, col + 1),
                    w: isOpen(row, col - 1)
                };
                var cell = document.createElement('div');
                // Base cell class with Tailwind + custom CSS
                var cellClasses = "grid-cell ".concat(room.type, " w-16 h-16 md:w-20 md:h-20 flex items-center justify-center cursor-pointer font-bold relative");
                // Skill status is now only shown via indicators, not cell classes
                cell.className = cellClasses;
                cell.dataset.row = row;
                cell.dataset.col = col;
                // Room tooltips handled by existing showRoomTooltip system
                var roomIcon = (0, $ca7af38ea7b7b4a8$export$dd077d95a65121be)(room.name, room.type);
                // Overlay markup per cell type; the animated tile canvas is
                // prepended below it by registerAnimCell
                if (room.type === 'blocked') cell.innerHTML = '\n                        <div class="room-content blocked-cell">\n                        </div>\n                    ';
                else if (room.type === 'road' || room.type === 'campsite' || room.type === 'water') cell.innerHTML = '\n                        <div class="room-content room-with-background">\n                            <div class="room-overlay"></div>\n                        </div>\n                    ';
                else {
                    // The room's odds at a glance, off the same number and the
                    // same thresholds the raid log prints as `🎯 N%`. Hovering
                    // the tile explains WHY in words — that is where coverage
                    // (which skill is missing) still lives.
                    var roomIndicator = '';
                    if (room.type !== 'start' && room.type !== 'exit') {
                        var odds = (0, $1249ab814b7054d4$export$ac3767a8a135daf7)((0, $1249ab814b7054d4$export$278313c6a8f74dd)(room, teamSkills, gridData.tier, teamTechniques));
                        var typeIndicator = room.type === 'gate' ? "\u25CF\u25CF" : "\u25CF";
                        roomIndicator = '<div class="skill-indicator tracking-widest '.concat(odds.indicator, '">\n                            <span class="mr-1">').concat(typeIndicator, "</span>").concat(odds.symbol, "\n                        </div>");
                    }
                    cell.innerHTML = '\n                        <div class="room-content room-with-background">\n                            '.concat(roomIndicator, "\n                        </div>\n                    ");
                }
                (0, $bfcb035c6f32f2dc$export$5f82487e371f5e57)(cell, room, conn, (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedRegion);
                // Add click handler
                cell.addEventListener('click', function() {
                    return $3f29ea4265abff3b$export$f2a0cf624bd292ab(row, col);
                });
                // Hover handlers for the room tooltip.
                //
                // Pointer events rather than mouse events, and touch is skipped
                // explicitly: a tap on iPad synthesises mouseenter but never a
                // matching mouseleave, so the tooltip parked itself beside the
                // tapped tile and covered its neighbours for the rest of the
                // planning session. Nothing dismissed it, because there is no
                // "move away" on a touchscreen.
                //
                // Filtering per EVENT beats a device-wide `(hover: none)` query:
                // an iPad with a trackpad, or an Apple Pencil hovering (pen), is
                // a real hover and still gets the tooltip — only the finger is
                // excluded. pageX/pageY come along, since PointerEvent extends
                // MouseEvent.
                var hoverOnly = function(handler) {
                    return function(e) {
                        if (e.pointerType !== 'touch') handler(e);
                    };
                };
                cell.addEventListener('pointerenter', hoverOnly(function(e) {
                    return $3f29ea4265abff3b$export$b127b30033aaeba9(e, room);
                }));
                cell.addEventListener('pointerleave', $3f29ea4265abff3b$export$a23289342bf715b2);
                cell.addEventListener('pointermove', hoverOnly($3f29ea4265abff3b$export$7fa52bbeeb0b31af));
                gridContainer.appendChild(cell);
            };
            for(var col = 0; col < gridCols; col++)_loop(col);
        };
        (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, 'Displaying raid grid...');
        gridContainer.innerHTML = '';
        (0, $bfcb035c6f32f2dc$export$72b470d5f7d48c79)();
        // Where on the planet this grid is, for the day clock (M3 S9). Set
        // before the cells register so the very first frame draws the right sky.
        (0, $bfcb035c6f32f2dc$export$bcbc425da348b5df)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedRegion, (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidSite);
        // Use cols/rows for grid template, fallback to size for backward compatibility
        var gridCols = gridData.cols || gridData.size;
        var gridRows = gridData.rows || gridData.size;
        gridContainer.classList.remove("raid-cols-7", "raid-cols-13", "raid-cols-17");
        gridContainer.classList.add("raid-cols-" + gridCols);
        gridContainer.style.gridTemplateColumns = "repeat(".concat(gridCols, ", 1fr)");
        // Set viewport height based on number of rows and cell size
        // Mobile: 64px cells (w-16 h-16), Desktop: 80px cells (md:w-20 md:h-20)
        // Plus padding and gap
        var viewport = document.getElementById('raid-grid-viewport');
        if (viewport) {
            var cellHeight = 80;
            var gap = 0; // seamless map — tiles butt up against each other
            var paddingAndBorder = 18;
            var viewportSize = cellHeight * gridRows + gap * (gridRows - 1) + paddingAndBorder * 2 + (gridCols > 7 ? 15 : 0);
            viewport.style.height = "".concat(viewportSize, "px");
            viewport.style.width = "".concat(viewportSize, "px");
        }
        // Get current team skills for skill checking. Both hoisted out of the
        // per-cell loop: a tier-3 grid is 119 cells and neither answer varies
        // between them.
        var teamSkills = (0, $1249ab814b7054d4$export$bf19dc1273cbd1a1)();
        var teamTechniques = (0, $1249ab814b7054d4$export$c41f4a6445888331)();
        // Traversable-neighbour flags. These no longer drive the roadway —
        // roads come from the generated network stamped on each room — but the
        // renderer still takes conn for things that key off open sides.
        var isOpen = function(r, c) {
            return r >= 0 && c >= 0 && r < gridRows && c < gridCols && gridData.grid[r][c] && gridData.grid[r][c].type !== 'blocked';
        };
        for(var row = 0; row < gridRows; row++)_loop(row);
        // Room tooltips use the existing custom system
        // Match path-rooms height to grid height after grid is rendered
        setTimeout($3f29ea4265abff3b$export$d86087c4a9b82d46, 1000);
    }
}
function $3f29ea4265abff3b$export$d86087c4a9b82d46() {
    var gridData = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid;
    if (gridData) {
        var raidGrid = document.getElementById('raid-grid');
        var pathRooms = document.getElementById('path-info');
        //console.log('MatchPathRoomsHeight', raidGrid, pathRooms);
        if (raidGrid && pathRooms) {
            // Measure the map column (day-clock bar + grid viewport) directly
            // so the panel's bottom always lines up with the grid's bottom —
            // the old arithmetic drifted whenever grid CSS changed
            var mapSection = document.querySelector('.map-section');
            var gridHeight = 0;
            if (!gridHeight) {
                var cellHeight = 80;
                var paddingAndBorder = 18;
                gridHeight = cellHeight * gridData.rows + paddingAndBorder * 2 + (gridData.cols > 7 ? 15 : 0);
            }
            pathRooms.style.height = "".concat(gridHeight, "px");
            pathRooms.style.maxHeight = "".concat(gridHeight, "px"); // Keep dynamic height matching
        //pathRooms.style.maxWidth = `${gridHeight*1.5}px`;
        }
    }
}
function $3f29ea4265abff3b$export$3de9c504cadcc6ea() {
    var stepIndex = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    var pathRooms = document.getElementById('path-rooms');
    if (!pathRooms) return;
    // Determine which step to focus
    var focusStepIndex;
    if (stepIndex !== null) focusStepIndex = stepIndex;
    else if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress) {
        var currentStepIndex = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress.currentRoomIndex;
        focusStepIndex = currentStepIndex > 0 ? currentStepIndex : currentStepIndex == (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath.length - 1 ? currentStepIndex : 0;
    } else return;
    // Find the step element
    var focusStepElement = pathRooms.querySelector('[data-step-index="'.concat(focusStepIndex, '"]'));
    if (focusStepElement) {
        // Scroll the step to the top with smooth animation
        focusStepElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest'
        });
        (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "Scrolled to step index ".concat(focusStepIndex));
    }
}
/**
 * Keep the crew count on the Map pane, under the planned-path line.
 *
 * Playtest feedback was that people did not know how or when to add
 * contractors. The Reserve buttons work and are where you would expect them —
 * on the empty slots — but they live inside a panel tab that is NOT the one
 * the planner opens on (🗺️ Map), so a player can pick a region, chart a path
 * and launch without ever seeing that a team exists. Nothing else on the
 * planner mentions it, and a solo raid is perfectly legal, so there is no error
 * state to bump into either.
 *
 * It sits beside the planned-path count rather than on the tab itself: the tab
 * row has to fit a tablet, and a count there pushed the four tabs too wide.
 * Here it is next to the thing it crews, on the pane the player is already
 * reading while they plan.
 *
 * A count informs without nagging, which is deliberate — going alone is a real
 * choice, since contractors take a share of the credits.
 */ function $3f29ea4265abff3b$var$updateTeamCountLine(teamSize, maxMembers) {
    var _el_parentElement;
    var el = document.getElementById('grid-team-count');
    if (!el) return;
    el.textContent = "".concat(teamSize, " / ").concat(maxMembers);
    (_el_parentElement = el.parentElement) === null || _el_parentElement === void 0 ? void 0 : _el_parentElement.classList.toggle('at-limit', teamSize >= maxMembers);
}
function $3f29ea4265abff3b$export$b70ccd83fb3eaefa() {
    var teamDisplay = document.getElementById('grid-team-display');
    var costDisplay = document.getElementById('team-cost-display');
    if (!teamDisplay || !costDisplay) return;
    // Get current active character
    var currentCharacter = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).characters.find(function(c) {
        return c.id === (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).activeCharacterId;
    });
    if (!currentCharacter) {
        teamDisplay.innerHTML = '<p class="text-gray-500">Create a character first</p>';
        costDisplay.textContent = 'Contractor Share: 0% of raid credits';
        $3f29ea4265abff3b$var$updateTeamCountLine(0, 3);
        return;
    }
    var raidTeam = (0, $1249ab814b7054d4$export$d17f5534c14b3dc5)();
    // Build team members array with rendered cards for carousel
    var maxMembers = 3;
    $3f29ea4265abff3b$var$updateTeamCountLine(raidTeam.length, maxMembers);
    var teamMembers = [];
    var pathSkills = (0, $1249ab814b7054d4$export$1311cf265aa89b71)();
    var teamSkills = (0, $1249ab814b7054d4$export$bf19dc1273cbd1a1)();
    // Add actual team members
    raidTeam.forEach(function(member) {
        teamMembers.push({
            id: member.id,
            html: (0, $670e0f14fa02ad13$export$5464865996ba2eb4)(member, 'team', pathSkills, teamSkills)
        });
    });
    // Add placeholder cards for empty team slots
    var emptySlots = maxMembers - raidTeam.length;
    for(var i = 0; i < emptySlots; i++){
        var context = 'empty-first';
        teamMembers.push({
            id: "empty-".concat(i),
            html: (0, $670e0f14fa02ad13$export$5464865996ba2eb4)('empty', context)
        });
    }
    (0, $8b8b7141704a735c$export$f1143e4c4cd76114)(teamDisplay, teamMembers);
    // Update percentage share
    var totalPercentage = raidTeam.reduce(function(sum, contractor) {
        return sum + (contractor.rewardPercentage ? contractor.rewardPercentage : 0);
    }, 0);
    costDisplay.textContent = "Contractor Share: ".concat(totalPercentage, "% of raid credits");
    // Update color classes based on percentage
    costDisplay.className = costDisplay.className.replace(/text-red-500|text-yellow-500|text-green-500/g, '');
    if (totalPercentage > 50) costDisplay.classList.add('text-red-500');
    else if (totalPercentage > 25) costDisplay.classList.add('text-yellow-500');
    else costDisplay.classList.add('text-green-500');
}
function $3f29ea4265abff3b$export$68c4600b33dd0ca8() {
    // Refresh the grid display to update skill indicators (only if raid grid is active and skills changed)
    if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid) {
        (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, 'Refreshing raid grid for team update');
        $3f29ea4265abff3b$export$cf8b2a65252147ea();
        // Restore path highlighting after grid refresh
        $3f29ea4265abff3b$export$ed4907da7d4af889();
        $3f29ea4265abff3b$var$debouncedHighlightValidMoves();
        // Restore the item-drop badges (displayRaidGrid rebuilt the cells)
        $3f29ea4265abff3b$export$edb541e336ea9a21();
    }
}
function $3f29ea4265abff3b$export$e4c69cea9b646118(contractorId) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var contractor, _gameState_characters, currentCharacter, result, error;
        return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (isNaN(contractorId)) {
                        (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "Invalid contractor id: ".concat(contractorId));
                        return [
                            2
                        ];
                    }
                    (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "Releasing reserved contractor ".concat(contractorId));
                    (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, 'isContractorReserved:', (0, $1249ab814b7054d4$export$595cb98aec43dd71)(contractorId));
                    if (!(0, $1249ab814b7054d4$export$595cb98aec43dd71)(contractorId)) return [
                        2
                    ];
                    // Find the contractor to check if it's a marketplace contractor
                    contractor = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.reservedContractors.find(function(c) {
                        return c.id == contractorId;
                    });
                    if (!(contractor && contractorId > 0)) return [
                        3,
                        4
                    ];
                    currentCharacter = (_gameState_characters = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).characters) === null || _gameState_characters === void 0 ? void 0 : _gameState_characters.find(function(c) {
                        return c.id === (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).activeCharacterId;
                    });
                    if (!currentCharacter) return [
                        3,
                        4
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0, $fde0976ce5d1665d$export$e4477200b6413a70).releaseContractor(contractorId, currentCharacter.multiplayerId)
                    ];
                case 2:
                    result = _state.sent();
                    if (!result.success) {
                        (0, $b5bda7fdec806d8b$export$c7def531c087da85)("Failed to release contractor: ".concat(result.message), 'error');
                        return [
                            2
                        ];
                    }
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    console.error('Error releasing marketplace contractor:', error);
                    (0, $b5bda7fdec806d8b$export$c7def531c087da85)('Failed to release contractor - network error', 'error');
                    return [
                        2
                    ];
                case 4:
                    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.reservedContractors = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.reservedContractors.filter(function(c) {
                        return c.id != contractorId;
                    });
                    // Update Alpine store
                    if ((0, $da6f71b8677b901e$export$2e2bcd8739ae039).store('contractors')) (0, $da6f71b8677b901e$export$2e2bcd8739ae039).store('contractors').updateReserved((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.reservedContractors);
                    $3f29ea4265abff3b$export$b70ccd83fb3eaefa();
                    $3f29ea4265abff3b$export$68c4600b33dd0ca8();
                    $3f29ea4265abff3b$export$f4fa7fe8ae486c6(); // Update current path skill coverage
                    (0, $59924438766e7d8e$export$d1c957a54f7124bc)();
                    (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
                    return [
                        2
                    ];
            }
        });
    })();
}
function $3f29ea4265abff3b$export$1de8727a75eb95ee(contractorId) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var contractor, _gameState_characters, currentCharacter, result, error;
        return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(0, $1249ab814b7054d4$export$4c8adf450afe39a2)(contractorId)) return [
                        2
                    ];
                    // Find the contractor to check if it's a marketplace contractor
                    contractor = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.hiredContractors.find(function(c) {
                        return c.id == contractorId;
                    });
                    if (!(contractor && contractorId > 0)) return [
                        3,
                        4
                    ];
                    currentCharacter = (_gameState_characters = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).characters) === null || _gameState_characters === void 0 ? void 0 : _gameState_characters.find(function(c) {
                        return c.id === (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).activeCharacterId;
                    });
                    if (!currentCharacter) return [
                        3,
                        4
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0, $fde0976ce5d1665d$export$e4477200b6413a70).releaseHiredContractor(contractorId, currentCharacter.multiplayerId)
                    ];
                case 2:
                    result = _state.sent();
                    if (!result.success) {
                        (0, $b5bda7fdec806d8b$export$c7def531c087da85)("Failed to release hired contractor: ".concat(result.message), 'error');
                        return [
                            2
                        ];
                    }
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    console.error('Error releasing hired marketplace contractor:', error);
                    (0, $b5bda7fdec806d8b$export$c7def531c087da85)('Failed to release hired contractor - network error', 'error');
                    return [
                        2
                    ];
                case 4:
                    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.hiredContractors = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.hiredContractors.filter(function(c) {
                        return c.id != contractorId;
                    });
                    (0, $da6f71b8677b901e$export$2e2bcd8739ae039).store('contractors').refresh();
                    $3f29ea4265abff3b$export$b70ccd83fb3eaefa();
                    $3f29ea4265abff3b$export$f4fa7fe8ae486c6(); // Update current path skill coverage
                    (0, $59924438766e7d8e$export$d1c957a54f7124bc)();
                    (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
                    return [
                        2
                    ];
            }
        });
    })();
}
function $3f29ea4265abff3b$export$bb6b71fe7f08b971() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var _ref, _ref_automated, automated, overallSuccessChance, region;
        var _arguments = arguments;
        return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _ref = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, _ref_automated = _ref.automated, automated = _ref_automated === void 0 ? false : _ref_automated;
                    // Validate we can start a raid
                    if (!(0, $1249ab814b7054d4$export$81a3d8aa8b7e7939)()) return [
                        2
                    ];
                    // Route bonus-loot and fishing events through the clickable browser
                    // presenters (player must click to collect) — UNLESS this raid is running
                    // hands-off, in which case the headless auto-grant collects them instead.
                    // Nobody is watching an automated raid to click a diamond, so the
                    // collectible would expire and take its loot with it.
                    (0, $eb7853ba84a48a26$export$93eaf817d66094f2)({
                        automated: automated
                    });
                    // Drop the planning-only item highlight + picker before the raid begins,
                    // and land the player on the log tab with a fresh loot pane
                    $3f29ea4265abff3b$export$6c9e89b1ffed34d7();
                    $3f29ea4265abff3b$export$d955e43ec94b6b38();
                    $3f29ea4265abff3b$export$a21eeedead301a30('log');
                    // Start raid execution
                    return [
                        4,
                        (0, $1249ab814b7054d4$export$43eae605f498c00a)()
                    ];
                case 1:
                    _state.sent();
                    (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
                    // Raid started notification
                    overallSuccessChance = Math.round((0, $1249ab814b7054d4$export$26622a6bc351fd6d)() * 100, 1);
                    region = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid.region;
                    (0, $8bda0cb20f0b197d$export$fd59807889add359)("\uD83D\uDE80 Starting raid on ".concat(region.name, "..."), 'info', {
                        stepIndex: 0
                    });
                    (0, $8bda0cb20f0b197d$export$fd59807889add359)("\uD83D\uDCAA Team assembled: ".concat(1 + (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.hiredContractors.length, " members"), 'info', {
                        stepIndex: 0,
                        notify: false
                    });
                    (0, $8bda0cb20f0b197d$export$fd59807889add359)("\uD83D\uDCAA Team Status - Total HP: ".concat((0, $1249ab814b7054d4$export$d17f5534c14b3dc5)().reduce(function(sum, member) {
                        return sum + member.currentHp;
                    }, 0)), 'info', {
                        stepIndex: 0,
                        notify: false
                    });
                    (0, $8bda0cb20f0b197d$export$fd59807889add359)("Path planned: ".concat((0, $1249ab814b7054d4$export$aedd9bb9e278a90a)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath), " rooms to traverse"), 'info', {
                        stepIndex: 0,
                        notify: false
                    });
                    (0, $8bda0cb20f0b197d$export$fd59807889add359)("Chance of looting all rooms: ".concat(overallSuccessChance, "%"), 'info', {
                        stepIndex: 0,
                        notify: false
                    });
                    // Update UI elements
                    $3f29ea4265abff3b$export$b70ccd83fb3eaefa();
                    $3f29ea4265abff3b$export$68c4600b33dd0ca8();
                    (0, $59924438766e7d8e$export$2ae62d947e9e1d03)(); //top raid button
                    //updateRaidGridForProgress(); // Called in loopRaidProgression
                    (0, $59924438766e7d8e$export$d1c957a54f7124bc)();
                    $3f29ea4265abff3b$export$96635d91a6ab659a();
                    // Start the raid progression timer
                    $3f29ea4265abff3b$export$46938b5e497922ff();
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $3f29ea4265abff3b$export$46938b5e497922ff() {
    var _gameState_currentRaid_raidInProgress, _gameState_currentRaid_raidInProgress1;
    var beginningStepIndex = ((_gameState_currentRaid_raidInProgress = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress) === null || _gameState_currentRaid_raidInProgress === void 0 ? void 0 : _gameState_currentRaid_raidInProgress.currentRoomIndex) || 0;
    $3f29ea4265abff3b$export$ed22353f8399566f();
    var endingStepIndex = ((_gameState_currentRaid_raidInProgress1 = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress) === null || _gameState_currentRaid_raidInProgress1 === void 0 ? void 0 : _gameState_currentRaid_raidInProgress1.currentRoomIndex) || 0;
    // Update the log messages in the path display
    $3f29ea4265abff3b$export$f4fa7fe8ae486c6();
    // Scroll to current step in path display
    if (endingStepIndex != beginningStepIndex) {
        setTimeout($3f29ea4265abff3b$export$3de9c504cadcc6ea, 1000);
        // Persist raid progress (currentRoomIndex, stepLogs, room timing) on every room
        // transition so a mid-raid reload restores the exact room with its log history
        if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress) (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
    }
    $3f29ea4265abff3b$export$b70ccd83fb3eaefa();
    // updateGridDisplay();
    // Update the path display to refresh timer
    $3f29ea4265abff3b$export$f4fa7fe8ae486c6();
    // Update grid to refresh timer display
    $3f29ea4265abff3b$export$17436b2a8cf51f27();
    // Keep the loot tab live while it's the visible pane
    if ($3f29ea4265abff3b$var$activeRaidPanelTab === 'loot') $3f29ea4265abff3b$export$cc4a7a45a09f1743();
    // End loop and update UI if raid completed
    if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidCompleted) {
        // Update Alpine store for inventory
        (0, $80ed874fd909c4ae$export$5b73e6a29e58b929)();
        // Update tab visibility now that raid is completed and ownership is cleared
        if (typeof (0, $59924438766e7d8e$export$2ae62d947e9e1d03) === 'function') (0, $59924438766e7d8e$export$2ae62d947e9e1d03)();
        // A raid can recover a Collapse Key, and with Auto-Raid the player is
        // often watching a different screen while it does. The Archive renders
        // on arrival, so if it is ALREADY the screen on show it would sit on a
        // stale count until the player navigated away and back.
        if ((0, $8896b37f0fd85895$export$517113b01f92f5fe)() === 'archive') (0, $11d54c59f84070a9$export$5dc9bc24597948d9)();
        // Transition grid to completed view immediately
        $3f29ea4265abff3b$export$20c4edcabec24020((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.completedRaidInfo);
        // Final loot snapshot (raidInProgress is gone; completedRaidInfo holds it)
        if ($3f29ea4265abff3b$var$activeRaidPanelTab === 'loot') $3f29ea4265abff3b$export$cc4a7a45a09f1743();
        (0, $59924438766e7d8e$export$d1c957a54f7124bc)();
        $3f29ea4265abff3b$export$96635d91a6ab659a(); // Update button to show reset option
        // Update tab visibility now that raid is completed and ownership is cleared
        if (typeof (0, $59924438766e7d8e$export$2ae62d947e9e1d03) === 'function') (0, $59924438766e7d8e$export$2ae62d947e9e1d03)();
    } else setTimeout($3f29ea4265abff3b$export$46938b5e497922ff, 1000);
}
function $3f29ea4265abff3b$export$ed22353f8399566f() {
    (0, $1249ab814b7054d4$export$493c70936cbe8c13)();
}
function $3f29ea4265abff3b$export$17436b2a8cf51f27() {
    if (!(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress || !(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid) return;
    var grid = document.getElementById('raid-grid');
    if (!grid) return;
    var currentRoomIndex = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress.currentRoomIndex;
    var currentTime = Date.now();
    // Hand the map the team's schedule. This runs at 1Hz with the rest of the
    // raid loop; the animation interpolates the walk between path steps off
    // the same roomStartTime/nextRoomTime the timer ring above uses, so the
    // figures and the countdown can never disagree about where the team is.
    (0, $bfcb035c6f32f2dc$export$2eefc97a05b1cdd3)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidCompleted ? null : {
        path: (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath,
        index: currentRoomIndex,
        raid: (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress,
        members: (0, $babd2312889b27ed$export$bdfac2c19033ece4)((0, $1249ab814b7054d4$export$d17f5534c14b3dc5)())
    });
    // Clean up expired special loot events
    //const specialEvent = gameState.currentRaid.raidInProgress.specialEvent;
    //if (specialEvent.active && specialEvent.roomIndex !== currentRoomIndex) {
    // Room has changed, clean up the old event
    //        cleanupBonusEvent();
    //}
    // Create path coordinate set for quick lookup
    var pathCoords = new Set();
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath.forEach(function(step) {
        pathCoords.add("".concat(step.row, "-").concat(step.col));
    });
    // First, dim all non-path rooms
    grid.querySelectorAll('.grid-cell').forEach(function(cell) {
        var row = cell.getAttribute('data-row');
        var col = cell.getAttribute('data-col');
        var coord = "".concat(row, "-").concat(col);
        if (!pathCoords.has(coord)) cell.classList.add('raid-dimmed');
        else cell.classList.remove('raid-dimmed');
    });
    // Update room styling to show progress
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath.forEach(function(pathStep, index) {
        var cell = grid.querySelector('[data-row="'.concat(pathStep.row, '"][data-col="').concat(pathStep.col, '"]'));
        if (cell) {
            cell.classList.remove('current-room', 'completed-room', 'upcoming-room', 'failed-room');
            // Add click handler to scroll to this step in the path display
            cell.style.cursor = 'pointer';
            cell.onclick = function() {
                return $3f29ea4265abff3b$export$3de9c504cadcc6ea(index);
            };
            // Remove existing path number or timer elements
            var existingElements = cell.querySelectorAll('.path-number, [class*="absolute bottom-1 right-1"]');
            existingElements.forEach(function(element) {
                return element.remove();
            });
            if (index < currentRoomIndex) {
                cell.classList.add('completed-room');
                // Add result indicator for completed rooms
                if (pathStep.room.type !== 'start' && pathStep.room.type !== 'exit' && index > 0) {
                    var _pathStep_room_result;
                    var completedMark = document.createElement('div');
                    var success = (_pathStep_room_result = pathStep.room.result) === null || _pathStep_room_result === void 0 ? void 0 : _pathStep_room_result.success;
                    completedMark.innerHTML = success ? "\u2713" : "\u2717";
                    var bgColor = success ? 'bg-green-500/40' : 'bg-red-500/40';
                    completedMark.className = "absolute bottom-1 right-1 ".concat(bgColor, " text-white w-5 h-5 rounded-full flex items-center justify-center text-xs font-bold ring-2 ring-black");
                    cell.appendChild(completedMark);
                }
            } else if (index === currentRoomIndex && !(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidCompleted) {
                cell.classList.add('current-room');
                // Scroll the current room into view in the viewport
                var viewport = document.getElementById('raid-grid-viewport');
                if (viewport && cell) // Use requestAnimationFrame to ensure DOM is ready
                requestAnimationFrame(function() {
                    var cellRect = cell.getBoundingClientRect();
                    var viewportRect = viewport.getBoundingClientRect();
                    // Check if cell is visible in viewport
                    var isVisible = cellRect.left >= viewportRect.left && cellRect.right <= viewportRect.right;
                    if (!isVisible) {
                        // Scroll the cell into view, centered in the viewport if possible
                        var scrollLeft = cell.offsetLeft - viewport.clientWidth / 2 + cell.offsetWidth / 2;
                        viewport.scrollLeft = Math.max(0, scrollLeft);
                    }
                });
                // Add timer for current room
                if (pathStep.room.type !== 'start' && pathStep.room.type !== 'exit') {
                    var timeRemaining = Math.max(0, (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress.nextRoomTime - currentTime);
                    var totalTime = pathStep.room.baseDuration * 1000;
                    var progress = Math.max(0, 1 - timeRemaining / totalTime);
                    var secondsLeft = Math.ceil(timeRemaining / 1000);
                    var timerElement = document.createElement('div');
                    timerElement.className = 'absolute bottom-1 right-1 w-5 h-5 flex items-center justify-center z-20 rounded-full';
                    timerElement.style.pointerEvents = 'none'; // Ensure it doesn't block interactions
                    timerElement.innerHTML = '\n                        <svg class="timer-circle-grid" width="20" height="20" style="display: block;">\n                            <circle cx="10" cy="10" r="8" fill="none" stroke="#333333AA" stroke-width="5"/>\n                            <circle cx="10" cy="10" r="8" fill="none" stroke="#ffd700CC" stroke-width="2"\n                                    stroke-dasharray="'.concat(2 * Math.PI * 8, '"\n                                    stroke-dashoffset="').concat(2 * Math.PI * 8 * (1 - progress), '"\n                                    transform="rotate(-90 10 10)"\n                                    style="transition: stroke-dashoffset 0.5s ease"/>\n                        </svg>\n                    ');
                    //console.log('Adding timer element with progress:', progress, 'timeRemaining:', timeRemaining, 'totalTime:', totalTime);
                    cell.appendChild(timerElement);
                }
            } else // Check if raid is completed - if so, mark uncompleted rooms with X
            if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidCompleted) {
                cell.classList.add('failed-room');
                // Add X mark for uncompleted rooms
                if (pathStep.room.type !== 'start' && pathStep.room.type !== 'exit' && index > 0) {
                    var failedMark = document.createElement('div');
                    failedMark.className = '';
                    failedMark.innerHTML = "\u2717";
                    failedMark.className += ' absolute bottom-1 right-1 bg-red-500/80 text-white w-5 h-5 rounded-full flex items-center justify-center text-xs font-bold ring-2 ring-black';
                    cell.appendChild(failedMark);
                }
            } else {
                cell.classList.add('upcoming-room');
                // Add step number or dash for upcoming rooms
                if (pathStep.room.type !== 'start' && pathStep.room.type !== 'exit' && index > 0) {
                    var pathNumber = document.createElement('div');
                    pathNumber.className = '';
                    // Show dash for roads, step number for gates/hazards
                    if (pathStep.room.type === 'road') {
                        pathNumber.textContent = "\u22C5";
                        pathNumber.className += ' absolute bottom-1 right-1 bg-gray-600/80 text-white w-5 h-5 rounded-full flex items-center justify-center text-xs font-bold ring-2 ring-black';
                    } else {
                        pathNumber.textContent = (0, $1249ab814b7054d4$export$86025a0d632dc830)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath, index);
                        pathNumber.className += ' absolute bottom-1 right-1 bg-white/80 text-gray-800 w-5 h-5 rounded-full flex items-center justify-center text-xs font-bold ring-2 ring-black';
                    }
                    cell.appendChild(pathNumber);
                }
            }
        }
    });
}
function $3f29ea4265abff3b$export$1967c0c6b54773a5(regionTier, room) {
    var includeCredits = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    var lootItemsHtml = '<div class="grid grid-cols-3 gap-2">';
    // SECTION 1: Skill-Check Event Loot (Gates & Hazards Only)
    if (room.type === 'gate' || room.type === 'hazard') {
        var allEvents = (0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$f152896064e09913).concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$9435522665f2dda4), (0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$1cd1fab9b9844b76));
        // Get events matching room's primary and support skills
        var relevantSkills = new Set([
            room.primary
        ].concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)(room.support || [])));
        var roomEvents = allEvents.filter(function(event) {
            return relevantSkills.has(event.relatedSkillId);
        });
        if (roomEvents.length > 0) {
            // Build skill-specific header
            var skillArray = [
                room.primary
            ].concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)(room.support || []));
            var skillNames = (0, $ca7af38ea7b7b4a8$export$7c6f492816bf045e)(skillArray);
            var skillList = skillNames.length > 0 ? skillNames.join(', ') : 'Related skills';
            lootItemsHtml += '<div class="col-span-3 text-sm border-b pb-1 mb-1">Materials related to:<br/><span class="font-bold">'.concat(skillList, "</span></div>");
            lootItemsHtml += '<div class="col-span-3 text-xs text-gray-400 italic mb-1">Chance to find each rarity in this room (events must succeed):</div>';
            // Effective per-room chance of each rarity across all loot mechanics
            var rarityChances = (0, $52a7294453bdb6d1$export$8f7497017a33a708)(regionTier, room);
            var rarities = [
                'common',
                'uncommon',
                'rare',
                'epic',
                'legendary',
                'unique'
            ];
            rarities.forEach(function(rarity) {
                var dropChance = rarityChances[rarity] || 0;
                var itemPool = (0, $52a7294453bdb6d1$export$ded25040c5f0ed12)(room, regionTier, rarity);
                if (itemPool.length > 0 && dropChance > 0) {
                    var quantityRange = (0, $8bda0cb20f0b197d$export$540736c4d7813ac)(rarity, regionTier, room.type);
                    // Handle both numeric and object quantity ranges
                    var qtyDisplay = '';
                    if (typeof quantityRange === 'number') qtyDisplay = "".concat(quantityRange);
                    else if (quantityRange && 'max' in quantityRange && 'min' in quantityRange) qtyDisplay = quantityRange.max != quantityRange.min ? "".concat(quantityRange.min, "-").concat(quantityRange.max) : "".concat(quantityRange.min);
                    var pct = Math.round(dropChance * 100);
                    var pctDisplay = pct < 1 ? '<1%' : "".concat(pct, "%");
                    var rarityConfig = $979b99378be707cd$export$d4a72d069095e9e5[rarity];
                    if (rarityConfig) {
                        lootItemsHtml += '<div class="text-xs" style="color: '.concat(rarityConfig.color, '">').concat(rarityConfig.name, "</div>");
                        lootItemsHtml += '<div class="col-span-2 text-xs" style="color: '.concat(rarityConfig.color, '">').concat(pctDisplay, " chance \u2192 ").concat(qtyDisplay, " items</div>");
                    }
                }
            });
        }
    }
    // SECTION 2: Fishing Loot (Water Rooms Only)
    if (room.type === 'water') {
        lootItemsHtml += '<div class="col-span-3 font-bold text-sm border-b pb-1 mb-1">\uD83C\uDFA3 Fishing</div>';
        lootItemsHtml += '<div class="text-xs">Fish spawn every 15s</div>';
        lootItemsHtml += '<div class="col-span-2 text-xs">~'.concat(Math.floor(room.baseDuration / 15), " Fish available</div>");
    }
    // SECTION 3: Credits
    if (includeCredits && (room.type === 'gate' || room.type === 'hazard')) {
        var minCredits = 40 + regionTier * 35;
        var maxCredits = minCredits + 75;
        lootItemsHtml += '<div class="col-span-3 font-bold text-sm border-b pb-1 mb-1">\uD83D\uDCB0 Credits</div>';
        lootItemsHtml += '<div class="col-span-3 text-xs">'.concat(minCredits, "-").concat(maxCredits, "</div>");
    }
    lootItemsHtml += '</div>';
    return lootItemsHtml;
}
function $3f29ea4265abff3b$export$96635d91a6ab659a() {
    // Before the early return: the grid's status is not the start button's
    // business, and a screen without that button still has a grid to stamp.
    $3f29ea4265abff3b$export$2d4508142cc72b6e();
    // Update start raid button with energy info or reset option
    var startBtn = document.getElementById('start-raid');
    if (!startBtn) return;
    // Reset button classes
    startBtn.classList.remove('!bg-green-500', '!bg-gray-500', '!bg-gradient-to-r', '!from-amber-500', '!to-amber-600', 'foil-card', 'complete-raid-btn');
    // Hide/show cancel raid button based on raid completion status
    var cancelBtn = document.getElementById('cancel-raid');
    if (cancelBtn) {
        if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidCompleted || (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress) {
            cancelBtn.classList.add('hidden');
            startBtn.classList.remove('mr-0', 'rounded-tr-none', 'rounded-br-none');
        } else {
            cancelBtn.classList.remove('hidden');
            startBtn.classList.add('mr-0', 'rounded-tr-none', 'rounded-br-none');
        }
    }
    // If raid was completed, show reset button instead
    if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidCompleted) {
        startBtn.disabled = false;
        startBtn.textContent = 'Complete Raid';
        // No text colour here: `.start-raid-btn` already sets #1a1a2e, which is
        // what the old `text-navy` was reaching for. There is no `navy` in
        // tailwind.config.js, so that class emitted nothing — and it was absent
        // from the reset list above, so it stuck to the button for every later
        // state. Dead and leaky; the base class was doing the work all along.
        startBtn.classList.add('!bg-gradient-to-r', '!from-amber-500', '!to-amber-600', 'foil-card', 'complete-raid-btn');
        startBtn.onclick = function() {
            $3f29ea4265abff3b$export$8dc8f2c13318a5b7();
            (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
        };
    } else if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress) {
        startBtn.disabled = true;
        startBtn.textContent = 'Raid in Progress';
    } else if (!(0, $1249ab814b7054d4$export$a678af82bf766611)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath, (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid)) {
        // Check if path is valid (starts at start, ends at exit)
        startBtn.disabled = true;
        startBtn.classList.add('!bg-gray-500'); // Override with Tailwind gray
        startBtn.textContent = 'Incomplete Path';
        startBtn.onclick = $3f29ea4265abff3b$export$bb6b71fe7f08b971;
    } else {
        var region = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid.region;
        var tier = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid.tier;
        var energyCost = (0, $1249ab814b7054d4$export$78de3bc967b7be)(tier, (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath);
        startBtn.disabled = true;
        startBtn.textContent = 'Start';
        // Check energy
        if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player.energy < energyCost) {
            startBtn.disabled = true;
            startBtn.textContent = "Need\u26A1".concat(energyCost);
        } else {
            startBtn.disabled = false;
            startBtn.textContent = "Start\u26A1".concat(energyCost);
        }
        startBtn.onclick = $3f29ea4265abff3b$export$bb6b71fe7f08b971;
    }
}
function $3f29ea4265abff3b$export$8dc8f2c13318a5b7() {
    // Refresh contractor pool with new skill levels based on player progression
    (0, $670e0f14fa02ad13$export$aca974319671fb3e)();
    (0, $1249ab814b7054d4$export$fae9674fe5380657)();
    // Hide raid grid, log, and raid active section; show region selection
    var elemIds = [
        'raid-grid-section',
        'raid-team',
        'raid-active'
    ];
    elemIds.forEach(function(id) {
        var el = document.getElementById(id);
        if (el) el.classList.add('hidden');
    });
    var setupEl = document.getElementById('raid-setup');
    if (setupEl) setupEl.classList.remove('hidden');
    // Clear raid dimming from all grid cells
    var grid = document.getElementById('raid-grid');
    if (grid) grid.querySelectorAll('.grid-cell').forEach(function(cell) {
        cell.classList.remove('raid-dimmed');
    });
    // Reset region selector
    $3f29ea4265abff3b$export$d6f634bba1273a2b();
    var genGridBtn = document.getElementById('generate-grid');
    if (genGridBtn) genGridBtn.disabled = true;
    // Show cancel button again (will be hidden/shown as needed by updateRaidButtonStates)
    var cancelBtn = document.getElementById('cancel-raid');
    if (cancelBtn) cancelBtn.classList.remove('hidden');
    // Update UI - the slider/tiles re-render with the previous selections
    // still applied (kept through resetRaidCore), so the info panel and
    // Generate button must reflect them too
    $3f29ea4265abff3b$export$b70ccd83fb3eaefa();
    $3f29ea4265abff3b$export$68c4600b33dd0ca8();
    $3f29ea4265abff3b$export$96635d91a6ab659a();
    (0, $59924438766e7d8e$export$d1c957a54f7124bc)();
    (0, $59924438766e7d8e$export$5d55f9eae051c4dc)();
    (0, $59924438766e7d8e$export$98a6c6e9bfe86f10)();
    (0, $59924438766e7d8e$export$6a940d9b4a9b252a)();
    (0, $b5bda7fdec806d8b$export$c7def531c087da85)('Raid reset - previous region and tier are still selected', 'info');
}
function $3f29ea4265abff3b$export$8f8ffb9ff36daf30() {
    var _gameState_currentRaid;
    var raidInProgress = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172) === null || (0, $fe47a452a83d9e00$export$8e361a1ffbebf172) === void 0 ? void 0 : (_gameState_currentRaid = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid) === null || _gameState_currentRaid === void 0 ? void 0 : _gameState_currentRaid.raidInProgress;
    var logEntries = document.getElementById('log-entries');
    if (!raidInProgress || !raidInProgress.logEntries || !logEntries) return;
    // Clear current entries
    logEntries.innerHTML = '';
    // Restore saved entries
    raidInProgress.logEntries.forEach(function(logEntry) {
        var entry = document.createElement('div');
        entry.className = "log-entry log-".concat(logEntry.type);
        entry.textContent = logEntry.message;
        logEntries.appendChild(entry);
    });
    // Scroll to bottom
    logEntries.scrollTop = logEntries.scrollHeight;
}
function $3f29ea4265abff3b$export$20c4edcabec24020(info) {
    // The team is off the map the moment the raid ends — win or lose, the
    // result markers are what the completed grid is saying now.
    (0, $bfcb035c6f32f2dc$export$2eefc97a05b1cdd3)(null);
    var grid = document.getElementById('raid-grid');
    if (!grid || !info.selectedPath) return;
    // Create path coordinate set for quick lookup
    var pathCoords = new Set();
    info.selectedPath.forEach(function(step) {
        pathCoords.add("".concat(step.row, "-").concat(step.col));
    });
    // First, dim all non-path rooms
    grid.querySelectorAll('.grid-cell').forEach(function(cell) {
        var row = cell.getAttribute('data-row');
        var col = cell.getAttribute('data-col');
        var coord = "".concat(row, "-").concat(col);
        if (!pathCoords.has(coord)) cell.classList.add('raid-dimmed');
        else cell.classList.remove('raid-dimmed');
    });
    // Find the last attempted room (last room with a result)
    var lastAttemptedIndex = -1;
    for(var i = info.selectedPath.length - 1; i >= 0; i--)if (info.selectedPath[i].room.result) {
        lastAttemptedIndex = i;
        break;
    }
    info.selectedPath.forEach(function(pathStep, index) {
        var cell = grid.querySelector('[data-row="'.concat(pathStep.row, '"][data-col="').concat(pathStep.col, '"]'));
        if (cell) {
            // Remove all existing classes
            cell.classList.remove('current-room', 'completed-room', 'upcoming-room', 'failed-room');
            // Add click handler to scroll to this step in the path display
            cell.style.cursor = 'pointer';
            cell.onclick = function() {
                return $3f29ea4265abff3b$export$3de9c504cadcc6ea(index);
            };
            // Remove existing path number or timer elements
            var existingElements = cell.querySelectorAll('.path-number, [class*="absolute bottom-1 right-1"]');
            existingElements.forEach(function(element) {
                return element.remove();
            });
            // Skip start portal
            if (pathStep.room.type === 'start' || pathStep.room.type == 'exit') return;
            // Check if this room was attempted (has a result)
            if (pathStep.room.result) {
                var success = pathStep.room.result.success;
                if (success) cell.classList.add('completed-room');
                else cell.classList.add('failed-room');
                // Add result indicator for non-exit rooms
                var completedMark = document.createElement('div');
                completedMark.className = 'path-number';
                completedMark.innerHTML = success ? "\u2713" : "\u2717";
                var bgColor = success ? 'bg-green-500/40' : 'bg-red-500/40';
                completedMark.className += " !absolute !bottom-1 !right-1 ".concat(bgColor, " !text-white !w-5 !h-5 !rounded-full !flex !items-center !justify-center !text-xs !font-bold !z-10 !ring-2 !ring-black");
                cell.appendChild(completedMark);
            } else if (!info.raidSuccess && index > lastAttemptedIndex) {
                // If raid failed and this room is after the last attempted room, mark as unattempted/failed
                cell.classList.add('failed-room');
                var completedMark1 = document.createElement('div');
                completedMark1.className = 'path-number';
                completedMark1.innerHTML = "\u2717";
                completedMark1.className += " !absolute !bottom-1 !right-1 !bg-red-500/40 !text-white !w-5 !h-5 !rounded-full !flex !items-center !justify-center !text-xs !font-bold !z-10 !ring-2 !ring-black";
                cell.appendChild(completedMark1);
            }
        }
    });
}






// Cache of last synced character state for change detection
var $dd2eed17ca70a8a9$var$lastSyncedCharacterState = null;
function $dd2eed17ca70a8a9$export$25f0d7933e956edb(character) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var currentSnapshot, response, _, _tmp, error;
        return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!character) return [
                        2
                    ];
                    // Create snapshot of relevant character fields for comparison.
                    // Keys are snake_case to match the DB columns the PUT endpoint writes.
                    currentSnapshot = {
                        name: character.name,
                        faction: character.faction,
                        skills: character.skills,
                        synergy_unlocks: character.synergyUnlocks,
                        skill_points: character.skillPoints,
                        max_hp: character.maxHp,
                        current_hp: character.currentHp,
                        level: character.level,
                        xp: character.xp,
                        xp_to_next: character.xpToNext,
                        avatar: character.avatar,
                        avatar_seed: character.avatarSeed,
                        avatar_features: character.avatarFeatures,
                        title: character.title,
                        quote: character.quote,
                        inventory: character.inventory,
                        artifacts: character.artifacts,
                        equipped_artifacts: character.equippedArtifacts,
                        equipped_technique_gear: character.equippedTechniqueGear
                    };
                    // Check if there are actual changes
                    if ($dd2eed17ca70a8a9$var$lastSyncedCharacterState && JSON.stringify($dd2eed17ca70a8a9$var$lastSyncedCharacterState) === JSON.stringify(currentSnapshot)) return [
                        2
                    ]; // No changes, skip API call
                    if (!character.multiplayerId) {
                        (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, 'Saved character sync state. Skipping sync call');
                        $dd2eed17ca70a8a9$var$lastSyncedCharacterState = currentSnapshot;
                        return [
                            2
                        ]; // Only sync characters registered with multiplayer
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        ,
                        7
                    ]);
                    return [
                        4,
                        fetch('/api/characters', {
                            method: 'PUT',
                            headers: (0, $fa9769297b8a68c8$export$71511d61b312f219)({
                                'Content-Type': 'application/json'
                            }, character.ownerToken ? {
                                'Authorization': "Bearer ".concat(character.ownerToken)
                            } : {}),
                            body: JSON.stringify((0, $fa9769297b8a68c8$export$71511d61b312f219)({
                                id: character.multiplayerId
                            }, currentSnapshot))
                        })
                    ];
                case 2:
                    response = _state.sent();
                    if (!response.ok) return [
                        3,
                        3
                    ];
                    // Update cache only after successful sync
                    $dd2eed17ca70a8a9$var$lastSyncedCharacterState = currentSnapshot;
                    return [
                        3,
                        5
                    ];
                case 3:
                    _ = console.warn;
                    _tmp = [
                        'Failed to sync character to database:'
                    ];
                    return [
                        4,
                        response.text()
                    ];
                case 4:
                    _.apply(console, _tmp.concat([
                        _state.sent()
                    ]));
                    _state.label = 5;
                case 5:
                    return [
                        3,
                        7
                    ];
                case 6:
                    error = _state.sent();
                    console.warn('Error syncing character to database:', error);
                    return [
                        3,
                        7
                    ];
                case 7:
                    return [
                        2
                    ];
            }
        });
    })();
}
function $dd2eed17ca70a8a9$export$384cd953322e3851() {
    try {
        var saveData = (0, $fe47a452a83d9e00$export$e12c04bc0206ba64)();
        (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, 'Saving game state...', saveData);
        localStorage.setItem('idleExtractionSave', JSON.stringify(saveData));
        //console.log('Game saved successfully');
        //console.log('Saved data:', saveData);
        // Sync character to database (async, non-blocking)
        if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character) $dd2eed17ca70a8a9$export$25f0d7933e956edb((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character);
        return true;
    } catch (error) {
        console.error('Save failed:', error);
        return false;
    }
}
function $dd2eed17ca70a8a9$export$756e5d66bdd28395() {
    try {
        var loaded = false;
        var lastLoaded = Date.now();
        var legacyReset = false;
        var saveData = localStorage.getItem('idleExtractionSave');
        if (saveData) {
            (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, 'Save data found');
            var parsed = JSON.parse(saveData);
            if (parsed.gameState) {
                var knownSkillIds = new Set(Object.values($979b99378be707cd$export$aeeef991191508e2 || {}).flatMap(function(f) {
                    return Object.keys(f.skills || {});
                }));
                if ((0, $fe47a452a83d9e00$export$e178d880fd9e46ee)(parsed, knownSkillIds)) {
                    // Pre-overhaul save: the redesign renamed skills and replaced
                    // ~90% of items, so it cannot be faithfully migrated. Archive
                    // it (recoverable) and start fresh with a one-time notice.
                    console.warn('Legacy (pre-overhaul) save detected - archiving and starting fresh');
                    try {
                        localStorage.setItem('idleExtractionSave_legacyBackup', saveData);
                    } catch (e) {}
                    localStorage.removeItem('idleExtractionSave');
                    legacyReset = true;
                } else {
                    (0, $fe47a452a83d9e00$export$5a216aa68e49a7fc)(parsed);
                    loaded = true;
                    lastLoaded = parsed.timestamp;
                }
            }
        }
        if (!loaded) (0, $fe47a452a83d9e00$export$5a216aa68e49a7fc)({
            "gameState": (0, $fe47a452a83d9e00$export$8e361a1ffbebf172)
        });
        if (legacyReset) (0, $b5bda7fdec806d8b$export$c7def531c087da85)("\uD83D\uDE80 Idle Raiders got a major overhaul \u2014 your old save was incompatible and has been archived. Starting fresh!", 'info');
        // Add avatar to player character if missing
        if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character && !(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.avatar) (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.avatar = (0, $ca7af38ea7b7b4a8$export$913078032f14f7f)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.faction);
        // Backfill procedural avatar seed (stable character id) for old saves.
        if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character && !(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.avatarSeed) (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.avatarSeed = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.id;
        // Refresh Alpine store if available
        (0, $80ed874fd909c4ae$export$5b73e6a29e58b929)();
        (0, $da6f71b8677b901e$export$2e2bcd8739ae039).store('contractors').refresh();
        // Validate raidOwnerId - if it references a non-existent character, clear raid data
        if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidOwnerId) {
            var raidOwnerExists = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).characters.some(function(c) {
                return c.id === (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidOwnerId;
            });
            if (!raidOwnerExists) {
                console.warn('Invalid raidOwnerId found, clearing raid data');
                (0, $3f29ea4265abff3b$export$8dc8f2c13318a5b7)();
                $dd2eed17ca70a8a9$export$384cd953322e3851();
            }
        }
        // Update contractors if character exists but no contractors generated
        if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character && (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).contractors.length === 0) (0, $670e0f14fa02ad13$export$aca974319671fb3e)();
        // Process offline progress
        var timeDiff = Date.now() - lastLoaded;
        (0, $670e0f14fa02ad13$export$3e71fa030a894242)(timeDiff);
        $dd2eed17ca70a8a9$export$384cd953322e3851();
        if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character && (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.faction) document.body.classList.add((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.faction);
        return true;
    } catch (error) {
        console.error('Load failed:', error);
        return false;
    }
}








function $a575049a7e5cb3a1$export$1d6271c3715ff9d3() {
    if (!(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character) return;
    // Not gated: this path DISCARDS the character's whole inventory. It should
    // be loud if it ever fires unexpectedly.
    console.warn("initializeInventory: clearing inventory for ".concat((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.name));
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.inventory = {};
    // Refresh Alpine store if available
    if (0, $80ed874fd909c4ae$export$5b73e6a29e58b929) (0, $80ed874fd909c4ae$export$5b73e6a29e58b929)();
}
function $a575049a7e5cb3a1$export$28b75a4bedf6475d(itemId) {
    var _gameState_character_artifacts, _gameState_character;
    // Check if it's a crafted artifact.
    //
    // ⚠ THE OPTIONAL CHAIN IS LOAD-BEARING: there is no character between
    // characters. Promotion and founding both legitimately set
    // `gameState.character = null`, and this helper is shared by the LAYER
    // pools — Command's vault, the Syndicate's dock and consignment — which
    // outlive every character by design (`inventoryManager.js` itemRows).
    //
    // Unguarded, this threw inside `refreshAlpineInventory` during
    // `loadGameState`, which aborted BOOT: a black page, and a save that failed
    // the same way on every reload afterwards. Both of the flows that reach it
    // are ordinary — promote your last character, or found a Syndicate — so the
    // account was bricked at exactly the moment a player would put the game
    // down. Found by the qa-player reload checks in §17/§35, 2026-08-05.
    if ((_gameState_character = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character) === null || _gameState_character === void 0 ? void 0 : (_gameState_character_artifacts = _gameState_character.artifacts) === null || _gameState_character_artifacts === void 0 ? void 0 : _gameState_character_artifacts.some(function(artifact) {
        return artifact.id === itemId;
    })) return 'artifact';
    // Check in itemTable for the item's type
    var item = (0, $ca7af38ea7b7b4a8$export$a2dea178c28a0308)('id', itemId);
    if (item) return item.type;
    // Check if it's a blueprint
    if (itemId.includes('-blueprint')) return 'blueprint';
    return 'material'; // Default type
}
function $a575049a7e5cb3a1$export$3702bf1024e2bfe4(factionKey) {
    var _config_factionSkills_factionKey;
    return ((_config_factionSkills_factionKey = $979b99378be707cd$export$aeeef991191508e2[factionKey]) === null || _config_factionSkills_factionKey === void 0 ? void 0 : _config_factionSkills_factionKey.icon) || '';
}
function $a575049a7e5cb3a1$export$b5651c43e62deea0(factionKey) {
    var _config_factionSkills_factionKey;
    return ((_config_factionSkills_factionKey = $979b99378be707cd$export$aeeef991191508e2[factionKey]) === null || _config_factionSkills_factionKey === void 0 ? void 0 : _config_factionSkills_factionKey.name) || '';
}
function $a575049a7e5cb3a1$export$af5e2922249239fd(tier) {
    var _config_itemRarities_tier;
    // Use itemRarities color scheme
    if (tier == 'currency') return '#ffd700';
    var rarityColor = (_config_itemRarities_tier = $979b99378be707cd$export$d4a72d069095e9e5[tier]) === null || _config_itemRarities_tier === void 0 ? void 0 : _config_itemRarities_tier.color;
    return rarityColor || '#9ca3af'; // Default to common
}
function $a575049a7e5cb3a1$export$e9db1543c5540d63(tier) {
    // Define sorting order for tiers (higher number = higher priority)
    var tierOrder = {
        'unique': 6,
        'legendary': 5,
        'epic': 4,
        'rare': 3,
        'common': 2,
        'currency': 1
    };
    return tierOrder[tier] || 0;
}
function $a575049a7e5cb3a1$export$86e4cd2f7b0dca8(type) {
    // Return color schemes for different item categories
    var itemTypeColors = {
        'material': {
            header: 'from-stone-600 to-stone-700',
            button: 'from-stone-600 to-stone-700 hover:from-stone-700 hover:to-stone-800'
        },
        'consumable': {
            header: 'from-green-600 to-green-700',
            button: 'from-green-600 to-green-700 hover:from-green-700 hover:to-green-800'
        },
        'blueprint': {
            header: 'from-blue-600 to-blue-700',
            button: 'from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800'
        },
        'relic': {
            header: 'from-purple-600 to-purple-700',
            button: 'from-purple-600 to-purple-700 hover:from-purple-700 hover:to-purple-800'
        },
        'storyRelic': {
            header: 'from-yellow-600 to-yellow-700',
            button: 'from-yellow-600 to-yellow-700 hover:from-yellow-700 hover:to-yellow-800'
        }
    };
    return itemTypeColors[type] || {
        header: 'from-gray-600 to-gray-700',
        button: 'from-gray-600 to-gray-700 hover:from-gray-700 hover:to-gray-800'
    };
}
function $a575049a7e5cb3a1$export$2e11c6c919ff347e(tier) {
    // Return header color schemes for different item tiers/rarities
    var tierHeaderColors = {
        'common': 'from-gray-500 to-gray-600',
        'uncommon': 'from-green-500 to-green-600',
        'rare': 'from-blue-600 to-blue-700',
        'epic': 'from-purple-600 to-purple-700',
        'legendary': 'from-yellow-600 to-yellow-700',
        'unique': 'from-orange-600 to-orange-700',
        'currency': 'from-yellow-600 to-yellow-700'
    };
    return tierHeaderColors[tier] || 'from-gray-600 to-gray-700';
}
function $a575049a7e5cb3a1$export$c194f198e80011d8(items) {
    return items.sort(function(a, b) {
        var aData = (0, $ca7af38ea7b7b4a8$export$a2dea178c28a0308)('name', a.name);
        var bData = (0, $ca7af38ea7b7b4a8$export$a2dea178c28a0308)('name', b.name);
        var aRarity = (aData === null || aData === void 0 ? void 0 : aData.rarity) || 'common';
        var bRarity = (bData === null || bData === void 0 ? void 0 : bData.rarity) || 'common';
        // First sort by tier priority (higher tier first)
        var tierDiff = $a575049a7e5cb3a1$export$e9db1543c5540d63(bRarity) - $a575049a7e5cb3a1$export$e9db1543c5540d63(aRarity);
        if (tierDiff !== 0) return tierDiff;
        // Then sort alphabetically by name
        return a.name.localeCompare(b.name);
    });
}
function $a575049a7e5cb3a1$export$683d0f4498a367f2(categoryKey) {
    // Update tab buttons
    document.querySelectorAll('.inventory-tab-btn').forEach(function(btn) {
        btn.classList.remove('active');
        if (btn.dataset.category === categoryKey) btn.classList.add('active');
    });
    // Update content panels
    document.querySelectorAll('.inventory-category').forEach(function(panel) {
        panel.classList.remove('active');
        if (panel.dataset.category === categoryKey) panel.classList.add('active');
    });
}
function $a575049a7e5cb3a1$export$dbdf3132d4782af0(itemId) {
    var _gameState_currentRaid;
    // Check if current character exists and is on marketplace
    if (!(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character) {
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)('No active character!', 'error');
        return;
    }
    // //@ts-ignore - character is checked above
    var char = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character;
    if (char.isMarketplace) {
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)('Cannot use items with a character that is contracted out on the marketplace', 'error');
        return;
    }
    if (!char.inventory[itemId] || char.inventory[itemId] <= 0) {
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)('You don\'t have any of this item!', 'error');
        return;
    }
    // Get consumable data
    var itemData = (0, $ca7af38ea7b7b4a8$export$a2dea178c28a0308)('id', itemId);
    if (!itemData || itemData.type !== 'consumable') {
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)('This item cannot be used!', 'error');
        return;
    }
    // Classify by the item's restore fields; technique consumables (epic,
    // effects-based) have neither and are deployed automatically in raids
    var isEnergyConsumable = !!itemData.restoresEnergy;
    var isHpConsumable = !!itemData.restoresHp;
    if (!isEnergyConsumable && !isHpConsumable) {
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)('Technique consumables rig automatically on their technique\'s first success during a raid', 'info');
        return;
    }
    // Check raid state
    var isRaidActive = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid && ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress || (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid);
    // RESTRICTION 1: Energy consumables can ONLY be used before raid starts
    if (isEnergyConsumable) {
        if (isRaidActive) {
            (0, $b5bda7fdec806d8b$export$c7def531c087da85)('Energy consumables can only be used before starting a raid!', 'error');
            return;
        }
    }
    // RESTRICTION 2: HP consumables can be used before raid OR at campsite during raid
    if (isHpConsumable && ((_gameState_currentRaid = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid) === null || _gameState_currentRaid === void 0 ? void 0 : _gameState_currentRaid.raidInProgress) && !$a575049a7e5cb3a1$export$32cc43b5b1b4dc0e()) {
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)('HP consumables can only be used at a campsite during a raid!', 'error');
        return;
    }
    var used = false;
    var healAmount = 0;
    var energyAmount = 0;
    // Apply consumable effects based on type
    if (isHpConsumable) {
        if (char.currentHp < char.maxHp) {
            // Use specific value from item definition, or fallback to default
            healAmount = itemData.restoresHp || 35;
            char.currentHp = Math.min(char.maxHp, char.currentHp + healAmount);
            (0, $b5bda7fdec806d8b$export$c7def531c087da85)("Used ".concat(itemData.name, "! Restored ").concat(healAmount, " HP."), 'success');
            used = true;
        } else (0, $b5bda7fdec806d8b$export$c7def531c087da85)('Your health is already full!', 'info');
    } else if (isEnergyConsumable) {
        if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player && (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player.energy < (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player.maxEnergy) {
            // Use specific value from item definition, or fallback to default
            energyAmount = itemData.restoresEnergy || 30;
            (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player.energy = Math.min((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player.maxEnergy, (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player.energy + energyAmount);
            (0, $b5bda7fdec806d8b$export$c7def531c087da85)("Used ".concat(itemData.name, "! Restored ").concat(energyAmount, " energy."), 'success');
            used = true;
        } else (0, $b5bda7fdec806d8b$export$c7def531c087da85)('Your energy is already full!', 'info');
    }
    if (used) {
        char.inventory[itemId]--;
        if (char.inventory[itemId] <= 0) delete char.inventory[itemId];
        // Update Alpine store if available
        if (0, $80ed874fd909c4ae$export$5b73e6a29e58b929) (0, $80ed874fd909c4ae$export$5b73e6a29e58b929)();
        (0, $59924438766e7d8e$export$d1c957a54f7124bc)();
        (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
    }
}
function $a575049a7e5cb3a1$export$e1c01f683feb5181(itemId) {
    if (!(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.inventory[itemId] || (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.inventory[itemId] <= 0) {
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)('You don\'t have any of this item to sell!', 'error');
        return;
    }
    // Get item data to determine sell price
    var itemData = (0, $ca7af38ea7b7b4a8$export$a2dea178c28a0308)('id', itemId);
    if (!itemData) {
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)('This item cannot be sold!', 'error');
        return;
    }
    // Get sell price from itemTable
    var sellPrice = 0;
    if (itemData.credits) sellPrice = itemData.credits;
    else {
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)("Cannot sell ".concat(itemData.name, " for credits"), 'error');
        return;
    }
    // Sell the quantity chosen via the +/- controls (defaults to 1)
    var qtyInput = document.getElementById("sell-qty-".concat(itemId));
    var quantity = Math.min(parseInt(qtyInput === null || qtyInput === void 0 ? void 0 : qtyInput.value) || 1, (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.inventory[itemId]);
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.inventory[itemId] -= quantity;
    if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.inventory[itemId] <= 0) delete (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.inventory[itemId];
    // Add credits to player
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player.credits += sellPrice * quantity;
    // Update Alpine store if available
    (0, $80ed874fd909c4ae$export$5b73e6a29e58b929)();
    // Show notification
    (0, $b5bda7fdec806d8b$export$c7def531c087da85)("Sold ".concat(quantity, "x ").concat(itemData.name, " for ").concat(sellPrice * quantity, " credits"), 'success');
    // Update UI and save
    (0, $59924438766e7d8e$export$d1c957a54f7124bc)();
    (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
}
function $a575049a7e5cb3a1$export$dba564f0cb325527(itemId) {
    if (!(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character) {
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)('No active character!', 'error');
        return;
    }
    if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.isMarketplace) {
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)('Cannot purchase items with a character that is contracted out on the marketplace', 'error');
        return;
    }
    // Get item data to determine purchase price
    var itemData = (0, $ca7af38ea7b7b4a8$export$a2dea178c28a0308)('id', itemId);
    if (!itemData || itemData.type !== 'consumable') {
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)('This item cannot be purchased!', 'error');
        return;
    }
    // Check if item has a credit cost
    if (!itemData.credits) {
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)("Cannot purchase ".concat(itemData.name, " for credits"), 'error');
        return;
    }
    // Energy consumables escalate with today's purchase count (credit sink)
    var purchasePrice = (0, $8bda0cb20f0b197d$export$1214c02c27df458d)(itemData, (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player);
    // Check if player has enough credits
    if (!(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player || (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player.credits < purchasePrice) {
        var _gameState_player;
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)("Not enough credits! Need ".concat(purchasePrice, ", have ").concat(((_gameState_player = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player) === null || _gameState_player === void 0 ? void 0 : _gameState_player.credits) || 0), 'error');
        return;
    }
    // Deduct credits from player
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player.credits -= purchasePrice;
    if (itemData.restoresEnergy) (0, $8bda0cb20f0b197d$export$cfff9bc32ab6cb78)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player);
    // Add item to inventory
    if (!(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.inventory[itemId]) (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.inventory[itemId] = 0;
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.inventory[itemId]++;
    // Update Alpine store if available
    (0, $80ed874fd909c4ae$export$5b73e6a29e58b929)();
    // Re-render the purchase grid if the modal is open: energy prices escalate
    // per purchase, so stale BUY labels would understate the next charge
    var purchaseModal = document.getElementById('purchase-consumables-modal');
    if (purchaseModal && !purchaseModal.classList.contains('hidden')) $a575049a7e5cb3a1$export$1690b2b2efa58f74();
    // Show notification
    (0, $b5bda7fdec806d8b$export$c7def531c087da85)("Purchased ".concat(itemData.name, " for ").concat(purchasePrice, " credits"), 'success');
    // Update UI and save
    (0, $59924438766e7d8e$export$d1c957a54f7124bc)();
    (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
}
function $a575049a7e5cb3a1$export$4ac7f915da1fa1c4(item) {
    var mode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'inventory', recipe = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, preComputedMaterials = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, options = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
    var isArtifact = item.type === 'artifact';
    var isSkillGear = item.type === 'techGear' || item.type === 'consumable' && item.rarity === 'epic';
    var isConsumable = item.type === 'consumable';
    var itemData = mode == 'inventory' ? isArtifact ? (0, $ca7af38ea7b7b4a8$export$891bd687a67340b8)('id', item.id) : (0, $ca7af38ea7b7b4a8$export$a2dea178c28a0308)('id', item.id) : item;
    (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "creating card for item: ", item, mode, itemData);
    if (itemData) {
        var _gameState_character, _gameState_character1;
        var isCrafting = mode === 'crafting';
        var isPurchase = mode === 'purchase';
        // Determine card styling based on rarity in crafting mode
        var rarity = itemData.rarity || 'common';
        var rarityConfig = isCrafting ? $979b99378be707cd$export$d4a72d069095e9e5[rarity] : null;
        var cardBg, cardBorder, headerBg, headerBorder, headerText, categoryText;
        if (isCrafting && rarityConfig) {
            var _config_itemTypes_itemData_type;
            // Crafting mode with rarity colors
            var hexToTailwind = function(hex) {
                return "[".concat(hex, "]");
            };
            var color = rarityConfig.color;
            cardBg = "from-".concat(hexToTailwind(color), "/10 to-").concat(hexToTailwind(color), "/20");
            cardBorder = "border-".concat(hexToTailwind(color), "/30");
            headerBg = "from-".concat(hexToTailwind(color), "/50 to-").concat(hexToTailwind(color), "/30");
            headerBorder = "border-".concat(hexToTailwind(color), "/30");
            headerText = 'text-white';
            categoryText = ((_config_itemTypes_itemData_type = $979b99378be707cd$export$d02ea220375e4aff[itemData.type]) === null || _config_itemTypes_itemData_type === void 0 ? void 0 : _config_itemTypes_itemData_type.name) || itemData.type;
        } else if (isArtifact) {
            cardBg = 'from-amber-800 to-amber-900';
            cardBorder = 'border-amber-600';
            headerBg = 'from-amber-700 to-amber-600';
            headerBorder = 'border-amber-500';
            headerText = 'text-amber-100';
            categoryText = 'Artifact';
        } else {
            (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, itemData.type, $979b99378be707cd$export$d02ea220375e4aff);
            cardBg = 'from-gray-800 to-gray-900';
            cardBorder = 'border-gray-600';
            headerBg = $a575049a7e5cb3a1$export$2e11c6c919ff347e((itemData === null || itemData === void 0 ? void 0 : itemData.rarity) || 'tier1');
            headerBorder = 'border-gray-500';
            headerText = 'text-white';
            categoryText = $979b99378be707cd$export$d02ea220375e4aff[itemData.type].name;
        }
        // Item-specific data
        var itemName = isArtifact ? itemData.name : isCrafting ? itemData.name : itemData.name.replace(' Blueprint', '');
        var itemIcon = isArtifact ? itemData.icon || "\u26A1" : isCrafting ? itemData.icon || "\u26A1" : itemData.icon;
        var description = (!isArtifact ? itemData.short ? itemData.short : itemData.name : '') + (isSkillGear || isArtifact ? ' <span class="font-bold">' + $a575049a7e5cb3a1$export$8a26d5080d84dfb0(itemData.id) + '</span>' : '');
        var techniqueName = '';
        var techniqueIcon = '';
        if (isSkillGear) {
            var skillName = (0, $ca7af38ea7b7b4a8$export$182937d2e68a339)((0, $ca7af38ea7b7b4a8$export$a6cb179f21ae932e)(itemData.techniqueId));
            techniqueName = (0, $ca7af38ea7b7b4a8$export$b7fbae54a8f17db)(itemData.techniqueId);
            techniqueIcon = (0, $ca7af38ea7b7b4a8$export$bf5389e28ce4699d)(itemData.techniqueId);
            description = "<p class='text-blue-500 font-bold'>".concat(skillName, "</p><p class='text-green-500 font-bold'>").concat(techniqueName, "</p>").concat(description);
        } else if (isArtifact && itemData.skill) {
            var skillName1 = (0, $ca7af38ea7b7b4a8$export$182937d2e68a339)(itemData.skill);
            description = "<p class='text-blue-500 font-bold'>".concat(skillName1, "</p>").concat(description);
        }
        var quantity = isArtifact || isSkillGear ? 1 : isCrafting ? null : item.quantity;
        /**
         * What ONE of these is worth, in credits, opposite the count.
         *
         * The count answers "how many"; on the Syndicate's Stores and the
         * Command Vault that is only half the question, because Operations
         * price a manifest in CREDITS of materials (`cargoValue`) — so a dock
         * of 500 commons and one of 20 rares are worth wildly different things
         * and the count alone cannot say which fills a convoy.
         *
         * PER UNIT, not the pile's total: the pile total is just count × this,
         * and the per-unit figure is the one that survives the count changing.
         * Materials only — artifacts, gear and relics are not on the crafting
         * ladder `materialValue` derives from, and would read as 0.
         *
         * Rendered into the slot the action button leaves empty when actions
         * are hidden, so read-only screens gain it and the sell/craft flows are
         * untouched rather than gaining a third control to line up.
         */ var unitValue = itemData.type === 'material' ? (0, $00cd2a5b8f760625$export$fec63043638a29c9)(itemData.id) : 0;
        var unitValueBadge = unitValue > 0 ? '<div class="bg-gray-700 text-gray-100 px-2 py-1 rounded-full text-xs font-bold border border-gray-500 inline-block"\n                    title="'.concat(unitValue.toLocaleString(), "\uD83D\uDCB0 each").concat(quantity != null ? " \u2014 ".concat((unitValue * quantity).toLocaleString(), "\uD83D\uDCB0 for all ").concat(quantity) : '', '">').concat(unitValue.toLocaleString(), "\uD83D\uDCB0</div>") : '';
        // Faction icon for materials
        var factionKey = !isArtifact && itemData.type === 'material' ? item.faction : null;
        var factionIcon = factionKey ? $a575049a7e5cb3a1$export$3702bf1024e2bfe4(factionKey) : itemData.type === 'relic' ? $979b99378be707cd$export$d02ea220375e4aff.relic.icon : '';
        var factionName = factionKey ? $a575049a7e5cb3a1$export$b5651c43e62deea0(factionKey) : '';
        // Action buttons - check if character is on marketplace (read-only mode)
        var isReadOnly = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character && (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.isMarketplace || options.hideActions;
        var actionButton = '';
        var qtyLabel = '';
        // Equip state (any mode): drives the equipped-card highlight and the
        // gear-tab equip row. Equipping is non-destructive, so "owned" means
        // in inventory (gear) / in the crafted-artifacts list (artifacts).
        var isEquippedItem = isSkillGear && Object.values(((_gameState_character = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character) === null || _gameState_character === void 0 ? void 0 : _gameState_character.equippedTechniqueGear) || {}).some(function(g) {
            return g && (g.id === itemData.id || g === itemData.id);
        }) || isArtifact && Object.values(((_gameState_character1 = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character) === null || _gameState_character1 === void 0 ? void 0 : _gameState_character1.equippedArtifacts) || {}).some(function(a) {
            return a && a.id === itemData.id;
        });
        // Durable gear/artifacts are crafted once per character (see
        // progressionScaling.allowDuplicateCrafts). Owned => the craft control
        // becomes a "✓ CRAFTED" marker instead of an active button.
        var ownsThisItem = isSkillGear ? (0, $ee71dfe8b201c427$export$2886ceaa061d802b)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character, itemData.id) : isArtifact ? (0, $ee71dfe8b201c427$export$770281d4afda41b1)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character, itemData.id) : false;
        var alreadyCrafted = (isSkillGear || isArtifact) && ownsThisItem && !(0, $ee71dfe8b201c427$export$c95b8ce76efadccf)();
        // Crafting-mode (Gear tab) equip row: owned gear/artifacts get an
        // EQUIP/UNEQUIP control that stays visible in the collapsed view too
        // (it sits outside .card-body, which the collapse hides)
        // A crafting-mode artifact whose design isn't unlocked yet: it can't be
        // crafted or expanded - only unlocked. The unlock control takes the
        // collapsed-visible equip-row slot (same place EQUIP sits).
        var artifactLocked = isCrafting && !isReadOnly && isArtifact && !(0, $ee71dfe8b201c427$export$2ab3ae91631fe8e5)(itemData.id);
        var equipRow = '';
        if (artifactLocked) {
            var _gameState_character_inventory, _gameState_character2, _config_progressionScaling_commandMarks, _config_progressionScaling;
            var blueprintId = "".concat(itemData.id, "-blueprint");
            var hasBlueprint = (((_gameState_character2 = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character) === null || _gameState_character2 === void 0 ? void 0 : (_gameState_character_inventory = _gameState_character2.inventory) === null || _gameState_character_inventory === void 0 ? void 0 : _gameState_character_inventory[blueprintId]) || 0) > 0;
            var unlockMarks = ((_config_progressionScaling = $979b99378be707cd$export$9f9786ac427715c7) === null || _config_progressionScaling === void 0 ? void 0 : (_config_progressionScaling_commandMarks = _config_progressionScaling.commandMarks) === null || _config_progressionScaling_commandMarks === void 0 ? void 0 : _config_progressionScaling_commandMarks.perArtifactUnlock) || 0;
            var btn = hasBlueprint ? '<button class="bg-gradient-to-r from-violet-500 to-violet-600 hover:from-violet-400 hover:to-violet-500 text-white px-2 py-0.5 rounded text-xs font-bold border border-violet-400 transition-colors"\n                    title="Consume this design\'s blueprint to unlock it for your account (+'.concat(unlockMarks, ' Command Marks). Any character can then craft it from materials."\n                    onclick="unlockArtifact(\'').concat(itemData.id, "'); showCraftingModal();\">\uD83D\uDD13 UNLOCK +").concat(unlockMarks, "\uD83C\uDF96\uFE0F</button>") : '<button class="bg-gray-700 text-gray-300 px-2 py-0.5 rounded text-xs font-bold border border-gray-600 cursor-not-allowed" disabled title="This design\'s blueprint drops from Tier 3 raids">\uD83D\uDD12 NEEDS BLUEPRINT</button>';
            equipRow = '<div class="card-equip-row mx-1 flex justify-end">'.concat(btn, "</div>");
        } else if (isCrafting && !isReadOnly && !isConsumable && (isSkillGear || isArtifact)) {
            if (ownsThisItem) {
                var equipButton;
                if (isEquippedItem) {
                    var unequipCall = isArtifact ? "unequipArtifact('".concat(itemData.slot, "')") : "unequipTechniqueGear('".concat(itemData.techniqueId, "')");
                    equipButton = '<button class="bg-red-600 hover:bg-red-700 text-white px-2 py-0.5 rounded text-xs font-bold border border-red-500 transition-colors" onclick="'.concat(unequipCall, '">UNEQUIP</button>');
                } else {
                    var canEquip = isArtifact ? (0, $7ea2865b97769aa3$export$106e54bf5a9adc20) ? (0, $7ea2865b97769aa3$export$106e54bf5a9adc20)(itemData) : true : (0, $7ea2865b97769aa3$export$9e693217356d7ac4) ? (0, $7ea2865b97769aa3$export$9e693217356d7ac4)(itemData.id) : true;
                    var requirement = isArtifact ? (0, $7ea2865b97769aa3$export$56e7fec58be964ef) ? (0, $7ea2865b97769aa3$export$56e7fec58be964ef)(itemData) : '' : (0, $7ea2865b97769aa3$export$bc6c3240a6a68b89) ? (0, $7ea2865b97769aa3$export$bc6c3240a6a68b89)(itemData.id) : '';
                    var equipCall = isArtifact ? "equipArtifact('".concat(itemData.id, "')") : "equipTechniqueGear('".concat(itemData.techniqueId, "', '").concat(itemData.id, "')");
                    equipButton = canEquip ? '<button class="bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-400 hover:to-amber-500 text-amber-950 px-2 py-0.5 rounded text-xs font-bold border border-amber-400 transition-colors" title="'.concat(isSkillGear ? 'One gear piece per skill - equipping swaps out the current one' : '', '" onclick="').concat(equipCall, '">EQUIP</button>') : '<button class="bg-gray-500 text-gray-300 px-2 py-0.5 rounded text-xs font-bold border border-gray-400 cursor-not-allowed" disabled title="'.concat(requirement, '">EQUIP</button>');
                }
                equipRow = '<div class="card-equip-row mx-1 flex justify-end">'.concat(equipButton, "</div>");
            }
        }
        // Locked artifacts show only the unlock control (in equipRow above);
        // the craft controls appear once the design is unlocked.
        if (isCrafting && !isReadOnly && !artifactLocked && alreadyCrafted) // One-per-character durable already in hand: the craft slot becomes a
        // completed-checklist marker (equip it from the row above).
        actionButton = '<button class="w-full h-10 bg-gray-700 text-emerald-300 rounded text-xs font-bold border border-emerald-600/40 cursor-not-allowed" disabled title="Already crafted - one per character. Equip it from your inventory.">\u2713 CRAFTED</button>';
        else if (isCrafting && !isReadOnly && !artifactLocked) {
            var _gameState_player;
            // Crafting mode - show craft button with quantity selector
            var canCraft = recipe ? (0, $83869d722e7ea000$export$10d9b633aa01c262)(recipe) : false;
            // Same scaled price calculateBulkCraftingCost charges (parity with the sim)
            var craftingCost = (0, $83869d722e7ea000$export$5c9f0b8d2a488474)(itemData.id, 1);
            var playerCredits = ((_gameState_player = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player) === null || _gameState_player === void 0 ? void 0 : _gameState_player.credits) || 0;
            var hasCredits = playerCredits >= craftingCost;
            var quantityId = "craft-qty-".concat(itemData.id);
            if (canCraft && hasCredits) {
                // Calculate cost for selected quantity and show discount
                // Calculate max craftable quantity
                var maxCraftQty = 1;
                if (recipe && recipe.inputs) {
                    maxCraftQty = 99;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = recipe.inputs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var input = _step.value;
                            var available = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.inventory[input.id] || 0;
                            var canCraftQty = Math.floor(available / input.qty);
                            maxCraftQty = Math.min(maxCraftQty, canCraftQty);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    maxCraftQty = Math.max(1, maxCraftQty);
                }
                var actionButtonClass = 'flex-grow px-2 h-10 bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-400 hover:to-amber-500 text-amber-950 rounded text-xs font-bold border border-amber-400 transition-colors';
                var actionButtonCountClass = 'h-10 w-10 bg-gray-600 border border-gray-800 hover:bg-gray-500 text-white rounded text-xs font-bold';
                actionButton = '\n                    <div class="w-full flex gap-1">\n                        <button class="'.concat(actionButtonCountClass, '" onclick="decrementCraftQty(\'').concat(quantityId, '\')">\u2212</button>\n                        <button class="').concat(actionButtonCountClass, '" onclick="incrementCraftQty(\'').concat(quantityId, '\')">+</button>\n                        <input type="number" id="').concat(quantityId, '" class="hidden" value="1" min="1" max="').concat(maxCraftQty, '" onchange="updateCraftCost(\'').concat(itemData.id, "', '").concat(quantityId, '\')">                            \n                        <button id="craft-btn-').concat(itemData.id, '" class="').concat(actionButtonClass, '" onclick="const qty = parseInt(document.getElementById(\'').concat(quantityId, "').value || 1); craftItem('").concat(itemData.id, "', ").concat(isArtifact, ', qty); showCraftingModal();">CRAFT 1<br/>\uD83D\uDCB0').concat(craftingCost, "</button>\n                    </div>\n                ");
            } else {
                // Determine the blocking gate. The artifact blueprint is a
                // regular recipe input (drop-only), so when it is the ONLY
                // shortfall the message says so instead of pointing at the
                // workbench. Otherwise missing materials come first: when
                // the shortfall is craftable, the button becomes an ACTIVE
                // "craft components" jump into the tree-filtered modal
                // instead of a dead end.
                var missingInputs = ((recipe === null || recipe === void 0 ? void 0 : recipe.inputs) || []).filter(function(input) {
                    return ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.inventory[input.id] || 0) < input.qty;
                });
                var materialsMissing = missingInputs.length > 0;
                var blueprintMissing = missingInputs.some(function(input) {
                    return input.id.endsWith('-blueprint');
                });
                var onlyBlueprintMissing = blueprintMissing && missingInputs.every(function(input) {
                    return input.id.endsWith('-blueprint');
                });
                var disabledMessage = null;
                if (onlyBlueprintMissing) disabledMessage = 'MISSING<br>BLUEPRINT';
                else if (materialsMissing) {
                    // Craftable components in the chain? Offer the workbench —
                    // but NOT inside the crafting modal itself (the jump would
                    // just reopen the same modal); there it stays disabled.
                    // Raw-only shortfalls stay disabled - those drop in raids.
                    if (!options.inModal && (0, $83869d722e7ea000$export$36d50cdf3bb88c77)(itemData.id).length > 1) actionButton = '<button class="w-full h-10 bg-gradient-to-r from-blue-700 to-blue-800 hover:from-blue-600 hover:to-blue-700 text-white rounded text-xs font-bold border border-game-accent transition-colors leading-tight"\n                            title="Open the crafting tree for this item'.concat(blueprintMissing ? ' (blueprint still needed - legendary drop)' : '', '"\n                            onclick="showCraftingTreeModal(\'').concat(itemData.id, "')\">\uD83D\uDD27 CRAFT<br>COMPONENTS</button>");
                    else disabledMessage = 'MISSING<br>MATERIALS';
                } else if (!hasCredits) disabledMessage = 'NOT ENOUGH<br>CREDITS';
                else disabledMessage = 'MISSING<br>MATERIALS';
                if (disabledMessage) actionButton = '<button class="w-full h-10 bg-gray-800 text-gray-400 rounded text-xs font-bold border border-gray-600 cursor-not-allowed flex items-center justify-center leading-tight" disabled '.concat(disabledMessage.includes('MATERIALS') ? 'title="Missing materials drop in raids"' : '', ">").concat(disabledMessage, "</button>");
            }
        } else if (isArtifact && !isReadOnly) {
            var isEquipped = Object.values((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.equippedArtifacts).some(function(equipped) {
                return equipped && equipped.id === itemData.id;
            });
            var canEquip1 = (0, $7ea2865b97769aa3$export$106e54bf5a9adc20) ? (0, $7ea2865b97769aa3$export$106e54bf5a9adc20)(itemData) : true;
            var skillMessage = (0, $7ea2865b97769aa3$export$56e7fec58be964ef) ? (0, $7ea2865b97769aa3$export$56e7fec58be964ef)(itemData) : '';
            if (isEquipped) actionButton = '<button class="bg-red-600 hover:bg-red-700 text-white px-2 py-1 rounded text-xs font-bold border border-red-500 transition-colors" onclick="unequipArtifact(\''.concat(itemData.slot, "')\">UNEQUIP</button>");
            else if (canEquip1) actionButton = '<button class="bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-400 hover:to-amber-500 text-amber-950 px-2 py-1 rounded text-xs font-bold border border-amber-400 transition-colors" onclick="equipArtifact(\''.concat(itemData.id, "')\">EQUIP</button>");
            else actionButton = '<button class="bg-gray-500 text-gray-300 px-2 py-1 rounded text-xs font-bold border border-gray-400 cursor-not-allowed" disabled title="'.concat(skillMessage, '">EQUIP</button>');
        } else if (isSkillGear && !isReadOnly) {
            var isEquipped1 = Object.values((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.equippedTechniqueGear).some(function(equipped) {
                return equipped && equipped.id === itemData.id;
            });
            var canEquip2 = (0, $7ea2865b97769aa3$export$9e693217356d7ac4) ? (0, $7ea2865b97769aa3$export$9e693217356d7ac4)(itemData.id) : true;
            var skillMessage1 = (0, $7ea2865b97769aa3$export$bc6c3240a6a68b89) ? (0, $7ea2865b97769aa3$export$bc6c3240a6a68b89)(itemData.id) : '';
            if (isEquipped1) actionButton = '<button class="bg-red-600 hover:bg-red-700 text-white px-2 py-1 rounded text-xs font-bold border border-red-500 transition-colors" onclick="unequipTechniqueGear(\''.concat(itemData.techniqueId, "')\">UNEQUIP</button>");
            else if (canEquip2) actionButton = '<button class="bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-400 hover:to-amber-500 text-amber-950 px-2 py-1 rounded text-xs font-bold border border-amber-400 transition-colors" onclick="equipTechniqueGear(\''.concat(itemData.techniqueId, "', '").concat(itemData.id, "')\">EQUIP</button>");
            else actionButton = '<button class="bg-gray-500 text-gray-300 px-2 py-1 rounded text-xs font-bold border border-gray-400 cursor-not-allowed" disabled title="'.concat(skillMessage1, '">EQUIP</button>');
        } else {
            var categoryColor = $a575049a7e5cb3a1$export$86e4cd2f7b0dca8(item.type);
            if (item.type === 'consumable') {
                if (isPurchase && !isReadOnly) {
                    var _gameState_player1;
                    // Purchase mode - show BUY button with credit cost
                    // (energy consumables escalate with today's purchases)
                    var credits = (0, $8bda0cb20f0b197d$export$1214c02c27df458d)(itemData, (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player);
                    var playerCredits1 = ((_gameState_player1 = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player) === null || _gameState_player1 === void 0 ? void 0 : _gameState_player1.credits) || 0;
                    var canBuy = credits > 0 && playerCredits1 >= credits;
                    var needsCredits = credits - playerCredits1;
                    var escalated = itemData.restoresEnergy && credits > (itemData.credits || 0);
                    var buttonLabel = "BUY \uD83D\uDCB0".concat(credits);
                    var escalationHint = escalated ? ' title="Field logistics surcharge: repeat energy orders cost more today (resets daily)"' : '';
                    if (canBuy) actionButton = '<button class="bg-gradient-to-r from-green-600 to-green-700 hover:from-green-500 hover:to-green-600 text-white px-2 py-1 rounded text-xs font-bold border border-green-400 transition-colors"'.concat(escalationHint, " onclick=\"purchaseConsumable('").concat(itemData.id, "')\">").concat(buttonLabel, "</button>");
                    else actionButton = '<button class="bg-gray-500 text-gray-300 px-2 py-1 rounded text-xs font-bold border border-gray-400 cursor-not-allowed" disabled title="Need '.concat(needsCredits, ' more credits">').concat(buttonLabel, "</button>");
                } else if (!isPurchase && !isReadOnly) {
                    if (!itemData.restoresHp && !itemData.restoresEnergy) // Technique consumable - deployed automatically in raids, no manual USE
                    actionButton = '<span class="bg-gray-700 text-gray-300 px-2 py-1 rounded text-xs font-bold border border-gray-600" title="Rigs automatically on its technique\'s first success in a raid \u2014 the rig lasts the whole raid">\u2699\uFE0F AUTO</span>';
                    else {
                        // Inventory mode - show USE button
                        var canUse = $a575049a7e5cb3a1$export$bc3104ce93d3a2dc && $a575049a7e5cb3a1$export$bc3104ce93d3a2dc(itemData.id);
                        var requirementMessage = $a575049a7e5cb3a1$export$2b82d321966e99d9 ? $a575049a7e5cb3a1$export$2b82d321966e99d9(itemData.id) : 'Cannot use';
                        if (canUse) actionButton = '<button class="bg-gradient-to-r '.concat(categoryColor.button, ' text-white px-2 py-1 rounded text-xs font-bold border border-gray-600 transition-colors" onclick="useConsumable(\'').concat(itemData.id, "')\">USE</button>");
                        else actionButton = '<button class="bg-gray-500 text-gray-300 px-2 py-1 rounded text-xs font-bold border border-gray-400 cursor-not-allowed" disabled title="'.concat(requirementMessage, '">USE</button>');
                    }
                }
            } else if (item.type === 'relic' && !isReadOnly) {
                var quantityId1 = "sell-qty-".concat(itemData.id);
                var actionButtonCountClass1 = 'px-1 py-1 bg-gray-600 border border-gray-800 hover:bg-gray-500 text-white rounded text-xs font-bold';
                actionButton = '\n                    <button class="'.concat(actionButtonCountClass1, '" onclick="decrementSellQty(\'').concat(quantityId1, '\')">\u2212</button>\n                    <button class="').concat(actionButtonCountClass1, '" onclick="incrementSellQty(\'').concat(quantityId1, '\')">+</button>\n                    <input type="number" id="').concat(quantityId1, '" class="hidden" value="1" min="1" max="').concat(quantity, '" onchange="updateSellQty(\'').concat(itemData.id, "', '").concat(quantityId1, '\')">\n                    <button id="sell-btn-').concat(itemData.id, '" class="bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white px-2 py-1 rounded text-xs font-bold border border-gray-600 transition-colors" onclick="sellItem(\'').concat(itemData.id, "')\">SELL 1</button>");
            }
        }
        // Collapse state + progress (collapsed view shows name, %, and a bar).
        // displayName overrides the shown title; hideToggle drops the expand
        // chevron (both used by the gear tab for un-blueprinted artifacts).
        var _ref = options || {}, _ref_collapsed = _ref.collapsed, collapsed = _ref_collapsed === void 0 ? false : _ref_collapsed, _ref_progress = _ref.progress, progress = _ref_progress === void 0 ? null : _ref_progress, _ref_displayName = _ref.displayName, displayName = _ref_displayName === void 0 ? null : _ref_displayName, _ref_hideToggle = _ref.hideToggle, hideToggle = _ref_hideToggle === void 0 ? false : _ref_hideToggle, _ref_progressQ = _ref.progressQ, progressQ = _ref_progressQ === void 0 ? null : _ref_progressQ;
        // A locked artifact can't be expanded (nothing to act on but the unlock
        // control, which shows in the collapsed view) - force collapsed + no toggle
        var effCollapsed = collapsed || artifactLocked;
        var effHideToggle = hideToggle || artifactLocked;
        var progressValue = progress;
        var progressQty = progressQ;
        if ((progressValue == null || progressQty == null) && isCrafting && recipe && recipe.inputs) {
            var _gameState_character_inventory1, _gameState_character3;
            var haveSum = 0, needSum = 0;
            recipe.inputs.forEach(function(input) {
                var _gameState_character_inventory, _gameState_character;
                var have = ((_gameState_character = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character) === null || _gameState_character === void 0 ? void 0 : (_gameState_character_inventory = _gameState_character.inventory) === null || _gameState_character_inventory === void 0 ? void 0 : _gameState_character_inventory[input.id]) || 0;
                haveSum += Math.min(have, input.qty);
                needSum += input.qty;
            });
            progressValue = needSum > 0 ? haveSum / needSum : 0;
            progressQty = ((_gameState_character3 = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character) === null || _gameState_character3 === void 0 ? void 0 : (_gameState_character_inventory1 = _gameState_character3.inventory) === null || _gameState_character_inventory1 === void 0 ? void 0 : _gameState_character_inventory1[recipe.target]) || 0;
        }
        var progressPct = progressValue != null ? Math.round(progressValue * 100) : null;
        return '\n            <div class="inv-card '.concat(effCollapsed ? 'inv-card-collapsed' : '', " ").concat(isEquippedItem ? 'inv-card-equipped' : '', " relative bg-gradient-to-b ").concat(cardBg, " border-4 ").concat(cardBorder, " rounded-xl shadow-lg hover:shadow-xl transition-all duration-200 ").concat(isCrafting ? '' : 'h-[17rem]', " ").concat(isCrafting ? 'w-52' : 'w-44', " overflow-hidden ").concat(isArtifact ? 'foil-card foil-card-bg' : '', '" data-item-id="').concat(itemData.id, '">\n                <!-- Card Border Frame -->\n                <div class="absolute"></div>\n\n                <!-- Header Banner -->\n                <div class="relative bg-gradient-to-r ').concat(headerBg, " ").concat(headerText, " px-3 py-2 text-left border-b-2 ").concat(headerBorder, ' h-8">\n                    <div class="text-xs font-bold uppercase tracking-wide">').concat(categoryText, "</div>\n                    ").concat(options.isFocus ? '<div class="absolute top-[0.2rem] right-[5rem] bg-black bg-opacity-30 border border-black rounded-full h-6 px-1 flex items-center justify-center text-sm" title="Suggested focus">\uD83C\uDFAF</div>' : '', "\n                    ").concat(factionIcon ? '<div class="inv-card-faction-icon absolute top-[0.2rem] right-[3.75rem] bg-black bg-opacity-30 border border-black rounded-full w-6 h-6 flex items-center justify-center text-sm" title="'.concat(factionName, '">').concat(factionIcon, "</div>") : '', "\n                    ").concat(itemIcon ? '<div class="inv-card-item-icon absolute top-[0.2rem] right-[1.75rem] bg-black bg-opacity-30 border border-black rounded-full h-6 px-1 flex items-center justify-center text-sm" title="'.concat(isSkillGear ? 'Technique: ' + techniqueName : '', '">').concat(isSkillGear ? techniqueIcon : itemIcon, "</div>") : '', "\n                    <!-- Expand/collapse toggle (top-right corner) -->\n                    ").concat(effHideToggle ? '' : '<div class="absolute top-[0.2rem] right-[0.2rem] z-20 bg-black bg-opacity-40 border border-gray-500 rounded-full w-6 h-6 flex items-center justify-center text-xs cursor-pointer hover:border-blue-400 hover:text-blue-300"\n                         onclick="event.stopPropagation(); toggleInventoryCardCollapse(this);" title="Expand / collapse">\n                        <span class="inv-toggle-open">\u25B8</span><span class="inv-toggle-close">\u25BE</span>\n                    </div>', '\n                </div>\n\n                <!-- Card Content -->\n                <div class="relative px-2 pb-2">\n                    <!-- Title Section -->\n                    <div class="min-h-8 flex items-center mx-1 my-2">\n                        <h4 class="font-bold text-white text-xs leading-tight flex-grow" ').concat(effCollapsed ? "title='" + itemData.short + "'" : "", ">").concat(displayName || itemName, "</h4>\n                        ").concat(progressPct != null ? '<span class="card-progress-pct ml-2 text-[12px] font-bold bg-gray-800 px-2 py-1 rounded-full border border-gray-500 '.concat(progressPct == 100 || progressQty > 0 ? 'text-green-400' : 'text-blue-300', '" title="').concat(progressQty > 0 ? "Item qty in inventory" : "Recipe components in inventory", '">').concat(progressPct < 100 && progressQty == 0 ? progressPct + "%" : "x" + progressQty, "</span>") : '', "\n                    </div>\n                    ").concat(progressPct != null ? '\n                    <!-- Collapsed-view progress bar -->\n                    <div class="card-progress-row mx-1 mb-2">\n                        <div class="h-1.5 rounded bg-gray-800 overflow-hidden border border-gray-600">\n                            <div class="h-full '.concat(progressPct >= 100 ? 'bg-green-500' : progressPct >= 99 ? 'bg-sky-300' : 'bg-blue-500', '" style="width:').concat(Math.min(100, progressPct), '%"></div>\n                        </div>\n                    </div>') : '', "\n                    ").concat(equipRow, "\n                    ").concat(quantity != null && !isCrafting ? '\n                    <div class="card-collapsed-qty flex justify-between items-center mb-2">\n                        <div class="bg-gray-700 text-gray-100 px-2 py-1 rounded-full text-xs font-bold border border-gray-500 inline-block">\xd7'.concat(quantity, "</div>\n                        ").concat(actionButton || unitValueBadge, "\n                    </div>") : '', '\n\n                    <div class="card-body">\n                    <!-- Artwork Area with Tippy Tooltip -->\n                    <div class="inventory-tooltip relative bg-gradient-to-b from-gray-700 to-gray-800 border-2 border-gray-500 rounded-lg mt-2 mb-2 ').concat(isCrafting ? 'h-24' : 'h-36', ' w-full overflow-hidden cursor-pointer">\n                        <!-- Hidden tooltip content -->\n                        <div class="inventory-tooltip-content hidden">').concat(description, '</div>\n\n                        <!-- Icon/Artwork -->\n                        <div class="absolute inset-0 flex items-center justify-center">\n                            <span class="text-4xl opacity-80 hover:opacity-60 transition-opacity duration-200">').concat(itemIcon, '</span>\n                        </div>\n\n                        <!-- Info Icon (top-right corner) to indicate tooltip -->\n                        <div class="absolute top-1 right-1 z-10 bg-black bg-opacity-50 text-gray-300 w-5 h-5 rounded-full flex items-center justify-center text-xs font-bold border border-gray-500 hover:text-blue-300 hover:border-blue-400 transition-colors">\u2139</div>\n\n                        <!-- Credit Value Badge (bottom-right corner of image) for relics -->\n                        ').concat(itemData.type === 'relic' && itemData && itemData.credits ? '<div class="absolute bottom-1 right-1 z-5 bg-gray-800 text-amber-200 px-2 py-1 rounded text-xs font-bold border border-gray-600 shadow-lg">\uD83D\uDCB0'.concat(itemData.credits, "</div>") : '', "\n                    </div>\n\n                    ").concat(isCrafting ? // Crafting mode: Materials at top, button at bottom
        '<!-- Material Requirements -->\n                        <div class="mb-2 text-xs bg-gradient-to-b from-gray-800 to-gray-900 border-2 border-gray-500 rounded-lg p-2 grid grid-cols-2 grid-rows-4 gap-x-2 gap-y-0.5" style="height: 140px; overflow: hidden; grid-auto-flow: column;">\n                            '.concat(function() {
            var requirements = '';
            // The artifact blueprint is a regular recipe
            // input now, so it renders in the generic
            // rows below like any other requirement
            if (!recipe) requirements += '<div class="text-red-400">Recipe not found</div>';
            else {
                // Use pre-computed materials if available, otherwise fetch on-demand
                var materialIds = recipe.inputs.map(function(input) {
                    return input.id;
                });
                var materialItems = preComputedMaterials || (0, $ca7af38ea7b7b4a8$export$4251a114f7437961)(materialIds);
                requirements += recipe.inputs.map(function(input) {
                    var materialId = input.id;
                    var required = input.qty;
                    var available = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.inventory[materialId] || 0;
                    var hasEnough = available >= required;
                    var material = materialItems[materialId];
                    return '<div class="flex justify-between items-center">\n                                            <span class="flex items-center cursor-pointer" title="'.concat(material === null || material === void 0 ? void 0 : material.name, '">\n                                                <span class="text-base mr-1 ').concat(hasEnough ? 'text-blue-300' : 'text-amber-300', '">').concat(material === null || material === void 0 ? void 0 : material.icon, '</span>\n                                            </span>\n                                            <span class="flex-shrink-0 ').concat(hasEnough ? 'text-blue-300' : 'text-amber-300', '">').concat(available, "/").concat(required, "</span>\n                                        </div>");
                }).join('');
            }
            return requirements;
        }(), '\n                        </div>\n                        <!-- Action Button at Bottom -->\n                        <div class="">\n                            ').concat(actionButton, "\n                        </div>") : isPurchase ? // Consumable purchase modal
        '<!-- Action Button Section with Quantity -->\n                            <div class="flex flex-row-reverse">\n                                '.concat(actionButton, "\n                            </div>") : // Regular inventory mode: quantity and button side by side
        '<!-- Action Button Section with Quantity -->\n                            <div class="flex justify-between items-center">\n                                <div class="bg-gray-700 text-gray-100 px-2 py-1 rounded-full text-xs font-bold border border-gray-500">\xd7'.concat(quantity, "</div>\n                                ").concat(actionButton, "\n                            </div>"), "\n                    </div>\n                </div>\n            </div>\n        ");
    }
}
function $a575049a7e5cb3a1$export$b6b265525b8284bc(el) {
    var _el_closest;
    (_el_closest = el.closest('.inv-card')) === null || _el_closest === void 0 ? void 0 : _el_closest.classList.toggle('inv-card-collapsed');
}
if (typeof window !== 'undefined') window.toggleInventoryCardCollapse = $a575049a7e5cb3a1$export$b6b265525b8284bc;
function $a575049a7e5cb3a1$export$32cc43b5b1b4dc0e() {
    var _gameState_currentRaid, _gameState_currentRaid_selectedPath, _step_room;
    var raid = (_gameState_currentRaid = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid) === null || _gameState_currentRaid === void 0 ? void 0 : _gameState_currentRaid.raidInProgress;
    if (!raid) return false;
    var step = (_gameState_currentRaid_selectedPath = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath) === null || _gameState_currentRaid_selectedPath === void 0 ? void 0 : _gameState_currentRaid_selectedPath[raid.currentRoomIndex];
    return (step === null || step === void 0 ? void 0 : (_step_room = step.room) === null || _step_room === void 0 ? void 0 : _step_room.type) === 'campsite';
}
function $a575049a7e5cb3a1$export$bc3104ce93d3a2dc(itemId) {
    var _gameState_currentRaid;
    if (!(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character) return false;
    if (!(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.inventory[itemId] || (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.inventory[itemId] <= 0) return false;
    // Ration Cut. Here rather than in useConsumable() so the button renders
    // disabled with a reason instead of failing on click — canUseConsumable is
    // what the card reads to decide.
    if ((0, $686e361e5cd4549d$export$a2c94bc2dc5c01e1)('noConsumables', false)) return false;
    // Same classification as useConsumable: the item's restore fields decide;
    // technique consumables (neither field) auto-deploy in raids, never manual
    var itemData = (0, $ca7af38ea7b7b4a8$export$a2dea178c28a0308)('id', itemId);
    if (itemData === null || itemData === void 0 ? void 0 : itemData.restoresEnergy) {
        // Energy consumables are blocked entirely once a raid is active (planning or in progress)
        var isRaidActive = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid && ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress || (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid);
        if (isRaidActive) return false;
        return (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player.energy < (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player.maxEnergy;
    }
    if (!(itemData === null || itemData === void 0 ? void 0 : itemData.restoresHp)) return false;
    if (((_gameState_currentRaid = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid) === null || _gameState_currentRaid === void 0 ? void 0 : _gameState_currentRaid.raidInProgress) && !$a575049a7e5cb3a1$export$32cc43b5b1b4dc0e()) return false;
    return (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.currentHp < (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.maxHp;
}
function $a575049a7e5cb3a1$export$2b82d321966e99d9(itemId) {
    var _gameState_currentRaid;
    if ((0, $686e361e5cd4549d$export$a2c94bc2dc5c01e1)('noConsumables', false)) return 'Ration Cut: no consumables on this contract';
    var itemData = (0, $ca7af38ea7b7b4a8$export$a2dea178c28a0308)('id', itemId);
    if (itemData === null || itemData === void 0 ? void 0 : itemData.restoresEnergy) {
        var isRaidActive = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid && ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress || (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid);
        if (isRaidActive) return 'Only usable before starting a raid';
        return 'Energy already full';
    }
    if (!(itemData === null || itemData === void 0 ? void 0 : itemData.restoresHp)) return 'Rigs automatically on its technique\'s first success in a raid';
    if (((_gameState_currentRaid = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid) === null || _gameState_currentRaid === void 0 ? void 0 : _gameState_currentRaid.raidInProgress) && !$a575049a7e5cb3a1$export$32cc43b5b1b4dc0e()) return 'Only usable at a campsite during a raid';
    return 'Health already full';
}
function $a575049a7e5cb3a1$export$8606b9937b72ca5d() {
    var _loop = function() {
        // Select a random artifact from the predefined list
        var allArtifacts = (0, $ca7af38ea7b7b4a8$export$18c4115a8e7963b)();
        var randomArtifact = allArtifacts[Math.floor(Math.random() * allArtifacts.length)];
        if (i > 1 && !bAddedUtilArtifact && randomArtifact.slot == 'skillSlot') return "continue";
        if (randomArtifact.slot != 'skillSlot') bAddedUtilArtifact = true;
        // Create artifact instance with unique ID (matching crafting system format)
        var artifact = {
            key: Date.now() + Math.random() + i,
            id: randomArtifact.id,
            name: randomArtifact.name,
            type: randomArtifact.type,
            slot: randomArtifact.slot,
            skill: randomArtifact.skill,
            effects: randomArtifact.effects,
            description: randomArtifact.description,
            short: randomArtifact.short,
            faction: randomArtifact.faction,
            rarity: randomArtifact.rarity,
            icon: randomArtifact.icon,
            crafted: true // Mark as crafted like the crafting system
        };
        // Only add if not already in artifacts array
        if (!(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.artifacts.some(function(a) {
            return a.id === artifact.id;
        })) (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.artifacts.push(artifact);
        i++;
    };
    // Ensure we have an active character
    if (!(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character || !(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).activeCharacterId) {
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)('No active character! Please create or select a character first.', 'error');
        return;
    }
    // Clear existing inventory and artifacts for current character
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.inventory = {};
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.artifacts = [];
    // Ensure we get items from each rarity tier
    var rarityTiers = [
        'common',
        'uncommon',
        'rare',
        'epic',
        'legendary',
        'unique'
    ];
    rarityTiers.forEach(function(rarity) {
        var tierItems = (0, $ca7af38ea7b7b4a8$export$15b7d0c192d0aa5d)().filter(function(item) {
            return item.rarity === rarity;
        });
        if (tierItems.length > 0) {
            // Add a number of item ids depending on the tier
            var count = Math.min(1 + Math.floor(Math.random() * 3), tierItems.length) * (6 - rarityTiers.indexOf(rarity));
            var shuffled = (0, $4c858c0d999a5b9b$export$71511d61b312f219)(tierItems).sort(function() {
                return Math.random() - 0.5;
            });
            for(var i = 0; i < count; i++){
                var randomItem = shuffled[i];
                (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "adding random item:", randomItem);
                var quantity = void 0;
                if (randomItem.type === 'storyRelic' || randomItem.type === 'blueprint' || randomItem.type === 'techGear') quantity = 1;
                else if (randomItem.type === 'relic') quantity = 3 + Math.floor(Math.random() * 3);
                else if (randomItem.type === 'consumable') quantity = 5 + Math.floor(Math.random() * 3);
                else quantity = 1000;
                (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.inventory[randomItem.id] = ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.inventory[randomItem.id] || 0) + quantity;
            }
        }
    });
    // Generate 3-5 predefined skill artifacts from artifactData
    var numArtifacts = 3 + Math.floor(Math.random() * 3);
    var bAddedUtilArtifact = false, i = 0;
    while(i < numArtifacts)_loop();
    // Save current character's inventory and artifacts to their character data
    var currentCharIndex = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).characters.findIndex(function(c) {
        return c.id === (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).activeCharacterId;
    });
    if (currentCharIndex !== -1) {
        (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).characters[currentCharIndex].inventory = (0, $fa9769297b8a68c8$export$71511d61b312f219)({}, (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.inventory);
        (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).characters[currentCharIndex].artifacts = (0, $4c858c0d999a5b9b$export$71511d61b312f219)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.artifacts);
    }
    // Refresh Alpine store
    (0, $80ed874fd909c4ae$export$5b73e6a29e58b929)();
    // Show notification
    (0, $b5bda7fdec806d8b$export$c7def531c087da85)("Generated random items!", 'success');
    // Update UI and save
    (0, $59924438766e7d8e$export$d1c957a54f7124bc)();
    (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
}
function $a575049a7e5cb3a1$export$56dcd79bae47b9c1() {
    // Ensure we have an active character
    if (!(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character || !(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).activeCharacterId) {
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)('No active character! Please create or select a character first.', 'error');
        return;
    }
    // Clear current character's inventory and artifacts
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.inventory = {};
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.artifacts = [];
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.equippedArtifacts = {
        skillSlot: null,
        utilitySlot: null
    };
    // Save current character's cleared inventory to their character data
    var currentCharIndex = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).characters.findIndex(function(c) {
        return c.id === (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).activeCharacterId;
    });
    if (currentCharIndex !== -1) {
        (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).characters[currentCharIndex].inventory = {};
        (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).characters[currentCharIndex].artifacts = [];
        (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).characters[currentCharIndex].equippedArtifacts = {
            skillSlot: null,
            utilitySlot: null
        };
    }
    // Refresh Alpine store
    (0, $80ed874fd909c4ae$export$5b73e6a29e58b929)();
    // Show notification
    (0, $b5bda7fdec806d8b$export$c7def531c087da85)('Inventory cleared!', 'success');
    // Update UI and save
    (0, $59924438766e7d8e$export$d1c957a54f7124bc)();
    (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
}
function $a575049a7e5cb3a1$export$d2567add70135c10() {
    var inventoryCharacterName = document.getElementById('inventory-character-name');
    if (inventoryCharacterName && (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character) inventoryCharacterName.textContent = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.name + "'s";
}
function $a575049a7e5cb3a1$export$8a26d5080d84dfb0(itemId) {
    var item = (0, $ca7af38ea7b7b4a8$export$a2dea178c28a0308)('id', itemId) || (0, $ca7af38ea7b7b4a8$export$891bd687a67340b8)('id', itemId);
    if (!item || !item.type || !item.effects) return '';
    return Object.entries(item.effects || {}).map(function(param) {
        var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), effectId = _param[0], amt = _param[1];
        var effect = (0, $ca7af38ea7b7b4a8$export$96671014a1dabc4c)(effectId);
        var effectQual = '';
        if (effect.unit == 'percent') effectQual += " by ".concat(amt, "%");
        else if (effect.unit == 'count') effectQual += " ".concat(amt, " time").concat(amt > 1 ? 's' : '');
        return effect.description + effectQual + '.';
    }).join('  ');
}
function $a575049a7e5cb3a1$export$8e8909cfaf15b391(itemId) {
    if (!(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character) return 0;
    var recipe = (0, $37e67442be28b253$export$3645b25e1a815566) ? (0, $37e67442be28b253$export$3645b25e1a815566)(itemId) : null;
    if (!recipe || !recipe.inputs) return 0;
    // Find the limiting factor (material with lowest quantity available)
    var maxQty = 99; // Start with max possible
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = recipe.inputs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var input = _step.value;
            var available = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.inventory[input.id] || 0;
            var canCraftQty = Math.floor(available / input.qty);
            maxQty = Math.min(maxQty, canCraftQty);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return Math.max(1, maxQty); // Always allow at least 1
}
function $a575049a7e5cb3a1$export$ff0507185d233e75(quantityId) {
    var input = document.getElementById(quantityId);
    if (input) {
        var itemId = quantityId.replace('sell-qty-', '');
        var currentVal = parseInt(input.value) || 1;
        var maxQty = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.inventory[itemId];
        var newVal = Math.min(currentVal + 1, maxQty);
        input.value = newVal;
        $a575049a7e5cb3a1$export$4b495d34a3840d43(itemId, quantityId);
    }
}
function $a575049a7e5cb3a1$export$a4d3bbe47949d494(quantityId) {
    var input = document.getElementById(quantityId);
    if (input) {
        var itemId = quantityId.replace('sell-qty-', '');
        var currentVal = parseInt(input.value) || 1;
        var newVal = Math.max(currentVal - 1, 1);
        input.value = newVal;
        $a575049a7e5cb3a1$export$4b495d34a3840d43(itemId, quantityId);
    }
}
function $a575049a7e5cb3a1$export$4b495d34a3840d43(itemId, quantityId) {
    var input = document.getElementById(quantityId);
    var sellBtn = document.getElementById("sell-btn-".concat(itemId));
    if (input && sellBtn) {
        var quantity = parseInt(input.value) || 1;
        var maxQty = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.inventory[itemId];
        // Clamp to max craftable
        if (quantity > maxQty) input.value = maxQty;
        sellBtn.innerHTML = "SELL ".concat(quantity);
    }
}
function $a575049a7e5cb3a1$export$ad1aa4315d00018a(quantityId) {
    var input = document.getElementById(quantityId);
    if (input) {
        var itemId = quantityId.replace('craft-qty-', '');
        var currentVal = parseInt(input.value) || 1;
        var maxQty = $a575049a7e5cb3a1$export$8e8909cfaf15b391(itemId);
        var newVal = Math.min(currentVal + 1, maxQty);
        input.value = newVal;
        $a575049a7e5cb3a1$export$8ef1bcc7d93420a1(itemId, quantityId);
    }
}
function $a575049a7e5cb3a1$export$7b962277503582ab(quantityId) {
    var input = document.getElementById(quantityId);
    if (input) {
        var itemId = quantityId.replace('craft-qty-', '');
        var currentVal = parseInt(input.value) || 1;
        var newVal = Math.max(currentVal - 1, 1);
        input.value = newVal;
        $a575049a7e5cb3a1$export$8ef1bcc7d93420a1(itemId, quantityId);
    }
}
function $a575049a7e5cb3a1$export$8ef1bcc7d93420a1(itemId, quantityId) {
    var input = document.getElementById(quantityId);
    var craftBtn = document.getElementById("craft-btn-".concat(itemId));
    if (input && craftBtn && window.calculateBulkCraftingCost) {
        var quantity = parseInt(input.value) || 1;
        var maxQty = $a575049a7e5cb3a1$export$8e8909cfaf15b391(itemId);
        // Clamp to max craftable
        if (quantity > maxQty) input.value = maxQty;
        var totalCost = (0, $83869d722e7ea000$export$5c9f0b8d2a488474)(itemId, quantity);
        craftBtn.innerHTML = "CRAFT ".concat(quantity, "<br/>\uD83D\uDCB0").concat(totalCost);
    }
}
function $a575049a7e5cb3a1$export$1690b2b2efa58f74() {
    // HP consumables only - energy is bought (and applied) one-step via the
    // header's ⚡ popup, so a second buy-then-use path here would just confuse
    var purchasableConsumables = [
        'field-health-stim',
        'recovery-injector-mk2',
        'advanced-recovery-serum'
    ];
    var grid = document.getElementById('purchasable-items-grid');
    var noItems = document.getElementById('no-purchasable-items');
    if (!grid || !noItems) return;
    // Clear grid
    grid.innerHTML = '';
    // Add each purchasable item to the grid
    var hasItems = false;
    purchasableConsumables.forEach(function(itemId) {
        var item = (0, $ca7af38ea7b7b4a8$export$a2dea178c28a0308)('id', itemId);
        if (item) {
            hasItems = true;
            // Create a modified item object for display in purchase mode
            var displayItem = (0, $715bf31211e65705$export$71511d61b312f219)((0, $fa9769297b8a68c8$export$71511d61b312f219)({}, item), {
                id: itemId,
                quantity: 0,
                type: 'consumable'
            });
            // Create card using the existing createInventoryCard with 'purchase' mode
            var cardHtml = $a575049a7e5cb3a1$export$4ac7f915da1fa1c4(displayItem, 'purchase');
            var tempDiv = document.createElement('div');
            tempDiv.innerHTML = cardHtml;
            grid.appendChild(tempDiv.firstElementChild);
        }
    });
    // Show/hide no items message
    noItems.classList.toggle('hidden', hasItems);
}
function $a575049a7e5cb3a1$export$432db33666131f90() {
    $a575049a7e5cb3a1$export$1690b2b2efa58f74();
    // Show modal
    var modal = document.getElementById('purchase-consumables-modal');
    if (modal) modal.classList.remove('hidden');
    // Reinitialize tooltips for the newly created cards
    if (window.tippy) tippy(".inventory-tooltip", {
        theme: "dark",
        placement: "top",
        delay: [
            300,
            0
        ],
        maxWidth: 300,
        allowHTML: true,
        content: function(reference) {
            var descDiv = reference.querySelector(".inventory-tooltip-content");
            return descDiv ? descDiv.innerHTML : "";
        },
        onMount: function(instance) {
            instance.popper.style.border = "2px solid white";
            instance.popper.style.borderRadius = "0.5rem";
        },
        onShow: function(instance) {
            // Create a named function so it can be accurately removed later
            instance._scrollHandler = function() {
                return instance.hide();
            };
            window.addEventListener('scroll', instance._scrollHandler, {
                passive: true
            });
        },
        onHide: function(instance) {
            // Clean up the listener to prevent memory leaks
            window.removeEventListener('scroll', instance._scrollHandler);
        }
    });
}
function $a575049a7e5cb3a1$export$1ed9acaf4451ebfa() {
    var modal = document.getElementById('purchase-consumables-modal');
    if (modal) modal.classList.add('hidden');
}
// ---------------------------------------------------------------------------
// Header energy popup - one-step purchase: buying applies the energy
// immediately (no inventory round-trip). Same rules as buy-then-use had:
// escalating same-day prices, blocked while a raid is planned or running.
// ---------------------------------------------------------------------------
var $a575049a7e5cb3a1$var$ENERGY_POPUP_ITEMS = [
    'portable-energy-pack',
    'energy-conversion-pack',
    'power-cell-mk3'
];
function $a575049a7e5cb3a1$var$isRaidBlockingEnergy() {
    return !!((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid && ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress || (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid));
}
function $a575049a7e5cb3a1$export$ab4faafa71d5b548() {
    var popup = document.getElementById('energy-popup');
    if (!popup) return;
    var player = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player || {
        energy: 0,
        maxEnergy: 100,
        credits: 0
    };
    var missing = Math.max(0, (player.maxEnergy || 0) - (player.energy || 0));
    var raidBlocked = $a575049a7e5cb3a1$var$isRaidBlockingEnergy();
    var anyEscalated = $a575049a7e5cb3a1$var$ENERGY_POPUP_ITEMS.some(function(id) {
        var item = (0, $ca7af38ea7b7b4a8$export$a2dea178c28a0308)('id', id);
        return item && (0, $8bda0cb20f0b197d$export$1214c02c27df458d)(item, player) > (item.credits || 0);
    });
    var rows = $a575049a7e5cb3a1$var$ENERGY_POPUP_ITEMS.map(function(id) {
        var item = (0, $ca7af38ea7b7b4a8$export$a2dea178c28a0308)('id', id);
        if (!item) return '';
        var price = (0, $8bda0cb20f0b197d$export$1214c02c27df458d)(item, player);
        var gain = Math.min(item.restoresEnergy, missing);
        var gainLabel = gain < item.restoresEnergy ? "+".concat(gain, "/").concat(item.restoresEnergy) : "+".concat(item.restoresEnergy);
        var disabled = raidBlocked || missing <= 0 || (player.credits || 0) < price;
        var title = raidBlocked ? 'Not available while a raid is being planned or running' : missing <= 0 ? 'Energy already full' : (player.credits || 0) < price ? "Need ".concat(price - (player.credits || 0), " more credits") : "Restores ".concat(gain, " energy instantly");
        return '\n            <button class="w-full flex items-center gap-2 px-2 py-1.5 rounded border text-sm text-left transition-colors\n                '.concat(disabled ? 'border-gray-700 text-gray-500 cursor-not-allowed' : 'border-blue-800 text-gray-200 hover:bg-blue-900/40', '"\n                ').concat(disabled ? 'disabled' : '', ' title="').concat(title, '" onclick="buyEnergyDirect(\'').concat(id, "')\">\n                <span>").concat(item.icon, '</span>\n                <span class="flex-1">').concat(item.name, '</span>\n                <span class="text-blue-400 font-bold whitespace-nowrap">').concat(gainLabel, ' \u26A1</span>\n                <span class="text-game-gold font-bold whitespace-nowrap">\uD83D\uDCB0').concat(price, "</span>\n            </button>");
    }).join('');
    popup.innerHTML = '\n        <div class="text-[11px] uppercase tracking-widest text-gray-400 mb-2">Buy Energy \u2014 applied instantly</div>\n        <div class="flex flex-col gap-1.5">'.concat(rows, "</div>\n        ").concat(raidBlocked ? '<div class="text-[11px] text-red-400 mt-2">Not available while a raid is planned or running</div>' : '', "\n        ").concat(anyEscalated ? '<div class="text-[11px] text-gray-500 mt-2">Field logistics surcharge: repeat energy orders cost more today (resets daily)</div>' : '');
}
function $a575049a7e5cb3a1$export$4c1b7a82836a6e5c(event) {
    event === null || event === void 0 ? void 0 : event.stopPropagation();
    var popup = document.getElementById('energy-popup');
    if (!popup) return;
    var opening = popup.classList.contains('hidden');
    popup.classList.toggle('hidden', !opening);
    if (opening) {
        var _document_getElementById;
        // Fixed-position under the header's ⚡ chip. The popup is a top-level
        // element (see index.html) rather than a header child, so it is
        // anchored by id — there is no useful parent to fall back to, and the
        // currency chips it points at are re-rendered from the layer registry.
        var chip = (_document_getElementById = document.getElementById('energy-chip')) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.getBoundingClientRect();
        if (chip) {
            popup.style.top = "".concat(chip.bottom + 8, "px");
            popup.style.right = "".concat(Math.max(8, window.innerWidth - chip.right), "px");
        }
        $a575049a7e5cb3a1$export$ab4faafa71d5b548();
        // Close on any click outside the popup (the opener button stops
        // propagation). A detached target means the click hit a row that
        // buyEnergyDirect just re-rendered away - that's inside, stay open.
        var closeOnOutside = function(e) {
            if (!popup.contains(e.target) && document.contains(e.target)) {
                popup.classList.add('hidden');
                document.removeEventListener('click', closeOnOutside);
            }
        };
        document.addEventListener('click', closeOnOutside);
    }
}
function $a575049a7e5cb3a1$export$d4a1bdd7cb9254a9(itemId) {
    var itemData = (0, $ca7af38ea7b7b4a8$export$a2dea178c28a0308)('id', itemId);
    if (!(itemData === null || itemData === void 0 ? void 0 : itemData.restoresEnergy)) {
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)('This item cannot be purchased here!', 'error');
        return;
    }
    if ($a575049a7e5cb3a1$var$isRaidBlockingEnergy()) {
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)('Energy can only be bought before starting a raid!', 'error');
        return;
    }
    var player = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player;
    if (!player || player.energy >= player.maxEnergy) {
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)('Your energy is already full!', 'info');
        return;
    }
    var price = (0, $8bda0cb20f0b197d$export$1214c02c27df458d)(itemData, player);
    if (player.credits < price) {
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)("Not enough credits! Need ".concat(price, ", have ").concat(player.credits), 'error');
        return;
    }
    player.credits -= price;
    (0, $8bda0cb20f0b197d$export$cfff9bc32ab6cb78)(player);
    var gained = Math.min(itemData.restoresEnergy, player.maxEnergy - player.energy);
    player.energy += gained;
    (0, $b5bda7fdec806d8b$export$c7def531c087da85)("".concat(itemData.icon, " ").concat(itemData.name, ": +").concat(gained, " energy for ").concat(price, " credits"), 'success');
    $a575049a7e5cb3a1$export$ab4faafa71d5b548(); // prices escalate per purchase - refresh labels
    (0, $59924438766e7d8e$export$d1c957a54f7124bc)();
    (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
}
function $a575049a7e5cb3a1$export$fe032c86fe8adff() {
    var closeBtn = document.getElementById('close-purchase-modal');
    if (closeBtn) closeBtn.addEventListener('click', $a575049a7e5cb3a1$export$1ed9acaf4451ebfa);
    // Close modal when clicking outside
    var modal = document.getElementById('purchase-consumables-modal');
    if (modal) modal.addEventListener('click', function(e) {
        if (e.target === modal) $a575049a7e5cb3a1$export$1ed9acaf4451ebfa();
    });
}








/**
 * Recipe Core - recipe lookup with input scaling applied. Pure, no DOM.
 *
 * Extracted from crafting.js so it can be used headlessly. crafting.js carries
 * the crafting UI (infinite scroll, MutationObserver, notifications), which
 * meant anything importing it - including gear-core.js - could not be loaded in
 * Node, breaking the rule that -core modules are usable by the simulator.
 *
 * crafting.js re-exports getRecipeById from here, so existing importers and
 * tests are unaffected.
 */ 




/**
 * Progression Scaling Configuration
 *
 * SINGLE SOURCE OF TRUTH for balance values shared by the game and the
 * headless simulator (tools/simulation/game-simulator.js). The simulator
 * defaults to these values; tools/simulation/simulation-config.json is
 * pure override/experiment space. To ship a validated experiment value,
 * edit it HERE and run `npm run build` (regenerates js/constants.js).
 *
 * Values are tuned so that:
 * - All 15 faction epic tech gear items are craftable in a 30-day cycle
 * - Inventory quantities stay in balanced range (50-150 per item)
 * - Higher-rarity intermediates are properly gated by their availability
 */ 

var $96b8284e43b2ceb4$export$9f9786ac427715c7 = {
    /**
   * Durable-gear craft cap. Skill (tech) gear and artifacts are equip-once
   * items - one slot per skill / per artifact slot, never consumed, sold, or
   * traded - so a second copy earns nothing (marks are already distinct-only)
   * and just burns materials. When false (default) each such design can be
   * crafted once per character; the crafting card shows "✓ CRAFTED" instead.
   * Flip to true to re-enable duplicate crafting (e.g. if a gear marketplace
   * ever makes spare copies worth something). Consumables are unaffected.
   */ allowDuplicateCrafts: false,
    recipeInputs: {
        // Re-tuned for weighted per-item drops: selection weights spread drops across
        // all items (nothing starves to zero anymore), so demand carries the pacing
        common: 5,
        uncommon: 5,
        rare: 4,
        epic: 4,
        legendary: 1,
        unique: 1
    },
    /**
   * Skill points awarded per level up (character-core.js levelUpCore).
   * Formula: base + Math.floor(level / levelDivisor) * increment
   * where `level` is the level just REACHED.
   *
   * With the values below (base: 2, levelDivisor: 2, increment: 3):
   * - Level 1:   3 skill points (the starting allotment, not a level-up grant)
   * - Level 2-3: 5 per level-up
   * - Level 4-5: 8 per level-up
   * - Level 6-7: 11 per level-up
   */ skillPointsPerLevel: {
        base: 2,
        levelDivisor: 2,
        increment: 3
    },
    /**
   * Per-skill synergy unlocks (progressive disclosure of the synergy layer):
   * hidden entirely below minLevel, then each skill's synergies are bought
   * with skill points. A synergy variant can fire only when it touches an
   * unlocked skill on either side (the event's skill, or the skill of the
   * player's partner device).
   */ synergyUnlocks: {
        minLevel: 4,
        cost: 2
    },
    /**
   * Raid XP tier weighting (Command era). The level curve's old assumption
   * ("level 8 in 1-2 months") predates promotion cycling; with 3-5 day
   * tours, character level was the binding progression constraint - tours
   * stalled at level 4-5 on tier-1 XP. Pushing tiers is now the leveling
   * ladder: T1 pacing (and first-promotion timing) unchanged, T2/T3 raids
   * pay multiples so deep tours can level past the plateau.
   */ raidXpTierMultipliers: {
        1: 1,
        2: 3,
        3: 5
    },
    /**
   * Skill event damage scaling per raid tier
   * Damage formula: minDamage + random(0, maxDamage - minDamage)
   * where minDamage = baseDamage * tier, maxDamage = minDamage + (baseDamage * tier)
   *
   * Example with defaults (baseDamage: 5):
   * - Tier 1: 5-15 damage (5 + 0-10)
   * - Tier 2: 10-30 damage (10 + 0-20)
   * - Tier 3: 15-45 damage (15 + 0-30)
   */ skillEventDamage: {
        baseDamage: 5,
        perTier: {
            1: {
                min: 20,
                max: 30
            },
            2: {
                min: 25,
                max: 35
            },
            3: {
                min: 30,
                max: 40
            }
        }
    },
    /**
   * Bonus event cascade chance multipliers, per raid tier AND per cascade step.
   * Applied as: rarityDropChance * bonusEventCascadeMultipliers[tier][nextRarity]
   * when the end-of-room bonus event rolls to cascade common→rare→epic→legendary→unique.
   *
   * Per-rarity so the legendary step can be boosted (its base chance is near zero,
   * this is the main legendary blueprint source) WITHOUT saturating the rare/epic
   * steps - a flat multiplier clamped those to 100% per clean room.
   */ bonusEventCascadeMultipliers: {
        // rare < 1.0 keeps leaf-rare cascade volume near recipe demand.
        // Legendary (= artifact blueprints, the whole legendary pool) is a TIER 3
        // EXCLUSIVE: reaching T3 is the plannable path to artifacts (and the
        // Syndicate boundary), not a lottery ticket at every tier. 50 saturates
        // the legendary step (0.02 base x 50 = chance 1.0 once the cascade
        // reaches epic), so a clean T3 room drops a blueprint at its epic-chain
        // rate (~3% hazard, ~7% gate).
        1: {
            rare: 0.5,
            epic: 1.0,
            legendary: 0,
            unique: 1.0
        },
        2: {
            rare: 0.5,
            epic: 1.0,
            legendary: 0,
            unique: 1.0
        },
        3: {
            rare: 0.5,
            epic: 1.0,
            legendary: 50,
            unique: 1.0
        }
    },
    /**
   * Share of a promoted character's MATERIALS that passes to their successor.
   * The remainder is consigned to the Syndicate dock as Operations cargo
   * (command-core.js disburseInventory).
   *
   * Fixed, and was a three-rank Command upgrade ("Guild Vault", 80/240/720
   * marks) until the S7c pass removed it. The rank bought nothing: gear crafted
   * per tour is FLAT across a 2.5x range of this value - 5.57 at 10/20/30,
   * 6.07 at 15/30/50, 5.61 at 25/50/75, n=4 each - so the upgrade taxed 1,040
   * marks for an effect that does not exist. An upgrade that cannot be measured
   * is worse than no upgrade, because buying it is a trap.
   *
   * Why the share does not matter: it is not a one-way transfer. Whatever the
   * successor inherits and does not CONSUME is disbursed again at their own
   * promotion, and again after that, so the dial changes timing rather than
   * totals. Measured: at 75% carryover the L3 dock was unchanged (17,977 vs
   * 18,504 units) and zero convoys were ever refused for cargo.
   *
   * 0.3 because it equals the old rank-3 value - nobody who had fully invested
   * is worse off - and because a flat "a third of your kit passes on" reads
   * cleanly in the fiction. Any value in 0.1-0.75 measures the same.
   */ vaultCarryover: 0.3,
    /**
   * Share of the NON-carried remainder that reaches the Syndicate dock as
   * Operations cargo. The rest is consumed — spent living, in the fiction.
   *
   * The accounting used to be closed: 30% to the successor, 70% to L3, nothing
   * lost. That was tidy and produced an unusable economy. A dock held ~18,000
   * units while a whole era's convoys consumed ~1,500 (8%), so the "common
   * material piles plateau (<300/signature)" target measured ~2,500 and rising,
   * and cargo could never be a real constraint on Operations — even 10x the
   * cargo per convoy would not have drained it.
   *
   * No dial inside Operations could fix that, because the problem is supply,
   * not demand. This is the supply valve.
   */ consignmentRate: 0.15,
    /**
   * Command layer (M2) - Command Marks formula coefficients + unlock threshold.
   * Consumed by command-core.js calculateCommandMarks:
   *   marks = perTechGear       * distinct tech gear owned (inventory + equipped)
   *         + perArtifactUnlock * lifetime.artifactsUnlocked
   *         + perArtifactCraft  * lifetime.artifactsCrafted
   *         + floor(lifetime.t3Wins / t3WinsDivisor)
   *         + perLevel          * level
   * The sim promotion policy tunes these so an un-upgraded character #1's
   * marks/hour peaks ~day 3-5 (see docs/Roadmap-070426.md playtime budget).
   */ commandMarks: {
        // Marks reward CRAFTING, which is the player's active progress: skill gear
        // early (the only thing craftable at first), artifacts later (once T3 is
        // reachable). Character level is an ENABLER, not a payout - it unlocks
        // higher tiers, which yield T3 wins + blueprints -> artifacts; its direct
        // marks contribution is deliberately small so it can't become the main
        // driver (it previously grew to ~50% of marks as accounts matured).
        // Held at 4. Raising it was MEASURED in the S7c pass and rejected: at 8,
        // three runs put the first founding on day 31/34/31 - identical to the
        // 31-36 baseline - while Writs overshot to 34-38 and the L1 era collapsed
        // from ~40h to 18-21h. Two reasons, both structural:
        //
        //  - It cannot shorten a tour. Tour length is when cumulative marks/hour
        //    PEAKS, and a bigger gear channel moves that peak later by about as
        //    much as it pays, so the schedule does not move.
        //  - Marks are also the CURRENCY for Command upgrades, so doubling this
        //    halves the real price of the whole catalogue. The first promotion
        //    fires at the 60-mark floor, which needs ~15 gear at 4 and only 8 at
        //    8 - halving the onboarding era as a side effect.
        //
        // The L2 era overruns because tours 2-15 run ~26h against the ~18h the
        // 300h budget implies. That is a CYCLE COMPRESSION problem (officer-academy
        // / guild-vault head starts not paying off enough), not a throughput one,
        // and this coefficient is the wrong lever for it.
        perTechGear: 4,
        // Artifacts split into two channels (see command-core unlockArtifactCore):
        //   perArtifactUnlock - ONE-TIME per design per ACCOUNT, banked when the
        //     design's blueprint is consumed to unlock it. The milestone: 27
        //     designs => a finite ~675-mark collection goal.
        //   perArtifactCraft - each distinct craft per character (parallel to gear,
        //     ~2x a gear piece). Keeps a modest sustained artifact-marks trickle
        //     without the runaway 25-per-craft farm.
        perArtifactUnlock: 25,
        perArtifactCraft: 8,
        // T3 wins are the "operating at high tier" marks channel that level
        // enables (2 wins per mark); artifacts are the high-tier crafting payoff
        t3WinsDivisor: 2,
        perLevel: 1,
        // Command tab reveals when estimated marks first reach this. Tied to
        // perTechGear: it fires on the 7th piece of gear. If perTechGear ever
        // moves, scale this by the same ratio - it is a progression milestone
        // measured in what the player has BUILT, and leaving it fixed would slide
        // a designed reveal earlier as a side effect of an unrelated change.
        unlockThreshold: 25
    },
    /**
   * Promotion credit levy (applied in command-core.js promoteCharacterCore).
   * Credits are account-shared, so promotion takes a percentage cut instead
   * of a flat reset: kept = max(floor, credits * keepFraction). The levy is
   * the economy's terminal credit sink — it must scale with wealth to keep
   * absorbing late-game surplus; the floor doubles as a safety net so a
   * broke account still restarts with working capital.
   */ promotionCreditLevy: {
        keepFraction: 0.25,
        floor: 1000
    },
    /**
   * Collapse Key recovery — the ONLY tunable in the story track.
   *
   * Chance that a successful raid recovers the next Collapse Key its faction is
   * still missing. Not an economic number: keys have no value, no sink and no
   * sale, so this tunes STORY PACING alone and no balance target reads it.
   *
   * The tier table (keys 1-2 at T1, 3-4 at T2, 5-7 at T3) is what actually
   * paces the arc — a T1 character can only ever hold two keys, however long
   * they raid. This number decides how quickly they reach that ceiling: at 0.25
   * the first key lands in the opening session and the T1 pair inside ~8 wins,
   * which is the point of shipping keys 1-7 at all. The game previously told
   * the player nothing until ~900 hours in.
   */ collapseKeyDropChance: 0.25,
    /**
   * Raid credit reward scaling (applied in raidUtil.js applyCreditsScaling)
   * effective = earned * globalMultiplier * tierMultipliers[tier]
   */ creditsScaling: {
        globalMultiplier: 0.3,
        tierMultipliers: {
            1: 1.0,
            2: 1.0,
            3: 1.0
        }
    },
    /**
   * Energy repurchase escalation (applied in raidUtil.js
   * getConsumablePurchasePrice): energy-restoring consumables cost
   * base * escalationFactor^(purchases today), resetting daily.
   * The primary Command-era credit sink - converts surplus credits into
   * raid throughput at a net credit loss (late game: 5-6 packs/day
   * ~ the 4-10k/day income it must soak). 1.0 disables escalation.
   */ energyPurchaseScaling: {
        escalationFactor: 2.0
    },
    /**
   * Per-tour crafting discount (Command layer). Each completed tour makes
   * crafting cheaper for every later tour — the institutional-knowledge payoff.
   *
   * DERIVED, never compounded:
   *   globalMultiplier = craftingCostScaling.globalMultiplier * factor^(tour - 1)
   *
   * It used to be applied by multiplying raidUtil's module state at each
   * promotion, which main.js then re-seeded from config on every boot — so the
   * discount silently vanished on reload. Deriving it from `command.tour` makes
   * it reload-safe, and makes L3's founding reset free: tour returns to 1, so
   * the multiplier returns to base with nothing extra to persist.
   *
   * 1.0 disables the discount.
   */ craftingDiscountPerTour: 0.9,
    /**
   * Crafting credit cost scaling (applied in raidUtil.js applyCraftingCostScaling)
   * effective = cost * globalMultiplier * rarityMultipliers[rarity]
   */ craftingCostScaling: {
        globalMultiplier: 5,
        rarityMultipliers: {
            common: 1.0,
            uncommon: 1.0,
            rare: 1.0,
            epic: 1.0,
            legendary: 1.0,
            unique: 1.0,
            artifact: 1.0
        }
    }
};
function $96b8284e43b2ceb4$export$6941830bed591a7b(rarity) {
    var multiplier = $96b8284e43b2ceb4$export$9f9786ac427715c7.recipeInputs[rarity];
    if (multiplier === undefined) {
        console.warn("Unknown input rarity: ".concat(rarity, ", returning 1.0"));
        return 1.0;
    }
    return multiplier;
}
function $96b8284e43b2ceb4$export$2a160ac1bc0ae37b(quantity) {
    if (quantity < 10) // Keep 1-9 as-is
    return Math.max(1, Math.ceil(quantity));
    else if (quantity < 100) // Round 10-99 to nearest 5
    return Math.ceil(quantity / 5) * 5;
    else // Round 100+ to nearest 10
    return Math.ceil(quantity / 10) * 10;
}
function $96b8284e43b2ceb4$export$a43c2a5178ae7642(inputs) {
    var getRarityFn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    if (!inputs || !Array.isArray(inputs)) return inputs;
    return inputs.map(function(input) {
        var inputQty = input.qty;
        // Get input rarity (from input object or from provided function)
        var inputRarity = input.rarity;
        if (!inputRarity && getRarityFn) inputRarity = getRarityFn(input.id);
        // Apply per-input scaling based on rarity
        if (inputRarity) {
            var inputMultiplier = $96b8284e43b2ceb4$export$6941830bed591a7b(inputRarity);
            inputQty *= inputMultiplier;
        }
        return (0, $715bf31211e65705$export$71511d61b312f219)((0, $fa9769297b8a68c8$export$71511d61b312f219)({}, input), {
            qty: $96b8284e43b2ceb4$export$2a160ac1bc0ae37b(inputQty)
        });
    });
}


function $37e67442be28b253$export$59400736ce304c7(recipe) {
    if (!recipe || !recipe.inputs) return recipe;
    var getRarityOfInput = function(itemId) {
        var item = (0, $ca7af38ea7b7b4a8$export$a2dea178c28a0308)('id', itemId);
        return (item === null || item === void 0 ? void 0 : item.rarity) || 'common';
    };
    return (0, $715bf31211e65705$export$71511d61b312f219)((0, $fa9769297b8a68c8$export$71511d61b312f219)({}, recipe), {
        inputs: (0, $96b8284e43b2ceb4$export$a43c2a5178ae7642)(recipe.inputs, getRarityOfInput)
    });
}
function $37e67442be28b253$export$3645b25e1a815566(itemId) {
    var recipe = $979b99378be707cd$export$c4df318d1f4ad4.find(function(r) {
        return r.target === itemId;
    }) || $979b99378be707cd$export$c95766f8298d6ed1.find(function(r) {
        return r.target === itemId;
    }) || $979b99378be707cd$export$12c2125da4fa007.find(function(r) {
        return r.target === itemId;
    }) || $979b99378be707cd$export$ded4d2beb9be271a.find(function(r) {
        return r.target === itemId;
    });
    return recipe ? $37e67442be28b253$export$59400736ce304c7(recipe) : null;
}
function $37e67442be28b253$export$10d9b633aa01c262(scaledRecipe, character) {
    if (!(scaledRecipe === null || scaledRecipe === void 0 ? void 0 : scaledRecipe.inputs)) return false;
    var inventory = (character === null || character === void 0 ? void 0 : character.inventory) || {};
    return scaledRecipe.inputs.every(function(input) {
        return (inventory[input.id] || 0) >= input.qty;
    });
}
function $37e67442be28b253$export$e6fc872703f0201(itemId) {
    var _config_itemRarities_item_rarity;
    var item = (0, $ca7af38ea7b7b4a8$export$a2dea178c28a0308)('id', itemId);
    if (!item) return 0;
    return (0, $8bda0cb20f0b197d$export$574cc08100f7d092)(((_config_itemRarities_item_rarity = $979b99378be707cd$export$d4a72d069095e9e5[item.rarity]) === null || _config_itemRarities_item_rarity === void 0 ? void 0 : _config_itemRarities_item_rarity.craftingCost) || 10, item.rarity);
}


// ============================================================================
// INFINITE SCROLL STATE FOR CRAFTING
// ============================================================================
var $83869d722e7ea000$var$craftingScrollState = {
    /** @type {Array<any>} */ allFilteredRecipes: [],
    /** @type {Array<any>} */ visibleRecipes: [],
    pageSize: 15,
    /** @type {Object} */ preComputedMaterials: {},
    /** @type {IntersectionObserver|null} */ observer: null,
    /** Track the actual end position of loaded recipes */ loadedUpTo: 0,
    /** @type {NodeJS.Timeout|null} Debounce timeout ID to prevent rapid successive loads */ loadDebounceTimeout: null,
    reset: function() {
        this.allFilteredRecipes = [];
        this.visibleRecipes = [];
        this.preComputedMaterials = {};
        this.loadedUpTo = 0;
        if (this.loadDebounceTimeout) {
            clearTimeout(this.loadDebounceTimeout);
            this.loadDebounceTimeout = null;
        }
    },
    hasMoreToLoad: function() {
        return this.loadedUpTo < this.allFilteredRecipes.length;
    },
    loadMore: function() {
        var _this = this;
        if (!this.hasMoreToLoad()) return false;
        var end = Math.min(this.loadedUpTo + this.pageSize, this.allFilteredRecipes.length);
        // Load from start (0) to current end position
        this.visibleRecipes = this.allFilteredRecipes.slice(0, end);
        this.loadedUpTo = end;
        // Set debounce timeout for 300ms to prevent rapid loads
        this.loadDebounceTimeout = setTimeout(function() {
            _this.loadDebounceTimeout = null;
        }, 300);
        return true;
    }
};
function $83869d722e7ea000$export$ac539fb4b9c6f75e(artifactKey) {
    var artifact = (0, $ca7af38ea7b7b4a8$export$891bd687a67340b8)('id', artifactKey);
    if (!artifact) return false;
    // Check if player's faction matches artifact faction (or artifact is neutral)
    if (artifact.faction !== 'neutral' && (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.faction !== artifact.faction) return false;
    // The design must be unlocked (blueprint consumed) before it can be crafted
    if (!(0, $ee71dfe8b201c427$export$2ab3ae91631fe8e5)(artifactKey)) return false;
    // Find the recipe for this artifact and check if it can be crafted
    var recipe = (0, $37e67442be28b253$export$3645b25e1a815566)(artifactKey);
    if (!recipe) return false;
    // Use the existing canCraftRecipe function to check materials
    return $83869d722e7ea000$export$10d9b633aa01c262(recipe);
}
function $83869d722e7ea000$export$67f8f6c6271cd4a2(itemId, isArtifact) {
    // Check if current character is on marketplace
    if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character && (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.isMarketplace) {
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)('Cannot craft with a character that is contracted out on the marketplace', 'error');
        return false;
    }
    if (isArtifact) return $83869d722e7ea000$export$cf54799c3e0d127e(itemId);
    else return $83869d722e7ea000$var$craftComponent(itemId);
}
function $83869d722e7ea000$var$craftComponent(itemId) {
    var quantity = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    var _gameState_player;
    var item = (0, $ca7af38ea7b7b4a8$export$a2dea178c28a0308)('id', itemId);
    if (!item) {
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)('Unknown component recipe!', 'error');
        return false;
    }
    // Get recipe with scaling applied
    var recipe = (0, $37e67442be28b253$export$3645b25e1a815566)(itemId);
    if (!recipe) {
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)('Recipe not found!', 'error');
        return false;
    }
    // One craft per design per character for durable tech gear (equip-once,
    // one per skill). Consumables and intermediate components stay repeatable.
    if (item.type === 'techGear' && !(0, $ee71dfe8b201c427$export$c95b8ce76efadccf)() && (0, $ee71dfe8b201c427$export$2886ceaa061d802b)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character, itemId)) {
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)("".concat(item.name, " is already crafted - one per character."), 'error');
        return false;
    }
    // Calculate total credit cost for all crafts
    var creditCost = $83869d722e7ea000$export$5c9f0b8d2a488474(itemId, quantity);
    var playerCredits = ((_gameState_player = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player) === null || _gameState_player === void 0 ? void 0 : _gameState_player.credits) || 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // Check materials for all quantities
        for(var _iterator = recipe.inputs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var input = _step.value;
            var available = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.inventory[input.id] || 0;
            var needed = input.qty * quantity;
            if (available < needed) {
                var _findItem;
                (0, $b5bda7fdec806d8b$export$c7def531c087da85)("Missing materials! Need ".concat(needed - available, " more ").concat(((_findItem = (0, $ca7af38ea7b7b4a8$export$a2dea178c28a0308)('id', input.id)) === null || _findItem === void 0 ? void 0 : _findItem.name) || input.id), 'error');
                return false;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Check credits
    if (playerCredits < creditCost) {
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)("Not enough credits! Need ".concat(creditCost, ", have ").concat(playerCredits), 'error');
        return false;
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        // Consume materials
        for(var _iterator1 = recipe.inputs[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var input1 = _step1.value;
            (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.inventory[input1.id] -= input1.qty * quantity;
            if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.inventory[input1.id] <= 0) delete (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.inventory[input1.id];
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    // Deduct credits
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player.credits -= creditCost;
    // Add crafted items to inventory
    if (!(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.inventory[item.id]) (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.inventory[item.id] = 0;
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.inventory[item.id] += quantity;
    (0, $80ed874fd909c4ae$export$5b73e6a29e58b929)();
    var message = quantity > 1 ? "Crafted ".concat(quantity, "x ").concat(item.name, " for ").concat(creditCost, "\uD83D\uDCB0!") : "Crafted ".concat(item.name, " for ").concat(creditCost, "\uD83D\uDCB0!");
    (0, $b5bda7fdec806d8b$export$c7def531c087da85)(message, 'success');
    (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
    return true;
}
function $83869d722e7ea000$export$3bec963ccca7a0ba() {
    var quantity = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
    if (quantity >= 20) return 50;
    if (quantity >= 11) return 65;
    if (quantity >= 6) return 75;
    if (quantity >= 2) return 85;
    return 100;
}
function $83869d722e7ea000$export$5c9f0b8d2a488474(itemId) {
    var quantity = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    var item = (0, $ca7af38ea7b7b4a8$export$a2dea178c28a0308)('id', itemId);
    if (!item) return 0;
    // Base cost from rarity, scaled by progressionScaling.craftingCostScaling.
    // Lives in recipes-core so the simulator and Auto-Fabricator charge the
    // same thing - keep parity.
    var baseCost = (0, $37e67442be28b253$export$e6fc872703f0201)(itemId);
    // Get cost percentage based on quantity (higher qty = lower percentage = more discount)
    var costPercent = $83869d722e7ea000$export$3bec963ccca7a0ba(quantity);
    // Calculate total cost with bulk discount applied
    var costPerUnit = baseCost * costPercent / 100;
    return Math.ceil(costPerUnit * quantity);
}
function $83869d722e7ea000$export$cf54799c3e0d127e(artifactKey) {
    var artifact = (0, $ca7af38ea7b7b4a8$export$891bd687a67340b8)('id', artifactKey);
    if (!artifact) {
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)('Unknown artifact recipe!', 'error');
        return false;
    }
    if (!$83869d722e7ea000$export$ac539fb4b9c6f75e(artifactKey)) {
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)('Cannot craft this artifact - missing materials or wrong faction!', 'error');
        return false;
    }
    // One craft per design per character (artifacts are equip-once; a duplicate
    // earns no marks and has no use). Toggle via allowDuplicateCrafts.
    if (!(0, $ee71dfe8b201c427$export$c95b8ce76efadccf)() && (0, $ee71dfe8b201c427$export$770281d4afda41b1)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character, artifactKey)) {
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)("".concat(artifact.name, " is already crafted - one per character."), 'error');
        return false;
    }
    // Get recipe with scaling applied
    var recipe = (0, $37e67442be28b253$export$3645b25e1a815566)(artifactKey);
    if (!recipe) {
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)('Artifact recipe not found!', 'error');
        return false;
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // Consume materials from recipe (blueprints are NO LONGER recipe inputs -
        // they're consumed once by unlockArtifact to unlock the design; crafting
        // an unlocked design costs materials only)
        for(var _iterator = recipe.inputs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var input = _step.value;
            (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.inventory[input.id] -= input.qty;
            if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.inventory[input.id] <= 0) delete (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.inventory[input.id];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Create artifact instance with unique ID
    var craftedArtifact = {
        key: Date.now() + Math.random(),
        id: artifact.id,
        name: artifact.name,
        type: artifact.type,
        slot: artifact.slot,
        skill: artifact.skill,
        effects: artifact.effects,
        description: artifact.description,
        short: artifact.short,
        faction: artifact.faction,
        rarity: artifact.rarity,
        icon: artifact.icon,
        crafted: true
    };
    // Add to artifacts collection
    if (!(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.artifacts) (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.artifacts = [];
    var firstOfType = !(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.artifacts.some(function(a) {
        return a.id === craftedArtifact.id;
    });
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.artifacts.push(craftedArtifact);
    // Lifetime counter for the Command Marks formula: DISTINCT designs only.
    // Command rewards novel engineering, not mass production - duplicate
    // crafts (deep tours farming blueprints at T3) earn no extra marks.
    (0, $fe47a452a83d9e00$export$6b22d50e3ddf4789)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character);
    if (firstOfType) (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.lifetime.artifactsCrafted += 1;
    (0, $80ed874fd909c4ae$export$5b73e6a29e58b929)();
    (0, $b5bda7fdec806d8b$export$c7def531c087da85)("Crafted ".concat(artifact.name, "!"), 'success');
    (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
    return true;
}
function $83869d722e7ea000$export$506c247f43a19ac3(artifactKey) {
    var artifact = (0, $ca7af38ea7b7b4a8$export$891bd687a67340b8)('id', artifactKey);
    if (!artifact) {
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)('Unknown artifact design!', 'error');
        return false;
    }
    var result = (0, $ee71dfe8b201c427$export$5361c32fc9d089b2)(artifactKey);
    if (!result.success) {
        var msg = result.reason === 'already-unlocked' ? 'Design already unlocked.' : 'You need this design\'s blueprint to unlock it.';
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)(msg, 'error');
        return false;
    }
    (0, $80ed874fd909c4ae$export$5b73e6a29e58b929)();
    (0, $b5bda7fdec806d8b$export$c7def531c087da85)("\uD83D\uDD13 ".concat(artifact.name, " design unlocked! +").concat(result.marks, " \uD83C\uDF96\uFE0F at promotion"), 'success');
    (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
    return true;
}
function $83869d722e7ea000$export$36d50cdf3bb88c77(itemId) {
    var depths = new Map(); // itemId -> deepest depth seen (target = 0)
    var walk = function(id, depth, pathSeen) {
        var recipe = (0, $37e67442be28b253$export$3645b25e1a815566)(id);
        if (!recipe) return; // raw material - not part of the craftable tree
        var _depths_get;
        if (((_depths_get = depths.get(id)) !== null && _depths_get !== void 0 ? _depths_get : -1) < depth) depths.set(id, depth);
        if (pathSeen.has(id)) return; // cycle guard
        var nextSeen = new Set(pathSeen).add(id);
        (recipe.inputs || []).forEach(function(input) {
            return walk(input.id, depth + 1, nextSeen);
        });
    };
    walk(itemId, 0, new Set());
    return (0, $4c858c0d999a5b9b$export$71511d61b312f219)(depths.entries()).sort(function(a, b) {
        return b[1] - a[1];
    }).map(function(param) {
        var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 1), id = _param[0];
        return id;
    });
}
function $83869d722e7ea000$export$911925165af984c6() {
    var recipes = [];
    // Add component recipes (uncommon, rare, epic) with scaling applied
    var craftingRecipes = (0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$c4df318d1f4ad4).concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$c95766f8298d6ed1), (0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$12c2125da4fa007));
    // Batch lookup all target items at once instead of individual lookups
    var targetIds = craftingRecipes.map(function(r) {
        return r.target;
    });
    var itemsMap = (0, $ca7af38ea7b7b4a8$export$4251a114f7437961)(targetIds);
    craftingRecipes.forEach(function(recipe) {
        var item = itemsMap[recipe.target];
        if (item) {
            // Get scaled recipe to apply progression scaling
            var scaledRecipe = (0, $37e67442be28b253$export$3645b25e1a815566)(recipe.target);
            recipes.push((0, $715bf31211e65705$export$71511d61b312f219)((0, $fa9769297b8a68c8$export$71511d61b312f219)({}, scaledRecipe || recipe), {
                itemRarity: item.rarity,
                itemType: item.type,
                techniqueId: item.techniqueId
            }));
        }
    });
    // Add artifact recipes with scaling applied
    $979b99378be707cd$export$ded4d2beb9be271a.forEach(function(recipe) {
        var artifact = (0, $ca7af38ea7b7b4a8$export$891bd687a67340b8)('id', recipe.target);
        if (artifact) {
            // Get scaled recipe to apply progression scaling
            var scaledRecipe = (0, $37e67442be28b253$export$3645b25e1a815566)(recipe.target);
            recipes.push((0, $715bf31211e65705$export$71511d61b312f219)((0, $fa9769297b8a68c8$export$71511d61b312f219)({}, scaledRecipe || recipe), {
                itemRarity: artifact.rarity,
                itemType: artifact.type
            }));
        }
    });
    return recipes;
}
function $83869d722e7ea000$export$c8bcd6f2224f6fb9() {
    var recipes = [];
    var playerFaction = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.faction;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries((0, $ca7af38ea7b7b4a8$export$18c4115a8e7963b)())[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step.value, 2), key = _step_value[0], artifact = _step_value[1];
            // Only show recipes for player's faction or neutral artifacts
            if (artifact.faction === 'neutral' || artifact.faction === playerFaction) recipes.push((0, $715bf31211e65705$export$71511d61b312f219)((0, $fa9769297b8a68c8$export$71511d61b312f219)({
                key: key
            }, artifact), {
                canCraft: $83869d722e7ea000$export$ac539fb4b9c6f75e(key)
            }));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return recipes;
}
function $83869d722e7ea000$export$aa7c3ee86bbf0990() {
    var techniqueId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    var modal = document.getElementById('crafting-modal');
    if (!modal) {
        $83869d722e7ea000$export$2cb4af04d696a1ed();
        return $83869d722e7ea000$export$aa7c3ee86bbf0990(techniqueId);
    }
    // If a techniqueId is provided, filter to techGear type for that technique
    var filterType = document.getElementById('filter-type');
    if (filterType) filterType.value = techniqueId ? 'techGear' : '';
    if (techniqueId) // Store the techniqueId so refreshCraftingList can use it for additional filtering
    modal.dataset.filteredTechniqueId = techniqueId;
    else // Clear any previous technique filter
    delete modal.dataset.filteredTechniqueId;
    $83869d722e7ea000$var$refreshCraftingList();
    modal.classList.remove('hidden');
}
function $83869d722e7ea000$export$bdea6cc9473d0c95() {
    $83869d722e7ea000$export$aa7c3ee86bbf0990();
}
function $83869d722e7ea000$export$301cbaf87c15a68f(itemId) {
    var modal = document.getElementById('crafting-modal');
    if (!modal) {
        $83869d722e7ea000$export$2cb4af04d696a1ed();
        modal = document.getElementById('crafting-modal');
    }
    modal.dataset.treeFilterItemId = itemId;
    delete modal.dataset.filteredTechniqueId;
    // Tree mode shows the whole chain: neutralize the manual filters
    var filterType = document.getElementById('filter-type');
    var filterRarity = document.getElementById('filter-rarity');
    var filterCraftable = document.getElementById('filter-craftable');
    if (filterType) filterType.value = '';
    if (filterRarity) filterRarity.value = '';
    if (filterCraftable) filterCraftable.checked = false;
    $83869d722e7ea000$var$refreshCraftingList();
    modal.classList.remove('hidden');
}
function $83869d722e7ea000$export$e186070c9358ae3a() {
    var modal = document.getElementById('crafting-modal');
    if (!modal) return;
    delete modal.dataset.treeFilterItemId;
    $83869d722e7ea000$var$refreshCraftingList();
}
function $83869d722e7ea000$export$2cb4af04d696a1ed() {
    // Build type filter options from config
    var craftableTypes = [
        'material',
        'consumable',
        'techGear',
        'artifact'
    ];
    var typeOptions = craftableTypes.map(function(type) {
        var _config_itemTypes_type;
        var typeName = ((_config_itemTypes_type = $979b99378be707cd$export$d02ea220375e4aff[type]) === null || _config_itemTypes_type === void 0 ? void 0 : _config_itemTypes_type.name) || type;
        return '<option value="'.concat(type, '">').concat(typeName, "</option>");
    }).join('');
    // Build rarity filter options from config
    var craftableRarities = [
        'uncommon',
        'rare',
        'epic',
        'unique'
    ];
    var rarityOptions = craftableRarities.map(function(rarity) {
        var _config_itemRarities_rarity;
        var rarityName = ((_config_itemRarities_rarity = $979b99378be707cd$export$d4a72d069095e9e5[rarity]) === null || _config_itemRarities_rarity === void 0 ? void 0 : _config_itemRarities_rarity.name) || rarity;
        return '<option value="'.concat(rarity, '">').concat(rarityName, "</option>");
    }).join('');
    var modal = document.createElement('div');
    modal.id = 'crafting-modal';
    modal.className = 'modal hidden';
    modal.innerHTML = '\n        <div class="modal-content crafting-modal-content max-w-6xl w-full max-h-screen">\n            <div class="modal-header">\n                <h3 class="modal-title">Crafting</h3>\n                <button id="close-crafting-modal" class="close-btn">&times;</button>\n            </div>\n            <div class="modal-body overflow-hidden">\n                <div class="flex gap-2 p-4 border-b border-gray-600">\n                    <select id="filter-type" class="px-2 py-1 bg-gray-700 border border-gray-600 rounded text-sm">\n                        <option value="">All Types</option>\n                        '.concat(typeOptions, '\n                    </select>\n                    <select id="filter-rarity" class="px-2 py-1 bg-gray-700 border border-gray-600 rounded text-sm">\n                        <option value="">All Rarities</option>\n                        ').concat(rarityOptions, '\n                    </select>\n                    <label class="flex items-center gap-1 text-sm">\n                        <input type="checkbox" id="filter-craftable" class="form-checkbox">\n                        <span>Craftable Only</span>\n                    </label>\n                    <span id="crafting-tree-chip" class="hidden items-center gap-2 px-3 py-1 rounded-full border border-game-accent text-game-accent text-xs font-bold">\n                        <!-- populated by refreshCraftingList when the tree filter is active -->\n                    </span>\n                </div>\n                <div id="crafting-recipe-list" class="grid gap-4 p-4" style="grid-template-columns: repeat(auto-fit, 13rem); justify-content: center; height: calc(70vh - 200px); overflow-y: auto; scrollbar-width: thin; scrollbar-color: #4a5568 #2d3748;">\n                    <!-- Recipes will be populated here -->\n                </div>\n            </div>\n        </div>\n    ');
    document.body.appendChild(modal);
    // Add event listener for close button
    var closeBtn = document.getElementById('close-crafting-modal');
    closeBtn.addEventListener('click', function() {
        modal.classList.add('hidden');
    });
    // Add filter listeners
    var filterType = document.getElementById('filter-type');
    var filterRarity = document.getElementById('filter-rarity');
    var filterCraftable = document.getElementById('filter-craftable');
    filterType.addEventListener('change', function() {
        // Clear technique + tree filters when user manually changes the type filter
        delete modal.dataset.filteredTechniqueId;
        delete modal.dataset.treeFilterItemId;
        $83869d722e7ea000$var$refreshCraftingList();
    });
    filterRarity.addEventListener('change', function() {
        // Manual rarity browsing exits tree mode too (a rarity slice of a
        // dependency chain reads as missing items, not as a filter)
        delete modal.dataset.treeFilterItemId;
        $83869d722e7ea000$var$refreshCraftingList();
    });
    // Craftable-only applies WITHIN tree mode (show me what I can craft next)
    filterCraftable.addEventListener('change', function() {
        return $83869d722e7ea000$var$refreshCraftingList();
    });
    // Close modal when clicking outside (only if mousedown started on background)
    var mousedownTarget = null;
    modal.addEventListener('mousedown', function(e) {
        mousedownTarget = e.target;
    });
    modal.addEventListener('click', function(e) {
        if (e.target === modal && mousedownTarget === modal) modal.classList.add('hidden');
    });
}
function $83869d722e7ea000$export$10d9b633aa01c262(scaledRecipe) {
    var character = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character;
    return (0, $37e67442be28b253$export$10d9b633aa01c262)(scaledRecipe, character);
}
function $83869d722e7ea000$var$createRecipeCard(recipe, preComputedMaterials) {
    // Recipe is already scaled from getAllRecipes()
    // For artifacts, get full item data
    var item = recipe.itemType === 'artifact' ? (0, $ca7af38ea7b7b4a8$export$891bd687a67340b8)('id', recipe.target) : (0, $ca7af38ea7b7b4a8$export$a2dea178c28a0308)('id', recipe.target);
    return item ? (0, $a575049a7e5cb3a1$export$4ac7f915da1fa1c4)(item, 'crafting', recipe, preComputedMaterials, {
        inModal: true
    }) : '';
}
function $83869d722e7ea000$var$refreshCraftingList() {
    var modal = document.getElementById('crafting-modal');
    var recipeList = document.getElementById('crafting-recipe-list');
    var filterType = document.getElementById('filter-type').value;
    var filterRarity = document.getElementById('filter-rarity').value;
    var filterCraftable = document.getElementById('filter-craftable').checked;
    var filteredTechniqueId = modal === null || modal === void 0 ? void 0 : modal.dataset.filteredTechniqueId;
    var treeFilterItemId = modal === null || modal === void 0 ? void 0 : modal.dataset.treeFilterItemId;
    var recipes = $83869d722e7ea000$export$911925165af984c6();
    if (treeFilterItemId) {
        // Component-tree mode: only the target + its craftable components,
        // ordered deepest-first (craft order). Replaces type/rarity/technique
        // filtering; Craftable Only still applies within the tree.
        var treeOrder = $83869d722e7ea000$export$36d50cdf3bb88c77(treeFilterItemId);
        var orderIndex = new Map(treeOrder.map(function(id, i) {
            return [
                id,
                i
            ];
        }));
        recipes = recipes.filter(function(r) {
            return orderIndex.has(r.target);
        });
        recipes.sort(function(a, b) {
            return orderIndex.get(a.target) - orderIndex.get(b.target);
        });
    } else {
        // Apply filters
        if (filterType) recipes = recipes.filter(function(r) {
            return r.itemType === filterType;
        });
        if (filterRarity) recipes = recipes.filter(function(r) {
            return r.itemRarity === filterRarity;
        });
        // If a technique filter is active, filter by technique ID
        if (filteredTechniqueId) recipes = recipes.filter(function(r) {
            return r.techniqueId === filteredTechniqueId;
        });
    }
    if (filterCraftable) recipes = recipes.filter(function(r) {
        return $83869d722e7ea000$export$10d9b633aa01c262(r);
    });
    // Tree filter chip: shows the target + item count, ✕ returns to browsing
    var treeChip = document.getElementById('crafting-tree-chip');
    if (treeChip) {
        if (treeFilterItemId) {
            var targetItem = (0, $ca7af38ea7b7b4a8$export$a2dea178c28a0308)('id', treeFilterItemId) || (0, $ca7af38ea7b7b4a8$export$891bd687a67340b8)('id', treeFilterItemId);
            treeChip.innerHTML = "\uD83C\uDF33 Components: <b>".concat((targetItem === null || targetItem === void 0 ? void 0 : targetItem.name) || treeFilterItemId, '</b>\n                <span class="text-gray-400 font-normal">(').concat(recipes.length, ' craftable, deepest first)</span>\n                <button onclick="clearCraftingTreeFilter()" class="text-gray-400 hover:text-white font-bold ml-1" title="Back to all recipes">\u2715</button>');
            treeChip.classList.remove('hidden');
            treeChip.classList.add('inline-flex');
        } else {
            treeChip.classList.add('hidden');
            treeChip.classList.remove('inline-flex');
        }
    }
    // Pre-compute all materials for all recipes in one batch lookup
    var allMaterialIds = [];
    recipes.forEach(function(recipe) {
        if (recipe.inputs) recipe.inputs.forEach(function(input) {
            if (!allMaterialIds.includes(input.id)) allMaterialIds.push(input.id);
        });
    });
    var preComputedMaterials = allMaterialIds.length > 0 ? (0, $ca7af38ea7b7b4a8$export$4251a114f7437961)(allMaterialIds) : {};
    // Reset scroll state with new filtered recipes
    $83869d722e7ea000$var$craftingScrollState.reset();
    $83869d722e7ea000$var$craftingScrollState.allFilteredRecipes = recipes;
    $83869d722e7ea000$var$craftingScrollState.preComputedMaterials = preComputedMaterials;
    // Load initial batch
    $83869d722e7ea000$var$craftingScrollState.loadMore();
    if (recipeList) {
        $83869d722e7ea000$var$renderCraftingRecipes(recipeList);
        // Set up infinite scroll observer
        $83869d722e7ea000$var$setupCraftingScrollObserver(recipeList);
    }
}
/**
 * Render the visible recipes to the DOM
 * @param {HTMLElement} recipeList - The recipe list container
 */ function $83869d722e7ea000$var$renderCraftingRecipes(recipeList) {
    var // Re-attach Tippy tooltips to the freshly-rendered card artwork (innerHTML
    // replacement above drops any previous instances)
    _window_reinitializeInventoryTooltips, _window;
    recipeList.innerHTML = '';
    $83869d722e7ea000$var$craftingScrollState.visibleRecipes.forEach(function(recipe) {
        var cardHtml = $83869d722e7ea000$var$createRecipeCard(recipe, $83869d722e7ea000$var$craftingScrollState.preComputedMaterials);
        recipeList.innerHTML += cardHtml;
    });
    // Add loading indicator if there are more recipes to load
    if ($83869d722e7ea000$var$craftingScrollState.visibleRecipes.length < $83869d722e7ea000$var$craftingScrollState.allFilteredRecipes.length) {
        var loadingEl = document.createElement('div');
        loadingEl.id = 'crafting-scroll-trigger';
        loadingEl.style.height = '1px';
        recipeList.appendChild(loadingEl);
    }
    (_window_reinitializeInventoryTooltips = (_window = window).reinitializeInventoryTooltips) === null || _window_reinitializeInventoryTooltips === void 0 ? void 0 : _window_reinitializeInventoryTooltips.call(_window);
}
/**
 * Set up Intersection Observer for infinite scroll
 * @param {HTMLElement} recipeList - The recipe list container
 */ function $83869d722e7ea000$var$setupCraftingScrollObserver(recipeList) {
    // Remove old observer if it exists
    if ($83869d722e7ea000$var$craftingScrollState.observer) $83869d722e7ea000$var$craftingScrollState.observer.disconnect();
    var pendingLoad = false;
    // Create observer to trigger load more when user scrolls near bottom
    $83869d722e7ea000$var$craftingScrollState.observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting && !pendingLoad) {
                pendingLoad = true;
                var didLoad = $83869d722e7ea000$var$craftingScrollState.loadMore();
                if (didLoad) {
                    $83869d722e7ea000$var$renderCraftingRecipes(recipeList);
                    // Wait before re-observing to allow the DOM to settle
                    setTimeout(function() {
                        var newTrigger = document.getElementById('crafting-scroll-trigger');
                        if (newTrigger && $83869d722e7ea000$var$craftingScrollState.observer) {
                            // Unobserve old trigger first
                            if (entry.target) $83869d722e7ea000$var$craftingScrollState.observer.unobserve(entry.target);
                            $83869d722e7ea000$var$craftingScrollState.observer.observe(newTrigger);
                        }
                        pendingLoad = false;
                    }, 100);
                } else pendingLoad = false;
            }
        });
    }, {
        root: recipeList,
        rootMargin: '100px',
        threshold: 0
    });
    // Observe the initial trigger element
    var trigger = document.getElementById('crafting-scroll-trigger');
    if (trigger) $83869d722e7ea000$var$craftingScrollState.observer.observe(trigger);
}






/**
 * Sub-tabs — one pane visible at a time, scrolling inside the viewport.
 *
 * Extracted from character.js, which had the only working copy of this. The
 * Command and Syndicate pages needed the same behaviour and gear.js already had
 * a second variant, so a third and fourth would have been four implementations
 * of one idea — and the subtle part (the sizing retry below) is exactly what
 * gets dropped when a pattern is re-typed rather than reused.
 *
 * Two jobs, and the second is the one that matters for tablets:
 *
 *   1. Show one pane, hide the rest, mark the active button.
 *   2. Cap the active pane's scroller at the viewport bottom, so a long list
 *      scrolls INSIDE the pane instead of growing the page. That is what keeps
 *      a page fitting a 768px-tall viewport regardless of how much content it
 *      grows later.
 */ 

/** groupId -> { panes, scrollers, active, onShow } */ var $bf6cb3ebdd8098d6$var$groups = new Map();
function $bf6cb3ebdd8098d6$export$589dc1e4c906c789(groupId, param) {
    var panes = param.panes, _param_scrollers = param.scrollers, scrollers = _param_scrollers === void 0 ? {} : _param_scrollers, _param_defaultTab = param.defaultTab, defaultTab = _param_defaultTab === void 0 ? null : _param_defaultTab, _param_onShow = param.onShow, onShow = _param_onShow === void 0 ? null : _param_onShow;
    $bf6cb3ebdd8098d6$var$groups.set(groupId, {
        panes: panes,
        scrollers: scrollers,
        onShow: onShow,
        active: defaultTab || Object.keys(panes)[0]
    });
}
function $bf6cb3ebdd8098d6$export$50d0994bd60f586c(groupId) {
    var _groups_get;
    return ((_groups_get = $bf6cb3ebdd8098d6$var$groups.get(groupId)) === null || _groups_get === void 0 ? void 0 : _groups_get.active) || null;
}
function $bf6cb3ebdd8098d6$export$7ad721b2ffe28f0c(groupId) {
    var _document_getElementById, _group_onShow;
    var group = $bf6cb3ebdd8098d6$var$groups.get(groupId);
    if (!group) return;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(group.panes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step.value, 2), name = _step_value[0], elementId = _step_value[1];
            (_document_getElementById = document.getElementById(elementId)) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.classList.toggle('hidden', name !== group.active);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    document.querySelectorAll('[data-subtab-group="'.concat(groupId, '"]')).forEach(function(btn) {
        btn.classList.toggle('active', btn.dataset.subtab === group.active);
    });
    (_group_onShow = group.onShow) === null || _group_onShow === void 0 ? void 0 : _group_onShow.call(group, group.active);
    $bf6cb3ebdd8098d6$var$sizeActiveScroller(groupId);
}
function $bf6cb3ebdd8098d6$export$8a8da8bddae1b567(groupId, name) {
    var group = $bf6cb3ebdd8098d6$var$groups.get(groupId);
    if (!group || !(name in group.panes)) return;
    group.active = name;
    $bf6cb3ebdd8098d6$export$7ad721b2ffe28f0c(groupId);
}
/**
 * Cap the active scroller at the viewport bottom.
 *
 * Measured from the element's own document offset rather than a fixed header
 * height, so it is immune to whatever sits above it (a stats strip, a founding
 * banner) changing height.
 *
 * The retry is load-bearing: during a boot reveal or a tab fade-in the element
 * is not laid out yet and measures 0, and writing that would clamp the pane to
 * the 200px floor permanently. Bounded so a genuinely hidden pane cannot spin.
 */ var $bf6cb3ebdd8098d6$var$sizeRaf = new Map();
function $bf6cb3ebdd8098d6$var$sizeActiveScroller(groupId) {
    var attempt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var group = $bf6cb3ebdd8098d6$var$groups.get(groupId);
    if (!group) return;
    var pending = $bf6cb3ebdd8098d6$var$sizeRaf.get(groupId);
    if (pending) {
        cancelAnimationFrame(pending);
        $bf6cb3ebdd8098d6$var$sizeRaf.delete(groupId);
    }
    var elementId = group.scrollers[group.active] || group.panes[group.active];
    var el = document.getElementById(elementId);
    if (!el) return;
    var absTop = el.offsetParent === null ? 0 : el.getBoundingClientRect().top + window.scrollY;
    if (absTop <= 0) {
        if (attempt < 30) $bf6cb3ebdd8098d6$var$sizeRaf.set(groupId, requestAnimationFrame(function() {
            return $bf6cb3ebdd8098d6$var$sizeActiveScroller(groupId, attempt + 1);
        }));
        return;
    }
    el.style.maxHeight = "".concat(Math.max(200, window.innerHeight - absTop - $bf6cb3ebdd8098d6$var$BOTTOM_GAP - $bf6cb3ebdd8098d6$var$chromeBelow(el)), "px");
    el.style.overflowY = 'auto';
}
/** Breathing room under the scroller, so it never sits flush to the fold. */ var $bf6cb3ebdd8098d6$var$BOTTOM_GAP = 12;
/**
 * Padding, border and margin BELOW the scroller, all the way out to <body>.
 *
 * Clamping the scroller to the viewport is not enough on its own: the panes wrap
 * it in padding and a 4px border, and the page container adds its own bottom
 * padding — the page still overflowed by exactly that chrome. Walking to body
 * rather than stopping at `.tab-content` is what closes the last few pixels.
 *
 * Read from computed STYLE, not measured geometry: this runs while the scroller
 * is mid-clamp, and a geometric read would feed its own result back in.
 */ function $bf6cb3ebdd8098d6$var$chromeBelow(el) {
    var total = 0;
    for(var node = el.parentElement; node && node !== document.body; node = node.parentElement){
        var cs = getComputedStyle(node);
        total += parseFloat(cs.paddingBottom) || 0;
        total += parseFloat(cs.borderBottomWidth) || 0;
        total += parseFloat(cs.marginBottom) || 0;
    }
    return total;
}
function $bf6cb3ebdd8098d6$export$514a72c52a691f03() {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $bf6cb3ebdd8098d6$var$groups.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var groupId = _step.value;
            $bf6cb3ebdd8098d6$var$sizeActiveScroller(groupId);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
if (typeof window !== 'undefined') {
    window.setSubTab = $bf6cb3ebdd8098d6$export$8a8da8bddae1b567;
    window.addEventListener('resize', (0, $ca7af38ea7b7b4a8$export$61fc7d43ac8f84b0)($bf6cb3ebdd8098d6$export$514a72c52a691f03, 100));
}


/**
 * Skill tabs — show one faction skill's content at a time.
 *
 * Three surfaces present the same 5-skill set: the character page's Skills pane,
 * the Gear tab's Field Kit, and its Technique Consumables. All three used to
 * render every skill at once, which is what made those pages scroll several
 * screens deep on a tablet. This is the one strip implementation they share,
 * for the same reason subTabs.js exists — see that file's header.
 *
 * The distinction from subTabs.js is deliberate: that module toggles STATIC
 * panes by element id and clamps their scroll height. These panes are rebuilt
 * from data on every render, so there is nothing stable to toggle — the caller
 * re-renders and asks which skill to draw.
 *
 * Selection is module-scoped per group, so re-rendering (crafting a piece,
 * spending a point) keeps the player on the skill they were reading. Groups are
 * independent: the skill you are reading about is not necessarily the one whose
 * gear you are crafting.
 */ 




function $bd823d1c24941985$export$71511d61b312f219(arr) {
    return (0, $94d3f045916e0583$export$71511d61b312f219)(arr) || (0, $b0c62864eda90b51$export$71511d61b312f219)(arr) || (0, $d6f91c356a8197fd$export$71511d61b312f219)(arr) || (0, $2b2eb8ca3633154b$export$71511d61b312f219)();
}




/** groupId -> selected skill key */ var $e8f8e272b259f38e$var$selected = new Map();
/** groupId -> re-render callback, invoked on switch */ var $e8f8e272b259f38e$var$renderers = new Map();
var $e8f8e272b259f38e$var$skillKeysFor = function(faction) {
    var _config_factionSkills_faction;
    return Object.keys(((_config_factionSkills_faction = $979b99378be707cd$export$aeeef991191508e2[faction]) === null || _config_factionSkills_faction === void 0 ? void 0 : _config_factionSkills_faction.skills) || {});
};
function $e8f8e272b259f38e$export$61a3455e09e10145(groupId, rerender) {
    $e8f8e272b259f38e$var$renderers.set(groupId, rerender);
}
function $e8f8e272b259f38e$export$5b90168a051cbfed(groupId, faction) {
    var keys = $e8f8e272b259f38e$var$skillKeysFor(faction);
    var current = $e8f8e272b259f38e$var$selected.get(groupId);
    return keys.includes(current) ? current : keys[0] || null;
}
function $e8f8e272b259f38e$export$f1cb70404787dca4(groupId, skillKey) {
    var _renderers_get;
    $e8f8e272b259f38e$var$selected.set(groupId, skillKey);
    (_renderers_get = $e8f8e272b259f38e$var$renderers.get(groupId)) === null || _renderers_get === void 0 ? void 0 : _renderers_get();
}
/**
 * Inactive tabs keep only the first word: "System Override" -> "System…".
 *
 * Five full skill names do not fit one row on a tablet, and the first word is
 * what distinguishes them anyway (Signal / System / Drone / Safeguard /
 * Quantum). The full name stays in the title attribute.
 */ function $e8f8e272b259f38e$var$tabLabel(name, isActive) {
    if (isActive) return name;
    var _name_split = (0, $bd823d1c24941985$export$71511d61b312f219)(name.split(' ')), first = _name_split[0], rest = _name_split.slice(1);
    return rest.length ? "".concat(first, "\u2026") : first;
}
function $e8f8e272b259f38e$export$313de1df173ff894(groupId, faction) {
    var _config_factionSkills_faction;
    var skills = ((_config_factionSkills_faction = $979b99378be707cd$export$aeeef991191508e2[faction]) === null || _config_factionSkills_faction === void 0 ? void 0 : _config_factionSkills_faction.skills) || {};
    var active = $e8f8e272b259f38e$export$5b90168a051cbfed(groupId, faction);
    var tabs = Object.entries(skills).map(function(param) {
        var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), skillKey = _param[0], skill = _param[1];
        var isActive = skillKey === active;
        return '\n            <button type="button"\n                    class="skill-tab-btn tracking-tighter border-2 '.concat(isActive ? 'active' : '', '"\n                    data-skill-tab-group="').concat(groupId, '"\n                    data-skill-tab="').concat(skillKey, '"\n                    onclick="setSkillTab(\'').concat(groupId, "', '").concat(skillKey, '\')"\n                    title="').concat(skill.name, '">\n                <span>').concat(skill.icon || "\u26A1", '</span>\n                <span class="skill-tab-name">').concat(skill.name, "</span>\n            </button>");
    }).join('');
    return '<div class="skill-tabs gap-1 mb-1">'.concat(tabs, "</div>");
}
if (typeof window !== 'undefined') window.setSkillTab = $e8f8e272b259f38e$export$f1cb70404787dca4;


/**
 * Gear - UI for the Gear tab, the phase-1 goal tracker.
 *
 * Layout (per the approved mockup): goal strip (set progress, artifacts,
 * Command value), suggested-focus card with craft-vs-farm sourcing hints,
 * the 5-skill x 3-technique gear matrix (craftable/focus items render the
 * standard inventory card; owned and distant items collapse to strips),
 * and the faction's artifacts as cards. Logic lives in gear-core.js.
 */ 






/**
 * Gear Core - pure logic for the Gear tab (phase-1 goal tracker).
 *
 * Computes the 5-skill x 3-technique tech gear matrix, per-item crafting
 * status, the suggested focus (the simulator's focused-crafting strategy,
 * simplified), artifact statuses, and material sourcing hints. No DOM.
 */ 





var $b50c9da22720ec3b$var$capitalize = function(s) {
    return s.charAt(0).toUpperCase() + s.slice(1);
};
function $b50c9da22720ec3b$export$75dc440158626230(faction) {
    var _config_factionSkills_faction;
    var skills = ((_config_factionSkills_faction = $979b99378be707cd$exports.factionSkills[faction]) === null || _config_factionSkills_faction === void 0 ? void 0 : _config_factionSkills_faction.skills) || {};
    var techniques = $979b99378be707cd$exports.skillTechniques[faction] || [];
    var gearItems = $979b99378be707cd$exports["itemsEpicDevice".concat($b50c9da22720ec3b$var$capitalize(faction))] || [];
    return Object.entries(skills).map(function(param) {
        var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), skillId = _param[0], skill = _param[1];
        return {
            skillId: skillId,
            skill: skill,
            techniques: techniques.filter(function(t) {
                return t.skill === skillId;
            }).map(function(technique) {
                return {
                    technique: technique,
                    item: gearItems.find(function(i) {
                        return i.techniqueId === technique.id;
                    }) || null
                };
            }).filter(function(entry) {
                return entry.item;
            })
        };
    });
}
function $b50c9da22720ec3b$export$93fb318ab1b10a05(itemId) {
    var character = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character;
    var inventory = (character === null || character === void 0 ? void 0 : character.inventory) || {};
    var equipped = Object.values((character === null || character === void 0 ? void 0 : character.equippedTechniqueGear) || {});
    var owned = (inventory[itemId] || 0) > 0 || equipped.some(function(g) {
        return g === itemId || (g === null || g === void 0 ? void 0 : g.id) === itemId;
    });
    var recipe = (0, $37e67442be28b253$export$3645b25e1a815566)(itemId);
    if (!recipe) return {
        itemId: itemId,
        owned: owned,
        craftable: false,
        progress: owned ? 1 : 0,
        missing: [],
        missingUnits: 0,
        recipe: null
    };
    var haveSum = 0, needSum = 0, missingUnits = 0;
    var missing = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = recipe.inputs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var input = _step.value;
            var have = inventory[input.id] || 0;
            haveSum += Math.min(have, input.qty);
            needSum += input.qty;
            if (have < input.qty) {
                missing.push({
                    id: input.id,
                    have: have,
                    need: input.qty,
                    short: input.qty - have
                });
                missingUnits += input.qty - have;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        itemId: itemId,
        owned: owned,
        craftable: !owned && missing.length === 0,
        progress: needSum > 0 ? haveSum / needSum : 0,
        missing: missing,
        missingUnits: missingUnits,
        recipe: recipe
    };
}
function $b50c9da22720ec3b$export$59244fb66f77c7e5(faction) {
    var character = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character;
    var best = null;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator = $b50c9da22720ec3b$export$75dc440158626230(faction)[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
            var column = _step.value;
            try {
                for(var _iterator1 = column.techniques[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                    var item = _step1.value.item;
                    var status = $b50c9da22720ec3b$export$93fb318ab1b10a05(item.id, character);
                    if (status.owned) continue;
                    if (!best || status.missingUnits < best.status.missingUnits || status.missingUnits === best.status.missingUnits && status.progress > best.status.progress) best = {
                        item: item,
                        status: status
                    };
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return best;
}
function $b50c9da22720ec3b$export$c1c785e1872a9a4c() {
    var character = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character;
    var best = null;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $b50c9da22720ec3b$export$f8a8a403466b6e1(character)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var entry = _step.value;
            if (entry.copiesOwned > 0 || entry.status.owned) continue;
            if (!best) {
                best = entry;
                continue;
            }
            // Blueprint-in-hand always outranks blueprint-missing.
            if (entry.hasBlueprint !== best.hasBlueprint) {
                if (entry.hasBlueprint) best = entry;
                continue;
            }
            if (entry.status.missingUnits < best.status.missingUnits || entry.status.missingUnits === best.status.missingUnits && entry.status.progress > best.status.progress) best = entry;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return best;
}
function $b50c9da22720ec3b$export$f8a8a403466b6e1() {
    var character = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character;
    var faction = character === null || character === void 0 ? void 0 : character.faction;
    var inventory = (character === null || character === void 0 ? void 0 : character.inventory) || {};
    var results = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var artifact = _step.value;
            if (artifact.faction !== 'neutral' && artifact.faction !== faction) return "continue";
            var status = $b50c9da22720ec3b$export$93fb318ab1b10a05(artifact.id, character);
            // Blueprints bank under their slug item id (the old name-keyed
            // lookup never matched dropped blueprints)
            results.push({
                artifact: artifact,
                status: status,
                hasBlueprint: (inventory["".concat(artifact.id, "-blueprint")] || 0) > 0,
                copiesOwned: ((character === null || character === void 0 ? void 0 : character.artifacts) || []).filter(function(a) {
                    return a.id === artifact.id;
                }).length
            });
        };
        for(var _iterator = Object.values((0, $ca7af38ea7b7b4a8$export$18c4115a8e7963b)())[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return results;
}
/**
 * Sourcing hint for a material: can it be crafted, and where does it drop?
 * Drop sourcing follows the engine's faction-scoped material pools
 * (common/rare materials drop in rooms of their faction); regions are
 * ranked by how many gate/hazard rooms belong to that faction. Uncommon
 * intermediates are craft-only under the current economy.
 */ var $b50c9da22720ec3b$var$sourceCache = new Map();
function $b50c9da22720ec3b$export$4ba1f2107d023679(itemId) {
    if ($b50c9da22720ec3b$var$sourceCache.has(itemId)) return $b50c9da22720ec3b$var$sourceCache.get(itemId);
    var item = (0, $ca7af38ea7b7b4a8$export$a2dea178c28a0308)('id', itemId);
    var craftable = !!(0, $37e67442be28b253$export$3645b25e1a815566)(itemId);
    var result = {
        craftable: craftable,
        regions: [],
        skills: []
    };
    if (item && item.type === 'material' && item.faction && (item.rarity === 'common' || item.rarity === 'rare')) {
        var skillSet = new Set();
        var regions = Object.entries($979b99378be707cd$exports.raidRegions).map(function(param) {
            var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), key = _param[0], region = _param[1];
            var rooms = 0;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = (0, $4c858c0d999a5b9b$export$71511d61b312f219)(region.gates || []).concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)(region.hazards || []))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var room = _step.value;
                    if ((0, $ca7af38ea7b7b4a8$export$a3603dda04ca8111)(room.primary) === item.faction) {
                        rooms++;
                        skillSet.add(room.primary);
                    } else if (item.faction == "neutral") rooms++;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return {
                key: key,
                name: region.name,
                rooms: rooms
            };
        }).filter(function(r) {
            return r.rooms > 0;
        }).sort(function(a, b) {
            return b.rooms - a.rooms;
        });
        result.regions = regions;
        result.skills = (0, $4c858c0d999a5b9b$export$71511d61b312f219)(skillSet);
    }
    $b50c9da22720ec3b$var$sourceCache.set(itemId, result);
    return result;
}
function $b50c9da22720ec3b$export$8ca1be1802f8b29a(missingInput) {
    var character = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character;
    var parts = [];
    var sources = $b50c9da22720ec3b$export$4ba1f2107d023679(missingInput.id);
    if (sources.craftable) {
        var subStatus = $b50c9da22720ec3b$export$93fb318ab1b10a05(missingInput.id, character);
        /*parts.push(subStatus.missing.length === 0
            ? `craft from materials you have (${missingInput.short} needed)`
            : `craftable — missing ${subStatus.missing.map(m => findItem('id', m.id)?.name || m.id).join(', ')}`);*/ parts.push("craftable");
    }
    if (sources.regions.length > 0) {
        var skillNames = sources.skills.map(function(s) {
            var _config_factionSkills_faction_skills_s, _config_factionSkills_faction;
            var faction = (0, $ca7af38ea7b7b4a8$export$a3603dda04ca8111)(s);
            return (_config_factionSkills_faction = $979b99378be707cd$exports.factionSkills[faction]) === null || _config_factionSkills_faction === void 0 ? void 0 : (_config_factionSkills_faction_skills_s = _config_factionSkills_faction.skills[s]) === null || _config_factionSkills_faction_skills_s === void 0 ? void 0 : _config_factionSkills_faction_skills_s.name;
        }).filter(Boolean).slice(0, 2).join(' / ');
        parts.push(skillNames == "" ? "" : "best found in ".concat(sources.regions[0].name));
    }
    return parts.join(' or ');
}
var $b50c9da22720ec3b$export$4d9cf51127854ad = {
    'knockout-prevention': 100,
    'hazard-damage-reduction': 90,
    'blueprint-find-bonus': 80,
    'loot-quantity-bonus': 70,
    'gate-material-bonus': 65,
    'raid-energy-reduction': 50,
    'currency-bonus': 40,
    'contractor-payout-bonus': 35,
    'faction-synergy-bonus': 30,
    'support-skill-bonus': 25,
    'relic-quality-bonus': 20
};
function $b50c9da22720ec3b$export$33d357ef4aaee78e(artifact) {
    var best = -1;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries((artifact === null || artifact === void 0 ? void 0 : artifact.effects) || {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step.value, 2), effectId = _step_value[0], magnitude = _step_value[1];
            var p = $b50c9da22720ec3b$export$4d9cf51127854ad[effectId];
            if (p == null) continue;
            var score = p * 1000 + (Number(magnitude) || 0);
            if (score > best) best = score;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return best;
}
/** Artifacts the character owns (crafted into inventory). */ function $b50c9da22720ec3b$var$ownedArtifacts(char) {
    return Object.entries(char.inventory || {}).filter(function(param) {
        var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), qty = _param[1];
        return qty > 0;
    }).map(function(param) {
        var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 1), id = _param[0];
        return (0, $ca7af38ea7b7b4a8$export$891bd687a67340b8)('id', id);
    }).filter(Boolean);
}
function $b50c9da22720ec3b$export$5f6199e96a03905b(char) {
    var owned = $b50c9da22720ec3b$var$ownedArtifacts(char);
    if (owned.length === 0) return;
    if (!char.equippedArtifacts) char.equippedArtifacts = {
        skillSlot: null,
        utilitySlot: null
    };
    // Skill slot: back the character's strongest skill.
    var skillCandidates = owned.filter(function(a) {
        return a.slot === 'skillSlot';
    });
    if (skillCandidates.length) char.equippedArtifacts.skillSlot = skillCandidates.reduce(function(best, a) {
        var _char_skills, _char_skills1;
        return (((_char_skills = char.skills) === null || _char_skills === void 0 ? void 0 : _char_skills[a.skill]) || 0) > (((_char_skills1 = char.skills) === null || _char_skills1 === void 0 ? void 0 : _char_skills1[best.skill]) || 0) ? a : best;
    });
    // Utility slot: highest-priority effect available.
    var utilityCandidates = owned.filter(function(a) {
        return a.slot === 'utilitySlot';
    });
    if (utilityCandidates.length) char.equippedArtifacts.utilitySlot = utilityCandidates.reduce(function(best, a) {
        return $b50c9da22720ec3b$export$33d357ef4aaee78e(a) > $b50c9da22720ec3b$export$33d357ef4aaee78e(best) ? a : best;
    });
}




// Field Kit and Technique Consumables each show one skill's three items rather
// than the full 5x3 matrix. Separate groups on purpose: the gear you are
// crafting is rarely the technique consumable you want next.
var $0de40feae1515521$var$KIT_TABS = 'gear-field-kit';
var $0de40feae1515521$var$CONSUMABLE_TABS = 'gear-consumables';
(0, $e8f8e272b259f38e$export$61a3455e09e10145)($0de40feae1515521$var$KIT_TABS, function() {
    return $0de40feae1515521$export$acf54b11566c856d();
});
(0, $e8f8e272b259f38e$export$61a3455e09e10145)($0de40feae1515521$var$CONSUMABLE_TABS, function() {
    return $0de40feae1515521$export$acf54b11566c856d();
});
// Three 13rem cards plus two 0.75rem gaps. Capping the grid's width rather than
// hard-coding `repeat(3, ...)` keeps it 3-up where there is room and lets it
// fall to 2 or 1 on a narrow pane instead of scrolling sideways.
var $0de40feae1515521$var$THREE_UP = 'grid gap-3 justify-start max-w-[40.5rem] mt-2';
var $0de40feae1515521$var$THREE_UP_TRACKS = 'grid-template-columns: repeat(auto-fit, 13rem);';
// Per-item expand/collapse overrides (persist across this page's re-renders;
// the card's own toggle is retargeted here so state survives crafting)
var $0de40feae1515521$var$gearCardOverrides = new Map(); // itemId -> expanded boolean
var $0de40feae1515521$var$renderedExpanded = new Map(); // itemId -> state actually rendered last
var $0de40feae1515521$var$focusCollapsed = false; // Suggested-focus panel hidden by the player
function $0de40feae1515521$var$ownedGearCount(faction) {
    var owned = 0, total = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator = (0, $b50c9da22720ec3b$export$75dc440158626230)(faction)[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
            var column = _step.value;
            try {
                for(var _iterator1 = column.techniques[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                    var item = _step1.value.item;
                    total++;
                    if ((0, $b50c9da22720ec3b$export$93fb318ab1b10a05)(item.id).owned) owned++;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return {
        owned: owned,
        total: total
    };
}
// ---------------------------------------------------------------------------
// Building blocks
// ---------------------------------------------------------------------------
function $0de40feae1515521$var$goalBlock(label, valueHtml, note) {
    var extra = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : '';
    return '\n        <div class="flex-1 min-w-[210px] rounded-lg px-4 py-2 bg-game-accent/20 border border-blue-500">\n            <div class="flex items-start">\n                <div class="text-sm uppercase tracking-widest text-gray-100 flex-grow">'.concat(label, '</div>\n                <div class="text-base font-bold text-game-accent whitespace-nowrap tracking-tighter">').concat(valueHtml, "</div>\n            </div>\n            ").concat(extra, '\n            <div class="text-xs text-gray-300 mt-3">').concat(note, "</div>\n        </div>");
}
function $0de40feae1515521$var$renderGoalStrip(container, faction) {
    var _gameState_character_lifetime, _gameState_character, _config_factionSkills_faction;
    var _ownedGearCount = $0de40feae1515521$var$ownedGearCount(faction), owned = _ownedGearCount.owned, total = _ownedGearCount.total;
    var pctGear = total > 0 ? Math.round(owned / total * 100) : 0;
    var artifactsCrafted = ((_gameState_character = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character) === null || _gameState_character === void 0 ? void 0 : (_gameState_character_lifetime = _gameState_character.lifetime) === null || _gameState_character_lifetime === void 0 ? void 0 : _gameState_character_lifetime.artifactsCrafted) || 0;
    var pctArtifacts = total > 0 ? Math.round(artifactsCrafted / 17 * 100) : 0;
    var barTechGear = '\n        <div class="h-2.5 rounded-full bg-gray-800 overflow-hidden mt-2">\n            <div class="h-full bg-gradient-to-r from-blue-700 to-game-accent" style="width:'.concat(pctGear, '%"></div>\n        </div>');
    var barArtifacts = '\n        <div class="h-2.5 rounded-full bg-gray-800 overflow-hidden mt-2">\n            <div class="h-full bg-gradient-to-r from-blue-700 to-game-accent" style="width:'.concat(pctArtifacts, '%"></div>\n        </div>');
    var commandBlock = '';
    if ((0, $ee71dfe8b201c427$export$25d1e5af45c35a33)() && (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character) {
        var marks = (0, $ee71dfe8b201c427$export$ffae5de2f7ddd94d)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character).total;
        commandBlock = '\n            <div class="flex flex-col place-content-between flex-1 min-w-[210px] rounded-lg px-4 py-2" style="background:rgba(177,140,255,0.08); border:1px solid hsl(261, 35%, 58%);">\n                <div class="flex items-start">\n                    <div class="text-sm uppercase tracking-widest text-gray-300 flex-grow">Promotion Marks</div>\n                    <div class="text-base font-bold whitespace-nowrap tracking-tighter" style="color:#b18cff">'.concat(marks, '\uD83C\uDF96\uFE0F</div>\n                </div>\n                <div class="text-xs text-gray-300">Command awards marks based on crafted Skill Gear and Artifacts</div>\n            </div>');
    }
    container.innerHTML = $0de40feae1515521$var$goalBlock('Faction Tech Gear', "".concat(owned, " / ").concat(total), "The core tools of the ".concat(((_config_factionSkills_faction = $979b99378be707cd$exports.factionSkills[faction]) === null || _config_factionSkills_faction === void 0 ? void 0 : _config_factionSkills_faction.name) || faction, " field kit"), barTechGear) + $0de40feae1515521$var$goalBlock('Artifacts Crafted', "".concat(artifactsCrafted, " / 17"), 'Artifact blueprints drop during T3 raids', barArtifacts) + commandBlock;
}
// Top-right ✕ that hides the focus panel; the matching re-open button lives
// next to the "Skill Gear increases…" text (#gear-focus-show).
var $0de40feae1515521$var$focusCloseBtn = '<button onclick="toggleGearFocus()" title="Hide suggested focus"\n    class="absolute top-2 right-2 w-6 h-6 flex items-center justify-center rounded bg-black/30 border border-gray-600 text-gray-400 hover:text-white hover:border-gray-400 text-sm leading-none">\u2715</button>';
function $0de40feae1515521$var$renderFocusCard(container, faction) {
    var showBtn = document.getElementById('gear-focus-show');
    if ($0de40feae1515521$var$focusCollapsed) {
        container.innerHTML = '';
        container.classList.remove('mb-4');
        if (showBtn) showBtn.innerHTML = '<button onclick="toggleGearFocus()"\n            class="text-xs font-bold text-game-warning border border-game-warning/50 rounded px-2 py-1 bg-game-warning/20 hover:bg-game-warning/50 hover:text-white whitespace-nowrap">\uD83C\uDFAF Show focus tip</button>';
        return;
    }
    if (showBtn) showBtn.innerHTML = '';
    var focus = (0, $b50c9da22720ec3b$export$59244fb66f77c7e5)(faction);
    if (!focus) {
        container.classList.add('mb-4');
        container.innerHTML = '\n            <div class="relative border-2 border-green-700 rounded-lg p-4 bg-green-900/10 text-sm">\n                '.concat($0de40feae1515521$var$focusCloseBtn, "\n                \u2705 <b>Field kit complete!</b> Every tech gear piece is yours \u2014 Tier-3 raids and Artifacts and are the next frontier.\n            </div>");
        return;
    }
    var item = focus.item, status = focus.status;
    var inputRows = status.recipe.inputs.map(function(input) {
        var have = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.inventory[input.id] || 0;
        var ok = have >= input.qty;
        var inputItem = (0, $ca7af38ea7b7b4a8$export$a2dea178c28a0308)('id', input.id);
        var sourceLine = '';
        if (!ok) {
            var desc = (0, $b50c9da22720ec3b$export$8ca1be1802f8b29a)({
                id: input.id,
                short: input.qty - have
            });
            if (desc) sourceLine = '<span class="text-[11.5px] text-blue-300/80">\u2192 '.concat(desc, "</span>");
        }
        return '\n            <div class="flex gap-2 items-baseline text-[13px] py-0.5">\n                <span class="'.concat(ok ? 'text-game-success' : 'text-game-danger', ' font-bold text-nowrap">').concat(ok ? "\u2714" : "\u2718", " ").concat(have, "/").concat(input.qty, '</span>\n                <span class="text-nowrap">').concat((inputItem === null || inputItem === void 0 ? void 0 : inputItem.icon) || '', " ").concat((inputItem === null || inputItem === void 0 ? void 0 : inputItem.name) || input.id, "</span>\n                ").concat(sourceLine, "\n            </div>");
    }).join('');
    container.classList.add('mb-4');
    container.innerHTML = '\n        <div class="relative border-2 border-game-warning rounded-lg p-4" style="background:rgba(245,158,11,0.1);">\n            '.concat($0de40feae1515521$var$focusCloseBtn, '\n            <h3 class="m-0 mb-1 pr-7 text-game-warning text-[15px] font-bold">\uD83C\uDFAF Suggested focus: ').concat(item.icon || '', " ").concat(item.name, '</h3>\n            <div class="text-xs text-gray-400 mb-2">Closest tech gear to completion \u2014 ').concat(status.recipe.inputs.length - status.missing.length, " of ").concat(status.recipe.inputs.length, " materials ready</div>\n            ").concat(inputRows, "\n        </div>");
}
// Inventory card cell (createInventoryCard verbatim, expanded or collapsed).
// Two onclick retargets: post-craft refresh goes to this page instead of the
// crafting modal, and the card's collapse toggle goes through toggleGearExpand
// so the state survives this page's re-renders.
function $0de40feae1515521$var$cardCell(item, status) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref_isFocus = _ref.isFocus, isFocus = _ref_isFocus === void 0 ? false : _ref_isFocus, _ref_collapsed = _ref.collapsed, collapsed = _ref_collapsed === void 0 ? false : _ref_collapsed, _ref_isArtifact = _ref.isArtifact, isArtifact = _ref_isArtifact === void 0 ? false : _ref_isArtifact, _ref_stackable = _ref.stackable, stackable = _ref_stackable === void 0 ? false : _ref_stackable;
    $0de40feae1515521$var$renderedExpanded.set(item.id, !collapsed);
    var recipeMeta = (0, $715bf31211e65705$export$71511d61b312f219)((0, $fa9769297b8a68c8$export$71511d61b312f219)({}, status.recipe), {
        itemType: isArtifact ? 'artifact' : item.type,
        itemRarity: item.rarity,
        techniqueId: item.techniqueId
    });
    var materials = (0, $ca7af38ea7b7b4a8$export$4251a114f7437961)(status.recipe.inputs.map(function(i) {
        return i.id;
    }));
    // Stackables (consumables) never "complete": keep showing recipe progress
    var options = {
        collapsed: collapsed,
        progress: !stackable && status.owned ? 1 : null,
        isFocus: isFocus
    };
    var cardHtml = (0, $a575049a7e5cb3a1$export$4ac7f915da1fa1c4)(item, 'crafting', recipeMeta, materials, options);
    cardHtml = cardHtml.replaceAll('showCraftingModal();', 'renderGearTab();').replaceAll('toggleInventoryCardCollapse(this);', "toggleGearExpand('".concat(item.id, "');"));
    // The card's own action button now covers the missing-materials case
    // (active CRAFT COMPONENTS inside the card), so no extra button here
    return '\n        <div class="relative">\n            '.concat(cardHtml, "\n        </div>");
}
/** The selected skill's row of the gear matrix, or null if the faction has none. */ function $0de40feae1515521$var$activeColumn(groupId, faction) {
    var skillId = (0, $e8f8e272b259f38e$export$5b90168a051cbfed)(groupId, faction);
    return (0, $b50c9da22720ec3b$export$75dc440158626230)(faction).find(function(column) {
        return column.skillId === skillId;
    }) || null;
}
function $0de40feae1515521$var$renderMatrix(container, faction) {
    var focus = (0, $b50c9da22720ec3b$export$59244fb66f77c7e5)(faction);
    var column = $0de40feae1515521$var$activeColumn($0de40feae1515521$var$KIT_TABS, faction);
    var cells = ((column === null || column === void 0 ? void 0 : column.techniques) || []).map(function(param) {
        var item = param.item;
        var status = (0, $b50c9da22720ec3b$export$93fb318ab1b10a05)(item.id);
        var isFocus = focus && focus.item.id === item.id;
        // Craftable and focus items open by default; owned and distant
        // items start collapsed. A player toggle overrides either way.
        var defaultExpanded = !status.owned && (status.craftable || isFocus);
        var expanded = $0de40feae1515521$var$gearCardOverrides.has(item.id) ? $0de40feae1515521$var$gearCardOverrides.get(item.id) : defaultExpanded;
        return $0de40feae1515521$var$cardCell(item, status, {
            isFocus: isFocus,
            collapsed: !expanded
        });
    }).join('');
    container.innerHTML = "\n        ".concat((0, $e8f8e272b259f38e$export$313de1df173ff894)($0de40feae1515521$var$KIT_TABS, faction), '\n        <div class="').concat($0de40feae1515521$var$THREE_UP, '" style="').concat($0de40feae1515521$var$THREE_UP_TRACKS, '">\n            ').concat(cells, "\n        </div>");
}
function $0de40feae1515521$var$renderArtifacts(container) {
    var statuses = (0, $b50c9da22720ec3b$export$f8a8a403466b6e1)();
    if (!statuses.length) {
        container.innerHTML = '<div class="text-gray-400 text-sm">No artifact recipes for this faction yet.</div>';
        return;
    }
    var cards = statuses.map(function(param) {
        var artifact = param.artifact, status = param.status, hasBlueprint = param.hasBlueprint, copiesOwned = param.copiesOwned;
        // Artifacts without a recipe (not craftable yet) get a minimal tile
        // instead of an orphaned footer
        if (!status.recipe) return '\n                <div class="rounded-lg border border-gray-700 bg-white/5 p-3 text-[12px] text-gray-400 flex flex-col gap-1">\n                    <span class="font-bold text-gray-300">'.concat(artifact.icon || '', " ").concat(artifact.name, "</span>\n                    <span>No recipe \u2014 drop only</span>\n                    ").concat(copiesOwned > 0 ? '<span class="text-game-gold">owned \xd7'.concat(copiesOwned, "</span>") : '', "\n                </div>");
        // UNLOCK is the real gate now: only unlocked designs are expandable
        // (their craft controls are actionable) and open by default. Locked
        // designs stay collapsed - the card component forces that and surfaces
        // the unlock control in the collapsed view.
        var unlocked = (0, $ee71dfe8b201c427$export$2ab3ae91631fe8e5)(artifact.id);
        var defaultExpanded = unlocked;
        var expanded = $0de40feae1515521$var$gearCardOverrides.has(artifact.id) ? $0de40feae1515521$var$gearCardOverrides.get(artifact.id) : defaultExpanded;
        $0de40feae1515521$var$renderedExpanded.set(artifact.id, expanded);
        var recipeMeta = (0, $715bf31211e65705$export$71511d61b312f219)((0, $fa9769297b8a68c8$export$71511d61b312f219)({}, status.recipe), {
            itemType: 'artifact',
            itemRarity: artifact.rarity
        });
        var materials = (0, $ca7af38ea7b7b4a8$export$4251a114f7437961)(status.recipe.inputs.map(function(i) {
            return i.id;
        }));
        // A blueprint identifies the design (shows its name + the unlock button);
        // fully-undiscovered designs (no blueprint, not unlocked) stay <unknown>.
        var cardOptions = unlocked ? {
            collapsed: !expanded
        } : hasBlueprint ? {
            collapsed: true
        } : {
            collapsed: true,
            displayName: "&lt;unknown&gt; \u2014 No Blueprint",
            hideToggle: true
        };
        var cardHtml = (0, $a575049a7e5cb3a1$export$4ac7f915da1fa1c4)(artifact, 'crafting', recipeMeta, materials, cardOptions).replaceAll('showCraftingModal();', 'renderGearTab();').replaceAll('toggleInventoryCardCollapse(this);', "toggleGearExpand('".concat(artifact.id, "');"));
        return '\n            <div class="relative">\n                '.concat(cardHtml, "\n            </div>");
    }).join('');
    container.innerHTML = '\n        <div class="grid gap-3 justify-between" style="grid-template-columns: repeat(auto-fit, 13rem);">\n            '.concat(cards, "\n        </div>");
}
// HP field supplies (purchase-only credit sinks; energy is bought one-step from
// the header's ⚡ popup). Their own tab beside the Field Kit: they are bought,
// not crafted, and share nothing with the skill-tabbed panes.
var $0de40feae1515521$var$FIELD_SUPPLY_IDS = [
    'field-health-stim',
    'recovery-injector-mk2',
    'advanced-recovery-serum'
];
function $0de40feae1515521$var$renderSupplies(container) {
    var _gameState_character;
    var inventory = ((_gameState_character = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character) === null || _gameState_character === void 0 ? void 0 : _gameState_character.inventory) || {};
    var supplyCards = $0de40feae1515521$var$FIELD_SUPPLY_IDS.map(function(id) {
        var item = (0, $ca7af38ea7b7b4a8$export$a2dea178c28a0308)('id', id);
        if (!item) return '';
        var qty = inventory[id] || 0;
        // Re-render this page after buying so owned counts stay fresh
        var cardHtml = (0, $a575049a7e5cb3a1$export$4ac7f915da1fa1c4)((0, $715bf31211e65705$export$71511d61b312f219)((0, $fa9769297b8a68c8$export$71511d61b312f219)({}, item), {
            quantity: qty
        }), 'purchase', null, null, {
            collapsed: true
        }).replaceAll("purchaseConsumable('".concat(id, "')"), "purchaseConsumable('".concat(id, "'); renderGearTab();"));
        return '<div class="relative">'.concat(cardHtml, "</div>");
    }).join('');
    container.innerHTML = '\n        <div class="'.concat($0de40feae1515521$var$THREE_UP, '" style="').concat($0de40feae1515521$var$THREE_UP_TRACKS, '">\n            ').concat(supplyCards, "\n        </div>");
}
// Technique consumables: one per technique, on the same skill tabs as the Field
// Kit. Crafted from materials; auto-deploy on technique success in raids.
function $0de40feae1515521$var$renderConsumables(container, faction) {
    var _gameState_character;
    var inventory = ((_gameState_character = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character) === null || _gameState_character === void 0 ? void 0 : _gameState_character.inventory) || {};
    var capitalize = function(s) {
        return s.charAt(0).toUpperCase() + s.slice(1);
    };
    var consumables = $979b99378be707cd$exports["itemsEpicConsumable".concat(capitalize(faction))] || [];
    var column = $0de40feae1515521$var$activeColumn($0de40feae1515521$var$CONSUMABLE_TABS, faction);
    var cells = ((column === null || column === void 0 ? void 0 : column.techniques) || []).map(function(param) {
        var technique = param.technique;
        var item = consumables.find(function(c) {
            return c.techniqueId === technique.id;
        });
        if (!item) return '';
        var status = (0, $b50c9da22720ec3b$export$93fb318ab1b10a05)(item.id);
        if (!status.recipe) return '';
        var qty = inventory[item.id] || 0;
        // Ready-to-craft items open by default; the rest stay collapsed
        var defaultExpanded = status.missing.length === 0 && qty === 0;
        var expanded = $0de40feae1515521$var$gearCardOverrides.has(item.id) ? $0de40feae1515521$var$gearCardOverrides.get(item.id) : defaultExpanded;
        return $0de40feae1515521$var$cardCell(item, status, {
            collapsed: !expanded,
            stackable: true
        });
    }).join('');
    container.innerHTML = "\n        ".concat((0, $e8f8e272b259f38e$export$313de1df173ff894)($0de40feae1515521$var$CONSUMABLE_TABS, faction), '\n        <div class="').concat($0de40feae1515521$var$THREE_UP, '" style="').concat($0de40feae1515521$var$THREE_UP_TRACKS, '">\n            ').concat(cells, "\n        </div>");
}
// ---------------------------------------------------------------------------
// Entry points
// ---------------------------------------------------------------------------
// Gear sub-tab state (Field Kit / Field Supplies / Artifacts / Consumables) -
// survives re-renders; buttons and panes are static markup in index.html
var $0de40feae1515521$var$activeGearSubTab = 'field-kit';
var $0de40feae1515521$var$GEAR_SUBTAB_PANES = {
    'field-kit': 'gear-pane-field-kit',
    'supplies': 'gear-pane-supplies',
    'artifacts': 'gear-pane-artifacts',
    'consumables': 'gear-pane-consumables'
};
function $0de40feae1515521$var$applyGearSubTab() {
    document.querySelectorAll('[data-gear-tab]').forEach(function(btn) {
        return btn.classList.toggle('active', btn.dataset.gearTab === $0de40feae1515521$var$activeGearSubTab);
    });
    Object.entries($0de40feae1515521$var$GEAR_SUBTAB_PANES).forEach(function(param) {
        var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), name = _param[0], paneId = _param[1];
        var _document_getElementById;
        return (_document_getElementById = document.getElementById(paneId)) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.classList.toggle('hidden', name !== $0de40feae1515521$var$activeGearSubTab);
    });
}
function $0de40feae1515521$export$c9de90a59921a224(name) {
    if (!$0de40feae1515521$var$GEAR_SUBTAB_PANES[name]) return;
    $0de40feae1515521$var$activeGearSubTab = name;
    $0de40feae1515521$var$applyGearSubTab();
}
function $0de40feae1515521$export$acf54b11566c856d() {
    var _gameState_character, // Attach Tippy tooltips to the freshly-rendered card artwork
    _window_reinitializeInventoryTooltips, _window;
    var faction = (_gameState_character = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character) === null || _gameState_character === void 0 ? void 0 : _gameState_character.faction;
    var strip = document.getElementById('gear-goal-strip');
    var focusEl = document.getElementById('gear-focus');
    var matrixEl = document.getElementById('gear-matrix');
    var artifactsEl = document.getElementById('gear-artifacts');
    var suppliesEl = document.getElementById('gear-supplies');
    var consumablesEl = document.getElementById('gear-consumables');
    if (!strip || !faction) return;
    $0de40feae1515521$var$renderGoalStrip(strip, faction);
    $0de40feae1515521$var$renderFocusCard(focusEl, faction);
    $0de40feae1515521$var$renderMatrix(matrixEl, faction);
    $0de40feae1515521$var$renderArtifacts(artifactsEl);
    if (suppliesEl) $0de40feae1515521$var$renderSupplies(suppliesEl);
    if (consumablesEl) $0de40feae1515521$var$renderConsumables(consumablesEl, faction);
    $0de40feae1515521$var$applyGearSubTab();
    (_window_reinitializeInventoryTooltips = (_window = window).reinitializeInventoryTooltips) === null || _window_reinitializeInventoryTooltips === void 0 ? void 0 : _window_reinitializeInventoryTooltips.call(_window);
}
function $0de40feae1515521$export$10f59a34a449d50b(itemId) {
    var _renderedExpanded_get;
    var current = (_renderedExpanded_get = $0de40feae1515521$var$renderedExpanded.get(itemId)) !== null && _renderedExpanded_get !== void 0 ? _renderedExpanded_get : false;
    $0de40feae1515521$var$gearCardOverrides.set(itemId, !current);
    $0de40feae1515521$export$acf54b11566c856d();
}
function $0de40feae1515521$export$f0d1aa93d6391a63() {
    $0de40feae1515521$var$focusCollapsed = !$0de40feae1515521$var$focusCollapsed;
    $0de40feae1515521$export$acf54b11566c856d();
}
if (typeof window !== 'undefined') {
    window.renderGearTab = $0de40feae1515521$export$acf54b11566c856d;
    window.toggleGearExpand = $0de40feae1515521$export$10f59a34a449d50b;
    window.toggleGearFocus = $0de40feae1515521$export$f0d1aa93d6391a63;
    window.setGearSubTab = $0de40feae1515521$export$c9de90a59921a224;
}





// DOM glue between the pure avatar generator (avatarGen.js) and the game UI.
//
// Static portraits render as memoized data-URL backgrounds on
// `.contractor-avatar-placeholder[data-avatar-seed]` elements. A single
// MutationObserver (observeAvatars, installed once at boot) hydrates any such
// element as it enters the DOM — this covers the reactive re-renders driven by
// Alpine (contractorManager.js) and raid.js that explicit calls would miss.
// Callers may also invoke hydrateAvatars(root) directly for a synchronous first
// paint, avoiding a flash of the CSS `new.png` fallback.
//
// An element may carry an explicit feature object in `data-avatar-features`
// (JSON) — a player's custom-created avatar. It takes precedence over the seed;
// the element still carries `data-avatar-seed` as a fallback, so the selector
// and observer are unchanged. The focused main-card portrait animates instead —
// see mountAvatarAnimation.

var $a6e2b3e30d0f771b$var$RENDER_SIZE = 128; // exact 2x of the 64px logical base; CSS scales boxes down
var $a6e2b3e30d0f771b$var$CACHE_CAP = 500; // soft LRU cap — contractors regenerate, so bound the memo
// spec.key -> data URL. Data URLs are expensive to build but free to reuse, so
// this memo is what makes repeated hydration / Alpine re-renders cheap.
var $a6e2b3e30d0f771b$var$cache = new Map();
// What to draw for an element: an explicit feature object (custom avatar) wins,
// else the seed. `key` is the memo/identity key; `phaseSeed` drives the idle
// animation's per-avatar phase offset.
function $a6e2b3e30d0f771b$var$resolveSpec(el) {
    var faction = el.dataset.avatarFaction || "dominion";
    // Opt-in transparent background so the portrait composites onto the card's own
    // gradient (used where a fixed-size placeholder doesn't fill a wider card).
    var cfg = el.dataset.avatarNobg ? {
        transparentBackground: true
    } : undefined;
    var suffix = cfg ? "|nobg" : "";
    var featJson = el.dataset.avatarFeatures;
    if (featJson) try {
        return {
            faction: faction,
            cfg: cfg,
            features: JSON.parse(featJson),
            key: "f:" + featJson + suffix,
            phaseSeed: featJson
        };
    } catch (e) {}
    var seed = el.dataset.avatarSeed || "seed";
    return {
        faction: faction,
        cfg: cfg,
        seed: seed,
        key: "s:" + seed + "|" + faction + suffix,
        phaseSeed: seed
    };
}
function $a6e2b3e30d0f771b$var$urlFor(spec) {
    var url = $a6e2b3e30d0f771b$var$cache.get(spec.key);
    if (url === undefined) {
        url = spec.features ? (0, $9b7c6ba2608f0479$export$adacf7b1df9d4c0e)(spec.features, spec.faction, $a6e2b3e30d0f771b$var$RENDER_SIZE, spec.cfg) : (0, $9b7c6ba2608f0479$export$df23e55b8e3e0ed8)(spec.seed, spec.faction, $a6e2b3e30d0f771b$var$RENDER_SIZE, spec.cfg);
        $a6e2b3e30d0f771b$var$cache.set(spec.key, url);
        if ($a6e2b3e30d0f771b$var$cache.size > $a6e2b3e30d0f771b$var$CACHE_CAP) $a6e2b3e30d0f771b$var$cache.delete($a6e2b3e30d0f771b$var$cache.keys().next().value); // evict oldest
    }
    return url;
}
function $a6e2b3e30d0f771b$export$518ad6ed798753d1(seed) {
    var faction = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "dominion";
    return $a6e2b3e30d0f771b$var$urlFor({
        faction: faction,
        seed: seed,
        key: "s:" + seed + "|" + faction
    });
}
function $a6e2b3e30d0f771b$var$setBackground(el, spec) {
    el.style.backgroundImage = "url(".concat($a6e2b3e30d0f771b$var$urlFor(spec), ")");
    el.style.backgroundSize = "cover";
    el.style.backgroundPosition = "center";
    el.style.imageRendering = "pixelated";
}
// Paint one placeholder's procedural portrait as its background. Idempotent via
// the data-avatar-hydrated flag; a seedless element (e.g. an empty roster slot)
// is left alone so it keeps the CSS default. The single element marked
// `data-avatar-main` (the focused main character card) gets an animated canvas
// on top of a static poster instead of a plain background.
function $a6e2b3e30d0f771b$var$hydrateOne(el) {
    if (el.dataset.avatarHydrated) return;
    if (!el.dataset.avatarSeed && !el.dataset.avatarFeatures) return;
    var spec = $a6e2b3e30d0f771b$var$resolveSpec(el);
    if (el.dataset.avatarMain) $a6e2b3e30d0f771b$var$mountMain(el, spec);
    else $a6e2b3e30d0f771b$var$setBackground(el, spec);
    el.dataset.avatarHydrated = "1";
}
// The one focused portrait animates. Only one is ever live: each displayCharacter
// re-render inserts a fresh main element, so we stop the previous loop and mount
// a new one. A static poster sits behind the canvas as an instant/fallback frame.
var $a6e2b3e30d0f771b$var$mainStop = null;
function $a6e2b3e30d0f771b$var$mountMain(host, spec) {
    if ($a6e2b3e30d0f771b$var$mainStop) {
        $a6e2b3e30d0f771b$var$mainStop();
        $a6e2b3e30d0f771b$var$mainStop = null;
    }
    $a6e2b3e30d0f771b$var$setBackground(host, spec); // poster behind the animated canvas
    var canvas = document.createElement("canvas");
    canvas.style.cssText = "position:absolute;inset:0;width:100%;height:100%;image-rendering:pixelated;";
    host.appendChild(canvas);
    var features = spec.features || (0, $9b7c6ba2608f0479$export$4fafee04cbe5d540)(spec.seed, spec.faction);
    $a6e2b3e30d0f771b$var$mainStop = $a6e2b3e30d0f771b$export$e3449c06744f2603(canvas, features, spec.faction, spec.phaseSeed);
}
function $a6e2b3e30d0f771b$export$b3f1d493f405542a() {
    if ($a6e2b3e30d0f771b$var$mainStop) {
        $a6e2b3e30d0f771b$var$mainStop();
        $a6e2b3e30d0f771b$var$mainStop = null;
    }
}
var $a6e2b3e30d0f771b$var$SELECTOR = ".contractor-avatar-placeholder[data-avatar-seed]:not([data-avatar-hydrated])";
function $a6e2b3e30d0f771b$export$a5172f1b26b4ebf8() {
    var root = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
    if (!root) return;
    if (root.matches && root.matches($a6e2b3e30d0f771b$var$SELECTOR)) $a6e2b3e30d0f771b$var$hydrateOne(root); // the root itself
    if (root.querySelectorAll) root.querySelectorAll($a6e2b3e30d0f771b$var$SELECTOR).forEach($a6e2b3e30d0f771b$var$hydrateOne);
}
var $a6e2b3e30d0f771b$var$observer = null;
function $a6e2b3e30d0f771b$export$f32bf1f4ac79976() {
    if ($a6e2b3e30d0f771b$var$observer || typeof MutationObserver === "undefined") return;
    $a6e2b3e30d0f771b$export$a5172f1b26b4ebf8(document); // catch anything already present
    $a6e2b3e30d0f771b$var$observer = new MutationObserver(function(mutations) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = mutations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var m = _step.value;
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = m.addedNodes[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var node = _step1.value;
                        if (node.nodeType === 1) $a6e2b3e30d0f771b$export$a5172f1b26b4ebf8(node);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    $a6e2b3e30d0f771b$var$observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}
// ---- focused-avatar animation ---------------------------------------------
// The one large main-card portrait animates (idle blink/breathe/mouth/hair) via
// a single rAF loop into a 64px canvas scaled up by CSS. Everything else stays a
// static data-URL background. Returns a stop() to tear the loop down.
// Small stable phase offset from a string so two avatars don't animate in lockstep.
function $a6e2b3e30d0f771b$var$phaseFromSeed(seed) {
    var s = String(seed);
    var h = 0;
    for(var i = 0; i < s.length; i++)h = Math.imul(h, 31) + s.charCodeAt(i) | 0;
    return (h >>> 0) % 1000 / 100; // 0..10
}
function $a6e2b3e30d0f771b$export$e3449c06744f2603(canvas, features) {
    var faction = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "dominion", phaseSeed = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
    var ctx = canvas.getContext("2d");
    canvas.width = canvas.height = (0, $9b7c6ba2608f0479$export$aaa4582620b40efc);
    canvas.style.imageRendering = "pixelated";
    var phase = $a6e2b3e30d0f771b$var$phaseFromSeed(phaseSeed);
    var raf = 0;
    var stopped = false;
    var frame = function(t) {
        if (stopped || !canvas.isConnected) return stop();
        ctx.clearRect(0, 0, (0, $9b7c6ba2608f0479$export$aaa4582620b40efc), (0, $9b7c6ba2608f0479$export$aaa4582620b40efc));
        (0, $9b7c6ba2608f0479$export$a046ef6d7517111c)(ctx, features, faction, {}, (0, $9b7c6ba2608f0479$export$e5cd63d32a946e1d)(t, phase, features.mouthCurve));
        raf = requestAnimationFrame(frame);
    };
    var onVisibility = function() {
        if (document.hidden) {
            cancelAnimationFrame(raf);
            raf = 0;
        } else if (!stopped && !raf) raf = requestAnimationFrame(frame);
    };
    document.addEventListener("visibilitychange", onVisibility);
    function stop() {
        stopped = true;
        cancelAnimationFrame(raf);
        document.removeEventListener("visibilitychange", onVisibility);
    }
    raf = requestAnimationFrame(frame);
    return stop;
}







// ---------------------------------------------------------------------------
// Character sub-tabs (Skills / Inventory / Gear)
//
// The character page's right column swaps between three panes. The selection
// is module-scoped so it persists across re-renders AND character switches
// within a session (resets to Skills on reload).
// ---------------------------------------------------------------------------
// Registered with the shared helper rather than hand-rolled here. This file
// used to own the ONLY implementation of sub-tabs; Command, Syndicate and
// gear.js all needed the same thing, and the subtle part (the bounded sizing
// retry) is exactly what gets lost when a pattern is re-typed. See subTabs.js.
(0, $bf6cb3ebdd8098d6$export$589dc1e4c906c789)("character", {
    panes: {
        skills: "char-skills-pane",
        inventory: "inventory-tab",
        gear: "gear-tab"
    },
    scrollers: {
        skills: "skills-grid",
        inventory: "inventory-grid",
        gear: "gear-tab"
    },
    defaultTab: "skills",
    // Panes are hidden, not unmounted, so anything state-dependent has to be
    // refreshed on reveal (gear.js self-exposes renderGearTab; inventory is
    // Alpine-reactive but re-syncs USE/EQUIP/SELL against current HP/energy).
    onShow: function(name) {
        if (name === "gear") (0, $0de40feae1515521$export$acf54b11566c856d)();
        else if (name === "inventory") (0, $80ed874fd909c4ae$export$5b73e6a29e58b929)();
    }
});
// The Skills pane shows one skill at a time. Five cards in a 2-3 column grid
// was three screens of scrolling on a tablet; the strip is one row.
var $7ea2865b97769aa3$var$SKILL_TAB_GROUP = "char-skills";
(0, $e8f8e272b259f38e$export$61a3455e09e10145)($7ea2865b97769aa3$var$SKILL_TAB_GROUP, function() {
    return $7ea2865b97769aa3$export$2eced2100c12c50d();
});
function $7ea2865b97769aa3$export$c5004add704e7ef5() {
    (0, $bf6cb3ebdd8098d6$export$7ad721b2ffe28f0c)("character");
}
function $7ea2865b97769aa3$export$373d64f4d7d87f67(name) {
    (0, $bf6cb3ebdd8098d6$export$8a8da8bddae1b567)("character", name);
}
if (typeof window !== "undefined") {
    window.setCharSubTab = $7ea2865b97769aa3$export$373d64f4d7d87f67;
    window.applyCharSubTab = $7ea2865b97769aa3$export$c5004add704e7ef5;
    window.toggleCharacterCard = $7ea2865b97769aa3$export$63b7a79b9f19f21b;
// The resize listener lives in subTabs.js now, and re-measures every
// registered group rather than just this page's.
}
//
// Technique tab switching
//
window.switchTechniqueTab = function(tabGroupId, tabIndex) {
    // Update tab buttons
    var tabs = document.querySelectorAll('[data-tab-group="'.concat(tabGroupId, '"][data-tab-index]'));
    tabs.forEach(function(tab, idx) {
        if (idx === tabIndex) {
            tab.classList.remove("bg-gray-500/60", "hover:bg-gray-600/60");
            tab.classList.add("bg-black/65");
        } else {
            tab.classList.remove("bg-black/65");
            tab.classList.add("bg-gray-500/60", "hover:bg-gray-600/60");
        }
    });
    // Update panels
    var panels = document.querySelectorAll('.technique-panel[data-tab-group="'.concat(tabGroupId, '"]'));
    panels.forEach(function(panel, idx) {
        if (idx === tabIndex) panel.classList.remove("hidden");
        else panel.classList.add("hidden");
    });
    // Remember the selected tab for this skill
    if (!(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.techniqueTabSelections) (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.techniqueTabSelections = {};
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.techniqueTabSelections[tabGroupId] = tabIndex;
    (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
};
function $7ea2865b97769aa3$export$106e54bf5a9adc20(artifact) {
    if (!(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character) return false;
    // Check if artifact requires a specific skill and if character has it
    (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "canEquip", artifact);
    if (artifact.slot === "skillSlot" && artifact.skill) {
        var characterSkillLevel = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.skills[artifact.skill] || 0;
        return characterSkillLevel > 0;
    }
    return true; // Utility artifacts can always be equipped
}
function $7ea2865b97769aa3$export$56e7fec58be964ef(artifact) {
    if (!artifact.skill || artifact.slot !== "skillSlot") return "";
    // Get the human-readable skill name
    var skillName = (0, $ca7af38ea7b7b4a8$export$182937d2e68a339)(artifact.skill);
    return "Requires ".concat(skillName, " skill");
}
function $7ea2865b97769aa3$export$1f3b8068ff1292ef(artifactId) {
    var _window_renderGearTab, _window;
    (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, artifactId, (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.artifacts);
    var artifact = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.artifacts.find(function(a) {
        return a.id === artifactId;
    });
    if (!artifact) {
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)("Artifact not found!", "error");
        return false;
    }
    // Check if artifact can be equipped
    if (!$7ea2865b97769aa3$export$106e54bf5a9adc20(artifact)) {
        var message = $7ea2865b97769aa3$export$56e7fec58be964ef(artifact);
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)("Cannot equip ".concat(artifact.name, " - ").concat(message.toLowerCase(), "!"), "error");
        return false;
    }
    var slotName = artifact.slot;
    var currentEquipped = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.equippedArtifacts[slotName];
    // Unequip current artifact if any
    if (currentEquipped) $7ea2865b97769aa3$export$fd37f844ae84e59c(slotName);
    // Equip new artifact
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.equippedArtifacts[slotName] = artifact;
    (0, $b5bda7fdec806d8b$export$c7def531c087da85)("Equipped ".concat(artifact.name, "!"), "success");
    // Refresh inventory display to update equipped status
    (0, $80ed874fd909c4ae$export$5b73e6a29e58b929)();
    (_window_renderGearTab = (_window = window).renderGearTab) === null || _window_renderGearTab === void 0 ? void 0 : _window_renderGearTab.call(_window); // gear-tab cards show equip state
    (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
    $7ea2865b97769aa3$export$2eced2100c12c50d();
    return true;
}
function $7ea2865b97769aa3$export$fd37f844ae84e59c(slotName) {
    var _window_renderGearTab, _window;
    // Prevent unequipping artifacts for marketplace characters
    if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.isMarketplace) {
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)("Cannot modify equipment - character is on marketplace", "error");
        return false;
    }
    var artifact = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.equippedArtifacts[slotName];
    if (!artifact) return false;
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.equippedArtifacts[slotName] = null;
    (0, $b5bda7fdec806d8b$export$c7def531c087da85)("Unequipped ".concat(artifact.name, "!"), "info");
    // Refresh inventory display to update equipped status
    (0, $80ed874fd909c4ae$export$5b73e6a29e58b929)();
    (_window_renderGearTab = (_window = window).renderGearTab) === null || _window_renderGearTab === void 0 ? void 0 : _window_renderGearTab.call(_window); // gear-tab cards show equip state
    (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
    $7ea2865b97769aa3$export$2eced2100c12c50d();
    return true;
}
function $7ea2865b97769aa3$export$9e693217356d7ac4(gearId) {
    var techniqueId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "canEquipGear", gearId);
    if (!(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character) return false;
    // Check item requirements
    var gearItem = (0, $ca7af38ea7b7b4a8$export$a2dea178c28a0308)("id", gearId);
    if (gearItem.type !== "techGear") return false;
    // Check if character has related skill
    var characterSkill = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.skills[(0, $ca7af38ea7b7b4a8$export$a6cb179f21ae932e)(gearItem.techniqueId)];
    if (!characterSkill) return false;
    // Validate gear matches technique ID if provided
    if (techniqueId && gearItem.techniqueId !== techniqueId) return false;
    return true;
}
function $7ea2865b97769aa3$export$bc6c3240a6a68b89(gearId) {
    var gearItem = (0, $ca7af38ea7b7b4a8$export$a2dea178c28a0308)("id", gearId);
    if (!gearItem || !gearItem.techniqueId) return "";
    // Get the human-readable skill name
    var skillName = (0, $ca7af38ea7b7b4a8$export$182937d2e68a339)((0, $ca7af38ea7b7b4a8$export$a6cb179f21ae932e)(gearItem.techniqueId));
    return "Requires ".concat(skillName, " skill");
}
function $7ea2865b97769aa3$export$958ab300c288e475(techniqueId, gearId) {
    var _window_refreshAlpineContractors, _window, _window_renderGearTab, _window1;
    var gearItem = (0, $ca7af38ea7b7b4a8$export$a2dea178c28a0308)("id", gearId);
    // Prevent equipping gear for marketplace characters
    if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.isMarketplace) {
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)("Cannot modify equipment - character is on marketplace", "error");
        return false;
    }
    if (!$7ea2865b97769aa3$export$9e693217356d7ac4(gearId, techniqueId)) {
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)("Gear requirements not met", "error");
        return false;
    }
    // One gear per skill: equipping evicts whatever same-skill technique is
    // tooled up (incl. this technique's own current gear). The full kit is a
    // toolbox - swap freely between raids to match the route.
    var skillKey = (0, $ca7af38ea7b7b4a8$export$a6cb179f21ae932e)(techniqueId);
    Object.keys((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.equippedTechniqueGear).forEach(function(equippedTechId) {
        if ((0, $ca7af38ea7b7b4a8$export$a6cb179f21ae932e)(equippedTechId) === skillKey) $7ea2865b97769aa3$export$954d5d768998dfd1(equippedTechId);
    });
    // Equip new gear
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.equippedTechniqueGear[techniqueId] = gearItem;
    (0, $b5bda7fdec806d8b$export$c7def531c087da85)("Equipped ".concat(gearItem.name, "!"), "success");
    // Refresh displays (contractor cards show synergy indicators derived from
    // the player's equipped gear - window access avoids an import cycle)
    (0, $80ed874fd909c4ae$export$5b73e6a29e58b929)();
    (_window_refreshAlpineContractors = (_window = window).refreshAlpineContractors) === null || _window_refreshAlpineContractors === void 0 ? void 0 : _window_refreshAlpineContractors.call(_window);
    (_window_renderGearTab = (_window1 = window).renderGearTab) === null || _window_renderGearTab === void 0 ? void 0 : _window_renderGearTab.call(_window1); // gear-tab cards show equip state
    (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
    $7ea2865b97769aa3$export$2eced2100c12c50d();
    return true;
}
function $7ea2865b97769aa3$export$954d5d768998dfd1(techniqueId) {
    var _window_refreshAlpineContractors, _window, _window_renderGearTab, _window1;
    // Prevent unequipping gear for marketplace characters
    if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.isMarketplace) {
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)("Cannot modify equipment - character is on marketplace", "error");
        return false;
    }
    var gear = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.equippedTechniqueGear[techniqueId];
    if (!gear) return false;
    delete (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.equippedTechniqueGear[techniqueId];
    (0, $b5bda7fdec806d8b$export$c7def531c087da85)("Unequipped ".concat(gear.name, "!"), "info");
    // Refresh displays (incl. contractor synergy indicators)
    (0, $80ed874fd909c4ae$export$5b73e6a29e58b929)();
    (_window_refreshAlpineContractors = (_window = window).refreshAlpineContractors) === null || _window_refreshAlpineContractors === void 0 ? void 0 : _window_refreshAlpineContractors.call(_window);
    (_window_renderGearTab = (_window1 = window).renderGearTab) === null || _window_renderGearTab === void 0 ? void 0 : _window_renderGearTab.call(_window1); // gear-tab cards show equip state
    (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
    $7ea2865b97769aa3$export$2eced2100c12c50d();
    return true;
}
function $7ea2865b97769aa3$var$getAvailableSkillGear(techniqueId, skillKey) {
    var availableGear = Object.entries((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.inventory).filter(function(param) {
        var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), itemId = _param[0], qty = _param[1];
        return qty > 0;
    }).map(function(param) {
        var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 1), itemId = _param[0];
        var item = (0, $ca7af38ea7b7b4a8$export$a2dea178c28a0308)("id", itemId);
        return item;
    }).filter(function(item) {
        return item && item.type === "techGear" && item.techniqueId === techniqueId;
    });
    return availableGear;
}
function $7ea2865b97769aa3$export$4e0f5000083da307(techniqueId, skillKey) {
    // Get all techGear items from inventory
    var availableGear = $7ea2865b97769aa3$var$getAvailableSkillGear(techniqueId, skillKey);
    if (availableGear.length === 0) {
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)("No compatible gear in inventory", "warning");
        return;
    }
    // Create modal with gear options
    var gearOptions = availableGear.map(function(gear) {
        return '<div class="flex items-center justify-between p-2 border border-gray-500 rounded mb-2 hover:bg-gray-700/50 cursor-pointer" onclick="equipTechniqueGear(\''.concat(techniqueId, "', '").concat(gear.id, '\'); closeTechniqueGearSelector();">\n            <div>\n                <div class="font-bold text-white">').concat(gear.name, '</div>\n                <div class="text-xs text-gray-400">').concat(gear.icon, " ").concat(gear.short, "</div>\n                ").concat(gear.effects ? '<div class="text-xs text-amber-300">Effects: '.concat(Object.entries(gear.effects).map(function(param) {
            var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), k = _param[0], v = _param[1];
            return "".concat(k, ": +").concat(v);
        }).join(", "), "</div>") : "", '\n            </div>\n            <button class="px-3 py-1 bg-amber-600 hover:bg-amber-700 text-white rounded text-sm font-bold border border-amber-500" onclick="event.stopPropagation(); equipTechniqueGear(\'').concat(techniqueId, "', '").concat(gear.id, "'); closeTechniqueGearSelector();\">SELECT</button>\n        </div>");
    }).join("");
    // Show modal
    var modal = document.getElementById("technique-gear-selector-modal");
    if (modal) modal.remove();
    var newModal = document.createElement("div");
    newModal.id = "technique-gear-selector-modal";
    newModal.className = "modal hidden";
    newModal.innerHTML = '\n        <div class="modal-content max-w-md w-full">\n            <div class="modal-header">\n                <h3 class="modal-title">Select Gear for Technique</h3>\n                <button class="close-btn" onclick="closeTechniqueGearSelector()">&times;</button>\n            </div>\n            <div class="modal-body">\n                <div class="max-h-96 overflow-y-auto">\n                    '.concat(gearOptions, "\n                </div>\n            </div>\n        </div>\n    ");
    document.body.appendChild(newModal);
    newModal.classList.remove("hidden");
}
function $7ea2865b97769aa3$export$a9326cac8ab4c94a() {
    var modal = document.getElementById("technique-gear-selector-modal");
    if (modal) modal.classList.add("hidden");
}
function $7ea2865b97769aa3$export$fc83223e1b29d2d5(level) {
    // Calculate color intensity per level
    // Each level gradually shifts from dark grays (800-900) toward lighter grays (100-300)
    // Level 1 starts at dark, increases by ~2 gray-scale points per level
    var grayScale = {
        100: "gray-100",
        200: "gray-200",
        300: "gray-300",
        400: "gray-400",
        500: "gray-500",
        600: "gray-600",
        700: "gray-700",
        800: "gray-800",
        900: "gray-900"
    };
    // Calculate shift amount: 2 points per level, capped at 80
    var shiftAmount = Math.min((level - 1) * 2, 80);
    // Helper function to get closest Tailwind gray class
    var getGray = function(baseValue) {
        var adjusted = Math.max(100, baseValue - shiftAmount);
        var rounded = Math.round(adjusted / 100) * 100;
        return grayScale[rounded];
    };
    return {
        cardBg: "from-".concat(getGray(800), " to-").concat(getGray(900)),
        cardBorder: "border-".concat(getGray(600)),
        frameBorder: "border-".concat(getGray(500)),
        headerBg: "from-".concat(getGray(700), " to-").concat(getGray(600)),
        headerBorder: "border-".concat(getGray(500))
    };
}
function $7ea2865b97769aa3$export$35bc0bfc04b8de17() {
    var skillsSection = document.getElementById("skills-section");
    var pointsRemainingDiv = document.getElementById("points-remaining");
    var faction = $979b99378be707cd$export$aeeef991191508e2[(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).selectedFaction];
    if (!faction) return;
    // Only show skills after character is created
    if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character) {
        skillsSection.classList.remove("hidden");
        skillsSection.classList.add("grid");
        skillsSection.innerHTML = "";
        Object.entries(faction.skills).forEach(function(param) {
            var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), skillKey = _param[0], skill = _param[1];
            var skillLevel = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.skills[skillKey] || 0;
            var skillPointCost = Math.max(1, Math.floor(skillLevel / 3) + 1);
            var currencyCost = (0, $df8a44d92d572a5c$export$28bf58d3c9312b43)(skillLevel);
            var canAffordPoints = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.skillPoints >= skillPointCost;
            var canAffordCurrency = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player.credits >= currencyCost;
            var canAfford = canAffordPoints && canAffordCurrency;
            // Concrete benefit: success chance per tier for rooms where this skill
            // is primary (gates and hazards have different targets), and the +5%
            // a level buys (until the 97% cap). The equipped skill artifact's flat
            // bonus folds in exactly, under the same 97% cap the resolver applies.
            var artifactPct = (0, $df8a44d92d572a5c$export$a5a257639bbcfa93)(skillKey);
            var tierChances = [
                1,
                2,
                3
            ].map(function(tier) {
                var tierData = $979b99378be707cd$export$94e7ad7999c1ae32[tier];
                var gatePct = Math.min(97, Math.round((0, $52a7294453bdb6d1$export$2ad5af141c2ca6d2)(skillLevel, tierData.gateSkillLevel) * 100) + artifactPct);
                var hazardPct = Math.min(97, Math.round((0, $52a7294453bdb6d1$export$2ad5af141c2ca6d2)(skillLevel, tierData.hazardSkillLevel) * 100) + artifactPct);
                return "T".concat(tier, ' <span class="text-gray-300">gates ').concat(gatePct, "% \xb7 hazards ").concat(hazardPct, "%</span>");
            }).join(' &nbsp;|&nbsp; ');
            var atCap = (0, $52a7294453bdb6d1$export$2ad5af141c2ca6d2)(skillLevel, $979b99378be707cd$export$94e7ad7999c1ae32[3].hazardSkillLevel) * 100 + artifactPct >= 97;
            var nextLevelNote = atCap ? 'success chance at cap for current tiers' : 'next level: <span class="text-green-400 font-bold">+5%</span> on every room using this skill';
            var skillDiv = document.createElement("div");
            skillDiv.className = "skill-item";
            skillDiv.innerHTML = "\n                <h4>".concat(skill.name, '</h4>\n                <p class="text-gray-400 text-sm">').concat(skill.description, '</p>\n                <div class="text-xs text-gray-400 mt-1" title="Your success chance per skill check in rooms where this skill is primary (before support/contractor bonuses)">\n                    \uD83C\uDFB2 ').concat(tierChances, '\n                    <span class="block mt-0.5">').concat(nextLevelNote, '</span>\n                </div>\n                <div class="skill-controls">\n                    <span class="skill-level">Level: ').concat(skillLevel, '</span>\n                    <span class="skill-cost">Cost: ').concat(skillPointCost, " point").concat(skillPointCost > 1 ? "s" : "", " + ").concat(currencyCost, ' credits</span>\n                    <button class="skill-btn" onclick="upgradeSkill(\'').concat(skillKey, "')\" ").concat(!canAfford ? "disabled" : "", ">\n                        Upgrade ").concat(!canAffordPoints ? "(Need ".concat(skillPointCost - (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.skillPoints, " points)") : !canAffordCurrency ? "(Need ".concat(currencyCost - (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player.credits, " credits)") : "", "\n                    </button>\n                </div>\n            ");
            skillsSection.appendChild(skillDiv);
        });
        document.getElementById("points-remaining").textContent = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.skillPoints;
    } else {
        // Hide skills section during character creation
        skillsSection.classList.add("hidden");
        if (pointsRemainingDiv) pointsRemainingDiv.classList.add("hidden");
    }
    $7ea2865b97769aa3$export$44472cbca86113a6();
}
function $7ea2865b97769aa3$export$dfab59a277375299(skillKey) {
    (0, $df8a44d92d572a5c$export$909e62d4478cec23)(skillKey);
    $7ea2865b97769aa3$export$35bc0bfc04b8de17();
    $7ea2865b97769aa3$export$2eced2100c12c50d();
    (0, $59924438766e7d8e$export$d1c957a54f7124bc)(); // Update credits display
    (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
}
function $7ea2865b97769aa3$export$8d1a7714ddcaaa75(skillKey) {
    var _window_refreshAlpineContractors, _window;
    var result = (0, $df8a44d92d572a5c$export$a2d6ef296e5ae7a1)(skillKey);
    if (!result.success) {
        var messages = {
            'insufficient-points': "\u26A0\uFE0F Need ".concat((0, $df8a44d92d572a5c$export$d09b0dfa38532c40)().cost, " skill points to unlock synergies"),
            'already-unlocked': 'Synergies already unlocked for this skill',
            'not-revealed': "Synergies unlock at level ".concat((0, $df8a44d92d572a5c$export$d09b0dfa38532c40)().minLevel)
        };
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)(messages[result.reason] || 'Cannot unlock synergies', 'warning');
        return;
    }
    (0, $b5bda7fdec806d8b$export$c7def531c087da85)("\u26A1 ".concat((0, $ca7af38ea7b7b4a8$export$182937d2e68a339)(skillKey), " synergies unlocked! Teammates' partner gear can now upgrade its events."), 'success');
    $7ea2865b97769aa3$export$35bc0bfc04b8de17();
    $7ea2865b97769aa3$export$2eced2100c12c50d();
    (_window_refreshAlpineContractors = (_window = window).refreshAlpineContractors) === null || _window_refreshAlpineContractors === void 0 ? void 0 : _window_refreshAlpineContractors.call(_window); // card indicators depend on unlocks
    (0, $59924438766e7d8e$export$d1c957a54f7124bc)();
    (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
}
function $7ea2865b97769aa3$export$318eecdbf5a9bff1(xpAmount) {
    if (!(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character) return;
    // Use core logic for XP gain and leveling
    (0, $df8a44d92d572a5c$export$88ec20478ef6bd29)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character, xpAmount);
    // Update UI to reflect changes
    (0, $59924438766e7d8e$export$d1c957a54f7124bc)();
    $7ea2865b97769aa3$export$2eced2100c12c50d();
    // Update character selector to reflect XP changes
    if (typeof $7ea2865b97769aa3$export$d87722dc17dc5f68 !== "undefined") $7ea2865b97769aa3$export$d87722dc17dc5f68();
}
function $7ea2865b97769aa3$export$614d9188892af6f1() {
    var character = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character;
    var hpBefore = character.maxHp;
    // Use core logic for leveling
    (0, $df8a44d92d572a5c$export$57757d3a3e441a94)(character);
    var hpIncrease = character.maxHp - hpBefore;
    var skillPointsGained = 2 + Math.floor(character.level / 5); // Matches calculation in levelUpCore
    // Show level up notifications (UI only)
    (0, $b5bda7fdec806d8b$export$c7def531c087da85)("\uD83C\uDF89 Level Up! You are now level ".concat(character.level, "!"), "success");
    (0, $b5bda7fdec806d8b$export$c7def531c087da85)("\uD83D\uDCAA +".concat(hpIncrease, " Max HP, +").concat(skillPointsGained, " Skill Points"), "success");
    // Log level up in raid log if active
    var logEntries = document.getElementById("log-entries");
    if (logEntries && logEntries.innerHTML !== "") addLogEntry("\uD83C\uDF89 LEVEL UP! You reached level ".concat(character.level, "! (+").concat(hpIncrease, " HP, +").concat(skillPointsGained, " skill points)"), "success");
}
//
// Avatar selection functions
//
// When the player clicks "New Set", this holds a fresh random root so the grid
// shows brand-new candidates instead of variants of their current avatar.
var $7ea2865b97769aa3$var$galleryOverrideSeed = null;
function $7ea2865b97769aa3$export$aee20503c4a7fb32() {
    var _gameState_character;
    var faction = ((_gameState_character = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character) === null || _gameState_character === void 0 ? void 0 : _gameState_character.faction) || "dominion";
    // Default: seeded candidates off the character's own seed so re-opening is
    // stable (root, then root#0..root#28 — current avatar first; "#k" suffix
    // stripped so picking a variant doesn't keep growing the seed). "New Set"
    // swaps in a fresh random root for a full page of brand-new faces.
    var seeds;
    if ($7ea2865b97769aa3$var$galleryOverrideSeed) seeds = Array.from({
        length: 30
    }, function(_, k) {
        return "".concat($7ea2865b97769aa3$var$galleryOverrideSeed, "#").concat(k);
    });
    else {
        var root = String((0, $ca7af38ea7b7b4a8$export$f3619081e7e8f116)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character || {})).replace(/#\d+$/, "");
        seeds = [
            root
        ].concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)(Array.from({
            length: 29
        }, function(_, k) {
            return "".concat(root, "#").concat(k);
        })));
    }
    return seeds.map(function(seed) {
        return '\n            <div class="avatar-option" data-avatar-seed="'.concat(seed, '">\n                <div class="contractor-avatar-placeholder" data-avatar-seed="').concat(seed, '" data-avatar-faction="').concat(faction, '"></div>\n            </div>\n        ');
    }).join("");
}
function $7ea2865b97769aa3$export$a2a7c3306a075a0b() {
    var changeAvatarBtn = document.getElementById("change-avatar-btn");
    var avatarSelector = document.getElementById("avatar-selector");
    var closeAvatarBtn = document.getElementById("close-avatar-selector");
    if (changeAvatarBtn) changeAvatarBtn.addEventListener("click", function() {
        $7ea2865b97769aa3$export$b87daba1245f3381();
    });
    if (closeAvatarBtn) closeAvatarBtn.addEventListener("click", function() {
        $7ea2865b97769aa3$export$844cc0cc11314e02();
    });
    // Close modal when clicking outside
    if (avatarSelector) avatarSelector.addEventListener("click", function(e) {
        if (e.target === avatarSelector) $7ea2865b97769aa3$export$844cc0cc11314e02();
    });
    $7ea2865b97769aa3$var$wireAvatarOptions();
    // "New Set": swap the gallery in for a fresh random page of candidates.
    var refreshBtn = document.getElementById("avatar-gallery-refresh");
    if (refreshBtn) refreshBtn.addEventListener("click", function() {
        $7ea2865b97769aa3$var$galleryOverrideSeed = "gallery_".concat(Date.now(), "_").concat(Math.random().toString(36).slice(2, 8));
        var grid = document.getElementById("avatar-gallery-grid");
        if (grid) {
            grid.innerHTML = $7ea2865b97769aa3$export$aee20503c4a7fb32();
            $7ea2865b97769aa3$var$wireAvatarOptions();
        }
    });
    $7ea2865b97769aa3$var$setupAvatarTabs();
}
// The raid team carousel caches each member's card HTML with the avatar seed
// baked in, so an avatar edit on the Characters page leaves the player's team
// card stale. Whenever that carousel is currently showing cards (team assembly
// or path planning - both display the team before a grid exists), rebuild it so
// the new look shows immediately. updateGridTeamDisplay self-guards on the DOM.
function $7ea2865b97769aa3$var$refreshRaidTeamAvatar() {
    var teamDisplay = document.getElementById('grid-team-display');
    if (teamDisplay && teamDisplay.querySelector('[data-avatar-seed]')) (0, $3f29ea4265abff3b$export$b70ccd83fb3eaefa)();
}
// Wire click-to-pick on gallery options. Idempotent (data-wired guard) so it can
// be re-run after regenerating the grid for a new set. A gallery pick reverts any
// custom avatar back to a seed.
function $7ea2865b97769aa3$var$wireAvatarOptions() {
    document.querySelectorAll(".avatar-option").forEach(function(option) {
        if (option.dataset.wired) return;
        option.dataset.wired = "1";
        option.addEventListener("click", function() {
            (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.avatarSeed = option.dataset.avatarSeed;
            delete (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.avatarFeatures;
            $7ea2865b97769aa3$export$2eced2100c12c50d();
            $7ea2865b97769aa3$export$844cc0cc11314e02();
            (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
            if (typeof $7ea2865b97769aa3$export$d87722dc17dc5f68 !== "undefined") $7ea2865b97769aa3$export$d87722dc17dc5f68();
            $7ea2865b97769aa3$var$refreshRaidTeamAvatar();
        });
    });
}
// ---- Custom avatar creator (the "Custom" tab of the picker) --------------
// A working feature object the player edits live. Initialised from their current
// avatar: their saved custom features if any, else rolled from their seed.
var $7ea2865b97769aa3$var$creatorFeatures = null;
var $7ea2865b97769aa3$var$creatorAnimStop = null;
var $7ea2865b97769aa3$var$avatarCreatorFaction = function() {
    var _gameState_character;
    return ((_gameState_character = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character) === null || _gameState_character === void 0 ? void 0 : _gameState_character.faction) || "dominion";
};
function $7ea2865b97769aa3$var$initCreatorFeatures() {
    var c = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character;
    $7ea2865b97769aa3$var$creatorFeatures = (c === null || c === void 0 ? void 0 : c.avatarFeatures) ? (0, $fa9769297b8a68c8$export$71511d61b312f219)({}, c.avatarFeatures) : (0, $9b7c6ba2608f0479$export$4fafee04cbe5d540)((0, $ca7af38ea7b7b4a8$export$f3619081e7e8f116)(c || {}), $7ea2865b97769aa3$var$avatarCreatorFaction());
}
function $7ea2865b97769aa3$var$stopCreatorPreviewAnim() {
    if ($7ea2865b97769aa3$var$creatorAnimStop) {
        $7ea2865b97769aa3$var$creatorAnimStop();
        $7ea2865b97769aa3$var$creatorAnimStop = null;
    }
}
// Animate the preview canvas off the LIVE creatorFeatures object (same idle loop
// the main card uses). Edits mutate that object in place and Randomize
// Object.assigns into it, so the running loop always reflects the current look.
function $7ea2865b97769aa3$var$startCreatorPreviewAnim() {
    $7ea2865b97769aa3$var$stopCreatorPreviewAnim();
    var canvas = document.getElementById("avatar-creator-canvas");
    if (canvas && $7ea2865b97769aa3$var$creatorFeatures) $7ea2865b97769aa3$var$creatorAnimStop = (0, $a6e2b3e30d0f771b$export$e3449c06744f2603)(canvas, $7ea2865b97769aa3$var$creatorFeatures, $7ea2865b97769aa3$var$avatarCreatorFaction(), "creator");
}
var $7ea2865b97769aa3$var$acGet = function(field) {
    return field.get ? field.get($7ea2865b97769aa3$var$creatorFeatures) : $7ea2865b97769aa3$var$creatorFeatures[field.key];
};
// Edits mutate creatorFeatures in place; the running preview loop shows them.
var $7ea2865b97769aa3$var$acSet = function(field, v) {
    field.set ? field.set($7ea2865b97769aa3$var$creatorFeatures, v) : $7ea2865b97769aa3$var$creatorFeatures[field.key] = v;
};
var $7ea2865b97769aa3$var$acOpts = function(field) {
    return field.options.map(function(o) {
        return Array.isArray(o) ? o : [
            o,
            o
        ];
    });
};
// One labelled control for a FEATURE_SCHEMA field (ported from avatar-lab.html).
function $7ea2865b97769aa3$var$buildAvatarField(field) {
    var wrap = document.createElement("div");
    wrap.className = "cfield";
    var lab = document.createElement("label");
    lab.textContent = field.label;
    wrap.appendChild(lab);
    if (field.type === "bool") {
        var input = document.createElement("input");
        input.type = "checkbox";
        input.checked = !!$7ea2865b97769aa3$var$acGet(field);
        input.addEventListener("change", function() {
            return $7ea2865b97769aa3$var$acSet(field, input.checked);
        });
        wrap.appendChild(input);
    } else if (field.type === "int") {
        var input1 = document.createElement("input");
        input1.type = "number";
        input1.min = field.min;
        input1.max = field.max;
        input1.step = 1;
        input1.value = $7ea2865b97769aa3$var$acGet(field);
        input1.addEventListener("input", function() {
            var v = parseInt(input1.value, 10);
            if (!Number.isNaN(v)) $7ea2865b97769aa3$var$acSet(field, v);
        });
        wrap.appendChild(input1);
    } else if (field.type === "color") {
        var row = document.createElement("div");
        row.className = "color-row";
        var input2 = document.createElement("input");
        input2.type = "color";
        input2.value = $7ea2865b97769aa3$var$acGet(field) || "#888888";
        input2.addEventListener("input", function() {
            return $7ea2865b97769aa3$var$acSet(field, input2.value);
        });
        var presets = document.createElement("div");
        presets.className = "presets";
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var cc = _step.value;
                var b = document.createElement("button");
                b.type = "button";
                b.style.background = cc;
                b.title = cc;
                b.addEventListener("click", function() {
                    input2.value = cc;
                    $7ea2865b97769aa3$var$acSet(field, cc);
                });
                presets.appendChild(b);
            };
            for(var _iterator = (field.options || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        row.append(input2, presets);
        wrap.appendChild(row);
    } else if (field.type === "enum") {
        var sel = document.createElement("select");
        var opts = $7ea2865b97769aa3$var$acOpts(field);
        opts.forEach(function(param, i) {
            var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 1), label = _param[0];
            return sel.add(new Option(label, String(i)));
        });
        var idx = opts.findIndex(function(param) {
            var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), v = _param[1];
            return v === $7ea2865b97769aa3$var$acGet(field);
        });
        sel.value = String(idx < 0 ? 0 : idx);
        sel.addEventListener("change", function() {
            return $7ea2865b97769aa3$var$acSet(field, opts[Number(sel.value)][1]);
        });
        wrap.appendChild(sel);
    }
    return wrap;
}
// Build the grouped control grid (Face / Hair / Eyes / Accessories) for the
// current faction (drops faction-specific fields like the veil-only hood).
function $7ea2865b97769aa3$var$renderAvatarCreatorControls() {
    var host = document.getElementById("avatar-creator-controls");
    if (!host) return;
    host.innerHTML = "";
    var faction = $7ea2865b97769aa3$var$avatarCreatorFaction();
    var order = [], byGroup = new Map();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = (0, $9b7c6ba2608f0479$export$54d4f0a9b0c6e9b3)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var field = _step.value;
            if (field.factions && !field.factions.includes(faction)) continue;
            if (!byGroup.has(field.group)) {
                byGroup.set(field.group, []);
                order.push(field.group);
            }
            byGroup.get(field.group).push(field);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = order[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var g = _step1.value;
            var title = document.createElement("div");
            title.className = "cgroup-title";
            title.textContent = g;
            var grid = document.createElement("div");
            grid.className = "creator-controls";
            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
            try {
                for(var _iterator2 = byGroup.get(g)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                    var field1 = _step2.value;
                    grid.appendChild($7ea2865b97769aa3$var$buildAvatarField(field1));
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                        _iterator2.return();
                    }
                } finally{
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
            host.append(title, grid);
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
}
// Wire the Gallery/Custom tabs + the creator's Randomize/Use buttons. Re-run
// each time the modal markup is rebuilt (setupAvatarSelection).
function $7ea2865b97769aa3$var$setupAvatarTabs() {
    var tabs = document.querySelectorAll(".avatar-tab");
    var panes = {
        gallery: document.getElementById("avatar-pane-gallery"),
        custom: document.getElementById("avatar-pane-custom")
    };
    tabs.forEach(function(tab) {
        return tab.addEventListener("click", function() {
            var which = tab.dataset.avatarTab;
            tabs.forEach(function(t) {
                return t.classList.toggle("active", t === tab);
            });
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(panes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step.value, 2), k = _step_value[0], pane = _step_value[1];
                    pane && pane.classList.toggle("active", k === which);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            if (which === "custom") {
                if (!$7ea2865b97769aa3$var$creatorFeatures) $7ea2865b97769aa3$var$initCreatorFeatures(); // first open this session; keeps edits across toggles
                $7ea2865b97769aa3$var$renderAvatarCreatorControls();
                $7ea2865b97769aa3$var$startCreatorPreviewAnim();
            } else $7ea2865b97769aa3$var$stopCreatorPreviewAnim(); // no need to animate a hidden preview
        });
    });
    var randomBtn = document.getElementById("avatar-creator-random");
    if (randomBtn) randomBtn.addEventListener("click", function() {
        if (!$7ea2865b97769aa3$var$creatorFeatures) $7ea2865b97769aa3$var$initCreatorFeatures();
        // Mutate in place so the live preview loop keeps pointing at the same object.
        Object.assign($7ea2865b97769aa3$var$creatorFeatures, (0, $9b7c6ba2608f0479$export$4fafee04cbe5d540)("custom_".concat(Date.now(), "_").concat(Math.random().toString(36).slice(2, 8)), $7ea2865b97769aa3$var$avatarCreatorFaction()));
        $7ea2865b97769aa3$var$renderAvatarCreatorControls();
        $7ea2865b97769aa3$var$startCreatorPreviewAnim();
    });
    var applyBtn = document.getElementById("avatar-creator-apply");
    if (applyBtn) applyBtn.addEventListener("click", function() {
        if (!$7ea2865b97769aa3$var$creatorFeatures) return;
        $7ea2865b97769aa3$var$stopCreatorPreviewAnim();
        (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.avatarFeatures = (0, $fa9769297b8a68c8$export$71511d61b312f219)({}, $7ea2865b97769aa3$var$creatorFeatures);
        $7ea2865b97769aa3$export$2eced2100c12c50d();
        $7ea2865b97769aa3$export$844cc0cc11314e02();
        (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
        if (typeof $7ea2865b97769aa3$export$d87722dc17dc5f68 !== "undefined") $7ea2865b97769aa3$export$d87722dc17dc5f68();
        $7ea2865b97769aa3$var$refreshRaidTeamAvatar();
    });
}
function $7ea2865b97769aa3$export$b87daba1245f3381() {
    var _gameState_currentRaid, _document_getElementById, _document_getElementById1;
    // Editing is locked while a raid is actively running (the button is also
    // disabled, but guard the action too - render timing isn't guaranteed).
    if ((_gameState_currentRaid = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid) === null || _gameState_currentRaid === void 0 ? void 0 : _gameState_currentRaid.raidInProgress) {
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)("Can't edit your avatar while a raid is in progress", "info");
        return;
    }
    $7ea2865b97769aa3$var$galleryOverrideSeed = null;
    var grid = document.getElementById("avatar-gallery-grid");
    if (grid) {
        grid.innerHTML = $7ea2865b97769aa3$export$aee20503c4a7fb32();
        $7ea2865b97769aa3$var$wireAvatarOptions();
    }
    document.querySelectorAll(".avatar-tab").forEach(function(t) {
        return t.classList.toggle("active", t.dataset.avatarTab === "gallery");
    });
    (_document_getElementById = document.getElementById("avatar-pane-gallery")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.classList.add("active");
    (_document_getElementById1 = document.getElementById("avatar-pane-custom")) === null || _document_getElementById1 === void 0 ? void 0 : _document_getElementById1.classList.remove("active");
    $7ea2865b97769aa3$var$stopCreatorPreviewAnim();
    $7ea2865b97769aa3$var$creatorFeatures = null;
    var avatarSelector = document.getElementById("avatar-selector");
    if (avatarSelector) avatarSelector.classList.remove("hidden");
}
function $7ea2865b97769aa3$export$844cc0cc11314e02() {
    $7ea2865b97769aa3$var$stopCreatorPreviewAnim();
    $7ea2865b97769aa3$var$creatorFeatures = null;
    var avatarSelector = document.getElementById("avatar-selector");
    if (avatarSelector) avatarSelector.classList.add("hidden");
}
// ---------------------------------------------------------------------------
// Main character card: full card <-> drawer
//
// Collapsed, the card gives its ~240px column back to the Skills/Gear panes —
// the single biggest horizontal win available on this page for a tablet. What
// survives the collapse is the at-a-glance state (who, how healthy, what is
// equipped, what level) and the two actions that are not reachable anywhere
// else on the page. Renaming, the avatar editor and DELETE deliberately do not:
// a destructive control on a one-tap drawer is a mis-tap waiting to happen.
//
// Session-scoped, like the gear page's focus panel — a layout preference, not
// save data.
// ---------------------------------------------------------------------------
var $7ea2865b97769aa3$var$characterCardCollapsed = false;
function $7ea2865b97769aa3$export$63b7a79b9f19f21b() {
    $7ea2865b97769aa3$var$characterCardCollapsed = !$7ea2865b97769aa3$var$characterCardCollapsed;
    $7ea2865b97769aa3$export$2eced2100c12c50d();
}
/** One drawer row: icon over value, or icon alone when value is null. */ function $7ea2865b97769aa3$var$drawerChip(icon, value, title) {
    return '\n    <div class="w-full flex flex-col items-center rounded border border-gray-700 bg-black/70 pt-2" title="'.concat(title, '">\n        <span class="text-sm leading-none">').concat(icon, "</span>\n        ").concat(value != null ? '<span class="text-[10px] font-bold leading-tight mt-0.5">'.concat(value, "</span>") : "", "\n    </div>");
}
function $7ea2865b97769aa3$var$renderCharacterDrawer(param) {
    var faction = param.faction, levelColors = param.levelColors, isReadOnly = param.isReadOnly, hasRaid = param.hasRaid;
    var character = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character;
    var equippedGearCount = Object.values(character.equippedTechniqueGear || {}).filter(Boolean).length;
    var equippedArtifactCount = Object.values(character.equippedArtifacts || {}).filter(Boolean).length;
    var xpToNext = (0, $df8a44d92d572a5c$export$ae545994cbde97ee)(character.level);
    return '\n    <div class="character-avatar-section">\n        <div class="relative bg-gradient-to-b '.concat(levelColors.headerBg, " to-gray-900 border-4 ").concat(isReadOnly ? "border-orange-500" : levelColors.cardBorder, ' rounded-xl shadow-lg w-16 flex flex-col items-center gap-1.5 p-1.5 h-[480px]">\n            <button id="toggle-character-card-btn" onclick="toggleCharacterCard()"\n                title="Expand ').concat(character.name, '" aria-expanded="false"\n                class="w-full h-6 flex items-center justify-center rounded bg-black/40 border border-gray-600 text-gray-300 hover:text-white hover:border-gray-400 text-sm leading-none">\u25B8</button>\n\n            <div class="rounded-full w-7 h-7 flex items-center justify-center bg-black/30 border border-black text-sm flex-shrink-0"\n                title="').concat(faction.name).concat(isReadOnly ? " \u2014 on marketplace" : "", '">').concat(faction.icon || "\uD83C\uDFE2", "</div>\n\n            ").concat($7ea2865b97769aa3$var$drawerChip("\u2764\uFE0F", Math.floor(character.currentHp), "Health: ".concat(Math.floor(character.currentHp), " / ").concat(character.maxHp)), "\n            ").concat($7ea2865b97769aa3$var$drawerChip("\uD83E\uDDF0", equippedGearCount, "Equipped skill gear"), "\n            ").concat($7ea2865b97769aa3$var$drawerChip("\uD83D\uDD2E", equippedArtifactCount, "Equipped artifacts"), '\n\n            <div class="w-full rounded border-2 border-gray-500 bg-gradient-to-b from-gray-800 to-gray-900 py-1 text-center"\n                title="Level ').concat(character.level, " \u2014 ").concat(character.xp, "/").concat(xpToNext, ' XP">\n                <div class="text-[9px] uppercase tracking-wide text-gray-400 leading-none">Lv</div>\n                <div class="text-blue-300 font-bold text-sm leading-tight">').concat(character.level, '</div>\n            </div>\n            <div class="flex-grow"></div>\n            ').concat((0, $ee71dfe8b201c427$export$25d1e5af45c35a33)() ? '<button id="promote-character-btn" onclick="openPromoteModal()"\n                    class="w-full py-1 rounded text-xs font-bold transition-all duration-200 hover:shadow-lg"\n                    style="border:1.5px solid #6d4fa3; background:#6d4fa3; color:#b18cff;"\n                    title="Promote to Command \u2014 '.concat((0, $ee71dfe8b201c427$export$ffae5de2f7ddd94d)(character).total, ' marks">\uD83C\uDF96\uFE0F</button>') : "", '\n            <button id="contract-out-btn" ').concat(hasRaid ? "disabled" : "", ' class="').concat(character.isMarketplace ? "bg-orange-600 hover:bg-orange-700" : "bg-yellow-600 hover:bg-yellow-700", ' w-full text-white py-1 rounded text-xs font-bold transition-all duration-200" title="').concat(character.isMarketplace ? "Withdraw from Marketplace" : "Contract Out to Marketplace", '">').concat(character.isMarketplace ? "\uD83D\uDCE4" : "\uD83D\uDCBC", '</button>\n            \n            <button id="delete-character-btn" class="w-full bg-red-600 hover:bg-red-700 text-white py-1 rounded text-xs font-bold transition-all duration-200 ').concat(isReadOnly ? "opacity-50 cursor-not-allowed" : "", '" \n              title="').concat(isReadOnly ? "Cannot delete - character on marketplace" : "Delete Character", '" ').concat(isReadOnly ? "disabled" : "", ">\uD83D\uDDD1\uFE0F</button>\n        </div>\n    </div>");
}
function $7ea2865b97769aa3$export$2eced2100c12c50d() {
    var _gameState_currentRaid;
    // Update character selector first
    if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).characters.length > 0) $7ea2865b97769aa3$export$d87722dc17dc5f68();
    // Update inventory header
    (0, $a575049a7e5cb3a1$export$d2567add70135c10)();
    var faction = $979b99378be707cd$export$aeeef991191508e2[(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.faction];
    // Check if character is in read-only mode (on marketplace)
    var isReadOnly = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.isMarketplace;
    // Update header background when character is displayed
    (0, $59924438766e7d8e$export$ffc032d1101a5382)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.faction);
    // One skill card at a time — the strip below picks which, and carries that
    // skill's level and upgrade button.
    var shownSkill = (0, $e8f8e272b259f38e$export$5b90168a051cbfed)($7ea2865b97769aa3$var$SKILL_TAB_GROUP, (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.faction);
    var skillsHtml = "";
    Object.entries((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.skills).filter(function(param) {
        var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 1), skillKey = _param[0];
        return skillKey === shownSkill;
    }).forEach(function(param) {
        var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), skillKey = _param[0], level = _param[1];
        var skillShort = faction.skills[skillKey].short;
        var skillPointCost = (0, $df8a44d92d572a5c$export$7d0067675be54b12)(level);
        var canAfford = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.skillPoints >= skillPointCost && (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player.credits >= (0, $df8a44d92d572a5c$export$28bf58d3c9312b43)(level) && !isReadOnly;
        // The card's old header row is gone — the tab strip above already names the
        // skill. Its level and upgrade button moved down here, beside the synergy
        // control: both are "spend points on this skill", so they belong together.
        skillsHtml += '\n            <div class="skill-card relative flex flex-col justify-items-stretch border-2 border-gray-600/90 rounded-lg shadow-md bg-'.concat((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.faction, '-bright">\n                <!-- Header Banner -->\n                <div class="relative text-gray-100 backdrop-blur-lg bg-black/60 rounded-lg rounded-b-none">\n                    <div class="flex flex-col items-end mt-2 mx-2 rounded-lg bg-black/65">\n                        <!-- Synergy unlock, then level + upgrade. This row is NOT\n                             gated on the synergy reveal level: it now carries the\n                             only way to spend skill points, and the synergy\n                             control below already hides itself before then. -->\n                        <div class="flex items-center gap-2 w-full p-2">\n                            <div class="flex-grow text-sm">\n                              <p class="text-gray-100 leading-relaxed">').concat(skillShort, "</p>\n                            </div>\n                            ").concat(function() {
            // Per-skill synergy unlock: appears at the reveal
            // level, bought with skill points, then permanent
            if (!(0, $df8a44d92d572a5c$export$aaee02d18e8a1c01)() || isReadOnly) return "";
            if ((0, $df8a44d92d572a5c$export$7d626adf944498ee)(skillKey)) return '<span class="px-2 py-1 rounded text-sm font-bold bg-amber-900/60 text-amber-300 border border-amber-700 whitespace-nowrap" title="Synergy variants can fire on this skill\'s events, and its equipped gear can partner teammates\' events">\u26A1 Synergies</span>';
            var cfg = (0, $df8a44d92d572a5c$export$d09b0dfa38532c40)();
            var canUnlock = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.skillPoints >= cfg.cost;
            return '<button class="synergies-btn min-w-auto px-2 py-1 rounded whitespace-nowrap transition-all duration-200 text-sm font-bold '.concat(canUnlock ? "bg-blue-600 hover:bg-blue-500 text-white hover:shadow-lg border border-blue-400" : "bg-white/10 text-gray-400 cursor-not-allowed border border-gray-700", '" onclick="unlockSkillSynergy(\'').concat(skillKey, "')\" ").concat(!canUnlock ? "disabled" : "", " title=\"Unlock synergy variants for this skill's events and let its gear partner teammates' events\">\n                                  \uD83D\uDD13 Synergies (").concat(cfg.cost, " pts)\n                              </button>");
        }(), '\n                            <div class="flex flex-shrink-0">\n                                <div class="bg-amber-500 text-black px-2 py-1 rounded-l-md text-sm font-bold inline-block border border-amber-500">Lv.').concat(level, '</div>\n                                <button class="skill-upgrade-btn min-w-auto px-2 py-1 rounded-r-md transition-all duration-200 text-sm font-bold ').concat(canAfford ? "bg-blue-600 hover:bg-blue-500 text-white hover:shadow-lg border border-blue-400" : "bg-white/10 text-black cursor-not-allowed border border-gray-700", '" onclick="upgradeSkill(\'').concat(skillKey, "')\" ").concat(!canAfford ? "disabled" : "", ">\n                                    ").concat(isReadOnly ? "\uD83D\uDEAB" : "\u25B2 ".concat(skillPointCost, "pt").concat(skillPointCost > 1 ? "s" : ""), '\n                                </button>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n\n                <!-- Card Content -->\n                <div class="relative flex-grow text-[0.9rem] p-2 bg-black/60 backdrop-blur-[2px] border-b rounded-b-lg border-transparent">\n                    <!-- No fixed height: the h-12 that used to level card tops\n                         across a grid row costs two blank lines now that one\n                         card renders at full width. -->\n\n                    <!-- Skill Techniques Tabs -->\n                    ').concat(function() {
            var factionTechniques = $979b99378be707cd$export$aafe7b77259ba40d[(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.faction] || [];
            var techniques = factionTechniques.filter(function(t) {
                return t.skill === skillKey;
            });
            if (techniques.length === 0) return "";
            var tabId = "techniques-".concat(skillKey);
            var _gameState_character_techniqueTabSelections_tabId;
            // Get the saved tab selection for this skill, default to 0
            var selectedTabIndex = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.techniqueTabSelections ? (_gameState_character_techniqueTabSelections_tabId = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.techniqueTabSelections[tabId]) !== null && _gameState_character_techniqueTabSelections_tabId !== void 0 ? _gameState_character_techniqueTabSelections_tabId : 0 : 0;
            // Tab buttons (icons)
            var tabButtons = techniques.map(function(t, idx) {
                return '<button\n                                class="flex-1 technique-tab px-2 py-[2px] rounded-lg rounded-bl-none rounded-br-none text-lg transition-colors '.concat(idx === selectedTabIndex ? "bg-black/65" : "bg-gray-500/60 hover:bg-gray-900/60", '"\n                                onclick="window.switchTechniqueTab(\'').concat(tabId, "', ").concat(idx, ')"\n                                data-tab-group="').concat(tabId, '"\n                                data-tab-index="').concat(idx, '"\n                                title="').concat(t.name, '">\n                                ').concat(t.icon, "\n                            </button>");
            }).join("");
            // Tab content panels
            var tabPanels = techniques.map(function(t, idx) {
                // Progressive disclosure: synergies are invisible
                // below the reveal level, a locked teaser until the
                // skill's unlock is bought, then fully detailed.
                // Each synergy is unlocked by one specific cross-faction
                // device: the partner technique (from this technique's
                // event variants) whose skill matches the synergy target.
                // One synergy per column (gear management lives on the
                // Gear tab now, so the old gear column is gone).
                var synergyBlocks = [
                    "",
                    ""
                ];
                if ((0, $df8a44d92d572a5c$export$aaee02d18e8a1c01)() && !(0, $df8a44d92d572a5c$export$7d626adf944498ee)(skillKey)) synergyBlocks[0] = '<div class="text-gray-400 text-sm leading-tight mt-1" title="Synergy variants: teammates\' cross-faction gear upgrades this skill\'s events for bonus salvage">\uD83D\uDD12 Synergies \u2014 unlock on the skill card above ('.concat((0, $df8a44d92d572a5c$export$d09b0dfa38532c40)().cost, " pts)</div>");
                else if ((0, $df8a44d92d572a5c$export$aaee02d18e8a1c01)() && (0, $df8a44d92d572a5c$export$7d626adf944498ee)(skillKey)) {
                    var allDevices = (0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$71b953a5ed5f0cd6).concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$76261a034023b29), (0, $4c858c0d999a5b9b$export$71511d61b312f219)($979b99378be707cd$export$7a39b013515e9c7d));
                    var partnerTechniques = (0, $4c858c0d999a5b9b$export$71511d61b312f219)((0, $52a7294453bdb6d1$export$fe6715e7f54582df)(t.id));
                    synergyBlocks = t.synergies.map(function(s, idex) {
                        var partnerTech = partnerTechniques.find(function(p) {
                            return (0, $ca7af38ea7b7b4a8$export$a6cb179f21ae932e)(p) === s.targetSkill;
                        });
                        var device = partnerTech ? allDevices.find(function(d) {
                            return d.techniqueId === partnerTech;
                        }) : null;
                        var gearLine = device ? '<div class="text-[11.5px] text-amber-300/90 leading-tight mb-3" title="A teammate with this equipped unlocks the synergy variant (bonus salvage)">'.concat(device.icon || "\u2699\uFE0F", " ").concat(device.name, "</div>") : '';
                        return '<div class="text-blue-300 leading-tight mb-1 font-bold">\n                                    <span>'.concat($979b99378be707cd$export$aeeef991191508e2[s.targetFaction].name, ' Synergy</span> - \n                                    <span class="text-green-400">').concat($979b99378be707cd$export$aeeef991191508e2[s.targetFaction].skills[s.targetSkill].name, '</span>\n                                </div>\n                                <div class="text-sm/4 ').concat(device ? 'mb-1' : 'mb-3', '">').concat(s.effect, "</div>\n                                ").concat(gearLine);
                    });
                }
                return '\n                                <div class="technique-panel '.concat(idx === selectedTabIndex ? "" : "hidden", '" data-tab-group="').concat(tabId, '" data-panel-index="').concat(idx, '">\n                                    <div class="text-base font-bold text-gray-200 mb-1 leading-tight p-1 px-2 bg-black/50">Tech: ').concat(t.name, '</div>\n                                    <div class="">\n                                        <div class="text-gray-200 my-3 leading-tight px-2">').concat(t.description, '</div>\n                                        <div class="flex ').concat((0, $df8a44d92d572a5c$export$aaee02d18e8a1c01)() ? '' : 'hidden', '">\n                                            <div class="flex-1 text-gray-200 p-1 px-2">').concat(synergyBlocks[0] || "", '</div>\n                                            <div class="flex-1 text-gray-200 p-1 border-l border-gray-600 px-2">').concat(synergyBlocks[1] || "", "</div>\n                                        </div>\n                                    </div>\n                                </div>\n                            ");
            }).join("");
            return '\n                            <div>\n                                <div class="flex gap-1">\n                                    '.concat(tabButtons, '\n                                </div>\n                                <div class="technique-content rounded-lg rounded-t-none overflow-y-auto overflow-x-hidden bg-black/30">\n                                    ').concat(tabPanels, "\n                                </div>\n                            </div>\n                        ");
        }(), "\n                </div>\n            </div>\n        ");
    });
    var hasRaid = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid && (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidOwnerId == (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.id;
    // A raid actively running (not merely planned) locks name/avatar edits.
    var raidRunning = !!((_gameState_currentRaid = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid) === null || _gameState_currentRaid === void 0 ? void 0 : _gameState_currentRaid.raidInProgress);
    var xpToNext = (0, $df8a44d92d572a5c$export$ae545994cbde97ee)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.level);
    var xpPercentage = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.xp / xpToNext * 100;
    var overlayBg = "bg-black bg-opacity-70";
    var overlayBorder = "border-gray-500";
    var overlayText = "text-gray-400";
    // Get level-based card colors
    var levelColors = $7ea2865b97769aa3$export$fc83223e1b29d2d5((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.level || 1);
    // Equipped-loadout badge counts (mirror the HP badge on the opposite corner)
    var equippedGearCount = Object.values((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.equippedTechniqueGear || {}).filter(Boolean).length;
    var equippedArtifactCount = Object.values((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.equippedArtifacts || {}).filter(Boolean).length;
    // The 2-column shell + sub-tab bar are static in index.html; render the
    // left card column and the Skills pane into their mounts (Inventory/Gear
    // panes are static and toggled by the sub-tabs).
    if ($7ea2865b97769aa3$var$characterCardCollapsed) {
        // The drawer has no portrait to animate, and nothing else will arrive to
        // displace the running loop — stop it explicitly.
        (0, $a6e2b3e30d0f771b$export$b3f1d493f405542a)();
        document.getElementById("char-card-mount").innerHTML = $7ea2865b97769aa3$var$renderCharacterDrawer({
            faction: faction,
            levelColors: levelColors,
            isReadOnly: isReadOnly,
            hasRaid: hasRaid
        });
    } else // The full card's template keeps its original indentation rather than being
    // shifted one level in — re-flowing 150 untouched lines to satisfy the new
    // brace would bury this change in the diff and blame.
    document.getElementById("char-card-mount").innerHTML = '\n                <div class="character-avatar-section">\n                    <div class="relative bg-gradient-to-b '.concat(levelColors.cardBg, " border-4 ").concat(levelColors.cardBorder, " rounded-xl shadow-lg ").concat((0, $ee71dfe8b201c427$export$25d1e5af45c35a33)() ? "h-[480px]" : "h-[450px]", ' w-60 overflow-hidden">\n                        <!-- Card Border Frame -->\n                        <div class="absolute inset-1 border-2 ').concat(levelColors.frameBorder, ' rounded-lg"></div>\n\n                        <!-- Header Banner -->\n                        <div class="relative ').concat(isReadOnly ? "bg-gradient-to-r from-yellow-600 to-orange-600 border-b-2 border-transparent" : "bg-gradient-to-r ".concat(levelColors.headerBg, " border-b-2 ").concat(levelColors.headerBorder), ' text-gray-100 px-1 py-1 text-left h-8 flex items-center justify-between">\n                            <div class="flex items-center gap-1 min-w-0">\n                                <button id="toggle-character-card-btn" onclick="toggleCharacterCard()"\n                                    title="Collapse to a drawer" aria-expanded="true"\n                                    class="w-12 h-6 flex items-center justify-center rounded bg-black/40 border border-gray-600 text-gray-300 hover:text-white hover:border-gray-400 text-sm leading-none">\u25C2</button>\n                                <span class="text-s font-bold text-black truncate">').concat(isReadOnly ? "On Marketplace" : "", '</span>\n                            </div>\n                            <div class="bg-black bg-opacity-30 border border-black rounded-full w-6 h-6 flex items-center justify-center text-sm" title="').concat(faction.name, '">').concat(faction.icon || "\uD83C\uDFE2", '</div>\n                        </div>\n\n                        <!-- Card Content -->\n                        <div class="relative p-3 bg-gradient-to-b ').concat(levelColors.cardBg, '" style="height: calc(100% - 33px);">\n                            <!-- Title Section with Rename Button -->\n                            <div class="h-4 flex items-center">\n                                <h4 class="font-bold text-white text-base leading-tight">\n                                    ').concat((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.name, "\n                                </h4>\n                                ").concat(!isReadOnly ? '\n                                <button id="rename-character-btn" class="px-1 transition-colors text-sm '.concat(raidRunning ? "text-gray-500 opacity-40 cursor-not-allowed" : "text-purple-300 hover:text-purple-100 cursor-pointer", '" title="').concat(raidRunning ? "Can't edit during a raid" : "Edit Character", '" ').concat(raidRunning ? "disabled" : "", ">\n                                    \u270F\uFE0F\n                                </button>\n                                ") : "", '\n                            </div>\n\n                            <div class="h-4 mb-2">\n                                <h3 class="font-italic text-gray-400 text-xs leading-tight">\n                                    ').concat((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.title ? (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.title : "", '\n                                </h3>\n                            </div>\n\n                            <!-- Avatar Area -->\n                            <div class="relative bg-gradient-to-b from-gray-800 to-gray-900 border-2 border-gray-500 rounded-lg h-[200px] w-full mb-3 overflow-hidden group cursor-pointer">\n                                <!-- Avatar -->\n                                <div class="absolute inset-0 flex items-center justify-center">\n                                    <div class="contractor-avatar-placeholder transform group-hover:scale-110 transition-transform duration-200" data-avatar-main="1" ').concat((0, $ca7af38ea7b7b4a8$export$f06085c61225102a)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character), "></div>\n                                </div>\n                                <!-- Change Avatar Button -->\n                                ").concat(!isReadOnly ? '\n                                <button id="change-avatar-btn" class="absolute top-1 right-1 p-1 rounded text-xs transition-all duration-200 '.concat(raidRunning ? "bg-black bg-opacity-40 text-gray-400 cursor-not-allowed" : "bg-black bg-opacity-70 hover:bg-opacity-90 hover:scale-110 text-white", '" title="').concat(raidRunning ? "Can't edit during a raid" : "Edit avatar", '" ').concat(raidRunning ? "disabled" : "", ">\n                                    \u270F\uFE0F\n                                </button>\n                                ") : "", '\n                                <!-- HP Status (like contractor cards) -->\n                                <div class="absolute bottom-1 left-1 bg-black bg-opacity-70 text-white px-2 py-1 rounded text-xs border border-gray-700">\n                                    \u2764\uFE0F').concat(Math.floor((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.currentHp), '\n                                </div>\n\n                                <!-- Equipped loadout badges (opposite the HP badge): skill gear then artifacts -->\n                                <div class="absolute bottom-1 right-1 flex gap-1">\n                                    <div class="bg-black bg-opacity-70 text-white px-2 py-1 rounded text-xs border border-gray-700" title="Equipped skill gear">\uD83E\uDDF0').concat(equippedGearCount, '</div>\n                                    <div class="bg-black bg-opacity-70 text-white px-2 py-1 rounded text-xs border border-gray-700" title="Equipped artifacts">\uD83D\uDD2E').concat(equippedArtifactCount, '</div>\n                                </div>\n\n                                <!-- Quote Overlay at Bottom (hidden by default, shown on hover) -->\n                                <div class="').concat((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.quote ? "" : "hidden", " absolute bottom-0 left-0 right-0 ").concat(overlayBg, " p-2 border-t ").concat(overlayBorder, ' transform translate-y-full group-hover:translate-y-0 transition-transform duration-200 z-10">\n                                    <p class="').concat(overlayText, ' text-xs leading-tight">').concat((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.quote ? (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.quote : "", '</p>\n                                </div>\n                            </div>\n\n                            <!-- Character Info Section (Level and XP only) -->\n                            <div class="mt-2 text-xs space-y-3 mb-3 bg-gradient-to-b from-gray-800 to-gray-900 border-2 border-gray-500 rounded-lg p-2">\n                                <div class="text-center space-y-3">\n                                    <div class="text-blue-300 font-semibold text-base/4">Level ').concat((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.level, '</div>\n                                    <div class="bg-gray-700 rounded-lg h-5 overflow-hidden relative">\n                                        <div class="bg-gradient-to-r from-blue-500 to-blue-400 h-full transition-all duration-300" style="width: ').concat(xpPercentage, '%;"></div>\n                                        <div class="absolute inset-0 flex items-center justify-center text-white text-xs font-semibold">\n                                            ').concat((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.xp, "/").concat(xpToNext, '\n                                        </div>\n                                    </div>\n                                    <div class="text-xs text-gray-400 text-center" title="What the next level-up grants">\n                                        Next Lvl: <span class="text-game-success font-semibold">+').concat(function() {
        var cfg = $979b99378be707cd$export$9f9786ac427715c7.skillPointsPerLevel;
        var nextLevel = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.level + 1;
        return cfg.base + Math.floor(nextLevel / cfg.levelDivisor) * cfg.increment;
    }(), ' SP</span> \xb7 <span class="text-red-300 font-semibold tracking-tighter">+').concat((0, $df8a44d92d572a5c$export$d48d36379ada8c46)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.level + 1), " HP</span>\n                                    </div>\n                                    ").concat((0, $ee71dfe8b201c427$export$25d1e5af45c35a33)() ? '<div class="text-xs font-semibold" style="color:#b18cff" title="Command Marks if promoted now">\uD83C\uDF96\uFE0F Command value: '.concat((0, $ee71dfe8b201c427$export$ffae5de2f7ddd94d)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character).total, "</div>") : "", '\n                                </div>\n                            </div>\n\n                            <!-- Action Buttons -->\n                            <div class="mt-2 flex justify-between">\n                                <button id="delete-character-btn" class="bg-red-600 hover:bg-red-700 text-white px-2 py-1 rounded text-xs font-bold transition-all duration-200 ').concat(isReadOnly ? "opacity-50 cursor-not-allowed" : "", '" title="').concat(isReadOnly ? "Cannot delete - character on marketplace" : "Delete Character", '" ').concat(isReadOnly ? "disabled" : "", ">\n                                    \uD83D\uDDD1\uFE0F\n                                </button>\n                                ").concat((0, $ee71dfe8b201c427$export$25d1e5af45c35a33)() ? '<button id="promote-character-btn" onclick="openPromoteModal()" class="px-2 py-1 rounded text-xs font-bold transition-all duration-200 hover:shadow-lg" style="border:1.5px solid #6d4fa3; background: #6d4fa3; color:#b18cff;" title="Promote to Command">\n                                    \uD83C\uDF96\uFE0F\n                                </button>' : "", '\n                                <button id="contract-out-btn" ').concat(hasRaid ? "disabled" : "", ' class="').concat((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.isMarketplace ? "bg-orange-600 hover:bg-orange-700" : "bg-yellow-600 hover:bg-yellow-700", ' text-white px-2 py-1 rounded text-xs font-bold transition-all duration-200" title="').concat((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.isMarketplace ? "Withdraw from Marketplace" : "Contract Out to Marketplace", '">\n                                    ').concat((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.isMarketplace ? "\uD83D\uDCE4" : "\uD83D\uDCBC", '\n                                </button>\n                            </div>\n\n                        </div>\n                    </div>\n\n                    <!-- Equipment Section (Under Character Card) -->\n                    <div class="character-equipment-section bg-white/5 border-4 border-gray-600 hidden">\n                        <div class="equipment-slots flex flex-col gap-4">\n                            <!-- Skill Enhancement Slot -->\n                            <div class="equipment-slot-wrapper flex flex-col items-center">\n                                ').concat((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.equippedArtifacts.skillSlot ? (0, $a575049a7e5cb3a1$export$4ac7f915da1fa1c4)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.equippedArtifacts.skillSlot) : '<div class="empty-slot bg-amber-800/20 border-2 border-dashed border-amber-600 rounded-xl h-[180px] w-[160px] flex items-center justify-center text-gray-400 text-sm text-center">No skill artifact equipped</div>', '\n                            </div>\n\n                            <!-- Utility Enhancement Slot -->\n                            <div class="equipment-slot-wrapper flex flex-col items-center">\n                                ').concat((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.equippedArtifacts.utilitySlot ? (0, $a575049a7e5cb3a1$export$4ac7f915da1fa1c4)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.equippedArtifacts.utilitySlot) : '<div class="empty-slot bg-amber-800/20 border-2 border-dashed border-amber-600 rounded-xl h-[180px] w-[160px] flex items-center justify-center text-gray-400 text-sm text-center">No utility artifact equipped</div>', "\n                            </div>\n                        </div>\n                    </div>\n                </div>\n        ");
    document.getElementById("char-skills-pane").innerHTML = '\n                <div class="min-h-[415px] bg-white/5 border-4 border-white/20 rounded-lg rounded-tl-none p-2">\n                    <div class="flex items-start">\n                        <div class="text-lg font-semibold text-white mr-2 flex-grow">Faction Skills: '.concat(faction.name, " ").concat(faction.icon, '</div>\n                        <div class="bg-amber-500 text-black text-sm px-3 py-1 rounded font-bold place-content-end">\n                            ').concat((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.skillPoints, ' Points Available\n                        </div>\n                    </div>\n                    \n                    <div class="text-gray-300 text-sm mt-2">').concat(faction.description, "</div>\n                    ").concat(faction.doctrine ? '<div class="text-gray-400 text-sm italic mt-1 hidden">'.concat(faction.doctrine, "</div>") : "", '\n\n                    <div class="skills-container mt-2">\n                        ').concat((0, $e8f8e272b259f38e$export$313de1df173ff894)($7ea2865b97769aa3$var$SKILL_TAB_GROUP, (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.faction), '\n                        <div id="skills-grid" class="pr-4">\n                            ').concat(skillsHtml, '\n                        </div>\n                    </div>\n                </div>\n\n        <div id="avatar-selector" class="modal hidden">\n            <div class="modal-content max-w-4xl w-full max-h-[80vh] flex flex-col">\n                <div class="modal-header">\n                    <h3 class="modal-title">Choose Your Avatar</h3>\n                    <button id="close-avatar-selector" class="close-btn">&times;</button>\n                </div>\n                <div class="avatar-tabs">\n                    <button class="avatar-tab active" data-avatar-tab="gallery">Gallery</button>\n                    <button class="avatar-tab" data-avatar-tab="custom">Custom</button>\n                </div>\n                <div class="modal-body flex-1 overflow-hidden flex flex-col">\n                    <div id="avatar-pane-gallery" class="avatar-pane active">\n                        <div class="avatar-gallery-toolbar">\n                            <button id="avatar-gallery-refresh" class="ac-btn ac-btn-inline">\uD83C\uDFB2 New Set</button>\n                        </div>\n                        <div id="avatar-gallery-grid" class="avatar-modal-grid grid grid-cols-6 gap-1 p-2">\n                            ').concat($7ea2865b97769aa3$export$aee20503c4a7fb32(), '\n                        </div>\n                    </div>\n                    <div id="avatar-pane-custom" class="avatar-pane avatar-creator">\n                        <div class="ac-preview">\n                            <canvas id="avatar-creator-canvas" width="64" height="64"></canvas>\n                            <button id="avatar-creator-random" class="ac-btn">\uD83C\uDFB2 Randomize</button>\n                            <button id="avatar-creator-apply" class="ac-btn ac-btn-primary">\u2714 Use Avatar</button>\n                        </div>\n                        <div id="avatar-creator-controls" class="ac-controls"></div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    ');
    // Show the active sub-tab pane (Skills / Inventory / Gear) after re-render
    $7ea2865b97769aa3$export$c5004add704e7ef5();
    // Add event listeners for avatar selection
    $7ea2865b97769aa3$export$a2a7c3306a075a0b();
    $7ea2865b97769aa3$export$c83a71e532b8348d();
    // Add event listener for craft artifacts button
    var craftBtn = document.getElementById("craft-artifacts-btn");
    if (craftBtn) craftBtn.addEventListener("click", (0, $83869d722e7ea000$export$bdea6cc9473d0c95));
    // Add event listener for delete character button
    var deleteBtn = document.getElementById("delete-character-btn");
    if (deleteBtn) deleteBtn.addEventListener("click", $7ea2865b97769aa3$export$dfde25eb05d7b32e);
    // Add event listener for contract out button
    var contractOutBtn = document.getElementById("contract-out-btn");
    if (contractOutBtn) contractOutBtn.addEventListener("click", function() {
        if (!(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character || !(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).activeCharacterId) {
            (0, $b5bda7fdec806d8b$export$c7def531c087da85)("No active character selected", "error");
            return;
        }
        if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.isMarketplace) {
            // Withdraw from marketplace
            $7ea2865b97769aa3$export$100975602c9e0e5c((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).activeCharacterId);
            return;
        }
        // Cannot contract out character who owns an active raid
        if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidOwnerId === (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).activeCharacterId && ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress || (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidCompleted || (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid)) {
            (0, $b5bda7fdec806d8b$export$c7def531c087da85)("Cannot contract out character who has an active raid", "error");
            return;
        }
        $7ea2865b97769aa3$export$f02502e440424b7();
    });
}
function $7ea2865b97769aa3$export$44472cbca86113a6() {
    var btn = document.getElementById("create-character");
    var nameInput = document.getElementById("character-name-create");
    var validationMessage = document.getElementById("name-validation-message");
    // Check if faction is selected
    var hasFaction = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).selectedFaction;
    // Check if name is valid
    var hasValidName = nameInput && nameInput.value.trim().length >= 2;
    // Check if name validation passed (no error message showing)
    var nameValidationPassed = validationMessage && (validationMessage.classList.contains("hidden") || validationMessage.classList.contains("text-game-success"));
    btn.disabled = !hasFaction || !hasValidName || !nameValidationPassed;
}
function $7ea2865b97769aa3$export$c05f4d64df5567a5(characterData) {
    // Generate unique character ID
    var characterId = "char_".concat(Date.now(), "_").concat(Math.random().toString(36).substr(2, 9));
    var newCharacter = {
        id: characterId,
        name: characterData.name,
        faction: characterData.faction,
        skills: characterData.skills || {},
        skillPoints: characterData.skillPoints || 3,
        maxHp: characterData.maxHp || 100,
        currentHp: characterData.currentHp || 100,
        level: characterData.level || 1,
        xp: characterData.xp || 0,
        avatar: characterData.avatar,
        avatarSeed: characterData.avatarSeed || characterId,
        title: characterData.title || null,
        quote: characterData.quote || null,
        multiplayerId: characterData.multiplayerId || null,
        ownerToken: characterData.ownerToken || null,
        createdAt: Date.now(),
        isMarketplace: false,
        marketplaceData: null,
        inventory: {},
        artifacts: [],
        equippedArtifacts: {
            skillSlot: null,
            utilitySlot: null
        },
        equippedTechniqueGear: {},
        techniqueTabSelections: {},
        lifetime: {
            t3Wins: 0,
            artifactsCrafted: 0,
            artifactsUnlocked: 0
        }
    };
    // Command layer perks for the new recruit
    var startLevel = (0, $ee71dfe8b201c427$export$59fca837549bbada)("officer-academy", 0);
    if (startLevel > 1) {
        (0, $df8a44d92d572a5c$export$8ae8375981be11e0)(newCharacter, startLevel);
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)("\uD83C\uDFDB\uFE0F Officer Academy: ".concat(newCharacter.name, " starts at level ").concat(newCharacter.level), "success");
    }
    var conditioning = (0, $ee71dfe8b201c427$export$59fca837549bbada)("field-conditioning", 0);
    if (conditioning > 0) {
        newCharacter.maxHp += conditioning;
        newCharacter.currentHp += conditioning;
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)("\uD83E\uDE7A Field Conditioning: ".concat(newCharacter.name, " starts with +").concat(conditioning, " max HP"), "success");
    }
    var vaultGranted = (0, $ee71dfe8b201c427$export$b80ce5f774104e94)(newCharacter);
    var vaultKinds = Object.keys(vaultGranted).length;
    if (vaultKinds > 0) (0, $b5bda7fdec806d8b$export$c7def531c087da85)("\uD83C\uDFE6 Guild Vault: ".concat(vaultKinds, " material type").concat(vaultKinds === 1 ? "" : "s", " delivered from the last tour"), "success");
    // Add to characters array
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).characters.push(newCharacter);
    // Always set newly created character as active
    $7ea2865b97769aa3$export$48d701fa895cfc6a(characterId);
    return newCharacter;
}
function $7ea2865b97769aa3$export$dfde25eb05d7b32e() {
    var confirmDelete = confirm("\u26A0\uFE0F DELETE CHARACTER \u26A0\uFE0F\n\nThis will permanently delete your character and reset ALL progress including:\n\u2022 Character level and skills\n\u2022 All inventory items and credits\n\u2022 Raid progress and contractors\n\u2022 Equipped artifacts and technique gear\n\nThis action CANNOT be undone!\n\nType 'DELETE' to confirm:");
    if (confirmDelete) {
        var finalConfirm = prompt("Type 'DELETE' to permanently delete your character:");
        if (finalConfirm === "DELETE") $7ea2865b97769aa3$export$47ba525aee3af84();
        else (0, $b5bda7fdec806d8b$export$c7def531c087da85)("Character deletion cancelled", "info");
    }
}
function $7ea2865b97769aa3$export$47ba525aee3af84() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var characterId, character, index, availableChars;
        var _arguments = arguments;
        return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
            characterId = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).activeCharacterId;
            character = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).characters.find(function(c) {
                return c.id === characterId;
            });
            if (!character) {
                console.error("Character not found:", characterId);
                return [
                    2,
                    false
                ];
            }
            // Cannot delete character who owns an active raid
            if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidOwnerId === characterId && ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid != null || (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress || (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidCompleted)) {
                (0, $b5bda7fdec806d8b$export$c7def531c087da85)("Cannot delete ".concat(character.name, " - they have an active raid in progress"), "error");
                return [
                    2,
                    false
                ];
            }
            // Remove from marketplace first if needed
            if (character.isMarketplace) $7ea2865b97769aa3$export$62a9da74d0d7be4c(characterId);
            // Remove from multiplayer if applicable
            if (character.multiplayerId) (0, $fde0976ce5d1665d$export$e4477200b6413a70).deleteOwnCharacter(character.multiplayerId);
            // Remove from characters array
            index = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).characters.findIndex(function(c) {
                return c.id === characterId;
            });
            (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "Deleting character:", characterId, character.name, index);
            if (index !== -1) (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).characters.splice(index, 1);
            // Clear all character-related game state
            (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character = null;
            (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).selectedFaction = null;
            // Credits are shared between all characters - don't reset.
            // The contractor POOL is account-level too (NPCs with negative ids, shared by
            // every character), so deleting one character must not wipe it. It used to,
            // which left the account unable to hire for the rest of the session — and made
            // Foreman's Ledger report "No suitable contractors available for this route",
            // reading as a broken upgrade rather than an empty pool. It only looked benign
            // because a reload regenerates the pool.
            // The hired/reserved lists ARE raid-scoped and do belong to the deleted
            // character's run, so those are still cleared.
            (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.hiredContractors = [];
            (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.reservedContractors = [];
            // Clear any active raids
            /*
    gameState.currentRaid.raidInProgress = null;
    gameState.currentRaid.raidCompleted = false;
    gameState.currentRaid.currentRaidGrid = null;
    gameState.currentRaid.selectedPath = [];
    gameState.currentRaid.selectedRegion = null;
    gameState.currentRaid.selectedTier = null;
    gameState.currentRaid.raidOwnerId = null;
    gameState.currentRaid.completedRaidInfo = null;
    */ // Reset energy
            //gameState.energy = 100;
            //gameState.maxEnergy = 100;
            // Refresh Alpine store since we cleared inventory and artifacts
            if (window.refreshAlpineInventory) window.refreshAlpineInventory();
            // Save the reset state
            (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
            // Hide any active raid interface
            document.getElementById("raid-grid-section").classList.add("hidden");
            document.getElementById("raid-team").classList.add("hidden");
            document.getElementById("raid-setup").classList.remove("hidden");
            document.getElementById("raid-active").classList.add("hidden");
            // Reset UI
            (0, $59924438766e7d8e$export$d1c957a54f7124bc)();
            $7ea2865b97769aa3$export$35bc0bfc04b8de17();
            // Update tab visibility
            (0, $59924438766e7d8e$export$2ae62d947e9e1d03)();
            // If this was the active character, switch to another one
            if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).activeCharacterId === characterId) {
                availableChars = $7ea2865b97769aa3$export$c0bcfd3a15876767();
                if (availableChars.length > 0) $7ea2865b97769aa3$export$48d701fa895cfc6a(availableChars[0].id);
                else {
                    // Show character creator
                    document.getElementById("character-creator").classList.remove("hidden");
                    document.getElementById("character-display").classList.add("hidden");
                    $7ea2865b97769aa3$export$6d94845491c8110f();
                }
            }
            (0, $b5bda7fdec806d8b$export$c7def531c087da85)("\uD83D\uDD25 Character deleted!", "success");
            return [
                2,
                true
            ];
        });
    }).apply(this, arguments);
}
function $7ea2865b97769aa3$export$6d5555e9c1c275b6() {
    var availableChars = $7ea2865b97769aa3$export$c0bcfd3a15876767();
    if (availableChars.length > 0) $7ea2865b97769aa3$export$48d701fa895cfc6a(availableChars[0].id);
    else {
        document.getElementById("character-creator").classList.remove("hidden");
        document.getElementById("character-display").classList.add("hidden");
        $7ea2865b97769aa3$export$6d94845491c8110f();
        (0, $59924438766e7d8e$export$ac9b2c0e374abc75)();
    }
    (0, $59924438766e7d8e$export$d1c957a54f7124bc)();
    (0, $59924438766e7d8e$export$2ae62d947e9e1d03)();
    // Land the player on the character tab (creator or roster)
    var characterTabBtn = document.querySelector('[data-tab="character"]');
    if (characterTabBtn && !characterTabBtn.classList.contains("active")) characterTabBtn.click();
}
if (typeof window !== "undefined") window.showCharacterScreenAfterPromotion = $7ea2865b97769aa3$export$6d5555e9c1c275b6;
function $7ea2865b97769aa3$export$6d94845491c8110f() {
    // Clear character name input
    var nameInput = document.getElementById("character-name-create");
    (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "Resetting character creation form, name input:", nameInput);
    if (nameInput) nameInput.value = "";
    // Clear validation message
    var validationMessage = document.getElementById("name-validation-message");
    (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "Resetting character creation validation message:", validationMessage);
    if (validationMessage) {
        validationMessage.textContent = "";
        validationMessage.className = "mt-2 text-sm";
    }
    // Reset selected faction
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).selectedFaction = null;
    // Remove selected class from all faction cards
    document.querySelectorAll(".faction-card").forEach(function(card) {
        card.classList.remove("selected");
        card.classList.add("border-gray-600");
    });
    // Clear skills display
    var skillsSection = document.getElementById("skills-section");
    if (skillsSection) skillsSection.innerHTML = "";
    // Reset header background
    (0, $59924438766e7d8e$export$ffc032d1101a5382)(null);
    // Update faction availability based on existing characters
    (0, $59924438766e7d8e$export$ac9b2c0e374abc75)();
    // Update create button state
    $7ea2865b97769aa3$export$44472cbca86113a6();
}
function $7ea2865b97769aa3$export$48d701fa895cfc6a(characterId) {
    var character = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).characters.find(function(c) {
        return c.id === characterId;
    });
    (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "Switching to character:", characterId, character);
    if (!character) {
        console.error("Character not found:", characterId);
        return false;
    }
    (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "checking raid status:", (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidOwnerId, (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress, (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidCompleted);
    // Check if there's an active raid that belongs to a different character
    if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidOwnerId && (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidOwnerId !== characterId && ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress || (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidCompleted)) {
        var raidOwner = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).characters.find(function(c) {
            return c.id === (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidOwnerId;
        });
        var ownerName = raidOwner ? raidOwner.name : "another character";
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)("Cannot switch characters during ".concat(ownerName, "'s active raid"), "error");
        return false;
    }
    (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "saving current character state if needed");
    // Save current character state if switching from another character
    if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character && (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.id !== characterId) {
        var currentCharIndex = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).characters.findIndex(function(c) {
            return c.id === (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.id;
        });
        if (currentCharIndex !== -1) (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).characters[currentCharIndex] = (0, $fa9769297b8a68c8$export$71511d61b312f219)({}, (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character);
    }
    if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character && (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.faction) document.body.classList.remove((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.faction);
    (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "switching to new character state");
    // Switch to new character - ensure inventory exists
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character = (0, $715bf31211e65705$export$71511d61b312f219)((0, $fa9769297b8a68c8$export$71511d61b312f219)({}, character), {
        inventory: character.inventory || {},
        artifacts: character.artifacts || [],
        equippedArtifacts: character.equippedArtifacts || {
            skillSlot: null,
            utilitySlot: null
        },
        equippedTechniqueGear: character.equippedTechniqueGear || {},
        techniqueTabSelections: character.techniqueTabSelections || {},
        isAlive: character.isAlive == null ? true : character.isAlive,
        injuries: character.injuries || []
    });
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).activeCharacterId = characterId;
    (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "Updating UI for new character");
    if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character && (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.faction) document.body.classList.add((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.faction);
    // Update UI first
    (0, $59924438766e7d8e$export$d1c957a54f7124bc)();
    $7ea2865b97769aa3$export$2eced2100c12c50d();
    // Update tab visibility based on raid ownership
    (0, $59924438766e7d8e$export$2ae62d947e9e1d03)();
    // Refresh Alpine inventory store to reflect character-specific inventory after UI update
    setTimeout(function() {
        (0, $80ed874fd909c4ae$export$5b73e6a29e58b929)();
    }, 100);
    // Update inventory header with character name
    (0, $a575049a7e5cb3a1$export$d2567add70135c10)();
    // Save the game state to persist the character switch
    (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
    //addNotification(`Switched to ${character.name}`, 'success');
    return true;
}
function $7ea2865b97769aa3$export$c0bcfd3a15876767() {
    return (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).characters.filter(function(c) {
        return !c.isMarketplace;
    });
}
function $7ea2865b97769aa3$export$134d34ec75ad4a97() {
    return (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).characters.filter(function(c) {
        return c.isMarketplace;
    });
}
function $7ea2865b97769aa3$export$2a6225ba23811f91(characterId) {
    var durationHours = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 24, rewardPercentage = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 15;
    // If this is the active character, use gameState.character, otherwise lookup by characterId
    var character = characterId === (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).activeCharacterId && (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character ? (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character : (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).characters.find(function(c) {
        return c.id === characterId;
    });
    if (!character) {
        console.error("Character not found:", characterId);
        return false;
    }
    // Register with multiplayer marketplace if character has multiplayerId
    (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "Listing character on marketplace:", character.name, character.multiplayerId, typeof (0, $fde0976ce5d1665d$export$e4477200b6413a70) === "undefined" ? "undefined" : (0, $1968e3edfc5cfc11$export$71511d61b312f219)((0, $fde0976ce5d1665d$export$e4477200b6413a70)));
    if (character.multiplayerId && typeof (0, $fde0976ce5d1665d$export$e4477200b6413a70) !== "undefined") (0, $fde0976ce5d1665d$export$e4477200b6413a70).listCharacterOnMarketplace(character.multiplayerId, durationHours, rewardPercentage).then(function() {
        // Mark character as on marketplace
        character.isMarketplace = true;
        character.rewardPercentage = rewardPercentage;
        character.marketplaceData = {
            listedAt: Date.now(),
            expiresAt: Date.now() + durationHours * 3600000,
            durationHours: durationHours,
            rewardPercentage: rewardPercentage
        };
        (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)("".concat(character.name, " is now available for hire on the marketplace"), "success");
        $7ea2865b97769aa3$export$2eced2100c12c50d(); // Refresh character display
    }).catch(function(error) {
        console.error("Failed to list character on marketplace:", error);
        // Revert local changes if multiplayer fails
        character.isMarketplace = false;
        character.marketplaceData = null;
        (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)("Failed to list character on marketplace", "error");
    });
    else (0, $b5bda7fdec806d8b$export$c7def531c087da85)("".concat(character.name, " is cannot be listed for hire on the marketplace"), "error");
    return true;
}
function $7ea2865b97769aa3$export$f02502e440424b7() {
    var modal = document.createElement("div");
    modal.className = "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50";
    modal.innerHTML = '\n        <div class="bg-gray-800 border border-gray-600 rounded-lg p-6 max-w-md w-full mx-4">\n            <h3 class="text-xl font-bold text-game-accent mb-4">\uD83D\uDCBC Contract Out Character</h3>\n            <p class="text-gray-300 mb-4">\n                Contract out <span class="text-white font-bold">'.concat((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.name, '</span> to the marketplace?\n                They will be available for other players to hire as contractors.\n            </p>\n            <div class="mb-4">\n                <label class="block text-sm font-bold text-gray-300 mb-2">Duration:</label>\n                <select id="contract-duration" class="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded text-white">\n                    <option value="4">4 hours</option>\n                    <option value="8">8 hours</option>\n                    <option value="12">12 hours</option>\n                    <option value="24" selected>24 hours</option>\n                </select>\n                <p class="text-xs text-gray-400 mt-1">Contracts are for long absences \u2014 even un-hired, a completed contract pays out.</p>\n            </div>\n            <div class="mb-4">\n                <label class="block text-sm font-bold text-gray-300 mb-2">Reward Percentage:</label>\n                <div class="flex items-center space-x-2">\n                    <input id="contract-percentage" type="number" min="10" max="20" value="15" class="w-20 px-3 py-2 bg-gray-700 border border-gray-600 rounded text-white text-center">\n                    <span class="text-gray-300">% of raid rewards</span>\n                </div>\n                <p class="text-xs text-gray-400 mt-1">Set the percentage of raid earnings you\'ll receive (10-20%)</p>\n            </div>\n            <div class="flex space-x-3">\n                <button id="confirm-contract-out" class="flex-1 bg-yellow-600 hover:bg-yellow-700 text-white font-bold py-2 px-4 rounded">\n                    Contract Out\n                </button>\n                <button id="cancel-contract-out" class="flex-1 bg-gray-600 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded">\n                    Cancel\n                </button>\n            </div>\n        </div>\n    ');
    document.body.appendChild(modal);
    document.getElementById("confirm-contract-out").addEventListener("click", function() {
        var duration = parseInt(document.getElementById("contract-duration").value);
        var percentage = parseInt(document.getElementById("contract-percentage").value);
        // Validate percentage range
        if (percentage < 10 || percentage > 20) {
            (0, $b5bda7fdec806d8b$export$c7def531c087da85)("Reward percentage must be between 10% and 20%", "error");
            return;
        }
        if ($7ea2865b97769aa3$export$2a6225ba23811f91((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).activeCharacterId, duration, percentage)) $7ea2865b97769aa3$export$d87722dc17dc5f68();
        document.body.removeChild(modal);
    });
    document.getElementById("cancel-contract-out").addEventListener("click", function() {
        document.body.removeChild(modal);
    });
}
function $7ea2865b97769aa3$export$62a9da74d0d7be4c(characterId) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var character, error;
        return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    // Writes must go to the active character's live copy (see liveCharacter).
                    character = (0, $fe47a452a83d9e00$export$bda034a0354b67bb)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).characters.find(function(c) {
                        return c.id === characterId;
                    }));
                    if (!character) {
                        console.error("Character not found:", characterId);
                        return [
                            2,
                            false
                        ];
                    }
                    if (!(character.multiplayerId && typeof (0, $fde0976ce5d1665d$export$e4477200b6413a70) !== "undefined")) return [
                        3,
                        5
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0, $fde0976ce5d1665d$export$e4477200b6413a70).removeCharacterFromMarketplace(character.multiplayerId)
                    ];
                case 2:
                    _state.sent();
                    // Only update local state after successful server response
                    character.isMarketplace = false;
                    character.marketplaceData = null;
                    (0, $b5bda7fdec806d8b$export$c7def531c087da85)("".concat(character.name, " removed from marketplace"), "success");
                    $7ea2865b97769aa3$export$2eced2100c12c50d(); // Refresh character display
                    return [
                        2,
                        true
                    ];
                case 3:
                    error = _state.sent();
                    console.error("Failed to remove character from marketplace:", error);
                    (0, $b5bda7fdec806d8b$export$c7def531c087da85)("Failed to withdraw character from marketplace", "error");
                    return [
                        2,
                        false
                    ];
                case 4:
                    return [
                        3,
                        6
                    ];
                case 5:
                    // For offline mode, update local state directly
                    character.isMarketplace = false;
                    character.marketplaceData = null;
                    (0, $b5bda7fdec806d8b$export$c7def531c087da85)("".concat(character.name, " removed from marketplace"), "success");
                    $7ea2865b97769aa3$export$2eced2100c12c50d(); // Refresh character display
                    return [
                        2,
                        true
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    })();
}
function $7ea2865b97769aa3$export$655e187f5421a72c(param) {
    var title = param.title, bodyHtml = param.bodyHtml, _param_confirmText = param.confirmText, confirmText = _param_confirmText === void 0 ? "Confirm" : _param_confirmText, _param_cancelText = param.cancelText, cancelText = _param_cancelText === void 0 ? "Cancel" : _param_cancelText, _param_confirmClass = param.confirmClass, confirmClass = _param_confirmClass === void 0 ? "bg-yellow-600 hover:bg-yellow-700" : _param_confirmClass, onConfirm = param.onConfirm;
    var modal = document.createElement("div");
    modal.className = "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50";
    modal.innerHTML = '\n        <div class="bg-gray-800 border border-gray-600 rounded-lg p-6 max-w-md w-full mx-4">\n            <h3 class="text-xl font-bold text-game-accent mb-4">'.concat(title, '</h3>\n            <div class="text-gray-300 mb-4">').concat(bodyHtml, '</div>\n            <div class="flex space-x-3">\n                <button data-role="confirm" class="flex-1 ').concat(confirmClass, ' text-white font-bold py-2 px-4 rounded">').concat(confirmText, '</button>\n                <button data-role="cancel" class="flex-1 bg-gray-600 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded">').concat(cancelText, "</button>\n            </div>\n        </div>\n    ");
    document.body.appendChild(modal);
    var close = function() {
        if (modal.parentNode) modal.parentNode.removeChild(modal);
    };
    modal.querySelector('[data-role="confirm"]').addEventListener("click", function() {
        close();
        if (onConfirm) onConfirm();
    });
    modal.querySelector('[data-role="cancel"]').addEventListener("click", close);
}
function $7ea2865b97769aa3$export$100975602c9e0e5c(characterId) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var _character_marketplaceData, _character_marketplaceData1, character, ok, listedAt, elapsedHours, estimate, listedFor, bodyHtml;
        return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    // Active-character-aware: its live marketplaceData lives on gameState.character.
                    character = (0, $fe47a452a83d9e00$export$bda034a0354b67bb)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).characters.find(function(c) {
                        return c.id === characterId;
                    }));
                    if (!character) {
                        console.error("Character not found:", characterId);
                        return [
                            2,
                            false
                        ];
                    }
                    if (!character.isMarketplace) {
                        (0, $b5bda7fdec806d8b$export$c7def531c087da85)("Character is not on the marketplace", "error");
                        return [
                            2,
                            false
                        ];
                    }
                    if (!!character.multiplayerId) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        $7ea2865b97769aa3$export$62a9da74d0d7be4c(characterId)
                    ];
                case 1:
                    ok = _state.sent();
                    if (ok) {
                        $7ea2865b97769aa3$export$2eced2100c12c50d();
                        $7ea2865b97769aa3$export$d87722dc17dc5f68();
                        (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
                    }
                    return [
                        2,
                        ok
                    ];
                case 2:
                    // Server-listed contract: withdrawing settles it for the time actually listed,
                    // so confirm first and show what that settlement is worth. The estimate uses
                    // the same shared model the server settles with (raidEconomics-core), so the
                    // preview and the payout agree. It assumes the character wasn't hired — if it
                    // was, the real hire payment already covered it and the server pays nothing.
                    listedAt = (_character_marketplaceData = character.marketplaceData) === null || _character_marketplaceData === void 0 ? void 0 : _character_marketplaceData.listedAt;
                    elapsedHours = listedAt ? (Date.now() - listedAt) / 3600000 : 0;
                    estimate = (0, $7b2bbc8bf6b24d6d$export$8859df5e0e511018)({
                        level: character.level || 1,
                        durationHours: elapsedHours,
                        rewardPercentage: ((_character_marketplaceData1 = character.marketplaceData) === null || _character_marketplaceData1 === void 0 ? void 0 : _character_marketplaceData1.rewardPercentage) || 15
                    });
                    listedFor = 'Listed for <span class="text-white font-bold">'.concat(elapsedHours.toFixed(1), "h</span>");
                    bodyHtml = estimate.qualifies ? '<p class="mb-2">'.concat(listedFor, '. Withdrawing <span class="text-white font-bold">').concat(character.name, '</span> now settles the contract early.</p>\n       <div class="bg-gray-700/50 border border-gray-600 rounded p-3 mb-2">\n         <div class="text-sm">Estimated settlement:</div>\n         <div class="text-game-accent font-bold">\uD83D\uDCB0 ~').concat(estimate.credits, " credits &nbsp; \u2B50 ~").concat(estimate.xp, ' XP</div>\n         <div class="text-xs text-gray-400 mt-1 hidden">Based on ').concat(estimate.simulatedRaids, " simulated raid").concat(estimate.simulatedRaids === 1 ? "" : "s", '.</div>\n       </div>\n       <p class="text-xs text-gray-400">Leaving the contract to run its full term would pay more.</p>') : '<p class="mb-2">'.concat(listedFor, ' \u2014 under the <span class="text-white font-bold">~').concat((0, $7b2bbc8bf6b24d6d$export$bc8ed87c3bd68f91)(character.level || 1).toFixed(1), 'h</span> needed to earn a contract payout.</p>\n       <p class="text-yellow-400">If ').concat(character.name, ' wasn\'t hired, withdrawing now earns <span class="font-bold">nothing</span>.</p>\n       <p class="text-xs text-gray-400 mt-2">Leaving the contract running pays out even if nobody hires them.</p>');
                    $7ea2865b97769aa3$export$655e187f5421a72c({
                        title: estimate.qualifies ? "\uD83D\uDCBC Withdraw Contract Early?" : "\u26A0\uFE0F Withdraw Without Payout?",
                        bodyHtml: bodyHtml,
                        confirmText: estimate.qualifies ? "Withdraw" : "Withdraw Anyway",
                        confirmClass: estimate.qualifies ? "bg-yellow-600 hover:bg-yellow-700" : "bg-red-600 hover:bg-red-700",
                        onConfirm: function() {
                            $7ea2865b97769aa3$var$performContractWithdrawal(character, characterId).catch(function(err) {
                                return console.error("Failed to withdraw from marketplace:", err);
                            });
                        }
                    });
                    return [
                        2,
                        true
                    ];
            }
        });
    })();
}
// Settle + remove a server-listed contract. Split out of withdrawFromMarketplace
// so the confirm modal drives it.
function $7ea2865b97769aa3$var$performContractWithdrawal(character, characterId) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var settled, err, success;
        return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    // Settle the completion payout for time listed BEFORE removing the row (the
                    // server claim needs the active listing to still exist). The server is
                    // authoritative on the amount and pays nothing if the character was actually
                    // hired or the elapsed time is too short. Best-effort — a settle error must
                    // not block the withdrawal itself.
                    settled = null;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0, $fde0976ce5d1665d$export$e4477200b6413a70).claimContractCompletion(character.multiplayerId)
                    ];
                case 2:
                    settled = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    err = _state.sent();
                    console.error("Failed to settle contract on withdraw:", err);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        4,
                        $7ea2865b97769aa3$export$62a9da74d0d7be4c(characterId)
                    ];
                case 5:
                    success = _state.sent();
                    if (success) {
                        $7ea2865b97769aa3$export$2eced2100c12c50d();
                        $7ea2865b97769aa3$export$d87722dc17dc5f68();
                        (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
                        // Collect the settlement payment through the shared pending-payment flow
                        // (Contract Beacon bonus + "received credits" notification for free).
                        if (settled === null || settled === void 0 ? void 0 : settled.claimed) (0, $59924438766e7d8e$export$da1e47bae24a69b8)().catch(function(err) {
                            return console.error("Error checking payments:", err);
                        });
                    }
                    return [
                        2,
                        success
                    ];
            }
        });
    })();
}
function $7ea2865b97769aa3$export$dc8b5d9ee1e9ba76() {
    var characterSkills = Object.keys((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.skills || {}).filter(function(skill) {
        return (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.skills[skill] > 0;
    });
    var availableOptions = [];
    characterSkills.forEach(function(skill) {
        var flavorData = $979b99378be707cd$export$9be8953559278e7[skill];
        if (flavorData) availableOptions.push({
            skill: skill,
            roles: flavorData.roles,
            quotes: flavorData.quotes
        });
    });
    return availableOptions;
}
function $7ea2865b97769aa3$export$86361bdd2819774e() {
    var _gameState_currentRaid;
    // Editing is locked while a raid is actively running (the button is also
    // disabled, but guard the action too - render timing isn't guaranteed).
    if ((_gameState_currentRaid = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid) === null || _gameState_currentRaid === void 0 ? void 0 : _gameState_currentRaid.raidInProgress) {
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)("Can't edit your character while a raid is in progress", "info");
        return;
    }
    var modal = document.getElementById("rename-character-modal");
    var nameInput = document.getElementById("character-name-input");
    var roleSelect = document.getElementById("character-role-select");
    var quoteSelect = document.getElementById("character-quote-select");
    if (modal && nameInput && roleSelect && quoteSelect) {
        // Set current name in input
        nameInput.value = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.name || "";
        // Populate role and quote dropdowns
        var availableOptions = $7ea2865b97769aa3$export$dc8b5d9ee1e9ba76();
        // Build role options grouped by skill
        roleSelect.innerHTML = '<option value="">Select a role...</option>';
        var allRoles = new Map(); // Map role to skill for quote lookup
        availableOptions.forEach(function(param) {
            var skill = param.skill, roles = param.roles;
            var skillData = $979b99378be707cd$export$aeeef991191508e2[(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.faction].skills[skill];
            var skillName = skillData ? skillData.name : skill;
            roles.forEach(function(role) {
                var option = document.createElement("option");
                option.value = role;
                option.textContent = "".concat(role, " (").concat(skillName, ")");
                option.dataset.skill = skill;
                roleSelect.appendChild(option);
                allRoles.set(role, skill);
            });
        });
        // Set current role if exists
        if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.title) roleSelect.value = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.title;
        // Update quote dropdown when role changes
        var updateQuoteDropdown = function() {
            var selectedRole = roleSelect.value;
            quoteSelect.innerHTML = '<option value="">Select a quote...</option>';
            if (selectedRole) {
                var selectedSkill = allRoles.get(selectedRole);
                var skillData = availableOptions.find(function(opt) {
                    return opt.skill === selectedSkill;
                });
                if (skillData) skillData.quotes.forEach(function(quote) {
                    var option = document.createElement("option");
                    option.value = quote;
                    option.textContent = quote;
                    quoteSelect.appendChild(option);
                });
            }
            // Set current quote if exists
            if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.quote) quoteSelect.value = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.quote;
        };
        // Initial quote population
        updateQuoteDropdown();
        // Update quotes when role changes
        roleSelect.addEventListener("change", updateQuoteDropdown);
        nameInput.focus();
        nameInput.select();
        modal.classList.remove("hidden");
        // Setup event listeners
        $7ea2865b97769aa3$export$c0f3eced6453ae5a();
    }
}
function $7ea2865b97769aa3$export$3898e14ebf764df5() {
    var modal = document.getElementById("rename-character-modal");
    if (modal) modal.classList.add("hidden");
}
function $7ea2865b97769aa3$export$c0f3eced6453ae5a() {
    var modal = document.getElementById("rename-character-modal");
    var nameInput = document.getElementById("character-name-input");
    var confirmBtn = document.getElementById("confirm-rename-btn");
    var cancelBtn = document.getElementById("cancel-rename-btn");
    var closeBtn = document.getElementById("close-rename-modal");
    var validationMessage = document.getElementById("name-validation-message-modal");
    // Remove existing listeners to prevent duplicates
    var newConfirmBtn = confirmBtn.cloneNode(true);
    var newCancelBtn = cancelBtn.cloneNode(true);
    var newCloseBtn = closeBtn.cloneNode(true);
    confirmBtn.parentNode.replaceChild(newConfirmBtn, confirmBtn);
    cancelBtn.parentNode.replaceChild(newCancelBtn, cancelBtn);
    closeBtn.parentNode.replaceChild(newCloseBtn, closeBtn);
    // Real-time validation
    var debouncedValidate = (0, $ca7af38ea7b7b4a8$export$61fc7d43ac8f84b0)(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
            var name, result;
            return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        name = nameInput.value.trim();
                        if (name && name !== (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.name) {
                            validationMessage.className = "text-sm mt-1 text-gray-400";
                            validationMessage.textContent = "Checking name availability...";
                        }
                        return [
                            4,
                            (0, $fde0976ce5d1665d$export$6ebef846cc736ea)(name, (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.name)
                        ];
                    case 1:
                        result = _state.sent();
                        validationMessage.className = "text-sm mt-1 ".concat(result.className);
                        validationMessage.textContent = result.message;
                        return [
                            2
                        ];
                }
            });
        })();
    }, 500);
    nameInput.addEventListener("input", debouncedValidate);
    // Add event listeners
    newConfirmBtn.addEventListener("click", $7ea2865b97769aa3$export$3160d5723a2241f3);
    newCancelBtn.addEventListener("click", $7ea2865b97769aa3$export$3898e14ebf764df5);
    newCloseBtn.addEventListener("click", $7ea2865b97769aa3$export$3898e14ebf764df5);
    // Handle Enter key
    nameInput.addEventListener("keypress", function(e) {
        if (e.key === "Enter") $7ea2865b97769aa3$export$3160d5723a2241f3();
    });
    // Handle Escape key
    document.addEventListener("keydown", function(e) {
        if (e.key === "Escape") {
            var modal = document.getElementById("rename-character-modal");
            if (modal && !modal.classList.contains("hidden")) {
                $7ea2865b97769aa3$export$3898e14ebf764df5();
                document.removeEventListener("keydown", handleEscapeKey);
            }
        }
    });
    // Close on background click (only if mousedown started on background)
    var mousedownTarget = null;
    modal.addEventListener("mousedown", function(e) {
        mousedownTarget = e.target;
    });
    modal.addEventListener("click", function(e) {
        if (e.target === modal && mousedownTarget === modal) $7ea2865b97769aa3$export$3898e14ebf764df5();
    });
}
function $7ea2865b97769aa3$export$3160d5723a2241f3() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var nameInput, roleSelect, quoteSelect, newName, newRole, newQuote, nameChanged, roleChanged, quoteChanged, validation, oldName, oldRole, oldQuote, changes, error;
        return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    nameInput = document.getElementById("character-name-input");
                    roleSelect = document.getElementById("character-role-select");
                    quoteSelect = document.getElementById("character-quote-select");
                    newName = nameInput.value.trim();
                    newRole = roleSelect.value || null;
                    newQuote = quoteSelect.value || null;
                    // Check if anything changed
                    nameChanged = newName !== (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.name;
                    roleChanged = newRole !== (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.title;
                    quoteChanged = newQuote !== (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.quote;
                    if (!nameChanged && !roleChanged && !quoteChanged) {
                        $7ea2865b97769aa3$export$3898e14ebf764df5();
                        return [
                            2
                        ];
                    }
                    if (!nameChanged) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        (0, $fde0976ce5d1665d$export$6ebef846cc736ea)(newName, (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.name)
                    ];
                case 1:
                    validation = _state.sent();
                    if (!validation.valid) {
                        (0, $b5bda7fdec806d8b$export$c7def531c087da85)("\u274C ".concat(validation.message), "error");
                        nameInput.focus();
                        return [
                            2
                        ];
                    }
                    _state.label = 2;
                case 2:
                    oldName = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.name;
                    oldRole = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.title;
                    oldQuote = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.quote;
                    // Update character data
                    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.name = newName;
                    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.title = newRole;
                    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.quote = newQuote;
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        6,
                        ,
                        7
                    ]);
                    if (!(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.multiplayerId) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        (0, $fde0976ce5d1665d$export$e4477200b6413a70).updateCharacter((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.multiplayerId, {
                            name: newName,
                            title: newRole,
                            quote: newQuote
                        })
                    ];
                case 4:
                    _state.sent();
                    _state.label = 5;
                case 5:
                    // Save the game state
                    (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
                    // Update the display
                    $7ea2865b97769aa3$export$2eced2100c12c50d();
                    // Close modal
                    $7ea2865b97769aa3$export$3898e14ebf764df5();
                    // Show success notification
                    changes = [];
                    if (nameChanged) changes.push("name");
                    if (roleChanged) changes.push("role");
                    if (quoteChanged) changes.push("quote");
                    (0, $b5bda7fdec806d8b$export$c7def531c087da85)("\u2705 Character ".concat(changes.join(", "), " updated"), "success");
                    return [
                        3,
                        7
                    ];
                case 6:
                    error = _state.sent();
                    // Rollback changes on error
                    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.name = oldName;
                    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.title = oldRole;
                    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.quote = oldQuote;
                    console.error("Failed to update character in multiplayer system:", error);
                    (0, $b5bda7fdec806d8b$export$c7def531c087da85)("\u274C Failed to update character in multiplayer system", "error");
                    nameInput.focus();
                    return [
                        3,
                        7
                    ];
                case 7:
                    return [
                        2
                    ];
            }
        });
    })();
}
function $7ea2865b97769aa3$export$c83a71e532b8348d() {
    // Setup rename button listener
    document.addEventListener("click", function(e) {
        if (e.target && e.target.id === "rename-character-btn") $7ea2865b97769aa3$export$86361bdd2819774e();
    });
}
function $7ea2865b97769aa3$export$d87722dc17dc5f68() {
    var selectorContainer = document.getElementById("character-selector");
    if (!selectorContainer) return;
    selectorContainer.innerHTML = "";
    var maxCharacters = 3;
    var firstEmptySlot = true;
    // Display existing characters
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).characters.forEach(function(char) {
        var isActive = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).activeCharacterId === char.id;
        var character = isActive ? (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character : char;
        var isMarketplace = character.isMarketplace;
        var hasRaid = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidOwnerId == char.id;
        var cardDiv = document.createElement("div");
        cardDiv.className = "character-selector-card min-w-64 max-w-80 min-h-16 p-2 py-1 rounded-tr-lg rounded-tl-lg transition-all border-2 border-b-0 ".concat(isActive ? "border-transparent bg-white/[0.09]" : "border-transparent bg-gray-800/30");
        var faction = $979b99378be707cd$export$aeeef991191508e2[character.faction];
        var raidStatus = hasRaid ? '<div class="text-amber-400 text-sm font-bold">In Raid</div>' : "";
        var marketplaceStatus = "";
        if (isMarketplace && character.marketplaceData) {
            var timeLeftMs = Math.max(0, character.marketplaceData.expiresAt - Date.now());
            var hours = Math.floor(timeLeftMs / 3600000);
            var minutes = String(Math.ceil(timeLeftMs / 60000) - hours * 60).padStart(2, '0');
            marketplaceStatus = '<div class="text-sm hidden [@media(min-height:769px)]:inline-block"><span class="text-yellow-600 font-bold">\uD83D\uDCBC Marketplace</span> <span id="'.concat(char.id, '_marketplace_time" class="text-gray-400 mr-2">').concat(hours, ":").concat(minutes, "</span></div>");
        }
        var xpToNext = (0, $df8a44d92d572a5c$export$ae545994cbde97ee)(character.level || 1);
        var xpPercentage = (character.xp || 0) / xpToNext * 100;
        cardDiv.innerHTML = '\n            <div class="flex items-start justify-between h-full">\n                <div class="flex gap-2 flex-1 h-full">\n                    <!-- Avatar with proper background container -->\n                    <div class="'.concat(!isActive ? "opacity-40" : "", ' relative bg-gradient-to-b from-gray-800 to-gray-900 border-2 border-gray-500 rounded-lg w-24 overflow-hidden group flex-shrink-0 h-24 hidden [@media(min-height:769px)]:block">\n                        <div class="absolute inset-0 flex items-center justify-center">\n                            <div class="contractor-avatar-placeholder transform group-hover:scale-110 transition-transform duration-200" ').concat((0, $ca7af38ea7b7b4a8$export$f06085c61225102a)(character), '></div>\n                        </div>\n                        <div class="absolute left-1 top-1 bg-black bg-opacity-30 border border-gray-500 rounded-full w-6 h-6 flex items-center justify-center text-sm cursor-pointer" title="').concat(faction.name, '">').concat(faction.icon || "\uD83C\uDFE2", '</div>\n                        <!-- HP Status overlay -->\n                        <div class="absolute bottom-0 left-0 bg-black bg-opacity-70 text-white p-[2px] rounded-tl text-xs m-[1px]">\n                            \u2764\uFE0F').concat(character.currentHp, '\n                        </div>\n                    </div>\n                    <div class="flex-grow relative pr-2 h-full">\n                        <div class="flex items-center gap-2 pb-2 font-bold ').concat(isActive ? "text-white" : "text-white/50", ' nowrap">\n                          <div class="bg-black bg-opacity-30 border border-gray-500 rounded-full w-6 h-6 flex items-center justify-center text-sm cursor-pointer block [@media(min-height:769px)]:hidden" title="').concat(faction.name, '">').concat(faction.icon || "\uD83C\uDFE2", "</div>\n                          ").concat(character.name, '\n                          <div class="').concat(isActive ? "text-blue-300" : "text-blue-300/50", ' text-sm font-semibold nowrap block [@media(min-height:769px)]:hidden">Lv.').concat(character.level || 1, '</div>\n                        </div>\n                        <div class="').concat(isActive ? "text-blue-300" : "text-blue-300/50", ' text-sm font-semibold nowrap hidden [@media(min-height:769px)]:block">Level ').concat(character.level || 1, '</div>\n                        <div class="hidden bg-gray-700 rounded-lg h-4 overflow-hidden relative w-full">\n                            <div class="bg-gradient-to-r from-blue-500 to-blue-400 h-full transition-all duration-300" style="width: ').concat(xpPercentage, '%;"></div>\n                            <div class="absolute inset-0 flex items-center justify-center text-white text-xs font-semibold">\n                                ').concat(character.xp || 0, "/").concat(xpToNext, "\n                            </div>\n                        </div>\n                        ").concat(marketplaceStatus, "\n                        ").concat(raidStatus, '\n                        <div class="absolute bottom-0 right-0 z-10">\n                        ').concat(isActive ? '\n                            <div class="bg-amber-500 text-black hover:text-gray text-xs px-3 py-1 rounded font-bold">\n                                Active\n                            </div>\n                        ' : '\n                            <button class="switch-character-btn text-black hover:text-gray text-xs px-3 py-1 rounded font-bold" data-character-id="'.concat(character.id, '">\n                                Switch\n                            </button>\n                        '), "\n                        </div>\n                    </div>\n                </div>\n            </div>\n        ");
        // Add switch button event listener
        if (!isActive) setTimeout(function() {
            var switchBtn = cardDiv.querySelector(".switch-character-btn");
            if (switchBtn) switchBtn.addEventListener("click", function() {
                $7ea2865b97769aa3$export$48d701fa895cfc6a(character.id);
                $7ea2865b97769aa3$export$d87722dc17dc5f68();
            });
        }, 0);
        selectorContainer.appendChild(cardDiv);
    });
    // Add placeholder cards for empty slots
    var emptySlots = maxCharacters - (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).characters.length;
    for(var i = 0; i < emptySlots; i++){
        var cardDiv = document.createElement("div");
        cardDiv.className = "character-selector-card min-w-64 max-w-80 p-2 border-2 border-b-0 border-dashed border-gray-600 bg-gray-800/30 rounded-t-lg";
        cardDiv.innerHTML = '\n            <div class="flex items-end gap-3 h-full">\n                <!-- Empty avatar placeholder -->\n                <div class="relative bg-gradient-to-b from-gray-800 to-gray-900 border-2 border-gray-500 border-dashed rounded-lg h-24 w-24 overflow-hidden group flex-shrink-0 hidden [@media(min-height:769px)]:block">\n                    <div class="absolute inset-0 flex items-center justify-center">\n                        <div class="contractor-avatar-placeholder transform group-hover:scale-110 transition-transform duration-200"></div>\n                    </div>\n                </div>\n                '.concat(firstEmptySlot ? '\n                    <div class="flex-grow flex flex-col items-end justify-end">\n                        <button id="create-character-slot-btn" class="bg-blue-400 hover:bg-blue-300 text-black hover:text-gray text-xs px-3 py-1 rounded font-bold">\n                            Create Character\n                        </button>\n                    </div>\n                ' : "", "\n            </div>\n        ");
        selectorContainer.appendChild(cardDiv);
        if (firstEmptySlot) {
            firstEmptySlot = false;
            // Add event listener to the button
            setTimeout(function() {
                var createBtn = document.getElementById("create-character-slot-btn");
                if (createBtn) createBtn.addEventListener("click", function() {
                    document.getElementById("character-display").classList.add("hidden");
                    document.getElementById("character-creator").classList.remove("hidden");
                    var cancelBtn = document.getElementById("cancel-character-creation");
                    if (cancelBtn) cancelBtn.classList.remove("hidden");
                });
            }, 0);
        }
    }
}
function $7ea2865b97769aa3$export$b87cdb7b62197ecc() {
    // Create new character button
    var createNewCharBtn = document.getElementById("create-new-character-btn");
    (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "Setting up create new character button:", createNewCharBtn);
    if (createNewCharBtn) createNewCharBtn.addEventListener("click", function() {
        // Reset character creation form (includes updateFactionAvailability)
        $7ea2865b97769aa3$export$6d94845491c8110f();
        // Show character creator
        document.getElementById("character-display").classList.add("hidden");
        document.getElementById("character-creator").classList.remove("hidden");
        // Show cancel button if there's an active character
        $7ea2865b97769aa3$export$3e71199c94c9c7bc();
    });
    // Cancel character creation button
    var cancelBtn = document.getElementById("cancel-character-creation");
    if (cancelBtn) cancelBtn.addEventListener("click", function() {
        // Return to character display
        document.getElementById("character-creator").classList.add("hidden");
        (0, $59924438766e7d8e$export$ffc032d1101a5382)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.faction);
        document.getElementById("character-display").classList.remove("hidden");
    });
}
function $7ea2865b97769aa3$export$3e71199c94c9c7bc() {
    var cancelBtn = document.getElementById("cancel-character-creation");
    (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "cancel button", cancelBtn);
    if (cancelBtn) {
        if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character && (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).characters.length > 0) cancelBtn.classList.remove("hidden");
        else cancelBtn.classList.add("hidden");
    }
}













/**
 * Blackout Contracts UI (M3 S6) — the browser wrapper over blackout-core.js.
 *
 * Two surfaces, split the way the spec describes: contracts are ARMED from the
 * raid planner (L1), and the catalog of what has been earned lives on the
 * Syndicate screen (L3). That is the "layers reach into lower layers" rule from
 * LayerNavigation.md — an L3 feature putting a control on an L1 screen — and it
 * is why arming does not live on the Syndicate page where it would be three
 * navigations away from the raid it modifies.
 *
 * All rules live in blackout-core.js; this file renders and reports.
 */ 



var $0fcd42b930415164$var$NIGHT = '#8b7fd4';
var $0fcd42b930415164$var$NIGHT_DIM = '#4a4270';
var $0fcd42b930415164$var$BLOCKED_COPY = {
    'tier-too-low': function(c) {
        return "Tier ".concat(c.minTier, "+");
    },
    'already-cleared': function() {
        return "\u2713 Cleared";
    },
    'no-sanction': function() {
        return 'Unlicensed';
    }
};
function $0fcd42b930415164$export$c7f6a5a323f54379() {
    var _gameState_currentRaid, _gameState_currentRaid1;
    var container = document.getElementById('blackout-strip');
    if (!container) return;
    if (!(0, $686e361e5cd4549d$export$6030630ca4e35487)()) {
        container.classList.add('hidden');
        container.innerHTML = '';
        return;
    }
    container.classList.remove('hidden');
    var tier = ((_gameState_currentRaid = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid) === null || _gameState_currentRaid === void 0 ? void 0 : _gameState_currentRaid.selectedTier) || 0;
    var armed = (0, $686e361e5cd4549d$export$f266a4caac7fb67d)();
    // Arming is a SETUP decision — see setBlackoutContract, which refuses
    // mid-raid because the modifiers shape how the raid was assembled.
    var locked = !!((_gameState_currentRaid1 = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid) === null || _gameState_currentRaid1 === void 0 ? void 0 : _gameState_currentRaid1.raidInProgress);
    var cards = (0, $686e361e5cd4549d$export$6f07b662ae575a0e)().map(function(id) {
        var _BLOCKED_COPY_reason;
        var c = (0, $686e361e5cd4549d$export$913dd38406a903a1)(id);
        var reason = (0, $686e361e5cd4549d$export$f099249c2cd16830)(id, tier);
        var cleared = (0, $686e361e5cd4549d$export$e51189576207fce1)(id);
        var isArmed = (armed === null || armed === void 0 ? void 0 : armed.id) === id;
        var selectable = !reason && !locked;
        return '\n            <button type="button" '.concat(selectable ? "onclick=\"armBlackout('".concat(isArmed ? '' : id, "')\"") : 'disabled', '\n                class="text-left rounded-lg px-2 py-1.5 border-2 ').concat(selectable ? '' : 'opacity-60 cursor-not-allowed', '"\n                title="').concat(c.description).concat(cleared ? " \u2014 already cleared" : '', '"\n                style="border-color:').concat(isArmed ? $0fcd42b930415164$var$NIGHT : $0fcd42b930415164$var$NIGHT_DIM, "; background:").concat(isArmed ? 'rgba(139,127,212,0.18)' : 'rgba(255,255,255,0.04)', '">\n                <div class="flex items-baseline justify-between gap-2">\n                    <span class="font-bold text-xs" style="color:').concat(isArmed ? $0fcd42b930415164$var$NIGHT : '#c9c2ee', '">').concat(c.icon, " ").concat(c.name, "</span>\n                    ").concat(reason ? '<span class="text-[10px] '.concat(cleared ? 'text-emerald-400' : 'text-gray-400', '">').concat(((_BLOCKED_COPY_reason = $0fcd42b930415164$var$BLOCKED_COPY[reason]) === null || _BLOCKED_COPY_reason === void 0 ? void 0 : _BLOCKED_COPY_reason.call($0fcd42b930415164$var$BLOCKED_COPY, c)) || '', "</span>") : '', '\n                </div>\n                <div class="text-[10px] text-gray-400 leading-tight">').concat(c.perk.label, "</div>\n            </button>");
    }).join('');
    container.innerHTML = '\n        <div class="rounded-lg p-2" style="background:rgba(139,127,212,0.07); border:2px solid '.concat($0fcd42b930415164$var$NIGHT_DIM, ';">\n            <div class="flex items-baseline justify-between gap-2 mb-1.5">\n                <div class="text-[11px] uppercase tracking-widest" style="color:').concat($0fcd42b930415164$var$NIGHT, '">\uD83C\uDF11 Blackout Contract</div>\n                <div class="text-xs text-gray-400">\n                    ').concat(armed ? '<span style="color:'.concat($0fcd42b930415164$var$NIGHT, '">').concat(armed.icon, " ").concat(armed.name, "</span> armed \u2014 ").concat(armed.description) : 'Optional. Harder raid, one permanent perk. Click to arm.', '\n                </div>\n            </div>\n            <div class="grid gap-1.5" style="grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));">').concat(cards, "</div>\n        </div>");
}
function $0fcd42b930415164$export$38182372ac9340fd(contractId) {
    var result = (0, $686e361e5cd4549d$export$d1bd52becfd6c270)(contractId || null);
    if (!result.ok) {
        var copy = {
            'raid-in-progress': 'Cannot change contract mid-raid.',
            'tier-too-low': 'That contract needs a higher tier.',
            'already-cleared': "Already cleared \u2014 its perk is permanent.",
            'no-sanction': 'Sign the Blackout Sanction charter first.'
        };
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)(copy[result.reason] || 'Cannot arm that contract', 'error');
        return;
    }
    if (result.contract) (0, $b5bda7fdec806d8b$export$c7def531c087da85)("\uD83C\uDF11 ".concat(result.contract.name, " armed \u2014 ").concat(result.contract.description), 'warning');
    (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
    $0fcd42b930415164$export$c7f6a5a323f54379();
}
function $0fcd42b930415164$export$736506b4b237950c() {
    var container = document.getElementById('syndicate-blackout');
    if (!container) return;
    if (!(0, $686e361e5cd4549d$export$6030630ca4e35487)()) {
        container.innerHTML = '<div class="text-sm text-gray-400">Sign the Blackout Sanction charter to take on contracts.</div>';
        return;
    }
    container.innerHTML = (0, $686e361e5cd4549d$export$6f07b662ae575a0e)().map(function(id) {
        var c = (0, $686e361e5cd4549d$export$913dd38406a903a1)(id);
        var cleared = (0, $686e361e5cd4549d$export$e51189576207fce1)(id);
        return '\n            <div class="rounded-lg p-3" style="background:rgba(139,127,212,'.concat(cleared ? '0.12' : '0.05', "); border:2px solid ").concat(cleared ? $0fcd42b930415164$var$NIGHT : $0fcd42b930415164$var$NIGHT_DIM, ';">\n                <div class="flex items-baseline justify-between gap-2">\n                    <span class="font-bold text-sm" style="color:').concat($0fcd42b930415164$var$NIGHT, '">').concat(c.icon, " ").concat(c.name, '</span>\n                    <span class="text-xs ').concat(cleared ? 'text-emerald-400' : 'text-gray-400', '">').concat(cleared ? "\u2713 Cleared" : "Tier ".concat(c.minTier, "+"), '</span>\n                </div>\n                <div class="text-xs text-gray-400 italic leading-snug mt-0.5">').concat(c.flavor, '</div>\n                <div class="text-xs text-gray-300 leading-snug mt-1">').concat(c.description, '</div>\n                <div class="text-xs mt-1.5 font-bold" style="color:').concat(cleared ? '#7df5a0' : $0fcd42b930415164$var$NIGHT, '">').concat(cleared ? "\u2713 " : "\uD83C\uDF81 ").concat(c.perk.label, "</div>\n            </div>");
    }).join('');
}
if (typeof window !== 'undefined') window.armBlackout = $0fcd42b930415164$export$38182372ac9340fd;


/**
 * Region skill fit — "how will this region go for me, at this tier?"
 *
 * The raid planner used to answer this with a three-column wall of every skill
 * in the region, its level band, a tick, and a success percentage. Accurate, and
 * far too tall: on a 768px iPad viewport it pushed the region tiles and the
 * Generate button below the fold. The detail is still the right answer once a
 * player is CHOOSING A PATH — it just is not the right answer while they are
 * choosing a region, where the only question is "can I handle this place?"
 *
 * So this collapses the same inputs to one verdict per region, and the tiles
 * carry a single glyph.
 *
 * Headless and separate from the renderer on purpose: the thresholds ARE the
 * design, and burying them in a template string is how they end up disagreeing
 * with the detailed view that uses the same numbers.
 */ 






/**
 * Rooms a path visits, matching the income model in
 * `tools/loot-equilibrium.mjs` and `demand-core.js`. Hazards outnumber gates
 * 2:1, so a region's difficulty is set more by its hazards — weighting them
 * evenly would flatter a region with brutal hazards behind easy gates.
 */ var $407c40db325c5c12$var$GATES_PER_RAID = 2;
var $407c40db325c5c12$var$HAZARDS_PER_RAID = 4;
var $407c40db325c5c12$export$5380658a718e0007 = 0.75;
var $407c40db325c5c12$export$899a23df7b7e4a64 = 0.5;
var $407c40db325c5c12$export$32a3144cd774bde7 = {
    good: {
        glyph: "\u2705",
        label: 'Well matched',
        color: '#4ade80'
    },
    caution: {
        glyph: "\u26A0\uFE0F",
        label: 'Risky',
        color: '#fbbf24'
    },
    poor: {
        glyph: "\u274C",
        label: 'Outmatched',
        color: '#f87171'
    },
    unknown: {
        glyph: '',
        label: '',
        color: '#9ca3af'
    }
};
function $407c40db325c5c12$export$27b46fbd6918ae77(chance) {
    if (chance >= $407c40db325c5c12$export$5380658a718e0007) return 'good';
    if (chance >= $407c40db325c5c12$export$899a23df7b7e4a64) return 'caution';
    return 'poor';
}
/**
 * How the two halves combine.
 *
 * LEVEL DOMINATES, deliberately. An even split lets full coverage floor the
 * score at 0.5, so a character with no skills at all could never read
 * "outmatched" in their own faction's best region — the one place they most
 * need telling. Coverage still ranks regions against each other at any given
 * skill level; it just cannot carry a player who cannot pass their own checks.
 *
 * Provisional, like every other L3 number: S7 calibrates.
 */ var $407c40db325c5c12$var$COVERAGE_WEIGHT = 0.35;
var $407c40db325c5c12$var$LEVEL_WEIGHT = 0.65;
function $407c40db325c5c12$export$a07bea37865125aa(regionKey, faction) {
    var _config_raidRegions;
    var region = (_config_raidRegions = $979b99378be707cd$export$4fbdcec70fce9d73) === null || _config_raidRegions === void 0 ? void 0 : _config_raidRegions[regionKey];
    if (!region || !faction) return 0;
    var own = 0, total = 0;
    for(var _i = 0, _iter = [
        [
            region.gates || [],
            $407c40db325c5c12$var$GATES_PER_RAID
        ],
        [
            region.hazards || [],
            $407c40db325c5c12$var$HAZARDS_PER_RAID
        ]
    ]; _i < _iter.length; _i++){
        var _iter__i = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_iter[_i], 2), list = _iter__i[0], perRaid = _iter__i[1];
        var primaries = list.filter(function(room) {
            return room.primary;
        });
        if (!primaries.length) continue;
        var perRoom = perRaid / primaries.length;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = primaries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var room = _step.value;
                if ((0, $ca7af38ea7b7b4a8$export$a3603dda04ca8111)(room.primary) === faction) own += perRoom;
                total += perRoom;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return total > 0 ? own / total : 0;
}
/**
 * Best coverage any region offers a faction, so coverage is scored against what
 * is ACHIEVABLE rather than against 100%.
 *
 * Regions draw primaries from every faction — the most dominion-heavy region in
 * the game is only half dominion — so a raw coverage term caps every score near
 * 0.5 and "well matched" becomes unreachable. Scored against the faction's own
 * best region instead, the same trick `demand-core` uses for premiums.
 *
 * Pure over static config, so computed once.
 */ var $407c40db325c5c12$var$bestCoverageCache = null;
function $407c40db325c5c12$var$bestCoverageFor(faction) {
    if (!$407c40db325c5c12$var$bestCoverageCache) {
        var _Math;
        $407c40db325c5c12$var$bestCoverageCache = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var f = _step.value;
                $407c40db325c5c12$var$bestCoverageCache[f] = (_Math = Math).max.apply(_Math, [
                    0
                ].concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)(Object.keys($979b99378be707cd$export$4fbdcec70fce9d73 || {}).map(function(r) {
                    return $407c40db325c5c12$export$a07bea37865125aa(r, f);
                }))));
            };
            for(var _iterator = Object.keys($979b99378be707cd$export$aeeef991191508e2 || {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return $407c40db325c5c12$var$bestCoverageCache[faction] || 0;
}
function $407c40db325c5c12$export$92e1965816b22a3d(regionKey, tier) {
    var character = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character;
    var _config_raidRegions, _config_raidTierData;
    var region = (_config_raidRegions = $979b99378be707cd$export$4fbdcec70fce9d73) === null || _config_raidRegions === void 0 ? void 0 : _config_raidRegions[regionKey];
    var tierData = (_config_raidTierData = $979b99378be707cd$export$94e7ad7999c1ae32) === null || _config_raidTierData === void 0 ? void 0 : _config_raidTierData[tier];
    if (!region || !tierData || !(character === null || character === void 0 ? void 0 : character.faction)) return null;
    var ownFaction = character.faction;
    var rooms = [
        {
            list: region.gates || [],
            target: tierData.gateSkillLevel,
            perRaid: $407c40db325c5c12$var$GATES_PER_RAID
        },
        {
            list: region.hazards || [],
            target: tierData.hazardSkillLevel,
            perRaid: $407c40db325c5c12$var$HAZARDS_PER_RAID
        }
    ];
    var ownTotal = 0, ownWeight = 0;
    var weakest = null;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = rooms[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = _step.value, list = _step_value.list, target = _step_value.target, perRaid = _step_value.perRaid;
            var primaries = list.filter(function(room) {
                return room.primary;
            });
            if (!primaries.length) continue;
            var perRoom = perRaid / primaries.length;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = primaries[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var room = _step1.value;
                    var _character_skills;
                    var skillId = room.primary;
                    if ((0, $ca7af38ea7b7b4a8$export$a3603dda04ca8111)(skillId) !== ownFaction) continue; // hired, not judged
                    var level = ((_character_skills = character.skills) === null || _character_skills === void 0 ? void 0 : _character_skills[skillId]) || 0;
                    // An unlearned skill is a genuine zero, not a low roll — the check
                    // cannot be passed on merit at all. Short-circuited rather than run
                    // through the formula, whose lower clamp would flatter it to 20%.
                    var chance = level > 0 ? Math.min(0.97, (0, $52a7294453bdb6d1$export$2ad5af141c2ca6d2)(level, target) + (0, $df8a44d92d572a5c$export$a5a257639bbcfa93)(skillId, character) / 100) : 0;
                    ownTotal += chance * perRoom;
                    ownWeight += perRoom;
                    // Only own-faction skills can be a weakness worth naming: an
                    // off-faction gap is a hiring note, not something to train.
                    if (!weakest || chance < weakest.chance) weakest = {
                        skillId: skillId,
                        chance: chance
                    };
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var coverage = $407c40db325c5c12$export$a07bea37865125aa(regionKey, ownFaction);
    var best = $407c40db325c5c12$var$bestCoverageFor(ownFaction);
    var coverageScore = best > 0 ? Math.min(1, coverage / best) : 0;
    var levelFit = ownWeight > 0 ? ownTotal / ownWeight : 0;
    var score = $407c40db325c5c12$var$COVERAGE_WEIGHT * coverageScore + $407c40db325c5c12$var$LEVEL_WEIGHT * levelFit;
    return {
        score: score,
        verdict: $407c40db325c5c12$export$27b46fbd6918ae77(score),
        coverage: coverage,
        coverageScore: coverageScore,
        levelFit: levelFit,
        weakest: weakest
    };
}



function $59924438766e7d8e$export$ffc032d1101a5382() {
    var faction = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'dominion';
    var header = document.getElementById("game-header");
    if (!header) return;
    // Remove existing faction classes
    header.classList.remove("header-bg-dominion", "header-bg-veil", "header-bg-wilders");
    // Add appropriate faction class
    if (faction) header.classList.add("header-bg-".concat(faction));
    else header.classList.add("header-bg-dominion");
}
function $59924438766e7d8e$export$2ae62d947e9e1d03() {
    (0, $8896b37f0fd85895$export$5672aa0b2d188c2b)();
}
function $59924438766e7d8e$export$d1c957a54f7124bc() {
    // The raid button's label/state used to be computed here from raid state.
    // That logic now lives in the layer registry as Field's activeTask (the same
    // reads, same order), and the toolbar renders it — raiding is Field's task,
    // not a privileged global control. See layers-core.js / layerNav.js.
    //
    // Values, NOT a structural rebuild: updateUI() is on the per-second interval,
    // and forcing a rebuild each tick both wasted the render split and closed the
    // layer panel a second after opening it. refreshToolbarValues() promotes
    // itself to a rebuild only when the task state actually changes.
    (0, $8896b37f0fd85895$export$c6af328ac5cab01b)();
    // Update raid button states when UI updates
    (0, $3f29ea4265abff3b$export$96635d91a6ab659a)();
}
function $59924438766e7d8e$export$ac9b2c0e374abc75() {
    var usedFactions = new Set();
    // Get factions of all existing characters
    (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "Existing characters:", (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).characters);
    if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).characters && (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).characters.length > 0) (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).characters.forEach(function(character) {
        usedFactions.add(character.faction);
    });
    (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "Used factions:", usedFactions);
    // Update faction cards
    document.querySelectorAll(".faction-card").forEach(function(card) {
        var faction = card.dataset.faction;
        if (usedFactions.has(faction)) {
            // Disable this faction
            card.classList.add("faction-disabled", "cursor-not-allowed");
            card.classList.remove("cursor-pointer");
            // Add visual indicator
            if (!card.querySelector(".faction-used-indicator")) {
                var indicator = document.createElement("div");
                indicator.className = "faction-used-indicator text-red-400 text-sm font-bold mt-2";
                indicator.textContent = "\u2713 Already Created";
                card.appendChild(indicator);
            }
        } else {
            // Enable this faction
            card.classList.remove("faction-disabled", "cursor-not-allowed");
            card.classList.add("cursor-pointer");
            // Remove visual indicator
            var indicator1 = card.querySelector(".faction-used-indicator");
            if (indicator1) indicator1.remove();
        }
    });
}
function $59924438766e7d8e$export$6a940d9b4a9b252a() {
    var _config_factionSkills_gameState_character_faction, _gameState_character, _config_factionSkills;
    var regionInfo = document.getElementById("region-info");
    var generateBtn = document.getElementById("generate-grid");
    // The Blackout strip rides this same refresh: its cards are gated by TIER,
    // so it has to repaint whenever the tier changes — and this is the one
    // function every region/tier change already funnels through.
    (0, $0fcd42b930415164$export$c7f6a5a323f54379)();
    // Fit is per region AND tier, so every tile restamps when the tier changes.
    $59924438766e7d8e$export$76e61cb22c961267();
    var regionKey = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedRegion;
    var tier = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedTier;
    if (regionKey == null || tier == null) {
        regionInfo.innerHTML = "Select a region and tier to see details...";
        generateBtn.disabled = true;
        return;
    }
    var region = $979b99378be707cd$export$4fbdcec70fce9d73[regionKey];
    var fit = (0, $407c40db325c5c12$export$92e1965816b22a3d)(regionKey, tier);
    var display = (0, $407c40db325c5c12$export$32a3144cd774bde7)[(fit === null || fit === void 0 ? void 0 : fit.verdict) || 'unknown'];
    var factionName = ((_config_factionSkills = $979b99378be707cd$export$aeeef991191508e2) === null || _config_factionSkills === void 0 ? void 0 : (_config_factionSkills_gameState_character_faction = _config_factionSkills[(_gameState_character = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character) === null || _gameState_character === void 0 ? void 0 : _gameState_character.faction]) === null || _config_factionSkills_gameState_character_faction === void 0 ? void 0 : _config_factionSkills_gameState_character_faction.name) || "your faction";
    // The two inputs, stated separately. The composite is a ranking rather than a
    // probability (see regionFit-core), so printing it as a percentage would be a
    // lie — and the halves are what a player can act on anyway: train a skill, or
    // raid somewhere that uses more of them.
    var weakestName = (fit === null || fit === void 0 ? void 0 : fit.weakest) ? (0, $ca7af38ea7b7b4a8$export$182937d2e68a339)(fit.weakest.skillId) : null;
    regionInfo.innerHTML = '\n        <div class="text-sm flex flex-wrap items-baseline gap-x-2">\n            <span class="font-bold text-white">'.concat(region.icon || "\uD83D\uDDFA\uFE0F", " ").concat(region.name, '</span>\n            <span class="text-gray-400">').concat($979b99378be707cd$export$94e7ad7999c1ae32[tier].name, "</span>\n            ").concat(fit ? '<span class="font-bold" style="color:'.concat(display.color, '">').concat(display.glyph, " ").concat(display.label, '</span>\n                     <span class="text-gray-400">').concat(factionName, " covers ").concat(Math.round(fit.coverage * 100), "% of checks \xb7 you pass ").concat(Math.round(fit.levelFit * 100), "% of those").concat(weakestName ? " \xb7 weakest: ".concat(weakestName, " ").concat(Math.round(fit.weakest.chance * 100), "%") : '', "</span>") : '<span class="text-gray-400">Create a character to see your fit</span>', "\n        </div>");
    generateBtn.disabled = !(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character;
    (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
}
function $59924438766e7d8e$export$76e61cb22c961267() {
    var _gameState_currentRaid;
    var tier = (_gameState_currentRaid = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid) === null || _gameState_currentRaid === void 0 ? void 0 : _gameState_currentRaid.selectedTier;
    document.querySelectorAll("#region-tiles .region-tile").forEach(function(tile) {
        var badge = tile.querySelector(".region-fit-badge");
        if (!badge) return;
        // A locked region's fit is not a fact the player can act on — the lock
        // overlay is the whole answer, and a second verdict beside it just competes
        // with it.
        if (tile.dataset.locked === "true") {
            badge.textContent = "";
            badge.title = "";
            return;
        }
        var fit = tier ? (0, $407c40db325c5c12$export$92e1965816b22a3d)(tile.dataset.region, tier) : null;
        var display = (0, $407c40db325c5c12$export$32a3144cd774bde7)[(fit === null || fit === void 0 ? void 0 : fit.verdict) || 'unknown'];
        badge.textContent = display.glyph;
        badge.title = fit ? "".concat(display.label, " \u2014 your faction covers ").concat(Math.round(fit.coverage * 100), "% of this region's checks, and you pass ").concat(Math.round(fit.levelFit * 100), "% of those at this tier") : "Pick a tier to see how well your skills fit";
    });
}
// Where a region tile's clock is being read: the capital, or the tile a raid
// has actually been sited on.
var $59924438766e7d8e$var$CAPITAL_ICON = "\uD83C\uDFDB\uFE0F";
var $59924438766e7d8e$var$SITE_ICON = "\uD83D\uDCCD";
function $59924438766e7d8e$export$bfd4e77d5f2367cd() {
    var now = Date.now();
    // The site belongs to the GRID — cancelling leaves the field behind (two
    // teardown paths null the grid and neither owns this rule), so the grid is
    // what says whether a site is live. Checking here rather than clearing there
    // is one condition instead of one per teardown path.
    var _ref = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid || {}, selectedRegion = _ref.selectedRegion, raidSite = _ref.raidSite, currentRaidGrid = _ref.currentRaidGrid;
    var liveSite = currentRaidGrid ? raidSite : null;
    document.querySelectorAll("#region-tiles .region-tile").forEach(function(tile) {
        var badge = tile.querySelector(".region-clock-badge");
        if (!badge) return;
        var regionId = tile.dataset.region;
        var sited = liveSite && regionId === selectedRegion;
        var local = sited ? (0, $05f2074f6c82f4e0$export$239629a81011f2a4)(liveSite, now) : (0, $05f2074f6c82f4e0$export$30a7d07879d0db1d)(regionId, now);
        // WHERE the clock is read, before WHAT it reads. Without the place marker
        // the badge silently changes meaning when a raid is sited here — same
        // format, different location — and the time appearing to jump for no
        // reason is exactly what the marker prevents.
        badge.textContent = "".concat(sited ? $59924438766e7d8e$var$SITE_ICON : $59924438766e7d8e$var$CAPITAL_ICON, " ").concat(local.icon, " ").concat(local.time);
        badge.title = sited ? "Local time at your raid site \u2014 ".concat(local.name, ".") : "Local time at the capital \u2014 ".concat(local.name, ". A region spans several hours of longitude, so a raid sited within it can meet a different sun.");
    });
}
function $59924438766e7d8e$export$5d55f9eae051c4dc() {
    var sliderContainer = document.getElementById("tier-slider");
    sliderContainer.innerHTML = "";
    Object.keys($979b99378be707cd$export$94e7ad7999c1ae32).forEach(function(tierKey) {
        var tier = parseInt(tierKey);
        var data = $979b99378be707cd$export$94e7ad7999c1ae32[tier];
        // Extract short name and description from "Tier X - Name" format
        var shortName = data.name.split(" - ")[0] || tier;
        var shortDescription = data.name.split(" - ")[1] || data.name;
        var segment = document.createElement("div");
        segment.className = "tier-segment flex-1 cursor-pointer rounded-lg p-1 text-center font-bold transition-all border-2 border-gray-500 bg-gradient-to-b from-gray-700 to-gray-800 hover:border-gray-400 text-gray-400";
        segment.dataset.tier = tier;
        segment.innerHTML = '\n            <div class="text-sm">'.concat(shortName, '</div>\n            <div class="text-xs">').concat(shortDescription, " - ").concat(data.gridRows, " x ").concat(data.gridCols, " Grid</div>\n        ");
        // Check if this should be selected initially
        if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedTier === tier) segment.classList.add("selected");
        segment.addEventListener("click", function() {
            document.querySelectorAll(".tier-segment").forEach(function(s) {
                return s.classList.remove("selected");
            });
            segment.classList.add("selected");
            (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedTier = tier;
            $59924438766e7d8e$export$6a940d9b4a9b252a();
        });
        sliderContainer.appendChild(segment);
    });
}
function $59924438766e7d8e$export$98a6c6e9bfe86f10() {
    var tilesContainer = document.getElementById("region-tiles");
    tilesContainer.innerHTML = "";
    // Region locks (Command layer): faction starting pair + chartered regions.
    // Grandfathered pre-Command saves see everything.
    var availableRegions = new Set((0, $ee71dfe8b201c427$export$99736e0126d21b50)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character));
    // A locked region can't stay selected (e.g. a fresh character after promotion).
    //
    // ...but only while it's just a menu choice. Once a raid is set up or running,
    // selectedRegion is live state the grid, raid header and room rendering all
    // resolve through (`config.raidRegions[selectedRegion]`), so clearing it breaks
    // the raid in place. That happened on reload — boot calls this unconditionally,
    // unlike the raid-tab handler which skips it during a raid — and on switching
    // to a character whose faction doesn't share the region. The lock's job is to
    // stop you *starting* a raid somewhere locked, not to retroactively break one.
    var raidUsingRegion = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid || (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress || (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidCompleted;
    if (!raidUsingRegion && (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedRegion && !availableRegions.has((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedRegion)) (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedRegion = null;
    Object.keys($979b99378be707cd$export$4fbdcec70fce9d73).forEach(function(regionKey) {
        var region = $979b99378be707cd$export$4fbdcec70fce9d73[regionKey];
        var icon = region.icon || "\uD83D\uDDFA\uFE0F";
        var bgImage = "./images/regions/".concat(regionKey, "/RegionBackground.jpg");
        var locked = !availableRegions.has(regionKey);
        var tile = document.createElement("div");
        tile.className = "region-tile overflow-hidden rounded-lg border-2 transition-all " + (locked ? "relative border-gray-700 cursor-not-allowed" : "cursor-pointer border-gray-600 hover:border-game-accent");
        tile.dataset.region = regionKey;
        tile.dataset.locked = String(locked);
        tile.style.backgroundImage = "url('".concat(bgImage, "')");
        tile.style.backgroundSize = "135% auto";
        tile.style.backgroundPosition = "center";
        tile.style.transition = "background-position 1s ease-out, border-color 0.25s";
        if (locked) tile.style.filter = "grayscale(0.9) brightness(0.7)";
        tile.innerHTML = '\n            <div class="p-4 bg-gradient-to-b from-transparent via-gray-900/40 to-gray-900/90 h-32 flex flex-col justify-end relative">\n                <!-- Skill fit, stamped by refreshRegionFitBadges() rather than\n                     rendered here: it depends on TIER, which changes far more\n                     often than the tile list does. -->\n                <div class="region-fit-badge absolute top-2 right-2 text-lg leading-none drop-shadow"></div>\n                <!-- Local time (M3 S9). Stamped by refreshRegionClocks() on the\n                     tick: this one moves on its own, without anybody clicking. -->\n                <div class="region-clock-badge absolute top-2 left-2"></div>\n                <div class="text-white font-bold">'.concat(icon, " ").concat(region.name, '</div>\n                <div class="text-xs text-gray-400">').concat(region.theme, "</div>\n            </div>\n            ").concat(locked ? '\n            <div class="absolute inset-0 z-10 flex flex-col items-center justify-center gap-1 bg-black/45">\n                <div class="text-2xl">\uD83D\uDD12</div>\n                <div class="text-xs px-2 py-0.5 rounded border" style="color:#b18cff; border-color:#6d4fa3; background:rgba(12,8,20,0.85);">Regional Charter</div>\n            </div>' : "", "\n        ");
        if (locked) {
            // Allocation and licensing, NOT physical reachability (StoryAlignment.md
            // decision 2). The tooltip is the load-bearing half: it is the only place
            // in L1/L2 that can explain why an Operation may cross into a locked
            // region while a raid may not — gates move people, ground moves tonnage.
            tile.title = "Reachable overland \u2014 but your faction holds no gate allocation or charter here.";
            tile.addEventListener("click", function() {
                (0, $b5bda7fdec806d8b$export$c7def531c087da85)("\uD83D\uDD12 No gate allocation here \u2014 your faction's crossings land elsewhere. A Regional Charter rank (Command layer \u2192 Promotion) licenses a region of your choice", "error");
            });
            tilesContainer.appendChild(tile);
            return;
        }
        // Check if this should be selected initially
        if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedRegion === regionKey) tile.classList.add("selected");
        tile.addEventListener("click", function() {
            document.querySelectorAll(".region-tile").forEach(function(t) {
                return t.classList.remove("selected");
            });
            tile.classList.add("selected");
            (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedRegion = regionKey;
            (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
            $59924438766e7d8e$export$6a940d9b4a9b252a();
        });
        // Parallax effect on mouse move
        tile.addEventListener("mousemove", function(e) {
            var rect = tile.getBoundingClientRect();
            var x = (e.clientX - rect.left) / rect.width;
            var y = (e.clientY - rect.top) / rect.height;
            // Background at 180% gives room for movement
            // Invert X for parallax effect (mouse right = image left)
            var maxXOffset = 115;
            var maxYOffset = 32.5;
            var offsetX = 50 - (x - 0.5) * maxXOffset; // Inverted
            var offsetY = 50 + (y - 0.5) * maxYOffset;
            tile.style.backgroundPosition = "".concat(offsetX, "% ").concat(offsetY, "%");
        });
        tile.addEventListener("mouseleave", function() {
            tile.style.backgroundPosition = "center";
        });
        tilesContainer.appendChild(tile);
    });
    // Tiles are freshly built and carry empty badges — stamp them once here so a
    // boot or character switch shows fit and local time without waiting for a
    // tier click or the next tick.
    $59924438766e7d8e$export$76e61cb22c961267();
    $59924438766e7d8e$export$bfd4e77d5f2367cd();
}
function $59924438766e7d8e$export$bb017115af5d1f34() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var chars, changed, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, c, ch, eligible, token, _registered_character, registered, newId, err, err1;
        return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    chars = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).characters || [];
                    changed = false;
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        11,
                        12,
                        13
                    ]);
                    _iterator = chars[Symbol.iterator]();
                    _state.label = 2;
                case 2:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        10
                    ];
                    c = _step.value;
                    // Mutate the authoritative copy (see liveCharacter): writing only to the
                    // roster entry of the active character is clobbered on the next save.
                    // Mirror onto the roster entry so reads before that save agree too.
                    ch = (0, $fe47a452a83d9e00$export$bda034a0354b67bb)(c);
                    if (ch.multiplayerId && ch.ownerToken) return [
                        3,
                        9
                    ]; // already fully onboarded
                    eligible = (ch.level || 1) <= 2 && (Array.isArray(ch.artifacts) ? ch.artifacts.length : 0) === 0 && Object.keys(ch.equippedTechniqueGear || {}).length === 0;
                    if (!eligible) return [
                        3,
                        9
                    ];
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        8,
                        ,
                        9
                    ]);
                    if (!ch.multiplayerId) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        (0, $fde0976ce5d1665d$export$e4477200b6413a70).claimLegacyCharacter(ch.multiplayerId)
                    ];
                case 4:
                    token = _state.sent();
                    if (token) {
                        ch.ownerToken = token;
                        if (ch !== c) c.ownerToken = token;
                        changed = true;
                        console.log("Re-onboarded legacy character ".concat(ch.name));
                    }
                    return [
                        3,
                        7
                    ];
                case 5:
                    return [
                        4,
                        (0, $fde0976ce5d1665d$export$e4477200b6413a70).registerCharacter(ch)
                    ];
                case 6:
                    registered = _state.sent();
                    newId = (registered === null || registered === void 0 ? void 0 : registered.id) || (registered === null || registered === void 0 ? void 0 : (_registered_character = registered.character) === null || _registered_character === void 0 ? void 0 : _registered_character.id) || null;
                    if (newId) {
                        ch.multiplayerId = newId;
                        ch.ownerToken = registered.ownerToken || null;
                        if (ch !== c) {
                            c.multiplayerId = newId;
                            c.ownerToken = ch.ownerToken;
                        }
                        changed = true;
                        console.log("Registered previously-unsynced character ".concat(ch.name));
                    }
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        9
                    ];
                case 8:
                    err = _state.sent();
                    // Offline or name-taken, etc. — leave the character local-only.
                    console.warn("Could not re-onboard character ".concat(ch.name, ":"), err);
                    return [
                        3,
                        9
                    ];
                case 9:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        2
                    ];
                case 10:
                    return [
                        3,
                        13
                    ];
                case 11:
                    err1 = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err1;
                    return [
                        3,
                        13
                    ];
                case 12:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 13:
                    if (changed) (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
                    return [
                        2
                    ];
            }
        });
    })();
}
function $59924438766e7d8e$export$da1e47bae24a69b8() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var chars, totalCredits, totalXP, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, rosterEntry, character, pending, payoutBonus, credits, xp, paymentIds, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, payment, marked, err1, error;
        return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        10,
                        ,
                        11
                    ]);
                    chars = ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).characters || []).filter(function(c) {
                        return c.multiplayerId;
                    });
                    if (chars.length === 0) return [
                        2
                    ];
                    totalCredits = 0;
                    totalXP = 0;
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        7,
                        8,
                        9
                    ]);
                    _iterator = chars[Symbol.iterator]();
                    _state.label = 2;
                case 2:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        6
                    ];
                    rosterEntry = _step.value;
                    // Write (and read artifacts) through the authoritative copy — for the
                    // active character the roster entry is overwritten by
                    // gameState.character on the next save, which silently discarded the
                    // XP awarded below.
                    character = (0, $fe47a452a83d9e00$export$bda034a0354b67bb)(rosterEntry);
                    return [
                        4,
                        (0, $fde0976ce5d1665d$export$e4477200b6413a70).getPendingPayments(rosterEntry.multiplayerId)
                    ];
                case 3:
                    pending = _state.sent();
                    if (!pending || pending.length === 0) return [
                        3,
                        5
                    ];
                    // Contract Beacon on the contracted-out character: +X% on receipt.
                    // The hiring client can't see this character's artifacts and the
                    // server stores amounts verbatim, so the owner's client applies the
                    // bonus when collecting.
                    payoutBonus = 1 + (0, $df8a44d92d572a5c$export$401b195eeeb2d82c)('contractor-payout-bonus', character) / 100;
                    credits = 0;
                    xp = 0;
                    paymentIds = [];
                    _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(_iterator1 = pending[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            payment = _step1.value;
                            credits += Math.floor((payment.amount || 0) * payoutBonus);
                            xp += payment.xp || 0;
                            paymentIds.push(payment.id);
                        }
                    } catch (err1) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err1;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    return [
                        4,
                        (0, $fde0976ce5d1665d$export$e4477200b6413a70).markPaymentsProcessed(rosterEntry.multiplayerId, paymentIds)
                    ];
                case 4:
                    marked = _state.sent();
                    if (!marked) {
                        console.error("Failed to mark payments processed for ".concat(character.name, "; skipping to avoid duplicates"));
                        return [
                            3,
                            5
                        ];
                    }
                    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player.credits += credits; // credits are account-global
                    if (xp > 0) (0, $df8a44d92d572a5c$export$88ec20478ef6bd29)(character, xp); // XP goes to the recipient character
                    totalCredits += credits;
                    totalXP += xp;
                    _state.label = 5;
                case 5:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        2
                    ];
                case 6:
                    return [
                        3,
                        9
                    ];
                case 7:
                    err1 = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err1;
                    return [
                        3,
                        9
                    ];
                case 8:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 9:
                    if (totalCredits > 0 || totalXP > 0) {
                        (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
                        (0, $7ea2865b97769aa3$export$2eced2100c12c50d)(); // refresh the active character's panel if it changed
                        if (totalCredits > 0 && totalXP > 0) (0, $b5bda7fdec806d8b$export$c7def531c087da85)("\uD83D\uDCB0 Received ".concat(totalCredits, " credits and ").concat(totalXP, " XP from contractor payments!"), 'success');
                        else if (totalCredits > 0) (0, $b5bda7fdec806d8b$export$c7def531c087da85)("\uD83D\uDCB0 Received ".concat(totalCredits, " credits from contractor payments!"), 'success');
                        else if (totalXP > 0) (0, $b5bda7fdec806d8b$export$c7def531c087da85)("\u2B50 Received ".concat(totalXP, " XP from contractor payments!"), 'success');
                    }
                    return [
                        3,
                        11
                    ];
                case 10:
                    error = _state.sent();
                    console.error('Failed to check pending payments:', error);
                    return [
                        3,
                        11
                    ];
                case 11:
                    return [
                        2
                    ];
            }
        });
    })();
}
function $59924438766e7d8e$export$162c77cf09613261() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var chars, listings, byCharacterId, changed, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, rosterEntry, ch, listing, settled, fresh, current, stale;
        return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    chars = ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).characters || []).filter(function(c) {
                        return c.multiplayerId;
                    });
                    if (chars.length === 0) return [
                        2
                    ];
                    return [
                        4,
                        (0, $fde0976ce5d1665d$export$e4477200b6413a70).getMyMarketplaceListings(chars.map(function(c) {
                            return c.multiplayerId;
                        }))
                    ];
                case 1:
                    listings = _state.sent();
                    if (!listings) return [
                        2
                    ]; // couldn't reach the server — keep local state as-is
                    byCharacterId = new Map(listings.map(function(l) {
                        return [
                            l.character_id,
                            l
                        ];
                    }));
                    changed = false;
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(_iterator = chars[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            rosterEntry = _step.value;
                            ch = (0, $fe47a452a83d9e00$export$bda034a0354b67bb)(rosterEntry); // writes must hit the live copy
                            listing = byCharacterId.get(rosterEntry.multiplayerId);
                            // A claimed listing is settled: the payout is banked and there is nothing
                            // left for the player to do. The server still returns it (it filters on
                            // is_active, and claiming only flips completion_claimed), so treating it
                            // as live re-created `isMarketplace` with an expiry already in the past —
                            // which the expiry check below then "discovered" and announced again on
                            // every single load. Settled rows take the clearing path instead.
                            settled = listing && listing.completion_claimed === true;
                            if (listing && !settled) {
                                fresh = {
                                    listedAt: new Date(listing.listed_at).getTime(),
                                    expiresAt: new Date(listing.expires_at).getTime(),
                                    durationHours: listing.duration_hours,
                                    rewardPercentage: listing.reward_percentage
                                };
                                current = ch.marketplaceData;
                                stale = !ch.isMarketplace || !current || current.listedAt !== fresh.listedAt || current.expiresAt !== fresh.expiresAt || current.rewardPercentage !== fresh.rewardPercentage;
                                if (stale) {
                                    ch.isMarketplace = true;
                                    ch.marketplaceData = fresh;
                                    if (ch !== rosterEntry) {
                                        rosterEntry.isMarketplace = true;
                                        rosterEntry.marketplaceData = fresh;
                                    }
                                    changed = true;
                                }
                            } else if (ch.isMarketplace) {
                                // Nothing live server-side, so the local flag is stale: either no row
                                // at all (withdrawn elsewhere) or a settled one. Cleared quietly on
                                // purpose — the expiry announcement belongs to the load that actually
                                // did the claiming, not to every load after it.
                                ch.isMarketplace = false;
                                delete ch.marketplaceData;
                                if (ch !== rosterEntry) {
                                    rosterEntry.isMarketplace = false;
                                    delete rosterEntry.marketplaceData;
                                }
                                changed = true;
                            }
                        }
                    } catch (err1) {
                        _didIteratorError = true;
                        _iteratorError = err1;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    if (changed) {
                        (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
                        (0, $7ea2865b97769aa3$export$2eced2100c12c50d)();
                    }
                    return [
                        2
                    ];
            }
        });
    })();
}
// Completion claims in flight, keyed by multiplayerId. Module-level (not a
// character property) so the transient guard is never serialized into the save.
var $59924438766e7d8e$var$pendingCompletionClaims = new Set();
function $59924438766e7d8e$export$9124d6474b00dfc4() {
    // Check for expired marketplace listings
    var hasMarketplaceChars = false;
    var claimPromises = [];
    if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).characters) {
        var now = Date.now();
        (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).characters.forEach(function(c) {
            var _ch_marketplaceData;
            var ch = (0, $fe47a452a83d9e00$export$bda034a0354b67bb)(c); // active character's writes must go here
            if (ch.isMarketplace && ((_ch_marketplaceData = ch.marketplaceData) === null || _ch_marketplaceData === void 0 ? void 0 : _ch_marketplaceData.expiresAt) && ch.marketplaceData.expiresAt < now) {
                if (ch.multiplayerId) // Server-listed: try to claim the un-hired completion payout before
                // dropping local state. Clear only once the server responds (the
                // claim is idempotent server-side); on a network error, leave the
                // flag so the next tick retries.
                {
                    if (!$59924438766e7d8e$var$pendingCompletionClaims.has(ch.multiplayerId)) {
                        $59924438766e7d8e$var$pendingCompletionClaims.add(ch.multiplayerId);
                        var target = ch;
                        claimPromises.push((0, $fde0976ce5d1665d$export$e4477200b6413a70).claimContractCompletion(target.multiplayerId).then(function() {
                            target.isMarketplace = false;
                            delete target.marketplaceData;
                            (0, $b5bda7fdec806d8b$export$c7def531c087da85)("".concat(target.name, "'s marketplace listing expired"), "info");
                            (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
                            (0, $7ea2865b97769aa3$export$2eced2100c12c50d)();
                        }).catch(function(err) {
                            return console.error("Error claiming contract completion:", err);
                        }).finally(function() {
                            return $59924438766e7d8e$var$pendingCompletionClaims.delete(target.multiplayerId);
                        }));
                    }
                } else {
                    // Local-only listing (no server row to claim against).
                    ch.isMarketplace = false;
                    delete ch.marketplaceData;
                    (0, $b5bda7fdec806d8b$export$c7def531c087da85)("".concat(ch.name, "'s marketplace listing expired"), "info");
                }
            } else if (ch.isMarketplace) hasMarketplaceChars = true;
            (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
            (0, $7ea2865b97769aa3$export$2eced2100c12c50d)(); //refresh display for time remaining
        });
    }
    // Check for pending contractor payments
    // Only check for payments if we have marketplace characters that could earn
    if (hasMarketplaceChars && typeof $59924438766e7d8e$export$da1e47bae24a69b8 !== "undefined") $59924438766e7d8e$export$da1e47bae24a69b8().catch(function(err) {
        return console.error("Error checking payments:", err);
    });
    // A resolved completion claim inserts a pending payment server-side; collect
    // it once the claims settle so the payout lands in the same visit.
    if (claimPromises.length > 0 && typeof $59924438766e7d8e$export$da1e47bae24a69b8 !== "undefined") Promise.allSettled(claimPromises).then(function() {
        $59924438766e7d8e$export$da1e47bae24a69b8().catch(function(err) {
            return console.error("Error checking payments:", err);
        });
    });
}
















var $e63b1e314d73680b$export$fa0ee1eb937a38e6 = 10000;
var $e63b1e314d73680b$export$393daff81e921306 = 300000;
function $e63b1e314d73680b$export$64b66d963f6d5043(currentDelay) {
    // Anything missing or below the floor restarts the sequence.
    if (!Number.isFinite(currentDelay) || currentDelay < $e63b1e314d73680b$export$fa0ee1eb937a38e6) return $e63b1e314d73680b$export$fa0ee1eb937a38e6;
    // Once past the cap the cadence has settled — stop doubling.
    if (currentDelay > $e63b1e314d73680b$export$393daff81e921306) return currentDelay;
    return currentDelay * 2;
}
function $e63b1e314d73680b$export$9163caedda99cb08(contractor) {
    var _gameState_currentRaid, _gameState_currentRaid1, _gameState_character, _gameState_character1, _gameState_character2;
    // Progressive disclosure: no synergy indicators before the layer is
    // revealed (character below synergyUnlocks.minLevel)
    if (!(0, $df8a44d92d572a5c$export$aaee02d18e8a1c01)()) return {
        skills: {},
        gearPartners: {},
        hasReady: false,
        hasSwap: false
    };
    var teamTechniques = new Set();
    var addGear = function(c) {
        return Object.keys((c === null || c === void 0 ? void 0 : c.equippedTechniqueGear) || {}).forEach(function(t) {
            return teamTechniques.add(t);
        });
    };
    addGear((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character);
    (((_gameState_currentRaid = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid) === null || _gameState_currentRaid === void 0 ? void 0 : _gameState_currentRaid.reservedContractors) || []).forEach(addGear);
    (((_gameState_currentRaid1 = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid) === null || _gameState_currentRaid1 === void 0 ? void 0 : _gameState_currentRaid1.hiredContractors) || []).forEach(addGear);
    addGear(contractor);
    var playerTechniques = new Set(Object.keys(((_gameState_character = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character) === null || _gameState_character === void 0 ? void 0 : _gameState_character.equippedTechniqueGear) || {}));
    var ownedDevices = Object.entries(((_gameState_character1 = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character) === null || _gameState_character1 === void 0 ? void 0 : _gameState_character1.inventory) || {}).filter(function(param) {
        var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), qty = _param[1];
        return qty > 0;
    }).map(function(param) {
        var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 1), id = _param[0];
        return (0, $ca7af38ea7b7b4a8$export$a2dea178c28a0308)('id', id);
    }).filter(function(item) {
        return (item === null || item === void 0 ? void 0 : item.type) === 'techGear';
    });
    // Either-side unlock rule (mirrors variant selection): a partner technique
    // counts only if the event skill is unlocked, or it is the player's own
    // gear from an unlocked skill
    var partnerAllowed = function(eventSkillId, techniqueId, isPlayerDevice) {
        return (0, $df8a44d92d572a5c$export$7d626adf944498ee)(eventSkillId) || isPlayerDevice && (0, $df8a44d92d572a5c$export$7d626adf944498ee)((0, $ca7af38ea7b7b4a8$export$a6cb179f21ae932e)(techniqueId));
    };
    var skills = {};
    Object.keys((contractor === null || contractor === void 0 ? void 0 : contractor.skills) || {}).forEach(function(skillId) {
        var partners = (0, $52a7294453bdb6d1$export$3a3bfc913ac4efaa)(skillId);
        if (partners.size === 0) return;
        var ready = (0, $4c858c0d999a5b9b$export$71511d61b312f219)(partners).find(function(t) {
            return teamTechniques.has(t) && partnerAllowed(skillId, t, playerTechniques.has(t));
        });
        if (ready) {
            skills[skillId] = {
                state: 'ready',
                techniqueId: ready
            };
            return;
        }
        var swap = ownedDevices.find(function(d) {
            return partners.has(d.techniqueId) && partnerAllowed(skillId, d.techniqueId, true);
        });
        if (swap) skills[skillId] = {
            state: 'swap',
            techniqueId: swap.techniqueId,
            gearName: swap.name,
            gearIcon: swap.icon
        };
    });
    // Reverse direction: contractor gear that upgrades skills the player has
    // (event-side unlock applies - the event is the player's skill)
    var playerSkills = new Set(Object.keys(((_gameState_character2 = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character) === null || _gameState_character2 === void 0 ? void 0 : _gameState_character2.skills) || {}));
    var gearPartners = {};
    Object.keys((contractor === null || contractor === void 0 ? void 0 : contractor.equippedTechniqueGear) || {}).forEach(function(techniqueId) {
        var upgradable = (0, $4c858c0d999a5b9b$export$71511d61b312f219)((0, $52a7294453bdb6d1$export$9f7e6ebcfcd92245)(techniqueId)).filter(function(s) {
            return playerSkills.has(s) && (0, $df8a44d92d572a5c$export$7d626adf944498ee)(s);
        });
        if (upgradable.length > 0) gearPartners[techniqueId] = upgradable;
    });
    var states = Object.values(skills).map(function(s) {
        return s.state;
    });
    return {
        skills: skills,
        gearPartners: gearPartners,
        hasReady: states.includes('ready') || Object.keys(gearPartners).length > 0,
        hasSwap: states.includes('swap')
    };
}
function $e63b1e314d73680b$export$4e2035a3911d8600(factionKey, skills, level) {
    var equipped = {};
    var maxPieces = Math.min(2, Math.floor(level / 4));
    if (maxPieces <= 0) return equipped;
    var capitalized = factionKey.charAt(0).toUpperCase() + factionKey.slice(1);
    var devices = $979b99378be707cd$exports["itemsEpicDevice".concat(capitalized)] || [];
    var techniques = $979b99378be707cd$exports.skillTechniques[factionKey] || [];
    var knownSkills = Object.keys(skills).sort(function() {
        return Math.random() - 0.5;
    }).slice(0, maxPieces);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var skill = _step.value;
            var skillTechniques = techniques.filter(function(t) {
                return t.skill === skill;
            });
            if (skillTechniques.length === 0) return "continue";
            var technique = skillTechniques[Math.floor(Math.random() * skillTechniques.length)];
            var device = devices.find(function(d) {
                return d.techniqueId === technique.id;
            });
            if (device) equipped[technique.id] = device;
        };
        for(var _iterator = knownSkills[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return equipped;
}
function $e63b1e314d73680b$export$9471e02e816b8b11(playerLevel) {
    var newContractors = [];
    var contractorId = -1; // Negative IDs for AI contractors
    var baseSkillMin = Math.max(1, Math.floor(playerLevel / 3));
    var baseSkillMax = Math.max(3, playerLevel + Math.floor(playerLevel / 2));
    var skillRange = baseSkillMax - baseSkillMin;
    Object.keys($979b99378be707cd$exports.factionSkills).forEach(function(factionKey) {
        var _loop = function(i) {
            var _Math;
            // Generate faction-specific name
            var factionNameData = $979b99378be707cd$exports.factionNames[factionKey];
            var firstName = factionNameData.names[Math.floor(Math.random() * factionNameData.names.length)];
            var lastName = factionNameData.surnames[Math.floor(Math.random() * factionNameData.surnames.length)];
            var name = firstName + " " + lastName;
            var skills = {};
            var factionSkills = Object.keys(faction.skills);
            var rewardPercentage = 10;
            // Give each contractor 2-3 random skills from their faction
            var numSkills = 2 + Math.floor(Math.random() * 2);
            for(var j = 0; j < numSkills; j++){
                var skill = factionSkills[Math.floor(Math.random() * factionSkills.length)];
                var addlPoints = Math.round(Math.random() * skillRange);
                skills[skill] = baseSkillMin + addlPoints;
                rewardPercentage += Math.ceil(5 * (addlPoints / skillRange) * (addlPoints / skillRange));
            }
            // Calculate contractor level based on skill levels
            var skillLevels = Object.values(skills);
            var bestSkill = skillLevels.length > 0 ? Object.keys(skills).reduce(function(a, b) {
                return skills[a] > skills[b] ? a : b;
            }) : null;
            var highestSkillLevel = skillLevels.length > 0 ? (_Math = Math).max.apply(_Math, (0, $4c858c0d999a5b9b$export$71511d61b312f219)(skillLevels)) : 0;
            var avgSkillLevel = skillLevels.reduce(function(sum, level) {
                return sum + level;
            }, 0) / skillLevels.length;
            var contractorLevel = Math.max(1, Math.floor(avgSkillLevel / 2) + Math.floor(Math.random() * 3));
            var flavorText = $e63b1e314d73680b$export$ea991b314c8ed75e(bestSkill);
            (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).events, "Generated contractor flavor:", flavorText);
            var contractor = {
                id: -(newContractors.length + 1),
                name: name,
                faction: factionKey,
                skills: skills,
                rewardPercentage: rewardPercentage,
                hired: false,
                avatar: (0, $ca7af38ea7b7b4a8$export$913078032f14f7f)(factionKey),
                // Procedural portrait seed. A fresh persisted token, NOT the `id` above —
                // that id is a reused negative slot index, so seeding from it would make
                // every slot-N contractor share a face. This token is stable once saved.
                avatarSeed: "ctr_".concat(factionKey, "_").concat(Date.now(), "_").concat(Math.random().toString(36).slice(2, 9)),
                level: contractorLevel,
                xp: Math.floor(Math.random() * (0, $df8a44d92d572a5c$export$ae545994cbde97ee)(contractorLevel)),
                // Was `100 + (level-1) * gainAt(level)`, which multiplies the CURRENT
                // level's gain across every level instead of summing each level's own
                // gain - it over-paid increasingly with level (1300 HP at level 25 vs
                // the curve's 840). maxHpForLevel is the one definition of the curve.
                maxHp: (0, $df8a44d92d572a5c$export$266289d5372bee03)(contractorLevel),
                currentHp: null,
                isAlive: true,
                injuries: [],
                title: flavorText ? flavorText.role : "Contractor",
                quote: flavorText ? flavorText.quote : '"Ready for work."'
            };
            // Equipped skill gear: seasoned contractors come tooled up (0-2 pieces
            // by level, one per known skill - same one-per-skill rule as the
            // player). Their gear feeds team synergy variants and success bonuses,
            // making WHO you hire matter beyond raw skill numbers.
            contractor.equippedTechniqueGear = $e63b1e314d73680b$export$4e2035a3911d8600(factionKey, skills, contractorLevel);
            // Set current HP to max HP
            contractor.currentHp = contractor.maxHp;
            newContractors.push(contractor);
        };
        var faction = $979b99378be707cd$exports.factionSkills[factionKey];
        for(var i = 0; i < 5; i++)_loop(i);
    });
    // Preserve hired and reserved contractors by adding them to the new pool
    // Only preserve NPC contractors (negative IDs) - player contractors don't belong in the pool
    var preservedContractors = (0, $4c858c0d999a5b9b$export$71511d61b312f219)(((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.hiredContractors || []).filter(function(c) {
        return c.id < 0;
    })).concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)(((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.reservedContractors || []).filter(function(c) {
        return c.id < 0;
    })));
    if (preservedContractors.length > 0) {
        var preservedIds = new Set(preservedContractors.map(function(c) {
            return c.id;
        }));
        // Remove any generated contractors that have the same ID as preserved ones
        var dedupedNew = newContractors.filter(function(c) {
            return !preservedIds.has(c.id);
        });
        newContractors = (0, $4c858c0d999a5b9b$export$71511d61b312f219)(dedupedNew).concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)(preservedContractors));
    }
    return newContractors;
}
function $e63b1e314d73680b$export$62a89cfab93e40e(contractors, path, characterSkills) {
    if (!contractors || contractors.length === 0 || !path) return [];
    // Extract skills needed from the path
    var pathSkills = new Set();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = path[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var step = _step.value;
            if (step.room && step.room.primary) {
                pathSkills.add(step.room.primary);
                if (step.room.support && Array.isArray(step.room.support)) step.room.support.forEach(function(skill) {
                    return pathSkills.add(skill);
                });
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Helper function to calculate individual contractor score
    function scoreContractor(contractor) {
        var score = 0;
        var contractorSkillIds = Object.keys(contractor.skills || {});
        // Count how many path-required skills this contractor has
        var matchedSkills = contractorSkillIds.filter(function(skill) {
            return pathSkills.has(skill);
        });
        var unmatchedPathSkills = Array.from(pathSkills).filter(function(skill) {
            return !contractorSkillIds.includes(skill) && (characterSkills[skill] || 0) === 0;
        });
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // Score: contractor skills that cover missing path skills are valuable
            for(var _iterator = matchedSkills[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var skill = _step.value;
                var skillLevel = contractor.skills[skill];
                if ((characterSkills[skill] || 0) === 0) // Character doesn't have this skill, contractor fill-in is valuable
                score += 200 + skillLevel * 20;
                else // Character has skill but contractor's level helps
                score += 50 + skillLevel * 10;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        // Penalize contractors with many uncovered path skills
        score -= unmatchedPathSkills.length * 30;
        // Small bonus for higher level contractors
        score += contractor.level * 5;
        return score;
    }
    // Helper function to evaluate pair synergy
    function scorePair(contractor1, contractor2) {
        var skills1 = new Set(Object.keys(contractor1.skills || {}));
        var skills2 = new Set(Object.keys(contractor2.skills || {}));
        var pairScore = scoreContractor(contractor1) + scoreContractor(contractor2);
        // Bonus for complementary skills (skills that only one has)
        var uniqueSkills = new Set((0, $4c858c0d999a5b9b$export$71511d61b312f219)(skills1).concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)(skills2)));
        var sharedSkills = new Set((0, $4c858c0d999a5b9b$export$71511d61b312f219)(skills1).filter(function(s) {
            return skills2.has(s);
        }));
        var complementarySkills = uniqueSkills.size - sharedSkills.size;
        // Reward diversity: contractors with different skills complement each other
        pairScore += complementarySkills * 15;
        // Slight penalty for overlapping skills (unless covering critical gaps)
        pairScore -= sharedSkills.size * 3;
        return pairScore;
    }
    // Find the best pair of contractors
    var bestPair = [];
    var bestScore = -Infinity;
    // Try all possible pairs
    for(var i = 0; i < contractors.length; i++)for(var j = i + 1; j < contractors.length; j++){
        var pairScore = scorePair(contractors[i], contractors[j]);
        if (pairScore > bestScore) {
            bestScore = pairScore;
            bestPair = [
                contractors[i],
                contractors[j]
            ];
        }
    }
    // If no good pair found, also consider single contractors
    if (bestScore <= 0 && contractors.length > 0) {
        var bestSingle = contractors[0];
        var bestSingleScore = scoreContractor(contractors[0]);
        for(var i1 = 1; i1 < contractors.length; i1++){
            var singleScore = scoreContractor(contractors[i1]);
            if (singleScore > bestSingleScore) {
                bestSingleScore = singleScore;
                bestSingle = contractors[i1];
            }
        }
        if (bestSingleScore > 0) return [
            bestSingle
        ];
    }
    return bestScore > 0 ? bestPair : [];
}
function $e63b1e314d73680b$export$ea991b314c8ed75e(bestSkill) {
    var data = $979b99378be707cd$exports.contractorSkillFlavors[bestSkill];
    if (!data) return null;
    var role = data.roles[Math.floor(Math.random() * data.roles.length)];
    var quote = data.quotes[Math.floor(Math.random() * data.quotes.length)];
    return {
        role: role,
        quote: quote
    };
}
function $e63b1e314d73680b$export$b8366d52640d9f9(char, path, contractors) {
    if (!char.equippedTechniqueGear) char.equippedTechniqueGear = {};
    var teamTechniques = new Set(Object.keys(char.equippedTechniqueGear));
    (contractors || []).forEach(function(c) {
        return Object.keys((c === null || c === void 0 ? void 0 : c.equippedTechniqueGear) || {}).forEach(function(t) {
            return teamTechniques.add(t);
        });
    });
    var ownedDevices = Object.entries(char.inventory || {}).filter(function(param) {
        var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), qty = _param[1];
        return qty > 0;
    }).map(function(param) {
        var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 1), id = _param[0];
        return (0, $ca7af38ea7b7b4a8$export$a2dea178c28a0308)('id', id);
    }).filter(function(item) {
        return (item === null || item === void 0 ? void 0 : item.type) === 'techGear' && item.techniqueId;
    });
    if (ownedDevices.length === 0) return 0;
    var routeSkills = new Set();
    (path || []).forEach(function(step) {
        var _step_room;
        if ((_step_room = step.room) === null || _step_room === void 0 ? void 0 : _step_room.primary) routeSkills.add(step.room.primary);
    });
    // Either-side unlock rule, mirroring eventSystem-core's variant selection and
    // contractor-core's partnerAllowed: a partner counts when the EVENT's skill is
    // unlocked, OR when it is the player's own device from an unlocked skill.
    // Only checking the event side made this a no-op - a region's rooms span
    // factions, and a player only ever unlocks synergies on their own faction's
    // skills, so the event-side test almost never passed.
    var partnerAllowed = function(eventSkillId, techniqueId) {
        return (0, $df8a44d92d572a5c$export$7d626adf944498ee)(eventSkillId, char) || (0, $df8a44d92d572a5c$export$7d626adf944498ee)((0, $ca7af38ea7b7b4a8$export$a6cb179f21ae932e)(techniqueId), char);
    };
    var swaps = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var skillId = _step.value;
            var partners = (0, $52a7294453bdb6d1$export$3a3bfc913ac4efaa)(skillId);
            if (partners.size === 0) return "continue";
            // Already covered by the player's or a hired contractor's kit?
            if ((0, $4c858c0d999a5b9b$export$71511d61b312f219)(partners).some(function(t) {
                return teamTechniques.has(t) && partnerAllowed(skillId, t);
            })) return "continue";
            // Prefer a device that costs us coverage on a skill this route does not use.
            var candidates = ownedDevices.filter(function(d) {
                return partners.has(d.techniqueId) && partnerAllowed(skillId, d.techniqueId);
            });
            if (candidates.length === 0) return "continue";
            var device = candidates.find(function(d) {
                return !routeSkills.has((0, $ca7af38ea7b7b4a8$export$a6cb179f21ae932e)(d.techniqueId));
            }) || candidates[0];
            var deviceSkill = (0, $ca7af38ea7b7b4a8$export$a6cb179f21ae932e)(device.techniqueId);
            if (char.equippedTechniqueGear[device.techniqueId]) return "continue" // already on
            ;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.keys(char.equippedTechniqueGear)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var equipped = _step1.value;
                    if ((0, $ca7af38ea7b7b4a8$export$a6cb179f21ae932e)(equipped) === deviceSkill) {
                        teamTechniques.delete(equipped);
                        delete char.equippedTechniqueGear[equipped];
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            char.equippedTechniqueGear[device.techniqueId] = device;
            teamTechniques.add(device.techniqueId);
            swaps++;
        };
        for(var _iterator = routeSkills[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return swaps;
}



function $670e0f14fa02ad13$export$aca974319671fb3e() {
    // Calculate skill level range based on player level
    var playerLevel = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character ? (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.level : 1;
    var newContractors = (0, $e63b1e314d73680b$export$9471e02e816b8b11)(playerLevel);
    // Update both gameState and Alpine store
    if (Alpine.store("contractors")) Alpine.store("contractors").update(newContractors);
    else // Fallback if Alpine isn't ready yet
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).contractors = newContractors;
}
function $670e0f14fa02ad13$export$5464865996ba2eb4(member) {
    var context = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "main", pathSkills = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, teamSkills = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    //console.log('Creating contractor card for:', member, 'in context:', context);
    // Handle empty slot mode
    var isReadOnly = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character && (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.isMarketplace;
    var isEmpty = member === "empty";
    // Crewing is a PLANNING action. An empty slot goes on showing its Reserve
    // button once the raid is underway or finished, which offers to add somebody
    // to a team that has already left — reserving mid-raid cannot put them on it,
    // and reserving against a finished one is meaningless. The slot itself still
    // renders, because "you went in two-handed" is worth seeing on the way round.
    var raidStarted = !!(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress || !!(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidCompleted;
    var showReserveButton = !isReadOnly && !raidStarted && context === "empty-first";
    // Identity check, not type-sniffing: character ids are strings for created
    // characters but numeric in QA fixtures/legacy saves - type-based detection
    // rendered the player as a "Contractor" card (undefined% reward share)
    var isPlayer = !isEmpty && (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character != null && member.id === (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.id;
    var isMarketplaceContractor = !isEmpty && member.id > 0 && !isPlayer;
    var faction = !isEmpty && (isPlayer ? $979b99378be707cd$export$aeeef991191508e2[member.faction] : $979b99378be707cd$export$aeeef991191508e2[member.faction]);
    // Determine member status
    var isHired = !isEmpty && !isPlayer && (0, $1249ab814b7054d4$export$4c8adf450afe39a2)(member.id);
    var isReserved = !isEmpty && !isPlayer && (0, $1249ab814b7054d4$export$595cb98aec43dd71)(member.id);
    var isInjured = !isEmpty && (member.injured || false);
    var raidCompleted = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidCompleted;
    // Synergy indicators: ⚡ = a partner device is already equipped on the
    // prospective team (synergy variants can fire on this skill's events);
    // 🔀 = the player owns a partner device - one gear swap enables it
    var synergyStatus = isEmpty ? null : (0, $e63b1e314d73680b$export$9163caedda99cb08)(member);
    // Build skills display (sorted by level descending)
    var skillsText = isEmpty ? "" : Object.entries(member.skills).sort(function(param, param1) {
        var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), a = _param[1], _param1 = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param1, 2), b = _param1[1];
        return b - a;
    }) // Sort by level descending
    .map(function(param) {
        var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), skill = _param[0], level = _param[1];
        var _faction_skills_skill, _synergyStatus_skills;
        var skillIcon = (0, $ca7af38ea7b7b4a8$export$8a18dddc0824814c)(skill);
        var skillName = ((_faction_skills_skill = faction.skills[skill]) === null || _faction_skills_skill === void 0 ? void 0 : _faction_skills_skill.name) || skill;
        var truncatedName = skillName;
        var syn = synergyStatus === null || synergyStatus === void 0 ? void 0 : (_synergyStatus_skills = synergyStatus.skills) === null || _synergyStatus_skills === void 0 ? void 0 : _synergyStatus_skills[skill];
        var synIcon = "";
        if ((syn === null || syn === void 0 ? void 0 : syn.state) === "ready") synIcon = '<span class="ml-1 cursor-help" title="Synergy ready: the team\'s '.concat((0, $ca7af38ea7b7b4a8$export$b7fbae54a8f17db)(syn.techniqueId), " gear upgrades ").concat(skillName, ' events to synergy variants (bonus salvage)">\u26A1</span>');
        else if ((syn === null || syn === void 0 ? void 0 : syn.state) === "swap") synIcon = '<span class="ml-1 cursor-help opacity-60" title="Synergy possible: equip your '.concat(syn.gearIcon || '', " ").concat(syn.gearName, " (").concat((0, $ca7af38ea7b7b4a8$export$b7fbae54a8f17db)(syn.techniqueId), ") to upgrade ").concat(skillName, ' events to synergy variants">\uD83D\uDD00</span>');
        // Determine skill highlighting based on path requirements
        var skillClasses = "flex items-start justify-between text-sm mb-1 px-1";
        var nameClasses = "whitespace-nowrap overflow-hidden tracking-tighter";
        var levelClasses = "font-medium text-game-gold";
        if ((context === "modal" || context === "team") && pathSkills && teamSkills && !isPlayer) {
            var isNeededSkill = pathSkills.has(skill) && (teamSkills[skill] || 0) === 0;
            var isMatchingSkill = pathSkills.has(skill) && (teamSkills[skill] || 0) > 0;
            if (isNeededSkill) {
                // Critical needed skill - keep text highlighting only
                nameClasses += " text-orange-300";
                levelClasses = "font-bold text-orange-400";
            } else if (isMatchingSkill) {
                // Matching skill - keep text highlighting only
                nameClasses += " text-blue-300";
                levelClasses = "font-bold text-blue-400";
            }
        }
        return '<div class="'.concat(skillClasses, '">\n                <span class="flex items-start">\n                    <span class="skill-icon">').concat(skillIcon, '</span>\n                    <span class="').concat(nameClasses, '" title="').concat(skillName, '">').concat(truncatedName, "</span>\n                    ").concat(synIcon, '\n                </span>\n                <span class="').concat(levelClasses, '">').concat(level, "</span>\n            </div>");
    }).join("");
    // Equipped skill gear: shown on the card because a contractor's tools
    // unlock synergy variants and success bonuses for the whole team.
    // ⚡ marks gear that partners YOUR skills' events (the reverse direction:
    // hiring this contractor upgrades your own events to synergy variants).
    var equippedGear = isEmpty ? [] : Object.values(member.equippedTechniqueGear || {}).filter(Boolean);
    var gearText = equippedGear.length === 0 ? "" : '\n        <div class="border-t border-gray-600 pt-1 mt-1">\n            '.concat(equippedGear.map(function(gear) {
        var _synergyStatus_gearPartners;
        var partneredSkills = (synergyStatus === null || synergyStatus === void 0 ? void 0 : (_synergyStatus_gearPartners = synergyStatus.gearPartners) === null || _synergyStatus_gearPartners === void 0 ? void 0 : _synergyStatus_gearPartners[gear.techniqueId]) || [];
        var partnerNames = partneredSkills.map(function(s) {
            return (0, $ca7af38ea7b7b4a8$export$182937d2e68a339)(s);
        }).join(", ");
        var title = partneredSkills.length > 0 ? "".concat(gear.name, " \u2014 synergy partner for your ").concat(partnerNames, " events (bonus salvage on success)") : "".concat(gear.name, " \u2014 boosts ").concat((0, $ca7af38ea7b7b4a8$export$b7fbae54a8f17db)(gear.techniqueId) || 'its technique', " for the team");
        return '\n                <div class="flex items-start text-sm mb-1 px-1 text-amber-300" title="'.concat(title, '">\n                    <span class="skill-icon">\u2699\uFE0F</span>\n                    <span class="whitespace-nowrap overflow-hidden tracking-tighter">').concat(gear.name, "</span>\n                    ").concat(partneredSkills.length > 0 ? '<span class="ml-1 cursor-help">\u26A1</span>' : '', "\n                </div>");
    }).join(""), "\n        </div>");
    // Build health status - ensure all contractors show HP (except empty slots)
    var statusText = "";
    if (!isEmpty && isInjured && member.recoveryTime) {
        var timeLeft = Math.max(0, member.recoveryTime - Date.now());
        var hoursLeft = Math.ceil(timeLeft / 3600000);
        statusText = '<div class="text-red-500">\uD83C\uDFE5 '.concat(hoursLeft, "h recovery</div>");
    } else if (!isEmpty) {
        // Initialize HP if missing
        var maxHp = member.maxHp || 100;
        var currentHp = Math.max(0, member.currentHp !== undefined ? member.currentHp : maxHp);
        var healthPercent = currentHp / maxHp * 100;
        var healthColor = healthPercent > 75 ? "#4caf50" : healthPercent > 25 ? "#ffd700" : "#ff6b6b";
        statusText = '<div style="color: '.concat(healthColor, ';">\u2764\uFE0F').concat(Math.floor(currentHp), "</div>");
    }
    // Calculate skill relevance for modal context
    var relevanceText = "";
    var relevanceClass = "";
    if (context === "modal" && pathSkills && teamSkills && !isPlayer) {
        var relevantSkills = Object.keys(member.skills).filter(function(skill) {
            return pathSkills.has(skill);
        });
        var uncoveredSkills = Object.keys(member.skills).filter(function(skill) {
            return pathSkills.has(skill) && (teamSkills[skill] || 0) === 0;
        });
        if (uncoveredSkills.length > 0) {
            relevanceText = '<span class="skill-relevance critical">\uD83D\uDD25 '.concat(uncoveredSkills.length, " needed skill").concat(uncoveredSkills.length > 1 ? "s" : "", "</span>");
            relevanceClass = "critical-match";
        } else if (relevantSkills.length > 0) {
            relevanceText = '<span class="skill-relevance">\uD83C\uDFAF '.concat(relevantSkills.length, " matching skill").concat(relevantSkills.length > 1 ? "s" : "", "</span>");
            relevanceClass = "skill-match";
        }
    }
    // Determine card status styling
    var statusClasses = "bg-white/5 border-2 border-gray-600";
    if (isHired) statusClasses = "bg-green-500/20 border-green-500";
    if (isReserved) statusClasses = "bg-game-gold/20 border-game-gold";
    if (isInjured) statusClasses = "bg-red-500/20 border-red-500";
    if (isPlayer) statusClasses = "bg-game-accent/20 border-game-accent";
    if (relevanceClass === "critical-match") statusClasses = "bg-orange-500/20 border-orange-500";
    else if (relevanceClass === "skill-match") statusClasses = "bg-blue-500/20 border-blue-500";
    // Build action button
    var actionButton = "";
    if (isEmpty && showReserveButton) actionButton = '<button class="bg-blue-400 hover:bg-blue-300 text-black hover:text-gray text-xs px-3 py-1 rounded font-bold" onclick="openContractorModal()">\n            Reserve\n        </button>';
    else if (isEmpty) actionButton = "";
    else if (isReadOnly) // No action button in read-only mode
    actionButton = "";
    else if (isMarketplaceContractor && context === "main") {
        // Handle marketplace contractors with reservation system
        var raidInProgress = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.hiredContractors && (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.hiredContractors.length > 0;
        if (isReserved && !raidInProgress) actionButton = '<button class="px-2 py-1 rounded transition-all duration-200 text-xs font-bold bg-red-500 hover:bg-red-600 text-white hover:shadow-lg border border-red-400" onclick="releaseReservedContractor(\''.concat(member.id, "')\">Release</button>");
        else if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedTier && (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid && !raidInProgress) {
            var disabled = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.reservedContractors.length >= 2;
            var buttonText = disabled ? "Team Full" : "Reserve";
            var buttonClasses = disabled ? "bg-gray-600 text-gray-400 cursor-not-allowed border border-gray-500" : "bg-purple-600 hover:bg-purple-700 text-white hover:shadow-lg border border-purple-400";
            actionButton = '<button class="px-2 py-1 rounded transition-all duration-200 text-xs font-bold '.concat(buttonClasses, '" onclick="reserveContractorFromModal(\'').concat(member.id, "')\" ").concat(disabled ? "disabled" : "", ">\n                    ").concat(buttonText, "\n                </button>");
        }
    } else if (context === "main" && !isPlayer) {
        var raidInProgress1 = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.hiredContractors && (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.hiredContractors.length > 0;
        if (isHired || isReserved && !raidInProgress1 || (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedTier && (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid && !raidInProgress1) {
            var disabled1 = isInjured || !isHired && !isReserved && (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.reservedContractors.length >= 2;
            var buttonText1 = isHired ? "Release" : isReserved ? "Release" : isInjured ? "Injured" : (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.reservedContractors.length >= 2 ? "Team Full" : "Reserve";
            var buttonClasses1 = disabled1 ? "bg-gray-400 text-black text-xs px-3 py-1 rounded font-bold cursor-not-allowed" : "bg-blue-400 hover:bg-blue-300 text-black hover:text-gray text-xs px-3 py-1 rounded font-bold";
            actionButton = '<button class="'.concat(buttonClasses1, '" @click="toggleContractor(\'').concat(member.id, "')\" ").concat(disabled1 ? "disabled" : "", ">\n                    ").concat(buttonText1, "\n                </button>");
        }
    } else if (context === "modal" && !isPlayer) {
        var raidInProgress2 = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.hiredContractors && (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.hiredContractors.length > 0;
        if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedTier && (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid && !raidInProgress2) {
            var disabled2 = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.reservedContractors.length >= 2;
            var buttonText2 = disabled2 ? "Team Full" : "Reserve";
            var buttonClasses2 = disabled2 ? "bg-gray-400 text-black text-xs px-3 py-1 rounded font-bold cursor-not-allowed" : "bg-blue-400 hover:bg-blue-300 text-black hover:text-gray text-xs px-3 py-1 rounded font-bold";
            actionButton = '<button class="px-2 py-1 rounded transition-all duration-200 text-xs font-bold '.concat(buttonClasses2, '" onclick="reserveContractorFromModal(\'').concat(member.id, "')\" ").concat(disabled2 ? "disabled" : "", ">\n                    ").concat(buttonText2, "\n                </button>");
        }
    } else if (context === "team" && !isPlayer && !isHired) // Only show release button for reserved contractors, not hired ones
    actionButton = '<button class="px-2 py-1 rounded transition-all duration-200 text-xs font-bold bg-red-500 hover:bg-red-600 text-white hover:shadow-lg border border-red-400" onclick="releaseReservedContractor(\''.concat(member.id, "')\">Release</button>");
    // Build timer display for reserved marketplace contractors in team view
    var timerDisplay = "";
    if (context === "team" && isMarketplaceContractor && isReserved && member.reservationExpires) {
        var timeLeft1 = Math.max(0, Math.floor((member.reservationExpires - Date.now()) / 1000));
        var minutes = Math.floor(timeLeft1 / 60);
        var seconds = timeLeft1 % 60;
        timerDisplay = '<div class="bg-purple-700 text-purple-100 px-2 py-1 rounded text-xs font-bold border border-purple-400" id="reservation-timer-'.concat(member.id, '">\n            ').concat(minutes, ":").concat(seconds.toString().padStart(2, "0"), "\n        </div>");
    }
    // Build cost/percentage display for bottom left corner
    var costDisplay = "";
    if (isEmpty) costDisplay = '<div class="bg-gray-700 text-gray-500 px-2 py-1 rounded-full text-xs font-bold border border-gray-500 '.concat(isEmpty ? "border-dashed" : "", '">-%\uD83D\uDCB0</div>');
    else if (!isPlayer) costDisplay = '<div class="bg-gray-700 text-gray-100 px-2 py-1 rounded-full text-xs font-bold border border-gray-500">'.concat(member.rewardPercentage, "%\uD83D\uDCB0</div>");
    // Build detailed tooltip content for contractor
    var tooltipContent = isPlayer ? "Leader of the raid team<br><strong>Faction:</strong> ".concat(faction.name, "<br><strong>Skills:</strong><br>").concat(skillsText.replace(/class="skill-line"/g, "").replace(/<div>/g, "").replace(/<\/div>/g, "<br>")) : "<strong>Contractor Details</strong><br><strong>Faction:</strong> ".concat(faction.name, "<br><strong>Reward Share:</strong> ").concat(member.rewardPercentage, "%\uD83D\uDCB0<br><strong>Skills:</strong><br>").concat(skillsText.replace(/class="skill-line"/g, "").replace(/<div>/g, "").replace(/<\/div>/g, "<br>"));
    // Determine card colors based on status
    var cardBg, cardBorder, frameBorder, headerBg, headerBorder, headerText;
    if (isPlayer) {
        cardBg = "from-gray-800 to-gray-900";
        cardBorder = "border-purple-600";
        frameBorder = "border-purple-500";
        headerBg = "from-purple-700 to-purple-600";
        headerBorder = "border-purple-500";
        headerText = "text-purple-100";
    } else if (isMarketplaceContractor && isReserved) {
        // Reserved marketplace contractor - purple/amber blend
        cardBg = "from-purple-800 to-purple-900";
        cardBorder = "border-purple-500";
        frameBorder = "border-purple-400";
        headerBg = "from-purple-700 to-purple-600";
        headerBorder = "border-purple-400";
        headerText = "text-purple-100";
    } else if (isMarketplaceContractor) {
        cardBg = "from-indigo-800 to-indigo-900";
        cardBorder = "border-indigo-600";
        frameBorder = "border-indigo-500";
        headerBg = "from-indigo-700 to-indigo-600";
        headerBorder = "border-indigo-500";
        headerText = "text-indigo-100";
    } else if (isHired) {
        cardBg = "from-green-800 to-green-900";
        cardBorder = "border-green-600";
        frameBorder = "border-green-500";
        headerBg = "from-green-700 to-green-600";
        headerBorder = "border-green-500";
        headerText = "text-green-100";
    } else if (isReserved) {
        cardBg = "from-amber-800 to-amber-900";
        cardBorder = "border-amber-600";
        frameBorder = "border-amber-500";
        headerBg = "from-amber-700 to-amber-600";
        headerBorder = "border-amber-500";
        headerText = "text-amber-100";
    } else if (relevanceClass === "critical-match") {
        cardBg = "from-gray-800 to-gray-900";
        cardBorder = "border-orange-700";
        frameBorder = "border-orange-600";
        headerBg = "from-orange-800 to-orange-700";
        headerBorder = "border-orange-600";
        headerText = "text-orange-100";
    } else if (relevanceClass === "skill-match") {
        cardBg = "from-gray-800 to-gray-900";
        cardBorder = "border-blue-600";
        frameBorder = "border-blue-500";
        headerBg = "from-blue-700 to-blue-600";
        headerBorder = "border-blue-500";
        headerText = "text-blue-100";
    } else {
        // Use level-based colors for neutral contractors
        var levelColors = (0, $7ea2865b97769aa3$export$fc83223e1b29d2d5)(member.level || 1);
        cardBg = levelColors.cardBg;
        cardBorder = isEmpty ? "border-dashed ".concat(levelColors.cardBorder) : levelColors.cardBorder;
        frameBorder = isEmpty ? "border-dashed ".concat(levelColors.frameBorder) : levelColors.frameBorder;
        headerBg = levelColors.headerBg;
        headerBorder = isEmpty ? "border-dashed ".concat(levelColors.headerBorder) : levelColors.headerBorder;
        headerText = "text-white";
    }
    var overlayBg = "bg-black bg-opacity-70";
    var overlayBorder = "border-gray-500";
    var overlayText = "text-gray-400";
    // Create unified card HTML for all contexts
    return '\n        <div class="relative bg-gradient-to-b '.concat(cardBg, " border-4 ").concat(cardBorder, ' rounded-xl shadow-lg hover:shadow-xl transition-all duration-200 h-[430px] w-60 overflow-hidden">\n            <!-- Card Border Frame -->\n            <div class="absolute inset-1 border-2 ').concat(frameBorder, ' rounded-lg"></div>\n\n            <!-- Header Banner -->\n            <div class="relative bg-gradient-to-r ').concat(headerBg, " ").concat(headerText, " px-3 py-1 text-left border-b-2 ").concat(headerBorder, ' h-8">\n                <div class="absolute top-0.5 right-0.5 bg-black bg-opacity-30 border border-black rounded-full w-6 h-6 flex items-center justify-center text-sm" title="').concat(faction.name, '">').concat(faction.icon || "\uD83C\uDFE2", '</div>\n            </div>\n\n            <!-- Card Content -->\n            <div class="relative p-3 bg-gradient-to-b ').concat(cardBg, '" style="height: calc(100% - 32px);">\n                <!-- Title Section -->\n                <div class="h-4 flex items-center justify-between">\n                    <h4 class="font-bold ').concat(isEmpty ? "text-gray-500" : "text-white", ' text-sm leading-tight contractor-tooltip" data-tippy-content="').concat(isEmpty ? "" : tooltipContent.replace(/"/g, "&quot;").replace(/'/g, "&#39;"), '">\n                        ').concat(isEmpty ? "Available Slot" : member.name, "\n                    </h4>\n                    ").concat(!isEmpty ? '<div class="text-xs text-game-gold font-bold">Lv.'.concat(member.level || 1, "</div>") : "", '\n                </div>\n\n                <div class="h-4 mb-2">\n                    <h3 class="font-italic text-gray-400 text-xs leading-tight">\n                        ').concat(isEmpty ? "" : member.title ? member.title : isPlayer ? "Leader" : "Contractor", '\n                    </h3>\n                </div>\n\n                <!-- Avatar Area -->\n                <div class="relative bg-gradient-to-b from-gray-600 to-gray-900 border-2 ').concat(isEmpty ? "border-dashed border-gray-500" : "border-gray-500", ' rounded-lg h-[100px] w-full mb-2 overflow-hidden group cursor-pointer">\n                    <!-- Avatar -->\n                    <div class="absolute inset-0 flex items-center justify-center">\n                        ').concat(isEmpty ? '<div class="contractor-avatar-placeholder contractor-avatar-placeholder transform group-hover:scale-110 transition-transform duration-200"></div>' : '<div class="contractor-avatar-placeholder transform group-hover:scale-110 transition-transform duration-200" data-avatar-nobg="1" data-avatar-seed="'.concat((0, $ca7af38ea7b7b4a8$export$f3619081e7e8f116)(member), '" data-avatar-faction="').concat(member.faction, '"></div>'), "\n                    </div>\n\n                    <!-- Status badges -->\n                    ").concat(isHired && !raidCompleted ? '<div class="absolute top-1 left-1 bg-green-600 text-white px-2 py-1 rounded text-xs font-bold">HIRED</div>' : "", "\n                    ").concat(isHired && raidCompleted && isMarketplaceContractor && context === "team" ? '<div class="absolute top-1 left-1 bg-blue-600 text-white px-2 py-1 rounded text-xs font-bold">RELEASED</div>' : "", "\n                    ").concat(isReserved ? '<div class="absolute top-1 left-1 bg-amber-600 text-white px-2 py-1 rounded text-xs font-bold">RESERVED</div>' : "", "\n                    ").concat(isMarketplaceContractor ? '<div class="absolute bottom-1 right-1 bg-indigo-600 text-white px-2 py-1 rounded text-xs font-bold">\uD83D\uDC64 PLAYER</div>' : "", "\n                    ").concat(relevanceText ? '<div class="absolute top-1 right-1 text-s">'.concat(relevanceText, "</div>") : "", "\n                    ").concat(statusText ? '<div class="absolute bottom-1 left-1 bg-black bg-opacity-70 text-white px-2 py-1 rounded text-xs border border-gray-700">'.concat(statusText, "</div>") : "", '\n\n                    <!-- Quote Overlay at Bottom (hidden by default, shown on hover) -->\n                    <div class="').concat(member.quote ? "" : "hidden", " absolute bottom-0 left-0 right-0 ").concat(overlayBg, " p-2 border-t ").concat(overlayBorder, ' transform translate-y-full group-hover:translate-y-0 transition-transform duration-200 z-10">\n                        <p class="').concat(overlayText, ' text-xs leading-tight">').concat(member.quote ? member.quote : "", '</p>\n                    </div>\n                </div>\n\n                <!-- Skills Section -->\n                <div class="mt-2 text-xs space-y-1 mb-3 bg-gradient-to-b from-gray-800 to-gray-900 border-2 border-gray-500 rounded-lg p-1 ').concat(isEmpty ? "border-dashed" : "", '" style="height: 185px; overflow-y: auto;">\n                    ').concat(isEmpty ? '<div class="text-gray-600 text-center py-8">No skills</div>' : skillsText, "\n                    ").concat(gearText, '\n                </div>\n\n                <!-- Footer Section -->\n                <div class="absolute bottom-3 left-3 right-3 flex justify-between items-center gap-1">\n                    ').concat(costDisplay, "\n                    ").concat(timerDisplay, '\n                    <div class="ml-auto">').concat(actionButton, "</div>\n                </div>\n            </div>\n        </div>\n    ");
}
function $670e0f14fa02ad13$export$fada499eccb8a752() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var contractorList, allContractors;
        return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    contractorList = document.getElementById("contractor-list");
                    if (!contractorList) return [
                        2
                    ];
                    return [
                        4,
                        $670e0f14fa02ad13$export$362d4c3fa8c04b4b()
                    ];
                case 1:
                    allContractors = _state.sent();
                    if (!allContractors.length) {
                        contractorList.innerHTML = '<p class="text-gray-500 text-center col-span-full">Create a character first to see available contractors.</p>';
                        return [
                            2
                        ];
                    }
                    contractorList.innerHTML = "";
                    allContractors.forEach(function(contractor) {
                        // Ensure health properties exist and are synchronized
                        contractor.maxHp = contractor.maxHp || contractor.max_hp || 100;
                        if (contractor.currentHp === undefined) contractor.currentHp = contractor.current_hp || contractor.maxHp;
                        var contractorDiv = document.createElement("div");
                        contractorDiv.innerHTML = $670e0f14fa02ad13$export$5464865996ba2eb4(contractor, "main");
                        contractorList.appendChild(contractorDiv.firstElementChild);
                    });
                    return [
                        2
                    ];
            }
        });
    })();
}
function $670e0f14fa02ad13$export$362d4c3fa8c04b4b() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var _contractors, contractors, _contractors1, _this, minLevel, maxLevel, tier, selectedTier, requiredMs, now, ownCharacterIds, marketplaceContractors, error;
        return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    contractors = [];
                    // Add AI contractors
                    if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).contractors && (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).contractors.length > 0) (_contractors = contractors).push.apply(_contractors, (0, $4c858c0d999a5b9b$export$71511d61b312f219)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).contractors));
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    minLevel = 0;
                    maxLevel = 999;
                    if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedTier && $979b99378be707cd$export$94e7ad7999c1ae32[(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedTier]) {
                        tier = $979b99378be707cd$export$94e7ad7999c1ae32[(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedTier];
                        minLevel = tier.contractorMinLevel;
                        maxLevel = tier.contractorMaxLevel;
                    }
                    // A contract must have enough time left to see the raid through. If it
                    // expires mid-raid the owner reclaims the character locally while it is
                    // still in this raid — conflicting state, and the completion payout is
                    // blocked by the in_raid guard. Hide those listings rather than strand them.
                    selectedTier = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedTier || 1;
                    requiredMs = (0, $7b2bbc8bf6b24d6d$export$ff894ad244f3f26e)(selectedTier).avgRaidSeconds * 1000;
                    now = Date.now();
                    // You can't hire your own characters — exclude every character this player
                    // owns, not just the active one (any of them could be listed).
                    ownCharacterIds = ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).characters || []).map(function(c) {
                        return c.multiplayerId;
                    }).filter(Boolean);
                    return [
                        4,
                        (0, $fde0976ce5d1665d$export$e4477200b6413a70).getMarketplaceListings(minLevel, maxLevel, ownCharacterIds)
                    ];
                case 2:
                    marketplaceContractors = (_this = _state.sent()) === null || _this === void 0 ? void 0 : _this.filter(function(c) {
                        var expiresAt = c.expires_at || c.expiresAt;
                        if (!expiresAt) return true; // no expiry data — let the server decide
                        return new Date(expiresAt).getTime() - now >= requiredMs;
                    });
                    if (marketplaceContractors && marketplaceContractors.length > 0) (_contractors1 = contractors).push.apply(_contractors1, (0, $4c858c0d999a5b9b$export$71511d61b312f219)(marketplaceContractors.map(function(c) {
                        return (0, $715bf31211e65705$export$71511d61b312f219)((0, $fa9769297b8a68c8$export$71511d61b312f219)({}, c), {
                            // Normalize database field names (snake_case) to the camelCase the
                            // game engine reads. equippedTechniqueGear in particular is what the
                            // raid/event engine uses to apply a contractor's techniques.
                            currentHp: c.current_hp || c.maxHp || c.max_hp || 100,
                            maxHp: c.max_hp || 100,
                            rewardPercentage: c.reward_percentage || 15,
                            equippedTechniqueGear: c.equippedTechniqueGear || c.equipped_technique_gear || {},
                            avatarSeed: c.avatarSeed || c.avatar_seed || null,
                            avatarFeatures: c.avatarFeatures || c.avatar_features || null
                        });
                    })));
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    console.warn("Could not fetch marketplace contractors:", error);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2,
                        contractors
                    ];
            }
        });
    })();
}
/**
 * Skeleton Crew refuses a crew. Checked at RESERVATION rather than at raid
 * start, so the answer arrives when the player clicks rather than as a surprise
 * on launch — and it is one helper because there are two ways to reserve
 * (the team panel and the contractor modal) and a guard on only one of them is
 * not a guard.
 */ function $670e0f14fa02ad13$var$blackoutBlocksContractors() {
    if (!(0, $686e361e5cd4549d$export$a2c94bc2dc5c01e1)('noContractors', false)) return false;
    (0, $b5bda7fdec806d8b$export$c7def531c087da85)("\uD83D\uDC80 Skeleton Crew: this contract is run alone \u2014 no contractors.", "warning");
    return true;
}
function $670e0f14fa02ad13$export$dc7fd448e3805128(contractorId) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var _gameState_characters, contractor, currentCharacter, reservationResult;
        return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    contractor = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).contractors.find(function(c) {
                        return c.id == contractorId;
                    });
                    if (!contractor) return [
                        2
                    ];
                    currentCharacter = (_gameState_characters = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).characters) === null || _gameState_characters === void 0 ? void 0 : _gameState_characters.find(function(c) {
                        return c.id === (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).activeCharacterId;
                    });
                    if (!currentCharacter) return [
                        2
                    ];
                    if (!(0, $1249ab814b7054d4$export$4c8adf450afe39a2)(contractor.id)) return [
                        3,
                        3
                    ];
                    if (!(contractor.id > 0)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        (0, $fde0976ce5d1665d$export$e4477200b6413a70).releaseHiredContractor(contractor.id, currentCharacter.multiplayerId)
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.hiredContractors = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.hiredContractors.filter(function(c) {
                        return c.id != contractorId;
                    });
                    return [
                        3,
                        9
                    ];
                case 3:
                    if (!(0, $1249ab814b7054d4$export$595cb98aec43dd71)(contractor.id)) return [
                        3,
                        6
                    ];
                    if (!(contractor.id > 0)) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        (0, $fde0976ce5d1665d$export$e4477200b6413a70).releaseContractor(contractor.id, currentCharacter.multiplayerId)
                    ];
                case 4:
                    _state.sent();
                    _state.label = 5;
                case 5:
                    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.reservedContractors = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.reservedContractors.filter(function(c) {
                        return c.id != contractorId;
                    });
                    return [
                        3,
                        9
                    ];
                case 6:
                    if ($670e0f14fa02ad13$var$blackoutBlocksContractors()) return [
                        2
                    ];
                    // Check team size limit (player + 2 contractors max)
                    if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.reservedContractors.length >= 2) {
                        (0, $b5bda7fdec806d8b$export$c7def531c087da85)("\u26A0\uFE0F Team is full! Maximum 3 members (you + 2 contractors).", "warning");
                        return [
                            2
                        ];
                    }
                    if (!contractor.multiplayerId) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        (0, $fde0976ce5d1665d$export$e4477200b6413a70).reserveContractor(contractor.multiplayerId, currentCharacter.multiplayerId)
                    ];
                case 7:
                    reservationResult = _state.sent();
                    if (!reservationResult.success) {
                        (0, $b5bda7fdec806d8b$export$c7def531c087da85)("\u274C ".concat(reservationResult.message), "error");
                        return [
                            2
                        ];
                    }
                    _state.label = 8;
                case 8:
                    // Reserve contractor (add to reserved list - no cost yet)
                    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.reservedContractors.push(contractor);
                    _state.label = 9;
                case 9:
                    // Update Alpine store
                    Alpine.store("contractors").refresh();
                    (0, $3f29ea4265abff3b$export$b70ccd83fb3eaefa)(); // Update raid team display
                    (0, $3f29ea4265abff3b$export$68c4600b33dd0ca8)();
                    (0, $3f29ea4265abff3b$export$f4fa7fe8ae486c6)(); // Update current path skill coverage
                    (0, $59924438766e7d8e$export$d1c957a54f7124bc)();
                    (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
                    return [
                        2
                    ];
            }
        });
    })();
}
function $670e0f14fa02ad13$export$9a18f3125e8e0eca() {
    var modal = document.getElementById("contractor-modal");
    modal.classList.remove("hidden");
    // Add entrance animation
    modal.classList.add("animate__animated", "animate__fadeIn");
    modal.querySelector(".modal-content").classList.add("animate__animated", "animate__zoomIn");
// Alpine.js now handles the contractor display reactively
}
function $670e0f14fa02ad13$export$5d484cf67c77323e() {
    var modal = document.getElementById("contractor-modal");
    var modalContent = modal.querySelector(".modal-content");
    // Add exit animation
    modal.classList.add("animate__animated", "animate__fadeOut");
    modalContent.classList.add("animate__animated", "animate__zoomOut");
    // Hide modal after animation completes
    setTimeout(function() {
        modal.classList.add("hidden");
        // Clean up animation classes
        modal.classList.remove("animate__animated", "animate__fadeIn", "animate__fadeOut");
        modalContent.classList.remove("animate__animated", "animate__zoomIn", "animate__zoomOut");
    }, 150);
}
function $670e0f14fa02ad13$export$b98752098fb87559(contractor, pathSkills, teamSkills) {
    var contractorSkills = Object.keys(contractor.skills);
    // Count skills that are needed for the path
    var totalNeededSkills = contractorSkills.filter(function(skill) {
        return pathSkills.has(skill);
    }).length;
    // Count skills that are needed but not covered by current team
    var uncoveredNeededSkills = contractorSkills.filter(function(skill) {
        return pathSkills.has(skill) && (teamSkills[skill] || 0) === 0;
    }).length;
    return {
        uncoveredNeededSkills: uncoveredNeededSkills,
        totalNeededSkills: totalNeededSkills
    };
}
function $670e0f14fa02ad13$export$959fb65d2b5e760e(contractorId) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var _gameState_characters, contractor, currentCharacter, reservationResult;
        return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    // Find contractor in Alpine store (includes both AI and marketplace contractors)
                    //const contractor = Alpine.store('contractors').all.find(c => c.id == contractorId);
                    contractor = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).contractors.find(function(c) {
                        return c.id == contractorId;
                    });
                    // console.log('Reserving contractor from modal:', contractorId, contractor, isContractorReserved(contractorId));
                    if (!contractor || (0, $1249ab814b7054d4$export$595cb98aec43dd71)(contractorId)) return [
                        2
                    ];
                    if ($670e0f14fa02ad13$var$blackoutBlocksContractors()) return [
                        2
                    ];
                    currentCharacter = (_gameState_characters = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).characters) === null || _gameState_characters === void 0 ? void 0 : _gameState_characters.find(function(c) {
                        return c.id === (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).activeCharacterId;
                    });
                    if (!currentCharacter) return [
                        2
                    ];
                    // Check team size limit (player + 2 contractors max)
                    if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.reservedContractors.length >= 2) {
                        (0, $b5bda7fdec806d8b$export$c7def531c087da85)("\u26A0\uFE0F Team is full! Maximum 3 members (you + 2 contractors).", "warning");
                        return [
                            2
                        ];
                    }
                    if (!(contractor.id > 0)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        (0, $fde0976ce5d1665d$export$e4477200b6413a70).reserveContractor(contractor.id, currentCharacter.multiplayerId)
                    ];
                case 1:
                    reservationResult = _state.sent();
                    if (reservationResult.success) // Add marketplace contractor with expiration time from backend
                    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.reservedContractors.push((0, $715bf31211e65705$export$71511d61b312f219)((0, $fa9769297b8a68c8$export$71511d61b312f219)({}, contractor), {
                        reservedAt: Date.now(),
                        reservationExpires: new Date(reservationResult.expiresAt).getTime()
                    }));
                    else {
                        (0, $b5bda7fdec806d8b$export$c7def531c087da85)("\u274C ".concat(reservationResult.message), "error");
                        return [
                            2
                        ];
                    }
                    return [
                        3,
                        3
                    ];
                case 2:
                    // AI contractor (negative ID) - no server reservation needed
                    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.reservedContractors.push(contractor);
                    _state.label = 3;
                case 3:
                    // Update Alpine store
                    if (Alpine.store("contractors")) Alpine.store("contractors").updateReserved((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.reservedContractors);
                    (0, $3f29ea4265abff3b$export$b70ccd83fb3eaefa)();
                    (0, $3f29ea4265abff3b$export$68c4600b33dd0ca8)();
                    (0, $3f29ea4265abff3b$export$f4fa7fe8ae486c6)(); // Update current path skill coverage
                    (0, $59924438766e7d8e$export$d1c957a54f7124bc)();
                    (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
                    // Auto-close modal if team is now full
                    if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.reservedContractors.length >= 2) setTimeout(function() {
                        $670e0f14fa02ad13$export$5d484cf67c77323e();
                    }, 500); // Small delay to let user see the action complete
                    return [
                        2
                    ];
            }
        });
    })();
}
function $670e0f14fa02ad13$export$3e71fa030a894242(timePassedMs) {
    var raidTeam = (0, $1249ab814b7054d4$export$d17f5534c14b3dc5)();
    var hasChanges = false;
    raidTeam.forEach(function(member) {
        hasChanges = hasChanges || (0, $df8a44d92d572a5c$export$11d38807a029df6f)(member, timePassedMs);
    });
    return hasChanges;
}
function $670e0f14fa02ad13$export$797aa5f00658ac19() {
    var now = Date.now();
    var expiredContractors = [];
    // Find expired marketplace contractor reservations
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.reservedContractors.forEach(function(contractor) {
        if (contractor.id > 0 && contractor.reservationExpires && contractor.reservationExpires < now) expiredContractors.push(contractor);
    });
    if (expiredContractors.length > 0) {
        // Remove expired reservations
        expiredContractors.forEach(function(contractor) {
            // console.log(`Reservation expired for marketplace contractor: ${contractor.name}`);
            (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.reservedContractors = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.reservedContractors.filter(function(c) {
                return c.id !== contractor.id;
            });
        });
        // Update displays
        if (Alpine.store("contractors")) Alpine.store("contractors").updateReserved((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.reservedContractors);
        (0, $3f29ea4265abff3b$export$b70ccd83fb3eaefa)();
        (0, $3f29ea4265abff3b$export$68c4600b33dd0ca8)();
        (0, $59924438766e7d8e$export$d1c957a54f7124bc)();
        (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)("".concat(expiredContractors.length, " contractor reservation(s) expired"), "info");
        return true;
    } else return false;
}
function $670e0f14fa02ad13$export$1b23387deaaf022d() {
    var now = Date.now();
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.reservedContractors.forEach(function(contractor) {
        if (contractor.id > 0 && contractor.reservationExpires) {
            var timerElement = document.getElementById("reservation-timer-".concat(contractor.id));
            if (timerElement) {
                var timeLeft = Math.max(0, Math.floor((contractor.reservationExpires - now) / 1000));
                var minutes = Math.floor(timeLeft / 60);
                var seconds = timeLeft % 60;
                timerElement.textContent = "".concat(minutes, ":").concat(seconds.toString().padStart(2, "0"));
            }
        }
    });
}



//done
//@ts-check















function $8036d62b47ca0907$export$7532162a9c4df7a1() {
    // Alpine.js Contractor Store
    (0, $da6f71b8677b901e$export$2e2bcd8739ae039).store('contractors', {
        list: [],
        reserved: [],
        hired: [],
        init: function() {
            // Initialize with current gameState data
            this.refresh();
        },
        refresh: function() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                var _;
                return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            // Update store from gameState (AI contractors) + marketplace contractors
                            _ = this;
                            return [
                                4,
                                (0, $670e0f14fa02ad13$export$362d4c3fa8c04b4b)()
                            ];
                        case 1:
                            _.list = _state.sent();
                            // console.log('Contractors refreshed, total contractors:', this.list.length, this.list);
                            this.reserved = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.reservedContractors || [];
                            this.hired = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.hiredContractors || [];
                            // Update status on all contractor objects
                            this.updateContractorStatuses();
                            return [
                                2
                            ];
                    }
                });
            }).call(this);
        },
        update: function(newContractors) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            // Update both gameState and Alpine store
                            (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).contractors = newContractors;
                            return [
                                4,
                                this.refresh()
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }).call(this);
        },
        updateReserved: function(newReserved) {
            // Update both gameState and Alpine store
            // console.log('Store updateReserved called with:', newReserved);
            (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.reservedContractors = newReserved;
            this.reserved = newReserved;
            // console.log('Store reserved array updated to:', this.reserved);
            // Update status on all contractor objects
            this.updateContractorStatuses();
        },
        updateHired: function(newHired) {
            // Update both gameState and Alpine store
            (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.hiredContractors = newHired;
            this.hired = newHired;
            // Update status on all contractor objects
            this.updateContractorStatuses();
        },
        updateContractorStatuses: function() {
            // Create copies of contractors with status field for the store only
            var reservedIds = this.reserved.map(function(c) {
                return c.id;
            });
            var hiredIds = this.hired.map(function(c) {
                return c.id;
            });
            // Get current path skills and team skills for relevance calculation
            var pathSkills = (0, $1249ab814b7054d4$export$1311cf265aa89b71)();
            var teamSkills = (0, $1249ab814b7054d4$export$bf19dc1273cbd1a1)();
            this.list = this.list.map(function(contractor) {
                var contractorCopy = (0, $fa9769297b8a68c8$export$71511d61b312f219)({}, contractor);
                // Calculate status
                if (contractor.injuredUntil && contractor.injuredUntil > Date.now()) contractorCopy.status = 'injured';
                else if (hiredIds.includes(contractor.id)) contractorCopy.status = 'hired';
                else if (reservedIds.includes(contractor.id)) contractorCopy.status = 'reserved';
                else contractorCopy.status = 'available';
                // Calculate skill relevance indicators
                var contractorSkills = Object.keys(contractor.skills || {});
                var totalNeededSkills = contractorSkills.filter(function(skill) {
                    return pathSkills.has(skill);
                }).length;
                var uncoveredNeededSkills = contractorSkills.filter(function(skill) {
                    return pathSkills.has(skill) && (teamSkills[skill] || 0) === 0;
                }).length;
                var maxLevelNeededSkill = 0;
                contractorSkills.filter(function(skill) {
                    return pathSkills.has(skill) && (teamSkills[skill] || 0) === 0;
                }).forEach(function(skill) {
                    if (contractor.skills[skill] > maxLevelNeededSkill) maxLevelNeededSkill = contractor.skills[skill];
                });
                // Add relevance properties to contractor copy
                contractorCopy.totalNeededSkills = totalNeededSkills;
                contractorCopy.uncoveredNeededSkills = uncoveredNeededSkills;
                contractorCopy.hasNeededSkills = totalNeededSkills > 0;
                contractorCopy.hasUncoveredSkills = uncoveredNeededSkills > 0;
                contractorCopy.maxLevelNeededSkill = maxLevelNeededSkill;
                // Synergy relevance: ready (partner gear equipped on the
                // prospective team, or their gear partners your skills) vs
                // swap-possible (player owns an unequipped partner device)
                var synergy = (0, $e63b1e314d73680b$export$9163caedda99cb08)(contractor);
                contractorCopy.hasSynergyReady = synergy.hasReady;
                contractorCopy.hasSynergySwap = synergy.hasSwap;
                return contractorCopy;
            });
        },
        get all () {
            return this.list;
        },
        get allReserved () {
            return this.reserved;
        },
        get allHired () {
            return this.hired;
        },
        get count () {
            return this.list.length;
        },
        get reservedIds () {
            return this.reserved.map(function(c) {
                return c.id;
            });
        },
        get hiredIds () {
            return this.hired.map(function(c) {
                return c.id;
            });
        }
    });
}
function $8036d62b47ca0907$export$ecfe6fdf513f3742() {
    return {
        searchTerm: '',
        selectedFaction: '',
        selectedStatus: '',
        synergyFilter: '',
        get contractors () {
            // Use the Alpine store instead of direct gameState access
            return this.$store.contractors.all;
        },
        get synergyRevealed () {
            // The synergy filter only exists once the layer is revealed
            return (0, $df8a44d92d572a5c$export$aaee02d18e8a1c01)();
        },
        get reservedContractors () {
            // Use the Alpine store instead of direct gameState access
            return this.$store.contractors.allReserved;
        },
        get hiredContractors () {
            // Use the Alpine store instead of direct gameState access
            return this.$store.contractors.allHired;
        },
        get filteredContractors () {
            var _this = this;
            var filtered = this.contractors;
            var hired = this.hiredContractors;
            var reserved = this.reservedContractors;
            // Search filter (name and skills)
            if (this.searchTerm) {
                var term = this.searchTerm.toLowerCase();
                filtered = filtered.filter(function(contractor) {
                    // Search name
                    if (contractor.name.toLowerCase().includes(term)) return true;
                    // Search skills
                    var skillNames = Object.entries(contractor.skills || {}).map(function(param) {
                        var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), key = _param[0], level = _param[1];
                        var skillInfo = _this.getSkillInfo(key, contractor.faction);
                        return skillInfo ? skillInfo.name : key;
                    }).join(' ').toLowerCase();
                    return skillNames.includes(term);
                });
            }
            // Faction filter
            if (this.selectedFaction) filtered = filtered.filter(function(contractor) {
                return contractor.faction === _this.selectedFaction;
            });
            // Status filter
            if (this.selectedStatus) filtered = filtered.filter(function(contractor) {
                var status = _this.getContractorStatus(contractor);
                return status === _this.selectedStatus;
            });
            // Synergy filter: 'ready' = partner gear already on the team (or
            // their gear partners your skills); 'possible' also counts
            // contractors one player gear swap away
            if (this.synergyFilter === 'ready') filtered = filtered.filter(function(c) {
                return c.hasSynergyReady;
            });
            else if (this.synergyFilter === 'possible') filtered = filtered.filter(function(c) {
                return c.hasSynergyReady || c.hasSynergySwap;
            });
            // console.log('Contractors filtered, total contractors:', filtered.length, filtered);
            return filtered;
        },
        get modalSortedContractors () {
            var reservedCount = this.$store.contractors.reserved.length;
            // console.log('modalSortedContractors called, reserved count:', reservedCount);
            // Filter to only available contractors for modal
            var available = this.filteredContractors.filter(function(contractor) {
                var isAvailable = contractor.status === 'available';
                var teamNotFull = reservedCount < 2;
                //console.log(`Contractor ${contractor.name}: status=${contractor.status}, teamNotFull=${teamNotFull}`);
                return isAvailable && teamNotFull;
            });
            // Sort by relevance using pre-calculated properties
            return available.sort(function(a, b) {
                // Primary sort: contractors with uncovered needed skills first
                if (a.uncoveredNeededSkills !== b.uncoveredNeededSkills) return b.uncoveredNeededSkills - a.uncoveredNeededSkills;
                // Secondary sort: level of uncovered needed skills
                if (a.maxLevelNeededSkill !== b.maxLevelNeededSkill) return b.maxLevelNeededSkill - a.maxLevelNeededSkill;
                // Tertiary sort: contractors with any needed skills
                if (a.totalNeededSkills !== b.totalNeededSkills) return b.totalNeededSkills - a.totalNeededSkills;
                // Quaternary sort: contractors with higher reward percentage
                return a.rewardPercentage - b.rewardPercentage;
            });
        },
        getContractorStatus: function(contractor) {
            // Return the pre-calculated status field
            return contractor.status || 'available';
        },
        getSkillInfo: function(skillKey, faction) {
            var _config_factionSkills_faction;
            return ((_config_factionSkills_faction = $979b99378be707cd$export$aeeef991191508e2[faction]) === null || _config_factionSkills_faction === void 0 ? void 0 : _config_factionSkills_faction.skills[skillKey]) || null;
        },
        createContractorCardHTML: function(contractor) {
            return (0, $670e0f14fa02ad13$export$5464865996ba2eb4)(contractor, 'main');
        },
        clearFilters: function() {
            this.searchTerm = '';
            this.selectedFaction = '';
            this.selectedStatus = '';
            this.synergyFilter = '';
        },
        // Force refresh contractors from gameState
        refreshContractors: function() {
            // Trigger reactivity by accessing the getter
            this.contractors;
            this.$nextTick();
        },
        // Refresh contractors when the component is initialized or updated
        init: function() {
            var _this = this;
            // Initial refresh
            this.refreshContractors();
            // Make sure store is initialized with current data
            this.$store.contractors.refresh();
            // console.log('Initial store state - reserved:', this.$store.contractors.reserved);
            // Watch for game state changes and refresh
            this.$watch('contractors', function() {
                _this.$nextTick(function() {
                    // Ensure event handlers are attached to new elements
                    $8036d62b47ca0907$export$6df34f7d682befe6();
                });
            });
            // Watch for reserved contractors changes in the store
            this.$watch('$store.contractors.reserved', function(newValue, oldValue) {
                // console.log('Reserved contractors changed in store from', oldValue, 'to', newValue);
                _this.$store.contractors.updateContractorStatuses();
                _this.$nextTick();
            });
            // Watch for hired contractors changes in the store
            this.$watch('$store.contractors.hired', function(newValue, oldValue) {
                // console.log('Hired contractors changed in store from', oldValue, 'to', newValue);
                _this.$store.contractors.updateContractorStatuses();
                _this.$nextTick();
            });
        }
    };
}
function $8036d62b47ca0907$export$6df34f7d682befe6() {
    // Reattach click handlers for contractor buttons
    document.querySelectorAll('.contractor-card .hire-btn').forEach(function(btn) {
        var contractorId = btn.getAttribute('data-contractor-id');
        if (contractorId) btn.onclick = function() {
            return (0, $670e0f14fa02ad13$export$dc7fd448e3805128)(contractorId);
        };
    });
}
function $8036d62b47ca0907$export$17502054442d56b0() {
    // Update the Alpine store with current gameState data
    if ((0, $da6f71b8677b901e$export$2e2bcd8739ae039).store('contractors')) (0, $da6f71b8677b901e$export$2e2bcd8739ae039).store('contractors').refresh();
}







/**
 * Command - UI layer for the Command prestige layer (M2)
 *
 * Pure logic lives in command-core.js; this module renders the Command tab
 * (stats strip, upgrade roster, Legends gallery), the promote modal, and the
 * Regional Charter region-pick modal, and wires the header marks chip + tab
 * reveal. Player-facing verb is always promote/promotion.
 */ 













/**
 * The Legend card — one renderer, used by Command's gallery and the Syndicate
 * Charter's leadership panel.
 *
 * Its own module rather than living in either layer's UI file, because both
 * would otherwise have to import the other. Pure render: no gameState reads, no
 * DOM writes, so it can be dropped into any container.
 *
 * FIELDS ARE OPTIONAL BY DESIGN. A Command Legend snapshot carries the full tour
 * record (tech gear, artifacts, T3 wins); a Syndicate Leader snapshot carries
 * only the identity and the marks that elected them. Rendering only what is
 * present is what lets one card serve both, rather than two cards drifting.
 *
 * Colour comes in as `accent`/`accentDim` — the layers have different identity
 * colours and the card is the same object in both.
 */ 

/**
 * One stat line, or nothing when the field is absent.
 *
 * Values are coloured with an inline style, NOT `text-[${accent}]`. That was a
 * Tailwind arbitrary-value class built from a runtime variable, so the
 * build-time scanner never generated it — there is not a single `text-[#...]`
 * rule in the compiled CSS, and every Legend stat rendered unstyled. Same family
 * as the dead `text-navy`. Runtime colour has to be an inline style.
 */ function $1b36c0b1091d5de9$var$statLine(label, value, accent) {
    if (value === undefined || value === null) return '';
    return "".concat(label, ': <span class="tracking-tighter" style="color:').concat(accent, '">').concat(value, "</span><br/>");
}
function $1b36c0b1091d5de9$export$5eeeb728aab285f9(legend) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, accent = _ref.accent, accentDim = _ref.accentDim, _ref_title = _ref.title, title = _ref_title === void 0 ? '' : _ref_title, _ref_note = _ref.note, note = _ref_note === void 0 ? '' : _ref_note;
    if (!legend) return '';
    var faction = $979b99378be707cd$export$aeeef991191508e2[legend.faction] || {};
    var marks = (legend.marksEarned || 0).toLocaleString();
    return '\n        <div class="flex gap-3 bg-white/5 rounded-lg p-3" style="border:1px solid '.concat(accentDim, ';">\n            <div class="relative w-[96px] h-[96px] flex-shrink-0 rounded-lg border-2 border-gray-500 bg-gradient-to-b from-gray-800 to-gray-900 overflow-hidden">\n                <div class="absolute inset-0 flex items-center justify-center">\n                    <div class="contractor-avatar-placeholder" data-avatar-seed="').concat((0, $ca7af38ea7b7b4a8$export$f3619081e7e8f116)(legend), '" data-avatar-faction="').concat(legend.faction, '"></div>\n                </div>\n                <div class="absolute top-1 left-1 bg-black bg-opacity-40 border border-gray-500 rounded-full w-5 h-5 flex items-center justify-center text-xs" title="').concat(faction.name || legend.faction, '">').concat(faction.icon || "\uD83C\uDFE2", "</div>\n                ").concat(legend.tour ? '<div class="absolute bottom-0 left-0 right-0 text-center text-[10px] tracking-widest py-0.5 bg-black/75" style="color:'.concat(accent, '">TOUR ').concat(legend.tour, "</div>") : '', '\n            </div>\n            <div class="text-xs leading-relaxed min-w-0">\n                ').concat(title ? '<div class="text-[10px] uppercase tracking-widest text-gray-400">'.concat(title, "</div>") : '', '\n                <div class="font-bold text-white text-base">').concat(legend.name, "</div>\n                ").concat(legend.promotedRole ? 'Now: <span class="font-bold" style="color:'.concat(accent, '">').concat(legend.promotedRole, "</span><br/>") : '', "\n                ").concat($1b36c0b1091d5de9$var$statLine('Max Lv.', legend.level, accent), "\n                ").concat($1b36c0b1091d5de9$var$statLine('Skill Gear', legend.techGear === undefined ? undefined : "".concat(legend.techGear, "/15 crafted"), accent), "\n                ").concat($1b36c0b1091d5de9$var$statLine('Artifacts Unlocked', legend.artifactsUnlocked, accent), "\n                ").concat($1b36c0b1091d5de9$var$statLine('Artifacts Crafted', legend.artifactsCrafted, accent), "\n                ").concat($1b36c0b1091d5de9$var$statLine('T3 Successful', legend.t3Wins, accent), '\n                <span class="text-game-gold tracking-tighter">Tour Marks: ').concat(marks, "\uD83C\uDF96\uFE0F</span>\n                ").concat(note ? '<div class="text-gray-400 mt-1">'.concat(note, "</div>") : '', "\n            </div>\n        </div>");
}





/**
 * Raid Path Core - pure grid pathfinding shared by the game and simulator.
 *
 * Extracted from the simulator's battle-tested player model for the
 * Auto-Scout Command upgrade: BFS start→exit maximizing (in order)
 * character skill match, special-room placement (water before campsite,
 * both near mid-path), encounter count, then path length. Encounter rooms
 * (gate/hazard) are capped at rows+cols-1; traversal rooms are free.
 */ /**
 * Score special-room placement: water before campsite, both near the middle.
 */ 

function $afe3fe5fbf223eb0$export$307e743d4e5af7c0(path) {
    var waterIndex = -1;
    var campsiteIndex = -1;
    for(var i = 0; i < path.length; i++){
        var _path_i_room, _path_i_room1;
        if (((_path_i_room = path[i].room) === null || _path_i_room === void 0 ? void 0 : _path_i_room.type) === 'water' && waterIndex === -1) waterIndex = i;
        if (((_path_i_room1 = path[i].room) === null || _path_i_room1 === void 0 ? void 0 : _path_i_room1.type) === 'campsite' && campsiteIndex === -1) campsiteIndex = i;
    }
    var pathLength = path.length;
    var midpoint = pathLength / 2;
    var tolerance = pathLength * 0.25;
    var score = 0;
    // Each special room is a free benefit (fishing / healing) worth grabbing
    // whenever it adds no encounters. Keep every contribution strictly
    // NON-NEGATIVE so the pathfinder never rejects a free detour: the old
    // wrong-order penalty (-500) could make a free water+campsite detour score
    // worse than skipping it, so auto-scout would walk past free healing.
    if (waterIndex !== -1) score += 500 + Math.max(0, tolerance - Math.abs(waterIndex - midpoint)) * 10;
    if (campsiteIndex !== -1) score += 500 + Math.max(0, tolerance - Math.abs(campsiteIndex - midpoint)) * 10;
    // Prefer drinking (water) before resting (campsite) when both are present,
    // but only as a small tie-breaker between paths that already grab both -
    // never a penalty that would reject a free room.
    if (waterIndex !== -1 && campsiteIndex !== -1 && waterIndex < campsiteIndex) score += 100;
    return score;
}
function $afe3fe5fbf223eb0$export$ae716df5a29b8f48(room, characterSkills, skillTargets) {
    var type = room === null || room === void 0 ? void 0 : room.type;
    if (type !== 'gate' && type !== 'hazard') return 0;
    // Without skill targets every encounter is worth exactly 1, which makes the
    // running score identical to the old raw encounter count - so callers that
    // do not opt in get byte-for-byte the previous pathfinding.
    if (!skillTargets) return 1;
    // Expected skill events per room (gate 2-4, hazard 1-2).
    var exposure = type === 'gate' ? 3 : 1.5;
    var target = type === 'gate' ? skillTargets.gate : skillTargets.hazard;
    var skill = (characterSkills === null || characterSkills === void 0 ? void 0 : characterSkills[room.primary]) || 0;
    var deficit = Math.max(0, target - skill);
    // At or above the bar the room is worth taking: it is loot the team can
    // reach. Below it, each missing level costs ~5% per event, so the penalty
    // scales with both the shortfall and the number of rolls.
    return deficit === 0 ? exposure : -exposure * deficit;
}
function $afe3fe5fbf223eb0$export$f43380d00e970f98(path, characterSkills, skillTargets) {
    var score = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = path[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var step = _step.value;
            score += $afe3fe5fbf223eb0$export$ae716df5a29b8f48(step.room, characterSkills, skillTargets);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return score;
}
function $afe3fe5fbf223eb0$export$fe54d8e6fd3d69ac(path, characterSkills) {
    if (!characterSkills) return 0;
    var score = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = path[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var step = _step.value;
            if (!step.room || step.room.type === 'blocked') continue;
            if (!step.room.primary) continue;
            var primarySkillLevel = characterSkills[step.room.primary] || 0;
            if (primarySkillLevel > 0) score += 100 + primarySkillLevel * 10;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            if (step.room.support && Array.isArray(step.room.support)) try {
                for(var _iterator1 = step.room.support[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var supportSkill = _step1.value;
                    var supportSkillLevel = characterSkills[supportSkill] || 0;
                    if (supportSkillLevel > 0) score += 30 + supportSkillLevel * 5;
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return score;
}
function $afe3fe5fbf223eb0$export$4c0915d8c3abf5d2(path, wantedCells) {
    if (!wantedCells || wantedCells.size === 0) return 0;
    var score = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = path[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var step = _step.value;
            if (wantedCells.has("".concat(step.row, ",").concat(step.col))) score++;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return score;
}
var $afe3fe5fbf223eb0$var$TRAVERSAL_TYPES = new Set([
    'road',
    'water',
    'campsite',
    'start',
    'exit'
]);
var $afe3fe5fbf223eb0$var$isSpecialType = function(t) {
    return t === 'water' || t === 'campsite';
};
var $afe3fe5fbf223eb0$var$isEncounterType = function(t) {
    return t === 'gate' || t === 'hazard';
};
/**
 * Shortest free "leg" from A to B through unused traversal cells (road / water /
 * campsite - never gate/hazard) that passes through at least one special room.
 * Returns the intermediate cells [{row,col,room}] or null. `blocked` is the set
 * of "row,col" keys the leg may not step on (committed path cells).
 */ function $afe3fe5fbf223eb0$var$findFreeSpecialLeg(grid, A, B, blocked, maxLen) {
    var rows = grid.rows, cols = grid.cols;
    var dirs = [
        [
            -1,
            0
        ],
        [
            1,
            0
        ],
        [
            0,
            -1
        ],
        [
            0,
            1
        ]
    ];
    var seen = new Set([
        "".concat(A.row, ",").concat(A.col, ",0")
    ]);
    var queue = [
        {
            row: A.row,
            col: A.col,
            specials: 0,
            cells: []
        }
    ];
    var best = null; // legs reaching B: keep the one grabbing the MOST specials (then shortest)
    while(queue.length > 0){
        var cur = queue.shift();
        if (cur.cells.length >= maxLen) continue;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var _step_value = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step.value, 2), dr = _step_value[0], dc = _step_value[1];
                var _grid_grid_nr;
                var nr = cur.row + dr, nc = cur.col + dc;
                if (nr < 0 || nc < 0 || nr >= rows || nc >= cols) return "continue";
                var room = (_grid_grid_nr = grid.grid[nr]) === null || _grid_grid_nr === void 0 ? void 0 : _grid_grid_nr[nc];
                if (!room) return "continue";
                if (nr === B.row && nc === B.col) {
                    if (cur.specials > 0 && cur.cells.length > 0 && (!best || cur.specials > best.specials || cur.specials === best.specials && cur.cells.length < best.cells.length)) best = {
                        cells: cur.cells,
                        specials: cur.specials
                    };
                    return "continue" // reached B - don't route through it
                    ;
                }
                if (blocked.has("".concat(nr, ",").concat(nc))) return "continue";
                if (!$afe3fe5fbf223eb0$var$TRAVERSAL_TYPES.has(room.type)) return "continue" // never route a detour through an encounter
                ;
                if (cur.cells.some(function(c) {
                    return c.row === nr && c.col === nc;
                })) return "continue" // no intra-leg revisits
                ;
                var specials = cur.specials + ($afe3fe5fbf223eb0$var$isSpecialType(room.type) ? 1 : 0);
                var key = "".concat(nr, ",").concat(nc, ",").concat(specials);
                if (seen.has(key)) return "continue";
                seen.add(key);
                queue.push({
                    row: nr,
                    col: nc,
                    specials: specials,
                    cells: (0, $4c858c0d999a5b9b$export$71511d61b312f219)(cur.cells).concat([
                        {
                            row: nr,
                            col: nc,
                            room: room
                        }
                    ])
                });
            };
            for(var _iterator = dirs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return best ? best.cells : null;
}
function $afe3fe5fbf223eb0$export$c8e849ec9d7205c9(path, grid) {
    var _path_i_room;
    if (!path || path.length < 3 || !grid) return path;
    // Anchors are the rooms we must keep in order: start, exit, every encounter.
    var anchorIdx = [];
    for(var i = 0; i < path.length; i++)if (i === 0 || i === path.length - 1 || $afe3fe5fbf223eb0$var$isEncounterType((_path_i_room = path[i].room) === null || _path_i_room === void 0 ? void 0 : _path_i_room.type)) anchorIdx.push(i);
    if (anchorIdx.length < 2) return path;
    // All original cells are reserved; each segment frees only its OWN traversal
    // cells before rerouting, so a detour can reuse this segment's roads but never
    // steal another segment's cells.
    var committed = new Set(path.map(function(s) {
        return "".concat(s.row, ",").concat(s.col);
    }));
    var result = [
        path[anchorIdx[0]]
    ];
    for(var a = 0; a < anchorIdx.length - 1; a++){
        var startI = anchorIdx[a], endI = anchorIdx[a + 1];
        var A = path[startI], B = path[endI];
        for(var k = startI + 1; k < endI; k++)committed.delete("".concat(path[k].row, ",").concat(path[k].col));
        var segLen = endI - startI - 1;
        // Allow the reroute to run up to 6 rooms longer than the straight stretch:
        // enough to thread BOTH the water and the adjacent campsite (a 2-cell pair)
        // plus a few connector roads, without wandering far for a distant special.
        var leg = $afe3fe5fbf223eb0$var$findFreeSpecialLeg(grid, A, B, committed, segLen + 6);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (leg) try {
            for(var _iterator = leg[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var c = _step.value;
                result.push(c);
                committed.add("".concat(c.row, ",").concat(c.col));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        else for(var k1 = startI + 1; k1 < endI; k1++){
            result.push(path[k1]);
            committed.add("".concat(path[k1].row, ",").concat(path[k1].col));
        }
        result.push(B);
    }
    return result;
}
function $afe3fe5fbf223eb0$export$bbcc6782bce81af0(currentRaidGrid, startPos, endPos, characterSkills) {
    var _loop = function() {
        var _queue_shift = queue.shift(), pos = _queue_shift.pos, path = _queue_shift.path, encounterCount = _queue_shift.encounterCount, encounterScore = _queue_shift.encounterScore;
        var cellKey = "".concat(pos.row, ",").concat(pos.col);
        if (pos.row === endPos.row && pos.col === endPos.col) {
            var wantedScore = $afe3fe5fbf223eb0$export$4c0915d8c3abf5d2(path, wantedCells);
            var specialRoomsScore = $afe3fe5fbf223eb0$export$307e743d4e5af7c0(path);
            var skillMatchScore = $afe3fe5fbf223eb0$export$fe54d8e6fd3d69ac(path, characterSkills);
            // Lexicographic: wanted loot > skill match > special rooms > encounters > length
            var candidate = [
                wantedScore,
                skillMatchScore,
                specialRoomsScore,
                encounterScore,
                path.length
            ];
            var best = [
                bestWantedScore,
                bestSkillMatchScore,
                bestSpecialRoomsScore,
                bestEncounterScore,
                bestPathLength
            ];
            var better = candidate.findIndex(function(v, i) {
                return v !== best[i];
            });
            if (better !== -1 && candidate[better] > best[better]) {
                bestWantedScore = wantedScore;
                bestSkillMatchScore = skillMatchScore;
                bestSpecialRoomsScore = specialRoomsScore;
                bestEncounterScore = encounterScore;
                bestPathLength = path.length;
                bestExitPath = path;
            }
            return "continue";
        }
        // Keep the best-VALUED route to each cell, not the one with the most
        // encounter rooms. These are the same thing without skillTargets (every
        // encounter scores 1), but once rooms are risk-weighted a safer route must
        // be able to survive here - pruning on raw count discarded it before the
        // ranking below ever saw it, which is why weighting alone changed nothing.
        if (visited.has(cellKey)) {
            var prev = visited.get(cellKey);
            if (encounterScore < prev.encounterScore || encounterScore === prev.encounterScore && path.length <= prev.pathLength) return "continue";
        }
        visited.set(cellKey, {
            path: path,
            encounterCount: encounterCount,
            encounterScore: encounterScore,
            pathLength: path.length
        });
        if (encounterCount > maxPathLength) return "continue";
        var directions = [
            {
                row: -1,
                col: 0
            },
            {
                row: 1,
                col: 0
            },
            {
                row: 0,
                col: -1
            },
            {
                row: 0,
                col: 1
            }
        ];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var dir = _step.value;
                var newRow = pos.row + dir.row;
                var newCol = pos.col + dir.col;
                if (newRow < 0 || newRow >= rows || newCol < 0 || newCol >= cols) return "continue";
                if (path.some(function(p) {
                    return p.row === newRow && p.col === newCol;
                })) return "continue";
                var room = currentRaidGrid.grid[newRow][newCol];
                if (!room || room.type === 'blocked') return "continue";
                var newEncounterCount = countsTowardLimit.has(room.type) ? encounterCount + 1 : encounterCount;
                if (newEncounterCount > maxPathLength) return "continue";
                queue.push({
                    pos: {
                        row: newRow,
                        col: newCol
                    },
                    path: (0, $4c858c0d999a5b9b$export$71511d61b312f219)(path).concat([
                        {
                            row: newRow,
                            col: newCol,
                            room: room
                        }
                    ]),
                    encounterCount: newEncounterCount,
                    encounterScore: encounterScore + $afe3fe5fbf223eb0$export$ae716df5a29b8f48(room, characterSkills, skillTargets)
                });
            };
            for(var _iterator = directions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
    var wantedCells = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, skillTargets = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null;
    var _startStep_room;
    var rows = currentRaidGrid.rows;
    var cols = currentRaidGrid.cols;
    // Max encounters based on grid dimensions (only gate/hazard count)
    var maxPathLength = (rows || currentRaidGrid.size) + (cols || currentRaidGrid.size) - 1;
    var countsTowardLimit = new Set([
        'gate',
        'hazard'
    ]);
    var startStep = {
        row: startPos.row,
        col: startPos.col,
        room: currentRaidGrid.grid[startPos.row][startPos.col]
    };
    var visited = new Map(); // "row,col" -> { path, encounterCount, pathLength }
    var queue = [
        {
            pos: startPos,
            path: [
                startStep
            ],
            encounterCount: countsTowardLimit.has((_startStep_room = startStep.room) === null || _startStep_room === void 0 ? void 0 : _startStep_room.type) ? 1 : 0,
            // Running risk-weighted value of the encounters taken so far. Carried
            // incrementally (rather than rescored per candidate) so it can drive the
            // visited-pruning below without an O(path) cost at every node.
            encounterScore: $afe3fe5fbf223eb0$export$ae716df5a29b8f48(startStep.room, characterSkills, skillTargets)
        }
    ];
    var bestExitPath = null;
    var bestEncounterScore = -Infinity;
    var bestPathLength = -1;
    var bestSpecialRoomsScore = -Infinity;
    var bestSkillMatchScore = -Infinity;
    var bestWantedScore = -Infinity;
    while(queue.length > 0)_loop();
    return bestExitPath || [];
}


/**
 * Auto-Raid Protocol (M3 S3a) — runs the L1 loop hands-off.
 *
 * The raid itself is already timer-driven; this automates the button clicks
 * around it. One cycle is: generate grid → chart a path (Auto-Scout) → staff it
 * (Foreman's Ledger) → RE-TOOL → launch → wait → collect → repeat.
 *
 * TICK-DRIVEN, NOT AN ASYNC CHAIN. Each tick advances at most one step and
 * decides what to do purely from `gameState`, so a reload mid-raid resumes
 * correctly, a player taking manual control is noticed on the next tick, and
 * there is no long-lived promise holding a stale view of the world. The cost is
 * that this reads as a state machine rather than a script; that is the point.
 *
 * WHY THE RE-TOOL STEP IS NOT OPTIONAL (docs/layers/3-syndicate/design.md §4.1):
 * gear coverage is not "one device per skill". Whether a synergy variant fires
 * depends on the pairing between the player's tooled technique and what the
 * hired crew brings, so a kit that synergised with the last crew may synergise
 * with none of this one's. A player does this by hand off the `swap` prompt.
 * Automating the raid WITHOUT automating the swap would make automation a
 * downgrade in loot quality — the upgrade would actively cost the player value.
 * Same argument for artifact slots, which are otherwise frozen at whatever was
 * crafted first.
 */ 











var $2f2faed8b0830fbf$export$c4294a4a90e8256d = 0.5;
/** Guards against two cycles overlapping while an await is in flight. */ var $2f2faed8b0830fbf$var$stepInFlight = false;
function $2f2faed8b0830fbf$export$d386ff630e305d9f() {
    return (0, $ee71dfe8b201c427$export$12c456cbb12a94a8)('auto-raid-protocol') > 0;
}
function $2f2faed8b0830fbf$export$c750660aba17086b() {
    var _gameState_settings;
    return $2f2faed8b0830fbf$export$d386ff630e305d9f() && ((_gameState_settings = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).settings) === null || _gameState_settings === void 0 ? void 0 : _gameState_settings.autoRaidEnabled) === true;
}
function $2f2faed8b0830fbf$export$c790bcc16caca94(enabled) {
    if (!(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).settings) (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).settings = {};
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).settings.autoRaidEnabled = !!enabled;
    (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
    return (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).settings.autoRaidEnabled;
}
function $2f2faed8b0830fbf$export$18302fe48a4c0c92() {
    var character = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character;
    if (!character) return {
        code: 'no-character',
        text: 'No active character'
    };
    if (character.isAlive === false) return {
        code: 'character-down',
        text: 'Your character is down'
    };
    if (character.isMarketplace || character.marketplaceData) return {
        code: 'listed',
        text: 'Character is listed on the marketplace'
    };
    var raid = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid || {};
    if (raid.raidOwnerId && raid.raidOwnerId !== (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).activeCharacterId) return {
        code: 'not-owner',
        text: 'Another character owns the current raid'
    };
    // Blackouts are DELIBERATE challenge content: the whole point is a player
    // choosing to run under hard modifiers. Automation clearing one would pay a
    // permanent perk for a decision nobody made — and Lights Out disables the
    // Auto-Scout this loop depends on, so it could not run it anyway.
    if ((0, $686e361e5cd4549d$export$f266a4caac7fb67d)()) return {
        code: 'blackout-armed',
        text: "Blackout contract armed \u2014 challenge raids are run by hand"
    };
    if (!raid.selectedRegion || !raid.selectedTier) // Deliberately NOT auto-picked. Region and tier are the player's
    // standing orders — the automation executes them, it does not choose
    // them, and silently raiding somewhere unintended is worse than idling.
    return {
        code: 'no-orders',
        text: "Pick a region and tier \u2014 automation runs those orders"
    };
    var team = $2f2faed8b0830fbf$var$raidTeam();
    var hpFraction = $2f2faed8b0830fbf$var$teamHpFraction(team);
    if (hpFraction < $2f2faed8b0830fbf$export$c4294a4a90e8256d) return {
        code: 'low-hp',
        text: "Team at ".concat(Math.round(hpFraction * 100), "% HP \u2014 resting")
    };
    return null;
}
function $2f2faed8b0830fbf$var$raidTeam() {
    var _gameState_currentRaid;
    var hired = ((_gameState_currentRaid = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid) === null || _gameState_currentRaid === void 0 ? void 0 : _gameState_currentRaid.hiredContractors) || [];
    return [
        (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character
    ].concat((0, $4c858c0d999a5b9b$export$71511d61b312f219)(hired)).filter(Boolean);
}
function $2f2faed8b0830fbf$var$teamHpFraction(team) {
    var max = team.reduce(function(sum, m) {
        return sum + (m.maxHp || 0);
    }, 0);
    if (max <= 0) return 1;
    return team.reduce(function(sum, m) {
        return sum + (m.currentHp || 0);
    }, 0) / max;
}
function $2f2faed8b0830fbf$export$7db30007ec79b8c() {
    var raid = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid || {};
    if (!raid.selectedPath || raid.selectedPath.length < 2 || !raid.selectedTier) return null;
    return (0, $1249ab814b7054d4$export$78de3bc967b7be)(raid.selectedTier, raid.selectedPath);
}
/**
 * Stop automation and tell the player why.
 *
 * Sticky on purpose: automation stopping is the one thing an idle player must
 * not miss — the whole value of the upgrade is not having to watch it, so a
 * message that fades in 5s would strand them doing nothing for hours.
 */ function $2f2faed8b0830fbf$var$haltWith(message) {
    $2f2faed8b0830fbf$export$c790bcc16caca94(false);
    (0, $b5bda7fdec806d8b$export$c7def531c087da85)("\uD83E\uDD16 Auto-Raid stopped \u2014 ".concat(message), 'warning', {
        sticky: true
    });
}
function $2f2faed8b0830fbf$export$9f0fd7c5580c292() {
    var _gameState_player;
    if (!$2f2faed8b0830fbf$export$c750660aba17086b() || $2f2faed8b0830fbf$export$18302fe48a4c0c92()) return false;
    var cost = $2f2faed8b0830fbf$export$7db30007ec79b8c();
    return cost != null && (((_gameState_player = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player) === null || _gameState_player === void 0 ? void 0 : _gameState_player.energy) || 0) < cost;
}
function $2f2faed8b0830fbf$export$8e2efb5378addfbb(api) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var raid, blocked, cost;
        return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!$2f2faed8b0830fbf$export$c750660aba17086b() || $2f2faed8b0830fbf$var$stepInFlight) return [
                        2
                    ];
                    raid = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid || {};
                    // A raid is running: the existing timers own it. Nothing to do.
                    if (raid.raidInProgress) return [
                        2
                    ];
                    // A finished raid is waiting to be collected.
                    if (raid.raidCompleted) {
                        $2f2faed8b0830fbf$var$stepInFlight = true;
                        try {
                            api.resetRaid();
                            (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
                            (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).raid, 'Auto-Raid: collected completed raid');
                            // Succession Doctrine rides on the same moment: the rate was just
                            // re-evaluated at raid end, and promotion needs the raid cleared
                            // (canPromoteCore blocks on raid state), which resetRaid just did.
                            if ((0, $e39e78d7c65dc336$export$40d6ac4f92fd7c1c)() && (0, $e39e78d7c65dc336$export$8f29b06b79596501)().due && api.promoteAndSucceed) api.promoteAndSucceed((0, $e39e78d7c65dc336$export$8f29b06b79596501)());
                        } finally{
                            $2f2faed8b0830fbf$var$stepInFlight = false;
                        }
                        return [
                            2
                        ];
                    }
                    blocked = $2f2faed8b0830fbf$export$18302fe48a4c0c92();
                    if (blocked) {
                        // Transient states (mid-heal, no character yet) should pause rather than
                        // switch the feature off — only genuinely player-resolvable states halt.
                        if (blocked.code === 'low-hp') return [
                            2
                        ];
                        $2f2faed8b0830fbf$var$haltWith(blocked.text);
                        return [
                            2
                        ];
                    }
                    $2f2faed8b0830fbf$var$stepInFlight = true;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        ,
                        5,
                        6
                    ]);
                    // 1. Grid.
                    if (!raid.currentRaidGrid) {
                        api.generateGrid();
                        (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).raid, 'Auto-Raid: generated grid');
                        return [
                            2
                        ];
                    }
                    // 2. Path.
                    if (!raid.selectedPath || raid.selectedPath.length < 2) {
                        api.autoScoutPath();
                        if (!(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath || (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath.length < 2) $2f2faed8b0830fbf$var$haltWith('could not chart a route');
                        return [
                            2
                        ];
                    }
                    // 3. Energy, checked once the path exists because the cost depends on it.
                    cost = $2f2faed8b0830fbf$export$7db30007ec79b8c();
                    if (cost != null && ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player.energy || 0) < cost) // Not a halt: energy regenerates, so this is the normal idle state
                    // between raids and the cycle resumes on its own.
                    return [
                        2
                    ];
                    if (!((raid.reservedContractors || []).length < 2 && ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).contractors || []).length > 0)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        api.autoReserveContractors()
                    ];
                case 2:
                    _state.sent();
                    // Deliberately no halt on failure — raiding solo is worse than
                    // raiding with one contractor, but both beat not raiding at all.
                    return [
                        2
                    ];
                case 3:
                    // 5. Re-tool for THIS crew, then launch. These two run in the same step
                    //    as the launch so the kit can never be one raid stale.
                    $2f2faed8b0830fbf$export$8c1031c7d77204c1();
                    // `automated` selects the headless auto-grant presenters for this raid:
                    // nobody is watching to click a 💎 or a 🐟, so the collectible would
                    // expire and take its loot with it. Passed as an argument rather than
                    // read from state inside raid.js on purpose — raid.js importing this
                    // module closes a cycle (raid -> autoRaid -> gameState -> raid) that
                    // silently breaks boot.
                    return [
                        4,
                        api.startRaid({
                            automated: true
                        })
                    ];
                case 4:
                    _state.sent();
                    (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).raid, 'Auto-Raid: launched');
                    return [
                        3,
                        6
                    ];
                case 5:
                    $2f2faed8b0830fbf$var$stepInFlight = false;
                    return [
                        7
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    })();
}
function $2f2faed8b0830fbf$export$8c1031c7d77204c1() {
    var _gameState_currentRaid, _gameState_currentRaid_reservedContractors, _gameState_currentRaid1, _gameState_currentRaid2;
    var character = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character;
    if (!character) return;
    var path = ((_gameState_currentRaid = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid) === null || _gameState_currentRaid === void 0 ? void 0 : _gameState_currentRaid.selectedPath) || [];
    var crew = ((_gameState_currentRaid1 = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid) === null || _gameState_currentRaid1 === void 0 ? void 0 : (_gameState_currentRaid_reservedContractors = _gameState_currentRaid1.reservedContractors) === null || _gameState_currentRaid_reservedContractors === void 0 ? void 0 : _gameState_currentRaid_reservedContractors.length) ? (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.reservedContractors : ((_gameState_currentRaid2 = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid) === null || _gameState_currentRaid2 === void 0 ? void 0 : _gameState_currentRaid2.hiredContractors) || [];
    (0, $e63b1e314d73680b$export$b8366d52640d9f9)(character, path, crew);
    (0, $b50c9da22720ec3b$export$5f6199e96a03905b)(character);
}


/**
 * Auto-Fabricator (M3) — runs the workshop hands-off.
 *
 * The selection is in `autoFabricator-core.js`, which is pure and headless.
 * This file is the part that touches the game: it calls the same crafting
 * functions the player's own buttons call, so an automated craft and a manual
 * one are the same event — same marks, same notifications, same save.
 *
 * SEPARATE FROM AUTO-RAID ON PURPOSE. Auto-Fabricator is its own Command
 * upgrade and a player can own it without owning Auto-Raid Protocol, so it gets
 * its own tick rather than a step inside the raid cycle.
 *
 * ONE CRAFT PER TICK, whenever it is switched on — see `autoFabricatorTick` for
 * why it does not wait for an "idle" window, which is a mistake this shipped
 * with for a day.
 */ 

/**
 * Auto-Fabricator (M3) — what the workshop should build next. Pure, no DOM.
 *
 * WHY THIS UPGRADE EXISTS: marks come from crafting. Measured on a late-game
 * character, tech gear + artifact unlocks + artifact crafts are 111 of 157
 * marks — 71%. Auto-Raid Protocol automates the raid and nothing else, so a
 * hands-off character earned under a third of a tour's marks, and
 * `succession-doctrine` (which promotes on the marks RATE) was automating that
 * trickle. Raid → craft → marks → promote is the loop; this is the second step.
 *
 * ONE DECISION PER CALL, deliberately. The caller crafts it and comes back next
 * tick, so a deep component tree is walked one item at a time and the player
 * watches it build rather than finding it done. It also means a craft that
 * fails for a reason this module cannot see costs one tick, not a loop.
 *
 * PRIORITY, cheapest-marks-first:
 *   1. unlock   — an owned blueprint for a design not yet unlocked. Free: costs
 *                 the blueprint, no materials, no credits, and unlocks are the
 *                 single largest marks line (75 of the 157 above).
 *   2. artifact — an unlocked, faction-legal design this character has not
 *                 crafted. Distinct designs only: a duplicate earns no marks.
 *   3. gear     — tech gear this character does not own, or the deepest
 *                 component it still needs. Components are not marks
 *                 themselves; they are the only route to gear that is.
 *
 * WHAT IT WILL NOT DO, and each of these is a decision rather than an omission:
 *   - craft duplicates (no marks, and it would drain materials forever)
 *   - craft consumables (the player's call — they are spent, not accumulated)
 *   - craft toward a target it cannot finish (it takes the deepest step that is
 *     craftable NOW, so it never strands materials in a half-built tree)
 */ 




var $325425fbb9c40f26$export$681e702191fb2db1 = 'auto-fabricator';
function $325425fbb9c40f26$export$17068373f54d4cc4() {
    return (0, $ee71dfe8b201c427$export$12c456cbb12a94a8)($325425fbb9c40f26$export$681e702191fb2db1) > 0;
}
/** Blueprint item id for a design, matching `unlockArtifactCore`. */ var $325425fbb9c40f26$var$blueprintFor = function(artifactId) {
    return "".concat(artifactId, "-blueprint");
};
/** Faction-legal for this character? Neutral designs are legal for everyone. */ var $325425fbb9c40f26$var$factionAllows = function(character, thing) {
    return !(thing === null || thing === void 0 ? void 0 : thing.faction) || thing.faction === 'neutral' || thing.faction === (character === null || character === void 0 ? void 0 : character.faction);
};
function $325425fbb9c40f26$export$c2fff4ca1f762b21(targetId, character) {
    var seen = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : new Set();
    if (seen.has(targetId)) return null; // cycle guard, same as getCraftingTree
    seen.add(targetId);
    var recipe = (0, $37e67442be28b253$export$3645b25e1a815566)(targetId);
    if (!recipe) return null; // a raw drop: nothing to craft
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // Try the inputs first. If any input is short AND craftable, that is the
        // step to take now.
        for(var _iterator = recipe.inputs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var input = _step.value;
            var _character_inventory;
            var have = (character === null || character === void 0 ? void 0 : (_character_inventory = character.inventory) === null || _character_inventory === void 0 ? void 0 : _character_inventory[input.id]) || 0;
            if (have >= input.qty) continue;
            var step = $325425fbb9c40f26$export$c2fff4ca1f762b21(input.id, character, seen);
            if (step) return step;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return (0, $37e67442be28b253$export$10d9b633aa01c262)(recipe, character) ? targetId : null;
}
var $325425fbb9c40f26$var$_gameState_player_credits;
function $325425fbb9c40f26$export$6473dc4b900a5b32() {
    var character = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character, credits = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {
        var _gameState_player;
        return ($325425fbb9c40f26$var$_gameState_player_credits = (_gameState_player = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player) === null || _gameState_player === void 0 ? void 0 : _gameState_player.credits) !== null && $325425fbb9c40f26$var$_gameState_player_credits !== void 0 ? $325425fbb9c40f26$var$_gameState_player_credits : 0;
    }();
    if (!character) return null;
    var allowDuplicates = (0, $ee71dfe8b201c427$export$c95b8ce76efadccf)();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // 1. Unlocks. No materials, no credits — only a blueprint the character is
        //    already carrying, which is otherwise dead weight in the inventory.
        for(var _iterator = (0, $ca7af38ea7b7b4a8$export$18c4115a8e7963b)()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var artifact = _step.value;
            var _character_inventory;
            if (!$325425fbb9c40f26$var$factionAllows(character, artifact)) continue;
            if ((0, $ee71dfe8b201c427$export$2ab3ae91631fe8e5)(artifact.id)) continue;
            if ((((_character_inventory = character.inventory) === null || _character_inventory === void 0 ? void 0 : _character_inventory[$325425fbb9c40f26$var$blueprintFor(artifact.id)]) || 0) < 1) continue;
            return {
                kind: 'unlock',
                id: artifact.id
            };
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        // 2. Artifacts the character has not built. Materials only.
        for(var _iterator1 = (0, $ca7af38ea7b7b4a8$export$18c4115a8e7963b)()[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var artifact1 = _step1.value;
            if (!$325425fbb9c40f26$var$factionAllows(character, artifact1)) continue;
            if (!(0, $ee71dfe8b201c427$export$2ab3ae91631fe8e5)(artifact1.id)) continue;
            if (!allowDuplicates && (0, $ee71dfe8b201c427$export$770281d4afda41b1)(character, artifact1.id)) continue;
            var recipe = (0, $37e67442be28b253$export$3645b25e1a815566)(artifact1.id);
            if (recipe && (0, $37e67442be28b253$export$10d9b633aa01c262)(recipe, character)) return {
                kind: 'artifact',
                id: artifact1.id
            };
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined, _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
    try {
        // 3. Tech gear, and the components it is made of.
        //
        //    Walked via `getGearMatrix`, which is the character's OWN faction gear
        //    in the order the Gear page shows it — the fabricator then builds the
        //    kit in the order the player already reads it, and the order is stable
        //    across reloads. A flat item scan would not do: tech gear items carry
        //    no `faction` field (it is encoded by which catalog array they sit in),
        //    so scanning every item would happily spend materials on gear this
        //    character can never equip.
        for(var _iterator2 = (0, $b50c9da22720ec3b$export$75dc440158626230)(character.faction)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion3 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion3 = true){
            var techniques = _step2.value.techniques;
            try {
                for(var _iterator3 = techniques[Symbol.iterator](), _step3; !(_iteratorNormalCompletion2 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion2 = true){
                    var item = _step3.value.item;
                    if (!item) continue;
                    if (!allowDuplicates && (0, $ee71dfe8b201c427$export$2886ceaa061d802b)(character, item.id)) continue;
                    var step = $325425fbb9c40f26$export$c2fff4ca1f762b21(item.id, character);
                    if (!step) continue;
                    var cost = (0, $37e67442be28b253$export$e6fc872703f0201)(step);
                    // Credits gate components (artifact crafting is free). Skipping
                    // rather than halting: a cheaper target further down the matrix may
                    // still be affordable, and the raid loop keeps earning either way.
                    if (cost > credits) continue;
                    return {
                        kind: 'gear',
                        id: step,
                        cost: cost
                    };
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion2 && _iterator3.return != null) {
                        _iterator3.return();
                    }
                } finally{
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion3 && _iterator2.return != null) {
                _iterator2.return();
            }
        } finally{
            if (_didIteratorError3) {
                throw _iteratorError3;
            }
        }
    }
    return null;
}



function $7a60a8a88cdf0fcd$export$a0f4aa4561249df8() {
    var _gameState_settings;
    return (0, $325425fbb9c40f26$export$17068373f54d4cc4)() && ((_gameState_settings = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).settings) === null || _gameState_settings === void 0 ? void 0 : _gameState_settings.autoFabricatorEnabled) === true;
}
/**
 * What the last tick did — null when it found nothing worth building.
 *
 * Kept so the button can tell "on and working" from "on with nothing to build".
 * Not persisted: it describes this session's last tick, and a stale verdict read
 * from a save would be worse than none.
 */ var $7a60a8a88cdf0fcd$var$lastJob = null;
var $7a60a8a88cdf0fcd$var$hasTicked = false;
function $7a60a8a88cdf0fcd$export$273610d740a9bd65(enabled) {
    if (!(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).settings) (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).settings = {};
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).settings.autoFabricatorEnabled = !!enabled;
    // A fresh switch-on has not decided anything yet, so the button must not
    // show a verdict left over from the last time it ran.
    $7a60a8a88cdf0fcd$var$hasTicked = false;
    $7a60a8a88cdf0fcd$var$lastJob = null;
    (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
    return (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).settings.autoFabricatorEnabled;
}
function $7a60a8a88cdf0fcd$export$82e2837406d30fe2() {
    if (!(0, $325425fbb9c40f26$export$17068373f54d4cc4)()) return {
        state: 'unowned'
    };
    if (!$7a60a8a88cdf0fcd$export$a0f4aa4561249df8()) return {
        state: 'off'
    };
    var blocked = $7a60a8a88cdf0fcd$export$b71b3d68892c51f2();
    if (blocked) return {
        state: 'blocked',
        reason: blocked.text
    };
    if ($7a60a8a88cdf0fcd$var$hasTicked && !$7a60a8a88cdf0fcd$var$lastJob) return {
        state: 'nothing'
    };
    return {
        state: 'working'
    };
}
function $7a60a8a88cdf0fcd$export$b71b3d68892c51f2() {
    var character = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character;
    if (!character) return {
        code: 'no-character',
        text: 'No active character'
    };
    // The same refusal `craftItem` makes, checked here so the automation never
    // calls into a path that would raise an error notification at the player.
    if (character.isMarketplace || character.marketplaceData) return {
        code: 'listed',
        text: 'Character is listed on the marketplace'
    };
    return null;
}
function $7a60a8a88cdf0fcd$export$80adecd30958438d() {
    if (!$7a60a8a88cdf0fcd$export$a0f4aa4561249df8() || $7a60a8a88cdf0fcd$export$b71b3d68892c51f2()) return null;
    var job = (0, $325425fbb9c40f26$export$6473dc4b900a5b32)();
    $7a60a8a88cdf0fcd$var$hasTicked = true;
    $7a60a8a88cdf0fcd$var$lastJob = job;
    if (!job) return null;
    // The player's own crafting functions, deliberately: they bank the marks,
    // charge the credits, and notify. An automated craft the player never sees
    // in the log would read as the game inventing items.
    var done = job.kind === 'unlock' ? (0, $83869d722e7ea000$export$506c247f43a19ac3)(job.id) : (0, $83869d722e7ea000$export$67f8f6c6271cd4a2)(job.id, job.kind === 'artifact');
    if (!done) {
        // The selector said yes and the craft said no — a real disagreement,
        // worth a debug line rather than a silent retry loop next tick.
        (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "Auto-Fabricator: ".concat(job.kind, " ").concat(job.id, " was selected but refused"));
        $7a60a8a88cdf0fcd$var$lastJob = null;
        return null;
    }
    (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "Auto-Fabricator: ".concat(job.kind, " ").concat(job.id));
    return job;
}
function $7a60a8a88cdf0fcd$export$109e3e91403b4584() {
    return $7a60a8a88cdf0fcd$export$80adecd30958438d();
}



var $4c1b6c766bf73b42$var$VIOLET = '#b18cff';
var $4c1b6c766bf73b42$var$VIOLET_DIM = '#6d4fa3';
// ---------------------------------------------------------------------------
// Header chip + tab reveal
// ---------------------------------------------------------------------------
var $4c1b6c766bf73b42$var$wasRevealed = false;
function $4c1b6c766bf73b42$export$ca081aebb329a098() {
    var revealed = (0, $ee71dfe8b201c427$export$25d1e5af45c35a33)();
    // First reveal mid-session: the character card was rendered without the
    // promote button - re-render it and announce the new layer once
    if (revealed && !$4c1b6c766bf73b42$var$wasRevealed) {
        var // A newly unlocked layer changes what the switcher can reach.
        _window_renderLayerToolbar, _window;
        $4c1b6c766bf73b42$var$wasRevealed = true;
        if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character) (0, $7ea2865b97769aa3$export$2eced2100c12c50d)();
        if (!(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).command.legends.length && !(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).command.marks) {
            // Sticky: a one-way latch that fires on a background tick rather than
            // on anything the player just did, and it opens a whole layer. Missing
            // it means not knowing the Command tab appeared.
            (0, $b5bda7fdec806d8b$export$c7def531c087da85)("\uD83C\uDF96\uFE0F Faction command has taken notice - the Command layer is now available", 'success', {
                sticky: true
            });
            (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
        }
        (_window_renderLayerToolbar = (_window = window).renderLayerToolbar) === null || _window_renderLayerToolbar === void 0 ? void 0 : _window_renderLayerToolbar.call(_window);
    }
    $4c1b6c766bf73b42$var$updateAutomationButtons();
}
// ---------------------------------------------------------------------------
// Command tab rendering
// ---------------------------------------------------------------------------
function $4c1b6c766bf73b42$var$statBlock(label, valueHtml, note) {
    return '\n        <div class="flex-1 min-w-[200px] rounded-lg p-3" style="background:rgba(177,140,255,0.10); border:2px solid '.concat($4c1b6c766bf73b42$var$VIOLET_DIM, ';">\n            <div class="text-[11px] uppercase tracking-widest text-gray-400">').concat(label, '</div>\n            <div class="text-lg font-bold leading-tight" style="color:').concat($4c1b6c766bf73b42$var$VIOLET, '">').concat(valueHtml, '</div>\n            <div class="text-xs text-gray-400 mt-0.5 leading-snug">').concat(note, "</div>\n        </div>");
}
function $4c1b6c766bf73b42$var$renderCommandStats() {
    var container = document.getElementById('command-stats');
    if (!container) return;
    var command = (0, $ee71dfe8b201c427$export$b97b2e8df296cd3b)();
    var activeValue = '<span class="text-gray-400">No active character</span>';
    var activeNote = 'Create a character to begin the next tour';
    if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character) {
        var _calculateCommandMarks = (0, $ee71dfe8b201c427$export$ffae5de2f7ddd94d)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character), total = _calculateCommandMarks.total, breakdown = _calculateCommandMarks.breakdown;
        activeValue = "".concat((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.name, " \xb7 ").concat(total, "\uD83C\uDF96\uFE0F");
        // Marks/day makes the promotion peak legible: when the rate stops
        // climbing tour-over-tour, it's time to promote
        var tourDays = (Date.now() - ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.createdAt || 0)) / 86400000;
        var rate = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.createdAt && tourDays >= 1 / 24 ? "".concat((total / tourDays).toFixed(1), "\uD83C\uDF96\uFE0F/day this tour") : '';
        activeNote = '<div class="mt-1">'.concat(rate, "</div>");
    }
    container.innerHTML = $4c1b6c766bf73b42$var$statBlock('Command Marks', (command.marks || 0).toLocaleString(), 'Influence carried up-well by your promoted officers') + $4c1b6c766bf73b42$var$statBlock('Current Tour', "Tour ".concat(command.tour), "".concat(command.legends.length, " Legend").concat(command.legends.length === 1 ? '' : 's', " enshrined \xb7 counted across all factions")) + $4c1b6c766bf73b42$var$statBlock("Active Character \u2014 Command Value", activeValue, activeNote);
}
function $4c1b6c766bf73b42$var$rankPips(owned, max) {
    var pips = '';
    for(var i = 0; i < max; i++)pips += '<span class="inline-block w-2.5 h-2.5 rounded-sm mr-1" style="border:1px solid '.concat($4c1b6c766bf73b42$var$VIOLET_DIM, "; ").concat(i < owned ? "background:".concat($4c1b6c766bf73b42$var$VIOLET, ";") : '', '"></span>');
    return '<span title="Rank '.concat(owned, "/").concat(max, '">').concat(pips, "</span>");
}
function $4c1b6c766bf73b42$var$renderCommandUpgrades() {
    var container = document.getElementById('command-upgrades');
    if (!container) return;
    var command = (0, $ee71dfe8b201c427$export$b97b2e8df296cd3b)();
    container.innerHTML = Object.entries($979b99378be707cd$export$617b3a0bcd7cead7).map(function(param) {
        var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), id = _param[0], def = _param[1];
        var rank = (0, $ee71dfe8b201c427$export$12c456cbb12a94a8)(id);
        var maxed = rank >= def.costs.length;
        // Discounted price via the shared helper, so the card quotes exactly
        // what purchaseUpgradeCore will deduct.
        var nextCost = maxed ? null : (0, $ee71dfe8b201c427$export$21d6f53ea6843ff6)(id, rank);
        // Prerequisites are a different kind of "no" from price, so they get
        // their own line rather than a silently disabled button.
        var missing = maxed ? [] : (0, $ee71dfe8b201c427$export$21736c92e8c4e21c)(def);
        var affordable = !maxed && missing.length === 0 && command.marks >= nextCost;
        var rankLabel = def.costs.length > 1 && !maxed ? "Rank ".concat([
            'I',
            'II',
            'III'
        ][rank] || rank + 1, " \u2014 ") : '';
        var missingNames = missing.map(function(reqId) {
            var _config_commandUpgrades_reqId, _config_commandUpgrades;
            return ((_config_commandUpgrades = $979b99378be707cd$export$617b3a0bcd7cead7) === null || _config_commandUpgrades === void 0 ? void 0 : (_config_commandUpgrades_reqId = _config_commandUpgrades[reqId]) === null || _config_commandUpgrades_reqId === void 0 ? void 0 : _config_commandUpgrades_reqId.name) || reqId;
        });
        return '\n            <div class="catalog-card bg-white/10 border-2 border-gray-700 rounded-lg p-3 flex flex-col gap-1.5">\n                <div class="flex justify-between items-baseline gap-2">\n                    <h4 class="font-bold text-[15px] m-0" style="color:'.concat($4c1b6c766bf73b42$var$VIOLET, '">').concat(def.icon, " ").concat(def.name, "</h4>\n                    ").concat($4c1b6c766bf73b42$var$rankPips(rank, def.costs.length), '\n                </div>\n                <div class="catalog-card-flavor text-xs text-gray-400 italic leading-snug" title="').concat(def.flavor, '">').concat(def.flavor, '</div>\n                <div class="catalog-card-effect text-[13px] leading-snug">').concat(def.effect).concat(rank > 0 && !maxed ? ' <span class="text-game-success">Rank '.concat([
            'I',
            'II',
            'III'
        ][rank - 1] || rank, " owned.</span>") : '', "</div>\n                ").concat(missingNames.length ? '<div class="text-xs text-amber-300">\uD83D\uDD12 Requires '.concat(missingNames.join(' and '), ".</div>") : '', '\n                <div class="catalog-card-footer flex justify-between items-center mt-auto pt-2">\n                    ').concat(maxed ? '<span class="text-game-success text-sm font-bold">\u2713 Maxed</span><span></span>' : '<span class="font-bold text-sm" style="color:'.concat($4c1b6c766bf73b42$var$VIOLET, '">').concat(rankLabel).concat(nextCost, " \uD83C\uDF96\uFE0F</span>\n                           <button onclick=\"purchaseCommandUpgrade('").concat(id, "')\" ").concat(affordable ? '' : 'disabled', '\n                               class="px-3 py-1.5 rounded text-xs font-bold ').concat(affordable ? 'text-black hover:shadow-lg' : 'bg-gray-600 text-gray-800 cursor-not-allowed', '"\n                               ').concat(affordable ? 'style="background:'.concat($4c1b6c766bf73b42$var$VIOLET, '"') : '', ">ACQUIRE</button>"), "\n                </div>\n            </div>");
    }).join('');
}
function $4c1b6c766bf73b42$var$renderCommandGallery() {
    var container = document.getElementById('command-gallery');
    if (!container) return;
    var command = (0, $ee71dfe8b201c427$export$b97b2e8df296cd3b)();
    if (!command.legends.length) {
        container.innerHTML = '\n            <div class="col-span-full text-center text-gray-400 py-8 border border-dashed border-gray-600 rounded-lg">\n                No Legends yet. Promote your first character to begin building the faction ranks.\n            </div>';
        return;
    }
    container.innerHTML = (0, $4c858c0d999a5b9b$export$71511d61b312f219)(command.legends).reverse().map(function(legend) {
        return (0, $1b36c0b1091d5de9$export$5eeeb728aab285f9)((0, $fa9769297b8a68c8$export$71511d61b312f219)({
            artifactsUnlocked: 0
        }, legend), {
            accent: $4c1b6c766bf73b42$var$VIOLET,
            accentDim: $4c1b6c766bf73b42$var$VIOLET_DIM
        });
    }).join('');
}
(0, $bf6cb3ebdd8098d6$export$589dc1e4c906c789)('command', {
    panes: {
        upgrades: 'command-pane-upgrades',
        legends: 'command-pane-legends'
    },
    // The GRID scrolls, not the pane: the blurb above it should stay put rather
    // than scroll away with the cards.
    scrollers: {
        upgrades: 'command-upgrades',
        legends: 'command-gallery'
    }
});
function $4c1b6c766bf73b42$export$cf457306c8f8ec80() {
    $4c1b6c766bf73b42$var$renderCommandStats();
    $4c1b6c766bf73b42$var$renderCommandUpgrades();
    $4c1b6c766bf73b42$var$renderCommandGallery();
    $4c1b6c766bf73b42$export$ca081aebb329a098();
    // Both panes are rendered above — they are hidden, not unmounted, so the
    // cost is one innerHTML each and the hidden one is correct when revealed.
    // Re-applying re-measures the scroller against whatever height the stats
    // strip ended up at.
    (0, $bf6cb3ebdd8098d6$export$7ad721b2ffe28f0c)('command');
}
function $4c1b6c766bf73b42$export$6385b3d28f532d4c(upgradeId) {
    var _config_commandUpgrades;
    var def = (_config_commandUpgrades = $979b99378be707cd$export$617b3a0bcd7cead7) === null || _config_commandUpgrades === void 0 ? void 0 : _config_commandUpgrades[upgradeId];
    if (!def) return;
    if (def.choice === 'region') {
        $4c1b6c766bf73b42$var$openCharterPickModal();
        return;
    }
    var result = (0, $ee71dfe8b201c427$export$a9f5f3e18483ed51)(upgradeId);
    if (!result.success) {
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)($4c1b6c766bf73b42$var$purchaseFailureMessage(result.reason, result), 'error');
        return;
    }
    (0, $b5bda7fdec806d8b$export$c7def531c087da85)("\uD83C\uDF96\uFE0F Acquired ".concat(def.name).concat(def.costs.length > 1 ? " Rank ".concat([
        'I',
        'II',
        'III'
    ][result.rank - 1] || result.rank) : '', " (-").concat(result.cost, " marks)"), 'success');
    (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
    $4c1b6c766bf73b42$export$cf457306c8f8ec80();
}
function $4c1b6c766bf73b42$var$purchaseFailureMessage(reason) {
    var result = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    switch(reason){
        case 'insufficient-marks':
            return 'Not enough Command Marks!';
        case 'max-rank':
            return 'Already at maximum rank!';
        case 'region-already-chartered':
            return 'That region is already chartered!';
        case 'invalid-region':
            return 'Pick a region to charter first.';
        case 'missing-requirement':
            {
                var names = ((result === null || result === void 0 ? void 0 : result.requires) || []).map(function(id) {
                    var _config_commandUpgrades_id, _config_commandUpgrades;
                    return ((_config_commandUpgrades = $979b99378be707cd$export$617b3a0bcd7cead7) === null || _config_commandUpgrades === void 0 ? void 0 : (_config_commandUpgrades_id = _config_commandUpgrades[id]) === null || _config_commandUpgrades_id === void 0 ? void 0 : _config_commandUpgrades_id.name) || id;
                });
                return "Requires ".concat(names.join(' and '), " first.");
            }
        default:
            return 'Cannot acquire this upgrade.';
    }
}
function $4c1b6c766bf73b42$var$openCharterPickModal() {
    var modal = document.getElementById('charter-pick-modal');
    var body = document.getElementById('charter-pick-body');
    if (!modal || !body) return;
    var command = (0, $ee71dfe8b201c427$export$b97b2e8df296cd3b)();
    var rank = (0, $ee71dfe8b201c427$export$12c456cbb12a94a8)('regional-charter');
    var def = $979b99378be707cd$export$617b3a0bcd7cead7['regional-charter'];
    if (rank >= def.costs.length) {
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)('Already at maximum rank!', 'error');
        return;
    }
    var cost = def.costs[rank];
    var chartered = new Set(command.charterRegions);
    var candidates = Object.keys($979b99378be707cd$export$4fbdcec70fce9d73).filter(function(r) {
        return !chartered.has(r);
    });
    body.innerHTML = '\n        <p class="text-sm text-gray-300 mb-1">Command negotiates access corridors no field team could.</p>\n        <p class="text-xs text-gray-400 mb-4">Choose one region to unlock for ALL your characters \u2014 '.concat(cost, " \uD83C\uDF96\uFE0F (you have ").concat(command.marks, ').</p>\n        <div class="flex flex-col gap-2">\n            ').concat(candidates.map(function(regionKey) {
        var region = $979b99378be707cd$export$4fbdcec70fce9d73[regionKey];
        return "\n                    <button onclick=\"confirmCharterPick('".concat(regionKey, "')\" ").concat(command.marks >= cost ? '' : 'disabled', '\n                        class="text-left px-4 py-3 rounded-lg border-2 border-gray-600 bg-white/5 hover:border-[#b18cff] disabled:opacity-50 disabled:cursor-not-allowed">\n                        <span class="font-bold text-white">').concat(region.icon || "\uD83D\uDDFA\uFE0F", " ").concat(region.name, '</span>\n                        <span class="block text-xs text-gray-400">').concat(region.theme || '', "</span>\n                    </button>");
    }).join(''), "\n        </div>");
    modal.classList.remove('hidden');
}
function $4c1b6c766bf73b42$export$65f57c7876e71d24(regionKey) {
    var _document_getElementById, _config_raidRegions_regionKey;
    var result = (0, $ee71dfe8b201c427$export$a9f5f3e18483ed51)('regional-charter', regionKey);
    if (!result.success) {
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)($4c1b6c766bf73b42$var$purchaseFailureMessage(result.reason, result), 'error');
        return;
    }
    (_document_getElementById = document.getElementById('charter-pick-modal')) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.classList.add('hidden');
    (0, $b5bda7fdec806d8b$export$c7def531c087da85)("\uD83D\uDDFA\uFE0F Regional Charter: ".concat(((_config_raidRegions_regionKey = $979b99378be707cd$export$4fbdcec70fce9d73[regionKey]) === null || _config_raidRegions_regionKey === void 0 ? void 0 : _config_raidRegions_regionKey.name) || regionKey, " unlocked for all characters! (-").concat(result.cost, " marks)"), 'success');
    (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
    $4c1b6c766bf73b42$export$cf457306c8f8ec80();
}
function $4c1b6c766bf73b42$export$91233bcb850c2ee1() {
    var modal = document.getElementById('promote-modal');
    var body = document.getElementById('promote-modal-body');
    var title = document.getElementById('promote-modal-title');
    if (!modal || !body || !(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character) return;
    var character = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character;
    var command = (0, $ee71dfe8b201c427$export$b97b2e8df296cd3b)();
    title.textContent = "\uD83C\uDF96\uFE0F Promote ".concat(character.name);
    var eligible = (0, $ee71dfe8b201c427$export$d7db1ce90eca9a05)();
    if (!eligible.ok && eligible.reason !== 'no-active-character') {
        var message = eligible.reason === 'listed-on-marketplace' ? "<b>".concat(character.name, " is listed on the contractor marketplace.</b><br>Recall them from contract before promoting \u2014 the listing (or an active hire) must end first.") : "<b>".concat(character.name, " has a raid in progress.</b><br>Finish or abandon the raid before promoting.");
        body.innerHTML = '\n            <div class="border rounded-lg p-4 text-sm leading-relaxed mb-4" style="border-color:#ef4444; background:rgba(239,68,68,0.08); color:#fca5a5;">\u26A0\uFE0F '.concat(message, '</div>\n            <div class="flex justify-end">\n                <button onclick="closePromoteModal()" class="px-4 py-2 rounded border border-gray-500 text-gray-300 text-sm font-bold">Close</button>\n            </div>');
        modal.classList.remove('hidden');
        return;
    }
    var _calculateCommandMarks = (0, $ee71dfe8b201c427$export$ffae5de2f7ddd94d)(character), total = _calculateCommandMarks.total, breakdown = _calculateCommandMarks.breakdown;
    var marksCfg = $979b99378be707cd$export$9f9786ac427715c7.commandMarks;
    var vaultShare = $979b99378be707cd$export$9f9786ac427715c7.vaultCarryover;
    // The post waiting up-well: promoted role + a command member's welcome,
    // both resolved from the character's title/best skill (deterministic, so
    // this preview always matches the Legend enshrined on confirm)
    var promotedFlavor = (0, $ee71dfe8b201c427$export$5a56eaf8a61d7ab9)(character);
    var factionInfo = $979b99378be707cd$export$aeeef991191508e2[character.faction] || {};
    // Promotion credit levy: credits are account-shared, so a percentage cut
    // (with a working-capital floor) replaces the old flat reset
    var levy = $979b99378be707cd$export$9f9786ac427715c7.promotionCreditLevy || {
        keepFraction: 0.25,
        floor: 1000
    };
    var creditsNow = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).player.credits || 0;
    // Promotion SELLS relics and consumables before the levy is taken, so the
    // levy lands on a bigger number than the header shows. Dry-run the same
    // function the promotion uses — passing no vault/consignment makes it a pure
    // valuation — or this modal promises less than the player actually keeps.
    var _disburseInventory = (0, $ee71dfe8b201c427$export$da98dc4e7bdea782)(character.inventory, {
        vaultShare: vaultShare
    }), liquidation = _disburseInventory.credits;
    var creditsAtLevy = creditsNow + liquidation;
    var creditsKept = Math.max(levy.floor, Math.floor(creditsAtLevy * levy.keepFraction));
    body.innerHTML = '\n        <div class="text-s text-gray-100 mb-1">End of Tour '.concat(command.tour, ' \u2014 Promotion to Faction Command</div>\n        <!-- The mechanic has always been irreversible; nothing said so. Also the\n             only place L1/L2 states that Command is PLANETSIDE, which is what\n             makes a promoted officer unable to go home and what L3\'s founding\n             needs to read as a diaspora rather than an incorporation.\n             docs/story/StoryAlignment.md \xa7Economic geography. -->\n        <div class="text-xs text-gray-400 mb-3 leading-relaxed">\n            Promotion is one-way. Enough transit dilation has accumulated that ').concat(character.name, " cannot return to the field \u2014 or home. Faction Command is planetside, and it is where the crossing leaves them.\n        </div>\n        ").concat(promotedFlavor.role ? '\n        <div class="border rounded-lg p-3 mb-4" style="border-color:'.concat($4c1b6c766bf73b42$var$VIOLET_DIM, '; background:rgba(177,140,255,0.04);">\n            <div class="uppercase tracking-widest text-[10px] font-bold mb-1" style="color:').concat($4c1b6c766bf73b42$var$VIOLET, '">New Post \u2014 ').concat(factionInfo.icon || '', " ").concat(factionInfo.name || character.faction, ' Command</div>\n            <div class="text-sm font-bold text-white mb-2">').concat(character.name, ", ").concat(promotedFlavor.role, "</div>\n            ").concat(promotedFlavor.quote ? '\n            <div class="text-xs italic leading-relaxed" style="color:#a78bda;">\n                '.concat(promotedFlavor.quote, '\n                <div class="not-italic text-right text-[10px] mt-1 text-gray-500">\u2014 ').concat(factionInfo.name || character.faction, " Command</div>\n            </div>") : '', "\n        </div>") : '', '\n        <div class="text-xs italic border-l-2 pl-3 py-1 mb-4 leading-relaxed" style="border-color:').concat($4c1b6c766bf73b42$var$VIOLET_DIM, '; color:#a78bda; background:rgba(177,140,255,0.06);">\n            \u201CField clearance expires with accumulated temporal desync. The Relay is waiting, Commander. Home is\u2026 further than it was.\u201D\n        </div>\n        <table class="w-full text-sm mb-4" style="font-variant-numeric: tabular-nums;">\n            <tr class="border-b border-gray-700"><td class="py-1">Faction tech gear</td><td class="text-right text-gray-400">').concat(breakdown.techGear.count, " \xd7 ").concat(marksCfg.perTechGear, '</td><td class="text-right font-bold w-20" style="color:').concat($4c1b6c766bf73b42$var$VIOLET, '">').concat(breakdown.techGear.marks, '</td></tr>\n            <tr class="border-b border-gray-700"><td class="py-1" title="One-time milestone per artifact design unlocked with its blueprint">Artifact designs unlocked</td><td class="text-right text-gray-400">').concat(breakdown.artifactUnlocks.count, " \xd7 ").concat(marksCfg.perArtifactUnlock, '</td><td class="text-right font-bold" style="color:').concat($4c1b6c766bf73b42$var$VIOLET, '">').concat(breakdown.artifactUnlocks.marks, '</td></tr>\n            <tr class="border-b border-gray-700"><td class="py-1" title="Each distinct artifact this character crafted from unlocked designs">Artifacts crafted</td><td class="text-right text-gray-400">').concat(breakdown.artifacts.count, " \xd7 ").concat(marksCfg.perArtifactCraft, '</td><td class="text-right font-bold" style="color:').concat($4c1b6c766bf73b42$var$VIOLET, '">').concat(breakdown.artifacts.marks, '</td></tr>\n            <tr class="border-b border-gray-700"><td class="py-1">Tier-3 victories</td><td class="text-right text-gray-400">').concat(breakdown.t3Wins.count, " \xf7 ").concat(marksCfg.t3WinsDivisor, '</td><td class="text-right font-bold" style="color:').concat($4c1b6c766bf73b42$var$VIOLET, '">').concat(breakdown.t3Wins.marks, '</td></tr>\n            <tr><td class="py-1">Level</td><td class="text-right text-gray-400">').concat(breakdown.level.count, " \xd7 ").concat(marksCfg.perLevel, '</td><td class="text-right font-bold" style="color:').concat($4c1b6c766bf73b42$var$VIOLET, '">').concat(breakdown.level.marks, '</td></tr>\n            <tr class="border-t-2" style="border-color:').concat($4c1b6c766bf73b42$var$VIOLET_DIM, '"><td class="py-1 font-bold text-white">Command Marks</td><td></td><td class="text-right font-bold text-game-gold text-base">\uD83C\uDF96\uFE0F').concat(total, '</td></tr>\n        </table>\n\n        <div class="grid grid-cols-2 gap-3 mb-4 text-xs leading-relaxed">\n            <div class="border border-gray-700 rounded-lg p-3">\n                <div class="uppercase tracking-widest text-[10px] font-bold mb-1 text-game-success">\u2713 Persists</div>\n                <ul class="list-disc pl-4 text-gray-400">\n                    <li>Command Marks &amp; all upgrades</li>\n                    <li>Legends gallery entry</li>\n                    <li>Chartered regions</li>\n                    <li>Your other characters</li>\n                    <li>Artifact blueprints (filed with Command)</li>\n                    ').concat(vaultShare > 0 ? "<li>Materials: ".concat(Math.round(vaultShare * 100), "% to your next recruit, the rest consigned to your next Syndicate</li>") : "", '\n                </ul>\n            </div>\n            <div class="border border-gray-700 rounded-lg p-3">\n                <div class="uppercase tracking-widest text-[10px] font-bold mb-1 text-game-danger">\u2717 Lost</div>\n                <ul class="list-disc pl-4 text-gray-400">\n                    <li>').concat(character.name, ' (leaves your roster)</li>\n                    <li>Equipped gear, and relics &amp; consumables (sold off first \u2014 the credits below include them)</li>\n                    <li title="Your credit line was issued against a tour. When the tour ends the balance underwrites the next roster; what is left is your working float."><b>Tour accounts close</b> \u2014 Command levies ').concat(Math.round((1 - levy.keepFraction) * 100), "% of credits (").concat(creditsAtLevy.toLocaleString()).concat(liquidation > 0 ? " incl. ".concat(liquidation.toLocaleString(), " from the sale") : "", " \u2192 ").concat(creditsKept.toLocaleString(), ')</li>\n                </ul>\n            </div>\n        </div>\n\n        <input type="text" id="promote-confirm-name" autocomplete="off" placeholder=\'Type "').concat(character.name, '" to confirm\'\n            class="w-full px-4 py-2 bg-white/5 border-2 border-gray-600 rounded-lg text-white placeholder-gray-400 focus:outline-none text-sm mb-4" style="caret-color:').concat($4c1b6c766bf73b42$var$VIOLET, '">\n\n        <div class="flex justify-end gap-3">\n            <button onclick="closePromoteModal()" class="px-4 py-2 rounded border border-gray-500 text-gray-300 text-sm font-bold">Cancel</button>\n            <button id="promote-confirm-btn" onclick="confirmPromotion()" disabled\n                class="px-5 py-2 rounded text-sm font-bold text-black disabled:bg-gray-600 disabled:text-gray-800 disabled:cursor-not-allowed" style="background:').concat($4c1b6c766bf73b42$var$VIOLET, '">\n                Promote to Command\n            </button>\n        </div>');
    var input = document.getElementById('promote-confirm-name');
    var confirmBtn = document.getElementById('promote-confirm-btn');
    input.addEventListener('input', function() {
        confirmBtn.disabled = input.value.trim().toLowerCase() !== character.name.trim().toLowerCase();
    });
    input.addEventListener('focus', function() {
        input.style.borderColor = $4c1b6c766bf73b42$var$VIOLET;
    });
    modal.classList.remove('hidden');
    // Focus without scrolling: the confirm input sits at the bottom, and a
    // scroll-on-focus would jump the (now scrollable) body past the marks
    // breakdown at the top. Keep the body pinned to the top on open.
    input.focus({
        preventScroll: true
    });
    if (body) body.scrollTop = 0;
}
function $4c1b6c766bf73b42$export$ffb8f728a2943b32() {
    var _document_getElementById;
    (_document_getElementById = document.getElementById('promote-modal')) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.classList.add('hidden');
}
function $4c1b6c766bf73b42$export$a522e88637d89e58() {
    var _window_multiplayer;
    var character = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character;
    if (!character) return;
    var multiplayerId = character.multiplayerId;
    var result = (0, $ee71dfe8b201c427$export$f0bd6e9010bb1600)();
    if (!result.success) {
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)($4c1b6c766bf73b42$var$purchaseFailureMessage(result.reason, result), 'error');
        $4c1b6c766bf73b42$export$ffb8f728a2943b32();
        return;
    }
    // Server-side v1 reuses the delete path (switches to a status flag when Old Guard ships)
    if (multiplayerId && ((_window_multiplayer = window.multiplayer) === null || _window_multiplayer === void 0 ? void 0 : _window_multiplayer.deleteOwnCharacter)) window.multiplayer.deleteOwnCharacter(multiplayerId);
    // Fresh outpost for the next tour
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).selectedFaction = null;
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).contractors = [];
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.hiredContractors = [];
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.reservedContractors = [];
    (0, $670e0f14fa02ad13$export$aca974319671fb3e)();
    $4c1b6c766bf73b42$export$ffb8f728a2943b32();
    (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
    (0, $b5bda7fdec806d8b$export$c7def531c087da85)("\u23F3 Tour ".concat(result.legend.tour, " complete \u2014 ").concat(result.legend.name, " promoted to Command \xb7 +").concat(result.marks.total, " \uD83C\uDF96\uFE0F"), 'success');
    // The active slot is free: show the character screen (creator or selector)
    (0, $59924438766e7d8e$export$2ae62d947e9e1d03)();
    (0, $59924438766e7d8e$export$d1c957a54f7124bc)();
    $4c1b6c766bf73b42$export$ca081aebb329a098();
    if (window.showCharacterScreenAfterPromotion) window.showCharacterScreenAfterPromotion();
    $4c1b6c766bf73b42$export$cf457306c8f8ec80();
}
// ---------------------------------------------------------------------------
// Automation upgrades: Auto-Scout + Foreman's Ledger (raid planning),
// Auto-Raid Protocol (the raid loop), Auto-Fabricator (the workshop)
// ---------------------------------------------------------------------------
/**
 * Show/hide the automation buttons based on owned upgrades.
 *
 * Called from updateCommandHeader (5s interval). The raid-planning buttons live
 * in the raid grid header, so they only appear once a grid exists anyway -
 * Auto-Fabricator's does NOT: it sits in the character subtab bar, because it
 * crafts whenever the player is idle rather than only around a raid.
 */ function $4c1b6c766bf73b42$var$updateAutomationButtons() {
    var // The `-arrow` companions these used to toggle no longer exist in the
    // markup; optional chaining made their absence silent.
    _document_getElementById, _document_getElementById1;
    (_document_getElementById = document.getElementById('auto-scout-btn')) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.classList.toggle('hidden', (0, $ee71dfe8b201c427$export$12c456cbb12a94a8)('auto-scout') <= 0);
    (_document_getElementById1 = document.getElementById('auto-reserve-btn')) === null || _document_getElementById1 === void 0 ? void 0 : _document_getElementById1.classList.toggle('hidden', (0, $ee71dfe8b201c427$export$12c456cbb12a94a8)('foremans-ledger') <= 0);
    $4c1b6c766bf73b42$var$updateAutoRaidButton();
    $4c1b6c766bf73b42$var$updateAutoFabricatorButton();
}
/**
 * Auto-Raid is a toggle, so its button carries STATE, not just an action: lit
 * while running, dim while idle, with a status line saying what it is doing or
 * why it is not. An automation that silently does nothing is indistinguishable
 * from one that is broken.
 */ function $4c1b6c766bf73b42$var$updateAutoRaidButton() {
    var btn = document.getElementById('auto-raid-btn');
    var status = document.getElementById('auto-raid-status');
    if (!btn) return;
    var owned = (0, $2f2faed8b0830fbf$export$d386ff630e305d9f)();
    btn.classList.toggle('hidden', !owned);
    status === null || status === void 0 ? void 0 : status.classList.toggle('hidden', !owned);
    if (!owned) return;
    var on = (0, $2f2faed8b0830fbf$export$c750660aba17086b)();
    btn.style.background = on ? '#4ade80' : '';
    btn.style.color = on ? '#000' : '';
    btn.title = on ? "Auto-Raid Protocol: running \u2014 click to stop" : 'Auto-Raid Protocol: click to run raids hands-off';
    if (!status) return;
    if (!on) {
        status.textContent = 'Auto-Raid off';
        status.style.color = '#9ca3af';
        return;
    }
    var blocked = (0, $2f2faed8b0830fbf$export$18302fe48a4c0c92)();
    var waitingForEnergy = (0, $2f2faed8b0830fbf$export$9f0fd7c5580c292)();
    status.textContent = blocked ? "\u23F8 ".concat(blocked.text) : waitingForEnergy ? "\u23F8 Waiting for \u26A1".concat((0, $2f2faed8b0830fbf$export$7db30007ec79b8c)()) : "\u25B6 Auto-Raid running";
    status.style.color = blocked || waitingForEnergy ? '#fbbf24' : '#4ade80';
}
function $4c1b6c766bf73b42$export$4bdca4d15177534a() {
    if (!(0, $2f2faed8b0830fbf$export$d386ff630e305d9f)()) return;
    var nowOn = (0, $2f2faed8b0830fbf$export$c790bcc16caca94)(!(0, $2f2faed8b0830fbf$export$c750660aba17086b)());
    $4c1b6c766bf73b42$var$updateAutoRaidButton();
    if (nowOn) {
        var blocked = (0, $2f2faed8b0830fbf$export$18302fe48a4c0c92)();
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)(blocked ? "\uD83E\uDD16 Auto-Raid armed \u2014 ".concat(blocked.text) : "\uD83E\uDD16 Auto-Raid running", blocked ? 'warning' : 'success');
    } else (0, $b5bda7fdec806d8b$export$c7def531c087da85)("\uD83E\uDD16 Auto-Raid stopped", 'info');
}
/**
 * Auto-Fabricator's button: a toggle, so it carries STATE rather than an action.
 *
 * It sits in the CHARACTER subtab bar, not the raid grid header where Auto-Raid
 * lives, because it is not raid-scoped — it crafts whenever the player is idle.
 * That bar has no room for a status line beside it, so the LABEL is the status
 * and the tooltip carries the detail. An automation that silently does nothing
 * is indistinguishable from one that is broken, and "Off" vs "⏸" is the
 * difference between "you turned this off" and "it cannot run right now".
 */ var $4c1b6c766bf73b42$var$FAB_BUTTON_STATES = {
    off: {
        text: 'Auto-Craft Off',
        colour: '#b18cff',
        title: 'Auto-Fabricator: click to craft hands-off between raids'
    },
    working: {
        text: 'Auto-Craft On',
        colour: '#4ade80',
        title: "Auto-Fabricator: crafting between raids \u2014 click to stop"
    },
    // Not a failure, and the most common state early on: everything craftable is
    // already built, or the materials and credits are not there yet.
    nothing: {
        text: 'Auto-Craft Idle',
        colour: '#9ca3af',
        title: "Auto-Fabricator: on, but nothing it can build right now \u2014 no blueprint to unlock, no complete recipe, nothing affordable"
    },
    blocked: {
        text: "Auto-Craft \u23F8",
        colour: '#fbbf24',
        title: null
    }
};
function $4c1b6c766bf73b42$var$updateAutoFabricatorButton() {
    var btn = document.getElementById('auto-fab-btn');
    if (!btn) return;
    // One source of truth: the module that runs the automation decides what
    // state it is in, and this only paints it.
    var _autoFabricatorStatus = (0, $7a60a8a88cdf0fcd$export$82e2837406d30fe2)(), state = _autoFabricatorStatus.state, reason = _autoFabricatorStatus.reason;
    btn.classList.toggle('hidden', state === 'unowned');
    if (state === 'unowned') return;
    var style = $4c1b6c766bf73b42$var$FAB_BUTTON_STATES[state];
    btn.textContent = style.text;
    btn.style.borderColor = style.colour;
    btn.style.background = "".concat(style.colour, "22");
    btn.style.color = style.colour;
    btn.title = style.title || "Auto-Fabricator paused \u2014 ".concat(reason);
}
function $4c1b6c766bf73b42$export$a6ca5fb2b2eca75d() {
    if (!(0, $325425fbb9c40f26$export$17068373f54d4cc4)()) return;
    var nowOn = (0, $7a60a8a88cdf0fcd$export$273610d740a9bd65)(!(0, $7a60a8a88cdf0fcd$export$a0f4aa4561249df8)());
    $4c1b6c766bf73b42$var$updateAutoFabricatorButton();
    if (nowOn) {
        var blocked = (0, $7a60a8a88cdf0fcd$export$b71b3d68892c51f2)();
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)(blocked ? "\u2699\uFE0F Auto-Fabricator armed \u2014 ".concat(blocked.text) : "\u2699\uFE0F Auto-Fabricator running", blocked ? 'warning' : 'success');
    } else (0, $b5bda7fdec806d8b$export$c7def531c087da85)("\u2699\uFE0F Auto-Fabricator stopped", 'info');
}
function $4c1b6c766bf73b42$export$478f57514b105434() {
    var grid = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid;
    if (!grid || !(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character || (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress) return;
    // Lights Out. Told, not silently ignored: a button that does nothing when
    // pressed is indistinguishable from a broken one.
    if ((0, $686e361e5cd4549d$export$a2c94bc2dc5c01e1)('noAutoScout', false)) {
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)("\uD83C\uDF11 Lights Out: no recon on this contract \u2014 chart it yourself.", 'warning');
        return;
    }
    var wantedCells = (0, $3f29ea4265abff3b$export$a2d78d1f68010f97)();
    // Weight encounter rooms by whether this character can pass them: a gate
    // fires 2-4 skill events against a higher skill bar than a hazard's 1-2,
    // so routing through gates the player is under-skilled for is what turns a
    // scouted path into a wipe.
    var tierData = $979b99378be707cd$export$94e7ad7999c1ae32[grid.tier] || {};
    var skillTargets = {
        gate: tierData.gateSkillLevel,
        hazard: tierData.hazardSkillLevel
    };
    var path = (0, $afe3fe5fbf223eb0$export$bbcc6782bce81af0)(grid, grid.startPos, grid.endPos, (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.skills || {}, wantedCells, skillTargets);
    if (!path.length) {
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)("\uD83D\uDEF0\uFE0F Auto-Scout could not chart a route to the exit", 'error');
        return;
    }
    // Grab any water/campsite that sit on a free (zero-encounter) detour off the
    // charted route - free fishing/healing at no path-length cost.
    path = (0, $afe3fe5fbf223eb0$export$c8e849ec9d7205c9)(path, grid);
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath = path;
    (0, $3f29ea4265abff3b$export$68c4600b33dd0ca8)();
    (0, $3f29ea4265abff3b$export$f4fa7fe8ae486c6)();
    (0, $3f29ea4265abff3b$export$d6f634bba1273a2b)();
    (0, $3f29ea4265abff3b$export$25fc6ae0ff69cc)();
    (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
    var encounters = path.filter(function(s) {
        var _s_room, _s_room1;
        return ((_s_room = s.room) === null || _s_room === void 0 ? void 0 : _s_room.type) === 'gate' || ((_s_room1 = s.room) === null || _s_room1 === void 0 ? void 0 : _s_room1.type) === 'hazard';
    }).length;
    var targeted = wantedCells ? path.filter(function(s) {
        return wantedCells.has("".concat(s.row, ",").concat(s.col));
    }).length : 0;
    (0, $b5bda7fdec806d8b$export$c7def531c087da85)("\uD83D\uDEF0\uFE0F Auto-Scout charted a ".concat(path.length, "-room route (").concat(encounters, " encounters").concat(targeted ? ", ".concat(targeted, " rooms drop your marked items") : '', ")"), 'success');
}
function $4c1b6c766bf73b42$export$95f7842af258a4dd() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var _gameState_character, path, available, best, hired, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, contractor, err;
        return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    path = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath;
                    if (!path || path.length < 2) {
                        (0, $b5bda7fdec806d8b$export$c7def531c087da85)("\uD83D\uDCD2 Plan a path first \u2014 the Foreman staffs for the route", 'warning');
                        return [
                            2
                        ];
                    }
                    if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.reservedContractors.length >= 2) {
                        (0, $b5bda7fdec806d8b$export$c7def531c087da85)("\uD83D\uDCD2 Team is already full", 'warning');
                        return [
                            2
                        ];
                    }
                    available = ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).contractors || []).filter(function(c) {
                        return c.isAlive !== false && !(0, $1249ab814b7054d4$export$595cb98aec43dd71)(c.id);
                    });
                    best = (0, $e63b1e314d73680b$export$62a89cfab93e40e)(available, path, ((_gameState_character = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character) === null || _gameState_character === void 0 ? void 0 : _gameState_character.skills) || {});
                    if (!best.length) {
                        (0, $b5bda7fdec806d8b$export$c7def531c087da85)("\uD83D\uDCD2 No suitable contractors available for this route", 'warning');
                        return [
                            2
                        ];
                    }
                    hired = 0;
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        8
                    ]);
                    _iterator = best[Symbol.iterator]();
                    _state.label = 2;
                case 2:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        5
                    ];
                    contractor = _step.value;
                    if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.reservedContractors.length >= 2) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        (0, $670e0f14fa02ad13$export$959fb65d2b5e760e)(contractor.id)
                    ];
                case 3:
                    _state.sent();
                    hired++;
                    _state.label = 4;
                case 4:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        8
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        8
                    ];
                case 7:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 8:
                    if (hired > 0) (0, $b5bda7fdec806d8b$export$c7def531c087da85)("\uD83D\uDCD2 Foreman's Ledger reserved ".concat(hired, " contractor").concat(hired === 1 ? '' : 's', " for the route"), 'success');
                    return [
                        2
                    ];
            }
        });
    })();
}
// ---------------------------------------------------------------------------
// Window exposure (onclick-string pattern used across the codebase)
// ---------------------------------------------------------------------------
if (typeof window !== 'undefined') {
    window.openPromoteModal = $4c1b6c766bf73b42$export$91233bcb850c2ee1;
    window.closePromoteModal = $4c1b6c766bf73b42$export$ffb8f728a2943b32;
    window.confirmPromotion = $4c1b6c766bf73b42$export$a522e88637d89e58;
    window.purchaseCommandUpgrade = $4c1b6c766bf73b42$export$6385b3d28f532d4c;
    window.confirmCharterPick = $4c1b6c766bf73b42$export$65f57c7876e71d24;
    window.autoScoutPath = $4c1b6c766bf73b42$export$478f57514b105434;
    window.autoReserveContractors = $4c1b6c766bf73b42$export$95f7842af258a4dd;
    window.toggleAutoRaid = $4c1b6c766bf73b42$export$4bdca4d15177534a;
    window.toggleAutoFabricator = $4c1b6c766bf73b42$export$a6ca5fb2b2eca75d;
    document.addEventListener('DOMContentLoaded', function() {
        var _document_getElementById, _document_getElementById1;
        (_document_getElementById = document.getElementById('promote-modal-close')) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.addEventListener('click', $4c1b6c766bf73b42$export$ffb8f728a2943b32);
        (_document_getElementById1 = document.getElementById('charter-pick-close')) === null || _document_getElementById1 === void 0 ? void 0 : _document_getElementById1.addEventListener('click', function() {
            var _document_getElementById;
            (_document_getElementById = document.getElementById('charter-pick-modal')) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.classList.add('hidden');
        });
    });
}



/**
 * Syndicate UI (M3 S2) - the browser wrapper over syndicate-core.js.
 *
 * Mirrors command.js deliberately: same stat-strip / catalog-grid / modal
 * shapes, same window-exposure pattern for onclick strings. All rules live in
 * syndicate-core.js so the simulator sees the same behaviour; this file only
 * renders and reports.
 *
 * See docs/layers/3-syndicate/design.md §2-§3.
 */ 












var $5114056da3d46141$var$GOLD = '#e0a84c';
var $5114056da3d46141$var$GOLD_DIM = '#8a6526';
var $5114056da3d46141$var$ROMAN = [
    'I',
    'II',
    'III'
];
/**
 * Display name(s) for the Command upgrade(s) a charter depends on.
 *
 * Prefers the live catalog, falling back to the charter's declared
 * `requiresName` — which now only matters if an id is renamed out from under
 * the catalog, since both required upgrades ship in it.
 *
 * Takes an id OR a list, because `succession-doctrine` requires two. A lock
 * line naming one of two prerequisites is worse than none: the player buys the
 * named one and the button is still disabled.
 */ function $5114056da3d46141$var$commandUpgradeName(upgradeIds) {
    var charterDef = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var ids = Array.isArray(upgradeIds) ? upgradeIds : [
        upgradeIds
    ];
    var names = ids.map(function(id) {
        var _config_commandUpgrades_id, _config_commandUpgrades;
        return ((_config_commandUpgrades = $979b99378be707cd$export$617b3a0bcd7cead7) === null || _config_commandUpgrades === void 0 ? void 0 : (_config_commandUpgrades_id = _config_commandUpgrades[id]) === null || _config_commandUpgrades_id === void 0 ? void 0 : _config_commandUpgrades_id.name) || (charterDef === null || charterDef === void 0 ? void 0 : charterDef.requiresName) || id;
    });
    return names.length > 1 ? "".concat(names.slice(0, -1).join(', '), " and ").concat(names[names.length - 1]) : names[0];
}
function $5114056da3d46141$var$statBlock(label, valueHtml, note) {
    return '\n        <div class="flex-1 min-w-[200px] rounded-lg p-3" style="background:rgba(224,168,76,0.10); border:2px solid '.concat($5114056da3d46141$var$GOLD_DIM, ';">\n            <div class="text-[11px] uppercase tracking-widest text-gray-400">').concat(label, '</div>\n            <div class="text-lg font-bold leading-tight" style="color:').concat($5114056da3d46141$var$GOLD, '">').concat(valueHtml, '</div>\n            <div class="text-xs text-gray-400 mt-0.5 leading-snug">').concat(note, "</div>\n        </div>");
}
/**
 * Marks banked this era PLUS whatever the active character is carrying.
 *
 * Founding folds unbanked marks in (docs decision 8), so the preview has to as
 * well - showing only `eraMarks` would under-report the Writs the player is
 * about to receive and make the fold-in look like a bug.
 */ function $5114056da3d46141$var$projectedEra() {
    var _calculateCommandMarks;
    var syndicate = (0, $e39e78d7c65dc336$export$cdfa564b532bb699)();
    var unbanked = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character ? ((_calculateCommandMarks = (0, $ee71dfe8b201c427$export$ffae5de2f7ddd94d)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character)) === null || _calculateCommandMarks === void 0 ? void 0 : _calculateCommandMarks.total) || 0 : 0;
    return {
        eraMarks: syndicate.eraMarks,
        unbanked: unbanked,
        total: syndicate.eraMarks + unbanked
    };
}
function $5114056da3d46141$var$renderSyndicateStats() {
    var _gameState_command_legends, _gameState_command;
    var container = document.getElementById('syndicate-stats');
    if (!container) return;
    var syndicate = (0, $e39e78d7c65dc336$export$cdfa564b532bb699)();
    var legends = ((_gameState_command = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).command) === null || _gameState_command === void 0 ? void 0 : (_gameState_command_legends = _gameState_command.legends) === null || _gameState_command_legends === void 0 ? void 0 : _gameState_command_legends.length) || 0;
    var era = $5114056da3d46141$var$projectedEra();
    var foundedNote = syndicate.founded === 0 ? 'No Syndicate founded yet' : "".concat(syndicate.totalTours, " tour").concat(syndicate.totalTours === 1 ? '' : 's', " served across all eras");
    var eraNote = era.unbanked > 0 ? "".concat(era.eraMarks.toLocaleString(), " banked + ").concat(era.unbanked.toLocaleString(), " on your active character") : "".concat(legends, " of ").concat((0, $e39e78d7c65dc336$export$ab98ff7829062ba4)(), " Legends promoted this era");
    container.innerHTML = $5114056da3d46141$var$statBlock('Syndicate Writs', (syndicate.writs || 0).toLocaleString(), 'Issued at founding; spent on charters') + $5114056da3d46141$var$statBlock('Foundings', String(syndicate.founded), foundedNote) + $5114056da3d46141$var$statBlock('This Era', "".concat(era.total.toLocaleString(), "\uD83C\uDF96\uFE0F \u2192 ").concat((0, $e39e78d7c65dc336$export$fc09ffc64d9013e3)(era.total), "\uD83D\uDCDC"), eraNote);
}
/**
 * The founding call-to-action.
 *
 * Always shows what founding is worth right now, even when blocked - a prestige
 * the player cannot yet reach should still be legible, or the requirement reads
 * as an arbitrary wall rather than a goal.
 */ function $5114056da3d46141$var$renderFounding() {
    var _gameState_command_legends, _gameState_command;
    var container = document.getElementById('syndicate-founding');
    if (!container) return;
    var eligible = (0, $e39e78d7c65dc336$export$5799eac7aba24ab2)();
    var era = $5114056da3d46141$var$projectedEra();
    var writs = (0, $e39e78d7c65dc336$export$fc09ffc64d9013e3)(era.total);
    var legends = ((_gameState_command = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).command) === null || _gameState_command === void 0 ? void 0 : (_gameState_command_legends = _gameState_command.legends) === null || _gameState_command_legends === void 0 ? void 0 : _gameState_command_legends.length) || 0;
    var blockedCopy = {
        'insufficient-legends': "Promote ".concat((0, $e39e78d7c65dc336$export$ab98ff7829062ba4)() - legends, " more Legend").concat((0, $e39e78d7c65dc336$export$ab98ff7829062ba4)() - legends === 1 ? '' : 's', " to found."),
        'raid-in-progress': 'Finish or clear the current raid first.',
        'listed-on-marketplace': 'Your active character is listed on the marketplace.',
        'operations-in-flight': "Wait for your operations to complete \u2014 they are led by this era\u2019s Legends.",
        'no-command-layer': 'The Command layer is not open yet.'
    };
    var progressPct = Math.min(100, Math.round(legends / (0, $e39e78d7c65dc336$export$ab98ff7829062ba4)() * 100));
    container.innerHTML = '\n        <div class="rounded-lg px-3 py-2" style="background:rgba(224,168,76,0.07); border:2px solid '.concat($5114056da3d46141$var$GOLD_DIM, ';">\n            <div class="flex flex-wrap justify-between items-center gap-3">\n                <div class="min-w-0">\n                    <div class="font-bold" style="color:').concat($5114056da3d46141$var$GOLD, '">\uD83D\uDCDC Progress towards next Syndicate</div>\n                    <div class="founding-subtitle text-xs text-gray-300 leading-snug">\n                        Ends this Command era and issues <span class="font-bold" style="color:').concat($5114056da3d46141$var$GOLD, '">').concat(writs, "\uD83D\uDCDC</span>\n                        for the ").concat(era.total.toLocaleString(), '\uD83C\uDF96\uFE0F earned.\n                    </div>\n                </div>\n                <button onclick="openFoundModal()" ').concat(eligible.ok ? '' : 'disabled', '\n                    class="px-4 py-1.5 rounded font-bold whitespace-nowrap ').concat(eligible.ok ? 'text-black hover:shadow-lg' : 'bg-gray-600 text-gray-800 cursor-not-allowed', '"\n                    ').concat(eligible.ok ? 'style="background:'.concat($5114056da3d46141$var$GOLD, '"') : '', ">FOUND SYNDICATE</button>\n            </div>\n            ").concat(eligible.ok ? '' : '\n                <!-- Bar and reason share a row: stacked, this banner cost 128px of\n                     a 768px viewport for two short lines of status. -->\n                <div class="flex items-center gap-2 mt-1.5">\n                    <div class="flex-1 h-1.5 rounded-full bg-black/40 overflow-hidden">\n                        <div class="h-full" style="width:'.concat(progressPct, "%; background:").concat($5114056da3d46141$var$GOLD, '"></div>\n                    </div>\n                    <div class="text-xs text-gray-400 whitespace-nowrap">').concat(blockedCopy[eligible.reason] || 'Not available right now.', "</div>\n                </div>"), "\n        </div>");
}
function $5114056da3d46141$var$rankPips(owned, max) {
    var pips = '';
    for(var i = 0; i < max; i++)pips += '<span class="inline-block w-2.5 h-2.5 rounded-sm mr-1" style="border:1px solid '.concat($5114056da3d46141$var$GOLD_DIM, "; ").concat(i < owned ? "background:".concat($5114056da3d46141$var$GOLD, ";") : '', '"></span>');
    return '<span title="Rank '.concat(owned, "/").concat(max, '">').concat(pips, "</span>");
}
function $5114056da3d46141$var$renderCharters() {
    var container = document.getElementById('syndicate-charters');
    if (!container) return;
    var syndicate = (0, $e39e78d7c65dc336$export$cdfa564b532bb699)();
    container.innerHTML = Object.entries($979b99378be707cd$export$1a64c4c64ba19abd).map(function(param) {
        var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), id = _param[0], def = _param[1];
        var rank = (0, $e39e78d7c65dc336$export$6955e231f1466c44)(id);
        var maxed = rank >= def.costs.length;
        var nextCost = maxed ? null : def.costs[rank];
        // A cross-layer requirement is a real blocker, not a price problem, so
        // it gets its own line rather than a silently-disabled button.
        // Same rule as the purchase itself (`requiredUpgradesMissing`), so the
        // card and the button can never disagree about whether it is buyable.
        var missingRequirement = (0, $ee71dfe8b201c427$export$21736c92e8c4e21c)(def);
        var affordable = !maxed && !missingRequirement.length && syndicate.writs >= nextCost;
        var rankLabel = def.costs.length > 1 && !maxed ? "Rank ".concat($5114056da3d46141$var$ROMAN[rank] || rank + 1, " \u2014 ") : '';
        var requirementName = missingRequirement.length ? $5114056da3d46141$var$commandUpgradeName(missingRequirement, def) : null;
        return '\n            <div class="catalog-card bg-white/10 border-2 border-gray-700 rounded-lg p-3 flex flex-col gap-1.5">\n                <div class="flex justify-between items-baseline gap-2">\n                    <h4 class="font-bold text-[15px] m-0" style="color:'.concat($5114056da3d46141$var$GOLD, '">').concat(def.icon, " ").concat(def.name, "</h4>\n                    ").concat($5114056da3d46141$var$rankPips(rank, def.costs.length), '\n                </div>\n                <div class="catalog-card-flavor text-xs text-gray-400 italic leading-snug" title="').concat(def.flavor, '">').concat(def.flavor, '</div>\n                <div class="catalog-card-effect text-[13px] leading-snug">').concat(def.effect).concat(rank > 0 && !maxed ? ' <span class="text-game-success">Rank '.concat($5114056da3d46141$var$ROMAN[rank - 1] || rank, " owned.</span>") : '', "</div>\n                ").concat(requirementName ? '<div class="text-xs text-amber-300">\uD83D\uDD12 Requires the '.concat(requirementName, " Command upgrade").concat(missingRequirement.length > 1 ? 's' : '', ".</div>") : '', '\n                <div class="catalog-card-footer flex justify-between items-center mt-auto pt-2">\n                    ').concat(maxed ? '<span class="text-game-success text-sm font-bold">\u2713 Maxed</span><span></span>' : '<span class="font-bold text-sm" style="color:'.concat($5114056da3d46141$var$GOLD, '">').concat(rankLabel).concat(nextCost, " \uD83D\uDCDC</span>\n                           <button onclick=\"purchaseCharter('").concat(id, "')\" ").concat(affordable ? '' : 'disabled', '\n                               class="px-3 py-1.5 rounded text-xs font-bold ').concat(affordable ? 'text-black hover:shadow-lg' : 'bg-gray-600 text-gray-800 cursor-not-allowed', '"\n                               ').concat(affordable ? 'style="background:'.concat($5114056da3d46141$var$GOLD, '"') : '', ">SIGN</button>"), "\n                </div>\n            </div>");
    }).join('');
}
/**
 * The SAME card the Command gallery uses, in Syndicate gold.
 *
 * A Leader is a Legend who won an election — showing them as a plain text box
 * beside Command's portrait cards made the layer's most permanent character read
 * as the least important thing on the page. A Leader snapshot carries fewer
 * fields than a full Legend record, and the shared card renders only what is
 * present.
 */ function $5114056da3d46141$var$leaderCard(leader, title, note) {
    return (0, $1b36c0b1091d5de9$export$5eeeb728aab285f9)(leader, {
        accent: $5114056da3d46141$var$GOLD,
        accentDim: $5114056da3d46141$var$GOLD_DIM,
        title: title,
        note: note
    });
}
/**
 * Succession status.
 *
 * Reads `successionStatus()` — the SAME computation the automation acts on, so
 * the panel can never tell the player something the doctrine does not believe.
 * Shown whenever the charter is owned, including while paused.
 */ function $5114056da3d46141$var$renderSuccession() {
    var _ensureSyndicateState_succession, _gameState_character;
    var container = document.getElementById('syndicate-succession');
    if (!container) return;
    if ((0, $e39e78d7c65dc336$export$6955e231f1466c44)('succession-doctrine') <= 0) {
        container.innerHTML = '';
        return;
    }
    var s = (0, $e39e78d7c65dc336$export$8f29b06b79596501)();
    var paused = (_ensureSyndicateState_succession = (0, $e39e78d7c65dc336$export$cdfa564b532bb699)().succession) === null || _ensureSyndicateState_succession === void 0 ? void 0 : _ensureSyndicateState_succession.paused;
    var template = (0, $e39e78d7c65dc336$export$a91ccccac4a2b08)();
    var pct = Math.min(100, Math.round(s.marksIfPromotedNow / Math.max(1, s.floor) * 100));
    var state = paused ? "\u23F8 Paused" : s.due ? "\u25B6 Promoting now \u2014 ".concat(s.reason === 'max-tour' ? 'tour cap reached' : 'past the rate peak') : s.tourRaids < (0, $e39e78d7c65dc336$export$65d88b3701cdf574).minTourRaids ? "Watching \u2014 ".concat((0, $e39e78d7c65dc336$export$65d88b3701cdf574).minTourRaids - s.tourRaids, " more raid").concat((0, $e39e78d7c65dc336$export$65d88b3701cdf574).minTourRaids - s.tourRaids === 1 ? '' : 's', " before the rate is judged") : s.marksIfPromotedNow < s.floor ? "Holding \u2014 promotion buys nothing yet (".concat(s.marksIfPromotedNow, "/").concat(s.floor, "\uD83C\uDF96\uFE0F)") : "Watching the rate \u2014 ".concat(s.raidsSincePeak, "/").concat((0, $e39e78d7c65dc336$export$65d88b3701cdf574).peakPatienceRaids, " raids past the peak");
    container.innerHTML = '\n        <div class="rounded-lg p-4" style="background:rgba(224,168,76,0.07); border:2px solid '.concat($5114056da3d46141$var$GOLD_DIM, ';">\n            <div class="flex flex-wrap justify-between items-center gap-3">\n                <div>\n                    <div class="font-bold" style="color:').concat($5114056da3d46141$var$GOLD, '">\uD83D\uDD4A\uFE0F Succession Doctrine</div>\n                    <div class="text-sm text-gray-300 mt-1">').concat(state, '</div>\n                </div>\n                <button onclick="toggleSuccessionPause()"\n                    class="px-3 py-1.5 rounded text-xs font-bold ').concat(paused ? 'text-black' : 'bg-gray-600 text-white hover:bg-gray-500', '"\n                    ').concat(paused ? 'style="background:'.concat($5114056da3d46141$var$GOLD, '"') : '', ">").concat(paused ? 'RESUME' : 'PAUSE', '</button>\n            </div>\n            <div class="mt-3 h-2 rounded-full bg-black/40 overflow-hidden">\n                <div class="h-full" style="width:').concat(pct, "%; background:").concat($5114056da3d46141$var$GOLD, '"></div>\n            </div>\n            <div class="text-xs text-gray-400 mt-1">\n                Tour: ').concat(s.tourRaids, " raid").concat(s.tourRaids === 1 ? '' : 's', " \xb7\n                ").concat(s.marks, "\uD83C\uDF96\uFE0F on ").concat(((_gameState_character = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character) === null || _gameState_character === void 0 ? void 0 : _gameState_character.name) || 'no one', " \xb7\n                rate ").concat(s.avgRate.toFixed(1), "\uD83C\uDF96\uFE0F/raid (peak ").concat(s.peakRate.toFixed(1), ')\n            </div>\n            <div class="text-xs text-gray-400 mt-1">\n                Successor: ').concat(template ? "".concat(template.faction).concat(template.derived ? " \u2014 mirrors your current character" : ' (your template)') : 'none', "\n            </div>\n        </div>");
}
function $5114056da3d46141$var$renderLeadership() {
    var container = document.getElementById('syndicate-leadership');
    if (!container) return;
    var syndicate = (0, $e39e78d7c65dc336$export$cdfa564b532bb699)();
    if (!syndicate.leader) {
        // Pre-founding: show who WOULD be elected. The Leader is a permanent
        // Operations anchor, so knowing the candidate is a reason to keep
        // promoting rather than a surprise at the ceremony.
        var candidate = (0, $e39e78d7c65dc336$export$9ab0fc0c1d4f0dcd)();
        container.innerHTML = candidate ? $5114056da3d46141$var$leaderCard(candidate, 'Leader-presumptive', "Elected when you found \u2014 the era\u2019s best record leads the Syndicate permanently.") : '<div class="text-sm text-gray-400">No Legends yet. The era\'s highest-marks Legend becomes your Syndicate Leader.</div>';
        return;
    }
    container.innerHTML = $5114056da3d46141$var$leaderCard(syndicate.leader, 'Syndicate Leader', "Permanent \u2014 leads operations in every era.") + syndicate.pastLeaders.slice().reverse().map(function(l) {
        return $5114056da3d46141$var$leaderCard(l, 'Past Leader', '');
    }).join('');
}
(0, $bf6cb3ebdd8098d6$export$589dc1e4c906c789)('syndicate', {
    panes: {
        charters: 'syndicate-pane-charters',
        leadership: 'syndicate-pane-leadership',
        blackout: 'syndicate-pane-blackout'
    },
    scrollers: {
        charters: 'syndicate-charters',
        leadership: 'syndicate-leadership',
        blackout: 'syndicate-blackout'
    }
});
function $5114056da3d46141$export$8cd027517c8fb270() {
    $5114056da3d46141$var$renderSyndicateStats();
    $5114056da3d46141$var$renderFounding();
    $5114056da3d46141$var$renderSuccession();
    $5114056da3d46141$var$renderCharters();
    $5114056da3d46141$var$renderLeadership();
    (0, $0fcd42b930415164$export$736506b4b237950c)();
    // Re-measures the scroller: the founding banner and the succession panel
    // above it both change height with state, so a fixed offset would be wrong
    // the moment a charter is bought.
    (0, $bf6cb3ebdd8098d6$export$7ad721b2ffe28f0c)('syndicate');
}
function $5114056da3d46141$export$dbfe7896af6f1ddd(charterId) {
    var _config_syndicateUpgrades;
    var def = (_config_syndicateUpgrades = $979b99378be707cd$export$1a64c4c64ba19abd) === null || _config_syndicateUpgrades === void 0 ? void 0 : _config_syndicateUpgrades[charterId];
    var result = (0, $e39e78d7c65dc336$export$db5a865159d9ae65)(charterId);
    if (!result.success) {
        var messages = {
            'insufficient-writs': 'Not enough Writs',
            'max-rank': 'Already at maximum rank!',
            'unknown-charter': 'Unknown charter',
            'missing-requirement': "Requires the ".concat($5114056da3d46141$var$commandUpgradeName(result.requires, def), " Command upgrade first")
        };
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)(messages[result.reason] || 'Could not sign that charter', 'error');
        return;
    }
    var rankSuffix = def.costs.length > 1 ? " Rank ".concat($5114056da3d46141$var$ROMAN[result.rank - 1] || result.rank) : '';
    (0, $b5bda7fdec806d8b$export$c7def531c087da85)("\uD83D\uDCDC Signed ".concat(def.name).concat(rankSuffix, " (-").concat(result.cost, " \uD83D\uDCDC)"), 'success');
    (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
    $5114056da3d46141$export$8cd027517c8fb270();
    (0, $59924438766e7d8e$export$d1c957a54f7124bc)();
}
function $5114056da3d46141$export$fd4956538c1ee694() {
    var _gameState_character, _gameState_command_legends, _gameState_command;
    var modal = document.getElementById('found-modal');
    var body = document.getElementById('found-modal-body');
    if (!modal || !body) return;
    var eligible = (0, $e39e78d7c65dc336$export$5799eac7aba24ab2)();
    if (!eligible.ok) {
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)('Cannot found a Syndicate right now', 'error');
        return;
    }
    var era = $5114056da3d46141$var$projectedEra();
    var writs = (0, $e39e78d7c65dc336$export$fc09ffc64d9013e3)(era.total);
    var leader = (0, $e39e78d7c65dc336$export$9ab0fc0c1d4f0dcd)();
    // Standing Orders re-grants BOTH automation upgrades, so the ledger names
    // both. This column is the confirmation for an irreversible action —
    // under-reporting what survives is the same class of error as
    // over-reporting it.
    var keepsAutomation = (0, $e39e78d7c65dc336$export$6955e231f1466c44)('standing-orders') > 0;
    var endowment = (0, $e39e78d7c65dc336$export$d9ea4b2d96397ab9)('founders-endowment', 0);
    // Both columns, spelled out. Founding is irreversible and wipes an era of
    // work, so the ledger IS the ceremony - a confirm dialog that only said
    // "are you sure?" would be the wrong control for this decision.
    body.innerHTML = '\n        <p class="mb-4">\n            Your Syndicate is founded from the officers of this era. Their record becomes its charter \u2014\n            and the Command layer starts again from nothing.\n        </p>\n\n        <div class="rounded-lg p-4 mb-4" style="background:rgba(224,168,76,0.10); border:2px solid '.concat($5114056da3d46141$var$GOLD_DIM, ';">\n            <div class="text-[11px] uppercase tracking-widest text-gray-400">You receive</div>\n            <div class="text-2xl font-bold mt-1" style="color:').concat($5114056da3d46141$var$GOLD, '">').concat(writs, ' \uD83D\uDCDC Writs</div>\n            <div class="text-xs text-gray-400 mt-1">\n                from ').concat(era.total.toLocaleString(), "\uD83C\uDF96\uFE0F this era").concat(era.unbanked > 0 ? " \u2014 including ".concat(era.unbanked.toLocaleString(), "\uD83C\uDF96\uFE0F still on ").concat((_gameState_character = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character) === null || _gameState_character === void 0 ? void 0 : _gameState_character.name, ", folded in automatically") : '', "\n            </div>\n            ").concat(leader ? '<div class="text-sm mt-2">Syndicate Leader: <span class="font-bold" style="color:'.concat($5114056da3d46141$var$GOLD, '">').concat(leader.name, "</span> (").concat((leader.marksEarned || 0).toLocaleString(), "\uD83C\uDF96\uFE0F)</div>") : '', '\n        </div>\n\n        <div class="grid gap-4 mb-4" style="grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));">\n            <div class="rounded-lg p-3 border-2 border-red-900/60" style="background:rgba(239,68,68,0.07)">\n                <div class="text-[11px] uppercase tracking-widest text-red-300">Wiped</div>\n                <ul class="text-[13px] mt-2 space-y-1 list-disc list-inside text-gray-200">\n                    <li>All Command Marks and upgrades</li>\n                    <li>All ').concat(((_gameState_command = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).command) === null || _gameState_command === void 0 ? void 0 : (_gameState_command_legends = _gameState_command.legends) === null || _gameState_command_legends === void 0 ? void 0 : _gameState_command_legends.length) || 0, " Legends</li>\n                    <li>Regional charters</li>\n                    <li>Your characters, and the vault's materials</li>\n                    <li>Credits, down to ").concat($979b99378be707cd$export$9f9786ac427715c7.promotionCreditLevy.floor.toLocaleString(), '</li>\n                </ul>\n            </div>\n            <div class="rounded-lg p-3 border-2 border-green-900/60" style="background:rgba(74,222,128,0.07)">\n                <div class="text-[11px] uppercase tracking-widest text-green-300">Kept</div>\n                <ul class="text-[13px] mt-2 space-y-1 list-disc list-inside text-gray-200">\n                    <li>Every Writ and charter you hold</li>\n                    <li>Unlocked artifact designs</li>\n                    <li>Artifact blueprints in the vault</li>\n                    <li>Your Syndicate Leader, and past leaders</li>\n                    ').concat(keepsAutomation ? '<li>Auto-Raid Protocol and Auto-Fabricator (Standing Orders)</li>' : '', "\n                    ").concat(endowment > 0 ? "<li>".concat(endowment, "\uD83C\uDF96\uFE0F to start the next era (Founder's Endowment)</li>") : '', '\n                </ul>\n            </div>\n        </div>\n\n        <div class="flex justify-end gap-3">\n            <button onclick="closeFoundModal()" class="px-4 py-2 rounded font-bold bg-gray-600 hover:bg-gray-500 text-white">Not yet</button>\n            <button onclick="confirmFounding()" class="px-4 py-2 rounded font-bold text-black hover:shadow-lg" style="background:').concat($5114056da3d46141$var$GOLD, '">Sign the Charter</button>\n        </div>');
    modal.classList.remove('hidden');
}
function $5114056da3d46141$export$e82e976bfeefb724() {
    var _document_getElementById;
    (_document_getElementById = document.getElementById('found-modal')) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.classList.add('hidden');
}
function $5114056da3d46141$export$4f6051a0a4daa070() {
    var _window_multiplayer, _result_leader;
    var character = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character;
    var multiplayerId = character === null || character === void 0 ? void 0 : character.multiplayerId;
    var result = (0, $e39e78d7c65dc336$export$1861729e67332c20)();
    if (!result.success) {
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)('Cannot found a Syndicate right now', 'error');
        $5114056da3d46141$export$e82e976bfeefb724();
        return;
    }
    // Same server-side handling promotion uses: the character is gone.
    if (multiplayerId && ((_window_multiplayer = window.multiplayer) === null || _window_multiplayer === void 0 ? void 0 : _window_multiplayer.deleteOwnCharacter)) window.multiplayer.deleteOwnCharacter(multiplayerId);
    // Fresh outpost for the new era.
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).selectedFaction = null;
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).contractors = [];
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.hiredContractors = [];
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.reservedContractors = [];
    (0, $670e0f14fa02ad13$export$aca974319671fb3e)();
    $5114056da3d46141$export$e82e976bfeefb724();
    (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
    (0, $b5bda7fdec806d8b$export$c7def531c087da85)("\uD83D\uDCDC Syndicate founded \u2014 ".concat(((_result_leader = result.leader) === null || _result_leader === void 0 ? void 0 : _result_leader.name) || 'your Leader', " takes the charter \xb7 +").concat(result.writs, " \uD83D\uDCDC"), 'success', {
        sticky: true
    } // irreversible, once per era, and it hands off to a fresh character
    );
    // The active slot is empty: same handoff promotion performs.
    (0, $59924438766e7d8e$export$2ae62d947e9e1d03)();
    (0, $59924438766e7d8e$export$d1c957a54f7124bc)();
    (0, $8896b37f0fd85895$export$5672aa0b2d188c2b)();
    $5114056da3d46141$export$8cd027517c8fb270();
    if (window.showCharacterScreenAfterPromotion) window.showCharacterScreenAfterPromotion();
}
// ---------------------------------------------------------------------------
// Succession Doctrine — promote at the peak, raise the successor
// ---------------------------------------------------------------------------
/** Successor names. Flavour only; the player can rename from the character card. */ var $5114056da3d46141$var$SUCCESSOR_NAMES = [
    'Ash',
    'Vale',
    'Corr',
    'Wren',
    'Idris',
    'Sable',
    'Quill',
    'Mercer',
    'Rook',
    'Lin'
];
function $5114056da3d46141$var$successorName(tour) {
    // Deterministic from the tour number rather than random, so a successor's
    // name is reproducible from a save rather than a fresh roll on every load.
    return "".concat($5114056da3d46141$var$SUCCESSOR_NAMES[tour % $5114056da3d46141$var$SUCCESSOR_NAMES.length], "-").concat(tour);
}
function $5114056da3d46141$export$e62c6e81abdadce7(status) {
    var _window_multiplayer;
    var outgoing = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character;
    if (!outgoing) return {
        success: false,
        reason: 'no-character'
    };
    var template = (0, $e39e78d7c65dc336$export$a91ccccac4a2b08)();
    var multiplayerId = outgoing.multiplayerId;
    var result = (0, $ee71dfe8b201c427$export$f0bd6e9010bb1600)();
    if (!result.success) return result;
    if (multiplayerId && ((_window_multiplayer = window.multiplayer) === null || _window_multiplayer === void 0 ? void 0 : _window_multiplayer.deleteOwnCharacter)) window.multiplayer.deleteOwnCharacter(multiplayerId);
    // Fresh outpost, exactly as the manual promote path does.
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).selectedFaction = (template === null || template === void 0 ? void 0 : template.faction) || null;
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).contractors = [];
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.hiredContractors = [];
    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.reservedContractors = [];
    (0, $670e0f14fa02ad13$export$aca974319671fb3e)();
    var recruit = (0, $7ea2865b97769aa3$export$c05f4d64df5567a5)({
        name: $5114056da3d46141$var$successorName((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).command.tour),
        faction: (template === null || template === void 0 ? void 0 : template.faction) || outgoing.faction
    });
    // Spend the recruit's opening points along the template's ordering, so the
    // successor starts pointed the same way the player was playing.
    $5114056da3d46141$var$applySkillPlan(recruit, (template === null || template === void 0 ? void 0 : template.skillPlan) || []);
    (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
    (0, $b5bda7fdec806d8b$export$c7def531c087da85)("\uD83D\uDD4A\uFE0F Succession \u2014 ".concat(result.legend.name, " promoted (").concat(result.marks.total, "\uD83C\uDF96\uFE0F, ").concat((status === null || status === void 0 ? void 0 : status.reason) === 'max-tour' ? 'tour cap' : 'rate peak', ") \xb7 ").concat(recruit.name, " takes the field"), 'success', {
        sticky: true
    } // happens while the player is away, and it replaced their character
    );
    (0, $59924438766e7d8e$export$2ae62d947e9e1d03)();
    (0, $59924438766e7d8e$export$d1c957a54f7124bc)();
    (0, $8896b37f0fd85895$export$5672aa0b2d188c2b)();
    $5114056da3d46141$export$8cd027517c8fb270();
    return {
        success: true,
        legend: result.legend,
        recruit: recruit
    };
}
function $5114056da3d46141$export$ee70bc03de7bbd2f() {
    var _ensureSyndicateState_succession;
    var paused = (0, $e39e78d7c65dc336$export$43bf52c97b14116a)(!((_ensureSyndicateState_succession = (0, $e39e78d7c65dc336$export$cdfa564b532bb699)().succession) === null || _ensureSyndicateState_succession === void 0 ? void 0 : _ensureSyndicateState_succession.paused));
    (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
    $5114056da3d46141$export$8cd027517c8fb270();
    (0, $b5bda7fdec806d8b$export$c7def531c087da85)(paused ? "\uD83D\uDD4A\uFE0F Succession paused" : "\uD83D\uDD4A\uFE0F Succession resumed", paused ? 'info' : 'success');
}
function $5114056da3d46141$var$applySkillPlan(character, skillPlan) {
    if (!character || !(skillPlan === null || skillPlan === void 0 ? void 0 : skillPlan.length)) return;
    var points = character.skillPoints || 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = skillPlan[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var skillId = _step.value;
            if (points <= 0) break;
            character.skills[skillId] = (character.skills[skillId] || 0) + 1;
            points -= 1;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    character.skillPoints = points;
}
// ---------------------------------------------------------------------------
// Window exposure (onclick-string pattern used across the codebase)
// ---------------------------------------------------------------------------
if (typeof window !== 'undefined') {
    window.purchaseCharter = $5114056da3d46141$export$dbfe7896af6f1ddd;
    window.openFoundModal = $5114056da3d46141$export$fd4956538c1ee694;
    window.closeFoundModal = $5114056da3d46141$export$e82e976bfeefb724;
    window.confirmFounding = $5114056da3d46141$export$4f6051a0a4daa070;
    window.toggleSuccessionPause = $5114056da3d46141$export$ee70bc03de7bbd2f;
    document.addEventListener('DOMContentLoaded', function() {
        var _document_getElementById;
        (_document_getElementById = document.getElementById('found-modal-close')) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.addEventListener('click', $5114056da3d46141$export$e82e976bfeefb724);
    });
}


/**
 * Operations UI (M3 S4) — the browser wrapper over operations-core.js.
 *
 * Layout is the INVERSE of the raid view on purpose: the whole world map at the
 * top, controls beneath it. A raid path is built by clicking rooms in sequence;
 * a route is chosen by looking at where things are relative to each other, so
 * the map has to be the thing you read first.
 *
 * The map is a plain CSS grid, NOT the raid grid renderer. The spec suggested
 * reusing it, but that renderer paints a procedural canvas per tile and is
 * wired to raid state throughout; a world map needs five region pins and some
 * terrain shading. Reuse would have cost more than it saved.
 *
 * All rules live in operations-core.js — this file renders and reports.
 */ 









var $c95f3da2626a9dfc$var$GOLD = '#e0a84c';
var $c95f3da2626a9dfc$var$GOLD_DIM = '#8a6526';
/**
 * Territory colour per region.
 *
 * Placeholder until tiles are procedurally generated (no spec yet): the job for
 * now is only that a player can see WHICH region a tile belongs to. Hues are
 * spread far enough apart to stay distinct after terrain shading darkens them.
 */ var $c95f3da2626a9dfc$var$REGION_COLOR = {
    'cradle-expanse': '#7a5a3c',
    'shard-cities': '#4a5a7a',
    'verdant-reclamation': '#3f6b45',
    'sunken-bastions': '#2f6b6b',
    'hollow-core': '#6b3f5f'
};
/**
 * Terrain modulates the territory colour rather than replacing it, so a tile
 * answers both questions at once: whose is it, and what is the ground like.
 * `mix` is how far toward the terrain tint the region colour is dragged.
 */ var $c95f3da2626a9dfc$var$TERRAIN_STYLE = {
    '.': {
        tint: null,
        mix: 0,
        label: 'Open ground',
        cost: 1
    },
    // Highland LIGHTENS. Darkening made high ground read as shadow, which is
    // backwards — at this scale a highland is a snowline, and the eye reads
    // pale as "up".
    '^': {
        tint: '#dfe7f0',
        mix: 0.34,
        label: 'Highland',
        cost: 2
    },
    // Ocean is very nearly uniform, and dark. It used to blend only halfway to
    // a mid blue, which left every sea tile carrying its region's hue — the map
    // read as five vertical colour bands with invisible coastlines. Darkening
    // it further is what separates the sea from the two regions whose own
    // colours are blue-ish (Shard Cities slate, Flooded Bastions teal); at a
    // lighter value their coastlines disappeared into it.
    '~': {
        tint: '#061424',
        mix: 0.92,
        label: 'Ocean',
        cost: 3
    },
    '#': {
        tint: '#000000',
        mix: 0.85,
        label: 'Impassable',
        cost: null
    }
};
/** Blend two hex colours. Keeps territory legible under terrain shading. */ function $c95f3da2626a9dfc$var$mixHex(base, tint, amount) {
    if (!tint || amount <= 0) return base;
    var parse = function(h) {
        return [
            1,
            3,
            5
        ].map(function(i) {
            return parseInt(h.slice(i, i + 2), 16);
        });
    };
    var _parse = (0, $1788e2ed61915b1e$export$71511d61b312f219)(parse(base), 3), r1 = _parse[0], g1 = _parse[1], b1 = _parse[2];
    var _parse1 = (0, $1788e2ed61915b1e$export$71511d61b312f219)(parse(tint), 3), r2 = _parse1[0], g2 = _parse1[1], b2 = _parse1[2];
    var blend = function(a, b) {
        return Math.round(a + (b - a) * amount).toString(16).padStart(2, '0');
    };
    return "#".concat(blend(r1, r2)).concat(blend(g1, g2)).concat(blend(b1, b2));
}
/** Distinct colours for each convoy in transit, so routes never merge visually. */ var $c95f3da2626a9dfc$var$CONVOY_COLORS = [
    '#6ee7ff',
    '#ff9de2',
    '#ffe066'
];
/** Green marks a delivery that also earns the Writ trickle. */ var $c95f3da2626a9dfc$var$DEMAND_HOT = '#7df5a0';
/**
 * The demand premium, rendered.
 *
 * Two states worth distinguishing, not one: any premium is worth seeing, but the
 * Writ threshold is a cliff — cross it and a Long Haul pays 2📜 instead of 1 —
 * and a cliff nobody can see is a cliff nobody plans around.
 */ /**
 * Would a delivery at this multiplier actually bank a Writ *as drafted*?
 *
 * BOTH halves have to hold: the market must be hungry AND the class must be
 * Writ-eligible (only Grand Circuit is — see OPERATION_TEMPLATES). Reading the
 * demand alone stamped 📜 on every hungry destination on the map even while a
 * Short Haul was selected, promising a reward that class can never earn.
 *
 * Deliberately NOT used for the demand COLOUR: a market is hot whatever you
 * choose to send, and hiding that would hide the reason to step up a class.
 */ function $c95f3da2626a9dfc$var$draftEarnsWrit(multiplier) {
    var _OPERATION_TEMPLATES_draft_templateId;
    return (0, $35d30e7dcff465af$export$d48946d0a3e2934b)(multiplier) && !!((_OPERATION_TEMPLATES_draft_templateId = (0, $aee9584c1e6e51e7$export$36ac5ebae0245093)[$c95f3da2626a9dfc$var$draft.templateId]) === null || _OPERATION_TEMPLATES_draft_templateId === void 0 ? void 0 : _OPERATION_TEMPLATES_draft_templateId.writEligible);
}
function $c95f3da2626a9dfc$var$demandChip(multiplier) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_markWrit = _ref.markWrit, markWrit = _ref_markWrit === void 0 ? true : _ref_markWrit, _ref_base = _ref.base, base = _ref_base === void 0 ? null : _ref_base;
    // A fallen price is only readable next to what it fell from, so a fed market
    // carries its struck-through list price. Only when it has actually moved —
    // "×2.00 ×2.00" would be noise on every hungry region on the map.
    var strike = $c95f3da2626a9dfc$var$isFed(multiplier, base) ? ' <span class="text-gray-500 line-through">\xd7'.concat(base.toFixed(2), "</span>") : '';
    if (!multiplier || multiplier <= (0, $35d30e7dcff465af$export$2119d59df637b878)) return '<span class="text-gray-500">\xd71.00</span>'.concat(strike);
    var hot = (0, $35d30e7dcff465af$export$d48946d0a3e2934b)(multiplier);
    // `markWrit` off wherever the actual Writ count is already on the line —
    // "+2📜 · ×1.90 +📜" says the same thing twice and reads as two bonuses.
    return '<span style="color:'.concat(hot ? $c95f3da2626a9dfc$var$DEMAND_HOT : $c95f3da2626a9dfc$var$GOLD, '">\xd7').concat(multiplier.toFixed(2)).concat(markWrit && $c95f3da2626a9dfc$var$draftEarnsWrit(multiplier) ? " +\uD83D\uDCDC" : '', "</span>").concat(strike);
}
/** Plain-text form of the same, for <option> labels and tooltips. */ function $c95f3da2626a9dfc$var$demandText(multiplier) {
    var base = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var list = $c95f3da2626a9dfc$var$isFed(multiplier, base) ? " (list \xd7".concat(base.toFixed(2), ")") : '';
    if (!multiplier || multiplier <= (0, $35d30e7dcff465af$export$2119d59df637b878)) return "\xd71.00".concat(list);
    return "\xd7".concat(multiplier.toFixed(2)).concat($c95f3da2626a9dfc$var$draftEarnsWrit(multiplier) ? " +\uD83D\uDCDC" : '').concat(list);
}
/**
 * Has this price actually been pushed down by saturation?
 *
 * The epsilon is not decoration: both numbers are rounded to 2dp independently,
 * so a market a fraction of a percent fed can round to its own list price and a
 * bare `>` would strike through "×2.00 ×2.00".
 */ function $c95f3da2626a9dfc$var$isFed(multiplier, base) {
    return base != null && base > (multiplier || 0) + 0.005;
}
/** Recovery time, rounded to whatever unit reads better at that scale. */ function $c95f3da2626a9dfc$var$recoveryText(ms) {
    var hours = ms / 3600000;
    return hours >= 1 ? "~".concat(Math.round(hours), "h") : "~".concat(Math.max(1, Math.round(hours * 60)), "m");
}
/**
 * Why a price is down and when it comes back, appended to a tooltip.
 *
 * Empty for a hungry market: the mechanic should be invisible until it bites,
 * and a "0% fed" note on every region teaches nothing.
 */ function $c95f3da2626a9dfc$var$saturationNote(regionId, faction) {
    var level = (0, $35d30e7dcff465af$export$f9e4fa3cb5360b25)(regionId, faction);
    if (level <= 0) return '';
    return " \xb7 market ".concat(Math.round(level * 100), "% fed, list \xd7").concat((0, $35d30e7dcff465af$export$37444e2aca3975f8)(regionId, faction).toFixed(2), ",") + " recovers ".concat($c95f3da2626a9dfc$var$recoveryText((0, $35d30e7dcff465af$export$5839d85e36227b6a)(regionId, faction)));
}
/**
 * Which view of the Operations screen is showing.
 *
 * Planning a convoy and watching three of them are different jobs. Putting both
 * on one page meant the map carried every route at once, which is exactly the
 * information overload this splits apart:
 *
 *   'plan'    — the map with ONLY the route being planned, plus the controls
 *   'transit' — the map with every convoy, plus their cards; no controls
 *
 * The toolbar's "New Operation" button opens 'plan'; the Operations screen tab
 * opens 'transit'.
 */ var $c95f3da2626a9dfc$var$view = 'transit';
/** In 'transit', the convoy whose route is isolated. null = show them all. */ var $c95f3da2626a9dfc$var$selectedOpId = null;
function $c95f3da2626a9dfc$export$a4a190e64d36c7a(next) {
    $c95f3da2626a9dfc$var$view = next === 'plan' ? 'plan' : 'transit';
    if ($c95f3da2626a9dfc$var$view === 'plan') $c95f3da2626a9dfc$var$selectedOpId = null;
    $c95f3da2626a9dfc$export$1ed263e826d67cb7();
}
function $c95f3da2626a9dfc$export$7bde3dae25e9ac40(opId) {
    // Clicking the selected convoy again returns to "show them all", so there
    // is always a way back without hunting for a deselect control.
    $c95f3da2626a9dfc$var$selectedOpId = $c95f3da2626a9dfc$var$selectedOpId === opId ? null : opId;
    $c95f3da2626a9dfc$export$1ed263e826d67cb7();
}
/** Planner selection. Module state, not gameState: nothing here is worth saving. */ var $c95f3da2626a9dfc$var$draft = {
    templateId: 'short-haul',
    toRegionId: null,
    fromRegionId: null,
    skillId: null,
    leadName: null
};
/**
 * The four staging points available for the chosen destination, shortest first.
 *
 * No cache and no template argument, both of which the derived-origin version
 * needed: offers were random within a ring, so re-rolling on every render made
 * the map shuffle under the cursor, and reach depended on the template. Neither
 * is true now — this is four Dijkstra runs over 153 tiles with one answer, so
 * caching it would only be a second thing to invalidate.
 *
 * Sorted by duration because duration is the decision the list exists to serve.
 */ function $c95f3da2626a9dfc$var$currentOffers() {
    if (!$c95f3da2626a9dfc$var$draft.toRegionId) return [];
    return (0, $aee9584c1e6e51e7$export$f41c2be0717214ee)($c95f3da2626a9dfc$var$draft.toRegionId).sort(function(a, b) {
        return a.hours - b.hours;
    });
}
/** The offer for the chosen origin, or null. */ function $c95f3da2626a9dfc$var$currentOffer() {
    return $c95f3da2626a9dfc$var$currentOffers().find(function(o) {
        return o.fromRegionId === $c95f3da2626a9dfc$var$draft.fromRegionId;
    }) || null;
}
/**
 * Every signature a convoy can carry, grouped by faction.
 *
 * ALL fifteen, not just the player's own five. Restricting cargo to your own
 * faction made the demand premium a single lookup: a dominion player's five
 * signatures all price identically, so the only variable left was destination
 * and there was exactly one right answer forever.
 *
 * Opening it up is what makes this an economy BETWEEN factions rather than a
 * price list. Off-faction material is what a player accumulates by raiding
 * elsewhere and has no recipes for, and the regions that pay most for it are the
 * ones that produce least of it. Nothing had to be built: planCargo already
 * reads any signature, and a signature the player has no stock in simply blocks
 * the launch as "NO CARGO".
 *
 * @returns {Array<{faction:string, name:string, skills:string[]}>}
 */ function $c95f3da2626a9dfc$var$signatureGroups() {
    var _gameState_character;
    var own = (_gameState_character = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character) === null || _gameState_character === void 0 ? void 0 : _gameState_character.faction;
    return Object.entries($979b99378be707cd$export$aeeef991191508e2 || {}).map(function(param) {
        var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), faction = _param[0], def = _param[1];
        return {
            faction: faction,
            name: def.name || faction,
            skills: Object.keys(def.skills || {})
        };
    })// The player's own faction first: it is the one they will usually have
    // stock in, so it should not need scrolling to.
    .sort(function(a, b) {
        return (a.faction === own ? -1 : 0) - (b.faction === own ? -1 : 0);
    });
}
function $c95f3da2626a9dfc$var$allSignatureIds() {
    return $c95f3da2626a9dfc$var$signatureGroups().flatMap(function(g) {
        return g.skills;
    });
}
/**
 * The cargo-signature control: fifteen signatures in three priced groups.
 *
 * Grouped by faction because the PRICE is per-faction — every dominion signature
 * fetches the same premium at a given destination — so the group header is the
 * honest place for it, and repeating it on all five options would be noise.
 *
 * Each option is marked when the player cannot actually fill that manifest.
 * Without it the only way to discover a signature is unshippable is to select it
 * and watch LAUNCH turn into NO CARGO, which is a dead end per attempt.
 *
 * ⚠ EVERY OPTION CARRIES ITS STOCK, and that is the whole hint. Because the
 * price is per-faction, the five signatures inside a group are worth EXACTLY
 * the same to ship — so the only thing that separates them is how much of each
 * you are sitting on, and the right play is always the deepest pile. Grouping
 * says they are interchangeable; the stock number says which to pick.
 *
 * Without it the choice looks arbitrary and gets made arbitrarily. The
 * simulator did precisely that — it broke the tie on iteration order, shipped
 * the same two signatures forever, and left the biggest piles untouched (the
 * five deepest received 2 convoys between them). A player reading a list of
 * five identically-priced names has no more information than that loop did.
 *
 * Stock is shown in UNITS, not credits: a signature holding three rares
 * outvalues one holding sixty commons, so a credit figure would point at the
 * pile that is not in the player's way. See `signatureStock`.
 *
 * ⚠ THE OPTION SAYS "items" AND THE BUDGET IS IN 💰, and it took three passes.
 * Both figures started as 📦, so one glyph carried two incomparable scales: a
 * Long Haul reading "📦340" beside a signature reading "📦9" invites the
 * conclusion that you are 331 short, when those 9 units are worth 815 — more
 * than twice the budget.
 *
 *   1. "📦340 goods" vs "9 items" — fixed nothing. Synonyms; both read as counts.
 *   2. "📦340 value" vs "9 items" — better, but "value" of WHAT is still a guess.
 *   3. "340💰" vs "9 items" — the budget IS a credit figure (materialValue-core
 *      derives it from the crafting ladder), so it takes the credit icon the
 *      rest of the game already uses. A count and a price cannot be confused.
 *
 * The numbers were right throughout; only their units were ever missing.
 *
 * Sorted deepest-first WITHIN a group for the same reason — the useful answer
 * should not need hunting for. Groups keep their own order (the player's own
 * faction leads), because that is a different question.
 */ function $c95f3da2626a9dfc$var$signatureSelect(templateId) {
    var sizeClass = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'text-sm px-2 py-1.5';
    var groups = $c95f3da2626a9dfc$var$signatureGroups().map(function(group) {
        var premium = $c95f3da2626a9dfc$var$draft.toRegionId ? " \xb7 ".concat($c95f3da2626a9dfc$var$demandText((0, $35d30e7dcff465af$export$b9d88bbf27398a14)($c95f3da2626a9dfc$var$draft.toRegionId, group.faction), (0, $35d30e7dcff465af$export$37444e2aca3975f8)($c95f3da2626a9dfc$var$draft.toRegionId, group.faction))) : '';
        var options = group.skills.map(function(skillId) {
            return {
                skillId: skillId,
                stock: (0, $aee9584c1e6e51e7$export$94a2b01ae45f0aa0)(skillId).units
            };
        }).sort(function(a, b) {
            return b.stock - a.stock;
        }).map(function(param) {
            var skillId = param.skillId, stock = param.stock;
            var _config_factionSkills_group_faction_skills_skillId, _config_factionSkills_group_faction_skills, _config_factionSkills_group_faction;
            var short = (0, $aee9584c1e6e51e7$export$a666674acd11f81d)(templateId, skillId).short;
            var thin = short.value > 0;
            var name = ((_config_factionSkills_group_faction = $979b99378be707cd$export$aeeef991191508e2[group.faction]) === null || _config_factionSkills_group_faction === void 0 ? void 0 : (_config_factionSkills_group_faction_skills = _config_factionSkills_group_faction.skills) === null || _config_factionSkills_group_faction_skills === void 0 ? void 0 : (_config_factionSkills_group_faction_skills_skillId = _config_factionSkills_group_faction_skills[skillId]) === null || _config_factionSkills_group_faction_skills_skillId === void 0 ? void 0 : _config_factionSkills_group_faction_skills_skillId.name) || skillId;
            return '<option value="'.concat(skillId, '" ').concat(skillId === $c95f3da2626a9dfc$var$draft.skillId ? 'selected' : '', ">").concat(name, " \xb7 ").concat(stock, " items").concat(thin ? " \u26A0" : '', "</option>");
        }).join('');
        return '<optgroup label="'.concat(group.name).concat(premium, '">').concat(options, "</optgroup>");
    }).join('');
    return '\n        <select id="op-skill" onchange="setOperationSignature(this.value)"\n            title="Every signature in a faction fetches the SAME price, so the only thing separating them is stock \u2014 \uD83D\uDCE6 is what the dock holds. Ship your deepest pile."\n            class="w-full bg-white/5 border-2 border-gray-600 rounded text-white '.concat(sizeClass, '">\n            ').concat(groups, "\n        </select>");
}
/**
 * Fill any unset draft field with a sensible default.
 *
 * Endpoints are deliberately NOT defaulted: the map lets the player pick them,
 * and pre-filling both was what made pin-clicking feel broken — with origin and
 * destination always set, every click could only ever overwrite the
 * destination, so there was no way to choose an origin or start over.
 */ function $c95f3da2626a9dfc$var$ensureDraftDefaults() {
    var _leads_reduce;
    if (!$c95f3da2626a9dfc$var$draft.skillId) $c95f3da2626a9dfc$var$draft.skillId = $c95f3da2626a9dfc$var$allSignatureIds()[0] || null;
    // A destination with no staging point is a half-planned route the player
    // cannot launch and did not ask for. Default to the SHORTEST run: it is the
    // cheapest thing that can go wrong, and the long routes are the ones worth
    // choosing deliberately. Also re-seats a stale origin — picking a new
    // destination can make the previous origin the destination itself.
    var offers = $c95f3da2626a9dfc$var$currentOffers();
    if (offers.length && !offers.some(function(o) {
        return o.fromRegionId === $c95f3da2626a9dfc$var$draft.fromRegionId;
    })) $c95f3da2626a9dfc$var$draft.fromRegionId = offers[0].fromRegionId;
    if (!$c95f3da2626a9dfc$var$draft.toRegionId) $c95f3da2626a9dfc$var$draft.fromRegionId = null;
    var leads = (0, $aee9584c1e6e51e7$export$34097b07af09d661)();
    if (!$c95f3da2626a9dfc$var$draft.leadName || !leads.some(function(l) {
        return l.name === $c95f3da2626a9dfc$var$draft.leadName;
    })) // BEST record, not the first in the list. The lead bonus is worth up to
    // +25% credits, so defaulting to whoever happened to be first was
    // quietly costing the player money on every convoy they did not stop to
    // re-pick — and it is what lets the control be small.
    $c95f3da2626a9dfc$var$draft.leadName = ((_leads_reduce = leads.reduce(function(best, l) {
        return !best || (l.marksEarned || 0) > (best.marksEarned || 0) ? l : best;
    }, null)) === null || _leads_reduce === void 0 ? void 0 : _leads_reduce.name) || null;
}
// ---------------------------------------------------------------------------
// Map
// ---------------------------------------------------------------------------
function $c95f3da2626a9dfc$var$renderMap() {
    var _gameState_syndicate;
    var container = document.getElementById('operations-map');
    if (!container) return;
    var _getWorldGrid = (0, $aee9584c1e6e51e7$export$8fe62d261aacdb61)(), width = _getWorldGrid.width, height = _getWorldGrid.height, tiles = _getWorldGrid.tiles, regions = _getWorldGrid.regions;
    // One timestamp for the whole paint: convoy progress, the terminator and
    // every tooltip must agree about when "now" is.
    var now = Date.now();
    // The planned route belongs to the PLANNER only. Drawing it on the transit
    // board left the last-planned route highlighted there permanently — and
    // because it never cleared when a convoy was selected, it read as one
    // convoy's highlight refusing to go away.
    var offer = $c95f3da2626a9dfc$var$view === 'plan' ? $c95f3da2626a9dfc$var$currentOffer() : null;
    var planned = offer ? {
        tiles: offer.tiles,
        cost: offer.cost
    } : null;
    var plannedKeys = new Set(((planned === null || planned === void 0 ? void 0 : planned.tiles) || []).map(function(t) {
        return "".concat(t.row, ",").concat(t.col);
    }));
    // The planner shows ONLY the route being planned — that is the whole point
    // of splitting the views. The transit board shows every convoy, or just one
    // when the player has selected it.
    var allOps = ((_gameState_syndicate = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).syndicate) === null || _gameState_syndicate === void 0 ? void 0 : _gameState_syndicate.operations) || [];
    var shown = $c95f3da2626a9dfc$var$view === 'plan' ? [] : $c95f3da2626a9dfc$var$selectedOpId ? allOps.filter(function(o) {
        return o.id === $c95f3da2626a9dfc$var$selectedOpId;
    }) : allOps;
    // tile -> { color, fill } where `fill` is how far this convoy has crossed
    // THIS tile, 0..1. Split by TERRAIN COST via routeProgress(), so a water
    // tile holds the convoy three times as long as an open one — which is what
    // the route cost already charged for in the duration.
    var convoyAt = new Map();
    var convoys = shown.map(function(op) {
        var color = $c95f3da2626a9dfc$var$CONVOY_COLORS[allOps.indexOf(op) % $c95f3da2626a9dfc$var$CONVOY_COLORS.length];
        var route = op.waypoints ? (0, $aee9584c1e6e51e7$export$c8a5c29d2838f4de)(op.waypoints) : (0, $aee9584c1e6e51e7$export$4fa936acba669006)(op.from || op.fromRegionId, op.toRegionId);
        var routeTiles = (route === null || route === void 0 ? void 0 : route.tiles) || [];
        var pct = Math.min(1, Math.max(0, (now - op.startedAt) / (op.completesAt - op.startedAt)));
        var _routeProgress = (0, $aee9584c1e6e51e7$export$f23f7f2631f7375a)(route, pct), fills = _routeProgress.fills, index = _routeProgress.index;
        routeTiles.forEach(function(t, i) {
            var key = "".concat(t.row, ",").concat(t.col);
            var _fills_i;
            var fill = (_fills_i = fills[i]) !== null && _fills_i !== void 0 ? _fills_i : 0;
            var existing = convoyAt.get(key);
            // Where two routes overlap, the further-advanced one wins the tile,
            // so a shared corridor still shows the leading convoy.
            if (!existing || fill > existing.fill) convoyAt.set(key, {
                color: color,
                fill: fill
            });
        });
        // Same computation drives the marker, so the ▪ can never disagree with
        // the squares about where the convoy is.
        return {
            op: op,
            color: color,
            at: routeTiles[index],
            pct: pct
        };
    });
    var convoyMarker = new Map(convoys.filter(function(c) {
        return c.at;
    }).map(function(c) {
        return [
            "".concat(c.at.row, ",").concat(c.at.col),
            c
        ];
    }));
    // Leg boundaries. The first waypoint already carries the staging marker (the
    // class icon) and the last is the 🏕️ destination, so only the joins in
    // between get a flag — those are the turns a tour actually makes.
    var legFlagAt = new Map();
    var flagWaypoints = function(waypoints, color) {
        (waypoints || []).slice(1, -1).forEach(function(w) {
            var key = "".concat(w.row, ",").concat(w.col);
            if (!legFlagAt.has(key)) legFlagAt.set(key, color);
        });
    };
    if (offer) flagWaypoints(offer.waypoints, $c95f3da2626a9dfc$var$GOLD);
    convoys.forEach(function(c) {
        return flagWaypoints(c.op.waypoints, c.color);
    });
    var capitalOf = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = (0, $aee9584c1e6e51e7$export$4a444fae199f4849)()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var id = _step.value;
            var t = (0, $aee9584c1e6e51e7$export$9caf4fdf37b2a28)(id);
            if (t) capitalOf["".concat(t.row, ",").concat(t.col)] = id;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var cells = '';
    for(var row = 0; row < height; row++)for(var col = 0; col < width; col++){
        var _config_raidRegions_regionId, _config_raidRegions;
        var terrain = tiles[row][col];
        var regionId = regions[row][col];
        var style = $c95f3da2626a9dfc$var$TERRAIN_STYLE[terrain] || $c95f3da2626a9dfc$var$TERRAIN_STYLE['.'];
        var bg = $c95f3da2626a9dfc$var$mixHex($c95f3da2626a9dfc$var$REGION_COLOR[regionId] || '#333333', style.tint, style.mix);
        var key = "".concat(row, ",").concat(col);
        var capital = capitalOf[key];
        var onRoute = plannedKeys.has(key);
        var convoy = convoyAt.get(key);
        var convoyColor = convoy === null || convoy === void 0 ? void 0 : convoy.color;
        var marker = convoyMarker.get(key);
        var regionName = ((_config_raidRegions = $979b99378be707cd$export$4fbdcec70fce9d73) === null || _config_raidRegions === void 0 ? void 0 : (_config_raidRegions_regionId = _config_raidRegions[regionId]) === null || _config_raidRegions_regionId === void 0 ? void 0 : _config_raidRegions_regionId.name) || regionId || 'Unclaimed';
        // A capital is a place you can SELL to, so its tooltip carries the
        // price. Only in the planner: on the transit board the signature is
        // already fixed per convoy and a hover price would be misleading.
        var capitalDemand = capital && $c95f3da2626a9dfc$var$view === 'plan' && $c95f3da2626a9dfc$var$draft.skillId ? " \xb7 pays ".concat($c95f3da2626a9dfc$var$demandText((0, $35d30e7dcff465af$export$6bba5a60cd02466f)(capital, $c95f3da2626a9dfc$var$draft.skillId))) + $c95f3da2626a9dfc$var$saturationNote(capital, (0, $ca7af38ea7b7b4a8$export$a3603dda04ca8111)($c95f3da2626a9dfc$var$draft.skillId)) : '';
        // Local time on EVERY tile, not just capitals: the clock is keyed
        // to tiles, the terminator is visible across open ground, and a
        // player who wonders why one stretch of a route is dark should get
        // the answer by hovering it.
        var tileLocal = (0, $05f2074f6c82f4e0$export$239629a81011f2a4)({
            row: row,
            col: col
        }, now);
        var title = "".concat(regionName, " \xb7 ").concat(style.label).concat(style.cost ? " (cost ".concat(style.cost, ")") : '').concat(capitalDemand, " \xb7 ").concat(tileLocal.time, " local");
        // Origin and destination are DIFFERENT glyphs, not the same pin in a
        // different colour — direction has to be readable at a glance.
        //
        // In the planner EVERY capital is a possible destination, so every
        // capital wears the 🏕️ and carries its own price. The premium was
        // otherwise only visible one option at a time in a dropdown, which
        // is the worst possible place for a number whose entire purpose is
        // to be compared against four others.
        var glyph = '';
        var isOrigin = offer && offer.from.row === row && offer.from.col === col;
        var legFlag = legFlagAt.get(key);
        var chosen = capital && capital === $c95f3da2626a9dfc$var$draft.toRegionId;
        if (chosen) glyph = '<span class="world-pin dest" title="Destination">\uD83C\uDFD5\uFE0F</span>';
        else if (isOrigin) {
            var cls = (0, $aee9584c1e6e51e7$export$36ac5ebae0245093)[$c95f3da2626a9dfc$var$draft.templateId];
            glyph = '<span class="world-pin origin" title="Staging point'.concat(cls ? " \u2014 ".concat(cls.name) : '', '">').concat((cls === null || cls === void 0 ? void 0 : cls.icon) || "\u25B6", "</span>");
        } else if (legFlag) glyph = '<span class="world-pin leg" style="color:'.concat(legFlag, '" title="Leg staging point">\u2691</span>');
        else if (capital && $c95f3da2626a9dfc$var$view === 'plan') glyph = '<span class="world-pin dest dim" title="Possible destination">\uD83C\uDFD5\uFE0F</span>';
        else if (capital) glyph = '<span class="world-pin">\u25C6</span>';
        // Price tag, planner only. On the transit board each convoy's
        // signature is already fixed, so a per-region price there would be
        // quoting a trade the player can no longer make.
        if (capital && $c95f3da2626a9dfc$var$view === 'plan' && $c95f3da2626a9dfc$var$draft.skillId && !isOrigin) {
            var mult = (0, $35d30e7dcff465af$export$6bba5a60cd02466f)(capital, $c95f3da2626a9dfc$var$draft.skillId);
            var hot = (0, $35d30e7dcff465af$export$d48946d0a3e2934b)(mult);
            var color = mult <= (0, $35d30e7dcff465af$export$2119d59df637b878) ? '#9ca3af' : hot ? $c95f3da2626a9dfc$var$DEMAND_HOT : $c95f3da2626a9dfc$var$GOLD;
            // One line, not two: a tile is ~40px wide and a wrapped price tag
            // spills past its own tile into the neighbour's.
            // The 📜 tracks the DRAFT, not just the market — the colour still
            // says "hungry" so stepping up a class has a visible reason.
            glyph += '<span class="world-price" style="color:'.concat(color, '">\xd7').concat(mult.toFixed(2)).concat($c95f3da2626a9dfc$var$draftEarnsWrit(mult) ? "\uD83D\uDCDC" : '', "</span>");
        }
        // Progress square: grows 0 -> 50% of the tile as the convoy crosses it,
        // so a route reads as a filling bar rather than a static outline.
        if (convoy && convoy.fill > 0) {
            var size = (convoy.fill * 50).toFixed(1);
            glyph += '<span class="world-progress" style="width:'.concat(size, "%;height:").concat(size, "%;background:").concat(convoy.color, '"></span>');
        }
        if (marker) glyph += '<span class="world-convoy" style="color:'.concat(marker.color, '">\u25AA</span>');
        cells += '<div class="world-tile'.concat(capital ? ' capital' : '').concat(onRoute ? ' on-route' : '').concat(convoyColor && !onRoute ? ' on-active' : '', '"\n                style="background:').concat(bg, "; --night:var(--n").concat(col, ")").concat(convoyColor && !onRoute ? "; outline-color:".concat(convoyColor) : '', '" title="').concat(title, '"\n                ').concat(capital ? 'data-region="'.concat(capital, '" onclick="cycleOperationEndpoint(\'').concat(capital, "')\"") : '', ">").concat(glyph, "</div>");
    }
    // In the planner the legend doubles as the PRICE LIST: five destinations,
    // five premiums, side by side. Comparing them is the whole decision, and a
    // dropdown you have to open one option at a time cannot show a comparison.
    var legend = (0, $aee9584c1e6e51e7$export$4a444fae199f4849)().map(function(id) {
        var _config_raidRegions_id, _config_raidRegions;
        var name = ((_config_raidRegions = $979b99378be707cd$export$4fbdcec70fce9d73) === null || _config_raidRegions === void 0 ? void 0 : (_config_raidRegions_id = _config_raidRegions[id]) === null || _config_raidRegions_id === void 0 ? void 0 : _config_raidRegions_id.name) || id;
        var role = id === $c95f3da2626a9dfc$var$draft.toRegionId ? "\uD83C\uDFD5\uFE0F destination" : '';
        // The legend is the price LIST — five destinations side by side — so it
        // is where the list price belongs next to the fed one. On the map itself
        // a struck-through second number would spill out of a 40px tile.
        var price = $c95f3da2626a9dfc$var$view === 'plan' && $c95f3da2626a9dfc$var$draft.skillId ? " ".concat($c95f3da2626a9dfc$var$demandChip((0, $35d30e7dcff465af$export$6bba5a60cd02466f)(id, $c95f3da2626a9dfc$var$draft.skillId), {
            base: (0, $35d30e7dcff465af$export$37444e2aca3975f8)(id, (0, $ca7af38ea7b7b4a8$export$a3603dda04ca8111)($c95f3da2626a9dfc$var$draft.skillId))
        })) : '';
        // The legend is already the map's key, and it is listed west to east —
        // which makes it the one place five local clocks can be read in order
        // and the rotation seen as a sequence rather than a shading.
        var local = (0, $05f2074f6c82f4e0$export$30a7d07879d0db1d)(id, now);
        return '<span class="text-xs inline-flex items-center gap-1 '.concat(role ? 'font-bold' : 'text-gray-400', '" style="').concat(role ? "color:".concat($c95f3da2626a9dfc$var$GOLD) : '', '">\n            <span style="display:inline-block;width:9px;height:9px;border-radius:2px;background:').concat($c95f3da2626a9dfc$var$REGION_COLOR[id], '"></span>\n            ').concat(name).concat(role ? " (".concat(role, ")") : '').concat(price, '<span class="world-clock-chip" data-clock-region="').concat(id, '" title="').concat(name, " local time \u2014 ").concat(local.name, '">').concat(local.icon, " ").concat(local.time, "</span></span>");
    }).join('<span class="text-gray-600 text-xs">\xb7</span> ');
    // The legend belongs directly under the map it explains, in the same column.
    // It sat outside the row for a while so the controls column could align to
    // the map's bottom edge; collapsing the three template cards into one select
    // made the columns comparable again without that trick.
    container.innerHTML = '\n        <div class="world-map" style="grid-template-columns: repeat('.concat(width, ', minmax(0, 1fr));">').concat(cells, '</div>\n        <div class="world-map-legend mt-1.5 flex flex-wrap items-center gap-x-3 gap-y-1">').concat(legend, "</div>");
    $c95f3da2626a9dfc$var$paintWorldClock(now);
}
/**
 * Advance the terminator across the world map (M3 S9).
 *
 * Every tile has its own clock, but longitude does not depend on latitude — so
 * a column's worth of tiles always share a phase, and the paint is DEDUPED BY
 * COLUMN rather than computed 153 times. Writes one `--n<col>` variable onto
 * the `.world-map` element; each tile reads its column's through `--night` (see
 * styles.css). Seventeen property writes, no reflow of the grid, and —
 * critically — no innerHTML: this runs on the planner too, where rebuilding the
 * map is fine but rebuilding anything else would close an open <select> under
 * the player's cursor.
 *
 * The darkness is the inverse of the daylight curve, capped below 1 so a night
 * tile is still readable: this is a world clock, not a fog of war, and a player
 * has to be able to plan a route across the dark side.
 */ var $c95f3da2626a9dfc$var$MAX_NIGHT = 0.62;
function $c95f3da2626a9dfc$var$paintWorldClock() {
    var now = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Date.now();
    var map = document.querySelector('#operations-map .world-map');
    if (!map) return;
    var width = (0, $aee9584c1e6e51e7$export$8fe62d261aacdb61)().width;
    for(var col = 0; col < width; col++){
        var night = (1 - (0, $05f2074f6c82f4e0$export$45f6af437d59d9ba)((0, $05f2074f6c82f4e0$export$239629a81011f2a4)({
            row: 0,
            col: col
        }, now).phase)) * $c95f3da2626a9dfc$var$MAX_NIGHT;
        map.style.setProperty("--n".concat(col), night.toFixed(3));
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // The legend's clocks are restated in place rather than re-rendered with
        // the legend, for the same reason: this has to be safe to run on the
        // planner while a dropdown is open.
        for(var _iterator = document.querySelectorAll('#operations-map [data-clock-region]')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var chip = _step.value;
            var local = (0, $05f2074f6c82f4e0$export$30a7d07879d0db1d)(chip.dataset.clockRegion, now);
            chip.textContent = "".concat(local.icon, " ").concat(local.time);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $c95f3da2626a9dfc$export$4af0774c25cece2a() {
    var tab = document.getElementById('operations-tab');
    if (!(tab === null || tab === void 0 ? void 0 : tab.classList.contains('active'))) return;
    $c95f3da2626a9dfc$var$paintWorldClock();
}
function $c95f3da2626a9dfc$export$d5def383e43b5037(regionId) {
    if ($c95f3da2626a9dfc$var$draft.toRegionId === regionId) $c95f3da2626a9dfc$var$draft.toRegionId = null;
    else if ($c95f3da2626a9dfc$var$draft.fromRegionId === regionId) $c95f3da2626a9dfc$var$draft.fromRegionId = null;
    else if (!$c95f3da2626a9dfc$var$draft.toRegionId) $c95f3da2626a9dfc$var$draft.toRegionId = regionId;
    else $c95f3da2626a9dfc$var$draft.fromRegionId = regionId;
    $c95f3da2626a9dfc$export$1ed263e826d67cb7();
}
function $c95f3da2626a9dfc$export$576d259aa2156e8d(regionId) {
    $c95f3da2626a9dfc$var$draft.fromRegionId = regionId || null;
    $c95f3da2626a9dfc$export$1ed263e826d67cb7();
}
function $c95f3da2626a9dfc$export$53461ed7a4cadb9e() {
    $c95f3da2626a9dfc$var$draft.toRegionId = null;
    $c95f3da2626a9dfc$var$draft.fromRegionId = null;
    $c95f3da2626a9dfc$export$1ed263e826d67cb7();
}
// ---------------------------------------------------------------------------
// In-flight
// ---------------------------------------------------------------------------
function $c95f3da2626a9dfc$var$formatRemaining(ms) {
    if (ms <= 0) return 'arriving';
    var totalMinutes = Math.ceil(ms / 60000);
    var h = Math.floor(totalMinutes / 60);
    var m = totalMinutes % 60;
    return h > 0 ? "".concat(h, "h ").concat(m, "m") : "".concat(m, "m");
}
/**
 * The convoy list, as a column beside the map.
 *
 * Stacked vertically in a ~224px column rather than a wide grid, so each card
 * has to earn its lines: route, lead, progress, and what it pays. The cargo
 * manifest was dropped from the card — it is fixed at launch and unchangeable
 * in transit, so on this screen it is history, not information. What a player
 * comes here for is where a convoy IS and when it lands.
 */ function $c95f3da2626a9dfc$var$renderInFlight() {
    var _gameState_syndicate;
    var container = document.getElementById('operations-inflight');
    if (!container) return;
    var ops = ((_gameState_syndicate = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).syndicate) === null || _gameState_syndicate === void 0 ? void 0 : _gameState_syndicate.operations) || [];
    var slots = (0, $aee9584c1e6e51e7$export$c87f3aa20ea43c6e)();
    if (!ops.length) {
        container.innerHTML = '<div class="text-xs text-gray-400">No convoys in transit \xb7 '.concat(slots, " slot").concat(slots === 1 ? '' : 's', " licensed</div>");
        return;
    }
    var now = Date.now();
    container.innerHTML = '\n        <div class="text-[10px] uppercase tracking-widest text-gray-400 mb-1">\n            In transit \u2014 '.concat(ops.length, "/").concat(slots).concat($c95f3da2626a9dfc$var$selectedOpId ? " \xb7 one route" : '', '</div>\n        <div class="flex flex-col gap-1.5">\n        ').concat(ops.map(function(op) {
        var _config_raidRegions_op_fromRegionId, _config_raidRegions, _config_raidRegions_op_toRegionId, _config_raidRegions1;
        var t = (0, $aee9584c1e6e51e7$export$36ac5ebae0245093)[op.templateId];
        var total = op.completesAt - op.startedAt;
        var pct = Math.min(100, Math.round((now - op.startedAt) / total * 100));
        var payout = (0, $aee9584c1e6e51e7$export$a4ac0527bd343e81)(op);
        var from = ((_config_raidRegions = $979b99378be707cd$export$4fbdcec70fce9d73) === null || _config_raidRegions === void 0 ? void 0 : (_config_raidRegions_op_fromRegionId = _config_raidRegions[op.fromRegionId]) === null || _config_raidRegions_op_fromRegionId === void 0 ? void 0 : _config_raidRegions_op_fromRegionId.name) || op.fromRegionId;
        var to = ((_config_raidRegions1 = $979b99378be707cd$export$4fbdcec70fce9d73) === null || _config_raidRegions1 === void 0 ? void 0 : (_config_raidRegions_op_toRegionId = _config_raidRegions1[op.toRegionId]) === null || _config_raidRegions_op_toRegionId === void 0 ? void 0 : _config_raidRegions_op_toRegionId.name) || op.toRegionId;
        var color = $c95f3da2626a9dfc$var$CONVOY_COLORS[ops.indexOf(op) % $c95f3da2626a9dfc$var$CONVOY_COLORS.length];
        var isSelected = $c95f3da2626a9dfc$var$selectedOpId === op.id;
        return "\n                <div onclick=\"selectOperation('".concat(op.id, '\')"\n                    class="rounded-lg px-2 py-1.5 cursor-pointer text-[11px] leading-tight"\n                    style="background:rgba(224,168,76,').concat(isSelected ? '0.16' : '0.07', "); border:2px solid ").concat(isSelected ? color : $c95f3da2626a9dfc$var$GOLD_DIM, ';"\n                    title="').concat(from, " \u2192 ").concat(to).concat(isSelected ? " \xb7 click again to show every route" : " \xb7 click to show only this route", '">\n                    <div class="font-bold text-xs flex items-center gap-1 truncate" style="color:').concat($c95f3da2626a9dfc$var$GOLD, '">\n                        <span style="color:').concat(color, '">\u25AA</span>').concat((t === null || t === void 0 ? void 0 : t.icon) || "\uD83D\uDE9A", " ").concat((t === null || t === void 0 ? void 0 : t.name) || op.templateId, '</div>\n                    <div class="text-gray-300 truncate">').concat(from, " \u2192 ").concat(to, '</div>\n                    <div class="text-gray-400 truncate">').concat(op.leadName, '</div>\n                    <div class="mt-1 h-1.5 rounded-full bg-black/40 overflow-hidden">\n                        <div class="h-full" style="width:').concat(pct, "%; background:").concat($c95f3da2626a9dfc$var$GOLD, '"></div>\n                    </div>\n                    <div class="text-gray-400 flex justify-between gap-1 whitespace-nowrap mt-0.5">\n                        <span>').concat($c95f3da2626a9dfc$var$formatRemaining(op.completesAt - now), "</span>\n                        <span>").concat(payout.credits.toLocaleString(), "\uD83D\uDCB0").concat(payout.writs ? " +".concat(payout.writs, "\uD83D\uDCDC") : '', "</span>\n                    </div>\n                </div>");
    }).join(''), "\n        </div>");
}
// ---------------------------------------------------------------------------
// Planner
// ---------------------------------------------------------------------------
/**
 * Short button faces. "Ready to launch" above an enabled LAUNCH button said
 * nothing the button did not already say, so the state now lives IN the button
 * — a disabled control that explains itself beats a disabled control plus a
 * caption. The full sentence stays as the tooltip.
 */ var $c95f3da2626a9dfc$var$BLOCKED_LABEL = {
    'no-route': 'NO ROUTE',
    'insufficient-cargo': 'NO CARGO',
    'insufficient-energy': 'NO ENERGY',
    'no-free-slot': 'NO SLOT',
    'lead-unavailable': 'NO LEAD',
    'insufficient-legends': 'LOCKED',
    'no-charter': 'UNLICENSED'
};
var $c95f3da2626a9dfc$var$BLOCKED_COPY = {
    'no-charter': 'Sign the Operations Charter first.',
    'no-free-slot': 'Every licensed slot is busy.',
    'insufficient-legends': 'Promote more Legends this era to run longer routes.',
    'lead-unavailable': "No idle lead \u2014 the Leader and every era-Legend is out.",
    'no-route': 'No route between those regions.',
    'insufficient-cargo': 'Not enough material in that signature.',
    'insufficient-energy': 'Not enough energy.',
    'unknown-template': 'Unknown operation type.'
};
/**
 * Shared planner state, computed once per paint.
 *
 * The controls column and the manifest row both need the offer, the leads and
 * the eligibility verdict. Computing them twice would be two chances for the
 * quoted price and the LAUNCH button to disagree about the same convoy.
 */ function $c95f3da2626a9dfc$var$plannerContext() {
    $c95f3da2626a9dfc$var$ensureDraftDefaults();
    var offer = $c95f3da2626a9dfc$var$currentOffer();
    var leads = (0, $aee9584c1e6e51e7$export$34097b07af09d661)();
    return {
        offer: offer,
        leads: leads,
        eligible: (0, $aee9584c1e6e51e7$export$4f87675e88a56589)({
            templateId: $c95f3da2626a9dfc$var$draft.templateId,
            fromRegionId: $c95f3da2626a9dfc$var$draft.fromRegionId,
            toRegionId: $c95f3da2626a9dfc$var$draft.toRegionId,
            skillId: $c95f3da2626a9dfc$var$draft.skillId,
            leadName: $c95f3da2626a9dfc$var$draft.leadName
        })
    };
}
/**
 * The column beside the map: what SIZE of operation, who leads it, what it
 * carries, and LAUNCH at the bottom.
 *
 * Vertical because it sits next to a map that wants every pixel of width, and
 * because these are the sizing decision — read top to bottom, they are the order
 * the question is actually asked. Destination and staging point are deliberately
 * NOT here: the map sets the destination by click and prices every candidate on
 * the tile itself, and the staging point is derived from it, so both were form
 * fields restating what the map already showed.
 */ function $c95f3da2626a9dfc$var$renderControls() {
    var _gameState_command_legends, _gameState_command, _config_raidRegions_offer_fromRegionId, _config_raidRegions, _config_raidRegions_draft_toRegionId, _config_raidRegions1;
    var container = document.getElementById('operations-controls');
    if (!container) return;
    var _plannerContext = $c95f3da2626a9dfc$var$plannerContext(), offer = _plannerContext.offer, leads = _plannerContext.leads, eligible = _plannerContext.eligible;
    var eraLegends = ((_gameState_command = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).command) === null || _gameState_command === void 0 ? void 0 : (_gameState_command_legends = _gameState_command.legends) === null || _gameState_command_legends === void 0 ? void 0 : _gameState_command_legends.length) || 0;
    // ONE select, not three cards. Stacked cards were 171px of a column that has
    // to fit beside the map, and they showed three sets of numbers when only the
    // selected one is being decided about. The cost line below restates that one
    // set, so nothing is lost — the other two are a dropdown away.
    // A class is priced in CARGO, not hours. It used to show the hours its own
    // reach implied, which no longer means anything: every class runs the same
    // route in the same time, and what separates them is how much they carry.
    var templateOptions = Object.entries((0, $aee9584c1e6e51e7$export$36ac5ebae0245093)).map(function(param) {
        var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), id = _param[0], t = _param[1];
        var locked = eraLegends < t.legendsRequired;
        var suffix = locked ? " \u2014 \uD83D\uDD12 ".concat(t.legendsRequired, " Legends") : " \xb7 ".concat(t.cargoValue, "\uD83D\uDCB0\uD83D\uDCE6");
        return '<option value="'.concat(id, '" ').concat(locked ? 'disabled' : '', " ").concat(id === $c95f3da2626a9dfc$var$draft.templateId ? 'selected' : '', ">").concat(t.icon, " ").concat(t.name).concat(suffix, "</option>");
    }).join('');
    // COSTS ONLY. A Writ is never spent to launch anything — `writEligible`
    // gates the demand trickle a convoy EARNS — but sitting on this line, under
    // a tooltip that opens "Energy drawn", it read as a third price, and the
    // Writ paid back on delivery then looked like a refund of it. The 📜 now
    // appears only where it is genuinely earned: on the destinations that pay
    // it (map and legend, gated by draftEarnsWrit) and on the payout line.
    var selected = (0, $aee9584c1e6e51e7$export$36ac5ebae0245093)[$c95f3da2626a9dfc$var$draft.templateId];
    var costLine = selected ? "".concat((0, $aee9584c1e6e51e7$export$804dfc1c9f8f293a)($c95f3da2626a9dfc$var$draft.templateId), "\u26A1 \xb7 ").concat(selected.cargoValue, "\uD83D\uDCB0\uD83D\uDCE6") : '';
    // The staging point is the DURATION dial, and the reason it is a control
    // rather than a derived tile: cargo is flat per class, so a longer run is
    // the same manifest for more credits. Each option carries its own hours
    // because that number IS the choice being made.
    var originOptions = $c95f3da2626a9dfc$var$currentOffers().map(function(o) {
        var _config_raidRegions_o_fromRegionId, _config_raidRegions;
        var name = ((_config_raidRegions = $979b99378be707cd$export$4fbdcec70fce9d73) === null || _config_raidRegions === void 0 ? void 0 : (_config_raidRegions_o_fromRegionId = _config_raidRegions[o.fromRegionId]) === null || _config_raidRegions_o_fromRegionId === void 0 ? void 0 : _config_raidRegions_o_fromRegionId.name) || o.fromRegionId;
        return '<option value="'.concat(o.fromRegionId, '" ').concat(o.fromRegionId === $c95f3da2626a9dfc$var$draft.fromRegionId ? 'selected' : '', ">").concat(name, " \xb7 ").concat(o.hours.toFixed(1), "h</option>");
    }).join('');
    var originSelect = originOptions ? '<select id="op-origin" onchange="setOperationOrigin(this.value)"\n                class="w-full bg-white/5 border-2 border-gray-600 rounded px-2 py-1 text-xs text-white">'.concat(originOptions, "</select>") : '<div class="text-xs text-gray-400">Pick a destination first</div>';
    var leadSelect = leads.length ? '<select id="op-lead" onchange="setOperationLead(this.value)"\n                class="w-full bg-white/5 border-2 border-gray-600 rounded px-2 py-1 text-xs text-white">\n                '.concat(leads.map(function(l) {
        return '<option value="'.concat(l.name, '" ').concat(l.name === $c95f3da2626a9dfc$var$draft.leadName ? 'selected' : '', ">").concat(l.name).concat(l.isLeader ? ' (Leader)' : '', " \xb7 ").concat(l.marksEarned, "\uD83C\uDF96\uFE0F</option>");
    }).join(''), "\n           </select>") : '<div class="text-xs text-gray-400">No idle lead</div>';
    // The route, immediately above the button that commits it — the last thing
    // read before pressing LAUNCH should be what is being launched.
    var routeBlock = offer ? '<div class="text-xs leading-tight rounded px-2 py-1 mt-1 2xl:mt-2 flex" style="background:rgba(0,0,0,0.25); border:1px solid '.concat($c95f3da2626a9dfc$var$GOLD_DIM, ';">\n               <div class="flex-grow">\n                    <div class="text-gray-300 truncate" title="Staging point">\u25B6 ').concat(((_config_raidRegions = $979b99378be707cd$export$4fbdcec70fce9d73) === null || _config_raidRegions === void 0 ? void 0 : (_config_raidRegions_offer_fromRegionId = _config_raidRegions[offer.fromRegionId]) === null || _config_raidRegions_offer_fromRegionId === void 0 ? void 0 : _config_raidRegions_offer_fromRegionId.name) || offer.fromRegionId, '</div>\n                    <div class="font-bold truncate" style="color:').concat($c95f3da2626a9dfc$var$GOLD, '" title="Destination">\uD83C\uDFD5\uFE0F ').concat(((_config_raidRegions1 = $979b99378be707cd$export$4fbdcec70fce9d73) === null || _config_raidRegions1 === void 0 ? void 0 : (_config_raidRegions_draft_toRegionId = _config_raidRegions1[$c95f3da2626a9dfc$var$draft.toRegionId]) === null || _config_raidRegions_draft_toRegionId === void 0 ? void 0 : _config_raidRegions_draft_toRegionId.name) || $c95f3da2626a9dfc$var$draft.toRegionId, '</div>\n                </div>\n               <div class="text-gray-400">').concat(offer.hours.toFixed(1), "h</div>\n           </div>") : '<div class="text-xs text-gray-400 leading-snug mt-1">Click a destination on the map.</div>';
    container.innerHTML = '\n        <div class="text-[11px] uppercase tracking-widest text-gray-300 mb-0.5">Operation</div>\n        <select id="op-template" onchange="selectOperationTemplate(this.value)"\n            class="w-full bg-white/5 border-2 rounded px-2 py-1.5 text-sm font-bold text-white"\n            style="border-color:'.concat($c95f3da2626a9dfc$var$GOLD, '">').concat(templateOptions, '</select>\n        <!-- The \uD83D\uDCB0 figure is what the CARGO must be worth, not a charge against\n             the credit balance \u2014 a convoy is paid for in materials off the dock.\n             Spelling that out because the icon says credits and the line sits\n             beside an energy cost that IS deducted. -->\n\n        <div class="mt-2">\n            <div class="text-[11px] uppercase tracking-widest text-gray-300 mb-0.5">Operation Cost</div>\n\n            <div class="text-xs text-gray-400 mt-0.5"\n                title="What this convoy costs to launch: energy drawn \xb7 credits\' worth of materials the manifest must carry (taken from the Guild Vault\'s dock, never from your credit balance). No Writs are spent \u2014 a Grand Circuit EARNS one by delivering into a hungry market.">').concat(costLine, '\n            </div>\n        </div>\n\n        <div class="mt-2">\n            <div class="text-[11px] uppercase tracking-widest text-gray-300 mb-0.5">Cargo signature</div>\n            ').concat($c95f3da2626a9dfc$var$signatureSelect($c95f3da2626a9dfc$var$draft.templateId, 'text-xs px-2 py-1'), '\n        </div>\n\n        <div class="mt-2">\n            <div class="text-[11px] uppercase tracking-widest text-gray-300 mb-0.5"\n                 title="Where the convoy forms up. Cargo is the same whatever the distance, so a longer run is more credits for the same manifest \u2014 and a longer hold on the slot.">Staging point</div>\n            ').concat(originSelect, '\n        </div>\n\n        <div class="mt-2 mb-2">\n            <!-- Lead is worth up to +25% credits (LEAD_BONUS_CAP), so it is not\n                 decoration \u2014 but ensureDraftDefaults picks the best available\n                 record, so the default needs no attention and the control can be\n                 the smallest thing here. -->\n            <div class="text-[11px] uppercase tracking-widest text-gray-300 mb-0.5">Lead</div>\n            ').concat(leadSelect, "\n        </div>\n\n        ").concat(routeBlock, "\n        ").concat($c95f3da2626a9dfc$var$manifestFragment(offer, leads), '\n\n        <button onclick="launchOperation()" ').concat(eligible.ok ? '' : 'disabled', '\n            title="').concat(eligible.ok ? '' : $c95f3da2626a9dfc$var$BLOCKED_COPY[eligible.reason] || 'Cannot launch', '"\n            class="w-full mt-1.5 2xl:mt-4 px-3 py-2.5 rounded font-bold ').concat(eligible.ok ? 'text-black hover:shadow-lg' : 'bg-gray-600 text-gray-800 cursor-not-allowed', '"\n            ').concat(eligible.ok ? 'style="background:'.concat($c95f3da2626a9dfc$var$GOLD, '"') : '', ">").concat(eligible.ok ? 'LAUNCH' : $c95f3da2626a9dfc$var$BLOCKED_LABEL[eligible.reason] || 'CANNOT LAUNCH', '</button>\n\n        <!-- Last in the column, so its bottom edge lands on the map\'s. Undo\n             belongs after the commit control, not competing with it. -->\n        <button onclick="clearOperationRoute()" ').concat($c95f3da2626a9dfc$var$draft.toRegionId ? '' : 'disabled', '\n            class="w-full mt-1.5 2xl:mt-2 px-3 py-1 rounded text-xs font-bold ').concat($c95f3da2626a9dfc$var$draft.toRegionId ? 'bg-gray-700 hover:bg-gray-600 text-white' : 'bg-gray-800 text-gray-600 cursor-not-allowed', '">Clear route</button>');
}
/**
 * The manifest and payout, as a fragment for the controls column.
 *
 * Returns HTML rather than rendering, because it now lives INSIDE the column
 * between the route and LAUNCH — cost and reward belong next to the button that
 * commits them, and below the map they were a second place to look after the
 * decision had already been made.
 */ function $c95f3da2626a9dfc$var$manifestFragment(offer, leads) {
    var _leads_find, _config_raidRegions_draft_toRegionId, _config_raidRegions, _config_factionSkills_getSkillFaction, _config_factionSkills;
    // Flat per class, so the manifest does not move when the staging point does
    // — which is exactly the trade the planner is trying to make visible: the
    // rows below stay put while the payout above them climbs with distance.
    var _ref = $c95f3da2626a9dfc$var$draft.skillId ? (0, $aee9584c1e6e51e7$export$a666674acd11f81d)($c95f3da2626a9dfc$var$draft.templateId, $c95f3da2626a9dfc$var$draft.skillId) : {
        manifest: {},
        short: {
            value: 0
        },
        value: 0,
        budget: 0
    }, manifest = _ref.manifest, short = _ref.short, value = _ref.value, budget = _ref.budget;
    // A convoy that could not fill its budget without going OVER it sails light,
    // and silently doing so is what made the planner read as broken: a Long Haul
    // asking 340 value, a signature holding 9 items, and a manifest taking two
    // chips gave the player three numbers and no way to reconcile them. The
    // header now states what was actually loaded against what was asked, and
    // amber marks the gap so "240/340" is not mistaken for a rounding artefact.
    var underFilled = budget > 0 && value < budget;
    // One line per item, each saying what the pile will be left at. "-80" alone
    // answers what this convoy costs but not whether the next one is
    // affordable, which is the question a player actually has. The stock is the
    // Guild Vault's dock — account-level, so no character owns it.
    var inventory = (0, $aee9584c1e6e51e7$export$21c1c9fc1bed7f77)();
    var manifestRows = Object.entries(manifest).map(function(param) {
        var _param = (0, $1788e2ed61915b1e$export$71511d61b312f219)(param, 2), id = _param[0], qty = _param[1];
        var held = inventory[id] || 0;
        var left = Math.max(0, held - qty);
        // Amber when the convoy takes most of what is there — a pile about
        // to run dry is worth noticing before pressing LAUNCH.
        var thin = held > 0 && left / held < 0.25;
        return '<div class="flex justify-between gap-1 leading-tight">\n                <span class="truncate" title="'.concat((0, $ca7af38ea7b7b4a8$export$31330438f6059b08)(id) || id, '">').concat((0, $ca7af38ea7b7b4a8$export$31330438f6059b08)(id) || id, '</span>\n                <span class="whitespace-nowrap"><span class="text-gray-400">-').concat(qty, '</span><span class="').concat(thin ? 'text-amber-300' : 'text-gray-500', '">/').concat(left.toLocaleString(), "</span></span>\n            </div>");
    }).join('');
    // Projected payout, computed by the SAME function that pays it out. A
    // planner that estimates with its own arithmetic is a planner that will one
    // day quote a number the settlement does not honour.
    var projected = offer && $c95f3da2626a9dfc$var$draft.toRegionId ? (0, $aee9584c1e6e51e7$export$a4ac0527bd343e81)({
        templateId: $c95f3da2626a9dfc$var$draft.templateId,
        hours: offer.hours,
        toRegionId: $c95f3da2626a9dfc$var$draft.toRegionId,
        skillId: $c95f3da2626a9dfc$var$draft.skillId,
        leadMarks: ((_leads_find = leads.find(function(l) {
            return l.name === $c95f3da2626a9dfc$var$draft.leadName;
        })) === null || _leads_find === void 0 ? void 0 : _leads_find.marksEarned) || 0
    }) : null;
    if (!manifestRows && !projected) return '';
    return '\n        <div class="mt-2 rounded px-2 py-1 text-[11px]" style="background:rgba(0,0,0,0.25); border:1px solid '.concat($c95f3da2626a9dfc$var$GOLD_DIM, ';">\n            <div class="flex justify-between items-baseline gap-1 text-[11px] uppercase tracking-widest text-gray-400"\n                 title="Cargo is loaded from the Guild Vault \u2014 the share of each promoted member\'s kit their successor did not inherit. No character owns it.').concat(underFilled ? "\n\nLoaded ".concat(value, "\uD83D\uDCB0 of the ").concat(budget, "\uD83D\uDCB0 this class asks for. Nothing left on the dock fits the remaining ").concat(budget - value, " without going over, so the convoy sails a little light rather than overpaying.") : '', '">\n                <span>\uD83C\uDFE6 Manifest</span>\n                ').concat(budget ? '<span class="'.concat(underFilled ? 'text-amber-300' : 'text-gray-500', ' normal-case tracking-normal">').concat(value, "/").concat(budget, "\uD83D\uDCB0</span>") : '', "\n            </div>\n            ").concat(manifestRows || '<div class="text-gray-400 leading-tight">Pick a destination</div>', "\n            ").concat(short.value ? '<div class="text-red-300 leading-tight">Short '.concat(short.value, "\uD83D\uDCB0</div>") : '', "\n            ").concat(projected ? '<div class="flex justify-between items-baseline gap-1 mt-1 pt-1 whitespace-nowrap" style="border-top:1px solid '.concat($c95f3da2626a9dfc$var$GOLD_DIM, '"\n                        title="Demand premium: ').concat(((_config_raidRegions = $979b99378be707cd$export$4fbdcec70fce9d73) === null || _config_raidRegions === void 0 ? void 0 : (_config_raidRegions_draft_toRegionId = _config_raidRegions[$c95f3da2626a9dfc$var$draft.toRegionId]) === null || _config_raidRegions_draft_toRegionId === void 0 ? void 0 : _config_raidRegions_draft_toRegionId.name) || $c95f3da2626a9dfc$var$draft.toRegionId, " pays ").concat($c95f3da2626a9dfc$var$demandText(projected.demand), " for ").concat(((_config_factionSkills = $979b99378be707cd$export$aeeef991191508e2) === null || _config_factionSkills === void 0 ? void 0 : (_config_factionSkills_getSkillFaction = _config_factionSkills[(0, $ca7af38ea7b7b4a8$export$a3603dda04ca8111)($c95f3da2626a9dfc$var$draft.skillId)]) === null || _config_factionSkills_getSkillFaction === void 0 ? void 0 : _config_factionSkills_getSkillFaction.name) || 'this', " cargo").concat($c95f3da2626a9dfc$var$saturationNote($c95f3da2626a9dfc$var$draft.toRegionId, (0, $ca7af38ea7b7b4a8$export$a3603dda04ca8111)($c95f3da2626a9dfc$var$draft.skillId)), '">\n                     <span class="text-[11px] uppercase tracking-widest text-gray-400">Payout</span>\n                     <span><span class="font-bold" style="color:').concat($c95f3da2626a9dfc$var$GOLD, '">').concat(projected.credits.toLocaleString(), "\uD83D\uDCB0</span>").concat(projected.writs ? '<span class="font-bold" style="color:'.concat($c95f3da2626a9dfc$var$GOLD, '"> +').concat(projected.writs, "\uD83D\uDCDC</span>") : '', " ").concat($c95f3da2626a9dfc$var$demandChip(projected.demand, {
        markWrit: false,
        base: (0, $35d30e7dcff465af$export$37444e2aca3975f8)($c95f3da2626a9dfc$var$draft.toRegionId, (0, $ca7af38ea7b7b4a8$export$a3603dda04ca8111)($c95f3da2626a9dfc$var$draft.skillId))
    }), "</span>\n                   </div>") : '', "\n        </div>");
}
function $c95f3da2626a9dfc$export$1ed263e826d67cb7() {
    var inflight = document.getElementById('operations-inflight');
    var heading = document.getElementById('operations-heading');
    if ((0, $e39e78d7c65dc336$export$6955e231f1466c44)('operations-charter') <= 0) {
        var controls = document.getElementById('operations-controls');
        if (controls) controls.innerHTML = '<div class="text-sm text-gray-400">Sign the Operations Charter to license convoys.</div>';
        return;
    }
    // Defaults FIRST: the map highlights the planned route, and it renders
    // before the controls. Filling the draft inside renderControls meant the map
    // drew with no endpoints on the very first paint.
    $c95f3da2626a9dfc$var$ensureDraftDefaults();
    var planning = $c95f3da2626a9dfc$var$view === 'plan';
    if (heading) // One line each. The subtitles were flavour, and on the planner the
    // whole screen is the explanation.
    heading.innerHTML = planning ? '<h3 class="text-lg font-bold flex flex-wrap items-baseline gap-x-2" style="color:'.concat($c95f3da2626a9dfc$var$GOLD, '">Plan an Operation\n                 <span class="text-xs font-normal text-gray-400">Cargo is spent at launch \u2014 it does not come back.</span></h3>') : '<h3 class="text-lg font-bold flex flex-wrap items-baseline gap-x-2" style="color:'.concat($c95f3da2626a9dfc$var$GOLD, '">Operations in Transit\n                 <span class="text-xs font-normal text-gray-400">Click a convoy to isolate its route.</span></h3>');
    // Each view shows exactly one job's worth of controls: the planner has no
    // convoy list, the transit board has no planning fields or launch button.
    var controls1 = document.getElementById('operations-controls');
    if (controls1) controls1.classList.toggle('hidden', !planning);
    if (inflight) inflight.classList.toggle('hidden', planning);
    $c95f3da2626a9dfc$var$renderMap();
    if (planning) $c95f3da2626a9dfc$var$renderControls();
    else $c95f3da2626a9dfc$var$renderInFlight();
}
function $c95f3da2626a9dfc$export$e2d67cc94e3cd65c(id) {
    $c95f3da2626a9dfc$var$draft.templateId = id;
    $c95f3da2626a9dfc$export$1ed263e826d67cb7();
}
function $c95f3da2626a9dfc$export$9c80dfd1c0bf48d5(id) {
    $c95f3da2626a9dfc$var$draft.toRegionId = id || null;
    $c95f3da2626a9dfc$export$1ed263e826d67cb7();
}
function $c95f3da2626a9dfc$export$909bfe5c3a3681b1(id) {
    $c95f3da2626a9dfc$var$draft.skillId = id;
    $c95f3da2626a9dfc$export$1ed263e826d67cb7();
}
function $c95f3da2626a9dfc$export$433c4f7deeca3758(name) {
    $c95f3da2626a9dfc$var$draft.leadName = name;
    $c95f3da2626a9dfc$export$1ed263e826d67cb7();
}
function $c95f3da2626a9dfc$export$1c5606b786938b38() {
    var result = (0, $aee9584c1e6e51e7$export$9cb89297e30fe792)({
        templateId: $c95f3da2626a9dfc$var$draft.templateId,
        fromRegionId: $c95f3da2626a9dfc$var$draft.fromRegionId,
        toRegionId: $c95f3da2626a9dfc$var$draft.toRegionId,
        skillId: $c95f3da2626a9dfc$var$draft.skillId,
        leadName: $c95f3da2626a9dfc$var$draft.leadName
    });
    if (!result.success) {
        (0, $b5bda7fdec806d8b$export$c7def531c087da85)($c95f3da2626a9dfc$var$BLOCKED_COPY[result.reason] || 'Could not launch that operation', 'error');
        return;
    }
    var t = (0, $aee9584c1e6e51e7$export$36ac5ebae0245093)[result.operation.templateId];
    (0, $b5bda7fdec806d8b$export$c7def531c087da85)("".concat(t.icon, " ").concat(t.name, " away \u2014 ").concat(result.hours.toFixed(1), "h, led by ").concat(result.operation.leadName), 'success');
    (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
    // Hand straight off to the transit board with the new convoy isolated: the
    // player just answered "what shall I send?", so the next useful question is
    // "where is it?" — not the empty planner they were already looking at.
    $c95f3da2626a9dfc$var$view = 'transit';
    $c95f3da2626a9dfc$var$selectedOpId = result.operation.id;
    $c95f3da2626a9dfc$export$1ed263e826d67cb7();
    (0, $59924438766e7d8e$export$d1c957a54f7124bc)();
}
function $c95f3da2626a9dfc$export$9dd8092a8219c221() {
    var _gameState_syndicate;
    var hadOps = (((_gameState_syndicate = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).syndicate) === null || _gameState_syndicate === void 0 ? void 0 : _gameState_syndicate.operations) || []).length > 0;
    var result = hadOps ? (0, $aee9584c1e6e51e7$export$b68d61a5f45d991c)({
        now: Date.now()
    }) : {
        settled: []
    };
    if (result.settled.length) {
        $c95f3da2626a9dfc$var$announceSettlement(result);
        (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
        (0, $59924438766e7d8e$export$d1c957a54f7124bc)();
    }
    // Countdowns, progress bars and the map's per-tile fill are all functions
    // of NOW, so they have to be repainted on the tick — not only when the
    // player happens to click something. Only while the screen is actually
    // showing, so this costs nothing from anywhere else in the game.
    if (hadOps || result.settled.length) $c95f3da2626a9dfc$var$refreshOperationsIfVisible();
}
/**
 * Repaint the transit board if it is the one on display.
 *
 * TRANSIT ONLY. The planner holds live <select> elements, and rebuilding it
 * under the player would close an open dropdown mid-choice — the same failure
 * the toolbar hit with the energy popup. It also has nothing to repaint:
 * route duration and cargo do not change with the clock.
 */ function $c95f3da2626a9dfc$var$refreshOperationsIfVisible() {
    if ($c95f3da2626a9dfc$var$view !== 'transit') return;
    var tab = document.getElementById('operations-tab');
    if (tab === null || tab === void 0 ? void 0 : tab.classList.contains('active')) $c95f3da2626a9dfc$export$1ed263e826d67cb7();
}
function $c95f3da2626a9dfc$export$f9a694398861c909() {
    var _gameState_syndicate;
    if (!(((_gameState_syndicate = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).syndicate) === null || _gameState_syndicate === void 0 ? void 0 : _gameState_syndicate.operations) || []).length) return;
    var result = (0, $aee9584c1e6e51e7$export$b68d61a5f45d991c)({
        now: Date.now(),
        maxPerSlot: 1
    });
    if (result.settled.length) $c95f3da2626a9dfc$var$announceSettlement(result, true);
}
function $c95f3da2626a9dfc$var$announceSettlement(result) {
    var whileAway = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var names = result.settled.map(function(o) {
        var _OPERATION_TEMPLATES_o_templateId;
        return ((_OPERATION_TEMPLATES_o_templateId = (0, $aee9584c1e6e51e7$export$36ac5ebae0245093)[o.templateId]) === null || _OPERATION_TEMPLATES_o_templateId === void 0 ? void 0 : _OPERATION_TEMPLATES_o_templateId.name) || o.templateId;
    });
    (0, $b5bda7fdec806d8b$export$c7def531c087da85)("\uD83D\uDDFA\uFE0F ".concat(names.join(', '), " arrived").concat(whileAway ? ' while you were away' : '', " \xb7 +").concat(result.credits.toLocaleString(), "\uD83D\uDCB0").concat(result.writs ? " +".concat(result.writs, "\uD83D\uDCDC") : ''), 'success', // Sticky when it landed during an absence: the player was not watching,
    // and a payout they never saw is exactly what stickiness is for.
    whileAway ? {
        sticky: true
    } : {});
}
// ---------------------------------------------------------------------------
// Window exposure (onclick-string pattern used across the codebase)
// ---------------------------------------------------------------------------
if (typeof window !== 'undefined') {
    window.cycleOperationEndpoint = $c95f3da2626a9dfc$export$d5def383e43b5037;
    window.clearOperationRoute = $c95f3da2626a9dfc$export$53461ed7a4cadb9e;
    window.selectOperation = $c95f3da2626a9dfc$export$7bde3dae25e9ac40;
    window.selectOperationTemplate = $c95f3da2626a9dfc$export$e2d67cc94e3cd65c;
    window.setOperationDestination = $c95f3da2626a9dfc$export$9c80dfd1c0bf48d5;
    window.setOperationOrigin = $c95f3da2626a9dfc$export$576d259aa2156e8d;
    window.setOperationSignature = $c95f3da2626a9dfc$export$909bfe5c3a3681b1;
    window.setOperationLead = $c95f3da2626a9dfc$export$433c4f7deeca3758;
    window.launchOperation = $c95f3da2626a9dfc$export$1c5606b786938b38;
}












/**
 * Gameplay guide — assembled per read, showing only what the player has unlocked.
 *
 * WHY THIS IS COMPOSED RATHER THAN ONE STRING: the guide is also the game's
 * biggest spoiler surface. A new player opening Help met the whole ladder at
 * once — prestige, a second prestige, convoy routes — which both buries the one
 * loop they can actually play and gives away the reveals the layers exist to
 * deliver. Sections are gated on the SAME one-way latches the header uses
 * (`isCommandRevealed`, `isSyndicateRevealed`), so Help can never disagree with
 * which layers the switcher is offering.
 *
 * The gates are deliberately COARSE — one per layer, not one per mechanic.
 * Hiding artifacts until the first blueprint drops, or campsites until the first
 * one is walked, would be a second progression system to maintain and would keep
 * answers from players who are looking something up mid-raid. The rule is: hide
 * a LAYER the player has not been shown, not a detail inside one they have.
 *
 * Forward references matter as much as sections. A line about "Command Marks"
 * inside the always-on crafting section leaks exactly as much as the Command
 * chapter would, so those clauses are gated individually below.
 */ 

var $166366154a864305$var$ALWAYS = function() {
    return true;
};
/** The layer ladder, in order. Each entry appears once its layer is revealed. */ var $166366154a864305$var$LAYERS = [
    {
        when: $166366154a864305$var$ALWAYS,
        md: "**The Field** \u2014 run raids with your active character to earn credits, level\n   skills, craft gear, and craft artifacts."
    },
    {
        when: (0, $ee71dfe8b201c427$export$25d1e5af45c35a33),
        md: "**Command (prestige)** \u2014 when a character is established, **promote** them\n   into your faction's command. They retire into your Legends gallery, you bank\n   **Command Marks**, and a fresh recruit starts the next tour. Marks buy\n   permanent account-wide upgrades that make every future tour faster."
    },
    {
        when: (0, $e39e78d7c65dc336$export$f0d4871acc619a3),
        md: "**Syndicate (second prestige)** \u2014 once fifteen officers have been promoted,\n   **found a Syndicate** from them. Command starts over from nothing, and in\n   exchange you gain **Writs**, permanent **charters**, and **Operations** \u2014 a\n   planet-scale convoy economy that runs while the Field runs itself."
    }
];
/**
 * The opening section, sized to how much of the ladder is visible.
 *
 * A numbered list of one item reads like a list with things missing, so a
 * player who has only the Field gets prose instead — the shape itself should
 * not hint at what is being withheld.
 */ function $166366154a864305$var$bigPicture() {
    var open = $166366154a864305$var$LAYERS.filter(function(l) {
        return l.when();
    });
    var intro = "You lead operatives who raid collapsed zones for loot, level them up, and gear\nthem out.";
    if (open.length === 1) return "## The Big Picture\n\n".concat(intro, " Run raids with your active character to earn credits, level\nskills, craft gear, and craft artifacts.");
    var ladder = open.map(function(l, i) {
        return "".concat(i + 1, ". ").concat(l.md);
    }).join('\n');
    var compounds = (0, $e39e78d7c65dc336$export$f0d4871acc619a3)() ? "Progress compounds: each tour is quicker than the last thanks to the upgrades\nyour promoted Legends paid for, and each **era** is quicker than the last thanks\nto the charters your Syndicate signed." : "Progress compounds: each tour is quicker than the last thanks to the upgrades\nyour promoted Legends paid for.";
    var currencies = (0, $e39e78d7c65dc336$export$f0d4871acc619a3)() ? 'Marks live in Command, Writs in the Syndicate, credits and energy in the Field.' : 'Marks live in Command, credits and energy in the Field.';
    return "## The Big Picture\n\n".concat(intro, " The game has ").concat(open.length === 2 ? 'two' : 'three', " connected layers, each one built out of the last:\n\n").concat(ladder, "\n\n").concat(compounds, "\n\n**Switching layers:** the button at the top left is the layer switcher \u2014 the\nheader only ever shows one layer's screens and currencies at a time. ").concat(currencies);
}
var $166366154a864305$var$GUIDE_HEAD = "# Gameplay Guide";
/** Always shown. Built per read so the gated clauses inside it stay live. */ var $166366154a864305$var$fieldBody = function() {
    return "## Characters & Factions\n\nYou can keep up to **3 characters**. Each has its own skills, level, inventory,\nand gear. Faction is chosen at creation and is permanent.\n\n### Dominion \uD83D\uDD27 \u2014 engineers and systems tacticians\n\uD83D\uDCE1 Signal Relay \xb7 \uD83D\uDCBB System Override \xb7 \uD83E\uDD16 Drone Command \xb7 \u26A0\uFE0F Safeguard \xb7 \uD83D\uDD2C Quantum Scan\n\n### Wilders \uD83C\uDF3F \u2014 biotech operatives and survival engineers\n\uD83C\uDF31 Reclamation \xb7 \uD83C\uDF3F Growth Control \xb7 \uD83E\uDD8E Wild Influence \xb7 \uD83E\uDDEC Bio Shield \xb7 \u2623\uFE0F Containment\n\n### Veil \uD83D\uDC64 \u2014 infiltrators and intelligence specialists\n\uD83D\uDDFA\uFE0F Echo Trace \xb7 \uD83D\uDD13 Lock Breach \xb7 \uD83D\uDC64 Stealth Transit \xb7 \uD83D\uDC7B Signal Mask \xb7 \uD83C\uDF00 Transit Anchor\n\nSwitch characters from the Field layer's **Characters** screen \u2192 **Switch**.\n\n---\n\n## Skills & Leveling\n\nEach faction has **5 skills**. Skills and character level grow by running raids \u2014\nboth successes and failures grant XP, with successes granting more. Leveling up\nawards **skill points** (spend them to raise individual skills) and increases max\nHP. Higher skill levels raise your success chance on rooms that use that skill.\n\nAt higher levels you can also spend skill points to **unlock synergies** for a\nskill, which lets its gear boost teammates' matching events during a raid.\n\n---\n\n## Raids\n\nRaids are the core loop:\n\n1. Pick a **region** and a **difficulty tier**.\n2. Assemble a **team** \u2014 your character plus up to **2 contractors** to cover\n   skills you're missing.\n3. **Plan a path** through a procedurally generated grid to the exit.\n4. **Start** \u2014 the raid runs automatically, resolving each room in turn.\n5. Collect **credits, materials, blueprints, and XP**; watch for bonus events.\n\n### Success is about survival\nBefore you start, each room shows a success chance \u2014 that's your odds of a\n**clean run** (which yields the best loot). Failing a skill check doesn't end the\nraid; it just deals **damage** scaled to the tier. What ends a raid early is a\n**full team wipe** (everyone at 0 HP), which forfeits the reward. So push tiers\nwhere your team can *survive*, not only where every check is guaranteed.\n\n### Difficulty tiers\n- **Tier 1** \u2014 smaller grids, gentle checks; where you build early levels.\n- **Tier 2** \u2014 larger grids, tougher checks, better loot.\n- **Tier 3** \u2014 the largest/hardest raids, and the **only source of artifact\n  blueprints**.\n\nHigher tiers use bigger grids, longer path limits, and stronger contractors.\n\n### Room types\n- **\uD83C\uDF00 Start / \uD83C\uDF0C Exit** \u2014 entry and completion, no challenge.\n- **\uD83D\uDEAA Gates** \u2014 hardest skill checks, the best and most loot.\n- **\u26A0\uFE0F Hazards** \u2014 easier checks, moderate loot.\n- **\uD83C\uDFC3 Roads** \u2014 free movement, no checks and no loot; don't count toward the\n  path-length limit.\n- **\uD83C\uDFD5\uFE0F Campsites** \u2014 the team rests and heals (spending any field supplies you\n  carry, then a base heal); no checks.\n\n### Highlights\nIn the raid panel's **Highlights** tab you can mark rooms that can drop a chosen\n**item**, or that use a chosen **skill**, to plan the best path at a glance.\n\n---\n\n## Contractors & Marketplace\n\n- **Contractors** are AI operatives you hire to fill skill gaps. They're paid a\n  percentage of the raid's credits, carry their own gear, and are temporary\n  (they don't level up). The pool refreshes over time.\n- **Marketplace** \u2014 contract your own character out for other players to hire,\n  earning passive credits and XP while you're away.\n\n---\n\n## Loot, Gear & Crafting\n\nRaids drop **credits**, faction **materials** (common \u2192 uncommon \u2192 rare \u2192 epic),\nand **blueprints** (Tier 3 only). Materials feed crafting.\n\n### Skill Gear\nCraftable equipment tied to a technique. Equip **one piece per skill** to raise\nthat skill's success chance; some gear also enables **synergies** that help\nteammates' events. Skill gear is equip-once \u2014 **one craft per character**\n(a duplicate would do nothing), so a finished gear set is a clear milestone.\n\n### Artifacts\nEach character has **two artifact slots**:\n- a **Skill artifact** (boosts one skill's success), and\n- a **Utility artifact** (economy, defense, or utility effects).\n\nArtifacts use a two-step model:\n1. **Unlock** \u2014 blueprints drop only from Tier 3. Consume a blueprint once to\n   **unlock that design for your whole account** (any character can then craft\n   it).".concat((0, $ee71dfe8b201c427$export$25d1e5af45c35a33)() ? ' This is a one-time milestone worth a chunk of Command Marks.' : '', "\n2. **Craft** \u2014 build the unlocked design from materials. Like gear, it's\n   **one craft per character**.\n\n### Consumables\n- **Field Supplies** \u2014 restore team HP; bought with credits, used before a raid\n  or automatically while resting at a campsite.\n- **Technique Consumables** \u2014 crafted from materials; **auto-rig** on their\n  technique's first success in a raid, then every room where that technique\n  succeeds runs faster for the rest of the raid.\n\n---\n\n## Collapse Keys & the Archive\n\nNobody agrees on what ended this world, and the three factions do not agree with\neach other. **Collapse Keys** are the records that bear on it \u2014 and the Archive\nsets each one beside what your faction makes of it.\n\nA successful raid can recover one. They arrive **in order**, and the tier you\nraid sets how far the story can go: keys **1\u20132** surface at Tier 1, **3\u20134** at\nTier 2, **5\u20137** at Tier 3. So a Tier 1 character will find two and then no more,\nhowever long they raid \u2014 the way on is deeper raids, not more of them.\n\n**The Archive** screen appears in the Field layer with your first key and never\nleaves. Every key stays there to be re-read: the fragment as it was recorded,\nand what your faction makes of it.\n\nThree things worth knowing:\n- **Keys are yours, not your character's.** They are filed to your account, not\n  to whoever recovered them, and cannot be sold, crafted or lost.").concat((0, $ee71dfe8b201c427$export$25d1e5af45c35a33)() ? ' No promotion or prestige ever takes one back.' : '', "\n- **Each faction has its own set of seven**, recovered by raiding with a\n  character of that faction. The Archive shows all three sets, including ones\n  you have never played \u2014 the other factions' theories are part of the picture.\n- **Seven per faction is what the field holds.** The last three of each set are\n  somewhere no current expedition can reach.");
};
/** Shown once the Command layer has been revealed. Built per read: its Vault
 *  paragraph names the Syndicate only when that layer is known too. */ var $166366154a864305$var$commandBody = function() {
    return "## Command (Prestige)\n\nThe **Command** tab appears once your active character is worth enough Command\nMarks. This is the meta-game.\n\n### Promotion\nPromoting your active character:\n- retires them into your **Legends** gallery (a permanent record),\n- banks **Command Marks** based on their career, and\n- starts the next **tour** with a fresh recruit (most credits are spent down \u2014\n  you keep a small fraction, floored near 1,000).\n\nPromotion resets the tour, but these **persist**: Command Marks, Command\nupgrades, your Legends, unlocked regions, and your other characters.\n\n### Command Marks come from\n- **Skill gear** owned,\n- **Artifact designs unlocked** (the biggest single source),\n- **Artifacts crafted**,\n- **Tier-3 wins**, and\n- **Character level**.\n\nSo a tour's goal is legible: finish your gear/artifact set, push Tier 3, and\nlevel up \u2014 then promote at the peak.\n\n### Command upgrades (spend Marks)\n- **\uD83E\uDE7A Field Conditioning** \u2014 recruits start with extra max HP.\n- **\uD83C\uDFDB\uFE0F Officer Academy** \u2014 recruits start at a higher level.\n- **\uD83D\uDD0B Forward Depot** \u2014 energy returns faster, which is what really sets your\n  raid throughput.\n- **\uD83D\uDDFA\uFE0F Regional Charter** \u2014 unlock additional regions for all characters.\n- **\uD83D\uDCD6 Legend Bonus** \u2014 bonus XP for every enshrined Legend.\n- **\uD83D\uDEF0\uFE0F Auto-Scout** \u2014 auto-generates the grid and proposes the best path.\n- **\uD83D\uDCD2 Foreman's Ledger** \u2014 auto-reserves the best contractors for your path.\n- **\uD83E\uDD16 Auto-Raid Protocol** \u2014 runs raids hands-off: charts, staffs, re-tools,\n  launches, then chains the next while energy holds.\n- **\u2699\uFE0F Auto-Fabricator** \u2014 crafts hands-off between raids: unlocks artifact\n  designs first, then builds gear and the components it needs.\n\n**Buy the automation pair together.** Most of a character's Marks come from\ncrafting, so a character that raids by itself but never crafts earns a fraction\nof a normal tour. Auto-Raid and Auto-Fabricator are the two halves of one loop \u2014\nraid \u2192 craft \u2192 marks \u2192 promote \u2014 and the Syndicate's Succession Doctrine\nrequires both before it will run that loop for you.\n\n### The Vault\nPromotion no longer destroys your materials. What the outgoing character was\ncarrying is **split**: a share goes straight to your next recruit, and the\nremainder is set aside".concat((0, $e39e78d7c65dc336$export$f0d4871acc619a3)() ? " \u2014 **consigned** to the Syndicate you found next" : '', ". Both piles are\nvisible on Command \u2192 **Vault**. Artifact blueprints always survive in full.\n\nEach promotion is a **Tour**; rotating characters up to command builds a\npersistent account that keeps getting stronger.");
};
/** Shown once a Syndicate is within reach (15 Legends) or already founded. */ var $166366154a864305$var$SYNDICATE_BODY = "## Syndicate Charters (Second Prestige)\n\nThe **Syndicate** layer appears once you have promoted **15 officers**. Founding\na Syndicate is the second prestige: Command goes back to zero, and what you get\nin exchange outlives every era that follows.\n\n### Founding\nThe founding ceremony itemises both columns before you sign, because it cannot\nbe undone.\n\n**Wiped:** Command Marks, every Legend, Command upgrades, regional charters,\nyour characters, and credits (down to the levy floor).\n\n**Kept:** every **Writ** and charter, unlocked artifact designs, artifact\nblueprints in the vault, your Syndicate **Leader** and past leaders, cleared\nBlackout perks, and the whole consigned material dock.\n\nThe era's best officer \u2014 most Marks earned, not the newest \u2014 becomes your\n**Leader**, a permanent anchor who can run Operations forever.\n\n### Writs\n**\uD83D\uDCDC Writs** are the Syndicate's currency, issued at founding from everything\nthat era banked. The yield is damped (it scales with the *square root* of era\nMarks), which is deliberate: camping one era to farm Writs loses to founding\nagain sooner. Growth comes from founding **more**, not from founding **bigger**.\n\n### Charters (spend Writs)\n- **\uD83D\uDCCB Standing Orders** \u2014 every founding starts the new era with Auto-Raid\n  Protocol and Auto-Fabricator already running, whether or not Command bought\n  them. The cheapest thing on the board and usually the first pick.\n- **\uD83D\uDD4A\uFE0F Succession Doctrine** \u2014 promotes at the peak Marks rate and raises the\n  successor from your template, hands-off. Requires both automation upgrades.\n- **\uD83D\uDDFA\uFE0F Operations Charter** \u2014 unlocks Operations, and licenses 1 / 2 / 3\n  concurrent convoys.\n- **\uD83C\uDFDB\uFE0F Founder's Endowment** \u2014 each new Command era starts with banked Marks.\n- **\uD83D\uDCDA Institutional Memory** \u2014 found the next Syndicate with fewer Legends.\n  This is the real compression lever: it shortens every era after it.\n- **\uD83D\uDCE6 Provision Contracts** \u2014 operation cargo costs less.\n- **\uD83C\uDF11 Blackout Sanction** \u2014 unlocks Blackout Contracts.\n\n### Operations\nWhere the Field plans a path through a room grid, the Syndicate plans a **route\nacross the world map** \u2014 the same decision at planetary scale.\n\n- **A route is two capitals.** You pick the destination and the staging point;\n  the ground between them sets the duration (roughly 2.5\u201311 hours). Distance is\n  a real trade, not a menu of tiers.\n- **Cargo comes from the dock** (Syndicate \u2192 **Stores**), stocked by the\n  consignments your promotions banked. A dock is a per-era budget that only goes\n  down, so an era's promotions provision the *next* Syndicate.\n- **Destinations pay differently.** Every capital shows its own **demand\n  premium** for the signature you are shipping, and delivering into a region\n  cools its appetite for that faction's goods for a while. The map is a decision\n  you re-make, not a table you solve once.\n- **Convoys run in real time** and settle while you are away \u2014 one round per\n  licensed slot. Deliveries above a high premium also trickle **Writs** back.\n- Each convoy is led by your Leader or an officer promoted **this era**, so\n  mid-era promotions have a second payoff.\n\n### Blackout Contracts\nOptional raids under a hard modifier \u2014 no grid preview, no consumables, no\ncontractors, and so on \u2014 each paying one **permanent** account perk. You clear a\ncontract by *finishing* such a raid; failing it changes nothing. Automation\nrefuses to run them: the difficulty has to be a choice you made.\n\n### Hands-off by design\nWith Standing Orders, Succession Doctrine and the two automation upgrades in\nplace, the whole Command loop runs itself \u2014 raid, craft, promote, raise a\nsuccessor \u2014 while you spend your attention on the Syndicate's routes. That is\nwhat the layer is for: your old game becomes the engine for the new one.";
/** Always shown; two of its lines only make sense once Command exists. */ var $166366154a864305$var$tail = function() {
    return "## Energy, HP & Credits\n\n- **Energy** \u2014 raids cost energy based on the path; it regenerates over time, and\n  you can buy more with credits from the header.\n- **HP** \u2014 lost to failed skill checks, restored at campsites (field supplies +\n  base heal) and slowly over time outside raids. A full team wipe ends a raid.\n- **Credits** \u2014 earned from raids, spent on contractors, consumables, energy, and\n  crafting.".concat((0, $ee71dfe8b201c427$export$25d1e5af45c35a33)() ? ' Largely reset each promotion (the end-of-tour spend-down is the game).' : '', "\n\n---\n\n## Tips\n\n- **Early** \u2014 run Tier 1, level up, and start crafting your skill-gear set.\n- **Mid** \u2014 move to Tier 2, unlock synergies, and begin working toward artifacts.\n- **Late** \u2014 push Tier 3 for blueprints and complete your gear/artifact set").concat((0, $ee71dfe8b201c427$export$25d1e5af45c35a33)() ? ", then\n  **promote** to bank Marks and buy upgrades that speed up the next tour" : '', ".").concat((0, $e39e78d7c65dc336$export$f0d4871acc619a3)() ? "\n- **Prestige** \u2014 once fifteen officers are promoted, found a Syndicate. Take\n  **Standing Orders** first (it is the cheapest charter and it keeps your\n  automation across every future founding), then **Institutional Memory**, which\n  shortens every era after it." : '', "\n- Match your raid tier to what your team can **survive**, not just to guaranteed\n  checks \u2014 a clean Tier 2 beats a wipe on Tier 3.").concat((0, $ee71dfe8b201c427$export$25d1e5af45c35a33)() ? "\n- Buy **Forward Depot** earlier than it looks worth: energy regeneration, not\n  raid speed, is what caps how much you can actually run in a day." : '', "\n\n---\n\n## FAQ\n\n**Can I change my faction?** No \u2014 it's permanent. Roll another character to try a\ndifferent faction.\n\n**How many artifacts can I equip?** Two \u2014 one Skill artifact and one Utility\nartifact.\n\n**Why can't I craft a second copy of gear/an artifact?** Durable gear and\nartifacts are equip-once, so each is capped at one craft per character. Finishing\nthe set is the point.\n\n**Do contractors level up?** No \u2014 they're temporary hires.\n\n**What happens if my team wipes?** The raid ends early with no reward, but your\ncharacter returns safely \u2014 characters can't permanently die.").concat((0, $ee71dfe8b201c427$export$25d1e5af45c35a33)() ? "\n\n**What do I lose when I promote?** The character (they become a Legend) and most\nof your credits \u2014 their leftover relics and consumables are sold off first, so\nthe amount you keep is a share of that larger total. Their materials are not\ndestroyed: they are split and set aside. You keep Marks, upgrades, unlocked\nregions, and every other character \u2014 and gain a permanent power boost." : '').concat((0, $e39e78d7c65dc336$export$f0d4871acc619a3)() ? "\n\n**When should I found a Syndicate?** As soon as you can. Writs scale with the\nsquare root of an era's Marks, so a longer era pays steadily less per hour than\nfounding again and starting the next one with better charters.\n\n**Do I lose my Legends when I found?** Yes \u2014 the whole gallery is spent to\ncreate the Syndicate, and the era's best officer becomes its permanent Leader.\nUnlocked artifact designs, blueprints, Writs, charters and the material dock all\ncarry over.\n\n**Why won't Succession Doctrine let me buy it?** It needs **both** Auto-Raid\nProtocol and Auto-Fabricator. It promotes on your Marks *rate*, and most Marks\ncome from crafting \u2014 automating the raids alone would have it judging a\ncharacter that only earns a fraction of a normal tour.\n\n**Why is Auto-Craft sitting on \"Idle\"?** It is on, but has nothing it can build\nright now: no blueprint to unlock, no complete recipe, and nothing affordable.\nIt will start again on its own as raids bring materials in." : '', "\n\n---\n\n*Last Updated: 8/5/2026*");
};
function $166366154a864305$export$ec50a2d4695064b2() {
    return [
        $166366154a864305$var$GUIDE_HEAD,
        $166366154a864305$var$bigPicture(),
        $166366154a864305$var$fieldBody(),
        (0, $ee71dfe8b201c427$export$25d1e5af45c35a33)() ? $166366154a864305$var$commandBody() : null,
        (0, $e39e78d7c65dc336$export$f0d4871acc619a3)() ? $166366154a864305$var$SYNDICATE_BODY : null,
        $166366154a864305$var$tail()
    ].filter(Boolean).join('\n\n---\n\n');
}


/**
 * Dev-only viewport button — open the game at exactly iPad landscape.
 *
 * Lives on the shared dev strip (`devBar.js`), which owns the localhost gate,
 * the positioning and the chip styling.
 *
 * WHY A POPUP, and not a clamped container. A page cannot resize its own tab:
 * `window.resizeTo` is ignored unless the window was opened by script. The
 * tempting alternative — constraining #game-container to 1024x768 and calling
 * that a preview — would LIE, because this layout leans on things that read the
 * real viewport and not the container:
 *
 *   @media (max-height: 820px)   the catalog-card and pane-blurb compression
 *   calc(100vh - var(--map-chrome))  the world map's size
 *   subTabs.js sizeActiveScroller    window.innerHeight
 *
 * All three would keep reporting the desktop viewport, so the clamped box would
 * render the DESKTOP layout at tablet dimensions — the exact opposite of what a
 * tablet check is for. A script-opened window has a real viewport, and may then
 * be resized to correct for browser chrome.
 */ /**
 * The dev control strip — a fixed row of localhost-only chips over the header.
 *
 * Shared by `devViewport.js` and `devFixtures.js`, which is the whole reason it
 * exists: two floating controls each picking their own `top`/`left` is a magic
 * number waiting to overlap, and two copies of the same chip CSS is two places
 * to change it.
 *
 * NOT inside `#game-header`. Tempting, since that is where these visually sit,
 * but the header is `overflow: hidden` (so an extra control is silently clipped
 * rather than visibly wrong) and it is one of the surfaces the tablet pass is
 * most sensitive about. A fixed overlay owes the layout nothing and cannot
 * change how the real header behaves at any viewport.
 */ function $7298e89ec732fd6b$export$6dd1bbd39f571125() {
    return typeof location !== 'undefined' && (location.hostname === 'localhost' || location.hostname === '127.0.0.1');
}
var $7298e89ec732fd6b$var$bar = null;
function $7298e89ec732fd6b$export$d2e04e586301da9d() {
    if (!$7298e89ec732fd6b$export$6dd1bbd39f571125() || typeof document === 'undefined') return null;
    if ($7298e89ec732fd6b$var$bar) return $7298e89ec732fd6b$var$bar;
    $7298e89ec732fd6b$var$bar = document.createElement('div');
    $7298e89ec732fd6b$var$bar.id = 'dev-bar';
    $7298e89ec732fd6b$var$bar.style.cssText = [
        'position:fixed',
        'top:2px',
        'left:2px',
        'z-index:2147483647',
        'display:flex',
        'flex-wrap:wrap',
        'gap:2px',
        'align-items:center',
        // Dim at rest, awake on approach. These sit on top of the game at all
        // times during development, so they have to be findable without being
        // something the eye keeps catching while looking at the layout.
        'opacity:0.55',
        'transition:opacity 0.12s'
    ].join(';');
    $7298e89ec732fd6b$var$bar.addEventListener('mouseenter', function() {
        $7298e89ec732fd6b$var$bar.style.opacity = '1';
    });
    $7298e89ec732fd6b$var$bar.addEventListener('mouseleave', function() {
        $7298e89ec732fd6b$var$bar.style.opacity = '0.55';
    });
    document.body.appendChild($7298e89ec732fd6b$var$bar);
    return $7298e89ec732fd6b$var$bar;
}
function $7298e89ec732fd6b$export$3edc0c30f7140ad8(param) {
    var label = param.label, title = param.title, onClick = param.onClick;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.textContent = label;
    btn.title = title;
    btn.style.cssText = [
        'font:700 10px/1 ui-monospace,monospace',
        'padding:3px 5px',
        'color:#9ca3af',
        'background:rgba(0,0,0,0.72)',
        'border:1px solid #374151',
        'border-radius:4px',
        'cursor:pointer'
    ].join(';');
    if (onClick) btn.addEventListener('click', onClick);
    return btn;
}


var $0923a07be718bea9$var$PRESET = {
    label: 'iPad landscape',
    w: 1024,
    h: 768
};
var $0923a07be718bea9$var$WINDOW_NAME = 'idle-extraction-ipad-landscape';
/**
 * Resize until the CONTENT area matches, not the outer window.
 *
 * `window.open`'s width/height are interpreted inconsistently — some browsers
 * size the outer frame, so asking for 768 can leave ~700 of usable height once
 * the toolbar is subtracted. Correcting by the measured delta is the only way to
 * land on the number that actually matters, which is innerWidth/innerHeight.
 */ function $0923a07be718bea9$var$fitViewport(w, h) {
    window.resizeBy(w - window.innerWidth, h - window.innerHeight);
}
function $0923a07be718bea9$var$atPreset() {
    return window.innerWidth === $0923a07be718bea9$var$PRESET.w && window.innerHeight === $0923a07be718bea9$var$PRESET.h;
}
function $0923a07be718bea9$var$label() {
    return "".concat($0923a07be718bea9$var$atPreset() ? "\u2705" : "\uD83D\uDCD0", " ").concat(window.innerWidth, "\xd7").concat(window.innerHeight);
}
function $0923a07be718bea9$export$d95b3e0536e68b56() {
    var bar = (0, $7298e89ec732fd6b$export$d2e04e586301da9d)();
    if (!bar) return;
    var btn = (0, $7298e89ec732fd6b$export$3edc0c30f7140ad8)({
        label: $0923a07be718bea9$var$label(),
        title: "Dev only \u2014 open the game in a window sized to ".concat($0923a07be718bea9$var$PRESET.label, " (").concat($0923a07be718bea9$var$PRESET.w, "\xd7").concat($0923a07be718bea9$var$PRESET.h, "). Shows the live viewport size.")
    });
    btn.id = 'dev-viewport-btn';
    btn.style.marginRight = '4px';
    btn.addEventListener('click', function() {
        // Already in the sized window: re-fit in place. Handy after a manual
        // drag, and it is the only case where resizing is permitted at all.
        if (window.name === $0923a07be718bea9$var$WINDOW_NAME) {
            $0923a07be718bea9$var$fitViewport($0923a07be718bea9$var$PRESET.w, $0923a07be718bea9$var$PRESET.h);
            return;
        }
        var popup = window.open(location.href, $0923a07be718bea9$var$WINDOW_NAME, "width=".concat($0923a07be718bea9$var$PRESET.w, ",height=").concat($0923a07be718bea9$var$PRESET.h, ",menubar=no,toolbar=no,location=no,status=no"));
        if (!popup) {
            btn.textContent = "\uD83D\uDCD0 popup blocked";
            return;
        }
        popup.focus();
    });
    // Doubles as a live readout, which is what makes this useful even where the
    // popup is blocked or the browser absorbs window.open: drag the window until
    // it goes green and you are at iPad landscape.
    var refresh = function() {
        btn.textContent = $0923a07be718bea9$var$label();
        btn.style.color = $0923a07be718bea9$var$atPreset() ? '#4ade80' : '#9ca3af';
        btn.style.borderColor = $0923a07be718bea9$var$atPreset() ? '#166534' : '#374151';
    };
    window.addEventListener('resize', refresh);
    bar.appendChild(btn);
    refresh();
    // The popup lands at whatever size the browser chose; correct it once it
    // has laid out, then report the real number.
    if (window.name === $0923a07be718bea9$var$WINDOW_NAME) requestAnimationFrame(function() {
        $0923a07be718bea9$var$fitViewport($0923a07be718bea9$var$PRESET.w, $0923a07be718bea9$var$PRESET.h);
        refresh();
    });
}



/**
 * Dev-only fixture switcher — one click to any layer (localhost only).
 *
 * The maintained save fixtures in `tools/qa/fixtures` are the fastest way to
 * stand in any part of the game without grinding a save, and they were already
 * reachable from the console. This puts them on a strip of buttons, because
 * "which fixture reaches the Operations planner again?" is a question you
 * should not have to answer from memory every time you want to look at it.
 *
 * ONE LIST DRIVES EVERYTHING. `FIXTURES` below is the source for the buttons,
 * the console hint and the not-found error. The previous version of this had
 * the names written out in a comment, in an error string and in a console.info
 * line, and the comment was already the only one listing all five.
 *
 * The real save is stashed under `qaBackupSave` on first use and put back by
 * `restoreSave()` — the fixtures overwrite `idleExtractionSave` in place, so
 * that stash is the only copy of the player's actual game.
 *
 * Fixtures are served from `/fixtures` (see package.json `staticFiles`), which
 * copies them AT SERVER START — regenerate them and the running server keeps
 * handing out the old snapshot until it is restarted.
 */ 


var $03744ae8c690a79a$var$SAVE_KEY = 'idleExtractionSave';
var $03744ae8c690a79a$var$BACKUP_KEY = 'qaBackupSave';
// Which fixture is on screen. Kept in storage rather than sniffed from the
// character name because the point is to survive the reload that loading one
// causes, and a name can be edited in-game.
var $03744ae8c690a79a$var$ACTIVE_KEY = 'qaFixtureActive';
var $03744ae8c690a79a$export$18c53a34fcd81ece = [
    {
        name: 'fresh',
        label: 'fresh',
        layer: 'new account',
        desc: 'Wipe the save and run the new-account flow'
    },
    {
        name: 'mid',
        label: 'mid',
        layer: 'Field',
        desc: "Pre-Command, level 10 \u2014 crosses the Command reveal threshold on boot"
    },
    {
        name: 'late',
        label: 'late',
        layer: 'Command',
        desc: 'Post-Command veteran: marks, Legends, upgrades, artifacts'
    },
    {
        name: 'pre-founding',
        label: 'pre-found',
        layer: 'Syndicate founding',
        desc: "15 Legends, ceremony still ahead \u2014 one-way, so reload to repeat"
    },
    {
        name: 'syndicate',
        label: 'syndicate',
        layer: 'Syndicate',
        desc: "Founded once: Leader, charters, rebuilding era \u2014 the L3 starting point"
    },
    {
        name: 'grand-tour',
        label: 'tour',
        layer: 'Operations',
        desc: '6 era-Legends + rank-3 charter: one click from the longest operation'
    }
];
var $03744ae8c690a79a$var$NAMES = $03744ae8c690a79a$export$18c53a34fcd81ece.map(function(f) {
    return f.name;
});
function $03744ae8c690a79a$export$fad9145e0ce507a0() {
    var name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'late';
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var existing, res, _, _tmp, _1;
        return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    existing = localStorage.getItem($03744ae8c690a79a$var$SAVE_KEY);
                    if (existing && !localStorage.getItem($03744ae8c690a79a$var$BACKUP_KEY)) localStorage.setItem($03744ae8c690a79a$var$BACKUP_KEY, existing); // stash the real save once
                    localStorage.setItem($03744ae8c690a79a$var$ACTIVE_KEY, name);
                    if (name === 'fresh') {
                        localStorage.removeItem($03744ae8c690a79a$var$SAVE_KEY);
                        location.reload();
                        return [
                            2
                        ];
                    }
                    return [
                        4,
                        fetch("/fixtures/".concat(name, "-game.json"), {
                            cache: 'no-store'
                        })
                    ];
                case 1:
                    res = _state.sent();
                    if (!res.ok) {
                        console.error('Fixture "'.concat(name, '" not found (').concat(res.status, "). Use one of: ").concat($03744ae8c690a79a$var$NAMES.join(', '), "."));
                        localStorage.removeItem($03744ae8c690a79a$var$ACTIVE_KEY);
                        return [
                            2
                        ];
                    }
                    _ = localStorage.setItem;
                    _tmp = [
                        $03744ae8c690a79a$var$SAVE_KEY
                    ];
                    _1 = JSON.stringify;
                    return [
                        4,
                        res.json()
                    ];
                case 2:
                    _.apply(localStorage, _tmp.concat([
                        _1.apply(JSON, [
                            _state.sent()
                        ])
                    ]));
                    location.reload();
                    return [
                        2
                    ];
            }
        });
    })();
}
function $03744ae8c690a79a$export$4fd8d4441084914c() {
    var backup = localStorage.getItem($03744ae8c690a79a$var$BACKUP_KEY);
    if (!backup) {
        console.warn("restoreSave(): nothing stashed \u2014 no fixture has been loaded, so the live save is left alone.");
        return false;
    }
    localStorage.setItem($03744ae8c690a79a$var$SAVE_KEY, backup);
    localStorage.removeItem($03744ae8c690a79a$var$BACKUP_KEY);
    localStorage.removeItem($03744ae8c690a79a$var$ACTIVE_KEY);
    location.reload();
    return true;
}
function $03744ae8c690a79a$export$45e422e963dadb5c() {
    var bar = (0, $7298e89ec732fd6b$export$d2e04e586301da9d)();
    if (!bar) return;
    var active = localStorage.getItem($03744ae8c690a79a$var$ACTIVE_KEY);
    var hasBackup = !!localStorage.getItem($03744ae8c690a79a$var$BACKUP_KEY);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var f = _step.value;
            var btn = (0, $7298e89ec732fd6b$export$3edc0c30f7140ad8)({
                label: f.label,
                title: 'Dev only \u2014 load the "'.concat(f.name, '" fixture \u2192 ').concat(f.layer, ".\n").concat(f.desc, "\n\nOverwrites the live save; your real one is kept until you press \u21A9."),
                onClick: function() {
                    return $03744ae8c690a79a$export$fad9145e0ce507a0(f.name);
                }
            });
            // The loaded fixture is marked, because the strip is otherwise the one
            // place in the UI that cannot tell you which save you are looking at —
            // and a fixture you did not mean to be in explains a lot of confusing
            // test results.
            if (f.name === active) {
                btn.style.color = '#fbbf24';
                btn.style.borderColor = '#92400e';
            }
            bar.appendChild(btn);
        };
        for(var _iterator = $03744ae8c690a79a$export$18c53a34fcd81ece[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Restore is last and visually apart: it is the way OUT of fixture-land,
    // and pressing it by mistake while reaching for a fixture costs a reload.
    var restore = (0, $7298e89ec732fd6b$export$3edc0c30f7140ad8)({
        label: "\u21A9",
        title: hasBackup ? "Dev only \u2014 restore the save that was live before the first fixture load" : "Dev only \u2014 no stashed save (no fixture has been loaded yet)",
        onClick: function() {
            if (hasBackup) $03744ae8c690a79a$export$4fd8d4441084914c();
        }
    });
    restore.style.marginLeft = '4px';
    if (hasBackup) {
        restore.style.color = '#4ade80';
        restore.style.borderColor = '#166534';
    } else {
        restore.style.opacity = '0.4';
        restore.style.cursor = 'default';
    }
    bar.appendChild(restore);
}
function $03744ae8c690a79a$export$17bd57c6fd7474d9() {
    if (!(0, $7298e89ec732fd6b$export$6dd1bbd39f571125)()) return;
    console.info("%cDev fixtures:%c loadFixture('".concat($03744ae8c690a79a$var$NAMES.join("'|'"), "') \xb7 restoreSave() \u2014 or use the buttons top-left"), 'font-weight:bold', '');
}






/**
 * Config Validation - fail fast when generated config is missing or malformed.
 *
 * `js/constants.js` is GENERATED (npm run build) from js/data/*. If a build is
 * stale, partial, or a data export gets renamed, the old habit of reading
 * balance values through `config.x?.y || <inline default>` silently substitutes
 * a different game: marks, XP and credit curves quietly change and nothing
 * reports it. Those inline fallbacks also rot — they were the ORIGINAL tuning
 * values and drifted years out of date while reading like documentation.
 *
 * So: balance reads are now direct (config.progressionScaling.commandMarks.x),
 * and this module is the one place that checks the config is actually there.
 * Called once at boot, before any game state loads.
 *
 * Pure - no browser or gameState dependency, so the simulator and tests can
 * assert the same contract.
 */ /**
 * Required config paths, as [dotted path, kind].
 *
 * kind:
 *   'object'  - must be a non-null object with at least one own key
 *   'number'  - must be a finite number
 *   'divisor' - finite number, and not 0 (it is used as a denominator)
 *
 * Only values the code READS belong here. Adding a path makes it a hard boot
 * requirement, so add when code starts depending on it, not speculatively.
 */ 

var $ad0da473ec84234c$export$56d525b7f833c577 = [
    // Core game data
    [
        'raidTierData',
        'object'
    ],
    [
        'raidRegions',
        'object'
    ],
    [
        'commonAreas',
        'object'
    ],
    [
        'factionSkills',
        'object'
    ],
    [
        'itemRarities',
        'object'
    ],
    [
        'commandUpgrades',
        'object'
    ],
    // Balance SSOT - js/data/progressionScaling.js
    [
        'progressionScaling.recipeInputs',
        'object'
    ],
    [
        'progressionScaling.raidXpTierMultipliers',
        'object'
    ],
    [
        'progressionScaling.skillEventDamage',
        'object'
    ],
    [
        'progressionScaling.bonusEventCascadeMultipliers',
        'object'
    ],
    [
        'progressionScaling.skillPointsPerLevel.base',
        'number'
    ],
    [
        'progressionScaling.skillPointsPerLevel.levelDivisor',
        'divisor'
    ],
    [
        'progressionScaling.skillPointsPerLevel.increment',
        'number'
    ],
    [
        'progressionScaling.synergyUnlocks.minLevel',
        'number'
    ],
    [
        'progressionScaling.synergyUnlocks.cost',
        'number'
    ],
    [
        'progressionScaling.commandMarks.perTechGear',
        'number'
    ],
    [
        'progressionScaling.commandMarks.perArtifactUnlock',
        'number'
    ],
    [
        'progressionScaling.commandMarks.perArtifactCraft',
        'number'
    ],
    [
        'progressionScaling.commandMarks.t3WinsDivisor',
        'divisor'
    ],
    [
        'progressionScaling.commandMarks.perLevel',
        'number'
    ],
    [
        'progressionScaling.commandMarks.unlockThreshold',
        'number'
    ],
    [
        'progressionScaling.promotionCreditLevy.keepFraction',
        'number'
    ],
    [
        'progressionScaling.promotionCreditLevy.floor',
        'number'
    ],
    [
        'progressionScaling.creditsScaling.globalMultiplier',
        'number'
    ],
    [
        'progressionScaling.creditsScaling.tierMultipliers',
        'object'
    ],
    [
        'progressionScaling.craftingCostScaling.globalMultiplier',
        'number'
    ],
    [
        'progressionScaling.craftingCostScaling.rarityMultipliers',
        'object'
    ],
    [
        'progressionScaling.craftingDiscountPerTour',
        'number'
    ],
    [
        'progressionScaling.energyPurchaseScaling.escalationFactor',
        'number'
    ],
    // Here for exactly the reason in this file's header: it was read through
    // `?? 0`, and that fallback fails silently in the worst possible way — a stale
    // build ships a game where no key ever drops and the Archive is permanently
    // empty, which looks identical to "the player has not found one yet".
    //
    // `collapseKeys` itself is deliberately NOT listed. The item arrays it sits
    // beside (itemsCommon, itemsStoryRelics, …) are not validated here either;
    // data-completeness is a build-time question that collapseKeys.test.js
    // already answers, where this file's job is the balance values whose absence
    // is invisible at runtime.
    [
        'progressionScaling.collapseKeyDropChance',
        'number'
    ]
];
function $ad0da473ec84234c$var$readPath(root, path) {
    return path.split('.').reduce(function(node, key) {
        return node == null ? undefined : node[key];
    }, root);
}
function $ad0da473ec84234c$var$describeProblem(path, kind, value) {
    if (value === undefined) return "".concat(path, " is missing");
    if (kind === 'object') {
        if ((typeof value === "undefined" ? "undefined" : (0, $1968e3edfc5cfc11$export$71511d61b312f219)(value)) !== 'object' || value === null || Array.isArray(value)) return "".concat(path, " should be an object, got ").concat(Array.isArray(value) ? 'array' : typeof value === "undefined" ? "undefined" : (0, $1968e3edfc5cfc11$export$71511d61b312f219)(value));
        if (Object.keys(value).length === 0) return "".concat(path, " is an empty object");
        return null;
    }
    if (!Number.isFinite(value)) return "".concat(path, " should be a finite number, got ").concat(JSON.stringify(value));
    if (kind === 'divisor' && value === 0) return "".concat(path, " is 0, but it is used as a divisor");
    return null;
}
function $ad0da473ec84234c$export$127f9a442b42d18(config) {
    if (config == null || (typeof config === "undefined" ? "undefined" : (0, $1968e3edfc5cfc11$export$71511d61b312f219)(config)) !== 'object') return [
        'config module did not load at all'
    ];
    var problems = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $ad0da473ec84234c$export$56d525b7f833c577[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $1788e2ed61915b1e$export$71511d61b312f219)(_step.value, 2), path = _step_value[0], kind = _step_value[1];
            var problem = $ad0da473ec84234c$var$describeProblem(path, kind, $ad0da473ec84234c$var$readPath(config, path));
            if (problem) problems.push(problem);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return problems;
}
function $ad0da473ec84234c$export$82367cdd05923d12(config) {
    var problems = $ad0da473ec84234c$export$127f9a442b42d18(config);
    if (problems.length === 0) return;
    throw new Error("Game config failed to load (".concat(problems.length, " problem").concat(problems.length === 1 ? '' : 's', "). ") + "js/constants.js is generated \u2014 run `npm run build`.\n  - ".concat(problems.join('\n  - ')));
}



var $898c8f476f4ac4f1$export$5def58af4fd46132 = Symbol('abort');
var $898c8f476f4ac4f1$export$da980962bd2147a4 = Symbol('activeElement');
var $898c8f476f4ac4f1$export$2f2960ad29426dcb = Symbol('asyncTaskManager');
var $898c8f476f4ac4f1$export$3e74b83f1104272d = Symbol('bodyBuffer');
var $898c8f476f4ac4f1$export$ab1029bcae9ddb4a = Symbol('buffer');
var $898c8f476f4ac4f1$export$d3a0c81e6dd45916 = Symbol('cachedResponse');
var $898c8f476f4ac4f1$export$b89c5c1b934d8237 = Symbol('callbacks');
var $898c8f476f4ac4f1$export$b96bb35bc88d6fa = Symbol('checked');
var $898c8f476f4ac4f1$export$c9fa23d9ff60a2d1 = Symbol('childNodes');
var $898c8f476f4ac4f1$export$bacb5cc5a11aef16 = Symbol('children');
var $898c8f476f4ac4f1$export$11c615ce16f87241 = Symbol('classList');
var $898c8f476f4ac4f1$export$5261f17c72b73389 = Symbol('connectedToNode');
var $898c8f476f4ac4f1$export$cd768479ff770c20 = Symbol('disconnectedFromNode');
var $898c8f476f4ac4f1$export$7bcafbe05fbfa5b1 = Symbol('connectedToDocument');
var $898c8f476f4ac4f1$export$62389f4045fa8671 = Symbol('disconnectedFromDocument');
var $898c8f476f4ac4f1$export$c0100fdcae152d59 = Symbol('contentLength');
var $898c8f476f4ac4f1$export$8019223850b8bf78 = Symbol('contentType');
var $898c8f476f4ac4f1$export$76d490348eec5e39 = Symbol('cssText');
var $898c8f476f4ac4f1$export$7aca2fdfd0625e3a = Symbol('currentScript');
var $898c8f476f4ac4f1$export$28b27b1605aa05ad = Symbol('currentTarget');
var $898c8f476f4ac4f1$export$4051a07651545597 = Symbol('data');
var $898c8f476f4ac4f1$export$93acc5219d6538bb = Symbol('defaultView');
var $898c8f476f4ac4f1$export$b1fb4cac938035f7 = Symbol('destroy');
var $898c8f476f4ac4f1$export$7ebb24f7f0859a21 = Symbol('dirtyness');
var $898c8f476f4ac4f1$export$bd5df0f255a350f8 = Symbol('end');
var $898c8f476f4ac4f1$export$3e9f948b41964866 = Symbol('entries');
var $898c8f476f4ac4f1$export$ec50bd62c0d468dd = Symbol('evaluateCSS');
var $898c8f476f4ac4f1$export$80601be7cebdc7d3 = Symbol('evaluateScript');
var $898c8f476f4ac4f1$export$145e1b7a763b687a = Symbol('exceptionObserver');
var $898c8f476f4ac4f1$export$b05ea1b97b1edb0f = Symbol('formNode');
var $898c8f476f4ac4f1$export$89c21e0f18de79c = Symbol('internalId');
var $898c8f476f4ac4f1$export$ac607276a8fe9f0a = Symbol('height');
var $898c8f476f4ac4f1$export$b0d3f7c520d97ddf = Symbol('immediatePropagationStopped');
var $898c8f476f4ac4f1$export$5a1fde3dfe3b3c2a = Symbol('indeterminate');
var $898c8f476f4ac4f1$export$be5f715765399e60 = Symbol('isFirstWrite');
var $898c8f476f4ac4f1$export$2a8d67a8e92bd591 = Symbol('isFirstWriteAfterOpen');
var $898c8f476f4ac4f1$export$8035c60dfffb0f3c = Symbol('isInPassiveEventListener');
var $898c8f476f4ac4f1$export$2fb7a00a48619649 = Symbol('isValue');
var $898c8f476f4ac4f1$export$99a24029806ba245 = Symbol('listenerOptions');
var $898c8f476f4ac4f1$export$58bed631278dbc67 = Symbol('listeners');
var $898c8f476f4ac4f1$export$fae23e6e0e86e83a = Symbol('itemsByName');
var $898c8f476f4ac4f1$export$46676622036c082b = Symbol('nextActiveElement');
var $898c8f476f4ac4f1$export$46debc62fc90cfe5 = Symbol('observeMutations');
var $898c8f476f4ac4f1$export$96b91b50ecdf2e19 = Symbol('mutationListeners');
var $898c8f476f4ac4f1$export$512a1115db01100d = Symbol('ownerDocument');
var $898c8f476f4ac4f1$export$975cb7bbfe3c62ec = Symbol('ownerElement');
var $898c8f476f4ac4f1$export$319913b486a9e3fc = Symbol('propagationStopped');
var $898c8f476f4ac4f1$export$984aa9e1cd8e27bf = Symbol('readyStateManager');
var $898c8f476f4ac4f1$export$a0c6a011d8b20057 = Symbol('referrer');
var $898c8f476f4ac4f1$export$4bb7493d241fd8a5 = Symbol('registry');
var $898c8f476f4ac4f1$export$5884a0b424dd5ef2 = Symbol('relList');
var $898c8f476f4ac4f1$export$d0c8d979056ee3a9 = Symbol('resetSelection');
var $898c8f476f4ac4f1$export$da02117a63b881a8 = Symbol('rootNode');
var $898c8f476f4ac4f1$export$cbcb4f775d907a9e = Symbol('selectNode');
var $898c8f476f4ac4f1$export$c14ef38ba55762e4 = Symbol('selectedness');
var $898c8f476f4ac4f1$export$7c69810f7b8835c9 = Symbol('selection');
var $898c8f476f4ac4f1$export$77eb42331d4516cf = Symbol('setupVMContext');
var $898c8f476f4ac4f1$export$10fb11023ed0cf27 = Symbol('shadowRoot');
var $898c8f476f4ac4f1$export$b3571188c770cc5a = Symbol('start');
var $898c8f476f4ac4f1$export$1d567c320f4763bc = Symbol('style');
var $898c8f476f4ac4f1$export$44271b4f0c6a3563 = Symbol('target');
var $898c8f476f4ac4f1$export$5739d30adb1c099 = Symbol('textAreaNode');
var $898c8f476f4ac4f1$export$970b39750526e0e2 = Symbol('unobserveMutations');
var $898c8f476f4ac4f1$export$47b1fb35c7874795 = Symbol('reportMutation');
var $898c8f476f4ac4f1$export$b339d29f76738b20 = Symbol('updateSelectedness');
var $898c8f476f4ac4f1$export$128fa18b7194ef = Symbol('url');
var $898c8f476f4ac4f1$export$2ab9a8f9f1186f14 = Symbol('value');
var $898c8f476f4ac4f1$export$7e3df82ee760448c = Symbol('width');
var $898c8f476f4ac4f1$export$8291e5b88f90ce4 = Symbol('window');
var $898c8f476f4ac4f1$export$5201366159206f54 = Symbol('windowResizeListener');
var $898c8f476f4ac4f1$export$367c557fdd85162f = Symbol('mutationObservers');
var $898c8f476f4ac4f1$export$fb8fd923cbcaa51 = Symbol('openerFrame');
var $898c8f476f4ac4f1$export$14386cb9d04bf779 = Symbol('openerWindow');
var $898c8f476f4ac4f1$export$63b4813c5280c707 = Symbol('popup');
var $898c8f476f4ac4f1$export$e5a90df53f832dc9 = Symbol('isConnected');
var $898c8f476f4ac4f1$export$b54be7ce267a037b = Symbol('parentNode');
var $898c8f476f4ac4f1$export$4debbe1037afe35e = Symbol('nodeType');
var $898c8f476f4ac4f1$export$45e0b80f1e500bd4 = Symbol('tagName');
var $898c8f476f4ac4f1$export$82e9f45cca5ba907 = Symbol('prefix');
var $898c8f476f4ac4f1$export$5a0845c0f7cb1511 = Symbol('scrollHeight');
var $898c8f476f4ac4f1$export$dc81048565b75a98 = Symbol('scrollWidth');
var $898c8f476f4ac4f1$export$3e0c8fa3b5e4b3b9 = Symbol('scrollTop');
var $898c8f476f4ac4f1$export$6eddf9bc7f2b7d80 = Symbol('scrollLeft');
var $898c8f476f4ac4f1$export$16bd37df0047a29c = Symbol('attributes');
var $898c8f476f4ac4f1$export$9a6cb5364cfc98aa = Symbol('attributesProxy');
var $898c8f476f4ac4f1$export$4bb31c815825375a = Symbol('namespaceURI');
var $898c8f476f4ac4f1$export$1113a6923fc2e342 = Symbol('accessKey');
var $898c8f476f4ac4f1$export$74bccced03596b17 = Symbol('accessKeyLabel');
var $898c8f476f4ac4f1$export$720e3813341eb9b = Symbol('offsetHeight');
var $898c8f476f4ac4f1$export$abda199d6e675d54 = Symbol('offsetWidth');
var $898c8f476f4ac4f1$export$4ad6bc00a859a01c = Symbol('offsetLeft');
var $898c8f476f4ac4f1$export$9051df5ff5b6ece8 = Symbol('offsetTop');
var $898c8f476f4ac4f1$export$1ceecc078aa19b72 = Symbol('clientHeight');
var $898c8f476f4ac4f1$export$f451d61d633bfdbe = Symbol('clientWidth');
var $898c8f476f4ac4f1$export$6af8701396d90b51 = Symbol('clientLeft');
var $898c8f476f4ac4f1$export$b570871c7d022cff = Symbol('clientTop');
var $898c8f476f4ac4f1$export$a8ff84c12d48cfa6 = Symbol('name');
var $898c8f476f4ac4f1$export$73c81789889f78fa = Symbol('specified');
var $898c8f476f4ac4f1$export$1bfc6cbb3cb6245f = Symbol('adoptedStyleSheets');
var $898c8f476f4ac4f1$export$92ebad0065552617 = Symbol('implementation');
var $898c8f476f4ac4f1$export$1ae2b664eea77b7e = Symbol('readyState');
var $898c8f476f4ac4f1$export$be552e86f287cd4b = Symbol('publicId');
var $898c8f476f4ac4f1$export$b81d14d988111634 = Symbol('systemId');
var $898c8f476f4ac4f1$export$6ee4201e37a931e2 = Symbol('validationMessage');
var $898c8f476f4ac4f1$export$1bdd3f9a89b22594 = Symbol('validity');
var $898c8f476f4ac4f1$export$499f1697a123b0bc = Symbol('returnValue');
var $898c8f476f4ac4f1$export$7a5d735b2ab6389d = Symbol('elements');
var $898c8f476f4ac4f1$export$f24224f1c91d8156 = Symbol('length');
var $898c8f476f4ac4f1$export$b1bc8081da8c9e77 = Symbol('complete');
var $898c8f476f4ac4f1$export$6a4b566b54dc81c0 = Symbol('naturalHeight');
var $898c8f476f4ac4f1$export$c32e50dfb9f4ec89 = Symbol('naturalWidth');
var $898c8f476f4ac4f1$export$46c1c92549715335 = Symbol('loading');
var $898c8f476f4ac4f1$export$d141bba7fdc215a3 = Symbol('x');
var $898c8f476f4ac4f1$export$4a5767248b18ef41 = Symbol('y');
var $898c8f476f4ac4f1$export$8f49a7e9e3141ccc = Symbol('defaultChecked');
var $898c8f476f4ac4f1$export$3a444357c5f65f65 = Symbol('files');
var $898c8f476f4ac4f1$export$995990c5c04c46f0 = Symbol('sheet');
var $898c8f476f4ac4f1$export$7714b48ed08b13f2 = Symbol('volume');
var $898c8f476f4ac4f1$export$cd215b91700bbebc = Symbol('paused');
var $898c8f476f4ac4f1$export$283f641d6ed1ac80 = Symbol('currentTime');
var $898c8f476f4ac4f1$export$6d7f3930b8041bc4 = Symbol('playbackRate');
var $898c8f476f4ac4f1$export$388da195c50bfd17 = Symbol('defaultPlaybackRate');
var $898c8f476f4ac4f1$export$987a4e3838aef8c6 = Symbol('muted');
var $898c8f476f4ac4f1$export$4c9bd91015e50a76 = Symbol('defaultMuted');
var $898c8f476f4ac4f1$export$164ab51d3829a076 = Symbol('preservesPitch');
var $898c8f476f4ac4f1$export$8843b826b2cc8d0c = Symbol('buffered');
var $898c8f476f4ac4f1$export$1f34108aa9eb96ab = Symbol('duration');
var $898c8f476f4ac4f1$export$a3bc9b8ed74fc = Symbol('error');
var $898c8f476f4ac4f1$export$999b7b72c79021f2 = Symbol('ended');
var $898c8f476f4ac4f1$export$8ee3aa19592dce0d = Symbol('networkState');
var $898c8f476f4ac4f1$export$2d89dd5615a16994 = Symbol('textTracks');
var $898c8f476f4ac4f1$export$c8243f3943339030 = Symbol('seeking');
var $898c8f476f4ac4f1$export$5821955352efceb5 = Symbol('seekable');
var $898c8f476f4ac4f1$export$c6e32fc63aaa6e76 = Symbol('played');
var $898c8f476f4ac4f1$export$41c562ebe57d11e2 = Symbol('options');
var $898c8f476f4ac4f1$export$a7db06668cad9adb = Symbol('content');
var $898c8f476f4ac4f1$export$549ff81930776885 = Symbol('mode');
var $898c8f476f4ac4f1$export$5e032988b71f6158 = Symbol('host');
var $898c8f476f4ac4f1$export$926a1681f03b3972 = Symbol('setURL');
var $898c8f476f4ac4f1$export$cbef64f03c7768af = Symbol('localName');
var $898c8f476f4ac4f1$export$2792378e23a7920c = Symbol('classRegistry');
var $898c8f476f4ac4f1$export$be98572e04cea348 = Symbol('nodeStream');
var $898c8f476f4ac4f1$export$17b07c660794dc13 = Symbol('location');
var $898c8f476f4ac4f1$export$55abd4691b317664 = Symbol('history');
var $898c8f476f4ac4f1$export$ec7c8efa7f5790ae = Symbol('navigator');
var $898c8f476f4ac4f1$export$be623a1d3e871e62 = Symbol('screen');
var $898c8f476f4ac4f1$export$f119d83aa936d634 = Symbol('sessionStorage');
var $898c8f476f4ac4f1$export$c2ed3351cac403d1 = Symbol('localStorage');
var $898c8f476f4ac4f1$export$f020670913e851a6 = Symbol('sandbox');
var $898c8f476f4ac4f1$export$ae8e35ea29ddac22 = Symbol('cloneNode');
var $898c8f476f4ac4f1$export$1b8e57c9ea42f1d2 = Symbol('appendChild');
var $898c8f476f4ac4f1$export$7ae609f7af59e4f7 = Symbol('removeChild');
var $898c8f476f4ac4f1$export$86b68c7dbeb53c22 = Symbol('insertBefore');
var $898c8f476f4ac4f1$export$46f78da0e790aab7 = Symbol('replaceChild');
var $898c8f476f4ac4f1$export$c42c4b43e6ce031e = Symbol('tracks');
var $898c8f476f4ac4f1$export$264486c0939fa42b = Symbol('constraints');
var $898c8f476f4ac4f1$export$8e76ac9f37578d1b = Symbol('capabilities');
var $898c8f476f4ac4f1$export$a5a6e0b888b2c992 = Symbol('settings');
var $898c8f476f4ac4f1$export$9cd59f9826255e47 = Symbol('clone');
var $898c8f476f4ac4f1$export$2fb3bf594548fad2 = Symbol('removeNamedItem');
var $898c8f476f4ac4f1$export$17a1664ed1fb5d6f = Symbol('items');
var $898c8f476f4ac4f1$export$b0ea99e7ae5aed6c = Symbol('selectedOptions');
var $898c8f476f4ac4f1$export$d790dbddab3a5a7 = Symbol('styleNode');
var $898c8f476f4ac4f1$export$49c3ff852145bbc3 = Symbol('updateSheet');
var $898c8f476f4ac4f1$export$d2adf65b87e47523 = Symbol('clearCache');
var $898c8f476f4ac4f1$export$772723555d727dca = Symbol('onSetAttribute');
var $898c8f476f4ac4f1$export$c4c8b87eaa1d4a6d = Symbol('onRemoveAttribute');
var $898c8f476f4ac4f1$export$34baf9226cd3d576 = Symbol('nodeArray');
var $898c8f476f4ac4f1$export$2eb2dc5352f5da3 = Symbol('elementArray');
var $898c8f476f4ac4f1$export$69a3209f1a06c04d = Symbol('cache');
var $898c8f476f4ac4f1$export$80de6e30a9c630d9 = Symbol('affectsCache');
var $898c8f476f4ac4f1$export$71730bae229ad1d = Symbol('forms');
var $898c8f476f4ac4f1$export$f5f8cbac9d743c03 = Symbol('affectsComputedStyleCache');
var $898c8f476f4ac4f1$export$2fa187e846a241c4 = Symbol('query');
var $898c8f476f4ac4f1$export$ade5b9b1819f1516 = Symbol('computedStyle');
var $898c8f476f4ac4f1$export$4198a1a890646286 = Symbol('getFormControlItems');
var $898c8f476f4ac4f1$export$e8846d4d2446a1c9 = Symbol('getFormControlNamedItem');
var $898c8f476f4ac4f1$export$ff416b0d33795a06 = Symbol('dataset');
var $898c8f476f4ac4f1$export$714c5d3403db4c93 = Symbol('getNamespaceItemKey');
var $898c8f476f4ac4f1$export$5dd1224c2ae94442 = Symbol('getNamedItemKey');
var $898c8f476f4ac4f1$export$5ca502276fc813a = Symbol('itemsByNamespaceURI');
var $898c8f476f4ac4f1$export$923f96dd5afa9ce6 = Symbol('proxy');
var $898c8f476f4ac4f1$export$f5d9e770a4a8bf7b = Symbol('setNamedItem');
var $898c8f476f4ac4f1$export$4aec0e9d20ba276 = Symbol('getTokenList');
var $898c8f476f4ac4f1$export$8e830b0a8238aa08 = Symbol('attributeName');
var $898c8f476f4ac4f1$export$9ea87e299ff6a368 = Symbol('selectedIndex');
var $898c8f476f4ac4f1$export$82c2e460fb230c2a = Symbol('self');
var $898c8f476f4ac4f1$export$91124bb58bc04465 = Symbol('parent');
var $898c8f476f4ac4f1$export$1e95b668f3b82d = Symbol('top');
var $898c8f476f4ac4f1$export$4bdc600e2ccf60d6 = Symbol('areas');
var $898c8f476f4ac4f1$export$1a01ae0705bafd37 = Symbol('defaultValue');
var $898c8f476f4ac4f1$export$3fc11fe47bfd2f32 = Symbol('elementIdMap');
var $898c8f476f4ac4f1$export$9c4ad76ccad91f4f = Symbol('clonable');
var $898c8f476f4ac4f1$export$e31e112bc058ddaa = Symbol('delegatesFocus');
var $898c8f476f4ac4f1$export$c1faf8344a396331 = Symbol('serializable');
var $898c8f476f4ac4f1$export$60a619da8e8331f = Symbol('slotAssignment');
var $898c8f476f4ac4f1$export$2221f266c58dd824 = Symbol('assignedNodes');
var $898c8f476f4ac4f1$export$5f6c46426d2443cb = Symbol('assignedToSlot');
var $898c8f476f4ac4f1$export$57ba6370ea0e47f8 = Symbol('cells');
var $898c8f476f4ac4f1$export$2dd197b55cf13440 = Symbol('rows');
var $898c8f476f4ac4f1$export$838e2a576d4d6ff6 = Symbol('headers');
var $898c8f476f4ac4f1$export$c63586cd99d53eee = Symbol('tBodies');
var $898c8f476f4ac4f1$export$6b2a7d5132615086 = Symbol('track');
var $898c8f476f4ac4f1$export$af7f203a9950b02 = Symbol('controlsList');
var $898c8f476f4ac4f1$export$6641d4e7d2375a56 = Symbol('mediaKeys');
var $898c8f476f4ac4f1$export$a98641f1e36ae240 = Symbol('remote');
var $898c8f476f4ac4f1$export$b86dea9785c8c56f = Symbol('sinkId');
var $898c8f476f4ac4f1$export$a66885030df323c9 = Symbol('srcObject');
var $898c8f476f4ac4f1$export$c49f4d1debcf7f5b = Symbol('cues');
var $898c8f476f4ac4f1$export$b64d6e1c1737858c = Symbol('activeCues');
var $898c8f476f4ac4f1$export$78062f36b16ed2f8 = Symbol('kind');
var $898c8f476f4ac4f1$export$1237798dc640739a = Symbol('label');
var $898c8f476f4ac4f1$export$789c912f57fe164c = Symbol('language');
var $898c8f476f4ac4f1$export$d560c7e4a29451c2 = Symbol('id');
var $898c8f476f4ac4f1$export$c164fb211d29dfae = Symbol('illegalConstructor');
var $898c8f476f4ac4f1$export$ca000e230c0caa3e = Symbol('state');
var $898c8f476f4ac4f1$export$67ea982130081db = Symbol('canvas');
var $898c8f476f4ac4f1$export$ace1eea069cbbfe3 = Symbol('popoverTargetElement');
var $898c8f476f4ac4f1$export$3bf036c976d2370d = Symbol('composed');
var $898c8f476f4ac4f1$export$a0e54c3daa7db493 = Symbol('bubbles');
var $898c8f476f4ac4f1$export$95ff25b64c2b7c9d = Symbol('cancelable');
var $898c8f476f4ac4f1$export$6add31d873bb7f97 = Symbol('defaultPrevented');
var $898c8f476f4ac4f1$export$adaf9bfc2029072d = Symbol('eventPhase');
var $898c8f476f4ac4f1$export$c0dbb1ea68a069d3 = Symbol('timeStamp');
var $898c8f476f4ac4f1$export$bf9fb029d174d554 = Symbol('type');
var $898c8f476f4ac4f1$export$13a2d28b88853ef2 = Symbol('detail');
var $898c8f476f4ac4f1$export$ded1884231baf037 = Symbol('globalObject');
var $898c8f476f4ac4f1$export$ee16d7cb334f2c25 = Symbol('destroyed');
var $898c8f476f4ac4f1$export$bd75b6d981b9c7f2 = Symbol('aborted');
var $898c8f476f4ac4f1$export$8e3f89d89ab2e81a = Symbol('browserFrames');
var $898c8f476f4ac4f1$export$f6a5d0560c16dc39 = Symbol('windowInternalId');
var $898c8f476f4ac4f1$export$fe2d92c6190fd201 = Symbol('getItemList');
var $898c8f476f4ac4f1$export$17b5f2f53bc91e64 = Symbol('requiredExtensions');
var $898c8f476f4ac4f1$export$3d9884d57c583c6e = Symbol('systemLanguage');
var $898c8f476f4ac4f1$export$51186ad6e864892a = Symbol('transform');
var $898c8f476f4ac4f1$export$85fd356182841bc1 = Symbol('baseVal');
var $898c8f476f4ac4f1$export$ac2228a3780c1373 = Symbol('animVal');
var $898c8f476f4ac4f1$export$2d949ea0af312bcc = Symbol('pathLength');
var $898c8f476f4ac4f1$export$28441ec3aecc1a1 = Symbol('unitType');
var $898c8f476f4ac4f1$export$a179c88182cb9d56 = Symbol('viewBox');
var $898c8f476f4ac4f1$export$29ed369710e4e3ee = Symbol('markerUnits');
var $898c8f476f4ac4f1$export$365fc137c57b820 = Symbol('markerWidth');
var $898c8f476f4ac4f1$export$791533ea8a6adb36 = Symbol('markerHeight');
var $898c8f476f4ac4f1$export$68c286be0e7e55b7 = Symbol('values');
var $898c8f476f4ac4f1$export$9026555e890bab7 = Symbol('orientType');
var $898c8f476f4ac4f1$export$40f91b5b71d00141 = Symbol('orientAngle');
var $898c8f476f4ac4f1$export$f8ea6418a93b1766 = Symbol('refX');
var $898c8f476f4ac4f1$export$bea20940f2ab408d = Symbol('refY');
var $898c8f476f4ac4f1$export$b2cbc93d4da94977 = Symbol('readOnly');
var $898c8f476f4ac4f1$export$2cdd29748c601977 = Symbol('preserveAspectRatio');
var $898c8f476f4ac4f1$export$3f9d9544b5392aef = Symbol('animatedPoints');
var $898c8f476f4ac4f1$export$9f048bf86ee2e9d2 = Symbol('points');
var $898c8f476f4ac4f1$export$723a0c7037372ed6 = Symbol('rx');
var $898c8f476f4ac4f1$export$ca60ec8735b3eb59 = Symbol('ry');
var $898c8f476f4ac4f1$export$a274e22fb40f762e = Symbol('cx');
var $898c8f476f4ac4f1$export$aea64bc1b6f8f415 = Symbol('cy');
var $898c8f476f4ac4f1$export$43caf9889c228507 = Symbol('r');
var $898c8f476f4ac4f1$export$3c2731656864509c = Symbol('clipPathUnits');
var $898c8f476f4ac4f1$export$d7d6c8e209c718dd = Symbol('maskUnits');
var $898c8f476f4ac4f1$export$d8ca4674d0cabe81 = Symbol('maskContentUnits');
var $898c8f476f4ac4f1$export$206a4a7add109812 = Symbol('filterUnits');
var $898c8f476f4ac4f1$export$6c52b8f37a440e30 = Symbol('primitiveUnits');
var $898c8f476f4ac4f1$export$8f51af5840e0602a = Symbol('href');
var $898c8f476f4ac4f1$export$cdb484d3c68e5374 = Symbol('x1');
var $898c8f476f4ac4f1$export$f07ceed34b807c99 = Symbol('y1');
var $898c8f476f4ac4f1$export$8b7d42aa892c205b = Symbol('x2');
var $898c8f476f4ac4f1$export$bfb0cc6882fbf1fb = Symbol('y2');
var $898c8f476f4ac4f1$export$ef9501593e13374e = Symbol('gradientUnits');
var $898c8f476f4ac4f1$export$6bab994d7a66bebb = Symbol('gradientTransform');
var $898c8f476f4ac4f1$export$8a144b41063b9858 = Symbol('spreadMethod');
var $898c8f476f4ac4f1$export$e1f2563e13b909a9 = Symbol('patternUnits');
var $898c8f476f4ac4f1$export$7885149275f532ef = Symbol('patternContentUnits');
var $898c8f476f4ac4f1$export$9f3724c8da55136f = Symbol('patternTransform');
var $898c8f476f4ac4f1$export$68ae324f2f6c6252 = Symbol('fx');
var $898c8f476f4ac4f1$export$c0dcd1f2238f086d = Symbol('fy');
var $898c8f476f4ac4f1$export$cc800923e997bb8 = Symbol('offset');
var $898c8f476f4ac4f1$export$683472f6198a076e = Symbol('disabled');
var $898c8f476f4ac4f1$export$6f846043e306f02c = Symbol('textLength');
var $898c8f476f4ac4f1$export$d434f16f6fa84c07 = Symbol('lengthAdjust');
var $898c8f476f4ac4f1$export$735ee1799fd02602 = Symbol('getAttribute');
var $898c8f476f4ac4f1$export$9fec4d97f1922e0b = Symbol('setAttribute');
var $898c8f476f4ac4f1$export$df995fae86a55f06 = Symbol('z');
var $898c8f476f4ac4f1$export$efccba1c4a2ef57b = Symbol('w');
var $898c8f476f4ac4f1$export$45b10814cc054894 = Symbol('toArray');
var $898c8f476f4ac4f1$export$3004f64547af360e = Symbol('fromString');
var $898c8f476f4ac4f1$export$571d59b505e6bb4e = Symbol('fromArray');
var $898c8f476f4ac4f1$export$944b09d2ad10b378 = Symbol('angle');
var $898c8f476f4ac4f1$export$79d7ef402ccfe467 = Symbol('m11');
var $898c8f476f4ac4f1$export$97f5dbf02e136635 = Symbol('m12');
var $898c8f476f4ac4f1$export$bde1af0fc10716f0 = Symbol('m13');
var $898c8f476f4ac4f1$export$cac488ca1cf886cd = Symbol('m14');
var $898c8f476f4ac4f1$export$274acebb869cd4a0 = Symbol('m21');
var $898c8f476f4ac4f1$export$7aa0e98362223cb5 = Symbol('m22');
var $898c8f476f4ac4f1$export$306fac0490f3149e = Symbol('m23');
var $898c8f476f4ac4f1$export$71ea0096e8c723ec = Symbol('m24');
var $898c8f476f4ac4f1$export$95ae793e7c4e6543 = Symbol('m31');
var $898c8f476f4ac4f1$export$63bfc780feafcbf1 = Symbol('m32');
var $898c8f476f4ac4f1$export$997eccfd0cbd0255 = Symbol('m33');
var $898c8f476f4ac4f1$export$21d7e274d018da99 = Symbol('m34');
var $898c8f476f4ac4f1$export$949afd8576dd20f0 = Symbol('m41');
var $898c8f476f4ac4f1$export$f7918218e24f0114 = Symbol('m42');
var $898c8f476f4ac4f1$export$7618c0e3d8a311d6 = Symbol('m43');
var $898c8f476f4ac4f1$export$374ec4744d81b586 = Symbol('m44');
var $898c8f476f4ac4f1$export$8d2d093544b9c1ff = Symbol('setMatrixValue');
var $898c8f476f4ac4f1$export$2aff0b95423b51ba = Symbol('translateSelf');
var $898c8f476f4ac4f1$export$a420c0f8a08efc03 = Symbol('rotateSelf');
var $898c8f476f4ac4f1$export$6c1b9f1a6a6bc3e0 = Symbol('rotateAxisAngleSelf');
var $898c8f476f4ac4f1$export$23ddae2b75165d5c = Symbol('scaleSelf');
var $898c8f476f4ac4f1$export$dca95805d9752040 = Symbol('scale3dSelf');
var $898c8f476f4ac4f1$export$d73a1f57ff6bc0c3 = Symbol('scaleNonUniformSelf');
var $898c8f476f4ac4f1$export$48cada4eca6d68ce = Symbol('skewXSelf');
var $898c8f476f4ac4f1$export$f2ccb77914d8bf17 = Symbol('skewYSelf');
var $898c8f476f4ac4f1$export$9f5218110e97916c = Symbol('multiplySelf');
var $898c8f476f4ac4f1$export$9bdad1ae37d738e0 = Symbol('matrix');
var $898c8f476f4ac4f1$export$c7aa713bdac78167 = Symbol('domMatrix');
var $898c8f476f4ac4f1$export$2ddd00e60c975f93 = Symbol('getDOMMatrix');
var $898c8f476f4ac4f1$export$1e7a0e137398bf39 = Symbol('setDOMMatrix');
var $898c8f476f4ac4f1$export$8efefd68bbabb683 = Symbol('attributeValue');
var $898c8f476f4ac4f1$export$3c7a5870e7f5ee75 = Symbol('startOffset');
var $898c8f476f4ac4f1$export$26f73335cc2e7868 = Symbol('method');
var $898c8f476f4ac4f1$export$5458b64234d1333c = Symbol('spacing');
var $898c8f476f4ac4f1$export$e2fd68fefd1f88cb = Symbol('in1');
var $898c8f476f4ac4f1$export$46594abed2c6588b = Symbol('in2');
var $898c8f476f4ac4f1$export$aaf36426b5008f7a = Symbol('result');
var $898c8f476f4ac4f1$export$b4c7a57a34b46a4a = Symbol('bias');
var $898c8f476f4ac4f1$export$5b5be35630ee4885 = Symbol('divisor');
var $898c8f476f4ac4f1$export$d2a1c7ef8ea4821e = Symbol('edgeMode');
var $898c8f476f4ac4f1$export$4c64642e02923fa5 = Symbol('kernelMatrix');
var $898c8f476f4ac4f1$export$78a2cfa446a06db9 = Symbol('kernelUnitLengthX');
var $898c8f476f4ac4f1$export$d5a510dc7c229103 = Symbol('kernelUnitLengthY');
var $898c8f476f4ac4f1$export$8fd0aac9d900da8d = Symbol('orderX');
var $898c8f476f4ac4f1$export$857f6d02ab3af3e8 = Symbol('orderY');
var $898c8f476f4ac4f1$export$3bc44247294bd916 = Symbol('preserveAlpha');
var $898c8f476f4ac4f1$export$fe3981a8eebcfaf5 = Symbol('targetX');
var $898c8f476f4ac4f1$export$f2185c905aa6640 = Symbol('targetY');
var $898c8f476f4ac4f1$export$d86b85890bac6db8 = Symbol('diffuseConstant');
var $898c8f476f4ac4f1$export$832a69a4bcf983c6 = Symbol('surfaceScale');
var $898c8f476f4ac4f1$export$dcdf75081b88279d = Symbol('scale');
var $898c8f476f4ac4f1$export$a3f0de261983cd60 = Symbol('xChannelSelector');
var $898c8f476f4ac4f1$export$de825f8e71fac764 = Symbol('yChannelSelector');
var $898c8f476f4ac4f1$export$c499e0030428ae85 = Symbol('azimuth');
var $898c8f476f4ac4f1$export$845e8aeb9a42ea24 = Symbol('elevation');
var $898c8f476f4ac4f1$export$dfa1698a1e9944f5 = Symbol('dx');
var $898c8f476f4ac4f1$export$df8cac1947751fe2 = Symbol('dy');
var $898c8f476f4ac4f1$export$de5ca30c0f202eba = Symbol('stdDeviationX');
var $898c8f476f4ac4f1$export$2d39ca4530a88381 = Symbol('stdDeviationY');
var $898c8f476f4ac4f1$export$7e802621e4669c62 = Symbol('tableValues');
var $898c8f476f4ac4f1$export$abff5e70462cbd6b = Symbol('slope');
var $898c8f476f4ac4f1$export$ab0f802c05dd969b = Symbol('intercept');
var $898c8f476f4ac4f1$export$f269d0dbcdcbb1a4 = Symbol('amplitude');
var $898c8f476f4ac4f1$export$abde88043842a778 = Symbol('exponent');
var $898c8f476f4ac4f1$export$c47cb7c63271266e = Symbol('crossOrigin');
var $898c8f476f4ac4f1$export$dbd72860f701d4f3 = Symbol('operator');
var $898c8f476f4ac4f1$export$72716fab198d26f9 = Symbol('radiusX');
var $898c8f476f4ac4f1$export$d46fdc86894b825c = Symbol('radiusY');
var $898c8f476f4ac4f1$export$db5a2af817670ee6 = Symbol('specularConstant');
var $898c8f476f4ac4f1$export$48ceb09a4bdd4d62 = Symbol('specularExponent');
var $898c8f476f4ac4f1$export$48d8e7684611f6da = Symbol('pointsAtX');
var $898c8f476f4ac4f1$export$c03ce0928973a32d = Symbol('pointsAtY');
var $898c8f476f4ac4f1$export$d9f9d56f85cfd076 = Symbol('pointsAtZ');
var $898c8f476f4ac4f1$export$144854373bfef05c = Symbol('limitingConeAngle');
var $898c8f476f4ac4f1$export$1b396282c0d11891 = Symbol('baseFrequencyX');
var $898c8f476f4ac4f1$export$807eb29e865552dc = Symbol('baseFrequencyY');
var $898c8f476f4ac4f1$export$20bddd3972aa12d2 = Symbol('numOctaves');
var $898c8f476f4ac4f1$export$7f7d45814fc23e4d = Symbol('seed');
var $898c8f476f4ac4f1$export$607bca416b189c36 = Symbol('stitchTiles');
var $898c8f476f4ac4f1$export$ce74d7c7d760417f = Symbol('rotateFromVectorSelf');
var $898c8f476f4ac4f1$export$30fbe03ab57ee506 = Symbol('flipXSelf');
var $898c8f476f4ac4f1$export$a1b6e55c1a799c7f = Symbol('flipYSelf');
var $898c8f476f4ac4f1$export$ab14314deeab381d = Symbol('invertSelf');
var $898c8f476f4ac4f1$export$f0d11c074a923179 = Symbol('getLength');
var $898c8f476f4ac4f1$export$7cac36689b656583 = Symbol('currentScale');
var $898c8f476f4ac4f1$export$bb628a54ab399bc9 = Symbol('rotate');
var $898c8f476f4ac4f1$export$15e9b7173302ae00 = Symbol('bindMethods');
var $898c8f476f4ac4f1$export$6065b270a53f18ff = Symbol('xmlProcessingInstruction');
var $898c8f476f4ac4f1$export$e8e78c978b129247 = Symbol('root');
var $898c8f476f4ac4f1$export$50060fa398ae0a6 = Symbol('filterNode');
var $898c8f476f4ac4f1$export$6262c3e04a0774fa = Symbol('customElementReactionStack');
var $898c8f476f4ac4f1$export$3cc811ff7873d170 = Symbol('dispatching');
var $898c8f476f4ac4f1$export$cc2c248003684daa = Symbol('modules');
var $898c8f476f4ac4f1$export$fd2739e17e482e5d = Symbol('preloads');
var $898c8f476f4ac4f1$export$32180ef41b15b513 = Symbol('body');
var $898c8f476f4ac4f1$export$89e12c5b50f7529d = Symbol('redirect');
var $898c8f476f4ac4f1$export$8b29ef2611187a5f = Symbol('referrerPolicy');
var $898c8f476f4ac4f1$export$e2ef10f86a8d60e8 = Symbol('signal');
var $898c8f476f4ac4f1$export$990c50f893ee81a0 = Symbol('bodyUsed');
var $898c8f476f4ac4f1$export$78896651422bbf9e = Symbol('credentials');
var $898c8f476f4ac4f1$export$656bac03c1547317 = Symbol('blocking');
var $898c8f476f4ac4f1$export$f3e7c58193966145 = Symbol('moduleImportMap');
var $898c8f476f4ac4f1$export$cf7b7bc75a9281a8 = Symbol('dispatchError');
var $898c8f476f4ac4f1$export$cde6a56f9669daf6 = Symbol('supports');
var $898c8f476f4ac4f1$export$e5560ffd7150410d = Symbol('reason');
var $898c8f476f4ac4f1$export$16d9772d7787f85 = Symbol('propertyEventListeners');
var $898c8f476f4ac4f1$export$ff225bc3fa466c48 = Symbol('cssRules');
var $898c8f476f4ac4f1$export$b722d3af22bfa730 = Symbol('parentRule');
var $898c8f476f4ac4f1$export$dfea80c48c12841 = Symbol('parentStyleSheet');
var $898c8f476f4ac4f1$export$7e124d7fd0a718c0 = Symbol('conditionText');
var $898c8f476f4ac4f1$export$584a5bf9373e3852 = Symbol('keyText');
var $898c8f476f4ac4f1$export$987d49ffe1b0900f = Symbol('media');
var $898c8f476f4ac4f1$export$1e5b4ce2fa884e6a = Symbol('styleMap');
var $898c8f476f4ac4f1$export$87f583ebf1847e9c = Symbol('selectorText');
var $898c8f476f4ac4f1$export$8f7584c51b5fc4ff = Symbol('cssParser');
var $898c8f476f4ac4f1$export$7bffc948341a2c5c = Symbol('cssRule');
var $898c8f476f4ac4f1$export$9b567b5c08a764f9 = Symbol('rulePrefix');
var $898c8f476f4ac4f1$export$c07a6c2bca9253b4 = Symbol('virtualServerFile');
var $898c8f476f4ac4f1$export$3ce3cb072716a2c7 = Symbol('frames');
var $898c8f476f4ac4f1$export$d48af2287e1c82ec = Symbol('disableEvaluation');
var $898c8f476f4ac4f1$export$5f73145c2c4db2a7 = Symbol('validateJavaScriptExecutionEnvironment');


// Expose only what Alpine templates need in global scope
window.createContractorCard = (0, $670e0f14fa02ad13$export$5464865996ba2eb4);
window.getPathRequiredSkills = (0, $1249ab814b7054d4$export$1311cf265aa89b71);
window.getTeamSkillLevels = (0, $1249ab814b7054d4$export$bf19dc1273cbd1a1);
window.contractorManager = (0, $8036d62b47ca0907$export$ecfe6fdf513f3742);
window.inventoryManager = (0, $80ed874fd909c4ae$export$277774029cdaf1);
window.gameState = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172);
window.config = $979b99378be707cd$exports;
// Dev-only QA helpers (localhost): load a maintained save fixture to exercise
// features (e.g. the whole Command layer) without grinding a save, then put the
// real save back. The catalogue, the loader and the button strip all live in
// devFixtures.js; these globals are the console entry points the qa-player
// skill drives.
if ((0, $7298e89ec732fd6b$export$6dd1bbd39f571125)()) {
    window.loadFixture = (0, $03744ae8c690a79a$export$fad9145e0ce507a0);
    window.restoreSave = (0, $03744ae8c690a79a$export$4fd8d4441084914c);
    (0, $03744ae8c690a79a$export$17bd57c6fd7474d9)();
}
window.Alpine = (0, $da6f71b8677b901e$export$2e2bcd8739ae039);
window.craftItem = (0, $83869d722e7ea000$export$67f8f6c6271cd4a2);
window.unlockArtifact = (0, $83869d722e7ea000$export$506c247f43a19ac3);
window.showCraftingModal = (0, $83869d722e7ea000$export$aa7c3ee86bbf0990);
window.showCraftingTreeModal = (0, $83869d722e7ea000$export$301cbaf87c15a68f);
window.clearCraftingTreeFilter = (0, $83869d722e7ea000$export$e186070c9358ae3a);
window.openContractorModal = (0, $670e0f14fa02ad13$export$9a18f3125e8e0eca);
window.reserveContractorFromModal = (0, $670e0f14fa02ad13$export$959fb65d2b5e760e);
window.generateTestInventory = (0, $a575049a7e5cb3a1$export$8606b9937b72ca5d);
window.createInventoryCard = (0, $a575049a7e5cb3a1$export$4ac7f915da1fa1c4);
window.clearInventory = (0, $a575049a7e5cb3a1$export$56dcd79bae47b9c1);
window.upgradeSkill = (0, $7ea2865b97769aa3$export$dfab59a277375299);
window.unlockSkillSynergy = (0, $7ea2865b97769aa3$export$8d1a7714ddcaaa75);
window.releaseReservedContractor = (0, $3f29ea4265abff3b$export$e4c69cea9b646118);
window.equipArtifact = (0, $7ea2865b97769aa3$export$1f3b8068ff1292ef);
window.unequipArtifact = (0, $7ea2865b97769aa3$export$fd37f844ae84e59c);
window.showTechniqueGearSelector = (0, $7ea2865b97769aa3$export$4e0f5000083da307);
window.equipTechniqueGear = (0, $7ea2865b97769aa3$export$958ab300c288e475);
window.unequipTechniqueGear = (0, $7ea2865b97769aa3$export$954d5d768998dfd1);
window.closeTechniqueGearSelector = (0, $7ea2865b97769aa3$export$a9326cac8ab4c94a);
window.equipTechniqueGear = (0, $7ea2865b97769aa3$export$958ab300c288e475);
window.unequipTechniqueGear = (0, $7ea2865b97769aa3$export$954d5d768998dfd1);
window.sellItem = (0, $a575049a7e5cb3a1$export$e1c01f683feb5181);
window.purchaseConsumable = (0, $a575049a7e5cb3a1$export$dba564f0cb325527);
window.useConsumable = (0, $a575049a7e5cb3a1$export$dbdf3132d4782af0);
window.openPurchaseModal = (0, $a575049a7e5cb3a1$export$432db33666131f90);
window.closePurchaseModal = (0, $a575049a7e5cb3a1$export$1ed9acaf4451ebfa);
window.toggleEnergyPopup = (0, $a575049a7e5cb3a1$export$4c1b7a82836a6e5c);
window.buyEnergyDirect = (0, $a575049a7e5cb3a1$export$d4a1bdd7cb9254a9);
window.refreshAlpineContractors = (0, $8036d62b47ca0907$export$17502054442d56b0);
window.setupPurchaseModalHandler = (0, $a575049a7e5cb3a1$export$fe032c86fe8adff);
window.calculateBulkCraftingCost = (0, $83869d722e7ea000$export$5c9f0b8d2a488474);
window.getBulkCraftingCostPercent = (0, $83869d722e7ea000$export$3bec963ccca7a0ba);
window.incrementCraftQty = (0, $a575049a7e5cb3a1$export$ad1aa4315d00018a);
window.decrementCraftQty = (0, $a575049a7e5cb3a1$export$7b962277503582ab);
window.updateCraftCost = (0, $a575049a7e5cb3a1$export$8ef1bcc7d93420a1);
window.getMaxCraftableQty = (0, $a575049a7e5cb3a1$export$8e8909cfaf15b391);
window.incrementSellQty = (0, $a575049a7e5cb3a1$export$ff0507185d233e75);
window.decrementSellQty = (0, $a575049a7e5cb3a1$export$a4d3bbe47949d494);
window.updateSellQty = (0, $a575049a7e5cb3a1$export$4b495d34a3840d43);
// Reinitialize Tippy tooltips for dynamically created inventory cards
window.reinitializeInventoryTooltips = function() {
    if (window.tippy) {
        // Idempotent: tear down any existing instances first so callers across
        // render paths (inventory, crafting modal, gear tab) never stack duplicates
        document.querySelectorAll(".inventory-tooltip").forEach(function(el) {
            var _el__tippy;
            return (_el__tippy = el._tippy) === null || _el__tippy === void 0 ? void 0 : _el__tippy.destroy();
        });
        tippy(".inventory-tooltip", {
            theme: "dark",
            placement: "top",
            delay: [
                300,
                0
            ],
            maxWidth: 300,
            allowHTML: true,
            content: function(reference) {
                var descDiv = reference.querySelector(".inventory-tooltip-content");
                return descDiv ? descDiv.innerHTML : "";
            },
            onMount: function(instance) {
                instance.popper.style.border = "2px solid white";
                instance.popper.style.borderRadius = "0.5rem";
            },
            onShow: function(instance) {
                // Create a named function so it can be accurately removed later
                instance._scrollHandler = function() {
                    return instance.hide();
                };
                window.addEventListener('scroll', instance._scrollHandler, {
                    passive: true
                });
            },
            onHide: function(instance) {
                // Clean up the listener to prevent memory leaks
                window.removeEventListener('scroll', instance._scrollHandler);
            }
        });
    }
};
// Current contractor-list poll delay (see pollContractorList). Module scope so
// the tab-switch handler can reset the backoff when the section is reopened.
var $a13c06a9ce2afd55$var$contractorPollDelay = (0, $e63b1e314d73680b$export$fa0ee1eb937a38e6);
/**
 * Boot-blocking error banner. Config problems mean the generated constants are
 * stale/partial, so the page must not come up half-working — a console-only
 * error would look like a blank screen with no cause.
 */ function $a13c06a9ce2afd55$var$showBootFailure(err) {
    var banner = document.createElement("pre");
    banner.style.cssText = "position:fixed;inset:0;z-index:9999;margin:0;padding:2rem;overflow:auto;background:#1a0d0d;color:#ffb4b4;font:13px/1.5 ui-monospace,monospace;white-space:pre-wrap;";
    banner.textContent = "Idle Extraction failed to start.\n\n".concat(err.message);
    document.body.appendChild(banner);
}
// Initialize game
(0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "adding dom event listener");
document.addEventListener("DOMContentLoaded", function() {
    // Fail fast on a stale or partial js/constants.js BEFORE anything reads a
    // balance value. Balance reads are direct (no inline fallbacks), so a missing
    // config must stop boot loudly rather than silently run a different game.
    try {
        (0, $ad0da473ec84234c$export$82367cdd05923d12)($979b99378be707cd$exports);
    } catch (err) {
        console.error(err);
        $a13c06a9ce2afd55$var$showBootFailure(err);
        return;
    }
    // Hydrate procedural avatars as they enter the DOM (covers every render path,
    // including Alpine/raid.js reactive re-renders). Install before any UI renders.
    (0, $a6e2b3e30d0f771b$export$f32bf1f4ac79976)();
    // Try to load saved game first
    (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "doc loaded:", document);
    var loaded = (0, $dd2eed17ca70a8a9$export$756e5d66bdd28395)();
    (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "loaded data: ", loaded);
    if (!loaded) return;
    // Operations that arrived while away, capped at one round per slot so a week
    // off pays the same as a night off. Called from here rather than inside
    // loadGameState: gameState.js importing operations.js would close a cycle
    // (operations -> gameState -> operations), which breaks boot silently.
    (0, $c95f3da2626a9dfc$export$f9a694398861c909)();
    // Initialize per-item drop rate multipliers from itemRarities config
    var itemDropRates = {};
    Object.values($979b99378be707cd$exports.itemRarities).forEach(function(rarity) {
        var _rarity_dropChance;
        if ((_rarity_dropChance = rarity.dropChance) === null || _rarity_dropChance === void 0 ? void 0 : _rarity_dropChance.perItem) Object.assign(itemDropRates, rarity.dropChance.perItem);
    });
    if (Object.keys(itemDropRates).length > 0) (0, $8bda0cb20f0b197d$export$16a0347071379537)(itemDropRates);
    // Apply credit and crafting cost scaling from progressionScaling (single source of truth,
    // shared with the headless simulator). Unguarded: assertConfigLoaded above
    // already proved these exist, so a guard here could only hide a real problem.
    (0, $8bda0cb20f0b197d$export$b1b6e81d46587814)($979b99378be707cd$exports.progressionScaling.creditsScaling);
    (0, $8bda0cb20f0b197d$export$b2554e3c8ffeec59)($979b99378be707cd$exports.progressionScaling.craftingCostScaling);
    (0, $8bda0cb20f0b197d$export$12f04c67a6a6e4dd)($979b99378be707cd$exports.progressionScaling.energyPurchaseScaling);
    // Re-apply the per-tour crafting discount AFTER the config seed above, which
    // would otherwise wipe it. This is the reload path that used to lose it.
    (0, $ee71dfe8b201c427$export$6d153901dd951884)();
    if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).activeCharacterId) {
        // Load their inventory (already done above in inventory loading section)
        // Update UI components
        document.getElementById("character-creator").classList.add("hidden");
        document.getElementById("character-display").classList.remove("hidden");
        (0, $7ea2865b97769aa3$export$2eced2100c12c50d)();
        // Update character selector to show correct active character
        if (typeof (0, $7ea2865b97769aa3$export$d87722dc17dc5f68) === "function") (0, $7ea2865b97769aa3$export$d87722dc17dc5f68)();
        // Update inventory header
        if (typeof (0, $a575049a7e5cb3a1$export$d2567add70135c10) === "function") (0, $a575049a7e5cb3a1$export$d2567add70135c10)();
    }
    // Resume raid if it was in progress (only if not completed)
    if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress && !(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidCompleted) {
        // Show team
        document.getElementById("raid-team").classList.remove("hidden");
        // Restore log entries
        (0, $3f29ea4265abff3b$export$8f8ffb9ff36daf30)();
        (0, $3f29ea4265abff3b$export$17436b2a8cf51f27)();
        (0, $3f29ea4265abff3b$export$46938b5e497922ff)();
    }
    // No need to sync contractor.reserved flags - we use only reservedContractors list
    // Update team display immediately after contractor sync to ensure reserved contractors show
    if (document.getElementById("grid-team-display")) {
        (0, $3f29ea4265abff3b$export$b70ccd83fb3eaefa)();
        (0, $3f29ea4265abff3b$export$68c4600b33dd0ca8)();
    }
    // Build the layer toolbar before the first visibility pass, so the screen
    // tabs it operates on exist.
    (0, $8896b37f0fd85895$export$544b0f50b5799474)();
    (0, $59924438766e7d8e$export$d1c957a54f7124bc)();
    (0, $59924438766e7d8e$export$2ae62d947e9e1d03)();
    // Update tab visibility again after character restoration to account for raid ownership
    setTimeout(function() {
        (0, $59924438766e7d8e$export$2ae62d947e9e1d03)();
        (0, $8896b37f0fd85895$export$5672aa0b2d188c2b)();
    }, 100);
    // Clean up multiplayer storage after game state is loaded
    (0, $fde0976ce5d1665d$export$347a45e01153443c)();
    // Refresh Alpine stores after loading game state
    (0, $80ed874fd909c4ae$export$5b73e6a29e58b929)();
    (0, $8036d62b47ca0907$export$17502054442d56b0)();
    // Restore raid grid UI if it exists
    if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid && document.getElementById("raid-grid-section")) {
        document.getElementById("raid-grid-section").classList.remove("hidden");
        document.getElementById("raid-team").classList.remove("hidden");
        document.getElementById("raid-setup").classList.add("hidden");
        document.getElementById("raid-active").classList.remove("hidden");
        // Update raid active info
        (0, $3f29ea4265abff3b$export$d6f634bba1273a2b)();
        (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "Restoring raid grid display");
        (0, $3f29ea4265abff3b$export$cf8b2a65252147ea)();
        (0, $3f29ea4265abff3b$export$c9b7157fc13410c5)(); // Restore grid header with area info and room count
        // Restore the planning-only item-drop highlight picker (it is populated in
        // the generate-grid handler, which a reload doesn't run). Only in the
        // planning phase — hidden once a raid is in progress or completed.
        if (!(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress && !(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidCompleted) (0, $3f29ea4265abff3b$export$d72ea71bfd67dd40)();
        // Check if we need to restore completed raid visualization
        if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidCompleted && (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.completedRaidInfo) {
            (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "Restoring completed raid visualization in DOMContentLoaded");
            // Apply completed raid state directly after displayRaidGrid
            (0, $3f29ea4265abff3b$export$20c4edcabec24020)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.completedRaidInfo);
            // Restore log entries
            if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.completedRaidInfo.logEntries && (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.completedRaidInfo.logEntries.length > 0) {
                var logEntries = document.getElementById("log-entries");
                if (logEntries) {
                    logEntries.innerHTML = "";
                    (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.completedRaidInfo.logEntries.forEach(function(logEntry) {
                        var entry = document.createElement("div");
                        entry.className = "log-entry log-".concat(logEntry.type);
                        entry.textContent = logEntry.message;
                        logEntries.appendChild(entry);
                    });
                    logEntries.scrollTop = logEntries.scrollHeight;
                }
            }
        } else {
            // Only call these for non-completed raids
            (0, $3f29ea4265abff3b$export$ed4907da7d4af889)();
            (0, $3f29ea4265abff3b$export$c3f865504cdad6c4)();
        }
        (0, $3f29ea4265abff3b$export$f4fa7fe8ae486c6)();
        (0, $3f29ea4265abff3b$export$d6f634bba1273a2b)();
        (0, $3f29ea4265abff3b$export$25fc6ae0ff69cc)();
    }
    // Monotonic id so a fade-out that is still running can tell it has been
    // superseded by a newer navigation. See activateOnly below.
    var tabTransitionId = 0;
    // Tab switching with animations.
    //
    // DELEGATED rather than bound per button: screen tabs and the active-task
    // button are re-rendered from the layer registry, so listeners attached at
    // boot would be discarded on the first layer switch.
    document.addEventListener("click", function(event) {
        var _event_target_closest, _event_target;
        var btn = (_event_target_closest = (_event_target = event.target).closest) === null || _event_target_closest === void 0 ? void 0 : _event_target_closest.call(_event_target, ".tab-btn");
        if (!btn) return;
        {
            var tabName = btn.getAttribute("data-tab");
            if (tabName == null || tabName == "") return;
            var newTab = document.getElementById("".concat(tabName, "-tab"));
            // One screen can host more than one VIEW. Operations is both a planner
            // and a transit board, and switching between them is a real navigation
            // even though the tab does not change — so this runs BEFORE the
            // already-here guard below, which would otherwise swallow it.
            if (tabName === "operations") // `data-mode` is set only by the toolbar's "New Operation" button; the
            // screen tab carries none, so the default is the transit board.
            (0, $c95f3da2626a9dfc$export$a4a190e64d36c7a)(btn.dataset.mode === "plan" ? "plan" : "transit");
            // Don't switch if we are already on (or heading to) this screen.
            //
            // Compares tracked intent rather than the button's `active` class: the
            // class is painted from a re-render that can happen mid fade-out, so a
            // stale one used to make this swallow a legitimate navigation.
            if (tabName === (0, $8896b37f0fd85895$export$517113b01f92f5fe)()) return;
            // Check raid access for raid tab
            if (tabName === "raid" && !(0, $fe47a452a83d9e00$export$77866226ea57ca79)()) {
                var raidOwner = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).characters.find(function(c) {
                    return c.id === (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidOwnerId;
                });
                var ownerName = raidOwner ? raidOwner.name : "another character";
                (0, $b5bda7fdec806d8b$export$c7def531c087da85)("Cannot access raid tab - ".concat(ownerName, " has an active raid"), "error");
                return;
            }
            if (tabName === "contractors") {
                // Refresh contractor list when opening contractors tab
                if ((0, $da6f71b8677b901e$export$2e2bcd8739ae039).store("contractors")) (0, $da6f71b8677b901e$export$2e2bcd8739ae039).store("contractors").refresh();
                // Reopening is fresh interest — restart the poll backoff so the next few
                // updates are prompt rather than inheriting a settled 5-minute cadence.
                $a13c06a9ce2afd55$var$contractorPollDelay = (0, $e63b1e314d73680b$export$fa0ee1eb937a38e6);
            }
            if (tabName === "character") {
                var // Inventory and Gear are now sub-tabs of the character page; refresh
                // the active sub-pane so its content is current on return
                _window_applyCharSubTab, _window;
                (_window_applyCharSubTab = (_window = window).applyCharSubTab) === null || _window_applyCharSubTab === void 0 ? void 0 : _window_applyCharSubTab.call(_window);
                // Re-render the card so its state (e.g. edit buttons locked during a
                // raid) is current on every return, not just after an edit/level-up.
                if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character) (0, $7ea2865b97769aa3$export$2eced2100c12c50d)();
                else (0, $7ea2865b97769aa3$export$d87722dc17dc5f68) === null || (0, $7ea2865b97769aa3$export$d87722dc17dc5f68) === void 0 ? void 0 : (0, $7ea2865b97769aa3$export$d87722dc17dc5f68)();
                // With no character this screen IS the creator, whichever route got
                // here. Asserting it on arrival rather than trusting whoever emptied the
                // roster to have set it: promotion and founding both call
                // showCharacterScreenAfterPromotion(), but the layer switcher and the
                // switcher panel are two more ways in, and a blank Field screen is the
                // failure they produced.
                if (!(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character) {
                    var _document_getElementById, _document_getElementById1;
                    (_document_getElementById = document.getElementById("character-creator")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.classList.remove("hidden");
                    (_document_getElementById1 = document.getElementById("character-display")) === null || _document_getElementById1 === void 0 ? void 0 : _document_getElementById1.classList.add("hidden");
                }
            }
            if (tabName === "command") // Re-render so marks, upgrade affordability, and gallery are current
            (0, $4c1b6c766bf73b42$export$cf457306c8f8ec80)();
            if (tabName === "archive") // Keys arrive while the player is on the raid screen, so the Archive is
            // never current on arrival.
            (0, $11d54c59f84070a9$export$5dc9bc24597948d9)();
            if (tabName === "command-vault" || tabName === "syndicate-stores") // The vaults change on promotion, founding and every convoy launch —
            // none of which is a thing the player does from these screens, so the
            // store has to be re-read on arrival rather than trusted to be current.
            (0, $80ed874fd909c4ae$export$5b73e6a29e58b929)();
            if (tabName === "syndicate") // Same reason: Writs, charter affordability, and founding eligibility
            // all move while the player is elsewhere.
            (0, $5114056da3d46141$export$8cd027517c8fb270)();
            // Find currently active tab content
            var currentActiveTab = document.querySelector(".tab-content.active");
            // Every activation goes through here, and it leaves EXACTLY ONE screen
            // active. That is not defensive tidying — it is the fix for a real stuck
            // state: switching layer and then immediately pressing the layer's task
            // button (New Operation) queued two fade-outs on the same outgoing tab,
            // because querySelector(".tab-content.active") still returned it the
            // second time. Both animationend handlers then fired and each activated
            // ITS OWN target, leaving two screens stacked and the page scrolling
            // twice its height until something re-clicked the tab.
            var activateOnly = function(tab) {
                document.querySelectorAll(".tab-content.active").forEach(function(t) {
                    if (t !== tab) t.classList.remove("active", "animate__animated", "animate__fadeOut");
                });
                tab.classList.add("active", "animate__animated", "animate__fadeIn");
                tab.addEventListener("animationend", function handleFadeIn() {
                    tab.classList.remove("animate__animated", "animate__fadeIn");
                    tab.removeEventListener("animationend", handleFadeIn);
                });
            };
            // A superseded transition must not finish: without the token, the older
            // handler still activates the screen the player already navigated away
            // from.
            var transition = ++tabTransitionId;
            // Animate out current tab
            if (currentActiveTab && currentActiveTab !== newTab) {
                currentActiveTab.classList.add("animate__animated", "animate__fadeOut");
                currentActiveTab.addEventListener("animationend", function handleFadeOut() {
                    currentActiveTab.removeEventListener("animationend", handleFadeOut);
                    currentActiveTab.classList.remove("active", "animate__animated", "animate__fadeOut");
                    if (transition !== tabTransitionId) return; // a newer click won
                    activateOnly(newTab);
                });
            } else // No current tab, just show new one with animation
            activateOnly(newTab);
            // Active styling is no longer inferred by matching Tailwind border
            // classes (which encoded each layer's accent as a magic string and had to
            // be edited per layer). renderLayerToolbar() re-renders the screen tabs
            // and colours the active one from the registry's `accent`.
            // Special handling for specific tabs
            if (tabName === "raid") {
                // Re-render region tiles: availability is per-character (Command
                // region locks), so tiles rendered at boot go stale after character
                // creation/switch/promotion or a Regional Charter purchase
                if (!(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid && !(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress) (0, $59924438766e7d8e$export$98a6c6e9bfe86f10)();
                setTimeout((0, $3f29ea4265abff3b$export$d86087c4a9b82d46), 250); // Delay for animation
                setTimeout((0, $59924438766e7d8e$export$6a940d9b4a9b252a), 250);
                (0, $3f29ea4265abff3b$export$a21eeedead301a30)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress ? 'log' : 'highlights');
            } else if (tabName === "character") setTimeout(function() {}, 150); // Delay for animation to complete
            // Remember where each layer was left, so switching back returns there.
            (0, $8896b37f0fd85895$export$581d35409857f84f)(tabName);
            // Reflect the new active screen in the toolbar (accent + active state).
            (0, $8896b37f0fd85895$export$5672aa0b2d188c2b)();
        }
    });
    // Update faction availability when page loads
    (0, $59924438766e7d8e$export$ac9b2c0e374abc75)();
    // Command layer: reveal state + marks chip on boot
    (0, $4c1b6c766bf73b42$export$ca081aebb329a098)();
    // Setup character management events
    (0, $7ea2865b97769aa3$export$b87cdb7b62197ecc)();
    // Update inventory character header
    (0, $a575049a7e5cb3a1$export$d2567add70135c10)();
    // Faction selection
    document.querySelectorAll(".faction-card").forEach(function(card) {
        card.addEventListener("click", function() {
            var faction = card.dataset.faction;
            // Check if faction is disabled
            if (card.classList.contains("faction-disabled")) {
                (0, $b5bda7fdec806d8b$export$c7def531c087da85)("You already have a character of this faction", "error");
                return;
            }
            // Update selection with Tailwind classes
            document.querySelectorAll(".faction-card").forEach(function(c) {
                c.classList.remove("selected", "text-gray-200", "animate-pulse");
                c.classList.add("text-gray-400");
            });
            card.classList.add("selected", "text-gray-200", "animate-pulse");
            card.classList.remove("text-gray-400");
            (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).selectedFaction = faction;
            // Update header background based on selected faction
            (0, $59924438766e7d8e$export$ffc032d1101a5382)(faction);
            (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "Faction selected:", faction);
            (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
            (0, $7ea2865b97769aa3$export$44472cbca86113a6)();
        });
    });
    // Character name validation
    var nameInput = document.getElementById("character-name-create");
    var validationMessage = document.getElementById("name-validation-message");
    var debouncedValidate = (0, $ca7af38ea7b7b4a8$export$61fc7d43ac8f84b0)(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
            var name, result;
            return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        name = nameInput.value.trim();
                        if (name) {
                            validationMessage.className = "text-sm mt-1 text-gray-400";
                            validationMessage.textContent = "Checking name availability...";
                        }
                        return [
                            4,
                            (0, $fde0976ce5d1665d$export$6ebef846cc736ea)(name)
                        ];
                    case 1:
                        result = _state.sent();
                        validationMessage.className = "text-sm mt-1 ".concat(result.className);
                        validationMessage.textContent = result.message;
                        (0, $7ea2865b97769aa3$export$44472cbca86113a6)();
                        return [
                            2
                        ];
                }
            });
        })();
    }, 500);
    nameInput.addEventListener("input", debouncedValidate);
    // Attach all event listeners
    document.getElementById("create-character").addEventListener("click", function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
            var characterName, isUnique, error, characterFactionSkills, characterData, newCharacter, _registeredCharacter_character, registeredCharacter, error1;
            return (0, $4fa1715f971c561b$export$67ebef60e6f28a6)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        characterName = nameInput.value.trim();
                        if (!(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).selectedFaction || !characterName || characterName.length < 2) {
                            (0, $b5bda7fdec806d8b$export$c7def531c087da85)("\u274C Please enter a valid name and select a faction", "error");
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0, $fde0976ce5d1665d$export$6ec81efa6b4944af)(characterName)
                        ];
                    case 2:
                        isUnique = _state.sent();
                        if (!isUnique) {
                            (0, $b5bda7fdec806d8b$export$c7def531c087da85)("\u274C Character name already exists", "error");
                            return [
                                2
                            ];
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.warn("Could not verify name uniqueness:", error);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        // All faction skills at level 0. createNewCharacter applies the same rule,
                        // so this is really just the shape the registration payload is sent in.
                        characterFactionSkills = (0, $fe47a452a83d9e00$export$f70dbb2553d659e4)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).selectedFaction);
                        // Create character with all faction skills at level 0
                        characterData = {
                            id: "player",
                            name: characterName,
                            faction: (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).selectedFaction,
                            skills: characterFactionSkills,
                            maxHp: 100,
                            currentHp: 100,
                            injuries: [],
                            level: 1,
                            xp: 0,
                            avatar: (0, $ca7af38ea7b7b4a8$export$913078032f14f7f)()
                        };
                        newCharacter = {};
                        _state.label = 5;
                    case 5:
                        _state.trys.push([
                            5,
                            7,
                            ,
                            8
                        ]);
                        return [
                            4,
                            (0, $fde0976ce5d1665d$export$e4477200b6413a70).registerCharacter(characterData)
                        ];
                    case 6:
                        registeredCharacter = _state.sent();
                        (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "Registered character:", registeredCharacter);
                        // Create new character using multi-character system
                        newCharacter = (0, $7ea2865b97769aa3$export$c05f4d64df5567a5)((0, $715bf31211e65705$export$71511d61b312f219)((0, $fa9769297b8a68c8$export$71511d61b312f219)({}, characterData), {
                            multiplayerId: registeredCharacter.id || ((_registeredCharacter_character = registeredCharacter.character) === null || _registeredCharacter_character === void 0 ? void 0 : _registeredCharacter_character.id) || null,
                            ownerToken: registeredCharacter.ownerToken || null
                        }));
                        return [
                            3,
                            8
                        ];
                    case 7:
                        error1 = _state.sent();
                        // Not gated: the user is told multiplayer degraded, so the cause should
                        // always be visible in the console.
                        console.warn("Failed to register character:", error1);
                        (0, $b5bda7fdec806d8b$export$c7def531c087da85)("\u26A0\uFE0F Character created locally. Multiplayer features may be limited.", "warning");
                        // Create new character using multi-character system (fallback)
                        newCharacter = (0, $7ea2865b97769aa3$export$c05f4d64df5567a5)((0, $fa9769297b8a68c8$export$71511d61b312f219)({}, characterData));
                        return [
                            3,
                            8
                        ];
                    case 8:
                        // Update gameState.character.skills to match character skills
                        (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character.skills = (0, $fa9769297b8a68c8$export$71511d61b312f219)({}, characterFactionSkills);
                        (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "Character created:", newCharacter);
                        (0, $b5bda7fdec806d8b$export$c7def531c087da85)('\u2705 Character "'.concat(characterName, '" created and registered!'), "success");
                        (0, $670e0f14fa02ad13$export$aca974319671fb3e)();
                        // Hide creator, show character display
                        document.getElementById("character-creator").classList.add("hidden");
                        document.getElementById("character-display").classList.remove("hidden");
                        // Show character info
                        (0, $7ea2865b97769aa3$export$2eced2100c12c50d)();
                        (0, $59924438766e7d8e$export$2ae62d947e9e1d03)();
                        (0, $59924438766e7d8e$export$d1c957a54f7124bc)();
                        (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
                        return [
                            2
                        ];
                }
            });
        })();
    });
    // Initialize default tier if not set
    if (!(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedTier) (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedTier = 1;
    // Generate UI components on load
    (0, $59924438766e7d8e$export$5d55f9eae051c4dc)();
    (0, $59924438766e7d8e$export$98a6c6e9bfe86f10)();
    // Generate grid.
    //
    // A named function, not just a click handler, because Auto-Raid Protocol needs
    // the same work done. Clicking the button from automation looked equivalent
    // and is not: `#generate-grid` is DISABLED until the player has driven the
    // raid-setup UI, and a click on a disabled button silently does nothing — so
    // automation would sit there reporting "running" while achieving nothing.
    // Automation drives state, never widgets.
    var setupRaidGrid = function() {
        if (!(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedRegion || !(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedTier || !(0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character) return false;
        // Set raid ownership to current character when they start planning a raid
        (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidOwnerId = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).activeCharacterId;
        // Update tab visibility now that raid is owned by current character
        (0, $59924438766e7d8e$export$2ae62d947e9e1d03)();
        // Clear any existing grid data to ensure fresh generation
        (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid = null;
        (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath = [];
        // Generate completely new grid with region and tier
        (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid = (0, $1249ab814b7054d4$export$2ebdd7a7b7382080)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedRegion, (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedTier);
        // WHERE on the planet this raid is (M3 S9). Rolled once, here, and saved
        // with the raid: a region spans four to six hours of longitude, so two
        // raids in the same region land at different times of day — but re-rolling
        // on read would make the sky flicker between paints and shift across a
        // reload. Only the world clock reads it today; it is a location, so
        // anything later that cares where a raid is can read it too.
        (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidSite = (0, $05f2074f6c82f4e0$export$73436c04d978a296)((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedRegion);
        (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "Generated raid grid:", (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid);
        // Auto-select start position
        var startPos = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid.startPos;
        var startRoom = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid.grid[startPos.row][startPos.col];
        (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath = [
            {
                row: startPos.row,
                col: startPos.col,
                room: startRoom
            }
        ];
        (0, $3f29ea4265abff3b$export$cf8b2a65252147ea)();
        (0, $3f29ea4265abff3b$export$c9b7157fc13410c5)(); // Initialize grid header with area info and room count
        (0, $3f29ea4265abff3b$export$b70ccd83fb3eaefa)();
        (0, $3f29ea4265abff3b$export$68c4600b33dd0ca8)();
        (0, $3f29ea4265abff3b$export$ed4907da7d4af889)();
        (0, $3f29ea4265abff3b$export$c3f865504cdad6c4)(); // Show initial valid moves
        // Populate the item-drop highlight picker for the freshly generated grid
        (0, $3f29ea4265abff3b$export$6c9e89b1ffed34d7)();
        (0, $3f29ea4265abff3b$export$d72ea71bfd67dd40)();
        (0, $3f29ea4265abff3b$export$a21eeedead301a30)('highlights');
        // Show raid grid section and team section
        document.getElementById("raid-grid-section").classList.remove("hidden");
        document.getElementById("raid-team").classList.remove("hidden");
        // Hide region selection and show raid active state
        document.getElementById("raid-setup").classList.add("hidden");
        document.getElementById("raid-active").classList.remove("hidden");
        // Update current raid info
        (0, $3f29ea4265abff3b$export$f4fa7fe8ae486c6)();
        (0, $3f29ea4265abff3b$export$d6f634bba1273a2b)();
        (0, $59924438766e7d8e$export$d1c957a54f7124bc)();
        (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
        return true;
    };
    document.getElementById("generate-grid").addEventListener("click", setupRaidGrid);
    // Cancel raid button
    // Tear down the current raid. Split out of the click handler so the confirm
    // modal below drives it.
    var performRaidCancel = function() {
        var _gameState_characters;
        // Release any server-side contractor reservations/hires this raid holds
        // before we drop them locally — cancelling abandons the raid without ever
        // reaching finishRaidCore, which is what normally releases them. Best-effort
        // (fire-and-forget); the server's stale-hire sweep is the backstop. Only
        // player contractors (multiplayerId) have server state; AI ones are skipped.
        var cancelActor = (_gameState_characters = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).characters) === null || _gameState_characters === void 0 ? void 0 : _gameState_characters.find(function(c) {
            return c.id === (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).activeCharacterId;
        });
        if ((cancelActor === null || cancelActor === void 0 ? void 0 : cancelActor.multiplayerId) && typeof (0, $fde0976ce5d1665d$export$e4477200b6413a70) !== "undefined") {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.hiredContractors || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var contractor = _step.value;
                    if (contractor === null || contractor === void 0 ? void 0 : contractor.multiplayerId) (0, $fde0976ce5d1665d$export$e4477200b6413a70).releaseHiredContractor(contractor.multiplayerId, cancelActor.multiplayerId).catch(function(err) {
                        return console.error("Failed to release hired contractor on cancel:", err);
                    });
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.reservedContractors || [])[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var contractor1 = _step1.value;
                    if (contractor1 === null || contractor1 === void 0 ? void 0 : contractor1.multiplayerId) (0, $fde0976ce5d1665d$export$e4477200b6413a70).releaseContractor(contractor1.multiplayerId, cancelActor.multiplayerId).catch(function(err) {
                        return console.error("Failed to release reserved contractor on cancel:", err);
                    });
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
        // Hide raid grid section
        document.getElementById("raid-grid-section").classList.add("hidden");
        document.getElementById("raid-team").classList.add("hidden");
        // Clear the planning-only item highlight + picker
        (0, $3f29ea4265abff3b$export$6c9e89b1ffed34d7)();
        // Show region selection and hide raid active state
        document.getElementById("raid-setup").classList.remove("hidden");
        document.getElementById("raid-active").classList.add("hidden");
        // Clear raid state - but keep selectedRegion/selectedTier so the setup
        // screen comes back pre-selected with the previous choices
        (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress = null;
        (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidCompleted = false;
        (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.currentRaidGrid = null;
        (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.selectedPath = [];
        (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidOwnerId = null;
        (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.completedRaidInfo = null;
        // Update tab visibility now that raid is cleared
        (0, $59924438766e7d8e$export$2ae62d947e9e1d03)();
        // Release reserved contractors
        (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.reservedContractors = [];
        (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.hiredContractors = [];
        // The tile/segment .selected classes are untouched (setup was only
        // hidden); refresh the info panel + Generate button from the kept state
        (0, $59924438766e7d8e$export$6a940d9b4a9b252a)();
        (0, $59924438766e7d8e$export$d1c957a54f7124bc)();
        (0, $3f29ea4265abff3b$export$96635d91a6ab659a)();
        (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
    };
    document.getElementById("cancel-raid").addEventListener("click", function() {
        // Cancelling discards the run, so confirm first. Mid-raid the stakes are
        // real — energy was spent at raid start and isn't refunded, and progress and
        // gathered loot are lost — so that variant warns harder than clearing a
        // setup that hasn't cost anything yet.
        var raid = (0, $fe47a452a83d9e00$export$8e361a1ffbebf172).currentRaid.raidInProgress;
        var roomsCompleted = (raid === null || raid === void 0 ? void 0 : raid.roomsCompleted) || 0;
        var clearedNote = roomsCompleted > 0 ? " (".concat(roomsCompleted, " room").concat(roomsCompleted === 1 ? "" : "s", " cleared)") : "";
        var bodyHtml = raid ? '<p class="mb-2">Abandon the raid in progress?</p>\n         <p class="text-yellow-400">Your progress'.concat(clearedNote, " and everything gathered so far are lost, and the energy already spent is not refunded.</p>") : '<p class="mb-2">Clear this raid setup?</p>\n         <p class="text-xs text-gray-400">The generated map, chosen path and team are discarded. No energy has been spent yet, and your region and tier stay selected.</p>';
        (0, $7ea2865b97769aa3$export$655e187f5421a72c)({
            title: raid ? "\u26A0\uFE0F Abandon Raid?" : "\uD83D\uDDFA\uFE0F Clear Raid Setup?",
            bodyHtml: bodyHtml,
            confirmText: raid ? "Abandon Raid" : "Clear Setup",
            cancelText: raid ? "Keep Raiding" : "Go Back",
            confirmClass: raid ? "bg-red-600 hover:bg-red-700" : "bg-yellow-600 hover:bg-yellow-700",
            onConfirm: performRaidCancel
        });
    });
    // Clear path button
    /*
    document.getElementById('clear-path').addEventListener('click', () => {
        gameState.currentRaid.selectedPath = [];
        updatePathDisplay();
        updateGridPathHighlight();
            highlightValidMoves();
        saveGameState();
    });
    */ // Close modal button
    document.getElementById("close-modal").addEventListener("click", function() {
        (0, $670e0f14fa02ad13$export$5d484cf67c77323e)();
    });
    // Modal background click to close (only if mousedown started on background)
    var contractorModal = document.getElementById("contractor-modal");
    var mousedownTarget = null;
    contractorModal.addEventListener("mousedown", function(e) {
        mousedownTarget = e.target;
    });
    contractorModal.addEventListener("click", function(e) {
        if (e.target.id === "contractor-modal" && (mousedownTarget === null || mousedownTarget === void 0 ? void 0 : mousedownTarget.id) === "contractor-modal") (0, $670e0f14fa02ad13$export$5d484cf67c77323e)();
    });
    // Setup purchase modal handlers
    (0, $a575049a7e5cb3a1$export$fe032c86fe8adff)();
    // Tab switching handled above with animations
    // Regenerate contractors test button
    document.getElementById("regenerate-contractors-btn").addEventListener("click", function() {
        if ((0, $fe47a452a83d9e00$export$8e361a1ffbebf172).character) {
            (0, $670e0f14fa02ad13$export$aca974319671fb3e)();
            // Refresh Alpine.js contractors display
            (0, $8036d62b47ca0907$export$17502054442d56b0)();
            (0, $b5bda7fdec806d8b$export$c7def531c087da85)("\uD83D\uDD04 Contractor list regenerated for testing", "info");
            (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
        }
    });
    (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "Setting up periodic updates...");
    // Set up periodic energy regeneration and UI updates
    var regenIntervalMs = 5000;
    setInterval(function() {
        (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "Processing team health regeneration (including self)...");
        var healthChanged = (0, $670e0f14fa02ad13$export$3e71fa030a894242)(regenIntervalMs);
        // Update energy first
        (0, $df8a44d92d572a5c$export$e4e85317acdbc3c2)();
        // Currency values and the active-task label come from the layer registry.
        // Values only - refreshToolbarValues() deliberately does not rebuild the
        // chips, so the energy popup survives being open across a tick.
        (0, $8896b37f0fd85895$export$c6af328ac5cab01b)();
        (0, $4c1b6c766bf73b42$export$ca081aebb329a098)(); // one-way Command reveal (announce + re-render)
        // Update reservation timers every second
        if (typeof (0, $670e0f14fa02ad13$export$1b23387deaaf022d) !== "undefined") (0, $670e0f14fa02ad13$export$1b23387deaaf022d)();
        // Check for expired marketplace contractor reservations
        var contractorsExpired = (0, $670e0f14fa02ad13$export$797aa5f00658ac19)();
        // Update UI
        (0, $59924438766e7d8e$export$d1c957a54f7124bc)();
        if (healthChanged || contractorsExpired) {
            (0, $3f29ea4265abff3b$export$b70ccd83fb3eaefa)();
            (0, $dd2eed17ca70a8a9$export$384cd953322e3851)();
        }
        // Auto-Raid Protocol advances at most one step per tick, reading only from
        // gameState — so a reload mid-raid resumes, and a player taking manual
        // control is noticed on the next tick rather than fought by a live promise.
        // The raid functions are injected rather than imported by autoRaid.js: they
        // live in DOM-heavy modules, and passing them keeps the cycle testable.
        // Operations arrive on their own clock; settle whatever is due.
        (0, $c95f3da2626a9dfc$export$9dd8092a8219c221)();
        // The world clock (M3 S9) turns whether or not anything else happens. Both
        // calls are no-ops off their own screens — the raid grid's own animation
        // loop drives the day clock above the map, so only these two surfaces need
        // the tick: region tiles in raid planning, and the world map's terminator.
        (0, $59924438766e7d8e$export$bfd4e77d5f2367cd)();
        (0, $c95f3da2626a9dfc$export$4af0774c25cece2a)();
        (0, $2f2faed8b0830fbf$export$8e2efb5378addfbb)({
            generateGrid: setupRaidGrid,
            autoScoutPath: (0, $4c1b6c766bf73b42$export$478f57514b105434),
            autoReserveContractors: (0, $4c1b6c766bf73b42$export$95f7842af258a4dd),
            startRaid: (0, $3f29ea4265abff3b$export$bb6b71fe7f08b971),
            resetRaid: (0, $3f29ea4265abff3b$export$8dc8f2c13318a5b7),
            promoteAndSucceed: (0, $5114056da3d46141$export$e62c6e81abdadce7)
        }).catch(function(err) {
            return console.error("Auto-Raid tick failed:", err);
        });
        // Auto-Fabricator works the DEAD TIME — while a raid runs, or while the
        // raid cycle waits on energy. Crafting in the launch path would delay every
        // raid by a tick per component, and a tech-gear tree is several. The window
        // is decided here because only main.js sees both the raid and the cycle.
        // Auto-Fabricator: one craft per tick while it is switched on. It shares
        // nothing with the raid cycle above and cannot delay it, so it runs on the
        // same plain schedule rather than waiting for a window.
        (0, $7a60a8a88cdf0fcd$export$109e3e91403b4584)();
    }, regenIntervalMs); // Update every 5 seconds
    // Refresh the contractor list to show latest availability (both main list and
    // modal). A self-rescheduling timeout rather than setInterval, because the
    // cadence backs off: 10s, 20s, 40s ... settling at ~5m20s while the section
    // stays open, so a page left open all day stops hammering the API. Any poll
    // that finds the UI off-screen resets the cadence, so reopening the section
    // (which also refreshes immediately via the tab handler) is responsive again.
    var pollContractorList = function() {
        var contractorsTab = document.getElementById("contractors-tab");
        var modal = document.getElementById("contractor-modal");
        // document.hidden covers a backgrounded browser tab — no point polling for a
        // list nobody is looking at.
        var onScreen = function(el) {
            return !document.hidden && el && !el.classList.contains("hidden") && window.getComputedStyle(el).display !== "none";
        };
        var contractorsTabVisible = onScreen(contractorsTab);
        var modalVisible = onScreen(modal);
        if (contractorsTabVisible || modalVisible) {
            // Refresh Alpine store (updates modal)
            if ((0, $da6f71b8677b901e$export$2e2bcd8739ae039).store("contractors")) (0, $da6f71b8677b901e$export$2e2bcd8739ae039).store("contractors").refresh();
            // Refresh main list display
            if (contractorsTabVisible) (0, $670e0f14fa02ad13$export$fada499eccb8a752)();
            $a13c06a9ce2afd55$var$contractorPollDelay = (0, $e63b1e314d73680b$export$64b66d963f6d5043)($a13c06a9ce2afd55$var$contractorPollDelay);
        } else $a13c06a9ce2afd55$var$contractorPollDelay = (0, $e63b1e314d73680b$export$fa0ee1eb937a38e6);
        setTimeout(pollContractorList, $a13c06a9ce2afd55$var$contractorPollDelay);
    };
    setTimeout(pollContractorList, $a13c06a9ce2afd55$var$contractorPollDelay);
    // Auto-sync when coming back online
    window.addEventListener("online", function() {
        setTimeout(function() {
            (0, $fde0976ce5d1665d$export$e4477200b6413a70).syncLocalCharacters();
            (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "Multiplayer system initialized");
        }, 1000); // Give a moment for connection to stabilize
    });
    // Startup marketplace reconciliation, ordered because each step feeds the next:
    //   1. re-onboard pre-token (legacy) characters so they have a multiplayerId,
    //   2. refresh their listing state from the server (local marketplaceData is a
    //      snapshot taken at listing time and can be stale),
    //   3. act on it — expire listings and collect any pending payouts.
    // Non-blocking; each step is best-effort and must not stop the next.
    (0, $59924438766e7d8e$export$bb017115af5d1f34)().catch(function(err) {
        return console.error("Error claiming legacy characters:", err);
    }).then(function() {
        return (0, $59924438766e7d8e$export$162c77cf09613261)();
    }).catch(function(err) {
        return console.error("Error syncing marketplace listings:", err);
    }).finally(function() {
        return (0, $59924438766e7d8e$export$9124d6474b00dfc4)();
    });
    setInterval(function() {
        (0, $59924438766e7d8e$export$9124d6474b00dfc4)();
    }, 600000); // Update every 10 minutes
    // Initialize Tippy.js tooltips for all elements
    if (window.tippy) {
        // Initialize contractor tooltips
        tippy(".contractor-tooltip", {
            theme: "dark",
            placement: "top",
            delay: [
                500,
                200
            ],
            maxWidth: 400,
            allowHTML: true
        });
        // Initialize skill tooltips
        tippy(".skill-tooltip", {
            theme: "dark",
            placement: "top",
            delay: [
                500,
                200
            ],
            maxWidth: 300,
            allowHTML: true
        });
        // Initialize room tooltips (if they exist)
        tippy(".room-tooltip", {
            theme: "dark",
            placement: "top",
            delay: [
                500,
                200
            ],
            maxWidth: 350,
            allowHTML: true,
            content: function(reference) {
                return reference.dataset.tippyContent;
            }
        });
        // Initialize inventory item tooltips
        tippy(".inventory-tooltip", {
            theme: "dark",
            placement: "top",
            delay: [
                300,
                0
            ],
            maxWidth: 300,
            allowHTML: true,
            content: function(reference) {
                // Get the description from the hidden div if it exists
                var descDiv = reference.querySelector(".inventory-tooltip-content");
                return descDiv ? descDiv.innerHTML : "";
            },
            onMount: function(instance) {
                instance.popper.style.border = "2px solid white";
                instance.popper.style.borderRadius = "0.5rem";
            },
            onShow: function(instance) {
                // Create a named function so it can be accurately removed later
                instance._scrollHandler = function() {
                    return instance.hide();
                };
                window.addEventListener('scroll', instance._scrollHandler, {
                    passive: true
                });
            },
            onHide: function(instance) {
                // Clean up the listener to prevent memory leaks
                window.removeEventListener('scroll', instance._scrollHandler);
            }
        });
    }
    // Show game UI with fade-in after everything is loaded
    var gameContainer = document.getElementById("game-container");
    if (gameContainer) {
        gameContainer.style.display = "";
        gameContainer.style.opacity = "0";
        gameContainer.style.transition = "opacity 0.3s ease-in";
        setTimeout(function() {
            gameContainer.style.opacity = "1";
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        }, 10);
    }
    // How To Play button
    document.getElementById("how-to-btn").addEventListener("click", function() {
        // Built on open, not at boot: the Command reveal fires on a background tick,
        // so a guide captured earlier would still be hiding a layer the header shows.
        var html = (0, $ca7af38ea7b7b4a8$export$189173d473c82c30)((0, $166366154a864305$export$ec50a2d4695064b2)());
        (0, $ca7af38ea7b7b4a8$export$d7e8d4d4450c819c)("Gameplay Guide", '\n            <div class="gameplay-guide prose prose-invert max-w-none max-h-[70vh] overflow-y-auto">\n                '.concat(html, "\n            </div>\n        "));
    });
    document.getElementById("version-display").textContent = "v".concat((0, $fb87f08ff5f65798$export$9badeb9b04b4b71c));
    // Dev-only strip: tablet check, then one button per save fixture. Both
    // self-gate to localhost via devBar.js. Viewport first so it stays leftmost.
    (0, $0923a07be718bea9$export$d95b3e0536e68b56)();
    (0, $03744ae8c690a79a$export$45e422e963dadb5c)();
});
document.addEventListener("alpine:init", function() {
    (0, $fb5bf89946773306$export$1c9f709888824e05)((0, $fb5bf89946773306$export$31ff2235b44019b8).ui, "Initializing Alpine Stores");
    (0, $8036d62b47ca0907$export$7532162a9c4df7a1)();
    (0, $80ed874fd909c4ae$export$5e57bb1ccaa580e5)();
    // Vault screen bodies. Injected HERE, not later: alpine:init fires before
    // Alpine walks the DOM, so this markup gets initialized with everything else.
    // Injecting after Alpine.start() would need a manual initTree and would leave
    // the directives inert if that were ever forgotten.
    var paneBody = function(id, source, accent, empty) {
        var host = document.getElementById(id);
        if (host) host.innerHTML = (0, $80ed874fd909c4ae$export$4d450619ebe70217)(source, accent, empty);
    };
    paneBody("command-vault-body", "commandVault", "#b18cff", "Nothing outbound. Promote a character to send their kit onward.");
    paneBody("syndicate-stores-body", "syndicateStores", "#e0a84c", "Nothing on the dock. Founding delivers what the Guild Vault has consigned.");
});
(0, $da6f71b8677b901e$export$2e2bcd8739ae039).start();

})();
//# sourceMappingURL=repo.bbaef93d.js.map
